(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirefbb4"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirefbb4"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("3vQ1E", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hHcC4 = parcelRequire("hHcC4");

var $iUxao = parcelRequire("iUxao");

var $jyEe9 = parcelRequire("jyEe9");

var $4OdOk = parcelRequire("4OdOk");

var $lJzTh = parcelRequire("lJzTh");

var $9X7hl = parcelRequire("9X7hl");

var $4Ae9I = parcelRequire("4Ae9I");

var $dkd4c = parcelRequire("dkd4c");

var $in1Kg = parcelRequire("in1Kg");

var $gwwm3 = parcelRequire("gwwm3");

var $5puYc = parcelRequire("5puYc");

var $1N6Mo = parcelRequire("1N6Mo");

var $3dwiN = parcelRequire("3dwiN");

var $bOthn = parcelRequire("bOthn");

var $8txOP = parcelRequire("8txOP");

var $gjJ9A = parcelRequire("gjJ9A");

var $gRCrP = parcelRequire("gRCrP");

var $Up7k9 = parcelRequire("Up7k9");

var $hbMFZ = parcelRequire("hbMFZ");

var $jIJ38 = parcelRequire("jIJ38");

var $d8aK6 = parcelRequire("d8aK6");

var $6l1mu = parcelRequire("6l1mu");

var $ezH6v = parcelRequire("ezH6v");

var $ej2aq = parcelRequire("ej2aq");

var $15QgH = parcelRequire("15QgH");

var $3XQ7d = parcelRequire("3XQ7d");

var $lk7k6 = parcelRequire("lk7k6");

var $fEhTX = parcelRequire("fEhTX");

var $5QaR1 = parcelRequire("5QaR1");

var $8DGLQ = parcelRequire("8DGLQ");

var $btAkR = parcelRequire("btAkR");

var $1gnzN = parcelRequire("1gnzN");

var $dCVJN = parcelRequire("dCVJN");

var $9qZHH = parcelRequire("9qZHH");

var $3k7kU = parcelRequire("3k7kU");

var $crfCR = parcelRequire("crfCR");

var $5ZEoH = parcelRequire("5ZEoH");

var $hbAIy = parcelRequire("hbAIy");

var $lPd4g = parcelRequire("lPd4g");

var $fsZ9V = parcelRequire("fsZ9V");

var $8qJ6j = parcelRequire("8qJ6j");

var $csMoB = parcelRequire("csMoB");

var $ltYup = parcelRequire("ltYup");

var $gIYVG = parcelRequire("gIYVG");

var $2dG64 = parcelRequire("2dG64");

var $k7IIJ = parcelRequire("k7IIJ");

var $d2351 = parcelRequire("d2351");

var $csEW0 = parcelRequire("csEW0");

var $Qbf2O = parcelRequire("Qbf2O");

var $7itcc = parcelRequire("7itcc");

var $4DgSG = parcelRequire("4DgSG");

var $k0CHb = parcelRequire("k0CHb");

var $bOToE = parcelRequire("bOToE");

var $dbEaR = parcelRequire("dbEaR");

var $iMjbh = parcelRequire("iMjbh");

var $fXcxa = parcelRequire("fXcxa");

var $75yrz = parcelRequire("75yrz");

var $jJ1ed = parcelRequire("jJ1ed");

var $3VZtP = parcelRequire("3VZtP");

var $iZK6v = parcelRequire("iZK6v");

var $5c0E9 = parcelRequire("5c0E9");

var $j0HbT = parcelRequire("j0HbT");

var $gpkRr = parcelRequire("gpkRr");

var $9d3BR = parcelRequire("9d3BR");

var $glXHH = parcelRequire("glXHH");

var $5dbkS = parcelRequire("5dbkS");

var $lrqNu = parcelRequire("lrqNu");

var $98bRC = parcelRequire("98bRC");

var $6bvZk = parcelRequire("6bvZk");

var $k7uEO = parcelRequire("k7uEO");

var $720L4 = parcelRequire("720L4");

var $6J050 = parcelRequire("6J050");

var $2yqyX = parcelRequire("2yqyX");

var $kxD6q = parcelRequire("kxD6q");

var $dgc2Y = parcelRequire("dgc2Y");

var $9ZcIi = parcelRequire("9ZcIi");

var $hAYfg = parcelRequire("hAYfg");

var $az8OY = parcelRequire("az8OY");

var $1VNMa = parcelRequire("1VNMa");

var $iTp6h = parcelRequire("iTp6h");

var $iHNtB = parcelRequire("iHNtB");

var $3Jcbc = parcelRequire("3Jcbc");

var $ilbTW = parcelRequire("ilbTW");

var $lFN6F = parcelRequire("lFN6F");

var $3GQdK = parcelRequire("3GQdK");

var $gpdWe = parcelRequire("gpdWe");

var $9APZV = parcelRequire("9APZV");

var $2Qsdk = parcelRequire("2Qsdk");

var $7GPrZ = parcelRequire("7GPrZ");

var $5i7Tv = parcelRequire("5i7Tv");

var $hBbOb = parcelRequire("hBbOb");

var $i1Lan = parcelRequire("i1Lan");

var $jLYfK = parcelRequire("jLYfK");

var $7cQmT = parcelRequire("7cQmT");

var $iYNsH = parcelRequire("iYNsH");

var $26DyO = parcelRequire("26DyO");

var $9wTeJ = parcelRequire("9wTeJ");

var $lIOsi = parcelRequire("lIOsi");

var $4Y3t2 = parcelRequire("4Y3t2");

var $cut0U = parcelRequire("cut0U");

var $5y6zC = parcelRequire("5y6zC");

var $wqmhe = parcelRequire("wqmhe");

var $jypZc = parcelRequire("jypZc");

var $8QzOy = parcelRequire("8QzOy");

var $hsCGK = parcelRequire("hsCGK");

var $9SKf6 = parcelRequire("9SKf6");

var $8cQs4 = parcelRequire("8cQs4");

var $66l16 = parcelRequire("66l16");

var $k5t8i = parcelRequire("k5t8i");

var $86JSI = parcelRequire("86JSI");

var $fBPG6 = parcelRequire("fBPG6");

var $9Vsrl = parcelRequire("9Vsrl");

var $jix5p = parcelRequire("jix5p");

var $k6pIc = parcelRequire("k6pIc");

var $bg87c = parcelRequire("bg87c");

var $fhFRD = parcelRequire("fhFRD");

var $2SQtm = parcelRequire("2SQtm");

var $adgNM = parcelRequire("adgNM");

var $9DgSh = parcelRequire("9DgSh");

var $53CIi = parcelRequire("53CIi");

var $cjy9I = parcelRequire("cjy9I");

var $8S2lx = parcelRequire("8S2lx");

var $23Myp = parcelRequire("23Myp");

var $4ZAQw = parcelRequire("4ZAQw");

var $8IgEN = parcelRequire("8IgEN");

var $7q4WK = parcelRequire("7q4WK");

var $hiiHh = parcelRequire("hiiHh");

var $5kWFc = parcelRequire("5kWFc");

var $5fqIb = parcelRequire("5fqIb");

var $8IqnM = parcelRequire("8IqnM");

var $a8HWQ = parcelRequire("a8HWQ");

var $enaoN = parcelRequire("enaoN");

var $kipJA = parcelRequire("kipJA");

var $bjI1e = parcelRequire("bjI1e");

var $88kW2 = parcelRequire("88kW2");

var $bSNF3 = parcelRequire("bSNF3");

var $gywEi = parcelRequire("gywEi");

var $9Dizr = parcelRequire("9Dizr");

var $2ETn4 = parcelRequire("2ETn4");

var $1GUda = parcelRequire("1GUda");

var $9xAUk = parcelRequire("9xAUk");

var $5TFPR = parcelRequire("5TFPR");

var $6wQ2i = parcelRequire("6wQ2i");
module.exports.registerSpanErrorInstrumentation = $hHcC4.registerSpanErrorInstrumentation;
module.exports.getCapturedScopesOnSpan = $iUxao.getCapturedScopesOnSpan;
module.exports.setCapturedScopesOnSpan = $iUxao.setCapturedScopesOnSpan;
module.exports.TRACING_DEFAULTS = $jyEe9.TRACING_DEFAULTS;
module.exports.startIdleSpan = $jyEe9.startIdleSpan;
module.exports.SentrySpan = $4OdOk.SentrySpan;
module.exports.SentryNonRecordingSpan = $lJzTh.SentryNonRecordingSpan;
module.exports.SPAN_STATUS_ERROR = $9X7hl.SPAN_STATUS_ERROR;
module.exports.SPAN_STATUS_OK = $9X7hl.SPAN_STATUS_OK;
module.exports.SPAN_STATUS_UNSET = $9X7hl.SPAN_STATUS_UNSET;
module.exports.getSpanStatusFromHttpCode = $9X7hl.getSpanStatusFromHttpCode;
module.exports.setHttpStatus = $9X7hl.setHttpStatus;
module.exports.SUPPRESS_TRACING_KEY = $4Ae9I.SUPPRESS_TRACING_KEY;
module.exports.continueTrace = $4Ae9I.continueTrace;
module.exports.startInactiveSpan = $4Ae9I.startInactiveSpan;
module.exports.startNewTrace = $4Ae9I.startNewTrace;
module.exports.startSpan = $4Ae9I.startSpan;
module.exports.startSpanManual = $4Ae9I.startSpanManual;
module.exports.suppressTracing = $4Ae9I.suppressTracing;
module.exports.withActiveSpan = $4Ae9I.withActiveSpan;
module.exports.getDynamicSamplingContextFromClient = $dkd4c.getDynamicSamplingContextFromClient;
module.exports.getDynamicSamplingContextFromScope = $dkd4c.getDynamicSamplingContextFromScope;
module.exports.getDynamicSamplingContextFromSpan = $dkd4c.getDynamicSamplingContextFromSpan;
module.exports.spanToBaggageHeader = $dkd4c.spanToBaggageHeader;
module.exports.setMeasurement = $in1Kg.setMeasurement;
module.exports.timedEventsToMeasurements = $in1Kg.timedEventsToMeasurements;
module.exports.sampleSpan = $gwwm3.sampleSpan;
module.exports.logSpanEnd = $5puYc.logSpanEnd;
module.exports.logSpanStart = $5puYc.logSpanStart;
module.exports.captureSpan = $1N6Mo.captureSpan;
module.exports.safeSetSpanJSONAttributes = $1N6Mo.safeSetSpanJSONAttributes;
module.exports.GEN_AI_CONVERSATION_ID_ATTRIBUTE = $3dwiN.GEN_AI_CONVERSATION_ID_ATTRIBUTE;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_HIT = $3dwiN.SEMANTIC_ATTRIBUTE_CACHE_HIT;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE = $3dwiN.SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_KEY = $3dwiN.SEMANTIC_ATTRIBUTE_CACHE_KEY;
module.exports.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME = $3dwiN.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME;
module.exports.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD = $3dwiN.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD;
module.exports.SEMANTIC_ATTRIBUTE_PROFILE_ID = $3dwiN.SEMANTIC_ATTRIBUTE_PROFILE_ID;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME = $3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT = $3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON = $3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT = $3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE = $3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_OP = $3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_OP;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN = $3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE = $3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_RELEASE = $3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_RELEASE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE = $3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS = $3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME = $3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION = $3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID = $3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME = $3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE = $3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE;
module.exports.SEMANTIC_ATTRIBUTE_URL_FULL = $3dwiN.SEMANTIC_ATTRIBUTE_URL_FULL;
module.exports.SEMANTIC_ATTRIBUTE_USER_EMAIL = $3dwiN.SEMANTIC_ATTRIBUTE_USER_EMAIL;
module.exports.SEMANTIC_ATTRIBUTE_USER_ID = $3dwiN.SEMANTIC_ATTRIBUTE_USER_ID;
module.exports.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS = $3dwiN.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS;
module.exports.SEMANTIC_ATTRIBUTE_USER_USERNAME = $3dwiN.SEMANTIC_ATTRIBUTE_USER_USERNAME;
module.exports.SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE = $3dwiN.SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE;
module.exports.createEventEnvelope = $bOthn.createEventEnvelope;
module.exports.createSessionEnvelope = $bOthn.createSessionEnvelope;
module.exports.createSpanEnvelope = $bOthn.createSpanEnvelope;
module.exports.addEventProcessor = $8txOP.addEventProcessor;
module.exports.captureCheckIn = $8txOP.captureCheckIn;
module.exports.captureEvent = $8txOP.captureEvent;
module.exports.captureException = $8txOP.captureException;
module.exports.captureMessage = $8txOP.captureMessage;
module.exports.captureSession = $8txOP.captureSession;
module.exports.close = $8txOP.close;
module.exports.endSession = $8txOP.endSession;
module.exports.flush = $8txOP.flush;
module.exports.isEnabled = $8txOP.isEnabled;
module.exports.isInitialized = $8txOP.isInitialized;
module.exports.lastEventId = $8txOP.lastEventId;
module.exports.setContext = $8txOP.setContext;
module.exports.setConversationId = $8txOP.setConversationId;
module.exports.setExtra = $8txOP.setExtra;
module.exports.setExtras = $8txOP.setExtras;
module.exports.setTag = $8txOP.setTag;
module.exports.setTags = $8txOP.setTags;
module.exports.setUser = $8txOP.setUser;
module.exports.startSession = $8txOP.startSession;
module.exports.withMonitor = $8txOP.withMonitor;
module.exports.getClient = $gjJ9A.getClient;
module.exports.getCurrentScope = $gjJ9A.getCurrentScope;
module.exports.getExternalPropagationContext = $gjJ9A.getExternalPropagationContext;
module.exports.getGlobalScope = $gjJ9A.getGlobalScope;
module.exports.getIsolationScope = $gjJ9A.getIsolationScope;
module.exports.getTraceContextFromScope = $gjJ9A.getTraceContextFromScope;
module.exports.hasExternalPropagationContext = $gjJ9A.hasExternalPropagationContext;
module.exports.registerExternalPropagationContext = $gjJ9A.registerExternalPropagationContext;
module.exports.withIsolationScope = $gjJ9A.withIsolationScope;
module.exports.withScope = $gjJ9A.withScope;
module.exports.getDefaultCurrentScope = $gRCrP.getDefaultCurrentScope;
module.exports.getDefaultIsolationScope = $gRCrP.getDefaultIsolationScope;
module.exports.setAsyncContextStrategy = $Up7k9.setAsyncContextStrategy;
module.exports.getGlobalSingleton = $hbMFZ.getGlobalSingleton;
module.exports.getMainCarrier = $hbMFZ.getMainCarrier;
module.exports.closeSession = $jIJ38.closeSession;
module.exports.makeSession = $jIJ38.makeSession;
module.exports.updateSession = $jIJ38.updateSession;
module.exports.Scope = $d8aK6.Scope;
module.exports.notifyEventProcessors = $6l1mu.notifyEventProcessors;
module.exports.SENTRY_API_VERSION = $ezH6v.SENTRY_API_VERSION;
module.exports.getEnvelopeEndpointWithUrlEncodedAuth = $ezH6v.getEnvelopeEndpointWithUrlEncodedAuth;
module.exports.getReportDialogEndpoint = $ezH6v.getReportDialogEndpoint;
module.exports.Client = $ej2aq.Client;
module.exports.initAndBind = $15QgH.initAndBind;
module.exports.setCurrentClient = $15QgH.setCurrentClient;
module.exports.createTransport = $3XQ7d.createTransport;
module.exports.makeOfflineTransport = $lk7k6.makeOfflineTransport;
module.exports.MULTIPLEXED_TRANSPORT_EXTRA_KEY = $fEhTX.MULTIPLEXED_TRANSPORT_EXTRA_KEY;
module.exports.makeMultiplexedTransport = $fEhTX.makeMultiplexedTransport;
module.exports.addIntegration = $5QaR1.addIntegration;
module.exports.defineIntegration = $5QaR1.defineIntegration;
module.exports.getIntegrationsToSetup = $5QaR1.getIntegrationsToSetup;
module.exports.installedIntegrations = $5QaR1.installedIntegrations;
module.exports._INTERNAL_clearAiProviderSkips = $8DGLQ._INTERNAL_clearAiProviderSkips;
module.exports._INTERNAL_shouldSkipAiProviderWrapping = $8DGLQ._INTERNAL_shouldSkipAiProviderWrapping;
module.exports._INTERNAL_skipAiProviderWrapping = $8DGLQ._INTERNAL_skipAiProviderWrapping;
module.exports._INTERNAL_filterKeyValueData = $btAkR.filterKeyValueData;
module.exports._INTERNAL_filterCookies = $1gnzN.filterCookies;
module.exports._INTERNAL_filterQueryParams = $dCVJN.filterQueryParams;
module.exports.envToBool = $9qZHH.envToBool;
module.exports.applyScopeDataToEvent = $3k7kU.applyScopeDataToEvent;
module.exports.getCombinedScopeData = $3k7kU.getCombinedScopeData;
module.exports.mergeScopeData = $3k7kU.mergeScopeData;
module.exports.prepareEvent = $crfCR.prepareEvent;
module.exports.createCheckInEnvelope = $5ZEoH.createCheckInEnvelope;
module.exports.hasSpansEnabled = $hbAIy.hasSpansEnabled;
module.exports.isStreamedBeforeSendSpanCallback = $lPd4g.isStreamedBeforeSendSpanCallback;
module.exports.withStreamedSpan = $lPd4g.withStreamedSpan;
module.exports.isSentryRequestUrl = $fsZ9V.isSentryRequestUrl;
module.exports.handleCallbackErrors = $8qJ6j.handleCallbackErrors;
module.exports.fmt = $csMoB.fmt;
module.exports.parameterize = $csMoB.parameterize;
module.exports.handleTunnelRequest = $ltYup.handleTunnelRequest;
module.exports.addAutoIpAddressToSession = $gIYVG.addAutoIpAddressToSession;
module.exports.addAutoIpAddressToUser = $gIYVG.addAutoIpAddressToUser;
module.exports.INTERNAL_getSegmentSpan = $2dG64.INTERNAL_getSegmentSpan;
module.exports.addChildSpanToSpan = $2dG64.addChildSpanToSpan;
module.exports.convertSpanLinksForEnvelope = $2dG64.convertSpanLinksForEnvelope;
module.exports.getActiveSpan = $2dG64.getActiveSpan;
module.exports.getRootSpan = $2dG64.getRootSpan;
module.exports.getSpanDescendants = $2dG64.getSpanDescendants;
module.exports.getStatusMessage = $2dG64.getStatusMessage;
module.exports.spanIsSampled = $2dG64.spanIsSampled;
module.exports.spanTimeInputToSeconds = $2dG64.spanTimeInputToSeconds;
module.exports.spanToJSON = $2dG64.spanToJSON;
module.exports.spanToStreamedSpanJSON = $2dG64.spanToStreamedSpanJSON;
module.exports.spanToTraceContext = $2dG64.spanToTraceContext;
module.exports.spanToTraceHeader = $2dG64.spanToTraceHeader;
module.exports.updateSpanName = $2dG64.updateSpanName;
module.exports._INTERNAL_setSpanForScope = $k7IIJ._setSpanForScope;
module.exports.parseSampleRate = $d2351.parseSampleRate;
module.exports.applySdkMetadata = $csEW0.applySdkMetadata;
module.exports.getTraceData = $Qbf2O.getTraceData;
module.exports.shouldPropagateTraceForUrl = $7itcc.shouldPropagateTraceForUrl;
module.exports.getTraceMetaTags = $4DgSG.getTraceMetaTags;
module.exports.debounce = $k0CHb.debounce;
module.exports.derefWeakRef = $bOToE.derefWeakRef;
module.exports.makeWeakRef = $bOToE.makeWeakRef;
module.exports.shouldIgnoreSpan = $dbEaR.shouldIgnoreSpan;
module.exports.MAX_BODY_BYTE_LENGTH = $iMjbh.MAX_BODY_BYTE_LENGTH;
module.exports.captureBodyFromWinterCGRequest = $iMjbh.captureBodyFromWinterCGRequest;
module.exports.extractQueryParamsFromUrl = $iMjbh.extractQueryParamsFromUrl;
module.exports.getMaxBodyByteLength = $iMjbh.getMaxBodyByteLength;
module.exports.headersToDict = $iMjbh.headersToDict;
module.exports.httpHeadersToSpanAttributes = $iMjbh.httpHeadersToSpanAttributes;
module.exports.httpRequestToRequestData = $iMjbh.httpRequestToRequestData;
module.exports.winterCGHeadersToDict = $iMjbh.winterCGHeadersToDict;
module.exports.winterCGRequestToRequestData = $iMjbh.winterCGRequestToRequestData;
module.exports.DEFAULT_ENVIRONMENT = $fXcxa.DEFAULT_ENVIRONMENT;
module.exports.DEV_ENVIRONMENT = $fXcxa.DEV_ENVIRONMENT;
module.exports.addBreadcrumb = $75yrz.addBreadcrumb;
module.exports.functionToStringIntegration = $jJ1ed.functionToStringIntegration;
module.exports.eventFiltersIntegration = $3VZtP.eventFiltersIntegration;
module.exports.inboundFiltersIntegration = $3VZtP.inboundFiltersIntegration;
module.exports.linkedErrorsIntegration = $iZK6v.linkedErrorsIntegration;
module.exports.moduleMetadataIntegration = $5c0E9.moduleMetadataIntegration;
module.exports.requestDataIntegration = $j0HbT.requestDataIntegration;
module.exports.captureConsoleIntegration = $gpkRr.captureConsoleIntegration;
module.exports.dedupeIntegration = $9d3BR.dedupeIntegration;
module.exports.extraErrorDataIntegration = $glXHH.extraErrorDataIntegration;
module.exports.rewriteFramesIntegration = $5dbkS.rewriteFramesIntegration;
module.exports.instrumentSupabaseClient = $lrqNu.instrumentSupabaseClient;
module.exports.supabaseIntegration = $lrqNu.supabaseIntegration;
module.exports.zodErrorsIntegration = $98bRC.zodErrorsIntegration;
module.exports.thirdPartyErrorFilterIntegration = $6bvZk.thirdPartyErrorFilterIntegration;
module.exports.consoleIntegration = $k7uEO.consoleIntegration;
module.exports.featureFlagsIntegration = $720L4.featureFlagsIntegration;
module.exports.growthbookIntegration = $6J050.growthbookIntegration;
module.exports.conversationIdIntegration = $2yqyX.conversationIdIntegration;
module.exports.profiler = $kxD6q.profiler;
module.exports._INTERNAL_getTracingHeadersForFetchRequest = $dgc2Y._INTERNAL_getTracingHeadersForFetchRequest;
module.exports.instrumentFetchRequest = $dgc2Y.instrumentFetchRequest;
module.exports.captureFeedback = $9ZcIi.captureFeedback;
module.exports._INTERNAL_captureLog = $hAYfg._INTERNAL_captureLog;
module.exports._INTERNAL_captureSerializedLog = $hAYfg._INTERNAL_captureSerializedLog;
module.exports._INTERNAL_flushLogsBuffer = $hAYfg._INTERNAL_flushLogsBuffer;
module.exports.logger = $az8OY;
module.exports.consoleLoggingIntegration = $1VNMa.consoleLoggingIntegration;
module.exports._INTERNAL_captureMetric = $iTp6h._INTERNAL_captureMetric;
module.exports._INTERNAL_captureSerializedMetric = $iTp6h._INTERNAL_captureSerializedMetric;
module.exports._INTERNAL_flushMetricsBuffer = $iTp6h._INTERNAL_flushMetricsBuffer;
module.exports.metrics = $iHNtB;
module.exports.createConsolaReporter = $3Jcbc.createConsolaReporter;
module.exports.addVercelAiProcessors = $ilbTW.addVercelAiProcessors;
module.exports._INTERNAL_cleanupToolCallSpanContext = $lFN6F._INTERNAL_cleanupToolCallSpanContext;
module.exports._INTERNAL_getSpanContextForToolCallId = $lFN6F._INTERNAL_getSpanContextForToolCallId;
module.exports._INTERNAL_toolCallSpanContextMap = $3GQdK.toolCallSpanContextMap;
module.exports.instrumentOpenAiClient = $gpdWe.instrumentOpenAiClient;
module.exports.OPENAI_INTEGRATION_NAME = $9APZV.OPENAI_INTEGRATION_NAME;
module.exports.instrumentAnthropicAiClient = $2Qsdk.instrumentAnthropicAiClient;
module.exports.ANTHROPIC_AI_INTEGRATION_NAME = $7GPrZ.ANTHROPIC_AI_INTEGRATION_NAME;
module.exports.instrumentGoogleGenAIClient = $5i7Tv.instrumentGoogleGenAIClient;
module.exports.GOOGLE_GENAI_INTEGRATION_NAME = $hBbOb.GOOGLE_GENAI_INTEGRATION_NAME;
module.exports.createLangChainCallbackHandler = $i1Lan.createLangChainCallbackHandler;
module.exports._INTERNAL_mergeLangChainCallbackHandler = $jLYfK._INTERNAL_mergeLangChainCallbackHandler;
module.exports.LANGCHAIN_INTEGRATION_NAME = $7cQmT.LANGCHAIN_INTEGRATION_NAME;
module.exports.instrumentCreateReactAgent = $iYNsH.instrumentCreateReactAgent;
module.exports.instrumentLangGraph = $iYNsH.instrumentLangGraph;
module.exports.instrumentStateGraphCompile = $iYNsH.instrumentStateGraphCompile;
module.exports.LANGGRAPH_INTEGRATION_NAME = $26DyO.LANGGRAPH_INTEGRATION_NAME;
module.exports.SpanBuffer = $9wTeJ.SpanBuffer;
module.exports.hasSpanStreamingEnabled = $lIOsi.hasSpanStreamingEnabled;
module.exports.spanStreamingIntegration = $4Y3t2.spanStreamingIntegration;
module.exports._INTERNAL_FLAG_BUFFER_SIZE = $cut0U._INTERNAL_FLAG_BUFFER_SIZE;
module.exports._INTERNAL_MAX_FLAGS_PER_SPAN = $cut0U._INTERNAL_MAX_FLAGS_PER_SPAN;
module.exports._INTERNAL_addFeatureFlagToActiveSpan = $cut0U._INTERNAL_addFeatureFlagToActiveSpan;
module.exports._INTERNAL_copyFlagsFromScopeToEvent = $cut0U._INTERNAL_copyFlagsFromScopeToEvent;
module.exports._INTERNAL_insertFlagToScope = $cut0U._INTERNAL_insertFlagToScope;
module.exports.applyAggregateErrorsToEvent = $5y6zC.applyAggregateErrorsToEvent;
module.exports.getBreadcrumbLogLevelFromHttpStatusCode = $wqmhe.getBreadcrumbLogLevelFromHttpStatusCode;
module.exports.dsnFromString = $jypZc.dsnFromString;
module.exports.dsnToString = $jypZc.dsnToString;
module.exports.makeDsn = $jypZc.makeDsn;
module.exports.SentryError = $8QzOy.SentryError;
module.exports.GLOBAL_OBJ = $hsCGK.GLOBAL_OBJ;
module.exports.addConsoleInstrumentationFilter = $9SKf6.addConsoleInstrumentationFilter;
module.exports.addConsoleInstrumentationHandler = $9SKf6.addConsoleInstrumentationHandler;
module.exports.addFetchEndInstrumentationHandler = $8cQs4.addFetchEndInstrumentationHandler;
module.exports.addFetchInstrumentationHandler = $8cQs4.addFetchInstrumentationHandler;
module.exports.addGlobalErrorInstrumentationHandler = $66l16.addGlobalErrorInstrumentationHandler;
module.exports.addGlobalUnhandledRejectionInstrumentationHandler = $k5t8i.addGlobalUnhandledRejectionInstrumentationHandler;
module.exports.addHandler = $86JSI.addHandler;
module.exports.maybeInstrument = $86JSI.maybeInstrument;
module.exports.resetInstrumentationHandlers = $86JSI.resetInstrumentationHandlers;
module.exports.triggerHandlers = $86JSI.triggerHandlers;
module.exports.isDOMError = $fBPG6.isDOMError;
module.exports.isDOMException = $fBPG6.isDOMException;
module.exports.isElement = $fBPG6.isElement;
module.exports.isError = $fBPG6.isError;
module.exports.isErrorEvent = $fBPG6.isErrorEvent;
module.exports.isEvent = $fBPG6.isEvent;
module.exports.isInstanceOf = $fBPG6.isInstanceOf;
module.exports.isParameterizedString = $fBPG6.isParameterizedString;
module.exports.isPlainObject = $fBPG6.isPlainObject;
module.exports.isPrimitive = $fBPG6.isPrimitive;
module.exports.isRegExp = $fBPG6.isRegExp;
module.exports.isString = $fBPG6.isString;
module.exports.isSyntheticEvent = $fBPG6.isSyntheticEvent;
module.exports.isThenable = $fBPG6.isThenable;
module.exports.isVueViewModel = $fBPG6.isVueViewModel;
module.exports.isBrowser = $9Vsrl.isBrowser;
module.exports.CONSOLE_LEVELS = $jix5p.CONSOLE_LEVELS;
module.exports.consoleSandbox = $jix5p.consoleSandbox;
module.exports.debug = $jix5p.debug;
module.exports.originalConsoleMethods = $jix5p.originalConsoleMethods;
module.exports.addContextToFrame = $k6pIc.addContextToFrame;
module.exports.addExceptionMechanism = $k6pIc.addExceptionMechanism;
module.exports.addExceptionTypeValue = $k6pIc.addExceptionTypeValue;
module.exports.checkOrSetAlreadyCaught = $k6pIc.checkOrSetAlreadyCaught;
module.exports.getEventDescription = $k6pIc.getEventDescription;
module.exports.isAlreadyCaptured = $k6pIc.isAlreadyCaptured;
module.exports.parseSemver = $k6pIc.parseSemver;
module.exports.uuid4 = $k6pIc.uuid4;
module.exports.normalize = $bg87c.normalize;
module.exports.normalizeToSize = $bg87c.normalizeToSize;
module.exports.normalizeUrlToBase = $bg87c.normalizeUrlToBase;
module.exports.setNormalizeStringifier = $bg87c.setNormalizeStringifier;
module.exports.setNormalizationDepthOverrideHint = $fhFRD.setNormalizationDepthOverrideHint;
module.exports.setSkipNormalizationHint = $fhFRD.setSkipNormalizationHint;
module.exports.addNonEnumerableProperty = $2SQtm.addNonEnumerableProperty;
module.exports.convertToPlainObject = $2SQtm.convertToPlainObject;
module.exports.dropUndefinedKeys = $2SQtm.dropUndefinedKeys;
module.exports.extractExceptionKeysForMessage = $2SQtm.extractExceptionKeysForMessage;
module.exports.fill = $2SQtm.fill;
module.exports.getOriginalFunction = $2SQtm.getOriginalFunction;
module.exports.markFunctionWrapped = $2SQtm.markFunctionWrapped;
module.exports.objectify = $2SQtm.objectify;
module.exports.basename = $adgNM.basename;
module.exports.dirname = $adgNM.dirname;
module.exports.isAbsolute = $adgNM.isAbsolute;
module.exports.join = $adgNM.join;
module.exports.normalizePath = $adgNM.normalizePath;
module.exports.relative = $adgNM.relative;
module.exports.resolve = $adgNM.resolve;
module.exports.SENTRY_BUFFER_FULL_ERROR = $9DgSh.SENTRY_BUFFER_FULL_ERROR;
module.exports.makePromiseBuffer = $9DgSh.makePromiseBuffer;
module.exports.severityLevelFromString = $53CIi.severityLevelFromString;
module.exports.replaceExports = $cjy9I.replaceExports;
module.exports.UNKNOWN_FUNCTION = $8S2lx.UNKNOWN_FUNCTION;
module.exports.createStackParser = $8S2lx.createStackParser;
module.exports.getFramesFromEvent = $8S2lx.getFramesFromEvent;
module.exports.getFunctionName = $8S2lx.getFunctionName;
module.exports.stackParserFromStackParserOptions = $8S2lx.stackParserFromStackParserOptions;
module.exports.stripSentryFramesAndReverse = $8S2lx.stripSentryFramesAndReverse;
module.exports.isMatchingPattern = $23Myp.isMatchingPattern;
module.exports.safeJoin = $23Myp.safeJoin;
module.exports.snipLine = $23Myp.snipLine;
module.exports.stringMatchesSomePattern = $23Myp.stringMatchesSomePattern;
module.exports.truncate = $23Myp.truncate;
module.exports.isNativeFunction = $4ZAQw.isNativeFunction;
module.exports.supportsDOMError = $4ZAQw.supportsDOMError;
module.exports.supportsDOMException = $4ZAQw.supportsDOMException;
module.exports.supportsErrorEvent = $4ZAQw.supportsErrorEvent;
module.exports.supportsFetch = $4ZAQw.supportsFetch;
module.exports.supportsHistory = $4ZAQw.supportsHistory;
module.exports.supportsNativeFetch = $4ZAQw.supportsNativeFetch;
module.exports.supportsReferrerPolicy = $4ZAQw.supportsReferrerPolicy;
module.exports.supportsReportingObserver = $4ZAQw.supportsReportingObserver;
module.exports.SyncPromise = $8IgEN.SyncPromise;
module.exports.rejectedSyncPromise = $8IgEN.rejectedSyncPromise;
module.exports.resolvedSyncPromise = $8IgEN.resolvedSyncPromise;
module.exports.browserPerformanceTimeOrigin = $7q4WK.browserPerformanceTimeOrigin;
module.exports.dateTimestampInSeconds = $7q4WK.dateTimestampInSeconds;
module.exports.timestampInSeconds = $7q4WK.timestampInSeconds;
module.exports.TRACEPARENT_REGEXP = $hiiHh.TRACEPARENT_REGEXP;
module.exports.extractTraceparentData = $hiiHh.extractTraceparentData;
module.exports.generateSentryTraceHeader = $hiiHh.generateSentryTraceHeader;
module.exports.generateTraceparentHeader = $hiiHh.generateTraceparentHeader;
module.exports.propagationContextFromHeaders = $hiiHh.propagationContextFromHeaders;
module.exports.shouldContinueTrace = $hiiHh.shouldContinueTrace;
module.exports.getSDKSource = $5kWFc.getSDKSource;
module.exports.isBrowserBundle = $5kWFc.isBrowserBundle;
module.exports.addItemToEnvelope = $5fqIb.addItemToEnvelope;
module.exports.createAttachmentEnvelopeItem = $5fqIb.createAttachmentEnvelopeItem;
module.exports.createEnvelope = $5fqIb.createEnvelope;
module.exports.createEventEnvelopeHeaders = $5fqIb.createEventEnvelopeHeaders;
module.exports.createSpanEnvelopeItem = $5fqIb.createSpanEnvelopeItem;
module.exports.envelopeContainsItemType = $5fqIb.envelopeContainsItemType;
module.exports.envelopeItemTypeToDataCategory = $5fqIb.envelopeItemTypeToDataCategory;
module.exports.forEachEnvelopeItem = $5fqIb.forEachEnvelopeItem;
module.exports.getSdkMetadataForEnvelopeHeader = $5fqIb.getSdkMetadataForEnvelopeHeader;
module.exports.parseEnvelope = $5fqIb.parseEnvelope;
module.exports.serializeEnvelope = $5fqIb.serializeEnvelope;
module.exports.createClientReportEnvelope = $8IqnM.createClientReportEnvelope;
module.exports.DEFAULT_RETRY_AFTER = $a8HWQ.DEFAULT_RETRY_AFTER;
module.exports.disabledUntil = $a8HWQ.disabledUntil;
module.exports.isRateLimited = $a8HWQ.isRateLimited;
module.exports.parseRetryAfterHeader = $a8HWQ.parseRetryAfterHeader;
module.exports.updateRateLimits = $a8HWQ.updateRateLimits;
module.exports.MAX_BAGGAGE_STRING_LENGTH = $enaoN.MAX_BAGGAGE_STRING_LENGTH;
module.exports.SENTRY_BAGGAGE_KEY_PREFIX = $enaoN.SENTRY_BAGGAGE_KEY_PREFIX;
module.exports.SENTRY_BAGGAGE_KEY_PREFIX_REGEX = $enaoN.SENTRY_BAGGAGE_KEY_PREFIX_REGEX;
module.exports.baggageHeaderToDynamicSamplingContext = $enaoN.baggageHeaderToDynamicSamplingContext;
module.exports.dynamicSamplingContextToSentryBaggageHeader = $enaoN.dynamicSamplingContextToSentryBaggageHeader;
module.exports.mergeBaggageHeaders = $enaoN.mergeBaggageHeaders;
module.exports.objectToBaggageHeader = $enaoN.objectToBaggageHeader;
module.exports.parseBaggageHeader = $enaoN.parseBaggageHeader;
module.exports.getHttpSpanDetailsFromUrlObject = $kipJA.getHttpSpanDetailsFromUrlObject;
module.exports.getSanitizedUrlString = $kipJA.getSanitizedUrlString;
module.exports.getSanitizedUrlStringFromUrlObject = $kipJA.getSanitizedUrlStringFromUrlObject;
module.exports.isURLObjectRelative = $kipJA.isURLObjectRelative;
module.exports.parseStringToURLObject = $kipJA.parseStringToURLObject;
module.exports.parseUrl = $kipJA.parseUrl;
module.exports.stripDataUrlContent = $kipJA.stripDataUrlContent;
module.exports.stripUrlQueryAndFragment = $kipJA.stripUrlQueryAndFragment;
module.exports._INTERNAL_enhanceErrorWithSentryInfo = $bjI1e._enhanceErrorWithSentryInfo;
module.exports.eventFromMessage = $bjI1e.eventFromMessage;
module.exports.eventFromUnknownInput = $bjI1e.eventFromUnknownInput;
module.exports.exceptionFromError = $bjI1e.exceptionFromError;
module.exports.parseStackFrames = $bjI1e.parseStackFrames;
module.exports.LRUMap = $88kW2.LRUMap;
module.exports.generateSpanId = $bSNF3.generateSpanId;
module.exports.generateTraceId = $bSNF3.generateTraceId;
module.exports.SDK_VERSION = $gywEi.SDK_VERSION;
module.exports.getDebugImagesForResources = $9Dizr.getDebugImagesForResources;
module.exports.getFilenameToDebugIdMap = $9Dizr.getFilenameToDebugIdMap;
module.exports.getFilenameToMetadataMap = $2ETn4.getFilenameToMetadataMap;
module.exports.escapeStringForRegex = $1GUda.escapeStringForRegex;
module.exports._INTERNAL_safeDateNow = $9xAUk.safeDateNow;
module.exports._INTERNAL_safeMathRandom = $9xAUk.safeMathRandom;
module.exports._INTERNAL_withRandomSafeContext = $9xAUk.withRandomSafeContext;
module.exports.getComponentName = $5TFPR.getComponentName;
module.exports.getLocationHref = $5TFPR.getLocationHref;
module.exports.htmlTreeAsString = $5TFPR.htmlTreeAsString;
module.exports.instrumentLangChainEmbeddings = $6wQ2i.instrumentLangChainEmbeddings;

});
parcelRegister("hHcC4", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $jCjMv = parcelRequire("jCjMv");

var $66l16 = parcelRequire("66l16");

var $k5t8i = parcelRequire("k5t8i");

var $jix5p = parcelRequire("jix5p");

var $2dG64 = parcelRequire("2dG64");

var $9X7hl = parcelRequire("9X7hl");
let $ce203c85e35f0598$var$errorsInstrumented = false;
function $ce203c85e35f0598$var$registerSpanErrorInstrumentation() {
    if ($ce203c85e35f0598$var$errorsInstrumented) return;
    function errorCallback() {
        const activeSpan = $2dG64.getActiveSpan();
        const rootSpan = activeSpan && $2dG64.getRootSpan(activeSpan);
        if (rootSpan) {
            const message = "internal_error";
            $jCjMv.DEBUG_BUILD && $jix5p.debug.log(`[Tracing] Root span: ${message} -> Global error occurred`);
            rootSpan.setStatus({
                code: $9X7hl.SPAN_STATUS_ERROR,
                message: message
            });
        }
    }
    $ce203c85e35f0598$var$errorsInstrumented = true;
    $66l16.addGlobalErrorInstrumentationHandler(errorCallback);
    $k5t8i.addGlobalUnhandledRejectionInstrumentationHandler(errorCallback);
}
module.exports.registerSpanErrorInstrumentation = $ce203c85e35f0598$var$registerSpanErrorInstrumentation;

});
parcelRegister("jCjMv", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $e480e91689ea8b79$var$DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;
module.exports.DEBUG_BUILD = $e480e91689ea8b79$var$DEBUG_BUILD;

});

parcelRegister("66l16", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hsCGK = parcelRequire("hsCGK");

var $86JSI = parcelRequire("86JSI");
let $47139b1cfcab87ed$var$_oldOnErrorHandler = null;
function $47139b1cfcab87ed$var$addGlobalErrorInstrumentationHandler(handler) {
    const type = "error";
    $86JSI.addHandler(type, handler);
    $86JSI.maybeInstrument(type, $47139b1cfcab87ed$var$instrumentError);
}
function $47139b1cfcab87ed$var$instrumentError() {
    $47139b1cfcab87ed$var$_oldOnErrorHandler = $hsCGK.GLOBAL_OBJ.onerror;
    $hsCGK.GLOBAL_OBJ.onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        $86JSI.triggerHandlers("error", handlerData);
        if ($47139b1cfcab87ed$var$_oldOnErrorHandler) return $47139b1cfcab87ed$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    $hsCGK.GLOBAL_OBJ.onerror.__SENTRY_INSTRUMENTED__ = true;
}
module.exports.addGlobalErrorInstrumentationHandler = $47139b1cfcab87ed$var$addGlobalErrorInstrumentationHandler;

});
parcelRegister("hsCGK", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $cb630fe70a110f80$var$GLOBAL_OBJ = globalThis;
module.exports.GLOBAL_OBJ = $cb630fe70a110f80$var$GLOBAL_OBJ;

});

parcelRegister("86JSI", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $jCjMv = parcelRequire("jCjMv");

var $jix5p = parcelRequire("jix5p");

var $8S2lx = parcelRequire("8S2lx");
const $5e72796119110080$var$handlers = {};
const $5e72796119110080$var$instrumented = {};
function $5e72796119110080$var$addHandler(type, handler) {
    $5e72796119110080$var$handlers[type] = $5e72796119110080$var$handlers[type] || [];
    $5e72796119110080$var$handlers[type].push(handler);
    return ()=>{
        const typeHandlers = $5e72796119110080$var$handlers[type];
        if (typeHandlers) {
            const index = typeHandlers.indexOf(handler);
            if (index !== -1) typeHandlers.splice(index, 1);
        }
    };
}
function $5e72796119110080$var$resetInstrumentationHandlers() {
    Object.keys($5e72796119110080$var$handlers).forEach((key)=>{
        $5e72796119110080$var$handlers[key] = void 0;
    });
}
function $5e72796119110080$var$maybeInstrument(type, instrumentFn) {
    if (!$5e72796119110080$var$instrumented[type]) {
        $5e72796119110080$var$instrumented[type] = true;
        try {
            instrumentFn();
        } catch (e) {
            $jCjMv.DEBUG_BUILD && $jix5p.debug.error(`Error while instrumenting ${type}`, e);
        }
    }
}
function $5e72796119110080$var$triggerHandlers(type, data) {
    const typeHandlers = type && $5e72796119110080$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        $jCjMv.DEBUG_BUILD && $jix5p.debug.error(`Error while triggering instrumentation handler.
Type: ${type}
Name: ${$8S2lx.getFunctionName(handler)}
Error:`, e);
    }
}
module.exports.addHandler = $5e72796119110080$var$addHandler;
module.exports.maybeInstrument = $5e72796119110080$var$maybeInstrument;
module.exports.resetInstrumentationHandlers = $5e72796119110080$var$resetInstrumentationHandlers;
module.exports.triggerHandlers = $5e72796119110080$var$triggerHandlers;

});
parcelRegister("jix5p", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hbMFZ = parcelRequire("hbMFZ");

var $jCjMv = parcelRequire("jCjMv");

var $hsCGK = parcelRequire("hsCGK");
const $e0c95d00d4ba4ab5$var$CONSOLE_LEVELS = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
const $e0c95d00d4ba4ab5$var$PREFIX = "Sentry Logger ";
const $e0c95d00d4ba4ab5$var$originalConsoleMethods = {};
function $e0c95d00d4ba4ab5$var$consoleSandbox(callback) {
    if (!("console" in $hsCGK.GLOBAL_OBJ)) return callback();
    const console = $hsCGK.GLOBAL_OBJ.console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($e0c95d00d4ba4ab5$var$originalConsoleMethods);
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $e0c95d00d4ba4ab5$var$originalConsoleMethods[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $e0c95d00d4ba4ab5$var$enable() {
    $e0c95d00d4ba4ab5$var$_getLoggerSettings().enabled = true;
}
function $e0c95d00d4ba4ab5$var$disable() {
    $e0c95d00d4ba4ab5$var$_getLoggerSettings().enabled = false;
}
function $e0c95d00d4ba4ab5$var$isEnabled() {
    return $e0c95d00d4ba4ab5$var$_getLoggerSettings().enabled;
}
function $e0c95d00d4ba4ab5$var$log(...args) {
    $e0c95d00d4ba4ab5$var$_maybeLog("log", ...args);
}
function $e0c95d00d4ba4ab5$var$warn(...args) {
    $e0c95d00d4ba4ab5$var$_maybeLog("warn", ...args);
}
function $e0c95d00d4ba4ab5$var$error(...args) {
    $e0c95d00d4ba4ab5$var$_maybeLog("error", ...args);
}
function $e0c95d00d4ba4ab5$var$_maybeLog(level, ...args) {
    if (!$jCjMv.DEBUG_BUILD) return;
    if ($e0c95d00d4ba4ab5$var$isEnabled()) $e0c95d00d4ba4ab5$var$consoleSandbox(()=>{
        $hsCGK.GLOBAL_OBJ.console[level](`${$e0c95d00d4ba4ab5$var$PREFIX}[${level}]:`, ...args);
    });
}
function $e0c95d00d4ba4ab5$var$_getLoggerSettings() {
    if (!$jCjMv.DEBUG_BUILD) return {
        enabled: false
    };
    return $hbMFZ.getGlobalSingleton("loggerSettings", ()=>({
            enabled: false
        }));
}
const $e0c95d00d4ba4ab5$var$debug = {
    enable: /** Enable logging. */ $e0c95d00d4ba4ab5$var$enable,
    disable: /** Disable logging. */ $e0c95d00d4ba4ab5$var$disable,
    isEnabled: /** Check if logging is enabled. */ $e0c95d00d4ba4ab5$var$isEnabled,
    log: /** Log a message. */ $e0c95d00d4ba4ab5$var$log,
    warn: /** Log a warning. */ $e0c95d00d4ba4ab5$var$warn,
    error: /** Log an error. */ $e0c95d00d4ba4ab5$var$error
};
module.exports.CONSOLE_LEVELS = $e0c95d00d4ba4ab5$var$CONSOLE_LEVELS;
module.exports.consoleSandbox = $e0c95d00d4ba4ab5$var$consoleSandbox;
module.exports.debug = $e0c95d00d4ba4ab5$var$debug;
module.exports.originalConsoleMethods = $e0c95d00d4ba4ab5$var$originalConsoleMethods;

});
parcelRegister("hbMFZ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gywEi = parcelRequire("gywEi");

var $hsCGK = parcelRequire("hsCGK");
function $c83938d0ed117cec$var$getMainCarrier() {
    $c83938d0ed117cec$var$getSentryCarrier($hsCGK.GLOBAL_OBJ);
    return $hsCGK.GLOBAL_OBJ;
}
function $c83938d0ed117cec$var$getSentryCarrier(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.version = __SENTRY__.version || $gywEi.SDK_VERSION;
    return __SENTRY__[$gywEi.SDK_VERSION] = __SENTRY__[$gywEi.SDK_VERSION] || {};
}
function $c83938d0ed117cec$var$getGlobalSingleton(name, creator, obj = $hsCGK.GLOBAL_OBJ) {
    const __SENTRY__ = obj.__SENTRY__ = obj.__SENTRY__ || {};
    const carrier = __SENTRY__[$gywEi.SDK_VERSION] = __SENTRY__[$gywEi.SDK_VERSION] || {};
    return carrier[name] || (carrier[name] = creator());
}
module.exports.getGlobalSingleton = $c83938d0ed117cec$var$getGlobalSingleton;
module.exports.getMainCarrier = $c83938d0ed117cec$var$getMainCarrier;
module.exports.getSentryCarrier = $c83938d0ed117cec$var$getSentryCarrier;

});
parcelRegister("gywEi", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $c0d925b6d5756770$var$SDK_VERSION = "10.55.0";
module.exports.SDK_VERSION = $c0d925b6d5756770$var$SDK_VERSION;

});



parcelRegister("8S2lx", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $67552fd1c6a0a70e$var$STACKTRACE_FRAME_LIMIT = 50;
const $67552fd1c6a0a70e$var$UNKNOWN_FUNCTION = "?";
const $67552fd1c6a0a70e$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $67552fd1c6a0a70e$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
function $67552fd1c6a0a70e$var$createStackParser(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split("\n");
        for(let i = skipFirstLines; i < lines.length; i++){
            let line = lines[i];
            if (line.length > 1024) line = line.slice(0, 1024);
            const cleanedLine = $67552fd1c6a0a70e$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($67552fd1c6a0a70e$var$WEBPACK_ERROR_REGEXP, "$1") : line;
            if (cleanedLine.includes("Error: ")) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $67552fd1c6a0a70e$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $67552fd1c6a0a70e$var$stripSentryFramesAndReverse(frames.slice(framesToPop));
    };
}
function $67552fd1c6a0a70e$var$stackParserFromStackParserOptions(stackParser) {
    if (Array.isArray(stackParser)) return $67552fd1c6a0a70e$var$createStackParser(...stackParser);
    return stackParser;
}
function $67552fd1c6a0a70e$var$stripSentryFramesAndReverse(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    if (/sentryWrapped/.test($67552fd1c6a0a70e$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    localStack.reverse();
    if ($67552fd1c6a0a70e$var$STRIP_FRAME_REGEXP.test($67552fd1c6a0a70e$var$getLastStackFrame(localStack).function || "")) {
        localStack.pop();
        if ($67552fd1c6a0a70e$var$STRIP_FRAME_REGEXP.test($67552fd1c6a0a70e$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    }
    return localStack.slice(0, $67552fd1c6a0a70e$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || $67552fd1c6a0a70e$var$getLastStackFrame(localStack).filename,
            function: frame.function || $67552fd1c6a0a70e$var$UNKNOWN_FUNCTION
        }));
}
function $67552fd1c6a0a70e$var$getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
const $67552fd1c6a0a70e$var$defaultFunctionName = "<anonymous>";
function $67552fd1c6a0a70e$var$getFunctionName(fn) {
    try {
        if (!fn || typeof fn !== "function") return $67552fd1c6a0a70e$var$defaultFunctionName;
        return fn.name || $67552fd1c6a0a70e$var$defaultFunctionName;
    } catch  {
        return $67552fd1c6a0a70e$var$defaultFunctionName;
    }
}
function $67552fd1c6a0a70e$var$getFramesFromEvent(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            exception.values.forEach((value)=>{
                if (value.stacktrace.frames) frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch  {
            return void 0;
        }
    }
    return void 0;
}
function $67552fd1c6a0a70e$var$normalizeStackTracePath(path) {
    let filename = path?.startsWith("file://") ? path.slice(7) : path;
    if (filename?.match(/\/[A-Z]:/)) filename = filename.slice(1);
    return filename;
}
module.exports.UNKNOWN_FUNCTION = $67552fd1c6a0a70e$var$UNKNOWN_FUNCTION;
module.exports.createStackParser = $67552fd1c6a0a70e$var$createStackParser;
module.exports.getFramesFromEvent = $67552fd1c6a0a70e$var$getFramesFromEvent;
module.exports.getFunctionName = $67552fd1c6a0a70e$var$getFunctionName;
module.exports.normalizeStackTracePath = $67552fd1c6a0a70e$var$normalizeStackTracePath;
module.exports.stackParserFromStackParserOptions = $67552fd1c6a0a70e$var$stackParserFromStackParserOptions;
module.exports.stripSentryFramesAndReverse = $67552fd1c6a0a70e$var$stripSentryFramesAndReverse;

});



parcelRegister("k5t8i", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hsCGK = parcelRequire("hsCGK");

var $86JSI = parcelRequire("86JSI");
let $e9fadf6f00b7b6a2$var$_oldOnUnhandledRejectionHandler = null;
function $e9fadf6f00b7b6a2$var$addGlobalUnhandledRejectionInstrumentationHandler(handler) {
    const type = "unhandledrejection";
    $86JSI.addHandler(type, handler);
    $86JSI.maybeInstrument(type, $e9fadf6f00b7b6a2$var$instrumentUnhandledRejection);
}
function $e9fadf6f00b7b6a2$var$instrumentUnhandledRejection() {
    $e9fadf6f00b7b6a2$var$_oldOnUnhandledRejectionHandler = $hsCGK.GLOBAL_OBJ.onunhandledrejection;
    $hsCGK.GLOBAL_OBJ.onunhandledrejection = function(e) {
        const handlerData = e;
        $86JSI.triggerHandlers("unhandledrejection", handlerData);
        if ($e9fadf6f00b7b6a2$var$_oldOnUnhandledRejectionHandler) return $e9fadf6f00b7b6a2$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    $hsCGK.GLOBAL_OBJ.onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}
module.exports.addGlobalUnhandledRejectionInstrumentationHandler = $e9fadf6f00b7b6a2$var$addGlobalUnhandledRejectionInstrumentationHandler;

});

parcelRegister("2dG64", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $Up7k9 = parcelRequire("Up7k9");

var $f8fWp = parcelRequire("f8fWp");

var $hbMFZ = parcelRequire("hbMFZ");

var $gjJ9A = parcelRequire("gjJ9A");

var $3dwiN = parcelRequire("3dwiN");

var $9X7hl = parcelRequire("9X7hl");

var $iUxao = parcelRequire("iUxao");

var $2SQtm = parcelRequire("2SQtm");

var $bSNF3 = parcelRequire("bSNF3");

var $7q4WK = parcelRequire("7q4WK");

var $hiiHh = parcelRequire("hiiHh");

var $jix5p = parcelRequire("jix5p");

var $k7IIJ = parcelRequire("k7IIJ");
const $19dd733b72c5107f$var$TRACE_FLAG_NONE = 0;
const $19dd733b72c5107f$var$TRACE_FLAG_SAMPLED = 1;
let $19dd733b72c5107f$var$hasShownSpanDropWarning = false;
function $19dd733b72c5107f$var$spanToTransactionTraceContext(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, origin: origin, links: links } = $19dd733b72c5107f$var$spanToJSON(span);
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id,
        data: data,
        op: op,
        status: status,
        origin: origin,
        links: links
    };
}
function $19dd733b72c5107f$var$spanToTraceContext(span) {
    const { spanId: spanId, traceId: trace_id, isRemote: isRemote } = span.spanContext();
    const parent_span_id = isRemote ? spanId : $19dd733b72c5107f$var$spanToJSON(span).parent_span_id;
    const scope = $iUxao.getCapturedScopesOnSpan(span).scope;
    const span_id = isRemote ? scope?.getPropagationContext().propagationSpanId || $bSNF3.generateSpanId() : spanId;
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id
    };
}
function $19dd733b72c5107f$var$spanToTraceHeader(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $19dd733b72c5107f$var$spanIsSampled(span);
    return $hiiHh.generateSentryTraceHeader(traceId, spanId, sampled);
}
function $19dd733b72c5107f$var$spanToTraceparentHeader(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $19dd733b72c5107f$var$spanIsSampled(span);
    return $hiiHh.generateTraceparentHeader(traceId, spanId, sampled);
}
function $19dd733b72c5107f$var$convertSpanLinksForEnvelope(links) {
    if (links && links.length > 0) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags, ...restContext }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $19dd733b72c5107f$var$TRACE_FLAG_SAMPLED,
            attributes: attributes,
            ...restContext
        }));
    else return void 0;
}
function $19dd733b72c5107f$var$getStreamedSpanLinks(links) {
    if (links?.length) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $19dd733b72c5107f$var$TRACE_FLAG_SAMPLED,
            attributes: attributes
        }));
    else return void 0;
}
function $19dd733b72c5107f$var$spanTimeInputToSeconds(input) {
    if (typeof input === "number") return $19dd733b72c5107f$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $19dd733b72c5107f$var$ensureTimestampInSeconds(input.getTime());
    return $7q4WK.timestampInSeconds();
}
function $19dd733b72c5107f$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1e3 : timestamp;
}
function $19dd733b72c5107f$var$spanToJSON(span) {
    if ($19dd733b72c5107f$var$spanIsSentrySpan(span)) return span.getSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    if ($19dd733b72c5107f$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, status: status, links: links } = span;
        return {
            span_id: span_id,
            trace_id: trace_id,
            data: attributes,
            description: name,
            parent_span_id: $19dd733b72c5107f$var$getOtelParentSpanId(span),
            start_timestamp: $19dd733b72c5107f$var$spanTimeInputToSeconds(startTime),
            // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
            timestamp: $19dd733b72c5107f$var$spanTimeInputToSeconds(endTime) || void 0,
            status: $19dd733b72c5107f$var$getStatusMessage(status),
            op: attributes[$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_OP],
            origin: attributes[$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
            links: $19dd733b72c5107f$var$convertSpanLinksForEnvelope(links)
        };
    }
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        data: {}
    };
}
function $19dd733b72c5107f$var$spanToStreamedSpanJSON(span) {
    if ($19dd733b72c5107f$var$spanIsSentrySpan(span)) return span.getStreamedSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    if ($19dd733b72c5107f$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, status: status, links: links } = span;
        return {
            name: name,
            span_id: span_id,
            trace_id: trace_id,
            parent_span_id: $19dd733b72c5107f$var$getOtelParentSpanId(span),
            start_timestamp: $19dd733b72c5107f$var$spanTimeInputToSeconds(startTime),
            end_timestamp: $19dd733b72c5107f$var$spanTimeInputToSeconds(endTime),
            is_segment: span === $19dd733b72c5107f$var$INTERNAL_getSegmentSpan(span),
            status: $19dd733b72c5107f$var$getSimpleStatusMessage(status),
            attributes: attributes,
            links: $19dd733b72c5107f$var$getStreamedSpanLinks(links)
        };
    }
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        name: "",
        end_timestamp: 0,
        status: "ok",
        is_segment: span === $19dd733b72c5107f$var$INTERNAL_getSegmentSpan(span)
    };
}
function $19dd733b72c5107f$var$getOtelParentSpanId(span) {
    return "parentSpanId" in span ? span.parentSpanId : "parentSpanContext" in span ? span.parentSpanContext?.spanId : void 0;
}
function $19dd733b72c5107f$var$streamedSpanJsonToSerializedSpan(spanJson) {
    return {
        ...spanJson,
        attributes: $f8fWp.serializeAttributes(spanJson.attributes),
        links: spanJson.links?.map((link)=>({
                ...link,
                attributes: $f8fWp.serializeAttributes(link.attributes)
            }))
    };
}
function $19dd733b72c5107f$var$spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    const castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
function $19dd733b72c5107f$var$spanIsSentrySpan(span) {
    return typeof span.getSpanJSON === "function";
}
function $19dd733b72c5107f$var$spanIsSampled(span) {
    const { traceFlags: traceFlags } = span.spanContext();
    return traceFlags === $19dd733b72c5107f$var$TRACE_FLAG_SAMPLED;
}
function $19dd733b72c5107f$var$getStatusMessage(status) {
    if (!status || status.code === $9X7hl.SPAN_STATUS_UNSET) return void 0;
    if (status.code === $9X7hl.SPAN_STATUS_OK) return "ok";
    return status.message || "internal_error";
}
function $19dd733b72c5107f$var$getSimpleStatusMessage(status) {
    return !status || status.code === $9X7hl.SPAN_STATUS_OK || status.code === $9X7hl.SPAN_STATUS_UNSET || status.message === "cancelled" ? "ok" : "error";
}
const $19dd733b72c5107f$var$CHILD_SPANS_FIELD = "_sentryChildSpans";
const $19dd733b72c5107f$var$ROOT_SPAN_FIELD = "_sentryRootSpan";
function $19dd733b72c5107f$var$addChildSpanToSpan(span, childSpan) {
    const rootSpan = span[$19dd733b72c5107f$var$ROOT_SPAN_FIELD] || span;
    $2SQtm.addNonEnumerableProperty(childSpan, $19dd733b72c5107f$var$ROOT_SPAN_FIELD, rootSpan);
    if (span[$19dd733b72c5107f$var$CHILD_SPANS_FIELD]) span[$19dd733b72c5107f$var$CHILD_SPANS_FIELD].add(childSpan);
    else $2SQtm.addNonEnumerableProperty(span, $19dd733b72c5107f$var$CHILD_SPANS_FIELD, /* @__PURE__ */ new Set([
        childSpan
    ]));
}
function $19dd733b72c5107f$var$removeChildSpanFromSpan(span, childSpan) {
    if (span[$19dd733b72c5107f$var$CHILD_SPANS_FIELD]) span[$19dd733b72c5107f$var$CHILD_SPANS_FIELD].delete(childSpan);
}
function $19dd733b72c5107f$var$getSpanDescendants(span) {
    const resultSet = /* @__PURE__ */ new Set();
    function addSpanChildren(span2) {
        if (resultSet.has(span2)) return;
        else if ($19dd733b72c5107f$var$spanIsSampled(span2)) {
            resultSet.add(span2);
            const childSpans = span2[$19dd733b72c5107f$var$CHILD_SPANS_FIELD] ? Array.from(span2[$19dd733b72c5107f$var$CHILD_SPANS_FIELD]) : [];
            for (const childSpan of childSpans)addSpanChildren(childSpan);
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
const $19dd733b72c5107f$var$getRootSpan = $19dd733b72c5107f$var$INTERNAL_getSegmentSpan;
function $19dd733b72c5107f$var$INTERNAL_getSegmentSpan(span) {
    return span[$19dd733b72c5107f$var$ROOT_SPAN_FIELD] || span;
}
function $19dd733b72c5107f$var$getActiveSpan() {
    const carrier$1 = $hbMFZ.getMainCarrier();
    const acs = $Up7k9.getAsyncContextStrategy(carrier$1);
    if (acs.getActiveSpan) return acs.getActiveSpan();
    return $k7IIJ._getSpanForScope($gjJ9A.getCurrentScope());
}
function $19dd733b72c5107f$var$showSpanDropWarning() {
    if (!$19dd733b72c5107f$var$hasShownSpanDropWarning) {
        $jix5p.consoleSandbox(()=>{
            console.warn("[Sentry] Returning null from `beforeSendSpan` is disallowed. To drop certain spans, configure the respective integrations directly or use `ignoreSpans`.");
        });
        $19dd733b72c5107f$var$hasShownSpanDropWarning = true;
    }
}
function $19dd733b72c5107f$var$updateSpanName(span, name) {
    span.updateName(name);
    span.setAttributes({
        [$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: "custom",
        [$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME]: name
    });
}
module.exports.INTERNAL_getSegmentSpan = $19dd733b72c5107f$var$INTERNAL_getSegmentSpan;
module.exports.TRACE_FLAG_NONE = $19dd733b72c5107f$var$TRACE_FLAG_NONE;
module.exports.TRACE_FLAG_SAMPLED = $19dd733b72c5107f$var$TRACE_FLAG_SAMPLED;
module.exports.addChildSpanToSpan = $19dd733b72c5107f$var$addChildSpanToSpan;
module.exports.convertSpanLinksForEnvelope = $19dd733b72c5107f$var$convertSpanLinksForEnvelope;
module.exports.getActiveSpan = $19dd733b72c5107f$var$getActiveSpan;
module.exports.getRootSpan = $19dd733b72c5107f$var$getRootSpan;
module.exports.getSimpleStatusMessage = $19dd733b72c5107f$var$getSimpleStatusMessage;
module.exports.getSpanDescendants = $19dd733b72c5107f$var$getSpanDescendants;
module.exports.getStatusMessage = $19dd733b72c5107f$var$getStatusMessage;
module.exports.getStreamedSpanLinks = $19dd733b72c5107f$var$getStreamedSpanLinks;
module.exports.removeChildSpanFromSpan = $19dd733b72c5107f$var$removeChildSpanFromSpan;
module.exports.showSpanDropWarning = $19dd733b72c5107f$var$showSpanDropWarning;
module.exports.spanIsSampled = $19dd733b72c5107f$var$spanIsSampled;
module.exports.spanTimeInputToSeconds = $19dd733b72c5107f$var$spanTimeInputToSeconds;
module.exports.spanToJSON = $19dd733b72c5107f$var$spanToJSON;
module.exports.spanToStreamedSpanJSON = $19dd733b72c5107f$var$spanToStreamedSpanJSON;
module.exports.spanToTraceContext = $19dd733b72c5107f$var$spanToTraceContext;
module.exports.spanToTraceHeader = $19dd733b72c5107f$var$spanToTraceHeader;
module.exports.spanToTraceparentHeader = $19dd733b72c5107f$var$spanToTraceparentHeader;
module.exports.spanToTransactionTraceContext = $19dd733b72c5107f$var$spanToTransactionTraceContext;
module.exports.streamedSpanJsonToSerializedSpan = $19dd733b72c5107f$var$streamedSpanJsonToSerializedSpan;
module.exports.updateSpanName = $19dd733b72c5107f$var$updateSpanName;

});
parcelRegister("Up7k9", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hbMFZ = parcelRequire("hbMFZ");

var $eE5JQ = parcelRequire("eE5JQ");
function $0a98b6d0eaf3981a$var$setAsyncContextStrategy(strategy) {
    const registry = $hbMFZ.getMainCarrier();
    const sentry = $hbMFZ.getSentryCarrier(registry);
    sentry.acs = strategy;
}
function $0a98b6d0eaf3981a$var$getAsyncContextStrategy(carrier$1) {
    const sentry = $hbMFZ.getSentryCarrier(carrier$1);
    if (sentry.acs) return sentry.acs;
    return $eE5JQ.getStackAsyncContextStrategy();
}
module.exports.getAsyncContextStrategy = $0a98b6d0eaf3981a$var$getAsyncContextStrategy;
module.exports.setAsyncContextStrategy = $0a98b6d0eaf3981a$var$setAsyncContextStrategy;

});
parcelRegister("eE5JQ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gRCrP = parcelRequire("gRCrP");

var $d8aK6 = parcelRequire("d8aK6");

var $grxWE = parcelRequire("grxWE");

var $fBPG6 = parcelRequire("fBPG6");

var $hbMFZ = parcelRequire("hbMFZ");
class $aa9940a8be97ed6c$var$AsyncContextStack {
    constructor(scope$1, isolationScope){
        let assignedScope;
        if (!scope$1) assignedScope = new $d8aK6.Scope();
        else assignedScope = scope$1;
        let assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new $d8aK6.Scope();
        else assignedIsolationScope = isolationScope;
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Fork a scope for the stack.
   */ withScope(callback) {
        const scope = this._pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            this._popScope();
            throw e;
        }
        if ($fBPG6.isThenable(maybePromiseResult)) return $grxWE.chainAndCopyPromiseLike(maybePromiseResult, ()=>this._popScope(), ()=>this._popScope());
        this._popScope();
        return maybePromiseResult;
    }
    /**
   * Get the client of the stack.
   */ getClient() {
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   */ getScope() {
        return this.getStackTop().scope;
    }
    /**
   * Get the isolation scope for the stack.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * Push a scope to the stack.
   */ _pushScope() {
        const scope = this.getScope().clone();
        this._stack.push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * Pop a scope from the stack.
   */ _popScope() {
        if (this._stack.length <= 1) return false;
        return !!this._stack.pop();
    }
}
function $aa9940a8be97ed6c$var$getAsyncContextStack() {
    const registry = $hbMFZ.getMainCarrier();
    const sentry = $hbMFZ.getSentryCarrier(registry);
    return sentry.stack = sentry.stack || new $aa9940a8be97ed6c$var$AsyncContextStack($gRCrP.getDefaultCurrentScope(), $gRCrP.getDefaultIsolationScope());
}
function $aa9940a8be97ed6c$var$withScope(callback) {
    return $aa9940a8be97ed6c$var$getAsyncContextStack().withScope(callback);
}
function $aa9940a8be97ed6c$var$withSetScope(scope, callback) {
    const stack = $aa9940a8be97ed6c$var$getAsyncContextStack();
    return stack.withScope(()=>{
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function $aa9940a8be97ed6c$var$withIsolationScope(callback) {
    return $aa9940a8be97ed6c$var$getAsyncContextStack().withScope(()=>{
        return callback($aa9940a8be97ed6c$var$getAsyncContextStack().getIsolationScope());
    });
}
function $aa9940a8be97ed6c$var$getStackAsyncContextStrategy() {
    return {
        withIsolationScope: $aa9940a8be97ed6c$var$withIsolationScope,
        withScope: $aa9940a8be97ed6c$var$withScope,
        withSetScope: $aa9940a8be97ed6c$var$withSetScope,
        withSetIsolationScope: (_isolationScope, callback)=>{
            return $aa9940a8be97ed6c$var$withIsolationScope(callback);
        },
        getCurrentScope: ()=>$aa9940a8be97ed6c$var$getAsyncContextStack().getScope(),
        getIsolationScope: ()=>$aa9940a8be97ed6c$var$getAsyncContextStack().getIsolationScope()
    };
}
module.exports.AsyncContextStack = $aa9940a8be97ed6c$var$AsyncContextStack;
module.exports.getStackAsyncContextStrategy = $aa9940a8be97ed6c$var$getStackAsyncContextStrategy;

});
parcelRegister("gRCrP", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hbMFZ = parcelRequire("hbMFZ");

var $d8aK6 = parcelRequire("d8aK6");
function $c46f6b82b515a262$var$getDefaultCurrentScope() {
    return $hbMFZ.getGlobalSingleton("defaultCurrentScope", ()=>new $d8aK6.Scope());
}
function $c46f6b82b515a262$var$getDefaultIsolationScope() {
    return $hbMFZ.getGlobalSingleton("defaultIsolationScope", ()=>new $d8aK6.Scope());
}
module.exports.getDefaultCurrentScope = $c46f6b82b515a262$var$getDefaultCurrentScope;
module.exports.getDefaultIsolationScope = $c46f6b82b515a262$var$getDefaultIsolationScope;

});
parcelRegister("d8aK6", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $jCjMv = parcelRequire("jCjMv");

var $jIJ38 = parcelRequire("jIJ38");

var $jix5p = parcelRequire("jix5p");

var $fBPG6 = parcelRequire("fBPG6");

var $j4dmO = parcelRequire("j4dmO");

var $k6pIc = parcelRequire("k6pIc");

var $bSNF3 = parcelRequire("bSNF3");

var $9xAUk = parcelRequire("9xAUk");

var $k7IIJ = parcelRequire("k7IIJ");

var $23Myp = parcelRequire("23Myp");

var $7q4WK = parcelRequire("7q4WK");
const $98f45afb44e85f0e$var$DEFAULT_MAX_BREADCRUMBS = 100;
class $98f45afb44e85f0e$var$Scope {
    // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._attributes = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = {
            traceId: $bSNF3.generateTraceId(),
            sampleRand: $9xAUk.safeMathRandom()
        };
    }
    /**
   * Clone all data from this scope into a new scope.
   */ clone() {
        const newScope = new $98f45afb44e85f0e$var$Scope();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._attributes = {
            ...this._attributes
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        if (this._contexts.flags) newScope._contexts.flags = {
            values: [
                ...this._contexts.flags.values
            ]
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        newScope._lastEventId = this._lastEventId;
        newScope._conversationId = this._conversationId;
        $k7IIJ._setSpanForScope(newScope, $k7IIJ._getSpanForScope(this));
        return newScope;
    }
    /**
   * Update the client assigned to this scope.
   * Note that not every scope will have a client assigned - isolation scopes & the global scope will generally not have a client,
   * as well as manually created scopes.
   */ setClient(client) {
        this._client = client;
    }
    /**
   * Set the ID of the last captured error event.
   * This is generally only captured on the isolation scope.
   */ setLastEventId(lastEventId) {
        this._lastEventId = lastEventId;
    }
    /**
   * Get the client assigned to this scope.
   */ getClient() {
        return this._client;
    }
    /**
   * Get the ID of the last captured error event.
   * This is generally only available on the isolation scope.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * Add an event processor that will be called before an event is sent.
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * Set the user for this scope.
   * Set to `null` to unset the user.
   */ setUser(user) {
        this._user = user || {
            email: void 0,
            id: void 0,
            ip_address: void 0,
            username: void 0
        };
        if (this._session) $jIJ38.updateSession(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the user from this scope.
   */ getUser() {
        return this._user;
    }
    /**
   * Set the conversation ID for this scope.
   * Set to `null` to unset the conversation ID.
   */ setConversationId(conversationId) {
        this._conversationId = conversationId || void 0;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set an object that will be merged into existing tags on the scope,
   * and will be sent as tags data with the event.
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single tag that will be sent as tags data with the event.
   */ setTag(key, value) {
        return this.setTags({
            [key]: value
        });
    }
    /**
   * Sets attributes onto the scope.
   *
   * These attributes are currently applied to logs and metrics.
   * In the future, they will also be applied to spans.
   *
   * Important: For now, only strings, numbers and boolean attributes are supported, despite types allowing for
   * more complex attribute types. We'll add this support in the future but already specify the wider type to
   * avoid a breaking change in the future.
   *
   * @param newAttributes - The attributes to set on the scope. You can either pass in key-value pairs, or
   * an object with a `value` and an optional `unit` (if applicable to your attribute).
   *
   * @example
   * ```typescript
   * scope.setAttributes({
   *   is_admin: true,
   *   payment_selection: 'credit_card',
   *   render_duration: { value: 'render_duration', unit: 'ms' },
   * });
   * ```
   */ setAttributes(newAttributes) {
        this._attributes = {
            ...this._attributes,
            ...newAttributes
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets an attribute onto the scope.
   *
   * These attributes are currently applied to logs and metrics.
   * In the future, they will also be applied to spans.
   *
   * Important: For now, only strings, numbers and boolean attributes are supported, despite types allowing for
   * more complex attribute types. We'll add this support in the future but already specify the wider type to
   * avoid a breaking change in the future.
   *
   * @param key - The attribute key.
   * @param value - the attribute value. You can either pass in a raw value, or an attribute
   * object with a `value` and an optional `unit` (if applicable to your attribute).
   *
   * @example
   * ```typescript
   * scope.setAttribute('is_admin', true);
   * scope.setAttribute('render_duration', { value: 'render_duration', unit: 'ms' });
   * ```
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setAttribute(key, value) {
        return this.setAttributes({
            [key]: value
        });
    }
    /**
   * Removes the attribute with the given key from the scope.
   *
   * @param key - The attribute key.
   *
   * @example
   * ```typescript
   * scope.removeAttribute('is_admin');
   * ```
   */ removeAttribute(key) {
        if (key in this._attributes) {
            delete this._attributes[key];
            this._notifyScopeListeners();
        }
        return this;
    }
    /**
   * Set an object that will be merged into existing extra on the scope,
   * and will be sent as extra data with the event.
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single key:value extra entry that will be sent as extra data with the event.
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the fingerprint on the scope to send with the events.
   * @param {string[]} fingerprint Fingerprint to group events in Sentry.
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the level on the scope for future events.
   */ setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets context data with the given name.
   * Data passed as context will be normalized. You can also pass `null` to unset the context.
   * Note that context data will not be merged - calling `setContext` will overwrite an existing context with the same key.
   */ setContext(key, context) {
        if (context === null) delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set the session for the scope.
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the session from the scope.
   */ getSession() {
        return this._session;
    }
    /**
   * Updates the scope with provided data. Can work in three variations:
   * - plain object containing updatable attributes
   * - Scope instance that'll extract the attributes from
   * - callback function that'll receive the current scope as an argument and allow for modifications
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === "function" ? captureContext(this) : captureContext;
        const scopeInstance = scopeToMerge instanceof $98f45afb44e85f0e$var$Scope ? scopeToMerge.getScopeData() : $fBPG6.isPlainObject(scopeToMerge) ? captureContext : void 0;
        const { tags: tags, attributes: attributes, extra: extra, user: user, contexts: contexts, level: level, fingerprint: fingerprint = [], propagationContext: propagationContext, conversationId: conversationId } = scopeInstance || {};
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._attributes = {
            ...this._attributes,
            ...attributes
        };
        this._extra = {
            ...this._extra,
            ...extra
        };
        this._contexts = {
            ...this._contexts,
            ...contexts
        };
        if (user && Object.keys(user).length) this._user = user;
        if (level) this._level = level;
        if (fingerprint.length) this._fingerprint = fingerprint;
        if (propagationContext) this._propagationContext = propagationContext;
        if (conversationId) this._conversationId = conversationId;
        return this;
    }
    /**
   * Clears the current scope and resets its properties.
   * Note: The client will not be cleared.
   */ clear() {
        this._breadcrumbs = [];
        this._tags = {};
        this._attributes = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = void 0;
        this._transactionName = void 0;
        this._fingerprint = void 0;
        this._session = void 0;
        this._conversationId = void 0;
        $k7IIJ._setSpanForScope(this, void 0);
        this._attachments = [];
        this.setPropagationContext({
            traceId: $bSNF3.generateTraceId(),
            sampleRand: $9xAUk.safeMathRandom()
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Adds a breadcrumb to the scope.
   * By default, the last 100 breadcrumbs are kept.
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : $98f45afb44e85f0e$var$DEFAULT_MAX_BREADCRUMBS;
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: $7q4WK.dateTimestampInSeconds(),
            ...breadcrumb,
            // Breadcrumb messages can theoretically be infinitely large and they're held in memory so we truncate them not to leak (too much) memory
            message: breadcrumb.message ? $23Myp.truncate(breadcrumb.message, 2048) : breadcrumb.message
        };
        this._breadcrumbs.push(mergedBreadcrumb);
        if (this._breadcrumbs.length > maxCrumbs) {
            this._breadcrumbs = this._breadcrumbs.slice(-maxCrumbs);
            this._client?.recordDroppedEvent("buffer_overflow", "log_item");
        }
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the last breadcrumb of the scope.
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * Clear all breadcrumbs from the scope.
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Add an attachment to the scope.
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * Clear all attachments from the scope.
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /**
   * Get the data of this scope, which should be applied to an event during processing.
   */ getScopeData() {
        return {
            breadcrumbs: this._breadcrumbs,
            attachments: this._attachments,
            contexts: this._contexts,
            tags: this._tags,
            attributes: this._attributes,
            extra: this._extra,
            user: this._user,
            level: this._level,
            fingerprint: this._fingerprint || [],
            eventProcessors: this._eventProcessors,
            propagationContext: this._propagationContext,
            sdkProcessingMetadata: this._sdkProcessingMetadata,
            transactionName: this._transactionName,
            span: $k7IIJ._getSpanForScope(this),
            conversationId: this._conversationId
        };
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry.
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = $j4dmO.merge(this._sdkProcessingMetadata, newData, 2);
        return this;
    }
    /**
   * Add propagation context to the scope, used for distributed tracing
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * Get propagation context from the scope, used for distributed tracing
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @returns {string} The id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint?.event_id || $k6pIc.uuid4();
        if (!this._client) {
            $jCjMv.DEBUG_BUILD && $jix5p.debug.warn("No client configured on scope - will not capture exception!");
            return eventId;
        }
        const syntheticException = new Error("Sentry syntheticException");
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @returns {string} The id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint?.event_id || $k6pIc.uuid4();
        if (!this._client) {
            $jCjMv.DEBUG_BUILD && $jix5p.debug.warn("No client configured on scope - will not capture message!");
            return eventId;
        }
        const syntheticException = hint?.syntheticException ?? new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a Sentry event for this scope.
   *
   * @returns {string} The id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = event.event_id || hint?.event_id || $k6pIc.uuid4();
        if (!this._client) {
            $jCjMv.DEBUG_BUILD && $jix5p.debug.warn("No client configured on scope - will not capture event!");
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}
module.exports.Scope = $98f45afb44e85f0e$var$Scope;

});
parcelRegister("jIJ38", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $k6pIc = parcelRequire("k6pIc");

var $7q4WK = parcelRequire("7q4WK");
function $e5b51248488d9ac2$var$makeSession(context) {
    const startingTime = $7q4WK.timestampInSeconds();
    const session = {
        sid: $k6pIc.uuid4(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$e5b51248488d9ac2$var$sessionToJSON(session)
    };
    if (context) $e5b51248488d9ac2$var$updateSession(session, context);
    return session;
}
function $e5b51248488d9ac2$var$updateSession(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || $7q4WK.timestampInSeconds();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) session.sid = context.sid.length === 32 ? context.sid : $k6pIc.uuid4();
    if (context.init !== void 0) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === "number") session.started = context.started;
    if (session.ignoreDuration) session.duration = void 0;
    else if (typeof context.duration === "number") session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === "number") session.errors = context.errors;
    if (context.status) session.status = context.status;
}
function $e5b51248488d9ac2$var$closeSession(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === "ok") context = {
        status: "exited"
    };
    $e5b51248488d9ac2$var$updateSession(session, context);
}
function $e5b51248488d9ac2$var$sessionToJSON(session) {
    return {
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1e3).toISOString(),
        timestamp: new Date(session.timestamp * 1e3).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : void 0,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    };
}
module.exports.closeSession = $e5b51248488d9ac2$var$closeSession;
module.exports.makeSession = $e5b51248488d9ac2$var$makeSession;
module.exports.updateSession = $e5b51248488d9ac2$var$updateSession;

});
parcelRegister("k6pIc", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $2SQtm = parcelRequire("2SQtm");

var $9xAUk = parcelRequire("9xAUk");

var $23Myp = parcelRequire("23Myp");

var $hsCGK = parcelRequire("hsCGK");
function $ea28500b04b147de$var$getCrypto() {
    const gbl = $hsCGK.GLOBAL_OBJ;
    return gbl.crypto || gbl.msCrypto;
}
let $ea28500b04b147de$var$emptyUuid;
function $ea28500b04b147de$var$getRandomByte() {
    return $9xAUk.safeMathRandom() * 16;
}
function $ea28500b04b147de$var$uuid4(crypto = $ea28500b04b147de$var$getCrypto()) {
    try {
        if (crypto?.randomUUID) return $9xAUk.withRandomSafeContext(()=>crypto.randomUUID()).replace(/-/g, "");
    } catch  {}
    if (!$ea28500b04b147de$var$emptyUuid) $ea28500b04b147de$var$emptyUuid = "10000000100040008000100000000000";
    return $ea28500b04b147de$var$emptyUuid.replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ ($ea28500b04b147de$var$getRandomByte() & 15) >> c / 4).toString(16));
}
function $ea28500b04b147de$var$getFirstException(event) {
    return event.exception?.values?.[0];
}
function $ea28500b04b147de$var$getEventDescription(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $ea28500b04b147de$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
function $ea28500b04b147de$var$addExceptionTypeValue(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
function $ea28500b04b147de$var$addExceptionMechanism(event, newMechanism) {
    const firstException = $ea28500b04b147de$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: "generic",
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && "data" in newMechanism) {
        const mergedData = {
            ...currentMechanism?.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
const $ea28500b04b147de$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
function $ea28500b04b147de$var$_parseInt(input) {
    return parseInt(input || "", 10);
}
function $ea28500b04b147de$var$parseSemver(input) {
    const match = input.match($ea28500b04b147de$var$SEMVER_REGEXP) || [];
    const major = $ea28500b04b147de$var$_parseInt(match[1]);
    const minor = $ea28500b04b147de$var$_parseInt(match[2]);
    const patch = $ea28500b04b147de$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? void 0 : major,
        minor: isNaN(minor) ? void 0 : minor,
        patch: isNaN(patch) ? void 0 : patch,
        prerelease: match[4]
    };
}
function $ea28500b04b147de$var$addContextToFrame(lines, frame, linesOfContext = 5) {
    if (frame.lineno === void 0) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>$23Myp.snipLine(line, 0));
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    frame.context_line = $23Myp.snipLine(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>$23Myp.snipLine(line, 0));
}
function $ea28500b04b147de$var$checkOrSetAlreadyCaught(exception) {
    if ($ea28500b04b147de$var$isAlreadyCaptured(exception)) return true;
    try {
        $2SQtm.addNonEnumerableProperty(exception, "__sentry_captured__", true);
    } catch  {}
    return false;
}
function $ea28500b04b147de$var$isAlreadyCaptured(exception) {
    try {
        return exception.__sentry_captured__;
    } catch  {}
}
module.exports.addContextToFrame = $ea28500b04b147de$var$addContextToFrame;
module.exports.addExceptionMechanism = $ea28500b04b147de$var$addExceptionMechanism;
module.exports.addExceptionTypeValue = $ea28500b04b147de$var$addExceptionTypeValue;
module.exports.checkOrSetAlreadyCaught = $ea28500b04b147de$var$checkOrSetAlreadyCaught;
module.exports.getEventDescription = $ea28500b04b147de$var$getEventDescription;
module.exports.isAlreadyCaptured = $ea28500b04b147de$var$isAlreadyCaptured;
module.exports.parseSemver = $ea28500b04b147de$var$parseSemver;
module.exports.uuid4 = $ea28500b04b147de$var$uuid4;

});
parcelRegister("2SQtm", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $jCjMv = parcelRequire("jCjMv");

var $jix5p = parcelRequire("jix5p");

var $fBPG6 = parcelRequire("fBPG6");
function $219953e4dbe57cf5$var$fill(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    if (typeof original !== "function") return;
    const wrapped = replacementFactory(original);
    if (typeof wrapped === "function") $219953e4dbe57cf5$var$markFunctionWrapped(wrapped, original);
    try {
        source[name] = wrapped;
    } catch  {
        $jCjMv.DEBUG_BUILD && $jix5p.debug.log(`Failed to replace method "${name}" in object`, source);
    }
}
function $219953e4dbe57cf5$var$addNonEnumerableProperty(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            value: // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value,
            writable: true,
            configurable: true
        });
    } catch  {
        $jCjMv.DEBUG_BUILD && $jix5p.debug.log(`Failed to add non-enumerable property "${String(name)}" to object`, obj);
    }
}
function $219953e4dbe57cf5$var$markFunctionWrapped(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $219953e4dbe57cf5$var$addNonEnumerableProperty(wrapped, "__sentry_original__", original);
    } catch  {}
}
function $219953e4dbe57cf5$var$wrapMethod(obj, field, wrapped, enumerable = true) {
    const original = obj[field];
    if (typeof original !== "function") throw new Error(`Cannot wrap method: ${field} is not a function`);
    if ($219953e4dbe57cf5$var$getOriginalFunction(original)) throw new Error(`Attempting to wrap method ${field} multiple times`);
    $219953e4dbe57cf5$var$markFunctionWrapped(wrapped, original);
    Object.defineProperty(obj, field, {
        writable: true,
        configurable: true,
        enumerable: enumerable,
        value: wrapped
    });
}
function $219953e4dbe57cf5$var$getOriginalFunction(func) {
    return func.__sentry_original__;
}
function $219953e4dbe57cf5$var$convertToPlainObject(value) {
    if ($fBPG6.isError(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$219953e4dbe57cf5$var$getOwnProperties(value)
    };
    if ($fBPG6.isEvent(value)) {
        const { type: type, target: target, currentTarget: currentTarget, detail: detail } = value;
        return {
            type: type,
            target: target,
            currentTarget: currentTarget,
            ...detail ? {
                detail: detail
            } : {},
            ...$219953e4dbe57cf5$var$getOwnProperties(value)
        };
    }
    return value;
}
function $219953e4dbe57cf5$var$getOwnProperties(obj) {
    if (typeof obj === "object" && obj !== null) return Object.fromEntries(Object.entries(obj));
    return {};
}
function $219953e4dbe57cf5$var$extractExceptionKeysForMessage(exception) {
    const keys = Object.keys($219953e4dbe57cf5$var$convertToPlainObject(exception));
    keys.sort();
    return !keys[0] ? "[object has no keys]" : keys.join(", ");
}
function $219953e4dbe57cf5$var$dropUndefinedKeys(inputValue) {
    const memoizationMap = /* @__PURE__ */ new Map();
    return $219953e4dbe57cf5$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $219953e4dbe57cf5$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if (inputValue === null || typeof inputValue !== "object") return inputValue;
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== void 0) return memoVal;
    if (Array.isArray(inputValue)) {
        const returnValue = [];
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((value)=>{
            returnValue.push($219953e4dbe57cf5$var$_dropUndefinedKeys(value, memoizationMap));
        });
        return returnValue;
    }
    if ($219953e4dbe57cf5$var$isPojo(inputValue)) {
        const returnValue = {};
        memoizationMap.set(inputValue, returnValue);
        const keys = Object.keys(inputValue);
        keys.forEach((key)=>{
            const val = inputValue[key];
            if (val !== void 0) returnValue[key] = $219953e4dbe57cf5$var$_dropUndefinedKeys(val, memoizationMap);
        });
        return returnValue;
    }
    return inputValue;
}
function $219953e4dbe57cf5$var$isPojo(input) {
    const constructor = input.constructor;
    return constructor === Object || constructor === void 0;
}
function $219953e4dbe57cf5$var$objectify(wat) {
    let objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == void 0:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case $fBPG6.isPrimitive(wat):
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}
module.exports.addNonEnumerableProperty = $219953e4dbe57cf5$var$addNonEnumerableProperty;
module.exports.convertToPlainObject = $219953e4dbe57cf5$var$convertToPlainObject;
module.exports.dropUndefinedKeys = $219953e4dbe57cf5$var$dropUndefinedKeys;
module.exports.extractExceptionKeysForMessage = $219953e4dbe57cf5$var$extractExceptionKeysForMessage;
module.exports.fill = $219953e4dbe57cf5$var$fill;
module.exports.getOriginalFunction = $219953e4dbe57cf5$var$getOriginalFunction;
module.exports.markFunctionWrapped = $219953e4dbe57cf5$var$markFunctionWrapped;
module.exports.objectify = $219953e4dbe57cf5$var$objectify;
module.exports.wrapMethod = $219953e4dbe57cf5$var$wrapMethod;

});
parcelRegister("fBPG6", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $02eebf943c95bae6$var$objectToString = Object.prototype.toString;
function $02eebf943c95bae6$var$isError(wat) {
    switch($02eebf943c95bae6$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
        case "[object WebAssembly.Exception]":
            return true;
        default:
            return $02eebf943c95bae6$var$isInstanceOf(wat, Error);
    }
}
function $02eebf943c95bae6$var$isBuiltin(wat, className) {
    return $02eebf943c95bae6$var$objectToString.call(wat) === `[object ${className}]`;
}
function $02eebf943c95bae6$var$isErrorEvent(wat) {
    return $02eebf943c95bae6$var$isBuiltin(wat, "ErrorEvent");
}
function $02eebf943c95bae6$var$isDOMError(wat) {
    return $02eebf943c95bae6$var$isBuiltin(wat, "DOMError");
}
function $02eebf943c95bae6$var$isDOMException(wat) {
    return $02eebf943c95bae6$var$isBuiltin(wat, "DOMException");
}
function $02eebf943c95bae6$var$isString(wat) {
    return $02eebf943c95bae6$var$isBuiltin(wat, "String");
}
function $02eebf943c95bae6$var$isParameterizedString(wat) {
    return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
function $02eebf943c95bae6$var$isPrimitive(wat) {
    return wat === null || $02eebf943c95bae6$var$isParameterizedString(wat) || typeof wat !== "object" && typeof wat !== "function";
}
function $02eebf943c95bae6$var$isPlainObject(wat) {
    return $02eebf943c95bae6$var$isBuiltin(wat, "Object");
}
function $02eebf943c95bae6$var$isEvent(wat) {
    return typeof Event !== "undefined" && $02eebf943c95bae6$var$isInstanceOf(wat, Event);
}
function $02eebf943c95bae6$var$isElement(wat) {
    return typeof Element !== "undefined" && $02eebf943c95bae6$var$isInstanceOf(wat, Element);
}
function $02eebf943c95bae6$var$isRegExp(wat) {
    return $02eebf943c95bae6$var$isBuiltin(wat, "RegExp");
}
function $02eebf943c95bae6$var$isThenable(wat) {
    return Boolean(wat?.then && typeof wat.then === "function");
}
function $02eebf943c95bae6$var$isSyntheticEvent(wat) {
    return $02eebf943c95bae6$var$isPlainObject(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
function $02eebf943c95bae6$var$isInstanceOf(wat, base) {
    try {
        return wat instanceof base;
    } catch  {
        return false;
    }
}
function $02eebf943c95bae6$var$isVueViewModel(wat) {
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue || wat.__v_isVNode));
}
function $02eebf943c95bae6$var$isRequest(request) {
    return typeof Request !== "undefined" && $02eebf943c95bae6$var$isInstanceOf(request, Request);
}
module.exports.isDOMError = $02eebf943c95bae6$var$isDOMError;
module.exports.isDOMException = $02eebf943c95bae6$var$isDOMException;
module.exports.isElement = $02eebf943c95bae6$var$isElement;
module.exports.isError = $02eebf943c95bae6$var$isError;
module.exports.isErrorEvent = $02eebf943c95bae6$var$isErrorEvent;
module.exports.isEvent = $02eebf943c95bae6$var$isEvent;
module.exports.isInstanceOf = $02eebf943c95bae6$var$isInstanceOf;
module.exports.isParameterizedString = $02eebf943c95bae6$var$isParameterizedString;
module.exports.isPlainObject = $02eebf943c95bae6$var$isPlainObject;
module.exports.isPrimitive = $02eebf943c95bae6$var$isPrimitive;
module.exports.isRegExp = $02eebf943c95bae6$var$isRegExp;
module.exports.isRequest = $02eebf943c95bae6$var$isRequest;
module.exports.isString = $02eebf943c95bae6$var$isString;
module.exports.isSyntheticEvent = $02eebf943c95bae6$var$isSyntheticEvent;
module.exports.isThenable = $02eebf943c95bae6$var$isThenable;
module.exports.isVueViewModel = $02eebf943c95bae6$var$isVueViewModel;

});


parcelRegister("9xAUk", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hsCGK = parcelRequire("hsCGK");
let $6f23d329fadd6150$var$RESOLVED_RUNNER;
function $6f23d329fadd6150$var$withRandomSafeContext(cb) {
    if ($6f23d329fadd6150$var$RESOLVED_RUNNER !== void 0) return $6f23d329fadd6150$var$RESOLVED_RUNNER ? $6f23d329fadd6150$var$RESOLVED_RUNNER(cb) : cb();
    const sym = /* @__PURE__ */ Symbol.for("__SENTRY_SAFE_RANDOM_ID_WRAPPER__");
    const globalWithSymbol = $hsCGK.GLOBAL_OBJ;
    if (sym in globalWithSymbol && typeof globalWithSymbol[sym] === "function") {
        $6f23d329fadd6150$var$RESOLVED_RUNNER = globalWithSymbol[sym];
        return $6f23d329fadd6150$var$RESOLVED_RUNNER(cb);
    }
    $6f23d329fadd6150$var$RESOLVED_RUNNER = null;
    return cb();
}
function $6f23d329fadd6150$var$safeMathRandom() {
    return $6f23d329fadd6150$var$withRandomSafeContext(()=>Math.random());
}
function $6f23d329fadd6150$var$safeDateNow() {
    return $6f23d329fadd6150$var$withRandomSafeContext(()=>Date.now());
}
module.exports.safeDateNow = $6f23d329fadd6150$var$safeDateNow;
module.exports.safeMathRandom = $6f23d329fadd6150$var$safeMathRandom;
module.exports.withRandomSafeContext = $6f23d329fadd6150$var$withRandomSafeContext;

});

parcelRegister("23Myp", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $fBPG6 = parcelRequire("fBPG6");

var $bg87c = parcelRequire("bg87c");
function $18018660bab539c0$var$truncate(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
function $18018660bab539c0$var$snipLine(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
function $18018660bab539c0$var$safeJoin(input, delimiter) {
    if (!Array.isArray(input)) return "";
    const output = [];
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        if ($fBPG6.isPrimitive(value)) output.push(String(value));
        else if (value instanceof Error) output.push(value.message ? `${value.name}: ${value.message}` : value.name);
        else output.push($bg87c.stringifyValue(void 0, value));
    }
    return output.join(delimiter);
}
function $18018660bab539c0$var$isMatchingPattern(value, pattern, requireExactStringMatch = false) {
    if (!$fBPG6.isString(value)) return false;
    if ($fBPG6.isRegExp(pattern)) return pattern.test(value);
    if ($fBPG6.isString(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    if (typeof pattern === "function") return pattern(value);
    return false;
}
function $18018660bab539c0$var$stringMatchesSomePattern(testString, patterns = [], requireExactStringMatch = false) {
    for (const pattern of patterns){
        if ($18018660bab539c0$var$isMatchingPattern(testString, pattern, requireExactStringMatch)) return true;
    }
    return false;
}
module.exports.isMatchingPattern = $18018660bab539c0$var$isMatchingPattern;
module.exports.safeJoin = $18018660bab539c0$var$safeJoin;
module.exports.snipLine = $18018660bab539c0$var$snipLine;
module.exports.stringMatchesSomePattern = $18018660bab539c0$var$stringMatchesSomePattern;
module.exports.truncate = $18018660bab539c0$var$truncate;

});
parcelRegister("bg87c", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $fhFRD = parcelRequire("fhFRD");

var $2SQtm = parcelRequire("2SQtm");

var $8S2lx = parcelRequire("8S2lx");
let $83277bd17cfda475$var$stringifier;
function $83277bd17cfda475$var$setNormalizeStringifier(newStringifier) {
    $83277bd17cfda475$var$stringifier = newStringifier;
}
function $83277bd17cfda475$var$normalize(input, depth = 100, maxProperties = Infinity) {
    try {
        return $83277bd17cfda475$var$visit("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
function $83277bd17cfda475$var$normalizeToSize(object, depth = 3, maxSize = 102400) {
    const normalized = $83277bd17cfda475$var$normalize(object, depth);
    if ($83277bd17cfda475$var$jsonSize(normalized) > maxSize) return $83277bd17cfda475$var$normalizeToSize(object, depth - 1, maxSize);
    return normalized;
}
function $83277bd17cfda475$var$visit(key, value, depth = Infinity, maxProperties = Infinity, memo = $83277bd17cfda475$var$memoBuilder()) {
    const [memoize, unmemoize] = memo;
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "boolean",
        "string"
    ].includes(typeof value) || typeof value === "number" && Number.isFinite(value)) return value;
    const stringified = $83277bd17cfda475$var$stringifyValue(key, value);
    if (!stringified.startsWith("[object ")) return stringified;
    if ($fhFRD.hasSkipNormalizationHint(value)) return value;
    const overrideDepth = $fhFRD.getNormalizationDepthOverrideHint(value);
    const remainingDepth = overrideDepth !== void 0 ? overrideDepth : depth;
    if (remainingDepth === 0) return stringified.replace("object ", "");
    if (memoize(value)) return "[Circular ~]";
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        const jsonValue = valueWithToJSON.toJSON();
        return $83277bd17cfda475$var$visit("", jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch  {}
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    const visitable = $2SQtm.convertToPlainObject(value);
    for(const visitKey in visitable){
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $83277bd17cfda475$var$visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    unmemoize(value);
    return normalized;
}
function $83277bd17cfda475$var$stringifyValue(key, value) {
    try {
        if ($83277bd17cfda475$var$stringifier) {
            const stringified = $83277bd17cfda475$var$stringifier(value);
            if (stringified) return stringified;
        }
        if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
        if (typeof value === "number" && !Number.isFinite(value)) return `[${value}]`;
        if (typeof value === "function") return `[Function: ${$8S2lx.getFunctionName(value)}]`;
        if (typeof value === "symbol") return `[${String(value)}]`;
        if (typeof value === "bigint") return `[BigInt: ${String(value)}]`;
        const objName = $83277bd17cfda475$var$getConstructorName(value);
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
function $83277bd17cfda475$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype?.constructor ? prototype.constructor.name : "null prototype";
}
function $83277bd17cfda475$var$utf8Length(value) {
    return ~-encodeURI(value).split(/%..|./).length;
}
function $83277bd17cfda475$var$jsonSize(value) {
    return $83277bd17cfda475$var$utf8Length(JSON.stringify(value));
}
function $83277bd17cfda475$var$normalizeUrlToBase(url, basePath) {
    const escapedBase = basePath.replace(/\\/g, "/").replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch  {}
    return newUrl.replace(/\\/g, "/").replace(/webpack:\/?/g, "").replace(new RegExp(`(file://)?/*${escapedBase}/*`, "ig"), "app:///");
}
function $83277bd17cfda475$var$memoBuilder() {
    const inner = /* @__PURE__ */ new WeakSet();
    function memoize(obj) {
        if (inner.has(obj)) return true;
        inner.add(obj);
        return false;
    }
    function unmemoize(obj) {
        inner.delete(obj);
    }
    return [
        memoize,
        unmemoize
    ];
}
module.exports.normalize = $83277bd17cfda475$var$normalize;
module.exports.normalizeToSize = $83277bd17cfda475$var$normalizeToSize;
module.exports.normalizeUrlToBase = $83277bd17cfda475$var$normalizeUrlToBase;
module.exports.setNormalizeStringifier = $83277bd17cfda475$var$setNormalizeStringifier;
module.exports.stringifyValue = $83277bd17cfda475$var$stringifyValue;

});
parcelRegister("fhFRD", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $2SQtm = parcelRequire("2SQtm");
const $b208eadd2b4fea73$var$SENTRY_SKIP_NORMALIZATION = /* @__PURE__ */ Symbol.for("sentry.skipNormalization");
const $b208eadd2b4fea73$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH = /* @__PURE__ */ Symbol.for("sentry.overrideNormalizationDepth");
function $b208eadd2b4fea73$var$setSkipNormalizationHint(obj) {
    $2SQtm.addNonEnumerableProperty(obj, $b208eadd2b4fea73$var$SENTRY_SKIP_NORMALIZATION, true);
}
function $b208eadd2b4fea73$var$setNormalizationDepthOverrideHint(obj, depth) {
    $2SQtm.addNonEnumerableProperty(obj, $b208eadd2b4fea73$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH, depth);
}
function $b208eadd2b4fea73$var$hasSkipNormalizationHint(value) {
    return Boolean(value[$b208eadd2b4fea73$var$SENTRY_SKIP_NORMALIZATION]);
}
function $b208eadd2b4fea73$var$getNormalizationDepthOverrideHint(value) {
    const v = value[$b208eadd2b4fea73$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH];
    return typeof v === "number" ? v : void 0;
}
module.exports.getNormalizationDepthOverrideHint = $b208eadd2b4fea73$var$getNormalizationDepthOverrideHint;
module.exports.hasSkipNormalizationHint = $b208eadd2b4fea73$var$hasSkipNormalizationHint;
module.exports.setNormalizationDepthOverrideHint = $b208eadd2b4fea73$var$setNormalizationDepthOverrideHint;
module.exports.setSkipNormalizationHint = $b208eadd2b4fea73$var$setSkipNormalizationHint;

});




parcelRegister("7q4WK", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9xAUk = parcelRequire("9xAUk");

var $hsCGK = parcelRequire("hsCGK");
const $566ecc63bc254a77$var$ONE_SECOND_IN_MS = 1e3;
function $566ecc63bc254a77$var$dateTimestampInSeconds() {
    return $9xAUk.safeDateNow() / $566ecc63bc254a77$var$ONE_SECOND_IN_MS;
}
function $566ecc63bc254a77$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = $hsCGK.GLOBAL_OBJ;
    if (!performance?.now || !performance.timeOrigin) return $566ecc63bc254a77$var$dateTimestampInSeconds;
    const timeOrigin = performance.timeOrigin;
    return ()=>{
        return (timeOrigin + $9xAUk.withRandomSafeContext(()=>performance.now())) / $566ecc63bc254a77$var$ONE_SECOND_IN_MS;
    };
}
let $566ecc63bc254a77$var$_cachedTimestampInSeconds;
function $566ecc63bc254a77$var$timestampInSeconds() {
    const func = $566ecc63bc254a77$var$_cachedTimestampInSeconds ?? ($566ecc63bc254a77$var$_cachedTimestampInSeconds = $566ecc63bc254a77$var$createUnixTimestampInSecondsFunc());
    return func();
}
let $566ecc63bc254a77$var$cachedTimeOrigin = null;
function $566ecc63bc254a77$var$getBrowserTimeOrigin() {
    const { performance: performance } = $hsCGK.GLOBAL_OBJ;
    if (!performance?.now) return void 0;
    const threshold = 3e5;
    const performanceNow = $9xAUk.withRandomSafeContext(()=>performance.now());
    const dateNow = $9xAUk.safeDateNow();
    const timeOrigin = performance.timeOrigin;
    if (typeof timeOrigin === "number") {
        const timeOriginDelta = Math.abs(timeOrigin + performanceNow - dateNow);
        if (timeOriginDelta < threshold) return timeOrigin;
    }
    const navigationStart = performance.timing?.navigationStart;
    if (typeof navigationStart === "number") {
        const navigationStartDelta = Math.abs(navigationStart + performanceNow - dateNow);
        if (navigationStartDelta < threshold) return navigationStart;
    }
    return dateNow - performanceNow;
}
function $566ecc63bc254a77$var$browserPerformanceTimeOrigin() {
    if ($566ecc63bc254a77$var$cachedTimeOrigin === null) $566ecc63bc254a77$var$cachedTimeOrigin = $566ecc63bc254a77$var$getBrowserTimeOrigin();
    return $566ecc63bc254a77$var$cachedTimeOrigin;
}
module.exports.browserPerformanceTimeOrigin = $566ecc63bc254a77$var$browserPerformanceTimeOrigin;
module.exports.dateTimestampInSeconds = $566ecc63bc254a77$var$dateTimestampInSeconds;
module.exports.timestampInSeconds = $566ecc63bc254a77$var$timestampInSeconds;

});


parcelRegister("j4dmO", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $de18c270aa252585$var$merge(initialObj, mergeObj, levels = 2) {
    if (!mergeObj || typeof mergeObj !== "object" || levels <= 0) return mergeObj;
    if (initialObj && Object.keys(mergeObj).length === 0) return initialObj;
    const output = {
        ...initialObj
    };
    for(const key in mergeObj)if (Object.prototype.hasOwnProperty.call(mergeObj, key)) output[key] = $de18c270aa252585$var$merge(output[key], mergeObj[key], levels - 1);
    return output;
}
module.exports.merge = $de18c270aa252585$var$merge;

});

parcelRegister("bSNF3", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $k6pIc = parcelRequire("k6pIc");
function $8a6b4287eef01279$var$generateTraceId() {
    return $k6pIc.uuid4();
}
function $8a6b4287eef01279$var$generateSpanId() {
    return $k6pIc.uuid4().substring(16);
}
module.exports.generateSpanId = $8a6b4287eef01279$var$generateSpanId;
module.exports.generateTraceId = $8a6b4287eef01279$var$generateTraceId;

});

parcelRegister("k7IIJ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $2SQtm = parcelRequire("2SQtm");
const $ea67269fc07256d6$var$SCOPE_SPAN_FIELD = "_sentrySpan";
function $ea67269fc07256d6$var$_setSpanForScope(scope, span) {
    if (span) $2SQtm.addNonEnumerableProperty(scope, $ea67269fc07256d6$var$SCOPE_SPAN_FIELD, span);
    else delete scope[$ea67269fc07256d6$var$SCOPE_SPAN_FIELD];
}
function $ea67269fc07256d6$var$_getSpanForScope(scope) {
    return scope[$ea67269fc07256d6$var$SCOPE_SPAN_FIELD];
}
module.exports._getSpanForScope = $ea67269fc07256d6$var$_getSpanForScope;
module.exports._setSpanForScope = $ea67269fc07256d6$var$_setSpanForScope;

});



parcelRegister("grxWE", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $bf897fb56170853c$var$isActualPromise = (p)=>p instanceof Promise && !p[$bf897fb56170853c$var$kChainedCopy];
const $bf897fb56170853c$var$kChainedCopy = /* @__PURE__ */ Symbol("chained PromiseLike");
const $bf897fb56170853c$var$chainAndCopyPromiseLike = (original, onSuccess, onError)=>{
    const chained = original.then((value)=>{
        onSuccess(value);
        return value;
    }, (err)=>{
        onError(err);
        throw err;
    });
    return $bf897fb56170853c$var$isActualPromise(chained) && $bf897fb56170853c$var$isActualPromise(original) ? chained : $bf897fb56170853c$var$copyProps(original, chained);
};
const $bf897fb56170853c$var$copyProps = (original, chained)=>{
    if (!chained) return original;
    let mutated = false;
    for(const key in original){
        if (key in chained) continue;
        mutated = true;
        const value = original[key];
        if (typeof value === "function") Object.defineProperty(chained, key, {
            value: (...args)=>value.apply(original, args),
            enumerable: true,
            configurable: true,
            writable: true
        });
        else chained[key] = value;
    }
    if (mutated) Object.assign(chained, {
        [$bf897fb56170853c$var$kChainedCopy]: true
    });
    return chained;
};
module.exports.chainAndCopyPromiseLike = $bf897fb56170853c$var$chainAndCopyPromiseLike;

});



parcelRegister("f8fWp", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $fBPG6 = parcelRequire("fBPG6");
function $b043f7edbd893b64$var$isAttributeObject(maybeObj) {
    return typeof maybeObj === "object" && maybeObj != null && !Array.isArray(maybeObj) && Object.keys(maybeObj).includes("value");
}
function $b043f7edbd893b64$var$attributeValueToTypedAttributeValue(rawValue, useFallback) {
    const { value: value, unit: unit } = $b043f7edbd893b64$var$isAttributeObject(rawValue) ? rawValue : {
        value: rawValue,
        unit: void 0
    };
    const attributeValue = $b043f7edbd893b64$var$getTypedAttributeValue(value);
    const checkedUnit = unit && typeof unit === "string" ? {
        unit: unit
    } : {};
    if (attributeValue) return {
        ...attributeValue,
        ...checkedUnit
    };
    if (!useFallback || useFallback === "skip-undefined" && value === void 0) return;
    let stringValue = "";
    try {
        stringValue = JSON.stringify(value) ?? "";
    } catch  {}
    return {
        value: stringValue,
        type: "string",
        ...checkedUnit
    };
}
function $b043f7edbd893b64$var$serializeAttributes(attributes, fallback = false) {
    const serializedAttributes = {};
    for (const [key, value] of Object.entries(attributes ?? {})){
        const typedValue = $b043f7edbd893b64$var$attributeValueToTypedAttributeValue(value, fallback);
        if (typedValue) serializedAttributes[key] = typedValue;
    }
    return serializedAttributes;
}
function $b043f7edbd893b64$var$estimateTypedAttributesSizeInBytes(attributes) {
    if (!attributes) return 0;
    let weight = 0;
    for (const [key, attr] of Object.entries(attributes)){
        weight += key.length * 2;
        weight += attr.type.length * 2;
        weight += (attr.unit?.length ?? 0) * 2;
        const val = attr.value;
        if (Array.isArray(val)) weight += $b043f7edbd893b64$var$estimatePrimitiveSizeInBytes(val[0]) * val.length;
        else if ($fBPG6.isPrimitive(val)) weight += $b043f7edbd893b64$var$estimatePrimitiveSizeInBytes(val);
        else weight += 100;
    }
    return weight;
}
function $b043f7edbd893b64$var$estimatePrimitiveSizeInBytes(value) {
    if (typeof value === "string") return value.length * 2;
    else if (typeof value === "boolean") return 4;
    else if (typeof value === "number") return 8;
    return 0;
}
function $b043f7edbd893b64$var$getTypedAttributeValue(value) {
    if (Array.isArray(value)) return {
        value: value,
        type: "array"
    };
    const primitiveType = typeof value === "string" ? "string" : typeof value === "boolean" ? "boolean" : typeof value === "number" && !Number.isNaN(value) ? Number.isInteger(value) ? "integer" : "double" : null;
    if (primitiveType) return {
        value: value,
        type: primitiveType
    };
}
module.exports.attributeValueToTypedAttributeValue = $b043f7edbd893b64$var$attributeValueToTypedAttributeValue;
module.exports.estimateTypedAttributesSizeInBytes = $b043f7edbd893b64$var$estimateTypedAttributesSizeInBytes;
module.exports.isAttributeObject = $b043f7edbd893b64$var$isAttributeObject;
module.exports.serializeAttributes = $b043f7edbd893b64$var$serializeAttributes;

});

parcelRegister("gjJ9A", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $Up7k9 = parcelRequire("Up7k9");

var $hbMFZ = parcelRequire("hbMFZ");

var $d8aK6 = parcelRequire("d8aK6");

var $bSNF3 = parcelRequire("bSNF3");
let $be11723f183186a2$var$_externalPropagationContextProvider;
function $be11723f183186a2$var$registerExternalPropagationContext(fn) {
    $be11723f183186a2$var$_externalPropagationContextProvider = fn;
}
function $be11723f183186a2$var$getExternalPropagationContext() {
    return $be11723f183186a2$var$_externalPropagationContextProvider?.();
}
function $be11723f183186a2$var$hasExternalPropagationContext() {
    return $be11723f183186a2$var$_externalPropagationContextProvider !== void 0;
}
function $be11723f183186a2$var$getCurrentScope() {
    const carrier$1 = $hbMFZ.getMainCarrier();
    const acs = $Up7k9.getAsyncContextStrategy(carrier$1);
    return acs.getCurrentScope();
}
function $be11723f183186a2$var$getIsolationScope() {
    const carrier$1 = $hbMFZ.getMainCarrier();
    const acs = $Up7k9.getAsyncContextStrategy(carrier$1);
    return acs.getIsolationScope();
}
function $be11723f183186a2$var$getGlobalScope() {
    return $hbMFZ.getGlobalSingleton("globalScope", ()=>new $d8aK6.Scope());
}
function $be11723f183186a2$var$withScope(...rest) {
    const carrier$1 = $hbMFZ.getMainCarrier();
    const acs = $Up7k9.getAsyncContextStrategy(carrier$1);
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
function $be11723f183186a2$var$withIsolationScope(...rest) {
    const carrier$1 = $hbMFZ.getMainCarrier();
    const acs = $Up7k9.getAsyncContextStrategy(carrier$1);
    if (rest.length === 2) {
        const [isolationScope, callback] = rest;
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
function $be11723f183186a2$var$getClient() {
    return $be11723f183186a2$var$getCurrentScope().getClient();
}
function $be11723f183186a2$var$getTraceContextFromScope(scope) {
    const externalContext = $be11723f183186a2$var$getExternalPropagationContext();
    if (externalContext) return {
        trace_id: externalContext.traceId,
        span_id: externalContext.spanId
    };
    const propagationContext$1 = scope.getPropagationContext();
    const { traceId: traceId, parentSpanId: parentSpanId, propagationSpanId: propagationSpanId } = propagationContext$1;
    const traceContext = {
        trace_id: traceId,
        span_id: propagationSpanId || $bSNF3.generateSpanId()
    };
    if (parentSpanId) traceContext.parent_span_id = parentSpanId;
    return traceContext;
}
module.exports.getClient = $be11723f183186a2$var$getClient;
module.exports.getCurrentScope = $be11723f183186a2$var$getCurrentScope;
module.exports.getExternalPropagationContext = $be11723f183186a2$var$getExternalPropagationContext;
module.exports.getGlobalScope = $be11723f183186a2$var$getGlobalScope;
module.exports.getIsolationScope = $be11723f183186a2$var$getIsolationScope;
module.exports.getTraceContextFromScope = $be11723f183186a2$var$getTraceContextFromScope;
module.exports.hasExternalPropagationContext = $be11723f183186a2$var$hasExternalPropagationContext;
module.exports.registerExternalPropagationContext = $be11723f183186a2$var$registerExternalPropagationContext;
module.exports.withIsolationScope = $be11723f183186a2$var$withIsolationScope;
module.exports.withScope = $be11723f183186a2$var$withScope;

});

parcelRegister("3dwiN", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $257ba48cb1fe1f5d$var$SEMANTIC_ATTRIBUTE_SENTRY_SOURCE = "sentry.source";
const $257ba48cb1fe1f5d$var$SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE = "sentry.sample_rate";
const $257ba48cb1fe1f5d$var$SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE = "sentry.previous_trace_sample_rate";
const $257ba48cb1fe1f5d$var$SEMANTIC_ATTRIBUTE_SENTRY_OP = "sentry.op";
const $257ba48cb1fe1f5d$var$SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN = "sentry.origin";
const $257ba48cb1fe1f5d$var$SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON = "sentry.idle_span_finish_reason";
const $257ba48cb1fe1f5d$var$SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT = "sentry.measurement_unit";
const $257ba48cb1fe1f5d$var$SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE = "sentry.measurement_value";
const $257ba48cb1fe1f5d$var$SEMANTIC_ATTRIBUTE_SENTRY_RELEASE = "sentry.release";
const $257ba48cb1fe1f5d$var$SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT = "sentry.environment";
const $257ba48cb1fe1f5d$var$SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME = "sentry.segment.name";
const $257ba48cb1fe1f5d$var$SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID = "sentry.segment.id";
const $257ba48cb1fe1f5d$var$SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME = "sentry.sdk.name";
const $257ba48cb1fe1f5d$var$SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION = "sentry.sdk.version";
const $257ba48cb1fe1f5d$var$SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS = "sentry.sdk.integrations";
const $257ba48cb1fe1f5d$var$SEMANTIC_ATTRIBUTE_USER_ID = "user.id";
const $257ba48cb1fe1f5d$var$SEMANTIC_ATTRIBUTE_USER_EMAIL = "user.email";
const $257ba48cb1fe1f5d$var$SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS = "user.ip_address";
const $257ba48cb1fe1f5d$var$SEMANTIC_ATTRIBUTE_USER_USERNAME = "user.name";
const $257ba48cb1fe1f5d$var$SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME = "sentry.custom_span_name";
const $257ba48cb1fe1f5d$var$SEMANTIC_ATTRIBUTE_PROFILE_ID = "sentry.profile_id";
const $257ba48cb1fe1f5d$var$SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME = "sentry.exclusive_time";
const $257ba48cb1fe1f5d$var$SEMANTIC_ATTRIBUTE_CACHE_HIT = "cache.hit";
const $257ba48cb1fe1f5d$var$SEMANTIC_ATTRIBUTE_CACHE_KEY = "cache.key";
const $257ba48cb1fe1f5d$var$SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE = "cache.item_size";
const $257ba48cb1fe1f5d$var$SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD = "http.request.method";
const $257ba48cb1fe1f5d$var$SEMANTIC_ATTRIBUTE_URL_FULL = "url.full";
const $257ba48cb1fe1f5d$var$SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE = "sentry.link.type";
const $257ba48cb1fe1f5d$var$GEN_AI_CONVERSATION_ID_ATTRIBUTE = "gen_ai.conversation.id";
module.exports.GEN_AI_CONVERSATION_ID_ATTRIBUTE = $257ba48cb1fe1f5d$var$GEN_AI_CONVERSATION_ID_ATTRIBUTE;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_HIT = $257ba48cb1fe1f5d$var$SEMANTIC_ATTRIBUTE_CACHE_HIT;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE = $257ba48cb1fe1f5d$var$SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_KEY = $257ba48cb1fe1f5d$var$SEMANTIC_ATTRIBUTE_CACHE_KEY;
module.exports.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME = $257ba48cb1fe1f5d$var$SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME;
module.exports.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD = $257ba48cb1fe1f5d$var$SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD;
module.exports.SEMANTIC_ATTRIBUTE_PROFILE_ID = $257ba48cb1fe1f5d$var$SEMANTIC_ATTRIBUTE_PROFILE_ID;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME = $257ba48cb1fe1f5d$var$SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT = $257ba48cb1fe1f5d$var$SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON = $257ba48cb1fe1f5d$var$SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT = $257ba48cb1fe1f5d$var$SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE = $257ba48cb1fe1f5d$var$SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_OP = $257ba48cb1fe1f5d$var$SEMANTIC_ATTRIBUTE_SENTRY_OP;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN = $257ba48cb1fe1f5d$var$SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE = $257ba48cb1fe1f5d$var$SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_RELEASE = $257ba48cb1fe1f5d$var$SEMANTIC_ATTRIBUTE_SENTRY_RELEASE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE = $257ba48cb1fe1f5d$var$SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS = $257ba48cb1fe1f5d$var$SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME = $257ba48cb1fe1f5d$var$SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION = $257ba48cb1fe1f5d$var$SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID = $257ba48cb1fe1f5d$var$SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME = $257ba48cb1fe1f5d$var$SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE = $257ba48cb1fe1f5d$var$SEMANTIC_ATTRIBUTE_SENTRY_SOURCE;
module.exports.SEMANTIC_ATTRIBUTE_URL_FULL = $257ba48cb1fe1f5d$var$SEMANTIC_ATTRIBUTE_URL_FULL;
module.exports.SEMANTIC_ATTRIBUTE_USER_EMAIL = $257ba48cb1fe1f5d$var$SEMANTIC_ATTRIBUTE_USER_EMAIL;
module.exports.SEMANTIC_ATTRIBUTE_USER_ID = $257ba48cb1fe1f5d$var$SEMANTIC_ATTRIBUTE_USER_ID;
module.exports.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS = $257ba48cb1fe1f5d$var$SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS;
module.exports.SEMANTIC_ATTRIBUTE_USER_USERNAME = $257ba48cb1fe1f5d$var$SEMANTIC_ATTRIBUTE_USER_USERNAME;
module.exports.SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE = $257ba48cb1fe1f5d$var$SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE;

});

parcelRegister("9X7hl", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $73ef452d89a5f632$var$SPAN_STATUS_UNSET = 0;
const $73ef452d89a5f632$var$SPAN_STATUS_OK = 1;
const $73ef452d89a5f632$var$SPAN_STATUS_ERROR = 2;
function $73ef452d89a5f632$var$getSpanStatusFromHttpCode(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: $73ef452d89a5f632$var$SPAN_STATUS_OK
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: $73ef452d89a5f632$var$SPAN_STATUS_ERROR,
                message: "unauthenticated"
            };
        case 403:
            return {
                code: $73ef452d89a5f632$var$SPAN_STATUS_ERROR,
                message: "permission_denied"
            };
        case 404:
            return {
                code: $73ef452d89a5f632$var$SPAN_STATUS_ERROR,
                message: "not_found"
            };
        case 409:
            return {
                code: $73ef452d89a5f632$var$SPAN_STATUS_ERROR,
                message: "already_exists"
            };
        case 413:
            return {
                code: $73ef452d89a5f632$var$SPAN_STATUS_ERROR,
                message: "failed_precondition"
            };
        case 429:
            return {
                code: $73ef452d89a5f632$var$SPAN_STATUS_ERROR,
                message: "resource_exhausted"
            };
        case 499:
            return {
                code: $73ef452d89a5f632$var$SPAN_STATUS_ERROR,
                message: "cancelled"
            };
        default:
            return {
                code: $73ef452d89a5f632$var$SPAN_STATUS_ERROR,
                message: "invalid_argument"
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: $73ef452d89a5f632$var$SPAN_STATUS_ERROR,
                message: "unimplemented"
            };
        case 503:
            return {
                code: $73ef452d89a5f632$var$SPAN_STATUS_ERROR,
                message: "unavailable"
            };
        case 504:
            return {
                code: $73ef452d89a5f632$var$SPAN_STATUS_ERROR,
                message: "deadline_exceeded"
            };
        default:
            return {
                code: $73ef452d89a5f632$var$SPAN_STATUS_ERROR,
                message: "internal_error"
            };
    }
    return {
        code: $73ef452d89a5f632$var$SPAN_STATUS_ERROR,
        message: "internal_error"
    };
}
function $73ef452d89a5f632$var$setHttpStatus(span, httpStatus) {
    span.setAttribute("http.response.status_code", httpStatus);
    const spanStatus = $73ef452d89a5f632$var$getSpanStatusFromHttpCode(httpStatus);
    if (spanStatus.message !== "unknown_error") span.setStatus(spanStatus);
}
module.exports.SPAN_STATUS_ERROR = $73ef452d89a5f632$var$SPAN_STATUS_ERROR;
module.exports.SPAN_STATUS_OK = $73ef452d89a5f632$var$SPAN_STATUS_OK;
module.exports.SPAN_STATUS_UNSET = $73ef452d89a5f632$var$SPAN_STATUS_UNSET;
module.exports.getSpanStatusFromHttpCode = $73ef452d89a5f632$var$getSpanStatusFromHttpCode;
module.exports.setHttpStatus = $73ef452d89a5f632$var$setHttpStatus;

});

parcelRegister("iUxao", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $2SQtm = parcelRequire("2SQtm");

var $bOToE = parcelRequire("bOToE");
const $dc472f23d15a4fd9$var$SCOPE_ON_START_SPAN_FIELD = "_sentryScope";
const $dc472f23d15a4fd9$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = "_sentryIsolationScope";
function $dc472f23d15a4fd9$var$setCapturedScopesOnSpan(span, scope, isolationScope) {
    if (span) {
        $2SQtm.addNonEnumerableProperty(span, $dc472f23d15a4fd9$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, $bOToE.makeWeakRef(isolationScope));
        $2SQtm.addNonEnumerableProperty(span, $dc472f23d15a4fd9$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
function $dc472f23d15a4fd9$var$getCapturedScopesOnSpan(span) {
    const spanWithScopes = span;
    return {
        scope: spanWithScopes[$dc472f23d15a4fd9$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: $bOToE.derefWeakRef(spanWithScopes[$dc472f23d15a4fd9$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD])
    };
}
module.exports.getCapturedScopesOnSpan = $dc472f23d15a4fd9$var$getCapturedScopesOnSpan;
module.exports.setCapturedScopesOnSpan = $dc472f23d15a4fd9$var$setCapturedScopesOnSpan;

});
parcelRegister("bOToE", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hsCGK = parcelRequire("hsCGK");
function $89af55d1c4a1af20$var$makeWeakRef(value) {
    try {
        const WeakRefImpl = $hsCGK.GLOBAL_OBJ.WeakRef;
        if (typeof WeakRefImpl === "function") return new WeakRefImpl(value);
    } catch  {}
    return value;
}
function $89af55d1c4a1af20$var$derefWeakRef(ref) {
    if (!ref) return void 0;
    if (typeof ref === "object" && "deref" in ref && typeof ref.deref === "function") try {
        return ref.deref();
    } catch  {
        return void 0;
    }
    return ref;
}
module.exports.derefWeakRef = $89af55d1c4a1af20$var$derefWeakRef;
module.exports.makeWeakRef = $89af55d1c4a1af20$var$makeWeakRef;

});


parcelRegister("hiiHh", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $jix5p = parcelRequire("jix5p");

var $enaoN = parcelRequire("enaoN");

var $jypZc = parcelRequire("jypZc");

var $d2351 = parcelRequire("d2351");

var $bSNF3 = parcelRequire("bSNF3");

var $9xAUk = parcelRequire("9xAUk");
const $c9729ef3e40bb3e7$var$TRACEPARENT_REGEXP = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
function $c9729ef3e40bb3e7$var$extractTraceparentData(traceparent) {
    if (!traceparent) return void 0;
    const matches = traceparent.match($c9729ef3e40bb3e7$var$TRACEPARENT_REGEXP);
    if (!matches) return void 0;
    let parentSampled;
    if (matches[3] === "1") parentSampled = true;
    else if (matches[3] === "0") parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
function $c9729ef3e40bb3e7$var$propagationContextFromHeaders(sentryTrace, baggage$1) {
    const traceparentData = $c9729ef3e40bb3e7$var$extractTraceparentData(sentryTrace);
    const dynamicSamplingContext = $enaoN.baggageHeaderToDynamicSamplingContext(baggage$1);
    if (!traceparentData?.traceId) return {
        traceId: $bSNF3.generateTraceId(),
        sampleRand: $9xAUk.safeMathRandom()
    };
    const sampleRand = $c9729ef3e40bb3e7$var$getSampleRandFromTraceparentAndDsc(traceparentData, dynamicSamplingContext);
    if (dynamicSamplingContext) dynamicSamplingContext.sample_rand = sampleRand.toString();
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData;
    return {
        traceId: traceId,
        parentSpanId: parentSpanId,
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {},
        sampleRand: // If we have traceparent data but no DSC it means we are not head of trace and we must freeze it
        sampleRand
    };
}
function $c9729ef3e40bb3e7$var$generateSentryTraceHeader(traceId = $bSNF3.generateTraceId(), spanId = $bSNF3.generateSpanId(), sampled) {
    let sampledString = "";
    if (sampled !== void 0) sampledString = sampled ? "-1" : "-0";
    return `${traceId}-${spanId}${sampledString}`;
}
function $c9729ef3e40bb3e7$var$generateTraceparentHeader(traceId = $bSNF3.generateTraceId(), spanId = $bSNF3.generateSpanId(), sampled) {
    return `00-${traceId}-${spanId}-${sampled ? "01" : "00"}`;
}
function $c9729ef3e40bb3e7$var$getSampleRandFromTraceparentAndDsc(traceparentData, dsc) {
    const parsedSampleRand = $d2351.parseSampleRate(dsc?.sample_rand);
    if (parsedSampleRand !== void 0) return parsedSampleRand;
    const parsedSampleRate = $d2351.parseSampleRate(dsc?.sample_rate);
    if (parsedSampleRate && traceparentData?.parentSampled !== void 0) return traceparentData.parentSampled ? // Returns a sample rand with positive sampling decision [0, sampleRate)
    $9xAUk.safeMathRandom() * parsedSampleRate : // Returns a sample rand with negative sampling decision [sampleRate, 1)
    parsedSampleRate + $9xAUk.safeMathRandom() * (1 - parsedSampleRate);
    else return $9xAUk.safeMathRandom();
}
function $c9729ef3e40bb3e7$var$shouldContinueTrace(client, baggageOrgId) {
    const clientOrgId = $jypZc.extractOrgIdFromClient(client);
    if (baggageOrgId && clientOrgId && baggageOrgId !== clientOrgId) {
        $jix5p.debug.log(`Won't continue trace because org IDs don't match (incoming baggage: ${baggageOrgId}, SDK options: ${clientOrgId})`);
        return false;
    }
    const strictTraceContinuation = client.getOptions().strictTraceContinuation || false;
    if (strictTraceContinuation) {
        if (baggageOrgId && !clientOrgId || !baggageOrgId && clientOrgId) {
            $jix5p.debug.log(`Starting a new trace because strict trace continuation is enabled but one org ID is missing (incoming baggage: ${baggageOrgId}, Sentry client: ${clientOrgId})`);
            return false;
        }
    }
    return true;
}
module.exports.TRACEPARENT_REGEXP = $c9729ef3e40bb3e7$var$TRACEPARENT_REGEXP;
module.exports.extractTraceparentData = $c9729ef3e40bb3e7$var$extractTraceparentData;
module.exports.generateSentryTraceHeader = $c9729ef3e40bb3e7$var$generateSentryTraceHeader;
module.exports.generateTraceparentHeader = $c9729ef3e40bb3e7$var$generateTraceparentHeader;
module.exports.propagationContextFromHeaders = $c9729ef3e40bb3e7$var$propagationContextFromHeaders;
module.exports.shouldContinueTrace = $c9729ef3e40bb3e7$var$shouldContinueTrace;

});
parcelRegister("enaoN", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $jCjMv = parcelRequire("jCjMv");

var $jix5p = parcelRequire("jix5p");

var $fBPG6 = parcelRequire("fBPG6");
const $a76b47b3a0759ba5$var$SENTRY_BAGGAGE_KEY_PREFIX = "sentry-";
const $a76b47b3a0759ba5$var$SENTRY_BAGGAGE_KEY_PREFIX_REGEX = /^sentry-/;
const $a76b47b3a0759ba5$var$MAX_BAGGAGE_STRING_LENGTH = 8192;
function $a76b47b3a0759ba5$var$baggageHeaderToDynamicSamplingContext(baggageHeader) {
    const baggageObject = $a76b47b3a0759ba5$var$parseBaggageHeader(baggageHeader);
    if (!baggageObject) return void 0;
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.startsWith($a76b47b3a0759ba5$var$SENTRY_BAGGAGE_KEY_PREFIX)) {
            const nonPrefixedKey = key.slice($a76b47b3a0759ba5$var$SENTRY_BAGGAGE_KEY_PREFIX.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return void 0;
}
function $a76b47b3a0759ba5$var$dynamicSamplingContextToSentryBaggageHeader(dynamicSamplingContext) {
    if (!dynamicSamplingContext) return void 0;
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$a76b47b3a0759ba5$var$SENTRY_BAGGAGE_KEY_PREFIX}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $a76b47b3a0759ba5$var$objectToBaggageHeader(sentryPrefixedDSC);
}
function $a76b47b3a0759ba5$var$parseBaggageHeader(baggageHeader) {
    if (!baggageHeader || !$fBPG6.isString(baggageHeader) && !Array.isArray(baggageHeader)) return void 0;
    if (Array.isArray(baggageHeader)) return baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $a76b47b3a0759ba5$var$baggageHeaderToObject(curr);
        Object.entries(currBaggageObject).forEach(([key, value])=>{
            acc[key] = value;
        });
        return acc;
    }, {});
    return $a76b47b3a0759ba5$var$baggageHeaderToObject(baggageHeader);
}
function $a76b47b3a0759ba5$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(",").map((baggageEntry)=>{
        const eqIdx = baggageEntry.indexOf("=");
        if (eqIdx === -1) return [];
        const key = baggageEntry.slice(0, eqIdx);
        const value = baggageEntry.slice(eqIdx + 1);
        return [
            key,
            value
        ].map((keyOrValue)=>{
            try {
                return decodeURIComponent(keyOrValue.trim());
            } catch  {
                return;
            }
        });
    }).reduce((acc, [key, value])=>{
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
function $a76b47b3a0759ba5$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) return void 0;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $a76b47b3a0759ba5$var$MAX_BAGGAGE_STRING_LENGTH) {
            $jCjMv.DEBUG_BUILD && $jix5p.debug.warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, "");
}
function $a76b47b3a0759ba5$var$mergeBaggageHeaders(existing, incoming) {
    if (!existing) return incoming;
    const existingEntries = $a76b47b3a0759ba5$var$parseBaggageHeader(existing);
    const incomingEntries = $a76b47b3a0759ba5$var$parseBaggageHeader(incoming);
    if (!incomingEntries) return existing;
    const merged = {};
    let hasNewSentryEntries = false;
    const newSentryEntries = {};
    const newNonSentryEntries = {};
    for (const [key, value] of Object.entries(incomingEntries))if (key.startsWith($a76b47b3a0759ba5$var$SENTRY_BAGGAGE_KEY_PREFIX)) {
        newSentryEntries[key] = value;
        hasNewSentryEntries = true;
    } else newNonSentryEntries[key] = value;
    if (existingEntries) {
        for (const [key, value] of Object.entries(existingEntries))if (!hasNewSentryEntries || !key.startsWith($a76b47b3a0759ba5$var$SENTRY_BAGGAGE_KEY_PREFIX)) merged[key] = value;
    }
    if (hasNewSentryEntries) Object.assign(merged, newSentryEntries);
    for (const [key, value] of Object.entries(newNonSentryEntries))merged[key] ?? (merged[key] = value);
    return $a76b47b3a0759ba5$var$objectToBaggageHeader(merged);
}
module.exports.MAX_BAGGAGE_STRING_LENGTH = $a76b47b3a0759ba5$var$MAX_BAGGAGE_STRING_LENGTH;
module.exports.SENTRY_BAGGAGE_KEY_PREFIX = $a76b47b3a0759ba5$var$SENTRY_BAGGAGE_KEY_PREFIX;
module.exports.SENTRY_BAGGAGE_KEY_PREFIX_REGEX = $a76b47b3a0759ba5$var$SENTRY_BAGGAGE_KEY_PREFIX_REGEX;
module.exports.baggageHeaderToDynamicSamplingContext = $a76b47b3a0759ba5$var$baggageHeaderToDynamicSamplingContext;
module.exports.dynamicSamplingContextToSentryBaggageHeader = $a76b47b3a0759ba5$var$dynamicSamplingContextToSentryBaggageHeader;
module.exports.mergeBaggageHeaders = $a76b47b3a0759ba5$var$mergeBaggageHeaders;
module.exports.objectToBaggageHeader = $a76b47b3a0759ba5$var$objectToBaggageHeader;
module.exports.parseBaggageHeader = $a76b47b3a0759ba5$var$parseBaggageHeader;

});

parcelRegister("jypZc", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $jCjMv = parcelRequire("jCjMv");

var $jix5p = parcelRequire("jix5p");
const $e3c559987c7d24e1$var$ORG_ID_REGEX = /^o(\d+)\./;
const $e3c559987c7d24e1$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)((?:\[[:.%\w]+\]|[\w.-]+))(?::(\d+))?\/(.+)/;
function $e3c559987c7d24e1$var$isValidProtocol(protocol) {
    return protocol === "http" || protocol === "https";
}
function $e3c559987c7d24e1$var$dsnToString(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ""}@${host}${port ? `:${port}` : ""}/${path ? `${path}/` : path}${projectId}`;
}
function $e3c559987c7d24e1$var$dsnFromString(str) {
    const match = $e3c559987c7d24e1$var$DSN_REGEX.exec(str);
    if (!match) {
        $jix5p.consoleSandbox(()=>{
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return void 0;
    }
    const [protocol, publicKey, pass = "", host = "", port = "", lastPath = ""] = match.slice(1);
    let path = "";
    let projectId = lastPath;
    const split = projectId.split("/");
    if (split.length > 1) {
        path = split.slice(0, -1).join("/");
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $e3c559987c7d24e1$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $e3c559987c7d24e1$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || "",
        pass: components.pass || "",
        host: components.host,
        port: components.port || "",
        path: components.path || "",
        projectId: components.projectId
    };
}
function $e3c559987c7d24e1$var$validateDsn(dsn) {
    if (!$jCjMv.DEBUG_BUILD) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        "protocol",
        "publicKey",
        "host",
        "projectId"
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            $jix5p.debug.error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        $jix5p.debug.error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$e3c559987c7d24e1$var$isValidProtocol(protocol)) {
        $jix5p.debug.error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        $jix5p.debug.error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
function $e3c559987c7d24e1$var$extractOrgIdFromDsnHost(host) {
    const match = host.match($e3c559987c7d24e1$var$ORG_ID_REGEX);
    return match?.[1];
}
function $e3c559987c7d24e1$var$extractOrgIdFromClient(client) {
    const options = client.getOptions();
    const { host: host } = client.getDsn() || {};
    let org_id;
    if (options.orgId) org_id = String(options.orgId);
    else if (host) org_id = $e3c559987c7d24e1$var$extractOrgIdFromDsnHost(host);
    return org_id;
}
function $e3c559987c7d24e1$var$makeDsn(from) {
    const components = typeof from === "string" ? $e3c559987c7d24e1$var$dsnFromString(from) : $e3c559987c7d24e1$var$dsnFromComponents(from);
    if (!components || !$e3c559987c7d24e1$var$validateDsn(components)) return void 0;
    return components;
}
module.exports.dsnFromString = $e3c559987c7d24e1$var$dsnFromString;
module.exports.dsnToString = $e3c559987c7d24e1$var$dsnToString;
module.exports.extractOrgIdFromClient = $e3c559987c7d24e1$var$extractOrgIdFromClient;
module.exports.extractOrgIdFromDsnHost = $e3c559987c7d24e1$var$extractOrgIdFromDsnHost;
module.exports.makeDsn = $e3c559987c7d24e1$var$makeDsn;

});

parcelRegister("d2351", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $97cdd9de37e718b6$var$parseSampleRate(sampleRate) {
    if (typeof sampleRate === "boolean") return Number(sampleRate);
    const rate = typeof sampleRate === "string" ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== "number" || isNaN(rate) || rate < 0 || rate > 1) return void 0;
    return rate;
}
module.exports.parseSampleRate = $97cdd9de37e718b6$var$parseSampleRate;

});




parcelRegister("jyEe9", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gjJ9A = parcelRequire("gjJ9A");

var $jCjMv = parcelRequire("jCjMv");

var $3dwiN = parcelRequire("3dwiN");

var $jix5p = parcelRequire("jix5p");

var $hbAIy = parcelRequire("hbAIy");

var $dbEaR = parcelRequire("dbEaR");

var $k7IIJ = parcelRequire("k7IIJ");

var $2dG64 = parcelRequire("2dG64");

var $7q4WK = parcelRequire("7q4WK");

var $dkd4c = parcelRequire("dkd4c");

var $lJzTh = parcelRequire("lJzTh");

var $4OdOk = parcelRequire("4OdOk");

var $9X7hl = parcelRequire("9X7hl");

var $4Ae9I = parcelRequire("4Ae9I");
const $e3d065948179af25$var$TRACING_DEFAULTS = {
    idleTimeout: 1e3,
    finalTimeout: 3e4,
    childSpanTimeout: 15e3
};
const $e3d065948179af25$var$FINISH_REASON_HEARTBEAT_FAILED = "heartbeatFailed";
const $e3d065948179af25$var$FINISH_REASON_IDLE_TIMEOUT = "idleTimeout";
const $e3d065948179af25$var$FINISH_REASON_FINAL_TIMEOUT = "finalTimeout";
const $e3d065948179af25$var$FINISH_REASON_EXTERNAL_FINISH = "externalFinish";
function $e3d065948179af25$var$startIdleSpan(startSpanOptions, options = {}) {
    const activities = /* @__PURE__ */ new Map();
    let _finished = false;
    let _idleTimeoutID;
    let _finishReason = $e3d065948179af25$var$FINISH_REASON_EXTERNAL_FINISH;
    let _autoFinishAllowed = !options.disableAutoFinish;
    const _cleanupHooks = [];
    const { idleTimeout: idleTimeout = $e3d065948179af25$var$TRACING_DEFAULTS.idleTimeout, finalTimeout: finalTimeout = $e3d065948179af25$var$TRACING_DEFAULTS.finalTimeout, childSpanTimeout: childSpanTimeout = $e3d065948179af25$var$TRACING_DEFAULTS.childSpanTimeout, beforeSpanEnd: beforeSpanEnd, trimIdleSpanEndTimestamp: trimIdleSpanEndTimestamp = true } = options;
    const client = $gjJ9A.getClient();
    if (!client || !$hbAIy.hasSpansEnabled()) {
        const span2 = new $lJzTh.SentryNonRecordingSpan();
        const dsc = {
            sample_rate: "0",
            sampled: "false",
            ...$dkd4c.getDynamicSamplingContextFromSpan(span2)
        };
        $dkd4c.freezeDscOnSpan(span2, dsc);
        return span2;
    }
    const scope = $gjJ9A.getCurrentScope();
    const previousActiveSpan = $2dG64.getActiveSpan();
    const span = $e3d065948179af25$var$_startIdleSpan(startSpanOptions);
    span.end = new Proxy(span.end, {
        apply (target, thisArg, args) {
            if (beforeSpanEnd) beforeSpanEnd(span);
            if (thisArg instanceof $lJzTh.SentryNonRecordingSpan) return;
            const [definedEndTimestamp, ...rest] = args;
            const timestamp = definedEndTimestamp || $7q4WK.timestampInSeconds();
            const spanEndTimestamp = $2dG64.spanTimeInputToSeconds(timestamp);
            const spans = $2dG64.getSpanDescendants(span).filter((child)=>child !== span);
            const spanJson = $2dG64.spanToJSON(span);
            if (!spans.length || !trimIdleSpanEndTimestamp) {
                onIdleSpanEnded(spanEndTimestamp);
                return Reflect.apply(target, thisArg, [
                    spanEndTimestamp,
                    ...rest
                ]);
            }
            const ignoreSpans = client.getOptions().ignoreSpans;
            const latestSpanEndTimestamp = spans?.reduce((acc, current)=>{
                const currentSpanJson = $2dG64.spanToJSON(current);
                if (!currentSpanJson.timestamp) return acc;
                if (ignoreSpans && $dbEaR.shouldIgnoreSpan({
                    description: currentSpanJson.description,
                    op: currentSpanJson.op,
                    attributes: currentSpanJson.data
                }, ignoreSpans)) return acc;
                return acc ? Math.max(acc, currentSpanJson.timestamp) : currentSpanJson.timestamp;
            }, void 0);
            const spanStartTimestamp = spanJson.start_timestamp;
            const endTimestamp = Math.min(spanStartTimestamp ? spanStartTimestamp + finalTimeout / 1e3 : Infinity, Math.max(spanStartTimestamp || -Infinity, Math.min(spanEndTimestamp, latestSpanEndTimestamp || Infinity)));
            onIdleSpanEnded(endTimestamp);
            return Reflect.apply(target, thisArg, [
                endTimestamp,
                ...rest
            ]);
        }
    });
    function _cancelIdleTimeout() {
        if (_idleTimeoutID) {
            clearTimeout(_idleTimeoutID);
            _idleTimeoutID = void 0;
        }
    }
    function _restartIdleTimeout(endTimestamp) {
        _cancelIdleTimeout();
        _idleTimeoutID = setTimeout(()=>{
            if (!_finished && activities.size === 0 && _autoFinishAllowed) {
                _finishReason = $e3d065948179af25$var$FINISH_REASON_IDLE_TIMEOUT;
                span.end(endTimestamp);
            }
        }, idleTimeout);
    }
    function _restartChildSpanTimeout(endTimestamp) {
        _idleTimeoutID = setTimeout(()=>{
            if (!_finished && _autoFinishAllowed) {
                _finishReason = $e3d065948179af25$var$FINISH_REASON_HEARTBEAT_FAILED;
                span.end(endTimestamp);
            }
        }, childSpanTimeout);
    }
    function _pushActivity(spanId) {
        _cancelIdleTimeout();
        activities.set(spanId, true);
        const endTimestamp = $7q4WK.timestampInSeconds();
        _restartChildSpanTimeout(endTimestamp + childSpanTimeout / 1e3);
    }
    function _popActivity(spanId) {
        if (activities.has(spanId)) activities.delete(spanId);
        if (activities.size === 0) {
            const endTimestamp = $7q4WK.timestampInSeconds();
            _restartIdleTimeout(endTimestamp + idleTimeout / 1e3);
        }
    }
    function onIdleSpanEnded(endTimestamp) {
        _finished = true;
        activities.clear();
        _cleanupHooks.forEach((cleanup)=>cleanup());
        $k7IIJ._setSpanForScope(scope, previousActiveSpan);
        const spanJSON = $2dG64.spanToJSON(span);
        const { start_timestamp: startTimestamp } = spanJSON;
        if (!startTimestamp) return;
        const attributes = spanJSON.data;
        if (!attributes[$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON]) span.setAttribute($3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON, _finishReason);
        const currentStatus = spanJSON.status;
        if (!currentStatus || currentStatus === "unknown") span.setStatus({
            code: $9X7hl.SPAN_STATUS_OK
        });
        $jix5p.debug.log(`[Tracing] Idle span "${spanJSON.op}" finished`);
        const childSpans = $2dG64.getSpanDescendants(span).filter((child)=>child !== span);
        let discardedSpans = 0;
        childSpans.forEach((childSpan)=>{
            if (childSpan.isRecording()) {
                childSpan.setStatus({
                    code: $9X7hl.SPAN_STATUS_ERROR,
                    message: "cancelled"
                });
                childSpan.end(endTimestamp);
                $jCjMv.DEBUG_BUILD && $jix5p.debug.log("[Tracing] Cancelling span since span ended early", JSON.stringify(childSpan, void 0, 2));
            }
            const childSpanJSON = $2dG64.spanToJSON(childSpan);
            const { timestamp: childEndTimestamp = 0, start_timestamp: childStartTimestamp = 0 } = childSpanJSON;
            const spanStartedBeforeIdleSpanEnd = childStartTimestamp <= endTimestamp;
            const timeoutWithMarginOfError = (finalTimeout + idleTimeout) / 1e3;
            const spanEndedBeforeFinalTimeout = childEndTimestamp - childStartTimestamp <= timeoutWithMarginOfError;
            if ($jCjMv.DEBUG_BUILD) {
                const stringifiedSpan = JSON.stringify(childSpan, void 0, 2);
                if (!spanStartedBeforeIdleSpanEnd) $jix5p.debug.log("[Tracing] Discarding span since it happened after idle span was finished", stringifiedSpan);
                else if (!spanEndedBeforeFinalTimeout) $jix5p.debug.log("[Tracing] Discarding span since it finished after idle span final timeout", stringifiedSpan);
            }
            if (!spanEndedBeforeFinalTimeout || !spanStartedBeforeIdleSpanEnd) {
                $2dG64.removeChildSpanFromSpan(span, childSpan);
                discardedSpans++;
            }
        });
        if (discardedSpans > 0) span.setAttribute("sentry.idle_span_discarded_spans", discardedSpans);
    }
    _cleanupHooks.push(client.on("spanStart", (startedSpan)=>{
        if (_finished || startedSpan === span || !!$2dG64.spanToJSON(startedSpan).timestamp || startedSpan instanceof $4OdOk.SentrySpan && startedSpan.isStandaloneSpan()) return;
        const allSpans = $2dG64.getSpanDescendants(span);
        if (allSpans.includes(startedSpan)) _pushActivity(startedSpan.spanContext().spanId);
    }));
    _cleanupHooks.push(client.on("spanEnd", (endedSpan)=>{
        if (_finished) return;
        _popActivity(endedSpan.spanContext().spanId);
    }));
    _cleanupHooks.push(client.on("idleSpanEnableAutoFinish", (spanToAllowAutoFinish)=>{
        if (spanToAllowAutoFinish === span) {
            _autoFinishAllowed = true;
            _restartIdleTimeout();
            if (activities.size) _restartChildSpanTimeout();
        }
    }));
    if (!options.disableAutoFinish) _restartIdleTimeout();
    setTimeout(()=>{
        if (!_finished) {
            span.setStatus({
                code: $9X7hl.SPAN_STATUS_ERROR,
                message: "deadline_exceeded"
            });
            _finishReason = $e3d065948179af25$var$FINISH_REASON_FINAL_TIMEOUT;
            span.end();
        }
    }, finalTimeout);
    return span;
}
function $e3d065948179af25$var$_startIdleSpan(options) {
    const span = $4Ae9I.startInactiveSpan(options);
    $k7IIJ._setSpanForScope($gjJ9A.getCurrentScope(), span);
    $jCjMv.DEBUG_BUILD && $jix5p.debug.log("[Tracing] Started span is an idle span");
    return span;
}
module.exports.TRACING_DEFAULTS = $e3d065948179af25$var$TRACING_DEFAULTS;
module.exports.startIdleSpan = $e3d065948179af25$var$startIdleSpan;

});
parcelRegister("hbAIy", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gjJ9A = parcelRequire("gjJ9A");
function $c82ff21b7ea4af51$var$hasSpansEnabled(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === "boolean" && !__SENTRY_TRACING__) return false;
    const options = maybeOptions || $gjJ9A.getClient()?.getOptions();
    return !!options && // Note: This check is `!= null`, meaning "nullish". `0` is not "nullish", `undefined` and `null` are. (This comment was brought to you by 15 minutes of questioning life)
    (options.tracesSampleRate != null || !!options.tracesSampler);
}
module.exports.hasSpansEnabled = $c82ff21b7ea4af51$var$hasSpansEnabled;

});

parcelRegister("dbEaR", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $jCjMv = parcelRequire("jCjMv");

var $jix5p = parcelRequire("jix5p");

var $23Myp = parcelRequire("23Myp");
function $999b7738a3364ac0$var$logIgnoredSpan(droppedSpan) {
    $jix5p.debug.log(`Ignoring span ${droppedSpan.op} - ${droppedSpan.description} because it matches \`ignoreSpans\`.`);
}
function $999b7738a3364ac0$var$shouldIgnoreSpan(span, ignoreSpans) {
    if (!ignoreSpans?.length) return false;
    for (const pattern of ignoreSpans){
        if ($999b7738a3364ac0$var$isStringOrRegExp(pattern)) {
            if (span.description && $23Myp.isMatchingPattern(span.description, pattern)) {
                $jCjMv.DEBUG_BUILD && $999b7738a3364ac0$var$logIgnoredSpan(span);
                return true;
            }
            continue;
        }
        const hasAttributes = !!pattern.attributes && Object.keys(pattern.attributes).length > 0;
        if (!pattern.name && !pattern.op && !hasAttributes) continue;
        const nameMatches = pattern.name ? span.description && $23Myp.isMatchingPattern(span.description, pattern.name) : true;
        const opMatches = pattern.op ? span.op && $23Myp.isMatchingPattern(span.op, pattern.op) : true;
        const attrsMatch = pattern.attributes ? Object.entries(pattern.attributes).every(([key, valuePattern])=>$999b7738a3364ac0$var$_matchesAttributeValue(span.attributes?.[key], valuePattern)) : true;
        if (nameMatches && opMatches && attrsMatch) {
            $jCjMv.DEBUG_BUILD && $999b7738a3364ac0$var$logIgnoredSpan(span);
            return true;
        }
    }
    return false;
}
function $999b7738a3364ac0$var$_matchesAttributeValue(actual, pat) {
    if (typeof actual === "string" && (typeof pat === "string" || pat instanceof RegExp)) return $23Myp.isMatchingPattern(actual, pat);
    if (Array.isArray(actual) && Array.isArray(pat)) return actual.length === pat.length && actual.every((v, i)=>v === pat[i]);
    return actual === pat;
}
function $999b7738a3364ac0$var$reparentChildSpans(spans, dropSpan) {
    const droppedSpanParentId = dropSpan.parent_span_id;
    const droppedSpanId = dropSpan.span_id;
    if (!droppedSpanParentId) return;
    for (const span of spans)if (span.parent_span_id === droppedSpanId) span.parent_span_id = droppedSpanParentId;
}
function $999b7738a3364ac0$var$isStringOrRegExp(value) {
    return typeof value === "string" || value instanceof RegExp;
}
module.exports.reparentChildSpans = $999b7738a3364ac0$var$reparentChildSpans;
module.exports.shouldIgnoreSpan = $999b7738a3364ac0$var$shouldIgnoreSpan;

});

parcelRegister("dkd4c", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $fXcxa = parcelRequire("fXcxa");

var $gjJ9A = parcelRequire("gjJ9A");

var $3dwiN = parcelRequire("3dwiN");

var $enaoN = parcelRequire("enaoN");

var $jypZc = parcelRequire("jypZc");

var $hbAIy = parcelRequire("hbAIy");

var $2SQtm = parcelRequire("2SQtm");

var $2dG64 = parcelRequire("2dG64");

var $iUxao = parcelRequire("iUxao");
const $9b374767ad121bab$var$FROZEN_DSC_FIELD = "_frozenDsc";
function $9b374767ad121bab$var$freezeDscOnSpan(span, dsc) {
    const spanWithMaybeDsc = span;
    $2SQtm.addNonEnumerableProperty(spanWithMaybeDsc, $9b374767ad121bab$var$FROZEN_DSC_FIELD, dsc);
}
function $9b374767ad121bab$var$getDynamicSamplingContextFromClient(trace_id, client) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    const dsc = {
        environment: options.environment || $fXcxa.DEFAULT_ENVIRONMENT,
        release: options.release,
        public_key: public_key,
        trace_id: trace_id,
        org_id: $jypZc.extractOrgIdFromClient(client)
    };
    client.emit("createDsc", dsc);
    return dsc;
}
function $9b374767ad121bab$var$getDynamicSamplingContextFromScope(client, scope) {
    const propagationContext = scope.getPropagationContext();
    return propagationContext.dsc || $9b374767ad121bab$var$getDynamicSamplingContextFromClient(propagationContext.traceId, client);
}
function $9b374767ad121bab$var$getDynamicSamplingContextFromSpan(span) {
    const client = $gjJ9A.getClient();
    if (!client) return {};
    const rootSpan = $2dG64.getRootSpan(span);
    const rootSpanJson = $2dG64.spanToJSON(rootSpan);
    const rootSpanAttributes = rootSpanJson.data;
    const traceState = rootSpan.spanContext().traceState;
    const rootSpanSampleRate = traceState?.get("sentry.sample_rate") ?? rootSpanAttributes[$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE] ?? rootSpanAttributes[$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE];
    function applyLocalSampleRateToDsc(dsc2) {
        if (typeof rootSpanSampleRate === "number" || typeof rootSpanSampleRate === "string") dsc2.sample_rate = `${rootSpanSampleRate}`;
        return dsc2;
    }
    const frozenDsc = rootSpan[$9b374767ad121bab$var$FROZEN_DSC_FIELD];
    if (frozenDsc) return applyLocalSampleRateToDsc(frozenDsc);
    const traceStateDsc = traceState?.get("sentry.dsc");
    const dscOnTraceState = traceStateDsc && $enaoN.baggageHeaderToDynamicSamplingContext(traceStateDsc);
    if (dscOnTraceState) return applyLocalSampleRateToDsc(dscOnTraceState);
    const dsc = $9b374767ad121bab$var$getDynamicSamplingContextFromClient(span.spanContext().traceId, client);
    const source = rootSpanAttributes[$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] ?? rootSpanAttributes["sentry.span.source"];
    const name = rootSpanJson.description;
    if (source !== "url" && name) dsc.transaction = name;
    if ($hbAIy.hasSpansEnabled()) {
        dsc.sampled = String($2dG64.spanIsSampled(rootSpan));
        dsc.sample_rand = // The Sentry OTEL SpanSampler takes care of writing the sample rand on the root span
        traceState?.get("sentry.sample_rand") ?? // On all other platforms we can actually get the scopes from a root span (we use this as a fallback)
        $iUxao.getCapturedScopesOnSpan(rootSpan).scope?.getPropagationContext().sampleRand.toString();
    }
    applyLocalSampleRateToDsc(dsc);
    client.emit("createDsc", dsc, rootSpan);
    return dsc;
}
function $9b374767ad121bab$var$spanToBaggageHeader(span) {
    const dsc = $9b374767ad121bab$var$getDynamicSamplingContextFromSpan(span);
    return $enaoN.dynamicSamplingContextToSentryBaggageHeader(dsc);
}
module.exports.freezeDscOnSpan = $9b374767ad121bab$var$freezeDscOnSpan;
module.exports.getDynamicSamplingContextFromClient = $9b374767ad121bab$var$getDynamicSamplingContextFromClient;
module.exports.getDynamicSamplingContextFromScope = $9b374767ad121bab$var$getDynamicSamplingContextFromScope;
module.exports.getDynamicSamplingContextFromSpan = $9b374767ad121bab$var$getDynamicSamplingContextFromSpan;
module.exports.spanToBaggageHeader = $9b374767ad121bab$var$spanToBaggageHeader;

});
parcelRegister("fXcxa", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $b9d616b0cc39dfad$var$DEFAULT_ENVIRONMENT = "production";
const $b9d616b0cc39dfad$var$DEV_ENVIRONMENT = "development";
module.exports.DEFAULT_ENVIRONMENT = $b9d616b0cc39dfad$var$DEFAULT_ENVIRONMENT;
module.exports.DEV_ENVIRONMENT = $b9d616b0cc39dfad$var$DEV_ENVIRONMENT;

});


parcelRegister("lJzTh", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $bSNF3 = parcelRequire("bSNF3");

var $2dG64 = parcelRequire("2dG64");
class $fd29a41652dd19b1$var$SentryNonRecordingSpan {
    constructor(spanContext = {}){
        this._traceId = spanContext.traceId || $bSNF3.generateTraceId();
        this._spanId = spanContext.spanId || $bSNF3.generateSpanId();
        this.dropReason = spanContext.dropReason;
    }
    /** @inheritdoc */ spanContext() {
        return {
            spanId: this._spanId,
            traceId: this._traceId,
            traceFlags: $2dG64.TRACE_FLAG_NONE
        };
    }
    /** @inheritdoc */ end(_timestamp) {}
    /** @inheritdoc */ setAttribute(_key, _value) {
        return this;
    }
    /** @inheritdoc */ setAttributes(_values) {
        return this;
    }
    /** @inheritdoc */ setStatus(_status) {
        return this;
    }
    /** @inheritdoc */ updateName(_name) {
        return this;
    }
    /** @inheritdoc */ isRecording() {
        return false;
    }
    /** @inheritdoc */ addEvent(_name, _attributesOrStartTime, _startTime) {
        return this;
    }
    /** @inheritDoc */ addLink(_link) {
        return this;
    }
    /** @inheritDoc */ addLinks(_links) {
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {}
}
module.exports.SentryNonRecordingSpan = $fd29a41652dd19b1$var$SentryNonRecordingSpan;

});

parcelRegister("4OdOk", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gjJ9A = parcelRequire("gjJ9A");

var $jCjMv = parcelRequire("jCjMv");

var $bOthn = parcelRequire("bOthn");

var $3dwiN = parcelRequire("3dwiN");

var $jix5p = parcelRequire("jix5p");

var $bSNF3 = parcelRequire("bSNF3");

var $2dG64 = parcelRequire("2dG64");

var $7q4WK = parcelRequire("7q4WK");

var $dkd4c = parcelRequire("dkd4c");

var $5puYc = parcelRequire("5puYc");

var $in1Kg = parcelRequire("in1Kg");

var $lIOsi = parcelRequire("lIOsi");

var $iUxao = parcelRequire("iUxao");
const $38068b78f2e6a171$var$MAX_SPAN_COUNT = 1e3;
class $38068b78f2e6a171$var$SentrySpan {
    /**
   * You should never call the constructor manually, always use `Sentry.startSpan()`
   * or other span methods.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || $bSNF3.generateTraceId();
        this._spanId = spanContext.spanId || $bSNF3.generateSpanId();
        this._startTime = spanContext.startTimestamp || $7q4WK.timestampInSeconds();
        this._links = spanContext.links;
        this._attributes = {};
        this.setAttributes({
            [$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "manual",
            [$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_OP]: spanContext.op,
            ...spanContext.attributes
        });
        this._name = spanContext.name;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        if ("sampled" in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        this._events = [];
        this._isStandaloneSpan = spanContext.isStandalone;
        if (this._endTime) this._onSpanEnded();
    }
    /** @inheritDoc */ addLink(link) {
        if (this._links) this._links.push(link);
        else this._links = [
            link
        ];
        return this;
    }
    /** @inheritDoc */ addLinks(links) {
        if (this._links) this._links.push(...links);
        else this._links = links;
        return this;
    }
    /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {}
    /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId: spanId,
            traceId: traceId,
            traceFlags: sampled ? $2dG64.TRACE_FLAG_SAMPLED : $2dG64.TRACE_FLAG_NONE
        };
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (value === void 0) delete this._attributes[key];
        else this._attributes[key] = value;
        return this;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for browser tracing where we want to adjust the start time afterwards.
   * USE THIS WITH CAUTION!
   *
   * @hidden
   * @internal
   */ updateStartTime(timeInput) {
        this._startTime = $2dG64.spanTimeInputToSeconds(timeInput);
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        this._name = name;
        this.setAttribute($3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE, "custom");
        return this;
    }
    /** @inheritdoc */ end(endTimestamp) {
        if (this._endTime) return;
        this._endTime = $2dG64.spanTimeInputToSeconds(endTimestamp);
        $5puYc.logSpanEnd(this);
        this._onSpanEnded();
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return {
            data: this._attributes,
            description: this._name,
            op: this._attributes[$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_OP],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: $2dG64.getStatusMessage(this._status),
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
            profile_id: this._attributes[$3dwiN.SEMANTIC_ATTRIBUTE_PROFILE_ID],
            exclusive_time: this._attributes[$3dwiN.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME],
            measurements: $in1Kg.timedEventsToMeasurements(this._events),
            is_segment: this._isStandaloneSpan && $2dG64.getRootSpan(this) === this || void 0,
            segment_id: this._isStandaloneSpan ? $2dG64.getRootSpan(this).spanContext().spanId : void 0,
            links: $2dG64.convertSpanLinksForEnvelope(this._links)
        };
    }
    /**
   * Get {@link StreamedSpanJSON} representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToStreamedSpanJSON(span)` instead.
   */ getStreamedSpanJSON() {
        return {
            name: this._name ?? "",
            span_id: this._spanId,
            trace_id: this._traceId,
            parent_span_id: this._parentSpanId,
            start_timestamp: this._startTime,
            // just in case _endTime is not set, we use the start time (i.e. duration 0)
            end_timestamp: this._endTime ?? this._startTime,
            is_segment: this._isStandaloneSpan || this === $2dG64.getRootSpan(this),
            status: $2dG64.getSimpleStatusMessage(this._status),
            attributes: this._attributes,
            links: $2dG64.getStreamedSpanLinks(this._links)
        };
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * @inheritdoc
   */ addEvent(name, attributesOrStartTime, startTime) {
        $jCjMv.DEBUG_BUILD && $jix5p.debug.log("[Tracing] Adding an event to span:", name);
        const time$1 = $38068b78f2e6a171$var$isSpanTimeInput(attributesOrStartTime) ? attributesOrStartTime : startTime || $7q4WK.timestampInSeconds();
        const attributes = $38068b78f2e6a171$var$isSpanTimeInput(attributesOrStartTime) ? {} : attributesOrStartTime || {};
        const event = {
            name: name,
            time: $2dG64.spanTimeInputToSeconds(time$1),
            attributes: attributes
        };
        this._events.push(event);
        return this;
    }
    /**
   * This method should generally not be used,
   * but for now we need a way to publicly check if the `_isStandaloneSpan` flag is set.
   * USE THIS WITH CAUTION!
   * @internal
   * @hidden
   * @experimental
   */ isStandaloneSpan() {
        return !!this._isStandaloneSpan;
    }
    /** Emit `spanEnd` when the span is ended. */ _onSpanEnded() {
        const client = $gjJ9A.getClient();
        if (client) {
            client.emit("spanEnd", this);
            if (!this._isStandaloneSpan) client.emit("afterSpanEnd", this);
        }
        const isSegmentSpan = this._isStandaloneSpan || this === $2dG64.getRootSpan(this);
        if (!isSegmentSpan) return;
        if (this._isStandaloneSpan) {
            if (this._sampled) $38068b78f2e6a171$var$sendSpanEnvelope($bOthn.createSpanEnvelope([
                this
            ], client));
            else {
                $jCjMv.DEBUG_BUILD && $jix5p.debug.log("[Tracing] Discarding standalone span because its trace was not chosen to be sampled.");
                if (client) client.recordDroppedEvent("sample_rate", "span");
            }
            return;
        } else if (client && $lIOsi.hasSpanStreamingEnabled(client)) {
            client.emit("afterSegmentSpanEnd", this);
            return;
        }
        const transactionEvent = this._convertSpanToTransaction();
        if (transactionEvent) {
            const scope = $iUxao.getCapturedScopesOnSpan(this).scope || $gjJ9A.getCurrentScope();
            scope.captureEvent(transactionEvent);
        }
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _convertSpanToTransaction() {
        if (!$38068b78f2e6a171$var$isFullFinishedSpan($2dG64.spanToJSON(this))) return void 0;
        if (!this._name) {
            $jCjMv.DEBUG_BUILD && $jix5p.debug.warn("Transaction has no name, falling back to `<unlabeled transaction>`.");
            this._name = "<unlabeled transaction>";
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = $iUxao.getCapturedScopesOnSpan(this);
        const normalizedRequest = capturedSpanScope?.getScopeData().sdkProcessingMetadata?.normalizedRequest;
        if (this._sampled !== true) return void 0;
        const finishedSpans = $2dG64.getSpanDescendants(this).filter((span)=>span !== this && !$38068b78f2e6a171$var$isStandaloneSpan(span));
        const spans = finishedSpans.map((span)=>$2dG64.spanToJSON(span)).filter($38068b78f2e6a171$var$isFullFinishedSpan);
        const source = this._attributes[$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
        delete this._attributes[$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME];
        let hasGenAiSpans = false;
        spans.forEach((span)=>{
            delete span.data[$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME];
            if (span.op?.startsWith("gen_ai.")) hasGenAiSpans = true;
        });
        const transaction = {
            contexts: {
                trace: $2dG64.spanToTransactionTraceContext(this)
            },
            spans: // spans.sort() mutates the array, but `spans` is already a copy so we can safely do this here
            // we do not use spans anymore after this point
            spans.length > $38068b78f2e6a171$var$MAX_SPAN_COUNT ? spans.sort((a, b)=>a.start_timestamp - b.start_timestamp).slice(0, $38068b78f2e6a171$var$MAX_SPAN_COUNT) : spans,
            start_timestamp: this._startTime,
            timestamp: this._endTime,
            transaction: this._name,
            type: "transaction",
            sdkProcessingMetadata: {
                capturedSpanScope: capturedSpanScope,
                capturedSpanIsolationScope: capturedSpanIsolationScope,
                dynamicSamplingContext: $dkd4c.getDynamicSamplingContextFromSpan(this),
                hasGenAiSpans: hasGenAiSpans
            },
            request: normalizedRequest,
            ...source && {
                transaction_info: {
                    source: source
                }
            }
        };
        const measurements = $in1Kg.timedEventsToMeasurements(this._events);
        const hasMeasurements = measurements && Object.keys(measurements).length;
        if (hasMeasurements) {
            $jCjMv.DEBUG_BUILD && $jix5p.debug.log("[Measurements] Adding measurements to transaction event", JSON.stringify(measurements, void 0, 2));
            transaction.measurements = measurements;
        }
        return transaction;
    }
}
function $38068b78f2e6a171$var$isSpanTimeInput(value) {
    return value && typeof value === "number" || value instanceof Date || Array.isArray(value);
}
function $38068b78f2e6a171$var$isFullFinishedSpan(input) {
    return !!input.start_timestamp && !!input.timestamp && !!input.span_id && !!input.trace_id;
}
function $38068b78f2e6a171$var$isStandaloneSpan(span) {
    return span instanceof $38068b78f2e6a171$var$SentrySpan && span.isStandaloneSpan();
}
function $38068b78f2e6a171$var$sendSpanEnvelope(envelope) {
    const client = $gjJ9A.getClient();
    if (!client) return;
    const spanItems = envelope[1];
    if (!spanItems || spanItems.length === 0) {
        client.recordDroppedEvent("before_send", "span");
        return;
    }
    client.sendEnvelope(envelope);
}
module.exports.SentrySpan = $38068b78f2e6a171$var$SentrySpan;

});
parcelRegister("bOthn", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $dkd4c = parcelRequire("dkd4c");

var $lPd4g = parcelRequire("lPd4g");

var $jypZc = parcelRequire("jypZc");

var $5fqIb = parcelRequire("5fqIb");

var $dbEaR = parcelRequire("dbEaR");

var $2dG64 = parcelRequire("2dG64");
function $899b13783c6a9be1$var$_enhanceEventWithSdkInfo(event, newSdkInfo) {
    if (!newSdkInfo) return event;
    const eventSdkInfo = event.sdk || {};
    event.sdk = {
        ...eventSdkInfo,
        name: eventSdkInfo.name || newSdkInfo.name,
        version: eventSdkInfo.version || newSdkInfo.version,
        integrations: [
            ...event.sdk?.integrations || [],
            ...newSdkInfo.integrations || []
        ],
        packages: [
            ...event.sdk?.packages || [],
            ...newSdkInfo.packages || []
        ],
        settings: event.sdk?.settings || newSdkInfo.settings ? {
            ...event.sdk?.settings,
            ...newSdkInfo.settings
        } : void 0
    };
    return event;
}
function $899b13783c6a9be1$var$createSessionEnvelope(session, dsn$1, metadata, tunnel) {
    const sdkInfo = $5fqIb.getSdkMetadataForEnvelopeHeader(metadata);
    const envelopeHeaders = {
        sent_at: /* @__PURE__ */ new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn$1 && {
            dsn: $jypZc.dsnToString(dsn$1)
        }
    };
    const envelopeItem = "aggregates" in session ? [
        {
            type: "sessions"
        },
        session
    ] : [
        {
            type: "session"
        },
        session.toJSON()
    ];
    return $5fqIb.createEnvelope(envelopeHeaders, [
        envelopeItem
    ]);
}
function $899b13783c6a9be1$var$createEventEnvelope(event, dsn, metadata, tunnel) {
    const sdkInfo = $5fqIb.getSdkMetadataForEnvelopeHeader(metadata);
    const eventType = event.type && event.type !== "replay_event" ? event.type : "event";
    $899b13783c6a9be1$var$_enhanceEventWithSdkInfo(event, metadata?.sdk);
    const envelopeHeaders = $5fqIb.createEventEnvelopeHeaders(event, sdkInfo, tunnel, dsn);
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return $5fqIb.createEnvelope(envelopeHeaders, [
        eventItem
    ]);
}
function $899b13783c6a9be1$var$createSpanEnvelope(spans, client) {
    function dscHasRequiredProps(dsc2) {
        return !!dsc2.trace_id && !!dsc2.public_key;
    }
    const dsc = $dkd4c.getDynamicSamplingContextFromSpan(spans[0]);
    const dsn$1 = client?.getDsn();
    const tunnel = client?.getOptions().tunnel;
    const headers = {
        sent_at: /* @__PURE__ */ new Date().toISOString(),
        ...dscHasRequiredProps(dsc) && {
            trace: dsc
        },
        ...!!tunnel && dsn$1 && {
            dsn: $jypZc.dsnToString(dsn$1)
        }
    };
    const { beforeSendSpan: beforeSendSpan$1, ignoreSpans: ignoreSpans } = client?.getOptions() || {};
    const filteredSpans = ignoreSpans?.length ? spans.filter((span)=>{
        const json = $2dG64.spanToJSON(span);
        return !$dbEaR.shouldIgnoreSpan({
            description: json.description,
            op: json.op,
            attributes: json.data
        }, ignoreSpans);
    }) : spans;
    const droppedSpans = spans.length - filteredSpans.length;
    if (droppedSpans) client?.recordDroppedEvent("before_send", "span", droppedSpans);
    const convertToSpanJSON = beforeSendSpan$1 ? (span)=>{
        const spanJson = $2dG64.spanToJSON(span);
        const processedSpan = !$lPd4g.isStreamedBeforeSendSpanCallback(beforeSendSpan$1) ? beforeSendSpan$1(spanJson) : spanJson;
        if (!processedSpan) {
            $2dG64.showSpanDropWarning();
            return spanJson;
        }
        return processedSpan;
    } : $2dG64.spanToJSON;
    const items = [];
    for (const span of filteredSpans){
        const spanJson = convertToSpanJSON(span);
        if (spanJson) items.push($5fqIb.createSpanEnvelopeItem(spanJson));
    }
    return $5fqIb.createEnvelope(headers, items);
}
module.exports._enhanceEventWithSdkInfo = $899b13783c6a9be1$var$_enhanceEventWithSdkInfo;
module.exports.createEventEnvelope = $899b13783c6a9be1$var$createEventEnvelope;
module.exports.createSessionEnvelope = $899b13783c6a9be1$var$createSessionEnvelope;
module.exports.createSpanEnvelope = $899b13783c6a9be1$var$createSpanEnvelope;

});
parcelRegister("lPd4g", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $2SQtm = parcelRequire("2SQtm");
function $fe387f61c94c1888$var$withStreamedSpan(callback) {
    $2SQtm.addNonEnumerableProperty(callback, "_streamed", true);
    return callback;
}
function $fe387f61c94c1888$var$isStreamedBeforeSendSpanCallback(callback) {
    return !!callback && typeof callback === "function" && "_streamed" in callback && !!callback._streamed;
}
module.exports.isStreamedBeforeSendSpanCallback = $fe387f61c94c1888$var$isStreamedBeforeSendSpanCallback;
module.exports.withStreamedSpan = $fe387f61c94c1888$var$withStreamedSpan;

});

parcelRegister("5fqIb", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hbMFZ = parcelRequire("hbMFZ");

var $jypZc = parcelRequire("jypZc");

var $bg87c = parcelRequire("bg87c");

var $hsCGK = parcelRequire("hsCGK");
function $3d2312d3c932a47a$var$createEnvelope(headers, items = []) {
    return [
        headers,
        items
    ];
}
function $3d2312d3c932a47a$var$addItemToEnvelope(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
function $3d2312d3c932a47a$var$forEachEnvelopeItem(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
function $3d2312d3c932a47a$var$envelopeContainsItemType(envelope, types) {
    return $3d2312d3c932a47a$var$forEachEnvelopeItem(envelope, (_, type)=>types.includes(type));
}
function $3d2312d3c932a47a$var$encodeUTF8(input) {
    const carrier$1 = $hbMFZ.getSentryCarrier($hsCGK.GLOBAL_OBJ);
    return carrier$1.encodePolyfill ? carrier$1.encodePolyfill(input) : new TextEncoder().encode(input);
}
function $3d2312d3c932a47a$var$decodeUTF8(input) {
    const carrier$1 = $hbMFZ.getSentryCarrier($hsCGK.GLOBAL_OBJ);
    return carrier$1.decodePolyfill ? carrier$1.decodePolyfill(input) : new TextDecoder().decode(input);
}
function $3d2312d3c932a47a$var$serializeEnvelope(envelope) {
    const [envHeaders, items] = envelope;
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === "string") parts = typeof next === "string" ? parts + next : [
            $3d2312d3c932a47a$var$encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === "string" ? $3d2312d3c932a47a$var$encodeUTF8(next) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`
${JSON.stringify(itemHeaders)}
`);
        if (typeof payload === "string" || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch  {
                stringifiedPayload = JSON.stringify($bg87c.normalize(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === "string" ? parts : $3d2312d3c932a47a$var$concatBuffers(parts);
}
function $3d2312d3c932a47a$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
function $3d2312d3c932a47a$var$parseEnvelope(env) {
    let buffer = typeof env === "string" ? $3d2312d3c932a47a$var$encodeUTF8(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(10);
        if (i < 0) i = buffer.length;
        return JSON.parse($3d2312d3c932a47a$var$decodeUTF8(readBinary(i)));
    }
    const envelopeHeader = readJson();
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === "number" ? itemHeader.length : void 0;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
function $3d2312d3c932a47a$var$createSpanEnvelopeItem(spanJson) {
    const spanHeaders = {
        type: "span"
    };
    return [
        spanHeaders,
        spanJson
    ];
}
function $3d2312d3c932a47a$var$createAttachmentEnvelopeItem(attachment) {
    const buffer = typeof attachment.data === "string" ? $3d2312d3c932a47a$var$encodeUTF8(attachment.data) : attachment.data;
    return [
        {
            type: "attachment",
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        },
        buffer
    ];
}
const $3d2312d3c932a47a$var$DATA_CATEGORY_OVERRIDES = {
    sessions: "session",
    event: "error",
    client_report: "internal",
    user_report: "default",
    profile_chunk: "profile",
    replay_event: "replay",
    replay_recording: "replay",
    check_in: "monitor",
    raw_security: "security",
    log: "log_item",
    trace_metric: "metric"
};
function $3d2312d3c932a47a$var$_isOverriddenType(type) {
    return type in $3d2312d3c932a47a$var$DATA_CATEGORY_OVERRIDES;
}
function $3d2312d3c932a47a$var$envelopeItemTypeToDataCategory(type) {
    return $3d2312d3c932a47a$var$_isOverriddenType(type) ? $3d2312d3c932a47a$var$DATA_CATEGORY_OVERRIDES[type] : type;
}
function $3d2312d3c932a47a$var$getSdkMetadataForEnvelopeHeader(metadataOrEvent) {
    if (!metadataOrEvent?.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
function $3d2312d3c932a47a$var$createEventEnvelopeHeaders(event, sdkInfo, tunnel, dsn$1) {
    const dynamicSamplingContext = event.sdkProcessingMetadata?.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: /* @__PURE__ */ new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn$1 && {
            dsn: $jypZc.dsnToString(dsn$1)
        },
        ...dynamicSamplingContext && {
            trace: dynamicSamplingContext
        }
    };
}
module.exports.addItemToEnvelope = $3d2312d3c932a47a$var$addItemToEnvelope;
module.exports.createAttachmentEnvelopeItem = $3d2312d3c932a47a$var$createAttachmentEnvelopeItem;
module.exports.createEnvelope = $3d2312d3c932a47a$var$createEnvelope;
module.exports.createEventEnvelopeHeaders = $3d2312d3c932a47a$var$createEventEnvelopeHeaders;
module.exports.createSpanEnvelopeItem = $3d2312d3c932a47a$var$createSpanEnvelopeItem;
module.exports.envelopeContainsItemType = $3d2312d3c932a47a$var$envelopeContainsItemType;
module.exports.envelopeItemTypeToDataCategory = $3d2312d3c932a47a$var$envelopeItemTypeToDataCategory;
module.exports.forEachEnvelopeItem = $3d2312d3c932a47a$var$forEachEnvelopeItem;
module.exports.getSdkMetadataForEnvelopeHeader = $3d2312d3c932a47a$var$getSdkMetadataForEnvelopeHeader;
module.exports.parseEnvelope = $3d2312d3c932a47a$var$parseEnvelope;
module.exports.serializeEnvelope = $3d2312d3c932a47a$var$serializeEnvelope;

});


parcelRegister("5puYc", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $jCjMv = parcelRequire("jCjMv");

var $jix5p = parcelRequire("jix5p");

var $2dG64 = parcelRequire("2dG64");
function $3f074f8f1b8db8d9$var$logSpanStart(span) {
    if (!$jCjMv.DEBUG_BUILD) return;
    const { description: description = "< unknown name >", op: op = "< unknown op >", parent_span_id: parentSpanId } = $2dG64.spanToJSON(span);
    const { spanId: spanId } = span.spanContext();
    const sampled = $2dG64.spanIsSampled(span);
    const rootSpan = $2dG64.getRootSpan(span);
    const isRootSpan = rootSpan === span;
    const header = `[Tracing] Starting ${sampled ? "sampled" : "unsampled"} ${isRootSpan ? "root " : ""}span`;
    const infoParts = [
        `op: ${op}`,
        `name: ${description}`,
        `ID: ${spanId}`
    ];
    if (parentSpanId) infoParts.push(`parent ID: ${parentSpanId}`);
    if (!isRootSpan) {
        const { op: op2, description: description2 } = $2dG64.spanToJSON(rootSpan);
        infoParts.push(`root ID: ${rootSpan.spanContext().spanId}`);
        if (op2) infoParts.push(`root op: ${op2}`);
        if (description2) infoParts.push(`root description: ${description2}`);
    }
    $jix5p.debug.log(`${header}
  ${infoParts.join("\n  ")}`);
}
function $3f074f8f1b8db8d9$var$logSpanEnd(span) {
    if (!$jCjMv.DEBUG_BUILD) return;
    const { description: description = "< unknown name >", op: op = "< unknown op >" } = $2dG64.spanToJSON(span);
    const { spanId: spanId } = span.spanContext();
    const rootSpan = $2dG64.getRootSpan(span);
    const isRootSpan = rootSpan === span;
    const msg = `[Tracing] Finishing "${op}" ${isRootSpan ? "root " : ""}span "${description}" with ID ${spanId}`;
    $jix5p.debug.log(msg);
}
module.exports.logSpanEnd = $3f074f8f1b8db8d9$var$logSpanEnd;
module.exports.logSpanStart = $3f074f8f1b8db8d9$var$logSpanStart;

});

parcelRegister("in1Kg", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $jCjMv = parcelRequire("jCjMv");

var $3dwiN = parcelRequire("3dwiN");

var $jix5p = parcelRequire("jix5p");

var $2dG64 = parcelRequire("2dG64");
function $d5fbba853c2ebaa0$var$setMeasurement(name, value, unit, activeSpan = $2dG64.getActiveSpan()) {
    const rootSpan = activeSpan && $2dG64.getRootSpan(activeSpan);
    if (rootSpan) {
        $jCjMv.DEBUG_BUILD && $jix5p.debug.log(`[Measurement] Setting measurement on root span: ${name} = ${value} ${unit}`);
        rootSpan.addEvent(name, {
            [$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE]: value,
            [$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT]: unit
        });
    }
}
function $d5fbba853c2ebaa0$var$timedEventsToMeasurements(events) {
    if (!events || events.length === 0) return void 0;
    const measurements = {};
    events.forEach((event)=>{
        const attributes = event.attributes || {};
        const unit = attributes[$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT];
        const value = attributes[$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE];
        if (typeof unit === "string" && typeof value === "number") measurements[event.name] = {
            value: value,
            unit: unit
        };
    });
    return measurements;
}
module.exports.setMeasurement = $d5fbba853c2ebaa0$var$setMeasurement;
module.exports.timedEventsToMeasurements = $d5fbba853c2ebaa0$var$timedEventsToMeasurements;

});

parcelRegister("lIOsi", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $fd04d866779fcd92$var$hasSpanStreamingEnabled(client) {
    return client.getOptions().traceLifecycle === "stream";
}
module.exports.hasSpanStreamingEnabled = $fd04d866779fcd92$var$hasSpanStreamingEnabled;

});


parcelRegister("4Ae9I", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $Up7k9 = parcelRequire("Up7k9");

var $hbMFZ = parcelRequire("hbMFZ");

var $gjJ9A = parcelRequire("gjJ9A");

var $jCjMv = parcelRequire("jCjMv");

var $3dwiN = parcelRequire("3dwiN");

var $enaoN = parcelRequire("enaoN");

var $jix5p = parcelRequire("jix5p");

var $8qJ6j = parcelRequire("8qJ6j");

var $hbAIy = parcelRequire("hbAIy");

var $dbEaR = parcelRequire("dbEaR");

var $lIOsi = parcelRequire("lIOsi");

var $d2351 = parcelRequire("d2351");

var $bSNF3 = parcelRequire("bSNF3");

var $9xAUk = parcelRequire("9xAUk");

var $k7IIJ = parcelRequire("k7IIJ");

var $2dG64 = parcelRequire("2dG64");

var $hiiHh = parcelRequire("hiiHh");

var $dkd4c = parcelRequire("dkd4c");

var $5puYc = parcelRequire("5puYc");

var $gwwm3 = parcelRequire("gwwm3");

var $lJzTh = parcelRequire("lJzTh");

var $4OdOk = parcelRequire("4OdOk");

var $9X7hl = parcelRequire("9X7hl");

var $iUxao = parcelRequire("iUxao");
const $356581433bd279f8$var$SUPPRESS_TRACING_KEY = "__SENTRY_SUPPRESS_TRACING__";
function $356581433bd279f8$var$startSpan(options, callback) {
    const acs = $356581433bd279f8$var$getAcs();
    if (acs.startSpan) return acs.startSpan(options, callback);
    const spanArguments = $356581433bd279f8$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    const customForkedScope = customScope?.clone();
    return $gjJ9A.withScope(customForkedScope, ()=>{
        const wrapper = $356581433bd279f8$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = $gjJ9A.getCurrentScope();
            const parentSpan = $356581433bd279f8$var$getParentSpan(scope, customParentSpan);
            const client = $gjJ9A.getClient();
            const missingRequiredParent = options.onlyIfParent && !parentSpan;
            const activeSpan = missingRequiredParent ? new $lJzTh.SentryNonRecordingSpan() : $356581433bd279f8$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            if (missingRequiredParent) client?.recordDroppedEvent("no_parent_span", "span");
            if (!$356581433bd279f8$var$_isIgnoredSpan(activeSpan) || !parentSpan) $k7IIJ._setSpanForScope(scope, activeSpan);
            return $8qJ6j.handleCallbackErrors(()=>callback(activeSpan), ()=>{
                const { status: status } = $2dG64.spanToJSON(activeSpan);
                if (activeSpan.isRecording() && (!status || status === "ok")) activeSpan.setStatus({
                    code: $9X7hl.SPAN_STATUS_ERROR,
                    message: "internal_error"
                });
            }, ()=>{
                activeSpan.end();
            });
        });
    });
}
function $356581433bd279f8$var$startSpanManual(options, callback) {
    const acs = $356581433bd279f8$var$getAcs();
    if (acs.startSpanManual) return acs.startSpanManual(options, callback);
    const spanArguments = $356581433bd279f8$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    const customForkedScope = customScope?.clone();
    return $gjJ9A.withScope(customForkedScope, ()=>{
        const wrapper = $356581433bd279f8$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = $gjJ9A.getCurrentScope();
            const parentSpan = $356581433bd279f8$var$getParentSpan(scope, customParentSpan);
            const missingRequiredParent = options.onlyIfParent && !parentSpan;
            const activeSpan = missingRequiredParent ? new $lJzTh.SentryNonRecordingSpan() : $356581433bd279f8$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            if (missingRequiredParent) $gjJ9A.getClient()?.recordDroppedEvent("no_parent_span", "span");
            if (!$356581433bd279f8$var$_isIgnoredSpan(activeSpan) || !parentSpan) $k7IIJ._setSpanForScope(scope, activeSpan);
            return $8qJ6j.handleCallbackErrors(// We pass the `finish` function to the callback, so the user can finish the span manually
            // this is mainly here for historic purposes because previously, we instructed users to call
            // `finish` instead of `span.end()` to also clean up the scope. Nowadays, calling `span.end()`
            // or `finish` has the same effect and we simply leave it here to avoid breaking user code.
            ()=>callback(activeSpan, ()=>activeSpan.end()), ()=>{
                const { status: status } = $2dG64.spanToJSON(activeSpan);
                if (activeSpan.isRecording() && (!status || status === "ok")) activeSpan.setStatus({
                    code: $9X7hl.SPAN_STATUS_ERROR,
                    message: "internal_error"
                });
            });
        });
    });
}
function $356581433bd279f8$var$startInactiveSpan(options) {
    const acs = $356581433bd279f8$var$getAcs();
    if (acs.startInactiveSpan) return acs.startInactiveSpan(options);
    const spanArguments = $356581433bd279f8$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan } = options;
    const wrapper = options.scope ? (callback)=>$gjJ9A.withScope(options.scope, callback) : customParentSpan !== void 0 ? (callback)=>$356581433bd279f8$var$withActiveSpan(customParentSpan, callback) : (callback)=>callback();
    return wrapper(()=>{
        const scope = $gjJ9A.getCurrentScope();
        const parentSpan = $356581433bd279f8$var$getParentSpan(scope, customParentSpan);
        const client = $gjJ9A.getClient();
        const missingRequiredParent = options.onlyIfParent && !parentSpan;
        if (missingRequiredParent) {
            client?.recordDroppedEvent("no_parent_span", "span");
            return new $lJzTh.SentryNonRecordingSpan();
        }
        return $356581433bd279f8$var$createChildOrRootSpan({
            parentSpan: parentSpan,
            spanArguments: spanArguments,
            forceTransaction: forceTransaction,
            scope: scope
        });
    });
}
const $356581433bd279f8$var$continueTrace = (options, callback)=>{
    const carrier$1 = $hbMFZ.getMainCarrier();
    const acs = $Up7k9.getAsyncContextStrategy(carrier$1);
    if (acs.continueTrace) return acs.continueTrace(options, callback);
    const { sentryTrace: sentryTrace, baggage: baggage$1 } = options;
    const client = $gjJ9A.getClient();
    const incomingDsc = $enaoN.baggageHeaderToDynamicSamplingContext(baggage$1);
    if (client && !$hiiHh.shouldContinueTrace(client, incomingDsc?.org_id)) return $356581433bd279f8$var$startNewTrace(callback);
    return $gjJ9A.withScope((scope)=>{
        const propagationContext = $hiiHh.propagationContextFromHeaders(sentryTrace, baggage$1);
        scope.setPropagationContext(propagationContext);
        $k7IIJ._setSpanForScope(scope, void 0);
        return callback();
    });
};
function $356581433bd279f8$var$withActiveSpan(span, callback) {
    const acs = $356581433bd279f8$var$getAcs();
    if (acs.withActiveSpan) return acs.withActiveSpan(span, callback);
    return $gjJ9A.withScope((scope)=>{
        $k7IIJ._setSpanForScope(scope, span || void 0);
        return callback(scope);
    });
}
function $356581433bd279f8$var$suppressTracing(callback) {
    const acs = $356581433bd279f8$var$getAcs();
    if (acs.suppressTracing) return acs.suppressTracing(callback);
    return $gjJ9A.withScope((scope)=>{
        scope.setSDKProcessingMetadata({
            [$356581433bd279f8$var$SUPPRESS_TRACING_KEY]: true
        });
        const res = callback();
        scope.setSDKProcessingMetadata({
            [$356581433bd279f8$var$SUPPRESS_TRACING_KEY]: void 0
        });
        return res;
    });
}
function $356581433bd279f8$var$startNewTrace(callback) {
    const acs = $356581433bd279f8$var$getAcs();
    if (acs.startNewTrace) return acs.startNewTrace(callback);
    return $gjJ9A.withScope((scope)=>{
        scope.setPropagationContext({
            traceId: $bSNF3.generateTraceId(),
            sampleRand: $9xAUk.safeMathRandom()
        });
        $jCjMv.DEBUG_BUILD && $jix5p.debug.log(`Starting a new trace with id ${scope.getPropagationContext().traceId}`);
        return $356581433bd279f8$var$withActiveSpan(null, callback);
    });
}
function $356581433bd279f8$var$createChildOrRootSpan({ parentSpan: parentSpan, spanArguments: spanArguments, forceTransaction: forceTransaction, scope: scope }) {
    if (!$hbAIy.hasSpansEnabled()) {
        const span2 = new $lJzTh.SentryNonRecordingSpan();
        if (forceTransaction || !parentSpan) {
            const dsc = {
                sampled: "false",
                sample_rate: "0",
                transaction: spanArguments.name,
                ...$dkd4c.getDynamicSamplingContextFromSpan(span2)
            };
            $dkd4c.freezeDscOnSpan(span2, dsc);
        }
        return span2;
    }
    const client = $gjJ9A.getClient();
    if ($356581433bd279f8$var$_shouldIgnoreStreamedSpan(client, spanArguments)) {
        if (!$356581433bd279f8$var$_isTracingSuppressed(scope)) client?.recordDroppedEvent("ignored", "span");
        return new $lJzTh.SentryNonRecordingSpan({
            dropReason: "ignored",
            traceId: parentSpan?.spanContext().traceId ?? scope.getPropagationContext().traceId
        });
    }
    const isolationScope = $gjJ9A.getIsolationScope();
    let span;
    if (parentSpan && !forceTransaction) {
        span = $356581433bd279f8$var$_startChildSpan(parentSpan, scope, spanArguments);
        $2dG64.addChildSpanToSpan(parentSpan, span);
    } else if (parentSpan) {
        const dsc = $dkd4c.getDynamicSamplingContextFromSpan(parentSpan);
        const { traceId: traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const parentSampled = $2dG64.spanIsSampled(parentSpan);
        span = $356581433bd279f8$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, parentSampled);
        $dkd4c.freezeDscOnSpan(span, dsc);
    } else {
        const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: parentSampled } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        span = $356581433bd279f8$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, parentSampled);
        if (dsc) $dkd4c.freezeDscOnSpan(span, dsc);
    }
    $5puYc.logSpanStart(span);
    $iUxao.setCapturedScopesOnSpan(span, scope, isolationScope);
    return span;
}
function $356581433bd279f8$var$parseSentrySpanArguments(options) {
    const exp = options.experimental || {};
    const initialCtx = {
        isStandalone: exp.standalone,
        ...options
    };
    if (options.startTime) {
        const ctx = {
            ...initialCtx
        };
        ctx.startTimestamp = $2dG64.spanTimeInputToSeconds(options.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return initialCtx;
}
function $356581433bd279f8$var$getAcs() {
    const carrier$1 = $hbMFZ.getMainCarrier();
    return $Up7k9.getAsyncContextStrategy(carrier$1);
}
function $356581433bd279f8$var$_startRootSpan(spanArguments, scope, parentSampled) {
    const client = $gjJ9A.getClient();
    const options = client?.getOptions() || {};
    const { name: name = "" } = spanArguments;
    const mutableSpanSamplingData = {
        spanAttributes: {
            ...spanArguments.attributes
        },
        spanName: name,
        parentSampled: parentSampled
    };
    client?.emit("beforeSampling", mutableSpanSamplingData, {
        decision: false
    });
    const finalParentSampled = mutableSpanSamplingData.parentSampled ?? parentSampled;
    const finalAttributes = mutableSpanSamplingData.spanAttributes;
    const currentPropagationContext = scope.getPropagationContext();
    const isTracingSuppressed = $356581433bd279f8$var$_isTracingSuppressed(scope);
    const [sampled, sampleRate, localSampleRateWasApplied] = isTracingSuppressed ? [
        false
    ] : $gwwm3.sampleSpan(options, {
        name: name,
        parentSampled: finalParentSampled,
        attributes: finalAttributes,
        parentSampleRate: $d2351.parseSampleRate(currentPropagationContext.dsc?.sample_rate)
    }, currentPropagationContext.sampleRand);
    const rootSpan = new $4OdOk.SentrySpan({
        ...spanArguments,
        attributes: {
            [$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: "custom",
            [$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE]: sampleRate !== void 0 && localSampleRateWasApplied ? sampleRate : void 0,
            ...finalAttributes
        },
        sampled: sampled
    });
    if (!sampled && client && !isTracingSuppressed) {
        $jCjMv.DEBUG_BUILD && $jix5p.debug.log("[Tracing] Discarding root span because its trace was not chosen to be sampled.");
        client.recordDroppedEvent("sample_rate", $lIOsi.hasSpanStreamingEnabled(client) ? "span" : "transaction");
    }
    if (client) client.emit("spanStart", rootSpan);
    return rootSpan;
}
function $356581433bd279f8$var$_startChildSpan(parentSpan, scope, spanArguments) {
    const { spanId: spanId, traceId: traceId } = parentSpan.spanContext();
    const isTracingSuppressed = $356581433bd279f8$var$_isTracingSuppressed(scope);
    const sampled = isTracingSuppressed ? false : $2dG64.spanIsSampled(parentSpan);
    const childSpan = sampled ? new $4OdOk.SentrySpan({
        ...spanArguments,
        parentSpanId: spanId,
        traceId: traceId,
        sampled: sampled
    }) : new $lJzTh.SentryNonRecordingSpan({
        traceId: traceId
    });
    $2dG64.addChildSpanToSpan(parentSpan, childSpan);
    const client = $gjJ9A.getClient();
    if (!client) return childSpan;
    if ($lIOsi.hasSpanStreamingEnabled(client) && childSpan instanceof $lJzTh.SentryNonRecordingSpan) {
        if (parentSpan instanceof $lJzTh.SentryNonRecordingSpan && parentSpan.dropReason) {
            childSpan.dropReason = parentSpan.dropReason;
            client.recordDroppedEvent(parentSpan.dropReason, "span");
        } else if (!isTracingSuppressed) {
            childSpan.dropReason = "sample_rate";
            client.recordDroppedEvent("sample_rate", "span");
        }
    }
    client.emit("spanStart", childSpan);
    if (spanArguments.endTimestamp) {
        client.emit("spanEnd", childSpan);
        client.emit("afterSpanEnd", childSpan);
    }
    return childSpan;
}
function $356581433bd279f8$var$getParentSpan(scope, customParentSpan) {
    if (customParentSpan) return customParentSpan;
    if (customParentSpan === null) return void 0;
    const span = $k7IIJ._getSpanForScope(scope);
    if (!span) return void 0;
    const client = $gjJ9A.getClient();
    const options = client ? client.getOptions() : {};
    if (options.parentSpanIsAlwaysRootSpan) return $2dG64.getRootSpan(span);
    return span;
}
function $356581433bd279f8$var$getActiveSpanWrapper(parentSpan) {
    return parentSpan !== void 0 ? (callback)=>{
        return $356581433bd279f8$var$withActiveSpan(parentSpan, callback);
    } : (callback)=>callback();
}
function $356581433bd279f8$var$_shouldIgnoreStreamedSpan(client, spanArguments) {
    const ignoreSpans = client?.getOptions().ignoreSpans;
    if (!client || !$lIOsi.hasSpanStreamingEnabled(client) || !ignoreSpans?.length) return false;
    return $dbEaR.shouldIgnoreSpan({
        description: spanArguments.name || "",
        op: spanArguments.attributes?.[$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_OP] || spanArguments.op,
        attributes: spanArguments.attributes
    }, ignoreSpans);
}
function $356581433bd279f8$var$_isIgnoredSpan(span) {
    return span instanceof $lJzTh.SentryNonRecordingSpan && span.dropReason === "ignored";
}
function $356581433bd279f8$var$_isTracingSuppressed(scope) {
    return scope.getScopeData().sdkProcessingMetadata[$356581433bd279f8$var$SUPPRESS_TRACING_KEY] === true;
}
module.exports.SUPPRESS_TRACING_KEY = $356581433bd279f8$var$SUPPRESS_TRACING_KEY;
module.exports.continueTrace = $356581433bd279f8$var$continueTrace;
module.exports.startInactiveSpan = $356581433bd279f8$var$startInactiveSpan;
module.exports.startNewTrace = $356581433bd279f8$var$startNewTrace;
module.exports.startSpan = $356581433bd279f8$var$startSpan;
module.exports.startSpanManual = $356581433bd279f8$var$startSpanManual;
module.exports.suppressTracing = $356581433bd279f8$var$suppressTracing;
module.exports.withActiveSpan = $356581433bd279f8$var$withActiveSpan;

});
parcelRegister("8qJ6j", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $grxWE = parcelRequire("grxWE");

var $fBPG6 = parcelRequire("fBPG6");
function $6233bc8abec322ea$var$handleCallbackErrors(fn, onError, onFinally = ()=>{}, onSuccess = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $6233bc8abec322ea$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally, onSuccess);
}
function $6233bc8abec322ea$var$maybeHandlePromiseRejection(value, onError, onFinally, onSuccess) {
    if ($fBPG6.isThenable(value)) return $grxWE.chainAndCopyPromiseLike(value, (result)=>{
        onFinally();
        onSuccess(result);
    }, (err)=>{
        onError(err);
        onFinally();
    });
    onFinally();
    onSuccess(value);
    return value;
}
module.exports.handleCallbackErrors = $6233bc8abec322ea$var$handleCallbackErrors;

});

parcelRegister("gwwm3", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $jCjMv = parcelRequire("jCjMv");

var $jix5p = parcelRequire("jix5p");

var $hbAIy = parcelRequire("hbAIy");

var $d2351 = parcelRequire("d2351");
function $c078bb7e7a9196f8$var$sampleSpan(options, samplingContext, sampleRand) {
    if (!$hbAIy.hasSpansEnabled(options)) return [
        false
    ];
    let localSampleRateWasApplied = void 0;
    let sampleRate;
    if (typeof options.tracesSampler === "function") {
        sampleRate = options.tracesSampler({
            ...samplingContext,
            inheritOrSampleWith: (fallbackSampleRate)=>{
                if (typeof samplingContext.parentSampleRate === "number") return samplingContext.parentSampleRate;
                if (typeof samplingContext.parentSampled === "boolean") return Number(samplingContext.parentSampled);
                return fallbackSampleRate;
            }
        });
        localSampleRateWasApplied = true;
    } else if (samplingContext.parentSampled !== void 0) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== "undefined") {
        sampleRate = options.tracesSampleRate;
        localSampleRateWasApplied = true;
    }
    const parsedSampleRate = $d2351.parseSampleRate(sampleRate);
    if (parsedSampleRate === void 0) {
        $jCjMv.DEBUG_BUILD && $jix5p.debug.warn(`[Tracing] Discarding root span because of invalid sample rate. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(sampleRate)} of type ${JSON.stringify(typeof sampleRate)}.`);
        return [
            false
        ];
    }
    if (!parsedSampleRate) {
        $jCjMv.DEBUG_BUILD && $jix5p.debug.log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === "function" ? "tracesSampler returned 0 or false" : "a negative sampling decision was inherited or tracesSampleRate is set to 0"}`);
        return [
            false,
            parsedSampleRate,
            localSampleRateWasApplied
        ];
    }
    const shouldSample = sampleRand < parsedSampleRate;
    if (!shouldSample) $jCjMv.DEBUG_BUILD && $jix5p.debug.log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
    return [
        shouldSample,
        parsedSampleRate,
        localSampleRateWasApplied
    ];
}
module.exports.sampleSpan = $c078bb7e7a9196f8$var$sampleSpan;

});



parcelRegister("1N6Mo", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3dwiN = parcelRequire("3dwiN");

var $3k7kU = parcelRequire("3k7kU");

var $kipJA = parcelRequire("kipJA");

var $2dG64 = parcelRequire("2dG64");

var $iUxao = parcelRequire("iUxao");

var $lPd4g = parcelRequire("lPd4g");

var $5pzKb = parcelRequire("5pzKb");
function $14dfa052ce64a7e0$var$captureSpan(span, client) {
    const spanJSON = $2dG64.spanToStreamedSpanJSON(span);
    const segmentSpan = $2dG64.INTERNAL_getSegmentSpan(span);
    const serializedSegmentSpan = $2dG64.spanToStreamedSpanJSON(segmentSpan);
    const { isolationScope: spanIsolationScope, scope: spanScope } = $iUxao.getCapturedScopesOnSpan(span);
    const finalScopeData = $3k7kU.getCombinedScopeData(spanIsolationScope, spanScope);
    $14dfa052ce64a7e0$var$applyCommonSpanAttributes(spanJSON, serializedSegmentSpan, client, finalScopeData);
    const spanKind = span.kind;
    $14dfa052ce64a7e0$var$inferSpanDataFromOtelAttributes(spanJSON, spanKind);
    if (spanJSON.is_segment) {
        $14dfa052ce64a7e0$var$applyScopeToSegmentSpan(spanJSON, finalScopeData);
        $14dfa052ce64a7e0$var$applySdkMetadataToSegmentSpan(spanJSON, client);
        client.emit("processSegmentSpan", spanJSON);
    }
    client.emit("processSpan", spanJSON);
    const { beforeSendSpan: beforeSendSpan$1 } = client.getOptions();
    const processedSpan = beforeSendSpan$1 && $lPd4g.isStreamedBeforeSendSpanCallback(beforeSendSpan$1) ? $14dfa052ce64a7e0$var$applyBeforeSendSpanCallback(spanJSON, beforeSendSpan$1) : spanJSON;
    const spanNameSource = processedSpan.attributes?.[$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    if (spanNameSource) $14dfa052ce64a7e0$var$safeSetSpanJSONAttributes(processedSpan, {
        // Purposefully not using a constant defined here like in other attributes:
        // This will be the name for SEMANTIC_ATTRIBUTE_SENTRY_SOURCE in v11
        "sentry.span.source": spanNameSource
    });
    return {
        ...$2dG64.streamedSpanJsonToSerializedSpan(processedSpan),
        _segmentSpan: segmentSpan
    };
}
function $14dfa052ce64a7e0$var$applyScopeToSegmentSpan(segmentSpanJSON, scopeData) {
    const contextAttributes = $5pzKb.scopeContextsToSpanAttributes(scopeData.contexts);
    $14dfa052ce64a7e0$var$safeSetSpanJSONAttributes(segmentSpanJSON, contextAttributes);
}
function $14dfa052ce64a7e0$var$safeSetSpanJSONAttributes(spanJSON, newAttributes) {
    const originalAttributes = spanJSON.attributes ?? (spanJSON.attributes = {});
    Object.entries(newAttributes).forEach(([key, value])=>{
        if (value != null && !(key in originalAttributes)) originalAttributes[key] = value;
    });
}
function $14dfa052ce64a7e0$var$applySdkMetadataToSegmentSpan(segmentSpanJSON, client) {
    const integrationNames = client.getIntegrationNames();
    if (!integrationNames.length) return;
    $14dfa052ce64a7e0$var$safeSetSpanJSONAttributes(segmentSpanJSON, {
        [$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS]: integrationNames
    });
}
function $14dfa052ce64a7e0$var$applyCommonSpanAttributes(spanJSON, serializedSegmentSpan, client, scopeData) {
    const sdk = client.getSdkMetadata();
    const { release: release, environment: environment } = client.getOptions();
    $14dfa052ce64a7e0$var$safeSetSpanJSONAttributes(spanJSON, {
        [$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_RELEASE]: release,
        [$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT]: environment,
        [$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME]: serializedSegmentSpan.name,
        [$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID]: serializedSegmentSpan.span_id,
        [$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME]: sdk?.sdk?.name,
        [$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION]: sdk?.sdk?.version,
        [$3dwiN.SEMANTIC_ATTRIBUTE_USER_ID]: scopeData.user?.id,
        [$3dwiN.SEMANTIC_ATTRIBUTE_USER_EMAIL]: scopeData.user?.email,
        [$3dwiN.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS]: scopeData.user?.ip_address,
        [$3dwiN.SEMANTIC_ATTRIBUTE_USER_USERNAME]: scopeData.user?.username,
        ...scopeData.attributes
    });
}
function $14dfa052ce64a7e0$var$applyBeforeSendSpanCallback(span, beforeSendSpan) {
    const modifedSpan = beforeSendSpan(span);
    if (!modifedSpan) {
        $2dG64.showSpanDropWarning();
        return span;
    }
    return modifedSpan;
}
const $14dfa052ce64a7e0$var$SPAN_KIND_SERVER = 1;
const $14dfa052ce64a7e0$var$SPAN_KIND_CLIENT = 2;
function $14dfa052ce64a7e0$var$inferSpanDataFromOtelAttributes(spanJSON, spanKind) {
    const attributes = spanJSON.attributes;
    if (!attributes) return;
    const httpMethod = attributes["http.request.method"] || attributes["http.method"];
    if (httpMethod) {
        $14dfa052ce64a7e0$var$inferHttpSpanData(spanJSON, attributes, spanKind, httpMethod);
        return;
    }
    const dbSystem = attributes["db.system.name"] || attributes["db.system"];
    const opIsCache = typeof attributes[$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_OP] === "string" && `${attributes[$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_OP]}`.startsWith("cache.");
    if (dbSystem && !opIsCache) {
        $14dfa052ce64a7e0$var$inferDbSpanData(spanJSON, attributes);
        return;
    }
    if (attributes["rpc.service"]) {
        $14dfa052ce64a7e0$var$safeSetSpanJSONAttributes(spanJSON, {
            [$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "rpc"
        });
        return;
    }
    if (attributes["messaging.system"]) {
        $14dfa052ce64a7e0$var$safeSetSpanJSONAttributes(spanJSON, {
            [$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "message"
        });
        return;
    }
    const faasTrigger = attributes["faas.trigger"];
    if (faasTrigger) $14dfa052ce64a7e0$var$safeSetSpanJSONAttributes(spanJSON, {
        [$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_OP]: `${faasTrigger}`
    });
}
function $14dfa052ce64a7e0$var$inferHttpSpanData(spanJSON, attributes, spanKind, httpMethod) {
    const opParts = [
        "http"
    ];
    if (spanKind === $14dfa052ce64a7e0$var$SPAN_KIND_CLIENT) opParts.push("client");
    else if (spanKind === $14dfa052ce64a7e0$var$SPAN_KIND_SERVER) opParts.push("server");
    if (attributes["sentry.http.prefetch"]) opParts.push("prefetch");
    $14dfa052ce64a7e0$var$safeSetSpanJSONAttributes(spanJSON, {
        [$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_OP]: opParts.join(".")
    });
    const customName = attributes[$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME];
    if (typeof customName === "string") {
        spanJSON.name = customName;
        return;
    }
    if (attributes[$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] === "custom") return;
    const httpRoute = attributes["http.route"];
    if (typeof httpRoute === "string") {
        spanJSON.name = `${httpMethod} ${httpRoute}`;
        $14dfa052ce64a7e0$var$safeSetSpanJSONAttributes(spanJSON, {
            [$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: "route"
        });
    } else {
        if (spanKind === $14dfa052ce64a7e0$var$SPAN_KIND_CLIENT || spanKind === $14dfa052ce64a7e0$var$SPAN_KIND_SERVER) {
            const urlPath = $14dfa052ce64a7e0$var$getUrlPath(attributes, spanKind);
            if (urlPath) spanJSON.name = `${httpMethod} ${urlPath}`;
        }
        $14dfa052ce64a7e0$var$safeSetSpanJSONAttributes(spanJSON, {
            [$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: "url"
        });
    }
}
function $14dfa052ce64a7e0$var$getUrlPath(attributes, spanKind) {
    const httpUrl = attributes["http.url"] || attributes["url.full"];
    const httpTarget = attributes["http.target"];
    const parsedUrl = typeof httpUrl === "string" ? $kipJA.parseUrl(httpUrl) : void 0;
    const sanitizedUrl = parsedUrl ? $kipJA.getSanitizedUrlString(parsedUrl) : void 0;
    if (spanKind === $14dfa052ce64a7e0$var$SPAN_KIND_SERVER && typeof httpTarget === "string") return $kipJA.stripUrlQueryAndFragment(httpTarget);
    if (sanitizedUrl) return sanitizedUrl;
    if (typeof httpTarget === "string") return $kipJA.stripUrlQueryAndFragment(httpTarget);
    return void 0;
}
function $14dfa052ce64a7e0$var$inferDbSpanData(spanJSON, attributes) {
    $14dfa052ce64a7e0$var$safeSetSpanJSONAttributes(spanJSON, {
        [$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "db"
    });
    const customName = attributes[$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME];
    if (typeof customName === "string") {
        spanJSON.name = customName;
        return;
    }
    if (attributes[$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] === "custom") return;
    const statement = attributes["db.statement"];
    if (statement) {
        spanJSON.name = `${statement}`;
        $14dfa052ce64a7e0$var$safeSetSpanJSONAttributes(spanJSON, {
            [$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: "task"
        });
    }
}
module.exports.applyBeforeSendSpanCallback = $14dfa052ce64a7e0$var$applyBeforeSendSpanCallback;
module.exports.captureSpan = $14dfa052ce64a7e0$var$captureSpan;
module.exports.inferSpanDataFromOtelAttributes = $14dfa052ce64a7e0$var$inferSpanDataFromOtelAttributes;
module.exports.safeSetSpanJSONAttributes = $14dfa052ce64a7e0$var$safeSetSpanJSONAttributes;

});
parcelRegister("3k7kU", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gjJ9A = parcelRequire("gjJ9A");

var $dkd4c = parcelRequire("dkd4c");

var $j4dmO = parcelRequire("j4dmO");

var $2dG64 = parcelRequire("2dG64");
function $26b8ee27e9e6e4b6$var$applyScopeDataToEvent(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    $26b8ee27e9e6e4b6$var$applyDataToEvent(event, data);
    if (span) $26b8ee27e9e6e4b6$var$applySpanToEvent(event, span);
    $26b8ee27e9e6e4b6$var$applyFingerprintToEvent(event, fingerprint);
    $26b8ee27e9e6e4b6$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $26b8ee27e9e6e4b6$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
function $26b8ee27e9e6e4b6$var$mergeScopeData(data, mergeData) {
    const { extra: extra, tags: tags, attributes: attributes, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: transactionName, span: span } = mergeData;
    $26b8ee27e9e6e4b6$var$mergeAndOverwriteScopeData(data, "extra", extra);
    $26b8ee27e9e6e4b6$var$mergeAndOverwriteScopeData(data, "tags", tags);
    $26b8ee27e9e6e4b6$var$mergeAndOverwriteScopeData(data, "attributes", attributes);
    $26b8ee27e9e6e4b6$var$mergeAndOverwriteScopeData(data, "user", user);
    $26b8ee27e9e6e4b6$var$mergeAndOverwriteScopeData(data, "contexts", contexts);
    data.sdkProcessingMetadata = $j4dmO.merge(data.sdkProcessingMetadata, sdkProcessingMetadata, 2);
    if (level) data.level = level;
    if (transactionName) data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
function $26b8ee27e9e6e4b6$var$mergeAndOverwriteScopeData(data, prop, mergeVal) {
    data[prop] = $j4dmO.merge(data[prop], mergeVal, 1);
}
function $26b8ee27e9e6e4b6$var$getCombinedScopeData(isolationScope, currentScope) {
    const scopeData = $gjJ9A.getGlobalScope().getScopeData();
    isolationScope && $26b8ee27e9e6e4b6$var$mergeScopeData(scopeData, isolationScope.getScopeData());
    currentScope && $26b8ee27e9e6e4b6$var$mergeScopeData(scopeData, currentScope.getScopeData());
    return scopeData;
}
function $26b8ee27e9e6e4b6$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: transactionName } = data;
    if (Object.keys(extra).length) event.extra = {
        ...extra,
        ...event.extra
    };
    if (Object.keys(tags).length) event.tags = {
        ...tags,
        ...event.tags
    };
    if (Object.keys(user).length) event.user = {
        ...user,
        ...event.user
    };
    if (Object.keys(contexts).length) event.contexts = {
        ...contexts,
        ...event.contexts
    };
    if (level) event.level = level;
    if (transactionName && event.type !== "transaction") event.transaction = transactionName;
}
function $26b8ee27e9e6e4b6$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : void 0;
}
function $26b8ee27e9e6e4b6$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $26b8ee27e9e6e4b6$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: $2dG64.spanToTraceContext(span),
        ...event.contexts
    };
    event.sdkProcessingMetadata = {
        dynamicSamplingContext: $dkd4c.getDynamicSamplingContextFromSpan(span),
        ...event.sdkProcessingMetadata
    };
    const rootSpan = $2dG64.getRootSpan(span);
    const transactionName = $2dG64.spanToJSON(rootSpan).description;
    if (transactionName && !event.transaction && event.type === "transaction") event.transaction = transactionName;
}
function $26b8ee27e9e6e4b6$var$applyFingerprintToEvent(event, fingerprint) {
    event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
        event.fingerprint
    ] : [];
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    if (!event.fingerprint.length) delete event.fingerprint;
}
module.exports.applyScopeDataToEvent = $26b8ee27e9e6e4b6$var$applyScopeDataToEvent;
module.exports.getCombinedScopeData = $26b8ee27e9e6e4b6$var$getCombinedScopeData;
module.exports.mergeAndOverwriteScopeData = $26b8ee27e9e6e4b6$var$mergeAndOverwriteScopeData;
module.exports.mergeScopeData = $26b8ee27e9e6e4b6$var$mergeScopeData;

});

parcelRegister("kipJA", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3dwiN = parcelRequire("3dwiN");
const $ec697361f5e44b54$var$DEFAULT_BASE_URL = "thismessage:/";
function $ec697361f5e44b54$var$isURLObjectRelative(url) {
    return "isRelative" in url;
}
function $ec697361f5e44b54$var$parseStringToURLObject(url, urlBase) {
    const isRelative = url.indexOf("://") <= 0 && url.indexOf("//") !== 0;
    const base = urlBase ?? (isRelative ? $ec697361f5e44b54$var$DEFAULT_BASE_URL : void 0);
    try {
        if ("canParse" in URL && !URL.canParse(url, base)) return void 0;
        const fullUrlObject = new URL(url, base);
        if (isRelative) return {
            isRelative: isRelative,
            pathname: fullUrlObject.pathname,
            search: fullUrlObject.search,
            hash: fullUrlObject.hash
        };
        return fullUrlObject;
    } catch  {}
    return void 0;
}
function $ec697361f5e44b54$var$getSanitizedUrlStringFromUrlObject(url) {
    if ($ec697361f5e44b54$var$isURLObjectRelative(url)) return url.pathname;
    const newUrl = new URL(url);
    newUrl.search = "";
    newUrl.hash = "";
    if ([
        "80",
        "443"
    ].includes(newUrl.port)) newUrl.port = "";
    if (newUrl.password) newUrl.password = "%filtered%";
    if (newUrl.username) newUrl.username = "%filtered%";
    return newUrl.toString();
}
function $ec697361f5e44b54$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName) {
    const method = request?.method?.toUpperCase() ?? "GET";
    const route = routeName ? routeName : urlObject ? kind === "client" ? $ec697361f5e44b54$var$getSanitizedUrlStringFromUrlObject(urlObject) : urlObject.pathname : "/";
    return `${method} ${route}`;
}
function $ec697361f5e44b54$var$getHttpSpanDetailsFromUrlObject(urlObject, kind, spanOrigin, request, routeName) {
    const attributes = {
        [$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: spanOrigin,
        [$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: "url"
    };
    if (routeName) {
        attributes[kind === "server" ? "http.route" : "url.template"] = routeName;
        attributes[$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = "route";
    }
    if (request?.method) attributes[$3dwiN.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD] = request.method.toUpperCase();
    if (urlObject) {
        if (urlObject.search) attributes["url.query"] = urlObject.search;
        if (urlObject.hash) attributes["url.fragment"] = urlObject.hash;
        if (urlObject.pathname) {
            attributes["url.path"] = urlObject.pathname;
            if (urlObject.pathname === "/") attributes[$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = "route";
        }
        if (!$ec697361f5e44b54$var$isURLObjectRelative(urlObject)) {
            attributes[$3dwiN.SEMANTIC_ATTRIBUTE_URL_FULL] = urlObject.href;
            if (urlObject.port) attributes["url.port"] = urlObject.port;
            if (urlObject.protocol) attributes["url.scheme"] = urlObject.protocol;
            if (urlObject.hostname) attributes[kind === "server" ? "server.address" : "url.domain"] = urlObject.hostname;
        }
    }
    return [
        $ec697361f5e44b54$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName),
        attributes
    ];
}
function $ec697361f5e44b54$var$parseUrl(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    const query = match[6] || "";
    const fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
function $ec697361f5e44b54$var$stripUrlQueryAndFragment(urlPath) {
    return urlPath.split(/[?#]/, 1)[0];
}
function $ec697361f5e44b54$var$getSanitizedUrlString(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host?.replace(/^.*@/, "[filtered]:[filtered]@").replace(/(:80)$/, "").replace(/(:443)$/, "") || "";
    return `${protocol ? `${protocol}://` : ""}${filteredHost}${path}`;
}
function $ec697361f5e44b54$var$stripDataUrlContent(url, includeDataPrefix = true) {
    if (url.startsWith("data:")) {
        const match = url.match(/^data:([^;,]+)/);
        const mimeType = match ? match[1] : "text/plain";
        const isBase64 = url.includes(";base64,");
        const dataStart = url.indexOf(",");
        let dataPrefix = "";
        if (includeDataPrefix && dataStart !== -1) {
            const data = url.slice(dataStart + 1);
            dataPrefix = data.length > 10 ? `${data.slice(0, 10)}... [truncated]` : data;
        }
        return `data:${mimeType}${isBase64 ? ",base64" : ""}${dataPrefix ? `,${dataPrefix}` : ""}`;
    }
    return url;
}
module.exports.getHttpSpanDetailsFromUrlObject = $ec697361f5e44b54$var$getHttpSpanDetailsFromUrlObject;
module.exports.getSanitizedUrlString = $ec697361f5e44b54$var$getSanitizedUrlString;
module.exports.getSanitizedUrlStringFromUrlObject = $ec697361f5e44b54$var$getSanitizedUrlStringFromUrlObject;
module.exports.isURLObjectRelative = $ec697361f5e44b54$var$isURLObjectRelative;
module.exports.parseStringToURLObject = $ec697361f5e44b54$var$parseStringToURLObject;
module.exports.parseUrl = $ec697361f5e44b54$var$parseUrl;
module.exports.stripDataUrlContent = $ec697361f5e44b54$var$stripDataUrlContent;
module.exports.stripUrlQueryAndFragment = $ec697361f5e44b54$var$stripUrlQueryAndFragment;

});

parcelRegister("5pzKb", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $3f0b0387ac024b0a$var$scopeContextsToSpanAttributes(contexts) {
    const attrs = {};
    const { response: response, profile: profile, cloud_resource: cloud_resource, culture: culture, state: state } = contexts;
    if (response) {
        if (response.status_code != null) attrs["http.response.status_code"] = response.status_code;
        if (response.body_size != null) attrs["http.response.body.size"] = response.body_size;
    }
    if (profile) {
        if (profile.profile_id) attrs["sentry.profile_id"] = profile.profile_id;
        if (profile.profiler_id) attrs["sentry.profiler_id"] = profile.profiler_id;
    }
    if (cloud_resource) {
        for (const [key, value] of Object.entries(cloud_resource))if (value != null) attrs[key] = value;
    }
    if (culture) {
        if (culture.locale) attrs["culture.locale"] = culture.locale;
        if (culture.timezone) attrs["culture.timezone"] = culture.timezone;
    }
    if (state?.state && typeof state.state.type === "string") attrs["state.type"] = state.state.type;
    const angular = contexts["angular"];
    if (angular) {
        const version = angular["version"];
        if (typeof version === "string" || typeof version === "number") attrs["angular.version"] = version;
    }
    const react = contexts["react"];
    if (react) {
        const version = react["version"];
        if (typeof version === "string" || typeof version === "number") attrs["react.version"] = version;
    }
    return attrs;
}
module.exports.scopeContextsToSpanAttributes = $3f0b0387ac024b0a$var$scopeContextsToSpanAttributes;

});


parcelRegister("8txOP", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gjJ9A = parcelRequire("gjJ9A");

var $jCjMv = parcelRequire("jCjMv");

var $jIJ38 = parcelRequire("jIJ38");

var $4Ae9I = parcelRequire("4Ae9I");

var $jix5p = parcelRequire("jix5p");

var $fBPG6 = parcelRequire("fBPG6");

var $k6pIc = parcelRequire("k6pIc");

var $crfCR = parcelRequire("crfCR");

var $3k7kU = parcelRequire("3k7kU");

var $7q4WK = parcelRequire("7q4WK");

var $hsCGK = parcelRequire("hsCGK");
function $62bb43e3d355db00$var$captureException(exception, hint) {
    return $gjJ9A.getCurrentScope().captureException(exception, $crfCR.parseEventHintOrCaptureContext(hint));
}
function $62bb43e3d355db00$var$captureMessage(message, captureContext) {
    const level = typeof captureContext === "string" ? captureContext : void 0;
    const hint = typeof captureContext !== "string" ? {
        captureContext: captureContext
    } : void 0;
    return $gjJ9A.getCurrentScope().captureMessage(message, level, hint);
}
function $62bb43e3d355db00$var$captureEvent(event, hint) {
    return $gjJ9A.getCurrentScope().captureEvent(event, hint);
}
function $62bb43e3d355db00$var$setContext(name, context) {
    $gjJ9A.getIsolationScope().setContext(name, context);
}
function $62bb43e3d355db00$var$setExtras(extras) {
    $gjJ9A.getIsolationScope().setExtras(extras);
}
function $62bb43e3d355db00$var$setExtra(key, extra) {
    $gjJ9A.getIsolationScope().setExtra(key, extra);
}
function $62bb43e3d355db00$var$setTags(tags) {
    $gjJ9A.getIsolationScope().setTags(tags);
}
function $62bb43e3d355db00$var$setTag(key, value) {
    $gjJ9A.getIsolationScope().setTag(key, value);
}
function $62bb43e3d355db00$var$setUser(user) {
    $gjJ9A.getIsolationScope().setUser(user);
}
function $62bb43e3d355db00$var$setConversationId(conversationId) {
    $gjJ9A.getIsolationScope().setConversationId(conversationId);
}
function $62bb43e3d355db00$var$lastEventId() {
    return $gjJ9A.getIsolationScope().lastEventId();
}
function $62bb43e3d355db00$var$captureCheckIn(checkIn, upsertMonitorConfig) {
    const scope = $gjJ9A.getCurrentScope();
    const client = $gjJ9A.getClient();
    if (!client) $jCjMv.DEBUG_BUILD && $jix5p.debug.warn("Cannot capture check-in. No client defined.");
    else if (!client.captureCheckIn) $jCjMv.DEBUG_BUILD && $jix5p.debug.warn("Cannot capture check-in. Client does not support sending check-ins.");
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return $k6pIc.uuid4();
}
function $62bb43e3d355db00$var$withMonitor(monitorSlug, callback, upsertMonitorConfig) {
    function runCallback() {
        const checkInId = $62bb43e3d355db00$var$captureCheckIn({
            monitorSlug: monitorSlug,
            status: "in_progress"
        }, upsertMonitorConfig);
        const now = $7q4WK.timestampInSeconds();
        function finishCheckIn(status) {
            $62bb43e3d355db00$var$captureCheckIn({
                monitorSlug: monitorSlug,
                status: status,
                checkInId: checkInId,
                duration: $7q4WK.timestampInSeconds() - now
            });
        }
        let maybePromiseResult;
        try {
            maybePromiseResult = callback();
        } catch (e) {
            finishCheckIn("error");
            throw e;
        }
        if ($fBPG6.isThenable(maybePromiseResult)) return maybePromiseResult.then((r)=>{
            finishCheckIn("ok");
            return r;
        }, (e)=>{
            finishCheckIn("error");
            throw e;
        });
        finishCheckIn("ok");
        return maybePromiseResult;
    }
    return $gjJ9A.withIsolationScope(()=>upsertMonitorConfig?.isolateTrace ? $4Ae9I.startNewTrace(runCallback) : runCallback());
}
async function $62bb43e3d355db00$var$flush(timeout) {
    const client = $gjJ9A.getClient();
    if (client) return client.flush(timeout);
    $jCjMv.DEBUG_BUILD && $jix5p.debug.warn("Cannot flush events. No client defined.");
    return Promise.resolve(false);
}
async function $62bb43e3d355db00$var$close(timeout) {
    const client = $gjJ9A.getClient();
    if (client) return client.close(timeout);
    $jCjMv.DEBUG_BUILD && $jix5p.debug.warn("Cannot flush events and disable SDK. No client defined.");
    return Promise.resolve(false);
}
function $62bb43e3d355db00$var$isInitialized() {
    return !!$gjJ9A.getClient();
}
function $62bb43e3d355db00$var$isEnabled() {
    const client = $gjJ9A.getClient();
    return client?.getOptions().enabled !== false && !!client?.getTransport();
}
function $62bb43e3d355db00$var$addEventProcessor(callback) {
    $gjJ9A.getIsolationScope().addEventProcessor(callback);
}
function $62bb43e3d355db00$var$startSession(context) {
    const isolationScope = $gjJ9A.getIsolationScope();
    const { user: user } = $3k7kU.getCombinedScopeData(isolationScope, $gjJ9A.getCurrentScope());
    const { userAgent: userAgent } = $hsCGK.GLOBAL_OBJ.navigator || {};
    const session$1 = $jIJ38.makeSession({
        user: user,
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    const currentSession = isolationScope.getSession();
    if (currentSession?.status === "ok") $jIJ38.updateSession(currentSession, {
        status: "exited"
    });
    $62bb43e3d355db00$var$endSession();
    isolationScope.setSession(session$1);
    return session$1;
}
function $62bb43e3d355db00$var$endSession() {
    const isolationScope = $gjJ9A.getIsolationScope();
    const currentScope = $gjJ9A.getCurrentScope();
    const session$1 = currentScope.getSession() || isolationScope.getSession();
    if (session$1) $jIJ38.closeSession(session$1);
    $62bb43e3d355db00$var$_sendSessionUpdate();
    isolationScope.setSession();
}
function $62bb43e3d355db00$var$_sendSessionUpdate() {
    const isolationScope = $gjJ9A.getIsolationScope();
    const client = $gjJ9A.getClient();
    const session = isolationScope.getSession();
    if (session && client) client.captureSession(session);
}
function $62bb43e3d355db00$var$captureSession(end = false) {
    if (end) {
        $62bb43e3d355db00$var$endSession();
        return;
    }
    $62bb43e3d355db00$var$_sendSessionUpdate();
}
module.exports.addEventProcessor = $62bb43e3d355db00$var$addEventProcessor;
module.exports.captureCheckIn = $62bb43e3d355db00$var$captureCheckIn;
module.exports.captureEvent = $62bb43e3d355db00$var$captureEvent;
module.exports.captureException = $62bb43e3d355db00$var$captureException;
module.exports.captureMessage = $62bb43e3d355db00$var$captureMessage;
module.exports.captureSession = $62bb43e3d355db00$var$captureSession;
module.exports.close = $62bb43e3d355db00$var$close;
module.exports.endSession = $62bb43e3d355db00$var$endSession;
module.exports.flush = $62bb43e3d355db00$var$flush;
module.exports.isEnabled = $62bb43e3d355db00$var$isEnabled;
module.exports.isInitialized = $62bb43e3d355db00$var$isInitialized;
module.exports.lastEventId = $62bb43e3d355db00$var$lastEventId;
module.exports.setContext = $62bb43e3d355db00$var$setContext;
module.exports.setConversationId = $62bb43e3d355db00$var$setConversationId;
module.exports.setExtra = $62bb43e3d355db00$var$setExtra;
module.exports.setExtras = $62bb43e3d355db00$var$setExtras;
module.exports.setTag = $62bb43e3d355db00$var$setTag;
module.exports.setTags = $62bb43e3d355db00$var$setTags;
module.exports.setUser = $62bb43e3d355db00$var$setUser;
module.exports.startSession = $62bb43e3d355db00$var$startSession;
module.exports.withMonitor = $62bb43e3d355db00$var$withMonitor;

});
parcelRegister("crfCR", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $fXcxa = parcelRequire("fXcxa");

var $6l1mu = parcelRequire("6l1mu");

var $d8aK6 = parcelRequire("d8aK6");

var $9Dizr = parcelRequire("9Dizr");

var $k6pIc = parcelRequire("k6pIc");

var $bg87c = parcelRequire("bg87c");

var $3k7kU = parcelRequire("3k7kU");

var $23Myp = parcelRequire("23Myp");

var $8IgEN = parcelRequire("8IgEN");

var $7q4WK = parcelRequire("7q4WK");
function $90e42097e079a3e9$var$prepareEvent(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1e3 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || $k6pIc.uuid4(),
        timestamp: event.timestamp || $7q4WK.dateTimestampInSeconds()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $90e42097e079a3e9$var$applyClientOptions(prepared, options);
    $90e42097e079a3e9$var$applyIntegrationsMetadata(prepared, integrations);
    if (client) client.emit("applyFrameMetadata", event);
    if (event.type === void 0) $90e42097e079a3e9$var$applyDebugIds(prepared, options.stackParser);
    const finalScope = $90e42097e079a3e9$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) $k6pIc.addExceptionMechanism(prepared, hint.mechanism);
    const clientEventProcessors = client ? client.getEventProcessors() : [];
    const data = $3k7kU.getCombinedScopeData(isolationScope, finalScope);
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    $3k7kU.applyScopeDataToEvent(prepared, data);
    const eventProcessors$1 = [
        ...clientEventProcessors,
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const isInternalException = hint.data && hint.data.__sentry__ === true;
    const result = isInternalException ? $8IgEN.resolvedSyncPromise(prepared) : $6l1mu.notifyEventProcessors(eventProcessors$1, prepared, hint);
    return result.then((evt)=>{
        if (evt) $90e42097e079a3e9$var$applyDebugMeta(evt);
        if (typeof normalizeDepth === "number" && normalizeDepth > 0) return $90e42097e079a3e9$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
function $90e42097e079a3e9$var$applyClientOptions(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength } = options;
    event.environment = event.environment || environment || $fXcxa.DEFAULT_ENVIRONMENT;
    if (!event.release && release) event.release = release;
    if (!event.dist && dist) event.dist = dist;
    const request = event.request;
    if (request?.url && maxValueLength) request.url = $23Myp.truncate(request.url, maxValueLength);
    if (maxValueLength) event.exception?.values?.forEach((exception)=>{
        if (exception.value) exception.value = $23Myp.truncate(exception.value, maxValueLength);
    });
}
function $90e42097e079a3e9$var$applyDebugIds(event, stackParser) {
    const filenameDebugIdMap = $9Dizr.getFilenameToDebugIdMap(stackParser);
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
        });
    });
}
function $90e42097e079a3e9$var$applyDebugMeta(event) {
    const filenameDebugIdMap = {};
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.debug_id) {
                if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                delete frame.debug_id;
            }
        });
    });
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.entries(filenameDebugIdMap).forEach(([filename, debug_id])=>{
        images.push({
            type: "sourcemap",
            code_file: filename,
            debug_id: debug_id
        });
    });
}
function $90e42097e079a3e9$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
function $90e42097e079a3e9$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: $bg87c.normalize(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: $bg87c.normalize(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: $bg87c.normalize(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: $bg87c.normalize(event.extra, depth, maxBreadth)
        }
    };
    if (event.contexts?.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        if (event.contexts.trace.data) normalized.contexts.trace.data = $bg87c.normalize(event.contexts.trace.data, depth, maxBreadth);
    }
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        return {
            ...span,
            ...span.data && {
                data: $bg87c.normalize(span.data, depth, maxBreadth)
            }
        };
    });
    if (event.contexts?.flags && normalized.contexts) normalized.contexts.flags = $bg87c.normalize(event.contexts.flags, 3, maxBreadth);
    return normalized;
}
function $90e42097e079a3e9$var$getFinalScope(scope$1, captureContext) {
    if (!captureContext) return scope$1;
    const finalScope = scope$1 ? scope$1.clone() : new $d8aK6.Scope();
    finalScope.update(captureContext);
    return finalScope;
}
function $90e42097e079a3e9$var$parseEventHintOrCaptureContext(hint) {
    if (!hint) return void 0;
    if ($90e42097e079a3e9$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($90e42097e079a3e9$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $90e42097e079a3e9$var$hintIsScopeOrFunction(hint) {
    return hint instanceof $d8aK6.Scope || typeof hint === "function";
}
const $90e42097e079a3e9$var$captureContextKeys = [
    "user",
    "level",
    "extra",
    "contexts",
    "tags",
    "fingerprint",
    "propagationContext"
];
function $90e42097e079a3e9$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$90e42097e079a3e9$var$captureContextKeys.includes(key));
}
module.exports.applyClientOptions = $90e42097e079a3e9$var$applyClientOptions;
module.exports.applyDebugIds = $90e42097e079a3e9$var$applyDebugIds;
module.exports.applyDebugMeta = $90e42097e079a3e9$var$applyDebugMeta;
module.exports.parseEventHintOrCaptureContext = $90e42097e079a3e9$var$parseEventHintOrCaptureContext;
module.exports.prepareEvent = $90e42097e079a3e9$var$prepareEvent;

});
parcelRegister("6l1mu", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $jCjMv = parcelRequire("jCjMv");

var $jix5p = parcelRequire("jix5p");

var $fBPG6 = parcelRequire("fBPG6");

var $8IgEN = parcelRequire("8IgEN");
function $49d5c2aced55cf2c$var$notifyEventProcessors(processors, event, hint, index = 0) {
    try {
        const result = $49d5c2aced55cf2c$var$_notifyEventProcessors(event, hint, processors, index);
        return $fBPG6.isThenable(result) ? result : $8IgEN.resolvedSyncPromise(result);
    } catch (error) {
        return $8IgEN.rejectedSyncPromise(error);
    }
}
function $49d5c2aced55cf2c$var$_notifyEventProcessors(event, hint, processors, index) {
    const processor = processors[index];
    if (!event || !processor) return event;
    const result = processor({
        ...event
    }, hint);
    $jCjMv.DEBUG_BUILD && result === null && $jix5p.debug.log(`Event processor "${processor.id || "?"}" dropped event`);
    if ($fBPG6.isThenable(result)) return result.then((final)=>$49d5c2aced55cf2c$var$_notifyEventProcessors(final, hint, processors, index + 1));
    return $49d5c2aced55cf2c$var$_notifyEventProcessors(result, hint, processors, index + 1);
}
module.exports.notifyEventProcessors = $49d5c2aced55cf2c$var$notifyEventProcessors;

});
parcelRegister("8IgEN", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $fBPG6 = parcelRequire("fBPG6");
const $657f5a8080c447b9$var$STATE_PENDING = 0;
const $657f5a8080c447b9$var$STATE_RESOLVED = 1;
const $657f5a8080c447b9$var$STATE_REJECTED = 2;
function $657f5a8080c447b9$var$resolvedSyncPromise(value) {
    return new $657f5a8080c447b9$var$SyncPromise((resolve)=>{
        resolve(value);
    });
}
function $657f5a8080c447b9$var$rejectedSyncPromise(reason) {
    return new $657f5a8080c447b9$var$SyncPromise((_, reject)=>{
        reject(reason);
    });
}
class $657f5a8080c447b9$var$SyncPromise {
    constructor(executor){
        this._state = $657f5a8080c447b9$var$STATE_PENDING;
        this._handlers = [];
        this._runExecutor(executor);
    }
    /** @inheritdoc */ then(onfulfilled, onrejected) {
        return new $657f5a8080c447b9$var$SyncPromise((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** @inheritdoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** @inheritdoc */ finally(onfinally) {
        return new $657f5a8080c447b9$var$SyncPromise((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** Excute the resolve/reject handlers. */ _executeHandlers() {
        if (this._state === $657f5a8080c447b9$var$STATE_PENDING) return;
        const cachedHandlers = this._handlers.slice();
        this._handlers = [];
        cachedHandlers.forEach((handler)=>{
            if (handler[0]) return;
            if (this._state === $657f5a8080c447b9$var$STATE_RESOLVED) handler[1](this._value);
            if (this._state === $657f5a8080c447b9$var$STATE_REJECTED) handler[2](this._value);
            handler[0] = true;
        });
    }
    /** Run the executor for the SyncPromise. */ _runExecutor(executor) {
        const setResult = (state, value)=>{
            if (this._state !== $657f5a8080c447b9$var$STATE_PENDING) return;
            if ($fBPG6.isThenable(value)) {
                value.then(resolve, reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
        const resolve = (value)=>{
            setResult($657f5a8080c447b9$var$STATE_RESOLVED, value);
        };
        const reject = (reason)=>{
            setResult($657f5a8080c447b9$var$STATE_REJECTED, reason);
        };
        try {
            executor(resolve, reject);
        } catch (e) {
            reject(e);
        }
    }
}
module.exports.SyncPromise = $657f5a8080c447b9$var$SyncPromise;
module.exports.rejectedSyncPromise = $657f5a8080c447b9$var$rejectedSyncPromise;
module.exports.resolvedSyncPromise = $657f5a8080c447b9$var$resolvedSyncPromise;

});


parcelRegister("9Dizr", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8S2lx = parcelRequire("8S2lx");

var $hsCGK = parcelRequire("hsCGK");
let $7036295235fd25e4$var$parsedStackResults;
let $7036295235fd25e4$var$lastSentryKeysCount;
let $7036295235fd25e4$var$lastNativeKeysCount;
let $7036295235fd25e4$var$cachedFilenameDebugIds;
function $7036295235fd25e4$var$getFilenameToDebugIdMap(stackParser) {
    const sentryDebugIdMap = $hsCGK.GLOBAL_OBJ._sentryDebugIds;
    const nativeDebugIdMap = $hsCGK.GLOBAL_OBJ._debugIds;
    if (!sentryDebugIdMap && !nativeDebugIdMap) return {};
    const sentryDebugIdKeys = sentryDebugIdMap ? Object.keys(sentryDebugIdMap) : [];
    const nativeDebugIdKeys = nativeDebugIdMap ? Object.keys(nativeDebugIdMap) : [];
    if ($7036295235fd25e4$var$cachedFilenameDebugIds && sentryDebugIdKeys.length === $7036295235fd25e4$var$lastSentryKeysCount && nativeDebugIdKeys.length === $7036295235fd25e4$var$lastNativeKeysCount) return $7036295235fd25e4$var$cachedFilenameDebugIds;
    $7036295235fd25e4$var$lastSentryKeysCount = sentryDebugIdKeys.length;
    $7036295235fd25e4$var$lastNativeKeysCount = nativeDebugIdKeys.length;
    $7036295235fd25e4$var$cachedFilenameDebugIds = {};
    if (!$7036295235fd25e4$var$parsedStackResults) $7036295235fd25e4$var$parsedStackResults = {};
    const processDebugIds = (debugIdKeys, debugIdMap)=>{
        for (const key of debugIdKeys){
            const debugId = debugIdMap[key];
            const result = $7036295235fd25e4$var$parsedStackResults?.[key];
            if (result && $7036295235fd25e4$var$cachedFilenameDebugIds && debugId) {
                $7036295235fd25e4$var$cachedFilenameDebugIds[result[0]] = debugId;
                if ($7036295235fd25e4$var$parsedStackResults) $7036295235fd25e4$var$parsedStackResults[key] = [
                    result[0],
                    debugId
                ];
            } else if (debugId) {
                const parsedStack = stackParser(key);
                for(let i = parsedStack.length - 1; i >= 0; i--){
                    const stackFrame = parsedStack[i];
                    const filename = stackFrame?.filename;
                    if (filename && $7036295235fd25e4$var$cachedFilenameDebugIds && $7036295235fd25e4$var$parsedStackResults) {
                        $7036295235fd25e4$var$cachedFilenameDebugIds[filename] = debugId;
                        $7036295235fd25e4$var$parsedStackResults[key] = [
                            filename,
                            debugId
                        ];
                        break;
                    }
                }
            }
        }
    };
    if (sentryDebugIdMap) processDebugIds(sentryDebugIdKeys, sentryDebugIdMap);
    if (nativeDebugIdMap) processDebugIds(nativeDebugIdKeys, nativeDebugIdMap);
    return $7036295235fd25e4$var$cachedFilenameDebugIds;
}
function $7036295235fd25e4$var$getDebugImagesForResources(stackParser, resource_paths) {
    const filenameDebugIdMap = $7036295235fd25e4$var$getFilenameToDebugIdMap(stackParser);
    if (!filenameDebugIdMap) return [];
    const images = [];
    for (const path of resource_paths){
        const normalizedPath = $8S2lx.normalizeStackTracePath(path);
        if (normalizedPath && filenameDebugIdMap[normalizedPath]) images.push({
            type: "sourcemap",
            code_file: path,
            debug_id: filenameDebugIdMap[normalizedPath]
        });
    }
    return images;
}
module.exports.getDebugImagesForResources = $7036295235fd25e4$var$getDebugImagesForResources;
module.exports.getFilenameToDebugIdMap = $7036295235fd25e4$var$getFilenameToDebugIdMap;

});



parcelRegister("ezH6v", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $jypZc = parcelRequire("jypZc");
const $a9c5c51797299336$var$SENTRY_API_VERSION = "7";
function $a9c5c51797299336$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : "";
    const port = dsn.port ? `:${dsn.port}` : "";
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ""}/api/`;
}
function $a9c5c51797299336$var$_getIngestEndpoint(dsn) {
    return `${$a9c5c51797299336$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
function $a9c5c51797299336$var$_encodedAuth(dsn, sdkInfo) {
    const params = {
        sentry_version: $a9c5c51797299336$var$SENTRY_API_VERSION
    };
    if (dsn.publicKey) params.sentry_key = dsn.publicKey;
    if (sdkInfo) params.sentry_client = `${sdkInfo.name}/${sdkInfo.version}`;
    return new URLSearchParams(params).toString();
}
function $a9c5c51797299336$var$getEnvelopeEndpointWithUrlEncodedAuth(dsn, tunnel, sdkInfo) {
    return tunnel ? tunnel : `${$a9c5c51797299336$var$_getIngestEndpoint(dsn)}?${$a9c5c51797299336$var$_encodedAuth(dsn, sdkInfo)}`;
}
function $a9c5c51797299336$var$getReportDialogEndpoint(dsnLike, dialogOptions) {
    const dsn$1 = $jypZc.makeDsn(dsnLike);
    if (!dsn$1) return "";
    const endpoint = `${$a9c5c51797299336$var$getBaseApiEndpoint(dsn$1)}embed/error-page/`;
    let encodedOptions = `dsn=${$jypZc.dsnToString(dsn$1)}`;
    for(const key in dialogOptions){
        if (key === "dsn") continue;
        if (key === "onClose") continue;
        if (key === "user") {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}
module.exports.SENTRY_API_VERSION = $a9c5c51797299336$var$SENTRY_API_VERSION;
module.exports.getEnvelopeEndpointWithUrlEncodedAuth = $a9c5c51797299336$var$getEnvelopeEndpointWithUrlEncodedAuth;
module.exports.getReportDialogEndpoint = $a9c5c51797299336$var$getReportDialogEndpoint;

});

parcelRegister("ej2aq", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $ezH6v = parcelRequire("ezH6v");

var $fXcxa = parcelRequire("fXcxa");

var $gjJ9A = parcelRequire("gjJ9A");

var $jCjMv = parcelRequire("jCjMv");

var $bOthn = parcelRequire("bOthn");

var $5QaR1 = parcelRequire("5QaR1");

var $hAYfg = parcelRequire("hAYfg");

var $iTp6h = parcelRequire("iTp6h");

var $jIJ38 = parcelRequire("jIJ38");

var $dkd4c = parcelRequire("dkd4c");

var $lPd4g = parcelRequire("lPd4g");

var $6hUzW = parcelRequire("6hUzW");

var $3XQ7d = parcelRequire("3XQ7d");

var $8IqnM = parcelRequire("8IqnM");

var $jix5p = parcelRequire("jix5p");

var $jypZc = parcelRequire("jypZc");

var $5fqIb = parcelRequire("5fqIb");

var $c8NRl = parcelRequire("c8NRl");

var $fBPG6 = parcelRequire("fBPG6");

var $j4dmO = parcelRequire("j4dmO");

var $k6pIc = parcelRequire("k6pIc");

var $d2351 = parcelRequire("d2351");

var $crfCR = parcelRequire("crfCR");

var $9DgSh = parcelRequire("9DgSh");

var $9xAUk = parcelRequire("9xAUk");

var $dbEaR = parcelRequire("dbEaR");

var $2dG64 = parcelRequire("2dG64");

var $8IgEN = parcelRequire("8IgEN");

var $f6Xap = parcelRequire("f6Xap");

var $cpquM = parcelRequire("cpquM");

var $hYGxQ = parcelRequire("hYGxQ");
const $a6a4856704804df5$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
const $a6a4856704804df5$var$MISSING_RELEASE_FOR_SESSION_ERROR = "Discarded session because of missing or non-string release";
const $a6a4856704804df5$var$INTERNAL_ERROR_SYMBOL = /* @__PURE__ */ Symbol.for("SentryInternalError");
const $a6a4856704804df5$var$DO_NOT_SEND_EVENT_SYMBOL = /* @__PURE__ */ Symbol.for("SentryDoNotSendEventError");
const $a6a4856704804df5$var$DEFAULT_FLUSH_INTERVAL = 5e3;
function $a6a4856704804df5$var$_makeInternalError(message) {
    return {
        message: message,
        [$a6a4856704804df5$var$INTERNAL_ERROR_SYMBOL]: true
    };
}
function $a6a4856704804df5$var$_makeDoNotSendEventError(message) {
    return {
        message: message,
        [$a6a4856704804df5$var$DO_NOT_SEND_EVENT_SYMBOL]: true
    };
}
function $a6a4856704804df5$var$_isInternalError(error) {
    return !!error && typeof error === "object" && $a6a4856704804df5$var$INTERNAL_ERROR_SYMBOL in error;
}
function $a6a4856704804df5$var$_isDoNotSendEventError(error) {
    return !!error && typeof error === "object" && $a6a4856704804df5$var$DO_NOT_SEND_EVENT_SYMBOL in error;
}
function $a6a4856704804df5$var$setupWeightBasedFlushing(client, afterCaptureHook, flushHook, estimateSizeFn, flushFn) {
    let weight = 0;
    let flushTimeout;
    let isTimerActive = false;
    client.on(flushHook, ()=>{
        weight = 0;
        clearTimeout(flushTimeout);
        isTimerActive = false;
    });
    client.on(afterCaptureHook, (item)=>{
        weight += estimateSizeFn(item);
        if (weight >= 8e5) flushFn(client);
        else if (!isTimerActive) {
            const flushInterval = client.getOptions()._flushInterval ?? $a6a4856704804df5$var$DEFAULT_FLUSH_INTERVAL;
            if (flushInterval > 0) {
                isTimerActive = true;
                flushTimeout = $f6Xap.safeUnref(setTimeout(()=>{
                    flushFn(client);
                }, flushInterval));
            }
        }
    });
    client.on("flush", ()=>{
        flushFn(client);
    });
}
class $a6a4856704804df5$var$Client {
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        this._promiseBuffer = $9DgSh.makePromiseBuffer(options.transportOptions?.bufferSize ?? $3XQ7d.DEFAULT_TRANSPORT_BUFFER_SIZE);
        this._dataCollection = $hYGxQ.resolveDataCollectionOptions(options);
        if (options.dsn) this._dsn = $jypZc.makeDsn(options.dsn);
        else $jCjMv.DEBUG_BUILD && $jix5p.debug.warn("No DSN provided, client will not send events.");
        if (this._dsn) {
            const url = $ezH6v.getEnvelopeEndpointWithUrlEncodedAuth(this._dsn, options.tunnel, options._metadata ? options._metadata.sdk : void 0);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
        this._options.enableLogs = this._options.enableLogs ?? this._options._experiments?.enableLogs;
        if (this._options.enableLogs) $a6a4856704804df5$var$setupWeightBasedFlushing(this, "afterCaptureLog", "flushLogs", $a6a4856704804df5$var$estimateLogSizeInBytes, $hAYfg._INTERNAL_flushLogsBuffer);
        const enableMetrics = this._options.enableMetrics ?? this._options._experiments?.enableMetrics ?? true;
        if (enableMetrics) $a6a4856704804df5$var$setupWeightBasedFlushing(this, "afterCaptureMetric", "flushMetrics", $a6a4856704804df5$var$estimateMetricSizeInBytes, $iTp6h._INTERNAL_flushMetricsBuffer);
    }
    /**
   * Captures an exception event and sends it to Sentry.
   *
   * Unlike `captureException` exported from every SDK, this method requires that you pass it the current scope.
   */ captureException(exception, hint, scope) {
        const eventId = $k6pIc.uuid4();
        if ($k6pIc.checkOrSetAlreadyCaught(exception)) {
            $jCjMv.DEBUG_BUILD && $jix5p.debug.log($a6a4856704804df5$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        this._process(()=>this.eventFromException(exception, hintWithEventId).then((event)=>this._captureEvent(event, hintWithEventId, scope)).then((res)=>res), "error");
        return hintWithEventId.event_id;
    }
    /**
   * Captures a message event and sends it to Sentry.
   *
   * Unlike `captureMessage` exported from every SDK, this method requires that you pass it the current scope.
   */ captureMessage(message, level, hint, currentScope) {
        const hintWithEventId = {
            event_id: $k6pIc.uuid4(),
            ...hint
        };
        const eventMessage = $fBPG6.isParameterizedString(message) ? message : String(message);
        const isMessage = $fBPG6.isPrimitive(message);
        const promisedEvent = isMessage ? this.eventFromMessage(eventMessage, level, hintWithEventId) : this.eventFromException(message, hintWithEventId);
        this._process(()=>promisedEvent.then((event)=>this._captureEvent(event, hintWithEventId, currentScope)), isMessage ? "unknown" : "error");
        return hintWithEventId.event_id;
    }
    /**
   * Captures a manually created event and sends it to Sentry.
   *
   * Unlike `captureEvent` exported from every SDK, this method requires that you pass it the current scope.
   */ captureEvent(event, hint, currentScope) {
        const eventId = $k6pIc.uuid4();
        if (hint?.originalException && $k6pIc.checkOrSetAlreadyCaught(hint.originalException)) {
            $jCjMv.DEBUG_BUILD && $jix5p.debug.log($a6a4856704804df5$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        const dataCategory = $a6a4856704804df5$var$getDataCategoryByType(event.type);
        this._process(()=>this._captureEvent(event, hintWithEventId, capturedSpanScope || currentScope, capturedSpanIsolationScope), dataCategory);
        return hintWithEventId.event_id;
    }
    /**
   * Captures a session.
   */ captureSession(session$1) {
        this.sendSession(session$1);
        $jIJ38.updateSession(session$1, {
            init: false
        });
    }
    /**
   * Get the current Dsn.
   */ getDsn() {
        return this._dsn;
    }
    /**
   * Get the current options.
   */ getOptions() {
        return this._options;
    }
    /**
   * Get the resolved data collection configuration.
   */ getDataCollectionOptions() {
        return this._dataCollection;
    }
    /**
   * Get the SDK metadata.
   * @see SdkMetadata
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * Returns the transport that is used by the client.
   * Please note that the transport gets lazy initialized so it will only be there once the first event has been sent.
   */ getTransport() {
        return this._transport;
    }
    /**
   * Wait for all events to be sent or the timeout to expire, whichever comes first.
   *
   * @param timeout Maximum time in ms the client should wait for events to be flushed. Omitting this parameter will
   *   cause the client to wait until all events are sent before resolving the promise.
   * @returns A promise that will resolve with `true` if all events are sent before the timeout, or `false` if there are
   * still events in the queue when the timeout is reached.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
    async flush(timeout) {
        const transport = this._transport;
        this.emit("flush");
        if (!transport) return true;
        const clientFinished = await this._isClientDoneProcessing(timeout);
        const transportFlushed = await transport.flush(timeout);
        return clientFinished && transportFlushed;
    }
    /**
   * Flush the event queue and set the client to `enabled = false`. See {@link Client.flush}.
   *
   * @param {number} timeout Maximum time in ms the client should wait before shutting down. Omitting this parameter will cause
   *   the client to wait until all events are sent before disabling itself.
   * @returns {Promise<boolean>} A promise which resolves to `true` if the flush completes successfully before the timeout, or `false` if
   * it doesn't.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
    async close(timeout) {
        $hAYfg._INTERNAL_flushLogsBuffer(this);
        const result = await this.flush(timeout);
        this.getOptions().enabled = false;
        this.emit("close");
        return result;
    }
    /**
   * Get all installed event processors.
   */ getEventProcessors() {
        return this._eventProcessors;
    }
    /**
   * Adds an event processor that applies to any event processed by this client.
   */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * Initialize this client.
   * Call this after the client was set on a scope.
   */ init() {
        if (this._isEnabled() || // Force integrations to be setup even if no DSN was set when we have
        // Spotlight enabled. This is particularly important for browser as we
        // don't support the `spotlight` option there and rely on the users
        // adding the `spotlightBrowserIntegration()` to their integrations which
        // wouldn't get initialized with the check below when there's no DSN set.
        this._options.integrations.some(({ name: name })=>name.startsWith("Spotlight"))) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns {Integration|undefined} The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Returns the names of all installed integrations.
   */ getIntegrationNames() {
        return Object.keys(this._integrations);
    }
    /**
   * Add an integration to the client.
   * This can be used to e.g. lazy load integrations.
   * In most cases, this should not be necessary,
   * and you're better off just passing the integrations via `integrations: []` at initialization time.
   * However, if you find the need to conditionally load & add an integration, you can use `addIntegration` to do so.
   */ addIntegration(integration$1) {
        const isAlreadyInstalled = this._integrations[integration$1.name];
        if (!isAlreadyInstalled && integration$1.beforeSetup) integration$1.beforeSetup(this);
        $5QaR1.setupIntegration(this, integration$1, this._integrations);
        if (!isAlreadyInstalled) $5QaR1.afterSetupIntegrations(this, [
            integration$1
        ]);
    }
    /**
   * Send a fully prepared event to Sentry.
   */ sendEvent(event, hint = {}) {
        this.emit("beforeSendEvent", event, hint);
        const genAiSpanItem = $6hUzW.extractGenAiSpansFromEvent(event, this);
        let env = $bOthn.createEventEnvelope(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = $5fqIb.addItemToEnvelope(env, $5fqIb.createAttachmentEnvelopeItem(attachment));
        if (genAiSpanItem) env = $5fqIb.addItemToEnvelope(env, genAiSpanItem);
        this.sendEnvelope(env).then((sendResponse)=>this.emit("afterSendEvent", event, sendResponse));
    }
    /**
   * Send a session or session aggregrates to Sentry.
   */ sendSession(session) {
        const { release: clientReleaseOption, environment: clientEnvironmentOption = $fXcxa.DEFAULT_ENVIRONMENT } = this._options;
        if ("aggregates" in session) {
            const sessionAttrs = session.attrs || {};
            if (!sessionAttrs.release && !clientReleaseOption) {
                $jCjMv.DEBUG_BUILD && $jix5p.debug.warn($a6a4856704804df5$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            sessionAttrs.release = sessionAttrs.release || clientReleaseOption;
            sessionAttrs.environment = sessionAttrs.environment || clientEnvironmentOption;
            session.attrs = sessionAttrs;
        } else {
            if (!session.release && !clientReleaseOption) {
                $jCjMv.DEBUG_BUILD && $jix5p.debug.warn($a6a4856704804df5$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            session.release = session.release || clientReleaseOption;
            session.environment = session.environment || clientEnvironmentOption;
        }
        this.emit("beforeSendSession", session);
        const env = $bOthn.createSessionEnvelope(session, this._dsn, this._options._metadata, this._options.tunnel);
        this.sendEnvelope(env);
    }
    /**
   * Record on the client that an event got dropped (ie, an event that will not be sent to Sentry).
   */ recordDroppedEvent(reason, category, count = 1) {
        if (this._options.sendClientReports) {
            const key = `${reason}:${category}`;
            $jCjMv.DEBUG_BUILD && $jix5p.debug.log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ""}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    /**
   * Register a hook on this client.
   */ on(hook, callback) {
        const hookCallbacks = this._hooks[hook] = this._hooks[hook] || /* @__PURE__ */ new Set();
        const uniqueCallback = (...args)=>callback(...args);
        hookCallbacks.add(uniqueCallback);
        return ()=>{
            hookCallbacks.delete(uniqueCallback);
        };
    }
    /**
   * Emit a hook that was previously registered via `on()`.
   */ emit(hook, ...rest) {
        const callbacks = this._hooks[hook];
        if (callbacks) callbacks.forEach((callback)=>callback(...rest));
    }
    /**
   * Send an envelope to Sentry.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
    async sendEnvelope(envelope) {
        this.emit("beforeEnvelope", envelope);
        if (this._isEnabled() && this._transport) try {
            return await this._transport.send(envelope);
        } catch (reason) {
            $jCjMv.DEBUG_BUILD && $jix5p.debug.error("Error while sending envelope:", reason);
            return {};
        }
        $jCjMv.DEBUG_BUILD && $jix5p.debug.error("Transport disabled");
        return {};
    }
    /**
   * Register a cleanup function to be called when the client is disposed.
   * This is useful for integrations that need to clean up global state.
   *
   * NOTE: This is a no-op in the base `Client` class. Subclasses like `ServerRuntimeClient`
   * override this method to actually register and execute cleanup callbacks.
   */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    registerCleanup(callback) {}
    /**
   * Disposes of the client and releases all resources.
   *
   * Subclasses should override this method to clean up their own resources, including invoking
   * any callbacks registered via {@link Client.registerCleanup}. The base implementation is a
   * no-op and does NOT execute registered cleanup callbacks.
   *
   * After calling dispose(), the client should not be used anymore.
   */ dispose() {}
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = $5QaR1.setupIntegrations(this, integrations);
        $5QaR1.afterSetupIntegrations(this, integrations);
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session$1, event) {
        let crashed = event.level === "fatal";
        let errored = false;
        const exceptions = event.exception?.values;
        if (exceptions) {
            errored = true;
            crashed = false;
            for (const ex of exceptions)if (ex.mechanism?.handled === false) {
                crashed = true;
                break;
            }
        }
        const sessionNonTerminal = session$1.status === "ok";
        const shouldUpdateAndSend = sessionNonTerminal && session$1.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            $jIJ38.updateSession(session$1, {
                ...crashed && {
                    status: "crashed"
                },
                errors: session$1.errors || Number(errored || crashed)
            });
            this.captureSession(session$1);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ async _isClientDoneProcessing(timeout) {
        let ticked = 0;
        while(!timeout || ticked < timeout){
            await new Promise((resolve)=>setTimeout(resolve, 1));
            if (!this._numProcessing) return true;
            ticked++;
        }
        return false;
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== void 0;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const integrations = this.getIntegrationNames();
        if (!hint.integrations && integrations.length) hint.integrations = integrations;
        this.emit("preprocessEvent", event, hint);
        if (!event.type) isolationScope.setLastEventId(event.event_id || hint.event_id);
        return $crfCR.prepareEvent(options, event, hint, currentScope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            this.emit("postprocessEvent", evt, hint);
            evt.contexts = {
                trace: {
                    ...evt.contexts?.trace,
                    ...$gjJ9A.getTraceContextFromScope(currentScope)
                },
                ...evt.contexts
            };
            const dynamicSamplingContext$1 = $dkd4c.getDynamicSamplingContextFromScope(this, currentScope);
            evt.sdkProcessingMetadata = {
                dynamicSamplingContext: dynamicSamplingContext$1,
                ...evt.sdkProcessingMetadata
            };
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, currentScope = $gjJ9A.getCurrentScope(), isolationScope = $gjJ9A.getIsolationScope()) {
        if ($jCjMv.DEBUG_BUILD && $a6a4856704804df5$var$isErrorEvent(event)) $jix5p.debug.log(`Captured error event \`${$c8NRl.getPossibleEventMessages(event)[0] || "<unknown>"}\``);
        return this._processEvent(event, hint, currentScope, isolationScope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if ($jCjMv.DEBUG_BUILD) {
                if ($a6a4856704804df5$var$_isDoNotSendEventError(reason)) $jix5p.debug.log(reason.message);
                else if ($a6a4856704804df5$var$_isInternalError(reason)) $jix5p.debug.warn(reason.message);
                else $jix5p.debug.warn(reason);
            }
            return void 0;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $a6a4856704804df5$var$isTransactionEvent(event);
        const isError = $a6a4856704804df5$var$isErrorEvent(event);
        const eventType = event.type || "error";
        const beforeSendLabel = `before send for type \`${eventType}\``;
        const parsedSampleRate = typeof sampleRate === "undefined" ? void 0 : $d2351.parseSampleRate(sampleRate);
        if (isError && typeof parsedSampleRate === "number" && $9xAUk.safeMathRandom() > parsedSampleRate) {
            this.recordDroppedEvent("sample_rate", "error");
            return $8IgEN.rejectedSyncPromise($a6a4856704804df5$var$_makeDoNotSendEventError(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`));
        }
        const dataCategory = $a6a4856704804df5$var$getDataCategoryByType(event.type);
        return this._prepareEvent(event, hint, currentScope, isolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent("event_processor", dataCategory);
                throw $a6a4856704804df5$var$_makeDoNotSendEventError("An event processor returned `null`, will not send event.");
            }
            const isInternalException = hint.data?.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $a6a4856704804df5$var$processBeforeSend(this, options, prepared, hint);
            return $a6a4856704804df5$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent("before_send", dataCategory);
                if (isTransaction) {
                    const spans = event.spans || [];
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent("before_send", "span", spanCount);
                }
                throw $a6a4856704804df5$var$_makeDoNotSendEventError(`${beforeSendLabel} returned \`null\`, will not send event.`);
            }
            const session = currentScope.getSession() || isolationScope.getSession();
            if (isError && session) this._updateSessionFromEvent(session, processedEvent);
            if (isTransaction) {
                const spanCountBefore = processedEvent.sdkProcessingMetadata?.spanCountBeforeProcessing || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent("before_send", "span", droppedSpanCount);
            }
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = "custom";
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if ($a6a4856704804df5$var$_isDoNotSendEventError(reason) || $a6a4856704804df5$var$_isInternalError(reason)) throw reason;
            this.captureException(reason, {
                mechanism: {
                    handled: false,
                    type: "internal"
                },
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw $a6a4856704804df5$var$_makeInternalError(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.
Reason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(taskProducer, dataCategory) {
        this._numProcessing++;
        this._promiseBuffer.add(taskProducer).then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            if (reason === $9DgSh.SENTRY_BUFFER_FULL_ERROR) this.recordDroppedEvent("queue_overflow", dataCategory);
            return reason;
        });
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.entries(outcomes).map(([key, quantity])=>{
            const [reason, category] = key.split(":");
            return {
                reason: reason,
                category: category,
                quantity: quantity
            };
        });
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        $jCjMv.DEBUG_BUILD && $jix5p.debug.log("Flushing outcomes...");
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            $jCjMv.DEBUG_BUILD && $jix5p.debug.log("No outcomes to send");
            return;
        }
        if (!this._dsn) {
            $jCjMv.DEBUG_BUILD && $jix5p.debug.log("No dsn provided, will not send outcomes");
            return;
        }
        $jCjMv.DEBUG_BUILD && $jix5p.debug.log("Sending outcomes:", outcomes);
        const envelope = $8IqnM.createClientReportEnvelope(outcomes, this._options.tunnel && $jypZc.dsnToString(this._dsn));
        this.sendEnvelope(envelope);
    }
}
function $a6a4856704804df5$var$getDataCategoryByType(type) {
    return type === "replay_event" ? "replay" : type || "error";
}
function $a6a4856704804df5$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ($fBPG6.isThenable(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!$fBPG6.isPlainObject(event) && event !== null) throw $a6a4856704804df5$var$_makeInternalError(invalidValueError);
        return event;
    }, (e)=>{
        throw $a6a4856704804df5$var$_makeInternalError(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!$fBPG6.isPlainObject(beforeSendResult) && beforeSendResult !== null) throw $a6a4856704804df5$var$_makeInternalError(invalidValueError);
    return beforeSendResult;
}
function $a6a4856704804df5$var$processBeforeSend(client, options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction, ignoreSpans: ignoreSpans } = options;
    const beforeSendSpan$1 = !$lPd4g.isStreamedBeforeSendSpanCallback(options.beforeSendSpan) && options.beforeSendSpan;
    let processedEvent = event;
    if ($a6a4856704804df5$var$isErrorEvent(processedEvent) && beforeSend) return beforeSend(processedEvent, hint);
    if ($a6a4856704804df5$var$isTransactionEvent(processedEvent)) {
        if (beforeSendSpan$1 || ignoreSpans) {
            const rootSpanJson = $cpquM.convertTransactionEventToSpanJson(processedEvent);
            if (ignoreSpans?.length && $dbEaR.shouldIgnoreSpan({
                description: rootSpanJson.description,
                op: rootSpanJson.op,
                attributes: rootSpanJson.data
            }, ignoreSpans)) return null;
            if (beforeSendSpan$1) {
                const processedRootSpanJson = beforeSendSpan$1(rootSpanJson);
                if (!processedRootSpanJson) $2dG64.showSpanDropWarning();
                else processedEvent = $j4dmO.merge(event, $cpquM.convertSpanJsonToTransactionEvent(processedRootSpanJson));
            }
            if (processedEvent.spans) {
                const processedSpans = [];
                const initialSpans = processedEvent.spans;
                for (const span of initialSpans){
                    if (ignoreSpans?.length && $dbEaR.shouldIgnoreSpan({
                        description: span.description,
                        op: span.op,
                        attributes: span.data
                    }, ignoreSpans)) {
                        $dbEaR.reparentChildSpans(initialSpans, span);
                        continue;
                    }
                    if (beforeSendSpan$1) {
                        const processedSpan = beforeSendSpan$1(span);
                        if (!processedSpan) {
                            $2dG64.showSpanDropWarning();
                            processedSpans.push(span);
                        } else processedSpans.push(processedSpan);
                    } else processedSpans.push(span);
                }
                const droppedSpans = processedEvent.spans.length - processedSpans.length;
                if (droppedSpans) client.recordDroppedEvent("before_send", "span", droppedSpans);
                processedEvent.spans = processedSpans;
            }
        }
        if (beforeSendTransaction) {
            if (processedEvent.spans) {
                const spanCountBefore = processedEvent.spans.length;
                processedEvent.sdkProcessingMetadata = {
                    ...event.sdkProcessingMetadata,
                    spanCountBeforeProcessing: spanCountBefore
                };
            }
            return beforeSendTransaction(processedEvent, hint);
        }
    }
    return processedEvent;
}
function $a6a4856704804df5$var$isErrorEvent(event) {
    return event.type === void 0;
}
function $a6a4856704804df5$var$isTransactionEvent(event) {
    return event.type === "transaction";
}
function $a6a4856704804df5$var$estimateMetricSizeInBytes(metric) {
    let weight = 0;
    if (metric.name) weight += metric.name.length * 2;
    weight += 8;
    return weight + $a6a4856704804df5$var$estimateAttributesSizeInBytes(metric.attributes);
}
function $a6a4856704804df5$var$estimateLogSizeInBytes(log) {
    let weight = 0;
    if (log.message) weight += log.message.length * 2;
    return weight + $a6a4856704804df5$var$estimateAttributesSizeInBytes(log.attributes);
}
function $a6a4856704804df5$var$estimateAttributesSizeInBytes(attributes) {
    if (!attributes) return 0;
    let weight = 0;
    Object.values(attributes).forEach((value)=>{
        if (Array.isArray(value)) weight += value.length * $a6a4856704804df5$var$estimatePrimitiveSizeInBytes(value[0]);
        else if ($fBPG6.isPrimitive(value)) weight += $a6a4856704804df5$var$estimatePrimitiveSizeInBytes(value);
        else weight += 100;
    });
    return weight;
}
function $a6a4856704804df5$var$estimatePrimitiveSizeInBytes(value) {
    if (typeof value === "string") return value.length * 2;
    else if (typeof value === "number") return 8;
    else if (typeof value === "boolean") return 4;
    return 0;
}
module.exports.Client = $a6a4856704804df5$var$Client;

});
parcelRegister("5QaR1", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gjJ9A = parcelRequire("gjJ9A");

var $jCjMv = parcelRequire("jCjMv");

var $jix5p = parcelRequire("jix5p");
const $440a3a7a7a629b5d$var$installedIntegrations = [];
function $440a3a7a7a629b5d$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.values(integrationsByName);
}
function $440a3a7a7a629b5d$var$getIntegrationsToSetup(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === "function") {
        const resolvedUserIntegrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(resolvedUserIntegrations) ? resolvedUserIntegrations : [
            resolvedUserIntegrations
        ];
    } else integrations = defaultIntegrations;
    return $440a3a7a7a629b5d$var$filterDuplicates(integrations);
}
function $440a3a7a7a629b5d$var$setupIntegrations(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        if (integration?.beforeSetup) integration.beforeSetup(client);
    });
    integrations.forEach((integration)=>{
        if (integration) $440a3a7a7a629b5d$var$setupIntegration(client, integration, integrationIndex);
    });
    return integrationIndex;
}
function $440a3a7a7a629b5d$var$afterSetupIntegrations(client, integrations) {
    for (const integration of integrations)if (integration?.afterAllSetup) integration.afterAllSetup(client);
}
function $440a3a7a7a629b5d$var$setupIntegration(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        $jCjMv.DEBUG_BUILD && $jix5p.debug.log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    if (!$440a3a7a7a629b5d$var$installedIntegrations.includes(integration.name) && typeof integration.setupOnce === "function") {
        integration.setupOnce();
        $440a3a7a7a629b5d$var$installedIntegrations.push(integration.name);
    }
    if (integration.setup && typeof integration.setup === "function") integration.setup(client);
    if (typeof integration.preprocessEvent === "function") {
        const callback = integration.preprocessEvent.bind(integration);
        client.on("preprocessEvent", (event, hint)=>callback(event, hint, client));
    }
    if (typeof integration.processEvent === "function") {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    [
        "processSpan",
        "processSegmentSpan"
    ].forEach((hook)=>{
        const callback = integration[hook];
        if (typeof callback === "function") client.on(hook, (span)=>callback.call(integration, span, client));
    });
    $jCjMv.DEBUG_BUILD && $jix5p.debug.log(`Integration installed: ${integration.name}`);
}
function $440a3a7a7a629b5d$var$addIntegration(integration) {
    const client = $gjJ9A.getClient();
    if (!client) {
        $jCjMv.DEBUG_BUILD && $jix5p.debug.warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
function $440a3a7a7a629b5d$var$defineIntegration(fn) {
    return fn;
}
module.exports.addIntegration = $440a3a7a7a629b5d$var$addIntegration;
module.exports.afterSetupIntegrations = $440a3a7a7a629b5d$var$afterSetupIntegrations;
module.exports.defineIntegration = $440a3a7a7a629b5d$var$defineIntegration;
module.exports.getIntegrationsToSetup = $440a3a7a7a629b5d$var$getIntegrationsToSetup;
module.exports.installedIntegrations = $440a3a7a7a629b5d$var$installedIntegrations;
module.exports.setupIntegration = $440a3a7a7a629b5d$var$setupIntegration;
module.exports.setupIntegrations = $440a3a7a7a629b5d$var$setupIntegrations;

});

parcelRegister("hAYfg", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $f8fWp = parcelRequire("f8fWp");

var $hbMFZ = parcelRequire("hbMFZ");

var $gjJ9A = parcelRequire("gjJ9A");

var $jCjMv = parcelRequire("jCjMv");

var $jix5p = parcelRequire("jix5p");

var $fBPG6 = parcelRequire("fBPG6");

var $3k7kU = parcelRequire("3k7kU");

var $k7IIJ = parcelRequire("k7IIJ");

var $7q4WK = parcelRequire("7q4WK");

var $kvtg3 = parcelRequire("kvtg3");

var $9n8AY = parcelRequire("9n8AY");

var $3PDxh = parcelRequire("3PDxh");

var $ZCHBl = parcelRequire("ZCHBl");
const $ccf487ec95f3343f$var$MAX_LOG_BUFFER_SIZE = 100;
function $ccf487ec95f3343f$var$setLogAttribute(logAttributes, key, value, setEvenIfPresent = true) {
    if (value && (!logAttributes[key] || setEvenIfPresent)) logAttributes[key] = value;
}
function $ccf487ec95f3343f$var$_INTERNAL_captureSerializedLog(client, serializedLog) {
    const bufferMap = $ccf487ec95f3343f$var$_getBufferMap();
    const logBuffer = $ccf487ec95f3343f$var$_INTERNAL_getLogBuffer(client);
    if (logBuffer === void 0) bufferMap.set(client, [
        serializedLog
    ]);
    else if (logBuffer.length >= $ccf487ec95f3343f$var$MAX_LOG_BUFFER_SIZE) {
        $ccf487ec95f3343f$var$_INTERNAL_flushLogsBuffer(client, logBuffer);
        bufferMap.set(client, [
            serializedLog
        ]);
    } else bufferMap.set(client, [
        ...logBuffer,
        serializedLog
    ]);
}
function $ccf487ec95f3343f$var$_INTERNAL_captureLog(beforeLog, currentScope = $gjJ9A.getCurrentScope(), captureSerializedLog = $ccf487ec95f3343f$var$_INTERNAL_captureSerializedLog) {
    const client = currentScope?.getClient() ?? $gjJ9A.getClient();
    if (!client) {
        $jCjMv.DEBUG_BUILD && $jix5p.debug.warn("No client available to capture log.");
        return;
    }
    const { release: release, environment: environment, enableLogs: enableLogs = false, beforeSendLog: beforeSendLog } = client.getOptions();
    if (!enableLogs) {
        $jCjMv.DEBUG_BUILD && $jix5p.debug.warn("logging option not enabled, log will not be captured.");
        return;
    }
    const [, traceContext] = $9n8AY._getTraceInfoFromScope(client, currentScope);
    const processedLogAttributes = {
        ...beforeLog.attributes
    };
    const { user: { id: id, email: email, username: username }, attributes: scopeAttributes = {} } = $3k7kU.getCombinedScopeData($gjJ9A.getIsolationScope(), currentScope);
    $ccf487ec95f3343f$var$setLogAttribute(processedLogAttributes, "user.id", id, false);
    $ccf487ec95f3343f$var$setLogAttribute(processedLogAttributes, "user.email", email, false);
    $ccf487ec95f3343f$var$setLogAttribute(processedLogAttributes, "user.name", username, false);
    $ccf487ec95f3343f$var$setLogAttribute(processedLogAttributes, "sentry.release", release);
    $ccf487ec95f3343f$var$setLogAttribute(processedLogAttributes, "sentry.environment", environment);
    const { name: name, version: version } = client.getSdkMetadata()?.sdk ?? {};
    $ccf487ec95f3343f$var$setLogAttribute(processedLogAttributes, "sentry.sdk.name", name);
    $ccf487ec95f3343f$var$setLogAttribute(processedLogAttributes, "sentry.sdk.version", version);
    const replay = client.getIntegrationByName("Replay");
    const replayId = replay?.getReplayId(true);
    $ccf487ec95f3343f$var$setLogAttribute(processedLogAttributes, "sentry.replay_id", replayId);
    if (replayId && replay?.getRecordingMode() === "buffer") $ccf487ec95f3343f$var$setLogAttribute(processedLogAttributes, "sentry._internal.replay_is_buffering", true);
    const beforeLogMessage = beforeLog.message;
    if ($fBPG6.isParameterizedString(beforeLogMessage)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ = [] } = beforeLogMessage;
        if (__sentry_template_values__?.length) processedLogAttributes["sentry.message.template"] = __sentry_template_string__;
        __sentry_template_values__.forEach((param, index)=>{
            processedLogAttributes[`sentry.message.parameter.${index}`] = param;
        });
    }
    const span = $k7IIJ._getSpanForScope(currentScope);
    $ccf487ec95f3343f$var$setLogAttribute(processedLogAttributes, "sentry.trace.parent_span_id", span?.spanContext().spanId);
    const processedLog = {
        ...beforeLog,
        attributes: processedLogAttributes
    };
    client.emit("beforeCaptureLog", processedLog);
    const log = beforeSendLog ? $jix5p.consoleSandbox(()=>beforeSendLog(processedLog)) : processedLog;
    if (!log) {
        client.recordDroppedEvent("before_send", "log_item", 1);
        $jCjMv.DEBUG_BUILD && $jix5p.debug.warn("beforeSendLog returned null, log will not be captured.");
        return;
    }
    const { level: level, message: message, attributes: logAttributes = {}, severityNumber: severityNumber } = log;
    const timestamp = $7q4WK.timestampInSeconds();
    const sequenceAttr = $kvtg3.getSequenceAttribute(timestamp);
    const serializedLog = {
        timestamp: timestamp,
        level: level,
        body: $ccf487ec95f3343f$var$_removeLoneSurrogates(String(message)),
        trace_id: traceContext?.trace_id,
        severity_number: severityNumber ?? $3PDxh.SEVERITY_TEXT_TO_SEVERITY_NUMBER[level],
        attributes: $ccf487ec95f3343f$var$sanitizeLogAttributes({
            ...$f8fWp.serializeAttributes(scopeAttributes),
            ...$f8fWp.serializeAttributes(logAttributes, true),
            [sequenceAttr.key]: sequenceAttr.value
        })
    };
    captureSerializedLog(client, serializedLog);
    client.emit("afterCaptureLog", log);
}
function $ccf487ec95f3343f$var$_INTERNAL_flushLogsBuffer(client, maybeLogBuffer) {
    const logBuffer = maybeLogBuffer ?? $ccf487ec95f3343f$var$_INTERNAL_getLogBuffer(client) ?? [];
    if (logBuffer.length === 0) return;
    const clientOptions = client.getOptions();
    const envelope$1 = $ZCHBl.createLogEnvelope(logBuffer, clientOptions._metadata, clientOptions.tunnel, client.getDsn(), client.getDataCollectionOptions().userInfo);
    $ccf487ec95f3343f$var$_getBufferMap().set(client, []);
    client.emit("flushLogs");
    client.sendEnvelope(envelope$1);
}
function $ccf487ec95f3343f$var$_INTERNAL_getLogBuffer(client) {
    return $ccf487ec95f3343f$var$_getBufferMap().get(client);
}
function $ccf487ec95f3343f$var$_getBufferMap() {
    return $hbMFZ.getGlobalSingleton("clientToLogBufferMap", ()=>/* @__PURE__ */ new WeakMap());
}
function $ccf487ec95f3343f$var$sanitizeLogAttributes(attributes) {
    const sanitized = {};
    for (const [key, attr] of Object.entries(attributes)){
        const sanitizedKey = $ccf487ec95f3343f$var$_removeLoneSurrogates(key);
        if (attr.type === "string") sanitized[sanitizedKey] = {
            ...attr,
            value: $ccf487ec95f3343f$var$_removeLoneSurrogates(attr.value)
        };
        else sanitized[sanitizedKey] = attr;
    }
    return sanitized;
}
function $ccf487ec95f3343f$var$_removeLoneSurrogates(str) {
    const strObj = Object(str);
    const isWellFormed = strObj["isWellFormed"];
    const toWellFormed = strObj["toWellFormed"];
    if (typeof isWellFormed === "function" && typeof toWellFormed === "function") return isWellFormed.call(str) ? str : toWellFormed.call(str);
    return str;
}
module.exports._INTERNAL_captureLog = $ccf487ec95f3343f$var$_INTERNAL_captureLog;
module.exports._INTERNAL_captureSerializedLog = $ccf487ec95f3343f$var$_INTERNAL_captureSerializedLog;
module.exports._INTERNAL_flushLogsBuffer = $ccf487ec95f3343f$var$_INTERNAL_flushLogsBuffer;
module.exports._INTERNAL_getLogBuffer = $ccf487ec95f3343f$var$_INTERNAL_getLogBuffer;
module.exports._removeLoneSurrogates = $ccf487ec95f3343f$var$_removeLoneSurrogates;

});
parcelRegister("kvtg3", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $eedd65ed56be47f7$var$SEQUENCE_ATTR_KEY = "sentry.timestamp.sequence";
let $eedd65ed56be47f7$var$_sequenceNumber = 0;
let $eedd65ed56be47f7$var$_previousTimestampMs;
function $eedd65ed56be47f7$var$getSequenceAttribute(timestampInSeconds) {
    const nowMs = Math.floor(timestampInSeconds * 1e3);
    if ($eedd65ed56be47f7$var$_previousTimestampMs !== void 0 && nowMs !== $eedd65ed56be47f7$var$_previousTimestampMs) $eedd65ed56be47f7$var$_sequenceNumber = 0;
    const value = $eedd65ed56be47f7$var$_sequenceNumber;
    $eedd65ed56be47f7$var$_sequenceNumber++;
    $eedd65ed56be47f7$var$_previousTimestampMs = nowMs;
    return {
        key: $eedd65ed56be47f7$var$SEQUENCE_ATTR_KEY,
        value: {
            value: value,
            type: "integer"
        }
    };
}
module.exports.getSequenceAttribute = $eedd65ed56be47f7$var$getSequenceAttribute;

});

parcelRegister("9n8AY", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gjJ9A = parcelRequire("gjJ9A");

var $dkd4c = parcelRequire("dkd4c");

var $2dG64 = parcelRequire("2dG64");
function $6d2cede27207ed9b$var$_getTraceInfoFromScope(client, scope) {
    if (!scope) return [
        void 0,
        void 0
    ];
    return $gjJ9A.withScope(scope, ()=>{
        const span = $2dG64.getActiveSpan();
        const traceContext = span ? $2dG64.spanToTraceContext(span) : $gjJ9A.getTraceContextFromScope(scope);
        const dynamicSamplingContext$1 = span ? $dkd4c.getDynamicSamplingContextFromSpan(span) : $dkd4c.getDynamicSamplingContextFromScope(client, scope);
        return [
            dynamicSamplingContext$1,
            traceContext
        ];
    });
}
module.exports._getTraceInfoFromScope = $6d2cede27207ed9b$var$_getTraceInfoFromScope;

});

parcelRegister("3PDxh", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $2ca4cd7dd8097fb6$var$SEVERITY_TEXT_TO_SEVERITY_NUMBER = {
    trace: 1,
    debug: 5,
    info: 9,
    warn: 13,
    error: 17,
    fatal: 21
};
module.exports.SEVERITY_TEXT_TO_SEVERITY_NUMBER = $2ca4cd7dd8097fb6$var$SEVERITY_TEXT_TO_SEVERITY_NUMBER;

});

parcelRegister("ZCHBl", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $jypZc = parcelRequire("jypZc");

var $5fqIb = parcelRequire("5fqIb");

var $9Vsrl = parcelRequire("9Vsrl");
function $0b93b8148e767bdf$var$createLogContainerEnvelopeItem(items, inferUserData) {
    const inferSetting = inferUserData ? "auto" : "never";
    return [
        {
            type: "log",
            item_count: items.length,
            content_type: "application/vnd.sentry.items.log+json"
        },
        {
            version: 2,
            ...$9Vsrl.isBrowser() && {
                ingest_settings: {
                    infer_ip: inferSetting,
                    infer_user_agent: inferSetting
                }
            },
            items: items
        }
    ];
}
function $0b93b8148e767bdf$var$createLogEnvelope(logs, metadata, tunnel, dsn$1, inferUserData) {
    const headers = {};
    if (metadata?.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn$1) headers.dsn = $jypZc.dsnToString(dsn$1);
    return $5fqIb.createEnvelope(headers, [
        $0b93b8148e767bdf$var$createLogContainerEnvelopeItem(logs, inferUserData)
    ]);
}
module.exports.createLogContainerEnvelopeItem = $0b93b8148e767bdf$var$createLogContainerEnvelopeItem;
module.exports.createLogEnvelope = $0b93b8148e767bdf$var$createLogEnvelope;

});
parcelRegister("9Vsrl", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $lcp1M = parcelRequire("lcp1M");

var $hsCGK = parcelRequire("hsCGK");
function $739f7f8c8d19c48c$var$isBrowser() {
    return typeof window !== "undefined" && (!$lcp1M.isNodeEnv() || $739f7f8c8d19c48c$var$isElectronNodeRenderer());
}
function $739f7f8c8d19c48c$var$isElectronNodeRenderer() {
    const process = $hsCGK.GLOBAL_OBJ.process;
    return process?.type === "renderer";
}
module.exports.isBrowser = $739f7f8c8d19c48c$var$isBrowser;

});
parcelRegister("lcp1M", function(module, exports) {
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5kWFc = parcelRequire("5kWFc");
function isNodeEnv() {
    return !$5kWFc.isBrowserBundle() && Object.prototype.toString.call(0) === "[object process]";
}
function dynamicRequire(mod, request) {
    return mod.require(request);
}
function loadModule(moduleName, existingModule = module) {
    let mod;
    try {
        mod = dynamicRequire(existingModule, moduleName);
    } catch  {}
    if (!mod) try {
        const { cwd } = dynamicRequire(existingModule, "process");
        mod = dynamicRequire(existingModule, `${cwd()}/node_modules/${moduleName}`);
    } catch  {}
    return mod;
}
exports.isNodeEnv = isNodeEnv;
exports.loadModule = loadModule;

});
parcelRegister("5kWFc", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $3e2c53593cad53aa$var$isBrowserBundle() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}
function $3e2c53593cad53aa$var$getSDKSource() {
    /*! __SENTRY_SDK_SOURCE__ */ return "npm";
}
module.exports.getSDKSource = $3e2c53593cad53aa$var$getSDKSource;
module.exports.isBrowserBundle = $3e2c53593cad53aa$var$isBrowserBundle;

});





parcelRegister("iTp6h", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $f8fWp = parcelRequire("f8fWp");

var $hbMFZ = parcelRequire("hbMFZ");

var $gjJ9A = parcelRequire("gjJ9A");

var $jCjMv = parcelRequire("jCjMv");

var $jix5p = parcelRequire("jix5p");

var $3k7kU = parcelRequire("3k7kU");

var $k7IIJ = parcelRequire("k7IIJ");

var $7q4WK = parcelRequire("7q4WK");

var $kvtg3 = parcelRequire("kvtg3");

var $9n8AY = parcelRequire("9n8AY");

var $JJBvC = parcelRequire("JJBvC");
const $dc10d570a64f8e88$var$MAX_METRIC_BUFFER_SIZE = 1e3;
function $dc10d570a64f8e88$var$setMetricAttribute(metricAttributes, key, value, setEvenIfPresent = true) {
    if (value && (setEvenIfPresent || !(key in metricAttributes))) metricAttributes[key] = value;
}
function $dc10d570a64f8e88$var$_INTERNAL_captureSerializedMetric(client, serializedMetric) {
    const bufferMap = $dc10d570a64f8e88$var$_getBufferMap();
    const metricBuffer = $dc10d570a64f8e88$var$_INTERNAL_getMetricBuffer(client);
    if (metricBuffer === void 0) bufferMap.set(client, [
        serializedMetric
    ]);
    else if (metricBuffer.length >= $dc10d570a64f8e88$var$MAX_METRIC_BUFFER_SIZE) {
        $dc10d570a64f8e88$var$_INTERNAL_flushMetricsBuffer(client, metricBuffer);
        bufferMap.set(client, [
            serializedMetric
        ]);
    } else bufferMap.set(client, [
        ...metricBuffer,
        serializedMetric
    ]);
}
function $dc10d570a64f8e88$var$_enrichMetricAttributes(beforeMetric, client, user) {
    const { release: release, environment: environment } = client.getOptions();
    const processedMetricAttributes = {
        ...beforeMetric.attributes
    };
    $dc10d570a64f8e88$var$setMetricAttribute(processedMetricAttributes, "user.id", user.id, false);
    $dc10d570a64f8e88$var$setMetricAttribute(processedMetricAttributes, "user.email", user.email, false);
    $dc10d570a64f8e88$var$setMetricAttribute(processedMetricAttributes, "user.name", user.username, false);
    $dc10d570a64f8e88$var$setMetricAttribute(processedMetricAttributes, "sentry.release", release);
    $dc10d570a64f8e88$var$setMetricAttribute(processedMetricAttributes, "sentry.environment", environment);
    const { name: name, version: version } = client.getSdkMetadata()?.sdk ?? {};
    $dc10d570a64f8e88$var$setMetricAttribute(processedMetricAttributes, "sentry.sdk.name", name);
    $dc10d570a64f8e88$var$setMetricAttribute(processedMetricAttributes, "sentry.sdk.version", version);
    const replay = client.getIntegrationByName("Replay");
    const replayId = replay?.getReplayId(true);
    $dc10d570a64f8e88$var$setMetricAttribute(processedMetricAttributes, "sentry.replay_id", replayId);
    if (replayId && replay?.getRecordingMode() === "buffer") $dc10d570a64f8e88$var$setMetricAttribute(processedMetricAttributes, "sentry._internal.replay_is_buffering", true);
    return {
        ...beforeMetric,
        attributes: processedMetricAttributes
    };
}
function $dc10d570a64f8e88$var$_buildSerializedMetric(metric, client, currentScope, scopeAttributes) {
    const [, traceContext] = $9n8AY._getTraceInfoFromScope(client, currentScope);
    const span = $k7IIJ._getSpanForScope(currentScope);
    const traceId = span ? span.spanContext().traceId : traceContext?.trace_id;
    const spanId = span ? span.spanContext().spanId : void 0;
    const timestamp = $7q4WK.timestampInSeconds();
    const sequenceAttr = $kvtg3.getSequenceAttribute(timestamp);
    return {
        timestamp: timestamp,
        trace_id: traceId ?? "",
        span_id: spanId,
        name: metric.name,
        type: metric.type,
        unit: metric.unit,
        value: metric.value,
        attributes: {
            ...$f8fWp.serializeAttributes(scopeAttributes),
            ...$f8fWp.serializeAttributes(metric.attributes, "skip-undefined"),
            [sequenceAttr.key]: sequenceAttr.value
        }
    };
}
function $dc10d570a64f8e88$var$_INTERNAL_captureMetric(beforeMetric, options) {
    const currentScope = options?.scope ?? $gjJ9A.getCurrentScope();
    const captureSerializedMetric = options?.captureSerializedMetric ?? $dc10d570a64f8e88$var$_INTERNAL_captureSerializedMetric;
    const client = currentScope?.getClient() ?? $gjJ9A.getClient();
    if (!client) {
        $jCjMv.DEBUG_BUILD && $jix5p.debug.warn("No client available to capture metric.");
        return;
    }
    const { _experiments: _experiments, enableMetrics: enableMetrics, beforeSendMetric: beforeSendMetric } = client.getOptions();
    const metricsEnabled = enableMetrics ?? _experiments?.enableMetrics ?? true;
    if (!metricsEnabled) {
        $jCjMv.DEBUG_BUILD && $jix5p.debug.warn("metrics option not enabled, metric will not be captured.");
        return;
    }
    const { user: user, attributes: scopeAttributes } = $3k7kU.getCombinedScopeData($gjJ9A.getIsolationScope(), currentScope);
    const enrichedMetric = $dc10d570a64f8e88$var$_enrichMetricAttributes(beforeMetric, client, user);
    client.emit("processMetric", enrichedMetric);
    const beforeSendCallback = beforeSendMetric || _experiments?.beforeSendMetric;
    const processedMetric = beforeSendCallback ? beforeSendCallback(enrichedMetric) : enrichedMetric;
    if (!processedMetric) {
        $jCjMv.DEBUG_BUILD && $jix5p.debug.log("`beforeSendMetric` returned `null`, will not send metric.");
        return;
    }
    const serializedMetric = $dc10d570a64f8e88$var$_buildSerializedMetric(processedMetric, client, currentScope, scopeAttributes);
    $jCjMv.DEBUG_BUILD && $jix5p.debug.log("[Metric]", serializedMetric);
    captureSerializedMetric(client, serializedMetric);
    client.emit("afterCaptureMetric", processedMetric);
}
function $dc10d570a64f8e88$var$_INTERNAL_flushMetricsBuffer(client, maybeMetricBuffer) {
    const metricBuffer = maybeMetricBuffer ?? $dc10d570a64f8e88$var$_INTERNAL_getMetricBuffer(client) ?? [];
    if (metricBuffer.length === 0) return;
    const clientOptions = client.getOptions();
    const envelope$1 = $JJBvC.createMetricEnvelope(metricBuffer, clientOptions._metadata, clientOptions.tunnel, client.getDsn(), client.getDataCollectionOptions().userInfo);
    $dc10d570a64f8e88$var$_getBufferMap().set(client, []);
    client.emit("flushMetrics");
    client.sendEnvelope(envelope$1);
}
function $dc10d570a64f8e88$var$_INTERNAL_getMetricBuffer(client) {
    return $dc10d570a64f8e88$var$_getBufferMap().get(client);
}
function $dc10d570a64f8e88$var$_getBufferMap() {
    return $hbMFZ.getGlobalSingleton("clientToMetricBufferMap", ()=>/* @__PURE__ */ new WeakMap());
}
module.exports._INTERNAL_captureMetric = $dc10d570a64f8e88$var$_INTERNAL_captureMetric;
module.exports._INTERNAL_captureSerializedMetric = $dc10d570a64f8e88$var$_INTERNAL_captureSerializedMetric;
module.exports._INTERNAL_flushMetricsBuffer = $dc10d570a64f8e88$var$_INTERNAL_flushMetricsBuffer;
module.exports._INTERNAL_getMetricBuffer = $dc10d570a64f8e88$var$_INTERNAL_getMetricBuffer;

});
parcelRegister("JJBvC", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $jypZc = parcelRequire("jypZc");

var $5fqIb = parcelRequire("5fqIb");

var $9Vsrl = parcelRequire("9Vsrl");
function $08979415e6d1f85b$var$createMetricContainerEnvelopeItem(items, inferUserData) {
    const inferSetting = inferUserData ? "auto" : "never";
    return [
        {
            type: "trace_metric",
            item_count: items.length,
            content_type: "application/vnd.sentry.items.trace-metric+json"
        },
        {
            version: 2,
            ...$9Vsrl.isBrowser() && {
                ingest_settings: {
                    infer_ip: inferSetting,
                    infer_user_agent: inferSetting
                }
            },
            items: items
        }
    ];
}
function $08979415e6d1f85b$var$createMetricEnvelope(metrics, metadata, tunnel, dsn$1, inferUserData) {
    const headers = {};
    if (metadata?.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn$1) headers.dsn = $jypZc.dsnToString(dsn$1);
    return $5fqIb.createEnvelope(headers, [
        $08979415e6d1f85b$var$createMetricContainerEnvelopeItem(metrics, inferUserData)
    ]);
}
module.exports.createMetricContainerEnvelopeItem = $08979415e6d1f85b$var$createMetricContainerEnvelopeItem;
module.exports.createMetricEnvelope = $08979415e6d1f85b$var$createMetricEnvelope;

});


parcelRegister("6hUzW", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9Vsrl = parcelRequire("9Vsrl");

var $lIOsi = parcelRequire("lIOsi");

var $3PlYy = parcelRequire("3PlYy");
function $494037f12c8f3f0a$var$extractGenAiSpansFromEvent(event, client) {
    if (event.type !== "transaction" || !event.spans?.length || !event.sdkProcessingMetadata?.hasGenAiSpans || !client.getOptions().streamGenAiSpans || $lIOsi.hasSpanStreamingEnabled(client)) return void 0;
    const genAiSpans = [];
    const remainingSpans = [];
    for (const span of event.spans)if (span.op?.startsWith("gen_ai.")) genAiSpans.push($3PlYy.spanJsonToSerializedStreamedSpan(span));
    else remainingSpans.push(span);
    if (genAiSpans.length === 0) return void 0;
    event.spans = remainingSpans;
    const inferSetting = client.getOptions().sendDefaultPii ? "auto" : "never";
    return [
        {
            type: "span",
            item_count: genAiSpans.length,
            content_type: "application/vnd.sentry.items.span.v2+json"
        },
        {
            version: 2,
            ...$9Vsrl.isBrowser() && {
                ingest_settings: {
                    infer_ip: inferSetting,
                    infer_user_agent: inferSetting
                }
            },
            items: genAiSpans
        }
    ];
}
module.exports.extractGenAiSpansFromEvent = $494037f12c8f3f0a$var$extractGenAiSpansFromEvent;

});
parcelRegister("3PlYy", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $2dG64 = parcelRequire("2dG64");
function $2c972e702ed1c227$var$spanJsonToSerializedStreamedSpan(span) {
    const streamedSpan = {
        trace_id: span.trace_id,
        span_id: span.span_id,
        parent_span_id: span.parent_span_id,
        name: span.description || "",
        start_timestamp: span.start_timestamp,
        end_timestamp: span.timestamp || span.start_timestamp,
        status: !span.status || span.status === "ok" || span.status === "cancelled" ? "ok" : "error",
        is_segment: false,
        attributes: {
            ...span.data
        },
        links: span.links
    };
    return $2dG64.streamedSpanJsonToSerializedSpan(streamedSpan);
}
module.exports.spanJsonToSerializedStreamedSpan = $2c972e702ed1c227$var$spanJsonToSerializedStreamedSpan;

});


parcelRegister("3XQ7d", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $jCjMv = parcelRequire("jCjMv");

var $jix5p = parcelRequire("jix5p");

var $5fqIb = parcelRequire("5fqIb");

var $9DgSh = parcelRequire("9DgSh");

var $a8HWQ = parcelRequire("a8HWQ");
const $2e2f4ed67036d23d$var$DEFAULT_TRANSPORT_BUFFER_SIZE = 64;
function $2e2f4ed67036d23d$var$createTransport(options, makeRequest, buffer = $9DgSh.makePromiseBuffer(options.bufferSize || $2e2f4ed67036d23d$var$DEFAULT_TRANSPORT_BUFFER_SIZE)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope$1) {
        const filteredEnvelopeItems = [];
        $5fqIb.forEachEnvelopeItem(envelope$1, (item, type)=>{
            const dataCategory = $5fqIb.envelopeItemTypeToDataCategory(type);
            if ($a8HWQ.isRateLimited(rateLimits, dataCategory)) options.recordDroppedEvent("ratelimit_backoff", dataCategory);
            else filteredEnvelopeItems.push(item);
        });
        if (filteredEnvelopeItems.length === 0) return Promise.resolve({});
        const filteredEnvelope = $5fqIb.createEnvelope(envelope$1[0], filteredEnvelopeItems);
        const recordEnvelopeLoss = (reason)=>{
            if ($5fqIb.envelopeContainsItemType(filteredEnvelope, [
                "client_report"
            ])) {
                $jCjMv.DEBUG_BUILD && $jix5p.debug.warn(`Dropping client report. Will not send outcomes (reason: ${reason}).`);
                return;
            }
            $5fqIb.forEachEnvelopeItem(filteredEnvelope, (item, type)=>{
                options.recordDroppedEvent(reason, $5fqIb.envelopeItemTypeToDataCategory(type));
            });
        };
        const requestTask = ()=>makeRequest({
                body: $5fqIb.serializeEnvelope(filteredEnvelope)
            }).then((response)=>{
                if (response.statusCode === 413) {
                    $jCjMv.DEBUG_BUILD && $jix5p.debug.error("Sentry responded with status code 413. Envelope was discarded due to exceeding size limits.");
                    recordEnvelopeLoss("send_error");
                    return response;
                }
                if ($jCjMv.DEBUG_BUILD && response.statusCode !== void 0 && (response.statusCode < 200 || response.statusCode >= 300)) $jix5p.debug.warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = $a8HWQ.updateRateLimits(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss("network_error");
                $jCjMv.DEBUG_BUILD && $jix5p.debug.error("Encountered error running transport request:", error);
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error === $9DgSh.SENTRY_BUFFER_FULL_ERROR) {
                $jCjMv.DEBUG_BUILD && $jix5p.debug.error("Skipped sending event because buffer is full.");
                recordEnvelopeLoss("queue_overflow");
                return Promise.resolve({});
            } else throw error;
        });
    }
    return {
        send: send,
        flush: flush
    };
}
module.exports.DEFAULT_TRANSPORT_BUFFER_SIZE = $2e2f4ed67036d23d$var$DEFAULT_TRANSPORT_BUFFER_SIZE;
module.exports.createTransport = $2e2f4ed67036d23d$var$createTransport;

});
parcelRegister("9DgSh", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8IgEN = parcelRequire("8IgEN");

var $f6Xap = parcelRequire("f6Xap");
const $7034d883c6725e13$var$SENTRY_BUFFER_FULL_ERROR = /* @__PURE__ */ Symbol.for("SentryBufferFullError");
function $7034d883c6725e13$var$makePromiseBuffer(limit = 100) {
    const buffer = /* @__PURE__ */ new Set();
    function isReady() {
        return buffer.size < limit;
    }
    function remove(task) {
        buffer.delete(task);
    }
    function add(taskProducer) {
        if (!isReady()) return $8IgEN.rejectedSyncPromise($7034d883c6725e13$var$SENTRY_BUFFER_FULL_ERROR);
        const task = taskProducer();
        buffer.add(task);
        task.then(()=>remove(task), ()=>remove(task));
        return task;
    }
    function drain(timeout) {
        if (!buffer.size) return $8IgEN.resolvedSyncPromise(true);
        const drainPromise = Promise.allSettled(Array.from(buffer)).then(()=>true);
        if (!timeout) return drainPromise;
        const promises = [
            drainPromise,
            new Promise((resolve)=>$f6Xap.safeUnref(setTimeout(()=>resolve(false), timeout)))
        ];
        return Promise.race(promises);
    }
    return {
        get $ () {
            return Array.from(buffer);
        },
        add: add,
        drain: drain
    };
}
module.exports.SENTRY_BUFFER_FULL_ERROR = $7034d883c6725e13$var$SENTRY_BUFFER_FULL_ERROR;
module.exports.makePromiseBuffer = $7034d883c6725e13$var$makePromiseBuffer;

});
parcelRegister("f6Xap", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $b0054fe2f7fc948e$var$safeUnref(timer) {
    if (typeof timer === "object" && typeof timer.unref === "function") timer.unref();
    return timer;
}
module.exports.safeUnref = $b0054fe2f7fc948e$var$safeUnref;

});


parcelRegister("a8HWQ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9xAUk = parcelRequire("9xAUk");
const $761cbde636ecefc8$var$DEFAULT_RETRY_AFTER = 60000;
function $761cbde636ecefc8$var$parseRetryAfterHeader(header, now = $9xAUk.safeDateNow()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1e3;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $761cbde636ecefc8$var$DEFAULT_RETRY_AFTER;
}
function $761cbde636ecefc8$var$disabledUntil(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
function $761cbde636ecefc8$var$isRateLimited(limits, dataCategory, now = $9xAUk.safeDateNow()) {
    return $761cbde636ecefc8$var$disabledUntil(limits, dataCategory) > now;
}
function $761cbde636ecefc8$var$updateRateLimits(limits, { statusCode: statusCode, headers: headers }, now = $9xAUk.safeDateNow()) {
    const updatedRateLimits = {
        ...limits
    };
    const rateLimitHeader = headers?.["x-sentry-rate-limits"];
    const retryAfterHeader = headers?.["retry-after"];
    if (rateLimitHeader) for (const limit of rateLimitHeader.trim().split(",")){
        const [retryAfter, categories, , , namespaces] = limit.split(":", 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1e3;
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(";")){
            if (category === "metric_bucket") {
                if (!namespaces || namespaces.split(";").includes("custom")) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $761cbde636ecefc8$var$parseRetryAfterHeader(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}
module.exports.DEFAULT_RETRY_AFTER = $761cbde636ecefc8$var$DEFAULT_RETRY_AFTER;
module.exports.disabledUntil = $761cbde636ecefc8$var$disabledUntil;
module.exports.isRateLimited = $761cbde636ecefc8$var$isRateLimited;
module.exports.parseRetryAfterHeader = $761cbde636ecefc8$var$parseRetryAfterHeader;
module.exports.updateRateLimits = $761cbde636ecefc8$var$updateRateLimits;

});


parcelRegister("8IqnM", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5fqIb = parcelRequire("5fqIb");

var $7q4WK = parcelRequire("7q4WK");
function $6586e5ceae34a17d$var$createClientReportEnvelope(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: "client_report"
        },
        {
            timestamp: timestamp || $7q4WK.dateTimestampInSeconds(),
            discarded_events: discarded_events
        }
    ];
    return $5fqIb.createEnvelope(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}
module.exports.createClientReportEnvelope = $6586e5ceae34a17d$var$createClientReportEnvelope;

});

parcelRegister("c8NRl", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $8d6ce8723e3be45c$var$getPossibleEventMessages(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    try {
        const lastException = event.exception.values[event.exception.values.length - 1];
        if (lastException?.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    } catch  {}
    return possibleMessages;
}
module.exports.getPossibleEventMessages = $8d6ce8723e3be45c$var$getPossibleEventMessages;

});

parcelRegister("cpquM", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3dwiN = parcelRequire("3dwiN");
function $908c5f48c5ec19ff$var$convertTransactionEventToSpanJson(event) {
    const { trace_id: trace_id, parent_span_id: parent_span_id, span_id: span_id, status: status, origin: origin, data: data, op: op } = event.contexts?.trace ?? {};
    return {
        data: data ?? {},
        description: event.transaction,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id ?? "",
        start_timestamp: event.start_timestamp ?? 0,
        status: status,
        timestamp: event.timestamp,
        trace_id: trace_id ?? "",
        origin: origin,
        profile_id: data?.[$3dwiN.SEMANTIC_ATTRIBUTE_PROFILE_ID],
        exclusive_time: data?.[$3dwiN.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME],
        measurements: event.measurements,
        is_segment: true
    };
}
function $908c5f48c5ec19ff$var$convertSpanJsonToTransactionEvent(span) {
    return {
        type: "transaction",
        timestamp: span.timestamp,
        start_timestamp: span.start_timestamp,
        transaction: span.description,
        contexts: {
            trace: {
                trace_id: span.trace_id,
                span_id: span.span_id,
                parent_span_id: span.parent_span_id,
                op: span.op,
                status: span.status,
                origin: span.origin,
                data: {
                    ...span.data,
                    ...span.profile_id && {
                        [$3dwiN.SEMANTIC_ATTRIBUTE_PROFILE_ID]: span.profile_id
                    },
                    ...span.exclusive_time && {
                        [$3dwiN.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME]: span.exclusive_time
                    }
                }
            }
        },
        measurements: span.measurements
    };
}
module.exports.convertSpanJsonToTransactionEvent = $908c5f48c5ec19ff$var$convertSpanJsonToTransactionEvent;
module.exports.convertTransactionEventToSpanJson = $908c5f48c5ec19ff$var$convertTransactionEventToSpanJson;

});

parcelRegister("hYGxQ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9Cooq = parcelRequire("9Cooq");
const $d1690ac97d8eae1c$var$DEFAULTS = {
    userInfo: false,
    cookies: true,
    httpHeaders: {
        request: true,
        response: true
    },
    httpBodies: [],
    queryParams: true,
    genAI: {
        inputs: true,
        outputs: true
    },
    stackFrameVariables: true,
    frameContextLines: 5
};
function $d1690ac97d8eae1c$var$resolveDataCollectionOptions(options) {
    const base = options.dataCollection != null ? $d1690ac97d8eae1c$var$DEFAULTS : $9Cooq.defaultPiiToCollectionOptions(options.sendDefaultPii);
    const dc = options.dataCollection ?? {};
    return {
        userInfo: dc.userInfo ?? base.userInfo,
        cookies: dc.cookies ?? base.cookies,
        httpHeaders: {
            request: dc.httpHeaders?.request ?? base.httpHeaders.request,
            response: dc.httpHeaders?.response ?? base.httpHeaders.response
        },
        httpBodies: dc.httpBodies ?? base.httpBodies,
        queryParams: dc.queryParams ?? base.queryParams,
        genAI: {
            inputs: dc.genAI?.inputs ?? base.genAI.inputs,
            outputs: dc.genAI?.outputs ?? base.genAI.outputs
        },
        stackFrameVariables: dc.stackFrameVariables ?? base.stackFrameVariables,
        frameContextLines: dc.frameContextLines ?? base.frameContextLines
    };
}
module.exports.resolveDataCollectionOptions = $d1690ac97d8eae1c$var$resolveDataCollectionOptions;

});
parcelRegister("9Cooq", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $iSrv6 = parcelRequire("iSrv6");
function $700a9597fd39a522$var$defaultPiiToCollectionOptions(sendDefaultPii) {
    return sendDefaultPii === true ? {
        userInfo: true,
        cookies: true,
        httpHeaders: {
            request: true,
            response: true
        },
        httpBodies: [
            "incomingRequest",
            "outgoingRequest",
            "incomingResponse",
            "outgoingResponse"
        ],
        queryParams: true,
        genAI: {
            inputs: true,
            outputs: true
        },
        stackFrameVariables: true,
        frameContextLines: 5
    } : {
        userInfo: false,
        cookies: {
            deny: $iSrv6.PII_HEADER_SNIPPETS
        },
        httpHeaders: {
            request: {
                deny: $iSrv6.PII_HEADER_SNIPPETS
            },
            response: {
                deny: $iSrv6.PII_HEADER_SNIPPETS
            }
        },
        httpBodies: [],
        queryParams: {
            deny: $iSrv6.PII_HEADER_SNIPPETS
        },
        genAI: {
            inputs: false,
            outputs: false
        },
        stackFrameVariables: true,
        frameContextLines: 5
    };
}
module.exports.defaultPiiToCollectionOptions = $700a9597fd39a522$var$defaultPiiToCollectionOptions;

});
parcelRegister("iSrv6", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $dbe29a3753776b33$var$FILTERED_VALUE = "[Filtered]";
const $dbe29a3753776b33$var$PII_HEADER_SNIPPETS = [
    "forwarded",
    "-ip",
    "remote-",
    "via",
    "-user"
];
const $dbe29a3753776b33$var$SENSITIVE_KEY_SNIPPETS = [
    "auth",
    "token",
    "secret",
    "session",
    // for the user_session cookie
    "password",
    "passwd",
    "pwd",
    "key",
    "jwt",
    "bearer",
    "sso",
    "saml",
    "csrf",
    "xsrf",
    "credentials",
    "sid",
    "identity",
    // Always treat cookie headers as sensitive in case individual key-value cookie pairs cannot properly be extracted
    "set-cookie",
    "cookie"
];
const $dbe29a3753776b33$var$SENSITIVE_COOKIE_NAME_SNIPPETS = [
    // Express / Connect default session cookie
    ".sid",
    // Opaque session ids (PHPSESSID, ASPSESSIONID*, BIGipServer*, *sessid*, …)
    "sessid",
    // Laravel etc. "remember me" tokens
    "remember",
    // OIDC / OAuth auxiliary (`oauth*` covered by header snippet `auth`)
    "oidc",
    "pkce",
    "nonce",
    // RFC 6265bis high-security cookie name prefixes
    "__secure-",
    "__host-",
    // Load balancer / CDN sticky-session cookies (opaque routing tokens)
    "awsalb",
    "awselb",
    "akamai",
    // BaaS / IdP session cookies (names often omit "session")
    "__stripe",
    "cognito",
    "firebase",
    "supabase",
    "sb-",
    // Step-up / MFA cookies
    "mfa",
    "2fa"
];
module.exports.FILTERED_VALUE = $dbe29a3753776b33$var$FILTERED_VALUE;
module.exports.PII_HEADER_SNIPPETS = $dbe29a3753776b33$var$PII_HEADER_SNIPPETS;
module.exports.SENSITIVE_COOKIE_NAME_SNIPPETS = $dbe29a3753776b33$var$SENSITIVE_COOKIE_NAME_SNIPPETS;
module.exports.SENSITIVE_KEY_SNIPPETS = $dbe29a3753776b33$var$SENSITIVE_KEY_SNIPPETS;

});




parcelRegister("15QgH", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gjJ9A = parcelRequire("gjJ9A");

var $jCjMv = parcelRequire("jCjMv");

var $jix5p = parcelRequire("jix5p");
function $0cbecd812e8c8f29$var$initAndBind(clientClass, options) {
    if (options.debug === true) {
        if ($jCjMv.DEBUG_BUILD) $jix5p.debug.enable();
        else $jix5p.consoleSandbox(()=>{
            console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
        });
    }
    const scope = $gjJ9A.getCurrentScope();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $0cbecd812e8c8f29$var$setCurrentClient(client);
    client.init();
    return client;
}
function $0cbecd812e8c8f29$var$setCurrentClient(client) {
    $gjJ9A.getCurrentScope().setClient(client);
}
module.exports.initAndBind = $0cbecd812e8c8f29$var$initAndBind;
module.exports.setCurrentClient = $0cbecd812e8c8f29$var$setCurrentClient;

});

parcelRegister("lk7k6", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $jCjMv = parcelRequire("jCjMv");

var $jix5p = parcelRequire("jix5p");

var $5fqIb = parcelRequire("5fqIb");

var $a8HWQ = parcelRequire("a8HWQ");

var $f6Xap = parcelRequire("f6Xap");
const $f861257b8430d8a4$var$MIN_DELAY = 100;
const $f861257b8430d8a4$var$START_DELAY = 5e3;
const $f861257b8430d8a4$var$MAX_DELAY = 36e5;
function $f861257b8430d8a4$var$makeOfflineTransport(createTransport) {
    function log(...args) {
        $jCjMv.DEBUG_BUILD && $jix5p.debug.log("[Offline]:", ...args);
    }
    return (options)=>{
        const transport = createTransport(options);
        if (!options.createStore) throw new Error("No `createStore` function was provided");
        const store = options.createStore(options);
        let retryDelay = $f861257b8430d8a4$var$START_DELAY;
        let flushTimer;
        function shouldQueue(env, error, retryDelay2) {
            if ($5fqIb.envelopeContainsItemType(env, [
                "client_report"
            ])) return false;
            if (options.shouldStore) return options.shouldStore(env, error, retryDelay2);
            return true;
        }
        function flushIn(delay) {
            if (flushTimer) clearTimeout(flushTimer);
            flushTimer = $f6Xap.safeUnref(setTimeout(async ()=>{
                flushTimer = void 0;
                const found = await store.shift();
                if (found) {
                    log("Attempting to send previously queued event");
                    found[0].sent_at = /* @__PURE__ */ new Date().toISOString();
                    send(found, true).catch((e)=>{
                        log("Failed to retry sending", e);
                    });
                }
            }, delay));
        }
        function flushWithBackOff() {
            if (flushTimer) return;
            flushIn(retryDelay);
            retryDelay = Math.min(retryDelay * 2, $f861257b8430d8a4$var$MAX_DELAY);
        }
        async function send(envelope$1, isRetry = false) {
            if (!isRetry && $5fqIb.envelopeContainsItemType(envelope$1, [
                "replay_event",
                "replay_recording"
            ])) {
                await store.push(envelope$1);
                flushIn($f861257b8430d8a4$var$MIN_DELAY);
                return {};
            }
            try {
                if (options.shouldSend && await options.shouldSend(envelope$1) === false) throw new Error("Envelope not sent because `shouldSend` callback returned false");
                const result = await transport.send(envelope$1);
                let delay = $f861257b8430d8a4$var$MIN_DELAY;
                if (result) {
                    if (result.headers?.["retry-after"]) delay = $a8HWQ.parseRetryAfterHeader(result.headers["retry-after"]);
                    else if (result.headers?.["x-sentry-rate-limits"]) delay = 6e4;
                    else if ((result.statusCode || 0) >= 400) return result;
                }
                flushIn(delay);
                retryDelay = $f861257b8430d8a4$var$START_DELAY;
                return result;
            } catch (e) {
                if (await shouldQueue(envelope$1, e, retryDelay)) {
                    if (isRetry) await store.unshift(envelope$1);
                    else await store.push(envelope$1);
                    flushWithBackOff();
                    log("Error sending. Event queued.", e);
                    return {};
                } else throw e;
            }
        }
        if (options.flushAtStartup) flushWithBackOff();
        return {
            send: send,
            flush: (timeout)=>{
                if (timeout === void 0) {
                    retryDelay = $f861257b8430d8a4$var$START_DELAY;
                    flushIn($f861257b8430d8a4$var$MIN_DELAY);
                }
                return transport.flush(timeout);
            }
        };
    };
}
module.exports.MIN_DELAY = $f861257b8430d8a4$var$MIN_DELAY;
module.exports.START_DELAY = $f861257b8430d8a4$var$START_DELAY;
module.exports.makeOfflineTransport = $f861257b8430d8a4$var$makeOfflineTransport;

});

parcelRegister("fEhTX", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $ezH6v = parcelRequire("ezH6v");

var $jypZc = parcelRequire("jypZc");

var $5fqIb = parcelRequire("5fqIb");
const $b6487a54fb3f5d0c$var$MULTIPLEXED_TRANSPORT_EXTRA_KEY = "MULTIPLEXED_TRANSPORT_EXTRA_KEY";
function $b6487a54fb3f5d0c$var$eventFromEnvelope(env, types) {
    let event;
    $5fqIb.forEachEnvelopeItem(env, (item, type)=>{
        if (types.includes(type)) event = Array.isArray(item) ? item[1] : void 0;
        return !!event;
    });
    return event;
}
function $b6487a54fb3f5d0c$var$makeOverrideReleaseTransport(createTransport, release) {
    return (options)=>{
        const transport = createTransport(options);
        return {
            ...transport,
            send: async (envelope)=>{
                const event = $b6487a54fb3f5d0c$var$eventFromEnvelope(envelope, [
                    "event",
                    "transaction",
                    "profile",
                    "replay_event"
                ]);
                if (event) event.release = release;
                return transport.send(envelope);
            }
        };
    };
}
function $b6487a54fb3f5d0c$var$overrideDsn(envelope$1, dsn) {
    return $5fqIb.createEnvelope(dsn ? {
        ...envelope$1[0],
        dsn: dsn
    } : envelope$1[0], envelope$1[1]);
}
function $b6487a54fb3f5d0c$var$makeMultiplexedTransport(createTransport, matcher) {
    return (options)=>{
        const fallbackTransport = createTransport(options);
        const otherTransports = /* @__PURE__ */ new Map();
        const actualMatcher = matcher || ((args)=>{
            const event = args.getEvent();
            if (event?.extra?.[$b6487a54fb3f5d0c$var$MULTIPLEXED_TRANSPORT_EXTRA_KEY] && Array.isArray(event.extra[$b6487a54fb3f5d0c$var$MULTIPLEXED_TRANSPORT_EXTRA_KEY])) return event.extra[$b6487a54fb3f5d0c$var$MULTIPLEXED_TRANSPORT_EXTRA_KEY];
            return [];
        });
        function getTransport(dsn$1, release) {
            const key = release ? `${dsn$1}:${release}` : dsn$1;
            let transport = otherTransports.get(key);
            if (!transport) {
                const validatedDsn = $jypZc.dsnFromString(dsn$1);
                if (!validatedDsn) return void 0;
                const url = $ezH6v.getEnvelopeEndpointWithUrlEncodedAuth(validatedDsn, options.tunnel);
                transport = release ? $b6487a54fb3f5d0c$var$makeOverrideReleaseTransport(createTransport, release)({
                    ...options,
                    url: url
                }) : createTransport({
                    ...options,
                    url: url
                });
                otherTransports.set(key, transport);
            }
            return [
                dsn$1,
                transport
            ];
        }
        async function send(envelope) {
            function getEvent(types) {
                const eventTypes = types?.length ? types : [
                    "event"
                ];
                return $b6487a54fb3f5d0c$var$eventFromEnvelope(envelope, eventTypes);
            }
            const transports = actualMatcher({
                envelope: envelope,
                getEvent: getEvent
            }).map((result)=>{
                if (typeof result === "string") return getTransport(result, void 0);
                else return getTransport(result.dsn, result.release);
            }).filter((t)=>!!t);
            const transportsWithFallback = transports.length ? transports : [
                [
                    "",
                    fallbackTransport
                ]
            ];
            const results = await Promise.all(transportsWithFallback.map(([dsn, transport])=>transport.send($b6487a54fb3f5d0c$var$overrideDsn(envelope, dsn))));
            return results[0];
        }
        async function flush(timeout) {
            const allTransports = [
                ...otherTransports.values(),
                fallbackTransport
            ];
            const results = await Promise.all(allTransports.map((transport)=>transport.flush(timeout)));
            return results.every((r)=>r);
        }
        return {
            send: send,
            flush: flush
        };
    };
}
module.exports.MULTIPLEXED_TRANSPORT_EXTRA_KEY = $b6487a54fb3f5d0c$var$MULTIPLEXED_TRANSPORT_EXTRA_KEY;
module.exports.eventFromEnvelope = $b6487a54fb3f5d0c$var$eventFromEnvelope;
module.exports.makeMultiplexedTransport = $b6487a54fb3f5d0c$var$makeMultiplexedTransport;

});

parcelRegister("8DGLQ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $jCjMv = parcelRequire("jCjMv");

var $jix5p = parcelRequire("jix5p");
const $64a32499acfe9c25$var$SKIPPED_AI_PROVIDERS = /* @__PURE__ */ new Set();
function $64a32499acfe9c25$var$_INTERNAL_skipAiProviderWrapping(modules) {
    modules.forEach((module)=>{
        $64a32499acfe9c25$var$SKIPPED_AI_PROVIDERS.add(module);
        $jCjMv.DEBUG_BUILD && $jix5p.debug.log(`AI provider "${module}" wrapping will be skipped`);
    });
}
function $64a32499acfe9c25$var$_INTERNAL_shouldSkipAiProviderWrapping(module) {
    return $64a32499acfe9c25$var$SKIPPED_AI_PROVIDERS.has(module);
}
function $64a32499acfe9c25$var$_INTERNAL_clearAiProviderSkips() {
    $64a32499acfe9c25$var$SKIPPED_AI_PROVIDERS.clear();
    $jCjMv.DEBUG_BUILD && $jix5p.debug.log("Cleared AI provider skip registrations");
}
module.exports._INTERNAL_clearAiProviderSkips = $64a32499acfe9c25$var$_INTERNAL_clearAiProviderSkips;
module.exports._INTERNAL_shouldSkipAiProviderWrapping = $64a32499acfe9c25$var$_INTERNAL_shouldSkipAiProviderWrapping;
module.exports._INTERNAL_skipAiProviderWrapping = $64a32499acfe9c25$var$_INTERNAL_skipAiProviderWrapping;

});

parcelRegister("btAkR", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $iSrv6 = parcelRequire("iSrv6");
function $85ae96a2668dc21d$var$isSensitiveKey(lower, denySnippets) {
    return denySnippets.some((snippet)=>lower.includes(snippet));
}
function $85ae96a2668dc21d$var$filterKeyValueData(data, behavior, additionalDenyTerms) {
    if (behavior === false) return {};
    const denySnippets = additionalDenyTerms != null ? [
        ...$iSrv6.SENSITIVE_KEY_SNIPPETS,
        ...additionalDenyTerms
    ] : $iSrv6.SENSITIVE_KEY_SNIPPETS;
    const result = {};
    if (behavior === true) {
        for (const key of Object.keys(data))result[key] = $85ae96a2668dc21d$var$isSensitiveKey(key.toLowerCase(), denySnippets) ? $iSrv6.FILTERED_VALUE : data[key];
        return result;
    }
    if ("deny" in behavior) {
        const lowerTerms2 = behavior.deny.map((t)=>t.toLowerCase());
        for (const key of Object.keys(data)){
            const lower = key.toLowerCase();
            const isDenied = $85ae96a2668dc21d$var$isSensitiveKey(lower, denySnippets) || lowerTerms2.some((term)=>lower.includes(term));
            result[key] = isDenied ? $iSrv6.FILTERED_VALUE : data[key];
        }
        return result;
    }
    const lowerTerms = behavior.allow.map((t)=>t.toLowerCase());
    for (const key of Object.keys(data)){
        const lower = key.toLowerCase();
        if ($85ae96a2668dc21d$var$isSensitiveKey(lower, denySnippets)) result[key] = $iSrv6.FILTERED_VALUE;
        else {
            const isAllowed = lowerTerms.some((term)=>lower.includes(term));
            result[key] = isAllowed ? data[key] : $iSrv6.FILTERED_VALUE;
        }
    }
    return result;
}
module.exports.filterKeyValueData = $85ae96a2668dc21d$var$filterKeyValueData;

});

parcelRegister("1gnzN", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $eWLQX = parcelRequire("eWLQX");

var $iSrv6 = parcelRequire("iSrv6");

var $btAkR = parcelRequire("btAkR");
function $0eb992d87f3d8d4b$var$filterCookies(cookieString, behavior) {
    if (behavior === false) return {};
    try {
        const parsed = $eWLQX.parseCookie(cookieString);
        if (Object.keys(parsed).length === 0) return {};
        return $btAkR.filterKeyValueData(parsed, behavior, $iSrv6.SENSITIVE_COOKIE_NAME_SNIPPETS);
    } catch  {
        return $iSrv6.FILTERED_VALUE;
    }
}
module.exports.filterCookies = $0eb992d87f3d8d4b$var$filterCookies;

});
parcelRegister("eWLQX", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $ae1b9a1cbbd96b77$var$parseCookie(str) {
    const obj = {};
    let index = 0;
    while(index < str.length){
        const eqIdx = str.indexOf("=", index);
        if (eqIdx === -1) break;
        let endIdx = str.indexOf(";", index);
        if (endIdx === -1) endIdx = str.length;
        else if (endIdx < eqIdx) {
            index = str.lastIndexOf(";", eqIdx - 1) + 1;
            continue;
        }
        const key = str.slice(index, eqIdx).trim();
        if (void 0 === obj[key]) {
            let val = str.slice(eqIdx + 1, endIdx).trim();
            if (val.charCodeAt(0) === 34) val = val.slice(1, -1);
            try {
                obj[key] = val.indexOf("%") !== -1 ? decodeURIComponent(val) : val;
            } catch  {
                obj[key] = val;
            }
        }
        index = endIdx + 1;
    }
    return obj;
}
module.exports.parseCookie = $ae1b9a1cbbd96b77$var$parseCookie;

});


parcelRegister("dCVJN", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $iSrv6 = parcelRequire("iSrv6");

var $btAkR = parcelRequire("btAkR");
function $9ebb9c7a3f5fde24$var$filterQueryParams(queryString, behavior) {
    if (behavior === false) return {};
    try {
        const params = new URLSearchParams(queryString);
        const parsed = {};
        params.forEach((value, key)=>{
            parsed[key] = value;
        });
        if (Object.keys(parsed).length === 0) return {};
        return $btAkR.filterKeyValueData(parsed, behavior);
    } catch  {
        return $iSrv6.FILTERED_VALUE;
    }
}
module.exports.filterQueryParams = $9ebb9c7a3f5fde24$var$filterQueryParams;

});

parcelRegister("9qZHH", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $6de667e0dd95f65f$var$FALSY_ENV_VALUES = /* @__PURE__ */ new Set([
    "false",
    "f",
    "n",
    "no",
    "off",
    "0"
]);
const $6de667e0dd95f65f$var$TRUTHY_ENV_VALUES = /* @__PURE__ */ new Set([
    "true",
    "t",
    "y",
    "yes",
    "on",
    "1"
]);
function $6de667e0dd95f65f$var$envToBool(value, options) {
    const normalized = String(value).toLowerCase();
    if ($6de667e0dd95f65f$var$FALSY_ENV_VALUES.has(normalized)) return false;
    if ($6de667e0dd95f65f$var$TRUTHY_ENV_VALUES.has(normalized)) return true;
    return options?.strict ? null : Boolean(value);
}
module.exports.FALSY_ENV_VALUES = $6de667e0dd95f65f$var$FALSY_ENV_VALUES;
module.exports.TRUTHY_ENV_VALUES = $6de667e0dd95f65f$var$TRUTHY_ENV_VALUES;
module.exports.envToBool = $6de667e0dd95f65f$var$envToBool;

});

parcelRegister("5ZEoH", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $jypZc = parcelRequire("jypZc");

var $5fqIb = parcelRequire("5fqIb");
function $45d1fc5be168c0a4$var$createCheckInEnvelope(checkIn, dynamicSamplingContext, metadata, tunnel, dsn$1) {
    const headers = {
        sent_at: /* @__PURE__ */ new Date().toISOString()
    };
    if (metadata?.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn$1) headers.dsn = $jypZc.dsnToString(dsn$1);
    if (dynamicSamplingContext) headers.trace = dynamicSamplingContext;
    const item = $45d1fc5be168c0a4$var$createCheckInEnvelopeItem(checkIn);
    return $5fqIb.createEnvelope(headers, [
        item
    ]);
}
function $45d1fc5be168c0a4$var$createCheckInEnvelopeItem(checkIn) {
    const checkInHeaders = {
        type: "check_in"
    };
    return [
        checkInHeaders,
        checkIn
    ];
}
module.exports.createCheckInEnvelope = $45d1fc5be168c0a4$var$createCheckInEnvelope;

});

parcelRegister("fsZ9V", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kipJA = parcelRequire("kipJA");
function $b428e9730d3dddb8$var$isSentryRequestUrl(url, client) {
    const dsn = client?.getDsn();
    const tunnel = client?.getOptions().tunnel;
    return $b428e9730d3dddb8$var$checkDsn(url, dsn) || $b428e9730d3dddb8$var$checkTunnel(url, tunnel);
}
function $b428e9730d3dddb8$var$checkTunnel(url, tunnel) {
    if (!tunnel) return false;
    return $b428e9730d3dddb8$var$removeTrailingSlash(url) === $b428e9730d3dddb8$var$removeTrailingSlash(tunnel);
}
function $b428e9730d3dddb8$var$checkDsn(url$1, dsn) {
    const urlParts = $kipJA.parseStringToURLObject(url$1);
    if (!urlParts || $kipJA.isURLObjectRelative(urlParts)) return false;
    if (!dsn) return false;
    return $b428e9730d3dddb8$var$hostnameMatchesDsnHost(urlParts.hostname, dsn.host) && /(^|&|\?)sentry_key=/.test(urlParts.search);
}
function $b428e9730d3dddb8$var$hostnameMatchesDsnHost(hostname, dsnHost) {
    return hostname === dsnHost || dsnHost.length > 0 && hostname.endsWith(`.${dsnHost}`);
}
function $b428e9730d3dddb8$var$removeTrailingSlash(str) {
    return str[str.length - 1] === "/" ? str.slice(0, -1) : str;
}
module.exports.isSentryRequestUrl = $b428e9730d3dddb8$var$isSentryRequestUrl;

});

parcelRegister("csMoB", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $912da3fbb9e0c2f5$var$parameterize(strings, ...values) {
    const formatted = new String(String.raw(strings, ...values));
    formatted.__sentry_template_string__ = strings.join("\0").replace(/%/g, "%%").replace(/\0/g, "%s");
    formatted.__sentry_template_values__ = values;
    return formatted;
}
const $912da3fbb9e0c2f5$var$fmt = $912da3fbb9e0c2f5$var$parameterize;
module.exports.fmt = $912da3fbb9e0c2f5$var$fmt;
module.exports.parameterize = $912da3fbb9e0c2f5$var$parameterize;

});

parcelRegister("ltYup", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $ezH6v = parcelRequire("ezH6v");

var $jix5p = parcelRequire("jix5p");

var $jypZc = parcelRequire("jypZc");

var $5fqIb = parcelRequire("5fqIb");
async function $fa3b3a60c7a98b56$var$handleTunnelRequest(options) {
    const { request: request, allowedDsns: allowedDsns } = options;
    if (allowedDsns.length === 0) return new Response("Tunnel not configured", {
        status: 500
    });
    const body = new Uint8Array(await request.arrayBuffer());
    let envelopeHeader;
    try {
        [envelopeHeader] = $5fqIb.parseEnvelope(body);
    } catch  {
        return new Response("Invalid envelope", {
            status: 400
        });
    }
    if (!envelopeHeader) return new Response("Invalid envelope: missing header", {
        status: 400
    });
    const dsn$1 = envelopeHeader.dsn;
    if (!dsn$1) return new Response("Invalid envelope: missing DSN", {
        status: 400
    });
    const isAllowed = allowedDsns.some((allowed)=>allowed === dsn$1);
    if (!isAllowed) {
        $jix5p.debug.warn(`Sentry tunnel: rejected request with unauthorized DSN (${dsn$1})`);
        return new Response("DSN not allowed", {
            status: 403
        });
    }
    const dsnComponents = $jypZc.makeDsn(dsn$1);
    if (!dsnComponents) {
        $jix5p.debug.warn(`Could not extract DSN Components from: ${dsn$1}`);
        return new Response("Invalid DSN", {
            status: 403
        });
    }
    const sentryIngestUrl = $ezH6v.getEnvelopeEndpointWithUrlEncodedAuth(dsnComponents);
    try {
        return await fetch(sentryIngestUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/x-sentry-envelope"
            },
            body: body
        });
    } catch (error) {
        $jix5p.debug.error("Sentry tunnel: failed to forward envelope", error);
        return new Response("Failed to forward envelope to Sentry", {
            status: 500
        });
    }
}
module.exports.handleTunnelRequest = $fa3b3a60c7a98b56$var$handleTunnelRequest;

});

parcelRegister("gIYVG", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $c2d004b3babfb8cf$var$addAutoIpAddressToUser(objWithMaybeUser) {
    if (objWithMaybeUser.user?.ip_address === void 0) objWithMaybeUser.user = {
        ...objWithMaybeUser.user,
        ip_address: "{{auto}}"
    };
}
function $c2d004b3babfb8cf$var$addAutoIpAddressToSession(session) {
    if ("aggregates" in session) {
        if (session.attrs?.["ip_address"] === void 0) session.attrs = {
            ...session.attrs,
            ip_address: "{{auto}}"
        };
    } else if (session.ipAddress === void 0) session.ipAddress = "{{auto}}";
}
module.exports.addAutoIpAddressToSession = $c2d004b3babfb8cf$var$addAutoIpAddressToSession;
module.exports.addAutoIpAddressToUser = $c2d004b3babfb8cf$var$addAutoIpAddressToUser;

});

parcelRegister("csEW0", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gywEi = parcelRequire("gywEi");
function $9127da4b25debf65$var$applySdkMetadata(options, name, names = [
    name
], source = "npm") {
    const sdk = (options._metadata = options._metadata || {}).sdk = options._metadata.sdk || {};
    if (!sdk.name) {
        sdk.name = `sentry.javascript.${name}`;
        sdk.packages = names.map((name2)=>({
                name: `${source}:@sentry/${name2}`,
                version: $gywEi.SDK_VERSION
            }));
        sdk.version = $gywEi.SDK_VERSION;
    }
}
module.exports.applySdkMetadata = $9127da4b25debf65$var$applySdkMetadata;

});

parcelRegister("Qbf2O", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $Up7k9 = parcelRequire("Up7k9");

var $hbMFZ = parcelRequire("hbMFZ");

var $gjJ9A = parcelRequire("gjJ9A");

var $8txOP = parcelRequire("8txOP");

var $jix5p = parcelRequire("jix5p");

var $2dG64 = parcelRequire("2dG64");

var $dkd4c = parcelRequire("dkd4c");

var $enaoN = parcelRequire("enaoN");

var $hiiHh = parcelRequire("hiiHh");
function $09cd93cd2e3c54b2$var$getTraceData(options = {}) {
    const client = options.client || $gjJ9A.getClient();
    if (!$8txOP.isEnabled() || !client) return {};
    const carrier$1 = $hbMFZ.getMainCarrier();
    const acs = $Up7k9.getAsyncContextStrategy(carrier$1);
    if (acs.getTraceData) return acs.getTraceData(options);
    const scope = options.scope || $gjJ9A.getCurrentScope();
    const span = options.span || $2dG64.getActiveSpan();
    if (!span && $gjJ9A.hasExternalPropagationContext()) return {};
    const sentryTrace = span ? $2dG64.spanToTraceHeader(span) : $09cd93cd2e3c54b2$var$scopeToTraceHeader(scope);
    const dsc = span ? $dkd4c.getDynamicSamplingContextFromSpan(span) : $dkd4c.getDynamicSamplingContextFromScope(client, scope);
    const baggage$1 = $enaoN.dynamicSamplingContextToSentryBaggageHeader(dsc);
    const isValidSentryTraceHeader = $hiiHh.TRACEPARENT_REGEXP.test(sentryTrace);
    if (!isValidSentryTraceHeader) {
        $jix5p.debug.warn("Invalid sentry-trace data. Cannot generate trace data");
        return {};
    }
    const traceData = {
        "sentry-trace": sentryTrace,
        baggage: baggage$1
    };
    if (options.propagateTraceparent) traceData.traceparent = span ? $2dG64.spanToTraceparentHeader(span) : $09cd93cd2e3c54b2$var$scopeToTraceparentHeader(scope);
    return traceData;
}
function $09cd93cd2e3c54b2$var$scopeToTraceHeader(scope) {
    const { traceId: traceId, sampled: sampled, propagationSpanId: propagationSpanId } = scope.getPropagationContext();
    return $hiiHh.generateSentryTraceHeader(traceId, propagationSpanId, sampled);
}
function $09cd93cd2e3c54b2$var$scopeToTraceparentHeader(scope) {
    const { traceId: traceId, sampled: sampled, propagationSpanId: propagationSpanId } = scope.getPropagationContext();
    return $hiiHh.generateTraceparentHeader(traceId, propagationSpanId, sampled);
}
module.exports.getTraceData = $09cd93cd2e3c54b2$var$getTraceData;

});

parcelRegister("7itcc", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $jCjMv = parcelRequire("jCjMv");

var $jix5p = parcelRequire("jix5p");

var $23Myp = parcelRequire("23Myp");
const $5500dc84ea75a82e$var$NOT_PROPAGATED_MESSAGE = "[Tracing] Not injecting trace data for url because it does not match tracePropagationTargets:";
function $5500dc84ea75a82e$var$shouldPropagateTraceForUrl(url, tracePropagationTargets, decisionMap) {
    if (typeof url !== "string" || !tracePropagationTargets) return true;
    const cachedDecision = decisionMap?.get(url);
    if (cachedDecision !== void 0) {
        $jCjMv.DEBUG_BUILD && !cachedDecision && $jix5p.debug.log($5500dc84ea75a82e$var$NOT_PROPAGATED_MESSAGE, url);
        return cachedDecision;
    }
    const decision = $23Myp.stringMatchesSomePattern(url, tracePropagationTargets);
    decisionMap?.set(url, decision);
    $jCjMv.DEBUG_BUILD && !decision && $jix5p.debug.log($5500dc84ea75a82e$var$NOT_PROPAGATED_MESSAGE, url);
    return decision;
}
module.exports.shouldPropagateTraceForUrl = $5500dc84ea75a82e$var$shouldPropagateTraceForUrl;

});

parcelRegister("4DgSG", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $Qbf2O = parcelRequire("Qbf2O");
function $35f7e626e99a676b$var$getTraceMetaTags(traceData$1) {
    return Object.entries(traceData$1 || $Qbf2O.getTraceData()).map(([key, value])=>`<meta name="${key}" content="${value}"/>`).join("\n");
}
module.exports.getTraceMetaTags = $35f7e626e99a676b$var$getTraceMetaTags;

});

parcelRegister("k0CHb", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $e911d2e0bd150010$var$debounce(func, wait, options) {
    let callbackReturnValue;
    let timerId;
    let maxTimerId;
    const maxWait = options?.maxWait ? Math.max(options.maxWait, wait) : 0;
    const setTimeoutImpl = options?.setTimeoutImpl || setTimeout;
    function invokeFunc() {
        cancelTimers();
        callbackReturnValue = func();
        return callbackReturnValue;
    }
    function cancelTimers() {
        timerId !== void 0 && clearTimeout(timerId);
        maxTimerId !== void 0 && clearTimeout(maxTimerId);
        timerId = maxTimerId = void 0;
    }
    function flush() {
        if (timerId !== void 0 || maxTimerId !== void 0) return invokeFunc();
        return callbackReturnValue;
    }
    function debounced() {
        if (timerId) clearTimeout(timerId);
        timerId = setTimeoutImpl(invokeFunc, wait);
        if (maxWait && maxTimerId === void 0) maxTimerId = setTimeoutImpl(invokeFunc, maxWait);
        return callbackReturnValue;
    }
    debounced.cancel = cancelTimers;
    debounced.flush = flush;
    return debounced;
}
module.exports.debounce = $e911d2e0bd150010$var$debounce;

});

parcelRegister("iMjbh", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $jCjMv = parcelRequire("jCjMv");

var $jix5p = parcelRequire("jix5p");

var $9Cooq = parcelRequire("9Cooq");

var $iSrv6 = parcelRequire("iSrv6");

var $btAkR = parcelRequire("btAkR");

var $f6Xap = parcelRequire("f6Xap");
const $dabb9699569d6762$var$MAX_BODY_BYTE_LENGTH = 1048576;
const $dabb9699569d6762$var$TEXT_CONTENT_TYPES = [
    "text/",
    "application/json",
    "application/x-www-form-urlencoded",
    "application/xml",
    "application/graphql"
];
function $dabb9699569d6762$var$getMaxBodyByteLength(maxRequestBodySize) {
    if (maxRequestBodySize === "small") return 1e3;
    if (maxRequestBodySize === "medium") return 1e4;
    return $dabb9699569d6762$var$MAX_BODY_BYTE_LENGTH;
}
function $dabb9699569d6762$var$winterCGHeadersToDict(winterCGHeaders) {
    const headers = {};
    try {
        winterCGHeaders.forEach((value, key)=>{
            if (typeof value === "string") headers[key] = value;
        });
    } catch  {}
    return headers;
}
function $dabb9699569d6762$var$headersToDict(reqHeaders) {
    const headers = /* @__PURE__ */ Object.create(null);
    try {
        Object.entries(reqHeaders).forEach(([key, value])=>{
            if (typeof value === "string") headers[key] = value;
            else if (typeof value === "number") headers[key] = String(value);
        });
    } catch  {}
    return headers;
}
function $dabb9699569d6762$var$winterCGRequestToRequestData(req) {
    const headers = $dabb9699569d6762$var$winterCGHeadersToDict(req.headers);
    return {
        method: req.method,
        url: req.url,
        query_string: $dabb9699569d6762$var$extractQueryParamsFromUrl(req.url),
        headers: headers
    };
}
function $dabb9699569d6762$var$isTextualContentType(contentType) {
    if (!contentType) return false;
    const lowerContentType = contentType.toLowerCase();
    return $dabb9699569d6762$var$TEXT_CONTENT_TYPES.some((type)=>lowerContentType.includes(type));
}
async function $dabb9699569d6762$var$captureBodyFromWinterCGRequest(request, isolationScope, maxRequestBodySize) {
    try {
        const contentType = request.headers.get("content-type");
        if (!$dabb9699569d6762$var$isTextualContentType(contentType)) {
            $jCjMv.DEBUG_BUILD && $jix5p.debug.log("Skipping body capture for non-textual content type:", contentType);
            return;
        }
        if (!request.body) return;
        const contentLength = request.headers.get("content-length");
        const maxBodySize = $dabb9699569d6762$var$getMaxBodyByteLength(maxRequestBodySize);
        if (contentLength) {
            const length = parseInt(contentLength, 10);
            if (!isNaN(length) && length > $dabb9699569d6762$var$MAX_BODY_BYTE_LENGTH) {
                $jCjMv.DEBUG_BUILD && $jix5p.debug.log("Skipping body capture: body too large", length);
                return;
            }
        }
        const clonedRequest = request.clone();
        const bodyPromise = clonedRequest.text();
        const timeoutPromise = new Promise((resolve)=>{
            $f6Xap.safeUnref(setTimeout(()=>resolve(null), 2e3));
        });
        const body = await Promise.race([
            bodyPromise,
            timeoutPromise
        ]);
        if (body === null) {
            $jCjMv.DEBUG_BUILD && $jix5p.debug.log("Timeout reading request body");
            return;
        }
        if (!body) return;
        const encoder = new TextEncoder();
        const bytes = encoder.encode(body);
        const bodyByteLength = bytes.length;
        let truncatedBody;
        if (bodyByteLength > maxBodySize) {
            const decoder = new TextDecoder();
            truncatedBody = `${decoder.decode(bytes.slice(0, maxBodySize - 3))}...`;
        } else truncatedBody = body;
        isolationScope.setSDKProcessingMetadata({
            normalizedRequest: {
                data: truncatedBody
            }
        });
        $jCjMv.DEBUG_BUILD && $jix5p.debug.log("Captured request body:", bodyByteLength, "bytes");
    } catch (error) {
        $jCjMv.DEBUG_BUILD && $jix5p.debug.error("Error capturing request body:", error);
    }
}
function $dabb9699569d6762$var$httpRequestToRequestData(request) {
    const headers = request.headers || {};
    const forwardedHost = typeof headers["x-forwarded-host"] === "string" ? headers["x-forwarded-host"] : void 0;
    const host = forwardedHost || (typeof headers.host === "string" ? headers.host : void 0);
    const forwardedProto = typeof headers["x-forwarded-proto"] === "string" ? headers["x-forwarded-proto"] : void 0;
    const protocol = forwardedProto || request.protocol || (request.socket?.encrypted ? "https" : "http");
    const url = request.url || "";
    const absoluteUrl = $dabb9699569d6762$var$getAbsoluteUrl({
        url: url,
        host: host,
        protocol: protocol
    });
    const data = request.body || void 0;
    const cookies = request.cookies;
    return {
        url: absoluteUrl,
        method: request.method,
        query_string: $dabb9699569d6762$var$extractQueryParamsFromUrl(url),
        headers: $dabb9699569d6762$var$headersToDict(headers),
        cookies: cookies,
        data: data
    };
}
function $dabb9699569d6762$var$getAbsoluteUrl({ url: url, protocol: protocol, host: host }) {
    if (url?.startsWith("http")) return url;
    if (url && host) return `${protocol}://${host}${url}`;
    return void 0;
}
function $dabb9699569d6762$var$httpHeadersToSpanAttributes(headers, dataCollection = false, lifecycle = "request") {
    const resolvedDataCollection = typeof dataCollection === "boolean" ? $9Cooq.defaultPiiToCollectionOptions(dataCollection) : dataCollection;
    const headerBehavior = lifecycle === "request" ? resolvedDataCollection.httpHeaders.request : resolvedDataCollection.httpHeaders.response;
    const cookieBehavior = resolvedDataCollection.cookies;
    const prefix = `http.${lifecycle}.header.`;
    const spanAttributes = {};
    try {
        const regularHeaders = {};
        for (const [key, value] of Object.entries(headers)){
            if (value == null) continue;
            const lowerKey = key.toLowerCase();
            const isCookieHeader = lowerKey === "cookie" || lowerKey === "set-cookie";
            if (isCookieHeader) {
                if (cookieBehavior === false) continue;
                if (typeof value === "string" && value !== "") {
                    const parsed = $dabb9699569d6762$var$parseCookieHeader(value, lowerKey === "set-cookie");
                    const filtered = $btAkR.filterKeyValueData(parsed, cookieBehavior, $iSrv6.SENSITIVE_COOKIE_NAME_SNIPPETS);
                    for (const [cookieKey, cookieValue] of Object.entries(filtered))spanAttributes[`${prefix}${$dabb9699569d6762$var$normalizeAttributeKey(lowerKey)}.${$dabb9699569d6762$var$normalizeAttributeKey(cookieKey)}`] = cookieValue;
                } else spanAttributes[`${prefix}${$dabb9699569d6762$var$normalizeAttributeKey(lowerKey)}`] = $iSrv6.FILTERED_VALUE;
            } else {
                if (headerBehavior === false) continue;
                if (Array.isArray(value)) regularHeaders[lowerKey] = value.map((v)=>v != null ? String(v) : v).join(";");
                else if (typeof value === "string") regularHeaders[lowerKey] = value;
            }
        }
        if (headerBehavior !== false) {
            const filtered = $btAkR.filterKeyValueData(regularHeaders, headerBehavior);
            for (const [headerKey, headerValue] of Object.entries(filtered))spanAttributes[`${prefix}${$dabb9699569d6762$var$normalizeAttributeKey(headerKey)}`] = headerValue;
        }
    } catch  {}
    return spanAttributes;
}
function $dabb9699569d6762$var$normalizeAttributeKey(key) {
    return key.replace(/-/g, "_");
}
function $dabb9699569d6762$var$parseCookieHeader(value, isSetCookie) {
    const semicolonIndex = value.indexOf(";");
    const cookieString = isSetCookie && semicolonIndex !== -1 ? value.substring(0, semicolonIndex) : value;
    const cookies = isSetCookie ? [
        cookieString
    ] : cookieString.split("; ");
    const result = {};
    for (const cookie of cookies){
        const equalSignIndex = cookie.indexOf("=");
        const cookieKey = (equalSignIndex !== -1 ? cookie.substring(0, equalSignIndex) : cookie).toLowerCase();
        const cookieValue = equalSignIndex !== -1 ? cookie.substring(equalSignIndex + 1) : "";
        result[cookieKey] = cookieValue;
    }
    return result;
}
function $dabb9699569d6762$var$extractQueryParamsFromUrl(url) {
    if (!url) return;
    try {
        const queryParams = new URL(url, "http://s.io").search.slice(1);
        return queryParams.length ? queryParams : void 0;
    } catch  {
        return void 0;
    }
}
module.exports.MAX_BODY_BYTE_LENGTH = $dabb9699569d6762$var$MAX_BODY_BYTE_LENGTH;
module.exports.captureBodyFromWinterCGRequest = $dabb9699569d6762$var$captureBodyFromWinterCGRequest;
module.exports.extractQueryParamsFromUrl = $dabb9699569d6762$var$extractQueryParamsFromUrl;
module.exports.getMaxBodyByteLength = $dabb9699569d6762$var$getMaxBodyByteLength;
module.exports.headersToDict = $dabb9699569d6762$var$headersToDict;
module.exports.httpHeadersToSpanAttributes = $dabb9699569d6762$var$httpHeadersToSpanAttributes;
module.exports.httpRequestToRequestData = $dabb9699569d6762$var$httpRequestToRequestData;
module.exports.winterCGHeadersToDict = $dabb9699569d6762$var$winterCGHeadersToDict;
module.exports.winterCGRequestToRequestData = $dabb9699569d6762$var$winterCGRequestToRequestData;

});

parcelRegister("75yrz", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gjJ9A = parcelRequire("gjJ9A");

var $jix5p = parcelRequire("jix5p");

var $7q4WK = parcelRequire("7q4WK");
const $5293b7cf6fcd3106$var$DEFAULT_BREADCRUMBS = 100;
function $5293b7cf6fcd3106$var$addBreadcrumb(breadcrumb, hint) {
    const client = $gjJ9A.getClient();
    const isolationScope = $gjJ9A.getIsolationScope();
    if (!client) return;
    const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $5293b7cf6fcd3106$var$DEFAULT_BREADCRUMBS } = client.getOptions();
    if (maxBreadcrumbs <= 0) return;
    const timestamp = $7q4WK.dateTimestampInSeconds();
    const mergedBreadcrumb = {
        timestamp: timestamp,
        ...breadcrumb
    };
    const finalBreadcrumb = beforeBreadcrumb ? $jix5p.consoleSandbox(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
    if (finalBreadcrumb === null) return;
    if (client.emit) client.emit("beforeAddBreadcrumb", finalBreadcrumb, hint);
    isolationScope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
}
module.exports.addBreadcrumb = $5293b7cf6fcd3106$var$addBreadcrumb;

});

parcelRegister("jJ1ed", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gjJ9A = parcelRequire("gjJ9A");

var $5QaR1 = parcelRequire("5QaR1");

var $2SQtm = parcelRequire("2SQtm");
let $e5c32c32a5938901$var$originalFunctionToString;
const $e5c32c32a5938901$var$INTEGRATION_NAME = "FunctionToString";
const $e5c32c32a5938901$var$SETUP_CLIENTS = /* @__PURE__ */ new WeakMap();
const $e5c32c32a5938901$var$_functionToStringIntegration = ()=>{
    return {
        name: $e5c32c32a5938901$var$INTEGRATION_NAME,
        setupOnce () {
            $e5c32c32a5938901$var$originalFunctionToString = Function.prototype.toString;
            try {
                Function.prototype.toString = function(...args) {
                    const originalFunction = $2SQtm.getOriginalFunction(this);
                    const context = $e5c32c32a5938901$var$SETUP_CLIENTS.has($gjJ9A.getClient()) && originalFunction !== void 0 ? originalFunction : this;
                    return $e5c32c32a5938901$var$originalFunctionToString.apply(context, args);
                };
            } catch  {}
        },
        setup (client) {
            $e5c32c32a5938901$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
const $e5c32c32a5938901$var$functionToStringIntegration = $5QaR1.defineIntegration($e5c32c32a5938901$var$_functionToStringIntegration);
module.exports.functionToStringIntegration = $e5c32c32a5938901$var$functionToStringIntegration;

});

parcelRegister("3VZtP", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $jCjMv = parcelRequire("jCjMv");

var $5QaR1 = parcelRequire("5QaR1");

var $jix5p = parcelRequire("jix5p");

var $c8NRl = parcelRequire("c8NRl");

var $k6pIc = parcelRequire("k6pIc");

var $23Myp = parcelRequire("23Myp");
const $2dd662a6e02d17fc$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    // The browser logs this when a ResizeObserver handler takes a bit longer. Usually this is not an actual issue though. It indicates slowness.
    /^Cannot redefine property: googletag$/,
    // This is thrown when google tag manager is used in combination with an ad blocker
    /^Can't find variable: gmo$/,
    // Error from Google Search App https://issuetracker.google.com/issues/396043331
    /^undefined is not an object \(evaluating 'a\.[A-Z]'\)$/,
    // Random error that happens but not actionable or noticeable to end-users.
    /can't redefine non-configurable property "solana"/,
    // Probably a browser extension or custom browser (Brave) throwing this error
    /vv\(\)\.getRestrictions is not a function/,
    // Error thrown by GTM, seemingly not affecting end-users
    /Can't find variable: _AutofillCallbackHandler/,
    // Unactionable error in instagram webview https://developers.facebook.com/community/threads/320013549791141/
    /Object Not Found Matching Id:\d+, MethodName:simulateEvent/,
    // unactionable error from CEFSharp, a .NET library that embeds chromium in .NET apps
    /^Java exception was raised during method invocation$/
];
const $2dd662a6e02d17fc$var$INTEGRATION_NAME = "EventFilters";
const $2dd662a6e02d17fc$var$eventFiltersIntegration = $5QaR1.defineIntegration((options = {})=>{
    let mergedOptions;
    return {
        name: $2dd662a6e02d17fc$var$INTEGRATION_NAME,
        setup (client) {
            const clientOptions = client.getOptions();
            mergedOptions = $2dd662a6e02d17fc$var$_mergeOptions(options, clientOptions);
        },
        processEvent (event, _hint, client) {
            if (!mergedOptions) {
                const clientOptions = client.getOptions();
                mergedOptions = $2dd662a6e02d17fc$var$_mergeOptions(options, clientOptions);
            }
            return $2dd662a6e02d17fc$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
});
const $2dd662a6e02d17fc$var$inboundFiltersIntegration = $5QaR1.defineIntegration((options = {})=>{
    return {
        ...$2dd662a6e02d17fc$var$eventFiltersIntegration(options),
        name: "InboundFilters"
    };
});
function $2dd662a6e02d17fc$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $2dd662a6e02d17fc$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || []
        ]
    };
}
function $2dd662a6e02d17fc$var$_shouldDropEvent(event, options) {
    if (!event.type) {
        if ($2dd662a6e02d17fc$var$_isIgnoredError(event, options.ignoreErrors)) {
            $jCjMv.DEBUG_BUILD && $jix5p.debug.warn(`Event dropped due to being matched by \`ignoreErrors\` option.
Event: ${$k6pIc.getEventDescription(event)}`);
            return true;
        }
        if ($2dd662a6e02d17fc$var$_isUselessError(event)) {
            $jCjMv.DEBUG_BUILD && $jix5p.debug.warn(`Event dropped due to not having an error message, error type or stacktrace.
Event: ${$k6pIc.getEventDescription(event)}`);
            return true;
        }
        if ($2dd662a6e02d17fc$var$_isDeniedUrl(event, options.denyUrls)) {
            $jCjMv.DEBUG_BUILD && $jix5p.debug.warn(`Event dropped due to being matched by \`denyUrls\` option.
Event: ${$k6pIc.getEventDescription(event)}.
Url: ${$2dd662a6e02d17fc$var$_getEventFilterUrl(event)}`);
            return true;
        }
        if (!$2dd662a6e02d17fc$var$_isAllowedUrl(event, options.allowUrls)) {
            $jCjMv.DEBUG_BUILD && $jix5p.debug.warn(`Event dropped due to not being matched by \`allowUrls\` option.
Event: ${$k6pIc.getEventDescription(event)}.
Url: ${$2dd662a6e02d17fc$var$_getEventFilterUrl(event)}`);
            return true;
        }
    } else if (event.type === "transaction") {
        if ($2dd662a6e02d17fc$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
            $jCjMv.DEBUG_BUILD && $jix5p.debug.warn(`Event dropped due to being matched by \`ignoreTransactions\` option.
Event: ${$k6pIc.getEventDescription(event)}`);
            return true;
        }
    }
    return false;
}
function $2dd662a6e02d17fc$var$_isIgnoredError(event, ignoreErrors) {
    if (!ignoreErrors?.length) return false;
    return $c8NRl.getPossibleEventMessages(event).some((message)=>$23Myp.stringMatchesSomePattern(message, ignoreErrors));
}
function $2dd662a6e02d17fc$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (!ignoreTransactions?.length) return false;
    const name = event.transaction;
    return name ? $23Myp.stringMatchesSomePattern(name, ignoreTransactions) : false;
}
function $2dd662a6e02d17fc$var$_isDeniedUrl(event, denyUrls) {
    if (!denyUrls?.length) return false;
    const url = $2dd662a6e02d17fc$var$_getEventFilterUrl(event);
    return !url ? false : $23Myp.stringMatchesSomePattern(url, denyUrls);
}
function $2dd662a6e02d17fc$var$_isAllowedUrl(event, allowUrls) {
    if (!allowUrls?.length) return true;
    const url = $2dd662a6e02d17fc$var$_getEventFilterUrl(event);
    return !url ? true : $23Myp.stringMatchesSomePattern(url, allowUrls);
}
function $2dd662a6e02d17fc$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== "<anonymous>" && frame.filename !== "[native code]") return frame.filename || null;
    }
    return null;
}
function $2dd662a6e02d17fc$var$_getEventFilterUrl(event) {
    try {
        const rootException = [
            ...event.exception?.values ?? []
        ].reverse().find((value)=>value.mechanism?.parent_id === void 0 && value.stacktrace?.frames?.length);
        const frames = rootException?.stacktrace?.frames;
        return frames ? $2dd662a6e02d17fc$var$_getLastValidUrl(frames) : null;
    } catch  {
        $jCjMv.DEBUG_BUILD && $jix5p.debug.error(`Cannot extract url for event ${$k6pIc.getEventDescription(event)}`);
        return null;
    }
}
function $2dd662a6e02d17fc$var$_isUselessError(event) {
    if (!event.exception?.values?.length) return false;
    return(// No top-level message
    !event.message && // There are no exception values that have a stacktrace, a non-generic-Error type or value
    !event.exception.values.some((value)=>value.stacktrace || value.type && value.type !== "Error" || value.value));
}
module.exports.eventFiltersIntegration = $2dd662a6e02d17fc$var$eventFiltersIntegration;
module.exports.inboundFiltersIntegration = $2dd662a6e02d17fc$var$inboundFiltersIntegration;

});

parcelRegister("iZK6v", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5QaR1 = parcelRequire("5QaR1");

var $5y6zC = parcelRequire("5y6zC");

var $bjI1e = parcelRequire("bjI1e");
const $dd41afc1441755ca$var$DEFAULT_KEY = "cause";
const $dd41afc1441755ca$var$DEFAULT_LIMIT = 5;
const $dd41afc1441755ca$var$INTEGRATION_NAME = "LinkedErrors";
const $dd41afc1441755ca$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $dd41afc1441755ca$var$DEFAULT_LIMIT;
    const key = options.key || $dd41afc1441755ca$var$DEFAULT_KEY;
    return {
        name: $dd41afc1441755ca$var$INTEGRATION_NAME,
        preprocessEvent (event, hint, client) {
            const options2 = client.getOptions();
            $5y6zC.applyAggregateErrorsToEvent($bjI1e.exceptionFromError, options2.stackParser, key, limit, event, hint);
        }
    };
};
const $dd41afc1441755ca$var$linkedErrorsIntegration = $5QaR1.defineIntegration($dd41afc1441755ca$var$_linkedErrorsIntegration);
module.exports.linkedErrorsIntegration = $dd41afc1441755ca$var$linkedErrorsIntegration;

});
parcelRegister("5y6zC", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $fBPG6 = parcelRequire("fBPG6");
function $40a53a1687dcff3b$var$applyAggregateErrorsToEvent(exceptionFromErrorImplementation, parser, key, limit, event, hint) {
    if (!event.exception?.values || !hint || !$fBPG6.isInstanceOf(hint.originalException, Error)) return;
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : void 0;
    if (originalException) event.exception.values = $40a53a1687dcff3b$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0);
}
function $40a53a1687dcff3b$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    if ($fBPG6.isInstanceOf(error[key], Error)) {
        $40a53a1687dcff3b$var$applyExceptionGroupFieldsForParentException(exception, exceptionId, error);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $40a53a1687dcff3b$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $40a53a1687dcff3b$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    if ($40a53a1687dcff3b$var$isExceptionGroup(error)) error.errors.forEach((childError, i)=>{
        if ($fBPG6.isInstanceOf(childError, Error)) {
            $40a53a1687dcff3b$var$applyExceptionGroupFieldsForParentException(exception, exceptionId, error);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $40a53a1687dcff3b$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $40a53a1687dcff3b$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $40a53a1687dcff3b$var$isExceptionGroup(error) {
    return Array.isArray(error.errors);
}
function $40a53a1687dcff3b$var$applyExceptionGroupFieldsForParentException(exception, exceptionId, error) {
    exception.mechanism = {
        handled: true,
        type: "auto.core.linked_errors",
        ...$40a53a1687dcff3b$var$isExceptionGroup(error) && {
            is_exception_group: true
        },
        ...exception.mechanism,
        exception_id: exceptionId
    };
}
function $40a53a1687dcff3b$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    exception.mechanism = {
        handled: true,
        ...exception.mechanism,
        type: "chained",
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}
module.exports.applyAggregateErrorsToEvent = $40a53a1687dcff3b$var$applyAggregateErrorsToEvent;

});

parcelRegister("bjI1e", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $fBPG6 = parcelRequire("fBPG6");

var $k6pIc = parcelRequire("k6pIc");

var $bg87c = parcelRequire("bg87c");

var $2SQtm = parcelRequire("2SQtm");
function $83d39d4346fe0577$var$parseStackFrames(stackParser, error) {
    return stackParser(error.stack || "", 1);
}
function $83d39d4346fe0577$var$hasSentryFetchUrlHost(error) {
    return $fBPG6.isError(error) && "__sentry_fetch_url_host__" in error && typeof error.__sentry_fetch_url_host__ === "string";
}
function $83d39d4346fe0577$var$_enhanceErrorWithSentryInfo(error) {
    if ($83d39d4346fe0577$var$hasSentryFetchUrlHost(error)) return `${error.message} (${error.__sentry_fetch_url_host__})`;
    return error.message;
}
function $83d39d4346fe0577$var$exceptionFromError(stackParser, error) {
    const exception = {
        type: error.name || error.constructor.name,
        value: $83d39d4346fe0577$var$_enhanceErrorWithSentryInfo(error)
    };
    const frames = $83d39d4346fe0577$var$parseStackFrames(stackParser, error);
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    return exception;
}
function $83d39d4346fe0577$var$getErrorPropertyFromObject(obj) {
    for(const prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        const value = obj[prop];
        if (value instanceof Error) return value;
    }
    return void 0;
}
function $83d39d4346fe0577$var$getMessageForObject(exception) {
    if ("name" in exception && typeof exception.name === "string") {
        let message = `'${exception.name}' captured as exception`;
        if ("message" in exception && typeof exception.message === "string") message += ` with message '${exception.message}'`;
        return message;
    } else if ("message" in exception && typeof exception.message === "string") return exception.message;
    const keys = $2SQtm.extractExceptionKeysForMessage(exception);
    if ($fBPG6.isErrorEvent(exception)) return `Event \`ErrorEvent\` captured as exception with message \`${exception.message}\``;
    const className = $83d39d4346fe0577$var$getObjectClassName(exception);
    return `${className && className !== "Object" ? `'${className}'` : "Object"} captured as exception with keys: ${keys}`;
}
function $83d39d4346fe0577$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : void 0;
    } catch  {}
}
function $83d39d4346fe0577$var$getException(client, mechanism, exception, hint) {
    if ($fBPG6.isError(exception)) return [
        exception,
        void 0
    ];
    mechanism.synthetic = true;
    if ($fBPG6.isPlainObject(exception)) {
        const normalizeDepth = client?.getOptions().normalizeDepth;
        const extras = {
            ["__serialized__"]: $bg87c.normalizeToSize(exception, normalizeDepth)
        };
        const errorFromProp = $83d39d4346fe0577$var$getErrorPropertyFromObject(exception);
        if (errorFromProp) return [
            errorFromProp,
            extras
        ];
        const message = $83d39d4346fe0577$var$getMessageForObject(exception);
        const ex2 = hint?.syntheticException || new Error(message);
        ex2.message = message;
        return [
            ex2,
            extras
        ];
    }
    const ex = hint?.syntheticException || new Error(exception);
    ex.message = `${exception}`;
    return [
        ex,
        void 0
    ];
}
function $83d39d4346fe0577$var$eventFromUnknownInput(client, stackParser, exception, hint) {
    const providedMechanism = hint?.data && hint.data.mechanism;
    const mechanism = providedMechanism || {
        handled: true,
        type: "generic"
    };
    const [ex, extras] = $83d39d4346fe0577$var$getException(client, mechanism, exception, hint);
    const event = {
        exception: {
            values: [
                $83d39d4346fe0577$var$exceptionFromError(stackParser, ex)
            ]
        }
    };
    if (extras) event.extra = extras;
    $k6pIc.addExceptionTypeValue(event, void 0, void 0);
    $k6pIc.addExceptionMechanism(event, mechanism);
    return {
        ...event,
        event_id: hint?.event_id
    };
}
function $83d39d4346fe0577$var$eventFromMessage(stackParser, message, level = "info", hint, attachStacktrace) {
    const event = {
        event_id: hint?.event_id,
        level: level
    };
    if (attachStacktrace && hint?.syntheticException) {
        const frames = $83d39d4346fe0577$var$parseStackFrames(stackParser, hint.syntheticException);
        if (frames.length) {
            event.exception = {
                values: [
                    {
                        value: message,
                        stacktrace: {
                            frames: frames
                        }
                    }
                ]
            };
            $k6pIc.addExceptionMechanism(event, {
                synthetic: true
            });
        }
    }
    if ($fBPG6.isParameterizedString(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
module.exports._enhanceErrorWithSentryInfo = $83d39d4346fe0577$var$_enhanceErrorWithSentryInfo;
module.exports.eventFromMessage = $83d39d4346fe0577$var$eventFromMessage;
module.exports.eventFromUnknownInput = $83d39d4346fe0577$var$eventFromUnknownInput;
module.exports.exceptionFromError = $83d39d4346fe0577$var$exceptionFromError;
module.exports.parseStackFrames = $83d39d4346fe0577$var$parseStackFrames;

});


parcelRegister("5c0E9", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5QaR1 = parcelRequire("5QaR1");

var $2ETn4 = parcelRequire("2ETn4");

var $5fqIb = parcelRequire("5fqIb");
const $3c7e932319882ec8$var$moduleMetadataIntegration = $5QaR1.defineIntegration(()=>{
    return {
        name: "ModuleMetadata",
        setup (client) {
            client.on("beforeEnvelope", (envelope$1)=>{
                $5fqIb.forEachEnvelopeItem(envelope$1, (item, type)=>{
                    if (type === "event") {
                        const event = Array.isArray(item) ? item[1] : void 0;
                        if (event) {
                            $2ETn4.stripMetadataFromStackFrames(event);
                            item[1] = event;
                        }
                    }
                });
            });
            client.on("applyFrameMetadata", (event)=>{
                if (event.type) return;
                const stackParser = client.getOptions().stackParser;
                $2ETn4.addMetadataToStackFrames(stackParser, event);
            });
        }
    };
});
module.exports.moduleMetadataIntegration = $3c7e932319882ec8$var$moduleMetadataIntegration;

});
parcelRegister("2ETn4", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hsCGK = parcelRequire("hsCGK");
const $1efa44b9eb849499$var$filenameMetadataMap = /* @__PURE__ */ new Map();
const $1efa44b9eb849499$var$parsedStacks = /* @__PURE__ */ new Set();
function $1efa44b9eb849499$var$getFilenameToMetadataMap(parser) {
    if (!$hsCGK.GLOBAL_OBJ._sentryModuleMetadata) return {};
    const filenameMap = {};
    for (const stack of Object.keys($hsCGK.GLOBAL_OBJ._sentryModuleMetadata)){
        const metadata = $hsCGK.GLOBAL_OBJ._sentryModuleMetadata[stack];
        const frames = parser(stack);
        for (const frame of frames.reverse())if (frame.filename) {
            filenameMap[frame.filename] = metadata;
            break;
        }
    }
    return filenameMap;
}
function $1efa44b9eb849499$var$ensureMetadataStacksAreParsed(parser) {
    if (!$hsCGK.GLOBAL_OBJ._sentryModuleMetadata) return;
    for (const stack of Object.keys($hsCGK.GLOBAL_OBJ._sentryModuleMetadata)){
        const metadata = $hsCGK.GLOBAL_OBJ._sentryModuleMetadata[stack];
        if ($1efa44b9eb849499$var$parsedStacks.has(stack)) continue;
        $1efa44b9eb849499$var$parsedStacks.add(stack);
        const frames = parser(stack);
        for (const frame of frames.reverse())if (frame.filename) {
            $1efa44b9eb849499$var$filenameMetadataMap.set(frame.filename, metadata);
            break;
        }
    }
}
function $1efa44b9eb849499$var$getMetadataForUrl(parser, filename) {
    $1efa44b9eb849499$var$ensureMetadataStacksAreParsed(parser);
    return $1efa44b9eb849499$var$filenameMetadataMap.get(filename);
}
function $1efa44b9eb849499$var$addMetadataToStackFrames(parser, event) {
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (!frame.filename || frame.module_metadata) return;
            const metadata = $1efa44b9eb849499$var$getMetadataForUrl(parser, frame.filename);
            if (metadata) frame.module_metadata = metadata;
        });
    });
}
function $1efa44b9eb849499$var$stripMetadataFromStackFrames(event) {
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            delete frame.module_metadata;
        });
    });
}
module.exports.addMetadataToStackFrames = $1efa44b9eb849499$var$addMetadataToStackFrames;
module.exports.getFilenameToMetadataMap = $1efa44b9eb849499$var$getFilenameToMetadataMap;
module.exports.getMetadataForUrl = $1efa44b9eb849499$var$getMetadataForUrl;
module.exports.stripMetadataFromStackFrames = $1efa44b9eb849499$var$stripMetadataFromStackFrames;

});


parcelRegister("j0HbT", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gjJ9A = parcelRequire("gjJ9A");

var $5QaR1 = parcelRequire("5QaR1");

var $3dwiN = parcelRequire("3dwiN");

var $eWLQX = parcelRequire("eWLQX");

var $iMjbh = parcelRequire("iMjbh");

var $hUrwV = parcelRequire("hUrwV");

var $1N6Mo = parcelRequire("1N6Mo");
const $dd6f8535eae636ab$var$INTEGRATION_NAME = "RequestData";
const $dd6f8535eae636ab$var$_requestDataIntegration = (options = {})=>{
    function resolveIncludeAndDataCollection(client) {
        const dc = client.getDataCollectionOptions();
        const dataCollection = {
            ...dc,
            ...options.include?.cookies === true && dc.cookies === false && {
                cookies: true
            },
            ...options.include?.headers === true && dc.httpHeaders.request === false && {
                httpHeaders: {
                    ...dc.httpHeaders,
                    request: true
                }
            }
        };
        return {
            dataCollection: dataCollection,
            include: {
                cookies: dataCollection.cookies !== false,
                // Always attach body data that's already on the scope — dataCollection.httpBodies gates write-time, not read-time
                data: true,
                headers: dataCollection.httpHeaders.request !== false,
                ip: dataCollection.userInfo,
                query_string: dataCollection.queryParams !== false,
                // No dataCollection equivalent — URL is always included
                url: true,
                ...options.include
            }
        };
    }
    return {
        name: $dd6f8535eae636ab$var$INTEGRATION_NAME,
        processEvent (event, _hint, client) {
            const { sdkProcessingMetadata: sdkProcessingMetadata = {} } = event;
            const { normalizedRequest: normalizedRequest, ipAddress: ipAddress } = sdkProcessingMetadata;
            const { include: include } = resolveIncludeAndDataCollection(client);
            if (normalizedRequest) $dd6f8535eae636ab$var$addNormalizedRequestDataToEvent(event, normalizedRequest, {
                ipAddress: ipAddress
            }, include);
            return event;
        },
        processSegmentSpan (span, client) {
            const { sdkProcessingMetadata: sdkProcessingMetadata = {} } = $gjJ9A.getIsolationScope().getScopeData();
            const { normalizedRequest: normalizedRequest, ipAddress: ipAddress } = sdkProcessingMetadata;
            if (!normalizedRequest) return;
            const { include: include, dataCollection: dataCollection } = resolveIncludeAndDataCollection(client);
            $dd6f8535eae636ab$var$addNormalizedRequestDataToSpan(span, normalizedRequest, ipAddress, include, dataCollection);
        }
    };
};
const $dd6f8535eae636ab$var$requestDataIntegration = $5QaR1.defineIntegration($dd6f8535eae636ab$var$_requestDataIntegration);
function $dd6f8535eae636ab$var$addNormalizedRequestDataToEvent(event, req, additionalData, include) {
    event.request = {
        ...event.request,
        ...$dd6f8535eae636ab$var$extractNormalizedRequestData(req, include)
    };
    if (include.ip) {
        const ip = req.headers && $hUrwV.getClientIPAddress(req.headers) || additionalData.ipAddress;
        if (ip) event.user = {
            ...event.user,
            ip_address: ip
        };
    }
}
function $dd6f8535eae636ab$var$addNormalizedRequestDataToSpan(span, normalizedRequest, ipAddress, include, dataCollection) {
    const requestData = $dd6f8535eae636ab$var$extractNormalizedRequestData(normalizedRequest, include);
    const attributes = {};
    if (requestData.url) attributes["url.full"] = requestData.url;
    if (requestData.method) attributes["http.request.method"] = requestData.method;
    if (requestData.query_string) attributes["url.query"] = $dd6f8535eae636ab$var$normalizeQueryString(requestData.query_string);
    $1N6Mo.safeSetSpanJSONAttributes(span, attributes);
    if (requestData.cookies && Object.keys(requestData.cookies).length > 0) {
        const cookieString = Object.entries(requestData.cookies).map(([name, value])=>`${name}=${value}`).join("; ");
        const cookieAttributes = $iMjbh.httpHeadersToSpanAttributes({
            cookie: cookieString
        }, dataCollection, "request");
        $1N6Mo.safeSetSpanJSONAttributes(span, cookieAttributes);
    }
    if (requestData.headers) {
        const headerAttributes = $iMjbh.httpHeadersToSpanAttributes(requestData.headers, dataCollection, "request");
        $1N6Mo.safeSetSpanJSONAttributes(span, headerAttributes);
    }
    if (requestData.data != null) {
        const serialized = typeof requestData.data === "string" ? requestData.data : JSON.stringify(requestData.data);
        if (serialized) $1N6Mo.safeSetSpanJSONAttributes(span, {
            "http.request.body.data": serialized
        });
    }
    if (include.ip) {
        const ip = normalizedRequest.headers && $hUrwV.getClientIPAddress(normalizedRequest.headers) || ipAddress || void 0;
        if (ip) $1N6Mo.safeSetSpanJSONAttributes(span, {
            [$3dwiN.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS]: ip
        });
    }
}
function $dd6f8535eae636ab$var$extractNormalizedRequestData(normalizedRequest, include) {
    const requestData = {};
    const headers = {
        ...normalizedRequest.headers
    };
    if (include.headers) {
        requestData.headers = headers;
        if (!include.cookies) delete headers.cookie;
        if (!include.ip) {
            const ipHeaderNamesLower = new Set($hUrwV.ipHeaderNames.map((name)=>name.toLowerCase()));
            for (const key of Object.keys(headers))if (ipHeaderNamesLower.has(key.toLowerCase())) delete headers[key];
        }
    }
    requestData.method = normalizedRequest.method;
    if (include.url) requestData.url = normalizedRequest.url;
    if (include.cookies) {
        const cookies = normalizedRequest.cookies || (headers?.cookie ? $eWLQX.parseCookie(headers.cookie) : void 0);
        requestData.cookies = cookies || {};
    }
    if (include.query_string) requestData.query_string = normalizedRequest.query_string;
    if (include.data) requestData.data = normalizedRequest.data;
    return requestData;
}
function $dd6f8535eae636ab$var$normalizeQueryString(queryString) {
    if (typeof queryString === "string") return queryString || void 0;
    const pairs = Array.isArray(queryString) ? queryString : Object.entries(queryString);
    const result = pairs.map(([key, value])=>`${key}=${value}`).join("&");
    return result || void 0;
}
module.exports.requestDataIntegration = $dd6f8535eae636ab$var$requestDataIntegration;

});
parcelRegister("hUrwV", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $d09d058be5a194f7$var$ipHeaderNames = [
    "X-Client-IP",
    "X-Forwarded-For",
    "Fly-Client-IP",
    "CF-Connecting-IP",
    "Fastly-Client-Ip",
    "True-Client-Ip",
    "X-Real-IP",
    "X-Cluster-Client-IP",
    "X-Forwarded",
    "Forwarded-For",
    "Forwarded",
    "X-Vercel-Forwarded-For"
];
function $d09d058be5a194f7$var$getClientIPAddress(headers) {
    const lowerCaseHeaders = {};
    for (const key of Object.keys(headers))lowerCaseHeaders[key.toLowerCase()] = headers[key];
    const headerValues = $d09d058be5a194f7$var$ipHeaderNames.map((headerName)=>{
        const rawValue = lowerCaseHeaders[headerName.toLowerCase()];
        const value = Array.isArray(rawValue) ? rawValue.join(";") : rawValue;
        if (headerName === "Forwarded") return $d09d058be5a194f7$var$parseForwardedHeader(value);
        return value?.split(",").map((v)=>v.trim());
    });
    const flattenedHeaderValues = headerValues.reduce((acc, val)=>{
        if (!val) return acc;
        return acc.concat(val);
    }, []);
    const ipAddress = flattenedHeaderValues.find((ip)=>ip !== null && $d09d058be5a194f7$var$isIP(ip));
    return ipAddress || null;
}
function $d09d058be5a194f7$var$parseForwardedHeader(value) {
    if (!value) return null;
    for (const part of value.split(";")){
        if (part.startsWith("for=")) return part.slice(4);
    }
    return null;
}
function $d09d058be5a194f7$var$isIP(str) {
    const regex = /(?:^(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}$)|(?:^(?:(?:[a-fA-F\d]{1,4}:){7}(?:[a-fA-F\d]{1,4}|:)|(?:[a-fA-F\d]{1,4}:){6}(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|:[a-fA-F\d]{1,4}|:)|(?:[a-fA-F\d]{1,4}:){5}(?::(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,2}|:)|(?:[a-fA-F\d]{1,4}:){4}(?:(?::[a-fA-F\d]{1,4}){0,1}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,3}|:)|(?:[a-fA-F\d]{1,4}:){3}(?:(?::[a-fA-F\d]{1,4}){0,2}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,4}|:)|(?:[a-fA-F\d]{1,4}:){2}(?:(?::[a-fA-F\d]{1,4}){0,3}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,5}|:)|(?:[a-fA-F\d]{1,4}:){1}(?:(?::[a-fA-F\d]{1,4}){0,4}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,6}|:)|(?::(?:(?::[a-fA-F\d]{1,4}){0,5}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,7}|:)))(?:%[0-9a-zA-Z]{1,})?$)/;
    return regex.test(str);
}
module.exports.getClientIPAddress = $d09d058be5a194f7$var$getClientIPAddress;
module.exports.ipHeaderNames = $d09d058be5a194f7$var$ipHeaderNames;

});


parcelRegister("gpkRr", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gjJ9A = parcelRequire("gjJ9A");

var $8txOP = parcelRequire("8txOP");

var $9SKf6 = parcelRequire("9SKf6");

var $5QaR1 = parcelRequire("5QaR1");

var $jix5p = parcelRequire("jix5p");

var $k6pIc = parcelRequire("k6pIc");

var $53CIi = parcelRequire("53CIi");

var $23Myp = parcelRequire("23Myp");

var $hsCGK = parcelRequire("hsCGK");
const $bf1f29b62f2bd9e9$var$INTEGRATION_NAME = "CaptureConsole";
const $bf1f29b62f2bd9e9$var$_captureConsoleIntegration = (options = {})=>{
    const levels = options.levels || $jix5p.CONSOLE_LEVELS;
    const handled = options.handled ?? true;
    return {
        name: $bf1f29b62f2bd9e9$var$INTEGRATION_NAME,
        setup (client) {
            if (!("console" in $hsCGK.GLOBAL_OBJ)) return;
            $9SKf6.addConsoleInstrumentationHandler(({ args: args, level: level })=>{
                if ($gjJ9A.getClient() !== client || !levels.includes(level)) return;
                $bf1f29b62f2bd9e9$var$consoleHandler(args, level, handled);
            });
        }
    };
};
const $bf1f29b62f2bd9e9$var$captureConsoleIntegration = $5QaR1.defineIntegration($bf1f29b62f2bd9e9$var$_captureConsoleIntegration);
function $bf1f29b62f2bd9e9$var$consoleHandler(args, level, handled) {
    const severityLevel = $53CIi.severityLevelFromString(level);
    const syntheticException = new Error();
    const captureContext = {
        level: $53CIi.severityLevelFromString(level),
        extra: {
            arguments: args
        }
    };
    $gjJ9A.withScope((scope)=>{
        scope.addEventProcessor((event)=>{
            event.logger = "console";
            $k6pIc.addExceptionMechanism(event, {
                handled: handled,
                type: "auto.core.capture_console"
            });
            return event;
        });
        if (level === "assert") {
            if (!args[0]) {
                const message2 = `Assertion failed: ${$23Myp.safeJoin(args.slice(1), " ") || "console.assert"}`;
                scope.setExtra("arguments", args.slice(1));
                scope.captureMessage(message2, severityLevel, {
                    captureContext: captureContext,
                    syntheticException: syntheticException
                });
            }
            return;
        }
        const error = args.find((arg)=>arg instanceof Error);
        if (error) {
            $8txOP.captureException(error, captureContext);
            return;
        }
        const message = $23Myp.safeJoin(args, " ");
        scope.captureMessage(message, severityLevel, {
            captureContext: captureContext,
            syntheticException: syntheticException
        });
    });
}
module.exports.captureConsoleIntegration = $bf1f29b62f2bd9e9$var$captureConsoleIntegration;

});
parcelRegister("9SKf6", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $jCjMv = parcelRequire("jCjMv");

var $jix5p = parcelRequire("jix5p");

var $2SQtm = parcelRequire("2SQtm");

var $23Myp = parcelRequire("23Myp");

var $hsCGK = parcelRequire("hsCGK");

var $86JSI = parcelRequire("86JSI");
const $731d06fe3cc2c699$var$_filter = /* @__PURE__ */ new Set([]);
function $731d06fe3cc2c699$var$addConsoleInstrumentationHandler(handler) {
    const type = "console";
    const removeHandler = $86JSI.addHandler(type, handler);
    $86JSI.maybeInstrument(type, $731d06fe3cc2c699$var$instrumentConsole);
    return removeHandler;
}
function $731d06fe3cc2c699$var$addConsoleInstrumentationFilter(filter) {
    for (const f of filter)$731d06fe3cc2c699$var$_filter.add(f);
    return ()=>{
        for (const f of filter)$731d06fe3cc2c699$var$_filter.delete(f);
    };
}
function $731d06fe3cc2c699$var$instrumentConsole() {
    if (!("console" in $hsCGK.GLOBAL_OBJ)) return;
    $jix5p.CONSOLE_LEVELS.forEach(function(level) {
        if (!(level in $hsCGK.GLOBAL_OBJ.console)) return;
        $2SQtm.fill($hsCGK.GLOBAL_OBJ.console, level, function(originalConsoleMethod) {
            $jix5p.originalConsoleMethods[level] = originalConsoleMethod;
            return function(...args) {
                const firstArg = args[0];
                const log = $jix5p.originalConsoleMethods[level];
                const isFiltered = $731d06fe3cc2c699$var$_filter.size && typeof firstArg === "string" && $23Myp.stringMatchesSomePattern(firstArg, $731d06fe3cc2c699$var$_filter);
                if (!isFiltered) $86JSI.triggerHandlers("console", {
                    args: args,
                    level: level
                });
                if (!isFiltered || $jCjMv.DEBUG_BUILD && $jix5p.debug.isEnabled()) log?.apply($hsCGK.GLOBAL_OBJ.console, args);
            };
        });
    });
}
module.exports.addConsoleInstrumentationFilter = $731d06fe3cc2c699$var$addConsoleInstrumentationFilter;
module.exports.addConsoleInstrumentationHandler = $731d06fe3cc2c699$var$addConsoleInstrumentationHandler;

});

parcelRegister("53CIi", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $3aeb433ab2212075$var$severityLevelFromString(level) {
    return level === "warn" ? "warning" : [
        "fatal",
        "error",
        "warning",
        "log",
        "info",
        "debug"
    ].includes(level) ? level : "log";
}
module.exports.severityLevelFromString = $3aeb433ab2212075$var$severityLevelFromString;

});


parcelRegister("9d3BR", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $jCjMv = parcelRequire("jCjMv");

var $5QaR1 = parcelRequire("5QaR1");

var $jix5p = parcelRequire("jix5p");

var $8S2lx = parcelRequire("8S2lx");
const $6b4820c549f70813$var$INTEGRATION_NAME = "Dedupe";
const $6b4820c549f70813$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $6b4820c549f70813$var$INTEGRATION_NAME,
        processEvent (currentEvent) {
            if (currentEvent.type) return currentEvent;
            try {
                if ($6b4820c549f70813$var$_shouldDropEvent(currentEvent, previousEvent)) {
                    $jCjMv.DEBUG_BUILD && $jix5p.debug.warn("Event dropped due to being a duplicate of previously captured event.");
                    return null;
                }
            } catch  {}
            return previousEvent = currentEvent;
        }
    };
};
const $6b4820c549f70813$var$dedupeIntegration = $5QaR1.defineIntegration($6b4820c549f70813$var$_dedupeIntegration);
function $6b4820c549f70813$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($6b4820c549f70813$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($6b4820c549f70813$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $6b4820c549f70813$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    if (!currentMessage && !previousMessage) return false;
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$6b4820c549f70813$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$6b4820c549f70813$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $6b4820c549f70813$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $6b4820c549f70813$var$_getExceptionFromEvent(previousEvent);
    const currentException = $6b4820c549f70813$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$6b4820c549f70813$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$6b4820c549f70813$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $6b4820c549f70813$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = $8S2lx.getFramesFromEvent(currentEvent);
    let previousFrames = $8S2lx.getFramesFromEvent(previousEvent);
    if (!currentFrames && !previousFrames) return true;
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    if (previousFrames.length !== currentFrames.length) return false;
    for(let i = 0; i < previousFrames.length; i++){
        const frameA = previousFrames[i];
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $6b4820c549f70813$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    if (!currentFingerprint && !previousFingerprint) return true;
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    try {
        return !!(currentFingerprint.join("") === previousFingerprint.join(""));
    } catch  {
        return false;
    }
}
function $6b4820c549f70813$var$_getExceptionFromEvent(event) {
    return event.exception?.values?.[0];
}
module.exports._shouldDropEvent = $6b4820c549f70813$var$_shouldDropEvent;
module.exports.dedupeIntegration = $6b4820c549f70813$var$dedupeIntegration;

});

parcelRegister("glXHH", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $jCjMv = parcelRequire("jCjMv");

var $5QaR1 = parcelRequire("5QaR1");

var $jix5p = parcelRequire("jix5p");

var $fBPG6 = parcelRequire("fBPG6");

var $bg87c = parcelRequire("bg87c");

var $fhFRD = parcelRequire("fhFRD");

var $23Myp = parcelRequire("23Myp");
const $be7ceb75b8fafafe$var$INTEGRATION_NAME = "ExtraErrorData";
const $be7ceb75b8fafafe$var$_extraErrorDataIntegration = (options = {})=>{
    const { depth: depth = 3, captureErrorCause: captureErrorCause = true } = options;
    return {
        name: $be7ceb75b8fafafe$var$INTEGRATION_NAME,
        processEvent (event, hint, client) {
            const { maxValueLength: maxValueLength } = client.getOptions();
            return $be7ceb75b8fafafe$var$_enhanceEventWithErrorData(event, hint, depth, captureErrorCause, maxValueLength);
        }
    };
};
const $be7ceb75b8fafafe$var$extraErrorDataIntegration = $5QaR1.defineIntegration($be7ceb75b8fafafe$var$_extraErrorDataIntegration);
function $be7ceb75b8fafafe$var$_enhanceEventWithErrorData(event, hint = {}, depth, captureErrorCause, maxValueLength) {
    if (!hint.originalException || !$fBPG6.isError(hint.originalException)) return event;
    const exceptionName = hint.originalException.name || hint.originalException.constructor.name;
    const errorData = $be7ceb75b8fafafe$var$_extractErrorData(hint.originalException, captureErrorCause, maxValueLength);
    if (errorData) {
        const contexts = {
            ...event.contexts
        };
        const normalizedErrorData = $bg87c.normalize(errorData, depth);
        if ($fBPG6.isPlainObject(normalizedErrorData)) {
            $fhFRD.setSkipNormalizationHint(normalizedErrorData);
            contexts[exceptionName] = normalizedErrorData;
        }
        return {
            ...event,
            contexts: contexts
        };
    }
    return event;
}
function $be7ceb75b8fafafe$var$_extractErrorData(error, captureErrorCause, maxValueLength) {
    try {
        const nativeKeys = [
            "name",
            "message",
            "stack",
            "line",
            "column",
            "fileName",
            "lineNumber",
            "columnNumber",
            "toJSON"
        ];
        const extraErrorInfo = {};
        for (const key of Object.keys(error)){
            if (nativeKeys.indexOf(key) !== -1) continue;
            const value = error[key];
            extraErrorInfo[key] = $fBPG6.isError(value) || typeof value === "string" ? maxValueLength ? $23Myp.truncate(`${value}`, maxValueLength) : `${value}` : value;
        }
        if (captureErrorCause && error.cause !== void 0) {
            if ($fBPG6.isError(error.cause)) {
                const errorName = error.cause.name || error.cause.constructor.name;
                extraErrorInfo.cause = {
                    [errorName]: $be7ceb75b8fafafe$var$_extractErrorData(error.cause, false, maxValueLength)
                };
            } else extraErrorInfo.cause = error.cause;
        }
        if (typeof error.toJSON === "function") {
            const serializedError = error.toJSON();
            for (const key of Object.keys(serializedError)){
                const value = serializedError[key];
                extraErrorInfo[key] = $fBPG6.isError(value) ? value.toString() : value;
            }
        }
        return extraErrorInfo;
    } catch (oO) {
        $jCjMv.DEBUG_BUILD && $jix5p.debug.error("Unable to extract extra data from the Error object:", oO);
    }
    return null;
}
module.exports.extraErrorDataIntegration = $be7ceb75b8fafafe$var$extraErrorDataIntegration;

});

parcelRegister("5dbkS", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5QaR1 = parcelRequire("5QaR1");

var $adgNM = parcelRequire("adgNM");

var $hsCGK = parcelRequire("hsCGK");
const $3cb6f5b00321b616$var$INTEGRATION_NAME = "RewriteFrames";
const $3cb6f5b00321b616$var$rewriteFramesIntegration = $5QaR1.defineIntegration((options = {})=>{
    const root = options.root;
    const prefix = options.prefix || "app:///";
    const isBrowser = "window" in $hsCGK.GLOBAL_OBJ && !!$hsCGK.GLOBAL_OBJ.window;
    const iteratee = options.iteratee || $3cb6f5b00321b616$var$generateIteratee({
        isBrowser: isBrowser,
        root: root,
        prefix: prefix
    });
    function _processExceptionsEvent(event) {
        try {
            return {
                ...event,
                exception: {
                    ...event.exception,
                    // The check for this is performed inside `process` call itself, safe to skip here
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    values: event.exception.values.map((value)=>({
                            ...value,
                            ...value.stacktrace && {
                                stacktrace: _processStacktrace(value.stacktrace)
                            }
                        }))
                }
            };
        } catch  {
            return event;
        }
    }
    function _processStacktrace(stacktrace) {
        return {
            ...stacktrace,
            frames: stacktrace?.frames?.map((f)=>iteratee(f))
        };
    }
    return {
        name: $3cb6f5b00321b616$var$INTEGRATION_NAME,
        processEvent (originalEvent) {
            let processedEvent = originalEvent;
            if (originalEvent.exception && Array.isArray(originalEvent.exception.values)) processedEvent = _processExceptionsEvent(processedEvent);
            return processedEvent;
        }
    };
});
function $3cb6f5b00321b616$var$generateIteratee({ isBrowser: isBrowser, root: root, prefix: prefix }) {
    return (frame)=>{
        if (!frame.filename) return frame;
        const isWindowsFrame = /^[a-zA-Z]:\\/.test(frame.filename) || // or the presence of a backslash without a forward slash (which are not allowed on Windows)
        frame.filename.includes("\\") && !frame.filename.includes("/");
        const startsWithSlash = /^\//.test(frame.filename);
        if (isBrowser) {
            if (root) {
                const oldFilename = frame.filename;
                if (oldFilename.indexOf(root) === 0) frame.filename = oldFilename.replace(root, prefix);
            }
        } else if (isWindowsFrame || startsWithSlash) {
            const filename = isWindowsFrame ? frame.filename.replace(/^[a-zA-Z]:/, "").replace(/\\/g, "/") : frame.filename;
            const base = root ? $adgNM.relative(root, filename) : $adgNM.basename(filename);
            frame.filename = `${prefix}${base}`;
        }
        return frame;
    };
}
module.exports.generateIteratee = $3cb6f5b00321b616$var$generateIteratee;
module.exports.rewriteFramesIntegration = $3cb6f5b00321b616$var$rewriteFramesIntegration;

});
parcelRegister("adgNM", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $76f826c68b62abbf$var$normalizeArray(parts, allowAboveRoot) {
    let up = 0;
    for(let i = parts.length - 1; i >= 0; i--){
        const last = parts[i];
        if (last === ".") parts.splice(i, 1);
        else if (last === "..") {
            parts.splice(i, 1);
            up++;
        } else if (up) {
            parts.splice(i, 1);
            up--;
        }
    }
    if (allowAboveRoot) for(; up--; up)parts.unshift("..");
    return parts;
}
const $76f826c68b62abbf$var$splitPathRe = /^(\S+:\\|\/?)([\s\S]*?)((?:\.{1,2}|[^/\\]+?|)(\.[^./\\]*|))(?:[/\\]*)$/;
function $76f826c68b62abbf$var$splitPath(filename) {
    const truncated = filename.length > 1024 ? `<truncated>${filename.slice(-1024)}` : filename;
    const parts = $76f826c68b62abbf$var$splitPathRe.exec(truncated);
    return parts ? parts.slice(1) : [];
}
function $76f826c68b62abbf$var$resolve(...args) {
    let resolvedPath = "";
    let resolvedAbsolute = false;
    for(let i = args.length - 1; i >= -1 && !resolvedAbsolute; i--){
        const path = i >= 0 ? args[i] : "/";
        if (!path) continue;
        resolvedPath = `${path}/${resolvedPath}`;
        resolvedAbsolute = path.charAt(0) === "/";
    }
    resolvedPath = $76f826c68b62abbf$var$normalizeArray(resolvedPath.split("/").filter((p)=>!!p), !resolvedAbsolute).join("/");
    return (resolvedAbsolute ? "/" : "") + resolvedPath || ".";
}
function $76f826c68b62abbf$var$trim(arr) {
    let start = 0;
    for(; start < arr.length; start++){
        if (arr[start] !== "") break;
    }
    let end = arr.length - 1;
    for(; end >= 0; end--){
        if (arr[end] !== "") break;
    }
    if (start > end) return [];
    return arr.slice(start, end - start + 1);
}
function $76f826c68b62abbf$var$relative(from, to) {
    from = $76f826c68b62abbf$var$resolve(from).slice(1);
    to = $76f826c68b62abbf$var$resolve(to).slice(1);
    const fromParts = $76f826c68b62abbf$var$trim(from.split("/"));
    const toParts = $76f826c68b62abbf$var$trim(to.split("/"));
    const length = Math.min(fromParts.length, toParts.length);
    let samePartsLength = length;
    for(let i = 0; i < length; i++)if (fromParts[i] !== toParts[i]) {
        samePartsLength = i;
        break;
    }
    let outputParts = [];
    for(let i = samePartsLength; i < fromParts.length; i++)outputParts.push("..");
    outputParts = outputParts.concat(toParts.slice(samePartsLength));
    return outputParts.join("/");
}
function $76f826c68b62abbf$var$normalizePath(path) {
    const isPathAbsolute = $76f826c68b62abbf$var$isAbsolute(path);
    const trailingSlash = path.slice(-1) === "/";
    let normalizedPath = $76f826c68b62abbf$var$normalizeArray(path.split("/").filter((p)=>!!p), !isPathAbsolute).join("/");
    if (!normalizedPath && !isPathAbsolute) normalizedPath = ".";
    if (normalizedPath && trailingSlash) normalizedPath += "/";
    return (isPathAbsolute ? "/" : "") + normalizedPath;
}
function $76f826c68b62abbf$var$isAbsolute(path) {
    return path.charAt(0) === "/";
}
function $76f826c68b62abbf$var$join(...args) {
    return $76f826c68b62abbf$var$normalizePath(args.join("/"));
}
function $76f826c68b62abbf$var$dirname(path) {
    const result = $76f826c68b62abbf$var$splitPath(path);
    const root = result[0] || "";
    let dir = result[1];
    if (!root && !dir) return ".";
    if (dir) dir = dir.slice(0, dir.length - 1);
    return root + dir;
}
function $76f826c68b62abbf$var$basename(path, ext) {
    let f = $76f826c68b62abbf$var$splitPath(path)[2] || "";
    if (ext && f.slice(ext.length * -1) === ext) f = f.slice(0, f.length - ext.length);
    return f;
}
module.exports.basename = $76f826c68b62abbf$var$basename;
module.exports.dirname = $76f826c68b62abbf$var$dirname;
module.exports.isAbsolute = $76f826c68b62abbf$var$isAbsolute;
module.exports.join = $76f826c68b62abbf$var$join;
module.exports.normalizePath = $76f826c68b62abbf$var$normalizePath;
module.exports.relative = $76f826c68b62abbf$var$relative;
module.exports.resolve = $76f826c68b62abbf$var$resolve;

});


parcelRegister("lrqNu", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $75yrz = parcelRequire("75yrz");

var $gjJ9A = parcelRequire("gjJ9A");

var $jCjMv = parcelRequire("jCjMv");

var $8txOP = parcelRequire("8txOP");

var $5QaR1 = parcelRequire("5QaR1");

var $3dwiN = parcelRequire("3dwiN");

var $jix5p = parcelRequire("jix5p");

var $k6pIc = parcelRequire("k6pIc");

var $fBPG6 = parcelRequire("fBPG6");

var $9X7hl = parcelRequire("9X7hl");

var $4Ae9I = parcelRequire("4Ae9I");
const $f9c0e7f323fdb381$var$AUTH_OPERATIONS_TO_INSTRUMENT = [
    "reauthenticate",
    "signInAnonymously",
    "signInWithOAuth",
    "signInWithIdToken",
    "signInWithOtp",
    "signInWithPassword",
    "signInWithSSO",
    "signOut",
    "signUp",
    "verifyOtp"
];
const $f9c0e7f323fdb381$var$AUTH_ADMIN_OPERATIONS_TO_INSTRUMENT = [
    "createUser",
    "deleteUser",
    "listUsers",
    "getUserById",
    "updateUserById",
    "inviteUserByEmail"
];
const $f9c0e7f323fdb381$var$FILTER_MAPPINGS = {
    eq: "eq",
    neq: "neq",
    gt: "gt",
    gte: "gte",
    lt: "lt",
    lte: "lte",
    like: "like",
    "like(all)": "likeAllOf",
    "like(any)": "likeAnyOf",
    ilike: "ilike",
    "ilike(all)": "ilikeAllOf",
    "ilike(any)": "ilikeAnyOf",
    is: "is",
    in: "in",
    cs: "contains",
    cd: "containedBy",
    sr: "rangeGt",
    nxl: "rangeGte",
    sl: "rangeLt",
    nxr: "rangeLte",
    adj: "rangeAdjacent",
    ov: "overlaps",
    fts: "",
    plfts: "plain",
    phfts: "phrase",
    wfts: "websearch",
    not: "not"
};
const $f9c0e7f323fdb381$var$DB_OPERATIONS_TO_INSTRUMENT = [
    "select",
    "insert",
    "upsert",
    "update",
    "delete"
];
function $f9c0e7f323fdb381$var$markAsInstrumented(fn) {
    try {
        fn.__SENTRY_INSTRUMENTED__ = true;
    } catch  {}
}
function $f9c0e7f323fdb381$var$isInstrumented(fn) {
    try {
        return fn.__SENTRY_INSTRUMENTED__;
    } catch  {
        return false;
    }
}
function $f9c0e7f323fdb381$var$getMutationBodyPayloadForTelemetry(rawBody, plainBody) {
    if (Object.keys(plainBody).length > 0) return plainBody;
    if (Array.isArray(rawBody) && rawBody.length > 0) return rawBody;
    return void 0;
}
function $f9c0e7f323fdb381$var$hasMutationBodyForDescription(rawBody, plainBody) {
    return $f9c0e7f323fdb381$var$getMutationBodyPayloadForTelemetry(rawBody, plainBody) !== void 0;
}
function $f9c0e7f323fdb381$var$extractOperation(method, headers = {}) {
    switch(method){
        case "GET":
            return "select";
        case "POST":
            if (headers["Prefer"]?.includes("resolution=")) return "upsert";
            else return "insert";
        case "PATCH":
            return "update";
        case "DELETE":
            return "delete";
        default:
            return "<unknown-op>";
    }
}
function $f9c0e7f323fdb381$var$translateFiltersIntoMethods(key, query) {
    if (query === "" || query === "*") return "select(*)";
    if (key === "select") return `select(${query})`;
    if (key === "or" || key.endsWith(".or")) return `${key}${query}`;
    const [filter, ...value] = query.split(".");
    let method;
    if (filter?.startsWith("fts")) method = "textSearch";
    else if (filter?.startsWith("plfts")) method = "textSearch[plain]";
    else if (filter?.startsWith("phfts")) method = "textSearch[phrase]";
    else if (filter?.startsWith("wfts")) method = "textSearch[websearch]";
    else method = filter && $f9c0e7f323fdb381$var$FILTER_MAPPINGS[filter] || "filter";
    return `${method}(${key}, ${value.join(".")})`;
}
function $f9c0e7f323fdb381$var$instrumentAuthOperation(operation, isAdmin = false) {
    return new Proxy(operation, {
        apply (target, thisArg, argumentsList) {
            return $4Ae9I.startSpan({
                name: `auth ${isAdmin ? "(admin) " : ""}${operation.name}`,
                attributes: {
                    [$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.db.supabase",
                    [$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "db",
                    "db.system": "postgresql",
                    "db.operation": `auth.${isAdmin ? "admin." : ""}${operation.name}`
                }
            }, (span)=>{
                return Reflect.apply(target, thisArg, argumentsList).then((res)=>{
                    if (res && typeof res === "object" && "error" in res && res.error) {
                        span.setStatus({
                            code: $9X7hl.SPAN_STATUS_ERROR
                        });
                        $8txOP.captureException(res.error, {
                            mechanism: {
                                handled: false,
                                type: "auto.db.supabase.auth"
                            }
                        });
                    } else span.setStatus({
                        code: $9X7hl.SPAN_STATUS_OK
                    });
                    span.end();
                    return res;
                }).catch((err)=>{
                    span.setStatus({
                        code: $9X7hl.SPAN_STATUS_ERROR
                    });
                    span.end();
                    $8txOP.captureException(err, {
                        mechanism: {
                            handled: false,
                            type: "auto.db.supabase.auth"
                        }
                    });
                    throw err;
                }).then(...argumentsList);
            });
        }
    });
}
function $f9c0e7f323fdb381$var$instrumentSupabaseAuthClient(supabaseClientInstance) {
    const auth = supabaseClientInstance.auth;
    if (!auth || $f9c0e7f323fdb381$var$isInstrumented(supabaseClientInstance.auth)) return;
    for (const operation of $f9c0e7f323fdb381$var$AUTH_OPERATIONS_TO_INSTRUMENT){
        const authOperation = auth[operation];
        if (!authOperation) continue;
        if (typeof supabaseClientInstance.auth[operation] === "function") supabaseClientInstance.auth[operation] = $f9c0e7f323fdb381$var$instrumentAuthOperation(authOperation);
    }
    for (const operation of $f9c0e7f323fdb381$var$AUTH_ADMIN_OPERATIONS_TO_INSTRUMENT){
        const authOperation = auth.admin[operation];
        if (!authOperation) continue;
        if (typeof supabaseClientInstance.auth.admin[operation] === "function") supabaseClientInstance.auth.admin[operation] = $f9c0e7f323fdb381$var$instrumentAuthOperation(authOperation, true);
    }
    $f9c0e7f323fdb381$var$markAsInstrumented(supabaseClientInstance.auth);
}
function $f9c0e7f323fdb381$var$instrumentSupabaseClientConstructor(SupabaseClient, _options) {
    if ($f9c0e7f323fdb381$var$isInstrumented(SupabaseClient.prototype.from)) return;
    SupabaseClient.prototype.from = new Proxy(SupabaseClient.prototype.from, {
        apply (target, thisArg, argumentsList) {
            const rv = Reflect.apply(target, thisArg, argumentsList);
            const PostgRESTQueryBuilder = rv.constructor;
            $f9c0e7f323fdb381$var$instrumentPostgRESTQueryBuilder(PostgRESTQueryBuilder, _options);
            return rv;
        }
    });
    $f9c0e7f323fdb381$var$markAsInstrumented(SupabaseClient.prototype.from);
}
function $f9c0e7f323fdb381$var$instrumentPostgRESTFilterBuilder(PostgRESTFilterBuilder, _options) {
    if ($f9c0e7f323fdb381$var$isInstrumented(PostgRESTFilterBuilder.prototype.then)) return;
    PostgRESTFilterBuilder.prototype.then = new Proxy(PostgRESTFilterBuilder.prototype.then, {
        apply (target, thisArg, argumentsList) {
            const operations = $f9c0e7f323fdb381$var$DB_OPERATIONS_TO_INSTRUMENT;
            const typedThis = thisArg;
            const operation = $f9c0e7f323fdb381$var$extractOperation(typedThis.method, typedThis.headers);
            if (!operations.includes(operation)) return Reflect.apply(target, thisArg, argumentsList);
            if (!typedThis?.url?.pathname || typeof typedThis.url.pathname !== "string") return Reflect.apply(target, thisArg, argumentsList);
            const pathParts = typedThis.url.pathname.split("/");
            const table = pathParts.length > 0 ? pathParts[pathParts.length - 1] : "";
            const queryItems = [];
            for (const [key, value] of typedThis.url.searchParams.entries())queryItems.push($f9c0e7f323fdb381$var$translateFiltersIntoMethods(key, value));
            const body = /* @__PURE__ */ Object.create(null);
            if ($fBPG6.isPlainObject(typedThis.body)) for (const [key, value] of Object.entries(typedThis.body))body[key] = value;
            const client = $gjJ9A.getClient();
            const shouldSendData = _options.sendOperationData ?? client?.getDataCollectionOptions().userInfo === true;
            const bodyPayload = $f9c0e7f323fdb381$var$getMutationBodyPayloadForTelemetry(typedThis.body, body);
            const mutationPart = operation === "select" ? "" : `${operation}${$f9c0e7f323fdb381$var$hasMutationBodyForDescription(typedThis.body, body) ? "(...) " : ""}`;
            const queryPart = shouldSendData ? queryItems.join(" ") : queryItems.length > 0 ? "[redacted]" : "";
            const descriptionMiddle = [
                mutationPart.trimEnd(),
                queryPart
            ].filter(Boolean).join(" ");
            const description = descriptionMiddle ? `${descriptionMiddle} from(${table})` : `from(${table})`;
            const attributes = {
                "db.table": table,
                "db.schema": typedThis.schema,
                "db.url": typedThis.url.origin,
                "db.sdk": typedThis.headers["X-Client-Info"],
                "db.system": "postgresql",
                "db.operation": operation,
                [$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.db.supabase",
                [$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "db"
            };
            if (queryItems.length && shouldSendData) attributes["db.query"] = queryItems;
            if (bodyPayload !== void 0 && shouldSendData) attributes["db.body"] = bodyPayload;
            return $4Ae9I.startSpan({
                name: description,
                attributes: attributes
            }, (span)=>{
                return Reflect.apply(target, thisArg, []).then((res)=>{
                    if (span) {
                        if (res && typeof res === "object" && "status" in res) $9X7hl.setHttpStatus(span, res.status || 500);
                        span.end();
                    }
                    if (res?.error) {
                        const err = new Error(res.error.message);
                        if (res.error.code) err.code = res.error.code;
                        if (res.error.details) err.details = res.error.details;
                        const supabaseContext = {};
                        if (queryItems.length && shouldSendData) supabaseContext.query = queryItems;
                        if (bodyPayload !== void 0 && shouldSendData) supabaseContext.body = bodyPayload;
                        $8txOP.captureException(err, (scope)=>{
                            scope.addEventProcessor((e)=>{
                                $k6pIc.addExceptionMechanism(e, {
                                    handled: false,
                                    type: "auto.db.supabase.postgres"
                                });
                                return e;
                            });
                            scope.setContext("supabase", supabaseContext);
                            return scope;
                        });
                    }
                    const breadcrumb = {
                        type: "supabase",
                        category: `db.${operation}`,
                        message: description
                    };
                    const data = {};
                    if (queryItems.length && shouldSendData) data.query = queryItems;
                    if (bodyPayload !== void 0 && shouldSendData) data.body = bodyPayload;
                    if (Object.keys(data).length) breadcrumb.data = data;
                    $75yrz.addBreadcrumb(breadcrumb);
                    return res;
                }, (err)=>{
                    if (span) {
                        $9X7hl.setHttpStatus(span, 500);
                        span.end();
                    }
                    throw err;
                }).then(...argumentsList);
            });
        }
    });
    $f9c0e7f323fdb381$var$markAsInstrumented(PostgRESTFilterBuilder.prototype.then);
}
function $f9c0e7f323fdb381$var$instrumentPostgRESTQueryBuilder(PostgRESTQueryBuilder, _options) {
    for (const operation of $f9c0e7f323fdb381$var$DB_OPERATIONS_TO_INSTRUMENT){
        if ($f9c0e7f323fdb381$var$isInstrumented(PostgRESTQueryBuilder.prototype[operation])) continue;
        PostgRESTQueryBuilder.prototype[operation] = new Proxy(PostgRESTQueryBuilder.prototype[operation], {
            apply (target, thisArg, argumentsList) {
                const rv = Reflect.apply(target, thisArg, argumentsList);
                const PostgRESTFilterBuilder = rv.constructor;
                $jCjMv.DEBUG_BUILD && $jix5p.debug.log(`Instrumenting ${operation} operation's PostgRESTFilterBuilder`);
                $f9c0e7f323fdb381$var$instrumentPostgRESTFilterBuilder(PostgRESTFilterBuilder, _options);
                return rv;
            }
        });
        $f9c0e7f323fdb381$var$markAsInstrumented(PostgRESTQueryBuilder.prototype[operation]);
    }
}
const $f9c0e7f323fdb381$var$instrumentSupabaseClient = (supabaseClient, options = {})=>{
    if (!supabaseClient) {
        $jCjMv.DEBUG_BUILD && $jix5p.debug.warn("Supabase integration was not installed because no Supabase client was provided.");
        return;
    }
    const SupabaseClientConstructor = supabaseClient.constructor === Function ? supabaseClient : supabaseClient.constructor;
    $f9c0e7f323fdb381$var$instrumentSupabaseClientConstructor(SupabaseClientConstructor, options);
    $f9c0e7f323fdb381$var$instrumentSupabaseAuthClient(supabaseClient);
};
const $f9c0e7f323fdb381$var$INTEGRATION_NAME = "Supabase";
const $f9c0e7f323fdb381$var$_supabaseIntegration = (supabaseClient, options)=>{
    return {
        setupOnce () {
            $f9c0e7f323fdb381$var$instrumentSupabaseClient(supabaseClient, options);
        },
        name: $f9c0e7f323fdb381$var$INTEGRATION_NAME
    };
};
const $f9c0e7f323fdb381$var$supabaseIntegration = $5QaR1.defineIntegration((options)=>{
    return $f9c0e7f323fdb381$var$_supabaseIntegration(options.supabaseClient, {
        sendOperationData: options.sendOperationData
    });
});
module.exports.DB_OPERATIONS_TO_INSTRUMENT = $f9c0e7f323fdb381$var$DB_OPERATIONS_TO_INSTRUMENT;
module.exports.FILTER_MAPPINGS = $f9c0e7f323fdb381$var$FILTER_MAPPINGS;
module.exports.extractOperation = $f9c0e7f323fdb381$var$extractOperation;
module.exports.instrumentSupabaseClient = $f9c0e7f323fdb381$var$instrumentSupabaseClient;
module.exports.supabaseIntegration = $f9c0e7f323fdb381$var$supabaseIntegration;
module.exports.translateFiltersIntoMethods = $f9c0e7f323fdb381$var$translateFiltersIntoMethods;

});

parcelRegister("98bRC", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5QaR1 = parcelRequire("5QaR1");

var $fBPG6 = parcelRequire("fBPG6");

var $23Myp = parcelRequire("23Myp");
const $6a5e105733137ce3$var$DEFAULT_LIMIT = 10;
const $6a5e105733137ce3$var$INTEGRATION_NAME = "ZodErrors";
function $6a5e105733137ce3$var$originalExceptionIsZodError(originalException) {
    return $fBPG6.isError(originalException) && originalException.name === "ZodError" && Array.isArray(originalException.issues);
}
function $6a5e105733137ce3$var$flattenIssue(issue) {
    return {
        ...issue,
        path: "path" in issue && Array.isArray(issue.path) ? issue.path.join(".") : void 0,
        keys: "keys" in issue ? JSON.stringify(issue.keys) : void 0,
        unionErrors: "unionErrors" in issue ? JSON.stringify(issue.unionErrors) : void 0
    };
}
function $6a5e105733137ce3$var$flattenIssuePath(path) {
    return path.map((p)=>{
        if (typeof p === "number") return "<array>";
        else return p;
    }).join(".");
}
function $6a5e105733137ce3$var$formatIssueMessage(zodError) {
    const errorKeyMap = /* @__PURE__ */ new Set();
    for (const iss of zodError.issues){
        const issuePath = $6a5e105733137ce3$var$flattenIssuePath(iss.path);
        if (issuePath.length > 0) errorKeyMap.add(issuePath);
    }
    const errorKeys = Array.from(errorKeyMap);
    if (errorKeys.length === 0) {
        let rootExpectedType = "variable";
        if (zodError.issues.length > 0) {
            const iss = zodError.issues[0];
            if (iss !== void 0 && "expected" in iss && typeof iss.expected === "string") rootExpectedType = iss.expected;
        }
        return `Failed to validate ${rootExpectedType}`;
    }
    return `Failed to validate keys: ${$23Myp.truncate(errorKeys.join(", "), 100)}`;
}
function $6a5e105733137ce3$var$applyZodErrorsToEvent(limit, saveZodIssuesAsAttachment = false, event, hint) {
    if (!event.exception?.values || !hint.originalException || !$6a5e105733137ce3$var$originalExceptionIsZodError(hint.originalException) || hint.originalException.issues.length === 0) return event;
    try {
        const issuesToFlatten = saveZodIssuesAsAttachment ? hint.originalException.issues : hint.originalException.issues.slice(0, limit);
        const flattenedIssues = issuesToFlatten.map($6a5e105733137ce3$var$flattenIssue);
        if (saveZodIssuesAsAttachment) {
            if (!Array.isArray(hint.attachments)) hint.attachments = [];
            hint.attachments.push({
                filename: "zod_issues.json",
                data: JSON.stringify({
                    issues: flattenedIssues
                })
            });
        }
        return {
            ...event,
            exception: {
                ...event.exception,
                values: [
                    {
                        ...event.exception.values[0],
                        value: $6a5e105733137ce3$var$formatIssueMessage(hint.originalException)
                    },
                    ...event.exception.values.slice(1)
                ]
            },
            extra: {
                ...event.extra,
                "zoderror.issues": flattenedIssues.slice(0, limit)
            }
        };
    } catch (e) {
        return {
            ...event,
            extra: {
                ...event.extra,
                "zoderrors sentry integration parse error": {
                    message: "an exception was thrown while processing ZodError within applyZodErrorsToEvent()",
                    error: e instanceof Error ? `${e.name}: ${e.message}
${e.stack}` : "unknown"
                }
            }
        };
    }
}
const $6a5e105733137ce3$var$_zodErrorsIntegration = (options = {})=>{
    const limit = options.limit ?? $6a5e105733137ce3$var$DEFAULT_LIMIT;
    return {
        name: $6a5e105733137ce3$var$INTEGRATION_NAME,
        processEvent (originalEvent, hint) {
            const processedEvent = $6a5e105733137ce3$var$applyZodErrorsToEvent(limit, options.saveZodIssuesAsAttachment, originalEvent, hint);
            return processedEvent;
        }
    };
};
const $6a5e105733137ce3$var$zodErrorsIntegration = $5QaR1.defineIntegration($6a5e105733137ce3$var$_zodErrorsIntegration);
module.exports.applyZodErrorsToEvent = $6a5e105733137ce3$var$applyZodErrorsToEvent;
module.exports.flattenIssue = $6a5e105733137ce3$var$flattenIssue;
module.exports.flattenIssuePath = $6a5e105733137ce3$var$flattenIssuePath;
module.exports.formatIssueMessage = $6a5e105733137ce3$var$formatIssueMessage;
module.exports.zodErrorsIntegration = $6a5e105733137ce3$var$zodErrorsIntegration;

});

parcelRegister("6bvZk", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5QaR1 = parcelRequire("5QaR1");

var $2ETn4 = parcelRequire("2ETn4");

var $5fqIb = parcelRequire("5fqIb");

var $8S2lx = parcelRequire("8S2lx");

var $hsCGK = parcelRequire("hsCGK");
const $480c955c6366a4cb$var$thirdPartyErrorFilterIntegration = $5QaR1.defineIntegration((options)=>{
    return {
        name: "ThirdPartyErrorsFilter",
        setup (client) {
            client.on("beforeEnvelope", (envelope$1)=>{
                $5fqIb.forEachEnvelopeItem(envelope$1, (item, type)=>{
                    if (type === "event") {
                        const event = Array.isArray(item) ? item[1] : void 0;
                        if (event) {
                            $2ETn4.stripMetadataFromStackFrames(event);
                            item[1] = event;
                        }
                    }
                });
            });
            client.on("applyFrameMetadata", (event)=>{
                if (event.type) return;
                const stackParser = client.getOptions().stackParser;
                $2ETn4.addMetadataToStackFrames(stackParser, event);
            });
        },
        preprocessEvent (event) {
            if (options.ignoreSentryInternalFrames && ($hsCGK.GLOBAL_OBJ._sentryWrappedDepth ?? 0) > 0) event.sdkProcessingMetadata = {
                ...event.sdkProcessingMetadata,
                insideSentryWrapped: true
            };
        },
        processEvent (event) {
            const insideSentryWrapped = options.ignoreSentryInternalFrames ? event.sdkProcessingMetadata?.insideSentryWrapped === true && event.exception?.values?.length === 1 : false;
            const frameKeys = $480c955c6366a4cb$var$getBundleKeysForAllFramesWithFilenames(event, options.ignoreSentryInternalFrames, insideSentryWrapped);
            if (frameKeys) {
                const arrayMethod = options.behaviour === "drop-error-if-contains-third-party-frames" || options.behaviour === "apply-tag-if-contains-third-party-frames" ? "some" : "every";
                const behaviourApplies = frameKeys[arrayMethod]((keys)=>!keys.some((key)=>options.filterKeys.includes(key)));
                if (behaviourApplies) {
                    const shouldDrop = options.behaviour === "drop-error-if-contains-third-party-frames" || options.behaviour === "drop-error-if-exclusively-contains-third-party-frames";
                    if (shouldDrop) return null;
                    else event.tags = {
                        ...event.tags,
                        third_party_code: true
                    };
                }
            }
            return event;
        }
    };
});
function $480c955c6366a4cb$var$isSentryInternalFrame(frame, frameIndex, insideSentryWrapped) {
    if (frameIndex !== 0) return false;
    if (insideSentryWrapped && $480c955c6366a4cb$var$isLikelyMinifiedSentryWrappedFrame(frame)) return true;
    if (frame.function === "sentryWrapped") return true;
    if (!frame.context_line || !frame.filename) return false;
    if (!frame.filename.includes("sentry") || !frame.filename.includes("helpers") || // Filename would look something like this: 'node_modules/@sentry/browser/build/npm/esm/helpers.js'
    !frame.context_line.includes($480c955c6366a4cb$var$SENTRY_INTERNAL_FN_APPLY)) return false;
    if (frame.pre_context) {
        const len = frame.pre_context.length;
        for(let i = 0; i < len; i++){
            if (frame.pre_context[i]?.includes($480c955c6366a4cb$var$SENTRY_INTERNAL_COMMENT)) return true;
        }
    }
    return false;
}
function $480c955c6366a4cb$var$getBundleKeysForAllFramesWithFilenames(event, ignoreSentryInternalFrames, insideSentryWrapped) {
    const frames = $8S2lx.getFramesFromEvent(event);
    if (!frames) return void 0;
    return frames.filter((frame, index)=>{
        if (!frame.filename) return false;
        if (frame.lineno == null && frame.colno == null && frame.instruction_addr == null) return false;
        return !ignoreSentryInternalFrames || !$480c955c6366a4cb$var$isSentryInternalFrame(frame, index, !!insideSentryWrapped);
    }).map((frame)=>{
        if (!frame.module_metadata) return [];
        return Object.keys(frame.module_metadata).filter((key)=>key.startsWith($480c955c6366a4cb$var$BUNDLER_PLUGIN_APP_KEY_PREFIX)).map((key)=>key.slice($480c955c6366a4cb$var$BUNDLER_PLUGIN_APP_KEY_PREFIX.length));
    });
}
function $480c955c6366a4cb$var$isLikelyMinifiedSentryWrappedFrame(frame) {
    return !frame.context_line && !frame.pre_context && !!frame.function && frame.function.length <= 2;
}
const $480c955c6366a4cb$var$BUNDLER_PLUGIN_APP_KEY_PREFIX = "_sentryBundlerPluginAppKey:";
const $480c955c6366a4cb$var$SENTRY_INTERNAL_COMMENT = "Attempt to invoke user-land function";
const $480c955c6366a4cb$var$SENTRY_INTERNAL_FN_APPLY = "fn.apply(this, wrappedArguments)";
module.exports.thirdPartyErrorFilterIntegration = $480c955c6366a4cb$var$thirdPartyErrorFilterIntegration;

});

parcelRegister("k7uEO", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $75yrz = parcelRequire("75yrz");

var $gjJ9A = parcelRequire("gjJ9A");

var $9SKf6 = parcelRequire("9SKf6");

var $5QaR1 = parcelRequire("5QaR1");

var $jix5p = parcelRequire("jix5p");

var $53CIi = parcelRequire("53CIi");

var $23Myp = parcelRequire("23Myp");

var $hsCGK = parcelRequire("hsCGK");
const $ea5c3df87b2e9cf4$var$INTEGRATION_NAME = "Console";
const $ea5c3df87b2e9cf4$var$consoleIntegration = $5QaR1.defineIntegration((options = {})=>{
    const levels = new Set(options.levels || $jix5p.CONSOLE_LEVELS);
    return {
        name: $ea5c3df87b2e9cf4$var$INTEGRATION_NAME,
        setup (client) {
            const unsubscribe = $9SKf6.addConsoleInstrumentationHandler(({ args: args, level: level })=>{
                if ($gjJ9A.getClient() !== client || !levels.has(level)) return;
                $ea5c3df87b2e9cf4$var$addConsoleBreadcrumb(level, args);
            });
            client.registerCleanup(unsubscribe);
            if (options.filter) {
                const unsubscribe2 = $9SKf6.addConsoleInstrumentationFilter(options.filter);
                client.registerCleanup(unsubscribe2);
            }
        }
    };
});
function $ea5c3df87b2e9cf4$var$addConsoleBreadcrumb(level, args) {
    const breadcrumb = {
        category: "console",
        data: {
            arguments: args,
            logger: "console"
        },
        level: $53CIi.severityLevelFromString(level),
        message: $ea5c3df87b2e9cf4$var$formatConsoleArgs(args)
    };
    if (level === "assert") {
        if (args[0] === false) {
            const assertionArgs = args.slice(1);
            breadcrumb.message = assertionArgs.length > 0 ? `Assertion failed: ${$ea5c3df87b2e9cf4$var$formatConsoleArgs(assertionArgs)}` : "Assertion failed";
            breadcrumb.data.arguments = assertionArgs;
        } else return;
    }
    $75yrz.addBreadcrumb(breadcrumb, {
        input: args,
        level: level
    });
}
function $ea5c3df87b2e9cf4$var$formatConsoleArgs(values) {
    return "util" in $hsCGK.GLOBAL_OBJ && typeof $hsCGK.GLOBAL_OBJ.util.format === "function" ? $hsCGK.GLOBAL_OBJ.util.format(...values) : $23Myp.safeJoin(values, " ");
}
module.exports.addConsoleBreadcrumb = $ea5c3df87b2e9cf4$var$addConsoleBreadcrumb;
module.exports.consoleIntegration = $ea5c3df87b2e9cf4$var$consoleIntegration;

});

parcelRegister("720L4", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5QaR1 = parcelRequire("5QaR1");

var $cut0U = parcelRequire("cut0U");
const $51e94edb75122906$var$featureFlagsIntegration = $5QaR1.defineIntegration(()=>{
    return {
        name: "FeatureFlags",
        processEvent (event, _hint, _client) {
            return $cut0U._INTERNAL_copyFlagsFromScopeToEvent(event);
        },
        addFeatureFlag (name, value) {
            $cut0U._INTERNAL_insertFlagToScope(name, value);
            $cut0U._INTERNAL_addFeatureFlagToActiveSpan(name, value);
        }
    };
});
module.exports.featureFlagsIntegration = $51e94edb75122906$var$featureFlagsIntegration;

});
parcelRegister("cut0U", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gjJ9A = parcelRequire("gjJ9A");

var $jCjMv = parcelRequire("jCjMv");

var $jix5p = parcelRequire("jix5p");

var $2dG64 = parcelRequire("2dG64");
const $917ecae40b6dbfe3$var$_INTERNAL_FLAG_BUFFER_SIZE = 100;
const $917ecae40b6dbfe3$var$_INTERNAL_MAX_FLAGS_PER_SPAN = 10;
const $917ecae40b6dbfe3$var$SPAN_FLAG_ATTRIBUTE_PREFIX = "flag.evaluation.";
function $917ecae40b6dbfe3$var$_INTERNAL_copyFlagsFromScopeToEvent(event) {
    if (event.type) return event;
    const scope = $gjJ9A.getCurrentScope();
    const flagContext = scope.getScopeData().contexts.flags;
    const flagBuffer = flagContext ? flagContext.values : [];
    if (!flagBuffer.length) return event;
    if (event.contexts === void 0) event.contexts = {};
    event.contexts.flags = {
        values: [
            ...flagBuffer
        ]
    };
    return event;
}
function $917ecae40b6dbfe3$var$_INTERNAL_insertFlagToScope(name, value, maxSize = $917ecae40b6dbfe3$var$_INTERNAL_FLAG_BUFFER_SIZE) {
    const scopeContexts = $gjJ9A.getCurrentScope().getScopeData().contexts;
    if (!scopeContexts.flags) scopeContexts.flags = {
        values: []
    };
    const flags = scopeContexts.flags.values;
    $917ecae40b6dbfe3$var$_INTERNAL_insertToFlagBuffer(flags, name, value, maxSize);
}
function $917ecae40b6dbfe3$var$_INTERNAL_insertToFlagBuffer(flags, name, value, maxSize) {
    if (typeof value !== "boolean") return;
    if (flags.length > maxSize) {
        $jCjMv.DEBUG_BUILD && $jix5p.debug.error(`[Feature Flags] insertToFlagBuffer called on a buffer larger than maxSize=${maxSize}`);
        return;
    }
    const index = flags.findIndex((f)=>f.flag === name);
    if (index !== -1) flags.splice(index, 1);
    if (flags.length === maxSize) flags.shift();
    flags.push({
        flag: name,
        result: value
    });
}
function $917ecae40b6dbfe3$var$_INTERNAL_addFeatureFlagToActiveSpan(name, value, maxFlagsPerSpan = $917ecae40b6dbfe3$var$_INTERNAL_MAX_FLAGS_PER_SPAN) {
    if (typeof value !== "boolean") return;
    const span = $2dG64.getActiveSpan();
    if (!span) return;
    const attributes = $2dG64.spanToJSON(span).data;
    if (`${$917ecae40b6dbfe3$var$SPAN_FLAG_ATTRIBUTE_PREFIX}${name}` in attributes) {
        span.setAttribute(`${$917ecae40b6dbfe3$var$SPAN_FLAG_ATTRIBUTE_PREFIX}${name}`, value);
        return;
    }
    const numOfAddedFlags = Object.keys(attributes).filter((key)=>key.startsWith($917ecae40b6dbfe3$var$SPAN_FLAG_ATTRIBUTE_PREFIX)).length;
    if (numOfAddedFlags < maxFlagsPerSpan) span.setAttribute(`${$917ecae40b6dbfe3$var$SPAN_FLAG_ATTRIBUTE_PREFIX}${name}`, value);
}
module.exports._INTERNAL_FLAG_BUFFER_SIZE = $917ecae40b6dbfe3$var$_INTERNAL_FLAG_BUFFER_SIZE;
module.exports._INTERNAL_MAX_FLAGS_PER_SPAN = $917ecae40b6dbfe3$var$_INTERNAL_MAX_FLAGS_PER_SPAN;
module.exports._INTERNAL_addFeatureFlagToActiveSpan = $917ecae40b6dbfe3$var$_INTERNAL_addFeatureFlagToActiveSpan;
module.exports._INTERNAL_copyFlagsFromScopeToEvent = $917ecae40b6dbfe3$var$_INTERNAL_copyFlagsFromScopeToEvent;
module.exports._INTERNAL_insertFlagToScope = $917ecae40b6dbfe3$var$_INTERNAL_insertFlagToScope;
module.exports._INTERNAL_insertToFlagBuffer = $917ecae40b6dbfe3$var$_INTERNAL_insertToFlagBuffer;

});


parcelRegister("6J050", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5QaR1 = parcelRequire("5QaR1");

var $cut0U = parcelRequire("cut0U");

var $2SQtm = parcelRequire("2SQtm");
const $4e5701e0c4731b4c$var$growthbookIntegration = $5QaR1.defineIntegration(({ growthbookClass: growthbookClass })=>{
    return {
        name: "GrowthBook",
        setupOnce () {
            const proto = growthbookClass.prototype;
            if (typeof proto.isOn === "function") $2SQtm.fill(proto, "isOn", $4e5701e0c4731b4c$var$_wrapAndCaptureBooleanResult);
            if (typeof proto.getFeatureValue === "function") $2SQtm.fill(proto, "getFeatureValue", $4e5701e0c4731b4c$var$_wrapAndCaptureBooleanResult);
        },
        processEvent (event, _hint, _client) {
            return $cut0U._INTERNAL_copyFlagsFromScopeToEvent(event);
        }
    };
});
function $4e5701e0c4731b4c$var$_wrapAndCaptureBooleanResult(original) {
    return function(...args) {
        const flagName = args[0];
        const result = original.apply(this, args);
        if (typeof flagName === "string" && typeof result === "boolean") {
            $cut0U._INTERNAL_insertFlagToScope(flagName, result);
            $cut0U._INTERNAL_addFeatureFlagToActiveSpan(flagName, result);
        }
        return result;
    };
}
module.exports.growthbookIntegration = $4e5701e0c4731b4c$var$growthbookIntegration;

});

parcelRegister("2yqyX", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gjJ9A = parcelRequire("gjJ9A");

var $5QaR1 = parcelRequire("5QaR1");

var $3dwiN = parcelRequire("3dwiN");

var $2dG64 = parcelRequire("2dG64");
const $1dc35c8d30edad98$var$INTEGRATION_NAME = "ConversationId";
const $1dc35c8d30edad98$var$_conversationIdIntegration = ()=>{
    return {
        name: $1dc35c8d30edad98$var$INTEGRATION_NAME,
        setup (client) {
            client.on("spanStart", (span)=>{
                const scopeData = $gjJ9A.getCurrentScope().getScopeData();
                const isolationScopeData = $gjJ9A.getIsolationScope().getScopeData();
                const conversationId = scopeData.conversationId || isolationScopeData.conversationId;
                if (conversationId) {
                    const { op: op, data: attributes, description: name } = $2dG64.spanToJSON(span);
                    if (!op?.startsWith("gen_ai.") && !attributes["ai.operationId"] && !name?.startsWith("ai.")) return;
                    span.setAttribute($3dwiN.GEN_AI_CONVERSATION_ID_ATTRIBUTE, conversationId);
                }
            });
        }
    };
};
const $1dc35c8d30edad98$var$conversationIdIntegration = $5QaR1.defineIntegration($1dc35c8d30edad98$var$_conversationIdIntegration);
module.exports.conversationIdIntegration = $1dc35c8d30edad98$var$conversationIdIntegration;

});

parcelRegister("kxD6q", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gjJ9A = parcelRequire("gjJ9A");

var $jCjMv = parcelRequire("jCjMv");

var $jix5p = parcelRequire("jix5p");
function $ef4538a8d3c6d340$var$isProfilingIntegrationWithProfiler(integration) {
    return !!integration && typeof integration["_profiler"] !== "undefined" && typeof integration["_profiler"]["start"] === "function" && typeof integration["_profiler"]["stop"] === "function";
}
function $ef4538a8d3c6d340$var$startProfiler() {
    const client = $gjJ9A.getClient();
    if (!client) {
        $jCjMv.DEBUG_BUILD && $jix5p.debug.warn("No Sentry client available, profiling is not started");
        return;
    }
    const integration = client.getIntegrationByName("ProfilingIntegration");
    if (!integration) {
        $jCjMv.DEBUG_BUILD && $jix5p.debug.warn("ProfilingIntegration is not available");
        return;
    }
    if (!$ef4538a8d3c6d340$var$isProfilingIntegrationWithProfiler(integration)) {
        $jCjMv.DEBUG_BUILD && $jix5p.debug.warn("Profiler is not available on profiling integration.");
        return;
    }
    integration._profiler.start();
}
function $ef4538a8d3c6d340$var$stopProfiler() {
    const client = $gjJ9A.getClient();
    if (!client) {
        $jCjMv.DEBUG_BUILD && $jix5p.debug.warn("No Sentry client available, profiling is not started");
        return;
    }
    const integration = client.getIntegrationByName("ProfilingIntegration");
    if (!integration) {
        $jCjMv.DEBUG_BUILD && $jix5p.debug.warn("ProfilingIntegration is not available");
        return;
    }
    if (!$ef4538a8d3c6d340$var$isProfilingIntegrationWithProfiler(integration)) {
        $jCjMv.DEBUG_BUILD && $jix5p.debug.warn("Profiler is not available on profiling integration.");
        return;
    }
    integration._profiler.stop();
}
const $ef4538a8d3c6d340$var$profiler = {
    startProfiler: $ef4538a8d3c6d340$var$startProfiler,
    stopProfiler: $ef4538a8d3c6d340$var$stopProfiler
};
module.exports.profiler = $ef4538a8d3c6d340$var$profiler;

});

parcelRegister("dgc2Y", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gjJ9A = parcelRequire("gjJ9A");

var $3dwiN = parcelRequire("3dwiN");

var $2dG64 = parcelRequire("2dG64");

var $9X7hl = parcelRequire("9X7hl");

var $fBPG6 = parcelRequire("fBPG6");

var $hbAIy = parcelRequire("hbAIy");

var $enaoN = parcelRequire("enaoN");

var $lJzTh = parcelRequire("lJzTh");

var $lIOsi = parcelRequire("lIOsi");

var $4Ae9I = parcelRequire("4Ae9I");

var $kipJA = parcelRequire("kipJA");

var $Qbf2O = parcelRequire("Qbf2O");
function $9a761d3c3aa446c0$var$instrumentFetchRequest(handlerData, shouldCreateSpan, shouldAttachHeaders, spans, spanOriginOrOptions) {
    if (!handlerData.fetchData) return void 0;
    const { method: method, url: url } = handlerData.fetchData;
    const shouldCreateSpanResult = $hbAIy.hasSpansEnabled() && shouldCreateSpan(url);
    if (handlerData.endTimestamp) {
        const spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        const span2 = spans[spanId];
        if (span2) {
            if (shouldCreateSpanResult) {
                $9a761d3c3aa446c0$var$endSpan(span2, handlerData);
                $9a761d3c3aa446c0$var$_callOnRequestSpanEnd(span2, handlerData, spanOriginOrOptions);
            }
            delete spans[spanId];
        }
        return void 0;
    }
    const { spanOrigin: spanOrigin = "auto.http.browser", propagateTraceparent: propagateTraceparent = false } = typeof spanOriginOrOptions === "object" ? spanOriginOrOptions : {
        spanOrigin: spanOriginOrOptions
    };
    const client = $gjJ9A.getClient();
    const hasParent = !!$2dG64.getActiveSpan();
    const shouldEmitSpan = hasParent || !!client && $lIOsi.hasSpanStreamingEnabled(client);
    const span = shouldCreateSpanResult && shouldEmitSpan ? $4Ae9I.startInactiveSpan($9a761d3c3aa446c0$var$getSpanStartOptions(url, method, spanOrigin)) : new $lJzTh.SentryNonRecordingSpan();
    if (shouldCreateSpanResult && !shouldEmitSpan) client?.recordDroppedEvent("no_parent_span", "span");
    handlerData.fetchData.__span = span.spanContext().spanId;
    spans[span.spanContext().spanId] = span;
    if (shouldAttachHeaders(handlerData.fetchData.url)) {
        const request = handlerData.args[0];
        const options = {
            ...handlerData.args[1] || {}
        };
        const headers = $9a761d3c3aa446c0$var$_INTERNAL_getTracingHeadersForFetchRequest(request, options, // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
        // we do not want to use the span as base for the trace headers,
        // which means that the headers will be generated from the scope and the sampling decision is deferred
        $hbAIy.hasSpansEnabled() && shouldEmitSpan ? span : void 0, propagateTraceparent);
        if (headers) {
            handlerData.args[1] = options;
            options.headers = headers;
        }
    }
    if (client) {
        const fetchHint = {
            input: handlerData.args,
            response: handlerData.response,
            startTimestamp: handlerData.startTimestamp,
            endTimestamp: handlerData.endTimestamp
        };
        client.emit("beforeOutgoingRequestSpan", span, fetchHint);
    }
    return span;
}
function $9a761d3c3aa446c0$var$_callOnRequestSpanEnd(span, handlerData, spanOriginOrOptions) {
    const onRequestSpanEnd = typeof spanOriginOrOptions === "object" && spanOriginOrOptions !== null ? spanOriginOrOptions.onRequestSpanEnd : void 0;
    onRequestSpanEnd?.(span, {
        headers: handlerData.response?.headers,
        error: handlerData.error
    });
}
function $9a761d3c3aa446c0$var$_INTERNAL_getTracingHeadersForFetchRequest(request, fetchOptionsObj, span, propagateTraceparent) {
    const traceHeaders = $Qbf2O.getTraceData({
        span: span,
        propagateTraceparent: propagateTraceparent
    });
    const sentryTrace = traceHeaders["sentry-trace"];
    const baggage = traceHeaders.baggage;
    const traceparent = traceHeaders.traceparent;
    if (!sentryTrace) return void 0;
    const originalHeaders = fetchOptionsObj.headers || ($fBPG6.isRequest(request) ? request.headers : void 0);
    if (!originalHeaders) return {
        ...traceHeaders
    };
    else if ($9a761d3c3aa446c0$var$isHeaders(originalHeaders)) {
        const newHeaders = new Headers(originalHeaders);
        if (!newHeaders.get("sentry-trace")) newHeaders.set("sentry-trace", sentryTrace);
        if (propagateTraceparent && traceparent && !newHeaders.get("traceparent")) newHeaders.set("traceparent", traceparent);
        if (baggage) {
            const prevBaggageHeader = newHeaders.get("baggage");
            if (!prevBaggageHeader) newHeaders.set("baggage", baggage);
            else if (!$9a761d3c3aa446c0$var$baggageHeaderHasSentryBaggageValues(prevBaggageHeader)) newHeaders.set("baggage", `${prevBaggageHeader},${baggage}`);
        }
        return newHeaders;
    } else if ($9a761d3c3aa446c0$var$isHeadersInitTupleArray(originalHeaders)) {
        const newHeaders = [
            ...originalHeaders
        ];
        if (!newHeaders.find((header)=>header[0] === "sentry-trace")) newHeaders.push([
            "sentry-trace",
            sentryTrace
        ]);
        if (propagateTraceparent && traceparent && !newHeaders.find((header)=>header[0] === "traceparent")) newHeaders.push([
            "traceparent",
            traceparent
        ]);
        const prevBaggageHeaderWithSentryValues = originalHeaders.find((header)=>header[0] === "baggage" && typeof header[1] === "string" && $9a761d3c3aa446c0$var$baggageHeaderHasSentryBaggageValues(header[1]));
        if (baggage && !prevBaggageHeaderWithSentryValues) newHeaders.push([
            "baggage",
            baggage
        ]);
        return newHeaders;
    } else {
        const existingSentryTraceHeader = "sentry-trace" in originalHeaders ? originalHeaders["sentry-trace"] : void 0;
        const existingTraceparentHeader = "traceparent" in originalHeaders ? originalHeaders.traceparent : void 0;
        const existingBaggageHeader = "baggage" in originalHeaders ? originalHeaders.baggage : void 0;
        const newBaggageHeaders = existingBaggageHeader ? Array.isArray(existingBaggageHeader) ? [
            ...existingBaggageHeader
        ] : [
            existingBaggageHeader
        ] : [];
        const prevBaggageHeaderWithSentryValues = existingBaggageHeader && (Array.isArray(existingBaggageHeader) ? existingBaggageHeader.find((headerItem)=>$9a761d3c3aa446c0$var$baggageHeaderHasSentryBaggageValues(headerItem)) : $9a761d3c3aa446c0$var$baggageHeaderHasSentryBaggageValues(existingBaggageHeader));
        if (baggage && !prevBaggageHeaderWithSentryValues) newBaggageHeaders.push(baggage);
        const newHeaders = Object.assign({}, originalHeaders, {
            "sentry-trace": existingSentryTraceHeader ?? sentryTrace,
            baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(",") : void 0
        });
        if (propagateTraceparent && traceparent && !existingTraceparentHeader) newHeaders.traceparent = traceparent;
        return newHeaders;
    }
}
function $9a761d3c3aa446c0$var$endSpan(span, handlerData) {
    if (handlerData.response) {
        $9X7hl.setHttpStatus(span, handlerData.response.status);
        const contentLength = handlerData.response?.headers?.get("content-length");
        if (contentLength) {
            const contentLengthNum = parseInt(contentLength);
            if (contentLengthNum > 0) span.setAttribute("http.response_content_length", contentLengthNum);
        }
    } else if (handlerData.error) span.setStatus({
        code: $9X7hl.SPAN_STATUS_ERROR,
        message: "internal_error"
    });
    span.end();
}
function $9a761d3c3aa446c0$var$baggageHeaderHasSentryBaggageValues(baggageHeader) {
    if (typeof baggageHeader !== "string") return false;
    return baggageHeader.split(",").some((baggageEntry)=>baggageEntry.trim().startsWith($enaoN.SENTRY_BAGGAGE_KEY_PREFIX));
}
function $9a761d3c3aa446c0$var$isHeaders(headers) {
    return typeof Headers !== "undefined" && $fBPG6.isInstanceOf(headers, Headers);
}
function $9a761d3c3aa446c0$var$isHeadersInitTupleArray(headers) {
    if (!Array.isArray(headers)) return false;
    return headers.every((item)=>Array.isArray(item) && item.length === 2 && typeof item[0] === "string");
}
function $9a761d3c3aa446c0$var$getSpanStartOptions(url$1, method, spanOrigin) {
    if (url$1.startsWith("data:")) {
        const sanitizedUrl2 = $kipJA.stripDataUrlContent(url$1);
        return {
            name: `${method} ${sanitizedUrl2}`,
            attributes: $9a761d3c3aa446c0$var$getFetchSpanAttributes(url$1, void 0, method, spanOrigin)
        };
    }
    const parsedUrl = $kipJA.parseStringToURLObject(url$1);
    const sanitizedUrl = parsedUrl ? $kipJA.getSanitizedUrlStringFromUrlObject(parsedUrl) : url$1;
    return {
        name: `${method} ${sanitizedUrl}`,
        attributes: $9a761d3c3aa446c0$var$getFetchSpanAttributes(url$1, parsedUrl, method, spanOrigin)
    };
}
function $9a761d3c3aa446c0$var$getFetchSpanAttributes(url$1, parsedUrl, method, spanOrigin) {
    const attributes = {
        url: $kipJA.stripDataUrlContent(url$1),
        type: "fetch",
        "http.method": method,
        [$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: spanOrigin,
        [$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "http.client"
    };
    if (parsedUrl) {
        if (!$kipJA.isURLObjectRelative(parsedUrl)) {
            attributes["http.url"] = $kipJA.stripDataUrlContent(parsedUrl.href);
            attributes["server.address"] = parsedUrl.host;
        }
        if (parsedUrl.search) attributes["http.query"] = parsedUrl.search;
        if (parsedUrl.hash) attributes["http.fragment"] = parsedUrl.hash;
    }
    return attributes;
}
module.exports._INTERNAL_getTracingHeadersForFetchRequest = $9a761d3c3aa446c0$var$_INTERNAL_getTracingHeadersForFetchRequest;
module.exports._callOnRequestSpanEnd = $9a761d3c3aa446c0$var$_callOnRequestSpanEnd;
module.exports.instrumentFetchRequest = $9a761d3c3aa446c0$var$instrumentFetchRequest;

});

parcelRegister("9ZcIi", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gjJ9A = parcelRequire("gjJ9A");
function $7453ac2f649dac61$var$captureFeedback(params, hint = {}, scope = $gjJ9A.getCurrentScope()) {
    const { message: message, name: name, email: email, url: url, source: source, associatedEventId: associatedEventId, tags: tags } = params;
    const feedbackEvent = {
        contexts: {
            feedback: {
                contact_email: email,
                name: name,
                message: message,
                url: url,
                source: source,
                associated_event_id: associatedEventId
            }
        },
        type: "feedback",
        level: "info",
        tags: tags
    };
    const client = scope?.getClient() || $gjJ9A.getClient();
    if (client) client.emit("beforeSendFeedback", feedbackEvent, hint);
    const eventId = scope.captureEvent(feedbackEvent, hint);
    return eventId;
}
module.exports.captureFeedback = $7453ac2f649dac61$var$captureFeedback;

});

parcelRegister("az8OY", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hAYfg = parcelRequire("hAYfg");

var $csMoB = parcelRequire("csMoB");
function $7b1403fa06350dfc$var$captureLog(level, message, attributes, scope, severityNumber) {
    $hAYfg._INTERNAL_captureLog({
        level: level,
        message: message,
        attributes: attributes,
        severityNumber: severityNumber
    }, scope);
}
function $7b1403fa06350dfc$var$trace(message, attributes, { scope: scope } = {}) {
    $7b1403fa06350dfc$var$captureLog("trace", message, attributes, scope);
}
function $7b1403fa06350dfc$var$debug(message, attributes, { scope: scope } = {}) {
    $7b1403fa06350dfc$var$captureLog("debug", message, attributes, scope);
}
function $7b1403fa06350dfc$var$info(message, attributes, { scope: scope } = {}) {
    $7b1403fa06350dfc$var$captureLog("info", message, attributes, scope);
}
function $7b1403fa06350dfc$var$warn(message, attributes, { scope: scope } = {}) {
    $7b1403fa06350dfc$var$captureLog("warn", message, attributes, scope);
}
function $7b1403fa06350dfc$var$error(message, attributes, { scope: scope } = {}) {
    $7b1403fa06350dfc$var$captureLog("error", message, attributes, scope);
}
function $7b1403fa06350dfc$var$fatal(message, attributes, { scope: scope } = {}) {
    $7b1403fa06350dfc$var$captureLog("fatal", message, attributes, scope);
}
module.exports.fmt = $csMoB.fmt;
module.exports.debug = $7b1403fa06350dfc$var$debug;
module.exports.error = $7b1403fa06350dfc$var$error;
module.exports.fatal = $7b1403fa06350dfc$var$fatal;
module.exports.info = $7b1403fa06350dfc$var$info;
module.exports.trace = $7b1403fa06350dfc$var$trace;
module.exports.warn = $7b1403fa06350dfc$var$warn;

});

parcelRegister("1VNMa", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gjJ9A = parcelRequire("gjJ9A");

var $jCjMv = parcelRequire("jCjMv");

var $9SKf6 = parcelRequire("9SKf6");

var $5QaR1 = parcelRequire("5QaR1");

var $3dwiN = parcelRequire("3dwiN");

var $jix5p = parcelRequire("jix5p");

var $hAYfg = parcelRequire("hAYfg");

var $32kR7 = parcelRequire("32kR7");
const $1681b9c3f5233788$var$INTEGRATION_NAME = "ConsoleLogs";
const $1681b9c3f5233788$var$DEFAULT_ATTRIBUTES = {
    [$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.log.console"
};
const $1681b9c3f5233788$var$_consoleLoggingIntegration = (options = {})=>{
    const levels = options.levels || $jix5p.CONSOLE_LEVELS;
    return {
        name: $1681b9c3f5233788$var$INTEGRATION_NAME,
        setup (client) {
            const { enableLogs: enableLogs, normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1e3 } = client.getOptions();
            if (!enableLogs) {
                $jCjMv.DEBUG_BUILD && $jix5p.debug.warn("`enableLogs` is not enabled, ConsoleLogs integration disabled");
                return;
            }
            const unsubscribe = $9SKf6.addConsoleInstrumentationHandler(({ args: args, level: level })=>{
                if ($gjJ9A.getClient() !== client || !levels.includes(level)) return;
                const firstArg = args[0];
                const followingArgs = args.slice(1);
                if (level === "assert") {
                    if (!firstArg) {
                        const assertionMessage = followingArgs.length > 0 ? `Assertion failed: ${$32kR7.formatConsoleArgs(followingArgs, normalizeDepth, normalizeMaxBreadth)}` : "Assertion failed";
                        $hAYfg._INTERNAL_captureLog({
                            level: "error",
                            message: assertionMessage,
                            attributes: $1681b9c3f5233788$var$DEFAULT_ATTRIBUTES
                        });
                    }
                    return;
                }
                const isLevelLog = level === "log";
                const shouldGenerateTemplate = args.length > 1 && typeof args[0] === "string" && !$32kR7.hasConsoleSubstitutions(args[0]);
                const attributes = {
                    ...$1681b9c3f5233788$var$DEFAULT_ATTRIBUTES,
                    ...shouldGenerateTemplate ? $32kR7.createConsoleTemplateAttributes(firstArg, followingArgs) : {}
                };
                $hAYfg._INTERNAL_captureLog({
                    level: isLevelLog ? "info" : level,
                    message: $32kR7.formatConsoleArgs(args, normalizeDepth, normalizeMaxBreadth),
                    severityNumber: isLevelLog ? 10 : void 0,
                    attributes: attributes
                });
            });
            client.registerCleanup(unsubscribe);
        }
    };
};
const $1681b9c3f5233788$var$consoleLoggingIntegration = $5QaR1.defineIntegration($1681b9c3f5233788$var$_consoleLoggingIntegration);
module.exports.consoleLoggingIntegration = $1681b9c3f5233788$var$consoleLoggingIntegration;

});
parcelRegister("32kR7", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $fBPG6 = parcelRequire("fBPG6");

var $bg87c = parcelRequire("bg87c");

var $hsCGK = parcelRequire("hsCGK");
function $2361bc89713d95c6$var$formatConsoleArgs(values, normalizeDepth, normalizeMaxBreadth) {
    return "util" in $hsCGK.GLOBAL_OBJ && typeof $hsCGK.GLOBAL_OBJ.util.format === "function" ? $hsCGK.GLOBAL_OBJ.util.format(...values) : $2361bc89713d95c6$var$safeJoinConsoleArgs(values, normalizeDepth, normalizeMaxBreadth);
}
function $2361bc89713d95c6$var$safeJoinConsoleArgs(values, normalizeDepth, normalizeMaxBreadth) {
    return values.map((value)=>$fBPG6.isPrimitive(value) ? String(value) : JSON.stringify($bg87c.normalize(value, normalizeDepth, normalizeMaxBreadth))).join(" ");
}
function $2361bc89713d95c6$var$hasConsoleSubstitutions(str) {
    return /%[sdifocO]/.test(str);
}
function $2361bc89713d95c6$var$createConsoleTemplateAttributes(firstArg, followingArgs) {
    const attributes = {};
    const template = new Array(followingArgs.length).fill("{}").join(" ");
    attributes["sentry.message.template"] = `${firstArg} ${template}`;
    followingArgs.forEach((arg, index)=>{
        attributes[`sentry.message.parameter.${index}`] = arg;
    });
    return attributes;
}
module.exports.createConsoleTemplateAttributes = $2361bc89713d95c6$var$createConsoleTemplateAttributes;
module.exports.formatConsoleArgs = $2361bc89713d95c6$var$formatConsoleArgs;
module.exports.hasConsoleSubstitutions = $2361bc89713d95c6$var$hasConsoleSubstitutions;
module.exports.safeJoinConsoleArgs = $2361bc89713d95c6$var$safeJoinConsoleArgs;

});


parcelRegister("iHNtB", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $iTp6h = parcelRequire("iTp6h");
function $d9e29f261c3201c0$var$captureMetric(type, name, value, options) {
    $iTp6h._INTERNAL_captureMetric({
        type: type,
        name: name,
        value: value,
        unit: options?.unit,
        attributes: options?.attributes
    }, {
        scope: options?.scope
    });
}
function $d9e29f261c3201c0$var$count(name, value = 1, options) {
    $d9e29f261c3201c0$var$captureMetric("counter", name, value, options);
}
function $d9e29f261c3201c0$var$gauge(name, value, options) {
    $d9e29f261c3201c0$var$captureMetric("gauge", name, value, options);
}
function $d9e29f261c3201c0$var$distribution(name, value, options) {
    $d9e29f261c3201c0$var$captureMetric("distribution", name, value, options);
}
module.exports.count = $d9e29f261c3201c0$var$count;
module.exports.distribution = $d9e29f261c3201c0$var$distribution;
module.exports.gauge = $d9e29f261c3201c0$var$gauge;

});

parcelRegister("3Jcbc", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gjJ9A = parcelRequire("gjJ9A");

var $hAYfg = parcelRequire("hAYfg");

var $32kR7 = parcelRequire("32kR7");

var $fBPG6 = parcelRequire("fBPG6");

var $bg87c = parcelRequire("bg87c");
const $2b6f05b66eb38fa0$var$DEFAULT_CAPTURED_LEVELS = [
    "trace",
    "debug",
    "info",
    "warn",
    "error",
    "fatal"
];
function $2b6f05b66eb38fa0$var$createConsolaReporter(options = {}) {
    const levels = new Set(options.levels ?? $2b6f05b66eb38fa0$var$DEFAULT_CAPTURED_LEVELS);
    const providedClient = options.client;
    return {
        log (logObj) {
            const { type: type, level: level, message: consolaMessage, args: args, tag: tag, date: _date, ...rest } = logObj;
            const client = providedClient || $gjJ9A.getClient();
            if (!client) return;
            const logSeverityLevel = $2b6f05b66eb38fa0$var$getLogSeverityLevel(type, level);
            if (!levels.has(logSeverityLevel)) return;
            const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1e3 } = client.getOptions();
            const attributes = {};
            for (const [key, value] of Object.entries(rest))attributes[key] = $bg87c.normalize(value, normalizeDepth, normalizeMaxBreadth);
            attributes["sentry.origin"] = "auto.log.consola";
            if (tag) attributes["consola.tag"] = tag;
            if (type) attributes["consola.type"] = type;
            if (level != null && typeof level === "number") attributes["consola.level"] = level;
            const extractionResult = $2b6f05b66eb38fa0$var$processExtractedAttributes($2b6f05b66eb38fa0$var$defaultExtractAttributes(args, normalizeDepth, normalizeMaxBreadth), normalizeDepth, normalizeMaxBreadth);
            if (extractionResult?.attributes) Object.assign(attributes, extractionResult.attributes);
            $hAYfg._INTERNAL_captureLog({
                level: logSeverityLevel,
                message: extractionResult?.message || consolaMessage || args && $32kR7.formatConsoleArgs(args, normalizeDepth, normalizeMaxBreadth) || "",
                attributes: attributes
            });
        }
    };
}
const $2b6f05b66eb38fa0$var$CONSOLA_TYPE_TO_LOG_SEVERITY_LEVEL_MAP = {
    // Consola built-in types
    silent: "trace",
    fatal: "fatal",
    error: "error",
    warn: "warn",
    log: "info",
    info: "info",
    success: "info",
    fail: "error",
    ready: "info",
    start: "info",
    box: "info",
    debug: "debug",
    trace: "trace",
    verbose: "debug",
    // Custom types that might exist
    critical: "fatal",
    notice: "info"
};
const $2b6f05b66eb38fa0$var$CONSOLA_LEVEL_TO_LOG_SEVERITY_LEVEL_MAP = {
    0: "fatal",
    // Fatal and Error
    1: "warn",
    // Warnings
    2: "info",
    // Normal logs
    3: "info",
    // Informational logs, success, fail, ready, start, ...
    4: "debug",
    // Debug logs
    5: "trace"
};
function $2b6f05b66eb38fa0$var$getLogSeverityLevel(type, level) {
    if (type === "verbose") return "debug";
    if (type === "silent") return "trace";
    if (type) {
        const mappedLevel = $2b6f05b66eb38fa0$var$CONSOLA_TYPE_TO_LOG_SEVERITY_LEVEL_MAP[type];
        if (mappedLevel) return mappedLevel;
    }
    if (typeof level === "number") {
        const mappedLevel = $2b6f05b66eb38fa0$var$CONSOLA_LEVEL_TO_LOG_SEVERITY_LEVEL_MAP[level];
        if (mappedLevel) return mappedLevel;
    }
    return "info";
}
function $2b6f05b66eb38fa0$var$defaultExtractAttributes(args, normalizeDepth, normalizeMaxBreadth) {
    if (!args?.length) return {
        message: ""
    };
    const message = $32kR7.formatConsoleArgs(args, normalizeDepth, normalizeMaxBreadth);
    const firstArg = args[0];
    if ($fBPG6.isPlainObject(firstArg)) {
        const remainingArgsStartIndex = typeof args[1] === "string" ? 2 : 1;
        const remainingArgs = args.slice(remainingArgsStartIndex);
        return {
            message: message,
            // Object content from first arg is added as attributes
            attributes: firstArg,
            // Add remaining args as message parameters
            messageParameters: remainingArgs
        };
    } else {
        const followingArgs = args.slice(1);
        const shouldAddTemplateAttr = followingArgs.length > 0 && typeof firstArg === "string" && !$32kR7.hasConsoleSubstitutions(firstArg);
        return {
            message: message,
            messageTemplate: shouldAddTemplateAttr ? firstArg : void 0,
            messageParameters: shouldAddTemplateAttr ? followingArgs : void 0
        };
    }
}
function $2b6f05b66eb38fa0$var$processExtractedAttributes(extractionResult, normalizeDepth, normalizeMaxBreadth) {
    const { message: message, attributes: attributes, messageTemplate: messageTemplate, messageParameters: messageParameters } = extractionResult;
    const messageParamAttributes = {};
    if (messageTemplate && messageParameters) {
        const templateAttrs = $32kR7.createConsoleTemplateAttributes(messageTemplate, messageParameters);
        for (const [key, value] of Object.entries(templateAttrs))messageParamAttributes[key] = key.startsWith("sentry.message.parameter.") ? $bg87c.normalize(value, normalizeDepth, normalizeMaxBreadth) : value;
    } else if (messageParameters && messageParameters.length > 0) messageParameters.forEach((arg, index)=>{
        messageParamAttributes[`sentry.message.parameter.${index}`] = $bg87c.normalize(arg, normalizeDepth, normalizeMaxBreadth);
    });
    return {
        message: message,
        attributes: {
            ...$bg87c.normalize(attributes, normalizeDepth, normalizeMaxBreadth),
            ...messageParamAttributes
        }
    };
}
module.exports.createConsolaReporter = $2b6f05b66eb38fa0$var$createConsolaReporter;

});

parcelRegister("ilbTW", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gjJ9A = parcelRequire("gjJ9A");

var $3dwiN = parcelRequire("3dwiN");

var $8rGYq = parcelRequire("8rGYq");

var $2dG64 = parcelRequire("2dG64");

var $njxh1 = parcelRequire("njxh1");

var $3GQdK = parcelRequire("3GQdK");

var $lIOsi = parcelRequire("lIOsi");

var $lFN6F = parcelRequire("lFN6F");

var $3rWH2 = parcelRequire("3rWH2");
function $d5a36b821305a330$var$onVercelAiSpanStart(span) {
    const { data: attributes, description: name } = $2dG64.spanToJSON(span);
    if (!name) return;
    if (attributes[$3rWH2.AI_TOOL_CALL_NAME_ATTRIBUTE] && attributes[$3rWH2.AI_TOOL_CALL_ID_ATTRIBUTE] && name === "ai.toolCall") {
        $d5a36b821305a330$var$processToolCallSpan(span, attributes);
        return;
    }
    if (!attributes[$3rWH2.AI_OPERATION_ID_ATTRIBUTE] && !name.startsWith("ai.")) return;
    const client = $gjJ9A.getClient();
    const integration = client?.getIntegrationByName("VercelAI");
    const enableTruncation = $8rGYq.shouldEnableTruncation(integration?.options?.enableTruncation);
    $d5a36b821305a330$var$processGenerateSpan(span, name, attributes, enableTruncation);
}
function $d5a36b821305a330$var$vercelAiEventProcessor(event) {
    if (event.type === "transaction" && event.spans) {
        const tokenAccumulator = /* @__PURE__ */ new Map();
        for (const span of event.spans){
            $d5a36b821305a330$var$processEndedVercelAiSpan(span);
            $lFN6F.accumulateTokensForParent(span, tokenAccumulator);
        }
        $lFN6F.applyToolDescriptionsAndTokens(event.spans, tokenAccumulator);
        const trace = event.contexts?.trace;
        if (trace?.op === "gen_ai.invoke_agent") $lFN6F.applyAccumulatedTokens(trace, tokenAccumulator);
    }
    return event;
}
function $d5a36b821305a330$var$normalizeFinishReason(finishReason) {
    if (typeof finishReason !== "string") return "stop";
    switch(finishReason){
        case "tool-calls":
            return "tool_call";
        case "stop":
        case "length":
        case "content_filter":
        case "error":
            return finishReason;
        default:
            return finishReason;
    }
}
function $d5a36b821305a330$var$buildOutputMessages(attributes) {
    const responseText = attributes[$3rWH2.AI_RESPONSE_TEXT_ATTRIBUTE];
    const responseToolCalls = attributes[$3rWH2.AI_RESPONSE_TOOL_CALLS_ATTRIBUTE];
    const finishReason = attributes[$3rWH2.AI_RESPONSE_FINISH_REASON_ATTRIBUTE];
    if (responseText == null && responseToolCalls == null) return;
    const parts = [];
    if (typeof responseText === "string" && responseText.length > 0) parts.push({
        type: "text",
        content: responseText
    });
    if (responseToolCalls != null) try {
        const toolCalls = typeof responseToolCalls === "string" ? JSON.parse(responseToolCalls) : responseToolCalls;
        if (Array.isArray(toolCalls)) {
            for (const toolCall of toolCalls){
                const args = toolCall.input ?? toolCall.args;
                parts.push({
                    type: "tool_call",
                    id: toolCall.toolCallId,
                    name: toolCall.toolName,
                    // Handle undefined args: JSON.stringify(undefined) returns undefined, not a string,
                    // which would cause the property to be omitted from the final JSON output
                    arguments: typeof args === "string" ? args : JSON.stringify(args ?? {})
                });
            }
            delete attributes[$3rWH2.AI_RESPONSE_TOOL_CALLS_ATTRIBUTE];
        }
    } catch  {}
    if (parts.length > 0) {
        const outputMessage = {
            role: "assistant",
            parts: parts,
            finish_reason: $d5a36b821305a330$var$normalizeFinishReason(finishReason)
        };
        attributes[$njxh1.GEN_AI_OUTPUT_MESSAGES_ATTRIBUTE] = JSON.stringify([
            outputMessage
        ]);
        delete attributes[$3rWH2.AI_RESPONSE_TEXT_ATTRIBUTE];
    }
}
function $d5a36b821305a330$var$processVercelAiSpanAttributes(attributes) {
    $d5a36b821305a330$var$renameAttributeKey(attributes, $3rWH2.AI_USAGE_COMPLETION_TOKENS_ATTRIBUTE, $njxh1.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE);
    $d5a36b821305a330$var$renameAttributeKey(attributes, $3rWH2.AI_USAGE_PROMPT_TOKENS_ATTRIBUTE, $njxh1.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE);
    $d5a36b821305a330$var$renameAttributeKey(attributes, $3rWH2.AI_USAGE_CACHED_INPUT_TOKENS_ATTRIBUTE, $njxh1.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE);
    $d5a36b821305a330$var$renameAttributeKey(attributes, "ai.usage.inputTokens", $njxh1.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE);
    $d5a36b821305a330$var$renameAttributeKey(attributes, "ai.usage.outputTokens", $njxh1.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE);
    $d5a36b821305a330$var$renameAttributeKey(attributes, $3rWH2.AI_USAGE_TOKENS_ATTRIBUTE, $njxh1.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE);
    $d5a36b821305a330$var$renameAttributeKey(attributes, "ai.response.avgOutputTokensPerSecond", "ai.response.avgCompletionTokensPerSecond");
    if (typeof attributes[$njxh1.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] === "number" && typeof attributes[$njxh1.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE] === "number") attributes[$njxh1.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] = attributes[$njxh1.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] + attributes[$njxh1.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE];
    if (typeof attributes[$njxh1.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] === "number") {
        const outputTokens = typeof attributes[$njxh1.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] === "number" ? attributes[$njxh1.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] : 0;
        attributes[$njxh1.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE] = outputTokens + attributes[$njxh1.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE];
    }
    if (attributes[$3rWH2.AI_PROMPT_TOOLS_ATTRIBUTE] && Array.isArray(attributes[$3rWH2.AI_PROMPT_TOOLS_ATTRIBUTE])) attributes[$3rWH2.AI_PROMPT_TOOLS_ATTRIBUTE] = $lFN6F.convertAvailableToolsToJsonString(attributes[$3rWH2.AI_PROMPT_TOOLS_ATTRIBUTE]);
    if (attributes[$3rWH2.OPERATION_NAME_ATTRIBUTE]) {
        const rawOperationName = attributes[$3rWH2.AI_OPERATION_ID_ATTRIBUTE] ? attributes[$3rWH2.AI_OPERATION_ID_ATTRIBUTE] : attributes[$3rWH2.OPERATION_NAME_ATTRIBUTE];
        const operationName = $3GQdK.SPAN_TO_OPERATION_NAME.get(rawOperationName) ?? rawOperationName;
        attributes[$njxh1.GEN_AI_OPERATION_NAME_ATTRIBUTE] = operationName;
        delete attributes[$3rWH2.OPERATION_NAME_ATTRIBUTE];
    }
    $d5a36b821305a330$var$renameAttributeKey(attributes, $3rWH2.AI_PROMPT_MESSAGES_ATTRIBUTE, $njxh1.GEN_AI_INPUT_MESSAGES_ATTRIBUTE);
    $d5a36b821305a330$var$buildOutputMessages(attributes);
    $d5a36b821305a330$var$renameAttributeKey(attributes, $3rWH2.AI_RESPONSE_OBJECT_ATTRIBUTE, "gen_ai.response.object");
    $d5a36b821305a330$var$renameAttributeKey(attributes, $3rWH2.AI_PROMPT_TOOLS_ATTRIBUTE, "gen_ai.request.available_tools");
    $d5a36b821305a330$var$renameAttributeKey(attributes, $3rWH2.AI_TOOL_CALL_ARGS_ATTRIBUTE, $njxh1.GEN_AI_TOOL_INPUT_ATTRIBUTE);
    $d5a36b821305a330$var$renameAttributeKey(attributes, $3rWH2.AI_TOOL_CALL_RESULT_ATTRIBUTE, $njxh1.GEN_AI_TOOL_OUTPUT_ATTRIBUTE);
    $d5a36b821305a330$var$renameAttributeKey(attributes, $3rWH2.AI_SCHEMA_ATTRIBUTE, "gen_ai.request.schema");
    $d5a36b821305a330$var$renameAttributeKey(attributes, $3rWH2.AI_MODEL_ID_ATTRIBUTE, $njxh1.GEN_AI_REQUEST_MODEL_ATTRIBUTE);
    if (Array.isArray(attributes[$3rWH2.AI_VALUES_ATTRIBUTE])) {
        const parsed = attributes[$3rWH2.AI_VALUES_ATTRIBUTE].map((v)=>{
            try {
                return JSON.parse(v);
            } catch  {
                return v;
            }
        });
        attributes[$njxh1.GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE] = parsed.length === 1 ? parsed[0] : JSON.stringify(parsed);
    }
    $d5a36b821305a330$var$addProviderMetadataToAttributes(attributes);
    for (const key of Object.keys(attributes)){
        if (Array.isArray(attributes[key])) attributes[key] = JSON.stringify(attributes[key]);
        if (key.startsWith("ai.")) $d5a36b821305a330$var$renameAttributeKey(attributes, key, `vercel.${key}`);
    }
}
function $d5a36b821305a330$var$processEndedVercelAiSpan(span) {
    const { data: attributes, origin: origin } = span;
    if (origin !== "auto.vercelai.otel") return;
    if (span.status && span.status !== "ok") span.status = "internal_error";
    $d5a36b821305a330$var$processVercelAiSpanAttributes(attributes);
}
function $d5a36b821305a330$var$processVercelAiStreamedSpan(span) {
    const attributes = span.attributes;
    if (attributes?.[$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN] !== "auto.vercelai.otel") return;
    $d5a36b821305a330$var$processVercelAiSpanAttributes(attributes);
    if (attributes[$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_OP] === "gen_ai.execute_tool" && span.parent_span_id) {
        const descriptions = $3GQdK.toolDescriptionMap.get(span.parent_span_id);
        if (descriptions) {
            const toolName = attributes[$njxh1.GEN_AI_TOOL_NAME_ATTRIBUTE];
            if (typeof toolName === "string") {
                const desc = descriptions.get(toolName);
                if (desc) attributes[$njxh1.GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE] = desc;
            }
        }
    }
    $3GQdK.toolDescriptionMap.delete(span.span_id);
}
function $d5a36b821305a330$var$renameAttributeKey(attributes, oldKey, newKey) {
    if (attributes[oldKey] != null) {
        attributes[newKey] = attributes[oldKey];
        delete attributes[oldKey];
    }
}
function $d5a36b821305a330$var$processToolCallSpan(span, attributes) {
    span.setAttribute($3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, "auto.vercelai.otel");
    span.setAttribute($3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_OP, "gen_ai.execute_tool");
    span.setAttribute($njxh1.GEN_AI_OPERATION_NAME_ATTRIBUTE, "execute_tool");
    $d5a36b821305a330$var$renameAttributeKey(attributes, $3rWH2.AI_TOOL_CALL_NAME_ATTRIBUTE, $njxh1.GEN_AI_TOOL_NAME_ATTRIBUTE);
    $d5a36b821305a330$var$renameAttributeKey(attributes, $3rWH2.AI_TOOL_CALL_ID_ATTRIBUTE, $njxh1.GEN_AI_TOOL_CALL_ID_ATTRIBUTE);
    const toolCallId = attributes[$njxh1.GEN_AI_TOOL_CALL_ID_ATTRIBUTE];
    if (typeof toolCallId === "string") $3GQdK.toolCallSpanContextMap.set(toolCallId, span.spanContext());
    if (!attributes[$njxh1.GEN_AI_TOOL_TYPE_ATTRIBUTE]) span.setAttribute($njxh1.GEN_AI_TOOL_TYPE_ATTRIBUTE, "function");
    const toolName = attributes[$njxh1.GEN_AI_TOOL_NAME_ATTRIBUTE];
    if (toolName) span.updateName(`execute_tool ${toolName}`);
}
function $d5a36b821305a330$var$processGenerateSpan(span, name, attributes, enableTruncation) {
    span.setAttribute($3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, "auto.vercelai.otel");
    const nameWthoutAi = name.replace("ai.", "");
    span.setAttribute("ai.pipeline.name", nameWthoutAi);
    span.updateName(nameWthoutAi);
    const functionId = attributes[$3rWH2.AI_TELEMETRY_FUNCTION_ID_ATTRIBUTE];
    if (functionId && typeof functionId === "string") span.setAttribute("gen_ai.function_id", functionId);
    $lFN6F.requestMessagesFromPrompt(span, attributes, enableTruncation);
    if (attributes[$3rWH2.AI_MODEL_ID_ATTRIBUTE] && !attributes[$njxh1.GEN_AI_RESPONSE_MODEL_ATTRIBUTE]) span.setAttribute($njxh1.GEN_AI_RESPONSE_MODEL_ATTRIBUTE, attributes[$3rWH2.AI_MODEL_ID_ATTRIBUTE]);
    span.setAttribute("ai.streaming", name.includes("stream"));
    const operationName = $3GQdK.SPAN_TO_OPERATION_NAME.get(name);
    if (operationName) span.setAttribute($3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_OP, `gen_ai.${operationName}`);
    else if (name.startsWith("ai.stream")) span.setAttribute($3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_OP, "ai.run");
    if (operationName === "invoke_agent") {
        if (functionId && typeof functionId === "string") span.updateName(`invoke_agent ${functionId}`);
        else span.updateName("invoke_agent");
        return;
    }
    const modelId = attributes[$3rWH2.AI_MODEL_ID_ATTRIBUTE];
    if (modelId && operationName) span.updateName(`${operationName} ${modelId}`);
    const client = $gjJ9A.getClient();
    if (client && $lIOsi.hasSpanStreamingEnabled(client) && attributes[$3rWH2.AI_PROMPT_TOOLS_ATTRIBUTE] && Array.isArray(attributes[$3rWH2.AI_PROMPT_TOOLS_ATTRIBUTE])) {
        const descriptions = /* @__PURE__ */ new Map();
        for (const toolStr of attributes[$3rWH2.AI_PROMPT_TOOLS_ATTRIBUTE])try {
            const parsed = typeof toolStr === "string" ? JSON.parse(toolStr) : toolStr;
            if (parsed?.name && parsed?.description) descriptions.set(parsed.name, parsed.description);
        } catch  {}
        if (descriptions.size > 0) {
            const parentSpanId = $2dG64.spanToJSON(span).parent_span_id;
            if (parentSpanId) $3GQdK.toolDescriptionMap.set(parentSpanId, descriptions);
        }
    }
}
function $d5a36b821305a330$var$addVercelAiProcessors(client) {
    client.on("spanStart", $d5a36b821305a330$var$onVercelAiSpanStart);
    client.addEventProcessor(Object.assign($d5a36b821305a330$var$vercelAiEventProcessor, {
        id: "VercelAiEventProcessor"
    }));
    client.on("processSpan", (span)=>{
        $d5a36b821305a330$var$processVercelAiStreamedSpan(span);
    });
}
function $d5a36b821305a330$var$addProviderMetadataToAttributes(attributes) {
    const providerMetadata = attributes[$3rWH2.AI_RESPONSE_PROVIDER_METADATA_ATTRIBUTE];
    if (providerMetadata) try {
        const providerMetadataObject = JSON.parse(providerMetadata);
        const openaiMetadata = providerMetadataObject.openai ?? providerMetadataObject.azure;
        if (openaiMetadata) {
            $d5a36b821305a330$var$setAttributeIfDefined(attributes, $njxh1.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE, openaiMetadata.cachedPromptTokens);
            $d5a36b821305a330$var$setAttributeIfDefined(attributes, "gen_ai.usage.output_tokens.reasoning", openaiMetadata.reasoningTokens);
            $d5a36b821305a330$var$setAttributeIfDefined(attributes, "gen_ai.usage.output_tokens.prediction_accepted", openaiMetadata.acceptedPredictionTokens);
            $d5a36b821305a330$var$setAttributeIfDefined(attributes, "gen_ai.usage.output_tokens.prediction_rejected", openaiMetadata.rejectedPredictionTokens);
            if (!attributes["gen_ai.conversation.id"]) $d5a36b821305a330$var$setAttributeIfDefined(attributes, "gen_ai.conversation.id", openaiMetadata.responseId);
        }
        if (providerMetadataObject.anthropic) {
            const cachedInputTokens = providerMetadataObject.anthropic.usage?.cache_read_input_tokens ?? providerMetadataObject.anthropic.cacheReadInputTokens;
            $d5a36b821305a330$var$setAttributeIfDefined(attributes, $njxh1.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE, cachedInputTokens);
            const cacheWriteInputTokens = providerMetadataObject.anthropic.usage?.cache_creation_input_tokens ?? providerMetadataObject.anthropic.cacheCreationInputTokens;
            $d5a36b821305a330$var$setAttributeIfDefined(attributes, $njxh1.GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE, cacheWriteInputTokens);
        }
        if (providerMetadataObject.bedrock?.usage) {
            $d5a36b821305a330$var$setAttributeIfDefined(attributes, $njxh1.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE, providerMetadataObject.bedrock.usage.cacheReadInputTokens);
            $d5a36b821305a330$var$setAttributeIfDefined(attributes, $njxh1.GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE, providerMetadataObject.bedrock.usage.cacheWriteInputTokens);
        }
        if (providerMetadataObject.deepseek) {
            $d5a36b821305a330$var$setAttributeIfDefined(attributes, $njxh1.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE, providerMetadataObject.deepseek.promptCacheHitTokens);
            $d5a36b821305a330$var$setAttributeIfDefined(attributes, "gen_ai.usage.input_tokens.cache_miss", providerMetadataObject.deepseek.promptCacheMissTokens);
        }
    } catch  {}
}
function $d5a36b821305a330$var$setAttributeIfDefined(attributes, key, value) {
    if (value != null) attributes[key] = value;
}
module.exports.addVercelAiProcessors = $d5a36b821305a330$var$addVercelAiProcessors;
module.exports.processVercelAiSpanAttributes = $d5a36b821305a330$var$processVercelAiSpanAttributes;

});
parcelRegister("8rGYq", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8txOP = parcelRequire("8txOP");

var $gjJ9A = parcelRequire("gjJ9A");

var $lIOsi = parcelRequire("lIOsi");

var $fBPG6 = parcelRequire("fBPG6");

var $njxh1 = parcelRequire("njxh1");

var $hxh4A = parcelRequire("hxh4A");
function $62622dfe746a9387$var$resolveAIRecordingOptions(options) {
    const sendDefaultPii = Boolean($gjJ9A.getClient()?.getOptions().sendDefaultPii);
    return {
        ...options,
        recordInputs: options?.recordInputs ?? sendDefaultPii,
        recordOutputs: options?.recordOutputs ?? sendDefaultPii
    };
}
function $62622dfe746a9387$var$shouldEnableTruncation(enableTruncation) {
    const client = $gjJ9A.getClient();
    return enableTruncation ?? !(client && $lIOsi.hasSpanStreamingEnabled(client));
}
function $62622dfe746a9387$var$buildMethodPath(currentPath, prop) {
    return currentPath ? `${currentPath}.${prop}` : prop;
}
function $62622dfe746a9387$var$setTokenUsageAttributes(span, promptTokens, completionTokens, cachedInputTokens, cachedOutputTokens) {
    if (promptTokens !== void 0) span.setAttributes({
        [$njxh1.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE]: promptTokens
    });
    if (completionTokens !== void 0) span.setAttributes({
        [$njxh1.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE]: completionTokens
    });
    if (promptTokens !== void 0 || completionTokens !== void 0 || cachedInputTokens !== void 0 || cachedOutputTokens !== void 0) {
        const totalTokens = (promptTokens ?? 0) + (completionTokens ?? 0) + (cachedInputTokens ?? 0) + (cachedOutputTokens ?? 0);
        span.setAttributes({
            [$njxh1.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE]: totalTokens
        });
    }
}
function $62622dfe746a9387$var$endStreamSpan(span, state, recordOutputs) {
    if (!span.isRecording()) return;
    const attrs = {
        [$njxh1.GEN_AI_RESPONSE_STREAMING_ATTRIBUTE]: true
    };
    if (state.responseId) attrs[$njxh1.GEN_AI_RESPONSE_ID_ATTRIBUTE] = state.responseId;
    if (state.responseModel) attrs[$njxh1.GEN_AI_RESPONSE_MODEL_ATTRIBUTE] = state.responseModel;
    if (state.promptTokens !== void 0) attrs[$njxh1.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] = state.promptTokens;
    if (state.completionTokens !== void 0) attrs[$njxh1.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] = state.completionTokens;
    if (state.totalTokens !== void 0) attrs[$njxh1.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE] = state.totalTokens;
    else if (state.promptTokens !== void 0 || state.completionTokens !== void 0 || state.cacheCreationInputTokens !== void 0 || state.cacheReadInputTokens !== void 0) attrs[$njxh1.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE] = (state.promptTokens ?? 0) + (state.completionTokens ?? 0) + (state.cacheCreationInputTokens ?? 0) + (state.cacheReadInputTokens ?? 0);
    if (state.finishReasons.length) attrs[$njxh1.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE] = JSON.stringify(state.finishReasons);
    if (recordOutputs && state.responseTexts.length) attrs[$njxh1.GEN_AI_RESPONSE_TEXT_ATTRIBUTE] = state.responseTexts.join("");
    if (recordOutputs && state.toolCalls.length) attrs[$njxh1.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE] = JSON.stringify(state.toolCalls);
    span.setAttributes(attrs);
    span.end();
}
function $62622dfe746a9387$var$getJsonString(value) {
    if (typeof value === "string") return value;
    return JSON.stringify(value);
}
function $62622dfe746a9387$var$getTruncatedJsonString(value) {
    if (typeof value === "string") return $hxh4A.truncateGenAiStringInput(value);
    if (Array.isArray(value)) {
        const truncatedMessages = $hxh4A.truncateGenAiMessages(value);
        return JSON.stringify(truncatedMessages);
    }
    return JSON.stringify(value);
}
function $62622dfe746a9387$var$extractSystemInstructions(messages) {
    if (!Array.isArray(messages)) return {
        systemInstructions: void 0,
        filteredMessages: messages
    };
    const systemMessageIndex = messages.findIndex((msg)=>msg && typeof msg === "object" && "role" in msg && msg.role === "system");
    if (systemMessageIndex === -1) return {
        systemInstructions: void 0,
        filteredMessages: messages
    };
    const systemMessage = messages[systemMessageIndex];
    const systemContent = typeof systemMessage.content === "string" ? systemMessage.content : systemMessage.content !== void 0 ? JSON.stringify(systemMessage.content) : void 0;
    if (!systemContent) return {
        systemInstructions: void 0,
        filteredMessages: messages
    };
    const systemInstructions = JSON.stringify([
        {
            type: "text",
            content: systemContent
        }
    ]);
    const filteredMessages = [
        ...messages.slice(0, systemMessageIndex),
        ...messages.slice(systemMessageIndex + 1)
    ];
    return {
        systemInstructions: systemInstructions,
        filteredMessages: filteredMessages
    };
}
async function $62622dfe746a9387$var$createWithResponseWrapper(originalWithResponse, instrumentedPromise, mechanismType) {
    const safeOriginalWithResponse = originalWithResponse.catch((error)=>{
        $8txOP.captureException(error, {
            mechanism: {
                handled: false,
                type: mechanismType
            }
        });
        throw error;
    });
    const instrumentedResult = await instrumentedPromise;
    const originalWrapper = await safeOriginalWithResponse;
    if (originalWrapper && typeof originalWrapper === "object" && "data" in originalWrapper) return {
        ...originalWrapper,
        data: instrumentedResult
    };
    return instrumentedResult;
}
function $62622dfe746a9387$var$wrapPromiseWithMethods(originalPromiseLike, instrumentedPromise, mechanismType) {
    if (!$fBPG6.isThenable(originalPromiseLike)) return instrumentedPromise;
    return new Proxy(originalPromiseLike, {
        get (target, prop) {
            const useInstrumentedPromise = prop in Promise.prototype || prop === Symbol.toStringTag;
            const source = useInstrumentedPromise ? instrumentedPromise : target;
            const value = Reflect.get(source, prop);
            if (prop === "withResponse" && typeof value === "function") return function wrappedWithResponse() {
                const originalWithResponse = value.call(target);
                return $62622dfe746a9387$var$createWithResponseWrapper(originalWithResponse, instrumentedPromise, mechanismType);
            };
            return typeof value === "function" ? value.bind(source) : value;
        }
    });
}
module.exports.buildMethodPath = $62622dfe746a9387$var$buildMethodPath;
module.exports.endStreamSpan = $62622dfe746a9387$var$endStreamSpan;
module.exports.extractSystemInstructions = $62622dfe746a9387$var$extractSystemInstructions;
module.exports.getJsonString = $62622dfe746a9387$var$getJsonString;
module.exports.getTruncatedJsonString = $62622dfe746a9387$var$getTruncatedJsonString;
module.exports.resolveAIRecordingOptions = $62622dfe746a9387$var$resolveAIRecordingOptions;
module.exports.setTokenUsageAttributes = $62622dfe746a9387$var$setTokenUsageAttributes;
module.exports.shouldEnableTruncation = $62622dfe746a9387$var$shouldEnableTruncation;
module.exports.wrapPromiseWithMethods = $62622dfe746a9387$var$wrapPromiseWithMethods;

});
parcelRegister("njxh1", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $04614d797e32a6f5$var$GEN_AI_PROMPT_ATTRIBUTE = "gen_ai.prompt";
const $04614d797e32a6f5$var$GEN_AI_SYSTEM_ATTRIBUTE = "gen_ai.system";
const $04614d797e32a6f5$var$GEN_AI_REQUEST_MODEL_ATTRIBUTE = "gen_ai.request.model";
const $04614d797e32a6f5$var$GEN_AI_REQUEST_STREAM_ATTRIBUTE = "gen_ai.request.stream";
const $04614d797e32a6f5$var$GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE = "gen_ai.request.temperature";
const $04614d797e32a6f5$var$GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE = "gen_ai.request.max_tokens";
const $04614d797e32a6f5$var$GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE = "gen_ai.request.frequency_penalty";
const $04614d797e32a6f5$var$GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE = "gen_ai.request.presence_penalty";
const $04614d797e32a6f5$var$GEN_AI_REQUEST_TOP_P_ATTRIBUTE = "gen_ai.request.top_p";
const $04614d797e32a6f5$var$GEN_AI_REQUEST_TOP_K_ATTRIBUTE = "gen_ai.request.top_k";
const $04614d797e32a6f5$var$GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE = "gen_ai.request.encoding_format";
const $04614d797e32a6f5$var$GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE = "gen_ai.request.dimensions";
const $04614d797e32a6f5$var$GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE = "gen_ai.response.finish_reasons";
const $04614d797e32a6f5$var$GEN_AI_RESPONSE_MODEL_ATTRIBUTE = "gen_ai.response.model";
const $04614d797e32a6f5$var$GEN_AI_RESPONSE_ID_ATTRIBUTE = "gen_ai.response.id";
const $04614d797e32a6f5$var$GEN_AI_RESPONSE_STOP_REASON_ATTRIBUTE = "gen_ai.response.stop_reason";
const $04614d797e32a6f5$var$GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE = "gen_ai.usage.input_tokens";
const $04614d797e32a6f5$var$GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE = "gen_ai.usage.output_tokens";
const $04614d797e32a6f5$var$GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE = "gen_ai.usage.total_tokens";
const $04614d797e32a6f5$var$GEN_AI_OPERATION_NAME_ATTRIBUTE = "gen_ai.operation.name";
const $04614d797e32a6f5$var$GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE = "sentry.sdk_meta.gen_ai.input.messages.original_length";
const $04614d797e32a6f5$var$GEN_AI_INPUT_MESSAGES_ATTRIBUTE = "gen_ai.input.messages";
const $04614d797e32a6f5$var$GEN_AI_OUTPUT_MESSAGES_ATTRIBUTE = "gen_ai.output.messages";
const $04614d797e32a6f5$var$GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE = "gen_ai.system_instructions";
const $04614d797e32a6f5$var$GEN_AI_RESPONSE_TEXT_ATTRIBUTE = "gen_ai.response.text";
const $04614d797e32a6f5$var$GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE = "gen_ai.request.available_tools";
const $04614d797e32a6f5$var$GEN_AI_RESPONSE_STREAMING_ATTRIBUTE = "gen_ai.response.streaming";
const $04614d797e32a6f5$var$GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE = "gen_ai.response.tool_calls";
const $04614d797e32a6f5$var$GEN_AI_AGENT_NAME_ATTRIBUTE = "gen_ai.agent.name";
const $04614d797e32a6f5$var$GEN_AI_PIPELINE_NAME_ATTRIBUTE = "gen_ai.pipeline.name";
const $04614d797e32a6f5$var$GEN_AI_CONVERSATION_ID_ATTRIBUTE = "gen_ai.conversation.id";
const $04614d797e32a6f5$var$GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS_ATTRIBUTE = "gen_ai.usage.cache_creation_input_tokens";
const $04614d797e32a6f5$var$GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS_ATTRIBUTE = "gen_ai.usage.cache_read_input_tokens";
const $04614d797e32a6f5$var$GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE = "gen_ai.usage.input_tokens.cache_write";
const $04614d797e32a6f5$var$GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE = "gen_ai.usage.input_tokens.cached";
const $04614d797e32a6f5$var$GEN_AI_INVOKE_AGENT_OPERATION_ATTRIBUTE = "gen_ai.invoke_agent";
const $04614d797e32a6f5$var$GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE = "gen_ai.embeddings.input";
const $04614d797e32a6f5$var$GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE = "gen_ai.embeddings";
const $04614d797e32a6f5$var$GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE = "gen_ai.execute_tool";
const $04614d797e32a6f5$var$GEN_AI_TOOL_NAME_ATTRIBUTE = "gen_ai.tool.name";
const $04614d797e32a6f5$var$GEN_AI_TOOL_CALL_ID_ATTRIBUTE = "gen_ai.tool.call.id";
const $04614d797e32a6f5$var$GEN_AI_TOOL_TYPE_ATTRIBUTE = "gen_ai.tool.type";
const $04614d797e32a6f5$var$GEN_AI_TOOL_INPUT_ATTRIBUTE = "gen_ai.tool.input";
const $04614d797e32a6f5$var$GEN_AI_TOOL_OUTPUT_ATTRIBUTE = "gen_ai.tool.output";
const $04614d797e32a6f5$var$GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE = "gen_ai.tool.description";
module.exports.GEN_AI_AGENT_NAME_ATTRIBUTE = $04614d797e32a6f5$var$GEN_AI_AGENT_NAME_ATTRIBUTE;
module.exports.GEN_AI_CONVERSATION_ID_ATTRIBUTE = $04614d797e32a6f5$var$GEN_AI_CONVERSATION_ID_ATTRIBUTE;
module.exports.GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE = $04614d797e32a6f5$var$GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE;
module.exports.GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE = $04614d797e32a6f5$var$GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE;
module.exports.GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE = $04614d797e32a6f5$var$GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE;
module.exports.GEN_AI_INPUT_MESSAGES_ATTRIBUTE = $04614d797e32a6f5$var$GEN_AI_INPUT_MESSAGES_ATTRIBUTE;
module.exports.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE = $04614d797e32a6f5$var$GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE;
module.exports.GEN_AI_INVOKE_AGENT_OPERATION_ATTRIBUTE = $04614d797e32a6f5$var$GEN_AI_INVOKE_AGENT_OPERATION_ATTRIBUTE;
module.exports.GEN_AI_OPERATION_NAME_ATTRIBUTE = $04614d797e32a6f5$var$GEN_AI_OPERATION_NAME_ATTRIBUTE;
module.exports.GEN_AI_OUTPUT_MESSAGES_ATTRIBUTE = $04614d797e32a6f5$var$GEN_AI_OUTPUT_MESSAGES_ATTRIBUTE;
module.exports.GEN_AI_PIPELINE_NAME_ATTRIBUTE = $04614d797e32a6f5$var$GEN_AI_PIPELINE_NAME_ATTRIBUTE;
module.exports.GEN_AI_PROMPT_ATTRIBUTE = $04614d797e32a6f5$var$GEN_AI_PROMPT_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE = $04614d797e32a6f5$var$GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE = $04614d797e32a6f5$var$GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE = $04614d797e32a6f5$var$GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE = $04614d797e32a6f5$var$GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE = $04614d797e32a6f5$var$GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_MODEL_ATTRIBUTE = $04614d797e32a6f5$var$GEN_AI_REQUEST_MODEL_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE = $04614d797e32a6f5$var$GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_STREAM_ATTRIBUTE = $04614d797e32a6f5$var$GEN_AI_REQUEST_STREAM_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE = $04614d797e32a6f5$var$GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_TOP_K_ATTRIBUTE = $04614d797e32a6f5$var$GEN_AI_REQUEST_TOP_K_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_TOP_P_ATTRIBUTE = $04614d797e32a6f5$var$GEN_AI_REQUEST_TOP_P_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE = $04614d797e32a6f5$var$GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_ID_ATTRIBUTE = $04614d797e32a6f5$var$GEN_AI_RESPONSE_ID_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_MODEL_ATTRIBUTE = $04614d797e32a6f5$var$GEN_AI_RESPONSE_MODEL_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_STOP_REASON_ATTRIBUTE = $04614d797e32a6f5$var$GEN_AI_RESPONSE_STOP_REASON_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_STREAMING_ATTRIBUTE = $04614d797e32a6f5$var$GEN_AI_RESPONSE_STREAMING_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_TEXT_ATTRIBUTE = $04614d797e32a6f5$var$GEN_AI_RESPONSE_TEXT_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE = $04614d797e32a6f5$var$GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE;
module.exports.GEN_AI_SYSTEM_ATTRIBUTE = $04614d797e32a6f5$var$GEN_AI_SYSTEM_ATTRIBUTE;
module.exports.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE = $04614d797e32a6f5$var$GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE;
module.exports.GEN_AI_TOOL_CALL_ID_ATTRIBUTE = $04614d797e32a6f5$var$GEN_AI_TOOL_CALL_ID_ATTRIBUTE;
module.exports.GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE = $04614d797e32a6f5$var$GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE;
module.exports.GEN_AI_TOOL_INPUT_ATTRIBUTE = $04614d797e32a6f5$var$GEN_AI_TOOL_INPUT_ATTRIBUTE;
module.exports.GEN_AI_TOOL_NAME_ATTRIBUTE = $04614d797e32a6f5$var$GEN_AI_TOOL_NAME_ATTRIBUTE;
module.exports.GEN_AI_TOOL_OUTPUT_ATTRIBUTE = $04614d797e32a6f5$var$GEN_AI_TOOL_OUTPUT_ATTRIBUTE;
module.exports.GEN_AI_TOOL_TYPE_ATTRIBUTE = $04614d797e32a6f5$var$GEN_AI_TOOL_TYPE_ATTRIBUTE;
module.exports.GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS_ATTRIBUTE = $04614d797e32a6f5$var$GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS_ATTRIBUTE;
module.exports.GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS_ATTRIBUTE = $04614d797e32a6f5$var$GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS_ATTRIBUTE;
module.exports.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE = $04614d797e32a6f5$var$GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE;
module.exports.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE = $04614d797e32a6f5$var$GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE;
module.exports.GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE = $04614d797e32a6f5$var$GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE;
module.exports.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE = $04614d797e32a6f5$var$GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE;
module.exports.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE = $04614d797e32a6f5$var$GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE;

});

parcelRegister("hxh4A", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $52AAP = parcelRequire("52AAP");
const $cc42c3172e8f26b4$var$DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT = 2e4;
const $cc42c3172e8f26b4$var$utf8Bytes = (text)=>{
    return new TextEncoder().encode(text).length;
};
const $cc42c3172e8f26b4$var$jsonBytes = (value)=>{
    return $cc42c3172e8f26b4$var$utf8Bytes(JSON.stringify(value));
};
function $cc42c3172e8f26b4$var$truncateTextByBytes(text, maxBytes) {
    if ($cc42c3172e8f26b4$var$utf8Bytes(text) <= maxBytes) return text;
    let low = 0;
    let high = text.length;
    let bestFit = "";
    while(low <= high){
        const mid = Math.floor((low + high) / 2);
        const candidate = text.slice(0, mid);
        const byteSize = $cc42c3172e8f26b4$var$utf8Bytes(candidate);
        if (byteSize <= maxBytes) {
            bestFit = candidate;
            low = mid + 1;
        } else high = mid - 1;
    }
    return bestFit;
}
function $cc42c3172e8f26b4$var$getItemText(item) {
    if (typeof item === "string") return item;
    if ("text" in item && typeof item.text === "string") return item.text;
    return "";
}
function $cc42c3172e8f26b4$var$withItemText(item, text) {
    if (typeof item === "string") return text;
    return {
        ...item,
        text: text
    };
}
function $cc42c3172e8f26b4$var$isContentMessage(message) {
    return message !== null && typeof message === "object" && "content" in message && typeof message.content === "string";
}
function $cc42c3172e8f26b4$var$isContentArrayMessage(message) {
    return message !== null && typeof message === "object" && "content" in message && Array.isArray(message.content);
}
function $cc42c3172e8f26b4$var$isPartsMessage(message) {
    return message !== null && typeof message === "object" && "parts" in message && Array.isArray(message.parts) && message.parts.length > 0;
}
function $cc42c3172e8f26b4$var$truncateContentMessage(message, maxBytes) {
    const emptyMessage = {
        ...message,
        content: ""
    };
    const overhead = $cc42c3172e8f26b4$var$jsonBytes(emptyMessage);
    const availableForContent = maxBytes - overhead;
    if (availableForContent <= 0) return [];
    const truncatedContent = $cc42c3172e8f26b4$var$truncateTextByBytes(message.content, availableForContent);
    return [
        {
            ...message,
            content: truncatedContent
        }
    ];
}
function $cc42c3172e8f26b4$var$getArrayItems(message) {
    if ("parts" in message && Array.isArray(message.parts)) return {
        key: "parts",
        items: message.parts
    };
    if ("content" in message && Array.isArray(message.content)) return {
        key: "content",
        items: message.content
    };
    return {
        key: null,
        items: []
    };
}
function $cc42c3172e8f26b4$var$truncateArrayMessage(message, maxBytes) {
    const { key: key, items: items } = $cc42c3172e8f26b4$var$getArrayItems(message);
    if (key === null || items.length === 0) return [];
    const emptyItems = items.map((item)=>$cc42c3172e8f26b4$var$withItemText(item, ""));
    const overhead = $cc42c3172e8f26b4$var$jsonBytes({
        ...message,
        [key]: emptyItems
    });
    let remainingBytes = maxBytes - overhead;
    if (remainingBytes <= 0) return [];
    const includedItems = [];
    for (const item of items){
        const text = $cc42c3172e8f26b4$var$getItemText(item);
        const textSize = $cc42c3172e8f26b4$var$utf8Bytes(text);
        if (textSize <= remainingBytes) {
            includedItems.push(item);
            remainingBytes -= textSize;
        } else if (includedItems.length === 0) {
            const truncated = $cc42c3172e8f26b4$var$truncateTextByBytes(text, remainingBytes);
            if (truncated) includedItems.push($cc42c3172e8f26b4$var$withItemText(item, truncated));
            break;
        } else break;
    }
    if (includedItems.length <= 0) return [];
    else return [
        {
            ...message,
            [key]: includedItems
        }
    ];
}
function $cc42c3172e8f26b4$var$truncateSingleMessage(message, maxBytes) {
    if (!message) return [];
    if (typeof message === "string") {
        const truncated = $cc42c3172e8f26b4$var$truncateTextByBytes(message, maxBytes);
        return truncated ? [
            truncated
        ] : [];
    }
    if (typeof message !== "object") return [];
    if ($cc42c3172e8f26b4$var$isContentMessage(message)) return $cc42c3172e8f26b4$var$truncateContentMessage(message, maxBytes);
    if ($cc42c3172e8f26b4$var$isContentArrayMessage(message) || $cc42c3172e8f26b4$var$isPartsMessage(message)) return $cc42c3172e8f26b4$var$truncateArrayMessage(message, maxBytes);
    return [];
}
function $cc42c3172e8f26b4$var$stripInlineMediaFromMessages(messages) {
    const stripped = messages.map((message)=>{
        let newMessage = void 0;
        if (!!message && typeof message === "object") {
            if ($cc42c3172e8f26b4$var$isContentArrayMessage(message)) newMessage = {
                ...message,
                content: $cc42c3172e8f26b4$var$stripInlineMediaFromMessages(message.content)
            };
            else if ("content" in message && $52AAP.isContentMedia(message.content)) newMessage = {
                ...message,
                content: $52AAP.stripInlineMediaFromSingleMessage(message.content)
            };
            if ($cc42c3172e8f26b4$var$isPartsMessage(message)) newMessage = {
                // might have to strip content AND parts
                ...newMessage ?? message,
                parts: $cc42c3172e8f26b4$var$stripInlineMediaFromMessages(message.parts)
            };
            if ($52AAP.isContentMedia(newMessage)) newMessage = $52AAP.stripInlineMediaFromSingleMessage(newMessage);
            else if ($52AAP.isContentMedia(message)) newMessage = $52AAP.stripInlineMediaFromSingleMessage(message);
        }
        return newMessage ?? message;
    });
    return stripped;
}
function $cc42c3172e8f26b4$var$truncateMessagesByBytes(messages, maxBytes) {
    if (!Array.isArray(messages) || messages.length === 0) return messages;
    const effectiveMaxBytes = maxBytes - 2;
    const lastMessage = messages[messages.length - 1];
    const stripped = $cc42c3172e8f26b4$var$stripInlineMediaFromMessages([
        lastMessage
    ]);
    const strippedMessage = stripped[0];
    const messageBytes = $cc42c3172e8f26b4$var$jsonBytes(strippedMessage);
    if (messageBytes <= effectiveMaxBytes) return stripped;
    return $cc42c3172e8f26b4$var$truncateSingleMessage(strippedMessage, effectiveMaxBytes);
}
function $cc42c3172e8f26b4$var$truncateGenAiMessages(messages) {
    return $cc42c3172e8f26b4$var$truncateMessagesByBytes(messages, $cc42c3172e8f26b4$var$DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT);
}
function $cc42c3172e8f26b4$var$truncateGenAiStringInput(input) {
    return $cc42c3172e8f26b4$var$truncateTextByBytes(input, $cc42c3172e8f26b4$var$DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT);
}
module.exports.DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT = $cc42c3172e8f26b4$var$DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT;
module.exports.truncateGenAiMessages = $cc42c3172e8f26b4$var$truncateGenAiMessages;
module.exports.truncateGenAiStringInput = $cc42c3172e8f26b4$var$truncateGenAiStringInput;

});
parcelRegister("52AAP", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $3ab98645bc73b63a$var$isContentMedia(part) {
    if (!part || typeof part !== "object") return false;
    return $3ab98645bc73b63a$var$isContentMediaSource(part) || $3ab98645bc73b63a$var$hasInlineData(part) || $3ab98645bc73b63a$var$hasImageUrl(part) || $3ab98645bc73b63a$var$hasInputAudio(part) || $3ab98645bc73b63a$var$hasFileData(part) || $3ab98645bc73b63a$var$hasMediaTypeData(part) || $3ab98645bc73b63a$var$hasVercelFileData(part) || $3ab98645bc73b63a$var$hasVercelImageData(part) || $3ab98645bc73b63a$var$hasBlobOrBase64Type(part) || $3ab98645bc73b63a$var$hasB64Json(part) || $3ab98645bc73b63a$var$hasImageGenerationResult(part) || $3ab98645bc73b63a$var$hasDataUri(part);
}
function $3ab98645bc73b63a$var$hasImageUrl(part) {
    if (!("image_url" in part)) return false;
    if (typeof part.image_url === "string") return part.image_url.startsWith("data:");
    return $3ab98645bc73b63a$var$hasNestedImageUrl(part);
}
function $3ab98645bc73b63a$var$hasNestedImageUrl(part) {
    return "image_url" in part && !!part.image_url && typeof part.image_url === "object" && "url" in part.image_url && typeof part.image_url.url === "string" && part.image_url.url.startsWith("data:");
}
function $3ab98645bc73b63a$var$isContentMediaSource(part) {
    return "type" in part && typeof part.type === "string" && "source" in part && $3ab98645bc73b63a$var$isContentMedia(part.source);
}
function $3ab98645bc73b63a$var$hasInlineData(part) {
    return "inlineData" in part && !!part.inlineData && typeof part.inlineData === "object" && "data" in part.inlineData && typeof part.inlineData.data === "string";
}
function $3ab98645bc73b63a$var$hasInputAudio(part) {
    return "type" in part && part.type === "input_audio" && "input_audio" in part && !!part.input_audio && typeof part.input_audio === "object" && "data" in part.input_audio && typeof part.input_audio.data === "string";
}
function $3ab98645bc73b63a$var$hasFileData(part) {
    return "type" in part && part.type === "file" && "file" in part && !!part.file && typeof part.file === "object" && "file_data" in part.file && typeof part.file.file_data === "string";
}
function $3ab98645bc73b63a$var$hasMediaTypeData(part) {
    return "media_type" in part && typeof part.media_type === "string" && "data" in part;
}
function $3ab98645bc73b63a$var$hasVercelFileData(part) {
    return "type" in part && part.type === "file" && "mediaType" in part && typeof part.mediaType === "string" && "data" in part && typeof part.data === "string" && // Only strip base64/binary data, not HTTP/HTTPS URLs which should be preserved as references
    !part.data.startsWith("http://") && !part.data.startsWith("https://");
}
function $3ab98645bc73b63a$var$hasVercelImageData(part) {
    return "type" in part && part.type === "image" && "image" in part && typeof part.image === "string" && // Only strip base64/data URIs, not HTTP/HTTPS URLs which should be preserved as references
    !part.image.startsWith("http://") && !part.image.startsWith("https://");
}
function $3ab98645bc73b63a$var$hasBlobOrBase64Type(part) {
    return "type" in part && (part.type === "blob" || part.type === "base64");
}
function $3ab98645bc73b63a$var$hasB64Json(part) {
    return "b64_json" in part;
}
function $3ab98645bc73b63a$var$hasImageGenerationResult(part) {
    return "type" in part && "result" in part && part.type === "image_generation";
}
function $3ab98645bc73b63a$var$hasDataUri(part) {
    return "uri" in part && typeof part.uri === "string" && part.uri.startsWith("data:");
}
const $3ab98645bc73b63a$var$REMOVED_STRING = "[Blob substitute]";
const $3ab98645bc73b63a$var$MEDIA_FIELDS = [
    "image_url",
    "data",
    "content",
    "b64_json",
    "result",
    "uri",
    "image"
];
function $3ab98645bc73b63a$var$stripInlineMediaFromSingleMessage(part) {
    const strip = {
        ...part
    };
    if ($3ab98645bc73b63a$var$isContentMedia(strip.source)) strip.source = $3ab98645bc73b63a$var$stripInlineMediaFromSingleMessage(strip.source);
    if ($3ab98645bc73b63a$var$hasInlineData(part)) strip.inlineData = {
        ...part.inlineData,
        data: $3ab98645bc73b63a$var$REMOVED_STRING
    };
    if ($3ab98645bc73b63a$var$hasNestedImageUrl(part)) strip.image_url = {
        ...part.image_url,
        url: $3ab98645bc73b63a$var$REMOVED_STRING
    };
    if ($3ab98645bc73b63a$var$hasInputAudio(part)) strip.input_audio = {
        ...part.input_audio,
        data: $3ab98645bc73b63a$var$REMOVED_STRING
    };
    if ($3ab98645bc73b63a$var$hasFileData(part)) strip.file = {
        ...part.file,
        file_data: $3ab98645bc73b63a$var$REMOVED_STRING
    };
    for (const field of $3ab98645bc73b63a$var$MEDIA_FIELDS)if (typeof strip[field] === "string") strip[field] = $3ab98645bc73b63a$var$REMOVED_STRING;
    return strip;
}
module.exports.isContentMedia = $3ab98645bc73b63a$var$isContentMedia;
module.exports.stripInlineMediaFromSingleMessage = $3ab98645bc73b63a$var$stripInlineMediaFromSingleMessage;

});



parcelRegister("3GQdK", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $2afdcd50d8c811c7$var$toolCallSpanContextMap = /* @__PURE__ */ new Map();
const $2afdcd50d8c811c7$var$toolDescriptionMap = /* @__PURE__ */ new Map();
const $2afdcd50d8c811c7$var$SPAN_TO_OPERATION_NAME = /* @__PURE__ */ new Map([
    [
        "ai.generateText",
        "invoke_agent"
    ],
    [
        "ai.streamText",
        "invoke_agent"
    ],
    [
        "ai.generateObject",
        "invoke_agent"
    ],
    [
        "ai.streamObject",
        "invoke_agent"
    ],
    [
        "ai.generateText.doGenerate",
        "generate_content"
    ],
    [
        "ai.streamText.doStream",
        "generate_content"
    ],
    [
        "ai.generateObject.doGenerate",
        "generate_content"
    ],
    [
        "ai.streamObject.doStream",
        "generate_content"
    ],
    [
        "ai.embed.doEmbed",
        "embeddings"
    ],
    [
        "ai.embedMany.doEmbed",
        "embeddings"
    ],
    [
        "ai.rerank.doRerank",
        "rerank"
    ],
    [
        "ai.toolCall",
        "execute_tool"
    ]
]);
module.exports.SPAN_TO_OPERATION_NAME = $2afdcd50d8c811c7$var$SPAN_TO_OPERATION_NAME;
module.exports.toolCallSpanContextMap = $2afdcd50d8c811c7$var$toolCallSpanContextMap;
module.exports.toolDescriptionMap = $2afdcd50d8c811c7$var$toolDescriptionMap;

});

parcelRegister("lFN6F", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $njxh1 = parcelRequire("njxh1");

var $8rGYq = parcelRequire("8rGYq");

var $3GQdK = parcelRequire("3GQdK");

var $3rWH2 = parcelRequire("3rWH2");
function $fc7384d2a85b6076$var$accumulateTokensForParent(span, tokenAccumulator) {
    const parentSpanId = span.parent_span_id;
    if (!parentSpanId) return;
    const inputTokens = span.data[$njxh1.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE];
    const outputTokens = span.data[$njxh1.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE];
    if (typeof inputTokens === "number" || typeof outputTokens === "number") {
        const existing = tokenAccumulator.get(parentSpanId) || {
            inputTokens: 0,
            outputTokens: 0
        };
        if (typeof inputTokens === "number") existing.inputTokens += inputTokens;
        if (typeof outputTokens === "number") existing.outputTokens += outputTokens;
        tokenAccumulator.set(parentSpanId, existing);
    }
}
function $fc7384d2a85b6076$var$applyAccumulatedTokens(spanOrTrace, tokenAccumulator) {
    const accumulated = tokenAccumulator.get(spanOrTrace.span_id);
    if (!accumulated || !spanOrTrace.data) return;
    if (accumulated.inputTokens > 0) spanOrTrace.data[$njxh1.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] = accumulated.inputTokens;
    if (accumulated.outputTokens > 0) spanOrTrace.data[$njxh1.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] = accumulated.outputTokens;
    if (accumulated.inputTokens > 0 || accumulated.outputTokens > 0) spanOrTrace.data["gen_ai.usage.total_tokens"] = accumulated.inputTokens + accumulated.outputTokens;
}
function $fc7384d2a85b6076$var$buildToolDescriptionMap(spans) {
    const toolDescriptions = /* @__PURE__ */ new Map();
    for (const span of spans){
        const availableTools = span.data[$njxh1.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE];
        if (typeof availableTools !== "string") continue;
        try {
            const tools = JSON.parse(availableTools);
            for (const tool of tools)if (tool.name && tool.description && !toolDescriptions.has(tool.name)) toolDescriptions.set(tool.name, tool.description);
        } catch  {}
    }
    return toolDescriptions;
}
function $fc7384d2a85b6076$var$applyToolDescriptionsAndTokens(spans, tokenAccumulator) {
    const toolDescriptions = $fc7384d2a85b6076$var$buildToolDescriptionMap(spans);
    for (const span of spans){
        if (span.op === "gen_ai.execute_tool") {
            const toolName = span.data[$njxh1.GEN_AI_TOOL_NAME_ATTRIBUTE];
            if (typeof toolName === "string") {
                const description = toolDescriptions.get(toolName);
                if (description) span.data[$njxh1.GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE] = description;
            }
        }
        if (span.op === "gen_ai.invoke_agent") $fc7384d2a85b6076$var$applyAccumulatedTokens(span, tokenAccumulator);
    }
}
function $fc7384d2a85b6076$var$_INTERNAL_getSpanContextForToolCallId(toolCallId) {
    return $3GQdK.toolCallSpanContextMap.get(toolCallId);
}
function $fc7384d2a85b6076$var$_INTERNAL_cleanupToolCallSpanContext(toolCallId) {
    $3GQdK.toolCallSpanContextMap.delete(toolCallId);
}
function $fc7384d2a85b6076$var$convertAvailableToolsToJsonString(tools) {
    const toolObjects = tools.map((tool)=>{
        if (typeof tool === "string") try {
            return JSON.parse(tool);
        } catch  {
            return tool;
        }
        return tool;
    });
    return JSON.stringify(toolObjects);
}
function $fc7384d2a85b6076$var$filterMessagesArray(input) {
    return input.filter((m)=>!!m && typeof m === "object" && "role" in m && "content" in m);
}
function $fc7384d2a85b6076$var$convertUserInputToMessagesFormat(userInput) {
    try {
        const p = JSON.parse(userInput);
        if (!!p && typeof p === "object") {
            let { messages: messages } = p;
            const { prompt: prompt, system: system } = p;
            const result = [];
            if (typeof system === "string") result.push({
                role: "system",
                content: system
            });
            if (typeof messages === "string") try {
                messages = JSON.parse(messages);
            } catch  {}
            if (Array.isArray(messages)) {
                result.push(...$fc7384d2a85b6076$var$filterMessagesArray(messages));
                return result;
            }
            if (Array.isArray(prompt)) {
                result.push(...$fc7384d2a85b6076$var$filterMessagesArray(prompt));
                return result;
            }
            if (typeof prompt === "string") result.push({
                role: "user",
                content: prompt
            });
            if (result.length > 0) return result;
        }
    } catch  {}
    return [];
}
function $fc7384d2a85b6076$var$requestMessagesFromPrompt(span, attributes, enableTruncation) {
    if (typeof attributes[$3rWH2.AI_PROMPT_ATTRIBUTE] === "string" && !attributes[$njxh1.GEN_AI_INPUT_MESSAGES_ATTRIBUTE] && !attributes[$3rWH2.AI_PROMPT_MESSAGES_ATTRIBUTE]) {
        const userInput = attributes[$3rWH2.AI_PROMPT_ATTRIBUTE];
        const messages = $fc7384d2a85b6076$var$convertUserInputToMessagesFormat(userInput);
        if (messages.length) {
            const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $8rGYq.extractSystemInstructions(messages);
            if (systemInstructions) span.setAttribute($njxh1.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
            const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
            const messagesJson = enableTruncation ? $8rGYq.getTruncatedJsonString(filteredMessages) : $8rGYq.getJsonString(filteredMessages);
            span.setAttributes({
                [$3rWH2.AI_PROMPT_ATTRIBUTE]: messagesJson,
                [$njxh1.GEN_AI_INPUT_MESSAGES_ATTRIBUTE]: messagesJson,
                [$njxh1.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE]: filteredLength
            });
        }
    } else if (typeof attributes[$3rWH2.AI_PROMPT_MESSAGES_ATTRIBUTE] === "string") try {
        const messages = JSON.parse(attributes[$3rWH2.AI_PROMPT_MESSAGES_ATTRIBUTE]);
        if (Array.isArray(messages)) {
            const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $8rGYq.extractSystemInstructions(messages);
            if (systemInstructions) span.setAttribute($njxh1.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
            const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
            const messagesJson = enableTruncation ? $8rGYq.getTruncatedJsonString(filteredMessages) : $8rGYq.getJsonString(filteredMessages);
            span.setAttributes({
                [$3rWH2.AI_PROMPT_MESSAGES_ATTRIBUTE]: messagesJson,
                [$njxh1.GEN_AI_INPUT_MESSAGES_ATTRIBUTE]: messagesJson,
                [$njxh1.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE]: filteredLength
            });
        }
    } catch  {}
}
module.exports._INTERNAL_cleanupToolCallSpanContext = $fc7384d2a85b6076$var$_INTERNAL_cleanupToolCallSpanContext;
module.exports._INTERNAL_getSpanContextForToolCallId = $fc7384d2a85b6076$var$_INTERNAL_getSpanContextForToolCallId;
module.exports.accumulateTokensForParent = $fc7384d2a85b6076$var$accumulateTokensForParent;
module.exports.applyAccumulatedTokens = $fc7384d2a85b6076$var$applyAccumulatedTokens;
module.exports.applyToolDescriptionsAndTokens = $fc7384d2a85b6076$var$applyToolDescriptionsAndTokens;
module.exports.convertAvailableToolsToJsonString = $fc7384d2a85b6076$var$convertAvailableToolsToJsonString;
module.exports.convertUserInputToMessagesFormat = $fc7384d2a85b6076$var$convertUserInputToMessagesFormat;
module.exports.requestMessagesFromPrompt = $fc7384d2a85b6076$var$requestMessagesFromPrompt;

});
parcelRegister("3rWH2", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $28316bf4ee7b8c8f$var$OPERATION_NAME_ATTRIBUTE = "operation.name";
const $28316bf4ee7b8c8f$var$AI_OPERATION_ID_ATTRIBUTE = "ai.operationId";
const $28316bf4ee7b8c8f$var$AI_PROMPT_ATTRIBUTE = "ai.prompt";
const $28316bf4ee7b8c8f$var$AI_SCHEMA_ATTRIBUTE = "ai.schema";
const $28316bf4ee7b8c8f$var$AI_RESPONSE_OBJECT_ATTRIBUTE = "ai.response.object";
const $28316bf4ee7b8c8f$var$AI_VALUES_ATTRIBUTE = "ai.values";
const $28316bf4ee7b8c8f$var$AI_RESPONSE_TEXT_ATTRIBUTE = "ai.response.text";
const $28316bf4ee7b8c8f$var$AI_RESPONSE_TOOL_CALLS_ATTRIBUTE = "ai.response.toolCalls";
const $28316bf4ee7b8c8f$var$AI_RESPONSE_FINISH_REASON_ATTRIBUTE = "ai.response.finishReason";
const $28316bf4ee7b8c8f$var$AI_PROMPT_MESSAGES_ATTRIBUTE = "ai.prompt.messages";
const $28316bf4ee7b8c8f$var$AI_PROMPT_TOOLS_ATTRIBUTE = "ai.prompt.tools";
const $28316bf4ee7b8c8f$var$AI_MODEL_ID_ATTRIBUTE = "ai.model.id";
const $28316bf4ee7b8c8f$var$AI_RESPONSE_PROVIDER_METADATA_ATTRIBUTE = "ai.response.providerMetadata";
const $28316bf4ee7b8c8f$var$AI_USAGE_CACHED_INPUT_TOKENS_ATTRIBUTE = "ai.usage.cachedInputTokens";
const $28316bf4ee7b8c8f$var$AI_TELEMETRY_FUNCTION_ID_ATTRIBUTE = "ai.telemetry.functionId";
const $28316bf4ee7b8c8f$var$AI_USAGE_COMPLETION_TOKENS_ATTRIBUTE = "ai.usage.completionTokens";
const $28316bf4ee7b8c8f$var$AI_USAGE_PROMPT_TOKENS_ATTRIBUTE = "ai.usage.promptTokens";
const $28316bf4ee7b8c8f$var$AI_USAGE_TOKENS_ATTRIBUTE = "ai.usage.tokens";
const $28316bf4ee7b8c8f$var$AI_TOOL_CALL_NAME_ATTRIBUTE = "ai.toolCall.name";
const $28316bf4ee7b8c8f$var$AI_TOOL_CALL_ID_ATTRIBUTE = "ai.toolCall.id";
const $28316bf4ee7b8c8f$var$AI_TOOL_CALL_ARGS_ATTRIBUTE = "ai.toolCall.args";
const $28316bf4ee7b8c8f$var$AI_TOOL_CALL_RESULT_ATTRIBUTE = "ai.toolCall.result";
module.exports.AI_MODEL_ID_ATTRIBUTE = $28316bf4ee7b8c8f$var$AI_MODEL_ID_ATTRIBUTE;
module.exports.AI_OPERATION_ID_ATTRIBUTE = $28316bf4ee7b8c8f$var$AI_OPERATION_ID_ATTRIBUTE;
module.exports.AI_PROMPT_ATTRIBUTE = $28316bf4ee7b8c8f$var$AI_PROMPT_ATTRIBUTE;
module.exports.AI_PROMPT_MESSAGES_ATTRIBUTE = $28316bf4ee7b8c8f$var$AI_PROMPT_MESSAGES_ATTRIBUTE;
module.exports.AI_PROMPT_TOOLS_ATTRIBUTE = $28316bf4ee7b8c8f$var$AI_PROMPT_TOOLS_ATTRIBUTE;
module.exports.AI_RESPONSE_FINISH_REASON_ATTRIBUTE = $28316bf4ee7b8c8f$var$AI_RESPONSE_FINISH_REASON_ATTRIBUTE;
module.exports.AI_RESPONSE_OBJECT_ATTRIBUTE = $28316bf4ee7b8c8f$var$AI_RESPONSE_OBJECT_ATTRIBUTE;
module.exports.AI_RESPONSE_PROVIDER_METADATA_ATTRIBUTE = $28316bf4ee7b8c8f$var$AI_RESPONSE_PROVIDER_METADATA_ATTRIBUTE;
module.exports.AI_RESPONSE_TEXT_ATTRIBUTE = $28316bf4ee7b8c8f$var$AI_RESPONSE_TEXT_ATTRIBUTE;
module.exports.AI_RESPONSE_TOOL_CALLS_ATTRIBUTE = $28316bf4ee7b8c8f$var$AI_RESPONSE_TOOL_CALLS_ATTRIBUTE;
module.exports.AI_SCHEMA_ATTRIBUTE = $28316bf4ee7b8c8f$var$AI_SCHEMA_ATTRIBUTE;
module.exports.AI_TELEMETRY_FUNCTION_ID_ATTRIBUTE = $28316bf4ee7b8c8f$var$AI_TELEMETRY_FUNCTION_ID_ATTRIBUTE;
module.exports.AI_TOOL_CALL_ARGS_ATTRIBUTE = $28316bf4ee7b8c8f$var$AI_TOOL_CALL_ARGS_ATTRIBUTE;
module.exports.AI_TOOL_CALL_ID_ATTRIBUTE = $28316bf4ee7b8c8f$var$AI_TOOL_CALL_ID_ATTRIBUTE;
module.exports.AI_TOOL_CALL_NAME_ATTRIBUTE = $28316bf4ee7b8c8f$var$AI_TOOL_CALL_NAME_ATTRIBUTE;
module.exports.AI_TOOL_CALL_RESULT_ATTRIBUTE = $28316bf4ee7b8c8f$var$AI_TOOL_CALL_RESULT_ATTRIBUTE;
module.exports.AI_USAGE_CACHED_INPUT_TOKENS_ATTRIBUTE = $28316bf4ee7b8c8f$var$AI_USAGE_CACHED_INPUT_TOKENS_ATTRIBUTE;
module.exports.AI_USAGE_COMPLETION_TOKENS_ATTRIBUTE = $28316bf4ee7b8c8f$var$AI_USAGE_COMPLETION_TOKENS_ATTRIBUTE;
module.exports.AI_USAGE_PROMPT_TOKENS_ATTRIBUTE = $28316bf4ee7b8c8f$var$AI_USAGE_PROMPT_TOKENS_ATTRIBUTE;
module.exports.AI_USAGE_TOKENS_ATTRIBUTE = $28316bf4ee7b8c8f$var$AI_USAGE_TOKENS_ATTRIBUTE;
module.exports.AI_VALUES_ATTRIBUTE = $28316bf4ee7b8c8f$var$AI_VALUES_ATTRIBUTE;
module.exports.OPERATION_NAME_ATTRIBUTE = $28316bf4ee7b8c8f$var$OPERATION_NAME_ATTRIBUTE;

});



parcelRegister("gpdWe", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $jCjMv = parcelRequire("jCjMv");

var $8txOP = parcelRequire("8txOP");

var $3dwiN = parcelRequire("3dwiN");

var $jix5p = parcelRequire("jix5p");

var $9X7hl = parcelRequire("9X7hl");

var $4Ae9I = parcelRequire("4Ae9I");

var $njxh1 = parcelRequire("njxh1");

var $8rGYq = parcelRequire("8rGYq");

var $9APZV = parcelRequire("9APZV");

var $a8agQ = parcelRequire("a8agQ");

var $jOjIq = parcelRequire("jOjIq");
function $bf19cb00ca20bbf4$var$extractAvailableTools(params) {
    const tools = Array.isArray(params.tools) ? params.tools : [];
    const hasWebSearchOptions = params.web_search_options && typeof params.web_search_options === "object";
    const webSearchOptions = hasWebSearchOptions ? [
        {
            type: "web_search_options",
            ...params.web_search_options
        }
    ] : [];
    const availableTools = [
        ...tools,
        ...webSearchOptions
    ];
    if (availableTools.length === 0) return void 0;
    try {
        return JSON.stringify(availableTools);
    } catch (error) {
        $jCjMv.DEBUG_BUILD && $jix5p.debug.error("Failed to serialize OpenAI tools:", error);
        return void 0;
    }
}
function $bf19cb00ca20bbf4$var$extractRequestAttributes(args, operationName) {
    const attributes = {
        [$njxh1.GEN_AI_SYSTEM_ATTRIBUTE]: "openai",
        [$njxh1.GEN_AI_OPERATION_NAME_ATTRIBUTE]: operationName,
        [$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.ai.openai"
    };
    if (args.length > 0 && typeof args[0] === "object" && args[0] !== null) {
        const params = args[0];
        const availableTools = $bf19cb00ca20bbf4$var$extractAvailableTools(params);
        if (availableTools) attributes[$njxh1.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE] = availableTools;
        Object.assign(attributes, $jOjIq.extractRequestParameters(params));
    } else attributes[$njxh1.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = "unknown";
    return attributes;
}
function $bf19cb00ca20bbf4$var$addRequestAttributes(span, params, operationName, enableTruncation) {
    if (operationName === "embeddings" && "input" in params) {
        const input = params.input;
        if (input == null) return;
        if (typeof input === "string" && input.length === 0) return;
        if (Array.isArray(input) && input.length === 0) return;
        span.setAttribute($njxh1.GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE, typeof input === "string" ? input : JSON.stringify(input));
        return;
    }
    const src = "input" in params ? params.input : "messages" in params ? params.messages : void 0;
    if (!src) return;
    if (Array.isArray(src) && src.length === 0) return;
    const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $8rGYq.extractSystemInstructions(src);
    if (systemInstructions) span.setAttribute($njxh1.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
    span.setAttribute($njxh1.GEN_AI_INPUT_MESSAGES_ATTRIBUTE, enableTruncation ? $8rGYq.getTruncatedJsonString(filteredMessages) : $8rGYq.getJsonString(filteredMessages));
    if (Array.isArray(filteredMessages)) span.setAttribute($njxh1.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE, filteredMessages.length);
    else span.setAttribute($njxh1.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE, 1);
}
function $bf19cb00ca20bbf4$var$instrumentMethod(originalMethod, methodPath, instrumentedMethod, context, options) {
    return function instrumentedCall(...args) {
        const operationName = instrumentedMethod.operation || "unknown";
        const requestAttributes = $bf19cb00ca20bbf4$var$extractRequestAttributes(args, operationName);
        const model = requestAttributes[$njxh1.GEN_AI_REQUEST_MODEL_ATTRIBUTE] || "unknown";
        const params = args[0];
        const isStreamRequested = params && typeof params === "object" && params.stream === true;
        const spanConfig = {
            name: `${operationName} ${model}`,
            op: `gen_ai.${operationName}`,
            attributes: requestAttributes
        };
        if (isStreamRequested) {
            let originalResult2;
            const instrumentedPromise2 = $4Ae9I.startSpanManual(spanConfig, (span)=>{
                originalResult2 = originalMethod.apply(context, args);
                if (options.recordInputs && params) $bf19cb00ca20bbf4$var$addRequestAttributes(span, params, operationName, $8rGYq.shouldEnableTruncation(options.enableTruncation));
                return (async ()=>{
                    try {
                        const result = await originalResult2;
                        return $a8agQ.instrumentStream(result, span, options.recordOutputs ?? false);
                    } catch (error) {
                        span.setStatus({
                            code: $9X7hl.SPAN_STATUS_ERROR,
                            message: "internal_error"
                        });
                        $8txOP.captureException(error, {
                            mechanism: {
                                handled: false,
                                type: "auto.ai.openai.stream",
                                data: {
                                    function: methodPath
                                }
                            }
                        });
                        span.end();
                        throw error;
                    }
                })();
            });
            return $8rGYq.wrapPromiseWithMethods(originalResult2, instrumentedPromise2, "auto.ai.openai");
        }
        let originalResult;
        const instrumentedPromise = $4Ae9I.startSpan(spanConfig, (span)=>{
            originalResult = originalMethod.apply(context, args);
            if (options.recordInputs && params) $bf19cb00ca20bbf4$var$addRequestAttributes(span, params, operationName, $8rGYq.shouldEnableTruncation(options.enableTruncation));
            return originalResult.then((result)=>{
                $jOjIq.addResponseAttributes(span, result, options.recordOutputs);
                return result;
            }, (error)=>{
                $8txOP.captureException(error, {
                    mechanism: {
                        handled: false,
                        type: "auto.ai.openai",
                        data: {
                            function: methodPath
                        }
                    }
                });
                throw error;
            });
        });
        return $8rGYq.wrapPromiseWithMethods(originalResult, instrumentedPromise, "auto.ai.openai");
    };
}
function $bf19cb00ca20bbf4$var$createDeepProxy(target, currentPath = "", options) {
    return new Proxy(target, {
        get (obj, prop) {
            const value = obj[prop];
            const methodPath = $8rGYq.buildMethodPath(currentPath, String(prop));
            const instrumentedMethod = $9APZV.OPENAI_METHOD_REGISTRY[methodPath];
            if (typeof value === "function" && instrumentedMethod) return $bf19cb00ca20bbf4$var$instrumentMethod(value, methodPath, instrumentedMethod, obj, options);
            if (typeof value === "function") return value.bind(obj);
            if (value && typeof value === "object") return $bf19cb00ca20bbf4$var$createDeepProxy(value, methodPath, options);
            return value;
        }
    });
}
function $bf19cb00ca20bbf4$var$instrumentOpenAiClient(client, options) {
    return $bf19cb00ca20bbf4$var$createDeepProxy(client, "", $8rGYq.resolveAIRecordingOptions(options));
}
module.exports.instrumentOpenAiClient = $bf19cb00ca20bbf4$var$instrumentOpenAiClient;

});
parcelRegister("9APZV", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $6fbfcf87a3b5bdb7$var$OPENAI_INTEGRATION_NAME = "OpenAI";
const $6fbfcf87a3b5bdb7$var$OPENAI_METHOD_REGISTRY = {
    "responses.create": {
        operation: "chat"
    },
    "chat.completions.create": {
        operation: "chat"
    },
    "embeddings.create": {
        operation: "embeddings"
    },
    // Conversations API - for conversation state management
    // https://platform.openai.com/docs/guides/conversation-state
    "conversations.create": {
        operation: "chat"
    }
};
const $6fbfcf87a3b5bdb7$var$RESPONSES_TOOL_CALL_EVENT_TYPES = [
    "response.output_item.added",
    "response.function_call_arguments.delta",
    "response.function_call_arguments.done",
    "response.output_item.done"
];
const $6fbfcf87a3b5bdb7$var$RESPONSE_EVENT_TYPES = [
    "response.created",
    "response.in_progress",
    "response.failed",
    "response.completed",
    "response.incomplete",
    "response.queued",
    "response.output_text.delta",
    ...$6fbfcf87a3b5bdb7$var$RESPONSES_TOOL_CALL_EVENT_TYPES
];
module.exports.OPENAI_INTEGRATION_NAME = $6fbfcf87a3b5bdb7$var$OPENAI_INTEGRATION_NAME;
module.exports.OPENAI_METHOD_REGISTRY = $6fbfcf87a3b5bdb7$var$OPENAI_METHOD_REGISTRY;
module.exports.RESPONSES_TOOL_CALL_EVENT_TYPES = $6fbfcf87a3b5bdb7$var$RESPONSES_TOOL_CALL_EVENT_TYPES;
module.exports.RESPONSE_EVENT_TYPES = $6fbfcf87a3b5bdb7$var$RESPONSE_EVENT_TYPES;

});

parcelRegister("a8agQ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8txOP = parcelRequire("8txOP");

var $9X7hl = parcelRequire("9X7hl");

var $8rGYq = parcelRequire("8rGYq");

var $9APZV = parcelRequire("9APZV");

var $jOjIq = parcelRequire("jOjIq");
function $76029e4bc73c736b$var$processChatCompletionToolCalls(toolCalls, state) {
    for (const toolCall of toolCalls){
        const index = toolCall.index;
        if (index === void 0 || !toolCall.function) continue;
        if (!(index in state.chatCompletionToolCalls)) state.chatCompletionToolCalls[index] = {
            ...toolCall,
            function: {
                name: toolCall.function.name,
                arguments: toolCall.function.arguments || ""
            }
        };
        else {
            const existingToolCall = state.chatCompletionToolCalls[index];
            if (toolCall.function.arguments && existingToolCall?.function) existingToolCall.function.arguments += toolCall.function.arguments;
        }
    }
}
function $76029e4bc73c736b$var$processChatCompletionChunk(chunk, state, recordOutputs) {
    state.responseId = chunk.id ?? state.responseId;
    state.responseModel = chunk.model ?? state.responseModel;
    if (chunk.usage) {
        state.promptTokens = chunk.usage.prompt_tokens;
        state.completionTokens = chunk.usage.completion_tokens;
        state.totalTokens = chunk.usage.total_tokens;
    }
    for (const choice of chunk.choices ?? []){
        if (recordOutputs) {
            if (choice.delta?.content) state.responseTexts.push(choice.delta.content);
            if (choice.delta?.tool_calls) $76029e4bc73c736b$var$processChatCompletionToolCalls(choice.delta.tool_calls, state);
        }
        if (choice.finish_reason) state.finishReasons.push(choice.finish_reason);
    }
}
function $76029e4bc73c736b$var$processResponsesApiEvent(streamEvent, state, recordOutputs, span) {
    if (!(streamEvent && typeof streamEvent === "object")) {
        state.eventTypes.push("unknown:non-object");
        return;
    }
    if (streamEvent instanceof Error) {
        span.setStatus({
            code: $9X7hl.SPAN_STATUS_ERROR,
            message: "internal_error"
        });
        $8txOP.captureException(streamEvent, {
            mechanism: {
                handled: false,
                type: "auto.ai.openai.stream-response"
            }
        });
        return;
    }
    if (!("type" in streamEvent)) return;
    const event = streamEvent;
    if (!$9APZV.RESPONSE_EVENT_TYPES.includes(event.type)) {
        state.eventTypes.push(event.type);
        return;
    }
    if (recordOutputs) {
        if (event.type === "response.output_item.done" && "item" in event) state.responsesApiToolCalls.push(event.item);
        if (event.type === "response.output_text.delta" && "delta" in event && event.delta) {
            state.responseTexts.push(event.delta);
            return;
        }
    }
    if ("response" in event) {
        const { response: response } = event;
        state.responseId = response.id ?? state.responseId;
        state.responseModel = response.model ?? state.responseModel;
        if (response.usage) {
            state.promptTokens = response.usage.input_tokens;
            state.completionTokens = response.usage.output_tokens;
            state.totalTokens = response.usage.total_tokens;
        }
        if (response.status) state.finishReasons.push(response.status);
        if (recordOutputs && response.output_text) state.responseTexts.push(response.output_text);
    }
}
async function* $76029e4bc73c736b$var$instrumentStream(stream, span, recordOutputs) {
    const state = {
        eventTypes: [],
        responseTexts: [],
        finishReasons: [],
        responseId: "",
        responseModel: "",
        promptTokens: void 0,
        completionTokens: void 0,
        totalTokens: void 0,
        chatCompletionToolCalls: {},
        responsesApiToolCalls: []
    };
    try {
        for await (const event of stream){
            if ($jOjIq.isChatCompletionChunk(event)) $76029e4bc73c736b$var$processChatCompletionChunk(event, state, recordOutputs);
            else if ($jOjIq.isResponsesApiStreamEvent(event)) $76029e4bc73c736b$var$processResponsesApiEvent(event, state, recordOutputs, span);
            yield event;
        }
    } finally{
        const allToolCalls = [
            ...Object.values(state.chatCompletionToolCalls),
            ...state.responsesApiToolCalls
        ];
        $8rGYq.endStreamSpan(span, {
            ...state,
            toolCalls: allToolCalls
        }, recordOutputs);
    }
}
module.exports.instrumentStream = $76029e4bc73c736b$var$instrumentStream;

});
parcelRegister("jOjIq", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $njxh1 = parcelRequire("njxh1");
function $e6c1faefeafd9ab2$var$isResponsesApiStreamEvent(event) {
    return event !== null && typeof event === "object" && "type" in event && typeof event.type === "string" && event.type.startsWith("response.");
}
function $e6c1faefeafd9ab2$var$isChatCompletionChunk(event) {
    return event !== null && typeof event === "object" && "object" in event && event.object === "chat.completion.chunk";
}
function $e6c1faefeafd9ab2$var$addResponseAttributes(span, result, recordOutputs) {
    if (!result || typeof result !== "object") return;
    const response = result;
    const attrs = {};
    if (typeof response.id === "string") attrs[$njxh1.GEN_AI_RESPONSE_ID_ATTRIBUTE] = response.id;
    if (typeof response.model === "string") attrs[$njxh1.GEN_AI_RESPONSE_MODEL_ATTRIBUTE] = response.model;
    if (response.object === "conversation" && typeof response.id === "string") attrs[$njxh1.GEN_AI_CONVERSATION_ID_ATTRIBUTE] = response.id;
    if (response.usage && typeof response.usage === "object") {
        const usage = response.usage;
        const inputTokens = usage.prompt_tokens ?? usage.input_tokens;
        if (typeof inputTokens === "number") attrs[$njxh1.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] = inputTokens;
        const outputTokens = usage.completion_tokens ?? usage.output_tokens;
        if (typeof outputTokens === "number") attrs[$njxh1.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] = outputTokens;
        if (typeof usage.total_tokens === "number") attrs[$njxh1.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE] = usage.total_tokens;
    }
    if (Array.isArray(response.choices)) {
        const choices = response.choices;
        const finishReasons = choices.map((choice)=>choice.finish_reason).filter((reason)=>typeof reason === "string");
        if (finishReasons.length > 0) attrs[$njxh1.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE] = JSON.stringify(finishReasons);
        if (recordOutputs) {
            const responseTexts = choices.map((choice)=>{
                const message = choice.message;
                return message?.content || "";
            });
            attrs[$njxh1.GEN_AI_RESPONSE_TEXT_ATTRIBUTE] = JSON.stringify(responseTexts);
            const toolCalls = choices.map((choice)=>{
                const message = choice.message;
                return message?.tool_calls;
            }).filter((calls)=>Array.isArray(calls) && calls.length > 0).flat();
            if (toolCalls.length > 0) attrs[$njxh1.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE] = JSON.stringify(toolCalls);
        }
    }
    if (typeof response.status === "string") {
        if (!attrs[$njxh1.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE]) attrs[$njxh1.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE] = JSON.stringify([
            response.status
        ]);
    }
    if (recordOutputs) {
        if (typeof response.output_text === "string" && !attrs[$njxh1.GEN_AI_RESPONSE_TEXT_ATTRIBUTE]) attrs[$njxh1.GEN_AI_RESPONSE_TEXT_ATTRIBUTE] = response.output_text;
        if (Array.isArray(response.output) && response.output.length > 0 && !attrs[$njxh1.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE]) {
            const functionCalls = response.output.filter((item)=>item?.type === "function_call");
            if (functionCalls.length > 0) attrs[$njxh1.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE] = JSON.stringify(functionCalls);
        }
    }
    span.setAttributes(attrs);
}
function $e6c1faefeafd9ab2$var$extractConversationId(params) {
    if ("conversation" in params && typeof params.conversation === "string") return params.conversation;
    if ("previous_response_id" in params && typeof params.previous_response_id === "string") return params.previous_response_id;
    return void 0;
}
function $e6c1faefeafd9ab2$var$extractRequestParameters(params) {
    const attributes = {
        [$njxh1.GEN_AI_REQUEST_MODEL_ATTRIBUTE]: params.model ?? "unknown"
    };
    if ("temperature" in params) attributes[$njxh1.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE] = params.temperature;
    if ("top_p" in params) attributes[$njxh1.GEN_AI_REQUEST_TOP_P_ATTRIBUTE] = params.top_p;
    if ("frequency_penalty" in params) attributes[$njxh1.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE] = params.frequency_penalty;
    if ("presence_penalty" in params) attributes[$njxh1.GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE] = params.presence_penalty;
    if ("stream" in params) attributes[$njxh1.GEN_AI_REQUEST_STREAM_ATTRIBUTE] = params.stream;
    if ("encoding_format" in params) attributes[$njxh1.GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE] = params.encoding_format;
    if ("dimensions" in params) attributes[$njxh1.GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE] = params.dimensions;
    const conversationId = $e6c1faefeafd9ab2$var$extractConversationId(params);
    if (conversationId) attributes[$njxh1.GEN_AI_CONVERSATION_ID_ATTRIBUTE] = conversationId;
    return attributes;
}
module.exports.addResponseAttributes = $e6c1faefeafd9ab2$var$addResponseAttributes;
module.exports.extractRequestParameters = $e6c1faefeafd9ab2$var$extractRequestParameters;
module.exports.isChatCompletionChunk = $e6c1faefeafd9ab2$var$isChatCompletionChunk;
module.exports.isResponsesApiStreamEvent = $e6c1faefeafd9ab2$var$isResponsesApiStreamEvent;

});



parcelRegister("2Qsdk", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8txOP = parcelRequire("8txOP");

var $3dwiN = parcelRequire("3dwiN");

var $9X7hl = parcelRequire("9X7hl");

var $4Ae9I = parcelRequire("4Ae9I");

var $njxh1 = parcelRequire("njxh1");

var $8rGYq = parcelRequire("8rGYq");

var $7GPrZ = parcelRequire("7GPrZ");

var $4Rd2l = parcelRequire("4Rd2l");

var $g0Q3M = parcelRequire("g0Q3M");
function $212652d37c1e1a3e$var$extractRequestAttributes(args, methodPath, operationName) {
    const attributes = {
        [$njxh1.GEN_AI_SYSTEM_ATTRIBUTE]: "anthropic",
        [$njxh1.GEN_AI_OPERATION_NAME_ATTRIBUTE]: operationName,
        [$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.ai.anthropic"
    };
    if (args.length > 0 && typeof args[0] === "object" && args[0] !== null) {
        const params = args[0];
        if (params.tools && Array.isArray(params.tools)) attributes[$njxh1.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE] = JSON.stringify(params.tools);
        attributes[$njxh1.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = params.model ?? "unknown";
        if ("temperature" in params) attributes[$njxh1.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE] = params.temperature;
        if ("top_p" in params) attributes[$njxh1.GEN_AI_REQUEST_TOP_P_ATTRIBUTE] = params.top_p;
        if ("stream" in params) attributes[$njxh1.GEN_AI_REQUEST_STREAM_ATTRIBUTE] = params.stream;
        if ("top_k" in params) attributes[$njxh1.GEN_AI_REQUEST_TOP_K_ATTRIBUTE] = params.top_k;
        if ("frequency_penalty" in params) attributes[$njxh1.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE] = params.frequency_penalty;
        if ("max_tokens" in params) attributes[$njxh1.GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE] = params.max_tokens;
    } else if (methodPath === "models.retrieve" || methodPath === "models.get") attributes[$njxh1.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = args[0];
    else attributes[$njxh1.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = "unknown";
    return attributes;
}
function $212652d37c1e1a3e$var$addPrivateRequestAttributes(span, params, enableTruncation) {
    const messages = $g0Q3M.messagesFromParams(params);
    $g0Q3M.setMessagesAttribute(span, messages, enableTruncation);
    if ("prompt" in params) span.setAttributes({
        [$njxh1.GEN_AI_PROMPT_ATTRIBUTE]: JSON.stringify(params.prompt)
    });
}
function $212652d37c1e1a3e$var$addContentAttributes(span, response) {
    if ("content" in response) {
        if (Array.isArray(response.content)) {
            span.setAttributes({
                [$njxh1.GEN_AI_RESPONSE_TEXT_ATTRIBUTE]: response.content.map((item)=>item.text).filter((text)=>!!text).join("")
            });
            const toolCalls = [];
            for (const item of response.content)if (item.type === "tool_use" || item.type === "server_tool_use") toolCalls.push(item);
            if (toolCalls.length > 0) span.setAttributes({
                [$njxh1.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE]: JSON.stringify(toolCalls)
            });
        }
    }
    if ("completion" in response) span.setAttributes({
        [$njxh1.GEN_AI_RESPONSE_TEXT_ATTRIBUTE]: response.completion
    });
    if ("input_tokens" in response) span.setAttributes({
        [$njxh1.GEN_AI_RESPONSE_TEXT_ATTRIBUTE]: JSON.stringify(response.input_tokens)
    });
}
function $212652d37c1e1a3e$var$addMetadataAttributes(span, response) {
    if ("id" in response && "model" in response) {
        span.setAttributes({
            [$njxh1.GEN_AI_RESPONSE_ID_ATTRIBUTE]: response.id,
            [$njxh1.GEN_AI_RESPONSE_MODEL_ATTRIBUTE]: response.model
        });
        if ("usage" in response && response.usage) $8rGYq.setTokenUsageAttributes(span, response.usage.input_tokens, response.usage.output_tokens, response.usage.cache_creation_input_tokens, response.usage.cache_read_input_tokens);
    }
}
function $212652d37c1e1a3e$var$addResponseAttributes(span, response, recordOutputs) {
    if (!response || typeof response !== "object") return;
    if ("type" in response && response.type === "error") {
        $g0Q3M.handleResponseError(span, response);
        return;
    }
    if (recordOutputs) $212652d37c1e1a3e$var$addContentAttributes(span, response);
    $212652d37c1e1a3e$var$addMetadataAttributes(span, response);
}
function $212652d37c1e1a3e$var$handleStreamingError(error, span, methodPath) {
    $8txOP.captureException(error, {
        mechanism: {
            handled: false,
            type: "auto.ai.anthropic",
            data: {
                function: methodPath
            }
        }
    });
    if (span.isRecording()) {
        span.setStatus({
            code: $9X7hl.SPAN_STATUS_ERROR,
            message: "internal_error"
        });
        span.end();
    }
    throw error;
}
function $212652d37c1e1a3e$var$handleStreamingRequest(originalMethod, target, context, args, requestAttributes, operationName, methodPath, params, options, isStreamRequested, isStreamingMethod) {
    const model = requestAttributes[$njxh1.GEN_AI_REQUEST_MODEL_ATTRIBUTE] ?? "unknown";
    const spanConfig = {
        name: `${operationName} ${model}`,
        op: `gen_ai.${operationName}`,
        attributes: requestAttributes
    };
    if (isStreamRequested && !isStreamingMethod) {
        let originalResult;
        const instrumentedPromise = $4Ae9I.startSpanManual(spanConfig, (span)=>{
            originalResult = originalMethod.apply(context, args);
            if (options.recordInputs && params) $212652d37c1e1a3e$var$addPrivateRequestAttributes(span, params, $8rGYq.shouldEnableTruncation(options.enableTruncation));
            return (async ()=>{
                try {
                    const result = await originalResult;
                    return $4Rd2l.instrumentAsyncIterableStream(result, span, options.recordOutputs ?? false);
                } catch (error) {
                    return $212652d37c1e1a3e$var$handleStreamingError(error, span, methodPath);
                }
            })();
        });
        return $8rGYq.wrapPromiseWithMethods(originalResult, instrumentedPromise, "auto.ai.anthropic");
    } else return $4Ae9I.startSpanManual(spanConfig, (span)=>{
        try {
            if (options.recordInputs && params) $212652d37c1e1a3e$var$addPrivateRequestAttributes(span, params, $8rGYq.shouldEnableTruncation(options.enableTruncation));
            const messageStream = target.apply(context, args);
            return $4Rd2l.instrumentMessageStream(messageStream, span, options.recordOutputs ?? false);
        } catch (error) {
            return $212652d37c1e1a3e$var$handleStreamingError(error, span, methodPath);
        }
    });
}
function $212652d37c1e1a3e$var$instrumentMethod(originalMethod, methodPath, instrumentedMethod, context, options) {
    return new Proxy(originalMethod, {
        apply (target, thisArg, args) {
            const operationName = instrumentedMethod.operation || "unknown";
            const requestAttributes = $212652d37c1e1a3e$var$extractRequestAttributes(args, methodPath, operationName);
            const model = requestAttributes[$njxh1.GEN_AI_REQUEST_MODEL_ATTRIBUTE] ?? "unknown";
            const params = typeof args[0] === "object" ? args[0] : void 0;
            const isStreamRequested = Boolean(params?.stream);
            const isStreamingMethod = instrumentedMethod.streaming === true;
            if (isStreamRequested || isStreamingMethod) return $212652d37c1e1a3e$var$handleStreamingRequest(originalMethod, target, context, args, requestAttributes, operationName, methodPath, params, options, isStreamRequested, isStreamingMethod);
            let originalResult;
            const instrumentedPromise = $4Ae9I.startSpan({
                name: `${operationName} ${model}`,
                op: `gen_ai.${operationName}`,
                attributes: requestAttributes
            }, (span)=>{
                originalResult = target.apply(context, args);
                if (options.recordInputs && params) $212652d37c1e1a3e$var$addPrivateRequestAttributes(span, params, $8rGYq.shouldEnableTruncation(options.enableTruncation));
                return originalResult.then((result)=>{
                    $212652d37c1e1a3e$var$addResponseAttributes(span, result, options.recordOutputs);
                    return result;
                }, (error)=>{
                    $8txOP.captureException(error, {
                        mechanism: {
                            handled: false,
                            type: "auto.ai.anthropic",
                            data: {
                                function: methodPath
                            }
                        }
                    });
                    throw error;
                });
            });
            return $8rGYq.wrapPromiseWithMethods(originalResult, instrumentedPromise, "auto.ai.anthropic");
        }
    });
}
function $212652d37c1e1a3e$var$createDeepProxy(target, currentPath = "", options) {
    return new Proxy(target, {
        get (obj, prop) {
            const value = obj[prop];
            const methodPath = $8rGYq.buildMethodPath(currentPath, String(prop));
            const instrumentedMethod = $7GPrZ.ANTHROPIC_METHOD_REGISTRY[methodPath];
            if (typeof value === "function" && instrumentedMethod) return $212652d37c1e1a3e$var$instrumentMethod(value, methodPath, instrumentedMethod, obj, options);
            if (typeof value === "function") return value.bind(obj);
            if (value && typeof value === "object") return $212652d37c1e1a3e$var$createDeepProxy(value, methodPath, options);
            return value;
        }
    });
}
function $212652d37c1e1a3e$var$instrumentAnthropicAiClient(anthropicAiClient, options) {
    return $212652d37c1e1a3e$var$createDeepProxy(anthropicAiClient, "", $8rGYq.resolveAIRecordingOptions(options));
}
module.exports.instrumentAnthropicAiClient = $212652d37c1e1a3e$var$instrumentAnthropicAiClient;

});
parcelRegister("7GPrZ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $59945da11bf75a87$var$ANTHROPIC_AI_INTEGRATION_NAME = "Anthropic_AI";
const $59945da11bf75a87$var$ANTHROPIC_METHOD_REGISTRY = {
    "messages.create": {
        operation: "chat"
    },
    "messages.stream": {
        operation: "chat",
        streaming: true
    },
    "messages.countTokens": {
        operation: "chat"
    },
    "models.get": {
        operation: "models"
    },
    "completions.create": {
        operation: "chat"
    },
    "models.retrieve": {
        operation: "models"
    },
    "beta.messages.create": {
        operation: "chat"
    }
};
module.exports.ANTHROPIC_AI_INTEGRATION_NAME = $59945da11bf75a87$var$ANTHROPIC_AI_INTEGRATION_NAME;
module.exports.ANTHROPIC_METHOD_REGISTRY = $59945da11bf75a87$var$ANTHROPIC_METHOD_REGISTRY;

});

parcelRegister("4Rd2l", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8txOP = parcelRequire("8txOP");

var $9X7hl = parcelRequire("9X7hl");

var $8rGYq = parcelRequire("8rGYq");

var $g0Q3M = parcelRequire("g0Q3M");
function $3896397da883d0a0$var$isErrorEvent(event, span) {
    if ("type" in event && typeof event.type === "string") {
        if (event.type === "error") {
            span.setStatus({
                code: $9X7hl.SPAN_STATUS_ERROR,
                message: $g0Q3M.mapAnthropicErrorToStatusMessage(event.error?.type)
            });
            $8txOP.captureException(event.error, {
                mechanism: {
                    handled: false,
                    type: "auto.ai.anthropic.anthropic_error"
                }
            });
            return true;
        }
    }
    return false;
}
function $3896397da883d0a0$var$handleMessageMetadata(event, state) {
    if (event.type === "message_delta" && event.usage) {
        if ("output_tokens" in event.usage && typeof event.usage.output_tokens === "number") state.completionTokens = event.usage.output_tokens;
    }
    if (event.message) {
        const message = event.message;
        if (message.id) state.responseId = message.id;
        if (message.model) state.responseModel = message.model;
        if (message.stop_reason) state.finishReasons.push(message.stop_reason);
        if (message.usage) {
            if (typeof message.usage.input_tokens === "number") state.promptTokens = message.usage.input_tokens;
            if (typeof message.usage.cache_creation_input_tokens === "number") state.cacheCreationInputTokens = message.usage.cache_creation_input_tokens;
            if (typeof message.usage.cache_read_input_tokens === "number") state.cacheReadInputTokens = message.usage.cache_read_input_tokens;
        }
    }
}
function $3896397da883d0a0$var$handleContentBlockStart(event, state) {
    if (event.type !== "content_block_start" || typeof event.index !== "number" || !event.content_block) return;
    if (event.content_block.type === "tool_use" || event.content_block.type === "server_tool_use") state.activeToolBlocks[event.index] = {
        id: event.content_block.id,
        name: event.content_block.name,
        inputJsonParts: []
    };
}
function $3896397da883d0a0$var$handleContentBlockDelta(event, state, recordOutputs) {
    if (event.type !== "content_block_delta" || !event.delta) return;
    if (typeof event.index === "number" && "partial_json" in event.delta && typeof event.delta.partial_json === "string") {
        const active = state.activeToolBlocks[event.index];
        if (active) active.inputJsonParts.push(event.delta.partial_json);
    }
    if (recordOutputs && typeof event.delta.text === "string") state.responseTexts.push(event.delta.text);
}
function $3896397da883d0a0$var$handleContentBlockStop(event, state) {
    if (event.type !== "content_block_stop" || typeof event.index !== "number") return;
    const active = state.activeToolBlocks[event.index];
    if (!active) return;
    const raw = active.inputJsonParts.join("");
    let parsedInput;
    try {
        parsedInput = raw ? JSON.parse(raw) : {};
    } catch  {
        parsedInput = {
            __unparsed: raw
        };
    }
    state.toolCalls.push({
        type: "tool_use",
        id: active.id,
        name: active.name,
        input: parsedInput
    });
    delete state.activeToolBlocks[event.index];
}
function $3896397da883d0a0$var$processEvent(event, state, recordOutputs, span) {
    if (!(event && typeof event === "object")) return;
    const isError = $3896397da883d0a0$var$isErrorEvent(event, span);
    if (isError) return;
    $3896397da883d0a0$var$handleMessageMetadata(event, state);
    $3896397da883d0a0$var$handleContentBlockStart(event, state);
    $3896397da883d0a0$var$handleContentBlockDelta(event, state, recordOutputs);
    $3896397da883d0a0$var$handleContentBlockStop(event, state);
}
async function* $3896397da883d0a0$var$instrumentAsyncIterableStream(stream, span, recordOutputs) {
    const state = {
        responseTexts: [],
        finishReasons: [],
        responseId: "",
        responseModel: "",
        promptTokens: void 0,
        completionTokens: void 0,
        cacheCreationInputTokens: void 0,
        cacheReadInputTokens: void 0,
        toolCalls: [],
        activeToolBlocks: {}
    };
    try {
        for await (const event of stream){
            $3896397da883d0a0$var$processEvent(event, state, recordOutputs, span);
            yield event;
        }
    } finally{
        $8rGYq.endStreamSpan(span, state, recordOutputs);
    }
}
function $3896397da883d0a0$var$instrumentMessageStream(stream, span, recordOutputs) {
    const state = {
        responseTexts: [],
        finishReasons: [],
        responseId: "",
        responseModel: "",
        promptTokens: void 0,
        completionTokens: void 0,
        cacheCreationInputTokens: void 0,
        cacheReadInputTokens: void 0,
        toolCalls: [],
        activeToolBlocks: {}
    };
    stream.on("streamEvent", (event)=>{
        $3896397da883d0a0$var$processEvent(event, state, recordOutputs, span);
    });
    stream.on("message", ()=>{
        $8rGYq.endStreamSpan(span, state, recordOutputs);
    });
    stream.on("error", (error)=>{
        $8txOP.captureException(error, {
            mechanism: {
                handled: false,
                type: "auto.ai.anthropic.stream_error"
            }
        });
        if (span.isRecording()) {
            span.setStatus({
                code: $9X7hl.SPAN_STATUS_ERROR,
                message: "internal_error"
            });
            span.end();
        }
    });
    return stream;
}
module.exports.instrumentAsyncIterableStream = $3896397da883d0a0$var$instrumentAsyncIterableStream;
module.exports.instrumentMessageStream = $3896397da883d0a0$var$instrumentMessageStream;

});
parcelRegister("g0Q3M", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8txOP = parcelRequire("8txOP");

var $9X7hl = parcelRequire("9X7hl");

var $njxh1 = parcelRequire("njxh1");

var $8rGYq = parcelRequire("8rGYq");
function $ba8507734354810d$var$setMessagesAttribute(span, messages, enableTruncation) {
    if (Array.isArray(messages) && messages.length === 0) return;
    const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $8rGYq.extractSystemInstructions(messages);
    if (systemInstructions) span.setAttributes({
        [$njxh1.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE]: systemInstructions
    });
    const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 1;
    span.setAttributes({
        [$njxh1.GEN_AI_INPUT_MESSAGES_ATTRIBUTE]: enableTruncation ? $8rGYq.getTruncatedJsonString(filteredMessages) : $8rGYq.getJsonString(filteredMessages),
        [$njxh1.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE]: filteredLength
    });
}
const $ba8507734354810d$var$ANTHROPIC_ERROR_TYPE_TO_SPAN_STATUS = {
    invalid_request_error: "invalid_argument",
    authentication_error: "unauthenticated",
    permission_error: "permission_denied",
    not_found_error: "not_found",
    request_too_large: "failed_precondition",
    rate_limit_error: "resource_exhausted",
    api_error: "internal_error",
    overloaded_error: "unavailable"
};
function $ba8507734354810d$var$mapAnthropicErrorToStatusMessage(errorType) {
    if (!errorType) return "internal_error";
    return $ba8507734354810d$var$ANTHROPIC_ERROR_TYPE_TO_SPAN_STATUS[errorType] || "internal_error";
}
function $ba8507734354810d$var$handleResponseError(span, response) {
    if (response.error) {
        span.setStatus({
            code: $9X7hl.SPAN_STATUS_ERROR,
            message: $ba8507734354810d$var$mapAnthropicErrorToStatusMessage(response.error.type)
        });
        $8txOP.captureException(response.error, {
            mechanism: {
                handled: false,
                type: "auto.ai.anthropic.anthropic_error"
            }
        });
    }
}
function $ba8507734354810d$var$messagesFromParams(params) {
    const { system: system, messages: messages, input: input } = params;
    const systemMessages = typeof system === "string" ? [
        {
            role: "system",
            content: params.system
        }
    ] : [];
    const inputParamMessages = Array.isArray(input) ? input : input != null ? [
        input
    ] : void 0;
    const messagesParamMessages = Array.isArray(messages) ? messages : messages != null ? [
        messages
    ] : [];
    const userMessages = inputParamMessages ?? messagesParamMessages;
    return [
        ...systemMessages,
        ...userMessages
    ];
}
module.exports.handleResponseError = $ba8507734354810d$var$handleResponseError;
module.exports.mapAnthropicErrorToStatusMessage = $ba8507734354810d$var$mapAnthropicErrorToStatusMessage;
module.exports.messagesFromParams = $ba8507734354810d$var$messagesFromParams;
module.exports.setMessagesAttribute = $ba8507734354810d$var$setMessagesAttribute;

});



parcelRegister("5i7Tv", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8txOP = parcelRequire("8txOP");

var $3dwiN = parcelRequire("3dwiN");

var $9X7hl = parcelRequire("9X7hl");

var $4Ae9I = parcelRequire("4Ae9I");

var $8qJ6j = parcelRequire("8qJ6j");

var $njxh1 = parcelRequire("njxh1");

var $8rGYq = parcelRequire("8rGYq");

var $hBbOb = parcelRequire("hBbOb");

var $dHbTD = parcelRequire("dHbTD");

var $6C0sn = parcelRequire("6C0sn");
function $3da4c1d45ef6705e$var$extractModel(params, context) {
    if ("model" in params && typeof params.model === "string") return params.model;
    if (context && typeof context === "object") {
        const contextObj = context;
        if ("model" in contextObj && typeof contextObj.model === "string") return contextObj.model;
        if ("modelVersion" in contextObj && typeof contextObj.modelVersion === "string") return contextObj.modelVersion;
    }
    return "unknown";
}
function $3da4c1d45ef6705e$var$extractConfigAttributes(config) {
    const attributes = {};
    if ("temperature" in config && typeof config.temperature === "number") attributes[$njxh1.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE] = config.temperature;
    if ("topP" in config && typeof config.topP === "number") attributes[$njxh1.GEN_AI_REQUEST_TOP_P_ATTRIBUTE] = config.topP;
    if ("topK" in config && typeof config.topK === "number") attributes[$njxh1.GEN_AI_REQUEST_TOP_K_ATTRIBUTE] = config.topK;
    if ("maxOutputTokens" in config && typeof config.maxOutputTokens === "number") attributes[$njxh1.GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE] = config.maxOutputTokens;
    if ("frequencyPenalty" in config && typeof config.frequencyPenalty === "number") attributes[$njxh1.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE] = config.frequencyPenalty;
    if ("presencePenalty" in config && typeof config.presencePenalty === "number") attributes[$njxh1.GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE] = config.presencePenalty;
    return attributes;
}
function $3da4c1d45ef6705e$var$extractRequestAttributes(operationName, params, context) {
    const attributes = {
        [$njxh1.GEN_AI_SYSTEM_ATTRIBUTE]: $hBbOb.GOOGLE_GENAI_SYSTEM_NAME,
        [$njxh1.GEN_AI_OPERATION_NAME_ATTRIBUTE]: operationName,
        [$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.ai.google_genai"
    };
    if (params) {
        attributes[$njxh1.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = $3da4c1d45ef6705e$var$extractModel(params, context);
        if ("config" in params && typeof params.config === "object" && params.config) {
            const config = params.config;
            Object.assign(attributes, $3da4c1d45ef6705e$var$extractConfigAttributes(config));
            if ("tools" in config && Array.isArray(config.tools)) {
                const functionDeclarations = config.tools.flatMap((tool)=>tool.functionDeclarations);
                attributes[$njxh1.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE] = JSON.stringify(functionDeclarations);
            }
        }
    } else attributes[$njxh1.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = $3da4c1d45ef6705e$var$extractModel({}, context);
    return attributes;
}
function $3da4c1d45ef6705e$var$addPrivateRequestAttributes(span, params, isEmbeddings, enableTruncation) {
    if (isEmbeddings) {
        const contents = params.contents;
        if (contents != null) span.setAttribute($njxh1.GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE, typeof contents === "string" ? contents : JSON.stringify(contents));
        return;
    }
    const messages = [];
    if ("config" in params && params.config && typeof params.config === "object" && "systemInstruction" in params.config && params.config.systemInstruction) messages.push(...$6C0sn.contentUnionToMessages(params.config.systemInstruction, "system"));
    if ("history" in params) messages.push(...$6C0sn.contentUnionToMessages(params.history, "user"));
    if ("contents" in params) messages.push(...$6C0sn.contentUnionToMessages(params.contents, "user"));
    if ("message" in params) messages.push(...$6C0sn.contentUnionToMessages(params.message, "user"));
    if (Array.isArray(messages) && messages.length) {
        const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $8rGYq.extractSystemInstructions(messages);
        if (systemInstructions) span.setAttribute($njxh1.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
        const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
        span.setAttributes({
            [$njxh1.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE]: filteredLength,
            [$njxh1.GEN_AI_INPUT_MESSAGES_ATTRIBUTE]: enableTruncation ? $8rGYq.getTruncatedJsonString(filteredMessages) : $8rGYq.getJsonString(filteredMessages)
        });
    }
}
function $3da4c1d45ef6705e$var$addResponseAttributes(span, response, recordOutputs) {
    if (!response || typeof response !== "object") return;
    if (response.modelVersion) span.setAttribute($njxh1.GEN_AI_RESPONSE_MODEL_ATTRIBUTE, response.modelVersion);
    if (response.usageMetadata && typeof response.usageMetadata === "object") {
        const usage = response.usageMetadata;
        if (typeof usage.promptTokenCount === "number") span.setAttributes({
            [$njxh1.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE]: usage.promptTokenCount
        });
        if (typeof usage.candidatesTokenCount === "number") span.setAttributes({
            [$njxh1.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE]: usage.candidatesTokenCount
        });
        if (typeof usage.totalTokenCount === "number") span.setAttributes({
            [$njxh1.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE]: usage.totalTokenCount
        });
    }
    if (recordOutputs && Array.isArray(response.candidates) && response.candidates.length > 0) {
        const responseTexts = response.candidates.map((candidate)=>{
            if (candidate.content?.parts && Array.isArray(candidate.content.parts)) return candidate.content.parts.map((part)=>typeof part.text === "string" ? part.text : "").filter((text)=>text.length > 0).join("");
            return "";
        }).filter((text)=>text.length > 0);
        if (responseTexts.length > 0) span.setAttributes({
            [$njxh1.GEN_AI_RESPONSE_TEXT_ATTRIBUTE]: responseTexts.join("")
        });
    }
    if (recordOutputs && response.functionCalls) {
        const functionCalls = response.functionCalls;
        if (Array.isArray(functionCalls) && functionCalls.length > 0) span.setAttributes({
            [$njxh1.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE]: JSON.stringify(functionCalls)
        });
    }
}
function $3da4c1d45ef6705e$var$instrumentMethod(originalMethod, methodPath, instrumentedMethod, context, options) {
    const isEmbeddings = instrumentedMethod.operation === "embeddings";
    return new Proxy(originalMethod, {
        apply (target, _, args) {
            const operationName = instrumentedMethod.operation || "unknown";
            const params = args[0];
            const requestAttributes = $3da4c1d45ef6705e$var$extractRequestAttributes(operationName, params, context);
            const model = requestAttributes[$njxh1.GEN_AI_REQUEST_MODEL_ATTRIBUTE] ?? "unknown";
            if (instrumentedMethod.streaming) return $4Ae9I.startSpanManual({
                name: `${operationName} ${model}`,
                op: `gen_ai.${operationName}`,
                attributes: requestAttributes
            }, async (span)=>{
                try {
                    if (options.recordInputs && params) $3da4c1d45ef6705e$var$addPrivateRequestAttributes(span, params, isEmbeddings, $8rGYq.shouldEnableTruncation(options.enableTruncation));
                    const stream = await target.apply(context, args);
                    return $dHbTD.instrumentStream(stream, span, Boolean(options.recordOutputs));
                } catch (error) {
                    span.setStatus({
                        code: $9X7hl.SPAN_STATUS_ERROR,
                        message: "internal_error"
                    });
                    $8txOP.captureException(error, {
                        mechanism: {
                            handled: false,
                            type: "auto.ai.google_genai",
                            data: {
                                function: methodPath
                            }
                        }
                    });
                    span.end();
                    throw error;
                }
            });
            return $4Ae9I.startSpan({
                name: `${operationName} ${model}`,
                op: `gen_ai.${operationName}`,
                attributes: requestAttributes
            }, (span)=>{
                if (options.recordInputs && params) $3da4c1d45ef6705e$var$addPrivateRequestAttributes(span, params, isEmbeddings, $8rGYq.shouldEnableTruncation(options.enableTruncation));
                return $8qJ6j.handleCallbackErrors(()=>target.apply(context, args), (error)=>{
                    $8txOP.captureException(error, {
                        mechanism: {
                            handled: false,
                            type: "auto.ai.google_genai",
                            data: {
                                function: methodPath
                            }
                        }
                    });
                }, ()=>{}, (result)=>{
                    if (!isEmbeddings) $3da4c1d45ef6705e$var$addResponseAttributes(span, result, options.recordOutputs);
                });
            });
        }
    });
}
function $3da4c1d45ef6705e$var$createDeepProxy(target, currentPath = "", options) {
    return new Proxy(target, {
        get: (t, prop, receiver)=>{
            const value = Reflect.get(t, prop, receiver);
            const methodPath = $8rGYq.buildMethodPath(currentPath, String(prop));
            const instrumentedMethod = $hBbOb.GOOGLE_GENAI_METHOD_REGISTRY[methodPath];
            if (typeof value === "function" && instrumentedMethod) {
                const wrappedMethod = instrumentedMethod.operation ? $3da4c1d45ef6705e$var$instrumentMethod(value, methodPath, instrumentedMethod, t, options) : value.bind(t);
                if (!instrumentedMethod.proxyResultPath) return wrappedMethod;
                return function(...args) {
                    const result = wrappedMethod(...args);
                    if (result && typeof result === "object") return $3da4c1d45ef6705e$var$createDeepProxy(result, instrumentedMethod.proxyResultPath, options);
                    return result;
                };
            }
            if (typeof value === "function") return value.bind(t);
            if (value && typeof value === "object") return $3da4c1d45ef6705e$var$createDeepProxy(value, methodPath, options);
            return value;
        }
    });
}
function $3da4c1d45ef6705e$var$instrumentGoogleGenAIClient(client, options) {
    return $3da4c1d45ef6705e$var$createDeepProxy(client, "", $8rGYq.resolveAIRecordingOptions(options));
}
module.exports.extractModel = $3da4c1d45ef6705e$var$extractModel;
module.exports.instrumentGoogleGenAIClient = $3da4c1d45ef6705e$var$instrumentGoogleGenAIClient;

});
parcelRegister("hBbOb", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $ccff0d43693b653b$var$GOOGLE_GENAI_INTEGRATION_NAME = "Google_GenAI";
const $ccff0d43693b653b$var$GOOGLE_GENAI_METHOD_REGISTRY = {
    "models.generateContent": {
        operation: "generate_content"
    },
    "models.generateContentStream": {
        operation: "generate_content",
        streaming: true
    },
    "models.embedContent": {
        operation: "embeddings"
    },
    "chats.create": {
        proxyResultPath: "chat"
    },
    "chat.sendMessage": {
        operation: "chat"
    },
    "chat.sendMessageStream": {
        operation: "chat",
        streaming: true
    }
};
const $ccff0d43693b653b$var$GOOGLE_GENAI_SYSTEM_NAME = "google_genai";
module.exports.GOOGLE_GENAI_INTEGRATION_NAME = $ccff0d43693b653b$var$GOOGLE_GENAI_INTEGRATION_NAME;
module.exports.GOOGLE_GENAI_METHOD_REGISTRY = $ccff0d43693b653b$var$GOOGLE_GENAI_METHOD_REGISTRY;
module.exports.GOOGLE_GENAI_SYSTEM_NAME = $ccff0d43693b653b$var$GOOGLE_GENAI_SYSTEM_NAME;

});

parcelRegister("dHbTD", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8txOP = parcelRequire("8txOP");

var $9X7hl = parcelRequire("9X7hl");

var $8rGYq = parcelRequire("8rGYq");
function $9f8884dd9b0c138c$var$isErrorChunk(chunk, span) {
    const feedback = chunk?.promptFeedback;
    if (feedback?.blockReason) {
        const message = feedback.blockReasonMessage ?? feedback.blockReason;
        span.setStatus({
            code: $9X7hl.SPAN_STATUS_ERROR,
            message: "internal_error"
        });
        $8txOP.captureException(`Content blocked: ${message}`, {
            mechanism: {
                handled: false,
                type: "auto.ai.google_genai"
            }
        });
        return true;
    }
    return false;
}
function $9f8884dd9b0c138c$var$handleResponseMetadata(chunk, state) {
    if (typeof chunk.responseId === "string") state.responseId = chunk.responseId;
    if (typeof chunk.modelVersion === "string") state.responseModel = chunk.modelVersion;
    const usage = chunk.usageMetadata;
    if (usage) {
        if (typeof usage.promptTokenCount === "number") state.promptTokens = usage.promptTokenCount;
        if (typeof usage.candidatesTokenCount === "number") state.completionTokens = usage.candidatesTokenCount;
        if (typeof usage.totalTokenCount === "number") state.totalTokens = usage.totalTokenCount;
    }
}
function $9f8884dd9b0c138c$var$handleCandidateContent(chunk, state, recordOutputs) {
    if (Array.isArray(chunk.functionCalls)) state.toolCalls.push(...chunk.functionCalls);
    for (const candidate of chunk.candidates ?? []){
        if (candidate?.finishReason && !state.finishReasons.includes(candidate.finishReason)) state.finishReasons.push(candidate.finishReason);
        for (const part of candidate?.content?.parts ?? []){
            if (recordOutputs && part.text) state.responseTexts.push(part.text);
            if (part.functionCall) state.toolCalls.push({
                type: "function",
                id: part.functionCall.id,
                name: part.functionCall.name,
                arguments: part.functionCall.args
            });
        }
    }
}
function $9f8884dd9b0c138c$var$processChunk(chunk, state, recordOutputs, span) {
    if (!chunk || $9f8884dd9b0c138c$var$isErrorChunk(chunk, span)) return;
    $9f8884dd9b0c138c$var$handleResponseMetadata(chunk, state);
    $9f8884dd9b0c138c$var$handleCandidateContent(chunk, state, recordOutputs);
}
async function* $9f8884dd9b0c138c$var$instrumentStream(stream, span, recordOutputs) {
    const state = {
        responseTexts: [],
        finishReasons: [],
        toolCalls: []
    };
    try {
        for await (const chunk of stream){
            $9f8884dd9b0c138c$var$processChunk(chunk, state, recordOutputs, span);
            yield chunk;
        }
    } finally{
        $8rGYq.endStreamSpan(span, state, recordOutputs);
    }
}
module.exports.instrumentStream = $9f8884dd9b0c138c$var$instrumentStream;

});

parcelRegister("6C0sn", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $4d06a564970c6997$var$contentUnionToMessages(content, role = "user") {
    if (typeof content === "string") return [
        {
            role: role,
            content: content
        }
    ];
    if (Array.isArray(content)) return content.flatMap((content2)=>$4d06a564970c6997$var$contentUnionToMessages(content2, role));
    if (typeof content !== "object" || !content) return [];
    if ("role" in content && typeof content.role === "string") return [
        content
    ];
    if ("parts" in content) return [
        {
            ...content,
            role: role
        }
    ];
    return [
        {
            role: role,
            content: content
        }
    ];
}
module.exports.contentUnionToMessages = $4d06a564970c6997$var$contentUnionToMessages;

});


parcelRegister("i1Lan", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8txOP = parcelRequire("8txOP");

var $3dwiN = parcelRequire("3dwiN");

var $9X7hl = parcelRequire("9X7hl");

var $4Ae9I = parcelRequire("4Ae9I");

var $njxh1 = parcelRequire("njxh1");

var $8rGYq = parcelRequire("8rGYq");

var $7cQmT = parcelRequire("7cQmT");

var $jLYfK = parcelRequire("jLYfK");
function $d1fce842915d902f$var$createLangChainCallbackHandler(options = {}) {
    const { recordInputs: recordInputs, recordOutputs: recordOutputs } = $8rGYq.resolveAIRecordingOptions(options);
    const enableTruncation = $8rGYq.shouldEnableTruncation(options.enableTruncation);
    const spanMap = /* @__PURE__ */ new Map();
    const exitSpan = (runId)=>{
        const span = spanMap.get(runId);
        if (span?.isRecording()) {
            span.end();
            spanMap.delete(runId);
        }
    };
    const handler = {
        // Required LangChain BaseCallbackHandler properties
        lc_serializable: false,
        lc_namespace: [
            "langchain_core",
            "callbacks",
            "sentry"
        ],
        lc_secrets: void 0,
        lc_attributes: void 0,
        lc_aliases: void 0,
        lc_serializable_keys: void 0,
        lc_id: [
            "langchain_core",
            "callbacks",
            "sentry"
        ],
        lc_kwargs: {},
        name: "SentryCallbackHandler",
        // BaseCallbackHandlerInput boolean flags
        ignoreLLM: false,
        ignoreChain: false,
        ignoreAgent: false,
        ignoreRetriever: false,
        ignoreCustomEvent: false,
        raiseError: false,
        awaitHandlers: true,
        handleLLMStart (llm, prompts, runId, _parentRunId, _extraParams, tags, metadata, _runName) {
            const invocationParams = $jLYfK.getInvocationParams(tags);
            const attributes = $jLYfK.extractLLMRequestAttributes(llm, prompts, recordInputs, enableTruncation, invocationParams, metadata);
            const modelName = attributes[$njxh1.GEN_AI_REQUEST_MODEL_ATTRIBUTE];
            const operationName = attributes[$njxh1.GEN_AI_OPERATION_NAME_ATTRIBUTE];
            $4Ae9I.startSpanManual({
                name: `${operationName} ${modelName}`,
                op: "gen_ai.chat",
                attributes: {
                    ...$jLYfK.getAgentNameFromMetadata(metadata),
                    ...attributes,
                    [$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "gen_ai.chat"
                }
            }, (span)=>{
                spanMap.set(runId, span);
                return span;
            });
        },
        // Chat Model Start Handler
        handleChatModelStart (llm, messages, runId, _parentRunId, extraParams, tags, metadata, _runName) {
            const invocationParams = $jLYfK.getInvocationParams(tags);
            const attributes = $jLYfK.extractChatModelRequestAttributes(llm, messages, recordInputs, enableTruncation, invocationParams, metadata);
            const toolDefsJson = $jLYfK.extractToolDefinitions(extraParams);
            if (toolDefsJson) attributes[$njxh1.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE] = toolDefsJson;
            const modelName = attributes[$njxh1.GEN_AI_REQUEST_MODEL_ATTRIBUTE];
            const operationName = attributes[$njxh1.GEN_AI_OPERATION_NAME_ATTRIBUTE];
            $4Ae9I.startSpanManual({
                name: `${operationName} ${modelName}`,
                op: "gen_ai.chat",
                attributes: {
                    ...$jLYfK.getAgentNameFromMetadata(metadata),
                    ...attributes,
                    [$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "gen_ai.chat"
                }
            }, (span)=>{
                spanMap.set(runId, span);
                return span;
            });
        },
        // LLM End Handler - note: handleLLMEnd with capital LLM (used by both LLMs and chat models!)
        handleLLMEnd (output, runId, _parentRunId, _tags, _extraParams) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                const attributes = $jLYfK.extractLlmResponseAttributes(output, recordOutputs);
                if (attributes) span.setAttributes(attributes);
                exitSpan(runId);
            }
        },
        // LLM Error Handler - note: handleLLMError with capital LLM
        handleLLMError (error, runId) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                span.setStatus({
                    code: $9X7hl.SPAN_STATUS_ERROR,
                    message: "internal_error"
                });
                exitSpan(runId);
            }
            $8txOP.captureException(error, {
                mechanism: {
                    handled: false,
                    type: `${$7cQmT.LANGCHAIN_ORIGIN}.llm_error_handler`
                }
            });
        },
        // Chain Start Handler
        handleChainStart (chain, inputs, runId, _parentRunId, _tags, metadata, _runType, runName) {
            if (metadata?.__sentry_langgraph__) return;
            const chainName = runName || chain.name || "unknown_chain";
            const attributes = {
                [$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.ai.langchain",
                "langchain.chain.name": chainName
            };
            if (recordInputs) attributes["langchain.chain.inputs"] = JSON.stringify(inputs);
            $4Ae9I.startSpanManual({
                name: `chain ${chainName}`,
                op: "gen_ai.invoke_agent",
                attributes: {
                    ...attributes,
                    [$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "gen_ai.invoke_agent"
                }
            }, (span)=>{
                spanMap.set(runId, span);
                return span;
            });
        },
        // Chain End Handler
        handleChainEnd (outputs, runId) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                if (recordOutputs) span.setAttributes({
                    "langchain.chain.outputs": JSON.stringify(outputs)
                });
                exitSpan(runId);
            }
        },
        // Chain Error Handler
        handleChainError (error, runId) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                span.setStatus({
                    code: $9X7hl.SPAN_STATUS_ERROR,
                    message: "internal_error"
                });
                exitSpan(runId);
            }
            $8txOP.captureException(error, {
                mechanism: {
                    handled: false,
                    type: `${$7cQmT.LANGCHAIN_ORIGIN}.chain_error_handler`
                }
            });
        },
        // Tool Start Handler
        handleToolStart (tool, input, runId, _parentRunId, _tags, metadata, runName) {
            if (metadata?.__sentry_langgraph__) return;
            const toolName = runName || tool.name || "unknown_tool";
            const attributes = {
                ...$jLYfK.getAgentNameFromMetadata(metadata),
                [$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $7cQmT.LANGCHAIN_ORIGIN,
                [$njxh1.GEN_AI_OPERATION_NAME_ATTRIBUTE]: "execute_tool",
                [$njxh1.GEN_AI_TOOL_NAME_ATTRIBUTE]: toolName
            };
            if (recordInputs) attributes[$njxh1.GEN_AI_TOOL_INPUT_ATTRIBUTE] = input;
            $4Ae9I.startSpanManual({
                name: `execute_tool ${toolName}`,
                op: "gen_ai.execute_tool",
                attributes: {
                    ...attributes,
                    [$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "gen_ai.execute_tool"
                }
            }, (span)=>{
                spanMap.set(runId, span);
                return span;
            });
        },
        // Tool End Handler
        handleToolEnd (output, runId) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                if (recordOutputs) {
                    const outputObj = output;
                    const content = outputObj && typeof outputObj === "object" && "content" in outputObj ? outputObj.content : output;
                    span.setAttributes({
                        [$njxh1.GEN_AI_TOOL_OUTPUT_ATTRIBUTE]: typeof content === "string" ? content : JSON.stringify(content)
                    });
                }
                exitSpan(runId);
            }
        },
        // Tool Error Handler
        handleToolError (error, runId) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                span.setStatus({
                    code: $9X7hl.SPAN_STATUS_ERROR,
                    message: "internal_error"
                });
                exitSpan(runId);
            }
            $8txOP.captureException(error, {
                mechanism: {
                    handled: false,
                    type: `${$7cQmT.LANGCHAIN_ORIGIN}.tool_error_handler`
                }
            });
        },
        // LangChain BaseCallbackHandler required methods
        copy () {
            return handler;
        },
        toJSON () {
            return {
                lc: 1,
                type: "not_implemented",
                id: handler.lc_id
            };
        },
        toJSONNotImplemented () {
            return {
                lc: 1,
                type: "not_implemented",
                id: handler.lc_id
            };
        }
    };
    return handler;
}
module.exports.createLangChainCallbackHandler = $d1fce842915d902f$var$createLangChainCallbackHandler;

});
parcelRegister("7cQmT", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $53f246a73f169809$var$LANGCHAIN_INTEGRATION_NAME = "LangChain";
const $53f246a73f169809$var$LANGCHAIN_ORIGIN = "auto.ai.langchain";
const $53f246a73f169809$var$ROLE_MAP = {
    human: "user",
    ai: "assistant",
    assistant: "assistant",
    system: "system",
    function: "function",
    tool: "tool"
};
module.exports.LANGCHAIN_INTEGRATION_NAME = $53f246a73f169809$var$LANGCHAIN_INTEGRATION_NAME;
module.exports.LANGCHAIN_ORIGIN = $53f246a73f169809$var$LANGCHAIN_ORIGIN;
module.exports.ROLE_MAP = $53f246a73f169809$var$ROLE_MAP;

});

parcelRegister("jLYfK", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3dwiN = parcelRequire("3dwiN");

var $njxh1 = parcelRequire("njxh1");

var $52AAP = parcelRequire("52AAP");

var $8rGYq = parcelRequire("8rGYq");

var $7cQmT = parcelRequire("7cQmT");
const $e65125157f68cd9d$var$setIfDefined = (target, key, value)=>{
    if (value != null) target[key] = value;
};
const $e65125157f68cd9d$var$setNumberIfDefined = (target, key, value)=>{
    const n = Number(value);
    if (!Number.isNaN(n)) target[key] = n;
};
function $e65125157f68cd9d$var$asString(v) {
    if (typeof v === "string") return v;
    try {
        return JSON.stringify(v);
    } catch  {
        return String(v);
    }
}
function $e65125157f68cd9d$var$normalizeContent(v) {
    if (Array.isArray(v)) try {
        const stripped = v.map((part)=>part && typeof part === "object" && $52AAP.isContentMedia(part) ? $52AAP.stripInlineMediaFromSingleMessage(part) : part);
        return JSON.stringify(stripped);
    } catch  {
        return String(v);
    }
    return $e65125157f68cd9d$var$asString(v);
}
function $e65125157f68cd9d$var$normalizeMessageRole(role) {
    const normalized = role.toLowerCase();
    return $7cQmT.ROLE_MAP[normalized] ?? normalized;
}
function $e65125157f68cd9d$var$normalizeRoleNameFromCtor(name) {
    if (name.includes("System")) return "system";
    if (name.includes("Human")) return "user";
    if (name.includes("AI") || name.includes("Assistant")) return "assistant";
    if (name.includes("Function")) return "function";
    if (name.includes("Tool")) return "tool";
    return "user";
}
function $e65125157f68cd9d$var$getInvocationParams(tags) {
    if (!tags || Array.isArray(tags)) return void 0;
    return tags.invocation_params;
}
function $e65125157f68cd9d$var$normalizeLangChainMessages(messages) {
    return messages.map((message)=>{
        const maybeGetType = message._getType;
        if (typeof maybeGetType === "function") {
            const messageType = maybeGetType.call(message);
            return {
                role: $e65125157f68cd9d$var$normalizeMessageRole(messageType),
                content: $e65125157f68cd9d$var$normalizeContent(message.content)
            };
        }
        if (message.lc === 1 && message.kwargs) {
            const id = message.id;
            const messageType = Array.isArray(id) && id.length > 0 ? id[id.length - 1] : "";
            const role = typeof messageType === "string" ? $e65125157f68cd9d$var$normalizeRoleNameFromCtor(messageType) : "user";
            return {
                role: $e65125157f68cd9d$var$normalizeMessageRole(role),
                content: $e65125157f68cd9d$var$normalizeContent(message.kwargs?.content)
            };
        }
        if (message.type) {
            const role = String(message.type).toLowerCase();
            return {
                role: $e65125157f68cd9d$var$normalizeMessageRole(role),
                content: $e65125157f68cd9d$var$normalizeContent(message.content)
            };
        }
        if (message.role) return {
            role: $e65125157f68cd9d$var$normalizeMessageRole(String(message.role)),
            content: $e65125157f68cd9d$var$normalizeContent(message.content)
        };
        const ctor = message.constructor?.name;
        if (ctor && ctor !== "Object") return {
            role: $e65125157f68cd9d$var$normalizeMessageRole($e65125157f68cd9d$var$normalizeRoleNameFromCtor(ctor)),
            content: $e65125157f68cd9d$var$normalizeContent(message.content)
        };
        return {
            role: "user",
            content: $e65125157f68cd9d$var$normalizeContent(message.content)
        };
    });
}
function $e65125157f68cd9d$var$extractCommonRequestAttributes(serialized, invocationParams, langSmithMetadata) {
    const attrs = {};
    const kwargs = "kwargs" in serialized ? serialized.kwargs : void 0;
    const temperature = invocationParams?.temperature ?? langSmithMetadata?.ls_temperature ?? kwargs?.temperature;
    $e65125157f68cd9d$var$setNumberIfDefined(attrs, $njxh1.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE, temperature);
    const maxTokens = invocationParams?.max_tokens ?? langSmithMetadata?.ls_max_tokens ?? kwargs?.max_tokens;
    $e65125157f68cd9d$var$setNumberIfDefined(attrs, $njxh1.GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE, maxTokens);
    const topP = invocationParams?.top_p ?? kwargs?.top_p;
    $e65125157f68cd9d$var$setNumberIfDefined(attrs, $njxh1.GEN_AI_REQUEST_TOP_P_ATTRIBUTE, topP);
    const frequencyPenalty = invocationParams?.frequency_penalty;
    $e65125157f68cd9d$var$setNumberIfDefined(attrs, $njxh1.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE, frequencyPenalty);
    const presencePenalty = invocationParams?.presence_penalty;
    $e65125157f68cd9d$var$setNumberIfDefined(attrs, $njxh1.GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE, presencePenalty);
    if (invocationParams && "stream" in invocationParams) $e65125157f68cd9d$var$setIfDefined(attrs, $njxh1.GEN_AI_REQUEST_STREAM_ATTRIBUTE, Boolean(invocationParams.stream));
    return attrs;
}
function $e65125157f68cd9d$var$baseRequestAttributes(system, modelName, serialized, invocationParams, langSmithMetadata) {
    return {
        [$njxh1.GEN_AI_SYSTEM_ATTRIBUTE]: $e65125157f68cd9d$var$asString(system ?? "langchain"),
        [$njxh1.GEN_AI_OPERATION_NAME_ATTRIBUTE]: "chat",
        [$njxh1.GEN_AI_REQUEST_MODEL_ATTRIBUTE]: $e65125157f68cd9d$var$asString(modelName),
        [$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $7cQmT.LANGCHAIN_ORIGIN,
        ...$e65125157f68cd9d$var$extractCommonRequestAttributes(serialized, invocationParams, langSmithMetadata)
    };
}
function $e65125157f68cd9d$var$extractLLMRequestAttributes(llm, prompts, recordInputs, enableTruncation, invocationParams, langSmithMetadata) {
    const system = langSmithMetadata?.ls_provider;
    const modelName = invocationParams?.model ?? langSmithMetadata?.ls_model_name ?? "unknown";
    const attrs = $e65125157f68cd9d$var$baseRequestAttributes(system, modelName, llm, invocationParams, langSmithMetadata);
    if (recordInputs && Array.isArray(prompts) && prompts.length > 0) {
        $e65125157f68cd9d$var$setIfDefined(attrs, $njxh1.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE, prompts.length);
        const messages = prompts.map((p)=>({
                role: "user",
                content: p
            }));
        $e65125157f68cd9d$var$setIfDefined(attrs, $njxh1.GEN_AI_INPUT_MESSAGES_ATTRIBUTE, enableTruncation ? $8rGYq.getTruncatedJsonString(messages) : $8rGYq.getJsonString(messages));
    }
    return attrs;
}
function $e65125157f68cd9d$var$extractChatModelRequestAttributes(llm, langChainMessages, recordInputs, enableTruncation, invocationParams, langSmithMetadata) {
    const system = langSmithMetadata?.ls_provider ?? llm.id?.[2];
    const modelName = invocationParams?.model ?? langSmithMetadata?.ls_model_name ?? "unknown";
    const attrs = $e65125157f68cd9d$var$baseRequestAttributes(system, modelName, llm, invocationParams, langSmithMetadata);
    if (recordInputs && Array.isArray(langChainMessages) && langChainMessages.length > 0) {
        const normalized = $e65125157f68cd9d$var$normalizeLangChainMessages(langChainMessages.flat());
        const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $8rGYq.extractSystemInstructions(normalized);
        if (systemInstructions) $e65125157f68cd9d$var$setIfDefined(attrs, $njxh1.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
        const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
        $e65125157f68cd9d$var$setIfDefined(attrs, $njxh1.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE, filteredLength);
        $e65125157f68cd9d$var$setIfDefined(attrs, $njxh1.GEN_AI_INPUT_MESSAGES_ATTRIBUTE, enableTruncation ? $8rGYq.getTruncatedJsonString(filteredMessages) : $8rGYq.getJsonString(filteredMessages));
    }
    return attrs;
}
function $e65125157f68cd9d$var$addToolCallsAttributes(generations, attrs) {
    const toolCalls = [];
    const flatGenerations = generations.flat();
    for (const gen of flatGenerations){
        const msg = gen.message;
        const msgToolCalls = msg?.tool_calls;
        if (Array.isArray(msgToolCalls) && msgToolCalls.length > 0) toolCalls.push(...msgToolCalls);
        else {
            const content = gen.message?.content;
            if (Array.isArray(content)) for (const item of content){
                const t = item;
                if (t.type === "tool_use") toolCalls.push(t);
            }
        }
    }
    if (toolCalls.length > 0) $e65125157f68cd9d$var$setIfDefined(attrs, $njxh1.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE, $e65125157f68cd9d$var$asString(toolCalls));
}
function $e65125157f68cd9d$var$addTokenUsageAttributes(llmOutput, attrs) {
    if (!llmOutput) return;
    const tokenUsage = llmOutput.tokenUsage;
    const anthropicUsage = llmOutput.usage;
    if (tokenUsage) {
        $e65125157f68cd9d$var$setNumberIfDefined(attrs, $njxh1.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE, tokenUsage.promptTokens);
        $e65125157f68cd9d$var$setNumberIfDefined(attrs, $njxh1.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE, tokenUsage.completionTokens);
        $e65125157f68cd9d$var$setNumberIfDefined(attrs, $njxh1.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE, tokenUsage.totalTokens);
    } else if (anthropicUsage) {
        $e65125157f68cd9d$var$setNumberIfDefined(attrs, $njxh1.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE, anthropicUsage.input_tokens);
        $e65125157f68cd9d$var$setNumberIfDefined(attrs, $njxh1.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE, anthropicUsage.output_tokens);
        const input = Number(anthropicUsage.input_tokens);
        const output = Number(anthropicUsage.output_tokens);
        const total = (Number.isNaN(input) ? 0 : input) + (Number.isNaN(output) ? 0 : output);
        if (total > 0) $e65125157f68cd9d$var$setNumberIfDefined(attrs, $njxh1.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE, total);
        if (anthropicUsage.cache_creation_input_tokens !== void 0) $e65125157f68cd9d$var$setNumberIfDefined(attrs, $njxh1.GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS_ATTRIBUTE, anthropicUsage.cache_creation_input_tokens);
        if (anthropicUsage.cache_read_input_tokens !== void 0) $e65125157f68cd9d$var$setNumberIfDefined(attrs, $njxh1.GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS_ATTRIBUTE, anthropicUsage.cache_read_input_tokens);
    }
}
function $e65125157f68cd9d$var$extractLlmResponseAttributes(llmResult, recordOutputs) {
    if (!llmResult) return;
    const attrs = {};
    if (Array.isArray(llmResult.generations)) {
        const finishReasons = llmResult.generations.flat().map((g)=>{
            if (g.generationInfo?.finish_reason) return g.generationInfo.finish_reason;
            if (g.generation_info?.finish_reason) return g.generation_info.finish_reason;
            return null;
        }).filter((r)=>typeof r === "string");
        if (finishReasons.length > 0) $e65125157f68cd9d$var$setIfDefined(attrs, $njxh1.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE, $e65125157f68cd9d$var$asString(finishReasons));
        $e65125157f68cd9d$var$addToolCallsAttributes(llmResult.generations, attrs);
        if (recordOutputs) {
            const texts = llmResult.generations.flat().map((gen)=>gen.text ?? gen.message?.content).filter((t)=>typeof t === "string");
            if (texts.length > 0) $e65125157f68cd9d$var$setIfDefined(attrs, $njxh1.GEN_AI_RESPONSE_TEXT_ATTRIBUTE, $e65125157f68cd9d$var$asString(texts));
        }
    }
    $e65125157f68cd9d$var$addTokenUsageAttributes(llmResult.llmOutput, attrs);
    const llmOutput = llmResult.llmOutput;
    const firstGeneration = llmResult.generations?.[0]?.[0];
    const v1Message = firstGeneration?.message;
    const modelName = llmOutput?.model_name ?? llmOutput?.model ?? v1Message?.response_metadata?.model_name;
    if (modelName) $e65125157f68cd9d$var$setIfDefined(attrs, $njxh1.GEN_AI_RESPONSE_MODEL_ATTRIBUTE, modelName);
    const responseId = llmOutput?.id ?? v1Message?.id;
    if (responseId) $e65125157f68cd9d$var$setIfDefined(attrs, $njxh1.GEN_AI_RESPONSE_ID_ATTRIBUTE, responseId);
    const stopReason = llmOutput?.stop_reason ?? v1Message?.response_metadata?.finish_reason;
    if (stopReason) $e65125157f68cd9d$var$setIfDefined(attrs, $njxh1.GEN_AI_RESPONSE_STOP_REASON_ATTRIBUTE, $e65125157f68cd9d$var$asString(stopReason));
    return attrs;
}
function $e65125157f68cd9d$var$getAgentNameFromMetadata(metadata) {
    const attrs = {};
    const agentName = metadata?.lc_agent_name;
    if (typeof agentName === "string") attrs[$njxh1.GEN_AI_AGENT_NAME_ATTRIBUTE] = agentName;
    return attrs;
}
function $e65125157f68cd9d$var$extractToolDefinitions(extraParams) {
    const tools = extraParams?.invocation_params?.tools ?? extraParams?.options?.tools;
    if (!Array.isArray(tools) || tools.length === 0) return void 0;
    const toolDefs = tools.map((tool)=>{
        const fn = tool.function;
        return {
            type: "function",
            name: tool.name ?? fn?.name ?? "",
            description: tool.description ?? fn?.description
        };
    });
    return JSON.stringify(toolDefs);
}
function $e65125157f68cd9d$var$isCallbackManager(value) {
    if (!value || typeof value !== "object") return false;
    const candidate = value;
    return typeof candidate.addHandler === "function" && typeof candidate.copy === "function";
}
function $e65125157f68cd9d$var$isSentryHandler(handler) {
    return typeof handler === "object" && handler?.name === "SentryCallbackHandler";
}
function $e65125157f68cd9d$var$containsSentryHandler(handlers) {
    return handlers.some($e65125157f68cd9d$var$isSentryHandler);
}
function $e65125157f68cd9d$var$_INTERNAL_mergeLangChainCallbackHandler(existing, sentryHandler) {
    if (!existing) return [
        sentryHandler
    ];
    if ($e65125157f68cd9d$var$isCallbackManager(existing)) {
        if ($e65125157f68cd9d$var$containsSentryHandler(existing.handlers ?? [])) return existing;
        const copied = existing.copy();
        copied.addHandler(sentryHandler, true);
        return copied;
    }
    const handlers = Array.isArray(existing) ? existing : [
        existing
    ];
    if ($e65125157f68cd9d$var$containsSentryHandler(handlers)) return existing;
    return [
        ...handlers,
        sentryHandler
    ];
}
module.exports._INTERNAL_mergeLangChainCallbackHandler = $e65125157f68cd9d$var$_INTERNAL_mergeLangChainCallbackHandler;
module.exports.extractChatModelRequestAttributes = $e65125157f68cd9d$var$extractChatModelRequestAttributes;
module.exports.extractLLMRequestAttributes = $e65125157f68cd9d$var$extractLLMRequestAttributes;
module.exports.extractLlmResponseAttributes = $e65125157f68cd9d$var$extractLlmResponseAttributes;
module.exports.extractToolDefinitions = $e65125157f68cd9d$var$extractToolDefinitions;
module.exports.getAgentNameFromMetadata = $e65125157f68cd9d$var$getAgentNameFromMetadata;
module.exports.getInvocationParams = $e65125157f68cd9d$var$getInvocationParams;
module.exports.normalizeLangChainMessages = $e65125157f68cd9d$var$normalizeLangChainMessages;

});


parcelRegister("iYNsH", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8txOP = parcelRequire("8txOP");

var $3dwiN = parcelRequire("3dwiN");

var $9X7hl = parcelRequire("9X7hl");

var $4Ae9I = parcelRequire("4Ae9I");

var $njxh1 = parcelRequire("njxh1");

var $8rGYq = parcelRequire("8rGYq");

var $i1Lan = parcelRequire("i1Lan");

var $jLYfK = parcelRequire("jLYfK");

var $26DyO = parcelRequire("26DyO");

var $gCsqa = parcelRequire("gCsqa");
let $dd1432b51ec9a419$var$_insideCreateReactAgent = false;
const $dd1432b51ec9a419$var$SENTRY_PATCHED = "__sentry_patched__";
function $dd1432b51ec9a419$var$instrumentStateGraphCompile(originalCompile, options) {
    if (Object.prototype.hasOwnProperty.call(originalCompile, $dd1432b51ec9a419$var$SENTRY_PATCHED)) return originalCompile;
    const sentryHandler = $i1Lan.createLangChainCallbackHandler(options);
    const wrapped = new Proxy(originalCompile, {
        apply (target, thisArg, args) {
            if ($dd1432b51ec9a419$var$_insideCreateReactAgent) return Reflect.apply(target, thisArg, args);
            return $4Ae9I.startSpan({
                op: "gen_ai.create_agent",
                name: "create_agent",
                attributes: {
                    [$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $26DyO.LANGGRAPH_ORIGIN,
                    [$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "gen_ai.create_agent",
                    [$njxh1.GEN_AI_OPERATION_NAME_ATTRIBUTE]: "create_agent"
                }
            }, (span)=>{
                try {
                    const compiledGraph = Reflect.apply(target, thisArg, args);
                    const compileOptions = args.length > 0 ? args[0] : {};
                    if (compileOptions?.name && typeof compileOptions.name === "string") {
                        span.setAttribute($njxh1.GEN_AI_AGENT_NAME_ATTRIBUTE, compileOptions.name);
                        span.updateName(`create_agent ${compileOptions.name}`);
                    }
                    const originalInvoke = compiledGraph.invoke;
                    if (originalInvoke && typeof originalInvoke === "function") compiledGraph.invoke = $dd1432b51ec9a419$var$instrumentCompiledGraphInvoke(originalInvoke.bind(compiledGraph), compiledGraph, compileOptions, options, void 0, sentryHandler);
                    return compiledGraph;
                } catch (error) {
                    span.setStatus({
                        code: $9X7hl.SPAN_STATUS_ERROR,
                        message: "internal_error"
                    });
                    $8txOP.captureException(error, {
                        mechanism: {
                            handled: false,
                            type: "auto.ai.langgraph.error"
                        }
                    });
                    throw error;
                }
            });
        }
    });
    Object.defineProperty(wrapped, $dd1432b51ec9a419$var$SENTRY_PATCHED, {
        value: true,
        enumerable: false
    });
    return wrapped;
}
function $dd1432b51ec9a419$var$instrumentCompiledGraphInvoke(originalInvoke, graphInstance, compileOptions, options, llm, sentryCallbackHandler) {
    return new Proxy(originalInvoke, {
        apply (target, thisArg, args) {
            const modelName = llm?.modelName ?? llm?.model;
            return $4Ae9I.startSpan({
                op: "gen_ai.invoke_agent",
                name: "invoke_agent",
                attributes: {
                    [$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $26DyO.LANGGRAPH_ORIGIN,
                    [$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_OP]: $njxh1.GEN_AI_INVOKE_AGENT_OPERATION_ATTRIBUTE,
                    [$njxh1.GEN_AI_OPERATION_NAME_ATTRIBUTE]: "invoke_agent"
                }
            }, async (span)=>{
                try {
                    const graphName = compileOptions?.name;
                    if (graphName && typeof graphName === "string") {
                        span.setAttribute($njxh1.GEN_AI_PIPELINE_NAME_ATTRIBUTE, graphName);
                        span.setAttribute($njxh1.GEN_AI_AGENT_NAME_ATTRIBUTE, graphName);
                        span.updateName(`invoke_agent ${graphName}`);
                    }
                    if (modelName) span.setAttribute($njxh1.GEN_AI_REQUEST_MODEL_ATTRIBUTE, modelName);
                    const config = args.length > 1 ? args[1] : void 0;
                    const configurable = config?.configurable;
                    const threadId = configurable?.thread_id;
                    if (threadId && typeof threadId === "string") span.setAttribute($njxh1.GEN_AI_CONVERSATION_ID_ATTRIBUTE, threadId);
                    if (sentryCallbackHandler) {
                        const invokeConfig = args[1] ?? {};
                        args[1] = invokeConfig;
                        const existingMetadata = invokeConfig.metadata ?? {};
                        invokeConfig.metadata = {
                            ...existingMetadata,
                            __sentry_langgraph__: true,
                            ...typeof graphName === "string" ? {
                                lc_agent_name: graphName
                            } : {}
                        };
                        invokeConfig.callbacks = $jLYfK._INTERNAL_mergeLangChainCallbackHandler(invokeConfig.callbacks, sentryCallbackHandler);
                    }
                    const tools = $gCsqa.extractToolsFromCompiledGraph(graphInstance);
                    if (tools) span.setAttribute($njxh1.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE, JSON.stringify(tools));
                    const recordInputs = options.recordInputs;
                    const recordOutputs = options.recordOutputs;
                    const inputMessages = args.length > 0 ? args[0]?.messages ?? [] : [];
                    if (inputMessages && recordInputs) {
                        const normalizedMessages = $jLYfK.normalizeLangChainMessages(inputMessages);
                        const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $8rGYq.extractSystemInstructions(normalizedMessages);
                        if (systemInstructions) span.setAttribute($njxh1.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
                        const enableTruncation = $8rGYq.shouldEnableTruncation(options.enableTruncation);
                        const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
                        span.setAttributes({
                            [$njxh1.GEN_AI_INPUT_MESSAGES_ATTRIBUTE]: enableTruncation ? $8rGYq.getTruncatedJsonString(filteredMessages) : $8rGYq.getJsonString(filteredMessages),
                            [$njxh1.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE]: filteredLength
                        });
                    }
                    const result = await Reflect.apply(target, thisArg, args);
                    if (recordOutputs) $gCsqa.setResponseAttributes(span, inputMessages ?? null, result);
                    return result;
                } catch (error) {
                    span.setStatus({
                        code: $9X7hl.SPAN_STATUS_ERROR,
                        message: "internal_error"
                    });
                    $8txOP.captureException(error, {
                        mechanism: {
                            handled: false,
                            type: "auto.ai.langgraph.error"
                        }
                    });
                    throw error;
                }
            });
        }
    });
}
function $dd1432b51ec9a419$var$instrumentCreateReactAgent(originalCreateReactAgent, options) {
    if (Object.prototype.hasOwnProperty.call(originalCreateReactAgent, $dd1432b51ec9a419$var$SENTRY_PATCHED)) return originalCreateReactAgent;
    const resolvedOptions = $8rGYq.resolveAIRecordingOptions(options);
    const sentryHandler = $i1Lan.createLangChainCallbackHandler(resolvedOptions);
    const wrapped = new Proxy(originalCreateReactAgent, {
        apply (target, thisArg, args) {
            const llm = $gCsqa.extractLLMFromParams(args);
            const agentName = $gCsqa.extractAgentNameFromParams(args);
            const params = args[0];
            if (params && Array.isArray(params.tools) && params.tools.length > 0) $gCsqa.wrapToolsWithSpans(params.tools, resolvedOptions, agentName ?? void 0);
            $dd1432b51ec9a419$var$_insideCreateReactAgent = true;
            let compiledGraph;
            try {
                compiledGraph = Reflect.apply(target, thisArg, args);
            } finally{
                $dd1432b51ec9a419$var$_insideCreateReactAgent = false;
            }
            const originalInvoke = compiledGraph.invoke;
            if (originalInvoke && typeof originalInvoke === "function") {
                const compileOptions = {};
                if (agentName) compileOptions.name = agentName;
                compiledGraph.invoke = $dd1432b51ec9a419$var$instrumentCompiledGraphInvoke(originalInvoke.bind(compiledGraph), compiledGraph, compileOptions, resolvedOptions, llm, sentryHandler);
            }
            return compiledGraph;
        }
    });
    Object.defineProperty(wrapped, $dd1432b51ec9a419$var$SENTRY_PATCHED, {
        value: true,
        enumerable: false
    });
    return wrapped;
}
function $dd1432b51ec9a419$var$instrumentLangGraph(stateGraph, options) {
    stateGraph.compile = $dd1432b51ec9a419$var$instrumentStateGraphCompile(stateGraph.compile, $8rGYq.resolveAIRecordingOptions(options));
    return stateGraph;
}
module.exports.instrumentCreateReactAgent = $dd1432b51ec9a419$var$instrumentCreateReactAgent;
module.exports.instrumentLangGraph = $dd1432b51ec9a419$var$instrumentLangGraph;
module.exports.instrumentStateGraphCompile = $dd1432b51ec9a419$var$instrumentStateGraphCompile;

});
parcelRegister("26DyO", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $188ad42e1a6787fb$var$LANGGRAPH_INTEGRATION_NAME = "LangGraph";
const $188ad42e1a6787fb$var$LANGGRAPH_ORIGIN = "auto.ai.langgraph";
module.exports.LANGGRAPH_INTEGRATION_NAME = $188ad42e1a6787fb$var$LANGGRAPH_INTEGRATION_NAME;
module.exports.LANGGRAPH_ORIGIN = $188ad42e1a6787fb$var$LANGGRAPH_ORIGIN;

});

parcelRegister("gCsqa", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8txOP = parcelRequire("8txOP");

var $3dwiN = parcelRequire("3dwiN");

var $9X7hl = parcelRequire("9X7hl");

var $4Ae9I = parcelRequire("4Ae9I");

var $njxh1 = parcelRequire("njxh1");

var $jLYfK = parcelRequire("jLYfK");

var $26DyO = parcelRequire("26DyO");
function $c1963dc37f0466b9$var$extractLLMFromParams(args) {
    const arg = args[0];
    if (typeof arg !== "object" || !arg || !("llm" in arg) || !arg.llm || typeof arg.llm !== "object") return null;
    const llm = arg.llm;
    if (typeof llm.modelName !== "string" && typeof llm.model !== "string") return null;
    return llm;
}
function $c1963dc37f0466b9$var$extractAgentNameFromParams(args) {
    const arg = args[0];
    if (typeof arg === "object" && !!arg && "name" in arg && typeof arg.name === "string") return arg.name;
    return null;
}
function $c1963dc37f0466b9$var$wrapToolsWithSpans(tools, options, agentName) {
    const SENTRY_WRAPPED = "__sentry_tool_wrapped__";
    for (const tool of tools){
        if (!tool || typeof tool !== "object") continue;
        const t = tool;
        const originalInvoke = t.invoke;
        if (typeof originalInvoke !== "function" || Object.prototype.hasOwnProperty.call(t, SENTRY_WRAPPED)) continue;
        const toolName = typeof t.name === "string" ? t.name : "unknown_tool";
        const toolDescription = typeof t.description === "string" ? t.description : void 0;
        const wrappedInvoke = new Proxy(originalInvoke, {
            apply (target, thisArg, args) {
                const spanAttributes = {
                    [$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $26DyO.LANGGRAPH_ORIGIN,
                    [$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_OP]: $njxh1.GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE,
                    [$njxh1.GEN_AI_OPERATION_NAME_ATTRIBUTE]: "execute_tool",
                    [$njxh1.GEN_AI_TOOL_NAME_ATTRIBUTE]: toolName,
                    [$njxh1.GEN_AI_TOOL_TYPE_ATTRIBUTE]: "function"
                };
                const callConfig = args[1];
                const callAgentName = callConfig?.metadata?.lc_agent_name ?? agentName;
                if (typeof callAgentName === "string") spanAttributes[$njxh1.GEN_AI_AGENT_NAME_ATTRIBUTE] = callAgentName;
                if (toolDescription) spanAttributes[$njxh1.GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE] = toolDescription;
                const input = args[0];
                if (typeof input === "object" && !!input) {
                    if ("id" in input && typeof input.id === "string") spanAttributes[$njxh1.GEN_AI_TOOL_CALL_ID_ATTRIBUTE] = input.id;
                    if (options.recordInputs) {
                        const toolArgs = "args" in input && typeof input.args === "object" ? input.args : input;
                        try {
                            spanAttributes[$njxh1.GEN_AI_TOOL_INPUT_ATTRIBUTE] = JSON.stringify(toolArgs);
                        } catch  {}
                    }
                }
                return $4Ae9I.startSpan({
                    op: $njxh1.GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE,
                    name: `execute_tool ${toolName}`,
                    attributes: spanAttributes
                }, async (span)=>{
                    try {
                        const result = await Reflect.apply(target, thisArg, args);
                        if (options.recordOutputs) try {
                            const resultObj = result;
                            const content = resultObj && typeof resultObj === "object" && "content" in resultObj ? resultObj.content : result;
                            span.setAttribute($njxh1.GEN_AI_TOOL_OUTPUT_ATTRIBUTE, typeof content === "string" ? content : JSON.stringify(content));
                        } catch  {}
                        return result;
                    } catch (error) {
                        span.setStatus({
                            code: $9X7hl.SPAN_STATUS_ERROR,
                            message: "internal_error"
                        });
                        $8txOP.captureException(error, {
                            mechanism: {
                                handled: false,
                                type: "auto.ai.langgraph.error"
                            }
                        });
                        throw error;
                    }
                });
            }
        });
        t.invoke = wrappedInvoke;
        Object.defineProperty(t, SENTRY_WRAPPED, {
            value: true,
            enumerable: false
        });
    }
    return tools;
}
function $c1963dc37f0466b9$var$extractToolCalls(messages) {
    if (!messages || messages.length === 0) return null;
    const toolCalls = [];
    for (const message of messages)if (message && typeof message === "object") {
        const msgToolCalls = message.tool_calls;
        if (msgToolCalls && Array.isArray(msgToolCalls)) toolCalls.push(...msgToolCalls);
    }
    return toolCalls.length > 0 ? toolCalls : null;
}
function $c1963dc37f0466b9$var$extractTokenUsageFromMessage(message) {
    const msg = message;
    let inputTokens = 0;
    let outputTokens = 0;
    let totalTokens = 0;
    if (msg.usage_metadata && typeof msg.usage_metadata === "object") {
        const usage = msg.usage_metadata;
        if (typeof usage.input_tokens === "number") inputTokens = usage.input_tokens;
        if (typeof usage.output_tokens === "number") outputTokens = usage.output_tokens;
        if (typeof usage.total_tokens === "number") totalTokens = usage.total_tokens;
        return {
            inputTokens: inputTokens,
            outputTokens: outputTokens,
            totalTokens: totalTokens
        };
    }
    if (msg.response_metadata && typeof msg.response_metadata === "object") {
        const metadata = msg.response_metadata;
        if (metadata.tokenUsage && typeof metadata.tokenUsage === "object") {
            const tokenUsage = metadata.tokenUsage;
            if (typeof tokenUsage.promptTokens === "number") inputTokens = tokenUsage.promptTokens;
            if (typeof tokenUsage.completionTokens === "number") outputTokens = tokenUsage.completionTokens;
            if (typeof tokenUsage.totalTokens === "number") totalTokens = tokenUsage.totalTokens;
        }
    }
    return {
        inputTokens: inputTokens,
        outputTokens: outputTokens,
        totalTokens: totalTokens
    };
}
function $c1963dc37f0466b9$var$extractModelMetadata(span, message) {
    const msg = message;
    if (msg.response_metadata && typeof msg.response_metadata === "object") {
        const metadata = msg.response_metadata;
        if (metadata.model_name && typeof metadata.model_name === "string") span.setAttribute($njxh1.GEN_AI_RESPONSE_MODEL_ATTRIBUTE, metadata.model_name);
        if (metadata.finish_reason && typeof metadata.finish_reason === "string") span.setAttribute($njxh1.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE, [
            metadata.finish_reason
        ]);
    }
}
function $c1963dc37f0466b9$var$extractToolsFromCompiledGraph(compiledGraph) {
    if (!compiledGraph.builder?.nodes?.tools?.runnable?.tools) return null;
    const tools = compiledGraph.builder?.nodes?.tools?.runnable?.tools;
    if (!tools || !Array.isArray(tools) || tools.length === 0) return null;
    return tools.map((tool)=>({
            name: tool.lc_kwargs?.name,
            description: tool.lc_kwargs?.description,
            schema: tool.lc_kwargs?.schema
        }));
}
function $c1963dc37f0466b9$var$setResponseAttributes(span, inputMessages, result) {
    const resultObj = result;
    const outputMessages = resultObj?.messages;
    if (!outputMessages || !Array.isArray(outputMessages)) return;
    const inputCount = inputMessages?.length ?? 0;
    const newMessages = outputMessages.length > inputCount ? outputMessages.slice(inputCount) : [];
    if (newMessages.length === 0) return;
    const toolCalls = $c1963dc37f0466b9$var$extractToolCalls(newMessages);
    if (toolCalls) span.setAttribute($njxh1.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE, JSON.stringify(toolCalls));
    const normalizedNewMessages = $jLYfK.normalizeLangChainMessages(newMessages);
    span.setAttribute($njxh1.GEN_AI_RESPONSE_TEXT_ATTRIBUTE, JSON.stringify(normalizedNewMessages));
    let totalInputTokens = 0;
    let totalOutputTokens = 0;
    let totalTokens = 0;
    for (const message of newMessages){
        const tokens = $c1963dc37f0466b9$var$extractTokenUsageFromMessage(message);
        totalInputTokens += tokens.inputTokens;
        totalOutputTokens += tokens.outputTokens;
        totalTokens += tokens.totalTokens;
        $c1963dc37f0466b9$var$extractModelMetadata(span, message);
    }
    if (totalInputTokens > 0) span.setAttribute($njxh1.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE, totalInputTokens);
    if (totalOutputTokens > 0) span.setAttribute($njxh1.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE, totalOutputTokens);
    if (totalTokens > 0) span.setAttribute($njxh1.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE, totalTokens);
}
module.exports.extractAgentNameFromParams = $c1963dc37f0466b9$var$extractAgentNameFromParams;
module.exports.extractLLMFromParams = $c1963dc37f0466b9$var$extractLLMFromParams;
module.exports.extractModelMetadata = $c1963dc37f0466b9$var$extractModelMetadata;
module.exports.extractTokenUsageFromMessage = $c1963dc37f0466b9$var$extractTokenUsageFromMessage;
module.exports.extractToolCalls = $c1963dc37f0466b9$var$extractToolCalls;
module.exports.extractToolsFromCompiledGraph = $c1963dc37f0466b9$var$extractToolsFromCompiledGraph;
module.exports.setResponseAttributes = $c1963dc37f0466b9$var$setResponseAttributes;
module.exports.wrapToolsWithSpans = $c1963dc37f0466b9$var$wrapToolsWithSpans;

});


parcelRegister("9wTeJ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $jCjMv = parcelRequire("jCjMv");

var $jix5p = parcelRequire("jix5p");

var $f6Xap = parcelRequire("f6Xap");

var $dkd4c = parcelRequire("dkd4c");

var $gimDc = parcelRequire("gimDc");

var $59ygG = parcelRequire("59ygG");
const $6f01f31291c677b1$var$MAX_SPANS_PER_ENVELOPE = 1e3;
const $6f01f31291c677b1$var$MAX_TRACE_WEIGHT_IN_BYTES = 5e6;
class $6f01f31291c677b1$var$SpanBuffer {
    constructor(client, options){
        this._traceBuckets = /* @__PURE__ */ new Map();
        this._client = client;
        const { maxSpanLimit: maxSpanLimit, flushInterval: flushInterval, maxTraceWeightInBytes: maxTraceWeightInBytes } = options ?? {};
        this._maxSpanLimit = maxSpanLimit && maxSpanLimit > 0 && maxSpanLimit <= $6f01f31291c677b1$var$MAX_SPANS_PER_ENVELOPE ? maxSpanLimit : $6f01f31291c677b1$var$MAX_SPANS_PER_ENVELOPE;
        this._flushInterval = flushInterval && flushInterval > 0 ? flushInterval : 5e3;
        this._maxTraceWeight = maxTraceWeightInBytes && maxTraceWeightInBytes > 0 ? maxTraceWeightInBytes : $6f01f31291c677b1$var$MAX_TRACE_WEIGHT_IN_BYTES;
        this._client.on("flush", ()=>{
            this.drain();
        });
        this._client.on("close", ()=>{
            this._traceBuckets.forEach((bucket)=>{
                clearTimeout(bucket.timeout);
            });
            this._traceBuckets.clear();
        });
    }
    /**
   * Add a span to the buffer.
   */ add(spanJSON) {
        const traceId = spanJSON.trace_id;
        let bucket = this._traceBuckets.get(traceId);
        if (!bucket) {
            bucket = {
                spans: /* @__PURE__ */ new Set(),
                size: 0,
                timeout: $f6Xap.safeUnref(setTimeout(()=>{
                    this.flush(traceId);
                }, this._flushInterval))
            };
            this._traceBuckets.set(traceId, bucket);
        }
        bucket.spans.add(spanJSON);
        bucket.size += $59ygG.estimateSerializedSpanSizeInBytes(spanJSON);
        if (bucket.spans.size >= this._maxSpanLimit || bucket.size >= this._maxTraceWeight) this.flush(traceId);
    }
    /**
   * Drain and flush all buffered traces.
   */ drain() {
        if (!this._traceBuckets.size) return;
        $jCjMv.DEBUG_BUILD && $jix5p.debug.log(`Flushing span tree map with ${this._traceBuckets.size} traces`);
        this._traceBuckets.forEach((_, traceId)=>{
            this.flush(traceId);
        });
    }
    /**
   * Flush spans of a specific trace.
   * In contrast to {@link SpanBuffer.drain}, this method does not flush all traces, but only the one with the given traceId.
   */ flush(traceId) {
        const bucket = this._traceBuckets.get(traceId);
        if (!bucket) return;
        if (!bucket.spans.size) {
            this._removeTrace(traceId);
            return;
        }
        const spans = Array.from(bucket.spans);
        const segmentSpan = spans[0]?._segmentSpan;
        if (!segmentSpan) {
            $jCjMv.DEBUG_BUILD && $jix5p.debug.warn("No segment span reference found on span JSON, cannot compute DSC");
            this._removeTrace(traceId);
            return;
        }
        const dsc = $dkd4c.getDynamicSamplingContextFromSpan(segmentSpan);
        const cleanedSpans = spans.map((spanJSON)=>{
            const { _segmentSpan: _segmentSpan, ...cleanSpanJSON } = spanJSON;
            return cleanSpanJSON;
        });
        const envelope$1 = $gimDc.createStreamedSpanEnvelope(cleanedSpans, dsc, this._client);
        $jCjMv.DEBUG_BUILD && $jix5p.debug.log(`Sending span envelope for trace ${traceId} with ${cleanedSpans.length} spans`);
        this._client.sendEnvelope(envelope$1).then(null, (reason)=>{
            $jCjMv.DEBUG_BUILD && $jix5p.debug.error("Error while sending streamed span envelope:", reason);
        });
        this._removeTrace(traceId);
    }
    _removeTrace(traceId) {
        const bucket = this._traceBuckets.get(traceId);
        if (bucket) clearTimeout(bucket.timeout);
        this._traceBuckets.delete(traceId);
    }
}
module.exports.SpanBuffer = $6f01f31291c677b1$var$SpanBuffer;

});
parcelRegister("gimDc", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $jypZc = parcelRequire("jypZc");

var $5fqIb = parcelRequire("5fqIb");

var $9Vsrl = parcelRequire("9Vsrl");
function $bdcfe1de6aca6f6d$var$createStreamedSpanEnvelope(serializedSpans, dsc, client) {
    const options = client.getOptions();
    const dsn$1 = client.getDsn();
    const tunnel = options.tunnel;
    const sdk = $5fqIb.getSdkMetadataForEnvelopeHeader(options._metadata);
    const headers = {
        sent_at: /* @__PURE__ */ new Date().toISOString(),
        ...$bdcfe1de6aca6f6d$var$dscHasRequiredProps(dsc) && {
            trace: dsc
        },
        ...sdk && {
            sdk: sdk
        },
        ...!!tunnel && dsn$1 && {
            dsn: $jypZc.dsnToString(dsn$1)
        }
    };
    const inferSetting = client.getDataCollectionOptions().userInfo ? "auto" : "never";
    const spanContainer = [
        {
            type: "span",
            item_count: serializedSpans.length,
            content_type: "application/vnd.sentry.items.span.v2+json"
        },
        {
            version: 2,
            ...$9Vsrl.isBrowser() && {
                ingest_settings: {
                    infer_ip: inferSetting,
                    infer_user_agent: inferSetting
                }
            },
            items: serializedSpans
        }
    ];
    return $5fqIb.createEnvelope(headers, [
        spanContainer
    ]);
}
function $bdcfe1de6aca6f6d$var$dscHasRequiredProps(dsc) {
    return !!dsc.trace_id && !!dsc.public_key;
}
module.exports.createStreamedSpanEnvelope = $bdcfe1de6aca6f6d$var$createStreamedSpanEnvelope;

});

parcelRegister("59ygG", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $f8fWp = parcelRequire("f8fWp");
function $3c085ff49e64d7e3$var$estimateSerializedSpanSizeInBytes(span) {
    let weight = 156;
    weight += span.name.length * 2;
    weight += $f8fWp.estimateTypedAttributesSizeInBytes(span.attributes);
    if (span.links && span.links.length > 0) {
        const firstLink = span.links[0];
        const attributes$1 = firstLink?.attributes;
        const linkWeight = 100 + (attributes$1 ? $f8fWp.estimateTypedAttributesSizeInBytes(attributes$1) : 0);
        weight += linkWeight * span.links.length;
    }
    return weight;
}
module.exports.estimateSerializedSpanSizeInBytes = $3c085ff49e64d7e3$var$estimateSerializedSpanSizeInBytes;

});


parcelRegister("4Y3t2", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $jCjMv = parcelRequire("jCjMv");

var $5QaR1 = parcelRequire("5QaR1");

var $lPd4g = parcelRequire("lPd4g");

var $1N6Mo = parcelRequire("1N6Mo");

var $lIOsi = parcelRequire("lIOsi");

var $9wTeJ = parcelRequire("9wTeJ");

var $jix5p = parcelRequire("jix5p");

var $2dG64 = parcelRequire("2dG64");
const $39df748cd399e569$var$spanStreamingIntegration = $5QaR1.defineIntegration(()=>{
    return {
        name: "SpanStreaming",
        setup (client) {
            const initialMessage = "SpanStreaming integration requires";
            const fallbackMsg = "Falling back to static trace lifecycle.";
            const clientOptions = client.getOptions();
            if (!$lIOsi.hasSpanStreamingEnabled(client)) {
                clientOptions.traceLifecycle = "static";
                $jCjMv.DEBUG_BUILD && $jix5p.debug.warn(`${initialMessage} \`traceLifecycle\` to be set to "stream"! ${fallbackMsg}`);
                return;
            }
            const beforeSendSpan$1 = clientOptions.beforeSendSpan;
            if (beforeSendSpan$1 && !$lPd4g.isStreamedBeforeSendSpanCallback(beforeSendSpan$1)) {
                clientOptions.traceLifecycle = "static";
                $jCjMv.DEBUG_BUILD && $jix5p.debug.warn(`${initialMessage} a beforeSendSpan callback using \`withStreamedSpan\`! ${fallbackMsg}`);
                return;
            }
            const buffer = new $9wTeJ.SpanBuffer(client);
            client.on("afterSpanEnd", (span)=>{
                if (!$2dG64.spanIsSampled(span)) return;
                buffer.add($1N6Mo.captureSpan(span, client));
            });
        }
    };
});
module.exports.spanStreamingIntegration = $39df748cd399e569$var$spanStreamingIntegration;

});

parcelRegister("wqmhe", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $06176f7bd358ac91$var$getBreadcrumbLogLevelFromHttpStatusCode(statusCode) {
    if (statusCode === void 0) return void 0;
    else if (statusCode >= 400 && statusCode < 500) return "warning";
    else if (statusCode >= 500) return "error";
    else return void 0;
}
module.exports.getBreadcrumbLogLevelFromHttpStatusCode = $06176f7bd358ac91$var$getBreadcrumbLogLevelFromHttpStatusCode;

});

parcelRegister("8QzOy", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
class $670ef60ce9d86dfe$var$SentryError extends Error {
    constructor(message, logLevel = "warn"){
        super(message);
        this.message = message;
        this.logLevel = logLevel;
    }
}
module.exports.SentryError = $670ef60ce9d86dfe$var$SentryError;

});

parcelRegister("8cQs4", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gjJ9A = parcelRequire("gjJ9A");

var $fBPG6 = parcelRequire("fBPG6");

var $2SQtm = parcelRequire("2SQtm");

var $4ZAQw = parcelRequire("4ZAQw");

var $7q4WK = parcelRequire("7q4WK");

var $hsCGK = parcelRequire("hsCGK");

var $86JSI = parcelRequire("86JSI");
function $5f9821891ddb58f2$var$addFetchInstrumentationHandler(handler, skipNativeFetchCheck) {
    const type = "fetch";
    const removeHandler = $86JSI.addHandler(type, handler);
    $86JSI.maybeInstrument(type, ()=>$5f9821891ddb58f2$var$instrumentFetch(void 0, skipNativeFetchCheck));
    return removeHandler;
}
function $5f9821891ddb58f2$var$addFetchEndInstrumentationHandler(handler) {
    const type = "fetch-body-resolved";
    const removeHandler = $86JSI.addHandler(type, handler);
    $86JSI.maybeInstrument(type, ()=>$5f9821891ddb58f2$var$instrumentFetch($5f9821891ddb58f2$var$streamHandler));
    return removeHandler;
}
function $5f9821891ddb58f2$var$instrumentFetch(onFetchResolved, skipNativeFetchCheck = false) {
    if (skipNativeFetchCheck && !$4ZAQw.supportsNativeFetch()) return;
    $2SQtm.fill($hsCGK.GLOBAL_OBJ, "fetch", function(originalFetch) {
        return function(...args) {
            const virtualError = new Error();
            const { method: method, url: url } = $5f9821891ddb58f2$var$parseFetchArgs(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: $7q4WK.timestampInSeconds() * 1e3,
                virtualError: // // Adding the error to be able to fingerprint the failed fetch event in HttpClient instrumentation
                virtualError,
                headers: $5f9821891ddb58f2$var$getHeadersFromFetchArgs(args)
            };
            if (!onFetchResolved) $86JSI.triggerHandlers("fetch", {
                ...handlerData
            });
            return originalFetch.apply($hsCGK.GLOBAL_OBJ, args).then(async (response)=>{
                if (onFetchResolved) onFetchResolved(response);
                else $86JSI.triggerHandlers("fetch", {
                    ...handlerData,
                    endTimestamp: $7q4WK.timestampInSeconds() * 1e3,
                    response: response
                });
                return response;
            }, (error)=>{
                $86JSI.triggerHandlers("fetch", {
                    ...handlerData,
                    endTimestamp: $7q4WK.timestampInSeconds() * 1e3,
                    error: error
                });
                if ($fBPG6.isError(error) && error.stack === void 0) {
                    error.stack = virtualError.stack;
                    $2SQtm.addNonEnumerableProperty(error, "framesToPop", 1);
                }
                const client = $gjJ9A.getClient();
                const enhanceOption = client?.getOptions().enhanceFetchErrorMessages ?? "always";
                const shouldEnhance = enhanceOption !== false;
                if (shouldEnhance && error instanceof TypeError && (error.message === "Failed to fetch" || error.message === "Load failed" || error.message === "NetworkError when attempting to fetch resource.")) try {
                    const url2 = new URL(handlerData.fetchData.url);
                    const hostname = url2.host;
                    if (enhanceOption === "always") error.message = `${error.message} (${hostname})`;
                    else $2SQtm.addNonEnumerableProperty(error, "__sentry_fetch_url_host__", hostname);
                } catch  {}
                throw error;
            });
        };
    });
}
async function $5f9821891ddb58f2$var$resolveResponse(res, onFinishedResolving) {
    if (res?.body) {
        const body = res.body;
        const responseReader = body.getReader();
        const maxFetchDurationTimeout = setTimeout(()=>{
            body.cancel().then(null, ()=>{});
        }, 90000);
        let readingActive = true;
        while(readingActive){
            let chunkTimeout;
            try {
                chunkTimeout = setTimeout(()=>{
                    body.cancel().then(null, ()=>{});
                }, 5e3);
                const { done: done } = await responseReader.read();
                clearTimeout(chunkTimeout);
                if (done) {
                    onFinishedResolving();
                    readingActive = false;
                }
            } catch  {
                readingActive = false;
            } finally{
                clearTimeout(chunkTimeout);
            }
        }
        clearTimeout(maxFetchDurationTimeout);
        responseReader.releaseLock();
        body.cancel().then(null, ()=>{});
    }
}
function $5f9821891ddb58f2$var$streamHandler(response) {
    let clonedResponseForResolving;
    try {
        clonedResponseForResolving = response.clone();
    } catch  {
        return;
    }
    $5f9821891ddb58f2$var$resolveResponse(clonedResponseForResolving, ()=>{
        $86JSI.triggerHandlers("fetch-body-resolved", {
            endTimestamp: $7q4WK.timestampInSeconds() * 1e3,
            response: response
        });
    });
}
function $5f9821891ddb58f2$var$hasProp(obj, prop) {
    return !!obj && typeof obj === "object" && !!obj[prop];
}
function $5f9821891ddb58f2$var$getUrlFromResource(resource) {
    if (typeof resource === "string") return resource;
    if (!resource) return "";
    if ($5f9821891ddb58f2$var$hasProp(resource, "url")) return resource.url;
    if (resource.toString) return resource.toString();
    return "";
}
function $5f9821891ddb58f2$var$parseFetchArgs(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: "GET",
        url: ""
    };
    if (fetchArgs.length === 2) {
        const [resource, options] = fetchArgs;
        return {
            url: $5f9821891ddb58f2$var$getUrlFromResource(resource),
            method: $5f9821891ddb58f2$var$hasProp(options, "method") ? String(options.method).toUpperCase() : // Request object as first argument
            $fBPG6.isRequest(resource) && $5f9821891ddb58f2$var$hasProp(resource, "method") ? String(resource.method).toUpperCase() : "GET"
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $5f9821891ddb58f2$var$getUrlFromResource(arg),
        method: $5f9821891ddb58f2$var$hasProp(arg, "method") ? String(arg.method).toUpperCase() : "GET"
    };
}
function $5f9821891ddb58f2$var$getHeadersFromFetchArgs(fetchArgs) {
    const [requestArgument, optionsArgument] = fetchArgs;
    try {
        if (typeof optionsArgument === "object" && optionsArgument !== null && "headers" in optionsArgument && optionsArgument.headers) return new Headers(optionsArgument.headers);
        if ($fBPG6.isRequest(requestArgument)) return new Headers(requestArgument.headers);
    } catch  {}
    return;
}
module.exports.addFetchEndInstrumentationHandler = $5f9821891ddb58f2$var$addFetchEndInstrumentationHandler;
module.exports.addFetchInstrumentationHandler = $5f9821891ddb58f2$var$addFetchInstrumentationHandler;
module.exports.parseFetchArgs = $5f9821891ddb58f2$var$parseFetchArgs;

});
parcelRegister("4ZAQw", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $jCjMv = parcelRequire("jCjMv");

var $jix5p = parcelRequire("jix5p");

var $hsCGK = parcelRequire("hsCGK");
const $3a2970ceea32f49c$var$WINDOW = $hsCGK.GLOBAL_OBJ;
function $3a2970ceea32f49c$var$supportsErrorEvent() {
    try {
        new ErrorEvent("");
        return true;
    } catch  {
        return false;
    }
}
function $3a2970ceea32f49c$var$supportsDOMError() {
    try {
        new DOMError("");
        return true;
    } catch  {
        return false;
    }
}
function $3a2970ceea32f49c$var$supportsDOMException() {
    try {
        new DOMException("");
        return true;
    } catch  {
        return false;
    }
}
function $3a2970ceea32f49c$var$supportsHistory() {
    return "history" in $3a2970ceea32f49c$var$WINDOW && !!$3a2970ceea32f49c$var$WINDOW.history;
}
const $3a2970ceea32f49c$var$supportsFetch = $3a2970ceea32f49c$var$_isFetchSupported;
function $3a2970ceea32f49c$var$_isFetchSupported() {
    if (!("fetch" in $3a2970ceea32f49c$var$WINDOW)) return false;
    try {
        new Headers();
        new Request("data:,");
        new Response();
        return true;
    } catch  {
        return false;
    }
}
function $3a2970ceea32f49c$var$isNativeFunction(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
function $3a2970ceea32f49c$var$supportsNativeFetch() {
    if (typeof EdgeRuntime === "string") return true;
    if (!$3a2970ceea32f49c$var$_isFetchSupported()) return false;
    if ($3a2970ceea32f49c$var$isNativeFunction($3a2970ceea32f49c$var$WINDOW.fetch)) return true;
    let result = false;
    const doc = $3a2970ceea32f49c$var$WINDOW.document;
    if (doc && typeof doc.createElement === "function") try {
        const sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow?.fetch) result = $3a2970ceea32f49c$var$isNativeFunction(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        $jCjMv.DEBUG_BUILD && $jix5p.debug.warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
function $3a2970ceea32f49c$var$supportsReportingObserver() {
    return "ReportingObserver" in $3a2970ceea32f49c$var$WINDOW;
}
function $3a2970ceea32f49c$var$supportsReferrerPolicy() {
    if (!$3a2970ceea32f49c$var$_isFetchSupported()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch  {
        return false;
    }
}
module.exports.isNativeFunction = $3a2970ceea32f49c$var$isNativeFunction;
module.exports.supportsDOMError = $3a2970ceea32f49c$var$supportsDOMError;
module.exports.supportsDOMException = $3a2970ceea32f49c$var$supportsDOMException;
module.exports.supportsErrorEvent = $3a2970ceea32f49c$var$supportsErrorEvent;
module.exports.supportsFetch = $3a2970ceea32f49c$var$supportsFetch;
module.exports.supportsHistory = $3a2970ceea32f49c$var$supportsHistory;
module.exports.supportsNativeFetch = $3a2970ceea32f49c$var$supportsNativeFetch;
module.exports.supportsReferrerPolicy = $3a2970ceea32f49c$var$supportsReferrerPolicy;
module.exports.supportsReportingObserver = $3a2970ceea32f49c$var$supportsReportingObserver;

});


parcelRegister("cjy9I", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $8f71c10089f39ce3$var$replaceExports(exports1, exportName, wrappedConstructor) {
    const original = exports1[exportName];
    if (typeof original !== "function") return;
    try {
        exports1[exportName] = wrappedConstructor;
    } catch  {
        Object.defineProperty(exports1, exportName, {
            value: wrappedConstructor,
            writable: true,
            configurable: true,
            enumerable: true
        });
    }
    if (exports1.default === original) try {
        exports1.default = wrappedConstructor;
    } catch  {
        Object.defineProperty(exports1, "default", {
            value: wrappedConstructor,
            writable: true,
            configurable: true,
            enumerable: true
        });
    }
}
module.exports.replaceExports = $8f71c10089f39ce3$var$replaceExports;

});

parcelRegister("88kW2", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
class $5ebf4f56b25d833c$var$LRUMap {
    constructor(_maxSize){
        this._maxSize = _maxSize;
        this._cache = /* @__PURE__ */ new Map();
    }
    /** Get the current size of the cache */ get size() {
        return this._cache.size;
    }
    /** Get an entry or undefined if it was not in the cache. Re-inserts to update the recently used order */ get(key) {
        const value = this._cache.get(key);
        if (value === void 0) return void 0;
        this._cache.delete(key);
        this._cache.set(key, value);
        return value;
    }
    /** Insert an entry and evict an older entry if we've reached maxSize */ set(key, value) {
        if (this._cache.size >= this._maxSize) {
            const nextKey = this._cache.keys().next().value;
            this._cache.delete(nextKey);
        }
        this._cache.set(key, value);
    }
    /** Remove an entry and return the entry if it was in the cache */ remove(key) {
        const value = this._cache.get(key);
        if (value) this._cache.delete(key);
        return value;
    }
    /** Clear all entries */ clear() {
        this._cache.clear();
    }
    /** Get all the keys */ keys() {
        return Array.from(this._cache.keys());
    }
    /** Get all the values */ values() {
        const values = [];
        this._cache.forEach((value)=>values.push(value));
        return values;
    }
}
module.exports.LRUMap = $5ebf4f56b25d833c$var$LRUMap;

});

parcelRegister("1GUda", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $13b55113d45fd2f7$var$escapeStringForRegex(regexString) {
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}
module.exports.escapeStringForRegex = $13b55113d45fd2f7$var$escapeStringForRegex;

});

parcelRegister("5TFPR", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $fBPG6 = parcelRequire("fBPG6");

var $hsCGK = parcelRequire("hsCGK");
const $44b28a783c566a39$var$WINDOW = $hsCGK.GLOBAL_OBJ;
const $44b28a783c566a39$var$DEFAULT_MAX_STRING_LENGTH = 80;
function $44b28a783c566a39$var$htmlTreeAsString(elem, options = {}) {
    if (!elem) return "<unknown>";
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $44b28a783c566a39$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $44b28a783c566a39$var$_htmlElementAsString(currentElem, keyAttrs);
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch  {
        return "<unknown>";
    }
}
function $44b28a783c566a39$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    if (!elem?.tagName) return "";
    if ($44b28a783c566a39$var$WINDOW.HTMLElement) {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset["sentryComponent"]) return elem.dataset["sentryComponent"];
            if (elem.dataset["sentryElement"]) return elem.dataset["sentryElement"];
        }
    }
    out.push(elem.tagName.toLowerCase());
    const keyAttrPairs = keyAttrs?.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs?.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        const className = elem.className;
        if (className && $fBPG6.isString(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    for (const k of [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ]){
        const attr = elem.getAttribute(k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join("");
}
function $44b28a783c566a39$var$getLocationHref() {
    try {
        return $44b28a783c566a39$var$WINDOW.document.location.href;
    } catch  {
        return "";
    }
}
function $44b28a783c566a39$var$getComponentName(elem, maxTraverseHeight = 5) {
    if (!$44b28a783c566a39$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    for(let i = 0; i < maxTraverseHeight; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset["sentryComponent"]) return currentElem.dataset["sentryComponent"];
            if (currentElem.dataset["sentryElement"]) return currentElem.dataset["sentryElement"];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}
module.exports.getComponentName = $44b28a783c566a39$var$getComponentName;
module.exports.getLocationHref = $44b28a783c566a39$var$getLocationHref;
module.exports.htmlTreeAsString = $44b28a783c566a39$var$htmlTreeAsString;

});

parcelRegister("6wQ2i", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8txOP = parcelRequire("8txOP");

var $3dwiN = parcelRequire("3dwiN");

var $4Ae9I = parcelRequire("4Ae9I");

var $njxh1 = parcelRequire("njxh1");

var $8rGYq = parcelRequire("8rGYq");

var $7cQmT = parcelRequire("7cQmT");
function $4c0e188671f69d29$var$inferSystemFromInstance(instance) {
    const name = instance.constructor?.name ?? "";
    if (name.includes("OpenAI")) return "openai";
    if (name.includes("Google")) return "google_genai";
    if (name.includes("Mistral")) return "mistralai";
    if (name.includes("Vertex")) return "google_vertexai";
    if (name.includes("Bedrock")) return "aws_bedrock";
    if (name.includes("Ollama")) return "ollama";
    if (name.includes("Cloudflare")) return "cloudflare";
    if (name.includes("Cohere")) return "cohere";
    return "langchain";
}
function $4c0e188671f69d29$var$extractEmbeddingAttributes(instance) {
    const embeddingsInstance = instance ?? {};
    const attributes = {
        [$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $7cQmT.LANGCHAIN_ORIGIN,
        [$3dwiN.SEMANTIC_ATTRIBUTE_SENTRY_OP]: $njxh1.GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE,
        [$njxh1.GEN_AI_OPERATION_NAME_ATTRIBUTE]: "embeddings",
        [$njxh1.GEN_AI_REQUEST_MODEL_ATTRIBUTE]: embeddingsInstance.model ?? "unknown"
    };
    attributes[$njxh1.GEN_AI_SYSTEM_ATTRIBUTE] = $4c0e188671f69d29$var$inferSystemFromInstance(embeddingsInstance);
    if ("dimensions" in embeddingsInstance) attributes[$njxh1.GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE] = embeddingsInstance.dimensions;
    if ("encodingFormat" in embeddingsInstance) attributes[$njxh1.GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE] = embeddingsInstance.encodingFormat;
    return attributes;
}
function $4c0e188671f69d29$var$instrumentEmbeddingMethod(originalMethod, options = {}) {
    const { recordInputs: recordInputs } = $8rGYq.resolveAIRecordingOptions(options);
    return new Proxy(originalMethod, {
        apply (target, thisArg, args) {
            const attributes = $4c0e188671f69d29$var$extractEmbeddingAttributes(thisArg);
            const modelName = attributes[$njxh1.GEN_AI_REQUEST_MODEL_ATTRIBUTE] || "unknown";
            if (recordInputs) {
                const input = args[0];
                if (input != null) attributes[$njxh1.GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE] = typeof input === "string" ? input : JSON.stringify(input);
            }
            return $4Ae9I.startSpan({
                name: `embeddings ${modelName}`,
                op: $njxh1.GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE,
                attributes: attributes
            }, ()=>{
                return Reflect.apply(target, thisArg, args).then(void 0, (error)=>{
                    $8txOP.captureException(error, {
                        mechanism: {
                            handled: false,
                            type: "auto.ai.langchain"
                        }
                    });
                    throw error;
                });
            });
        }
    });
}
function $4c0e188671f69d29$var$instrumentLangChainEmbeddings(instance, options) {
    const embeddingsInstance = instance;
    if (typeof embeddingsInstance.embedQuery === "function") embeddingsInstance.embedQuery = $4c0e188671f69d29$var$instrumentEmbeddingMethod(embeddingsInstance.embedQuery, options);
    if (typeof embeddingsInstance.embedDocuments === "function") embeddingsInstance.embedDocuments = $4c0e188671f69d29$var$instrumentEmbeddingMethod(embeddingsInstance.embedDocuments, options);
    return instance;
}
module.exports.instrumentEmbeddingMethod = $4c0e188671f69d29$var$instrumentEmbeddingMethod;
module.exports.instrumentLangChainEmbeddings = $4c0e188671f69d29$var$instrumentLangChainEmbeddings;

});


parcelRegister("763H4", function(module, exports) {

$parcel$export(module.exports, "isNodeEnv", function () { return isNodeEnv; });

var $gJYBF = parcelRequire("gJYBF");
function isNodeEnv() {
    return !(0, $gJYBF.isBrowserBundle)() && Object.prototype.toString.call(0) === "[object process]";
}
function dynamicRequire(mod, request) {
    return mod.require(request);
}
function loadModule(moduleName, existingModule = module) {
    let mod;
    try {
        mod = dynamicRequire(existingModule, moduleName);
    } catch  {}
    if (!mod) try {
        const { cwd } = dynamicRequire(existingModule, "process");
        mod = dynamicRequire(existingModule, `${cwd()}/node_modules/${moduleName}`);
    } catch  {}
    return mod;
}

});
parcelRegister("gJYBF", function(module, exports) {

$parcel$export(module.exports, "isBrowserBundle", function () { return $c2ffdc8717c877e3$export$2928c40372e623c0; });
function $c2ffdc8717c877e3$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}
function $c2ffdc8717c877e3$export$8ad33f488b1ab046() {
    /*! __SENTRY_SDK_SOURCE__ */ return "npm";
}

});


var $f183dd638760e746$exports = {};
(function(window1, factory) {
    var lazySizes = factory(window1, window1.document, Date);
    window1.lazySizes = lazySizes;
    if ($f183dd638760e746$exports) $f183dd638760e746$exports = lazySizes;
})(typeof window != 'undefined' ? window : {}, /**
 * import("./types/global")
 * @typedef { import("./types/lazysizes-config").LazySizesConfigPartial } LazySizesConfigPartial
 */ function l(window1, document, Date1) {
    'use strict';
    /*jshint eqnull:true */ var lazysizes, /**
		 * @type { LazySizesConfigPartial }
		 */ lazySizesCfg;
    (function() {
        var prop;
        var lazySizesDefaults = {
            lazyClass: 'lazyload',
            loadedClass: 'lazyloaded',
            loadingClass: 'lazyloading',
            preloadClass: 'lazypreload',
            errorClass: 'lazyerror',
            //strictClass: 'lazystrict',
            autosizesClass: 'lazyautosizes',
            fastLoadedClass: 'ls-is-cached',
            iframeLoadMode: 0,
            srcAttr: 'data-src',
            srcsetAttr: 'data-srcset',
            sizesAttr: 'data-sizes',
            //preloadAfterLoad: false,
            minSize: 40,
            customMedia: {},
            init: true,
            expFactor: 1.5,
            hFac: 0.8,
            loadMode: 2,
            loadHidden: true,
            ricTimeout: 0,
            throttleDelay: 125
        };
        lazySizesCfg = window1.lazySizesConfig || window1.lazysizesConfig || {};
        for(prop in lazySizesDefaults)if (!(prop in lazySizesCfg)) lazySizesCfg[prop] = lazySizesDefaults[prop];
    })();
    if (!document || !document.getElementsByClassName) return {
        init: function() {},
        /**
			 * @type { LazySizesConfigPartial }
			 */ cfg: lazySizesCfg,
        /**
			 * @type { true }
			 */ noSupport: true
    };
    var docElem = document.documentElement;
    var supportPicture = window1.HTMLPictureElement;
    var _addEventListener = 'addEventListener';
    var _getAttribute = 'getAttribute';
    /**
	 * Update to bind to window because 'this' becomes null during SSR
	 * builds.
	 */ var addEventListener = window1[_addEventListener].bind(window1);
    var setTimeout = window1.setTimeout;
    var requestAnimationFrame = window1.requestAnimationFrame || setTimeout;
    var requestIdleCallback = window1.requestIdleCallback;
    var regPicture = /^picture$/i;
    var loadEvents = [
        'load',
        'error',
        'lazyincluded',
        '_lazyloaded'
    ];
    var regClassCache = {};
    var forEach = Array.prototype.forEach;
    /**
	 * @param ele {Element}
	 * @param cls {string}
	 */ var hasClass = function(ele, cls) {
        if (!regClassCache[cls]) regClassCache[cls] = new RegExp('(\\s|^)' + cls + '(\\s|$)');
        return regClassCache[cls].test(ele[_getAttribute]('class') || '') && regClassCache[cls];
    };
    /**
	 * @param ele {Element}
	 * @param cls {string}
	 */ var addClass = function(ele, cls) {
        if (!hasClass(ele, cls)) ele.setAttribute('class', (ele[_getAttribute]('class') || '').trim() + ' ' + cls);
    };
    /**
	 * @param ele {Element}
	 * @param cls {string}
	 */ var removeClass = function(ele, cls) {
        var reg;
        if (reg = hasClass(ele, cls)) ele.setAttribute('class', (ele[_getAttribute]('class') || '').replace(reg, ' '));
    };
    var addRemoveLoadEvents = function(dom, fn, add) {
        var action = add ? _addEventListener : 'removeEventListener';
        if (add) addRemoveLoadEvents(dom, fn);
        loadEvents.forEach(function(evt) {
            dom[action](evt, fn);
        });
    };
    /**
	 * @param elem { Element }
	 * @param name { string }
	 * @param detail { any }
	 * @param noBubbles { boolean }
	 * @param noCancelable { boolean }
	 * @returns { CustomEvent }
	 */ var triggerEvent = function(elem, name, detail, noBubbles, noCancelable) {
        var event = document.createEvent('Event');
        if (!detail) detail = {};
        detail.instance = lazysizes;
        event.initEvent(name, !noBubbles, !noCancelable);
        event.detail = detail;
        elem.dispatchEvent(event);
        return event;
    };
    var updatePolyfill = function(el, full) {
        var polyfill;
        if (!supportPicture && (polyfill = window1.picturefill || lazySizesCfg.pf)) {
            if (full && full.src && !el[_getAttribute]('srcset')) el.setAttribute('srcset', full.src);
            polyfill({
                reevaluate: true,
                elements: [
                    el
                ]
            });
        } else if (full && full.src) el.src = full.src;
    };
    var getCSS = function(elem, style) {
        return (getComputedStyle(elem, null) || {})[style];
    };
    /**
	 *
	 * @param elem { Element }
	 * @param parent { Element }
	 * @param [width] {number}
	 * @returns {number}
	 */ var getWidth = function(elem, parent, width) {
        width = width || elem.offsetWidth;
        while(width < lazySizesCfg.minSize && parent && !elem._lazysizesWidth){
            width = parent.offsetWidth;
            parent = parent.parentNode;
        }
        return width;
    };
    var rAF = function() {
        var running, waiting;
        var firstFns = [];
        var secondFns = [];
        var fns = firstFns;
        var run = function() {
            var runFns = fns;
            fns = firstFns.length ? secondFns : firstFns;
            running = true;
            waiting = false;
            while(runFns.length)runFns.shift()();
            running = false;
        };
        var rafBatch = function(fn, queue) {
            if (running && !queue) fn.apply(this, arguments);
            else {
                fns.push(fn);
                if (!waiting) {
                    waiting = true;
                    (document.hidden ? setTimeout : requestAnimationFrame)(run);
                }
            }
        };
        rafBatch._lsFlush = run;
        return rafBatch;
    }();
    var rAFIt = function(fn, simple) {
        return simple ? function() {
            rAF(fn);
        } : function() {
            var that = this;
            var args = arguments;
            rAF(function() {
                fn.apply(that, args);
            });
        };
    };
    var throttle = function(fn) {
        var running;
        var lastTime = 0;
        var gDelay = lazySizesCfg.throttleDelay;
        var rICTimeout = lazySizesCfg.ricTimeout;
        var run = function() {
            running = false;
            lastTime = Date1.now();
            fn();
        };
        var idleCallback = requestIdleCallback && rICTimeout > 49 ? function() {
            requestIdleCallback(run, {
                timeout: rICTimeout
            });
            if (rICTimeout !== lazySizesCfg.ricTimeout) rICTimeout = lazySizesCfg.ricTimeout;
        } : rAFIt(function() {
            setTimeout(run);
        }, true);
        return function(isPriority) {
            var delay;
            if (isPriority = isPriority === true) rICTimeout = 33;
            if (running) return;
            running = true;
            delay = gDelay - (Date1.now() - lastTime);
            if (delay < 0) delay = 0;
            if (isPriority || delay < 9) idleCallback();
            else setTimeout(idleCallback, delay);
        };
    };
    //based on http://modernjavascript.blogspot.de/2013/08/building-better-debounce.html
    var debounce = function(func) {
        var timeout, timestamp;
        var wait = 99;
        var run = function() {
            timeout = null;
            func();
        };
        var later = function() {
            var last = Date1.now() - timestamp;
            if (last < wait) setTimeout(later, wait - last);
            else (requestIdleCallback || run)(run);
        };
        return function() {
            timestamp = Date1.now();
            if (!timeout) timeout = setTimeout(later, wait);
        };
    };
    var loader = function() {
        var preloadElems, isCompleted, resetPreloadingTimer, loadMode, started;
        var eLvW, elvH, eLtop, eLleft, eLright, eLbottom, isBodyHidden;
        var regImg = /^img$/i;
        var regIframe = /^iframe$/i;
        var supportScroll = 'onscroll' in window1 && !/(gle|ing)bot/.test(navigator.userAgent);
        var shrinkExpand = 0;
        var currentExpand = 0;
        var isLoading = 0;
        var lowRuns = -1;
        var resetPreloading = function(e) {
            isLoading--;
            if (!e || isLoading < 0 || !e.target) isLoading = 0;
        };
        var isVisible = function(elem) {
            if (isBodyHidden == null) isBodyHidden = getCSS(document.body, 'visibility') == 'hidden';
            return isBodyHidden || !(getCSS(elem.parentNode, 'visibility') == 'hidden' && getCSS(elem, 'visibility') == 'hidden');
        };
        var isNestedVisible = function(elem, elemExpand) {
            var outerRect;
            var parent = elem;
            var visible = isVisible(elem);
            eLtop -= elemExpand;
            eLbottom += elemExpand;
            eLleft -= elemExpand;
            eLright += elemExpand;
            while(visible && (parent = parent.offsetParent) && parent != document.body && parent != docElem){
                visible = (getCSS(parent, 'opacity') || 1) > 0;
                if (visible && getCSS(parent, 'overflow') != 'visible') {
                    outerRect = parent.getBoundingClientRect();
                    visible = eLright > outerRect.left && eLleft < outerRect.right && eLbottom > outerRect.top - 1 && eLtop < outerRect.bottom + 1;
                }
            }
            return visible;
        };
        var checkElements = function() {
            var eLlen, i, rect, autoLoadElem, loadedSomething, elemExpand, elemNegativeExpand, elemExpandVal, beforeExpandVal, defaultExpand, preloadExpand, hFac;
            var lazyloadElems = lazysizes.elements;
            if ((loadMode = lazySizesCfg.loadMode) && isLoading < 8 && (eLlen = lazyloadElems.length)) {
                i = 0;
                lowRuns++;
                for(; i < eLlen; i++){
                    if (!lazyloadElems[i] || lazyloadElems[i]._lazyRace) continue;
                    if (!supportScroll || lazysizes.prematureUnveil && lazysizes.prematureUnveil(lazyloadElems[i])) {
                        unveilElement(lazyloadElems[i]);
                        continue;
                    }
                    if (!(elemExpandVal = lazyloadElems[i][_getAttribute]('data-expand')) || !(elemExpand = elemExpandVal * 1)) elemExpand = currentExpand;
                    if (!defaultExpand) {
                        defaultExpand = !lazySizesCfg.expand || lazySizesCfg.expand < 1 ? docElem.clientHeight > 500 && docElem.clientWidth > 500 ? 500 : 370 : lazySizesCfg.expand;
                        lazysizes._defEx = defaultExpand;
                        preloadExpand = defaultExpand * lazySizesCfg.expFactor;
                        hFac = lazySizesCfg.hFac;
                        isBodyHidden = null;
                        if (currentExpand < preloadExpand && isLoading < 1 && lowRuns > 2 && loadMode > 2 && !document.hidden) {
                            currentExpand = preloadExpand;
                            lowRuns = 0;
                        } else if (loadMode > 1 && lowRuns > 1 && isLoading < 6) currentExpand = defaultExpand;
                        else currentExpand = shrinkExpand;
                    }
                    if (beforeExpandVal !== elemExpand) {
                        eLvW = innerWidth + elemExpand * hFac;
                        elvH = innerHeight + elemExpand;
                        elemNegativeExpand = elemExpand * -1;
                        beforeExpandVal = elemExpand;
                    }
                    rect = lazyloadElems[i].getBoundingClientRect();
                    if ((eLbottom = rect.bottom) >= elemNegativeExpand && (eLtop = rect.top) <= elvH && (eLright = rect.right) >= elemNegativeExpand * hFac && (eLleft = rect.left) <= eLvW && (eLbottom || eLright || eLleft || eLtop) && (lazySizesCfg.loadHidden || isVisible(lazyloadElems[i])) && (isCompleted && isLoading < 3 && !elemExpandVal && (loadMode < 3 || lowRuns < 4) || isNestedVisible(lazyloadElems[i], elemExpand))) {
                        unveilElement(lazyloadElems[i]);
                        loadedSomething = true;
                        if (isLoading > 9) break;
                    } else if (!loadedSomething && isCompleted && !autoLoadElem && isLoading < 4 && lowRuns < 4 && loadMode > 2 && (preloadElems[0] || lazySizesCfg.preloadAfterLoad) && (preloadElems[0] || !elemExpandVal && (eLbottom || eLright || eLleft || eLtop || lazyloadElems[i][_getAttribute](lazySizesCfg.sizesAttr) != 'auto'))) autoLoadElem = preloadElems[0] || lazyloadElems[i];
                }
                if (autoLoadElem && !loadedSomething) unveilElement(autoLoadElem);
            }
        };
        var throttledCheckElements = throttle(checkElements);
        var switchLoadingClass = function(e) {
            var elem = e.target;
            if (elem._lazyCache) {
                delete elem._lazyCache;
                return;
            }
            resetPreloading(e);
            addClass(elem, lazySizesCfg.loadedClass);
            removeClass(elem, lazySizesCfg.loadingClass);
            addRemoveLoadEvents(elem, rafSwitchLoadingClass);
            triggerEvent(elem, 'lazyloaded');
        };
        var rafedSwitchLoadingClass = rAFIt(switchLoadingClass);
        var rafSwitchLoadingClass = function(e) {
            rafedSwitchLoadingClass({
                target: e.target
            });
        };
        var changeIframeSrc = function(elem, src) {
            var loadMode = elem.getAttribute('data-load-mode') || lazySizesCfg.iframeLoadMode;
            // loadMode can be also a string!
            if (loadMode == 0) elem.contentWindow.location.replace(src);
            else if (loadMode == 1) elem.src = src;
        };
        var handleSources = function(source) {
            var customMedia;
            var sourceSrcset = source[_getAttribute](lazySizesCfg.srcsetAttr);
            if (customMedia = lazySizesCfg.customMedia[source[_getAttribute]('data-media') || source[_getAttribute]('media')]) source.setAttribute('media', customMedia);
            if (sourceSrcset) source.setAttribute('srcset', sourceSrcset);
        };
        var lazyUnveil = rAFIt(function(elem, detail, isAuto, sizes, isImg) {
            var src, srcset, parent, isPicture, event, firesLoad;
            if (!(event = triggerEvent(elem, 'lazybeforeunveil', detail)).defaultPrevented) {
                if (sizes) {
                    if (isAuto) addClass(elem, lazySizesCfg.autosizesClass);
                    else elem.setAttribute('sizes', sizes);
                }
                srcset = elem[_getAttribute](lazySizesCfg.srcsetAttr);
                src = elem[_getAttribute](lazySizesCfg.srcAttr);
                if (isImg) {
                    parent = elem.parentNode;
                    isPicture = parent && regPicture.test(parent.nodeName || '');
                }
                firesLoad = detail.firesLoad || 'src' in elem && (srcset || src || isPicture);
                event = {
                    target: elem
                };
                addClass(elem, lazySizesCfg.loadingClass);
                if (firesLoad) {
                    clearTimeout(resetPreloadingTimer);
                    resetPreloadingTimer = setTimeout(resetPreloading, 2500);
                    addRemoveLoadEvents(elem, rafSwitchLoadingClass, true);
                }
                if (isPicture) forEach.call(parent.getElementsByTagName('source'), handleSources);
                if (srcset) elem.setAttribute('srcset', srcset);
                else if (src && !isPicture) {
                    if (regIframe.test(elem.nodeName)) changeIframeSrc(elem, src);
                    else elem.src = src;
                }
                if (isImg && (srcset || isPicture)) updatePolyfill(elem, {
                    src: src
                });
            }
            if (elem._lazyRace) delete elem._lazyRace;
            removeClass(elem, lazySizesCfg.lazyClass);
            rAF(function() {
                // Part of this can be removed as soon as this fix is older: https://bugs.chromium.org/p/chromium/issues/detail?id=7731 (2015)
                var isLoaded = elem.complete && elem.naturalWidth > 1;
                if (!firesLoad || isLoaded) {
                    if (isLoaded) addClass(elem, lazySizesCfg.fastLoadedClass);
                    switchLoadingClass(event);
                    elem._lazyCache = true;
                    setTimeout(function() {
                        if ('_lazyCache' in elem) delete elem._lazyCache;
                    }, 9);
                }
                if (elem.loading == 'lazy') isLoading--;
            }, true);
        });
        /**
		 *
		 * @param elem { Element }
		 */ var unveilElement = function(elem) {
            if (elem._lazyRace) return;
            var detail;
            var isImg = regImg.test(elem.nodeName);
            //allow using sizes="auto", but don't use. it's invalid. Use data-sizes="auto" or a valid value for sizes instead (i.e.: sizes="80vw")
            var sizes = isImg && (elem[_getAttribute](lazySizesCfg.sizesAttr) || elem[_getAttribute]('sizes'));
            var isAuto = sizes == 'auto';
            if ((isAuto || !isCompleted) && isImg && (elem[_getAttribute]('src') || elem.srcset) && !elem.complete && !hasClass(elem, lazySizesCfg.errorClass) && hasClass(elem, lazySizesCfg.lazyClass)) return;
            detail = triggerEvent(elem, 'lazyunveilread').detail;
            if (isAuto) autoSizer.updateElem(elem, true, elem.offsetWidth);
            elem._lazyRace = true;
            isLoading++;
            lazyUnveil(elem, detail, isAuto, sizes, isImg);
        };
        var afterScroll = debounce(function() {
            lazySizesCfg.loadMode = 3;
            throttledCheckElements();
        });
        var altLoadmodeScrollListner = function() {
            if (lazySizesCfg.loadMode == 3) lazySizesCfg.loadMode = 2;
            afterScroll();
        };
        var onload = function() {
            if (isCompleted) return;
            if (Date1.now() - started < 999) {
                setTimeout(onload, 999);
                return;
            }
            isCompleted = true;
            lazySizesCfg.loadMode = 3;
            throttledCheckElements();
            addEventListener('scroll', altLoadmodeScrollListner, true);
        };
        return {
            _: function() {
                started = Date1.now();
                lazysizes.elements = document.getElementsByClassName(lazySizesCfg.lazyClass);
                preloadElems = document.getElementsByClassName(lazySizesCfg.lazyClass + ' ' + lazySizesCfg.preloadClass);
                addEventListener('scroll', throttledCheckElements, true);
                addEventListener('resize', throttledCheckElements, true);
                addEventListener('pageshow', function(e) {
                    if (e.persisted) {
                        var loadingElements = document.querySelectorAll('.' + lazySizesCfg.loadingClass);
                        if (loadingElements.length && loadingElements.forEach) requestAnimationFrame(function() {
                            loadingElements.forEach(function(img) {
                                if (img.complete) unveilElement(img);
                            });
                        });
                    }
                });
                if (window1.MutationObserver) new MutationObserver(throttledCheckElements).observe(docElem, {
                    childList: true,
                    subtree: true,
                    attributes: true
                });
                else {
                    docElem[_addEventListener]('DOMNodeInserted', throttledCheckElements, true);
                    docElem[_addEventListener]('DOMAttrModified', throttledCheckElements, true);
                    setInterval(throttledCheckElements, 999);
                }
                addEventListener('hashchange', throttledCheckElements, true);
                //, 'fullscreenchange'
                [
                    'focus',
                    'mouseover',
                    'click',
                    'load',
                    'transitionend',
                    'animationend'
                ].forEach(function(name) {
                    document[_addEventListener](name, throttledCheckElements, true);
                });
                if (/d$|^c/.test(document.readyState)) onload();
                else {
                    addEventListener('load', onload);
                    document[_addEventListener]('DOMContentLoaded', throttledCheckElements);
                    setTimeout(onload, 20000);
                }
                if (lazysizes.elements.length) {
                    checkElements();
                    rAF._lsFlush();
                } else throttledCheckElements();
            },
            checkElems: throttledCheckElements,
            unveil: unveilElement,
            _aLSL: altLoadmodeScrollListner
        };
    }();
    var autoSizer = function() {
        var autosizesElems;
        var sizeElement = rAFIt(function(elem, parent, event, width) {
            var sources, i, len;
            elem._lazysizesWidth = width;
            width += 'px';
            elem.setAttribute('sizes', width);
            if (regPicture.test(parent.nodeName || '')) {
                sources = parent.getElementsByTagName('source');
                for(i = 0, len = sources.length; i < len; i++)sources[i].setAttribute('sizes', width);
            }
            if (!event.detail.dataAttr) updatePolyfill(elem, event.detail);
        });
        /**
		 *
		 * @param elem {Element}
		 * @param dataAttr
		 * @param [width] { number }
		 */ var getSizeElement = function(elem, dataAttr, width) {
            var event;
            var parent = elem.parentNode;
            if (parent) {
                width = getWidth(elem, parent, width);
                event = triggerEvent(elem, 'lazybeforesizes', {
                    width: width,
                    dataAttr: !!dataAttr
                });
                if (!event.defaultPrevented) {
                    width = event.detail.width;
                    if (width && width !== elem._lazysizesWidth) sizeElement(elem, parent, event, width);
                }
            }
        };
        var updateElementsSizes = function() {
            var i;
            var len = autosizesElems.length;
            if (len) {
                i = 0;
                for(; i < len; i++)getSizeElement(autosizesElems[i]);
            }
        };
        var debouncedUpdateElementsSizes = debounce(updateElementsSizes);
        return {
            _: function() {
                autosizesElems = document.getElementsByClassName(lazySizesCfg.autosizesClass);
                addEventListener('resize', debouncedUpdateElementsSizes);
            },
            checkElems: debouncedUpdateElementsSizes,
            updateElem: getSizeElement
        };
    }();
    var init = function() {
        if (!init.i && document.getElementsByClassName) {
            init.i = true;
            autoSizer._();
            loader._();
        }
    };
    setTimeout(function() {
        if (lazySizesCfg.init) init();
    });
    lazysizes = {
        /**
		 * @type { LazySizesConfigPartial }
		 */ cfg: lazySizesCfg,
        autoSizer: autoSizer,
        loader: loader,
        init: init,
        uP: updatePolyfill,
        aC: addClass,
        rC: removeClass,
        hC: hasClass,
        fire: triggerEvent,
        gW: getWidth,
        rAF: rAF
    };
    return lazysizes;
});


// @ts-ignore
NodeList.prototype.addEventListener = function(eventName, callback, useCapture) {
    for (let node of this)node.addEventListener(eventName, callback, useCapture);
};
// @ts-ignore
NodeList.prototype.addClass = function(cls) {
    for (let node of this)// @ts-ignore
    node.classList.add(cls);
};
// @ts-ignore
NodeList.prototype.removeClass = function(cls) {
    for (let node of this)// @ts-ignore
    node.classList.remove(cls);
};
// @ts-ignore
NodeList.prototype.display = function(show) {
    for (let node of this)// @ts-ignore
    node.style.display = show ? "block" : "none";
};


var $492f0fb96695dd9f$exports = {};
// This file is a compatibility shim for bundlers (e.g. webpack 4) that do not
// support the package.json `exports` field for resolving subpath exports.

$492f0fb96695dd9f$exports = (parcelRequire("3vQ1E"));


/**
 * @param {string} msg
 */ function $d0b61ef20bcb31bc$export$a8ecead220dd38a6(msg) {
    const toast = document.getElementById("toast");
    if (!toast) return;
    // @ts-ignore
    toast.innerHTML = msg;
    toast.classList.remove('error');
    toast?.classList.add("show");
}
function $d0b61ef20bcb31bc$export$b410431fab84fa58(msg) {
    const toast = document.getElementById("toast");
    if (!toast) return;
    // @ts-ignore
    toast.innerHTML = msg;
    toast.classList.remove('error');
    $d0b61ef20bcb31bc$var$show(toast, 1500);
}
function $d0b61ef20bcb31bc$export$a3bc9b8ed74fc(msg) {
    const toast = document.getElementById("toast");
    if (!toast) return;
    // @ts-ignore
    toast.innerHTML = `<h3>B\u{142}\u{105}d!</h3>${msg}`;
    toast.classList.add('error');
    $d0b61ef20bcb31bc$var$show(toast, 10000);
}
function $d0b61ef20bcb31bc$export$491112666e282270(msg) {
    const toast = document.getElementById("toast");
    if (!toast) return;
    // @ts-ignore
    toast.innerHTML = msg;
    toast.classList.add('warning');
    $d0b61ef20bcb31bc$var$show(toast, 6000);
}
/**
 * @param {HTMLElement} toast
 * @param {number} ms
 */ function $d0b61ef20bcb31bc$var$show(toast, ms) {
    toast?.classList.add("show");
    setTimeout(()=>{
        toast?.classList.remove("show");
    }, ms);
}


class $2e0d7d2a9ac04488$export$2e2bcd8739ae039 {
    constructor(url, mute404 = false){
        this.url = url;
        this.mute404 = mute404;
    }
    async getJson() {
        const response = await fetch(this.url, {
            headers: {
                'Accept': 'application/json'
            },
            method: 'GET'
        });
        return await this.#parseResponse(response);
    }
    async getHtml() {
        const response = await fetch(this.url, {
            headers: {
                'Accept': 'text/html'
            },
            method: 'GET'
        });
        const repl = await response.text();
        if (response.ok) return repl;
        throw new Error(repl);
    }
    async post(data, headers = {}) {
        return await this.#postOrPatch(data, 'POST', headers);
    }
    async postForm(data, headers = {}) {
        const response = await fetch(this.url, {
            headers: {
                'Accept': 'application/json',
                ...headers
            },
            method: 'POST',
            body: data
        });
        return await this.#parseResponse(response);
    }
    async patch(data, headers = {}) {
        return await this.#postOrPatch(data, 'PATCH', headers);
    }
    async delete(data, headers = {}) {
        return await this.#postOrPatch(data, 'DELETE', headers);
    }
    async #postOrPatch(data, method, headers) {
        const response = await fetch(this.url, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                ...headers
            },
            method: method,
            body: JSON.stringify(data)
        });
        return await this.#parseResponse(response);
    }
    async #parseResponse(response) {
        const repl = await response.json();
        if (response.ok) return repl;
        if (response.status != 404 || !this.mute404) (0, $d0b61ef20bcb31bc$export$a3bc9b8ed74fc)(repl.error);
        throw new Error(repl.error, repl);
    }
}


var $957c80ea0e8f87df$exports = {};
$957c80ea0e8f87df$exports = JSON.parse('{"draft":{"name":"Draft","action":null,"allowed":["ready"],"comment":"Stworzenie zg\u0142oszenia","editable":true,"sendable":false},"ready":{"name":"Edycja","action":null,"allowed":["draft","confirmed","ready"],"comment":"Zapisanie wersji roboczej","editable":true,"sendable":false},"confirmed":{"name":"Nowe","action":"Zg\u0142oszenie gotowe do wys\u0142ania","allowed":["ready","sending","sending-problem","sending-failed","confirmed-waiting","archived"],"comment":"Zapisanie gotowego zg\u0142oszenia","editable":true,"sendable":true},"sending":{"name":"Wysy\u0142am","action":null,"allowed":["sending-problem","sending-failed","confirmed-waiting","archived"],"comment":"Wysy\u0142ka w trakcie","editable":false,"sendable":false},"sending-problem":{"name":"Problem z wysy\u0142k\u0105","action":null,"allowed":["sending-failed","confirmed-waiting","archived"],"comment":"Tymczasowy problem z wysy\u0142k\u0105","editable":false,"sendable":false},"sending-failed":{"name":"Niewys\u0142ane","action":null,"allowed":["sending","sending-problem","confirmed-waiting","archived"],"comment":"Nie uda\u0142o si\u0119 wys\u0142a\u0107 wiadomo\u015Bci","editable":false,"sendable":true},"confirmed-waiting":{"name":"Wys\u0142ane","action":"Zg\u0142oszenie zosta\u0142o wys\u0142ane","allowed":["confirmed-sm","confirmed-fined","confirmed-instructed","confirmed-ignored","archived"],"comment":"Wys\u0142anie zg\u0142oszenia","editable":false,"sendable":false},"confirmed-waitingE":{"name":"Wys\u0142ane epuap","action":"Zg\u0142oszenie zosta\u0142o wys\u0142ane przez EPUAP","allowed":["confirmed-sm","confirmed-fined","confirmed-instructed","confirmed-ignored","archived"],"comment":"Wys\u0142anie zg\u0142oszenia za pomoc\u0105 EPUAP","editable":false,"sendable":false},"confirmed-sm":{"name":"Potwierdzone","action":"Zg\u0142oszenie zosta\u0142o potwierdzone","allowed":["confirmed-fined","confirmed-instructed","confirmed-ignored","archived"],"comment":"Potwierdzenie przyj\u0119cia zg\u0142oszenia przez/w SM","editable":false,"sendable":false},"confirmed-fined":{"name":"Mandat","action":"Kierowca dosta\u0142 mandat","recydywa":"Kierowca tego pojazdu zosta\u0142 ukarany mandatem","allowed":["confirmed-instructed","confirmed-ignored","confirmed-sm","archived"],"comment":"Kierowca zosta\u0142 ukarany mandatem","editable":false,"sendable":false},"confirmed-instructed":{"name":"Pouczenie","action":"Kierowca zosta\u0142 pouczony","recydywa":"Kierowca tego pojazdu zosta\u0142 pouczony","allowed":["confirmed-fined","confirmed-ignored","confirmed-complaint","confirmed-sm","archived"],"comment":"Kierowca zosta\u0142 pouczony","editable":false,"sendable":false},"confirmed-ignored":{"name":"Zignorowane","action":"Nie ukarano ani nie pouczono kierowcy","recydywa":"Kierowca tego pojazdu pope\u0142ni\u0142 wykroczenie, ale nie zosta\u0142 niestety ukarany","allowed":["confirmed-fined","confirmed-instructed","confirmed-complaint","confirmed-sm","archived"],"comment":"Zg\u0142oszenie zosta\u0142o zignorowane, SM/Policja nie ustali\u0142a sprawcy albo nie doszuka\u0142a si\u0119 znamion wykroczenia","editable":false,"sendable":false},"confirmed-complaint":{"name":"Za\u017Calone","action":"Z\u0142o\u017Cone oficjalne za\u017Calenie","recydywa":"Post\u0119powanie wzgl\u0119dem wykroczenia kierowcy tego pojazdu zosta\u0142o zaskar\u017Cone w trybie art. 56a kpw","allowed":["confirmed-fined","confirmed-instructed","confirmed-ignored","archived"],"comment":"Z\u0142o\u017Cone oficjalne za\u017Calenie zgodnie z art. 56a kpw","editable":false,"sendable":false},"archived":{"name":"W archiwum","action":"Przenie\u015B do archiwum","allowed":["confirmed","confirmed-waiting"],"comment":"Zg\u0142oszenie zosta\u0142o zarchiwizowane","editable":false,"sendable":false,"confirmationNeeded":true}}');


async function $7d7309fb7d5d541e$export$e23f2da38df8914e(appId, status) {
    if ($957c80ea0e8f87df$exports[status]?.confirmationNeeded) {
        const confirmation = window.confirm("Czy na pewno chcesz przenies\u0107 zg\u0142oszenie do archiwum?");
        if (!confirmation) return;
    }
    const changeStatusButton = document.getElementById(`changeStatus${appId}`);
    if (changeStatusButton) changeStatusButton.classList.add('disabled');
    const api = new (0, $2e0d7d2a9ac04488$export$2e2bcd8739ae039)(`/api/app/${appId}/status/${status}`);
    const result = await api.patch();
    if (result?.patronite) // @ts-ignore
    document.getElementById('patronite')?.showModal();
    $7d7309fb7d5d541e$export$dd127eb7207846ef(appId, status);
    if (changeStatusButton) changeStatusButton.classList.remove('disabled');
    _paq.push([
        'trackEvent',
        'Application',
        'set-status',
        status
    ]);
}
// @ts-ignore
window.setStatus = $7d7309fb7d5d541e$export$e23f2da38df8914e;
function $7d7309fb7d5d541e$export$dd127eb7207846ef(appId, status) {
    const statusDef = $957c80ea0e8f87df$exports[status];
    const popup = document.getElementById("changeStatus" + appId);
    const application = document.getElementById(appId);
    if (popup) {
        const links = popup.querySelectorAll("li a");
        links.forEach((link)=>{
            const parent = /** @type {HTMLElement} */ link.parentElement;
            if (parent) parent.style.display = 'none';
        });
        statusDef.allowed.forEach(function(allowed) {
            const allowedLink = popup.querySelector("a." + allowed);
            if (allowedLink && allowedLink.parentElement) /** @type {HTMLElement} */ allowedLink.parentElement.style.display = 'block';
        });
    }
    const oldStatus = Object.keys($957c80ea0e8f87df$exports).find((s)=>application?.classList.contains(s));
    if (application) {
        const allClasses = Object.keys($957c80ea0e8f87df$exports).join(" ");
        application.classList.remove(...allClasses.split(' '));
        application.classList.add(status);
        const statusDots = application.querySelectorAll('div.status-dot');
        statusDots.forEach((dot)=>{
            dot.classList.remove(...allClasses.split(' '));
            dot.classList.add(status);
        });
        const detailsStatusText = application.querySelector(".application-details-list > .status-dot > b");
        if (detailsStatusText) detailsStatusText.textContent = statusDef.name.toUpperCase();
        const topLineStatusText = application.querySelector(".top-line > .status-dot > b");
        if (topLineStatusText) topLineStatusText.textContent = statusDef.name.toUpperCase();
    }
    $7d7309fb7d5d541e$export$d4f872c3eb032313(oldStatus, status);
}
function $7d7309fb7d5d541e$export$d4f872c3eb032313(oldStatus, newStatus) {
    if (!oldStatus || oldStatus === newStatus) return;
    $7d7309fb7d5d541e$var$bumpCounter(oldStatus, -1);
    $7d7309fb7d5d541e$var$bumpCounter(newStatus, 1);
}
function $7d7309fb7d5d541e$var$bumpCounter(status, delta) {
    const link = document.querySelector(`.status-filter a[id="${status}"]`);
    const item = /** @type {HTMLElement|null} */ link?.parentElement;
    const counter = item?.querySelector('.li-count');
    if (!item || !counter) return;
    const count = Math.max(0, parseInt(counter.textContent || '0') + delta);
    counter.textContent = count.toString();
    item.style.display = count > 0 ? 'block' : 'none';
}






/**
 * @param {{ apply: (arg0: any, arg1: IArguments) => void; }} callback
 * @param {number} ms
 */ function $9c7ecb60e349f774$var$delay(callback, ms) {
    var timer = null;
    return function() {
        var context = this, args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function() {
            callback.apply(context, args);
        }, ms || 0);
    };
}
var $9c7ecb60e349f774$export$2e2bcd8739ae039 = $9c7ecb60e349f774$var$delay;


function $88af1a0600537ba4$var$makeDropdown() {
    const dropdowns = document.querySelectorAll(".dropdown > button");
    for (let dropdown of dropdowns)dropdown.addEventListener("click", (event)=>{
        const dropdownContent = event?.target?.parentElement?.getElementsByClassName('dropdown-content').item(0);
        dropdownContent.classList.toggle('show');
    });
}
function $88af1a0600537ba4$var$dropdownClick(event) {
    if (event.target.matches('.dropdown-button')) return;
    const dropdowns = document.querySelectorAll(".dropdown-content.show");
    for (let dropdown of dropdowns)dropdown.classList.remove('show');
}
window.addEventListener("click", $88af1a0600537ba4$var$dropdownClick);
var $88af1a0600537ba4$export$2e2bcd8739ae039 = $88af1a0600537ba4$var$makeDropdown;


function $7625c8a76fddb1fb$var$makeDialog() {
    const dialogs = document.querySelectorAll('dialog');
    dialogs.forEach((dialog)=>dialog.addEventListener('mousedown', (event)=>{
            if (event.target === event.currentTarget) // @ts-ignore
            event.currentTarget?.close();
        }));
    const popups = document.querySelectorAll('a[data-rel=popup]');
    popups.forEach((popup)=>{
        popup.addEventListener("click", function() {
            const id = this.hash.substring(1);
            // @ts-ignore
            document.getElementById(id)?.showModal();
        });
    });
}
var $7625c8a76fddb1fb$export$2e2bcd8739ae039 = $7625c8a76fddb1fb$var$makeDialog;




const $c8e3ef1fa8730cc4$var$PAGE_SIZE = 100;
document.addEventListener("DOMContentLoaded", ()=>{
    const appsList = document.getElementById('apps-list');
    if (!appsList) return;
    (0, $7625c8a76fddb1fb$export$2e2bcd8739ae039)();
    // the list is replaced/appended on search, so delegate clicks
    appsList.addEventListener("click", (e)=>{
        const target = /** @type {HTMLElement} */ e.target;
        const more = target.closest("div.displayAllApps a");
        if (more) {
            e.preventDefault();
            $c8e3ef1fa8730cc4$var$loadMore(/** @type {HTMLElement} */ more);
            return;
        }
        const h3 = target.closest("h3");
        if (h3 && h3.parentElement?.parentElement === appsList) $c8e3ef1fa8730cc4$export$bbab7acbc3a2f3a5(h3.parentElement);
    });
    const search = /** @type {HTMLInputElement|null} */ document.getElementById('apps');
    search?.addEventListener("input", (0, $9c7ecb60e349f774$export$2e2bcd8739ae039)(()=>$c8e3ef1fa8730cc4$var$reloadApps(), 300));
    const filters = document.querySelectorAll(".status-filter a") || [];
    for (let filter of filters)filter.addEventListener("click", $c8e3ef1fa8730cc4$var$filterAppsHandler);
    // close „recydywa” dialong on Esc
    const recydywaElement = document.getElementById('recydywa');
    if (recydywaElement) {
        document.addEventListener('keyup', (e)=>{
            if (e.key === "Escape") recydywaElement.style.display = 'none';
        });
        recydywaElement.addEventListener('click', (_e)=>{
            recydywaElement.style.display = 'none';
        });
    }
});
/** @param {Event} e */ function $c8e3ef1fa8730cc4$var$filterAppsHandler(e) {
    e.preventDefault();
    const appsList = document.getElementById('apps-list');
    if (!appsList) return;
    const target = /** @type {HTMLElement} */ this;
    const active = target.classList.contains('active');
    document.querySelectorAll(".status-filter a").forEach((el)=>el.classList.remove("active"));
    if (!active) target.classList.add("active");
    appsList.dataset.status = active ? 'all' : target.id;
    $c8e3ef1fa8730cc4$var$reloadApps();
}
let $c8e3ef1fa8730cc4$var$lastRequest = 0;
/**
 * @param {number} offset
 */ async function $c8e3ef1fa8730cc4$var$fetchApps(offset) {
    const appsList = document.getElementById('apps-list');
    const search = /** @type {HTMLInputElement|null} */ document.getElementById('apps');
    const params = new URLSearchParams({
        status: appsList?.dataset.status || 'all',
        search: search?.value.trim() || '',
        limit: String($c8e3ef1fa8730cc4$var$PAGE_SIZE),
        offset: String(offset)
    });
    const request = ++$c8e3ef1fa8730cc4$var$lastRequest;
    const html = await new (0, $2e0d7d2a9ac04488$export$2e2bcd8739ae039)(`/app/partial?${params}`).getHtml();
    // a newer search was started in the meantime
    if (request !== $c8e3ef1fa8730cc4$var$lastRequest) return null;
    // keep the filter on reload
    const url = new URL(window.location.href);
    url.search = '';
    if (params.get('status') !== 'all') url.searchParams.set('status', params.get('status') || '');
    if (params.get('search')) url.searchParams.set('q', params.get('search') || '');
    history.replaceState(null, '', url);
    return html;
}
async function $c8e3ef1fa8730cc4$var$reloadApps() {
    const appsList = document.getElementById('apps-list');
    if (!appsList) return;
    appsList.classList.add('loading');
    try {
        const html = await $c8e3ef1fa8730cc4$var$fetchApps(0);
        if (html !== null) appsList.innerHTML = html;
    } catch (e) {
        (0, $d0b61ef20bcb31bc$export$a3bc9b8ed74fc)(e.message);
    } finally{
        appsList.classList.remove('loading');
    }
}
/** @param {HTMLElement} button */ async function $c8e3ef1fa8730cc4$var$loadMore(button) {
    const container = button.parentElement;
    button.classList.add('disabled');
    try {
        const html = await $c8e3ef1fa8730cc4$var$fetchApps(parseInt(button.dataset.offset || '0'));
        if (html === null) return;
        container?.insertAdjacentHTML('beforebegin', html);
        container?.remove();
    } catch (e) {
        button.classList.remove('disabled');
        (0, $d0b61ef20bcb31bc$export$a3bc9b8ed74fc)(e.message);
    }
}
function $c8e3ef1fa8730cc4$export$7f8924f9d827bc64() {
    const expanded = document.querySelectorAll("#apps-list .expanded");
    for (let app of expanded){
        app.classList.remove("expanded");
        const appDetailsDiv = app.getElementsByClassName("app-details").item(0);
        // @ts-ignore
        appDetailsDiv.innerHTML = "";
    }
}
async function $c8e3ef1fa8730cc4$export$bbab7acbc3a2f3a5(target) {
    if (!target) return;
    const appId = target.id;
    const appDetailsDiv = target.getElementsByClassName("app-details").item(0);
    const close = target.classList.contains("expanded");
    $c8e3ef1fa8730cc4$export$7f8924f9d827bc64();
    if (close) return; // dont expand clicked element
    target.classList.add("expanded");
    // @ts-ignore
    appDetailsDiv.innerHTML = '<div class="loader"></div>';
    const api = new (0, $2e0d7d2a9ac04488$export$2e2bcd8739ae039)(`/app/partial/${appId}`);
    const appDetails = await api.getHtml();
    location.hash = `#${appId}`;
    // @ts-ignore
    appDetailsDiv.innerHTML = appDetails;
    (0, $88af1a0600537ba4$export$2e2bcd8739ae039)();
    document.querySelectorAll('a.send-application').forEach((link)=>{
        link.addEventListener('click', async function(e) {
            e.preventDefault();
            // Prevent multiple clicks
            if (this.classList.contains('sending')) return;
            this.classList.add('sending');
            const appId = this.dataset.appid;
            try {
                await (0, $78108ba22a655e06$export$2e2bcd8739ae039)(appId);
            } catch (err) {
                console.error('Failed to send application:', err);
            // Error toast is already shown by sendApplication, just log here
            } finally{
                this.classList.remove('sending');
            }
        });
    });
    document.querySelectorAll('a.recydywa-seemore').forEach((link)=>{
        link.addEventListener('click', async function() {
            const plateId = this.dataset.plateid;
            const recydywaElement = document.getElementById('recydywa');
            const recydywaContent = document.querySelector('#recydywa .popup-content');
            if (recydywaContent) recydywaContent.innerHTML = '<div class="loader"></div>';
            if (recydywaElement) recydywaElement.style.display = 'block';
            const api = new (0, $2e0d7d2a9ac04488$export$2e2bcd8739ae039)(`/app/recydywa/partial/${plateId}`);
            const recydywa = await api.getHtml();
            if (recydywaContent) recydywaContent.innerHTML = recydywa;
        });
    });
    document.querySelectorAll('.app-field-editable').forEach((field)=>{
        field.addEventListener('focusout', async function() {
            const initialValue = this.dataset.initialValue ?? '';
            const newValue = this.value ?? '';
            if (initialValue === newValue) return;
            const body = {
                [this.name]: newValue
            };
            this.setAttribute('readonly', "true");
            try {
                const api = new (0, $2e0d7d2a9ac04488$export$2e2bcd8739ae039)(`/api/app/${appId}/fields`);
                const reply = await api.patch(body);
                this.removeAttribute('readonly');
                this.classList.remove("error");
                this.setAttribute("data-initial-value", newValue);
                if (reply.suggestStatusChange) {
                    if (confirm("Zg\u0142oszenie ma numer sprawy. Zmieni\u0107 jego status na \u201Epotwierdzone\u201D?")) (0, $7d7309fb7d5d541e$export$e23f2da38df8914e)(appId, 'confirmed-sm');
                }
            } catch (e) {
                this.removeAttribute('readonly');
                this.classList.add("error");
            }
        });
    });
}


async function $78108ba22a655e06$var$sendApplication(/** @type {string} */ appId) {
    const whatNext = document.querySelector(".whatNext");
    const afterSend = document.querySelector(".afterSend");
    // Use getElementById to avoid issues with IDs starting with numbers
    const appElement = document.getElementById(appId);
    const statusElement = appElement?.querySelector('.status-confirmed-waiting');
    if (statusElement) statusElement.classList.add("disabled");
    (0, $d0b61ef20bcb31bc$export$a8ecead220dd38a6)("Wysy\u0142am...");
    try {
        const api = new (0, $2e0d7d2a9ac04488$export$2e2bcd8739ae039)(`/api/app/${appId}/send`);
        const msg = await api.patch();
        (0, $7d7309fb7d5d541e$export$dd127eb7207846ef)(appId, msg.status);
        (0, $d0b61ef20bcb31bc$export$b410431fab84fa58)("Wys\u0142ane");
        if (document.querySelector(".dziekujemy")) {
            if (whatNext) /** @type {HTMLElement} */ whatNext.style.display = 'none';
            if (afterSend) /** @type {HTMLElement} */ afterSend.style.display = 'block';
        }
        if (document.querySelector('.my-applications')) {
            (0, $c8e3ef1fa8730cc4$export$7f8924f9d827bc64)();
            (0, $c8e3ef1fa8730cc4$export$bbab7acbc3a2f3a5)(document.getElementById(appId));
        }
        // @ts-ignore
        typeof ga == 'function' && ga("send", "event", {
            eventCategory: "js",
            eventAction: "sendViaAPI"
        });
    } catch (e) {
        (0, $d0b61ef20bcb31bc$export$a3bc9b8ed74fc)(e.message);
        if (whatNext) /** @type {HTMLElement} */ whatNext.style.display = 'none';
        $492f0fb96695dd9f$exports.captureException(e, {
            extra: e.message
        });
        if (afterSend) {
            afterSend.textContent = "B\u0142\u0105d: " + e.message;
            /** @type {HTMLElement} */ afterSend.style.display = 'block';
            afterSend.classList.add('error');
        }
        // @ts-ignore
        if (typeof ga == 'function') // @ts-ignore
        ga("send", "event", {
            eventCategory: "js-error",
            eventAction: "sendViaAPI"
        });
        throw e // Re-throw to allow caller to handle
        ;
    } finally{
        $78108ba22a655e06$export$2e765e68db96fa95();
    }
}
function $78108ba22a655e06$export$2e765e68db96fa95() {
    document.querySelectorAll('.button.disabled').forEach((button)=>{
        button.classList.remove("disabled");
    });
}
var $78108ba22a655e06$export$2e2bcd8739ae039 = $78108ba22a655e06$var$sendApplication;





function $9897809a589d544d$export$a6c2d27607295951(stackParser, ex) {
    const frames = $9897809a589d544d$var$parseStackFrames(stackParser, ex);
    const exception = {
        type: $9897809a589d544d$export$2e9ae379995d99e3(ex),
        value: $9897809a589d544d$export$86005d1b62804363(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === void 0 && exception.value === "") exception.value = "Unrecoverable error caught";
    return exception;
}
function $9897809a589d544d$var$eventFromPlainObject(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $492f0fb96695dd9f$exports.getClient)();
    const normalizeDepth = client?.getOptions().normalizeDepth;
    const errorFromProp = $9897809a589d544d$var$getErrorPropertyFromObject(exception);
    const extra = {
        __serialized__: (0, $492f0fb96695dd9f$exports.normalizeToSize)(exception, normalizeDepth)
    };
    if (errorFromProp) return {
        exception: {
            values: [
                $9897809a589d544d$export$a6c2d27607295951(stackParser, errorFromProp)
            ]
        },
        extra: extra
    };
    const event = {
        exception: {
            values: [
                {
                    type: (0, $492f0fb96695dd9f$exports.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? "UnhandledRejection" : "Error",
                    value: $9897809a589d544d$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: extra
    };
    if (syntheticException) {
        const frames = $9897809a589d544d$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
function $9897809a589d544d$var$eventFromError(stackParser, ex) {
    return {
        exception: {
            values: [
                $9897809a589d544d$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
function $9897809a589d544d$var$parseStackFrames(stackParser, ex) {
    const stacktrace = ex.stacktrace || ex.stack || "";
    const skipLines = $9897809a589d544d$var$getSkipFirstStackStringLines(ex);
    const framesToPop = $9897809a589d544d$var$getPopFirstTopFrames(ex);
    try {
        return stackParser(stacktrace, skipLines, framesToPop);
    } catch  {}
    return [];
}
const $9897809a589d544d$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $9897809a589d544d$var$getSkipFirstStackStringLines(ex) {
    if (ex && $9897809a589d544d$var$reactMinifiedRegexp.test(ex.message)) return 1;
    return 0;
}
function $9897809a589d544d$var$getPopFirstTopFrames(ex) {
    if (typeof ex.framesToPop === "number") return ex.framesToPop;
    return 0;
}
function $9897809a589d544d$var$isWebAssemblyException(exception) {
    if (typeof WebAssembly !== "undefined" && typeof WebAssembly.Exception !== "undefined") return exception instanceof WebAssembly.Exception;
    else return false;
}
function $9897809a589d544d$export$2e9ae379995d99e3(ex) {
    const name = ex?.name;
    if (!name && $9897809a589d544d$var$isWebAssemblyException(ex)) {
        const hasTypeInMessage = ex.message && Array.isArray(ex.message) && ex.message.length == 2;
        return hasTypeInMessage ? ex.message[0] : "WebAssembly.Exception";
    }
    return name;
}
function $9897809a589d544d$export$86005d1b62804363(ex) {
    const message = ex?.message;
    if ($9897809a589d544d$var$isWebAssemblyException(ex)) {
        if (Array.isArray(ex.message) && ex.message.length == 2) return ex.message[1];
        return "wasm exception";
    }
    if (!message) return "No error message";
    if (message.error && typeof message.error.message === "string") return (0, $492f0fb96695dd9f$exports._INTERNAL_enhanceErrorWithSentryInfo)(message.error);
    return (0, $492f0fb96695dd9f$exports._INTERNAL_enhanceErrorWithSentryInfo)(ex);
}
function $9897809a589d544d$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint?.syntheticException || void 0;
    const event = $9897809a589d544d$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $492f0fb96695dd9f$exports.addExceptionMechanism)(event);
    event.level = "error";
    if (hint?.event_id) event.event_id = hint.event_id;
    return (0, $492f0fb96695dd9f$exports.resolvedSyncPromise)(event);
}
function $9897809a589d544d$export$5425b53185d13d6c(stackParser, message, level = "info", hint, attachStacktrace) {
    const syntheticException = hint?.syntheticException || void 0;
    const event = $9897809a589d544d$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint?.event_id) event.event_id = hint.event_id;
    return (0, $492f0fb96695dd9f$exports.resolvedSyncPromise)(event);
}
function $9897809a589d544d$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $492f0fb96695dd9f$exports.isErrorEvent)(exception) && exception.error) {
        const errorEvent = exception;
        return $9897809a589d544d$var$eventFromError(stackParser, errorEvent.error);
    }
    if ((0, $492f0fb96695dd9f$exports.isDOMError)(exception) || (0, $492f0fb96695dd9f$exports.isDOMException)(exception)) {
        const domException = exception;
        if ("stack" in exception) {
            event = $9897809a589d544d$var$eventFromError(stackParser, exception);
            const firstException = event.exception?.values?.[0];
            if (attachStacktrace && syntheticException && firstException && !firstException.stacktrace) {
                const frames = $9897809a589d544d$var$parseStackFrames(stackParser, syntheticException);
                if (frames.length) {
                    firstException.stacktrace = {
                        frames: frames
                    };
                    (0, $492f0fb96695dd9f$exports.addExceptionMechanism)(event, {
                        synthetic: true
                    });
                }
            }
        } else {
            const name = domException.name || ((0, $492f0fb96695dd9f$exports.isDOMError)(domException) ? "DOMError" : "DOMException");
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $9897809a589d544d$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
            (0, $492f0fb96695dd9f$exports.addExceptionTypeValue)(event, message);
        }
        if ("code" in domException) event.tags = {
            ...event.tags,
            "DOMException.code": `${domException.code}`
        };
        return event;
    }
    if ((0, $492f0fb96695dd9f$exports.isError)(exception)) return $9897809a589d544d$var$eventFromError(stackParser, exception);
    if ((0, $492f0fb96695dd9f$exports.isPlainObject)(exception) || (0, $492f0fb96695dd9f$exports.isEvent)(exception)) {
        const objectException = exception;
        event = $9897809a589d544d$var$eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $492f0fb96695dd9f$exports.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    event = $9897809a589d544d$var$eventFromString(stackParser, exception, syntheticException, attachStacktrace);
    (0, $492f0fb96695dd9f$exports.addExceptionTypeValue)(event, `${exception}`, void 0);
    (0, $492f0fb96695dd9f$exports.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
function $9897809a589d544d$var$eventFromString(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $9897809a589d544d$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
        (0, $492f0fb96695dd9f$exports.addExceptionMechanism)(event, {
            synthetic: true
        });
    }
    if ((0, $492f0fb96695dd9f$exports.isParameterizedString)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $9897809a589d544d$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $492f0fb96695dd9f$exports.extractExceptionKeysForMessage)(exception);
    const captureType = isUnhandledRejection ? "promise rejection" : "exception";
    if ((0, $492f0fb96695dd9f$exports.isErrorEvent)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $492f0fb96695dd9f$exports.isEvent)(exception)) {
        const className = $9897809a589d544d$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $9897809a589d544d$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : void 0;
    } catch  {}
}
function $9897809a589d544d$var$getErrorPropertyFromObject(obj) {
    return Object.values(obj).find((v)=>v instanceof Error);
}



const $2b391a84339b074a$export$56d8a8a25bd48b81 = (0, $492f0fb96695dd9f$exports.GLOBAL_OBJ);
let $2b391a84339b074a$var$ignoreOnError = 0;
function $2b391a84339b074a$export$b79738ab10c590b2() {
    return $2b391a84339b074a$var$ignoreOnError > 0;
}
function $2b391a84339b074a$export$1265a142ff5ba165() {
    $2b391a84339b074a$var$ignoreOnError++;
    setTimeout(()=>{
        $2b391a84339b074a$var$ignoreOnError--;
    });
}
function $2b391a84339b074a$export$4997ffc0176396a6(fn, options = {}) {
    function isFunction(fn2) {
        return typeof fn2 === "function";
    }
    if (!isFunction(fn)) return fn;
    try {
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) {
            if (typeof wrapper === "function") return wrapper;
            else return fn;
        }
        if ((0, $492f0fb96695dd9f$exports.getOriginalFunction)(fn)) return fn;
    } catch  {
        return fn;
    }
    const sentryWrapped = function(...args) {
        (0, $492f0fb96695dd9f$exports.GLOBAL_OBJ)._sentryWrappedDepth = ((0, $492f0fb96695dd9f$exports.GLOBAL_OBJ)._sentryWrappedDepth || 0) + 1;
        try {
            const wrappedArguments = args.map((arg)=>$2b391a84339b074a$export$4997ffc0176396a6(arg, options));
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $2b391a84339b074a$export$1265a142ff5ba165();
            (0, $492f0fb96695dd9f$exports.withScope)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $492f0fb96695dd9f$exports.addExceptionTypeValue)(event, void 0, void 0);
                        (0, $492f0fb96695dd9f$exports.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $492f0fb96695dd9f$exports.captureException)(ex);
            });
            throw ex;
        } finally{
            (0, $492f0fb96695dd9f$exports.GLOBAL_OBJ)._sentryWrappedDepth = ((0, $492f0fb96695dd9f$exports.GLOBAL_OBJ)._sentryWrappedDepth || 0) - 1;
        }
    };
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch  {}
    (0, $492f0fb96695dd9f$exports.markFunctionWrapped)(sentryWrapped, fn);
    (0, $492f0fb96695dd9f$exports.addNonEnumerableProperty)(fn, "__sentry_wrapped__", sentryWrapped);
    try {
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, "name");
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, "name", {
            get () {
                return fn.name;
            }
        });
    } catch  {}
    return sentryWrapped;
}
function $2b391a84339b074a$export$a3c4a8453e8936f0() {
    const url = (0, $492f0fb96695dd9f$exports.getLocationHref)();
    const { referrer: referrer } = $2b391a84339b074a$export$56d8a8a25bd48b81.document || {};
    const { userAgent: userAgent } = $2b391a84339b074a$export$56d8a8a25bd48b81.navigator || {};
    const headers = {
        ...referrer && {
            Referer: referrer
        },
        ...userAgent && {
            "User-Agent": userAgent
        }
    };
    const request = {
        url: url,
        headers: headers
    };
    return request;
}


class $34f1afb37b6dc268$export$1df9218a526d318d extends (0, $492f0fb96695dd9f$exports.Client) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const opts = $34f1afb37b6dc268$export$4e107b20a7f977(options);
        const sdkSource = (0, $2b391a84339b074a$export$56d8a8a25bd48b81).SENTRY_SDK_SOURCE || (0, $492f0fb96695dd9f$exports.getSDKSource)();
        (0, $492f0fb96695dd9f$exports.applySdkMetadata)(opts, "browser", [
            "browser"
        ], sdkSource);
        if (opts._metadata?.sdk) opts._metadata.sdk.settings = {
            infer_ip: opts.sendDefaultPii ? "auto" : "never",
            // purposefully allowing already passed settings to override the default
            ...opts._metadata.sdk.settings
        };
        super(opts);
        const { sendDefaultPii: sendDefaultPii, sendClientReports: sendClientReports, enableLogs: enableLogs, _experiments: _experiments, enableMetrics: enableMetricsOption } = this._options;
        const enableMetrics = enableMetricsOption ?? _experiments?.enableMetrics ?? true;
        if ((0, $2b391a84339b074a$export$56d8a8a25bd48b81).document && (sendClientReports || enableLogs || enableMetrics)) (0, $2b391a84339b074a$export$56d8a8a25bd48b81).document.addEventListener("visibilitychange", ()=>{
            if ((0, $2b391a84339b074a$export$56d8a8a25bd48b81).document.visibilityState === "hidden") {
                if (sendClientReports) this._flushOutcomes();
                if (enableLogs) (0, $492f0fb96695dd9f$exports._INTERNAL_flushLogsBuffer)(this);
                if (enableMetrics) (0, $492f0fb96695dd9f$exports._INTERNAL_flushMetricsBuffer)(this);
            }
        });
        if (sendDefaultPii) this.on("beforeSendSession", (0, $492f0fb96695dd9f$exports.addAutoIpAddressToSession));
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $9897809a589d544d$export$ea3ec7e569b823fc)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, level = "info", hint) {
        return (0, $9897809a589d544d$export$5425b53185d13d6c)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        event.platform = event.platform || "javascript";
        return super._prepareEvent(event, hint, currentScope, isolationScope);
    }
}
function $34f1afb37b6dc268$export$4e107b20a7f977(optionsArg) {
    return {
        release: typeof __SENTRY_RELEASE__ === "string" ? __SENTRY_RELEASE__ : (0, $2b391a84339b074a$export$56d8a8a25bd48b81).SENTRY_RELEASE?.id,
        // This supports the variable that sentry-webpack-plugin injects
        sendClientReports: true,
        // We default this to true, as it is the safer scenario
        parentSpanIsAlwaysRootSpan: true,
        ...optionsArg
    };
}



const $2deb03c4495ce01f$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;


const $fb93b22781dedf8e$export$31499a9cd224b78c = "10.55.0";


const $f217104c897b328f$export$f1a6cdb1459e81d1 = globalThis;


function $f93478a31a56772c$export$19eade501500c6c1() {
    $f93478a31a56772c$export$c8bfa33e4e8ae492((0, $f217104c897b328f$export$f1a6cdb1459e81d1));
    return 0, $f217104c897b328f$export$f1a6cdb1459e81d1;
}
function $f93478a31a56772c$export$c8bfa33e4e8ae492(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.version = __SENTRY__.version || (0, $fb93b22781dedf8e$export$31499a9cd224b78c);
    return __SENTRY__[0, $fb93b22781dedf8e$export$31499a9cd224b78c] = __SENTRY__[0, $fb93b22781dedf8e$export$31499a9cd224b78c] || {};
}
function $f93478a31a56772c$export$7e223ec222791509(name, creator, obj = (0, $f217104c897b328f$export$f1a6cdb1459e81d1)) {
    const __SENTRY__ = obj.__SENTRY__ = obj.__SENTRY__ || {};
    const carrier = __SENTRY__[0, $fb93b22781dedf8e$export$31499a9cd224b78c] = __SENTRY__[0, $fb93b22781dedf8e$export$31499a9cd224b78c] || {};
    return carrier[name] || (carrier[name] = creator());
}




const $dd4af310e95b2daa$export$2a2b1d2252a69ecb = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
const $dd4af310e95b2daa$var$PREFIX = "Sentry Logger ";
const $dd4af310e95b2daa$export$77c4ce905194557b = {};
function $dd4af310e95b2daa$export$cda52e2a8927a2ca(callback) {
    if (!("console" in (0, $f217104c897b328f$export$f1a6cdb1459e81d1))) return callback();
    const console = (0, $f217104c897b328f$export$f1a6cdb1459e81d1).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($dd4af310e95b2daa$export$77c4ce905194557b);
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $dd4af310e95b2daa$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $dd4af310e95b2daa$var$enable() {
    $dd4af310e95b2daa$var$_getLoggerSettings().enabled = true;
}
function $dd4af310e95b2daa$var$disable() {
    $dd4af310e95b2daa$var$_getLoggerSettings().enabled = false;
}
function $dd4af310e95b2daa$var$isEnabled() {
    return $dd4af310e95b2daa$var$_getLoggerSettings().enabled;
}
function $dd4af310e95b2daa$var$log(...args) {
    $dd4af310e95b2daa$var$_maybeLog("log", ...args);
}
function $dd4af310e95b2daa$var$warn(...args) {
    $dd4af310e95b2daa$var$_maybeLog("warn", ...args);
}
function $dd4af310e95b2daa$var$error(...args) {
    $dd4af310e95b2daa$var$_maybeLog("error", ...args);
}
function $dd4af310e95b2daa$var$_maybeLog(level, ...args) {
    if (!(0, $2deb03c4495ce01f$export$16a28057038b10ef)) return;
    if ($dd4af310e95b2daa$var$isEnabled()) $dd4af310e95b2daa$export$cda52e2a8927a2ca(()=>{
        (0, $f217104c897b328f$export$f1a6cdb1459e81d1).console[level](`${$dd4af310e95b2daa$var$PREFIX}[${level}]:`, ...args);
    });
}
function $dd4af310e95b2daa$var$_getLoggerSettings() {
    if (!(0, $2deb03c4495ce01f$export$16a28057038b10ef)) return {
        enabled: false
    };
    return (0, $f93478a31a56772c$export$7e223ec222791509)("loggerSettings", ()=>({
            enabled: false
        }));
}
const $dd4af310e95b2daa$export$1c9f709888824e05 = {
    enable: /** Enable logging. */ $dd4af310e95b2daa$var$enable,
    disable: /** Disable logging. */ $dd4af310e95b2daa$var$disable,
    isEnabled: /** Check if logging is enabled. */ $dd4af310e95b2daa$var$isEnabled,
    log: /** Log a message. */ $dd4af310e95b2daa$var$log,
    warn: /** Log a warning. */ $dd4af310e95b2daa$var$warn,
    error: /** Log an error. */ $dd4af310e95b2daa$var$error
};


const $4f18ccbe39bfd9ec$var$STACKTRACE_FRAME_LIMIT = 50;
const $4f18ccbe39bfd9ec$export$27c7e15d453fc0ac = "?";
const $4f18ccbe39bfd9ec$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $4f18ccbe39bfd9ec$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
function $4f18ccbe39bfd9ec$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split("\n");
        for(let i = skipFirstLines; i < lines.length; i++){
            let line = lines[i];
            if (line.length > 1024) line = line.slice(0, 1024);
            const cleanedLine = $4f18ccbe39bfd9ec$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($4f18ccbe39bfd9ec$var$WEBPACK_ERROR_REGEXP, "$1") : line;
            if (cleanedLine.includes("Error: ")) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $4f18ccbe39bfd9ec$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $4f18ccbe39bfd9ec$export$c55c24c0eeba0205(frames.slice(framesToPop));
    };
}
function $4f18ccbe39bfd9ec$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $4f18ccbe39bfd9ec$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
function $4f18ccbe39bfd9ec$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    if (/sentryWrapped/.test($4f18ccbe39bfd9ec$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    localStack.reverse();
    if ($4f18ccbe39bfd9ec$var$STRIP_FRAME_REGEXP.test($4f18ccbe39bfd9ec$var$getLastStackFrame(localStack).function || "")) {
        localStack.pop();
        if ($4f18ccbe39bfd9ec$var$STRIP_FRAME_REGEXP.test($4f18ccbe39bfd9ec$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    }
    return localStack.slice(0, $4f18ccbe39bfd9ec$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || $4f18ccbe39bfd9ec$var$getLastStackFrame(localStack).filename,
            function: frame.function || $4f18ccbe39bfd9ec$export$27c7e15d453fc0ac
        }));
}
function $4f18ccbe39bfd9ec$var$getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
const $4f18ccbe39bfd9ec$var$defaultFunctionName = "<anonymous>";
function $4f18ccbe39bfd9ec$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== "function") return $4f18ccbe39bfd9ec$var$defaultFunctionName;
        return fn.name || $4f18ccbe39bfd9ec$var$defaultFunctionName;
    } catch  {
        return $4f18ccbe39bfd9ec$var$defaultFunctionName;
    }
}
function $4f18ccbe39bfd9ec$export$91d8ca51bd9f6a47(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            exception.values.forEach((value)=>{
                if (value.stacktrace.frames) frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch  {
            return void 0;
        }
    }
    return void 0;
}
function $4f18ccbe39bfd9ec$export$60c0d6c8e038267a(path) {
    let filename = path?.startsWith("file://") ? path.slice(7) : path;
    if (filename?.match(/\/[A-Z]:/)) filename = filename.slice(1);
    return filename;
}


const $ed9549bff616fd38$var$handlers = {};
const $ed9549bff616fd38$var$instrumented = {};
function $ed9549bff616fd38$export$a4e09611e30da72e(type, handler) {
    $ed9549bff616fd38$var$handlers[type] = $ed9549bff616fd38$var$handlers[type] || [];
    $ed9549bff616fd38$var$handlers[type].push(handler);
    return ()=>{
        const typeHandlers = $ed9549bff616fd38$var$handlers[type];
        if (typeHandlers) {
            const index = typeHandlers.indexOf(handler);
            if (index !== -1) typeHandlers.splice(index, 1);
        }
    };
}
function $ed9549bff616fd38$export$b17eab759a1cb5fe() {
    Object.keys($ed9549bff616fd38$var$handlers).forEach((key)=>{
        $ed9549bff616fd38$var$handlers[key] = void 0;
    });
}
function $ed9549bff616fd38$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$ed9549bff616fd38$var$instrumented[type]) {
        $ed9549bff616fd38$var$instrumented[type] = true;
        try {
            instrumentFn();
        } catch (e) {
            (0, $2deb03c4495ce01f$export$16a28057038b10ef) && (0, $dd4af310e95b2daa$export$1c9f709888824e05).error(`Error while instrumenting ${type}`, e);
        }
    }
}
function $ed9549bff616fd38$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $ed9549bff616fd38$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $2deb03c4495ce01f$export$16a28057038b10ef) && (0, $dd4af310e95b2daa$export$1c9f709888824e05).error(`Error while triggering instrumentation handler.
Type: ${type}
Name: ${(0, $4f18ccbe39bfd9ec$export$aad197c7121a6651)(handler)}
Error:`, e);
    }
}



const $2660f95a1b0d39e6$var$objectToString = Object.prototype.toString;
function $2660f95a1b0d39e6$export$e6127cc7fe7395c3(wat) {
    switch($2660f95a1b0d39e6$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
        case "[object WebAssembly.Exception]":
            return true;
        default:
            return $2660f95a1b0d39e6$export$49034edbe6b62415(wat, Error);
    }
}
function $2660f95a1b0d39e6$var$isBuiltin(wat, className) {
    return $2660f95a1b0d39e6$var$objectToString.call(wat) === `[object ${className}]`;
}
function $2660f95a1b0d39e6$export$9f9636d330b71954(wat) {
    return $2660f95a1b0d39e6$var$isBuiltin(wat, "ErrorEvent");
}
function $2660f95a1b0d39e6$export$ef9e2056653f0c8e(wat) {
    return $2660f95a1b0d39e6$var$isBuiltin(wat, "DOMError");
}
function $2660f95a1b0d39e6$export$12e869b2a583f783(wat) {
    return $2660f95a1b0d39e6$var$isBuiltin(wat, "DOMException");
}
function $2660f95a1b0d39e6$export$844ec244b1367d54(wat) {
    return $2660f95a1b0d39e6$var$isBuiltin(wat, "String");
}
function $2660f95a1b0d39e6$export$dbcbffa59149b824(wat) {
    return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
function $2660f95a1b0d39e6$export$c3825b437cbdea5c(wat) {
    return wat === null || $2660f95a1b0d39e6$export$dbcbffa59149b824(wat) || typeof wat !== "object" && typeof wat !== "function";
}
function $2660f95a1b0d39e6$export$53b83ca8eaab0383(wat) {
    return $2660f95a1b0d39e6$var$isBuiltin(wat, "Object");
}
function $2660f95a1b0d39e6$export$9671ea99bd126ace(wat) {
    return typeof Event !== "undefined" && $2660f95a1b0d39e6$export$49034edbe6b62415(wat, Event);
}
function $2660f95a1b0d39e6$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== "undefined" && $2660f95a1b0d39e6$export$49034edbe6b62415(wat, Element);
}
function $2660f95a1b0d39e6$export$49841c62b9eff15(wat) {
    return $2660f95a1b0d39e6$var$isBuiltin(wat, "RegExp");
}
function $2660f95a1b0d39e6$export$f5b060c2914b97c8(wat) {
    return Boolean(wat?.then && typeof wat.then === "function");
}
function $2660f95a1b0d39e6$export$bc2894c7158efbac(wat) {
    return $2660f95a1b0d39e6$export$53b83ca8eaab0383(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
function $2660f95a1b0d39e6$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch  {
        return false;
    }
}
function $2660f95a1b0d39e6$export$7916fad0ebc23f48(wat) {
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue || wat.__v_isVNode));
}
function $2660f95a1b0d39e6$export$6d3d1f317d7cda57(request) {
    return typeof Request !== "undefined" && $2660f95a1b0d39e6$export$49034edbe6b62415(request, Request);
}


function $a964b80d2257757d$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    if (typeof original !== "function") return;
    const wrapped = replacementFactory(original);
    if (typeof wrapped === "function") $a964b80d2257757d$export$5c1499e2e5d010ae(wrapped, original);
    try {
        source[name] = wrapped;
    } catch  {
        (0, $2deb03c4495ce01f$export$16a28057038b10ef) && (0, $dd4af310e95b2daa$export$1c9f709888824e05).log(`Failed to replace method "${name}" in object`, source);
    }
}
function $a964b80d2257757d$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            value: // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value,
            writable: true,
            configurable: true
        });
    } catch  {
        (0, $2deb03c4495ce01f$export$16a28057038b10ef) && (0, $dd4af310e95b2daa$export$1c9f709888824e05).log(`Failed to add non-enumerable property "${String(name)}" to object`, obj);
    }
}
function $a964b80d2257757d$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $a964b80d2257757d$export$e73679ffaf56810e(wrapped, "__sentry_original__", original);
    } catch  {}
}
function $a964b80d2257757d$export$e00416b3cd122575(obj, field, wrapped, enumerable = true) {
    const original = obj[field];
    if (typeof original !== "function") throw new Error(`Cannot wrap method: ${field} is not a function`);
    if ($a964b80d2257757d$export$e6cc1e135e2092e5(original)) throw new Error(`Attempting to wrap method ${field} multiple times`);
    $a964b80d2257757d$export$5c1499e2e5d010ae(wrapped, original);
    Object.defineProperty(obj, field, {
        writable: true,
        configurable: true,
        enumerable: enumerable,
        value: wrapped
    });
}
function $a964b80d2257757d$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
function $a964b80d2257757d$export$62ff257738bf57f5(value) {
    if ((0, $2660f95a1b0d39e6$export$e6127cc7fe7395c3)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$a964b80d2257757d$var$getOwnProperties(value)
    };
    if ((0, $2660f95a1b0d39e6$export$9671ea99bd126ace)(value)) {
        const { type: type, target: target, currentTarget: currentTarget, detail: detail } = value;
        return {
            type: type,
            target: target,
            currentTarget: currentTarget,
            ...detail ? {
                detail: detail
            } : {},
            ...$a964b80d2257757d$var$getOwnProperties(value)
        };
    }
    return value;
}
function $a964b80d2257757d$var$getOwnProperties(obj) {
    if (typeof obj === "object" && obj !== null) return Object.fromEntries(Object.entries(obj));
    return {};
}
function $a964b80d2257757d$export$b0244d5063c0b61b(exception) {
    const keys = Object.keys($a964b80d2257757d$export$62ff257738bf57f5(exception));
    keys.sort();
    return !keys[0] ? "[object has no keys]" : keys.join(", ");
}
function $a964b80d2257757d$export$d25f2688db1bb433(inputValue) {
    const memoizationMap = /* @__PURE__ */ new Map();
    return $a964b80d2257757d$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $a964b80d2257757d$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if (inputValue === null || typeof inputValue !== "object") return inputValue;
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== void 0) return memoVal;
    if (Array.isArray(inputValue)) {
        const returnValue = [];
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((value)=>{
            returnValue.push($a964b80d2257757d$var$_dropUndefinedKeys(value, memoizationMap));
        });
        return returnValue;
    }
    if ($a964b80d2257757d$var$isPojo(inputValue)) {
        const returnValue = {};
        memoizationMap.set(inputValue, returnValue);
        const keys = Object.keys(inputValue);
        keys.forEach((key)=>{
            const val = inputValue[key];
            if (val !== void 0) returnValue[key] = $a964b80d2257757d$var$_dropUndefinedKeys(val, memoizationMap);
        });
        return returnValue;
    }
    return inputValue;
}
function $a964b80d2257757d$var$isPojo(input) {
    const constructor = input.constructor;
    return constructor === Object || constructor === void 0;
}
function $a964b80d2257757d$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == void 0:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $2660f95a1b0d39e6$export$c3825b437cbdea5c)(wat):
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}



let $0d33076536fcb49a$var$RESOLVED_RUNNER;
function $0d33076536fcb49a$export$ff239213cb80e2da(cb) {
    if ($0d33076536fcb49a$var$RESOLVED_RUNNER !== void 0) return $0d33076536fcb49a$var$RESOLVED_RUNNER ? $0d33076536fcb49a$var$RESOLVED_RUNNER(cb) : cb();
    const sym = /* @__PURE__ */ Symbol.for("__SENTRY_SAFE_RANDOM_ID_WRAPPER__");
    const globalWithSymbol = (0, $f217104c897b328f$export$f1a6cdb1459e81d1);
    if (sym in globalWithSymbol && typeof globalWithSymbol[sym] === "function") {
        $0d33076536fcb49a$var$RESOLVED_RUNNER = globalWithSymbol[sym];
        return $0d33076536fcb49a$var$RESOLVED_RUNNER(cb);
    }
    $0d33076536fcb49a$var$RESOLVED_RUNNER = null;
    return cb();
}
function $0d33076536fcb49a$export$9869d72de32a3917() {
    return $0d33076536fcb49a$export$ff239213cb80e2da(()=>Math.random());
}
function $0d33076536fcb49a$export$65b1bada40c91b34() {
    return $0d33076536fcb49a$export$ff239213cb80e2da(()=>Date.now());
}




const $7b4fe4199b67a06e$var$SENTRY_SKIP_NORMALIZATION = /* @__PURE__ */ Symbol.for("sentry.skipNormalization");
const $7b4fe4199b67a06e$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH = /* @__PURE__ */ Symbol.for("sentry.overrideNormalizationDepth");
function $7b4fe4199b67a06e$export$280812de8e91ea53(obj) {
    (0, $a964b80d2257757d$export$e73679ffaf56810e)(obj, $7b4fe4199b67a06e$var$SENTRY_SKIP_NORMALIZATION, true);
}
function $7b4fe4199b67a06e$export$610d1422c4bdc4c1(obj, depth) {
    (0, $a964b80d2257757d$export$e73679ffaf56810e)(obj, $7b4fe4199b67a06e$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH, depth);
}
function $7b4fe4199b67a06e$export$c8d26b7b28f926c7(value) {
    return Boolean(value[$7b4fe4199b67a06e$var$SENTRY_SKIP_NORMALIZATION]);
}
function $7b4fe4199b67a06e$export$fe95a19841c4b155(value) {
    const v = value[$7b4fe4199b67a06e$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH];
    return typeof v === "number" ? v : void 0;
}




let $ac4a8bdf538bbe1f$var$stringifier;
function $ac4a8bdf538bbe1f$export$575c40989754ba4d(newStringifier) {
    $ac4a8bdf538bbe1f$var$stringifier = newStringifier;
}
function $ac4a8bdf538bbe1f$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        return $ac4a8bdf538bbe1f$var$visit("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
function $ac4a8bdf538bbe1f$export$23fbbb20bed71033(object, depth = 3, maxSize = 102400) {
    const normalized = $ac4a8bdf538bbe1f$export$a3295358bff77e(object, depth);
    if ($ac4a8bdf538bbe1f$var$jsonSize(normalized) > maxSize) return $ac4a8bdf538bbe1f$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
function $ac4a8bdf538bbe1f$var$visit(key, value, depth = Infinity, maxProperties = Infinity, memo = $ac4a8bdf538bbe1f$var$memoBuilder()) {
    const [memoize, unmemoize] = memo;
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "boolean",
        "string"
    ].includes(typeof value) || typeof value === "number" && Number.isFinite(value)) return value;
    const stringified = $ac4a8bdf538bbe1f$export$a110e5bc79f44a84(key, value);
    if (!stringified.startsWith("[object ")) return stringified;
    if ((0, $7b4fe4199b67a06e$export$c8d26b7b28f926c7)(value)) return value;
    const overrideDepth = (0, $7b4fe4199b67a06e$export$fe95a19841c4b155)(value);
    const remainingDepth = overrideDepth !== void 0 ? overrideDepth : depth;
    if (remainingDepth === 0) return stringified.replace("object ", "");
    if (memoize(value)) return "[Circular ~]";
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        const jsonValue = valueWithToJSON.toJSON();
        return $ac4a8bdf538bbe1f$var$visit("", jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch  {}
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    const visitable = (0, $a964b80d2257757d$export$62ff257738bf57f5)(value);
    for(const visitKey in visitable){
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $ac4a8bdf538bbe1f$var$visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    unmemoize(value);
    return normalized;
}
function $ac4a8bdf538bbe1f$export$a110e5bc79f44a84(key, value) {
    try {
        if ($ac4a8bdf538bbe1f$var$stringifier) {
            const stringified = $ac4a8bdf538bbe1f$var$stringifier(value);
            if (stringified) return stringified;
        }
        if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
        if (typeof value === "number" && !Number.isFinite(value)) return `[${value}]`;
        if (typeof value === "function") return `[Function: ${(0, $4f18ccbe39bfd9ec$export$aad197c7121a6651)(value)}]`;
        if (typeof value === "symbol") return `[${String(value)}]`;
        if (typeof value === "bigint") return `[BigInt: ${String(value)}]`;
        const objName = $ac4a8bdf538bbe1f$var$getConstructorName(value);
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
function $ac4a8bdf538bbe1f$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype?.constructor ? prototype.constructor.name : "null prototype";
}
function $ac4a8bdf538bbe1f$var$utf8Length(value) {
    return ~-encodeURI(value).split(/%..|./).length;
}
function $ac4a8bdf538bbe1f$var$jsonSize(value) {
    return $ac4a8bdf538bbe1f$var$utf8Length(JSON.stringify(value));
}
function $ac4a8bdf538bbe1f$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath.replace(/\\/g, "/").replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch  {}
    return newUrl.replace(/\\/g, "/").replace(/webpack:\/?/g, "").replace(new RegExp(`(file://)?/*${escapedBase}/*`, "ig"), "app:///");
}
function $ac4a8bdf538bbe1f$var$memoBuilder() {
    const inner = /* @__PURE__ */ new WeakSet();
    function memoize(obj) {
        if (inner.has(obj)) return true;
        inner.add(obj);
        return false;
    }
    function unmemoize(obj) {
        inner.delete(obj);
    }
    return [
        memoize,
        unmemoize
    ];
}


function $2088fbfa8bfbfeb6$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
function $2088fbfa8bfbfeb6$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
function $2088fbfa8bfbfeb6$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return "";
    const output = [];
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        if ((0, $2660f95a1b0d39e6$export$c3825b437cbdea5c)(value)) output.push(String(value));
        else if (value instanceof Error) output.push(value.message ? `${value.name}: ${value.message}` : value.name);
        else output.push((0, $ac4a8bdf538bbe1f$export$a110e5bc79f44a84)(void 0, value));
    }
    return output.join(delimiter);
}
function $2088fbfa8bfbfeb6$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $2660f95a1b0d39e6$export$844ec244b1367d54)(value)) return false;
    if ((0, $2660f95a1b0d39e6$export$49841c62b9eff15)(pattern)) return pattern.test(value);
    if ((0, $2660f95a1b0d39e6$export$844ec244b1367d54)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    if (typeof pattern === "function") return pattern(value);
    return false;
}
function $2088fbfa8bfbfeb6$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    for (const pattern of patterns){
        if ($2088fbfa8bfbfeb6$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch)) return true;
    }
    return false;
}



function $5f9617f585b2f74f$var$getCrypto() {
    const gbl = (0, $f217104c897b328f$export$f1a6cdb1459e81d1);
    return gbl.crypto || gbl.msCrypto;
}
let $5f9617f585b2f74f$var$emptyUuid;
function $5f9617f585b2f74f$var$getRandomByte() {
    return (0, $0d33076536fcb49a$export$9869d72de32a3917)() * 16;
}
function $5f9617f585b2f74f$export$19f53698e68b2496(crypto = $5f9617f585b2f74f$var$getCrypto()) {
    try {
        if (crypto?.randomUUID) return (0, $0d33076536fcb49a$export$ff239213cb80e2da)(()=>crypto.randomUUID()).replace(/-/g, "");
    } catch  {}
    if (!$5f9617f585b2f74f$var$emptyUuid) $5f9617f585b2f74f$var$emptyUuid = "10000000100040008000100000000000";
    return $5f9617f585b2f74f$var$emptyUuid.replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ ($5f9617f585b2f74f$var$getRandomByte() & 15) >> c / 4).toString(16));
}
function $5f9617f585b2f74f$var$getFirstException(event) {
    return event.exception?.values?.[0];
}
function $5f9617f585b2f74f$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $5f9617f585b2f74f$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
function $5f9617f585b2f74f$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
function $5f9617f585b2f74f$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $5f9617f585b2f74f$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: "generic",
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && "data" in newMechanism) {
        const mergedData = {
            ...currentMechanism?.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
const $5f9617f585b2f74f$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
function $5f9617f585b2f74f$var$_parseInt(input) {
    return parseInt(input || "", 10);
}
function $5f9617f585b2f74f$export$d364f2020ab30578(input) {
    const match = input.match($5f9617f585b2f74f$var$SEMVER_REGEXP) || [];
    const major = $5f9617f585b2f74f$var$_parseInt(match[1]);
    const minor = $5f9617f585b2f74f$var$_parseInt(match[2]);
    const patch = $5f9617f585b2f74f$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? void 0 : major,
        minor: isNaN(minor) ? void 0 : minor,
        patch: isNaN(patch) ? void 0 : patch,
        prerelease: match[4]
    };
}
function $5f9617f585b2f74f$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    if (frame.lineno === void 0) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $2088fbfa8bfbfeb6$export$4215662d762d6f9d)(line, 0));
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    frame.context_line = (0, $2088fbfa8bfbfeb6$export$4215662d762d6f9d)(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $2088fbfa8bfbfeb6$export$4215662d762d6f9d)(line, 0));
}
function $5f9617f585b2f74f$export$6de4ffac6a2f1098(exception) {
    if ($5f9617f585b2f74f$export$4a38e013f66150b(exception)) return true;
    try {
        (0, $a964b80d2257757d$export$e73679ffaf56810e)(exception, "__sentry_captured__", true);
    } catch  {}
    return false;
}
function $5f9617f585b2f74f$export$4a38e013f66150b(exception) {
    try {
        return exception.__sentry_captured__;
    } catch  {}
}



const $e601f21e4bdef308$export$56d8a8a25bd48b81 = (0, $f217104c897b328f$export$f1a6cdb1459e81d1);


const $f50b0324088e687b$var$DEBOUNCE_DURATION = 1e3;
let $f50b0324088e687b$var$debounceTimerID;
let $f50b0324088e687b$var$lastCapturedEventType;
let $f50b0324088e687b$var$lastCapturedEventTargetId;
function $f50b0324088e687b$export$5aeffd3db2cf9df7(handler) {
    const type = "dom";
    (0, $ed9549bff616fd38$export$a4e09611e30da72e)(type, handler);
    (0, $ed9549bff616fd38$export$e18d6c5462c01368)(type, $f50b0324088e687b$export$3014bbf0af0e1d4a);
}
function $f50b0324088e687b$export$3014bbf0af0e1d4a() {
    if (!(0, $e601f21e4bdef308$export$56d8a8a25bd48b81).document) return;
    const triggerDOMHandler = (0, $ed9549bff616fd38$export$b18c893e424d3127).bind(null, "dom");
    const globalDOMEventHandler = $f50b0324088e687b$var$makeDOMEventHandler(triggerDOMHandler, true);
    (0, $e601f21e4bdef308$export$56d8a8a25bd48b81).document.addEventListener("click", globalDOMEventHandler, false);
    (0, $e601f21e4bdef308$export$56d8a8a25bd48b81).document.addEventListener("keypress", globalDOMEventHandler, false);
    [
        "EventTarget",
        "Node"
    ].forEach((target)=>{
        const globalObject = (0, $e601f21e4bdef308$export$56d8a8a25bd48b81);
        const proto = globalObject[target]?.prototype;
        if (!proto?.hasOwnProperty?.("addEventListener")) return;
        (0, $a964b80d2257757d$export$9563e054e6f787fb)(proto, "addEventListener", function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const handlers = this.__sentry_instrumentation_handlers__ = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $f50b0324088e687b$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch  {}
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $a964b80d2257757d$export$9563e054e6f787fb)(proto, "removeEventListener", function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const handlers = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = void 0;
                            delete handlers[type];
                        }
                        if (Object.keys(handlers).length === 0) delete this.__sentry_instrumentation_handlers__;
                    }
                } catch  {}
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
function $f50b0324088e687b$var$isSimilarToLastCapturedEvent(event) {
    if (event.type !== $f50b0324088e687b$var$lastCapturedEventType) return false;
    try {
        if (!event.target || event.target._sentryId !== $f50b0324088e687b$var$lastCapturedEventTargetId) return false;
    } catch  {}
    return true;
}
function $f50b0324088e687b$var$shouldSkipDOMEvent(eventType, target) {
    if (eventType !== "keypress") return false;
    if (!target?.tagName) return true;
    if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable) return false;
    return true;
}
function $f50b0324088e687b$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        if (!event || event["_sentryCaptured"]) return;
        const target = $f50b0324088e687b$var$getEventTarget(event);
        if ($f50b0324088e687b$var$shouldSkipDOMEvent(event.type, target)) return;
        (0, $a964b80d2257757d$export$e73679ffaf56810e)(event, "_sentryCaptured", true);
        if (target && !target._sentryId) (0, $a964b80d2257757d$export$e73679ffaf56810e)(target, "_sentryId", (0, $5f9617f585b2f74f$export$19f53698e68b2496)());
        const name = event.type === "keypress" ? "input" : event.type;
        if (!$f50b0324088e687b$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $f50b0324088e687b$var$lastCapturedEventType = event.type;
            $f50b0324088e687b$var$lastCapturedEventTargetId = target ? target._sentryId : void 0;
        }
        clearTimeout($f50b0324088e687b$var$debounceTimerID);
        $f50b0324088e687b$var$debounceTimerID = (0, $e601f21e4bdef308$export$56d8a8a25bd48b81).setTimeout(()=>{
            $f50b0324088e687b$var$lastCapturedEventTargetId = void 0;
            $f50b0324088e687b$var$lastCapturedEventType = void 0;
        }, $f50b0324088e687b$var$DEBOUNCE_DURATION);
    };
}
function $f50b0324088e687b$var$getEventTarget(event) {
    try {
        return event.target;
    } catch  {
        return null;
    }
}




const $01c1392b0a01fb13$var$WINDOW = (0, $f217104c897b328f$export$f1a6cdb1459e81d1);
function $01c1392b0a01fb13$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent("");
        return true;
    } catch  {
        return false;
    }
}
function $01c1392b0a01fb13$export$1c08bd1a7eb3c472() {
    try {
        new DOMError("");
        return true;
    } catch  {
        return false;
    }
}
function $01c1392b0a01fb13$export$ab12a5d056f1d3a() {
    try {
        new DOMException("");
        return true;
    } catch  {
        return false;
    }
}
function $01c1392b0a01fb13$export$67fc34576016d6ec() {
    return "history" in $01c1392b0a01fb13$var$WINDOW && !!$01c1392b0a01fb13$var$WINDOW.history;
}
const $01c1392b0a01fb13$export$edf3cb81fd7d2a3e = $01c1392b0a01fb13$var$_isFetchSupported;
function $01c1392b0a01fb13$var$_isFetchSupported() {
    if (!("fetch" in $01c1392b0a01fb13$var$WINDOW)) return false;
    try {
        new Headers();
        new Request("data:,");
        new Response();
        return true;
    } catch  {
        return false;
    }
}
function $01c1392b0a01fb13$export$d5f608b368e73f38(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
function $01c1392b0a01fb13$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === "string") return true;
    if (!$01c1392b0a01fb13$var$_isFetchSupported()) return false;
    if ($01c1392b0a01fb13$export$d5f608b368e73f38($01c1392b0a01fb13$var$WINDOW.fetch)) return true;
    let result = false;
    const doc = $01c1392b0a01fb13$var$WINDOW.document;
    if (doc && typeof doc.createElement === "function") try {
        const sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow?.fetch) result = $01c1392b0a01fb13$export$d5f608b368e73f38(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $2deb03c4495ce01f$export$16a28057038b10ef) && (0, $dd4af310e95b2daa$export$1c9f709888824e05).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
function $01c1392b0a01fb13$export$531055a6c684a70a() {
    return "ReportingObserver" in $01c1392b0a01fb13$var$WINDOW;
}
function $01c1392b0a01fb13$export$2d308b428295192f() {
    if (!$01c1392b0a01fb13$var$_isFetchSupported()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch  {
        return false;
    }
}



let $3e85eb28f9001ea3$var$lastHref;
function $3e85eb28f9001ea3$export$3f18c56c58114e75(handler) {
    const type = "history";
    (0, $ed9549bff616fd38$export$a4e09611e30da72e)(type, handler);
    (0, $ed9549bff616fd38$export$e18d6c5462c01368)(type, $3e85eb28f9001ea3$export$d9b613a6254a184e);
}
function $3e85eb28f9001ea3$export$d9b613a6254a184e() {
    (0, $e601f21e4bdef308$export$56d8a8a25bd48b81).addEventListener("popstate", ()=>{
        const to = (0, $e601f21e4bdef308$export$56d8a8a25bd48b81).location.href;
        const from = $3e85eb28f9001ea3$var$lastHref;
        $3e85eb28f9001ea3$var$lastHref = to;
        if (from === to) return;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $ed9549bff616fd38$export$b18c893e424d3127)("history", handlerData);
    });
    if (!(0, $01c1392b0a01fb13$export$67fc34576016d6ec)()) return;
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : void 0;
            if (url) {
                const from = $3e85eb28f9001ea3$var$lastHref;
                const to = $3e85eb28f9001ea3$var$getAbsoluteUrl(String(url));
                $3e85eb28f9001ea3$var$lastHref = to;
                if (from === to) return originalHistoryFunction.apply(this, args);
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $ed9549bff616fd38$export$b18c893e424d3127)("history", handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $a964b80d2257757d$export$9563e054e6f787fb)((0, $e601f21e4bdef308$export$56d8a8a25bd48b81).history, "pushState", historyReplacementFunction);
    (0, $a964b80d2257757d$export$9563e054e6f787fb)((0, $e601f21e4bdef308$export$56d8a8a25bd48b81).history, "replaceState", historyReplacementFunction);
}
function $3e85eb28f9001ea3$var$getAbsoluteUrl(urlOrPath) {
    try {
        const url = new URL(urlOrPath, (0, $e601f21e4bdef308$export$56d8a8a25bd48b81).location.origin);
        return url.toString();
    } catch  {
        return urlOrPath;
    }
}



const $fd9cf0b48f691186$var$ONE_SECOND_IN_MS = 1e3;
function $fd9cf0b48f691186$export$7740643b9eeaf0c4() {
    return (0, $0d33076536fcb49a$export$65b1bada40c91b34)() / $fd9cf0b48f691186$var$ONE_SECOND_IN_MS;
}
function $fd9cf0b48f691186$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $f217104c897b328f$export$f1a6cdb1459e81d1);
    if (!performance?.now || !performance.timeOrigin) return $fd9cf0b48f691186$export$7740643b9eeaf0c4;
    const timeOrigin = performance.timeOrigin;
    return ()=>{
        return (timeOrigin + (0, $0d33076536fcb49a$export$ff239213cb80e2da)(()=>performance.now())) / $fd9cf0b48f691186$var$ONE_SECOND_IN_MS;
    };
}
let $fd9cf0b48f691186$var$_cachedTimestampInSeconds;
function $fd9cf0b48f691186$export$ee52dced521e3e18() {
    const func = $fd9cf0b48f691186$var$_cachedTimestampInSeconds ?? ($fd9cf0b48f691186$var$_cachedTimestampInSeconds = $fd9cf0b48f691186$var$createUnixTimestampInSecondsFunc());
    return func();
}
let $fd9cf0b48f691186$var$cachedTimeOrigin = null;
function $fd9cf0b48f691186$var$getBrowserTimeOrigin() {
    const { performance: performance } = (0, $f217104c897b328f$export$f1a6cdb1459e81d1);
    if (!performance?.now) return void 0;
    const threshold = 3e5;
    const performanceNow = (0, $0d33076536fcb49a$export$ff239213cb80e2da)(()=>performance.now());
    const dateNow = (0, $0d33076536fcb49a$export$65b1bada40c91b34)();
    const timeOrigin = performance.timeOrigin;
    if (typeof timeOrigin === "number") {
        const timeOriginDelta = Math.abs(timeOrigin + performanceNow - dateNow);
        if (timeOriginDelta < threshold) return timeOrigin;
    }
    const navigationStart = performance.timing?.navigationStart;
    if (typeof navigationStart === "number") {
        const navigationStartDelta = Math.abs(navigationStart + performanceNow - dateNow);
        if (navigationStartDelta < threshold) return navigationStart;
    }
    return dateNow - performanceNow;
}
function $fd9cf0b48f691186$export$baf075a948ffc0bf() {
    if ($fd9cf0b48f691186$var$cachedTimeOrigin === null) $fd9cf0b48f691186$var$cachedTimeOrigin = $fd9cf0b48f691186$var$getBrowserTimeOrigin();
    return $fd9cf0b48f691186$var$cachedTimeOrigin;
}



const $97eb65b7144e66a9$export$55b6bb1e45c6cf59 = "__sentry_xhr_v3__";
function $97eb65b7144e66a9$export$26ace48dd54c9aea(handler) {
    const type = "xhr";
    (0, $ed9549bff616fd38$export$a4e09611e30da72e)(type, handler);
    (0, $ed9549bff616fd38$export$e18d6c5462c01368)(type, $97eb65b7144e66a9$export$c67d533bf77cbf54);
}
function $97eb65b7144e66a9$export$c67d533bf77cbf54() {
    if (!(0, $e601f21e4bdef308$export$56d8a8a25bd48b81).XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    xhrproto.open = new Proxy(xhrproto.open, {
        apply (originalOpen, xhrOpenThisArg, xhrOpenArgArray) {
            const virtualError = new Error();
            const startTimestamp = (0, $fd9cf0b48f691186$export$ee52dced521e3e18)() * 1e3;
            const method = (0, $2660f95a1b0d39e6$export$844ec244b1367d54)(xhrOpenArgArray[0]) ? xhrOpenArgArray[0].toUpperCase() : void 0;
            const url = $97eb65b7144e66a9$var$parseXhrUrlArg(xhrOpenArgArray[1]);
            if (!method || !url) return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
            xhrOpenThisArg[$97eb65b7144e66a9$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            if (method === "POST" && url.match(/sentry_key/)) xhrOpenThisArg.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                const xhrInfo = xhrOpenThisArg[$97eb65b7144e66a9$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (xhrOpenThisArg.readyState === 4) {
                    try {
                        xhrInfo.status_code = xhrOpenThisArg.status;
                    } catch  {}
                    const handlerData = {
                        endTimestamp: (0, $fd9cf0b48f691186$export$ee52dced521e3e18)() * 1e3,
                        startTimestamp: startTimestamp,
                        xhr: xhrOpenThisArg,
                        virtualError: virtualError
                    };
                    (0, $ed9549bff616fd38$export$b18c893e424d3127)("xhr", handlerData);
                }
            };
            if ("onreadystatechange" in xhrOpenThisArg && typeof xhrOpenThisArg.onreadystatechange === "function") xhrOpenThisArg.onreadystatechange = new Proxy(xhrOpenThisArg.onreadystatechange, {
                apply (originalOnreadystatechange, onreadystatechangeThisArg, onreadystatechangeArgArray) {
                    onreadystatechangeHandler();
                    return originalOnreadystatechange.apply(onreadystatechangeThisArg, onreadystatechangeArgArray);
                }
            });
            else xhrOpenThisArg.addEventListener("readystatechange", onreadystatechangeHandler);
            xhrOpenThisArg.setRequestHeader = new Proxy(xhrOpenThisArg.setRequestHeader, {
                apply (originalSetRequestHeader, setRequestHeaderThisArg, setRequestHeaderArgArray) {
                    const [header, value] = setRequestHeaderArgArray;
                    const xhrInfo = setRequestHeaderThisArg[$97eb65b7144e66a9$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $2660f95a1b0d39e6$export$844ec244b1367d54)(header) && (0, $2660f95a1b0d39e6$export$844ec244b1367d54)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return originalSetRequestHeader.apply(setRequestHeaderThisArg, setRequestHeaderArgArray);
                }
            });
            return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
        }
    });
    xhrproto.send = new Proxy(xhrproto.send, {
        apply (originalSend, sendThisArg, sendArgArray) {
            const sentryXhrData = sendThisArg[$97eb65b7144e66a9$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(sendThisArg, sendArgArray);
            if (sendArgArray[0] !== void 0) sentryXhrData.body = sendArgArray[0];
            const handlerData = {
                startTimestamp: (0, $fd9cf0b48f691186$export$ee52dced521e3e18)() * 1e3,
                xhr: sendThisArg
            };
            (0, $ed9549bff616fd38$export$b18c893e424d3127)("xhr", handlerData);
            return originalSend.apply(sendThisArg, sendArgArray);
        }
    });
}
function $97eb65b7144e66a9$var$parseXhrUrlArg(url) {
    if ((0, $2660f95a1b0d39e6$export$844ec244b1367d54)(url)) return url;
    try {
        return url.toString();
    } catch  {}
    return void 0;
}


const $dea6f7c3fc893264$var$DEFAULT_MAX_STRING_LENGTH = 80;
function $dea6f7c3fc893264$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return "<unknown>";
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $dea6f7c3fc893264$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $dea6f7c3fc893264$var$_htmlElementAsString(currentElem, keyAttrs);
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch  {
        return "<unknown>";
    }
}
function $dea6f7c3fc893264$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    if (!elem?.tagName) return "";
    if (typeof HTMLElement !== "undefined") {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset["sentryComponent"]) return elem.dataset["sentryComponent"];
            if (elem.dataset["sentryElement"]) return elem.dataset["sentryElement"];
        }
    }
    out.push(elem.tagName.toLowerCase());
    const keyAttrPairs = keyAttrs?.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs?.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        const className = elem.className;
        if (className && (0, $2660f95a1b0d39e6$export$844ec244b1367d54)(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    for (const k of [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ]){
        const attr = elem.getAttribute(k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join("");
}


const $7b6b501ffbee5235$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;



const $dc4f734fe471b570$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $dc4f734fe471b570$var$INTEGRATION_NAME = "Breadcrumbs";
const $dc4f734fe471b570$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $dc4f734fe471b570$var$INTEGRATION_NAME,
        setup (client) {
            if (_options.console) (0, $492f0fb96695dd9f$exports.addConsoleInstrumentationHandler)($dc4f734fe471b570$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $f50b0324088e687b$export$5aeffd3db2cf9df7)($dc4f734fe471b570$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $97eb65b7144e66a9$export$26ace48dd54c9aea)($dc4f734fe471b570$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $492f0fb96695dd9f$exports.addFetchInstrumentationHandler)($dc4f734fe471b570$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $3e85eb28f9001ea3$export$3f18c56c58114e75)($dc4f734fe471b570$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry) client.on("beforeSendEvent", $dc4f734fe471b570$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $dc4f734fe471b570$export$c079d904b326663a = (0, $492f0fb96695dd9f$exports.defineIntegration)($dc4f734fe471b570$var$_breadcrumbsIntegration);
function $dc4f734fe471b570$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $492f0fb96695dd9f$exports.getClient)() !== client) return;
        (0, $492f0fb96695dd9f$exports.addBreadcrumb)({
            category: `sentry.${event.type === "transaction" ? "transaction" : "event"}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $492f0fb96695dd9f$exports.getEventDescription)(event)
        }, {
            event: event
        });
    };
}
function $dc4f734fe471b570$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $492f0fb96695dd9f$exports.getClient)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === "object" ? dom.serializeAttribute : void 0;
        let maxStringLength = typeof dom === "object" && typeof dom.maxStringLength === "number" ? dom.maxStringLength : void 0;
        if (maxStringLength && maxStringLength > $dc4f734fe471b570$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $7b6b501ffbee5235$export$16a28057038b10ef) && (0, $492f0fb96695dd9f$exports.debug).warn(`\`dom.maxStringLength\` cannot exceed ${$dc4f734fe471b570$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$dc4f734fe471b570$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $dc4f734fe471b570$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === "string") keyAttrs = [
            keyAttrs
        ];
        try {
            const event = handlerData.event;
            const element = $dc4f734fe471b570$var$_isEvent(event) ? event.target : event;
            target = (0, $dea6f7c3fc893264$export$5647df6b7814ac86)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $492f0fb96695dd9f$exports.getComponentName)(element);
        } catch  {
            target = "<unknown>";
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            "ui.component_name": componentName
        };
        (0, $492f0fb96695dd9f$exports.addBreadcrumb)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
function $dc4f734fe471b570$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $492f0fb96695dd9f$exports.getClient)() !== client) return;
        const breadcrumb = {
            category: "console",
            data: {
                arguments: handlerData.args,
                logger: "console"
            },
            level: (0, $492f0fb96695dd9f$exports.severityLevelFromString)(handlerData.level),
            message: (0, $492f0fb96695dd9f$exports.safeJoin)(handlerData.args, " ")
        };
        if (handlerData.level === "assert") {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $492f0fb96695dd9f$exports.safeJoin)(handlerData.args.slice(1), " ") || "console.assert"}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else return;
        }
        (0, $492f0fb96695dd9f$exports.addBreadcrumb)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
function $dc4f734fe471b570$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $492f0fb96695dd9f$exports.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $97eb65b7144e66a9$export$55b6bb1e45c6cf59];
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        const breadcrumb = {
            category: "xhr",
            data: data,
            type: "http",
            level: (0, $492f0fb96695dd9f$exports.getBreadcrumbLogLevelFromHttpStatusCode)(status_code)
        };
        client.emit("beforeOutgoingRequestBreadcrumb", breadcrumb, hint);
        (0, $492f0fb96695dd9f$exports.addBreadcrumb)(breadcrumb, hint);
    };
}
function $dc4f734fe471b570$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $492f0fb96695dd9f$exports.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === "POST") return;
        if (handlerData.error) {
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: "fetch",
                data: handlerData.fetchData,
                level: "error",
                type: "http"
            };
            client.emit("beforeOutgoingRequestBreadcrumb", breadcrumb, hint);
            (0, $492f0fb96695dd9f$exports.addBreadcrumb)(breadcrumb, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response?.status
            };
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: "fetch",
                data: data,
                type: "http",
                level: (0, $492f0fb96695dd9f$exports.getBreadcrumbLogLevelFromHttpStatusCode)(data.status_code)
            };
            client.emit("beforeOutgoingRequestBreadcrumb", breadcrumb, hint);
            (0, $492f0fb96695dd9f$exports.addBreadcrumb)(breadcrumb, hint);
        }
    };
}
function $dc4f734fe471b570$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $492f0fb96695dd9f$exports.getClient)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $492f0fb96695dd9f$exports.parseUrl)((0, $2b391a84339b074a$export$56d8a8a25bd48b81).location.href);
        let parsedFrom = from ? (0, $492f0fb96695dd9f$exports.parseUrl)(from) : void 0;
        const parsedTo = (0, $492f0fb96695dd9f$exports.parseUrl)(to);
        if (!parsedFrom?.path) parsedFrom = parsedLoc;
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $492f0fb96695dd9f$exports.addBreadcrumb)({
            category: "navigation",
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $dc4f734fe471b570$var$_isEvent(event) {
    return !!event && !!event.target;
}




const $e3869eafa5a7478c$var$DEFAULT_EVENT_TARGET = "EventTarget,Window,Node,ApplicationCache,AudioTrackList,BroadcastChannel,ChannelMergerNode,CryptoOperation,EventSource,FileReader,HTMLUnknownElement,IDBDatabase,IDBRequest,IDBTransaction,KeyOperation,MediaController,MessagePort,ModalWindow,Notification,SVGElementInstance,Screen,SharedWorker,TextTrack,TextTrackCue,TextTrackList,WebSocket,WebSocketWorker,Worker,XMLHttpRequest,XMLHttpRequestEventTarget,XMLHttpRequestUpload".split(",");
const $e3869eafa5a7478c$var$INTEGRATION_NAME = "BrowserApiErrors";
const $e3869eafa5a7478c$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        unregisterOriginalCallbacks: false,
        ...options
    };
    return {
        name: $e3869eafa5a7478c$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $492f0fb96695dd9f$exports.fill)((0, $2b391a84339b074a$export$56d8a8a25bd48b81), "setTimeout", $e3869eafa5a7478c$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $492f0fb96695dd9f$exports.fill)((0, $2b391a84339b074a$export$56d8a8a25bd48b81), "setInterval", $e3869eafa5a7478c$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $492f0fb96695dd9f$exports.fill)((0, $2b391a84339b074a$export$56d8a8a25bd48b81), "requestAnimationFrame", $e3869eafa5a7478c$var$_wrapRAF);
            if (_options.XMLHttpRequest && "XMLHttpRequest" in (0, $2b391a84339b074a$export$56d8a8a25bd48b81)) (0, $492f0fb96695dd9f$exports.fill)(XMLHttpRequest.prototype, "send", $e3869eafa5a7478c$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $e3869eafa5a7478c$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach((target)=>$e3869eafa5a7478c$var$_wrapEventTarget(target, _options));
            }
        }
    };
};
const $e3869eafa5a7478c$export$59bfe9f1c76150e = (0, $492f0fb96695dd9f$exports.defineIntegration)($e3869eafa5a7478c$var$_browserApiErrorsIntegration);
function $e3869eafa5a7478c$var$_wrapTimeFunction(original) {
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $2b391a84339b074a$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                handled: false,
                type: `auto.browser.browserapierrors.${(0, $492f0fb96695dd9f$exports.getFunctionName)(original)}`
            }
        });
        return original.apply(this, args);
    };
}
function $e3869eafa5a7478c$var$_wrapRAF(original) {
    return function(callback) {
        return original.apply(this, [
            (0, $2b391a84339b074a$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        handler: (0, $492f0fb96695dd9f$exports.getFunctionName)(original)
                    },
                    handled: false,
                    type: "auto.browser.browserapierrors.requestAnimationFrame"
                }
            })
        ]);
    };
}
function $e3869eafa5a7478c$var$_wrapXHR(originalSend) {
    return function(...args) {
        const xhr = this;
        const xmlHttpRequestProps = [
            "onload",
            "onerror",
            "onprogress",
            "onreadystatechange"
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === "function") (0, $492f0fb96695dd9f$exports.fill)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            handler: (0, $492f0fb96695dd9f$exports.getFunctionName)(original)
                        },
                        handled: false,
                        type: `auto.browser.browserapierrors.xhr.${prop}`
                    }
                };
                const originalFunction = (0, $492f0fb96695dd9f$exports.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $492f0fb96695dd9f$exports.getFunctionName)(originalFunction);
                return (0, $2b391a84339b074a$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $e3869eafa5a7478c$var$_wrapEventTarget(target, integrationOptions) {
    const globalObject = (0, $2b391a84339b074a$export$56d8a8a25bd48b81);
    const proto = globalObject[target]?.prototype;
    if (!proto?.hasOwnProperty?.("addEventListener")) return;
    (0, $492f0fb96695dd9f$exports.fill)(proto, "addEventListener", function(original) {
        return function(eventName, fn, options) {
            try {
                if ($e3869eafa5a7478c$var$isEventListenerObject(fn)) fn.handleEvent = (0, $2b391a84339b074a$export$4997ffc0176396a6)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            handler: (0, $492f0fb96695dd9f$exports.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: "auto.browser.browserapierrors.handleEvent"
                    }
                });
            } catch  {}
            if (integrationOptions.unregisterOriginalCallbacks) $e3869eafa5a7478c$var$unregisterOriginalCallback(this, eventName, fn);
            return original.apply(this, [
                eventName,
                (0, $2b391a84339b074a$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            handler: (0, $492f0fb96695dd9f$exports.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: "auto.browser.browserapierrors.addEventListener"
                    }
                }),
                options
            ]);
        };
    });
    (0, $492f0fb96695dd9f$exports.fill)(proto, "removeEventListener", function(originalRemoveEventListener) {
        return function(eventName, fn, options) {
            try {
                const originalEventHandler = fn.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch  {}
            return originalRemoveEventListener.call(this, eventName, fn, options);
        };
    });
}
function $e3869eafa5a7478c$var$isEventListenerObject(obj) {
    return typeof obj.handleEvent === "function";
}
function $e3869eafa5a7478c$var$unregisterOriginalCallback(target, eventName, fn) {
    if (target && typeof target === "object" && "removeEventListener" in target && typeof target.removeEventListener === "function") target.removeEventListener(eventName, fn);
}






const $7c0c681e37d09cf4$export$1baa7880e357371c = (0, $492f0fb96695dd9f$exports.defineIntegration)((options = {})=>{
    const lifecycle = options.lifecycle ?? "route";
    return {
        name: "BrowserSession",
        setupOnce () {
            if (typeof (0, $2b391a84339b074a$export$56d8a8a25bd48b81).document === "undefined") {
                (0, $7b6b501ffbee5235$export$16a28057038b10ef) && (0, $492f0fb96695dd9f$exports.debug).warn("Using the `browserSessionIntegration` in non-browser environments is not supported.");
                return;
            }
            (0, $492f0fb96695dd9f$exports.startSession)({
                ignoreDuration: true
            });
            (0, $492f0fb96695dd9f$exports.captureSession)();
            const isolationScope = (0, $492f0fb96695dd9f$exports.getIsolationScope)();
            let previousUser = isolationScope.getUser();
            isolationScope.addScopeListener((scope)=>{
                const maybeNewUser = scope.getUser();
                if (previousUser?.id !== maybeNewUser?.id || previousUser?.ip_address !== maybeNewUser?.ip_address) {
                    (0, $492f0fb96695dd9f$exports.captureSession)();
                    previousUser = maybeNewUser;
                }
            });
            if (lifecycle === "route") (0, $3e85eb28f9001ea3$export$3f18c56c58114e75)(({ from: from, to: to })=>{
                if (from !== to) {
                    (0, $492f0fb96695dd9f$exports.startSession)({
                        ignoreDuration: true
                    });
                    (0, $492f0fb96695dd9f$exports.captureSession)();
                }
            });
        }
    };
});




const $f1102036f34b703d$var$INTEGRATION_NAME = "CultureContext";
const $f1102036f34b703d$var$_cultureContextIntegration = ()=>{
    return {
        name: $f1102036f34b703d$var$INTEGRATION_NAME,
        preprocessEvent (event) {
            const culture = $f1102036f34b703d$var$getCultureContext();
            if (culture) event.contexts = {
                ...event.contexts,
                culture: {
                    ...culture,
                    ...event.contexts?.culture
                }
            };
        },
        processSegmentSpan (span) {
            const culture = $f1102036f34b703d$var$getCultureContext();
            if (culture) (0, $492f0fb96695dd9f$exports.safeSetSpanJSONAttributes)(span, {
                "culture.locale": culture.locale,
                "culture.timezone": culture.timezone,
                "culture.calendar": culture.calendar
            });
        }
    };
};
const $f1102036f34b703d$export$ec5976aacdc85985 = (0, $492f0fb96695dd9f$exports.defineIntegration)($f1102036f34b703d$var$_cultureContextIntegration);
function $f1102036f34b703d$var$getCultureContext() {
    try {
        const intl = (0, $2b391a84339b074a$export$56d8a8a25bd48b81).Intl;
        if (!intl) return void 0;
        const options = intl.DateTimeFormat().resolvedOptions();
        return {
            locale: options.locale,
            timezone: options.timeZone,
            calendar: options.calendar
        };
    } catch  {
        return void 0;
    }
}






const $e0811abf55b6698f$var$INTEGRATION_NAME = "GlobalHandlers";
const $e0811abf55b6698f$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $e0811abf55b6698f$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $e0811abf55b6698f$var$_installGlobalOnErrorHandler(client);
                $e0811abf55b6698f$var$globalHandlerLog("onerror");
            }
            if (_options.onunhandledrejection) {
                $e0811abf55b6698f$var$_installGlobalOnUnhandledRejectionHandler(client);
                $e0811abf55b6698f$var$globalHandlerLog("onunhandledrejection");
            }
        }
    };
};
const $e0811abf55b6698f$export$66acc70e8cf2b71a = (0, $492f0fb96695dd9f$exports.defineIntegration)($e0811abf55b6698f$var$_globalHandlersIntegration);
function $e0811abf55b6698f$var$_installGlobalOnErrorHandler(client) {
    (0, $492f0fb96695dd9f$exports.addGlobalErrorInstrumentationHandler)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $e0811abf55b6698f$var$getOptions();
        if ((0, $492f0fb96695dd9f$exports.getClient)() !== client || (0, $2b391a84339b074a$export$b79738ab10c590b2)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = $e0811abf55b6698f$var$_enhanceEventWithInitialFrame((0, $9897809a589d544d$export$9dd56ed1ef0c3420)(stackParser, error || msg, void 0, attachStacktrace, false), url, line, column);
        event.level = "error";
        (0, $492f0fb96695dd9f$exports.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "auto.browser.global_handlers.onerror"
            }
        });
    });
}
function $e0811abf55b6698f$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $492f0fb96695dd9f$exports.addGlobalUnhandledRejectionInstrumentationHandler)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $e0811abf55b6698f$var$getOptions();
        if ((0, $492f0fb96695dd9f$exports.getClient)() !== client || (0, $2b391a84339b074a$export$b79738ab10c590b2)()) return;
        const error = $e0811abf55b6698f$export$b2cc40fa8241780(e);
        const event = (0, $492f0fb96695dd9f$exports.isPrimitive)(error) ? $e0811abf55b6698f$export$1353b5b36844a9ed(error) : (0, $9897809a589d544d$export$9dd56ed1ef0c3420)(stackParser, error, void 0, attachStacktrace, true);
        event.level = "error";
        (0, $492f0fb96695dd9f$exports.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "auto.browser.global_handlers.onunhandledrejection"
            }
        });
    });
}
function $e0811abf55b6698f$export$b2cc40fa8241780(error) {
    if ((0, $492f0fb96695dd9f$exports.isPrimitive)(error)) return error;
    try {
        if ("reason" in error) return error.reason;
        if ("detail" in error && "reason" in error.detail) return error.detail.reason;
    } catch  {}
    return error;
}
function $e0811abf55b6698f$export$1353b5b36844a9ed(reason) {
    return {
        exception: {
            values: [
                {
                    type: "UnhandledRejection",
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
function $e0811abf55b6698f$var$_enhanceEventWithInitialFrame(event, url, lineno, colno) {
    const e = event.exception = event.exception || {};
    const ev = e.values = e.values || [];
    const ev0 = ev[0] = ev[0] || {};
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    const ev0sf = ev0s.frames = ev0s.frames || [];
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        lineno: lineno,
        filename: $e0811abf55b6698f$var$getFilenameFromUrl(url) ?? (0, $492f0fb96695dd9f$exports.getLocationHref)(),
        function: (0, $492f0fb96695dd9f$exports.UNKNOWN_FUNCTION),
        in_app: true
    });
    return event;
}
function $e0811abf55b6698f$var$globalHandlerLog(type) {
    (0, $7b6b501ffbee5235$export$16a28057038b10ef) && (0, $492f0fb96695dd9f$exports.debug).log(`Global Handler attached: ${type}`);
}
function $e0811abf55b6698f$var$getOptions() {
    const client = (0, $492f0fb96695dd9f$exports.getClient)();
    const options = client?.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}
function $e0811abf55b6698f$var$getFilenameFromUrl(url) {
    if (!(0, $492f0fb96695dd9f$exports.isString)(url) || url.length === 0) return void 0;
    if (url.startsWith("data:")) return `<${(0, $492f0fb96695dd9f$exports.stripDataUrlContent)(url, false)}>`;
    return url;
}




const $6e2dc479d4fcf62e$export$1378794447170364 = (0, $492f0fb96695dd9f$exports.defineIntegration)(()=>{
    return {
        name: "HttpContext",
        preprocessEvent (event) {
            if (!(0, $2b391a84339b074a$export$56d8a8a25bd48b81).navigator && !(0, $2b391a84339b074a$export$56d8a8a25bd48b81).location && !(0, $2b391a84339b074a$export$56d8a8a25bd48b81).document) return;
            const reqData = (0, $2b391a84339b074a$export$a3c4a8453e8936f0)();
            const headers = {
                ...reqData.headers,
                ...event.request?.headers
            };
            event.request = {
                ...reqData,
                ...event.request,
                headers: headers
            };
        },
        processSegmentSpan (span) {
            if (!(0, $2b391a84339b074a$export$56d8a8a25bd48b81).navigator && !(0, $2b391a84339b074a$export$56d8a8a25bd48b81).location && !(0, $2b391a84339b074a$export$56d8a8a25bd48b81).document) return;
            const reqData = (0, $2b391a84339b074a$export$a3c4a8453e8936f0)();
            (0, $492f0fb96695dd9f$exports.safeSetSpanJSONAttributes)(span, {
                // Coerce empty string to undefined so the helper's nullish check drops it,
                // rather than writing an empty `url.full` attribute onto the span.
                "url.full": reqData.url || void 0,
                "http.request.header.user_agent": reqData.headers["User-Agent"],
                "http.request.header.referer": reqData.headers["Referer"]
            });
        }
    };
});




const $fb2e7db7db9e843d$var$DEFAULT_KEY = "cause";
const $fb2e7db7db9e843d$var$DEFAULT_LIMIT = 5;
const $fb2e7db7db9e843d$var$INTEGRATION_NAME = "LinkedErrors";
const $fb2e7db7db9e843d$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $fb2e7db7db9e843d$var$DEFAULT_LIMIT;
    const key = options.key || $fb2e7db7db9e843d$var$DEFAULT_KEY;
    return {
        name: $fb2e7db7db9e843d$var$INTEGRATION_NAME,
        preprocessEvent (event, hint, client) {
            const options2 = client.getOptions();
            (0, $492f0fb96695dd9f$exports.applyAggregateErrorsToEvent)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $9897809a589d544d$export$a6c2d27607295951), options2.stackParser, key, limit, event, hint);
        }
    };
};
const $fb2e7db7db9e843d$export$ebabb00eb7f3a395 = (0, $492f0fb96695dd9f$exports.defineIntegration)($fb2e7db7db9e843d$var$_linkedErrorsIntegration);



const $cd2b1da0101f5e77$var$OPERA10_PRIORITY = 10;
const $cd2b1da0101f5e77$var$OPERA11_PRIORITY = 20;
const $cd2b1da0101f5e77$var$CHROME_PRIORITY = 30;
const $cd2b1da0101f5e77$var$WINJS_PRIORITY = 40;
const $cd2b1da0101f5e77$var$GECKO_PRIORITY = 50;
function $cd2b1da0101f5e77$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func === "<anonymous>" ? (0, $492f0fb96695dd9f$exports.UNKNOWN_FUNCTION) : func,
        in_app: true
    };
    if (lineno !== void 0) frame.lineno = lineno;
    if (colno !== void 0) frame.colno = colno;
    return frame;
}
const $cd2b1da0101f5e77$var$chromeRegexNoFnName = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i;
const $cd2b1da0101f5e77$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $cd2b1da0101f5e77$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
const $cd2b1da0101f5e77$var$chromeDataUriRegex = /at (.+?) ?\(data:(.+?),/;
const $cd2b1da0101f5e77$var$chromeStackParserFn = (line)=>{
    const dataUriMatch = line.match($cd2b1da0101f5e77$var$chromeDataUriRegex);
    if (dataUriMatch) return {
        filename: `<data:${dataUriMatch[2]}>`,
        function: dataUriMatch[1]
    };
    const noFnParts = $cd2b1da0101f5e77$var$chromeRegexNoFnName.exec(line);
    if (noFnParts) {
        const [, filename, line2, col] = noFnParts;
        return $cd2b1da0101f5e77$var$createFrame(filename, (0, $492f0fb96695dd9f$exports.UNKNOWN_FUNCTION), +line2, +col);
    }
    const parts = $cd2b1da0101f5e77$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2]?.indexOf("eval") === 0;
        if (isEval) {
            const subMatch = $cd2b1da0101f5e77$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                parts[2] = subMatch[1];
                parts[3] = subMatch[2];
                parts[4] = subMatch[3];
            }
        }
        const [func, filename] = $cd2b1da0101f5e77$var$extractSafariExtensionDetails(parts[1] || (0, $492f0fb96695dd9f$exports.UNKNOWN_FUNCTION), parts[2]);
        return $cd2b1da0101f5e77$var$createFrame(filename, func, parts[3] ? +parts[3] : void 0, parts[4] ? +parts[4] : void 0);
    }
    return;
};
const $cd2b1da0101f5e77$export$263a749fff749872 = [
    $cd2b1da0101f5e77$var$CHROME_PRIORITY,
    $cd2b1da0101f5e77$var$chromeStackParserFn
];
const $cd2b1da0101f5e77$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $cd2b1da0101f5e77$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $cd2b1da0101f5e77$var$gecko = (line)=>{
    const parts = $cd2b1da0101f5e77$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(" > eval") > -1;
        if (isEval) {
            const subMatch = $cd2b1da0101f5e77$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                parts[1] = parts[1] || "eval";
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = "";
            }
        }
        let filename = parts[3];
        let func = parts[1] || (0, $492f0fb96695dd9f$exports.UNKNOWN_FUNCTION);
        [func, filename] = $cd2b1da0101f5e77$var$extractSafariExtensionDetails(func, filename);
        return $cd2b1da0101f5e77$var$createFrame(filename, func, parts[4] ? +parts[4] : void 0, parts[5] ? +parts[5] : void 0);
    }
    return;
};
const $cd2b1da0101f5e77$export$cdba47a5dd2804d = [
    $cd2b1da0101f5e77$var$GECKO_PRIORITY,
    $cd2b1da0101f5e77$var$gecko
];
const $cd2b1da0101f5e77$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $cd2b1da0101f5e77$var$winjs = (line)=>{
    const parts = $cd2b1da0101f5e77$var$winjsRegex.exec(line);
    return parts ? $cd2b1da0101f5e77$var$createFrame(parts[2], parts[1] || (0, $492f0fb96695dd9f$exports.UNKNOWN_FUNCTION), +parts[3], parts[4] ? +parts[4] : void 0) : void 0;
};
const $cd2b1da0101f5e77$export$179460296da408e8 = [
    $cd2b1da0101f5e77$var$WINJS_PRIORITY,
    $cd2b1da0101f5e77$var$winjs
];
const $cd2b1da0101f5e77$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $cd2b1da0101f5e77$var$opera10 = (line)=>{
    const parts = $cd2b1da0101f5e77$var$opera10Regex.exec(line);
    return parts ? $cd2b1da0101f5e77$var$createFrame(parts[2], parts[3] || (0, $492f0fb96695dd9f$exports.UNKNOWN_FUNCTION), +parts[1]) : void 0;
};
const $cd2b1da0101f5e77$export$f892b52c880ffc7a = [
    $cd2b1da0101f5e77$var$OPERA10_PRIORITY,
    $cd2b1da0101f5e77$var$opera10
];
const $cd2b1da0101f5e77$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $cd2b1da0101f5e77$var$opera11 = (line)=>{
    const parts = $cd2b1da0101f5e77$var$opera11Regex.exec(line);
    return parts ? $cd2b1da0101f5e77$var$createFrame(parts[5], parts[3] || parts[4] || (0, $492f0fb96695dd9f$exports.UNKNOWN_FUNCTION), +parts[1], +parts[2]) : void 0;
};
const $cd2b1da0101f5e77$export$af11af13f09fb0dc = [
    $cd2b1da0101f5e77$var$OPERA11_PRIORITY,
    $cd2b1da0101f5e77$var$opera11
];
const $cd2b1da0101f5e77$export$7197c0fe6554c079 = [
    $cd2b1da0101f5e77$export$263a749fff749872,
    $cd2b1da0101f5e77$export$cdba47a5dd2804d
];
const $cd2b1da0101f5e77$export$2b2b997d81bf3907 = (0, $492f0fb96695dd9f$exports.createStackParser)(...$cd2b1da0101f5e77$export$7197c0fe6554c079);
const $cd2b1da0101f5e77$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf("safari-extension") !== -1;
    const isSafariWebExtension = func.indexOf("safari-web-extension") !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf("@") !== -1 ? func.split("@")[0] : (0, $492f0fb96695dd9f$exports.UNKNOWN_FUNCTION),
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};




const $1ace9bb4c0859f10$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;



const $546e120bd13c90e4$var$cachedImplementations = {};
function $546e120bd13c90e4$export$e464f4a514ac28a8(name) {
    const cached = $546e120bd13c90e4$var$cachedImplementations[name];
    if (cached) return cached;
    let impl = (0, $e601f21e4bdef308$export$56d8a8a25bd48b81)[name];
    if ((0, $01c1392b0a01fb13$export$d5f608b368e73f38)(impl)) return $546e120bd13c90e4$var$cachedImplementations[name] = impl.bind((0, $e601f21e4bdef308$export$56d8a8a25bd48b81));
    const document = (0, $e601f21e4bdef308$export$56d8a8a25bd48b81).document;
    if (document && typeof document.createElement === "function") try {
        const sandbox = document.createElement("iframe");
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow?.[name]) impl = contentWindow[name];
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, $1ace9bb4c0859f10$export$16a28057038b10ef) && (0, $dd4af310e95b2daa$export$1c9f709888824e05).warn(`Could not create sandbox iframe for ${name} check, bailing to window.${name}: `, e);
    }
    if (!impl) return impl;
    return $546e120bd13c90e4$var$cachedImplementations[name] = impl.bind((0, $e601f21e4bdef308$export$56d8a8a25bd48b81));
}
function $546e120bd13c90e4$export$8aa36702e8c8978(name) {
    $546e120bd13c90e4$var$cachedImplementations[name] = void 0;
}
function $546e120bd13c90e4$export$e7aa7bc5c1b3cfb3(...rest) {
    return $546e120bd13c90e4$export$e464f4a514ac28a8("fetch")(...rest);
}
function $546e120bd13c90e4$export$831dc9f2ab0a617b(...rest) {
    return $546e120bd13c90e4$export$e464f4a514ac28a8("setTimeout")(...rest);
}


const $1716c2dbf99d5feb$var$DEFAULT_BROWSER_TRANSPORT_BUFFER_SIZE = 40;
function $1716c2dbf99d5feb$export$b2311068c46d7cc8(options, nativeFetch = (0, $546e120bd13c90e4$export$e464f4a514ac28a8)("fetch")) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    async function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: "POST",
            referrerPolicy: "strict-origin",
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. when finishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 6e4 && pendingCount < 15,
            ...options.fetchOptions
        };
        try {
            const response = await nativeFetch(options.url, requestOptions);
            return {
                statusCode: response.status,
                headers: {
                    "x-sentry-rate-limits": response.headers.get("X-Sentry-Rate-Limits"),
                    "retry-after": response.headers.get("Retry-After")
                }
            };
        } catch (e) {
            (0, $546e120bd13c90e4$export$8aa36702e8c8978)("fetch");
            throw e;
        } finally{
            pendingBodySize -= requestSize;
            pendingCount--;
        }
    }
    return (0, $492f0fb96695dd9f$exports.createTransport)(options, makeRequest, (0, $492f0fb96695dd9f$exports.makePromiseBuffer)(options.bufferSize || $1716c2dbf99d5feb$var$DEFAULT_BROWSER_TRANSPORT_BUFFER_SIZE));
}


function $45614ed1f34b8bb5$export$45a5e7f76e0caa8d(wat) {
    if (typeof Element === "undefined") return false;
    try {
        return wat instanceof Element;
    } catch  {
        return false;
    }
}


const $75275490b2f7c191$var$HTML_ELEMENT_CONSTRUCTOR_NAME_REGEX = /^HTML(\w*)Element$/;
function $75275490b2f7c191$export$4c88c355e6072df5(value) {
    if (typeof window !== "undefined" && value === window) return "[Window]";
    if (typeof document !== "undefined" && value === document) return "[Document]";
    if ((0, $45614ed1f34b8bb5$export$45a5e7f76e0caa8d)(value)) {
        const objName = $75275490b2f7c191$var$getConstructorName(value);
        if ($75275490b2f7c191$var$HTML_ELEMENT_CONSTRUCTOR_NAME_REGEX.test(objName)) return `[HTMLElement: ${(0, $dea6f7c3fc893264$export$5647df6b7814ac86)(value)}]`;
    }
    return void 0;
}
function $75275490b2f7c191$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype?.constructor ? prototype.constructor.name : "null prototype";
}





function $6b4a5dff369026af$export$dc236a86065879fc() {
    if ($6b4a5dff369026af$var$_isEmbeddedBrowserExtension()) {
        if (0, $7b6b501ffbee5235$export$16a28057038b10ef) (0, $492f0fb96695dd9f$exports.consoleSandbox)(()=>{
            console.error("[Sentry] You cannot use Sentry.init() in a browser extension, see: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/");
        });
        return true;
    }
    return false;
}
function $6b4a5dff369026af$var$_isEmbeddedBrowserExtension() {
    if (typeof (0, $2b391a84339b074a$export$56d8a8a25bd48b81).window === "undefined") return false;
    const _window = (0, $2b391a84339b074a$export$56d8a8a25bd48b81);
    if (_window.nw) return false;
    const extensionObject = _window["chrome"] || _window["browser"];
    if (!extensionObject?.runtime?.id) return false;
    const href = (0, $492f0fb96695dd9f$exports.getLocationHref)();
    const isDedicatedExtensionPage = (0, $2b391a84339b074a$export$56d8a8a25bd48b81) === (0, $2b391a84339b074a$export$56d8a8a25bd48b81).top && /^(?:chrome-extension|moz-extension|ms-browser-extension|safari-web-extension):\/\//.test(href);
    return !isDedicatedExtensionPage;
}


function $a3ef985a7674cc0b$export$5783b2920b1d62b9(_options) {
    return [
        // TODO(v11): Replace with `eventFiltersIntegration` once we remove the deprecated `inboundFiltersIntegration`
        // eslint-disable-next-line deprecation/deprecation
        (0, $492f0fb96695dd9f$exports.inboundFiltersIntegration)(),
        (0, $492f0fb96695dd9f$exports.functionToStringIntegration)(),
        (0, $492f0fb96695dd9f$exports.conversationIdIntegration)(),
        (0, $e3869eafa5a7478c$export$59bfe9f1c76150e)(),
        (0, $dc4f734fe471b570$export$c079d904b326663a)(),
        (0, $e0811abf55b6698f$export$66acc70e8cf2b71a)(),
        (0, $fb2e7db7db9e843d$export$ebabb00eb7f3a395)(),
        (0, $492f0fb96695dd9f$exports.dedupeIntegration)(),
        (0, $6e2dc479d4fcf62e$export$1378794447170364)(),
        (0, $f1102036f34b703d$export$ec5976aacdc85985)(),
        (0, $7c0c681e37d09cf4$export$1baa7880e357371c)()
    ];
}
function $a3ef985a7674cc0b$export$2cd8252107eb640b(options = {}) {
    const shouldDisableBecauseIsBrowserExtenstion = !options.skipBrowserExtensionCheck && (0, $6b4a5dff369026af$export$dc236a86065879fc)();
    let defaultIntegrations = options.defaultIntegrations == null ? $a3ef985a7674cc0b$export$5783b2920b1d62b9() : options.defaultIntegrations;
    const clientOptions = {
        ...options,
        enabled: shouldDisableBecauseIsBrowserExtenstion ? false : options.enabled,
        stackParser: (0, $492f0fb96695dd9f$exports.stackParserFromStackParserOptions)(options.stackParser || (0, $cd2b1da0101f5e77$export$2b2b997d81bf3907)),
        integrations: (0, $492f0fb96695dd9f$exports.getIntegrationsToSetup)({
            integrations: options.integrations,
            defaultIntegrations: defaultIntegrations
        }),
        transport: options.transport || (0, $1716c2dbf99d5feb$export$b2311068c46d7cc8)
    };
    (0, $492f0fb96695dd9f$exports.setNormalizeStringifier)((0, $75275490b2f7c191$export$4c88c355e6072df5));
    return (0, $492f0fb96695dd9f$exports.initAndBind)((0, $34f1afb37b6dc268$export$1df9218a526d318d), clientOptions);
}
function $a3ef985a7674cc0b$export$a3f323d81eede727() {}
function $a3ef985a7674cc0b$export$4e4d8b287d028b6b(callback) {
    callback();
}






function $a829f05e7b5df86f$export$14a186326edbb264(context) {
    const startingTime = (0, $fd9cf0b48f691186$export$ee52dced521e3e18)();
    const session = {
        sid: (0, $5f9617f585b2f74f$export$19f53698e68b2496)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$a829f05e7b5df86f$var$sessionToJSON(session)
    };
    if (context) $a829f05e7b5df86f$export$531818e825e774db(session, context);
    return session;
}
function $a829f05e7b5df86f$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $fd9cf0b48f691186$export$ee52dced521e3e18)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) session.sid = context.sid.length === 32 ? context.sid : (0, $5f9617f585b2f74f$export$19f53698e68b2496)();
    if (context.init !== void 0) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === "number") session.started = context.started;
    if (session.ignoreDuration) session.duration = void 0;
    else if (typeof context.duration === "number") session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === "number") session.errors = context.errors;
    if (context.status) session.status = context.status;
}
function $a829f05e7b5df86f$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === "ok") context = {
        status: "exited"
    };
    $a829f05e7b5df86f$export$531818e825e774db(session, context);
}
function $a829f05e7b5df86f$var$sessionToJSON(session) {
    return {
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1e3).toISOString(),
        timestamp: new Date(session.timestamp * 1e3).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : void 0,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    };
}




function $0fd68d43e5df151c$export$4950aa0f605343fb(initialObj, mergeObj, levels = 2) {
    if (!mergeObj || typeof mergeObj !== "object" || levels <= 0) return mergeObj;
    if (initialObj && Object.keys(mergeObj).length === 0) return initialObj;
    const output = {
        ...initialObj
    };
    for(const key in mergeObj)if (Object.prototype.hasOwnProperty.call(mergeObj, key)) output[key] = $0fd68d43e5df151c$export$4950aa0f605343fb(output[key], mergeObj[key], levels - 1);
    return output;
}




function $37dcada2a8c7465b$export$dc6d7ea554bcce10() {
    return (0, $5f9617f585b2f74f$export$19f53698e68b2496)();
}
function $37dcada2a8c7465b$export$295213bc4d0c54ad() {
    return (0, $5f9617f585b2f74f$export$19f53698e68b2496)().substring(16);
}




const $5ece2fb3ee38e4e7$var$SCOPE_SPAN_FIELD = "_sentrySpan";
function $5ece2fb3ee38e4e7$export$3f25fa50c18e20ca(scope, span) {
    if (span) (0, $a964b80d2257757d$export$e73679ffaf56810e)(scope, $5ece2fb3ee38e4e7$var$SCOPE_SPAN_FIELD, span);
    else delete scope[$5ece2fb3ee38e4e7$var$SCOPE_SPAN_FIELD];
}
function $5ece2fb3ee38e4e7$export$91f063ebb8eff307(scope) {
    return scope[$5ece2fb3ee38e4e7$var$SCOPE_SPAN_FIELD];
}




const $7322a86e8ee4a60a$var$DEFAULT_MAX_BREADCRUMBS = 100;
class $7322a86e8ee4a60a$export$775b6bb06e53a214 {
    // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._attributes = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = {
            traceId: (0, $37dcada2a8c7465b$export$dc6d7ea554bcce10)(),
            sampleRand: (0, $0d33076536fcb49a$export$9869d72de32a3917)()
        };
    }
    /**
   * Clone all data from this scope into a new scope.
   */ clone() {
        const newScope = new $7322a86e8ee4a60a$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._attributes = {
            ...this._attributes
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        if (this._contexts.flags) newScope._contexts.flags = {
            values: [
                ...this._contexts.flags.values
            ]
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        newScope._lastEventId = this._lastEventId;
        newScope._conversationId = this._conversationId;
        (0, $5ece2fb3ee38e4e7$export$3f25fa50c18e20ca)(newScope, (0, $5ece2fb3ee38e4e7$export$91f063ebb8eff307)(this));
        return newScope;
    }
    /**
   * Update the client assigned to this scope.
   * Note that not every scope will have a client assigned - isolation scopes & the global scope will generally not have a client,
   * as well as manually created scopes.
   */ setClient(client) {
        this._client = client;
    }
    /**
   * Set the ID of the last captured error event.
   * This is generally only captured on the isolation scope.
   */ setLastEventId(lastEventId) {
        this._lastEventId = lastEventId;
    }
    /**
   * Get the client assigned to this scope.
   */ getClient() {
        return this._client;
    }
    /**
   * Get the ID of the last captured error event.
   * This is generally only available on the isolation scope.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * Add an event processor that will be called before an event is sent.
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * Set the user for this scope.
   * Set to `null` to unset the user.
   */ setUser(user) {
        this._user = user || {
            email: void 0,
            id: void 0,
            ip_address: void 0,
            username: void 0
        };
        if (this._session) (0, $a829f05e7b5df86f$export$531818e825e774db)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the user from this scope.
   */ getUser() {
        return this._user;
    }
    /**
   * Set the conversation ID for this scope.
   * Set to `null` to unset the conversation ID.
   */ setConversationId(conversationId) {
        this._conversationId = conversationId || void 0;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set an object that will be merged into existing tags on the scope,
   * and will be sent as tags data with the event.
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single tag that will be sent as tags data with the event.
   */ setTag(key, value) {
        return this.setTags({
            [key]: value
        });
    }
    /**
   * Sets attributes onto the scope.
   *
   * These attributes are currently applied to logs and metrics.
   * In the future, they will also be applied to spans.
   *
   * Important: For now, only strings, numbers and boolean attributes are supported, despite types allowing for
   * more complex attribute types. We'll add this support in the future but already specify the wider type to
   * avoid a breaking change in the future.
   *
   * @param newAttributes - The attributes to set on the scope. You can either pass in key-value pairs, or
   * an object with a `value` and an optional `unit` (if applicable to your attribute).
   *
   * @example
   * ```typescript
   * scope.setAttributes({
   *   is_admin: true,
   *   payment_selection: 'credit_card',
   *   render_duration: { value: 'render_duration', unit: 'ms' },
   * });
   * ```
   */ setAttributes(newAttributes) {
        this._attributes = {
            ...this._attributes,
            ...newAttributes
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets an attribute onto the scope.
   *
   * These attributes are currently applied to logs and metrics.
   * In the future, they will also be applied to spans.
   *
   * Important: For now, only strings, numbers and boolean attributes are supported, despite types allowing for
   * more complex attribute types. We'll add this support in the future but already specify the wider type to
   * avoid a breaking change in the future.
   *
   * @param key - The attribute key.
   * @param value - the attribute value. You can either pass in a raw value, or an attribute
   * object with a `value` and an optional `unit` (if applicable to your attribute).
   *
   * @example
   * ```typescript
   * scope.setAttribute('is_admin', true);
   * scope.setAttribute('render_duration', { value: 'render_duration', unit: 'ms' });
   * ```
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setAttribute(key, value) {
        return this.setAttributes({
            [key]: value
        });
    }
    /**
   * Removes the attribute with the given key from the scope.
   *
   * @param key - The attribute key.
   *
   * @example
   * ```typescript
   * scope.removeAttribute('is_admin');
   * ```
   */ removeAttribute(key) {
        if (key in this._attributes) {
            delete this._attributes[key];
            this._notifyScopeListeners();
        }
        return this;
    }
    /**
   * Set an object that will be merged into existing extra on the scope,
   * and will be sent as extra data with the event.
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single key:value extra entry that will be sent as extra data with the event.
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the fingerprint on the scope to send with the events.
   * @param {string[]} fingerprint Fingerprint to group events in Sentry.
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the level on the scope for future events.
   */ setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets context data with the given name.
   * Data passed as context will be normalized. You can also pass `null` to unset the context.
   * Note that context data will not be merged - calling `setContext` will overwrite an existing context with the same key.
   */ setContext(key, context) {
        if (context === null) delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set the session for the scope.
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the session from the scope.
   */ getSession() {
        return this._session;
    }
    /**
   * Updates the scope with provided data. Can work in three variations:
   * - plain object containing updatable attributes
   * - Scope instance that'll extract the attributes from
   * - callback function that'll receive the current scope as an argument and allow for modifications
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === "function" ? captureContext(this) : captureContext;
        const scopeInstance = scopeToMerge instanceof $7322a86e8ee4a60a$export$775b6bb06e53a214 ? scopeToMerge.getScopeData() : (0, $2660f95a1b0d39e6$export$53b83ca8eaab0383)(scopeToMerge) ? captureContext : void 0;
        const { tags: tags, attributes: attributes, extra: extra, user: user, contexts: contexts, level: level, fingerprint: fingerprint = [], propagationContext: propagationContext, conversationId: conversationId } = scopeInstance || {};
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._attributes = {
            ...this._attributes,
            ...attributes
        };
        this._extra = {
            ...this._extra,
            ...extra
        };
        this._contexts = {
            ...this._contexts,
            ...contexts
        };
        if (user && Object.keys(user).length) this._user = user;
        if (level) this._level = level;
        if (fingerprint.length) this._fingerprint = fingerprint;
        if (propagationContext) this._propagationContext = propagationContext;
        if (conversationId) this._conversationId = conversationId;
        return this;
    }
    /**
   * Clears the current scope and resets its properties.
   * Note: The client will not be cleared.
   */ clear() {
        this._breadcrumbs = [];
        this._tags = {};
        this._attributes = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = void 0;
        this._transactionName = void 0;
        this._fingerprint = void 0;
        this._session = void 0;
        this._conversationId = void 0;
        (0, $5ece2fb3ee38e4e7$export$3f25fa50c18e20ca)(this, void 0);
        this._attachments = [];
        this.setPropagationContext({
            traceId: (0, $37dcada2a8c7465b$export$dc6d7ea554bcce10)(),
            sampleRand: (0, $0d33076536fcb49a$export$9869d72de32a3917)()
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Adds a breadcrumb to the scope.
   * By default, the last 100 breadcrumbs are kept.
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : $7322a86e8ee4a60a$var$DEFAULT_MAX_BREADCRUMBS;
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $fd9cf0b48f691186$export$7740643b9eeaf0c4)(),
            ...breadcrumb,
            // Breadcrumb messages can theoretically be infinitely large and they're held in memory so we truncate them not to leak (too much) memory
            message: breadcrumb.message ? (0, $2088fbfa8bfbfeb6$export$6a506b36fdea397d)(breadcrumb.message, 2048) : breadcrumb.message
        };
        this._breadcrumbs.push(mergedBreadcrumb);
        if (this._breadcrumbs.length > maxCrumbs) {
            this._breadcrumbs = this._breadcrumbs.slice(-maxCrumbs);
            this._client?.recordDroppedEvent("buffer_overflow", "log_item");
        }
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the last breadcrumb of the scope.
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * Clear all breadcrumbs from the scope.
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Add an attachment to the scope.
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * Clear all attachments from the scope.
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /**
   * Get the data of this scope, which should be applied to an event during processing.
   */ getScopeData() {
        return {
            breadcrumbs: this._breadcrumbs,
            attachments: this._attachments,
            contexts: this._contexts,
            tags: this._tags,
            attributes: this._attributes,
            extra: this._extra,
            user: this._user,
            level: this._level,
            fingerprint: this._fingerprint || [],
            eventProcessors: this._eventProcessors,
            propagationContext: this._propagationContext,
            sdkProcessingMetadata: this._sdkProcessingMetadata,
            transactionName: this._transactionName,
            span: (0, $5ece2fb3ee38e4e7$export$91f063ebb8eff307)(this),
            conversationId: this._conversationId
        };
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry.
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = (0, $0fd68d43e5df151c$export$4950aa0f605343fb)(this._sdkProcessingMetadata, newData, 2);
        return this;
    }
    /**
   * Add propagation context to the scope, used for distributed tracing
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * Get propagation context from the scope, used for distributed tracing
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @returns {string} The id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint?.event_id || (0, $5f9617f585b2f74f$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $2deb03c4495ce01f$export$16a28057038b10ef) && (0, $dd4af310e95b2daa$export$1c9f709888824e05).warn("No client configured on scope - will not capture exception!");
            return eventId;
        }
        const syntheticException = new Error("Sentry syntheticException");
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @returns {string} The id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint?.event_id || (0, $5f9617f585b2f74f$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $2deb03c4495ce01f$export$16a28057038b10ef) && (0, $dd4af310e95b2daa$export$1c9f709888824e05).warn("No client configured on scope - will not capture message!");
            return eventId;
        }
        const syntheticException = hint?.syntheticException ?? new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a Sentry event for this scope.
   *
   * @returns {string} The id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = event.event_id || hint?.event_id || (0, $5f9617f585b2f74f$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $2deb03c4495ce01f$export$16a28057038b10ef) && (0, $dd4af310e95b2daa$export$1c9f709888824e05).warn("No client configured on scope - will not capture event!");
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}


function $36984d16b140c5cd$export$6f1b9191db9c4d5() {
    return (0, $f93478a31a56772c$export$7e223ec222791509)("defaultCurrentScope", ()=>new (0, $7322a86e8ee4a60a$export$775b6bb06e53a214)());
}
function $36984d16b140c5cd$export$de9862929b76bf57() {
    return (0, $f93478a31a56772c$export$7e223ec222791509)("defaultIsolationScope", ()=>new (0, $7322a86e8ee4a60a$export$775b6bb06e53a214)());
}



const $08b8884e1d2d75db$var$isActualPromise = (p)=>p instanceof Promise && !p[$08b8884e1d2d75db$var$kChainedCopy];
const $08b8884e1d2d75db$var$kChainedCopy = /* @__PURE__ */ Symbol("chained PromiseLike");
const $08b8884e1d2d75db$export$64da0f40b0f924ba = (original, onSuccess, onError)=>{
    const chained = original.then((value)=>{
        onSuccess(value);
        return value;
    }, (err)=>{
        onError(err);
        throw err;
    });
    return $08b8884e1d2d75db$var$isActualPromise(chained) && $08b8884e1d2d75db$var$isActualPromise(original) ? chained : $08b8884e1d2d75db$var$copyProps(original, chained);
};
const $08b8884e1d2d75db$var$copyProps = (original, chained)=>{
    if (!chained) return original;
    let mutated = false;
    for(const key in original){
        if (key in chained) continue;
        mutated = true;
        const value = original[key];
        if (typeof value === "function") Object.defineProperty(chained, key, {
            value: (...args)=>value.apply(original, args),
            enumerable: true,
            configurable: true,
            writable: true
        });
        else chained[key] = value;
    }
    if (mutated) Object.assign(chained, {
        [$08b8884e1d2d75db$var$kChainedCopy]: true
    });
    return chained;
};




class $f49b179d17c21349$export$d36ec451f120cfba {
    constructor(scope, isolationScope){
        let assignedScope;
        if (!scope) assignedScope = new (0, $7322a86e8ee4a60a$export$775b6bb06e53a214)();
        else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new (0, $7322a86e8ee4a60a$export$775b6bb06e53a214)();
        else assignedIsolationScope = isolationScope;
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Fork a scope for the stack.
   */ withScope(callback) {
        const scope = this._pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            this._popScope();
            throw e;
        }
        if ((0, $2660f95a1b0d39e6$export$f5b060c2914b97c8)(maybePromiseResult)) return (0, $08b8884e1d2d75db$export$64da0f40b0f924ba)(maybePromiseResult, ()=>this._popScope(), ()=>this._popScope());
        this._popScope();
        return maybePromiseResult;
    }
    /**
   * Get the client of the stack.
   */ getClient() {
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   */ getScope() {
        return this.getStackTop().scope;
    }
    /**
   * Get the isolation scope for the stack.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * Push a scope to the stack.
   */ _pushScope() {
        const scope = this.getScope().clone();
        this._stack.push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * Pop a scope from the stack.
   */ _popScope() {
        if (this._stack.length <= 1) return false;
        return !!this._stack.pop();
    }
}
function $f49b179d17c21349$var$getAsyncContextStack() {
    const registry = (0, $f93478a31a56772c$export$19eade501500c6c1)();
    const sentry = (0, $f93478a31a56772c$export$c8bfa33e4e8ae492)(registry);
    return sentry.stack = sentry.stack || new $f49b179d17c21349$export$d36ec451f120cfba((0, $36984d16b140c5cd$export$6f1b9191db9c4d5)(), (0, $36984d16b140c5cd$export$de9862929b76bf57)());
}
function $f49b179d17c21349$var$withScope(callback) {
    return $f49b179d17c21349$var$getAsyncContextStack().withScope(callback);
}
function $f49b179d17c21349$var$withSetScope(scope, callback) {
    const stack = $f49b179d17c21349$var$getAsyncContextStack();
    return stack.withScope(()=>{
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function $f49b179d17c21349$var$withIsolationScope(callback) {
    return $f49b179d17c21349$var$getAsyncContextStack().withScope(()=>{
        return callback($f49b179d17c21349$var$getAsyncContextStack().getIsolationScope());
    });
}
function $f49b179d17c21349$export$329d4d4d54e42710() {
    return {
        withIsolationScope: $f49b179d17c21349$var$withIsolationScope,
        withScope: $f49b179d17c21349$var$withScope,
        withSetScope: $f49b179d17c21349$var$withSetScope,
        withSetIsolationScope: (_isolationScope, callback)=>{
            return $f49b179d17c21349$var$withIsolationScope(callback);
        },
        getCurrentScope: ()=>$f49b179d17c21349$var$getAsyncContextStack().getScope(),
        getIsolationScope: ()=>$f49b179d17c21349$var$getAsyncContextStack().getIsolationScope()
    };
}


function $5a330bff927d6eb3$export$774ae0e6b6e444ca(strategy) {
    const registry = (0, $f93478a31a56772c$export$19eade501500c6c1)();
    const sentry = (0, $f93478a31a56772c$export$c8bfa33e4e8ae492)(registry);
    sentry.acs = strategy;
}
function $5a330bff927d6eb3$export$f639b0c2752203be(carrier) {
    const sentry = (0, $f93478a31a56772c$export$c8bfa33e4e8ae492)(carrier);
    if (sentry.acs) return sentry.acs;
    return (0, $f49b179d17c21349$export$329d4d4d54e42710)();
}





let $feb8814e57364805$var$_externalPropagationContextProvider;
function $feb8814e57364805$export$b5defb3466e9689b(fn) {
    $feb8814e57364805$var$_externalPropagationContextProvider = fn;
}
function $feb8814e57364805$export$92547f779c920a71() {
    return $feb8814e57364805$var$_externalPropagationContextProvider?.();
}
function $feb8814e57364805$export$53f0ae651a1c4298() {
    return $feb8814e57364805$var$_externalPropagationContextProvider !== void 0;
}
function $feb8814e57364805$export$c7be4b0125a10cba() {
    const carrier = (0, $f93478a31a56772c$export$19eade501500c6c1)();
    const acs = (0, $5a330bff927d6eb3$export$f639b0c2752203be)(carrier);
    return acs.getCurrentScope();
}
function $feb8814e57364805$export$68f3af03034c9e90() {
    const carrier = (0, $f93478a31a56772c$export$19eade501500c6c1)();
    const acs = (0, $5a330bff927d6eb3$export$f639b0c2752203be)(carrier);
    return acs.getIsolationScope();
}
function $feb8814e57364805$export$aa55d5ab8e05984f() {
    return (0, $f93478a31a56772c$export$7e223ec222791509)("globalScope", ()=>new (0, $7322a86e8ee4a60a$export$775b6bb06e53a214)());
}
function $feb8814e57364805$export$ec58d9285c204497(...rest) {
    const carrier = (0, $f93478a31a56772c$export$19eade501500c6c1)();
    const acs = (0, $5a330bff927d6eb3$export$f639b0c2752203be)(carrier);
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
function $feb8814e57364805$export$9a4fed82c350c2bd(...rest) {
    const carrier = (0, $f93478a31a56772c$export$19eade501500c6c1)();
    const acs = (0, $5a330bff927d6eb3$export$f639b0c2752203be)(carrier);
    if (rest.length === 2) {
        const [isolationScope, callback] = rest;
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
function $feb8814e57364805$export$6bb76d6eba7e258c() {
    return $feb8814e57364805$export$c7be4b0125a10cba().getClient();
}
function $feb8814e57364805$export$1e83db7ee4876dc4(scope) {
    const externalContext = $feb8814e57364805$export$92547f779c920a71();
    if (externalContext) return {
        trace_id: externalContext.traceId,
        span_id: externalContext.spanId
    };
    const propagationContext = scope.getPropagationContext();
    const { traceId: traceId, parentSpanId: parentSpanId, propagationSpanId: propagationSpanId } = propagationContext;
    const traceContext = {
        trace_id: traceId,
        span_id: propagationSpanId || (0, $37dcada2a8c7465b$export$295213bc4d0c54ad)()
    };
    if (parentSpanId) traceContext.parent_span_id = parentSpanId;
    return traceContext;
}




const $48d39529e25626c6$var$DEFAULT_BREADCRUMBS = 100;
function $48d39529e25626c6$export$efda9a273d7a036d(breadcrumb, hint) {
    const client = (0, $feb8814e57364805$export$6bb76d6eba7e258c)();
    const isolationScope = (0, $feb8814e57364805$export$68f3af03034c9e90)();
    if (!client) return;
    const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $48d39529e25626c6$var$DEFAULT_BREADCRUMBS } = client.getOptions();
    if (maxBreadcrumbs <= 0) return;
    const timestamp = (0, $fd9cf0b48f691186$export$7740643b9eeaf0c4)();
    const mergedBreadcrumb = {
        timestamp: timestamp,
        ...breadcrumb
    };
    const finalBreadcrumb = beforeBreadcrumb ? (0, $dd4af310e95b2daa$export$cda52e2a8927a2ca)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
    if (finalBreadcrumb === null) return;
    if (client.emit) client.emit("beforeAddBreadcrumb", finalBreadcrumb, hint);
    isolationScope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
}








const $fbf607a81dcbd641$export$d7a7d984b0791405 = "sentry.source";
const $fbf607a81dcbd641$export$ccfe0a40627cc34b = "sentry.sample_rate";
const $fbf607a81dcbd641$export$889fb736668e1ecc = "sentry.previous_trace_sample_rate";
const $fbf607a81dcbd641$export$1a413bd9a88fdb09 = "sentry.op";
const $fbf607a81dcbd641$export$cca8dd30f57f805e = "sentry.origin";
const $fbf607a81dcbd641$export$ba73f34502b7a3b3 = "sentry.idle_span_finish_reason";
const $fbf607a81dcbd641$export$f5f95cff026507b5 = "sentry.measurement_unit";
const $fbf607a81dcbd641$export$69cd5c610c7bb96a = "sentry.measurement_value";
const $fbf607a81dcbd641$export$f5cefb258679b29e = "sentry.release";
const $fbf607a81dcbd641$export$d1b1dbb47f5ba57c = "sentry.environment";
const $fbf607a81dcbd641$export$4626f2be16112c1c = "sentry.segment.name";
const $fbf607a81dcbd641$export$25fa4a1832d3736a = "sentry.segment.id";
const $fbf607a81dcbd641$export$87a4807042e1f1bb = "sentry.sdk.name";
const $fbf607a81dcbd641$export$301ebe936458e291 = "sentry.sdk.version";
const $fbf607a81dcbd641$export$bd847b1cc92ae587 = "sentry.sdk.integrations";
const $fbf607a81dcbd641$export$1f9cc1d34ea098a0 = "user.id";
const $fbf607a81dcbd641$export$b7466609ef46c07e = "user.email";
const $fbf607a81dcbd641$export$8d592bdaea63b930 = "user.ip_address";
const $fbf607a81dcbd641$export$c05ee933d3f74b2b = "user.name";
const $fbf607a81dcbd641$export$165ce9a229f6f050 = "sentry.custom_span_name";
const $fbf607a81dcbd641$export$1efec95406bbe327 = "sentry.profile_id";
const $fbf607a81dcbd641$export$fea48ba9f4550879 = "sentry.exclusive_time";
const $fbf607a81dcbd641$export$b016f89ac1066ec = "cache.hit";
const $fbf607a81dcbd641$export$3110e4c3f4386399 = "cache.key";
const $fbf607a81dcbd641$export$86be76deee227ff2 = "cache.item_size";
const $fbf607a81dcbd641$export$be7a251980e7e946 = "http.request.method";
const $fbf607a81dcbd641$export$25dfd73e0e32c6e1 = "url.full";
const $fbf607a81dcbd641$export$ff77b5fd5b2d627b = "sentry.link.type";
const $fbf607a81dcbd641$export$71a4a707257f2774 = "gen_ai.conversation.id";





const $32674b1da3a6c619$export$6e69537d67fa20f = "sentry-";
const $32674b1da3a6c619$export$eb0401070c617ea5 = /^sentry-/;
const $32674b1da3a6c619$export$bdd844ddb2def819 = 8192;
function $32674b1da3a6c619$export$5b96ee2c8421f107(baggageHeader) {
    const baggageObject = $32674b1da3a6c619$export$397de414d189db00(baggageHeader);
    if (!baggageObject) return void 0;
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.startsWith($32674b1da3a6c619$export$6e69537d67fa20f)) {
            const nonPrefixedKey = key.slice($32674b1da3a6c619$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return void 0;
}
function $32674b1da3a6c619$export$56766feef403f365(dynamicSamplingContext) {
    if (!dynamicSamplingContext) return void 0;
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$32674b1da3a6c619$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $32674b1da3a6c619$export$12a7349a29a6e3c2(sentryPrefixedDSC);
}
function $32674b1da3a6c619$export$397de414d189db00(baggageHeader) {
    if (!baggageHeader || !(0, $2660f95a1b0d39e6$export$844ec244b1367d54)(baggageHeader) && !Array.isArray(baggageHeader)) return void 0;
    if (Array.isArray(baggageHeader)) return baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $32674b1da3a6c619$var$baggageHeaderToObject(curr);
        Object.entries(currBaggageObject).forEach(([key, value])=>{
            acc[key] = value;
        });
        return acc;
    }, {});
    return $32674b1da3a6c619$var$baggageHeaderToObject(baggageHeader);
}
function $32674b1da3a6c619$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(",").map((baggageEntry)=>{
        const eqIdx = baggageEntry.indexOf("=");
        if (eqIdx === -1) return [];
        const key = baggageEntry.slice(0, eqIdx);
        const value = baggageEntry.slice(eqIdx + 1);
        return [
            key,
            value
        ].map((keyOrValue)=>{
            try {
                return decodeURIComponent(keyOrValue.trim());
            } catch  {
                return;
            }
        });
    }).reduce((acc, [key, value])=>{
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
function $32674b1da3a6c619$export$12a7349a29a6e3c2(object) {
    if (Object.keys(object).length === 0) return void 0;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $32674b1da3a6c619$export$bdd844ddb2def819) {
            (0, $2deb03c4495ce01f$export$16a28057038b10ef) && (0, $dd4af310e95b2daa$export$1c9f709888824e05).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, "");
}
function $32674b1da3a6c619$export$7b8640b7baaa3922(existing, incoming) {
    if (!existing) return incoming;
    const existingEntries = $32674b1da3a6c619$export$397de414d189db00(existing);
    const incomingEntries = $32674b1da3a6c619$export$397de414d189db00(incoming);
    if (!incomingEntries) return existing;
    const merged = {};
    let hasNewSentryEntries = false;
    const newSentryEntries = {};
    const newNonSentryEntries = {};
    for (const [key, value] of Object.entries(incomingEntries))if (key.startsWith($32674b1da3a6c619$export$6e69537d67fa20f)) {
        newSentryEntries[key] = value;
        hasNewSentryEntries = true;
    } else newNonSentryEntries[key] = value;
    if (existingEntries) {
        for (const [key, value] of Object.entries(existingEntries))if (!hasNewSentryEntries || !key.startsWith($32674b1da3a6c619$export$6e69537d67fa20f)) merged[key] = value;
    }
    if (hasNewSentryEntries) Object.assign(merged, newSentryEntries);
    for (const [key, value] of Object.entries(newNonSentryEntries))merged[key] ?? (merged[key] = value);
    return $32674b1da3a6c619$export$12a7349a29a6e3c2(merged);
}





function $fe046bb65185662c$export$18ce21a8b7efd7e9(fn, onError, onFinally = ()=>{}, onSuccess = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $fe046bb65185662c$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally, onSuccess);
}
function $fe046bb65185662c$var$maybeHandlePromiseRejection(value, onError, onFinally, onSuccess) {
    if ((0, $2660f95a1b0d39e6$export$f5b060c2914b97c8)(value)) return (0, $08b8884e1d2d75db$export$64da0f40b0f924ba)(value, (result)=>{
        onFinally();
        onSuccess(result);
    }, (err)=>{
        onError(err);
        onFinally();
    });
    onFinally();
    onSuccess(value);
    return value;
}



function $264ccf395dedc77f$export$1f70765132c3c225(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === "boolean" && !__SENTRY_TRACING__) return false;
    const options = maybeOptions || (0, $feb8814e57364805$export$6bb76d6eba7e258c)()?.getOptions();
    return !!options && // Note: This check is `!= null`, meaning "nullish". `0` is not "nullish", `undefined` and `null` are. (This comment was brought to you by 15 minutes of questioning life)
    (options.tracesSampleRate != null || !!options.tracesSampler);
}





function $476422f58a102e80$var$logIgnoredSpan(droppedSpan) {
    (0, $dd4af310e95b2daa$export$1c9f709888824e05).log(`Ignoring span ${droppedSpan.op} - ${droppedSpan.description} because it matches \`ignoreSpans\`.`);
}
function $476422f58a102e80$export$5d569ac97c389400(span, ignoreSpans) {
    if (!ignoreSpans?.length) return false;
    for (const pattern of ignoreSpans){
        if ($476422f58a102e80$var$isStringOrRegExp(pattern)) {
            if (span.description && (0, $2088fbfa8bfbfeb6$export$cdded5b28a5f8c6d)(span.description, pattern)) {
                (0, $2deb03c4495ce01f$export$16a28057038b10ef) && $476422f58a102e80$var$logIgnoredSpan(span);
                return true;
            }
            continue;
        }
        const hasAttributes = !!pattern.attributes && Object.keys(pattern.attributes).length > 0;
        if (!pattern.name && !pattern.op && !hasAttributes) continue;
        const nameMatches = pattern.name ? span.description && (0, $2088fbfa8bfbfeb6$export$cdded5b28a5f8c6d)(span.description, pattern.name) : true;
        const opMatches = pattern.op ? span.op && (0, $2088fbfa8bfbfeb6$export$cdded5b28a5f8c6d)(span.op, pattern.op) : true;
        const attrsMatch = pattern.attributes ? Object.entries(pattern.attributes).every(([key, valuePattern])=>$476422f58a102e80$var$_matchesAttributeValue(span.attributes?.[key], valuePattern)) : true;
        if (nameMatches && opMatches && attrsMatch) {
            (0, $2deb03c4495ce01f$export$16a28057038b10ef) && $476422f58a102e80$var$logIgnoredSpan(span);
            return true;
        }
    }
    return false;
}
function $476422f58a102e80$var$_matchesAttributeValue(actual, pat) {
    if (typeof actual === "string" && (typeof pat === "string" || pat instanceof RegExp)) return (0, $2088fbfa8bfbfeb6$export$cdded5b28a5f8c6d)(actual, pat);
    if (Array.isArray(actual) && Array.isArray(pat)) return actual.length === pat.length && actual.every((v, i)=>v === pat[i]);
    return actual === pat;
}
function $476422f58a102e80$export$ddf57376e818b444(spans, dropSpan) {
    const droppedSpanParentId = dropSpan.parent_span_id;
    const droppedSpanId = dropSpan.span_id;
    if (!droppedSpanParentId) return;
    for (const span of spans)if (span.parent_span_id === droppedSpanId) span.parent_span_id = droppedSpanParentId;
}
function $476422f58a102e80$var$isStringOrRegExp(value) {
    return typeof value === "string" || value instanceof RegExp;
}


function $a1f1ce22c197cf20$export$6ea47215d699c04a(client) {
    return client.getOptions().traceLifecycle === "stream";
}


function $4f88660a1945fceb$export$a5bd2d81656d9546(sampleRate) {
    if (typeof sampleRate === "boolean") return Number(sampleRate);
    const rate = typeof sampleRate === "string" ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== "number" || isNaN(rate) || rate < 0 || rate > 1) return void 0;
    return rate;
}







function $f445e0a7588d41cc$export$f5706f332d297c38(maybeObj) {
    return typeof maybeObj === "object" && maybeObj != null && !Array.isArray(maybeObj) && Object.keys(maybeObj).includes("value");
}
function $f445e0a7588d41cc$export$f18f8779fed6dfa(rawValue, useFallback) {
    const { value: value, unit: unit } = $f445e0a7588d41cc$export$f5706f332d297c38(rawValue) ? rawValue : {
        value: rawValue,
        unit: void 0
    };
    const attributeValue = $f445e0a7588d41cc$var$getTypedAttributeValue(value);
    const checkedUnit = unit && typeof unit === "string" ? {
        unit: unit
    } : {};
    if (attributeValue) return {
        ...attributeValue,
        ...checkedUnit
    };
    if (!useFallback || useFallback === "skip-undefined" && value === void 0) return;
    let stringValue = "";
    try {
        stringValue = JSON.stringify(value) ?? "";
    } catch  {}
    return {
        value: stringValue,
        type: "string",
        ...checkedUnit
    };
}
function $f445e0a7588d41cc$export$4954cae66e755861(attributes, fallback = false) {
    const serializedAttributes = {};
    for (const [key, value] of Object.entries(attributes ?? {})){
        const typedValue = $f445e0a7588d41cc$export$f18f8779fed6dfa(value, fallback);
        if (typedValue) serializedAttributes[key] = typedValue;
    }
    return serializedAttributes;
}
function $f445e0a7588d41cc$export$97341f7cd97c59f(attributes) {
    if (!attributes) return 0;
    let weight = 0;
    for (const [key, attr] of Object.entries(attributes)){
        weight += key.length * 2;
        weight += attr.type.length * 2;
        weight += (attr.unit?.length ?? 0) * 2;
        const val = attr.value;
        if (Array.isArray(val)) weight += $f445e0a7588d41cc$var$estimatePrimitiveSizeInBytes(val[0]) * val.length;
        else if ((0, $2660f95a1b0d39e6$export$c3825b437cbdea5c)(val)) weight += $f445e0a7588d41cc$var$estimatePrimitiveSizeInBytes(val);
        else weight += 100;
    }
    return weight;
}
function $f445e0a7588d41cc$var$estimatePrimitiveSizeInBytes(value) {
    if (typeof value === "string") return value.length * 2;
    else if (typeof value === "boolean") return 4;
    else if (typeof value === "number") return 8;
    return 0;
}
function $f445e0a7588d41cc$var$getTypedAttributeValue(value) {
    if (Array.isArray(value)) return {
        value: value,
        type: "array"
    };
    const primitiveType = typeof value === "string" ? "string" : typeof value === "boolean" ? "boolean" : typeof value === "number" && !Number.isNaN(value) ? Number.isInteger(value) ? "integer" : "double" : null;
    if (primitiveType) return {
        value: value,
        type: primitiveType
    };
}





const $29f989c1c2b83882$export$136e25984ba4a383 = 0;
const $29f989c1c2b83882$export$58f7963109c806fc = 1;
const $29f989c1c2b83882$export$f966a0446ece71e = 2;
function $29f989c1c2b83882$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: $29f989c1c2b83882$export$58f7963109c806fc
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: $29f989c1c2b83882$export$f966a0446ece71e,
                message: "unauthenticated"
            };
        case 403:
            return {
                code: $29f989c1c2b83882$export$f966a0446ece71e,
                message: "permission_denied"
            };
        case 404:
            return {
                code: $29f989c1c2b83882$export$f966a0446ece71e,
                message: "not_found"
            };
        case 409:
            return {
                code: $29f989c1c2b83882$export$f966a0446ece71e,
                message: "already_exists"
            };
        case 413:
            return {
                code: $29f989c1c2b83882$export$f966a0446ece71e,
                message: "failed_precondition"
            };
        case 429:
            return {
                code: $29f989c1c2b83882$export$f966a0446ece71e,
                message: "resource_exhausted"
            };
        case 499:
            return {
                code: $29f989c1c2b83882$export$f966a0446ece71e,
                message: "cancelled"
            };
        default:
            return {
                code: $29f989c1c2b83882$export$f966a0446ece71e,
                message: "invalid_argument"
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: $29f989c1c2b83882$export$f966a0446ece71e,
                message: "unimplemented"
            };
        case 503:
            return {
                code: $29f989c1c2b83882$export$f966a0446ece71e,
                message: "unavailable"
            };
        case 504:
            return {
                code: $29f989c1c2b83882$export$f966a0446ece71e,
                message: "deadline_exceeded"
            };
        default:
            return {
                code: $29f989c1c2b83882$export$f966a0446ece71e,
                message: "internal_error"
            };
    }
    return {
        code: $29f989c1c2b83882$export$f966a0446ece71e,
        message: "internal_error"
    };
}
function $29f989c1c2b83882$export$2ad6630ec8164254(span, httpStatus) {
    span.setAttribute("http.response.status_code", httpStatus);
    const spanStatus = $29f989c1c2b83882$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus.message !== "unknown_error") span.setStatus(spanStatus);
}




function $a10436b3597d732d$export$f0b98edec95fcb33(value) {
    try {
        const WeakRefImpl = (0, $f217104c897b328f$export$f1a6cdb1459e81d1).WeakRef;
        if (typeof WeakRefImpl === "function") return new WeakRefImpl(value);
    } catch  {}
    return value;
}
function $a10436b3597d732d$export$a0592ad8c3586cf(ref) {
    if (!ref) return void 0;
    if (typeof ref === "object" && "deref" in ref && typeof ref.deref === "function") try {
        return ref.deref();
    } catch  {
        return void 0;
    }
    return ref;
}


const $eee56b24e446780d$var$SCOPE_ON_START_SPAN_FIELD = "_sentryScope";
const $eee56b24e446780d$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = "_sentryIsolationScope";
function $eee56b24e446780d$export$cddb4027e3b0dd66(span, scope, isolationScope) {
    if (span) {
        (0, $a964b80d2257757d$export$e73679ffaf56810e)(span, $eee56b24e446780d$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, (0, $a10436b3597d732d$export$f0b98edec95fcb33)(isolationScope));
        (0, $a964b80d2257757d$export$e73679ffaf56810e)(span, $eee56b24e446780d$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
function $eee56b24e446780d$export$c08fbc656a245d03(span) {
    const spanWithScopes = span;
    return {
        scope: spanWithScopes[$eee56b24e446780d$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: (0, $a10436b3597d732d$export$a0592ad8c3586cf)(spanWithScopes[$eee56b24e446780d$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD])
    };
}









const $0c724bebadb45a90$var$ORG_ID_REGEX = /^o(\d+)\./;
const $0c724bebadb45a90$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)((?:\[[:.%\w]+\]|[\w.-]+))(?::(\d+))?\/(.+)/;
function $0c724bebadb45a90$var$isValidProtocol(protocol) {
    return protocol === "http" || protocol === "https";
}
function $0c724bebadb45a90$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ""}@${host}${port ? `:${port}` : ""}/${path ? `${path}/` : path}${projectId}`;
}
function $0c724bebadb45a90$export$b892860177f70a30(str) {
    const match = $0c724bebadb45a90$var$DSN_REGEX.exec(str);
    if (!match) {
        (0, $dd4af310e95b2daa$export$cda52e2a8927a2ca)(()=>{
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return void 0;
    }
    const [protocol, publicKey, pass = "", host = "", port = "", lastPath = ""] = match.slice(1);
    let path = "";
    let projectId = lastPath;
    const split = projectId.split("/");
    if (split.length > 1) {
        path = split.slice(0, -1).join("/");
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $0c724bebadb45a90$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $0c724bebadb45a90$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || "",
        pass: components.pass || "",
        host: components.host,
        port: components.port || "",
        path: components.path || "",
        projectId: components.projectId
    };
}
function $0c724bebadb45a90$var$validateDsn(dsn) {
    if (!(0, $2deb03c4495ce01f$export$16a28057038b10ef)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        "protocol",
        "publicKey",
        "host",
        "projectId"
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $dd4af310e95b2daa$export$1c9f709888824e05).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $dd4af310e95b2daa$export$1c9f709888824e05).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$0c724bebadb45a90$var$isValidProtocol(protocol)) {
        (0, $dd4af310e95b2daa$export$1c9f709888824e05).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $dd4af310e95b2daa$export$1c9f709888824e05).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
function $0c724bebadb45a90$export$5914f4e7748c29c9(host) {
    const match = host.match($0c724bebadb45a90$var$ORG_ID_REGEX);
    return match?.[1];
}
function $0c724bebadb45a90$export$b7ac9b8efa4bb595(client) {
    const options = client.getOptions();
    const { host: host } = client.getDsn() || {};
    let org_id;
    if (options.orgId) org_id = String(options.orgId);
    else if (host) org_id = $0c724bebadb45a90$export$5914f4e7748c29c9(host);
    return org_id;
}
function $0c724bebadb45a90$export$128827c3562ec0cb(from) {
    const components = typeof from === "string" ? $0c724bebadb45a90$export$b892860177f70a30(from) : $0c724bebadb45a90$var$dsnFromComponents(from);
    if (!components || !$0c724bebadb45a90$var$validateDsn(components)) return void 0;
    return components;
}





const $13171373d98776e8$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
function $13171373d98776e8$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return void 0;
    const matches = traceparent.match($13171373d98776e8$export$394a210812ba3012);
    if (!matches) return void 0;
    let parentSampled;
    if (matches[3] === "1") parentSampled = true;
    else if (matches[3] === "0") parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
function $13171373d98776e8$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $13171373d98776e8$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $32674b1da3a6c619$export$5b96ee2c8421f107)(baggage);
    if (!traceparentData?.traceId) return {
        traceId: (0, $37dcada2a8c7465b$export$dc6d7ea554bcce10)(),
        sampleRand: (0, $0d33076536fcb49a$export$9869d72de32a3917)()
    };
    const sampleRand = $13171373d98776e8$var$getSampleRandFromTraceparentAndDsc(traceparentData, dynamicSamplingContext);
    if (dynamicSamplingContext) dynamicSamplingContext.sample_rand = sampleRand.toString();
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData;
    return {
        traceId: traceId,
        parentSpanId: parentSpanId,
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {},
        sampleRand: // If we have traceparent data but no DSC it means we are not head of trace and we must freeze it
        sampleRand
    };
}
function $13171373d98776e8$export$f35d907436da45cf(traceId = (0, $37dcada2a8c7465b$export$dc6d7ea554bcce10)(), spanId = (0, $37dcada2a8c7465b$export$295213bc4d0c54ad)(), sampled) {
    let sampledString = "";
    if (sampled !== void 0) sampledString = sampled ? "-1" : "-0";
    return `${traceId}-${spanId}${sampledString}`;
}
function $13171373d98776e8$export$1aff3752542747dd(traceId = (0, $37dcada2a8c7465b$export$dc6d7ea554bcce10)(), spanId = (0, $37dcada2a8c7465b$export$295213bc4d0c54ad)(), sampled) {
    return `00-${traceId}-${spanId}-${sampled ? "01" : "00"}`;
}
function $13171373d98776e8$var$getSampleRandFromTraceparentAndDsc(traceparentData, dsc) {
    const parsedSampleRand = (0, $4f88660a1945fceb$export$a5bd2d81656d9546)(dsc?.sample_rand);
    if (parsedSampleRand !== void 0) return parsedSampleRand;
    const parsedSampleRate = (0, $4f88660a1945fceb$export$a5bd2d81656d9546)(dsc?.sample_rate);
    if (parsedSampleRate && traceparentData?.parentSampled !== void 0) return traceparentData.parentSampled ? // Returns a sample rand with positive sampling decision [0, sampleRate)
    (0, $0d33076536fcb49a$export$9869d72de32a3917)() * parsedSampleRate : // Returns a sample rand with negative sampling decision [sampleRate, 1)
    parsedSampleRate + (0, $0d33076536fcb49a$export$9869d72de32a3917)() * (1 - parsedSampleRate);
    else return (0, $0d33076536fcb49a$export$9869d72de32a3917)();
}
function $13171373d98776e8$export$18811bc99eefceaa(client, baggageOrgId) {
    const clientOrgId = (0, $0c724bebadb45a90$export$b7ac9b8efa4bb595)(client);
    if (baggageOrgId && clientOrgId && baggageOrgId !== clientOrgId) {
        (0, $dd4af310e95b2daa$export$1c9f709888824e05).log(`Won't continue trace because org IDs don't match (incoming baggage: ${baggageOrgId}, SDK options: ${clientOrgId})`);
        return false;
    }
    const strictTraceContinuation = client.getOptions().strictTraceContinuation || false;
    if (strictTraceContinuation) {
        if (baggageOrgId && !clientOrgId || !baggageOrgId && clientOrgId) {
            (0, $dd4af310e95b2daa$export$1c9f709888824e05).log(`Starting a new trace because strict trace continuation is enabled but one org ID is missing (incoming baggage: ${baggageOrgId}, Sentry client: ${clientOrgId})`);
            return false;
        }
    }
    return true;
}




const $5a613f00f24f7165$export$208d5b368507fb8b = 0;
const $5a613f00f24f7165$export$eb571cd9b5d98de8 = 1;
let $5a613f00f24f7165$var$hasShownSpanDropWarning = false;
function $5a613f00f24f7165$export$4c3967a8a2f6bbd6(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, origin: origin, links: links } = $5a613f00f24f7165$export$92d8c23565496537(span);
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id,
        data: data,
        op: op,
        status: status,
        origin: origin,
        links: links
    };
}
function $5a613f00f24f7165$export$46c6fbd1d265ebf0(span) {
    const { spanId: spanId, traceId: trace_id, isRemote: isRemote } = span.spanContext();
    const parent_span_id = isRemote ? spanId : $5a613f00f24f7165$export$92d8c23565496537(span).parent_span_id;
    const scope = (0, $eee56b24e446780d$export$c08fbc656a245d03)(span).scope;
    const span_id = isRemote ? scope?.getPropagationContext().propagationSpanId || (0, $37dcada2a8c7465b$export$295213bc4d0c54ad)() : spanId;
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id
    };
}
function $5a613f00f24f7165$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $5a613f00f24f7165$export$5caecac1caaf3a71(span);
    return (0, $13171373d98776e8$export$f35d907436da45cf)(traceId, spanId, sampled);
}
function $5a613f00f24f7165$export$cda58d87bc594e9f(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $5a613f00f24f7165$export$5caecac1caaf3a71(span);
    return (0, $13171373d98776e8$export$1aff3752542747dd)(traceId, spanId, sampled);
}
function $5a613f00f24f7165$export$cb3e3a12e0eec16c(links) {
    if (links && links.length > 0) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags, ...restContext }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $5a613f00f24f7165$export$eb571cd9b5d98de8,
            attributes: attributes,
            ...restContext
        }));
    else return void 0;
}
function $5a613f00f24f7165$export$9015adcf158ef3a5(links) {
    if (links?.length) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $5a613f00f24f7165$export$eb571cd9b5d98de8,
            attributes: attributes
        }));
    else return void 0;
}
function $5a613f00f24f7165$export$3f7581298f56c6d7(input) {
    if (typeof input === "number") return $5a613f00f24f7165$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $5a613f00f24f7165$var$ensureTimestampInSeconds(input.getTime());
    return (0, $fd9cf0b48f691186$export$ee52dced521e3e18)();
}
function $5a613f00f24f7165$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1e3 : timestamp;
}
function $5a613f00f24f7165$export$92d8c23565496537(span) {
    if ($5a613f00f24f7165$var$spanIsSentrySpan(span)) return span.getSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    if ($5a613f00f24f7165$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, status: status, links: links } = span;
        return {
            span_id: span_id,
            trace_id: trace_id,
            data: attributes,
            description: name,
            parent_span_id: $5a613f00f24f7165$var$getOtelParentSpanId(span),
            start_timestamp: $5a613f00f24f7165$export$3f7581298f56c6d7(startTime),
            // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
            timestamp: $5a613f00f24f7165$export$3f7581298f56c6d7(endTime) || void 0,
            status: $5a613f00f24f7165$export$e238a77ea3a8cd66(status),
            op: attributes[0, $fbf607a81dcbd641$export$1a413bd9a88fdb09],
            origin: attributes[0, $fbf607a81dcbd641$export$cca8dd30f57f805e],
            links: $5a613f00f24f7165$export$cb3e3a12e0eec16c(links)
        };
    }
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        data: {}
    };
}
function $5a613f00f24f7165$export$db0cad9e44f67af8(span) {
    if ($5a613f00f24f7165$var$spanIsSentrySpan(span)) return span.getStreamedSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    if ($5a613f00f24f7165$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, status: status, links: links } = span;
        return {
            name: name,
            span_id: span_id,
            trace_id: trace_id,
            parent_span_id: $5a613f00f24f7165$var$getOtelParentSpanId(span),
            start_timestamp: $5a613f00f24f7165$export$3f7581298f56c6d7(startTime),
            end_timestamp: $5a613f00f24f7165$export$3f7581298f56c6d7(endTime),
            is_segment: span === $5a613f00f24f7165$export$7a3106f345d83bb6(span),
            status: $5a613f00f24f7165$export$457dcd3df4e9f5c6(status),
            attributes: attributes,
            links: $5a613f00f24f7165$export$9015adcf158ef3a5(links)
        };
    }
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        name: "",
        end_timestamp: 0,
        status: "ok",
        is_segment: span === $5a613f00f24f7165$export$7a3106f345d83bb6(span)
    };
}
function $5a613f00f24f7165$var$getOtelParentSpanId(span) {
    return "parentSpanId" in span ? span.parentSpanId : "parentSpanContext" in span ? span.parentSpanContext?.spanId : void 0;
}
function $5a613f00f24f7165$export$5402aa553bcf35f3(spanJson) {
    return {
        ...spanJson,
        attributes: (0, $f445e0a7588d41cc$export$4954cae66e755861)(spanJson.attributes),
        links: spanJson.links?.map((link)=>({
                ...link,
                attributes: (0, $f445e0a7588d41cc$export$4954cae66e755861)(link.attributes)
            }))
    };
}
function $5a613f00f24f7165$var$spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    const castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
function $5a613f00f24f7165$var$spanIsSentrySpan(span) {
    return typeof span.getSpanJSON === "function";
}
function $5a613f00f24f7165$export$5caecac1caaf3a71(span) {
    const { traceFlags: traceFlags } = span.spanContext();
    return traceFlags === $5a613f00f24f7165$export$eb571cd9b5d98de8;
}
function $5a613f00f24f7165$export$e238a77ea3a8cd66(status) {
    if (!status || status.code === (0, $29f989c1c2b83882$export$136e25984ba4a383)) return void 0;
    if (status.code === (0, $29f989c1c2b83882$export$58f7963109c806fc)) return "ok";
    return status.message || "internal_error";
}
function $5a613f00f24f7165$export$457dcd3df4e9f5c6(status) {
    return !status || status.code === (0, $29f989c1c2b83882$export$58f7963109c806fc) || status.code === (0, $29f989c1c2b83882$export$136e25984ba4a383) || status.message === "cancelled" ? "ok" : "error";
}
const $5a613f00f24f7165$var$CHILD_SPANS_FIELD = "_sentryChildSpans";
const $5a613f00f24f7165$var$ROOT_SPAN_FIELD = "_sentryRootSpan";
function $5a613f00f24f7165$export$81397d924722cc65(span, childSpan) {
    const rootSpan = span[$5a613f00f24f7165$var$ROOT_SPAN_FIELD] || span;
    (0, $a964b80d2257757d$export$e73679ffaf56810e)(childSpan, $5a613f00f24f7165$var$ROOT_SPAN_FIELD, rootSpan);
    if (span[$5a613f00f24f7165$var$CHILD_SPANS_FIELD]) span[$5a613f00f24f7165$var$CHILD_SPANS_FIELD].add(childSpan);
    else (0, $a964b80d2257757d$export$e73679ffaf56810e)(span, $5a613f00f24f7165$var$CHILD_SPANS_FIELD, /* @__PURE__ */ new Set([
        childSpan
    ]));
}
function $5a613f00f24f7165$export$c2a0c9438bb89d91(span, childSpan) {
    if (span[$5a613f00f24f7165$var$CHILD_SPANS_FIELD]) span[$5a613f00f24f7165$var$CHILD_SPANS_FIELD].delete(childSpan);
}
function $5a613f00f24f7165$export$340c5c8a13ffc680(span) {
    const resultSet = /* @__PURE__ */ new Set();
    function addSpanChildren(span2) {
        if (resultSet.has(span2)) return;
        else if ($5a613f00f24f7165$export$5caecac1caaf3a71(span2)) {
            resultSet.add(span2);
            const childSpans = span2[$5a613f00f24f7165$var$CHILD_SPANS_FIELD] ? Array.from(span2[$5a613f00f24f7165$var$CHILD_SPANS_FIELD]) : [];
            for (const childSpan of childSpans)addSpanChildren(childSpan);
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
const $5a613f00f24f7165$export$c4c6a79b1260ca1b = $5a613f00f24f7165$export$7a3106f345d83bb6;
function $5a613f00f24f7165$export$7a3106f345d83bb6(span) {
    return span[$5a613f00f24f7165$var$ROOT_SPAN_FIELD] || span;
}
function $5a613f00f24f7165$export$1be426a8e585c83e() {
    const carrier = (0, $f93478a31a56772c$export$19eade501500c6c1)();
    const acs = (0, $5a330bff927d6eb3$export$f639b0c2752203be)(carrier);
    if (acs.getActiveSpan) return acs.getActiveSpan();
    return (0, $5ece2fb3ee38e4e7$export$91f063ebb8eff307)((0, $feb8814e57364805$export$c7be4b0125a10cba)());
}
function $5a613f00f24f7165$export$d11691ff45a3e535() {
    if (!$5a613f00f24f7165$var$hasShownSpanDropWarning) {
        (0, $dd4af310e95b2daa$export$cda52e2a8927a2ca)(()=>{
            console.warn("[Sentry] Returning null from `beforeSendSpan` is disallowed. To drop certain spans, configure the respective integrations directly or use `ignoreSpans`.");
        });
        $5a613f00f24f7165$var$hasShownSpanDropWarning = true;
    }
}
function $5a613f00f24f7165$export$5b72d3169c1be715(span, name) {
    span.updateName(name);
    span.setAttributes({
        [(0, $fbf607a81dcbd641$export$d7a7d984b0791405)]: "custom",
        [(0, $fbf607a81dcbd641$export$165ce9a229f6f050)]: name
    });
}



const $e345d2a6280067b6$export$849dbeeeda01ae98 = "production";
const $e345d2a6280067b6$export$6829f580e78306fa = "development";










const $6d02d85b64e23ac2$var$FROZEN_DSC_FIELD = "_frozenDsc";
function $6d02d85b64e23ac2$export$7398c93e763ca9fd(span, dsc) {
    const spanWithMaybeDsc = span;
    (0, $a964b80d2257757d$export$e73679ffaf56810e)(spanWithMaybeDsc, $6d02d85b64e23ac2$var$FROZEN_DSC_FIELD, dsc);
}
function $6d02d85b64e23ac2$export$366bad00d6815eed(trace_id, client) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    const dsc = {
        environment: options.environment || (0, $e345d2a6280067b6$export$849dbeeeda01ae98),
        release: options.release,
        public_key: public_key,
        trace_id: trace_id,
        org_id: (0, $0c724bebadb45a90$export$b7ac9b8efa4bb595)(client)
    };
    client.emit("createDsc", dsc);
    return dsc;
}
function $6d02d85b64e23ac2$export$89ef1736f08c6b2b(client, scope) {
    const propagationContext = scope.getPropagationContext();
    return propagationContext.dsc || $6d02d85b64e23ac2$export$366bad00d6815eed(propagationContext.traceId, client);
}
function $6d02d85b64e23ac2$export$a117f995597e25df(span) {
    const client = (0, $feb8814e57364805$export$6bb76d6eba7e258c)();
    if (!client) return {};
    const rootSpan = (0, $5a613f00f24f7165$export$c4c6a79b1260ca1b)(span);
    const rootSpanJson = (0, $5a613f00f24f7165$export$92d8c23565496537)(rootSpan);
    const rootSpanAttributes = rootSpanJson.data;
    const traceState = rootSpan.spanContext().traceState;
    const rootSpanSampleRate = traceState?.get("sentry.sample_rate") ?? rootSpanAttributes[0, $fbf607a81dcbd641$export$ccfe0a40627cc34b] ?? rootSpanAttributes[0, $fbf607a81dcbd641$export$889fb736668e1ecc];
    function applyLocalSampleRateToDsc(dsc2) {
        if (typeof rootSpanSampleRate === "number" || typeof rootSpanSampleRate === "string") dsc2.sample_rate = `${rootSpanSampleRate}`;
        return dsc2;
    }
    const frozenDsc = rootSpan[$6d02d85b64e23ac2$var$FROZEN_DSC_FIELD];
    if (frozenDsc) return applyLocalSampleRateToDsc(frozenDsc);
    const traceStateDsc = traceState?.get("sentry.dsc");
    const dscOnTraceState = traceStateDsc && (0, $32674b1da3a6c619$export$5b96ee2c8421f107)(traceStateDsc);
    if (dscOnTraceState) return applyLocalSampleRateToDsc(dscOnTraceState);
    const dsc = $6d02d85b64e23ac2$export$366bad00d6815eed(span.spanContext().traceId, client);
    const source = rootSpanAttributes[0, $fbf607a81dcbd641$export$d7a7d984b0791405] ?? rootSpanAttributes["sentry.span.source"];
    const name = rootSpanJson.description;
    if (source !== "url" && name) dsc.transaction = name;
    if ((0, $264ccf395dedc77f$export$1f70765132c3c225)()) {
        dsc.sampled = String((0, $5a613f00f24f7165$export$5caecac1caaf3a71)(rootSpan));
        dsc.sample_rand = // The Sentry OTEL SpanSampler takes care of writing the sample rand on the root span
        traceState?.get("sentry.sample_rand") ?? // On all other platforms we can actually get the scopes from a root span (we use this as a fallback)
        (0, $eee56b24e446780d$export$c08fbc656a245d03)(rootSpan).scope?.getPropagationContext().sampleRand.toString();
    }
    applyLocalSampleRateToDsc(dsc);
    client.emit("createDsc", dsc, rootSpan);
    return dsc;
}
function $6d02d85b64e23ac2$export$95cf936fdacaff7b(span) {
    const dsc = $6d02d85b64e23ac2$export$a117f995597e25df(span);
    return (0, $32674b1da3a6c619$export$56766feef403f365)(dsc);
}





function $561c21a1edb0b887$export$2f3d84e767c9592b(span) {
    if (!(0, $2deb03c4495ce01f$export$16a28057038b10ef)) return;
    const { description: description = "< unknown name >", op: op = "< unknown op >", parent_span_id: parentSpanId } = (0, $5a613f00f24f7165$export$92d8c23565496537)(span);
    const { spanId: spanId } = span.spanContext();
    const sampled = (0, $5a613f00f24f7165$export$5caecac1caaf3a71)(span);
    const rootSpan = (0, $5a613f00f24f7165$export$c4c6a79b1260ca1b)(span);
    const isRootSpan = rootSpan === span;
    const header = `[Tracing] Starting ${sampled ? "sampled" : "unsampled"} ${isRootSpan ? "root " : ""}span`;
    const infoParts = [
        `op: ${op}`,
        `name: ${description}`,
        `ID: ${spanId}`
    ];
    if (parentSpanId) infoParts.push(`parent ID: ${parentSpanId}`);
    if (!isRootSpan) {
        const { op: op2, description: description2 } = (0, $5a613f00f24f7165$export$92d8c23565496537)(rootSpan);
        infoParts.push(`root ID: ${rootSpan.spanContext().spanId}`);
        if (op2) infoParts.push(`root op: ${op2}`);
        if (description2) infoParts.push(`root description: ${description2}`);
    }
    (0, $dd4af310e95b2daa$export$1c9f709888824e05).log(`${header}
  ${infoParts.join("\n  ")}`);
}
function $561c21a1edb0b887$export$b77c830667a4d630(span) {
    if (!(0, $2deb03c4495ce01f$export$16a28057038b10ef)) return;
    const { description: description = "< unknown name >", op: op = "< unknown op >" } = (0, $5a613f00f24f7165$export$92d8c23565496537)(span);
    const { spanId: spanId } = span.spanContext();
    const rootSpan = (0, $5a613f00f24f7165$export$c4c6a79b1260ca1b)(span);
    const isRootSpan = rootSpan === span;
    const msg = `[Tracing] Finishing "${op}" ${isRootSpan ? "root " : ""}span "${description}" with ID ${spanId}`;
    (0, $dd4af310e95b2daa$export$1c9f709888824e05).log(msg);
}






function $28d1c2cf27dfe29d$export$5f833db634b217bb(options, samplingContext, sampleRand) {
    if (!(0, $264ccf395dedc77f$export$1f70765132c3c225)(options)) return [
        false
    ];
    let localSampleRateWasApplied = void 0;
    let sampleRate;
    if (typeof options.tracesSampler === "function") {
        sampleRate = options.tracesSampler({
            ...samplingContext,
            inheritOrSampleWith: (fallbackSampleRate)=>{
                if (typeof samplingContext.parentSampleRate === "number") return samplingContext.parentSampleRate;
                if (typeof samplingContext.parentSampled === "boolean") return Number(samplingContext.parentSampled);
                return fallbackSampleRate;
            }
        });
        localSampleRateWasApplied = true;
    } else if (samplingContext.parentSampled !== void 0) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== "undefined") {
        sampleRate = options.tracesSampleRate;
        localSampleRateWasApplied = true;
    }
    const parsedSampleRate = (0, $4f88660a1945fceb$export$a5bd2d81656d9546)(sampleRate);
    if (parsedSampleRate === void 0) {
        (0, $2deb03c4495ce01f$export$16a28057038b10ef) && (0, $dd4af310e95b2daa$export$1c9f709888824e05).warn(`[Tracing] Discarding root span because of invalid sample rate. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(sampleRate)} of type ${JSON.stringify(typeof sampleRate)}.`);
        return [
            false
        ];
    }
    if (!parsedSampleRate) {
        (0, $2deb03c4495ce01f$export$16a28057038b10ef) && (0, $dd4af310e95b2daa$export$1c9f709888824e05).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === "function" ? "tracesSampler returned 0 or false" : "a negative sampling decision was inherited or tracesSampleRate is set to 0"}`);
        return [
            false,
            parsedSampleRate,
            localSampleRateWasApplied
        ];
    }
    const shouldSample = sampleRand < parsedSampleRate;
    if (!shouldSample) (0, $2deb03c4495ce01f$export$16a28057038b10ef) && (0, $dd4af310e95b2daa$export$1c9f709888824e05).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
    return [
        shouldSample,
        parsedSampleRate,
        localSampleRateWasApplied
    ];
}




class $e95b1cceff42f823$export$d6636b700b76c516 {
    constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $37dcada2a8c7465b$export$dc6d7ea554bcce10)();
        this._spanId = spanContext.spanId || (0, $37dcada2a8c7465b$export$295213bc4d0c54ad)();
        this.dropReason = spanContext.dropReason;
    }
    /** @inheritdoc */ spanContext() {
        return {
            spanId: this._spanId,
            traceId: this._traceId,
            traceFlags: (0, $5a613f00f24f7165$export$208d5b368507fb8b)
        };
    }
    /** @inheritdoc */ end(_timestamp) {}
    /** @inheritdoc */ setAttribute(_key, _value) {
        return this;
    }
    /** @inheritdoc */ setAttributes(_values) {
        return this;
    }
    /** @inheritdoc */ setStatus(_status) {
        return this;
    }
    /** @inheritdoc */ updateName(_name) {
        return this;
    }
    /** @inheritdoc */ isRecording() {
        return false;
    }
    /** @inheritdoc */ addEvent(_name, _attributesOrStartTime, _startTime) {
        return this;
    }
    /** @inheritDoc */ addLink(_link) {
        return this;
    }
    /** @inheritDoc */ addLinks(_links) {
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {}
}






function $a2373b6b013d98db$export$d3f49b33a1f44720(callback) {
    (0, $a964b80d2257757d$export$e73679ffaf56810e)(callback, "_streamed", true);
    return callback;
}
function $a2373b6b013d98db$export$ca3e1ec3cdcc76ac(callback) {
    return !!callback && typeof callback === "function" && "_streamed" in callback && !!callback._streamed;
}







function $94c50881d8803006$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
function $94c50881d8803006$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
function $94c50881d8803006$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
function $94c50881d8803006$export$604a45d95a155e2b(envelope, types) {
    return $94c50881d8803006$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
function $94c50881d8803006$var$encodeUTF8(input) {
    const carrier = (0, $f93478a31a56772c$export$c8bfa33e4e8ae492)((0, $f217104c897b328f$export$f1a6cdb1459e81d1));
    return carrier.encodePolyfill ? carrier.encodePolyfill(input) : new TextEncoder().encode(input);
}
function $94c50881d8803006$var$decodeUTF8(input) {
    const carrier = (0, $f93478a31a56772c$export$c8bfa33e4e8ae492)((0, $f217104c897b328f$export$f1a6cdb1459e81d1));
    return carrier.decodePolyfill ? carrier.decodePolyfill(input) : new TextDecoder().decode(input);
}
function $94c50881d8803006$export$32f9b428425aac85(envelope) {
    const [envHeaders, items] = envelope;
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === "string") parts = typeof next === "string" ? parts + next : [
            $94c50881d8803006$var$encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === "string" ? $94c50881d8803006$var$encodeUTF8(next) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`
${JSON.stringify(itemHeaders)}
`);
        if (typeof payload === "string" || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch  {
                stringifiedPayload = JSON.stringify((0, $ac4a8bdf538bbe1f$export$a3295358bff77e)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === "string" ? parts : $94c50881d8803006$var$concatBuffers(parts);
}
function $94c50881d8803006$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
function $94c50881d8803006$export$3338d0c7b6e17a2b(env) {
    let buffer = typeof env === "string" ? $94c50881d8803006$var$encodeUTF8(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(10);
        if (i < 0) i = buffer.length;
        return JSON.parse($94c50881d8803006$var$decodeUTF8(readBinary(i)));
    }
    const envelopeHeader = readJson();
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === "number" ? itemHeader.length : void 0;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
function $94c50881d8803006$export$655cf139bc8b8afd(spanJson) {
    const spanHeaders = {
        type: "span"
    };
    return [
        spanHeaders,
        spanJson
    ];
}
function $94c50881d8803006$export$d8fc80952cc31fa4(attachment) {
    const buffer = typeof attachment.data === "string" ? $94c50881d8803006$var$encodeUTF8(attachment.data) : attachment.data;
    return [
        {
            type: "attachment",
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        },
        buffer
    ];
}
const $94c50881d8803006$var$DATA_CATEGORY_OVERRIDES = {
    sessions: "session",
    event: "error",
    client_report: "internal",
    user_report: "default",
    profile_chunk: "profile",
    replay_event: "replay",
    replay_recording: "replay",
    check_in: "monitor",
    raw_security: "security",
    log: "log_item",
    trace_metric: "metric"
};
function $94c50881d8803006$var$_isOverriddenType(type) {
    return type in $94c50881d8803006$var$DATA_CATEGORY_OVERRIDES;
}
function $94c50881d8803006$export$b11169581eeaf237(type) {
    return $94c50881d8803006$var$_isOverriddenType(type) ? $94c50881d8803006$var$DATA_CATEGORY_OVERRIDES[type] : type;
}
function $94c50881d8803006$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent?.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
function $94c50881d8803006$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata?.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: /* @__PURE__ */ new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $0c724bebadb45a90$export$44d472fbb931a776)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: dynamicSamplingContext
        }
    };
}




function $036fe402b3e061ac$export$8a6cdb6116a9fd2b(event, newSdkInfo) {
    if (!newSdkInfo) return event;
    const eventSdkInfo = event.sdk || {};
    event.sdk = {
        ...eventSdkInfo,
        name: eventSdkInfo.name || newSdkInfo.name,
        version: eventSdkInfo.version || newSdkInfo.version,
        integrations: [
            ...event.sdk?.integrations || [],
            ...newSdkInfo.integrations || []
        ],
        packages: [
            ...event.sdk?.packages || [],
            ...newSdkInfo.packages || []
        ],
        settings: event.sdk?.settings || newSdkInfo.settings ? {
            ...event.sdk?.settings,
            ...newSdkInfo.settings
        } : void 0
    };
    return event;
}
function $036fe402b3e061ac$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $94c50881d8803006$export$d369f3b2758f6743)(metadata);
    const envelopeHeaders = {
        sent_at: /* @__PURE__ */ new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $0c724bebadb45a90$export$44d472fbb931a776)(dsn)
        }
    };
    const envelopeItem = "aggregates" in session ? [
        {
            type: "sessions"
        },
        session
    ] : [
        {
            type: "session"
        },
        session.toJSON()
    ];
    return (0, $94c50881d8803006$export$f93f7f385160c44e)(envelopeHeaders, [
        envelopeItem
    ]);
}
function $036fe402b3e061ac$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $94c50881d8803006$export$d369f3b2758f6743)(metadata);
    const eventType = event.type && event.type !== "replay_event" ? event.type : "event";
    $036fe402b3e061ac$export$8a6cdb6116a9fd2b(event, metadata?.sdk);
    const envelopeHeaders = (0, $94c50881d8803006$export$92b6093782fe661b)(event, sdkInfo, tunnel, dsn);
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $94c50881d8803006$export$f93f7f385160c44e)(envelopeHeaders, [
        eventItem
    ]);
}
function $036fe402b3e061ac$export$19a0081d4b39d77(spans, client) {
    function dscHasRequiredProps(dsc2) {
        return !!dsc2.trace_id && !!dsc2.public_key;
    }
    const dsc = (0, $6d02d85b64e23ac2$export$a117f995597e25df)(spans[0]);
    const dsn = client?.getDsn();
    const tunnel = client?.getOptions().tunnel;
    const headers = {
        sent_at: /* @__PURE__ */ new Date().toISOString(),
        ...dscHasRequiredProps(dsc) && {
            trace: dsc
        },
        ...!!tunnel && dsn && {
            dsn: (0, $0c724bebadb45a90$export$44d472fbb931a776)(dsn)
        }
    };
    const { beforeSendSpan: beforeSendSpan, ignoreSpans: ignoreSpans } = client?.getOptions() || {};
    const filteredSpans = ignoreSpans?.length ? spans.filter((span)=>{
        const json = (0, $5a613f00f24f7165$export$92d8c23565496537)(span);
        return !(0, $476422f58a102e80$export$5d569ac97c389400)({
            description: json.description,
            op: json.op,
            attributes: json.data
        }, ignoreSpans);
    }) : spans;
    const droppedSpans = spans.length - filteredSpans.length;
    if (droppedSpans) client?.recordDroppedEvent("before_send", "span", droppedSpans);
    const convertToSpanJSON = beforeSendSpan ? (span)=>{
        const spanJson = (0, $5a613f00f24f7165$export$92d8c23565496537)(span);
        const processedSpan = !(0, $a2373b6b013d98db$export$ca3e1ec3cdcc76ac)(beforeSendSpan) ? beforeSendSpan(spanJson) : spanJson;
        if (!processedSpan) {
            (0, $5a613f00f24f7165$export$d11691ff45a3e535)();
            return spanJson;
        }
        return processedSpan;
    } : (0, $5a613f00f24f7165$export$92d8c23565496537);
    const items = [];
    for (const span of filteredSpans){
        const spanJson = convertToSpanJSON(span);
        if (spanJson) items.push((0, $94c50881d8803006$export$655cf139bc8b8afd)(spanJson));
    }
    return (0, $94c50881d8803006$export$f93f7f385160c44e)(headers, items);
}













function $043bcb59da76d3d5$export$7cc31b475d33a706(name, value, unit, activeSpan = (0, $5a613f00f24f7165$export$1be426a8e585c83e)()) {
    const rootSpan = activeSpan && (0, $5a613f00f24f7165$export$c4c6a79b1260ca1b)(activeSpan);
    if (rootSpan) {
        (0, $2deb03c4495ce01f$export$16a28057038b10ef) && (0, $dd4af310e95b2daa$export$1c9f709888824e05).log(`[Measurement] Setting measurement on root span: ${name} = ${value} ${unit}`);
        rootSpan.addEvent(name, {
            [(0, $fbf607a81dcbd641$export$69cd5c610c7bb96a)]: value,
            [(0, $fbf607a81dcbd641$export$f5f95cff026507b5)]: unit
        });
    }
}
function $043bcb59da76d3d5$export$487db6fcdf36893e(events) {
    if (!events || events.length === 0) return void 0;
    const measurements = {};
    events.forEach((event)=>{
        const attributes = event.attributes || {};
        const unit = attributes[0, $fbf607a81dcbd641$export$f5f95cff026507b5];
        const value = attributes[0, $fbf607a81dcbd641$export$69cd5c610c7bb96a];
        if (typeof unit === "string" && typeof value === "number") measurements[event.name] = {
            value: value,
            unit: unit
        };
    });
    return measurements;
}




const $e068fb314ea420fb$var$MAX_SPAN_COUNT = 1e3;
class $e068fb314ea420fb$export$a92149b045260d9f {
    /**
   * You should never call the constructor manually, always use `Sentry.startSpan()`
   * or other span methods.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $37dcada2a8c7465b$export$dc6d7ea554bcce10)();
        this._spanId = spanContext.spanId || (0, $37dcada2a8c7465b$export$295213bc4d0c54ad)();
        this._startTime = spanContext.startTimestamp || (0, $fd9cf0b48f691186$export$ee52dced521e3e18)();
        this._links = spanContext.links;
        this._attributes = {};
        this.setAttributes({
            [(0, $fbf607a81dcbd641$export$cca8dd30f57f805e)]: "manual",
            [(0, $fbf607a81dcbd641$export$1a413bd9a88fdb09)]: spanContext.op,
            ...spanContext.attributes
        });
        this._name = spanContext.name;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        if ("sampled" in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        this._events = [];
        this._isStandaloneSpan = spanContext.isStandalone;
        if (this._endTime) this._onSpanEnded();
    }
    /** @inheritDoc */ addLink(link) {
        if (this._links) this._links.push(link);
        else this._links = [
            link
        ];
        return this;
    }
    /** @inheritDoc */ addLinks(links) {
        if (this._links) this._links.push(...links);
        else this._links = links;
        return this;
    }
    /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {}
    /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId: spanId,
            traceId: traceId,
            traceFlags: sampled ? (0, $5a613f00f24f7165$export$eb571cd9b5d98de8) : (0, $5a613f00f24f7165$export$208d5b368507fb8b)
        };
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (value === void 0) delete this._attributes[key];
        else this._attributes[key] = value;
        return this;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for browser tracing where we want to adjust the start time afterwards.
   * USE THIS WITH CAUTION!
   *
   * @hidden
   * @internal
   */ updateStartTime(timeInput) {
        this._startTime = (0, $5a613f00f24f7165$export$3f7581298f56c6d7)(timeInput);
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        this._name = name;
        this.setAttribute((0, $fbf607a81dcbd641$export$d7a7d984b0791405), "custom");
        return this;
    }
    /** @inheritdoc */ end(endTimestamp) {
        if (this._endTime) return;
        this._endTime = (0, $5a613f00f24f7165$export$3f7581298f56c6d7)(endTimestamp);
        (0, $561c21a1edb0b887$export$b77c830667a4d630)(this);
        this._onSpanEnded();
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return {
            data: this._attributes,
            description: this._name,
            op: this._attributes[0, $fbf607a81dcbd641$export$1a413bd9a88fdb09],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: (0, $5a613f00f24f7165$export$e238a77ea3a8cd66)(this._status),
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[0, $fbf607a81dcbd641$export$cca8dd30f57f805e],
            profile_id: this._attributes[0, $fbf607a81dcbd641$export$1efec95406bbe327],
            exclusive_time: this._attributes[0, $fbf607a81dcbd641$export$fea48ba9f4550879],
            measurements: (0, $043bcb59da76d3d5$export$487db6fcdf36893e)(this._events),
            is_segment: this._isStandaloneSpan && (0, $5a613f00f24f7165$export$c4c6a79b1260ca1b)(this) === this || void 0,
            segment_id: this._isStandaloneSpan ? (0, $5a613f00f24f7165$export$c4c6a79b1260ca1b)(this).spanContext().spanId : void 0,
            links: (0, $5a613f00f24f7165$export$cb3e3a12e0eec16c)(this._links)
        };
    }
    /**
   * Get {@link StreamedSpanJSON} representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToStreamedSpanJSON(span)` instead.
   */ getStreamedSpanJSON() {
        return {
            name: this._name ?? "",
            span_id: this._spanId,
            trace_id: this._traceId,
            parent_span_id: this._parentSpanId,
            start_timestamp: this._startTime,
            // just in case _endTime is not set, we use the start time (i.e. duration 0)
            end_timestamp: this._endTime ?? this._startTime,
            is_segment: this._isStandaloneSpan || this === (0, $5a613f00f24f7165$export$c4c6a79b1260ca1b)(this),
            status: (0, $5a613f00f24f7165$export$457dcd3df4e9f5c6)(this._status),
            attributes: this._attributes,
            links: (0, $5a613f00f24f7165$export$9015adcf158ef3a5)(this._links)
        };
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * @inheritdoc
   */ addEvent(name, attributesOrStartTime, startTime) {
        (0, $2deb03c4495ce01f$export$16a28057038b10ef) && (0, $dd4af310e95b2daa$export$1c9f709888824e05).log("[Tracing] Adding an event to span:", name);
        const time = $e068fb314ea420fb$var$isSpanTimeInput(attributesOrStartTime) ? attributesOrStartTime : startTime || (0, $fd9cf0b48f691186$export$ee52dced521e3e18)();
        const attributes = $e068fb314ea420fb$var$isSpanTimeInput(attributesOrStartTime) ? {} : attributesOrStartTime || {};
        const event = {
            name: name,
            time: (0, $5a613f00f24f7165$export$3f7581298f56c6d7)(time),
            attributes: attributes
        };
        this._events.push(event);
        return this;
    }
    /**
   * This method should generally not be used,
   * but for now we need a way to publicly check if the `_isStandaloneSpan` flag is set.
   * USE THIS WITH CAUTION!
   * @internal
   * @hidden
   * @experimental
   */ isStandaloneSpan() {
        return !!this._isStandaloneSpan;
    }
    /** Emit `spanEnd` when the span is ended. */ _onSpanEnded() {
        const client = (0, $feb8814e57364805$export$6bb76d6eba7e258c)();
        if (client) {
            client.emit("spanEnd", this);
            if (!this._isStandaloneSpan) client.emit("afterSpanEnd", this);
        }
        const isSegmentSpan = this._isStandaloneSpan || this === (0, $5a613f00f24f7165$export$c4c6a79b1260ca1b)(this);
        if (!isSegmentSpan) return;
        if (this._isStandaloneSpan) {
            if (this._sampled) $e068fb314ea420fb$var$sendSpanEnvelope((0, $036fe402b3e061ac$export$19a0081d4b39d77)([
                this
            ], client));
            else {
                (0, $2deb03c4495ce01f$export$16a28057038b10ef) && (0, $dd4af310e95b2daa$export$1c9f709888824e05).log("[Tracing] Discarding standalone span because its trace was not chosen to be sampled.");
                if (client) client.recordDroppedEvent("sample_rate", "span");
            }
            return;
        } else if (client && (0, $a1f1ce22c197cf20$export$6ea47215d699c04a)(client)) {
            client.emit("afterSegmentSpanEnd", this);
            return;
        }
        const transactionEvent = this._convertSpanToTransaction();
        if (transactionEvent) {
            const scope = (0, $eee56b24e446780d$export$c08fbc656a245d03)(this).scope || (0, $feb8814e57364805$export$c7be4b0125a10cba)();
            scope.captureEvent(transactionEvent);
        }
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _convertSpanToTransaction() {
        if (!$e068fb314ea420fb$var$isFullFinishedSpan((0, $5a613f00f24f7165$export$92d8c23565496537)(this))) return void 0;
        if (!this._name) {
            (0, $2deb03c4495ce01f$export$16a28057038b10ef) && (0, $dd4af310e95b2daa$export$1c9f709888824e05).warn("Transaction has no name, falling back to `<unlabeled transaction>`.");
            this._name = "<unlabeled transaction>";
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = (0, $eee56b24e446780d$export$c08fbc656a245d03)(this);
        const normalizedRequest = capturedSpanScope?.getScopeData().sdkProcessingMetadata?.normalizedRequest;
        if (this._sampled !== true) return void 0;
        const finishedSpans = (0, $5a613f00f24f7165$export$340c5c8a13ffc680)(this).filter((span)=>span !== this && !$e068fb314ea420fb$var$isStandaloneSpan(span));
        const spans = finishedSpans.map((span)=>(0, $5a613f00f24f7165$export$92d8c23565496537)(span)).filter($e068fb314ea420fb$var$isFullFinishedSpan);
        const source = this._attributes[0, $fbf607a81dcbd641$export$d7a7d984b0791405];
        delete this._attributes[0, $fbf607a81dcbd641$export$165ce9a229f6f050];
        let hasGenAiSpans = false;
        spans.forEach((span)=>{
            delete span.data[0, $fbf607a81dcbd641$export$165ce9a229f6f050];
            if (span.op?.startsWith("gen_ai.")) hasGenAiSpans = true;
        });
        const transaction = {
            contexts: {
                trace: (0, $5a613f00f24f7165$export$4c3967a8a2f6bbd6)(this)
            },
            spans: // spans.sort() mutates the array, but `spans` is already a copy so we can safely do this here
            // we do not use spans anymore after this point
            spans.length > $e068fb314ea420fb$var$MAX_SPAN_COUNT ? spans.sort((a, b)=>a.start_timestamp - b.start_timestamp).slice(0, $e068fb314ea420fb$var$MAX_SPAN_COUNT) : spans,
            start_timestamp: this._startTime,
            timestamp: this._endTime,
            transaction: this._name,
            type: "transaction",
            sdkProcessingMetadata: {
                capturedSpanScope: capturedSpanScope,
                capturedSpanIsolationScope: capturedSpanIsolationScope,
                dynamicSamplingContext: (0, $6d02d85b64e23ac2$export$a117f995597e25df)(this),
                hasGenAiSpans: hasGenAiSpans
            },
            request: normalizedRequest,
            ...source && {
                transaction_info: {
                    source: source
                }
            }
        };
        const measurements = (0, $043bcb59da76d3d5$export$487db6fcdf36893e)(this._events);
        const hasMeasurements = measurements && Object.keys(measurements).length;
        if (hasMeasurements) {
            (0, $2deb03c4495ce01f$export$16a28057038b10ef) && (0, $dd4af310e95b2daa$export$1c9f709888824e05).log("[Measurements] Adding measurements to transaction event", JSON.stringify(measurements, void 0, 2));
            transaction.measurements = measurements;
        }
        return transaction;
    }
}
function $e068fb314ea420fb$var$isSpanTimeInput(value) {
    return value && typeof value === "number" || value instanceof Date || Array.isArray(value);
}
function $e068fb314ea420fb$var$isFullFinishedSpan(input) {
    return !!input.start_timestamp && !!input.timestamp && !!input.span_id && !!input.trace_id;
}
function $e068fb314ea420fb$var$isStandaloneSpan(span) {
    return span instanceof $e068fb314ea420fb$export$a92149b045260d9f && span.isStandaloneSpan();
}
function $e068fb314ea420fb$var$sendSpanEnvelope(envelope) {
    const client = (0, $feb8814e57364805$export$6bb76d6eba7e258c)();
    if (!client) return;
    const spanItems = envelope[1];
    if (!spanItems || spanItems.length === 0) {
        client.recordDroppedEvent("before_send", "span");
        return;
    }
    client.sendEnvelope(envelope);
}




const $8878fc8e27a65bea$export$61ab4e30f2201736 = "__SENTRY_SUPPRESS_TRACING__";
function $8878fc8e27a65bea$export$a1bd95187356f372(options, callback) {
    const acs = $8878fc8e27a65bea$var$getAcs();
    if (acs.startSpan) return acs.startSpan(options, callback);
    const spanArguments = $8878fc8e27a65bea$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    const customForkedScope = customScope?.clone();
    return (0, $feb8814e57364805$export$ec58d9285c204497)(customForkedScope, ()=>{
        const wrapper = $8878fc8e27a65bea$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = (0, $feb8814e57364805$export$c7be4b0125a10cba)();
            const parentSpan = $8878fc8e27a65bea$var$getParentSpan(scope, customParentSpan);
            const client = (0, $feb8814e57364805$export$6bb76d6eba7e258c)();
            const missingRequiredParent = options.onlyIfParent && !parentSpan;
            const activeSpan = missingRequiredParent ? new (0, $e95b1cceff42f823$export$d6636b700b76c516)() : $8878fc8e27a65bea$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            if (missingRequiredParent) client?.recordDroppedEvent("no_parent_span", "span");
            if (!$8878fc8e27a65bea$var$_isIgnoredSpan(activeSpan) || !parentSpan) (0, $5ece2fb3ee38e4e7$export$3f25fa50c18e20ca)(scope, activeSpan);
            return (0, $fe046bb65185662c$export$18ce21a8b7efd7e9)(()=>callback(activeSpan), ()=>{
                const { status: status } = (0, $5a613f00f24f7165$export$92d8c23565496537)(activeSpan);
                if (activeSpan.isRecording() && (!status || status === "ok")) activeSpan.setStatus({
                    code: (0, $29f989c1c2b83882$export$f966a0446ece71e),
                    message: "internal_error"
                });
            }, ()=>{
                activeSpan.end();
            });
        });
    });
}
function $8878fc8e27a65bea$export$c10292ad04b92aea(options, callback) {
    const acs = $8878fc8e27a65bea$var$getAcs();
    if (acs.startSpanManual) return acs.startSpanManual(options, callback);
    const spanArguments = $8878fc8e27a65bea$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    const customForkedScope = customScope?.clone();
    return (0, $feb8814e57364805$export$ec58d9285c204497)(customForkedScope, ()=>{
        const wrapper = $8878fc8e27a65bea$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = (0, $feb8814e57364805$export$c7be4b0125a10cba)();
            const parentSpan = $8878fc8e27a65bea$var$getParentSpan(scope, customParentSpan);
            const missingRequiredParent = options.onlyIfParent && !parentSpan;
            const activeSpan = missingRequiredParent ? new (0, $e95b1cceff42f823$export$d6636b700b76c516)() : $8878fc8e27a65bea$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            if (missingRequiredParent) (0, $feb8814e57364805$export$6bb76d6eba7e258c)()?.recordDroppedEvent("no_parent_span", "span");
            if (!$8878fc8e27a65bea$var$_isIgnoredSpan(activeSpan) || !parentSpan) (0, $5ece2fb3ee38e4e7$export$3f25fa50c18e20ca)(scope, activeSpan);
            return (0, $fe046bb65185662c$export$18ce21a8b7efd7e9)(// We pass the `finish` function to the callback, so the user can finish the span manually
            // this is mainly here for historic purposes because previously, we instructed users to call
            // `finish` instead of `span.end()` to also clean up the scope. Nowadays, calling `span.end()`
            // or `finish` has the same effect and we simply leave it here to avoid breaking user code.
            ()=>callback(activeSpan, ()=>activeSpan.end()), ()=>{
                const { status: status } = (0, $5a613f00f24f7165$export$92d8c23565496537)(activeSpan);
                if (activeSpan.isRecording() && (!status || status === "ok")) activeSpan.setStatus({
                    code: (0, $29f989c1c2b83882$export$f966a0446ece71e),
                    message: "internal_error"
                });
            });
        });
    });
}
function $8878fc8e27a65bea$export$63dbba021a6b4047(options) {
    const acs = $8878fc8e27a65bea$var$getAcs();
    if (acs.startInactiveSpan) return acs.startInactiveSpan(options);
    const spanArguments = $8878fc8e27a65bea$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan } = options;
    const wrapper = options.scope ? (callback)=>(0, $feb8814e57364805$export$ec58d9285c204497)(options.scope, callback) : customParentSpan !== void 0 ? (callback)=>$8878fc8e27a65bea$export$e57ac09b143d92a2(customParentSpan, callback) : (callback)=>callback();
    return wrapper(()=>{
        const scope = (0, $feb8814e57364805$export$c7be4b0125a10cba)();
        const parentSpan = $8878fc8e27a65bea$var$getParentSpan(scope, customParentSpan);
        const client = (0, $feb8814e57364805$export$6bb76d6eba7e258c)();
        const missingRequiredParent = options.onlyIfParent && !parentSpan;
        if (missingRequiredParent) {
            client?.recordDroppedEvent("no_parent_span", "span");
            return new (0, $e95b1cceff42f823$export$d6636b700b76c516)();
        }
        return $8878fc8e27a65bea$var$createChildOrRootSpan({
            parentSpan: parentSpan,
            spanArguments: spanArguments,
            forceTransaction: forceTransaction,
            scope: scope
        });
    });
}
const $8878fc8e27a65bea$export$d2ee9b39b25437b3 = (options, callback)=>{
    const carrier = (0, $f93478a31a56772c$export$19eade501500c6c1)();
    const acs = (0, $5a330bff927d6eb3$export$f639b0c2752203be)(carrier);
    if (acs.continueTrace) return acs.continueTrace(options, callback);
    const { sentryTrace: sentryTrace, baggage: baggage } = options;
    const client = (0, $feb8814e57364805$export$6bb76d6eba7e258c)();
    const incomingDsc = (0, $32674b1da3a6c619$export$5b96ee2c8421f107)(baggage);
    if (client && !(0, $13171373d98776e8$export$18811bc99eefceaa)(client, incomingDsc?.org_id)) return $8878fc8e27a65bea$export$f90b03291402f553(callback);
    return (0, $feb8814e57364805$export$ec58d9285c204497)((scope)=>{
        const propagationContext = (0, $13171373d98776e8$export$261f383d16a93e39)(sentryTrace, baggage);
        scope.setPropagationContext(propagationContext);
        (0, $5ece2fb3ee38e4e7$export$3f25fa50c18e20ca)(scope, void 0);
        return callback();
    });
};
function $8878fc8e27a65bea$export$e57ac09b143d92a2(span, callback) {
    const acs = $8878fc8e27a65bea$var$getAcs();
    if (acs.withActiveSpan) return acs.withActiveSpan(span, callback);
    return (0, $feb8814e57364805$export$ec58d9285c204497)((scope)=>{
        (0, $5ece2fb3ee38e4e7$export$3f25fa50c18e20ca)(scope, span || void 0);
        return callback(scope);
    });
}
function $8878fc8e27a65bea$export$869298f9835abc68(callback) {
    const acs = $8878fc8e27a65bea$var$getAcs();
    if (acs.suppressTracing) return acs.suppressTracing(callback);
    return (0, $feb8814e57364805$export$ec58d9285c204497)((scope)=>{
        scope.setSDKProcessingMetadata({
            [$8878fc8e27a65bea$export$61ab4e30f2201736]: true
        });
        const res = callback();
        scope.setSDKProcessingMetadata({
            [$8878fc8e27a65bea$export$61ab4e30f2201736]: void 0
        });
        return res;
    });
}
function $8878fc8e27a65bea$export$f90b03291402f553(callback) {
    const acs = $8878fc8e27a65bea$var$getAcs();
    if (acs.startNewTrace) return acs.startNewTrace(callback);
    return (0, $feb8814e57364805$export$ec58d9285c204497)((scope)=>{
        scope.setPropagationContext({
            traceId: (0, $37dcada2a8c7465b$export$dc6d7ea554bcce10)(),
            sampleRand: (0, $0d33076536fcb49a$export$9869d72de32a3917)()
        });
        (0, $2deb03c4495ce01f$export$16a28057038b10ef) && (0, $dd4af310e95b2daa$export$1c9f709888824e05).log(`Starting a new trace with id ${scope.getPropagationContext().traceId}`);
        return $8878fc8e27a65bea$export$e57ac09b143d92a2(null, callback);
    });
}
function $8878fc8e27a65bea$var$createChildOrRootSpan({ parentSpan: parentSpan, spanArguments: spanArguments, forceTransaction: forceTransaction, scope: scope }) {
    if (!(0, $264ccf395dedc77f$export$1f70765132c3c225)()) {
        const span2 = new (0, $e95b1cceff42f823$export$d6636b700b76c516)();
        if (forceTransaction || !parentSpan) {
            const dsc = {
                sampled: "false",
                sample_rate: "0",
                transaction: spanArguments.name,
                ...(0, $6d02d85b64e23ac2$export$a117f995597e25df)(span2)
            };
            (0, $6d02d85b64e23ac2$export$7398c93e763ca9fd)(span2, dsc);
        }
        return span2;
    }
    const client = (0, $feb8814e57364805$export$6bb76d6eba7e258c)();
    if ($8878fc8e27a65bea$var$_shouldIgnoreStreamedSpan(client, spanArguments)) {
        if (!$8878fc8e27a65bea$var$_isTracingSuppressed(scope)) client?.recordDroppedEvent("ignored", "span");
        return new (0, $e95b1cceff42f823$export$d6636b700b76c516)({
            dropReason: "ignored",
            traceId: parentSpan?.spanContext().traceId ?? scope.getPropagationContext().traceId
        });
    }
    const isolationScope = (0, $feb8814e57364805$export$68f3af03034c9e90)();
    let span;
    if (parentSpan && !forceTransaction) {
        span = $8878fc8e27a65bea$var$_startChildSpan(parentSpan, scope, spanArguments);
        (0, $5a613f00f24f7165$export$81397d924722cc65)(parentSpan, span);
    } else if (parentSpan) {
        const dsc = (0, $6d02d85b64e23ac2$export$a117f995597e25df)(parentSpan);
        const { traceId: traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const parentSampled = (0, $5a613f00f24f7165$export$5caecac1caaf3a71)(parentSpan);
        span = $8878fc8e27a65bea$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, parentSampled);
        (0, $6d02d85b64e23ac2$export$7398c93e763ca9fd)(span, dsc);
    } else {
        const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: parentSampled } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        span = $8878fc8e27a65bea$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, parentSampled);
        if (dsc) (0, $6d02d85b64e23ac2$export$7398c93e763ca9fd)(span, dsc);
    }
    (0, $561c21a1edb0b887$export$2f3d84e767c9592b)(span);
    (0, $eee56b24e446780d$export$cddb4027e3b0dd66)(span, scope, isolationScope);
    return span;
}
function $8878fc8e27a65bea$var$parseSentrySpanArguments(options) {
    const exp = options.experimental || {};
    const initialCtx = {
        isStandalone: exp.standalone,
        ...options
    };
    if (options.startTime) {
        const ctx = {
            ...initialCtx
        };
        ctx.startTimestamp = (0, $5a613f00f24f7165$export$3f7581298f56c6d7)(options.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return initialCtx;
}
function $8878fc8e27a65bea$var$getAcs() {
    const carrier = (0, $f93478a31a56772c$export$19eade501500c6c1)();
    return (0, $5a330bff927d6eb3$export$f639b0c2752203be)(carrier);
}
function $8878fc8e27a65bea$var$_startRootSpan(spanArguments, scope, parentSampled) {
    const client = (0, $feb8814e57364805$export$6bb76d6eba7e258c)();
    const options = client?.getOptions() || {};
    const { name: name = "" } = spanArguments;
    const mutableSpanSamplingData = {
        spanAttributes: {
            ...spanArguments.attributes
        },
        spanName: name,
        parentSampled: parentSampled
    };
    client?.emit("beforeSampling", mutableSpanSamplingData, {
        decision: false
    });
    const finalParentSampled = mutableSpanSamplingData.parentSampled ?? parentSampled;
    const finalAttributes = mutableSpanSamplingData.spanAttributes;
    const currentPropagationContext = scope.getPropagationContext();
    const isTracingSuppressed = $8878fc8e27a65bea$var$_isTracingSuppressed(scope);
    const [sampled, sampleRate, localSampleRateWasApplied] = isTracingSuppressed ? [
        false
    ] : (0, $28d1c2cf27dfe29d$export$5f833db634b217bb)(options, {
        name: name,
        parentSampled: finalParentSampled,
        attributes: finalAttributes,
        parentSampleRate: (0, $4f88660a1945fceb$export$a5bd2d81656d9546)(currentPropagationContext.dsc?.sample_rate)
    }, currentPropagationContext.sampleRand);
    const rootSpan = new (0, $e068fb314ea420fb$export$a92149b045260d9f)({
        ...spanArguments,
        attributes: {
            [(0, $fbf607a81dcbd641$export$d7a7d984b0791405)]: "custom",
            [(0, $fbf607a81dcbd641$export$ccfe0a40627cc34b)]: sampleRate !== void 0 && localSampleRateWasApplied ? sampleRate : void 0,
            ...finalAttributes
        },
        sampled: sampled
    });
    if (!sampled && client && !isTracingSuppressed) {
        (0, $2deb03c4495ce01f$export$16a28057038b10ef) && (0, $dd4af310e95b2daa$export$1c9f709888824e05).log("[Tracing] Discarding root span because its trace was not chosen to be sampled.");
        client.recordDroppedEvent("sample_rate", (0, $a1f1ce22c197cf20$export$6ea47215d699c04a)(client) ? "span" : "transaction");
    }
    if (client) client.emit("spanStart", rootSpan);
    return rootSpan;
}
function $8878fc8e27a65bea$var$_startChildSpan(parentSpan, scope, spanArguments) {
    const { spanId: spanId, traceId: traceId } = parentSpan.spanContext();
    const isTracingSuppressed = $8878fc8e27a65bea$var$_isTracingSuppressed(scope);
    const sampled = isTracingSuppressed ? false : (0, $5a613f00f24f7165$export$5caecac1caaf3a71)(parentSpan);
    const childSpan = sampled ? new (0, $e068fb314ea420fb$export$a92149b045260d9f)({
        ...spanArguments,
        parentSpanId: spanId,
        traceId: traceId,
        sampled: sampled
    }) : new (0, $e95b1cceff42f823$export$d6636b700b76c516)({
        traceId: traceId
    });
    (0, $5a613f00f24f7165$export$81397d924722cc65)(parentSpan, childSpan);
    const client = (0, $feb8814e57364805$export$6bb76d6eba7e258c)();
    if (!client) return childSpan;
    if ((0, $a1f1ce22c197cf20$export$6ea47215d699c04a)(client) && childSpan instanceof (0, $e95b1cceff42f823$export$d6636b700b76c516)) {
        if (parentSpan instanceof (0, $e95b1cceff42f823$export$d6636b700b76c516) && parentSpan.dropReason) {
            childSpan.dropReason = parentSpan.dropReason;
            client.recordDroppedEvent(parentSpan.dropReason, "span");
        } else if (!isTracingSuppressed) {
            childSpan.dropReason = "sample_rate";
            client.recordDroppedEvent("sample_rate", "span");
        }
    }
    client.emit("spanStart", childSpan);
    if (spanArguments.endTimestamp) {
        client.emit("spanEnd", childSpan);
        client.emit("afterSpanEnd", childSpan);
    }
    return childSpan;
}
function $8878fc8e27a65bea$var$getParentSpan(scope, customParentSpan) {
    if (customParentSpan) return customParentSpan;
    if (customParentSpan === null) return void 0;
    const span = (0, $5ece2fb3ee38e4e7$export$91f063ebb8eff307)(scope);
    if (!span) return void 0;
    const client = (0, $feb8814e57364805$export$6bb76d6eba7e258c)();
    const options = client ? client.getOptions() : {};
    if (options.parentSpanIsAlwaysRootSpan) return (0, $5a613f00f24f7165$export$c4c6a79b1260ca1b)(span);
    return span;
}
function $8878fc8e27a65bea$var$getActiveSpanWrapper(parentSpan) {
    return parentSpan !== void 0 ? (callback)=>{
        return $8878fc8e27a65bea$export$e57ac09b143d92a2(parentSpan, callback);
    } : (callback)=>callback();
}
function $8878fc8e27a65bea$var$_shouldIgnoreStreamedSpan(client, spanArguments) {
    const ignoreSpans = client?.getOptions().ignoreSpans;
    if (!client || !(0, $a1f1ce22c197cf20$export$6ea47215d699c04a)(client) || !ignoreSpans?.length) return false;
    return (0, $476422f58a102e80$export$5d569ac97c389400)({
        description: spanArguments.name || "",
        op: spanArguments.attributes?.[0, $fbf607a81dcbd641$export$1a413bd9a88fdb09] || spanArguments.op,
        attributes: spanArguments.attributes
    }, ignoreSpans);
}
function $8878fc8e27a65bea$var$_isIgnoredSpan(span) {
    return span instanceof (0, $e95b1cceff42f823$export$d6636b700b76c516) && span.dropReason === "ignored";
}
function $8878fc8e27a65bea$var$_isTracingSuppressed(scope) {
    return scope.getScopeData().sdkProcessingMetadata[$8878fc8e27a65bea$export$61ab4e30f2201736] === true;
}










const $07fb9b6b63e3f48c$var$STATE_PENDING = 0;
const $07fb9b6b63e3f48c$var$STATE_RESOLVED = 1;
const $07fb9b6b63e3f48c$var$STATE_REJECTED = 2;
function $07fb9b6b63e3f48c$export$1fda8aa4d135f8aa(value) {
    return new $07fb9b6b63e3f48c$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
function $07fb9b6b63e3f48c$export$78e43115b553f358(reason) {
    return new $07fb9b6b63e3f48c$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
class $07fb9b6b63e3f48c$export$6f292d4960313241 {
    constructor(executor){
        this._state = $07fb9b6b63e3f48c$var$STATE_PENDING;
        this._handlers = [];
        this._runExecutor(executor);
    }
    /** @inheritdoc */ then(onfulfilled, onrejected) {
        return new $07fb9b6b63e3f48c$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** @inheritdoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** @inheritdoc */ finally(onfinally) {
        return new $07fb9b6b63e3f48c$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** Excute the resolve/reject handlers. */ _executeHandlers() {
        if (this._state === $07fb9b6b63e3f48c$var$STATE_PENDING) return;
        const cachedHandlers = this._handlers.slice();
        this._handlers = [];
        cachedHandlers.forEach((handler)=>{
            if (handler[0]) return;
            if (this._state === $07fb9b6b63e3f48c$var$STATE_RESOLVED) handler[1](this._value);
            if (this._state === $07fb9b6b63e3f48c$var$STATE_REJECTED) handler[2](this._value);
            handler[0] = true;
        });
    }
    /** Run the executor for the SyncPromise. */ _runExecutor(executor) {
        const setResult = (state, value)=>{
            if (this._state !== $07fb9b6b63e3f48c$var$STATE_PENDING) return;
            if ((0, $2660f95a1b0d39e6$export$f5b060c2914b97c8)(value)) {
                value.then(resolve, reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
        const resolve = (value)=>{
            setResult($07fb9b6b63e3f48c$var$STATE_RESOLVED, value);
        };
        const reject = (reason)=>{
            setResult($07fb9b6b63e3f48c$var$STATE_REJECTED, reason);
        };
        try {
            executor(resolve, reject);
        } catch (e) {
            reject(e);
        }
    }
}


function $050047c15a5cdd23$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    try {
        const result = $050047c15a5cdd23$var$_notifyEventProcessors(event, hint, processors, index);
        return (0, $2660f95a1b0d39e6$export$f5b060c2914b97c8)(result) ? result : (0, $07fb9b6b63e3f48c$export$1fda8aa4d135f8aa)(result);
    } catch (error) {
        return (0, $07fb9b6b63e3f48c$export$78e43115b553f358)(error);
    }
}
function $050047c15a5cdd23$var$_notifyEventProcessors(event, hint, processors, index) {
    const processor = processors[index];
    if (!event || !processor) return event;
    const result = processor({
        ...event
    }, hint);
    (0, $2deb03c4495ce01f$export$16a28057038b10ef) && result === null && (0, $dd4af310e95b2daa$export$1c9f709888824e05).log(`Event processor "${processor.id || "?"}" dropped event`);
    if ((0, $2660f95a1b0d39e6$export$f5b060c2914b97c8)(result)) return result.then((final)=>$050047c15a5cdd23$var$_notifyEventProcessors(final, hint, processors, index + 1));
    return $050047c15a5cdd23$var$_notifyEventProcessors(result, hint, processors, index + 1);
}





let $8a775e00ef5ee0c1$var$parsedStackResults;
let $8a775e00ef5ee0c1$var$lastSentryKeysCount;
let $8a775e00ef5ee0c1$var$lastNativeKeysCount;
let $8a775e00ef5ee0c1$var$cachedFilenameDebugIds;
function $8a775e00ef5ee0c1$export$e069fee9c632ed00(stackParser) {
    const sentryDebugIdMap = (0, $f217104c897b328f$export$f1a6cdb1459e81d1)._sentryDebugIds;
    const nativeDebugIdMap = (0, $f217104c897b328f$export$f1a6cdb1459e81d1)._debugIds;
    if (!sentryDebugIdMap && !nativeDebugIdMap) return {};
    const sentryDebugIdKeys = sentryDebugIdMap ? Object.keys(sentryDebugIdMap) : [];
    const nativeDebugIdKeys = nativeDebugIdMap ? Object.keys(nativeDebugIdMap) : [];
    if ($8a775e00ef5ee0c1$var$cachedFilenameDebugIds && sentryDebugIdKeys.length === $8a775e00ef5ee0c1$var$lastSentryKeysCount && nativeDebugIdKeys.length === $8a775e00ef5ee0c1$var$lastNativeKeysCount) return $8a775e00ef5ee0c1$var$cachedFilenameDebugIds;
    $8a775e00ef5ee0c1$var$lastSentryKeysCount = sentryDebugIdKeys.length;
    $8a775e00ef5ee0c1$var$lastNativeKeysCount = nativeDebugIdKeys.length;
    $8a775e00ef5ee0c1$var$cachedFilenameDebugIds = {};
    if (!$8a775e00ef5ee0c1$var$parsedStackResults) $8a775e00ef5ee0c1$var$parsedStackResults = {};
    const processDebugIds = (debugIdKeys, debugIdMap)=>{
        for (const key of debugIdKeys){
            const debugId = debugIdMap[key];
            const result = $8a775e00ef5ee0c1$var$parsedStackResults?.[key];
            if (result && $8a775e00ef5ee0c1$var$cachedFilenameDebugIds && debugId) {
                $8a775e00ef5ee0c1$var$cachedFilenameDebugIds[result[0]] = debugId;
                if ($8a775e00ef5ee0c1$var$parsedStackResults) $8a775e00ef5ee0c1$var$parsedStackResults[key] = [
                    result[0],
                    debugId
                ];
            } else if (debugId) {
                const parsedStack = stackParser(key);
                for(let i = parsedStack.length - 1; i >= 0; i--){
                    const stackFrame = parsedStack[i];
                    const filename = stackFrame?.filename;
                    if (filename && $8a775e00ef5ee0c1$var$cachedFilenameDebugIds && $8a775e00ef5ee0c1$var$parsedStackResults) {
                        $8a775e00ef5ee0c1$var$cachedFilenameDebugIds[filename] = debugId;
                        $8a775e00ef5ee0c1$var$parsedStackResults[key] = [
                            filename,
                            debugId
                        ];
                        break;
                    }
                }
            }
        }
    };
    if (sentryDebugIdMap) processDebugIds(sentryDebugIdKeys, sentryDebugIdMap);
    if (nativeDebugIdMap) processDebugIds(nativeDebugIdKeys, nativeDebugIdMap);
    return $8a775e00ef5ee0c1$var$cachedFilenameDebugIds;
}
function $8a775e00ef5ee0c1$export$5a7368330d9ee6e3(stackParser, resource_paths) {
    const filenameDebugIdMap = $8a775e00ef5ee0c1$export$e069fee9c632ed00(stackParser);
    if (!filenameDebugIdMap) return [];
    const images = [];
    for (const path of resource_paths){
        const normalizedPath = (0, $4f18ccbe39bfd9ec$export$60c0d6c8e038267a)(path);
        if (normalizedPath && filenameDebugIdMap[normalizedPath]) images.push({
            type: "sourcemap",
            code_file: path,
            debug_id: filenameDebugIdMap[normalizedPath]
        });
    }
    return images;
}








function $8e3fa47d09daa1bc$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    $8e3fa47d09daa1bc$var$applyDataToEvent(event, data);
    if (span) $8e3fa47d09daa1bc$var$applySpanToEvent(event, span);
    $8e3fa47d09daa1bc$var$applyFingerprintToEvent(event, fingerprint);
    $8e3fa47d09daa1bc$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $8e3fa47d09daa1bc$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
function $8e3fa47d09daa1bc$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, attributes: attributes, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: transactionName, span: span } = mergeData;
    $8e3fa47d09daa1bc$export$b1a120a2871faa46(data, "extra", extra);
    $8e3fa47d09daa1bc$export$b1a120a2871faa46(data, "tags", tags);
    $8e3fa47d09daa1bc$export$b1a120a2871faa46(data, "attributes", attributes);
    $8e3fa47d09daa1bc$export$b1a120a2871faa46(data, "user", user);
    $8e3fa47d09daa1bc$export$b1a120a2871faa46(data, "contexts", contexts);
    data.sdkProcessingMetadata = (0, $0fd68d43e5df151c$export$4950aa0f605343fb)(data.sdkProcessingMetadata, sdkProcessingMetadata, 2);
    if (level) data.level = level;
    if (transactionName) data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
function $8e3fa47d09daa1bc$export$b1a120a2871faa46(data, prop, mergeVal) {
    data[prop] = (0, $0fd68d43e5df151c$export$4950aa0f605343fb)(data[prop], mergeVal, 1);
}
function $8e3fa47d09daa1bc$export$cc422922fcbb91c6(isolationScope, currentScope) {
    const scopeData = (0, $feb8814e57364805$export$aa55d5ab8e05984f)().getScopeData();
    isolationScope && $8e3fa47d09daa1bc$export$25ac7e259a513db4(scopeData, isolationScope.getScopeData());
    currentScope && $8e3fa47d09daa1bc$export$25ac7e259a513db4(scopeData, currentScope.getScopeData());
    return scopeData;
}
function $8e3fa47d09daa1bc$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: transactionName } = data;
    if (Object.keys(extra).length) event.extra = {
        ...extra,
        ...event.extra
    };
    if (Object.keys(tags).length) event.tags = {
        ...tags,
        ...event.tags
    };
    if (Object.keys(user).length) event.user = {
        ...user,
        ...event.user
    };
    if (Object.keys(contexts).length) event.contexts = {
        ...contexts,
        ...event.contexts
    };
    if (level) event.level = level;
    if (transactionName && event.type !== "transaction") event.transaction = transactionName;
}
function $8e3fa47d09daa1bc$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : void 0;
}
function $8e3fa47d09daa1bc$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $8e3fa47d09daa1bc$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $5a613f00f24f7165$export$46c6fbd1d265ebf0)(span),
        ...event.contexts
    };
    event.sdkProcessingMetadata = {
        dynamicSamplingContext: (0, $6d02d85b64e23ac2$export$a117f995597e25df)(span),
        ...event.sdkProcessingMetadata
    };
    const rootSpan = (0, $5a613f00f24f7165$export$c4c6a79b1260ca1b)(span);
    const transactionName = (0, $5a613f00f24f7165$export$92d8c23565496537)(rootSpan).description;
    if (transactionName && !event.transaction && event.type === "transaction") event.transaction = transactionName;
}
function $8e3fa47d09daa1bc$var$applyFingerprintToEvent(event, fingerprint) {
    event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
        event.fingerprint
    ] : [];
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    if (!event.fingerprint.length) delete event.fingerprint;
}





function $334fc2197f5d0e69$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1e3 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $5f9617f585b2f74f$export$19f53698e68b2496)(),
        timestamp: event.timestamp || (0, $fd9cf0b48f691186$export$7740643b9eeaf0c4)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $334fc2197f5d0e69$export$d7e04067a6fbc882(prepared, options);
    $334fc2197f5d0e69$var$applyIntegrationsMetadata(prepared, integrations);
    if (client) client.emit("applyFrameMetadata", event);
    if (event.type === void 0) $334fc2197f5d0e69$export$63042efc86f043e7(prepared, options.stackParser);
    const finalScope = $334fc2197f5d0e69$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $5f9617f585b2f74f$export$c69a9a0313b03bb1)(prepared, hint.mechanism);
    const clientEventProcessors = client ? client.getEventProcessors() : [];
    const data = (0, $8e3fa47d09daa1bc$export$cc422922fcbb91c6)(isolationScope, finalScope);
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $8e3fa47d09daa1bc$export$43988bc651a80216)(prepared, data);
    const eventProcessors = [
        ...clientEventProcessors,
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const isInternalException = hint.data && hint.data.__sentry__ === true;
    const result = isInternalException ? (0, $07fb9b6b63e3f48c$export$1fda8aa4d135f8aa)(prepared) : (0, $050047c15a5cdd23$export$bf2a096c3e883e79)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) $334fc2197f5d0e69$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === "number" && normalizeDepth > 0) return $334fc2197f5d0e69$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
function $334fc2197f5d0e69$export$d7e04067a6fbc882(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength } = options;
    event.environment = event.environment || environment || (0, $e345d2a6280067b6$export$849dbeeeda01ae98);
    if (!event.release && release) event.release = release;
    if (!event.dist && dist) event.dist = dist;
    const request = event.request;
    if (request?.url && maxValueLength) request.url = (0, $2088fbfa8bfbfeb6$export$6a506b36fdea397d)(request.url, maxValueLength);
    if (maxValueLength) event.exception?.values?.forEach((exception)=>{
        if (exception.value) exception.value = (0, $2088fbfa8bfbfeb6$export$6a506b36fdea397d)(exception.value, maxValueLength);
    });
}
function $334fc2197f5d0e69$export$63042efc86f043e7(event, stackParser) {
    const filenameDebugIdMap = (0, $8a775e00ef5ee0c1$export$e069fee9c632ed00)(stackParser);
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
        });
    });
}
function $334fc2197f5d0e69$export$1be657ba8ef44ff0(event) {
    const filenameDebugIdMap = {};
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.debug_id) {
                if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                delete frame.debug_id;
            }
        });
    });
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.entries(filenameDebugIdMap).forEach(([filename, debug_id])=>{
        images.push({
            type: "sourcemap",
            code_file: filename,
            debug_id: debug_id
        });
    });
}
function $334fc2197f5d0e69$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
function $334fc2197f5d0e69$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $ac4a8bdf538bbe1f$export$a3295358bff77e)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $ac4a8bdf538bbe1f$export$a3295358bff77e)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $ac4a8bdf538bbe1f$export$a3295358bff77e)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $ac4a8bdf538bbe1f$export$a3295358bff77e)(event.extra, depth, maxBreadth)
        }
    };
    if (event.contexts?.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $ac4a8bdf538bbe1f$export$a3295358bff77e)(event.contexts.trace.data, depth, maxBreadth);
    }
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        return {
            ...span,
            ...span.data && {
                data: (0, $ac4a8bdf538bbe1f$export$a3295358bff77e)(span.data, depth, maxBreadth)
            }
        };
    });
    if (event.contexts?.flags && normalized.contexts) normalized.contexts.flags = (0, $ac4a8bdf538bbe1f$export$a3295358bff77e)(event.contexts.flags, 3, maxBreadth);
    return normalized;
}
function $334fc2197f5d0e69$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $7322a86e8ee4a60a$export$775b6bb06e53a214)();
    finalScope.update(captureContext);
    return finalScope;
}
function $334fc2197f5d0e69$export$76b5f966996d1653(hint) {
    if (!hint) return void 0;
    if ($334fc2197f5d0e69$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($334fc2197f5d0e69$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $334fc2197f5d0e69$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $7322a86e8ee4a60a$export$775b6bb06e53a214) || typeof hint === "function";
}
const $334fc2197f5d0e69$var$captureContextKeys = [
    "user",
    "level",
    "extra",
    "contexts",
    "tags",
    "fingerprint",
    "propagationContext"
];
function $334fc2197f5d0e69$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$334fc2197f5d0e69$var$captureContextKeys.includes(key));
}





function $fce196f53ce88243$export$f5282963edea4a68(exception, hint) {
    return (0, $feb8814e57364805$export$c7be4b0125a10cba)().captureException(exception, (0, $334fc2197f5d0e69$export$76b5f966996d1653)(hint));
}
function $fce196f53ce88243$export$45654777c133ae80(message, captureContext) {
    const level = typeof captureContext === "string" ? captureContext : void 0;
    const hint = typeof captureContext !== "string" ? {
        captureContext: captureContext
    } : void 0;
    return (0, $feb8814e57364805$export$c7be4b0125a10cba)().captureMessage(message, level, hint);
}
function $fce196f53ce88243$export$1462b974fdcf6ba2(event, hint) {
    return (0, $feb8814e57364805$export$c7be4b0125a10cba)().captureEvent(event, hint);
}
function $fce196f53ce88243$export$2f04de43fe27971a(name, context) {
    (0, $feb8814e57364805$export$68f3af03034c9e90)().setContext(name, context);
}
function $fce196f53ce88243$export$bb4922da0dd51b92(extras) {
    (0, $feb8814e57364805$export$68f3af03034c9e90)().setExtras(extras);
}
function $fce196f53ce88243$export$8e8e7789d42ed61d(key, extra) {
    (0, $feb8814e57364805$export$68f3af03034c9e90)().setExtra(key, extra);
}
function $fce196f53ce88243$export$74a8fb34822092e6(tags) {
    (0, $feb8814e57364805$export$68f3af03034c9e90)().setTags(tags);
}
function $fce196f53ce88243$export$a37d07ee78eb4569(key, value) {
    (0, $feb8814e57364805$export$68f3af03034c9e90)().setTag(key, value);
}
function $fce196f53ce88243$export$8b6bb3dd62a01be2(user) {
    (0, $feb8814e57364805$export$68f3af03034c9e90)().setUser(user);
}
function $fce196f53ce88243$export$58213391a19e392(conversationId) {
    (0, $feb8814e57364805$export$68f3af03034c9e90)().setConversationId(conversationId);
}
function $fce196f53ce88243$export$5d4e9fd7fac8e617() {
    return (0, $feb8814e57364805$export$68f3af03034c9e90)().lastEventId();
}
function $fce196f53ce88243$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = (0, $feb8814e57364805$export$c7be4b0125a10cba)();
    const client = (0, $feb8814e57364805$export$6bb76d6eba7e258c)();
    if (!client) (0, $2deb03c4495ce01f$export$16a28057038b10ef) && (0, $dd4af310e95b2daa$export$1c9f709888824e05).warn("Cannot capture check-in. No client defined.");
    else if (!client.captureCheckIn) (0, $2deb03c4495ce01f$export$16a28057038b10ef) && (0, $dd4af310e95b2daa$export$1c9f709888824e05).warn("Cannot capture check-in. Client does not support sending check-ins.");
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $5f9617f585b2f74f$export$19f53698e68b2496)();
}
function $fce196f53ce88243$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    function runCallback() {
        const checkInId = $fce196f53ce88243$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: "in_progress"
        }, upsertMonitorConfig);
        const now = (0, $fd9cf0b48f691186$export$ee52dced521e3e18)();
        function finishCheckIn(status) {
            $fce196f53ce88243$export$413528111fbc67c({
                monitorSlug: monitorSlug,
                status: status,
                checkInId: checkInId,
                duration: (0, $fd9cf0b48f691186$export$ee52dced521e3e18)() - now
            });
        }
        let maybePromiseResult;
        try {
            maybePromiseResult = callback();
        } catch (e) {
            finishCheckIn("error");
            throw e;
        }
        if ((0, $2660f95a1b0d39e6$export$f5b060c2914b97c8)(maybePromiseResult)) return maybePromiseResult.then((r)=>{
            finishCheckIn("ok");
            return r;
        }, (e)=>{
            finishCheckIn("error");
            throw e;
        });
        finishCheckIn("ok");
        return maybePromiseResult;
    }
    return (0, $feb8814e57364805$export$9a4fed82c350c2bd)(()=>upsertMonitorConfig?.isolateTrace ? (0, $8878fc8e27a65bea$export$f90b03291402f553)(runCallback) : runCallback());
}
async function $fce196f53ce88243$export$4909b86c8034bf73(timeout) {
    const client = (0, $feb8814e57364805$export$6bb76d6eba7e258c)();
    if (client) return client.flush(timeout);
    (0, $2deb03c4495ce01f$export$16a28057038b10ef) && (0, $dd4af310e95b2daa$export$1c9f709888824e05).warn("Cannot flush events. No client defined.");
    return Promise.resolve(false);
}
async function $fce196f53ce88243$export$8360e631d277ea4d(timeout) {
    const client = (0, $feb8814e57364805$export$6bb76d6eba7e258c)();
    if (client) return client.close(timeout);
    (0, $2deb03c4495ce01f$export$16a28057038b10ef) && (0, $dd4af310e95b2daa$export$1c9f709888824e05).warn("Cannot flush events and disable SDK. No client defined.");
    return Promise.resolve(false);
}
function $fce196f53ce88243$export$3f95c6f800b78024() {
    return !!(0, $feb8814e57364805$export$6bb76d6eba7e258c)();
}
function $fce196f53ce88243$export$3b029eb57ac4d562() {
    const client = (0, $feb8814e57364805$export$6bb76d6eba7e258c)();
    return client?.getOptions().enabled !== false && !!client?.getTransport();
}
function $fce196f53ce88243$export$9aac0b9f77928fbf(callback) {
    (0, $feb8814e57364805$export$68f3af03034c9e90)().addEventProcessor(callback);
}
function $fce196f53ce88243$export$c0d84948cecf78d8(context) {
    const isolationScope = (0, $feb8814e57364805$export$68f3af03034c9e90)();
    const { user: user } = (0, $8e3fa47d09daa1bc$export$cc422922fcbb91c6)(isolationScope, (0, $feb8814e57364805$export$c7be4b0125a10cba)());
    const { userAgent: userAgent } = (0, $f217104c897b328f$export$f1a6cdb1459e81d1).navigator || {};
    const session = (0, $a829f05e7b5df86f$export$14a186326edbb264)({
        user: user,
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    const currentSession = isolationScope.getSession();
    if (currentSession?.status === "ok") (0, $a829f05e7b5df86f$export$531818e825e774db)(currentSession, {
        status: "exited"
    });
    $fce196f53ce88243$export$17a5be43989a0bc1();
    isolationScope.setSession(session);
    return session;
}
function $fce196f53ce88243$export$17a5be43989a0bc1() {
    const isolationScope = (0, $feb8814e57364805$export$68f3af03034c9e90)();
    const currentScope = (0, $feb8814e57364805$export$c7be4b0125a10cba)();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $a829f05e7b5df86f$export$56521d9ba90f62ee)(session);
    $fce196f53ce88243$var$_sendSessionUpdate();
    isolationScope.setSession();
}
function $fce196f53ce88243$var$_sendSessionUpdate() {
    const isolationScope = (0, $feb8814e57364805$export$68f3af03034c9e90)();
    const client = (0, $feb8814e57364805$export$6bb76d6eba7e258c)();
    const session = isolationScope.getSession();
    if (session && client) client.captureSession(session);
}
function $fce196f53ce88243$export$667e7b4d445d566b(end = false) {
    if (end) {
        $fce196f53ce88243$export$17a5be43989a0bc1();
        return;
    }
    $fce196f53ce88243$var$_sendSessionUpdate();
}

function $41fbec003ec03801$export$61fc7d43ac8f84b0(func, wait, options) {
    let callbackReturnValue;
    let timerId;
    let maxTimerId;
    const maxWait = options?.maxWait ? Math.max(options.maxWait, wait) : 0;
    const setTimeoutImpl = options?.setTimeoutImpl || setTimeout;
    function invokeFunc() {
        cancelTimers();
        callbackReturnValue = func();
        return callbackReturnValue;
    }
    function cancelTimers() {
        timerId !== void 0 && clearTimeout(timerId);
        maxTimerId !== void 0 && clearTimeout(maxTimerId);
        timerId = maxTimerId = void 0;
    }
    function flush() {
        if (timerId !== void 0 || maxTimerId !== void 0) return invokeFunc();
        return callbackReturnValue;
    }
    function debounced() {
        if (timerId) clearTimeout(timerId);
        timerId = setTimeoutImpl(invokeFunc, wait);
        if (maxWait && maxTimerId === void 0) maxTimerId = setTimeoutImpl(invokeFunc, maxWait);
        return callbackReturnValue;
    }
    debounced.cancel = cancelTimers;
    debounced.flush = flush;
    return debounced;
}



const $b3f3675dae70c197$var$WINDOW = (0, $f217104c897b328f$export$f1a6cdb1459e81d1);
const $b3f3675dae70c197$var$DEFAULT_MAX_STRING_LENGTH = 80;
function $b3f3675dae70c197$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return "<unknown>";
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $b3f3675dae70c197$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $b3f3675dae70c197$var$_htmlElementAsString(currentElem, keyAttrs);
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch  {
        return "<unknown>";
    }
}
function $b3f3675dae70c197$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    if (!elem?.tagName) return "";
    if ($b3f3675dae70c197$var$WINDOW.HTMLElement) {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset["sentryComponent"]) return elem.dataset["sentryComponent"];
            if (elem.dataset["sentryElement"]) return elem.dataset["sentryElement"];
        }
    }
    out.push(elem.tagName.toLowerCase());
    const keyAttrPairs = keyAttrs?.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs?.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        const className = elem.className;
        if (className && (0, $2660f95a1b0d39e6$export$844ec244b1367d54)(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    for (const k of [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ]){
        const attr = elem.getAttribute(k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join("");
}
function $b3f3675dae70c197$export$1cfafeee2987818b() {
    try {
        return $b3f3675dae70c197$var$WINDOW.document.location.href;
    } catch  {
        return "";
    }
}
function $b3f3675dae70c197$export$26727cfcc4d7e0fc(elem, maxTraverseHeight = 5) {
    if (!$b3f3675dae70c197$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    for(let i = 0; i < maxTraverseHeight; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset["sentryComponent"]) return currentElem.dataset["sentryComponent"];
            if (currentElem.dataset["sentryElement"]) return currentElem.dataset["sentryElement"];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}


var $763H4 = parcelRequire("763H4");

function $f90c965ae52ef7c3$export$4e09c449d6c407f7() {
    return typeof window !== "undefined" && (!(0, $763H4.isNodeEnv)() || $f90c965ae52ef7c3$var$isElectronNodeRenderer());
}
function $f90c965ae52ef7c3$var$isElectronNodeRenderer() {
    const process = (0, $f217104c897b328f$export$f1a6cdb1459e81d1).process;
    return process?.type === "renderer";
}


const $4736086234f81e69$export$b09ce39faaeb1e7c = 60000;
function $4736086234f81e69$export$615352e17ed7741(header, now = (0, $0d33076536fcb49a$export$65b1bada40c91b34)()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1e3;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $4736086234f81e69$export$b09ce39faaeb1e7c;
}
function $4736086234f81e69$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
function $4736086234f81e69$export$6c91fec22056810a(limits, dataCategory, now = (0, $0d33076536fcb49a$export$65b1bada40c91b34)()) {
    return $4736086234f81e69$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
function $4736086234f81e69$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = (0, $0d33076536fcb49a$export$65b1bada40c91b34)()) {
    const updatedRateLimits = {
        ...limits
    };
    const rateLimitHeader = headers?.["x-sentry-rate-limits"];
    const retryAfterHeader = headers?.["retry-after"];
    if (rateLimitHeader) for (const limit of rateLimitHeader.trim().split(",")){
        const [retryAfter, categories, , , namespaces] = limit.split(":", 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1e3;
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(";")){
            if (category === "metric_bucket") {
                if (!namespaces || namespaces.split(";").includes("custom")) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $4736086234f81e69$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}


const $f7c00614dae65e05$var$DEFAULT_BASE_URL = "thismessage:/";
function $f7c00614dae65e05$export$e258e13805402ba7(url) {
    return "isRelative" in url;
}
function $f7c00614dae65e05$export$2004d912a9ead694(url, urlBase) {
    const isRelative = url.indexOf("://") <= 0 && url.indexOf("//") !== 0;
    const base = urlBase ?? (isRelative ? $f7c00614dae65e05$var$DEFAULT_BASE_URL : void 0);
    try {
        if ("canParse" in URL && !URL.canParse(url, base)) return void 0;
        const fullUrlObject = new URL(url, base);
        if (isRelative) return {
            isRelative: isRelative,
            pathname: fullUrlObject.pathname,
            search: fullUrlObject.search,
            hash: fullUrlObject.hash
        };
        return fullUrlObject;
    } catch  {}
    return void 0;
}
function $f7c00614dae65e05$export$5339fcdc8e2a427c(url) {
    if ($f7c00614dae65e05$export$e258e13805402ba7(url)) return url.pathname;
    const newUrl = new URL(url);
    newUrl.search = "";
    newUrl.hash = "";
    if ([
        "80",
        "443"
    ].includes(newUrl.port)) newUrl.port = "";
    if (newUrl.password) newUrl.password = "%filtered%";
    if (newUrl.username) newUrl.username = "%filtered%";
    return newUrl.toString();
}
function $f7c00614dae65e05$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName) {
    const method = request?.method?.toUpperCase() ?? "GET";
    const route = routeName ? routeName : urlObject ? kind === "client" ? $f7c00614dae65e05$export$5339fcdc8e2a427c(urlObject) : urlObject.pathname : "/";
    return `${method} ${route}`;
}
function $f7c00614dae65e05$export$c37a41544f3c180c(urlObject, kind, spanOrigin, request, routeName) {
    const attributes = {
        [(0, $fbf607a81dcbd641$export$cca8dd30f57f805e)]: spanOrigin,
        [(0, $fbf607a81dcbd641$export$d7a7d984b0791405)]: "url"
    };
    if (routeName) {
        attributes[kind === "server" ? "http.route" : "url.template"] = routeName;
        attributes[0, $fbf607a81dcbd641$export$d7a7d984b0791405] = "route";
    }
    if (request?.method) attributes[0, $fbf607a81dcbd641$export$be7a251980e7e946] = request.method.toUpperCase();
    if (urlObject) {
        if (urlObject.search) attributes["url.query"] = urlObject.search;
        if (urlObject.hash) attributes["url.fragment"] = urlObject.hash;
        if (urlObject.pathname) {
            attributes["url.path"] = urlObject.pathname;
            if (urlObject.pathname === "/") attributes[0, $fbf607a81dcbd641$export$d7a7d984b0791405] = "route";
        }
        if (!$f7c00614dae65e05$export$e258e13805402ba7(urlObject)) {
            attributes[0, $fbf607a81dcbd641$export$25dfd73e0e32c6e1] = urlObject.href;
            if (urlObject.port) attributes["url.port"] = urlObject.port;
            if (urlObject.protocol) attributes["url.scheme"] = urlObject.protocol;
            if (urlObject.hostname) attributes[kind === "server" ? "server.address" : "url.domain"] = urlObject.hostname;
        }
    }
    return [
        $f7c00614dae65e05$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName),
        attributes
    ];
}
function $f7c00614dae65e05$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    const query = match[6] || "";
    const fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
function $f7c00614dae65e05$export$ce084c78234bd35(urlPath) {
    return urlPath.split(/[?#]/, 1)[0];
}
function $f7c00614dae65e05$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host?.replace(/^.*@/, "[filtered]:[filtered]@").replace(/(:80)$/, "").replace(/(:443)$/, "") || "";
    return `${protocol ? `${protocol}://` : ""}${filteredHost}${path}`;
}
function $f7c00614dae65e05$export$8abd806fcaf234fa(url, includeDataPrefix = true) {
    if (url.startsWith("data:")) {
        const match = url.match(/^data:([^;,]+)/);
        const mimeType = match ? match[1] : "text/plain";
        const isBase64 = url.includes(";base64,");
        const dataStart = url.indexOf(",");
        let dataPrefix = "";
        if (includeDataPrefix && dataStart !== -1) {
            const data = url.slice(dataStart + 1);
            dataPrefix = data.length > 10 ? `${data.slice(0, 10)}... [truncated]` : data;
        }
        return `data:${mimeType}${isBase64 ? ",base64" : ""}${dataPrefix ? `,${dataPrefix}` : ""}`;
    }
    return url;
}


function $d3d08e11b9b42721$export$d92e61f5600202af(url, client) {
    const dsn = client?.getDsn();
    const tunnel = client?.getOptions().tunnel;
    return $d3d08e11b9b42721$var$checkDsn(url, dsn) || $d3d08e11b9b42721$var$checkTunnel(url, tunnel);
}
function $d3d08e11b9b42721$var$checkTunnel(url, tunnel) {
    if (!tunnel) return false;
    return $d3d08e11b9b42721$var$removeTrailingSlash(url) === $d3d08e11b9b42721$var$removeTrailingSlash(tunnel);
}
function $d3d08e11b9b42721$var$checkDsn(url, dsn) {
    const urlParts = (0, $f7c00614dae65e05$export$2004d912a9ead694)(url);
    if (!urlParts || (0, $f7c00614dae65e05$export$e258e13805402ba7)(urlParts)) return false;
    if (!dsn) return false;
    return $d3d08e11b9b42721$var$hostnameMatchesDsnHost(urlParts.hostname, dsn.host) && /(^|&|\?)sentry_key=/.test(urlParts.search);
}
function $d3d08e11b9b42721$var$hostnameMatchesDsnHost(hostname, dsnHost) {
    return hostname === dsnHost || dsnHost.length > 0 && hostname.endsWith(`.${dsnHost}`);
}
function $d3d08e11b9b42721$var$removeTrailingSlash(str) {
    return str[str.length - 1] === "/" ? str.slice(0, -1) : str;
}







function $2ce3b14f10e8f3dc$export$3f58558cf4af9c09(contexts) {
    const attrs = {};
    const { response: response, profile: profile, cloud_resource: cloud_resource, culture: culture, state: state } = contexts;
    if (response) {
        if (response.status_code != null) attrs["http.response.status_code"] = response.status_code;
        if (response.body_size != null) attrs["http.response.body.size"] = response.body_size;
    }
    if (profile) {
        if (profile.profile_id) attrs["sentry.profile_id"] = profile.profile_id;
        if (profile.profiler_id) attrs["sentry.profiler_id"] = profile.profiler_id;
    }
    if (cloud_resource) {
        for (const [key, value] of Object.entries(cloud_resource))if (value != null) attrs[key] = value;
    }
    if (culture) {
        if (culture.locale) attrs["culture.locale"] = culture.locale;
        if (culture.timezone) attrs["culture.timezone"] = culture.timezone;
    }
    if (state?.state && typeof state.state.type === "string") attrs["state.type"] = state.state.type;
    const angular = contexts["angular"];
    if (angular) {
        const version = angular["version"];
        if (typeof version === "string" || typeof version === "number") attrs["angular.version"] = version;
    }
    const react = contexts["react"];
    if (react) {
        const version = react["version"];
        if (typeof version === "string" || typeof version === "number") attrs["react.version"] = version;
    }
    return attrs;
}


function $5cab9018a79b4113$export$b1e72a433efdc918(span, client) {
    const spanJSON = (0, $5a613f00f24f7165$export$db0cad9e44f67af8)(span);
    const segmentSpan = (0, $5a613f00f24f7165$export$7a3106f345d83bb6)(span);
    const serializedSegmentSpan = (0, $5a613f00f24f7165$export$db0cad9e44f67af8)(segmentSpan);
    const { isolationScope: spanIsolationScope, scope: spanScope } = (0, $eee56b24e446780d$export$c08fbc656a245d03)(span);
    const finalScopeData = (0, $8e3fa47d09daa1bc$export$cc422922fcbb91c6)(spanIsolationScope, spanScope);
    $5cab9018a79b4113$var$applyCommonSpanAttributes(spanJSON, serializedSegmentSpan, client, finalScopeData);
    const spanKind = span.kind;
    $5cab9018a79b4113$export$c3bd71cc0f7b2c55(spanJSON, spanKind);
    if (spanJSON.is_segment) {
        $5cab9018a79b4113$var$applyScopeToSegmentSpan(spanJSON, finalScopeData);
        $5cab9018a79b4113$var$applySdkMetadataToSegmentSpan(spanJSON, client);
        client.emit("processSegmentSpan", spanJSON);
    }
    client.emit("processSpan", spanJSON);
    const { beforeSendSpan: beforeSendSpan } = client.getOptions();
    const processedSpan = beforeSendSpan && (0, $a2373b6b013d98db$export$ca3e1ec3cdcc76ac)(beforeSendSpan) ? $5cab9018a79b4113$export$d38dd0f511e8d9ba(spanJSON, beforeSendSpan) : spanJSON;
    const spanNameSource = processedSpan.attributes?.[0, $fbf607a81dcbd641$export$d7a7d984b0791405];
    if (spanNameSource) $5cab9018a79b4113$export$146fcadff0eefcf3(processedSpan, {
        // Purposefully not using a constant defined here like in other attributes:
        // This will be the name for SEMANTIC_ATTRIBUTE_SENTRY_SOURCE in v11
        "sentry.span.source": spanNameSource
    });
    return {
        ...(0, $5a613f00f24f7165$export$5402aa553bcf35f3)(processedSpan),
        _segmentSpan: segmentSpan
    };
}
function $5cab9018a79b4113$var$applyScopeToSegmentSpan(segmentSpanJSON, scopeData) {
    const contextAttributes = (0, $2ce3b14f10e8f3dc$export$3f58558cf4af9c09)(scopeData.contexts);
    $5cab9018a79b4113$export$146fcadff0eefcf3(segmentSpanJSON, contextAttributes);
}
function $5cab9018a79b4113$export$146fcadff0eefcf3(spanJSON, newAttributes) {
    const originalAttributes = spanJSON.attributes ?? (spanJSON.attributes = {});
    Object.entries(newAttributes).forEach(([key, value])=>{
        if (value != null && !(key in originalAttributes)) originalAttributes[key] = value;
    });
}
function $5cab9018a79b4113$var$applySdkMetadataToSegmentSpan(segmentSpanJSON, client) {
    const integrationNames = client.getIntegrationNames();
    if (!integrationNames.length) return;
    $5cab9018a79b4113$export$146fcadff0eefcf3(segmentSpanJSON, {
        [(0, $fbf607a81dcbd641$export$bd847b1cc92ae587)]: integrationNames
    });
}
function $5cab9018a79b4113$var$applyCommonSpanAttributes(spanJSON, serializedSegmentSpan, client, scopeData) {
    const sdk = client.getSdkMetadata();
    const { release: release, environment: environment } = client.getOptions();
    $5cab9018a79b4113$export$146fcadff0eefcf3(spanJSON, {
        [(0, $fbf607a81dcbd641$export$f5cefb258679b29e)]: release,
        [(0, $fbf607a81dcbd641$export$d1b1dbb47f5ba57c)]: environment,
        [(0, $fbf607a81dcbd641$export$4626f2be16112c1c)]: serializedSegmentSpan.name,
        [(0, $fbf607a81dcbd641$export$25fa4a1832d3736a)]: serializedSegmentSpan.span_id,
        [(0, $fbf607a81dcbd641$export$87a4807042e1f1bb)]: sdk?.sdk?.name,
        [(0, $fbf607a81dcbd641$export$301ebe936458e291)]: sdk?.sdk?.version,
        [(0, $fbf607a81dcbd641$export$1f9cc1d34ea098a0)]: scopeData.user?.id,
        [(0, $fbf607a81dcbd641$export$b7466609ef46c07e)]: scopeData.user?.email,
        [(0, $fbf607a81dcbd641$export$8d592bdaea63b930)]: scopeData.user?.ip_address,
        [(0, $fbf607a81dcbd641$export$c05ee933d3f74b2b)]: scopeData.user?.username,
        ...scopeData.attributes
    });
}
function $5cab9018a79b4113$export$d38dd0f511e8d9ba(span, beforeSendSpan) {
    const modifedSpan = beforeSendSpan(span);
    if (!modifedSpan) {
        (0, $5a613f00f24f7165$export$d11691ff45a3e535)();
        return span;
    }
    return modifedSpan;
}
const $5cab9018a79b4113$var$SPAN_KIND_SERVER = 1;
const $5cab9018a79b4113$var$SPAN_KIND_CLIENT = 2;
function $5cab9018a79b4113$export$c3bd71cc0f7b2c55(spanJSON, spanKind) {
    const attributes = spanJSON.attributes;
    if (!attributes) return;
    const httpMethod = attributes["http.request.method"] || attributes["http.method"];
    if (httpMethod) {
        $5cab9018a79b4113$var$inferHttpSpanData(spanJSON, attributes, spanKind, httpMethod);
        return;
    }
    const dbSystem = attributes["db.system.name"] || attributes["db.system"];
    const opIsCache = typeof attributes[0, $fbf607a81dcbd641$export$1a413bd9a88fdb09] === "string" && `${attributes[0, $fbf607a81dcbd641$export$1a413bd9a88fdb09]}`.startsWith("cache.");
    if (dbSystem && !opIsCache) {
        $5cab9018a79b4113$var$inferDbSpanData(spanJSON, attributes);
        return;
    }
    if (attributes["rpc.service"]) {
        $5cab9018a79b4113$export$146fcadff0eefcf3(spanJSON, {
            [(0, $fbf607a81dcbd641$export$1a413bd9a88fdb09)]: "rpc"
        });
        return;
    }
    if (attributes["messaging.system"]) {
        $5cab9018a79b4113$export$146fcadff0eefcf3(spanJSON, {
            [(0, $fbf607a81dcbd641$export$1a413bd9a88fdb09)]: "message"
        });
        return;
    }
    const faasTrigger = attributes["faas.trigger"];
    if (faasTrigger) $5cab9018a79b4113$export$146fcadff0eefcf3(spanJSON, {
        [(0, $fbf607a81dcbd641$export$1a413bd9a88fdb09)]: `${faasTrigger}`
    });
}
function $5cab9018a79b4113$var$inferHttpSpanData(spanJSON, attributes, spanKind, httpMethod) {
    const opParts = [
        "http"
    ];
    if (spanKind === $5cab9018a79b4113$var$SPAN_KIND_CLIENT) opParts.push("client");
    else if (spanKind === $5cab9018a79b4113$var$SPAN_KIND_SERVER) opParts.push("server");
    if (attributes["sentry.http.prefetch"]) opParts.push("prefetch");
    $5cab9018a79b4113$export$146fcadff0eefcf3(spanJSON, {
        [(0, $fbf607a81dcbd641$export$1a413bd9a88fdb09)]: opParts.join(".")
    });
    const customName = attributes[0, $fbf607a81dcbd641$export$165ce9a229f6f050];
    if (typeof customName === "string") {
        spanJSON.name = customName;
        return;
    }
    if (attributes[0, $fbf607a81dcbd641$export$d7a7d984b0791405] === "custom") return;
    const httpRoute = attributes["http.route"];
    if (typeof httpRoute === "string") {
        spanJSON.name = `${httpMethod} ${httpRoute}`;
        $5cab9018a79b4113$export$146fcadff0eefcf3(spanJSON, {
            [(0, $fbf607a81dcbd641$export$d7a7d984b0791405)]: "route"
        });
    } else {
        if (spanKind === $5cab9018a79b4113$var$SPAN_KIND_CLIENT || spanKind === $5cab9018a79b4113$var$SPAN_KIND_SERVER) {
            const urlPath = $5cab9018a79b4113$var$getUrlPath(attributes, spanKind);
            if (urlPath) spanJSON.name = `${httpMethod} ${urlPath}`;
        }
        $5cab9018a79b4113$export$146fcadff0eefcf3(spanJSON, {
            [(0, $fbf607a81dcbd641$export$d7a7d984b0791405)]: "url"
        });
    }
}
function $5cab9018a79b4113$var$getUrlPath(attributes, spanKind) {
    const httpUrl = attributes["http.url"] || attributes["url.full"];
    const httpTarget = attributes["http.target"];
    const parsedUrl = typeof httpUrl === "string" ? (0, $f7c00614dae65e05$export$7a5253c0f62e0150)(httpUrl) : void 0;
    const sanitizedUrl = parsedUrl ? (0, $f7c00614dae65e05$export$e0ba26c9e23e1fe0)(parsedUrl) : void 0;
    if (spanKind === $5cab9018a79b4113$var$SPAN_KIND_SERVER && typeof httpTarget === "string") return (0, $f7c00614dae65e05$export$ce084c78234bd35)(httpTarget);
    if (sanitizedUrl) return sanitizedUrl;
    if (typeof httpTarget === "string") return (0, $f7c00614dae65e05$export$ce084c78234bd35)(httpTarget);
    return void 0;
}
function $5cab9018a79b4113$var$inferDbSpanData(spanJSON, attributes) {
    $5cab9018a79b4113$export$146fcadff0eefcf3(spanJSON, {
        [(0, $fbf607a81dcbd641$export$1a413bd9a88fdb09)]: "db"
    });
    const customName = attributes[0, $fbf607a81dcbd641$export$165ce9a229f6f050];
    if (typeof customName === "string") {
        spanJSON.name = customName;
        return;
    }
    if (attributes[0, $fbf607a81dcbd641$export$d7a7d984b0791405] === "custom") return;
    const statement = attributes["db.statement"];
    if (statement) {
        spanJSON.name = `${statement}`;
        $5cab9018a79b4113$export$146fcadff0eefcf3(spanJSON, {
            [(0, $fbf607a81dcbd641$export$d7a7d984b0791405)]: "task"
        });
    }
}

function $daafc8621233a3bd$export$d771ef054122c30a(level) {
    return level === "warn" ? "warning" : [
        "fatal",
        "error",
        "warning",
        "log",
        "info",
        "debug"
    ].includes(level) ? level : "log";
}





const $34629b289a1309dd$var$getRating = (value, thresholds)=>{
    if (value > thresholds[1]) return "poor";
    if (value > thresholds[0]) return "needs-improvement";
    return "good";
};
const $34629b289a1309dd$export$17679dccdd551979 = (callback, metric, thresholds, reportAllChanges)=>{
    let prevValue;
    let delta;
    return (forceReport)=>{
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                delta = metric.value - (prevValue ?? 0);
                if (delta || prevValue === void 0) {
                    prevValue = metric.value;
                    metric.delta = delta;
                    metric.rating = $34629b289a1309dd$var$getRating(metric.value, thresholds);
                    callback(metric);
                }
            }
        }
    };
};




const $af7a9c7869463492$export$6431553786c94949 = (checkResponseStart = true)=>{
    const navigationEntry = (0, $e601f21e4bdef308$export$56d8a8a25bd48b81).performance?.getEntriesByType?.("navigation")[0];
    if (// sentry-specific change:
    // We don't want to check for responseStart for our own use of `getNavigationEntry`
    !checkResponseStart || navigationEntry && navigationEntry.responseStart > 0 && navigationEntry.responseStart < performance.now()) return navigationEntry;
};


const $d4406b9926809e24$export$d3e828b3c7b5b845 = ()=>{
    const navEntry = (0, $af7a9c7869463492$export$6431553786c94949)();
    return navEntry?.activationStart ?? 0;
};



function $283a225c00c06ebf$export$26d3d892edc56833(type, listener, options) {
    if ((0, $e601f21e4bdef308$export$56d8a8a25bd48b81).document) (0, $e601f21e4bdef308$export$56d8a8a25bd48b81).addEventListener(type, listener, options);
}
function $283a225c00c06ebf$export$324d7b4b46528191(type, listener, options) {
    if ((0, $e601f21e4bdef308$export$56d8a8a25bd48b81).document) (0, $e601f21e4bdef308$export$56d8a8a25bd48b81).removeEventListener(type, listener, options);
}


let $2a0ce64905200878$var$firstHiddenTime = -1;
const $2a0ce64905200878$var$onHiddenFunctions = /* @__PURE__ */ new Set();
const $2a0ce64905200878$var$initHiddenTime = ()=>{
    return (0, $e601f21e4bdef308$export$56d8a8a25bd48b81).document?.visibilityState === "hidden" && !(0, $e601f21e4bdef308$export$56d8a8a25bd48b81).document?.prerendering ? 0 : Infinity;
};
const $2a0ce64905200878$var$onVisibilityUpdate = (event)=>{
    if ($2a0ce64905200878$var$isPageHidden(event) && $2a0ce64905200878$var$firstHiddenTime > -1) {
        if (event.type === "visibilitychange" || event.type === "pagehide") for (const onHiddenFunction of $2a0ce64905200878$var$onHiddenFunctions)onHiddenFunction();
        if (!isFinite($2a0ce64905200878$var$firstHiddenTime)) {
            $2a0ce64905200878$var$firstHiddenTime = event.type === "visibilitychange" ? event.timeStamp : 0;
            (0, $283a225c00c06ebf$export$324d7b4b46528191)("prerenderingchange", $2a0ce64905200878$var$onVisibilityUpdate, true);
        }
    }
};
const $2a0ce64905200878$export$443f86b2c77012c4 = ()=>{
    if ((0, $e601f21e4bdef308$export$56d8a8a25bd48b81).document && $2a0ce64905200878$var$firstHiddenTime < 0) {
        const activationStart = (0, $d4406b9926809e24$export$d3e828b3c7b5b845)();
        const firstVisibilityStateHiddenTime = !(0, $e601f21e4bdef308$export$56d8a8a25bd48b81).document.prerendering ? globalThis.performance.getEntriesByType("visibility-state").filter((e)=>e.name === "hidden" && e.startTime > activationStart)[0]?.startTime : void 0;
        $2a0ce64905200878$var$firstHiddenTime = firstVisibilityStateHiddenTime ?? $2a0ce64905200878$var$initHiddenTime();
        (0, $283a225c00c06ebf$export$26d3d892edc56833)("visibilitychange", $2a0ce64905200878$var$onVisibilityUpdate, true);
        (0, $283a225c00c06ebf$export$26d3d892edc56833)("pagehide", $2a0ce64905200878$var$onVisibilityUpdate, true);
        (0, $283a225c00c06ebf$export$26d3d892edc56833)("prerenderingchange", $2a0ce64905200878$var$onVisibilityUpdate, true);
    }
    return {
        get firstHiddenTime () {
            return $2a0ce64905200878$var$firstHiddenTime;
        },
        onHidden (cb) {
            $2a0ce64905200878$var$onHiddenFunctions.add(cb);
        }
    };
};
function $2a0ce64905200878$var$isPageHidden(event) {
    return event.type === "pagehide" || (0, $e601f21e4bdef308$export$56d8a8a25bd48b81).document?.visibilityState === "hidden";
}



const $3958da517b78568a$export$407ea409d1f3b539 = ()=>{
    return `v5-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};




const $a9e04ee2c9372876$export$3c29b44508a0612b = (name, value = -1)=>{
    const navEntry = (0, $af7a9c7869463492$export$6431553786c94949)();
    let navigationType = "navigate";
    if (navEntry) {
        if ((0, $e601f21e4bdef308$export$56d8a8a25bd48b81).document?.prerendering || (0, $d4406b9926809e24$export$d3e828b3c7b5b845)() > 0) navigationType = "prerender";
        else if ((0, $e601f21e4bdef308$export$56d8a8a25bd48b81).document?.wasDiscarded) navigationType = "restore";
        else if (navEntry.type) navigationType = navEntry.type.replace(/_/g, "-");
    }
    const entries = [];
    return {
        name: name,
        value: value,
        rating: "good",
        // If needed, will be updated when reported. `const` to keep the type from widening to `string`.
        delta: 0,
        entries: entries,
        id: (0, $3958da517b78568a$export$407ea409d1f3b539)(),
        navigationType: navigationType
    };
};


const $7acf1206ab23a71e$var$instanceMap = /* @__PURE__ */ new WeakMap();
function $7acf1206ab23a71e$export$7c74c9b2462ddb3c(identityObj, ClassObj) {
    try {
        if (!$7acf1206ab23a71e$var$instanceMap.get(identityObj)) $7acf1206ab23a71e$var$instanceMap.set(identityObj, new ClassObj());
        return $7acf1206ab23a71e$var$instanceMap.get(identityObj);
    } catch (_e) {
        return new ClassObj();
    }
}


class $f8e30ef5ca2a9613$export$4050f7f955e19aa0 {
    constructor(){
        // oxlint-disable-next-line sdk/no-class-field-initializers
        this._sessionValue = 0;
        // oxlint-disable-next-line sdk/no-class-field-initializers
        this._sessionEntries = [];
    }
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    _processEntry(entry) {
        if (entry.hadRecentInput) return;
        const firstSessionEntry = this._sessionEntries[0];
        const lastSessionEntry = this._sessionEntries[this._sessionEntries.length - 1];
        if (this._sessionValue && firstSessionEntry && lastSessionEntry && entry.startTime - lastSessionEntry.startTime < 1e3 && entry.startTime - firstSessionEntry.startTime < 5e3) {
            this._sessionValue += entry.value;
            this._sessionEntries.push(entry);
        } else {
            this._sessionValue = entry.value;
            this._sessionEntries = [
                entry
            ];
        }
        this._onAfterProcessingUnexpectedShift?.(entry);
    }
}


const $b308ff3be7b103e3$export$d1203567a167490e = (type, callback, opts = {})=>{
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            const po = new PerformanceObserver((list)=>{
                Promise.resolve().then(()=>{
                    callback(list.getEntries());
                });
            });
            po.observe({
                type: type,
                buffered: true,
                ...opts
            });
            return po;
        }
    } catch  {}
    return;
};


const $b6814898ec530b98$export$b841d51e31c12bab = (cb)=>{
    let called = false;
    return ()=>{
        if (!called) {
            cb();
            called = true;
        }
    };
};








const $37416b48c1745974$export$8bdb38a5671b594e = (callback)=>{
    if ((0, $e601f21e4bdef308$export$56d8a8a25bd48b81).document?.prerendering) addEventListener("prerenderingchange", ()=>callback(), true);
    else callback();
};


const $fd063c72e36d0046$export$e610c735b5510cec = [
    1800,
    3e3
];
const $fd063c72e36d0046$export$fe3c86b74e15d5de = (onReport, opts = {})=>{
    (0, $37416b48c1745974$export$8bdb38a5671b594e)(()=>{
        const visibilityWatcher = (0, $2a0ce64905200878$export$443f86b2c77012c4)();
        const metric = (0, $a9e04ee2c9372876$export$3c29b44508a0612b)("FCP");
        let report;
        const handleEntries = (entries)=>{
            for (const entry of entries)if (entry.name === "first-contentful-paint") {
                po.disconnect();
                if (entry.startTime < visibilityWatcher.firstHiddenTime) {
                    metric.value = Math.max(entry.startTime - (0, $d4406b9926809e24$export$d3e828b3c7b5b845)(), 0);
                    metric.entries.push(entry);
                    report(true);
                }
            }
        };
        const po = (0, $b308ff3be7b103e3$export$d1203567a167490e)("paint", handleEntries);
        if (po) report = (0, $34629b289a1309dd$export$17679dccdd551979)(onReport, metric, $fd063c72e36d0046$export$e610c735b5510cec, opts.reportAllChanges);
    });
};


const $fc5cfc1b0f7d5826$export$3f20d8e089ac35b2 = [
    0.1,
    0.25
];
const $fc5cfc1b0f7d5826$export$a7873055838e5ad8 = (onReport, opts = {})=>{
    (0, $fd063c72e36d0046$export$fe3c86b74e15d5de)((0, $b6814898ec530b98$export$b841d51e31c12bab)(()=>{
        const metric = (0, $a9e04ee2c9372876$export$3c29b44508a0612b)("CLS", 0);
        let report;
        const visibilityWatcher = (0, $2a0ce64905200878$export$443f86b2c77012c4)();
        const layoutShiftManager = (0, $7acf1206ab23a71e$export$7c74c9b2462ddb3c)(opts, (0, $f8e30ef5ca2a9613$export$4050f7f955e19aa0));
        const handleEntries = (entries)=>{
            for (const entry of entries)layoutShiftManager._processEntry(entry);
            if (layoutShiftManager._sessionValue > metric.value) {
                metric.value = layoutShiftManager._sessionValue;
                metric.entries = layoutShiftManager._sessionEntries;
                report();
            }
        };
        const po = (0, $b308ff3be7b103e3$export$d1203567a167490e)("layout-shift", handleEntries);
        if (po) {
            report = (0, $34629b289a1309dd$export$17679dccdd551979)(onReport, metric, $fc5cfc1b0f7d5826$export$3f20d8e089ac35b2, opts.reportAllChanges);
            visibilityWatcher.onHidden(()=>{
                handleEntries(po.takeRecords());
                report(true);
            });
            (0, $e601f21e4bdef308$export$56d8a8a25bd48b81)?.setTimeout?.(report);
        }
    }));
};







let $c8acb93ae3b6c432$var$interactionCountEstimate = 0;
let $c8acb93ae3b6c432$var$minKnownInteractionId = Infinity;
let $c8acb93ae3b6c432$var$maxKnownInteractionId = 0;
const $c8acb93ae3b6c432$var$updateEstimate = (entries)=>{
    entries.forEach((e)=>{
        if (e.interactionId) {
            $c8acb93ae3b6c432$var$minKnownInteractionId = Math.min($c8acb93ae3b6c432$var$minKnownInteractionId, e.interactionId);
            $c8acb93ae3b6c432$var$maxKnownInteractionId = Math.max($c8acb93ae3b6c432$var$maxKnownInteractionId, e.interactionId);
            $c8acb93ae3b6c432$var$interactionCountEstimate = $c8acb93ae3b6c432$var$maxKnownInteractionId ? ($c8acb93ae3b6c432$var$maxKnownInteractionId - $c8acb93ae3b6c432$var$minKnownInteractionId) / 7 + 1 : 0;
        }
    });
};
let $c8acb93ae3b6c432$var$po;
const $c8acb93ae3b6c432$export$8a962f2683a476d1 = ()=>{
    return $c8acb93ae3b6c432$var$po ? $c8acb93ae3b6c432$var$interactionCountEstimate : performance.interactionCount || 0;
};
const $c8acb93ae3b6c432$export$67d90cda6b78a2eb = ()=>{
    if ("interactionCount" in performance || $c8acb93ae3b6c432$var$po) return;
    $c8acb93ae3b6c432$var$po = (0, $b308ff3be7b103e3$export$d1203567a167490e)("event", $c8acb93ae3b6c432$var$updateEstimate, {
        type: "event",
        buffered: true,
        durationThreshold: 0
    });
};


const $eac1b3bc47c7f311$var$MAX_INTERACTIONS_TO_CONSIDER = 10;
let $eac1b3bc47c7f311$var$prevInteractionCount = 0;
const $eac1b3bc47c7f311$var$getInteractionCountForNavigation = ()=>{
    return (0, $c8acb93ae3b6c432$export$8a962f2683a476d1)() - $eac1b3bc47c7f311$var$prevInteractionCount;
};
class $eac1b3bc47c7f311$export$aaa80641d584351c {
    constructor(){
        /**
     * A list of longest interactions on the page (by latency) sorted so the
     * longest one is first. The list is at most MAX_INTERACTIONS_TO_CONSIDER
     * long.
     */ // oxlint-disable-next-line sdk/no-class-field-initializers
        this._longestInteractionList = [];
        /**
     * A mapping of longest interactions by their interaction ID.
     * This is used for faster lookup.
     */ // oxlint-disable-next-line sdk/no-class-field-initializers
        this._longestInteractionMap = /* @__PURE__ */ new Map();
    }
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility, jsdoc/require-jsdoc
    _resetInteractions() {
        $eac1b3bc47c7f311$var$prevInteractionCount = (0, $c8acb93ae3b6c432$export$8a962f2683a476d1)();
        this._longestInteractionList.length = 0;
        this._longestInteractionMap.clear();
    }
    /**
   * Returns the estimated p98 longest interaction based on the stored
   * interaction candidates and the interaction count for the current page.
   */ // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    _estimateP98LongestInteraction() {
        const candidateInteractionIndex = Math.min(this._longestInteractionList.length - 1, Math.floor($eac1b3bc47c7f311$var$getInteractionCountForNavigation() / 50));
        return this._longestInteractionList[candidateInteractionIndex];
    }
    /**
   * Takes a performance entry and adds it to the list of worst interactions
   * if its duration is long enough to make it among the worst. If the
   * entry is part of an existing interaction, it is merged and the latency
   * and entries list is updated as needed.
   */ // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    _processEntry(entry) {
        this._onBeforeProcessingEntry?.(entry);
        if (!(entry.interactionId || entry.entryType === "first-input")) return;
        const minLongestInteraction = this._longestInteractionList.at(-1);
        let interaction = this._longestInteractionMap.get(entry.interactionId);
        if (interaction || this._longestInteractionList.length < $eac1b3bc47c7f311$var$MAX_INTERACTIONS_TO_CONSIDER || // If the above conditions are false, `minLongestInteraction` will be set.
        entry.duration > minLongestInteraction._latency) {
            if (interaction) {
                if (entry.duration > interaction._latency) {
                    interaction.entries = [
                        entry
                    ];
                    interaction._latency = entry.duration;
                } else if (entry.duration === interaction._latency && entry.startTime === interaction.entries[0].startTime) interaction.entries.push(entry);
            } else {
                interaction = {
                    id: entry.interactionId,
                    entries: [
                        entry
                    ],
                    _latency: entry.duration
                };
                this._longestInteractionMap.set(interaction.id, interaction);
                this._longestInteractionList.push(interaction);
            }
            this._longestInteractionList.sort((a, b)=>b._latency - a._latency);
            if (this._longestInteractionList.length > $eac1b3bc47c7f311$var$MAX_INTERACTIONS_TO_CONSIDER) {
                const removedInteractions = this._longestInteractionList.splice($eac1b3bc47c7f311$var$MAX_INTERACTIONS_TO_CONSIDER);
                for (const interaction2 of removedInteractions)this._longestInteractionMap.delete(interaction2.id);
            }
            this._onAfterProcessingINPCandidate?.(interaction);
        }
    }
}








const $d007d36e56c227ae$export$d3314d5863fc1fef = (cb)=>{
    const rIC = (0, $e601f21e4bdef308$export$56d8a8a25bd48b81).requestIdleCallback || (0, $e601f21e4bdef308$export$56d8a8a25bd48b81).setTimeout;
    if ((0, $e601f21e4bdef308$export$56d8a8a25bd48b81).document?.visibilityState === "hidden") cb();
    else {
        cb = (0, $b6814898ec530b98$export$b841d51e31c12bab)(cb);
        (0, $283a225c00c06ebf$export$26d3d892edc56833)("visibilitychange", cb, {
            once: true,
            capture: true
        });
        (0, $283a225c00c06ebf$export$26d3d892edc56833)("pagehide", cb, {
            once: true,
            capture: true
        });
        rIC(()=>{
            cb();
            (0, $283a225c00c06ebf$export$324d7b4b46528191)("visibilitychange", cb, {
                capture: true
            });
            (0, $283a225c00c06ebf$export$324d7b4b46528191)("pagehide", cb, {
                capture: true
            });
        });
    }
};


const $677883b2289e1dcc$export$7f4cb060ded9173c = [
    200,
    500
];
const $677883b2289e1dcc$var$DEFAULT_DURATION_THRESHOLD = 40;
const $677883b2289e1dcc$export$7df4b36ecaed99e1 = (onReport, opts = {})=>{
    if (!(globalThis.PerformanceEventTiming && "interactionId" in PerformanceEventTiming.prototype)) return;
    const visibilityWatcher = (0, $2a0ce64905200878$export$443f86b2c77012c4)();
    (0, $37416b48c1745974$export$8bdb38a5671b594e)(()=>{
        (0, $c8acb93ae3b6c432$export$67d90cda6b78a2eb)();
        const metric = (0, $a9e04ee2c9372876$export$3c29b44508a0612b)("INP");
        let report;
        const interactionManager = (0, $7acf1206ab23a71e$export$7c74c9b2462ddb3c)(opts, (0, $eac1b3bc47c7f311$export$aaa80641d584351c));
        const handleEntries = (entries)=>{
            (0, $d007d36e56c227ae$export$d3314d5863fc1fef)(()=>{
                for (const entry of entries)interactionManager._processEntry(entry);
                const inp = interactionManager._estimateP98LongestInteraction();
                if (inp && inp._latency !== metric.value) {
                    metric.value = inp._latency;
                    metric.entries = inp.entries;
                    report();
                }
            });
        };
        const po = (0, $b308ff3be7b103e3$export$d1203567a167490e)("event", handleEntries, {
            // Event Timing entries have their durations rounded to the nearest 8ms,
            // so a duration of 40ms would be any event that spans 2.5 or more frames
            // at 60Hz. This threshold is chosen to strike a balance between usefulness
            // and performance. Running this callback for any interaction that spans
            // just one or two frames is likely not worth the insight that could be
            // gained.
            durationThreshold: opts.durationThreshold ?? $677883b2289e1dcc$var$DEFAULT_DURATION_THRESHOLD
        });
        report = (0, $34629b289a1309dd$export$17679dccdd551979)(onReport, metric, $677883b2289e1dcc$export$7f4cb060ded9173c, opts.reportAllChanges);
        if (po) {
            po.observe({
                type: "first-input",
                buffered: true
            });
            visibilityWatcher.onHidden(()=>{
                handleEntries(po.takeRecords());
                report(true);
            });
        }
    });
};








class $012809cd0fddfb9f$export$6a641ef2a067ec62 {
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility, jsdoc/require-jsdoc
    _processEntry(entry) {
        this._onBeforeProcessingEntry?.(entry);
    }
}






const $0264710ad959c0cc$export$948521ca5b0e1b17 = [
    2500,
    4e3
];
const $0264710ad959c0cc$export$947b1626ab8d5632 = (onReport, opts = {})=>{
    (0, $37416b48c1745974$export$8bdb38a5671b594e)(()=>{
        const visibilityWatcher = (0, $2a0ce64905200878$export$443f86b2c77012c4)();
        const metric = (0, $a9e04ee2c9372876$export$3c29b44508a0612b)("LCP");
        let report;
        const lcpEntryManager = (0, $7acf1206ab23a71e$export$7c74c9b2462ddb3c)(opts, (0, $012809cd0fddfb9f$export$6a641ef2a067ec62));
        const handleEntries = (entries)=>{
            if (!opts.reportAllChanges) entries = entries.slice(-1);
            for (const entry of entries){
                lcpEntryManager._processEntry(entry);
                if (entry.startTime < visibilityWatcher.firstHiddenTime) {
                    metric.value = Math.max(entry.startTime - (0, $d4406b9926809e24$export$d3e828b3c7b5b845)(), 0);
                    metric.entries = [
                        entry
                    ];
                    report();
                }
            }
        };
        const po = (0, $b308ff3be7b103e3$export$d1203567a167490e)("largest-contentful-paint", handleEntries);
        if (po) {
            report = (0, $34629b289a1309dd$export$17679dccdd551979)(onReport, metric, $0264710ad959c0cc$export$948521ca5b0e1b17, opts.reportAllChanges);
            const stopListening = (0, $b6814898ec530b98$export$b841d51e31c12bab)(()=>{
                handleEntries(po.takeRecords());
                po.disconnect();
                report(true);
            });
            const stopListeningWrapper = (event)=>{
                if (event.isTrusted) {
                    (0, $d007d36e56c227ae$export$d3314d5863fc1fef)(stopListening);
                    (0, $283a225c00c06ebf$export$324d7b4b46528191)(event.type, stopListeningWrapper, {
                        capture: true
                    });
                }
            };
            for (const type of [
                "keydown",
                "click",
                "visibilitychange"
            ])(0, $283a225c00c06ebf$export$26d3d892edc56833)(type, stopListeningWrapper, {
                capture: true
            });
        }
    });
};









const $01468d3f7d97f5f1$export$65c59ea8064668fc = [
    800,
    1800
];
const $01468d3f7d97f5f1$var$whenReady = (callback)=>{
    if ((0, $e601f21e4bdef308$export$56d8a8a25bd48b81).document?.prerendering) (0, $37416b48c1745974$export$8bdb38a5671b594e)(()=>$01468d3f7d97f5f1$var$whenReady(callback));
    else if ((0, $e601f21e4bdef308$export$56d8a8a25bd48b81).document?.readyState !== "complete") addEventListener("load", ()=>$01468d3f7d97f5f1$var$whenReady(callback), true);
    else setTimeout(callback);
};
const $01468d3f7d97f5f1$export$33a01e6c5f2c7e33 = (onReport, opts = {})=>{
    const metric = (0, $a9e04ee2c9372876$export$3c29b44508a0612b)("TTFB");
    const report = (0, $34629b289a1309dd$export$17679dccdd551979)(onReport, metric, $01468d3f7d97f5f1$export$65c59ea8064668fc, opts.reportAllChanges);
    $01468d3f7d97f5f1$var$whenReady(()=>{
        const navigationEntry = (0, $af7a9c7869463492$export$6431553786c94949)();
        if (navigationEntry) {
            metric.value = Math.max(navigationEntry.responseStart - (0, $d4406b9926809e24$export$d3e828b3c7b5b845)(), 0);
            metric.entries = [
                navigationEntry
            ];
            report(true);
        }
    });
};


const $8997673cf5a7dcf8$var$handlers = {};
const $8997673cf5a7dcf8$var$instrumented = {};
let $8997673cf5a7dcf8$var$_previousCls;
let $8997673cf5a7dcf8$var$_previousLcp;
let $8997673cf5a7dcf8$var$_previousTtfb;
let $8997673cf5a7dcf8$var$_previousInp;
function $8997673cf5a7dcf8$export$861b82818b37ba5b(callback, stopOnCallback = false) {
    return $8997673cf5a7dcf8$var$addMetricObserver("cls", callback, $8997673cf5a7dcf8$var$instrumentCls, $8997673cf5a7dcf8$var$_previousCls, stopOnCallback);
}
function $8997673cf5a7dcf8$export$3fd4b53331200102(callback, stopOnCallback = false) {
    return $8997673cf5a7dcf8$var$addMetricObserver("lcp", callback, $8997673cf5a7dcf8$var$instrumentLcp, $8997673cf5a7dcf8$var$_previousLcp, stopOnCallback);
}
function $8997673cf5a7dcf8$export$699d9529c099a797(callback) {
    return $8997673cf5a7dcf8$var$addMetricObserver("ttfb", callback, $8997673cf5a7dcf8$var$instrumentTtfb, $8997673cf5a7dcf8$var$_previousTtfb);
}
function $8997673cf5a7dcf8$export$da3b76aa2022cbd7(callback) {
    return $8997673cf5a7dcf8$var$addMetricObserver("inp", callback, $8997673cf5a7dcf8$var$instrumentInp, $8997673cf5a7dcf8$var$_previousInp);
}
function $8997673cf5a7dcf8$export$69816c1a049f8db6(type, callback) {
    $8997673cf5a7dcf8$var$addHandler(type, callback);
    if (!$8997673cf5a7dcf8$var$instrumented[type]) {
        $8997673cf5a7dcf8$var$instrumentPerformanceObserver(type);
        $8997673cf5a7dcf8$var$instrumented[type] = true;
    }
    return $8997673cf5a7dcf8$var$getCleanupCallback(type, callback);
}
function $8997673cf5a7dcf8$var$triggerHandlers(type, data) {
    const typeHandlers = $8997673cf5a7dcf8$var$handlers[type];
    if (!typeHandlers?.length) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $1ace9bb4c0859f10$export$16a28057038b10ef) && (0, $dd4af310e95b2daa$export$1c9f709888824e05).error(`Error while triggering instrumentation handler.
Type: ${type}
Name: ${(0, $4f18ccbe39bfd9ec$export$aad197c7121a6651)(handler)}
Error:`, e);
    }
}
function $8997673cf5a7dcf8$var$instrumentCls() {
    return (0, $fc5cfc1b0f7d5826$export$a7873055838e5ad8)((metric)=>{
        $8997673cf5a7dcf8$var$triggerHandlers("cls", {
            metric: metric
        });
        $8997673cf5a7dcf8$var$_previousCls = metric;
    }, // We want the callback to be called whenever the CLS value updates.
    // By default, the callback is only called when the tab goes to the background.
    {
        reportAllChanges: true
    });
}
function $8997673cf5a7dcf8$var$instrumentLcp() {
    return (0, $0264710ad959c0cc$export$947b1626ab8d5632)((metric)=>{
        $8997673cf5a7dcf8$var$triggerHandlers("lcp", {
            metric: metric
        });
        $8997673cf5a7dcf8$var$_previousLcp = metric;
    }, // We want the callback to be called whenever the LCP value updates.
    // By default, the callback is only called when the tab goes to the background.
    {
        reportAllChanges: true
    });
}
function $8997673cf5a7dcf8$var$instrumentTtfb() {
    return (0, $01468d3f7d97f5f1$export$33a01e6c5f2c7e33)((metric)=>{
        $8997673cf5a7dcf8$var$triggerHandlers("ttfb", {
            metric: metric
        });
        $8997673cf5a7dcf8$var$_previousTtfb = metric;
    });
}
function $8997673cf5a7dcf8$var$instrumentInp() {
    return (0, $677883b2289e1dcc$export$7df4b36ecaed99e1)((metric)=>{
        $8997673cf5a7dcf8$var$triggerHandlers("inp", {
            metric: metric
        });
        $8997673cf5a7dcf8$var$_previousInp = metric;
    });
}
function $8997673cf5a7dcf8$var$addMetricObserver(type, callback, instrumentFn, previousValue, stopOnCallback = false) {
    $8997673cf5a7dcf8$var$addHandler(type, callback);
    let stopListening;
    if (!$8997673cf5a7dcf8$var$instrumented[type]) {
        stopListening = instrumentFn();
        $8997673cf5a7dcf8$var$instrumented[type] = true;
    }
    if (previousValue) callback({
        metric: previousValue
    });
    return $8997673cf5a7dcf8$var$getCleanupCallback(type, callback, stopOnCallback ? stopListening : void 0);
}
function $8997673cf5a7dcf8$var$instrumentPerformanceObserver(type) {
    const options = {};
    if (type === "event") options.durationThreshold = 0;
    (0, $b308ff3be7b103e3$export$d1203567a167490e)(type, (entries)=>{
        $8997673cf5a7dcf8$var$triggerHandlers(type, {
            entries: entries
        });
    }, options);
}
function $8997673cf5a7dcf8$var$addHandler(type, handler) {
    $8997673cf5a7dcf8$var$handlers[type] = $8997673cf5a7dcf8$var$handlers[type] || [];
    $8997673cf5a7dcf8$var$handlers[type].push(handler);
}
function $8997673cf5a7dcf8$var$getCleanupCallback(type, callback, stopListening) {
    return ()=>{
        if (stopListening) stopListening();
        const typeHandlers = $8997673cf5a7dcf8$var$handlers[type];
        if (!typeHandlers) return;
        const index = typeHandlers.indexOf(callback);
        if (index !== -1) typeHandlers.splice(index, 1);
    };
}
function $8997673cf5a7dcf8$export$7affb50b622d8714(entry) {
    return "duration" in entry;
}



const $d7e25a8beb5484e0$export$363d064b9116000e = /* @__PURE__ */ Symbol.for("sentry__originalRequestBody");
function $d7e25a8beb5484e0$export$2f1b0f57f243f270(formData) {
    return new URLSearchParams(formData).toString();
}
function $d7e25a8beb5484e0$export$945a2d5364608d5(body, _debug = (0, $dd4af310e95b2daa$export$1c9f709888824e05)) {
    try {
        if (typeof body === "string") return [
            body
        ];
        if (body instanceof URLSearchParams) return [
            body.toString()
        ];
        if (body instanceof FormData) return [
            $d7e25a8beb5484e0$export$2f1b0f57f243f270(body)
        ];
        if (!body) return [
            void 0
        ];
    } catch (error) {
        (0, $1ace9bb4c0859f10$export$16a28057038b10ef) && _debug.error(error, "Failed to serialize body", body);
        return [
            void 0,
            "BODY_PARSE_ERROR"
        ];
    }
    (0, $1ace9bb4c0859f10$export$16a28057038b10ef) && _debug.log("Skipping network body because of body type", body);
    return [
        void 0,
        "UNPARSEABLE_BODY_TYPE"
    ];
}
function $d7e25a8beb5484e0$export$ad44edf8012ec314(fetchArgs = []) {
    if (fetchArgs.length >= 2 && fetchArgs[1] && typeof fetchArgs[1] === "object" && "body" in fetchArgs[1]) return fetchArgs[1].body;
    if (fetchArgs.length >= 1 && fetchArgs[0] instanceof Request) {
        const request = fetchArgs[0];
        const originalBody = request[$d7e25a8beb5484e0$export$363d064b9116000e];
        if (originalBody !== void 0) return originalBody;
        return void 0;
    }
    return void 0;
}
function $d7e25a8beb5484e0$export$ce71c337afb62ea(xhr) {
    let headers;
    try {
        headers = xhr.getAllResponseHeaders();
    } catch (error) {
        (0, $1ace9bb4c0859f10$export$16a28057038b10ef) && (0, $dd4af310e95b2daa$export$1c9f709888824e05).error(error, "Failed to get xhr response headers", xhr);
        return {};
    }
    if (!headers) return {};
    return headers.split("\r\n").reduce((acc, line)=>{
        const [key, value] = line.split(": ");
        if (value) acc[key.toLowerCase()] = value;
        return acc;
    }, {});
}


const $4242ad5853add3e0$var$WINDOW = (0, $f217104c897b328f$export$f1a6cdb1459e81d1);
const $4242ad5853add3e0$var$REPLAY_SESSION_KEY = "sentryReplaySession";
const $4242ad5853add3e0$var$REPLAY_EVENT_NAME = "replay_event";
const $4242ad5853add3e0$var$UNABLE_TO_SEND_REPLAY = "Unable to send Replay";
const $4242ad5853add3e0$var$SESSION_IDLE_PAUSE_DURATION = 3e5;
const $4242ad5853add3e0$var$SESSION_IDLE_EXPIRE_DURATION = 9e5;
const $4242ad5853add3e0$var$DEFAULT_FLUSH_MIN_DELAY = 5e3;
const $4242ad5853add3e0$var$DEFAULT_FLUSH_MAX_DELAY = 5500;
const $4242ad5853add3e0$var$BUFFER_CHECKOUT_TIME = 6e4;
const $4242ad5853add3e0$var$RETRY_BASE_INTERVAL = 5e3;
const $4242ad5853add3e0$var$RETRY_MAX_COUNT = 3;
const $4242ad5853add3e0$var$NETWORK_BODY_MAX_SIZE = 15e4;
const $4242ad5853add3e0$var$CONSOLE_ARG_MAX_SIZE = 5e3;
const $4242ad5853add3e0$var$SLOW_CLICK_THRESHOLD = 3e3;
const $4242ad5853add3e0$var$SLOW_CLICK_SCROLL_TIMEOUT = 300;
const $4242ad5853add3e0$var$REPLAY_MAX_EVENT_BUFFER_SIZE = 2e7;
const $4242ad5853add3e0$var$MIN_REPLAY_DURATION = 4999;
const $4242ad5853add3e0$var$MIN_REPLAY_DURATION_LIMIT = 5e4;
const $4242ad5853add3e0$var$MAX_REPLAY_DURATION = 36e5;
var $4242ad5853add3e0$var$__defProp = Object.defineProperty;
var $4242ad5853add3e0$var$__defNormalProp = (obj, key, value)=>key in obj ? $4242ad5853add3e0$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $4242ad5853add3e0$var$__publicField = (obj, key, value)=>$4242ad5853add3e0$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var $4242ad5853add3e0$var$NodeType$1 = /* @__PURE__ */ ((NodeType2)=>{
    NodeType2[NodeType2["Document"] = 0] = "Document";
    NodeType2[NodeType2["DocumentType"] = 1] = "DocumentType";
    NodeType2[NodeType2["Element"] = 2] = "Element";
    NodeType2[NodeType2["Text"] = 3] = "Text";
    NodeType2[NodeType2["CDATA"] = 4] = "CDATA";
    NodeType2[NodeType2["Comment"] = 5] = "Comment";
    return NodeType2;
})($4242ad5853add3e0$var$NodeType$1 || {});
function $4242ad5853add3e0$var$isElement$1(n) {
    return n.nodeType === n.ELEMENT_NODE;
}
function $4242ad5853add3e0$var$isShadowRoot(n) {
    const host = n?.host;
    return Boolean(host?.shadowRoot === n);
}
function $4242ad5853add3e0$var$isNativeShadowDom(shadowRoot) {
    return Object.prototype.toString.call(shadowRoot) === "[object ShadowRoot]";
}
function $4242ad5853add3e0$var$fixBrowserCompatibilityIssuesInCSS(cssText) {
    if (cssText.includes(" background-clip: text;") && !cssText.includes(" -webkit-background-clip: text;")) cssText = cssText.replace(/\sbackground-clip:\s*text;/g, " -webkit-background-clip: text; background-clip: text;");
    return cssText;
}
function $4242ad5853add3e0$var$escapeImportStatement(rule) {
    const { cssText: cssText } = rule;
    if (cssText.split('"').length < 3) return cssText;
    const statement = [
        "@import",
        `url(${JSON.stringify(rule.href)})`
    ];
    if (rule.layerName === "") statement.push(`layer`);
    else if (rule.layerName) statement.push(`layer(${rule.layerName})`);
    if (rule.supportsText) statement.push(`supports(${rule.supportsText})`);
    if (rule.media.length) statement.push(rule.media.mediaText);
    return statement.join(" ") + ";";
}
function $4242ad5853add3e0$var$stringifyStylesheet(s) {
    try {
        const rules = s.rules || s.cssRules;
        return rules ? $4242ad5853add3e0$var$fixBrowserCompatibilityIssuesInCSS(Array.from(rules, $4242ad5853add3e0$var$stringifyRule).join("")) : null;
    } catch (error) {
        return null;
    }
}
function $4242ad5853add3e0$var$fixAllCssProperty(rule) {
    let styles = "";
    for(let i = 0; i < rule.style.length; i++){
        const styleDeclaration = rule.style;
        const attribute = styleDeclaration[i];
        const isImportant = styleDeclaration.getPropertyPriority(attribute);
        styles += `${attribute}:${styleDeclaration.getPropertyValue(attribute)}${isImportant ? ` !important` : ""};`;
    }
    return `${rule.selectorText} { ${styles} }`;
}
function $4242ad5853add3e0$var$stringifyRule(rule) {
    let importStringified;
    if ($4242ad5853add3e0$var$isCSSImportRule(rule)) try {
        importStringified = // we can access the imported stylesheet rules directly
        $4242ad5853add3e0$var$stringifyStylesheet(rule.styleSheet) || // work around browser issues with the raw string `@import url(...)` statement
        $4242ad5853add3e0$var$escapeImportStatement(rule);
    } catch (error) {}
    else if ($4242ad5853add3e0$var$isCSSStyleRule(rule)) {
        let cssText = rule.cssText;
        const needsSafariColonFix = rule.selectorText.includes(":");
        const needsAllFix = typeof rule.style["all"] === "string" && rule.style["all"];
        if (needsAllFix) cssText = $4242ad5853add3e0$var$fixAllCssProperty(rule);
        if (needsSafariColonFix) cssText = $4242ad5853add3e0$var$fixSafariColons(cssText);
        if (needsSafariColonFix || needsAllFix) return cssText;
    }
    return importStringified || rule.cssText;
}
function $4242ad5853add3e0$var$fixSafariColons(cssStringified) {
    const regex = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
    return cssStringified.replace(regex, "$1\\$2");
}
function $4242ad5853add3e0$var$isCSSImportRule(rule) {
    return "styleSheet" in rule;
}
function $4242ad5853add3e0$var$isCSSStyleRule(rule) {
    return "selectorText" in rule;
}
class $4242ad5853add3e0$var$Mirror {
    constructor(){
        $4242ad5853add3e0$var$__publicField(this, "idNodeMap", /* @__PURE__ */ new Map());
        $4242ad5853add3e0$var$__publicField(this, "nodeMetaMap", /* @__PURE__ */ new WeakMap());
    }
    getId(n) {
        if (!n) return -1;
        const id = this.getMeta(n)?.id;
        return id ?? -1;
    }
    getNode(id) {
        return this.idNodeMap.get(id) || null;
    }
    getIds() {
        return Array.from(this.idNodeMap.keys());
    }
    getMeta(n) {
        return this.nodeMetaMap.get(n) || null;
    }
    // removes the node from idNodeMap
    // doesn't remove the node from nodeMetaMap
    removeNodeFromMap(n) {
        const id = this.getId(n);
        this.idNodeMap.delete(id);
        if (n.childNodes) n.childNodes.forEach((childNode)=>this.removeNodeFromMap(childNode));
    }
    has(id) {
        return this.idNodeMap.has(id);
    }
    hasNode(node) {
        return this.nodeMetaMap.has(node);
    }
    add(n, meta) {
        const id = meta.id;
        this.idNodeMap.set(id, n);
        this.nodeMetaMap.set(n, meta);
    }
    replace(id, n) {
        const oldNode = this.getNode(id);
        if (oldNode) {
            const meta = this.nodeMetaMap.get(oldNode);
            if (meta) this.nodeMetaMap.set(n, meta);
        }
        this.idNodeMap.set(id, n);
    }
    reset() {
        this.idNodeMap = /* @__PURE__ */ new Map();
        this.nodeMetaMap = /* @__PURE__ */ new WeakMap();
    }
}
function $4242ad5853add3e0$var$createMirror() {
    return new $4242ad5853add3e0$var$Mirror();
}
function $4242ad5853add3e0$var$shouldMaskInput({ maskInputOptions: maskInputOptions, tagName: tagName, type: type }) {
    if (tagName === "OPTION") tagName = "SELECT";
    return Boolean(maskInputOptions[tagName.toLowerCase()] || type && maskInputOptions[type] || type === "password" || // Default to "text" option for inputs without a "type" attribute defined
    tagName === "INPUT" && !type && maskInputOptions["text"]);
}
function $4242ad5853add3e0$var$maskInputValue({ isMasked: isMasked, element: element, value: value, maskInputFn: maskInputFn }) {
    let text = value || "";
    if (!isMasked) return text;
    if (maskInputFn) text = maskInputFn(text, element);
    return "*".repeat(text.length);
}
function $4242ad5853add3e0$var$toLowerCase(str) {
    return str.toLowerCase();
}
function $4242ad5853add3e0$var$toUpperCase(str) {
    return str.toUpperCase();
}
const $4242ad5853add3e0$var$ORIGINAL_ATTRIBUTE_NAME = "__rrweb_original__";
function $4242ad5853add3e0$var$is2DCanvasBlank(canvas) {
    const ctx = canvas.getContext("2d");
    if (!ctx) return true;
    const chunkSize = 50;
    for(let x = 0; x < canvas.width; x += chunkSize)for(let y = 0; y < canvas.height; y += chunkSize){
        const getImageData = ctx.getImageData;
        const originalGetImageData = $4242ad5853add3e0$var$ORIGINAL_ATTRIBUTE_NAME in getImageData ? getImageData[$4242ad5853add3e0$var$ORIGINAL_ATTRIBUTE_NAME] : getImageData;
        const pixelBuffer = new Uint32Array(// eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
        originalGetImageData.call(ctx, x, y, Math.min(chunkSize, canvas.width - x), Math.min(chunkSize, canvas.height - y)).data.buffer);
        if (pixelBuffer.some((pixel)=>pixel !== 0)) return false;
    }
    return true;
}
function $4242ad5853add3e0$var$getInputType(element) {
    const type = element.type;
    return element.hasAttribute("data-rr-is-password") ? "password" : type ? // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
    $4242ad5853add3e0$var$toLowerCase(type) : null;
}
function $4242ad5853add3e0$var$getInputValue(el, tagName, type) {
    if (tagName === "INPUT" && (type === "radio" || type === "checkbox")) return el.getAttribute("value") || "";
    return el.value;
}
function $4242ad5853add3e0$var$extractFileExtension(path, baseURL) {
    let url;
    try {
        url = new URL(path, baseURL ?? window.location.href);
    } catch (err) {
        return null;
    }
    const regex = /\.([0-9a-z]+)(?:$)/i;
    const match = url.pathname.match(regex);
    return match?.[1] ?? null;
}
const $4242ad5853add3e0$var$cachedImplementations$1 = {};
function $4242ad5853add3e0$var$getImplementation$1(name) {
    const cached = $4242ad5853add3e0$var$cachedImplementations$1[name];
    if (cached) return cached;
    const document2 = window.document;
    let impl = window[name];
    if (document2 && typeof document2.createElement === "function") try {
        const sandbox = document2.createElement("iframe");
        sandbox.hidden = true;
        document2.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow[name]) impl = contentWindow[name];
        document2.head.removeChild(sandbox);
    } catch (e) {}
    return $4242ad5853add3e0$var$cachedImplementations$1[name] = impl.bind(window);
}
function $4242ad5853add3e0$var$setTimeout$1(...rest) {
    return $4242ad5853add3e0$var$getImplementation$1("setTimeout")(...rest);
}
function $4242ad5853add3e0$var$clearTimeout$1(...rest) {
    return $4242ad5853add3e0$var$getImplementation$1("clearTimeout")(...rest);
}
function $4242ad5853add3e0$var$getIFrameContentDocument$1(iframe) {
    try {
        return iframe.contentDocument;
    } catch  {}
}
function $4242ad5853add3e0$var$getIFrameContentWindow$1(iframe) {
    try {
        return iframe.contentWindow;
    } catch  {}
}
let $4242ad5853add3e0$var$_id = 1;
const $4242ad5853add3e0$var$tagNameRegex = new RegExp("[^a-z0-9-_:]");
const $4242ad5853add3e0$var$IGNORED_NODE = -2;
function $4242ad5853add3e0$var$genId() {
    return $4242ad5853add3e0$var$_id++;
}
function $4242ad5853add3e0$var$getValidTagName(element) {
    if (element instanceof HTMLFormElement) return "form";
    const processedTagName = $4242ad5853add3e0$var$toLowerCase(element.tagName);
    if ($4242ad5853add3e0$var$tagNameRegex.test(processedTagName)) return "div";
    return processedTagName;
}
function $4242ad5853add3e0$var$extractOrigin(url) {
    let origin = "";
    if (url.indexOf("//") > -1) origin = url.split("/").slice(0, 3).join("/");
    else origin = url.split("/")[0];
    origin = origin.split("?")[0];
    return origin;
}
let $4242ad5853add3e0$var$canvasService;
let $4242ad5853add3e0$var$canvasCtx;
const $4242ad5853add3e0$var$URL_IN_CSS_REF = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm;
const $4242ad5853add3e0$var$URL_PROTOCOL_MATCH = /^(?:[a-z+]+:)?\/\//i;
const $4242ad5853add3e0$var$URL_WWW_MATCH = /^www\..*/i;
const $4242ad5853add3e0$var$DATA_URI = /^(data:)([^,]*),(.*)/i;
function $4242ad5853add3e0$var$filterCSSPropertiesFromInlineStyle(cssText, ignoredProperties) {
    if (!cssText || ignoredProperties.size === 0) return cssText;
    try {
        const properties = cssText.split(";");
        const filteredProperties = [];
        for (let property of properties){
            property = property.trim();
            if (!property) continue;
            const colonIndex = property.indexOf(":");
            if (colonIndex === -1) {
                filteredProperties.push(property);
                continue;
            }
            const propertyName = property.slice(0, colonIndex).trim();
            if (!ignoredProperties.has(propertyName)) filteredProperties.push(property);
        }
        return filteredProperties.join("; ") + (filteredProperties.length > 0 && cssText.endsWith(";") ? ";" : "");
    } catch (error) {
        console.warn("Error filtering CSS properties:", error);
        return cssText;
    }
}
function $4242ad5853add3e0$var$absoluteToStylesheet(cssText, href) {
    return (cssText || "").replace($4242ad5853add3e0$var$URL_IN_CSS_REF, (origin, quote1, path1, quote2, path2, path3)=>{
        const filePath = path1 || path2 || path3;
        const maybeQuote = quote1 || quote2 || "";
        if (!filePath) return origin;
        if ($4242ad5853add3e0$var$URL_PROTOCOL_MATCH.test(filePath) || $4242ad5853add3e0$var$URL_WWW_MATCH.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if ($4242ad5853add3e0$var$DATA_URI.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if (filePath[0] === "/") return `url(${maybeQuote}${$4242ad5853add3e0$var$extractOrigin(href) + filePath}${maybeQuote})`;
        const stack = href.split("/");
        const parts = filePath.split("/");
        stack.pop();
        for (const part of parts){
            if (part === ".") continue;
            else if (part === "..") stack.pop();
            else stack.push(part);
        }
        return `url(${maybeQuote}${stack.join("/")}${maybeQuote})`;
    });
}
const $4242ad5853add3e0$var$SRCSET_NOT_SPACES = /^[^ \t\n\r\u000c]+/;
const $4242ad5853add3e0$var$SRCSET_COMMAS_OR_SPACES = /^[, \t\n\r\u000c]+/;
function $4242ad5853add3e0$var$getAbsoluteSrcsetString(doc, attributeValue) {
    if (attributeValue.trim() === "") return attributeValue;
    let pos = 0;
    function collectCharacters(regEx) {
        let chars2;
        const match = regEx.exec(attributeValue.substring(pos));
        if (match) {
            chars2 = match[0];
            pos += chars2.length;
            return chars2;
        }
        return "";
    }
    const output = [];
    while(true){
        collectCharacters($4242ad5853add3e0$var$SRCSET_COMMAS_OR_SPACES);
        if (pos >= attributeValue.length) break;
        let url = collectCharacters($4242ad5853add3e0$var$SRCSET_NOT_SPACES);
        if (url.slice(-1) === ",") {
            url = $4242ad5853add3e0$var$absoluteToDoc(doc, url.substring(0, url.length - 1));
            output.push(url);
        } else {
            let descriptorsStr = "";
            url = $4242ad5853add3e0$var$absoluteToDoc(doc, url);
            let inParens = false;
            while(true){
                const c = attributeValue.charAt(pos);
                if (c === "") {
                    output.push((url + descriptorsStr).trim());
                    break;
                } else if (!inParens) {
                    if (c === ",") {
                        pos += 1;
                        output.push((url + descriptorsStr).trim());
                        break;
                    } else if (c === "(") inParens = true;
                } else if (c === ")") inParens = false;
                descriptorsStr += c;
                pos += 1;
            }
        }
    }
    return output.join(", ");
}
const $4242ad5853add3e0$var$cachedDocument = /* @__PURE__ */ new WeakMap();
function $4242ad5853add3e0$var$absoluteToDoc(doc, attributeValue) {
    if (!attributeValue || attributeValue.trim() === "") return attributeValue;
    return $4242ad5853add3e0$var$getHref(doc, attributeValue);
}
function $4242ad5853add3e0$var$isSVGElement(el) {
    return Boolean(el.tagName === "svg" || el.ownerSVGElement);
}
function $4242ad5853add3e0$var$getHref(doc, customHref) {
    let a = $4242ad5853add3e0$var$cachedDocument.get(doc);
    if (!a) {
        a = doc.createElement("a");
        $4242ad5853add3e0$var$cachedDocument.set(doc, a);
    }
    if (!customHref) customHref = "";
    else if (customHref.startsWith("blob:") || customHref.startsWith("data:")) return customHref;
    a.setAttribute("href", customHref);
    return a.href;
}
function $4242ad5853add3e0$var$transformAttribute(doc, tagName, name, value, element, maskAttributeFn, ignoreCSSAttributes) {
    if (!value) return value;
    if (name === "src" || name === "href" && !(tagName === "use" && value[0] === "#")) return $4242ad5853add3e0$var$absoluteToDoc(doc, value);
    else if (name === "xlink:href" && value[0] !== "#") return $4242ad5853add3e0$var$absoluteToDoc(doc, value);
    else if (name === "background" && (tagName === "table" || tagName === "td" || tagName === "th")) return $4242ad5853add3e0$var$absoluteToDoc(doc, value);
    else if (name === "srcset") return $4242ad5853add3e0$var$getAbsoluteSrcsetString(doc, value);
    else if (name === "style") {
        let processedStyle = $4242ad5853add3e0$var$absoluteToStylesheet(value, $4242ad5853add3e0$var$getHref(doc));
        if (ignoreCSSAttributes && ignoreCSSAttributes.size > 0) processedStyle = $4242ad5853add3e0$var$filterCSSPropertiesFromInlineStyle(processedStyle, ignoreCSSAttributes);
        return processedStyle;
    } else if (tagName === "object" && name === "data") return $4242ad5853add3e0$var$absoluteToDoc(doc, value);
    if (typeof maskAttributeFn === "function") return maskAttributeFn(name, value, element);
    return value;
}
function $4242ad5853add3e0$var$ignoreAttribute(tagName, name, _value) {
    return (tagName === "video" || tagName === "audio") && name === "autoplay";
}
function $4242ad5853add3e0$var$_isBlockedElement(element, blockClass, blockSelector, unblockSelector) {
    try {
        if (unblockSelector && element.matches(unblockSelector)) return false;
        if (typeof blockClass === "string") {
            if (element.classList.contains(blockClass)) return true;
        } else for(let eIndex = element.classList.length; eIndex--;){
            const className = element.classList[eIndex];
            if (blockClass.test(className)) return true;
        }
        if (blockSelector) return element.matches(blockSelector);
    } catch (e) {}
    return false;
}
function $4242ad5853add3e0$var$elementClassMatchesRegex(el, regex) {
    for(let eIndex = el.classList.length; eIndex--;){
        const className = el.classList[eIndex];
        if (regex.test(className)) return true;
    }
    return false;
}
function $4242ad5853add3e0$var$distanceToMatch(node, matchPredicate, limit = Infinity, distance = 0) {
    if (!node) return -1;
    if (node.nodeType !== node.ELEMENT_NODE) return -1;
    if (distance > limit) return -1;
    if (matchPredicate(node)) return distance;
    return $4242ad5853add3e0$var$distanceToMatch(node.parentNode, matchPredicate, limit, distance + 1);
}
function $4242ad5853add3e0$var$createMatchPredicate(className, selector) {
    return (node)=>{
        const el = node;
        if (el === null) return false;
        try {
            if (className) {
                if (typeof className === "string") {
                    if (el.matches(`.${className}`)) return true;
                } else if ($4242ad5853add3e0$var$elementClassMatchesRegex(el, className)) return true;
            }
            if (selector && el.matches(selector)) return true;
            return false;
        } catch  {
            return false;
        }
    };
}
function $4242ad5853add3e0$var$needMaskingText(node, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, maskAllText) {
    try {
        const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
        if (el === null) return false;
        if (el.tagName === "INPUT") {
            const autocomplete = el.getAttribute("autocomplete");
            const disallowedAutocompleteValues = [
                "current-password",
                "new-password",
                "cc-number",
                "cc-exp",
                "cc-exp-month",
                "cc-exp-year",
                "cc-csc"
            ];
            if (disallowedAutocompleteValues.includes(autocomplete)) return true;
        }
        let maskDistance = -1;
        let unmaskDistance = -1;
        if (maskAllText) {
            unmaskDistance = $4242ad5853add3e0$var$distanceToMatch(el, $4242ad5853add3e0$var$createMatchPredicate(unmaskTextClass, unmaskTextSelector));
            if (unmaskDistance < 0) return true;
            maskDistance = $4242ad5853add3e0$var$distanceToMatch(el, $4242ad5853add3e0$var$createMatchPredicate(maskTextClass, maskTextSelector), unmaskDistance >= 0 ? unmaskDistance : Infinity);
        } else {
            maskDistance = $4242ad5853add3e0$var$distanceToMatch(el, $4242ad5853add3e0$var$createMatchPredicate(maskTextClass, maskTextSelector));
            if (maskDistance < 0) return false;
            unmaskDistance = $4242ad5853add3e0$var$distanceToMatch(el, $4242ad5853add3e0$var$createMatchPredicate(unmaskTextClass, unmaskTextSelector), maskDistance >= 0 ? maskDistance : Infinity);
        }
        return maskDistance >= 0 ? unmaskDistance >= 0 ? maskDistance <= unmaskDistance : true : unmaskDistance >= 0 ? false : !!maskAllText;
    } catch (e) {}
    return !!maskAllText;
}
function $4242ad5853add3e0$var$onceIframeLoaded(iframeEl, listener, iframeLoadTimeout) {
    const win = $4242ad5853add3e0$var$getIFrameContentWindow$1(iframeEl);
    if (!win) return;
    let fired = false;
    let readyState;
    try {
        readyState = win.document.readyState;
    } catch (error) {
        return;
    }
    if (readyState !== "complete") {
        const timer = $4242ad5853add3e0$var$setTimeout$1(()=>{
            if (!fired) {
                listener();
                fired = true;
            }
        }, iframeLoadTimeout);
        iframeEl.addEventListener("load", ()=>{
            $4242ad5853add3e0$var$clearTimeout$1(timer);
            fired = true;
            listener();
        });
        return;
    }
    const blankUrl = "about:blank";
    if (win.location.href !== blankUrl || iframeEl.src === blankUrl || iframeEl.src === "") {
        $4242ad5853add3e0$var$setTimeout$1(listener, 0);
        return iframeEl.addEventListener("load", listener);
    }
    iframeEl.addEventListener("load", listener);
}
function $4242ad5853add3e0$var$onceStylesheetLoaded(link, listener, styleSheetLoadTimeout) {
    let fired = false;
    let styleSheetLoaded;
    try {
        styleSheetLoaded = link.sheet;
    } catch (error) {
        styleSheetLoaded = null;
    }
    if (styleSheetLoaded) return;
    const timer = $4242ad5853add3e0$var$setTimeout$1(()=>{
        if (!fired) {
            listener();
            fired = true;
        }
    }, styleSheetLoadTimeout);
    link.addEventListener("load", ()=>{
        $4242ad5853add3e0$var$clearTimeout$1(timer);
        fired = true;
        listener();
    });
}
function $4242ad5853add3e0$var$serializeNode(n, options) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, maskAllText: maskAllText, maskAttributeFn: maskAttributeFn, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, inlineStylesheet: inlineStylesheet, maskInputOptions: maskInputOptions = {}, maskTextFn: maskTextFn, maskInputFn: maskInputFn, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages, recordCanvas: recordCanvas, keepIframeSrcFn: keepIframeSrcFn, newlyAddedElement: newlyAddedElement = false, ignoreCSSAttributes: ignoreCSSAttributes } = options;
    const rootId = $4242ad5853add3e0$var$getRootId(doc, mirror);
    switch(n.nodeType){
        case n.DOCUMENT_NODE:
            if (n.compatMode !== "CSS1Compat") return {
                type: $4242ad5853add3e0$var$NodeType$1.Document,
                childNodes: [],
                compatMode: n.compatMode
            };
            else return {
                type: $4242ad5853add3e0$var$NodeType$1.Document,
                childNodes: []
            };
        case n.DOCUMENT_TYPE_NODE:
            return {
                type: $4242ad5853add3e0$var$NodeType$1.DocumentType,
                name: n.name,
                publicId: n.publicId,
                systemId: n.systemId,
                rootId: rootId
            };
        case n.ELEMENT_NODE:
            return $4242ad5853add3e0$var$serializeElementNode(n, {
                doc: doc,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                inlineStylesheet: inlineStylesheet,
                maskAttributeFn: maskAttributeFn,
                maskInputOptions: maskInputOptions,
                maskInputFn: maskInputFn,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                keepIframeSrcFn: keepIframeSrcFn,
                newlyAddedElement: newlyAddedElement,
                rootId: rootId,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                ignoreCSSAttributes: ignoreCSSAttributes
            });
        case n.TEXT_NODE:
            return $4242ad5853add3e0$var$serializeTextNode(n, {
                doc: doc,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                maskTextFn: maskTextFn,
                maskInputOptions: maskInputOptions,
                maskInputFn: maskInputFn,
                rootId: rootId
            });
        case n.CDATA_SECTION_NODE:
            return {
                type: $4242ad5853add3e0$var$NodeType$1.CDATA,
                textContent: "",
                rootId: rootId
            };
        case n.COMMENT_NODE:
            return {
                type: $4242ad5853add3e0$var$NodeType$1.Comment,
                textContent: n.textContent || "",
                rootId: rootId
            };
        default:
            return false;
    }
}
function $4242ad5853add3e0$var$getRootId(doc, mirror) {
    if (!mirror.hasNode(doc)) return void 0;
    const docId = mirror.getId(doc);
    return docId === 1 ? void 0 : docId;
}
function $4242ad5853add3e0$var$serializeTextNode(n, options) {
    const { maskAllText: maskAllText, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, maskTextFn: maskTextFn, maskInputOptions: maskInputOptions, maskInputFn: maskInputFn, rootId: rootId } = options;
    const parentTagName = n.parentNode && n.parentNode.tagName;
    let textContent = n.textContent;
    const isStyle = parentTagName === "STYLE" ? true : void 0;
    const isScript = parentTagName === "SCRIPT" ? true : void 0;
    const isTextarea = parentTagName === "TEXTAREA" ? true : void 0;
    if (isStyle && textContent) {
        try {
            if (n.nextSibling || n.previousSibling) ;
            else if (n.parentNode.sheet?.cssRules) textContent = $4242ad5853add3e0$var$stringifyStylesheet(n.parentNode.sheet);
        } catch (err) {
            console.warn(`Cannot get CSS styles from text's parentNode. Error: ${err}`, n);
        }
        textContent = $4242ad5853add3e0$var$absoluteToStylesheet(textContent, $4242ad5853add3e0$var$getHref(options.doc));
    }
    if (isScript) textContent = "SCRIPT_PLACEHOLDER";
    const forceMask = $4242ad5853add3e0$var$needMaskingText(n, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, maskAllText);
    if (!isStyle && !isScript && !isTextarea && textContent && forceMask) textContent = maskTextFn ? maskTextFn(textContent, n.parentElement) : textContent.replace(/[\S]/g, "*");
    if (isTextarea && textContent && (maskInputOptions.textarea || forceMask)) textContent = maskInputFn ? maskInputFn(textContent, n.parentNode) : textContent.replace(/[\S]/g, "*");
    if (parentTagName === "OPTION" && textContent) {
        const isInputMasked = $4242ad5853add3e0$var$shouldMaskInput({
            type: null,
            tagName: parentTagName,
            maskInputOptions: maskInputOptions
        });
        textContent = $4242ad5853add3e0$var$maskInputValue({
            isMasked: $4242ad5853add3e0$var$needMaskingText(n, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, isInputMasked),
            element: n,
            value: textContent,
            maskInputFn: maskInputFn
        });
    }
    return {
        type: $4242ad5853add3e0$var$NodeType$1.Text,
        textContent: textContent || "",
        isStyle: isStyle,
        rootId: rootId
    };
}
function $4242ad5853add3e0$var$serializeElementNode(n, options) {
    const { doc: doc, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, inlineStylesheet: inlineStylesheet, maskInputOptions: maskInputOptions = {}, maskAttributeFn: maskAttributeFn, maskInputFn: maskInputFn, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages, recordCanvas: recordCanvas, keepIframeSrcFn: keepIframeSrcFn, newlyAddedElement: newlyAddedElement = false, rootId: rootId, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, ignoreCSSAttributes: ignoreCSSAttributes } = options;
    const needBlock = $4242ad5853add3e0$var$_isBlockedElement(n, blockClass, blockSelector, unblockSelector);
    const tagName = $4242ad5853add3e0$var$getValidTagName(n);
    let attributes2 = {};
    const len = n.attributes.length;
    for(let i = 0; i < len; i++){
        const attr = n.attributes[i];
        if (attr.name && !$4242ad5853add3e0$var$ignoreAttribute(tagName, attr.name, attr.value)) attributes2[attr.name] = $4242ad5853add3e0$var$transformAttribute(doc, tagName, $4242ad5853add3e0$var$toLowerCase(attr.name), attr.value, n, maskAttributeFn, ignoreCSSAttributes);
    }
    if (tagName === "link" && inlineStylesheet) {
        const stylesheet = Array.from(doc.styleSheets).find((s)=>{
            return s.href === n.href;
        });
        let cssText = null;
        if (stylesheet) cssText = $4242ad5853add3e0$var$stringifyStylesheet(stylesheet);
        if (cssText) {
            attributes2.rel = null;
            attributes2.href = null;
            attributes2.crossorigin = null;
            attributes2._cssText = $4242ad5853add3e0$var$absoluteToStylesheet(cssText, stylesheet.href);
        }
    }
    if (tagName === "style" && n.sheet && // TODO: Currently we only try to get dynamic stylesheet when it is an empty style element
    !(n.innerText || n.textContent || "").trim().length) {
        const cssText = $4242ad5853add3e0$var$stringifyStylesheet(n.sheet);
        if (cssText) attributes2._cssText = $4242ad5853add3e0$var$absoluteToStylesheet(cssText, $4242ad5853add3e0$var$getHref(doc));
    }
    if (tagName === "input" || tagName === "textarea" || tagName === "select" || tagName === "option") {
        const el = n;
        const type = $4242ad5853add3e0$var$getInputType(el);
        const value = $4242ad5853add3e0$var$getInputValue(el, $4242ad5853add3e0$var$toUpperCase(tagName), type);
        const checked = el.checked;
        if (type !== "submit" && type !== "button" && value) {
            const forceMask = $4242ad5853add3e0$var$needMaskingText(el, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, $4242ad5853add3e0$var$shouldMaskInput({
                type: type,
                tagName: $4242ad5853add3e0$var$toUpperCase(tagName),
                maskInputOptions: maskInputOptions
            }));
            attributes2.value = $4242ad5853add3e0$var$maskInputValue({
                isMasked: forceMask,
                element: el,
                value: value,
                maskInputFn: maskInputFn
            });
        }
        if (checked) attributes2.checked = checked;
    }
    if (tagName === "option") {
        if (n.selected && !maskInputOptions["select"]) attributes2.selected = true;
        else delete attributes2.selected;
    }
    if (tagName === "canvas" && recordCanvas) {
        if (n.__context === "2d") {
            if (!$4242ad5853add3e0$var$is2DCanvasBlank(n)) attributes2.rr_dataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
        } else if (!("__context" in n)) {
            const canvasDataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            const blankCanvas = doc.createElement("canvas");
            blankCanvas.width = n.width;
            blankCanvas.height = n.height;
            const blankCanvasDataURL = blankCanvas.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            if (canvasDataURL !== blankCanvasDataURL) attributes2.rr_dataURL = canvasDataURL;
        }
    }
    if (tagName === "img" && inlineImages) {
        if (!$4242ad5853add3e0$var$canvasService) {
            $4242ad5853add3e0$var$canvasService = doc.createElement("canvas");
            $4242ad5853add3e0$var$canvasCtx = $4242ad5853add3e0$var$canvasService.getContext("2d");
        }
        const image = n;
        const imageSrc = image.currentSrc || image.getAttribute("src") || "<unknown-src>";
        const priorCrossOrigin = image.crossOrigin;
        const recordInlineImage = ()=>{
            image.removeEventListener("load", recordInlineImage);
            try {
                $4242ad5853add3e0$var$canvasService.width = image.naturalWidth;
                $4242ad5853add3e0$var$canvasService.height = image.naturalHeight;
                $4242ad5853add3e0$var$canvasCtx.drawImage(image, 0, 0);
                attributes2.rr_dataURL = $4242ad5853add3e0$var$canvasService.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            } catch (err) {
                if (image.crossOrigin !== "anonymous") {
                    image.crossOrigin = "anonymous";
                    if (image.complete && image.naturalWidth !== 0) recordInlineImage();
                    else image.addEventListener("load", recordInlineImage);
                    return;
                } else console.warn(`Cannot inline img src=${imageSrc}! Error: ${err}`);
            }
            if (image.crossOrigin === "anonymous") priorCrossOrigin ? attributes2.crossOrigin = priorCrossOrigin : image.removeAttribute("crossorigin");
        };
        if (image.complete && image.naturalWidth !== 0) recordInlineImage();
        else image.addEventListener("load", recordInlineImage);
    }
    if (tagName === "audio" || tagName === "video") {
        attributes2.rr_mediaState = n.paused ? "paused" : "played";
        attributes2.rr_mediaCurrentTime = n.currentTime;
    }
    if (!newlyAddedElement) {
        if (n.scrollLeft) attributes2.rr_scrollLeft = n.scrollLeft;
        if (n.scrollTop) attributes2.rr_scrollTop = n.scrollTop;
    }
    if (needBlock) {
        const { width: width, height: height } = n.getBoundingClientRect();
        attributes2 = {
            class: attributes2.class,
            rr_width: `${width}px`,
            rr_height: `${height}px`
        };
    }
    if (tagName === "iframe" && !keepIframeSrcFn(attributes2.src)) {
        if (!needBlock && !$4242ad5853add3e0$var$getIFrameContentDocument$1(n)) attributes2.rr_src = attributes2.src;
        delete attributes2.src;
    }
    let isCustomElement;
    try {
        if (customElements.get(tagName)) isCustomElement = true;
    } catch (e) {}
    return {
        type: $4242ad5853add3e0$var$NodeType$1.Element,
        tagName: tagName,
        attributes: attributes2,
        childNodes: [],
        isSVG: $4242ad5853add3e0$var$isSVGElement(n) || void 0,
        needBlock: needBlock,
        rootId: rootId,
        isCustom: isCustomElement
    };
}
function $4242ad5853add3e0$var$lowerIfExists(maybeAttr) {
    if (maybeAttr === void 0 || maybeAttr === null) return "";
    else return maybeAttr.toLowerCase();
}
function $4242ad5853add3e0$var$slimDOMExcluded(sn, slimDOMOptions) {
    if (slimDOMOptions.comment && sn.type === $4242ad5853add3e0$var$NodeType$1.Comment) return true;
    else if (sn.type === $4242ad5853add3e0$var$NodeType$1.Element) {
        if (slimDOMOptions.script && // script tag
        (sn.tagName === "script" || // (module)preload link
        sn.tagName === "link" && (sn.attributes.rel === "preload" || sn.attributes.rel === "modulepreload") || // prefetch link
        sn.tagName === "link" && sn.attributes.rel === "prefetch" && typeof sn.attributes.href === "string" && $4242ad5853add3e0$var$extractFileExtension(sn.attributes.href) === "js")) return true;
        else if (slimDOMOptions.headFavicon && (sn.tagName === "link" && sn.attributes.rel === "shortcut icon" || sn.tagName === "meta" && ($4242ad5853add3e0$var$lowerIfExists(sn.attributes.name).match(/^msapplication-tile(image|color)$/) || $4242ad5853add3e0$var$lowerIfExists(sn.attributes.name) === "application-name" || $4242ad5853add3e0$var$lowerIfExists(sn.attributes.rel) === "icon" || $4242ad5853add3e0$var$lowerIfExists(sn.attributes.rel) === "apple-touch-icon" || $4242ad5853add3e0$var$lowerIfExists(sn.attributes.rel) === "shortcut icon"))) return true;
        else if (sn.tagName === "meta") {
            if (slimDOMOptions.headMetaDescKeywords && $4242ad5853add3e0$var$lowerIfExists(sn.attributes.name).match(/^description|keywords$/)) return true;
            else if (slimDOMOptions.headMetaSocial && ($4242ad5853add3e0$var$lowerIfExists(sn.attributes.property).match(/^(og|twitter|fb):/) || // og = opengraph (facebook)
            $4242ad5853add3e0$var$lowerIfExists(sn.attributes.name).match(/^(og|twitter):/) || $4242ad5853add3e0$var$lowerIfExists(sn.attributes.name) === "pinterest")) return true;
            else if (slimDOMOptions.headMetaRobots && ($4242ad5853add3e0$var$lowerIfExists(sn.attributes.name) === "robots" || $4242ad5853add3e0$var$lowerIfExists(sn.attributes.name) === "googlebot" || $4242ad5853add3e0$var$lowerIfExists(sn.attributes.name) === "bingbot")) return true;
            else if (slimDOMOptions.headMetaHttpEquiv && sn.attributes["http-equiv"] !== void 0) return true;
            else if (slimDOMOptions.headMetaAuthorship && ($4242ad5853add3e0$var$lowerIfExists(sn.attributes.name) === "author" || $4242ad5853add3e0$var$lowerIfExists(sn.attributes.name) === "generator" || $4242ad5853add3e0$var$lowerIfExists(sn.attributes.name) === "framework" || $4242ad5853add3e0$var$lowerIfExists(sn.attributes.name) === "publisher" || $4242ad5853add3e0$var$lowerIfExists(sn.attributes.name) === "progid" || $4242ad5853add3e0$var$lowerIfExists(sn.attributes.property).match(/^article:/) || $4242ad5853add3e0$var$lowerIfExists(sn.attributes.property).match(/^product:/))) return true;
            else if (slimDOMOptions.headMetaVerification && ($4242ad5853add3e0$var$lowerIfExists(sn.attributes.name) === "google-site-verification" || $4242ad5853add3e0$var$lowerIfExists(sn.attributes.name) === "yandex-verification" || $4242ad5853add3e0$var$lowerIfExists(sn.attributes.name) === "csrf-token" || $4242ad5853add3e0$var$lowerIfExists(sn.attributes.name) === "p:domain_verify" || $4242ad5853add3e0$var$lowerIfExists(sn.attributes.name) === "verify-v1" || $4242ad5853add3e0$var$lowerIfExists(sn.attributes.name) === "verification" || $4242ad5853add3e0$var$lowerIfExists(sn.attributes.name) === "shopify-checkout-api-token")) return true;
        }
    }
    return false;
}
function $4242ad5853add3e0$var$serializeNodeWithId(n, options) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, maskAllText: maskAllText, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, skipChild: skipChild = false, inlineStylesheet: inlineStylesheet = true, maskInputOptions: maskInputOptions = {}, maskAttributeFn: maskAttributeFn, maskTextFn: maskTextFn, maskInputFn: maskInputFn, slimDOMOptions: slimDOMOptions, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages = false, recordCanvas: recordCanvas = false, onSerialize: onSerialize, onIframeLoad: onIframeLoad, iframeLoadTimeout: iframeLoadTimeout = 5e3, onBlockedImageLoad: onBlockedImageLoad, onStylesheetLoad: onStylesheetLoad, stylesheetLoadTimeout: stylesheetLoadTimeout = 5e3, keepIframeSrcFn: keepIframeSrcFn = ()=>false, newlyAddedElement: newlyAddedElement = false, ignoreCSSAttributes: ignoreCSSAttributes } = options;
    let { preserveWhiteSpace: preserveWhiteSpace = true } = options;
    const _serializedNode = $4242ad5853add3e0$var$serializeNode(n, {
        doc: doc,
        mirror: mirror,
        blockClass: blockClass,
        blockSelector: blockSelector,
        maskAllText: maskAllText,
        unblockSelector: unblockSelector,
        maskTextClass: maskTextClass,
        unmaskTextClass: unmaskTextClass,
        maskTextSelector: maskTextSelector,
        unmaskTextSelector: unmaskTextSelector,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskAttributeFn: maskAttributeFn,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: newlyAddedElement,
        ignoreCSSAttributes: ignoreCSSAttributes
    });
    if (!_serializedNode) {
        console.warn(n, "not serialized");
        return null;
    }
    let id;
    if (mirror.hasNode(n)) id = mirror.getId(n);
    else if ($4242ad5853add3e0$var$slimDOMExcluded(_serializedNode, slimDOMOptions) || !preserveWhiteSpace && _serializedNode.type === $4242ad5853add3e0$var$NodeType$1.Text && !_serializedNode.isStyle && !_serializedNode.textContent.trim().length) id = $4242ad5853add3e0$var$IGNORED_NODE;
    else id = $4242ad5853add3e0$var$genId();
    const serializedNode2 = Object.assign(_serializedNode, {
        id: id
    });
    mirror.add(n, serializedNode2);
    if (id === $4242ad5853add3e0$var$IGNORED_NODE) return null;
    if (onSerialize) onSerialize(n);
    let recordChild = !skipChild;
    if (serializedNode2.type === $4242ad5853add3e0$var$NodeType$1.Element) {
        recordChild = recordChild && !serializedNode2.needBlock;
        const shadowRoot = n.shadowRoot;
        if (shadowRoot && $4242ad5853add3e0$var$isNativeShadowDom(shadowRoot)) serializedNode2.isShadowHost = true;
    }
    if ((serializedNode2.type === $4242ad5853add3e0$var$NodeType$1.Document || serializedNode2.type === $4242ad5853add3e0$var$NodeType$1.Element) && recordChild) {
        if (slimDOMOptions.headWhitespace && serializedNode2.type === $4242ad5853add3e0$var$NodeType$1.Element && serializedNode2.tagName === "head") preserveWhiteSpace = false;
        const bypassOptions = {
            doc: doc,
            mirror: mirror,
            blockClass: blockClass,
            blockSelector: blockSelector,
            maskAllText: maskAllText,
            unblockSelector: unblockSelector,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            skipChild: skipChild,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            maskAttributeFn: maskAttributeFn,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            slimDOMOptions: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            inlineImages: inlineImages,
            recordCanvas: recordCanvas,
            preserveWhiteSpace: preserveWhiteSpace,
            onSerialize: onSerialize,
            onIframeLoad: onIframeLoad,
            iframeLoadTimeout: iframeLoadTimeout,
            onBlockedImageLoad: onBlockedImageLoad,
            onStylesheetLoad: onStylesheetLoad,
            stylesheetLoadTimeout: stylesheetLoadTimeout,
            keepIframeSrcFn: keepIframeSrcFn,
            ignoreCSSAttributes: ignoreCSSAttributes
        };
        const childNodes = n.childNodes ? Array.from(n.childNodes) : [];
        for (const childN of childNodes){
            const serializedChildNode = $4242ad5853add3e0$var$serializeNodeWithId(childN, bypassOptions);
            if (serializedChildNode) serializedNode2.childNodes.push(serializedChildNode);
        }
        if ($4242ad5853add3e0$var$isElement$1(n) && n.shadowRoot) for (const childN of Array.from(n.shadowRoot.childNodes)){
            const serializedChildNode = $4242ad5853add3e0$var$serializeNodeWithId(childN, bypassOptions);
            if (serializedChildNode) {
                $4242ad5853add3e0$var$isNativeShadowDom(n.shadowRoot) && (serializedChildNode.isShadow = true);
                serializedNode2.childNodes.push(serializedChildNode);
            }
        }
    }
    if (n.parentNode && $4242ad5853add3e0$var$isShadowRoot(n.parentNode) && $4242ad5853add3e0$var$isNativeShadowDom(n.parentNode)) serializedNode2.isShadow = true;
    if (serializedNode2.type === $4242ad5853add3e0$var$NodeType$1.Element && serializedNode2.tagName === "iframe" && !serializedNode2.needBlock) $4242ad5853add3e0$var$onceIframeLoaded(n, ()=>{
        const iframeDoc = $4242ad5853add3e0$var$getIFrameContentDocument$1(n);
        if (iframeDoc && onIframeLoad) {
            const serializedIframeNode = $4242ad5853add3e0$var$serializeNodeWithId(iframeDoc, {
                doc: iframeDoc,
                mirror: mirror,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskAttributeFn: maskAttributeFn,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn,
                ignoreCSSAttributes: ignoreCSSAttributes
            });
            if (serializedIframeNode) onIframeLoad(n, serializedIframeNode);
        }
    }, iframeLoadTimeout);
    if (serializedNode2.type === $4242ad5853add3e0$var$NodeType$1.Element && serializedNode2.tagName === "img" && !n.complete && serializedNode2.needBlock) {
        const image = n;
        const updateImageDimensions = ()=>{
            if (image.isConnected && !image.complete && onBlockedImageLoad) try {
                const rect = image.getBoundingClientRect();
                if (rect.width > 0 && rect.height > 0) onBlockedImageLoad(image, serializedNode2, rect);
            } catch (error) {}
            image.removeEventListener("load", updateImageDimensions);
        };
        if (image.isConnected) image.addEventListener("load", updateImageDimensions);
    }
    if (serializedNode2.type === $4242ad5853add3e0$var$NodeType$1.Element && serializedNode2.tagName === "link" && typeof serializedNode2.attributes.rel === "string" && (serializedNode2.attributes.rel === "stylesheet" || serializedNode2.attributes.rel === "preload" && typeof serializedNode2.attributes.href === "string" && $4242ad5853add3e0$var$extractFileExtension(serializedNode2.attributes.href) === "css")) $4242ad5853add3e0$var$onceStylesheetLoaded(n, ()=>{
        if (onStylesheetLoad) {
            const serializedLinkNode = $4242ad5853add3e0$var$serializeNodeWithId(n, {
                doc: doc,
                mirror: mirror,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskAttributeFn: maskAttributeFn,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn,
                ignoreCSSAttributes: ignoreCSSAttributes
            });
            if (serializedLinkNode) onStylesheetLoad(n, serializedLinkNode);
        }
    }, stylesheetLoadTimeout);
    if (serializedNode2.type === $4242ad5853add3e0$var$NodeType$1.Element) delete serializedNode2.needBlock;
    return serializedNode2;
}
function $4242ad5853add3e0$var$snapshot(n, options) {
    const { mirror: mirror = new $4242ad5853add3e0$var$Mirror(), blockClass: blockClass = "rr-block", blockSelector: blockSelector = null, unblockSelector: unblockSelector = null, maskAllText: maskAllText = false, maskTextClass: maskTextClass = "rr-mask", unmaskTextClass: unmaskTextClass = null, maskTextSelector: maskTextSelector = null, unmaskTextSelector: unmaskTextSelector = null, inlineStylesheet: inlineStylesheet = true, inlineImages: inlineImages = false, recordCanvas: recordCanvas = false, maskAllInputs: maskAllInputs = false, maskAttributeFn: maskAttributeFn, maskTextFn: maskTextFn, maskInputFn: maskInputFn, slimDOM: slimDOM = false, dataURLOptions: dataURLOptions, preserveWhiteSpace: preserveWhiteSpace, onSerialize: onSerialize, onIframeLoad: onIframeLoad, iframeLoadTimeout: iframeLoadTimeout, onBlockedImageLoad: onBlockedImageLoad, onStylesheetLoad: onStylesheetLoad, stylesheetLoadTimeout: stylesheetLoadTimeout, keepIframeSrcFn: keepIframeSrcFn = ()=>false, ignoreCSSAttributes: ignoreCSSAttributes = /* @__PURE__ */ new Set([]) } = options || {};
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true
    } : maskAllInputs === false ? {} : maskAllInputs;
    const slimDOMOptions = slimDOM === true || slimDOM === "all" ? // if true: set of sensible options that should not throw away any information
    {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaDescKeywords: slimDOM === "all",
        // destructive
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaAuthorship: true,
        headMetaVerification: true
    } : slimDOM === false ? {} : slimDOM;
    return $4242ad5853add3e0$var$serializeNodeWithId(n, {
        doc: n,
        mirror: mirror,
        blockClass: blockClass,
        blockSelector: blockSelector,
        unblockSelector: unblockSelector,
        maskAllText: maskAllText,
        maskTextClass: maskTextClass,
        unmaskTextClass: unmaskTextClass,
        maskTextSelector: maskTextSelector,
        unmaskTextSelector: unmaskTextSelector,
        skipChild: false,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskAttributeFn: maskAttributeFn,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        slimDOMOptions: slimDOMOptions,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        preserveWhiteSpace: preserveWhiteSpace,
        onSerialize: onSerialize,
        onIframeLoad: onIframeLoad,
        iframeLoadTimeout: iframeLoadTimeout,
        onBlockedImageLoad: onBlockedImageLoad,
        onStylesheetLoad: onStylesheetLoad,
        stylesheetLoadTimeout: stylesheetLoadTimeout,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: false,
        ignoreCSSAttributes: ignoreCSSAttributes
    });
}
function $4242ad5853add3e0$var$on(type, fn, target = document) {
    const options = {
        capture: true,
        passive: true
    };
    target.addEventListener(type, fn, options);
    return ()=>target.removeEventListener(type, fn, options);
}
const $4242ad5853add3e0$var$DEPARTED_MIRROR_ACCESS_WARNING = "Please stop import mirror directly. Instead of that,\r\nnow you can use replayer.getMirror() to access the mirror instance of a replayer,\r\nor you can use record.mirror to access the mirror instance during recording.";
let $4242ad5853add3e0$var$_mirror = {
    map: {},
    getId () {
        console.error($4242ad5853add3e0$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return -1;
    },
    getNode () {
        console.error($4242ad5853add3e0$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return null;
    },
    removeNodeFromMap () {
        console.error($4242ad5853add3e0$var$DEPARTED_MIRROR_ACCESS_WARNING);
    },
    has () {
        console.error($4242ad5853add3e0$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return false;
    },
    reset () {
        console.error($4242ad5853add3e0$var$DEPARTED_MIRROR_ACCESS_WARNING);
    }
};
if (typeof window !== "undefined" && window.Proxy && window.Reflect) $4242ad5853add3e0$var$_mirror = new Proxy($4242ad5853add3e0$var$_mirror, {
    get (target, prop, receiver) {
        if (prop === "map") console.error($4242ad5853add3e0$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return Reflect.get(target, prop, receiver);
    }
});
function $4242ad5853add3e0$var$throttle$1(func, wait, options = {}) {
    let timeout = null;
    let previous = 0;
    return function(...args) {
        const now = Date.now();
        if (!previous && options.leading === false) previous = now;
        const remaining = wait - (now - previous);
        const context = this;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                $4242ad5853add3e0$var$clearTimeout$2(timeout);
                timeout = null;
            }
            previous = now;
            func.apply(context, args);
        } else if (!timeout && options.trailing !== false) timeout = $4242ad5853add3e0$var$setTimeout$2(()=>{
            previous = options.leading === false ? 0 : Date.now();
            timeout = null;
            func.apply(context, args);
        }, remaining);
    };
}
function $4242ad5853add3e0$var$hookSetter(target, key, d, isRevoked, win = window) {
    const original = win.Object.getOwnPropertyDescriptor(target, key);
    win.Object.defineProperty(target, key, isRevoked ? d : {
        set (value) {
            $4242ad5853add3e0$var$setTimeout$2(()=>{
                d.set.call(this, value);
            }, 0);
            if (original && original.set) original.set.call(this, value);
        }
    });
    return ()=>$4242ad5853add3e0$var$hookSetter(target, key, original || {}, true);
}
function $4242ad5853add3e0$var$patch(source, name, replacement) {
    try {
        if (!(name in source)) return ()=>{};
        const original = source[name];
        const wrapped = replacement(original);
        if (typeof wrapped === "function") {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __rrweb_original__: {
                    enumerable: false,
                    value: original
                }
            });
        }
        source[name] = wrapped;
        return ()=>{
            source[name] = original;
        };
    } catch  {
        return ()=>{};
    }
}
let $4242ad5853add3e0$var$nowTimestamp = Date.now;
if (!/* @__PURE__ */ /[1-9][0-9]{12}/.test(Date.now().toString())) $4242ad5853add3e0$var$nowTimestamp = ()=>/* @__PURE__ */ new Date().getTime();
function $4242ad5853add3e0$var$getWindowScroll(win) {
    const doc = win.document;
    return {
        left: doc.scrollingElement ? doc.scrollingElement.scrollLeft : win.pageXOffset !== void 0 ? win.pageXOffset : doc?.documentElement.scrollLeft || doc?.body?.parentElement?.scrollLeft || doc?.body?.scrollLeft || 0,
        top: doc.scrollingElement ? doc.scrollingElement.scrollTop : win.pageYOffset !== void 0 ? win.pageYOffset : doc?.documentElement.scrollTop || doc?.body?.parentElement?.scrollTop || doc?.body?.scrollTop || 0
    };
}
function $4242ad5853add3e0$var$getWindowHeight() {
    return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
}
function $4242ad5853add3e0$var$getWindowWidth() {
    return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
}
function $4242ad5853add3e0$var$closestElementOfNode$1(node) {
    if (!node) return null;
    try {
        const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
        return el;
    } catch (error) {
        return null;
    }
}
function $4242ad5853add3e0$var$isBlocked(node, blockClass, blockSelector, unblockSelector, checkAncestors) {
    if (!node) return false;
    const el = $4242ad5853add3e0$var$closestElementOfNode$1(node);
    if (!el) return false;
    const blockedPredicate = $4242ad5853add3e0$var$createMatchPredicate(blockClass, blockSelector);
    if (!checkAncestors) {
        const isUnblocked = unblockSelector && el.matches(unblockSelector);
        return blockedPredicate(el) && !isUnblocked;
    }
    const blockDistance = $4242ad5853add3e0$var$distanceToMatch(el, blockedPredicate);
    let unblockDistance = -1;
    if (blockDistance < 0) return false;
    if (unblockSelector) unblockDistance = $4242ad5853add3e0$var$distanceToMatch(el, $4242ad5853add3e0$var$createMatchPredicate(null, unblockSelector));
    if (blockDistance > -1 && unblockDistance < 0) return true;
    return blockDistance < unblockDistance;
}
function $4242ad5853add3e0$var$isSerialized(n, mirror) {
    return mirror.getId(n) !== -1;
}
function $4242ad5853add3e0$var$isIgnored(n, mirror) {
    return mirror.getId(n) === $4242ad5853add3e0$var$IGNORED_NODE;
}
function $4242ad5853add3e0$var$isAncestorRemoved(target, mirror) {
    if ($4242ad5853add3e0$var$isShadowRoot(target)) return false;
    const id = mirror.getId(target);
    if (!mirror.has(id)) return true;
    if (target.parentNode && target.parentNode.nodeType === target.DOCUMENT_NODE) return false;
    if (!target.parentNode) return true;
    return $4242ad5853add3e0$var$isAncestorRemoved(target.parentNode, mirror);
}
function $4242ad5853add3e0$var$legacy_isTouchEvent(event) {
    return Boolean(event.changedTouches);
}
function $4242ad5853add3e0$var$polyfill(win = window) {
    if ("NodeList" in win && !win.NodeList.prototype.forEach) win.NodeList.prototype.forEach = Array.prototype.forEach;
    if ("DOMTokenList" in win && !win.DOMTokenList.prototype.forEach) win.DOMTokenList.prototype.forEach = Array.prototype.forEach;
    if (!Node.prototype.contains) Node.prototype.contains = (...args)=>{
        let node = args[0];
        if (!(0 in args)) throw new TypeError("1 argument is required");
        do {
            if (this === node) return true;
        }while (node = node && node.parentNode);
        return false;
    };
}
function $4242ad5853add3e0$var$isSerializedIframe(n, mirror) {
    return Boolean(n.nodeName === "IFRAME" && mirror.getMeta(n));
}
function $4242ad5853add3e0$var$isSerializedStylesheet(n, mirror) {
    return Boolean(n.nodeName === "LINK" && n.nodeType === n.ELEMENT_NODE && n.getAttribute && n.getAttribute("rel") === "stylesheet" && mirror.getMeta(n));
}
function $4242ad5853add3e0$var$hasShadowRoot(n) {
    return Boolean(n?.shadowRoot);
}
class $4242ad5853add3e0$var$StyleSheetMirror {
    constructor(){
        this.id = 1;
        this.styleIDMap = /* @__PURE__ */ new WeakMap();
        this.idStyleMap = /* @__PURE__ */ new Map();
    }
    getId(stylesheet) {
        return this.styleIDMap.get(stylesheet) ?? -1;
    }
    has(stylesheet) {
        return this.styleIDMap.has(stylesheet);
    }
    /**
   * @returns If the stylesheet is in the mirror, returns the id of the stylesheet. If not, return the new assigned id.
   */ add(stylesheet, id) {
        if (this.has(stylesheet)) return this.getId(stylesheet);
        let newId;
        if (id === void 0) newId = this.id++;
        else newId = id;
        this.styleIDMap.set(stylesheet, newId);
        this.idStyleMap.set(newId, stylesheet);
        return newId;
    }
    getStyle(id) {
        return this.idStyleMap.get(id) || null;
    }
    reset() {
        this.styleIDMap = /* @__PURE__ */ new WeakMap();
        this.idStyleMap = /* @__PURE__ */ new Map();
        this.id = 1;
    }
    generateId() {
        return this.id++;
    }
}
function $4242ad5853add3e0$var$getShadowHost(n) {
    let shadowHost = null;
    if (n.getRootNode?.()?.nodeType === Node.DOCUMENT_FRAGMENT_NODE && n.getRootNode().host) shadowHost = n.getRootNode().host;
    return shadowHost;
}
function $4242ad5853add3e0$var$getRootShadowHost(n) {
    let rootShadowHost = n;
    let shadowHost;
    while(shadowHost = $4242ad5853add3e0$var$getShadowHost(rootShadowHost))rootShadowHost = shadowHost;
    return rootShadowHost;
}
function $4242ad5853add3e0$var$shadowHostInDom(n) {
    const doc = n.ownerDocument;
    if (!doc) return false;
    const shadowHost = $4242ad5853add3e0$var$getRootShadowHost(n);
    return doc.contains(shadowHost);
}
function $4242ad5853add3e0$var$inDom(n) {
    const doc = n.ownerDocument;
    if (!doc) return false;
    return doc.contains(n) || $4242ad5853add3e0$var$shadowHostInDom(n);
}
const $4242ad5853add3e0$var$cachedImplementations = {};
function $4242ad5853add3e0$var$getImplementation(name) {
    const cached = $4242ad5853add3e0$var$cachedImplementations[name];
    if (cached) return cached;
    const document2 = window.document;
    let impl = window[name];
    if (document2 && typeof document2.createElement === "function") try {
        const sandbox = document2.createElement("iframe");
        sandbox.hidden = true;
        document2.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow[name]) impl = contentWindow[name];
        document2.head.removeChild(sandbox);
    } catch (e) {}
    return $4242ad5853add3e0$var$cachedImplementations[name] = impl.bind(window);
}
function $4242ad5853add3e0$var$onRequestAnimationFrame(...rest) {
    return $4242ad5853add3e0$var$getImplementation("requestAnimationFrame")(...rest);
}
function $4242ad5853add3e0$var$setTimeout$2(...rest) {
    return $4242ad5853add3e0$var$getImplementation("setTimeout")(...rest);
}
function $4242ad5853add3e0$var$clearTimeout$2(...rest) {
    return $4242ad5853add3e0$var$getImplementation("clearTimeout")(...rest);
}
var $4242ad5853add3e0$var$EventType = /* @__PURE__ */ ((EventType2)=>{
    EventType2[EventType2["DomContentLoaded"] = 0] = "DomContentLoaded";
    EventType2[EventType2["Load"] = 1] = "Load";
    EventType2[EventType2["FullSnapshot"] = 2] = "FullSnapshot";
    EventType2[EventType2["IncrementalSnapshot"] = 3] = "IncrementalSnapshot";
    EventType2[EventType2["Meta"] = 4] = "Meta";
    EventType2[EventType2["Custom"] = 5] = "Custom";
    EventType2[EventType2["Plugin"] = 6] = "Plugin";
    return EventType2;
})($4242ad5853add3e0$var$EventType || {});
var $4242ad5853add3e0$var$IncrementalSource = /* @__PURE__ */ ((IncrementalSource2)=>{
    IncrementalSource2[IncrementalSource2["Mutation"] = 0] = "Mutation";
    IncrementalSource2[IncrementalSource2["MouseMove"] = 1] = "MouseMove";
    IncrementalSource2[IncrementalSource2["MouseInteraction"] = 2] = "MouseInteraction";
    IncrementalSource2[IncrementalSource2["Scroll"] = 3] = "Scroll";
    IncrementalSource2[IncrementalSource2["ViewportResize"] = 4] = "ViewportResize";
    IncrementalSource2[IncrementalSource2["Input"] = 5] = "Input";
    IncrementalSource2[IncrementalSource2["TouchMove"] = 6] = "TouchMove";
    IncrementalSource2[IncrementalSource2["MediaInteraction"] = 7] = "MediaInteraction";
    IncrementalSource2[IncrementalSource2["StyleSheetRule"] = 8] = "StyleSheetRule";
    IncrementalSource2[IncrementalSource2["CanvasMutation"] = 9] = "CanvasMutation";
    IncrementalSource2[IncrementalSource2["Font"] = 10] = "Font";
    IncrementalSource2[IncrementalSource2["Log"] = 11] = "Log";
    IncrementalSource2[IncrementalSource2["Drag"] = 12] = "Drag";
    IncrementalSource2[IncrementalSource2["StyleDeclaration"] = 13] = "StyleDeclaration";
    IncrementalSource2[IncrementalSource2["Selection"] = 14] = "Selection";
    IncrementalSource2[IncrementalSource2["AdoptedStyleSheet"] = 15] = "AdoptedStyleSheet";
    IncrementalSource2[IncrementalSource2["CustomElement"] = 16] = "CustomElement";
    return IncrementalSource2;
})($4242ad5853add3e0$var$IncrementalSource || {});
var $4242ad5853add3e0$var$MouseInteractions = /* @__PURE__ */ ((MouseInteractions2)=>{
    MouseInteractions2[MouseInteractions2["MouseUp"] = 0] = "MouseUp";
    MouseInteractions2[MouseInteractions2["MouseDown"] = 1] = "MouseDown";
    MouseInteractions2[MouseInteractions2["Click"] = 2] = "Click";
    MouseInteractions2[MouseInteractions2["ContextMenu"] = 3] = "ContextMenu";
    MouseInteractions2[MouseInteractions2["DblClick"] = 4] = "DblClick";
    MouseInteractions2[MouseInteractions2["Focus"] = 5] = "Focus";
    MouseInteractions2[MouseInteractions2["Blur"] = 6] = "Blur";
    MouseInteractions2[MouseInteractions2["TouchStart"] = 7] = "TouchStart";
    MouseInteractions2[MouseInteractions2["TouchMove_Departed"] = 8] = "TouchMove_Departed";
    MouseInteractions2[MouseInteractions2["TouchEnd"] = 9] = "TouchEnd";
    MouseInteractions2[MouseInteractions2["TouchCancel"] = 10] = "TouchCancel";
    return MouseInteractions2;
})($4242ad5853add3e0$var$MouseInteractions || {});
var $4242ad5853add3e0$var$PointerTypes = /* @__PURE__ */ ((PointerTypes2)=>{
    PointerTypes2[PointerTypes2["Mouse"] = 0] = "Mouse";
    PointerTypes2[PointerTypes2["Pen"] = 1] = "Pen";
    PointerTypes2[PointerTypes2["Touch"] = 2] = "Touch";
    return PointerTypes2;
})($4242ad5853add3e0$var$PointerTypes || {});
var $4242ad5853add3e0$var$MediaInteractions = /* @__PURE__ */ ((MediaInteractions2)=>{
    MediaInteractions2[MediaInteractions2["Play"] = 0] = "Play";
    MediaInteractions2[MediaInteractions2["Pause"] = 1] = "Pause";
    MediaInteractions2[MediaInteractions2["Seeked"] = 2] = "Seeked";
    MediaInteractions2[MediaInteractions2["VolumeChange"] = 3] = "VolumeChange";
    MediaInteractions2[MediaInteractions2["RateChange"] = 4] = "RateChange";
    return MediaInteractions2;
})($4242ad5853add3e0$var$MediaInteractions || {});
let $4242ad5853add3e0$var$errorHandler;
function $4242ad5853add3e0$var$registerErrorHandler(handler) {
    $4242ad5853add3e0$var$errorHandler = handler;
}
function $4242ad5853add3e0$var$unregisterErrorHandler() {
    $4242ad5853add3e0$var$errorHandler = void 0;
}
const $4242ad5853add3e0$var$callbackWrapper = (cb)=>{
    if (!$4242ad5853add3e0$var$errorHandler) return cb;
    const rrwebWrapped = (...rest)=>{
        try {
            return cb(...rest);
        } catch (error) {
            if ($4242ad5853add3e0$var$errorHandler && $4242ad5853add3e0$var$errorHandler(error) === true) return ()=>{};
            throw error;
        }
    };
    return rrwebWrapped;
};
var $4242ad5853add3e0$var$chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
var $4242ad5853add3e0$var$lookup = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
for(var $4242ad5853add3e0$var$i = 0; $4242ad5853add3e0$var$i < $4242ad5853add3e0$var$chars.length; $4242ad5853add3e0$var$i++)$4242ad5853add3e0$var$lookup[$4242ad5853add3e0$var$chars.charCodeAt($4242ad5853add3e0$var$i)] = $4242ad5853add3e0$var$i;
class $4242ad5853add3e0$var$CanvasManagerNoop {
    reset() {}
    freeze() {}
    unfreeze() {}
    lock() {}
    unlock() {}
    snapshot() {}
    addWindow() {}
    addShadowRoot() {}
    resetShadowRoots() {}
}
function $4242ad5853add3e0$var$getIFrameContentDocument(iframe) {
    try {
        return iframe.contentDocument;
    } catch (e2) {}
}
function $4242ad5853add3e0$var$getIFrameContentWindow(iframe) {
    try {
        return iframe.contentWindow;
    } catch (e2) {}
}
class $4242ad5853add3e0$var$StyleDeclarationParser {
    constructor(doc){
        this.doc = doc;
        this.unattachedDoc = null;
    }
    parse(styleText) {
        return this.parseWithConstructableStylesheet(styleText) || this.parseWithDetachedElement(styleText);
    }
    parseWithConstructableStylesheet(styleText) {
        if (typeof CSSStyleSheet === "undefined" || typeof CSSStyleSheet.prototype.replaceSync !== "function") return null;
        try {
            const sheet = new CSSStyleSheet();
            sheet.replaceSync(`x { ${styleText} }`);
            const rule = sheet.cssRules[0];
            if (!rule || rule.type !== CSSRule.STYLE_RULE) return null;
            return rule.style;
        } catch  {
            return null;
        }
    }
    parseWithDetachedElement(styleText) {
        const old = this.getUnattachedDoc().createElement("span");
        old.setAttribute("style", styleText);
        return old.style;
    }
    getUnattachedDoc() {
        if (!this.unattachedDoc) try {
            this.unattachedDoc = document.implementation.createHTMLDocument();
        } catch  {
            this.unattachedDoc = this.doc;
        }
        return this.unattachedDoc;
    }
}
function $4242ad5853add3e0$var$isNodeInLinkedList(n2) {
    return "__ln" in n2;
}
class $4242ad5853add3e0$var$DoubleLinkedList {
    constructor(){
        this.length = 0;
        this.head = null;
        this.tail = null;
    }
    get(position) {
        if (position >= this.length) throw new Error("Position outside of list range");
        let current = this.head;
        for(let index = 0; index < position; index++)current = current?.next || null;
        return current;
    }
    addNode(n2) {
        const node = {
            value: n2,
            previous: null,
            next: null
        };
        n2.__ln = node;
        if (n2.previousSibling && $4242ad5853add3e0$var$isNodeInLinkedList(n2.previousSibling)) {
            const current = n2.previousSibling.__ln.next;
            node.next = current;
            node.previous = n2.previousSibling.__ln;
            n2.previousSibling.__ln.next = node;
            if (current) current.previous = node;
        } else if (n2.nextSibling && $4242ad5853add3e0$var$isNodeInLinkedList(n2.nextSibling) && n2.nextSibling.__ln.previous) {
            const current = n2.nextSibling.__ln.previous;
            node.previous = current;
            node.next = n2.nextSibling.__ln;
            n2.nextSibling.__ln.previous = node;
            if (current) current.next = node;
        } else {
            if (this.head) this.head.previous = node;
            node.next = this.head;
            this.head = node;
        }
        if (node.next === null) this.tail = node;
        this.length++;
    }
    removeNode(n2) {
        const current = n2.__ln;
        if (!this.head) return;
        if (!current.previous) {
            this.head = current.next;
            if (this.head) this.head.previous = null;
            else this.tail = null;
        } else {
            current.previous.next = current.next;
            if (current.next) current.next.previous = current.previous;
            else this.tail = current.previous;
        }
        if (n2.__ln) delete n2.__ln;
        this.length--;
    }
}
const $4242ad5853add3e0$var$moveKey = (id, parentId)=>`${id}@${parentId}`;
class $4242ad5853add3e0$var$MutationBuffer {
    constructor(){
        this.frozen = false;
        this.locked = false;
        this.texts = [];
        this.attributes = [];
        this.attributeMap = /* @__PURE__ */ new WeakMap();
        this.removes = [];
        this.mapRemoves = [];
        this.movedMap = {};
        this.addedSet = /* @__PURE__ */ new Set();
        this.movedSet = /* @__PURE__ */ new Set();
        this.droppedSet = /* @__PURE__ */ new Set();
        this.processMutations = (mutations)=>{
            mutations.forEach(this.processMutation);
            this.emit();
        };
        this.emit = ()=>{
            if (this.frozen || this.locked) return;
            const adds = [];
            const addedIds = /* @__PURE__ */ new Set();
            const addList = new $4242ad5853add3e0$var$DoubleLinkedList();
            const getNextId = (n2)=>{
                let ns = n2;
                let nextId = $4242ad5853add3e0$var$IGNORED_NODE;
                while(nextId === $4242ad5853add3e0$var$IGNORED_NODE){
                    ns = ns && ns.nextSibling;
                    nextId = ns && this.mirror.getId(ns);
                }
                return nextId;
            };
            const pushAdd = (n2)=>{
                if (!n2.parentNode || !$4242ad5853add3e0$var$inDom(n2)) return;
                const parentId = $4242ad5853add3e0$var$isShadowRoot(n2.parentNode) ? this.mirror.getId($4242ad5853add3e0$var$getShadowHost(n2)) : this.mirror.getId(n2.parentNode);
                const nextId = getNextId(n2);
                if (parentId === -1 || nextId === -1) return addList.addNode(n2);
                const sn = $4242ad5853add3e0$var$serializeNodeWithId(n2, {
                    doc: this.doc,
                    mirror: this.mirror,
                    blockClass: this.blockClass,
                    blockSelector: this.blockSelector,
                    maskAllText: this.maskAllText,
                    unblockSelector: this.unblockSelector,
                    maskTextClass: this.maskTextClass,
                    unmaskTextClass: this.unmaskTextClass,
                    maskTextSelector: this.maskTextSelector,
                    unmaskTextSelector: this.unmaskTextSelector,
                    skipChild: true,
                    newlyAddedElement: true,
                    inlineStylesheet: this.inlineStylesheet,
                    maskInputOptions: this.maskInputOptions,
                    maskAttributeFn: this.maskAttributeFn,
                    maskTextFn: this.maskTextFn,
                    maskInputFn: this.maskInputFn,
                    slimDOMOptions: this.slimDOMOptions,
                    dataURLOptions: this.dataURLOptions,
                    recordCanvas: this.recordCanvas,
                    inlineImages: this.inlineImages,
                    onSerialize: (currentN)=>{
                        if ($4242ad5853add3e0$var$isSerializedIframe(currentN, this.mirror) && !$4242ad5853add3e0$var$isBlocked(currentN, this.blockClass, this.blockSelector, this.unblockSelector, false)) this.iframeManager.addIframe(currentN);
                        if ($4242ad5853add3e0$var$isSerializedStylesheet(currentN, this.mirror)) this.stylesheetManager.trackLinkElement(currentN);
                        if ($4242ad5853add3e0$var$hasShadowRoot(n2)) this.shadowDomManager.addShadowRoot(n2.shadowRoot, this.doc);
                    },
                    onIframeLoad: (iframe, childSn)=>{
                        if ($4242ad5853add3e0$var$isBlocked(iframe, this.blockClass, this.blockSelector, this.unblockSelector, false)) return;
                        this.iframeManager.attachIframe(iframe, childSn);
                        const contentWindow = $4242ad5853add3e0$var$getIFrameContentWindow(iframe);
                        if (contentWindow) this.canvasManager.addWindow(contentWindow);
                        this.shadowDomManager.observeAttachShadow(iframe);
                    },
                    onStylesheetLoad: (link, childSn)=>{
                        this.stylesheetManager.attachLinkElement(link, childSn);
                    },
                    onBlockedImageLoad: (_imageEl, serializedNode, { width: width, height: height })=>{
                        this.mutationCb({
                            adds: [],
                            removes: [],
                            texts: [],
                            attributes: [
                                {
                                    id: serializedNode.id,
                                    attributes: {
                                        style: {
                                            width: `${width}px`,
                                            height: `${height}px`
                                        }
                                    }
                                }
                            ]
                        });
                    },
                    ignoreCSSAttributes: this.ignoreCSSAttributes
                });
                if (sn) {
                    adds.push({
                        parentId: parentId,
                        nextId: nextId,
                        node: sn
                    });
                    addedIds.add(sn.id);
                }
            };
            while(this.mapRemoves.length)this.mirror.removeNodeFromMap(this.mapRemoves.shift());
            for (const n2 of this.movedSet){
                if ($4242ad5853add3e0$var$isParentRemoved(this.removes, n2, this.mirror) && !this.movedSet.has(n2.parentNode)) continue;
                pushAdd(n2);
            }
            for (const n2 of this.addedSet){
                if (!$4242ad5853add3e0$var$isAncestorInSet(this.droppedSet, n2) && !$4242ad5853add3e0$var$isParentRemoved(this.removes, n2, this.mirror)) pushAdd(n2);
                else if ($4242ad5853add3e0$var$isAncestorInSet(this.movedSet, n2)) pushAdd(n2);
                else this.droppedSet.add(n2);
            }
            let candidate = null;
            while(addList.length){
                let node = null;
                if (candidate) {
                    const parentId = this.mirror.getId(candidate.value.parentNode);
                    const nextId = getNextId(candidate.value);
                    if (parentId !== -1 && nextId !== -1) node = candidate;
                }
                if (!node) {
                    let tailNode = addList.tail;
                    while(tailNode){
                        const _node = tailNode;
                        tailNode = tailNode.previous;
                        if (_node) {
                            const parentId = this.mirror.getId(_node.value.parentNode);
                            const nextId = getNextId(_node.value);
                            if (nextId === -1) continue;
                            else if (parentId !== -1) {
                                node = _node;
                                break;
                            } else {
                                const unhandledNode = _node.value;
                                if (unhandledNode.parentNode && unhandledNode.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                                    const shadowHost = unhandledNode.parentNode.host;
                                    const parentId2 = this.mirror.getId(shadowHost);
                                    if (parentId2 !== -1) {
                                        node = _node;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
                if (!node) {
                    while(addList.head)addList.removeNode(addList.head.value);
                    break;
                }
                candidate = node.previous;
                addList.removeNode(node.value);
                pushAdd(node.value);
            }
            const payload = {
                texts: this.texts.map((text)=>({
                        id: this.mirror.getId(text.node),
                        value: text.value
                    })).filter((text)=>!addedIds.has(text.id)).filter((text)=>this.mirror.has(text.id)),
                attributes: this.attributes.map((attribute)=>{
                    const { attributes: attributes } = attribute;
                    if (typeof attributes.style === "string") {
                        const diffAsStr = JSON.stringify(attribute.styleDiff);
                        const unchangedAsStr = JSON.stringify(attribute._unchangedStyles);
                        if (diffAsStr.length < attributes.style.length) {
                            if ((diffAsStr + unchangedAsStr).split("var(").length === attributes.style.split("var(").length) attributes.style = attribute.styleDiff;
                        }
                    }
                    return {
                        id: this.mirror.getId(attribute.node),
                        attributes: attributes
                    };
                }).filter((attribute)=>!addedIds.has(attribute.id)).filter((attribute)=>this.mirror.has(attribute.id)),
                removes: this.removes,
                adds: adds
            };
            if (!payload.texts.length && !payload.attributes.length && !payload.removes.length && !payload.adds.length) return;
            this.texts = [];
            this.attributes = [];
            this.attributeMap = /* @__PURE__ */ new WeakMap();
            this.removes = [];
            this.addedSet = /* @__PURE__ */ new Set();
            this.movedSet = /* @__PURE__ */ new Set();
            this.droppedSet = /* @__PURE__ */ new Set();
            this.movedMap = {};
            this.mutationCb(payload);
        };
        this.processMutation = (m)=>{
            if ($4242ad5853add3e0$var$isIgnored(m.target, this.mirror)) return;
            switch(m.type){
                case "characterData":
                    {
                        const value = m.target.textContent;
                        if (!$4242ad5853add3e0$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) && value !== m.oldValue) this.texts.push({
                            value: $4242ad5853add3e0$var$needMaskingText(m.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextClass, this.unmaskTextSelector, this.maskAllText) && value ? this.maskTextFn ? this.maskTextFn(value, $4242ad5853add3e0$var$closestElementOfNode$1(m.target)) : value.replace(/[\S]/g, "*") : value,
                            node: m.target
                        });
                        break;
                    }
                case "attributes":
                    {
                        const target = m.target;
                        let attributeName = m.attributeName;
                        let value = m.target.getAttribute(attributeName);
                        if (attributeName === "value") {
                            const type = $4242ad5853add3e0$var$getInputType(target);
                            const tagName = target.tagName;
                            value = $4242ad5853add3e0$var$getInputValue(target, tagName, type);
                            const isInputMasked = $4242ad5853add3e0$var$shouldMaskInput({
                                maskInputOptions: this.maskInputOptions,
                                tagName: tagName,
                                type: type
                            });
                            const forceMask = $4242ad5853add3e0$var$needMaskingText(m.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextClass, this.unmaskTextSelector, isInputMasked);
                            value = $4242ad5853add3e0$var$maskInputValue({
                                isMasked: forceMask,
                                element: target,
                                value: value,
                                maskInputFn: this.maskInputFn
                            });
                        }
                        if ($4242ad5853add3e0$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) || value === m.oldValue) return;
                        let item = this.attributeMap.get(m.target);
                        if (target.tagName === "IFRAME" && attributeName === "src" && !this.keepIframeSrcFn(value)) {
                            const iframeDoc = $4242ad5853add3e0$var$getIFrameContentDocument(target);
                            if (!iframeDoc) attributeName = "rr_src";
                            else return;
                        }
                        if (!item) {
                            item = {
                                node: m.target,
                                attributes: {},
                                styleDiff: {},
                                _unchangedStyles: {}
                            };
                            this.attributes.push(item);
                            this.attributeMap.set(m.target, item);
                        }
                        if (attributeName === "type" && target.tagName === "INPUT" && (m.oldValue || "").toLowerCase() === "password") target.setAttribute("data-rr-is-password", "true");
                        if (!$4242ad5853add3e0$var$ignoreAttribute(target.tagName, attributeName)) {
                            item.attributes[attributeName] = $4242ad5853add3e0$var$transformAttribute(this.doc, $4242ad5853add3e0$var$toLowerCase(target.tagName), $4242ad5853add3e0$var$toLowerCase(attributeName), value, target, this.maskAttributeFn);
                            if (attributeName === "style") {
                                const oldStyle = m.oldValue ? this.styleDeclarationParser.parse(m.oldValue) : null;
                                for (const pname of Array.from(target.style)){
                                    const newValue = target.style.getPropertyValue(pname);
                                    const newPriority = target.style.getPropertyPriority(pname);
                                    if (newValue !== (oldStyle?.getPropertyValue(pname) || "") || newPriority !== (oldStyle?.getPropertyPriority(pname) || "")) {
                                        if (newPriority === "") item.styleDiff[pname] = newValue;
                                        else item.styleDiff[pname] = [
                                            newValue,
                                            newPriority
                                        ];
                                    } else item._unchangedStyles[pname] = [
                                        newValue,
                                        newPriority
                                    ];
                                }
                                if (oldStyle) {
                                    for (const pname of Array.from(oldStyle))if (target.style.getPropertyValue(pname) === "") item.styleDiff[pname] = false;
                                }
                            }
                        }
                        break;
                    }
                case "childList":
                    if ($4242ad5853add3e0$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, true)) return;
                    m.addedNodes.forEach((n2)=>this.genAdds(n2, m.target));
                    m.removedNodes.forEach((n2)=>{
                        const nodeId = this.mirror.getId(n2);
                        const parentId = $4242ad5853add3e0$var$isShadowRoot(m.target) ? this.mirror.getId(m.target.host) : this.mirror.getId(m.target);
                        if ($4242ad5853add3e0$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) || $4242ad5853add3e0$var$isIgnored(n2, this.mirror) || !$4242ad5853add3e0$var$isSerialized(n2, this.mirror)) return;
                        if (this.addedSet.has(n2)) {
                            $4242ad5853add3e0$var$deepDelete(this.addedSet, n2);
                            this.droppedSet.add(n2);
                        } else if (this.addedSet.has(m.target) && nodeId === -1) ;
                        else if ($4242ad5853add3e0$var$isAncestorRemoved(m.target, this.mirror)) ;
                        else if (this.movedSet.has(n2) && this.movedMap[$4242ad5853add3e0$var$moveKey(nodeId, parentId)]) $4242ad5853add3e0$var$deepDelete(this.movedSet, n2);
                        else this.removes.push({
                            parentId: parentId,
                            id: nodeId,
                            isShadow: $4242ad5853add3e0$var$isShadowRoot(m.target) && $4242ad5853add3e0$var$isNativeShadowDom(m.target) ? true : void 0
                        });
                        this.mapRemoves.push(n2);
                    });
                    break;
            }
        };
        this.genAdds = (n2, target)=>{
            if (this.processedNodeManager.inOtherBuffer(n2, this)) return;
            if (this.addedSet.has(n2) || this.movedSet.has(n2)) return;
            if (this.mirror.hasNode(n2)) {
                if ($4242ad5853add3e0$var$isIgnored(n2, this.mirror)) return;
                this.movedSet.add(n2);
                let targetId = null;
                if (target && this.mirror.hasNode(target)) targetId = this.mirror.getId(target);
                if (targetId && targetId !== -1) this.movedMap[$4242ad5853add3e0$var$moveKey(this.mirror.getId(n2), targetId)] = true;
            } else {
                this.addedSet.add(n2);
                this.droppedSet.delete(n2);
            }
            if (!$4242ad5853add3e0$var$isBlocked(n2, this.blockClass, this.blockSelector, this.unblockSelector, false)) {
                if (n2.childNodes) n2.childNodes.forEach((childN)=>this.genAdds(childN));
                if ($4242ad5853add3e0$var$hasShadowRoot(n2)) n2.shadowRoot.childNodes.forEach((childN)=>{
                    this.processedNodeManager.add(childN, this);
                    this.genAdds(childN, n2);
                });
            }
        };
    }
    init(options) {
        [
            "mutationCb",
            "blockClass",
            "blockSelector",
            "unblockSelector",
            "maskAllText",
            "maskTextClass",
            "unmaskTextClass",
            "maskTextSelector",
            "unmaskTextSelector",
            "inlineStylesheet",
            "maskInputOptions",
            "maskAttributeFn",
            "maskTextFn",
            "maskInputFn",
            "keepIframeSrcFn",
            "recordCanvas",
            "inlineImages",
            "slimDOMOptions",
            "dataURLOptions",
            "doc",
            "mirror",
            "iframeManager",
            "stylesheetManager",
            "shadowDomManager",
            "canvasManager",
            "processedNodeManager",
            "ignoreCSSAttributes"
        ].forEach((key)=>{
            this[key] = options[key];
        });
        this.styleDeclarationParser = new $4242ad5853add3e0$var$StyleDeclarationParser(this.doc);
    }
    freeze() {
        this.frozen = true;
        this.canvasManager.freeze();
    }
    unfreeze() {
        this.frozen = false;
        this.canvasManager.unfreeze();
        this.emit();
    }
    isFrozen() {
        return this.frozen;
    }
    lock() {
        this.locked = true;
        this.canvasManager.lock();
    }
    unlock() {
        this.locked = false;
        this.canvasManager.unlock();
        this.emit();
    }
    reset() {
        this.shadowDomManager.reset();
        this.canvasManager.reset();
    }
}
function $4242ad5853add3e0$var$deepDelete(addsSet, n2) {
    addsSet.delete(n2);
    n2.childNodes?.forEach((childN)=>$4242ad5853add3e0$var$deepDelete(addsSet, childN));
}
function $4242ad5853add3e0$var$isParentRemoved(removes, n2, mirror2) {
    if (removes.length === 0) return false;
    return $4242ad5853add3e0$var$_isParentRemoved(removes, n2, mirror2);
}
function $4242ad5853add3e0$var$_isParentRemoved(removes, n2, mirror2) {
    let node = n2.parentNode;
    while(node){
        const parentId = mirror2.getId(node);
        if (removes.some((r2)=>r2.id === parentId)) return true;
        node = node.parentNode;
    }
    return false;
}
function $4242ad5853add3e0$var$isAncestorInSet(set, n2) {
    if (set.size === 0) return false;
    return $4242ad5853add3e0$var$_isAncestorInSet(set, n2);
}
function $4242ad5853add3e0$var$_isAncestorInSet(set, n2) {
    const { parentNode: parentNode } = n2;
    if (!parentNode) return false;
    if (set.has(parentNode)) return true;
    return $4242ad5853add3e0$var$_isAncestorInSet(set, parentNode);
}
const $4242ad5853add3e0$var$mutationBuffers = [];
function $4242ad5853add3e0$var$getEventTarget(event) {
    try {
        if ("composedPath" in event) {
            const path = event.composedPath();
            if (path.length) return path[0];
        } else if ("path" in event && event.path.length) return event.path[0];
    } catch  {}
    return event && event.target;
}
function $4242ad5853add3e0$var$initMutationObserver(options, rootEl) {
    const mutationBuffer = new $4242ad5853add3e0$var$MutationBuffer();
    $4242ad5853add3e0$var$mutationBuffers.push(mutationBuffer);
    mutationBuffer.init(options);
    let mutationObserverCtor = window.MutationObserver || /**
  * Some websites may disable MutationObserver by removing it from the window object.
  * If someone is using rrweb to build a browser extention or things like it, they
  * could not change the website's code but can have an opportunity to inject some
  * code before the website executing its JS logic.
  * Then they can do this to store the native MutationObserver:
  * window.__rrMutationObserver = MutationObserver
  */ window.__rrMutationObserver;
    const angularZoneSymbol = window?.Zone?.__symbol__?.("MutationObserver");
    if (angularZoneSymbol && window[angularZoneSymbol]) mutationObserverCtor = window[angularZoneSymbol];
    const observer = new mutationObserverCtor($4242ad5853add3e0$var$callbackWrapper((mutations)=>{
        if (options.onMutation && options.onMutation(mutations) === false) return;
        mutationBuffer.processMutations.bind(mutationBuffer)(mutations);
    }));
    observer.observe(rootEl, {
        attributes: true,
        attributeOldValue: true,
        characterData: true,
        characterDataOldValue: true,
        childList: true,
        subtree: true
    });
    return observer;
}
function $4242ad5853add3e0$var$initMoveObserver({ mousemoveCb: mousemoveCb, sampling: sampling, doc: doc, mirror: mirror2 }) {
    if (sampling.mousemove === false) return ()=>{};
    const threshold = typeof sampling.mousemove === "number" ? sampling.mousemove : 50;
    const callbackThreshold = typeof sampling.mousemoveCallback === "number" ? sampling.mousemoveCallback : 500;
    let positions = [];
    let timeBaseline;
    const wrappedCb = $4242ad5853add3e0$var$throttle$1($4242ad5853add3e0$var$callbackWrapper((source)=>{
        const totalOffset = Date.now() - timeBaseline;
        mousemoveCb(positions.map((p)=>{
            p.timeOffset -= totalOffset;
            return p;
        }), source);
        positions = [];
        timeBaseline = null;
    }), callbackThreshold);
    const updatePosition = $4242ad5853add3e0$var$callbackWrapper($4242ad5853add3e0$var$throttle$1($4242ad5853add3e0$var$callbackWrapper((evt)=>{
        const target = $4242ad5853add3e0$var$getEventTarget(evt);
        const { clientX: clientX, clientY: clientY } = $4242ad5853add3e0$var$legacy_isTouchEvent(evt) ? evt.changedTouches[0] : evt;
        if (!timeBaseline) timeBaseline = $4242ad5853add3e0$var$nowTimestamp();
        positions.push({
            x: clientX,
            y: clientY,
            id: mirror2.getId(target),
            timeOffset: $4242ad5853add3e0$var$nowTimestamp() - timeBaseline
        });
        wrappedCb(typeof DragEvent !== "undefined" && evt instanceof DragEvent ? $4242ad5853add3e0$var$IncrementalSource.Drag : evt instanceof MouseEvent ? $4242ad5853add3e0$var$IncrementalSource.MouseMove : $4242ad5853add3e0$var$IncrementalSource.TouchMove);
    }), threshold, {
        trailing: false
    }));
    const handlers = [
        $4242ad5853add3e0$var$on("mousemove", updatePosition, doc),
        $4242ad5853add3e0$var$on("touchmove", updatePosition, doc),
        $4242ad5853add3e0$var$on("drag", updatePosition, doc)
    ];
    return $4242ad5853add3e0$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $4242ad5853add3e0$var$initMouseInteractionObserver({ mouseInteractionCb: mouseInteractionCb, doc: doc, mirror: mirror2, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, sampling: sampling }) {
    if (sampling.mouseInteraction === false) return ()=>{};
    const disableMap = sampling.mouseInteraction === true || sampling.mouseInteraction === void 0 ? {} : sampling.mouseInteraction;
    const handlers = [];
    let currentPointerType = null;
    const getHandler = (eventKey)=>{
        return (event)=>{
            const target = $4242ad5853add3e0$var$getEventTarget(event);
            if ($4242ad5853add3e0$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
            let pointerType = null;
            let thisEventKey = eventKey;
            if ("pointerType" in event) {
                switch(event.pointerType){
                    case "mouse":
                        pointerType = $4242ad5853add3e0$var$PointerTypes.Mouse;
                        break;
                    case "touch":
                        pointerType = $4242ad5853add3e0$var$PointerTypes.Touch;
                        break;
                    case "pen":
                        pointerType = $4242ad5853add3e0$var$PointerTypes.Pen;
                        break;
                }
                if (pointerType === $4242ad5853add3e0$var$PointerTypes.Touch) {
                    if ($4242ad5853add3e0$var$MouseInteractions[eventKey] === $4242ad5853add3e0$var$MouseInteractions.MouseDown) thisEventKey = "TouchStart";
                    else if ($4242ad5853add3e0$var$MouseInteractions[eventKey] === $4242ad5853add3e0$var$MouseInteractions.MouseUp) thisEventKey = "TouchEnd";
                } else $4242ad5853add3e0$var$PointerTypes.Pen;
            } else if ($4242ad5853add3e0$var$legacy_isTouchEvent(event)) pointerType = $4242ad5853add3e0$var$PointerTypes.Touch;
            if (pointerType !== null) {
                currentPointerType = pointerType;
                if (thisEventKey.startsWith("Touch") && pointerType === $4242ad5853add3e0$var$PointerTypes.Touch || thisEventKey.startsWith("Mouse") && pointerType === $4242ad5853add3e0$var$PointerTypes.Mouse) pointerType = null;
            } else if ($4242ad5853add3e0$var$MouseInteractions[eventKey] === $4242ad5853add3e0$var$MouseInteractions.Click) {
                pointerType = currentPointerType;
                currentPointerType = null;
            }
            const e2 = $4242ad5853add3e0$var$legacy_isTouchEvent(event) ? event.changedTouches[0] : event;
            if (!e2) return;
            const id = mirror2.getId(target);
            const { clientX: clientX, clientY: clientY } = e2;
            $4242ad5853add3e0$var$callbackWrapper(mouseInteractionCb)({
                type: $4242ad5853add3e0$var$MouseInteractions[thisEventKey],
                id: id,
                x: clientX,
                y: clientY,
                ...pointerType !== null && {
                    pointerType: pointerType
                }
            });
        };
    };
    Object.keys($4242ad5853add3e0$var$MouseInteractions).filter((key)=>Number.isNaN(Number(key)) && !key.endsWith("_Departed") && disableMap[key] !== false).forEach((eventKey)=>{
        let eventName = $4242ad5853add3e0$var$toLowerCase(eventKey);
        const handler = getHandler(eventKey);
        if (window.PointerEvent) switch($4242ad5853add3e0$var$MouseInteractions[eventKey]){
            case $4242ad5853add3e0$var$MouseInteractions.MouseDown:
            case $4242ad5853add3e0$var$MouseInteractions.MouseUp:
                eventName = eventName.replace("mouse", "pointer");
                break;
            case $4242ad5853add3e0$var$MouseInteractions.TouchStart:
            case $4242ad5853add3e0$var$MouseInteractions.TouchEnd:
                return;
        }
        handlers.push($4242ad5853add3e0$var$on(eventName, handler, doc));
    });
    return $4242ad5853add3e0$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $4242ad5853add3e0$var$initScrollObserver({ scrollCb: scrollCb, doc: doc, mirror: mirror2, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, sampling: sampling }) {
    const updatePosition = $4242ad5853add3e0$var$callbackWrapper($4242ad5853add3e0$var$throttle$1($4242ad5853add3e0$var$callbackWrapper((evt)=>{
        const target = $4242ad5853add3e0$var$getEventTarget(evt);
        if (!target || $4242ad5853add3e0$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
        const id = mirror2.getId(target);
        if (target === doc && doc.defaultView) {
            const scrollLeftTop = $4242ad5853add3e0$var$getWindowScroll(doc.defaultView);
            scrollCb({
                id: id,
                x: scrollLeftTop.left,
                y: scrollLeftTop.top
            });
        } else scrollCb({
            id: id,
            x: target.scrollLeft,
            y: target.scrollTop
        });
    }), sampling.scroll || 100));
    return $4242ad5853add3e0$var$on("scroll", updatePosition, doc);
}
function $4242ad5853add3e0$var$initViewportResizeObserver({ viewportResizeCb: viewportResizeCb }, { win: win }) {
    let lastH = -1;
    let lastW = -1;
    const updateDimension = $4242ad5853add3e0$var$callbackWrapper($4242ad5853add3e0$var$throttle$1($4242ad5853add3e0$var$callbackWrapper(()=>{
        const height = $4242ad5853add3e0$var$getWindowHeight();
        const width = $4242ad5853add3e0$var$getWindowWidth();
        if (lastH !== height || lastW !== width) {
            viewportResizeCb({
                width: Number(width),
                height: Number(height)
            });
            lastH = height;
            lastW = width;
        }
    }), 200));
    return $4242ad5853add3e0$var$on("resize", updateDimension, win);
}
const $4242ad5853add3e0$var$INPUT_TAGS = [
    "INPUT",
    "TEXTAREA",
    "SELECT"
];
const $4242ad5853add3e0$var$lastInputValueMap = /* @__PURE__ */ new WeakMap();
function $4242ad5853add3e0$var$initInputObserver({ inputCb: inputCb, doc: doc, mirror: mirror2, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, ignoreClass: ignoreClass, ignoreSelector: ignoreSelector, maskInputOptions: maskInputOptions, maskInputFn: maskInputFn, sampling: sampling, userTriggeredOnInput: userTriggeredOnInput, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector }) {
    function eventHandler(event) {
        let target = $4242ad5853add3e0$var$getEventTarget(event);
        const userTriggered = event.isTrusted;
        const tagName = target && $4242ad5853add3e0$var$toUpperCase(target.tagName);
        if (tagName === "OPTION") target = target.parentElement;
        if (!target || !tagName || $4242ad5853add3e0$var$INPUT_TAGS.indexOf(tagName) < 0 || $4242ad5853add3e0$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
        const el = target;
        if (el.classList.contains(ignoreClass) || ignoreSelector && el.matches(ignoreSelector)) return;
        const type = $4242ad5853add3e0$var$getInputType(target);
        let text = $4242ad5853add3e0$var$getInputValue(el, tagName, type);
        let isChecked = false;
        const isInputMasked = $4242ad5853add3e0$var$shouldMaskInput({
            maskInputOptions: maskInputOptions,
            tagName: tagName,
            type: type
        });
        const forceMask = $4242ad5853add3e0$var$needMaskingText(target, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, isInputMasked);
        if (type === "radio" || type === "checkbox") isChecked = target.checked;
        text = $4242ad5853add3e0$var$maskInputValue({
            isMasked: forceMask,
            element: target,
            value: text,
            maskInputFn: maskInputFn
        });
        cbWithDedup(target, userTriggeredOnInput ? {
            text: text,
            isChecked: isChecked,
            userTriggered: userTriggered
        } : {
            text: text,
            isChecked: isChecked
        });
        const name = target.name;
        if (type === "radio" && name && isChecked) doc.querySelectorAll(`input[type="radio"][name="${name}"]`).forEach((el2)=>{
            if (el2 !== target) {
                const text2 = $4242ad5853add3e0$var$maskInputValue({
                    // share mask behavior of `target`
                    isMasked: forceMask,
                    element: el2,
                    value: $4242ad5853add3e0$var$getInputValue(el2, tagName, type),
                    maskInputFn: maskInputFn
                });
                cbWithDedup(el2, userTriggeredOnInput ? {
                    text: text2,
                    isChecked: !isChecked,
                    userTriggered: false
                } : {
                    text: text2,
                    isChecked: !isChecked
                });
            }
        });
    }
    function cbWithDedup(target, v2) {
        const lastInputValue = $4242ad5853add3e0$var$lastInputValueMap.get(target);
        if (!lastInputValue || lastInputValue.text !== v2.text || lastInputValue.isChecked !== v2.isChecked) {
            $4242ad5853add3e0$var$lastInputValueMap.set(target, v2);
            const id = mirror2.getId(target);
            $4242ad5853add3e0$var$callbackWrapper(inputCb)({
                ...v2,
                id: id
            });
        }
    }
    const events = sampling.input === "last" ? [
        "change"
    ] : [
        "input",
        "change"
    ];
    const handlers = events.map((eventName)=>$4242ad5853add3e0$var$on(eventName, $4242ad5853add3e0$var$callbackWrapper(eventHandler), doc));
    const currentWindow = doc.defaultView;
    if (!currentWindow) return ()=>{
        handlers.forEach((h)=>h());
    };
    const propertyDescriptor = currentWindow.Object.getOwnPropertyDescriptor(currentWindow.HTMLInputElement.prototype, "value");
    const hookProperties = [
        [
            currentWindow.HTMLInputElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLInputElement.prototype,
            "checked"
        ],
        [
            currentWindow.HTMLSelectElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLTextAreaElement.prototype,
            "value"
        ],
        // Some UI library use selectedIndex to set select value
        [
            currentWindow.HTMLSelectElement.prototype,
            "selectedIndex"
        ],
        [
            currentWindow.HTMLOptionElement.prototype,
            "selected"
        ]
    ];
    if (propertyDescriptor && propertyDescriptor.set) handlers.push(...hookProperties.map((p)=>$4242ad5853add3e0$var$hookSetter(p[0], p[1], {
            set () {
                $4242ad5853add3e0$var$callbackWrapper(eventHandler)({
                    target: this,
                    isTrusted: false
                });
            }
        }, false, currentWindow)));
    return $4242ad5853add3e0$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $4242ad5853add3e0$var$getNestedCSSRulePositions(rule) {
    const positions = [];
    function recurse(childRule, pos) {
        if ($4242ad5853add3e0$var$hasNestedCSSRule("CSSGroupingRule") && childRule.parentRule instanceof CSSGroupingRule || $4242ad5853add3e0$var$hasNestedCSSRule("CSSMediaRule") && childRule.parentRule instanceof CSSMediaRule || $4242ad5853add3e0$var$hasNestedCSSRule("CSSSupportsRule") && childRule.parentRule instanceof CSSSupportsRule || $4242ad5853add3e0$var$hasNestedCSSRule("CSSConditionRule") && childRule.parentRule instanceof CSSConditionRule) {
            const rules2 = Array.from(childRule.parentRule.cssRules);
            const index = rules2.indexOf(childRule);
            pos.unshift(index);
        } else if (childRule.parentStyleSheet) {
            const rules2 = Array.from(childRule.parentStyleSheet.cssRules);
            const index = rules2.indexOf(childRule);
            pos.unshift(index);
        }
        return pos;
    }
    return recurse(rule, positions);
}
function $4242ad5853add3e0$var$getIdAndStyleId(sheet, mirror2, styleMirror) {
    let id, styleId;
    if (!sheet) return {};
    if (sheet.ownerNode) id = mirror2.getId(sheet.ownerNode);
    else styleId = styleMirror.getId(sheet);
    return {
        styleId: styleId,
        id: id
    };
}
function $4242ad5853add3e0$var$initStyleSheetObserver({ styleSheetRuleCb: styleSheetRuleCb, mirror: mirror2, stylesheetManager: stylesheetManager }, { win: win }) {
    if (!win.CSSStyleSheet || !win.CSSStyleSheet.prototype) return ()=>{};
    const insertRule = win.CSSStyleSheet.prototype.insertRule;
    win.CSSStyleSheet.prototype.insertRule = new Proxy(insertRule, {
        apply: $4242ad5853add3e0$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [rule, index] = argumentsList;
            const { id: id, styleId: styleId } = $4242ad5853add3e0$var$getIdAndStyleId(thisArg, mirror2, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                adds: [
                    {
                        rule: rule,
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    const deleteRule = win.CSSStyleSheet.prototype.deleteRule;
    win.CSSStyleSheet.prototype.deleteRule = new Proxy(deleteRule, {
        apply: $4242ad5853add3e0$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [index] = argumentsList;
            const { id: id, styleId: styleId } = $4242ad5853add3e0$var$getIdAndStyleId(thisArg, mirror2, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                removes: [
                    {
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    let replace;
    if (win.CSSStyleSheet.prototype.replace) {
        replace = win.CSSStyleSheet.prototype.replace;
        win.CSSStyleSheet.prototype.replace = new Proxy(replace, {
            apply: $4242ad5853add3e0$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [text] = argumentsList;
                const { id: id, styleId: styleId } = $4242ad5853add3e0$var$getIdAndStyleId(thisArg, mirror2, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replace: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    let replaceSync;
    if (win.CSSStyleSheet.prototype.replaceSync) {
        replaceSync = win.CSSStyleSheet.prototype.replaceSync;
        win.CSSStyleSheet.prototype.replaceSync = new Proxy(replaceSync, {
            apply: $4242ad5853add3e0$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [text] = argumentsList;
                const { id: id, styleId: styleId } = $4242ad5853add3e0$var$getIdAndStyleId(thisArg, mirror2, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replaceSync: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    const supportedNestedCSSRuleTypes = {};
    if ($4242ad5853add3e0$var$canMonkeyPatchNestedCSSRule("CSSGroupingRule")) supportedNestedCSSRuleTypes.CSSGroupingRule = win.CSSGroupingRule;
    else {
        if ($4242ad5853add3e0$var$canMonkeyPatchNestedCSSRule("CSSMediaRule")) supportedNestedCSSRuleTypes.CSSMediaRule = win.CSSMediaRule;
        if ($4242ad5853add3e0$var$canMonkeyPatchNestedCSSRule("CSSConditionRule")) supportedNestedCSSRuleTypes.CSSConditionRule = win.CSSConditionRule;
        if ($4242ad5853add3e0$var$canMonkeyPatchNestedCSSRule("CSSSupportsRule")) supportedNestedCSSRuleTypes.CSSSupportsRule = win.CSSSupportsRule;
    }
    const unmodifiedFunctions = {};
    Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type])=>{
        unmodifiedFunctions[typeKey] = {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            insertRule: type.prototype.insertRule,
            // eslint-disable-next-line @typescript-eslint/unbound-method
            deleteRule: type.prototype.deleteRule
        };
        type.prototype.insertRule = new Proxy(unmodifiedFunctions[typeKey].insertRule, {
            apply: $4242ad5853add3e0$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [rule, index] = argumentsList;
                const { id: id, styleId: styleId } = $4242ad5853add3e0$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror2, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    adds: [
                        {
                            rule: rule,
                            index: [
                                ...$4242ad5853add3e0$var$getNestedCSSRulePositions(thisArg),
                                index || 0
                            ]
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
        type.prototype.deleteRule = new Proxy(unmodifiedFunctions[typeKey].deleteRule, {
            apply: $4242ad5853add3e0$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [index] = argumentsList;
                const { id: id, styleId: styleId } = $4242ad5853add3e0$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror2, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    removes: [
                        {
                            index: [
                                ...$4242ad5853add3e0$var$getNestedCSSRulePositions(thisArg),
                                index
                            ]
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    });
    return $4242ad5853add3e0$var$callbackWrapper(()=>{
        win.CSSStyleSheet.prototype.insertRule = insertRule;
        win.CSSStyleSheet.prototype.deleteRule = deleteRule;
        replace && (win.CSSStyleSheet.prototype.replace = replace);
        replaceSync && (win.CSSStyleSheet.prototype.replaceSync = replaceSync);
        Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type])=>{
            type.prototype.insertRule = unmodifiedFunctions[typeKey].insertRule;
            type.prototype.deleteRule = unmodifiedFunctions[typeKey].deleteRule;
        });
    });
}
function $4242ad5853add3e0$var$initAdoptedStyleSheetObserver({ mirror: mirror2, stylesheetManager: stylesheetManager }, host) {
    let hostId = null;
    if (host.nodeName === "#document") hostId = mirror2.getId(host);
    else hostId = mirror2.getId(host.host);
    const patchTarget = host.nodeName === "#document" ? host.defaultView?.Document : host.ownerDocument?.defaultView?.ShadowRoot;
    const originalPropertyDescriptor = patchTarget?.prototype ? Object.getOwnPropertyDescriptor(patchTarget?.prototype, "adoptedStyleSheets") : void 0;
    if (hostId === null || hostId === -1 || !patchTarget || !originalPropertyDescriptor) return ()=>{};
    Object.defineProperty(host, "adoptedStyleSheets", {
        configurable: originalPropertyDescriptor.configurable,
        enumerable: originalPropertyDescriptor.enumerable,
        get () {
            return originalPropertyDescriptor.get?.call(this);
        },
        set (sheets) {
            const result = originalPropertyDescriptor.set?.call(this, sheets);
            if (hostId !== null && hostId !== -1) try {
                stylesheetManager.adoptStyleSheets(sheets, hostId);
            } catch (e2) {}
            return result;
        }
    });
    return $4242ad5853add3e0$var$callbackWrapper(()=>{
        Object.defineProperty(host, "adoptedStyleSheets", {
            configurable: originalPropertyDescriptor.configurable,
            enumerable: originalPropertyDescriptor.enumerable,
            // eslint-disable-next-line @typescript-eslint/unbound-method
            get: originalPropertyDescriptor.get,
            // eslint-disable-next-line @typescript-eslint/unbound-method
            set: originalPropertyDescriptor.set
        });
    });
}
function $4242ad5853add3e0$var$initStyleDeclarationObserver({ styleDeclarationCb: styleDeclarationCb, mirror: mirror2, ignoreCSSAttributes: ignoreCSSAttributes, stylesheetManager: stylesheetManager }, { win: win }) {
    const setProperty = win.CSSStyleDeclaration.prototype.setProperty;
    win.CSSStyleDeclaration.prototype.setProperty = new Proxy(setProperty, {
        apply: $4242ad5853add3e0$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [property, value, priority] = argumentsList;
            if (ignoreCSSAttributes.has(property)) return setProperty.apply(thisArg, [
                property,
                value,
                priority
            ]);
            const { id: id, styleId: styleId } = $4242ad5853add3e0$var$getIdAndStyleId(thisArg.parentRule?.parentStyleSheet, mirror2, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                set: {
                    property: property,
                    value: value,
                    priority: priority
                },
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                index: $4242ad5853add3e0$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    const removeProperty = win.CSSStyleDeclaration.prototype.removeProperty;
    win.CSSStyleDeclaration.prototype.removeProperty = new Proxy(removeProperty, {
        apply: $4242ad5853add3e0$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [property] = argumentsList;
            if (ignoreCSSAttributes.has(property)) return removeProperty.apply(thisArg, [
                property
            ]);
            const { id: id, styleId: styleId } = $4242ad5853add3e0$var$getIdAndStyleId(thisArg.parentRule?.parentStyleSheet, mirror2, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                remove: {
                    property: property
                },
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                index: $4242ad5853add3e0$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    return $4242ad5853add3e0$var$callbackWrapper(()=>{
        win.CSSStyleDeclaration.prototype.setProperty = setProperty;
        win.CSSStyleDeclaration.prototype.removeProperty = removeProperty;
    });
}
function $4242ad5853add3e0$var$initMediaInteractionObserver({ mediaInteractionCb: mediaInteractionCb, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, mirror: mirror2, sampling: sampling, doc: doc }) {
    const handler = $4242ad5853add3e0$var$callbackWrapper((type)=>$4242ad5853add3e0$var$throttle$1($4242ad5853add3e0$var$callbackWrapper((event)=>{
            const target = $4242ad5853add3e0$var$getEventTarget(event);
            if (!target || $4242ad5853add3e0$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
            const { currentTime: currentTime, volume: volume, muted: muted, playbackRate: playbackRate } = target;
            mediaInteractionCb({
                type: type,
                id: mirror2.getId(target),
                currentTime: currentTime,
                volume: volume,
                muted: muted,
                playbackRate: playbackRate
            });
        }), sampling.media || 500));
    const handlers = [
        $4242ad5853add3e0$var$on("play", handler($4242ad5853add3e0$var$MediaInteractions.Play), doc),
        $4242ad5853add3e0$var$on("pause", handler($4242ad5853add3e0$var$MediaInteractions.Pause), doc),
        $4242ad5853add3e0$var$on("seeked", handler($4242ad5853add3e0$var$MediaInteractions.Seeked), doc),
        $4242ad5853add3e0$var$on("volumechange", handler($4242ad5853add3e0$var$MediaInteractions.VolumeChange), doc),
        $4242ad5853add3e0$var$on("ratechange", handler($4242ad5853add3e0$var$MediaInteractions.RateChange), doc)
    ];
    return $4242ad5853add3e0$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $4242ad5853add3e0$var$initFontObserver({ fontCb: fontCb, doc: doc }) {
    const win = doc.defaultView;
    if (!win) return ()=>{};
    const handlers = [];
    const fontMap = /* @__PURE__ */ new WeakMap();
    const originalFontFace = win.FontFace;
    win.FontFace = function FontFace2(family, source, descriptors) {
        const fontFace = new originalFontFace(family, source, descriptors);
        fontMap.set(fontFace, {
            family: family,
            buffer: typeof source !== "string",
            descriptors: descriptors,
            fontSource: typeof source === "string" ? source : JSON.stringify(Array.from(new Uint8Array(source)))
        });
        return fontFace;
    };
    const restoreHandler = $4242ad5853add3e0$var$patch(doc.fonts, "add", function(original) {
        return function(fontFace) {
            $4242ad5853add3e0$var$setTimeout$2($4242ad5853add3e0$var$callbackWrapper(()=>{
                const p = fontMap.get(fontFace);
                if (p) {
                    fontCb(p);
                    fontMap.delete(fontFace);
                }
            }), 0);
            return original.apply(this, [
                fontFace
            ]);
        };
    });
    handlers.push(()=>{
        win.FontFace = originalFontFace;
    });
    handlers.push(restoreHandler);
    return $4242ad5853add3e0$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $4242ad5853add3e0$var$initSelectionObserver(param) {
    const { doc: doc, mirror: mirror2, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, selectionCb: selectionCb } = param;
    let collapsed = true;
    const updateSelection = $4242ad5853add3e0$var$callbackWrapper(()=>{
        const selection = doc.getSelection();
        if (!selection || collapsed && selection?.isCollapsed) return;
        collapsed = selection.isCollapsed || false;
        const ranges = [];
        const count = selection.rangeCount || 0;
        for(let i2 = 0; i2 < count; i2++){
            const range = selection.getRangeAt(i2);
            const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = range;
            const blocked = $4242ad5853add3e0$var$isBlocked(startContainer, blockClass, blockSelector, unblockSelector, true) || $4242ad5853add3e0$var$isBlocked(endContainer, blockClass, blockSelector, unblockSelector, true);
            if (blocked) continue;
            ranges.push({
                start: mirror2.getId(startContainer),
                startOffset: startOffset,
                end: mirror2.getId(endContainer),
                endOffset: endOffset
            });
        }
        selectionCb({
            ranges: ranges
        });
    });
    updateSelection();
    return $4242ad5853add3e0$var$on("selectionchange", updateSelection);
}
function $4242ad5853add3e0$var$initCustomElementObserver({ doc: doc, customElementCb: customElementCb }) {
    const win = doc.defaultView;
    if (!win || !win.customElements) return ()=>{};
    const restoreHandler = $4242ad5853add3e0$var$patch(win.customElements, "define", function(original) {
        return function(name, constructor, options) {
            try {
                customElementCb({
                    define: {
                        name: name
                    }
                });
            } catch (e2) {}
            return original.apply(this, [
                name,
                constructor,
                options
            ]);
        };
    });
    return restoreHandler;
}
function $4242ad5853add3e0$var$initObservers(o2, _hooks = {}) {
    const currentWindow = o2.doc.defaultView;
    if (!currentWindow) return ()=>{};
    let mutationObserver;
    if (o2.recordDOM) mutationObserver = $4242ad5853add3e0$var$initMutationObserver(o2, o2.doc);
    const mousemoveHandler = $4242ad5853add3e0$var$initMoveObserver(o2);
    const mouseInteractionHandler = $4242ad5853add3e0$var$initMouseInteractionObserver(o2);
    const scrollHandler = $4242ad5853add3e0$var$initScrollObserver(o2);
    const viewportResizeHandler = $4242ad5853add3e0$var$initViewportResizeObserver(o2, {
        win: currentWindow
    });
    const inputHandler = $4242ad5853add3e0$var$initInputObserver(o2);
    const mediaInteractionHandler = $4242ad5853add3e0$var$initMediaInteractionObserver(o2);
    let styleSheetObserver = ()=>{};
    let adoptedStyleSheetObserver = ()=>{};
    let styleDeclarationObserver = ()=>{};
    let fontObserver = ()=>{};
    if (o2.recordDOM) {
        styleSheetObserver = $4242ad5853add3e0$var$initStyleSheetObserver(o2, {
            win: currentWindow
        });
        adoptedStyleSheetObserver = $4242ad5853add3e0$var$initAdoptedStyleSheetObserver(o2, o2.doc);
        styleDeclarationObserver = $4242ad5853add3e0$var$initStyleDeclarationObserver(o2, {
            win: currentWindow
        });
        if (o2.collectFonts) fontObserver = $4242ad5853add3e0$var$initFontObserver(o2);
    }
    const selectionObserver = $4242ad5853add3e0$var$initSelectionObserver(o2);
    const customElementObserver = $4242ad5853add3e0$var$initCustomElementObserver(o2);
    const pluginHandlers = [];
    for (const plugin of o2.plugins)pluginHandlers.push(plugin.observer(plugin.callback, currentWindow, plugin.options));
    return $4242ad5853add3e0$var$callbackWrapper(()=>{
        $4242ad5853add3e0$var$mutationBuffers.forEach((b)=>b.reset());
        mutationObserver?.disconnect();
        mousemoveHandler();
        mouseInteractionHandler();
        scrollHandler();
        viewportResizeHandler();
        inputHandler();
        mediaInteractionHandler();
        styleSheetObserver();
        adoptedStyleSheetObserver();
        styleDeclarationObserver();
        fontObserver();
        selectionObserver();
        customElementObserver();
        pluginHandlers.forEach((h)=>h());
    });
}
function $4242ad5853add3e0$var$hasNestedCSSRule(prop) {
    return typeof window[prop] !== "undefined";
}
function $4242ad5853add3e0$var$canMonkeyPatchNestedCSSRule(prop) {
    return Boolean(typeof window[prop] !== "undefined" && // Note: Generally, this check _shouldn't_ be necessary
    // However, in some scenarios (e.g. jsdom) this can sometimes fail, so we check for it here
    window[prop].prototype && "insertRule" in window[prop].prototype && "deleteRule" in window[prop].prototype);
}
class $4242ad5853add3e0$var$CrossOriginIframeMirror {
    constructor(generateIdFn){
        this.generateIdFn = generateIdFn;
        this.iframeIdToRemoteIdMap = /* @__PURE__ */ new WeakMap();
        this.iframeRemoteIdToIdMap = /* @__PURE__ */ new WeakMap();
    }
    getId(iframe, remoteId, idToRemoteMap, remoteToIdMap) {
        const idToRemoteIdMap = idToRemoteMap || this.getIdToRemoteIdMap(iframe);
        const remoteIdToIdMap = remoteToIdMap || this.getRemoteIdToIdMap(iframe);
        let id = idToRemoteIdMap.get(remoteId);
        if (!id) {
            id = this.generateIdFn();
            idToRemoteIdMap.set(remoteId, id);
            remoteIdToIdMap.set(id, remoteId);
        }
        return id;
    }
    getIds(iframe, remoteId) {
        const idToRemoteIdMap = this.getIdToRemoteIdMap(iframe);
        const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return remoteId.map((id)=>this.getId(iframe, id, idToRemoteIdMap, remoteIdToIdMap));
    }
    getRemoteId(iframe, id, map) {
        const remoteIdToIdMap = map || this.getRemoteIdToIdMap(iframe);
        if (typeof id !== "number") return id;
        const remoteId = remoteIdToIdMap.get(id);
        if (!remoteId) return -1;
        return remoteId;
    }
    getRemoteIds(iframe, ids) {
        const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return ids.map((id)=>this.getRemoteId(iframe, id, remoteIdToIdMap));
    }
    reset(iframe) {
        if (!iframe) {
            this.iframeIdToRemoteIdMap = /* @__PURE__ */ new WeakMap();
            this.iframeRemoteIdToIdMap = /* @__PURE__ */ new WeakMap();
            return;
        }
        this.iframeIdToRemoteIdMap.delete(iframe);
        this.iframeRemoteIdToIdMap.delete(iframe);
    }
    getIdToRemoteIdMap(iframe) {
        let idToRemoteIdMap = this.iframeIdToRemoteIdMap.get(iframe);
        if (!idToRemoteIdMap) {
            idToRemoteIdMap = /* @__PURE__ */ new Map();
            this.iframeIdToRemoteIdMap.set(iframe, idToRemoteIdMap);
        }
        return idToRemoteIdMap;
    }
    getRemoteIdToIdMap(iframe) {
        let remoteIdToIdMap = this.iframeRemoteIdToIdMap.get(iframe);
        if (!remoteIdToIdMap) {
            remoteIdToIdMap = /* @__PURE__ */ new Map();
            this.iframeRemoteIdToIdMap.set(iframe, remoteIdToIdMap);
        }
        return remoteIdToIdMap;
    }
}
class $4242ad5853add3e0$var$IframeManagerNoop {
    constructor(){
        this.crossOriginIframeMirror = new $4242ad5853add3e0$var$CrossOriginIframeMirror($4242ad5853add3e0$var$genId);
        this.crossOriginIframeRootIdMap = /* @__PURE__ */ new WeakMap();
    }
    addIframe() {}
    addLoadListener() {}
    attachIframe() {}
}
class $4242ad5853add3e0$var$IframeManager {
    constructor(options){
        this.iframes = /* @__PURE__ */ new WeakMap();
        this.crossOriginIframeMap = /* @__PURE__ */ new WeakMap();
        this.crossOriginIframeMirror = new $4242ad5853add3e0$var$CrossOriginIframeMirror($4242ad5853add3e0$var$genId);
        this.crossOriginIframeRootIdMap = /* @__PURE__ */ new WeakMap();
        this.mutationCb = options.mutationCb;
        this.wrappedEmit = options.wrappedEmit;
        this.stylesheetManager = options.stylesheetManager;
        this.recordCrossOriginIframes = options.recordCrossOriginIframes;
        this.crossOriginIframeStyleMirror = new $4242ad5853add3e0$var$CrossOriginIframeMirror(this.stylesheetManager.styleMirror.generateId.bind(this.stylesheetManager.styleMirror));
        this.mirror = options.mirror;
        if (this.recordCrossOriginIframes) window.addEventListener("message", this.handleMessage.bind(this));
    }
    addIframe(iframeEl) {
        this.iframes.set(iframeEl, true);
        const contentWindow = $4242ad5853add3e0$var$getIFrameContentWindow(iframeEl);
        if (contentWindow) this.crossOriginIframeMap.set(contentWindow, iframeEl);
    }
    addLoadListener(cb) {
        this.loadListener = cb;
    }
    attachIframe(iframeEl, childSn) {
        this.mutationCb({
            adds: [
                {
                    parentId: this.mirror.getId(iframeEl),
                    nextId: null,
                    node: childSn
                }
            ],
            removes: [],
            texts: [],
            attributes: [],
            isAttachIframe: true
        });
        if (this.recordCrossOriginIframes) $4242ad5853add3e0$var$getIFrameContentWindow(iframeEl)?.addEventListener("message", this.handleMessage.bind(this));
        this.loadListener?.(iframeEl);
        const iframeDoc = $4242ad5853add3e0$var$getIFrameContentDocument(iframeEl);
        if (iframeDoc && iframeDoc.adoptedStyleSheets && iframeDoc.adoptedStyleSheets.length > 0) this.stylesheetManager.adoptStyleSheets(iframeDoc.adoptedStyleSheets, this.mirror.getId(iframeDoc));
    }
    handleMessage(message) {
        const crossOriginMessageEvent = message;
        if (crossOriginMessageEvent.data.type !== "rrweb" || // To filter out the rrweb messages which are forwarded by some sites.
        crossOriginMessageEvent.origin !== crossOriginMessageEvent.data.origin) return;
        const iframeSourceWindow = message.source;
        if (!iframeSourceWindow) return;
        const iframeEl = this.crossOriginIframeMap.get(message.source);
        if (!iframeEl) return;
        const transformedEvent = this.transformCrossOriginEvent(iframeEl, crossOriginMessageEvent.data.event);
        if (transformedEvent) this.wrappedEmit(transformedEvent, crossOriginMessageEvent.data.isCheckout);
    }
    transformCrossOriginEvent(iframeEl, e2) {
        switch(e2.type){
            case $4242ad5853add3e0$var$EventType.FullSnapshot:
                {
                    this.crossOriginIframeMirror.reset(iframeEl);
                    this.crossOriginIframeStyleMirror.reset(iframeEl);
                    this.replaceIdOnNode(e2.data.node, iframeEl);
                    const rootId = e2.data.node.id;
                    this.crossOriginIframeRootIdMap.set(iframeEl, rootId);
                    this.patchRootIdOnNode(e2.data.node, rootId);
                    return {
                        timestamp: e2.timestamp,
                        type: $4242ad5853add3e0$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $4242ad5853add3e0$var$IncrementalSource.Mutation,
                            adds: [
                                {
                                    parentId: this.mirror.getId(iframeEl),
                                    nextId: null,
                                    node: e2.data.node
                                }
                            ],
                            removes: [],
                            texts: [],
                            attributes: [],
                            isAttachIframe: true
                        }
                    };
                }
            case $4242ad5853add3e0$var$EventType.Meta:
            case $4242ad5853add3e0$var$EventType.Load:
            case $4242ad5853add3e0$var$EventType.DomContentLoaded:
                return false;
            case $4242ad5853add3e0$var$EventType.Plugin:
                return e2;
            case $4242ad5853add3e0$var$EventType.Custom:
                this.replaceIds(e2.data.payload, iframeEl, [
                    "id",
                    "parentId",
                    "previousId",
                    "nextId"
                ]);
                return e2;
            case $4242ad5853add3e0$var$EventType.IncrementalSnapshot:
                switch(e2.data.source){
                    case $4242ad5853add3e0$var$IncrementalSource.Mutation:
                        e2.data.adds.forEach((n2)=>{
                            this.replaceIds(n2, iframeEl, [
                                "parentId",
                                "nextId",
                                "previousId"
                            ]);
                            this.replaceIdOnNode(n2.node, iframeEl);
                            const rootId = this.crossOriginIframeRootIdMap.get(iframeEl);
                            rootId && this.patchRootIdOnNode(n2.node, rootId);
                        });
                        e2.data.removes.forEach((n2)=>{
                            this.replaceIds(n2, iframeEl, [
                                "parentId",
                                "id"
                            ]);
                        });
                        e2.data.attributes.forEach((n2)=>{
                            this.replaceIds(n2, iframeEl, [
                                "id"
                            ]);
                        });
                        e2.data.texts.forEach((n2)=>{
                            this.replaceIds(n2, iframeEl, [
                                "id"
                            ]);
                        });
                        return e2;
                    case $4242ad5853add3e0$var$IncrementalSource.Drag:
                    case $4242ad5853add3e0$var$IncrementalSource.TouchMove:
                    case $4242ad5853add3e0$var$IncrementalSource.MouseMove:
                        e2.data.positions.forEach((p)=>{
                            this.replaceIds(p, iframeEl, [
                                "id"
                            ]);
                        });
                        return e2;
                    case $4242ad5853add3e0$var$IncrementalSource.ViewportResize:
                        return false;
                    case $4242ad5853add3e0$var$IncrementalSource.MediaInteraction:
                    case $4242ad5853add3e0$var$IncrementalSource.MouseInteraction:
                    case $4242ad5853add3e0$var$IncrementalSource.Scroll:
                    case $4242ad5853add3e0$var$IncrementalSource.CanvasMutation:
                    case $4242ad5853add3e0$var$IncrementalSource.Input:
                        this.replaceIds(e2.data, iframeEl, [
                            "id"
                        ]);
                        return e2;
                    case $4242ad5853add3e0$var$IncrementalSource.StyleSheetRule:
                    case $4242ad5853add3e0$var$IncrementalSource.StyleDeclaration:
                        this.replaceIds(e2.data, iframeEl, [
                            "id"
                        ]);
                        this.replaceStyleIds(e2.data, iframeEl, [
                            "styleId"
                        ]);
                        return e2;
                    case $4242ad5853add3e0$var$IncrementalSource.Font:
                        return e2;
                    case $4242ad5853add3e0$var$IncrementalSource.Selection:
                        e2.data.ranges.forEach((range)=>{
                            this.replaceIds(range, iframeEl, [
                                "start",
                                "end"
                            ]);
                        });
                        return e2;
                    case $4242ad5853add3e0$var$IncrementalSource.AdoptedStyleSheet:
                        this.replaceIds(e2.data, iframeEl, [
                            "id"
                        ]);
                        this.replaceStyleIds(e2.data, iframeEl, [
                            "styleIds"
                        ]);
                        e2.data.styles?.forEach((style)=>{
                            this.replaceStyleIds(style, iframeEl, [
                                "styleId"
                            ]);
                        });
                        return e2;
                }
        }
        return false;
    }
    replace(iframeMirror, obj, iframeEl, keys) {
        for (const key of keys){
            if (!Array.isArray(obj[key]) && typeof obj[key] !== "number") continue;
            if (Array.isArray(obj[key])) obj[key] = iframeMirror.getIds(iframeEl, obj[key]);
            else obj[key] = iframeMirror.getId(iframeEl, obj[key]);
        }
        return obj;
    }
    replaceIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeMirror, obj, iframeEl, keys);
    }
    replaceStyleIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeStyleMirror, obj, iframeEl, keys);
    }
    replaceIdOnNode(node, iframeEl) {
        this.replaceIds(node, iframeEl, [
            "id",
            "rootId"
        ]);
        if ("childNodes" in node) node.childNodes.forEach((child)=>{
            this.replaceIdOnNode(child, iframeEl);
        });
    }
    patchRootIdOnNode(node, rootId) {
        if (node.type !== $4242ad5853add3e0$var$NodeType$1.Document && !node.rootId) node.rootId = rootId;
        if ("childNodes" in node) node.childNodes.forEach((child)=>{
            this.patchRootIdOnNode(child, rootId);
        });
    }
}
class $4242ad5853add3e0$var$ShadowDomManagerNoop {
    init() {}
    addShadowRoot() {}
    observeAttachShadow() {}
    reset() {}
}
class $4242ad5853add3e0$var$ShadowDomManager {
    constructor(options){
        this.shadowDoms = /* @__PURE__ */ new WeakSet();
        this.restoreHandlers = [];
        this.mutationCb = options.mutationCb;
        this.scrollCb = options.scrollCb;
        this.bypassOptions = options.bypassOptions;
        this.mirror = options.mirror;
        this.init();
    }
    init() {
        this.reset();
        this.patchAttachShadow(Element, document);
    }
    addShadowRoot(shadowRoot, doc) {
        if (!$4242ad5853add3e0$var$isNativeShadowDom(shadowRoot)) return;
        if (this.shadowDoms.has(shadowRoot)) return;
        this.shadowDoms.add(shadowRoot);
        this.bypassOptions.canvasManager.addShadowRoot(shadowRoot);
        const observer = $4242ad5853add3e0$var$initMutationObserver({
            ...this.bypassOptions,
            doc: doc,
            mutationCb: this.mutationCb,
            mirror: this.mirror,
            shadowDomManager: this
        }, shadowRoot);
        this.restoreHandlers.push(()=>observer.disconnect());
        this.restoreHandlers.push($4242ad5853add3e0$var$initScrollObserver({
            ...this.bypassOptions,
            scrollCb: this.scrollCb,
            // https://gist.github.com/praveenpuglia/0832da687ed5a5d7a0907046c9ef1813
            // scroll is not allowed to pass the boundary, so we need to listen the shadow document
            doc: shadowRoot,
            mirror: this.mirror
        }));
        $4242ad5853add3e0$var$setTimeout$2(()=>{
            if (shadowRoot.adoptedStyleSheets && shadowRoot.adoptedStyleSheets.length > 0) this.bypassOptions.stylesheetManager.adoptStyleSheets(shadowRoot.adoptedStyleSheets, this.mirror.getId(shadowRoot.host));
            this.restoreHandlers.push($4242ad5853add3e0$var$initAdoptedStyleSheetObserver({
                mirror: this.mirror,
                stylesheetManager: this.bypassOptions.stylesheetManager
            }, shadowRoot));
        }, 0);
    }
    /**
   * Monkey patch 'attachShadow' of an IFrameElement to observe newly added shadow doms.
   */ observeAttachShadow(iframeElement) {
        const iframeDoc = $4242ad5853add3e0$var$getIFrameContentDocument(iframeElement);
        const iframeWindow = $4242ad5853add3e0$var$getIFrameContentWindow(iframeElement);
        if (!iframeDoc || !iframeWindow) return;
        this.patchAttachShadow(iframeWindow.Element, iframeDoc);
    }
    /**
   * Patch 'attachShadow' to observe newly added shadow doms.
   */ patchAttachShadow(element, doc) {
        const manager = this;
        this.restoreHandlers.push($4242ad5853add3e0$var$patch(element.prototype, "attachShadow", function(original) {
            return function(option) {
                const shadowRoot = original.call(this, option);
                if (this.shadowRoot && $4242ad5853add3e0$var$inDom(this)) manager.addShadowRoot(this.shadowRoot, doc);
                return shadowRoot;
            };
        }));
    }
    reset() {
        this.restoreHandlers.forEach((handler)=>{
            try {
                handler();
            } catch (e2) {}
        });
        this.restoreHandlers = [];
        this.shadowDoms = /* @__PURE__ */ new WeakSet();
        this.bypassOptions.canvasManager.resetShadowRoots();
    }
}
class $4242ad5853add3e0$var$StylesheetManager {
    constructor(options){
        this.trackedLinkElements = /* @__PURE__ */ new WeakSet();
        this.styleMirror = new $4242ad5853add3e0$var$StyleSheetMirror();
        this.mutationCb = options.mutationCb;
        this.adoptedStyleSheetCb = options.adoptedStyleSheetCb;
    }
    attachLinkElement(linkEl, childSn) {
        if ("_cssText" in childSn.attributes) this.mutationCb({
            adds: [],
            removes: [],
            texts: [],
            attributes: [
                {
                    id: childSn.id,
                    attributes: childSn.attributes
                }
            ]
        });
        this.trackLinkElement(linkEl);
    }
    trackLinkElement(linkEl) {
        if (this.trackedLinkElements.has(linkEl)) return;
        this.trackedLinkElements.add(linkEl);
        this.trackStylesheetInLinkElement(linkEl);
    }
    adoptStyleSheets(sheets, hostId) {
        if (sheets.length === 0) return;
        const adoptedStyleSheetData = {
            id: hostId,
            styleIds: []
        };
        const styles = [];
        for (const sheet of sheets){
            let styleId;
            if (!this.styleMirror.has(sheet)) {
                styleId = this.styleMirror.add(sheet);
                styles.push({
                    styleId: styleId,
                    rules: Array.from(sheet.rules || CSSRule, (r2, index)=>({
                            rule: $4242ad5853add3e0$var$stringifyRule(r2),
                            index: index
                        }))
                });
            } else styleId = this.styleMirror.getId(sheet);
            adoptedStyleSheetData.styleIds.push(styleId);
        }
        if (styles.length > 0) adoptedStyleSheetData.styles = styles;
        this.adoptedStyleSheetCb(adoptedStyleSheetData);
    }
    reset() {
        this.styleMirror.reset();
        this.trackedLinkElements = /* @__PURE__ */ new WeakSet();
    }
    // TODO: take snapshot on stylesheet reload by applying event listener
    trackStylesheetInLinkElement(_linkEl) {}
}
class $4242ad5853add3e0$var$ProcessedNodeManager {
    constructor(){
        this.nodeMap = /* @__PURE__ */ new WeakMap();
        this.active = false;
    }
    inOtherBuffer(node, thisBuffer) {
        const buffers = this.nodeMap.get(node);
        return buffers && Array.from(buffers).some((buffer)=>buffer !== thisBuffer);
    }
    add(node, buffer) {
        if (!this.active) {
            this.active = true;
            $4242ad5853add3e0$var$onRequestAnimationFrame(()=>{
                this.nodeMap = /* @__PURE__ */ new WeakMap();
                this.active = false;
            });
        }
        this.nodeMap.set(node, (this.nodeMap.get(node) || /* @__PURE__ */ new Set()).add(buffer));
    }
    destroy() {}
}
let $4242ad5853add3e0$var$wrappedEmit;
let $4242ad5853add3e0$var$_takeFullSnapshot;
try {
    if (Array.from([
        1
    ], (x)=>x * 2)[0] !== 2) {
        const cleanFrame = document.createElement("iframe");
        document.body.appendChild(cleanFrame);
        Array.from = cleanFrame.contentWindow?.Array.from || Array.from;
        document.body.removeChild(cleanFrame);
    }
} catch (err) {
    console.debug("Unable to override Array.from", err);
}
const $4242ad5853add3e0$var$mirror = $4242ad5853add3e0$var$createMirror();
function $4242ad5853add3e0$var$record(options = {}) {
    const { emit: emit, checkoutEveryNms: checkoutEveryNms, checkoutEveryNth: checkoutEveryNth, blockClass: blockClass = "rr-block", blockSelector: blockSelector = null, unblockSelector: unblockSelector = null, ignoreClass: ignoreClass = "rr-ignore", ignoreSelector: ignoreSelector = null, maskAllText: maskAllText = false, maskTextClass: maskTextClass = "rr-mask", unmaskTextClass: unmaskTextClass = null, maskTextSelector: maskTextSelector = null, unmaskTextSelector: unmaskTextSelector = null, inlineStylesheet: inlineStylesheet = true, maskAllInputs: maskAllInputs, maskInputOptions: _maskInputOptions, slimDOMOptions: _slimDOMOptions, maskAttributeFn: maskAttributeFn, maskInputFn: maskInputFn, maskTextFn: maskTextFn, maxCanvasSize: maxCanvasSize = null, packFn: packFn, sampling: sampling = {}, dataURLOptions: dataURLOptions = {}, mousemoveWait: mousemoveWait, recordDOM: recordDOM = true, recordCanvas: recordCanvas = false, recordCrossOriginIframes: recordCrossOriginIframes = false, recordAfter: recordAfter = options.recordAfter === "DOMContentLoaded" ? options.recordAfter : "load", userTriggeredOnInput: userTriggeredOnInput = false, collectFonts: collectFonts = false, inlineImages: inlineImages = false, plugins: plugins, keepIframeSrcFn: keepIframeSrcFn = ()=>false, ignoreCSSAttributes: ignoreCSSAttributes = /* @__PURE__ */ new Set([]), errorHandler: errorHandler, onMutation: onMutation, getCanvasManager: getCanvasManager } = options;
    $4242ad5853add3e0$var$registerErrorHandler(errorHandler);
    const inEmittingFrame = recordCrossOriginIframes ? window.parent === window : true;
    let passEmitsToParent = false;
    if (!inEmittingFrame) try {
        if (window.parent.document) passEmitsToParent = false;
    } catch (e2) {
        passEmitsToParent = true;
    }
    if (inEmittingFrame && !emit) throw new Error("emit function is required");
    if (!inEmittingFrame && !passEmitsToParent) return ()=>{};
    if (mousemoveWait !== void 0 && sampling.mousemove === void 0) sampling.mousemove = mousemoveWait;
    $4242ad5853add3e0$var$mirror.reset();
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true,
        radio: true,
        checkbox: true
    } : _maskInputOptions !== void 0 ? _maskInputOptions : {};
    const slimDOMOptions = _slimDOMOptions === true || _slimDOMOptions === "all" ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaVerification: true,
        // the following are off for slimDOMOptions === true,
        // as they destroy some (hidden) info:
        headMetaAuthorship: _slimDOMOptions === "all",
        headMetaDescKeywords: _slimDOMOptions === "all"
    } : _slimDOMOptions ? _slimDOMOptions : {};
    $4242ad5853add3e0$var$polyfill();
    let lastFullSnapshotEvent;
    let incrementalSnapshotCount = 0;
    const eventProcessor = (e2)=>{
        for (const plugin of plugins || [])if (plugin.eventProcessor) e2 = plugin.eventProcessor(e2);
        if (packFn && // Disable packing events which will be emitted to parent frames.
        !passEmitsToParent) e2 = packFn(e2);
        return e2;
    };
    $4242ad5853add3e0$var$wrappedEmit = (r2, isCheckout)=>{
        const e2 = r2;
        e2.timestamp = $4242ad5853add3e0$var$nowTimestamp();
        if ($4242ad5853add3e0$var$mutationBuffers[0]?.isFrozen() && e2.type !== $4242ad5853add3e0$var$EventType.FullSnapshot && !(e2.type === $4242ad5853add3e0$var$EventType.IncrementalSnapshot && e2.data.source === $4242ad5853add3e0$var$IncrementalSource.Mutation)) $4242ad5853add3e0$var$mutationBuffers.forEach((buf)=>buf.unfreeze());
        if (inEmittingFrame) emit?.(eventProcessor(e2), isCheckout);
        else if (passEmitsToParent) {
            const message = {
                type: "rrweb",
                event: eventProcessor(e2),
                origin: window.location.origin,
                isCheckout: isCheckout
            };
            window.parent.postMessage(message, "*");
        }
        if (e2.type === $4242ad5853add3e0$var$EventType.FullSnapshot) {
            lastFullSnapshotEvent = e2;
            incrementalSnapshotCount = 0;
        } else if (e2.type === $4242ad5853add3e0$var$EventType.IncrementalSnapshot) {
            if (e2.data.source === $4242ad5853add3e0$var$IncrementalSource.Mutation && e2.data.isAttachIframe) return;
            incrementalSnapshotCount++;
            const exceedCount = checkoutEveryNth && incrementalSnapshotCount >= checkoutEveryNth;
            const exceedTime = checkoutEveryNms && lastFullSnapshotEvent && e2.timestamp - lastFullSnapshotEvent.timestamp > checkoutEveryNms;
            if (exceedCount || exceedTime) takeFullSnapshot2(true);
        }
    };
    const wrappedMutationEmit = (m)=>{
        $4242ad5853add3e0$var$wrappedEmit({
            type: $4242ad5853add3e0$var$EventType.IncrementalSnapshot,
            data: {
                source: $4242ad5853add3e0$var$IncrementalSource.Mutation,
                ...m
            }
        });
    };
    const wrappedScrollEmit = (p)=>$4242ad5853add3e0$var$wrappedEmit({
            type: $4242ad5853add3e0$var$EventType.IncrementalSnapshot,
            data: {
                source: $4242ad5853add3e0$var$IncrementalSource.Scroll,
                ...p
            }
        });
    const wrappedCanvasMutationEmit = (p)=>$4242ad5853add3e0$var$wrappedEmit({
            type: $4242ad5853add3e0$var$EventType.IncrementalSnapshot,
            data: {
                source: $4242ad5853add3e0$var$IncrementalSource.CanvasMutation,
                ...p
            }
        });
    const wrappedAdoptedStyleSheetEmit = (a2)=>$4242ad5853add3e0$var$wrappedEmit({
            type: $4242ad5853add3e0$var$EventType.IncrementalSnapshot,
            data: {
                source: $4242ad5853add3e0$var$IncrementalSource.AdoptedStyleSheet,
                ...a2
            }
        });
    const stylesheetManager = new $4242ad5853add3e0$var$StylesheetManager({
        mutationCb: wrappedMutationEmit,
        adoptedStyleSheetCb: wrappedAdoptedStyleSheetEmit
    });
    const iframeManager = typeof __RRWEB_EXCLUDE_IFRAME__ === "boolean" && __RRWEB_EXCLUDE_IFRAME__ ? new $4242ad5853add3e0$var$IframeManagerNoop() : new $4242ad5853add3e0$var$IframeManager({
        mirror: $4242ad5853add3e0$var$mirror,
        mutationCb: wrappedMutationEmit,
        stylesheetManager: stylesheetManager,
        recordCrossOriginIframes: recordCrossOriginIframes,
        wrappedEmit: $4242ad5853add3e0$var$wrappedEmit
    });
    for (const plugin of plugins || [])if (plugin.getMirror) plugin.getMirror({
        nodeMirror: $4242ad5853add3e0$var$mirror,
        crossOriginIframeMirror: iframeManager.crossOriginIframeMirror,
        crossOriginIframeStyleMirror: iframeManager.crossOriginIframeStyleMirror
    });
    const processedNodeManager = new $4242ad5853add3e0$var$ProcessedNodeManager();
    const canvasManager = $4242ad5853add3e0$var$_getCanvasManager(getCanvasManager, {
        mirror: $4242ad5853add3e0$var$mirror,
        win: window,
        mutationCb: (p)=>$4242ad5853add3e0$var$wrappedEmit({
                type: $4242ad5853add3e0$var$EventType.IncrementalSnapshot,
                data: {
                    source: $4242ad5853add3e0$var$IncrementalSource.CanvasMutation,
                    ...p
                }
            }),
        recordCanvas: recordCanvas,
        blockClass: blockClass,
        blockSelector: blockSelector,
        unblockSelector: unblockSelector,
        maxCanvasSize: maxCanvasSize,
        sampling: sampling["canvas"],
        dataURLOptions: dataURLOptions,
        errorHandler: errorHandler
    });
    const shadowDomManager = typeof __RRWEB_EXCLUDE_SHADOW_DOM__ === "boolean" && __RRWEB_EXCLUDE_SHADOW_DOM__ ? new $4242ad5853add3e0$var$ShadowDomManagerNoop() : new $4242ad5853add3e0$var$ShadowDomManager({
        mutationCb: wrappedMutationEmit,
        scrollCb: wrappedScrollEmit,
        bypassOptions: {
            onMutation: onMutation,
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskAllText: maskAllText,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            dataURLOptions: dataURLOptions,
            maskAttributeFn: maskAttributeFn,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            sampling: sampling,
            slimDOMOptions: slimDOMOptions,
            iframeManager: iframeManager,
            stylesheetManager: stylesheetManager,
            canvasManager: canvasManager,
            keepIframeSrcFn: keepIframeSrcFn,
            processedNodeManager: processedNodeManager,
            ignoreCSSAttributes: ignoreCSSAttributes
        },
        mirror: $4242ad5853add3e0$var$mirror
    });
    const takeFullSnapshot2 = (isCheckout = false)=>{
        if (!recordDOM) return;
        $4242ad5853add3e0$var$wrappedEmit({
            type: $4242ad5853add3e0$var$EventType.Meta,
            data: {
                href: window.location.href,
                width: $4242ad5853add3e0$var$getWindowWidth(),
                height: $4242ad5853add3e0$var$getWindowHeight()
            }
        }, isCheckout);
        stylesheetManager.reset();
        shadowDomManager.init();
        $4242ad5853add3e0$var$mutationBuffers.forEach((buf)=>buf.lock());
        const node = $4242ad5853add3e0$var$snapshot(document, {
            mirror: $4242ad5853add3e0$var$mirror,
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskAllText: maskAllText,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskAllInputs: maskInputOptions,
            maskAttributeFn: maskAttributeFn,
            maskInputFn: maskInputFn,
            maskTextFn: maskTextFn,
            slimDOM: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            onSerialize: (n2)=>{
                if ($4242ad5853add3e0$var$isSerializedIframe(n2, $4242ad5853add3e0$var$mirror)) iframeManager.addIframe(n2);
                if ($4242ad5853add3e0$var$isSerializedStylesheet(n2, $4242ad5853add3e0$var$mirror)) stylesheetManager.trackLinkElement(n2);
                if ($4242ad5853add3e0$var$hasShadowRoot(n2)) shadowDomManager.addShadowRoot(n2.shadowRoot, document);
            },
            onIframeLoad: (iframe, childSn)=>{
                iframeManager.attachIframe(iframe, childSn);
                const contentWindow = $4242ad5853add3e0$var$getIFrameContentWindow(iframe);
                if (contentWindow) canvasManager.addWindow(contentWindow);
                shadowDomManager.observeAttachShadow(iframe);
            },
            onStylesheetLoad: (linkEl, childSn)=>{
                stylesheetManager.attachLinkElement(linkEl, childSn);
            },
            onBlockedImageLoad: (_imageEl, serializedNode, { width: width, height: height })=>{
                wrappedMutationEmit({
                    adds: [],
                    removes: [],
                    texts: [],
                    attributes: [
                        {
                            id: serializedNode.id,
                            attributes: {
                                style: {
                                    width: `${width}px`,
                                    height: `${height}px`
                                }
                            }
                        }
                    ]
                });
            },
            keepIframeSrcFn: keepIframeSrcFn,
            ignoreCSSAttributes: ignoreCSSAttributes
        });
        if (!node) return console.warn("Failed to snapshot the document");
        $4242ad5853add3e0$var$wrappedEmit({
            type: $4242ad5853add3e0$var$EventType.FullSnapshot,
            data: {
                node: node,
                initialOffset: $4242ad5853add3e0$var$getWindowScroll(window)
            }
        });
        $4242ad5853add3e0$var$mutationBuffers.forEach((buf)=>buf.unlock());
        if (document.adoptedStyleSheets && document.adoptedStyleSheets.length > 0) stylesheetManager.adoptStyleSheets(document.adoptedStyleSheets, $4242ad5853add3e0$var$mirror.getId(document));
    };
    $4242ad5853add3e0$var$_takeFullSnapshot = takeFullSnapshot2;
    try {
        const handlers = [];
        const observe = (doc)=>{
            return $4242ad5853add3e0$var$callbackWrapper($4242ad5853add3e0$var$initObservers)({
                onMutation: onMutation,
                mutationCb: wrappedMutationEmit,
                mousemoveCb: (positions, source)=>$4242ad5853add3e0$var$wrappedEmit({
                        type: $4242ad5853add3e0$var$EventType.IncrementalSnapshot,
                        data: {
                            source: source,
                            positions: positions
                        }
                    }),
                mouseInteractionCb: (d)=>$4242ad5853add3e0$var$wrappedEmit({
                        type: $4242ad5853add3e0$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $4242ad5853add3e0$var$IncrementalSource.MouseInteraction,
                            ...d
                        }
                    }),
                scrollCb: wrappedScrollEmit,
                viewportResizeCb: (d)=>$4242ad5853add3e0$var$wrappedEmit({
                        type: $4242ad5853add3e0$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $4242ad5853add3e0$var$IncrementalSource.ViewportResize,
                            ...d
                        }
                    }),
                inputCb: (v2)=>$4242ad5853add3e0$var$wrappedEmit({
                        type: $4242ad5853add3e0$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $4242ad5853add3e0$var$IncrementalSource.Input,
                            ...v2
                        }
                    }),
                mediaInteractionCb: (p)=>$4242ad5853add3e0$var$wrappedEmit({
                        type: $4242ad5853add3e0$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $4242ad5853add3e0$var$IncrementalSource.MediaInteraction,
                            ...p
                        }
                    }),
                styleSheetRuleCb: (r2)=>$4242ad5853add3e0$var$wrappedEmit({
                        type: $4242ad5853add3e0$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $4242ad5853add3e0$var$IncrementalSource.StyleSheetRule,
                            ...r2
                        }
                    }),
                styleDeclarationCb: (r2)=>$4242ad5853add3e0$var$wrappedEmit({
                        type: $4242ad5853add3e0$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $4242ad5853add3e0$var$IncrementalSource.StyleDeclaration,
                            ...r2
                        }
                    }),
                canvasMutationCb: wrappedCanvasMutationEmit,
                fontCb: (p)=>$4242ad5853add3e0$var$wrappedEmit({
                        type: $4242ad5853add3e0$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $4242ad5853add3e0$var$IncrementalSource.Font,
                            ...p
                        }
                    }),
                selectionCb: (p)=>{
                    $4242ad5853add3e0$var$wrappedEmit({
                        type: $4242ad5853add3e0$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $4242ad5853add3e0$var$IncrementalSource.Selection,
                            ...p
                        }
                    });
                },
                customElementCb: (c2)=>{
                    $4242ad5853add3e0$var$wrappedEmit({
                        type: $4242ad5853add3e0$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $4242ad5853add3e0$var$IncrementalSource.CustomElement,
                            ...c2
                        }
                    });
                },
                blockClass: blockClass,
                ignoreClass: ignoreClass,
                ignoreSelector: ignoreSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                maskInputOptions: maskInputOptions,
                inlineStylesheet: inlineStylesheet,
                sampling: sampling,
                recordDOM: recordDOM,
                recordCanvas: recordCanvas,
                inlineImages: inlineImages,
                userTriggeredOnInput: userTriggeredOnInput,
                collectFonts: collectFonts,
                doc: doc,
                maskAttributeFn: maskAttributeFn,
                maskInputFn: maskInputFn,
                maskTextFn: maskTextFn,
                keepIframeSrcFn: keepIframeSrcFn,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                mirror: $4242ad5853add3e0$var$mirror,
                iframeManager: iframeManager,
                stylesheetManager: stylesheetManager,
                shadowDomManager: shadowDomManager,
                processedNodeManager: processedNodeManager,
                canvasManager: canvasManager,
                ignoreCSSAttributes: ignoreCSSAttributes,
                plugins: plugins?.filter((p)=>p.observer)?.map((p)=>({
                        observer: p.observer,
                        options: p.options,
                        callback: (payload)=>$4242ad5853add3e0$var$wrappedEmit({
                                type: $4242ad5853add3e0$var$EventType.Plugin,
                                data: {
                                    plugin: p.name,
                                    payload: payload
                                }
                            })
                    })) || []
            }, {});
        };
        iframeManager.addLoadListener((iframeEl)=>{
            try {
                handlers.push(observe(iframeEl.contentDocument));
            } catch (error) {
                console.warn(error);
            }
        });
        const init = ()=>{
            takeFullSnapshot2();
            handlers.push(observe(document));
        };
        if (document.readyState === "interactive" || document.readyState === "complete") init();
        else {
            handlers.push($4242ad5853add3e0$var$on("DOMContentLoaded", ()=>{
                $4242ad5853add3e0$var$wrappedEmit({
                    type: $4242ad5853add3e0$var$EventType.DomContentLoaded,
                    data: {}
                });
                if (recordAfter === "DOMContentLoaded") init();
            }));
            handlers.push($4242ad5853add3e0$var$on("load", ()=>{
                $4242ad5853add3e0$var$wrappedEmit({
                    type: $4242ad5853add3e0$var$EventType.Load,
                    data: {}
                });
                if (recordAfter === "load") init();
            }, window));
        }
        return ()=>{
            handlers.forEach((h)=>h());
            processedNodeManager.destroy();
            $4242ad5853add3e0$var$_takeFullSnapshot = void 0;
            $4242ad5853add3e0$var$unregisterErrorHandler();
        };
    } catch (error) {
        console.warn(error);
    }
}
function $4242ad5853add3e0$var$takeFullSnapshot(isCheckout) {
    if (!$4242ad5853add3e0$var$_takeFullSnapshot) throw new Error("please take full snapshot after start recording");
    $4242ad5853add3e0$var$_takeFullSnapshot(isCheckout);
}
$4242ad5853add3e0$var$record.mirror = $4242ad5853add3e0$var$mirror;
$4242ad5853add3e0$var$record.takeFullSnapshot = $4242ad5853add3e0$var$takeFullSnapshot;
function $4242ad5853add3e0$var$_getCanvasManager(getCanvasManagerFn, options) {
    try {
        return getCanvasManagerFn ? getCanvasManagerFn(options) : new $4242ad5853add3e0$var$CanvasManagerNoop();
    } catch  {
        console.warn("Unable to initialize CanvasManager");
        return new $4242ad5853add3e0$var$CanvasManagerNoop();
    }
}
var $4242ad5853add3e0$var$n;
!function(t2) {
    t2[t2.NotStarted = 0] = "NotStarted", t2[t2.Running = 1] = "Running", t2[t2.Stopped = 2] = "Stopped";
}($4242ad5853add3e0$var$n || ($4242ad5853add3e0$var$n = {}));
const $4242ad5853add3e0$var$ReplayEventTypeIncrementalSnapshot = 3;
const $4242ad5853add3e0$var$ReplayEventTypeCustom = 5;
function $4242ad5853add3e0$var$timestampToMs(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp : timestamp * 1e3;
}
function $4242ad5853add3e0$var$timestampToS(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1e3 : timestamp;
}
function $4242ad5853add3e0$var$addBreadcrumbEvent(replay, breadcrumb) {
    if (breadcrumb.category === "sentry.transaction") return;
    if ([
        "ui.click",
        "ui.input"
    ].includes(breadcrumb.category)) replay.triggerUserActivity();
    else replay.checkAndHandleExpiredSession();
    replay.addUpdate(()=>{
        replay.throttledAddEvent({
            type: $4242ad5853add3e0$var$EventType.Custom,
            // TODO: We were converting from ms to seconds for breadcrumbs, spans,
            // but maybe we should just keep them as milliseconds
            timestamp: (breadcrumb.timestamp || 0) * 1e3,
            data: {
                tag: "breadcrumb",
                // normalize to max. 10 depth and 1_000 properties per object
                payload: (0, $ac4a8bdf538bbe1f$export$a3295358bff77e)(breadcrumb, 10, 1e3)
            }
        });
        return breadcrumb.category === "console";
    });
}
const $4242ad5853add3e0$var$INTERACTIVE_SELECTOR = "button,a";
function $4242ad5853add3e0$var$getClosestInteractive(element) {
    const closestInteractive = element.closest($4242ad5853add3e0$var$INTERACTIVE_SELECTOR);
    return closestInteractive || element;
}
function $4242ad5853add3e0$var$getClickTargetNode(event) {
    const target = $4242ad5853add3e0$var$getTargetNode(event);
    if (!target || !(target instanceof Element)) return target;
    return $4242ad5853add3e0$var$getClosestInteractive(target);
}
function $4242ad5853add3e0$var$getTargetNode(event) {
    if ($4242ad5853add3e0$var$isEventWithTarget(event)) return event.target;
    return event;
}
function $4242ad5853add3e0$var$isEventWithTarget(event) {
    return typeof event === "object" && !!event && "target" in event;
}
let $4242ad5853add3e0$var$handlers;
function $4242ad5853add3e0$var$onWindowOpen(cb) {
    if (!$4242ad5853add3e0$var$handlers) {
        $4242ad5853add3e0$var$handlers = [];
        $4242ad5853add3e0$var$monkeyPatchWindowOpen();
    }
    $4242ad5853add3e0$var$handlers.push(cb);
    return ()=>{
        const pos = $4242ad5853add3e0$var$handlers ? $4242ad5853add3e0$var$handlers.indexOf(cb) : -1;
        if (pos > -1) $4242ad5853add3e0$var$handlers.splice(pos, 1);
    };
}
function $4242ad5853add3e0$var$monkeyPatchWindowOpen() {
    (0, $a964b80d2257757d$export$9563e054e6f787fb)($4242ad5853add3e0$var$WINDOW, "open", function(originalWindowOpen) {
        return function(...args) {
            if ($4242ad5853add3e0$var$handlers) try {
                $4242ad5853add3e0$var$handlers.forEach((handler)=>handler());
            } catch  {}
            return originalWindowOpen.apply($4242ad5853add3e0$var$WINDOW, args);
        };
    });
}
const $4242ad5853add3e0$var$IncrementalMutationSources = /* @__PURE__ */ new Set([
    $4242ad5853add3e0$var$IncrementalSource.Mutation,
    $4242ad5853add3e0$var$IncrementalSource.StyleSheetRule,
    $4242ad5853add3e0$var$IncrementalSource.StyleDeclaration,
    $4242ad5853add3e0$var$IncrementalSource.AdoptedStyleSheet,
    $4242ad5853add3e0$var$IncrementalSource.CanvasMutation,
    $4242ad5853add3e0$var$IncrementalSource.Selection,
    $4242ad5853add3e0$var$IncrementalSource.MediaInteraction
]);
function $4242ad5853add3e0$var$handleClick(clickDetector, clickBreadcrumb, node) {
    clickDetector.handleClick(clickBreadcrumb, node);
}
class $4242ad5853add3e0$var$ClickDetector {
    constructor(replay, slowClickConfig, _addBreadcrumbEvent = $4242ad5853add3e0$var$addBreadcrumbEvent){
        this._lastMutation = 0;
        this._lastScroll = 0;
        this._clicks = [];
        this._timeout = slowClickConfig.timeout / 1e3;
        this._threshold = slowClickConfig.threshold / 1e3;
        this._scrollTimeout = slowClickConfig.scrollTimeout / 1e3;
        this._replay = replay;
        this._ignoreSelector = slowClickConfig.ignoreSelector;
        this._addBreadcrumbEvent = _addBreadcrumbEvent;
    }
    /** Register click detection handlers on mutation or scroll. */ addListeners() {
        const cleanupWindowOpen = $4242ad5853add3e0$var$onWindowOpen(()=>{
            this._lastMutation = $4242ad5853add3e0$var$nowInSeconds();
        });
        this._teardown = ()=>{
            cleanupWindowOpen();
            this._clicks = [];
            this._lastMutation = 0;
            this._lastScroll = 0;
        };
    }
    /** Clean up listeners. */ removeListeners() {
        if (this._teardown) this._teardown();
        if (this._checkClickTimeout) clearTimeout(this._checkClickTimeout);
    }
    /** @inheritDoc */ handleClick(breadcrumb, node) {
        if ($4242ad5853add3e0$var$ignoreElement(node, this._ignoreSelector) || !$4242ad5853add3e0$var$isClickBreadcrumb(breadcrumb)) return;
        const newClick = {
            timestamp: $4242ad5853add3e0$var$timestampToS(breadcrumb.timestamp),
            clickBreadcrumb: breadcrumb,
            // Set this to 0 so we know it originates from the click breadcrumb
            clickCount: 0,
            node: node
        };
        if (this._clicks.some((click)=>click.node === newClick.node && Math.abs(click.timestamp - newClick.timestamp) < 1)) return;
        this._clicks.push(newClick);
        if (this._clicks.length === 1) this._scheduleCheckClicks();
    }
    /** @inheritDoc */ registerMutation(timestamp = Date.now()) {
        this._lastMutation = $4242ad5853add3e0$var$timestampToS(timestamp);
    }
    /** @inheritDoc */ registerScroll(timestamp = Date.now()) {
        this._lastScroll = $4242ad5853add3e0$var$timestampToS(timestamp);
    }
    /** @inheritDoc */ registerClick(element) {
        const node = $4242ad5853add3e0$var$getClosestInteractive(element);
        this._handleMultiClick(node);
    }
    /** Count multiple clicks on elements. */ _handleMultiClick(node) {
        this._getClicks(node).forEach((click)=>{
            click.clickCount++;
        });
    }
    /** Get all pending clicks for a given node. */ _getClicks(node) {
        return this._clicks.filter((click)=>click.node === node);
    }
    /** Check the clicks that happened. */ _checkClicks() {
        const timedOutClicks = [];
        const now = $4242ad5853add3e0$var$nowInSeconds();
        this._clicks.forEach((click)=>{
            if (!click.mutationAfter && this._lastMutation) click.mutationAfter = click.timestamp <= this._lastMutation ? this._lastMutation - click.timestamp : void 0;
            if (!click.scrollAfter && this._lastScroll) click.scrollAfter = click.timestamp <= this._lastScroll ? this._lastScroll - click.timestamp : void 0;
            if (click.timestamp + this._timeout <= now) timedOutClicks.push(click);
        });
        for (const click of timedOutClicks){
            const pos = this._clicks.indexOf(click);
            if (pos > -1) {
                this._generateBreadcrumbs(click);
                this._clicks.splice(pos, 1);
            }
        }
        if (this._clicks.length) this._scheduleCheckClicks();
    }
    /** Generate matching breadcrumb(s) for the click. */ _generateBreadcrumbs(click) {
        const replay = this._replay;
        const hadScroll = click.scrollAfter && click.scrollAfter <= this._scrollTimeout;
        const hadMutation = click.mutationAfter && click.mutationAfter <= this._threshold;
        const isSlowClick = !hadScroll && !hadMutation;
        const { clickCount: clickCount, clickBreadcrumb: clickBreadcrumb } = click;
        if (isSlowClick) {
            const timeAfterClickMs = Math.min(click.mutationAfter || this._timeout, this._timeout) * 1e3;
            const endReason = timeAfterClickMs < this._timeout * 1e3 ? "mutation" : "timeout";
            const breadcrumb = {
                type: "default",
                message: clickBreadcrumb.message,
                timestamp: clickBreadcrumb.timestamp,
                category: "ui.slowClickDetected",
                data: {
                    ...clickBreadcrumb.data,
                    url: $4242ad5853add3e0$var$WINDOW.location.href,
                    route: replay.getCurrentRoute(),
                    timeAfterClickMs: timeAfterClickMs,
                    endReason: endReason,
                    // If clickCount === 0, it means multiClick was not correctly captured here
                    // - we still want to send 1 in this case
                    clickCount: clickCount || 1
                }
            };
            this._addBreadcrumbEvent(replay, breadcrumb);
            return;
        }
        if (clickCount > 1) {
            const breadcrumb = {
                type: "default",
                message: clickBreadcrumb.message,
                timestamp: clickBreadcrumb.timestamp,
                category: "ui.multiClick",
                data: {
                    ...clickBreadcrumb.data,
                    url: $4242ad5853add3e0$var$WINDOW.location.href,
                    route: replay.getCurrentRoute(),
                    clickCount: clickCount,
                    metric: true
                }
            };
            this._addBreadcrumbEvent(replay, breadcrumb);
        }
    }
    /** Schedule to check current clicks. */ _scheduleCheckClicks() {
        if (this._checkClickTimeout) clearTimeout(this._checkClickTimeout);
        this._checkClickTimeout = (0, $546e120bd13c90e4$export$831dc9f2ab0a617b)(()=>this._checkClicks(), 1e3);
    }
}
const $4242ad5853add3e0$var$SLOW_CLICK_TAGS = [
    "A",
    "BUTTON",
    "INPUT"
];
function $4242ad5853add3e0$var$ignoreElement(node, ignoreSelector) {
    if (!$4242ad5853add3e0$var$SLOW_CLICK_TAGS.includes(node.tagName)) return true;
    if (node.tagName === "INPUT" && ![
        "submit",
        "button"
    ].includes(node.getAttribute("type") || "")) return true;
    if (node.tagName === "A" && (node.hasAttribute("download") || node.hasAttribute("target") && node.getAttribute("target") !== "_self")) return true;
    if (ignoreSelector && node.matches(ignoreSelector)) return true;
    return false;
}
function $4242ad5853add3e0$var$isClickBreadcrumb(breadcrumb) {
    return !!(breadcrumb.data && typeof breadcrumb.data.nodeId === "number" && breadcrumb.timestamp);
}
function $4242ad5853add3e0$var$nowInSeconds() {
    return Date.now() / 1e3;
}
function $4242ad5853add3e0$var$updateClickDetectorForRecordingEvent(clickDetector, event) {
    try {
        if (!$4242ad5853add3e0$var$isIncrementalEvent(event)) return;
        const { source: source } = event.data;
        if ($4242ad5853add3e0$var$IncrementalMutationSources.has(source)) clickDetector.registerMutation(event.timestamp);
        if (source === $4242ad5853add3e0$var$IncrementalSource.Scroll) clickDetector.registerScroll(event.timestamp);
        if ($4242ad5853add3e0$var$isIncrementalMouseInteraction(event)) {
            const { type: type, id: id } = event.data;
            const node = $4242ad5853add3e0$var$record.mirror.getNode(id);
            if (node instanceof HTMLElement && type === $4242ad5853add3e0$var$MouseInteractions.Click) clickDetector.registerClick(node);
        }
    } catch  {}
}
function $4242ad5853add3e0$var$isIncrementalEvent(event) {
    return event.type === $4242ad5853add3e0$var$ReplayEventTypeIncrementalSnapshot;
}
function $4242ad5853add3e0$var$isIncrementalMouseInteraction(event) {
    return event.data.source === $4242ad5853add3e0$var$IncrementalSource.MouseInteraction;
}
function $4242ad5853add3e0$var$createBreadcrumb(breadcrumb) {
    return {
        timestamp: Date.now() / 1e3,
        type: "default",
        ...breadcrumb
    };
}
var $4242ad5853add3e0$var$NodeType = /* @__PURE__ */ ((NodeType2)=>{
    NodeType2[NodeType2["Document"] = 0] = "Document";
    NodeType2[NodeType2["DocumentType"] = 1] = "DocumentType";
    NodeType2[NodeType2["Element"] = 2] = "Element";
    NodeType2[NodeType2["Text"] = 3] = "Text";
    NodeType2[NodeType2["CDATA"] = 4] = "CDATA";
    NodeType2[NodeType2["Comment"] = 5] = "Comment";
    return NodeType2;
})($4242ad5853add3e0$var$NodeType || {});
const $4242ad5853add3e0$var$ATTRIBUTES_TO_RECORD = /* @__PURE__ */ new Set([
    "id",
    "class",
    "aria-label",
    "role",
    "name",
    "alt",
    "title",
    "data-test-id",
    "data-testid",
    "disabled",
    "aria-disabled",
    "data-sentry-component"
]);
function $4242ad5853add3e0$var$getAttributesToRecord(attributes) {
    const obj = {};
    if (!attributes["data-sentry-component"] && attributes["data-sentry-element"]) attributes["data-sentry-component"] = attributes["data-sentry-element"];
    for(const key in attributes)if ($4242ad5853add3e0$var$ATTRIBUTES_TO_RECORD.has(key)) {
        let normalizedKey = key;
        if (key === "data-testid" || key === "data-test-id") normalizedKey = "testId";
        obj[normalizedKey] = attributes[key];
    }
    return obj;
}
const $4242ad5853add3e0$var$handleDomListener = (replay)=>{
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $4242ad5853add3e0$var$handleDom(handlerData);
        if (!result) return;
        const isClick = handlerData.name === "click";
        const event = isClick ? handlerData.event : void 0;
        if (isClick && replay.clickDetector && event?.target && !event.altKey && !event.metaKey && !event.ctrlKey && !event.shiftKey) $4242ad5853add3e0$var$handleClick(replay.clickDetector, result, $4242ad5853add3e0$var$getClickTargetNode(handlerData.event));
        $4242ad5853add3e0$var$addBreadcrumbEvent(replay, result);
    };
};
function $4242ad5853add3e0$var$getBaseDomBreadcrumb(target, message) {
    const nodeId = $4242ad5853add3e0$var$record.mirror.getId(target);
    const node = nodeId && $4242ad5853add3e0$var$record.mirror.getNode(nodeId);
    const meta = node && $4242ad5853add3e0$var$record.mirror.getMeta(node);
    const element = meta && $4242ad5853add3e0$var$isElement(meta) ? meta : null;
    return {
        message: message,
        data: element ? {
            nodeId: nodeId,
            node: {
                id: nodeId,
                tagName: element.tagName,
                textContent: Array.from(element.childNodes).map((node2)=>node2.type === $4242ad5853add3e0$var$NodeType.Text && node2.textContent).filter(Boolean).map((text)=>text.trim()).join(""),
                attributes: $4242ad5853add3e0$var$getAttributesToRecord(element.attributes)
            }
        } : {}
    };
}
function $4242ad5853add3e0$var$handleDom(handlerData) {
    const { target: target, message: message } = $4242ad5853add3e0$var$getDomTarget(handlerData);
    return $4242ad5853add3e0$var$createBreadcrumb({
        category: `ui.${handlerData.name}`,
        ...$4242ad5853add3e0$var$getBaseDomBreadcrumb(target, message)
    });
}
function $4242ad5853add3e0$var$getDomTarget(handlerData) {
    const isClick = handlerData.name === "click";
    let message;
    let target = null;
    try {
        target = isClick ? $4242ad5853add3e0$var$getClickTargetNode(handlerData.event) : $4242ad5853add3e0$var$getTargetNode(handlerData.event);
        message = (0, $dea6f7c3fc893264$export$5647df6b7814ac86)(target, {
            maxStringLength: 200
        }) || "<unknown>";
    } catch  {
        message = "<unknown>";
    }
    return {
        target: target,
        message: message
    };
}
function $4242ad5853add3e0$var$isElement(node) {
    return node.type === $4242ad5853add3e0$var$NodeType.Element;
}
function $4242ad5853add3e0$var$handleKeyboardEvent(replay, event) {
    if (!replay.isEnabled()) return;
    replay.updateUserActivity();
    const breadcrumb = $4242ad5853add3e0$var$getKeyboardBreadcrumb(event);
    if (!breadcrumb) return;
    $4242ad5853add3e0$var$addBreadcrumbEvent(replay, breadcrumb);
}
function $4242ad5853add3e0$var$getKeyboardBreadcrumb(event) {
    const { metaKey: metaKey, shiftKey: shiftKey, ctrlKey: ctrlKey, altKey: altKey, key: key, target: target } = event;
    if (!target || $4242ad5853add3e0$var$isInputElement(target) || !key) return null;
    const hasModifierKey = metaKey || ctrlKey || altKey;
    const isCharacterKey = key.length === 1;
    if (!hasModifierKey && isCharacterKey) return null;
    const message = (0, $dea6f7c3fc893264$export$5647df6b7814ac86)(target, {
        maxStringLength: 200
    }) || "<unknown>";
    const baseBreadcrumb = $4242ad5853add3e0$var$getBaseDomBreadcrumb(target, message);
    return $4242ad5853add3e0$var$createBreadcrumb({
        category: "ui.keyDown",
        message: message,
        data: {
            ...baseBreadcrumb.data,
            metaKey: metaKey,
            shiftKey: shiftKey,
            ctrlKey: ctrlKey,
            altKey: altKey,
            key: key
        }
    });
}
function $4242ad5853add3e0$var$isInputElement(target) {
    return target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable;
}
const $4242ad5853add3e0$var$ENTRY_TYPES = {
    // @ts-expect-error TODO: entry type does not fit the create* functions entry type
    resource: $4242ad5853add3e0$var$createResourceEntry,
    paint: $4242ad5853add3e0$var$createPaintEntry,
    // @ts-expect-error TODO: entry type does not fit the create* functions entry type
    navigation: $4242ad5853add3e0$var$createNavigationEntry
};
function $4242ad5853add3e0$var$webVitalHandler(getter, replay) {
    return ({ metric: metric })=>void replay.replayPerformanceEntries.push(getter(metric));
}
function $4242ad5853add3e0$var$createPerformanceEntries(entries) {
    return entries.map($4242ad5853add3e0$var$createPerformanceEntry).filter(Boolean);
}
function $4242ad5853add3e0$var$createPerformanceEntry(entry) {
    const entryType = $4242ad5853add3e0$var$ENTRY_TYPES[entry.entryType];
    if (!entryType) return null;
    return entryType(entry);
}
function $4242ad5853add3e0$var$getAbsoluteTime(time) {
    return (((0, $fd9cf0b48f691186$export$baf075a948ffc0bf)() || $4242ad5853add3e0$var$WINDOW.performance.timeOrigin) + time) / 1e3;
}
function $4242ad5853add3e0$var$createPaintEntry(entry) {
    const { duration: duration, entryType: entryType, name: name, startTime: startTime } = entry;
    const start = $4242ad5853add3e0$var$getAbsoluteTime(startTime);
    return {
        type: entryType,
        name: name,
        start: start,
        end: start + duration,
        data: void 0
    };
}
function $4242ad5853add3e0$var$createNavigationEntry(entry) {
    const { entryType: entryType, name: name, decodedBodySize: decodedBodySize, duration: duration, domComplete: domComplete, encodedBodySize: encodedBodySize, domContentLoadedEventStart: domContentLoadedEventStart, domContentLoadedEventEnd: domContentLoadedEventEnd, domInteractive: domInteractive, loadEventStart: loadEventStart, loadEventEnd: loadEventEnd, redirectCount: redirectCount, startTime: startTime, transferSize: transferSize, type: type } = entry;
    if (duration === 0) return null;
    return {
        type: `${entryType}.${type}`,
        start: $4242ad5853add3e0$var$getAbsoluteTime(startTime),
        end: $4242ad5853add3e0$var$getAbsoluteTime(domComplete),
        name: name,
        data: {
            size: transferSize,
            decodedBodySize: decodedBodySize,
            encodedBodySize: encodedBodySize,
            duration: duration,
            domInteractive: domInteractive,
            domContentLoadedEventStart: domContentLoadedEventStart,
            domContentLoadedEventEnd: domContentLoadedEventEnd,
            loadEventStart: loadEventStart,
            loadEventEnd: loadEventEnd,
            domComplete: domComplete,
            redirectCount: redirectCount
        }
    };
}
function $4242ad5853add3e0$var$createResourceEntry(entry) {
    const { entryType: entryType, initiatorType: initiatorType, name: name, responseEnd: responseEnd, startTime: startTime, decodedBodySize: decodedBodySize, encodedBodySize: encodedBodySize, responseStatus: responseStatus, transferSize: transferSize } = entry;
    if ([
        "fetch",
        "xmlhttprequest"
    ].includes(initiatorType)) return null;
    return {
        type: `${entryType}.${initiatorType}`,
        start: $4242ad5853add3e0$var$getAbsoluteTime(startTime),
        end: $4242ad5853add3e0$var$getAbsoluteTime(responseEnd),
        name: name,
        data: {
            size: transferSize,
            statusCode: responseStatus,
            decodedBodySize: decodedBodySize,
            encodedBodySize: encodedBodySize
        }
    };
}
function $4242ad5853add3e0$var$getLargestContentfulPaint(metric) {
    const lastEntry = metric.entries[metric.entries.length - 1];
    const node = lastEntry?.element ? [
        lastEntry.element
    ] : void 0;
    return $4242ad5853add3e0$var$getWebVital(metric, "largest-contentful-paint", node);
}
function $4242ad5853add3e0$var$isLayoutShift(entry) {
    return entry.sources !== void 0;
}
function $4242ad5853add3e0$var$getCumulativeLayoutShift(metric) {
    const layoutShifts = [];
    const nodes = [];
    for (const entry of metric.entries)if ($4242ad5853add3e0$var$isLayoutShift(entry)) {
        const nodeIds = [];
        for (const source of entry.sources)if (source.node) {
            nodes.push(source.node);
            const nodeId = $4242ad5853add3e0$var$record.mirror.getId(source.node);
            if (nodeId) nodeIds.push(nodeId);
        }
        layoutShifts.push({
            value: entry.value,
            nodeIds: nodeIds.length ? nodeIds : void 0
        });
    }
    return $4242ad5853add3e0$var$getWebVital(metric, "cumulative-layout-shift", nodes, layoutShifts);
}
function $4242ad5853add3e0$var$getInteractionToNextPaint(metric) {
    const lastEntry = metric.entries[metric.entries.length - 1];
    const node = lastEntry?.target ? [
        lastEntry.target
    ] : void 0;
    return $4242ad5853add3e0$var$getWebVital(metric, "interaction-to-next-paint", node);
}
function $4242ad5853add3e0$var$getWebVital(metric, name, nodes, attributions) {
    const value = metric.value;
    const rating = metric.rating;
    const end = $4242ad5853add3e0$var$getAbsoluteTime(value);
    return {
        type: "web-vital",
        name: name,
        start: end,
        end: end,
        data: {
            value: value,
            size: value,
            rating: rating,
            nodeIds: nodes ? nodes.map((node)=>$4242ad5853add3e0$var$record.mirror.getId(node)) : void 0,
            attributions: attributions
        }
    };
}
function $4242ad5853add3e0$var$setupPerformanceObserver(replay) {
    function addPerformanceEntry(entry) {
        if (!replay.performanceEntries.includes(entry)) replay.performanceEntries.push(entry);
    }
    function onEntries({ entries: entries }) {
        entries.forEach(addPerformanceEntry);
    }
    const clearCallbacks = [];
    [
        "navigation",
        "paint",
        "resource"
    ].forEach((type)=>{
        clearCallbacks.push((0, $8997673cf5a7dcf8$export$69816c1a049f8db6)(type, onEntries));
    });
    clearCallbacks.push((0, $8997673cf5a7dcf8$export$3fd4b53331200102)($4242ad5853add3e0$var$webVitalHandler($4242ad5853add3e0$var$getLargestContentfulPaint, replay)), (0, $8997673cf5a7dcf8$export$861b82818b37ba5b)($4242ad5853add3e0$var$webVitalHandler($4242ad5853add3e0$var$getCumulativeLayoutShift, replay)), (0, $8997673cf5a7dcf8$export$da3b76aa2022cbd7)($4242ad5853add3e0$var$webVitalHandler($4242ad5853add3e0$var$getInteractionToNextPaint, replay)));
    return ()=>{
        clearCallbacks.forEach((clearCallback)=>clearCallback());
    };
}
const $4242ad5853add3e0$var$DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;
const $4242ad5853add3e0$var$r = `var t=Uint8Array,n=Uint16Array,r=Int32Array,e=new t([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0,0,0,0]),i=new t([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13,0,0]),s=new t([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),a=function(t,e){for(var i=new n(31),s=0;s<31;++s)i[s]=e+=1<<t[s-1];var a=new r(i[30]);for(s=1;s<30;++s)for(var o=i[s];o<i[s+1];++o)a[o]=o-i[s]<<5|s;return{b:i,r:a}},o=a(e,2),h=o.b,f=o.r;h[28]=258,f[258]=28;for(var l=a(i,0).r,u=new n(32768),c=0;c<32768;++c){var v=(43690&c)>>1|(21845&c)<<1;v=(61680&(v=(52428&v)>>2|(13107&v)<<2))>>4|(3855&v)<<4,u[c]=((65280&v)>>8|(255&v)<<8)>>1}var d=function(t,r,e){for(var i=t.length,s=0,a=new n(r);s<i;++s)t[s]&&++a[t[s]-1];var o,h=new n(r);for(s=1;s<r;++s)h[s]=h[s-1]+a[s-1]<<1;if(e){o=new n(1<<r);var f=15-r;for(s=0;s<i;++s)if(t[s])for(var l=s<<4|t[s],c=r-t[s],v=h[t[s]-1]++<<c,d=v|(1<<c)-1;v<=d;++v)o[u[v]>>f]=l}else for(o=new n(i),s=0;s<i;++s)t[s]&&(o[s]=u[h[t[s]-1]++]>>15-t[s]);return o},p=new t(288);for(c=0;c<144;++c)p[c]=8;for(c=144;c<256;++c)p[c]=9;for(c=256;c<280;++c)p[c]=7;for(c=280;c<288;++c)p[c]=8;var g=new t(32);for(c=0;c<32;++c)g[c]=5;var w=d(p,9,0),y=d(g,5,0),m=function(t){return(t+7)/8|0},b=function(n,r,e){return(null==e||e>n.length)&&(e=n.length),new t(n.subarray(r,e))},M=["unexpected EOF","invalid block type","invalid length/literal","invalid distance","stream finished","no stream handler",,"no callback","invalid UTF-8 data","extra field too long","date not in range 1980-2099","filename too long","stream finishing","invalid zip data"],E=function(t,n,r){var e=new Error(n||M[t]);if(e.code=t,Error.captureStackTrace&&Error.captureStackTrace(e,E),!r)throw e;return e},z=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8},_=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8,t[e+2]|=r>>16},x=function(r,e){for(var i=[],s=0;s<r.length;++s)r[s]&&i.push({s:s,f:r[s]});var a=i.length,o=i.slice();if(!a)return{t:F,l:0};if(1==a){var h=new t(i[0].s+1);return h[i[0].s]=1,{t:h,l:1}}i.sort(function(t,n){return t.f-n.f}),i.push({s:-1,f:25001});var f=i[0],l=i[1],u=0,c=1,v=2;for(i[0]={s:-1,f:f.f+l.f,l:f,r:l};c!=a-1;)f=i[i[u].f<i[v].f?u++:v++],l=i[u!=c&&i[u].f<i[v].f?u++:v++],i[c++]={s:-1,f:f.f+l.f,l:f,r:l};var d=o[0].s;for(s=1;s<a;++s)o[s].s>d&&(d=o[s].s);var p=new n(d+1),g=A(i[c-1],p,0);if(g>e){s=0;var w=0,y=g-e,m=1<<y;for(o.sort(function(t,n){return p[n.s]-p[t.s]||t.f-n.f});s<a;++s){var b=o[s].s;if(!(p[b]>e))break;w+=m-(1<<g-p[b]),p[b]=e}for(w>>=y;w>0;){var M=o[s].s;p[M]<e?w-=1<<e-p[M]++-1:++s}for(;s>=0&&w;--s){var E=o[s].s;p[E]==e&&(--p[E],++w)}g=e}return{t:new t(p),l:g}},A=function(t,n,r){return-1==t.s?Math.max(A(t.l,n,r+1),A(t.r,n,r+1)):n[t.s]=r},D=function(t){for(var r=t.length;r&&!t[--r];);for(var e=new n(++r),i=0,s=t[0],a=1,o=function(t){e[i++]=t},h=1;h<=r;++h)if(t[h]==s&&h!=r)++a;else{if(!s&&a>2){for(;a>138;a-=138)o(32754);a>2&&(o(a>10?a-11<<5|28690:a-3<<5|12305),a=0)}else if(a>3){for(o(s),--a;a>6;a-=6)o(8304);a>2&&(o(a-3<<5|8208),a=0)}for(;a--;)o(s);a=1,s=t[h]}return{c:e.subarray(0,i),n:r}},T=function(t,n){for(var r=0,e=0;e<n.length;++e)r+=t[e]*n[e];return r},k=function(t,n,r){var e=r.length,i=m(n+2);t[i]=255&e,t[i+1]=e>>8,t[i+2]=255^t[i],t[i+3]=255^t[i+1];for(var s=0;s<e;++s)t[i+s+4]=r[s];return 8*(i+4+e)},U=function(t,r,a,o,h,f,l,u,c,v,m){z(r,m++,a),++h[256];for(var b=x(h,15),M=b.t,E=b.l,A=x(f,15),U=A.t,C=A.l,F=D(M),I=F.c,S=F.n,L=D(U),O=L.c,j=L.n,q=new n(19),B=0;B<I.length;++B)++q[31&I[B]];for(B=0;B<O.length;++B)++q[31&O[B]];for(var G=x(q,7),H=G.t,J=G.l,K=19;K>4&&!H[s[K-1]];--K);var N,P,Q,R,V=v+5<<3,W=T(h,p)+T(f,g)+l,X=T(h,M)+T(f,U)+l+14+3*K+T(q,H)+2*q[16]+3*q[17]+7*q[18];if(c>=0&&V<=W&&V<=X)return k(r,m,t.subarray(c,c+v));if(z(r,m,1+(X<W)),m+=2,X<W){N=d(M,E,0),P=M,Q=d(U,C,0),R=U;var Y=d(H,J,0);z(r,m,S-257),z(r,m+5,j-1),z(r,m+10,K-4),m+=14;for(B=0;B<K;++B)z(r,m+3*B,H[s[B]]);m+=3*K;for(var Z=[I,O],$=0;$<2;++$){var tt=Z[$];for(B=0;B<tt.length;++B){var nt=31&tt[B];z(r,m,Y[nt]),m+=H[nt],nt>15&&(z(r,m,tt[B]>>5&127),m+=tt[B]>>12)}}}else N=w,P=p,Q=y,R=g;for(B=0;B<u;++B){var rt=o[B];if(rt>255){_(r,m,N[(nt=rt>>18&31)+257]),m+=P[nt+257],nt>7&&(z(r,m,rt>>23&31),m+=e[nt]);var et=31&rt;_(r,m,Q[et]),m+=R[et],et>3&&(_(r,m,rt>>5&8191),m+=i[et])}else _(r,m,N[rt]),m+=P[rt]}return _(r,m,N[256]),m+P[256]},C=new r([65540,131080,131088,131104,262176,1048704,1048832,2114560,2117632]),F=new t(0),I=function(){for(var t=new Int32Array(256),n=0;n<256;++n){for(var r=n,e=9;--e;)r=(1&r&&-306674912)^r>>>1;t[n]=r}return t}(),S=function(){var t=1,n=0;return{p:function(r){for(var e=t,i=n,s=0|r.length,a=0;a!=s;){for(var o=Math.min(a+2655,s);a<o;++a)i+=e+=r[a];e=(65535&e)+15*(e>>16),i=(65535&i)+15*(i>>16)}t=e,n=i},d:function(){return(255&(t%=65521))<<24|(65280&t)<<8|(255&(n%=65521))<<8|n>>8}}},L=function(s,a,o,h,u){if(!u&&(u={l:1},a.dictionary)){var c=a.dictionary.subarray(-32768),v=new t(c.length+s.length);v.set(c),v.set(s,c.length),s=v,u.w=c.length}return function(s,a,o,h,u,c){var v=c.z||s.length,d=new t(h+v+5*(1+Math.ceil(v/7e3))+u),p=d.subarray(h,d.length-u),g=c.l,w=7&(c.r||0);if(a){w&&(p[0]=c.r>>3);for(var y=C[a-1],M=y>>13,E=8191&y,z=(1<<o)-1,_=c.p||new n(32768),x=c.h||new n(z+1),A=Math.ceil(o/3),D=2*A,T=function(t){return(s[t]^s[t+1]<<A^s[t+2]<<D)&z},F=new r(25e3),I=new n(288),S=new n(32),L=0,O=0,j=c.i||0,q=0,B=c.w||0,G=0;j+2<v;++j){var H=T(j),J=32767&j,K=x[H];if(_[J]=K,x[H]=J,B<=j){var N=v-j;if((L>7e3||q>24576)&&(N>423||!g)){w=U(s,p,0,F,I,S,O,q,G,j-G,w),q=L=O=0,G=j;for(var P=0;P<286;++P)I[P]=0;for(P=0;P<30;++P)S[P]=0}var Q=2,R=0,V=E,W=J-K&32767;if(N>2&&H==T(j-W))for(var X=Math.min(M,N)-1,Y=Math.min(32767,j),Z=Math.min(258,N);W<=Y&&--V&&J!=K;){if(s[j+Q]==s[j+Q-W]){for(var $=0;$<Z&&s[j+$]==s[j+$-W];++$);if($>Q){if(Q=$,R=W,$>X)break;var tt=Math.min(W,$-2),nt=0;for(P=0;P<tt;++P){var rt=j-W+P&32767,et=rt-_[rt]&32767;et>nt&&(nt=et,K=rt)}}}W+=(J=K)-(K=_[J])&32767}if(R){F[q++]=268435456|f[Q]<<18|l[R];var it=31&f[Q],st=31&l[R];O+=e[it]+i[st],++I[257+it],++S[st],B=j+Q,++L}else F[q++]=s[j],++I[s[j]]}}for(j=Math.max(j,B);j<v;++j)F[q++]=s[j],++I[s[j]];w=U(s,p,g,F,I,S,O,q,G,j-G,w),g||(c.r=7&w|p[w/8|0]<<3,w-=7,c.h=x,c.p=_,c.i=j,c.w=B)}else{for(j=c.w||0;j<v+g;j+=65535){var at=j+65535;at>=v&&(p[w/8|0]=g,at=v),w=k(p,w+1,s.subarray(j,at))}c.i=v}return b(d,0,h+m(w)+u)}(s,null==a.level?6:a.level,null==a.mem?u.l?Math.ceil(1.5*Math.max(8,Math.min(13,Math.log(s.length)))):20:12+a.mem,o,h,u)},O=function(t,n,r){for(;r;++n)t[n]=r,r>>>=8},j=function(){function n(n,r){if("function"==typeof n&&(r=n,n={}),this.ondata=r,this.o=n||{},this.s={l:0,i:32768,w:32768,z:32768},this.b=new t(98304),this.o.dictionary){var e=this.o.dictionary.subarray(-32768);this.b.set(e,32768-e.length),this.s.i=32768-e.length}}return n.prototype.p=function(t,n){this.ondata(L(t,this.o,0,0,this.s),n)},n.prototype.push=function(n,r){this.ondata||E(5),this.s.l&&E(4);var e=n.length+this.s.z;if(e>this.b.length){if(e>2*this.b.length-32768){var i=new t(-32768&e);i.set(this.b.subarray(0,this.s.z)),this.b=i}var s=this.b.length-this.s.z;this.b.set(n.subarray(0,s),this.s.z),this.s.z=this.b.length,this.p(this.b,!1),this.b.set(this.b.subarray(-32768)),this.b.set(n.subarray(s),32768),this.s.z=n.length-s+32768,this.s.i=32766,this.s.w=32768}else this.b.set(n,this.s.z),this.s.z+=n.length;this.s.l=1&r,(this.s.z>this.s.w+8191||r)&&(this.p(this.b,r||!1),this.s.w=this.s.i,this.s.i-=2)},n.prototype.flush=function(){this.ondata||E(5),this.s.l&&E(4),this.p(this.b,!1),this.s.w=this.s.i,this.s.i-=2},n}();function q(t,n){n||(n={});var r=function(){var t=-1;return{p:function(n){for(var r=t,e=0;e<n.length;++e)r=I[255&r^n[e]]^r>>>8;t=r},d:function(){return~t}}}(),e=t.length;r.p(t);var i,s=L(t,n,10+((i=n).filename?i.filename.length+1:0),8),a=s.length;return function(t,n){var r=n.filename;if(t[0]=31,t[1]=139,t[2]=8,t[8]=n.level<2?4:9==n.level?2:0,t[9]=3,0!=n.mtime&&O(t,4,Math.floor(new Date(n.mtime||Date.now())/1e3)),r){t[3]=8;for(var e=0;e<=r.length;++e)t[e+10]=r.charCodeAt(e)}}(s,n),O(s,a-8,r.d()),O(s,a-4,e),s}var B=function(){function t(t,n){this.c=S(),this.v=1,j.call(this,t,n)}return t.prototype.push=function(t,n){this.c.p(t),j.prototype.push.call(this,t,n)},t.prototype.p=function(t,n){var r=L(t,this.o,this.v&&(this.o.dictionary?6:2),n&&4,this.s);this.v&&(function(t,n){var r=n.level,e=0==r?0:r<6?1:9==r?3:2;if(t[0]=120,t[1]=e<<6|(n.dictionary&&32),t[1]|=31-(t[0]<<8|t[1])%31,n.dictionary){var i=S();i.p(n.dictionary),O(t,2,i.d())}}(r,this.o),this.v=0),n&&O(r,r.length-4,this.c.d()),this.ondata(r,n)},t.prototype.flush=function(){j.prototype.flush.call(this)},t}(),G="undefined"!=typeof TextEncoder&&new TextEncoder,H="undefined"!=typeof TextDecoder&&new TextDecoder;try{H.decode(F,{stream:!0})}catch(t){}var J=function(){function t(t){this.ondata=t}return t.prototype.push=function(t,n){this.ondata||E(5),this.d&&E(4),this.ondata(K(t),this.d=n||!1)},t}();function K(n,r){if(G)return G.encode(n);for(var e=n.length,i=new t(n.length+(n.length>>1)),s=0,a=function(t){i[s++]=t},o=0;o<e;++o){if(s+5>i.length){var h=new t(s+8+(e-o<<1));h.set(i),i=h}var f=n.charCodeAt(o);f<128||r?a(f):f<2048?(a(192|f>>6),a(128|63&f)):f>55295&&f<57344?(a(240|(f=65536+(1047552&f)|1023&n.charCodeAt(++o))>>18),a(128|f>>12&63),a(128|f>>6&63),a(128|63&f)):(a(224|f>>12),a(128|f>>6&63),a(128|63&f))}return b(i,0,s)}const N=new class{constructor(){this._init()}clear(){this._init()}addEvent(t){if(!t)throw new Error("Adding invalid event");const n=this._hasEvents?",":"";this.stream.push(n+t),this._hasEvents=!0}finish(){this.stream.push("]",!0);const t=function(t){let n=0;for(const r of t)n+=r.length;const r=new Uint8Array(n);for(let n=0,e=0,i=t.length;n<i;n++){const i=t[n];r.set(i,e),e+=i.length}return r}(this._deflatedData);return this._init(),t}_init(){this._hasEvents=!1,this._deflatedData=[],this.deflate=new B,this.deflate.ondata=(t,n)=>{this._deflatedData.push(t)},this.stream=new J((t,n)=>{this.deflate.push(t,n)}),this.stream.push("[")}},P={clear:()=>{N.clear()},addEvent:t=>N.addEvent(t),finish:()=>N.finish(),compress:t=>function(t){return q(K(t))}(t)};addEventListener("message",function(t){const n=t.data.method,r=t.data.id,e=t.data.arg;if(n in P&&"function"==typeof P[n])try{const t=P[n](e);postMessage({id:r,method:n,success:!0,response:t})}catch(t){postMessage({id:r,method:n,success:!1,response:t.message}),console.error(t)}}),postMessage({id:void 0,method:"init",success:!0,response:void 0});`;
function $4242ad5853add3e0$var$e() {
    const e2 = new Blob([
        $4242ad5853add3e0$var$r
    ]);
    return URL.createObjectURL(e2);
}
const $4242ad5853add3e0$var$CONSOLE_LEVELS = [
    "log",
    "warn",
    "error"
];
const $4242ad5853add3e0$var$PREFIX = "[Replay] ";
function $4242ad5853add3e0$var$_addBreadcrumb(message, level = "info") {
    (0, $48d39529e25626c6$export$efda9a273d7a036d)({
        category: "console",
        data: {
            logger: "replay"
        },
        level: level,
        message: `${$4242ad5853add3e0$var$PREFIX}${message}`
    }, {
        level: level
    });
}
function $4242ad5853add3e0$var$makeReplayDebugLogger() {
    let _capture = false;
    let _trace = false;
    const _debug = {
        exception: ()=>void 0,
        infoTick: ()=>void 0,
        setConfig: (opts)=>{
            _capture = !!opts.captureExceptions;
            _trace = !!opts.traceInternals;
        }
    };
    if ($4242ad5853add3e0$var$DEBUG_BUILD) {
        $4242ad5853add3e0$var$CONSOLE_LEVELS.forEach((name)=>{
            _debug[name] = (...args)=>{
                (0, $dd4af310e95b2daa$export$1c9f709888824e05)[name]($4242ad5853add3e0$var$PREFIX, ...args);
                if (_trace) $4242ad5853add3e0$var$_addBreadcrumb(args.join(""), (0, $daafc8621233a3bd$export$d771ef054122c30a)(name));
            };
        });
        _debug.exception = (error, ...message)=>{
            if (message.length && _debug.error) _debug.error(...message);
            (0, $dd4af310e95b2daa$export$1c9f709888824e05).error($4242ad5853add3e0$var$PREFIX, error);
            if (_capture) (0, $fce196f53ce88243$export$f5282963edea4a68)(error, {
                mechanism: {
                    handled: true,
                    type: "auto.function.replay.debug"
                }
            });
            else if (_trace) $4242ad5853add3e0$var$_addBreadcrumb(error, "error");
        };
        _debug.infoTick = (...args)=>{
            (0, $dd4af310e95b2daa$export$1c9f709888824e05).log($4242ad5853add3e0$var$PREFIX, ...args);
            if (_trace) setTimeout(()=>$4242ad5853add3e0$var$_addBreadcrumb(args[0]), 0);
        };
    } else $4242ad5853add3e0$var$CONSOLE_LEVELS.forEach((name)=>{
        _debug[name] = ()=>void 0;
    });
    return _debug;
}
const $4242ad5853add3e0$var$debug = $4242ad5853add3e0$var$makeReplayDebugLogger();
class $4242ad5853add3e0$var$EventBufferSizeExceededError extends Error {
    constructor(){
        super(`Event buffer exceeded maximum size of ${$4242ad5853add3e0$var$REPLAY_MAX_EVENT_BUFFER_SIZE}.`);
    }
}
class $4242ad5853add3e0$var$EventBufferArray {
    constructor(){
        this.events = [];
        this._totalSize = 0;
        this.hasCheckout = false;
        this.waitForCheckout = false;
    }
    /** @inheritdoc */ get hasEvents() {
        return this.events.length > 0;
    }
    /** @inheritdoc */ get type() {
        return "sync";
    }
    /** @inheritdoc */ destroy() {
        this.events = [];
    }
    /** @inheritdoc */ async addEvent(event) {
        const eventSize = JSON.stringify(event).length;
        this._totalSize += eventSize;
        if (this._totalSize > $4242ad5853add3e0$var$REPLAY_MAX_EVENT_BUFFER_SIZE) throw new $4242ad5853add3e0$var$EventBufferSizeExceededError();
        this.events.push(event);
    }
    /** @inheritdoc */ finish() {
        return new Promise((resolve)=>{
            const eventsRet = this.events;
            this.clear();
            resolve(JSON.stringify(eventsRet));
        });
    }
    /** @inheritdoc */ clear() {
        this.events = [];
        this._totalSize = 0;
        this.hasCheckout = false;
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        let ts = null;
        for (const { timestamp: timestamp } of this.events)if (ts === null || timestamp < ts) ts = timestamp;
        return ts === null ? ts : $4242ad5853add3e0$var$timestampToMs(ts);
    }
}
class $4242ad5853add3e0$var$WorkerHandler {
    constructor(worker){
        this._onMessage = ({ data: data })=>{
            const response = data;
            if (typeof response.id !== "number") return;
            const pending = this._pending.get(response.id);
            if (!pending || pending.method !== response.method) return;
            this._pending.delete(response.id);
            if (!response.success) {
                $4242ad5853add3e0$var$DEBUG_BUILD && $4242ad5853add3e0$var$debug.error("Error in compression worker: ", response.response);
                pending.reject(new Error("Error in compression worker"));
                return;
            }
            pending.resolve(response.response);
        };
        this._worker = worker;
        this._id = 0;
        this._pending = /* @__PURE__ */ new Map();
        this._worker.addEventListener("message", this._onMessage);
    }
    /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occurred.
   */ ensureReady() {
        if (this._ensureReadyPromise) return this._ensureReadyPromise;
        this._ensureReadyPromise = new Promise((resolve, reject)=>{
            this._worker.addEventListener("message", ({ data: data })=>{
                if (data.success) resolve();
                else {
                    $4242ad5853add3e0$var$DEBUG_BUILD && $4242ad5853add3e0$var$debug.warn("Received worker message with unsuccessful status", data);
                    reject(new Error("Received worker message with unsuccessful status"));
                }
            }, {
                once: true
            });
            this._worker.addEventListener("error", (error)=>{
                $4242ad5853add3e0$var$DEBUG_BUILD && $4242ad5853add3e0$var$debug.warn("Failed to load Replay compression worker", error);
                reject(new Error(`Failed to load Replay compression worker: ${error instanceof ErrorEvent && error.message ? error.message : "Unknown error. This can happen due to CSP policy restrictions, network issues, or the worker script failing to load."}`));
            }, {
                once: true
            });
        });
        return this._ensureReadyPromise;
    }
    /**
   * Destroy the worker.
   */ destroy() {
        $4242ad5853add3e0$var$DEBUG_BUILD && $4242ad5853add3e0$var$debug.log("Destroying compression worker");
        this._worker.removeEventListener("message", this._onMessage);
        this._pending.forEach((pending)=>pending.reject(new Error("Worker destroyed")));
        this._pending.clear();
        this._worker.terminate();
    }
    /**
   * Post message to worker and wait for response before resolving promise.
   */ postMessage(method, arg) {
        const id = this._getAndIncrementId();
        return new Promise((resolve, reject)=>{
            this._pending.set(id, {
                method: method,
                resolve: resolve,
                reject: reject
            });
            try {
                this._worker.postMessage({
                    id: id,
                    method: method,
                    arg: arg
                });
            } catch (error) {
                this._pending.delete(id);
                reject(error);
            }
        });
    }
    /** Get the current ID and increment it for the next call. */ _getAndIncrementId() {
        return this._id++;
    }
}
class $4242ad5853add3e0$var$EventBufferCompressionWorker {
    constructor(worker){
        this._worker = new $4242ad5853add3e0$var$WorkerHandler(worker);
        this._earliestTimestamp = null;
        this._totalSize = 0;
        this.hasCheckout = false;
        this.waitForCheckout = false;
    }
    /** @inheritdoc */ get hasEvents() {
        return !!this._earliestTimestamp;
    }
    /** @inheritdoc */ get type() {
        return "worker";
    }
    /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occurred.
   */ ensureReady() {
        return this._worker.ensureReady();
    }
    /**
   * Destroy the event buffer.
   */ destroy() {
        this._worker.destroy();
    }
    /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfully received and processed by worker.
   */ addEvent(event) {
        const timestamp = $4242ad5853add3e0$var$timestampToMs(event.timestamp);
        if (!this._earliestTimestamp || timestamp < this._earliestTimestamp) this._earliestTimestamp = timestamp;
        const data = JSON.stringify(event);
        this._totalSize += data.length;
        if (this._totalSize > $4242ad5853add3e0$var$REPLAY_MAX_EVENT_BUFFER_SIZE) return Promise.reject(new $4242ad5853add3e0$var$EventBufferSizeExceededError());
        return this._sendEventToWorker(data);
    }
    /**
   * Finish the event buffer and return the compressed data.
   */ finish() {
        return this._finishRequest();
    }
    /** @inheritdoc */ clear() {
        this._earliestTimestamp = null;
        this._totalSize = 0;
        this.hasCheckout = false;
        this._worker.postMessage("clear").then(null, (e)=>{
            $4242ad5853add3e0$var$DEBUG_BUILD && $4242ad5853add3e0$var$debug.exception(e, 'Sending "clear" message to worker failed', e);
        });
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        return this._earliestTimestamp;
    }
    /**
   * Send the event to the worker.
   */ _sendEventToWorker(data) {
        return this._worker.postMessage("addEvent", data);
    }
    /**
   * Finish the request and return the compressed data from the worker.
   */ async _finishRequest() {
        const response = await this._worker.postMessage("finish");
        this._earliestTimestamp = null;
        this._totalSize = 0;
        return response;
    }
}
class $4242ad5853add3e0$var$EventBufferProxy {
    constructor(worker){
        this._fallback = new $4242ad5853add3e0$var$EventBufferArray();
        this._compression = new $4242ad5853add3e0$var$EventBufferCompressionWorker(worker);
        this._used = this._fallback;
        this._ensureWorkerIsLoadedPromise = this._ensureWorkerIsLoaded();
    }
    /** @inheritdoc */ get waitForCheckout() {
        return this._used.waitForCheckout;
    }
    /** @inheritdoc */ get type() {
        return this._used.type;
    }
    /** @inheritDoc */ get hasEvents() {
        return this._used.hasEvents;
    }
    /** @inheritdoc */ get hasCheckout() {
        return this._used.hasCheckout;
    }
    /** @inheritdoc */ set hasCheckout(value) {
        this._used.hasCheckout = value;
    }
    /** @inheritdoc */ // eslint-disable-next-line @typescript-eslint/adjacent-overload-signatures
    set waitForCheckout(value) {
        this._used.waitForCheckout = value;
    }
    /** @inheritDoc */ destroy() {
        this._fallback.destroy();
        this._compression.destroy();
    }
    /** @inheritdoc */ clear() {
        return this._used.clear();
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        return this._used.getEarliestTimestamp();
    }
    /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfully added.
   */ addEvent(event) {
        return this._used.addEvent(event);
    }
    /** @inheritDoc */ async finish() {
        await this.ensureWorkerIsLoaded();
        return this._used.finish();
    }
    /** Ensure the worker has loaded. */ ensureWorkerIsLoaded() {
        return this._ensureWorkerIsLoadedPromise;
    }
    /** Actually check if the worker has been loaded. */ async _ensureWorkerIsLoaded() {
        try {
            await this._compression.ensureReady();
        } catch (error) {
            $4242ad5853add3e0$var$DEBUG_BUILD && $4242ad5853add3e0$var$debug.exception(error, "Failed to load the compression worker, falling back to simple buffer");
            return;
        }
        await this._switchToCompressionWorker();
    }
    /** Switch the used buffer to the compression worker. */ async _switchToCompressionWorker() {
        const { events: events, hasCheckout: hasCheckout, waitForCheckout: waitForCheckout } = this._fallback;
        const addEventPromises = [];
        for (const event of events)addEventPromises.push(this._compression.addEvent(event));
        this._compression.hasCheckout = hasCheckout;
        this._compression.waitForCheckout = waitForCheckout;
        this._used = this._compression;
        try {
            await Promise.all(addEventPromises);
            this._fallback.clear();
        } catch (error) {
            $4242ad5853add3e0$var$DEBUG_BUILD && $4242ad5853add3e0$var$debug.exception(error, "Failed to add events when switching buffers.");
        }
    }
}
function $4242ad5853add3e0$var$createEventBuffer({ useCompression: useCompression, workerUrl: customWorkerUrl }) {
    if (useCompression && // eslint-disable-next-line no-restricted-globals
    window.Worker) {
        const worker = $4242ad5853add3e0$var$_loadWorker(customWorkerUrl);
        if (worker) return worker;
    }
    $4242ad5853add3e0$var$DEBUG_BUILD && $4242ad5853add3e0$var$debug.log("Using simple buffer");
    return new $4242ad5853add3e0$var$EventBufferArray();
}
function $4242ad5853add3e0$var$_loadWorker(customWorkerUrl) {
    try {
        const workerUrl = customWorkerUrl || $4242ad5853add3e0$var$_getWorkerUrl();
        if (!workerUrl) return;
        $4242ad5853add3e0$var$DEBUG_BUILD && $4242ad5853add3e0$var$debug.log(`Using compression worker${customWorkerUrl ? ` from ${customWorkerUrl}` : ""}`);
        const worker = new Worker(workerUrl);
        return new $4242ad5853add3e0$var$EventBufferProxy(worker);
    } catch (error) {
        $4242ad5853add3e0$var$DEBUG_BUILD && $4242ad5853add3e0$var$debug.exception(error, "Failed to create compression worker");
    }
}
function $4242ad5853add3e0$var$_getWorkerUrl() {
    if (typeof __SENTRY_EXCLUDE_REPLAY_WORKER__ === "undefined" || !__SENTRY_EXCLUDE_REPLAY_WORKER__) return $4242ad5853add3e0$var$e();
    return "";
}
function $4242ad5853add3e0$var$hasSessionStorage() {
    try {
        return "sessionStorage" in $4242ad5853add3e0$var$WINDOW && !!$4242ad5853add3e0$var$WINDOW.sessionStorage;
    } catch  {
        return false;
    }
}
function $4242ad5853add3e0$var$clearSession(replay) {
    $4242ad5853add3e0$var$deleteSession();
    replay.session = void 0;
}
function $4242ad5853add3e0$var$deleteSession() {
    if (!$4242ad5853add3e0$var$hasSessionStorage()) return;
    try {
        $4242ad5853add3e0$var$WINDOW.sessionStorage.removeItem($4242ad5853add3e0$var$REPLAY_SESSION_KEY);
    } catch  {}
}
function $4242ad5853add3e0$var$isSampled(sampleRate) {
    if (sampleRate === void 0) return false;
    return Math.random() < sampleRate;
}
function $4242ad5853add3e0$var$saveSession(session) {
    if (!$4242ad5853add3e0$var$hasSessionStorage()) return;
    try {
        $4242ad5853add3e0$var$WINDOW.sessionStorage.setItem($4242ad5853add3e0$var$REPLAY_SESSION_KEY, JSON.stringify(session));
    } catch  {}
}
function $4242ad5853add3e0$var$makeSession(session) {
    const now = Date.now();
    const id = session.id || (0, $5f9617f585b2f74f$export$19f53698e68b2496)();
    const started = session.started || now;
    const lastActivity = session.lastActivity || now;
    const segmentId = session.segmentId || 0;
    const sampled = session.sampled;
    const previousSessionId = session.previousSessionId;
    const dirty = session.dirty || false;
    return {
        id: id,
        started: started,
        lastActivity: lastActivity,
        segmentId: segmentId,
        sampled: sampled,
        previousSessionId: previousSessionId,
        dirty: dirty
    };
}
function $4242ad5853add3e0$var$getSessionSampleType(sessionSampleRate, allowBuffering) {
    return $4242ad5853add3e0$var$isSampled(sessionSampleRate) ? "session" : allowBuffering ? "buffer" : false;
}
function $4242ad5853add3e0$var$createSession({ sessionSampleRate: sessionSampleRate, allowBuffering: allowBuffering, stickySession: stickySession = false }, { previousSessionId: previousSessionId } = {}) {
    const sampled = $4242ad5853add3e0$var$getSessionSampleType(sessionSampleRate, allowBuffering);
    const session = $4242ad5853add3e0$var$makeSession({
        sampled: sampled,
        previousSessionId: previousSessionId
    });
    if (stickySession) $4242ad5853add3e0$var$saveSession(session);
    return session;
}
function $4242ad5853add3e0$var$fetchSession() {
    if (!$4242ad5853add3e0$var$hasSessionStorage()) return null;
    try {
        const sessionStringFromStorage = $4242ad5853add3e0$var$WINDOW.sessionStorage.getItem($4242ad5853add3e0$var$REPLAY_SESSION_KEY);
        if (!sessionStringFromStorage) return null;
        const sessionObj = JSON.parse(sessionStringFromStorage);
        $4242ad5853add3e0$var$DEBUG_BUILD && $4242ad5853add3e0$var$debug.infoTick("Loading existing session");
        return $4242ad5853add3e0$var$makeSession(sessionObj);
    } catch  {
        return null;
    }
}
function $4242ad5853add3e0$var$isExpired(initialTime, expiry, targetTime = +/* @__PURE__ */ new Date()) {
    if (initialTime === null || expiry === void 0 || expiry < 0) return true;
    if (expiry === 0) return false;
    return initialTime + expiry <= targetTime;
}
function $4242ad5853add3e0$var$isSessionExpired(session, { maxReplayDuration: maxReplayDuration, sessionIdleExpire: sessionIdleExpire, targetTime: targetTime = Date.now() }) {
    return(// First, check that maximum session length has not been exceeded
    $4242ad5853add3e0$var$isExpired(session.started, maxReplayDuration, targetTime) || // check that the idle timeout has not been exceeded (i.e. user has
    // performed an action within the last `sessionIdleExpire` ms)
    $4242ad5853add3e0$var$isExpired(session.lastActivity, sessionIdleExpire, targetTime));
}
function $4242ad5853add3e0$var$shouldRefreshSession(session, { sessionIdleExpire: sessionIdleExpire, maxReplayDuration: maxReplayDuration }) {
    if (!$4242ad5853add3e0$var$isSessionExpired(session, {
        sessionIdleExpire: sessionIdleExpire,
        maxReplayDuration: maxReplayDuration
    })) return false;
    if (session.sampled === "buffer" && session.segmentId === 0) return false;
    return true;
}
function $4242ad5853add3e0$var$loadOrCreateSession({ sessionIdleExpire: sessionIdleExpire, maxReplayDuration: maxReplayDuration, previousSessionId: previousSessionId }, sessionOptions) {
    const existingSession = sessionOptions.stickySession && $4242ad5853add3e0$var$fetchSession();
    if (!existingSession) {
        $4242ad5853add3e0$var$DEBUG_BUILD && $4242ad5853add3e0$var$debug.infoTick("Creating new session");
        return $4242ad5853add3e0$var$createSession(sessionOptions, {
            previousSessionId: previousSessionId
        });
    }
    if (!$4242ad5853add3e0$var$shouldRefreshSession(existingSession, {
        sessionIdleExpire: sessionIdleExpire,
        maxReplayDuration: maxReplayDuration
    })) return existingSession;
    $4242ad5853add3e0$var$DEBUG_BUILD && $4242ad5853add3e0$var$debug.infoTick("Session in sessionStorage is expired, creating new one...");
    return $4242ad5853add3e0$var$createSession(sessionOptions, {
        previousSessionId: existingSession.id
    });
}
function $4242ad5853add3e0$var$isCustomEvent(event) {
    return event.type === $4242ad5853add3e0$var$EventType.Custom;
}
function $4242ad5853add3e0$var$addEventSync(replay, event, isCheckout) {
    if (!$4242ad5853add3e0$var$shouldAddEvent(replay, event)) return false;
    $4242ad5853add3e0$var$_addEvent(replay, event, isCheckout);
    return true;
}
function $4242ad5853add3e0$var$addEvent(replay, event, isCheckout) {
    if (!$4242ad5853add3e0$var$shouldAddEvent(replay, event)) return Promise.resolve(null);
    return $4242ad5853add3e0$var$_addEvent(replay, event, isCheckout);
}
async function $4242ad5853add3e0$var$_addEvent(replay, event, isCheckout) {
    const { eventBuffer: eventBuffer } = replay;
    if (!eventBuffer || eventBuffer.waitForCheckout && !isCheckout) return null;
    const isBufferMode = replay.recordingMode === "buffer";
    try {
        if (isCheckout && isBufferMode) eventBuffer.clear();
        if (isCheckout) {
            eventBuffer.hasCheckout = true;
            eventBuffer.waitForCheckout = false;
        }
        const replayOptions = replay.getOptions();
        const eventAfterPossibleCallback = $4242ad5853add3e0$var$maybeApplyCallback(event, replayOptions.beforeAddRecordingEvent);
        if (!eventAfterPossibleCallback) return;
        return await eventBuffer.addEvent(eventAfterPossibleCallback);
    } catch (error) {
        const isExceeded = error && error instanceof $4242ad5853add3e0$var$EventBufferSizeExceededError;
        const reason = isExceeded ? "eventBufferOverflow" : "eventBufferError";
        const client = (0, $feb8814e57364805$export$6bb76d6eba7e258c)();
        if (client) {
            const dropReason = isExceeded ? "buffer_overflow" : "internal_sdk_error";
            client.recordDroppedEvent(dropReason, "replay");
        }
        if (isExceeded && isBufferMode) {
            eventBuffer.clear();
            eventBuffer.waitForCheckout = true;
            return null;
        }
        replay.handleException(error);
        await replay.stop({
            reason: reason
        });
    }
}
function $4242ad5853add3e0$var$shouldAddEvent(replay, event) {
    if (!replay.eventBuffer || replay.isPaused() || !replay.isEnabled()) return false;
    const timestampInMs = $4242ad5853add3e0$var$timestampToMs(event.timestamp);
    if (timestampInMs + replay.timeouts.sessionIdlePause < Date.now()) return false;
    if (timestampInMs > replay.getContext().initialTimestamp + replay.getOptions().maxReplayDuration) {
        $4242ad5853add3e0$var$DEBUG_BUILD && $4242ad5853add3e0$var$debug.infoTick(`Skipping event with timestamp ${timestampInMs} because it is after maxReplayDuration`);
        return false;
    }
    return true;
}
function $4242ad5853add3e0$var$maybeApplyCallback(event, callback) {
    try {
        if (typeof callback === "function" && $4242ad5853add3e0$var$isCustomEvent(event)) return callback(event);
    } catch (error) {
        $4242ad5853add3e0$var$DEBUG_BUILD && $4242ad5853add3e0$var$debug.exception(error, "An error occurred in the `beforeAddRecordingEvent` callback, skipping the event...");
        return null;
    }
    return event;
}
function $4242ad5853add3e0$var$isErrorEvent(event) {
    return !event.type;
}
function $4242ad5853add3e0$var$isTransactionEvent(event) {
    return event.type === "transaction";
}
function $4242ad5853add3e0$var$isReplayEvent(event) {
    return event.type === "replay_event";
}
function $4242ad5853add3e0$var$isFeedbackEvent(event) {
    return event.type === "feedback";
}
function $4242ad5853add3e0$var$handleAfterSendEvent(replay) {
    return (event, sendResponse)=>{
        if (!replay.isEnabled() || !$4242ad5853add3e0$var$isErrorEvent(event) && !$4242ad5853add3e0$var$isTransactionEvent(event)) return;
        const statusCode = sendResponse.statusCode;
        if (!statusCode || statusCode < 200 || statusCode >= 300) return;
        if ($4242ad5853add3e0$var$isTransactionEvent(event)) {
            $4242ad5853add3e0$var$handleTransactionEvent(replay, event);
            return;
        }
        $4242ad5853add3e0$var$handleErrorEvent(replay, event);
    };
}
function $4242ad5853add3e0$var$handleTransactionEvent(replay, event) {
    const replayContext = replay.getContext();
    if (event.contexts?.trace?.trace_id && replayContext.traceIds.size < 100) replayContext.traceIds.add(event.contexts.trace.trace_id);
}
function $4242ad5853add3e0$var$handleErrorEvent(replay, event) {
    const replayContext = replay.getContext();
    if (event.event_id && replayContext.errorIds.size < 100) replayContext.errorIds.add(event.event_id);
    if (replay.recordingMode !== "buffer" || !event.tags?.replayId) return;
    const { beforeErrorSampling: beforeErrorSampling } = replay.getOptions();
    if (typeof beforeErrorSampling === "function" && !beforeErrorSampling(event)) return;
    (0, $546e120bd13c90e4$export$831dc9f2ab0a617b)(async ()=>{
        try {
            await replay.sendBufferedReplayOrFlush();
        } catch (err) {
            replay.handleException(err);
        }
    });
}
function $4242ad5853add3e0$var$handleBeforeSendEvent(replay) {
    return (event)=>{
        if (!replay.isEnabled() || !$4242ad5853add3e0$var$isErrorEvent(event)) return;
        $4242ad5853add3e0$var$handleHydrationError(replay, event);
    };
}
function $4242ad5853add3e0$var$handleHydrationError(replay, event) {
    const exceptionValue = event.exception?.values?.[0]?.value;
    if (typeof exceptionValue !== "string") return;
    if (// Only matches errors in production builds of react-dom
    // Example https://reactjs.org/docs/error-decoder.html?invariant=423
    // With newer React versions, the messages changed to a different website https://react.dev/errors/418
    exceptionValue.match(/(reactjs\.org\/docs\/error-decoder\.html\?invariant=|react\.dev\/errors\/)(418|419|422|423|425)/) || // Development builds of react-dom
    // Error 1: Hydration failed because the initial UI does not match what was rendered on the server.
    // Error 2: Text content does not match server-rendered HTML. Warning: Text content did not match.
    exceptionValue.match(/(does not match server-rendered HTML|Hydration failed because)/i)) {
        const breadcrumb = $4242ad5853add3e0$var$createBreadcrumb({
            category: "replay.hydrate-error",
            data: {
                url: (0, $b3f3675dae70c197$export$1cfafeee2987818b)()
            }
        });
        $4242ad5853add3e0$var$addBreadcrumbEvent(replay, breadcrumb);
    }
}
function $4242ad5853add3e0$var$handleBreadcrumbs(replay) {
    const client = (0, $feb8814e57364805$export$6bb76d6eba7e258c)();
    if (!client) return;
    client.on("beforeAddBreadcrumb", (breadcrumb)=>$4242ad5853add3e0$var$beforeAddBreadcrumb(replay, breadcrumb));
}
function $4242ad5853add3e0$var$beforeAddBreadcrumb(replay, breadcrumb) {
    if (!replay.isEnabled() || !$4242ad5853add3e0$var$isBreadcrumbWithCategory(breadcrumb)) return;
    const result = $4242ad5853add3e0$var$normalizeBreadcrumb(breadcrumb);
    if (result) $4242ad5853add3e0$var$addBreadcrumbEvent(replay, result);
}
function $4242ad5853add3e0$var$normalizeBreadcrumb(breadcrumb) {
    if (!$4242ad5853add3e0$var$isBreadcrumbWithCategory(breadcrumb) || [
        // fetch & xhr are handled separately,in handleNetworkBreadcrumbs
        "fetch",
        "xhr",
        // These two are breadcrumbs for emitted sentry events, we don't care about them
        "sentry.event",
        "sentry.transaction"
    ].includes(breadcrumb.category) || // We capture UI breadcrumbs separately
    breadcrumb.category.startsWith("ui.")) return null;
    if (breadcrumb.category === "console") return $4242ad5853add3e0$var$normalizeConsoleBreadcrumb(breadcrumb);
    return $4242ad5853add3e0$var$createBreadcrumb(breadcrumb);
}
function $4242ad5853add3e0$var$normalizeConsoleBreadcrumb(breadcrumb) {
    const args = breadcrumb.data?.arguments;
    if (!Array.isArray(args) || args.length === 0) return $4242ad5853add3e0$var$createBreadcrumb(breadcrumb);
    let isTruncated = false;
    const normalizedArgs = args.map((arg)=>{
        if (!arg) return arg;
        if (typeof arg === "string") {
            if (arg.length > $4242ad5853add3e0$var$CONSOLE_ARG_MAX_SIZE) {
                isTruncated = true;
                return `${arg.slice(0, $4242ad5853add3e0$var$CONSOLE_ARG_MAX_SIZE)}\u2026`;
            }
            return arg;
        }
        if (typeof arg === "object") try {
            const normalizedArg = (0, $ac4a8bdf538bbe1f$export$a3295358bff77e)(arg, 7);
            const stringified = JSON.stringify(normalizedArg);
            if (stringified.length > $4242ad5853add3e0$var$CONSOLE_ARG_MAX_SIZE) {
                isTruncated = true;
                return `${JSON.stringify(normalizedArg, null, 2).slice(0, $4242ad5853add3e0$var$CONSOLE_ARG_MAX_SIZE)}\u2026`;
            }
            return normalizedArg;
        } catch  {}
        return arg;
    });
    return $4242ad5853add3e0$var$createBreadcrumb({
        ...breadcrumb,
        data: {
            ...breadcrumb.data,
            arguments: normalizedArgs,
            ...isTruncated ? {
                _meta: {
                    warnings: [
                        "CONSOLE_ARG_TRUNCATED"
                    ]
                }
            } : {}
        }
    });
}
function $4242ad5853add3e0$var$isBreadcrumbWithCategory(breadcrumb) {
    return !!breadcrumb.category;
}
function $4242ad5853add3e0$var$isRrwebError(event, hint) {
    if (event.type || !event.exception?.values?.length) return false;
    if (hint.originalException?.__rrweb__) return true;
    return false;
}
function $4242ad5853add3e0$var$resetReplayIdOnDynamicSamplingContext() {
    const dsc = (0, $feb8814e57364805$export$c7be4b0125a10cba)().getPropagationContext().dsc;
    if (dsc) delete dsc.replay_id;
    const activeSpan = (0, $5a613f00f24f7165$export$1be426a8e585c83e)();
    if (activeSpan) {
        const dsc2 = (0, $6d02d85b64e23ac2$export$a117f995597e25df)(activeSpan);
        delete dsc2.replay_id;
    }
}
function $4242ad5853add3e0$var$setReplayIdOnDynamicSamplingContext(replayId) {
    const dsc = (0, $feb8814e57364805$export$c7be4b0125a10cba)().getPropagationContext().dsc;
    if (dsc) dsc.replay_id = replayId;
    const activeSpan = (0, $5a613f00f24f7165$export$1be426a8e585c83e)();
    if (activeSpan) {
        const dsc2 = (0, $6d02d85b64e23ac2$export$a117f995597e25df)(activeSpan);
        dsc2.replay_id = replayId;
    }
}
function $4242ad5853add3e0$var$addFeedbackBreadcrumb(replay, event) {
    replay.triggerUserActivity();
    replay.addUpdate(()=>{
        if (!event.timestamp) return true;
        replay.throttledAddEvent({
            type: $4242ad5853add3e0$var$EventType.Custom,
            timestamp: event.timestamp * 1e3,
            data: {
                tag: "breadcrumb",
                payload: {
                    timestamp: event.timestamp,
                    type: "default",
                    category: "sentry.feedback",
                    data: {
                        feedbackId: event.event_id
                    }
                }
            }
        });
        return false;
    });
}
function $4242ad5853add3e0$var$shouldSampleForBufferEvent(replay, event) {
    if (replay.recordingMode !== "buffer") return false;
    if (event.message === $4242ad5853add3e0$var$UNABLE_TO_SEND_REPLAY) return false;
    if (!event.exception || event.type) return false;
    return $4242ad5853add3e0$var$isSampled(replay.getOptions().errorSampleRate);
}
function $4242ad5853add3e0$var$handleGlobalEventListener(replay) {
    return Object.assign((event, hint)=>{
        if (replay.session && $4242ad5853add3e0$var$shouldRefreshSession(replay.session, {
            maxReplayDuration: replay.getOptions().maxReplayDuration,
            sessionIdleExpire: replay.timeouts.sessionIdleExpire
        })) $4242ad5853add3e0$var$resetReplayIdOnDynamicSamplingContext();
        if (!replay.isEnabled() || replay.isPaused()) return event;
        if ($4242ad5853add3e0$var$isReplayEvent(event)) {
            delete event.breadcrumbs;
            return event;
        }
        if (!$4242ad5853add3e0$var$isErrorEvent(event) && !$4242ad5853add3e0$var$isTransactionEvent(event) && !$4242ad5853add3e0$var$isFeedbackEvent(event)) return event;
        const isSessionActive = replay.checkAndHandleExpiredSession();
        if (!isSessionActive) {
            $4242ad5853add3e0$var$resetReplayIdOnDynamicSamplingContext();
            return event;
        }
        if ($4242ad5853add3e0$var$isFeedbackEvent(event)) {
            replay.flush();
            event.contexts.feedback.replay_id = replay.getSessionId();
            $4242ad5853add3e0$var$addFeedbackBreadcrumb(replay, event);
            return event;
        }
        if ($4242ad5853add3e0$var$isRrwebError(event, hint) && !replay.getOptions()._experiments.captureExceptions) {
            $4242ad5853add3e0$var$DEBUG_BUILD && $4242ad5853add3e0$var$debug.log("Ignoring error from rrweb internals", event);
            return null;
        }
        const isErrorEventSampled = $4242ad5853add3e0$var$shouldSampleForBufferEvent(replay, event);
        const shouldTagReplayId = isErrorEventSampled || replay.recordingMode === "session";
        if (shouldTagReplayId) event.tags = {
            ...event.tags,
            replayId: replay.getSessionId()
        };
        if (isErrorEventSampled && replay.recordingMode === "buffer" && replay.session?.sampled === "buffer") {
            const session = replay.session;
            session.dirty = true;
            if (replay.getOptions().stickySession) $4242ad5853add3e0$var$saveSession(session);
        }
        return event;
    }, {
        id: "Replay"
    });
}
function $4242ad5853add3e0$var$createPerformanceSpans(replay, entries) {
    return entries.map(({ type: type, start: start, end: end, name: name, data: data })=>{
        const response = replay.throttledAddEvent({
            type: $4242ad5853add3e0$var$EventType.Custom,
            timestamp: start,
            data: {
                tag: "performanceSpan",
                payload: {
                    op: type,
                    description: name,
                    startTimestamp: start,
                    endTimestamp: end,
                    data: data
                }
            }
        });
        return typeof response === "string" ? Promise.resolve(null) : response;
    });
}
function $4242ad5853add3e0$var$handleHistory(handlerData) {
    const { from: from, to: to } = handlerData;
    const now = Date.now() / 1e3;
    return {
        type: "navigation.push",
        start: now,
        end: now,
        name: to,
        data: {
            previous: from
        }
    };
}
function $4242ad5853add3e0$var$handleHistorySpanListener(replay) {
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $4242ad5853add3e0$var$handleHistory(handlerData);
        if (result === null) return;
        replay.getContext().urls.push(result.name);
        replay.triggerUserActivity();
        replay.addUpdate(()=>{
            $4242ad5853add3e0$var$createPerformanceSpans(replay, [
                result
            ]);
            return false;
        });
    };
}
function $4242ad5853add3e0$var$shouldFilterRequest(replay, url) {
    if ($4242ad5853add3e0$var$DEBUG_BUILD && replay.getOptions()._experiments.traceInternals) return false;
    return (0, $d3d08e11b9b42721$export$d92e61f5600202af)(url, (0, $feb8814e57364805$export$6bb76d6eba7e258c)());
}
function $4242ad5853add3e0$var$addNetworkBreadcrumb(replay, result) {
    if (!replay.isEnabled()) return;
    if (result === null) return;
    if ($4242ad5853add3e0$var$shouldFilterRequest(replay, result.name)) return;
    replay.addUpdate(()=>{
        $4242ad5853add3e0$var$createPerformanceSpans(replay, [
            result
        ]);
        return true;
    });
}
function $4242ad5853add3e0$var$getBodySize(body) {
    if (!body) return void 0;
    const textEncoder = new TextEncoder();
    try {
        if (typeof body === "string") return textEncoder.encode(body).length;
        if (body instanceof URLSearchParams) return textEncoder.encode(body.toString()).length;
        if (body instanceof FormData) {
            const formDataStr = (0, $d7e25a8beb5484e0$export$2f1b0f57f243f270)(body);
            return textEncoder.encode(formDataStr).length;
        }
        if (body instanceof Blob) return body.size;
        if (body instanceof ArrayBuffer) return body.byteLength;
    } catch  {}
    return void 0;
}
function $4242ad5853add3e0$var$parseContentLengthHeader(header) {
    if (!header) return void 0;
    const size = parseInt(header, 10);
    return isNaN(size) ? void 0 : size;
}
function $4242ad5853add3e0$var$mergeWarning(info, warning) {
    if (!info) return {
        headers: {},
        size: void 0,
        _meta: {
            warnings: [
                warning
            ]
        }
    };
    const newMeta = {
        ...info._meta
    };
    const existingWarnings = newMeta.warnings || [];
    newMeta.warnings = [
        ...existingWarnings,
        warning
    ];
    info._meta = newMeta;
    return info;
}
function $4242ad5853add3e0$var$makeNetworkReplayBreadcrumb(type, data) {
    if (!data) return null;
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp, url: url, method: method, statusCode: statusCode, request: request, response: response } = data;
    const result = {
        type: type,
        start: startTimestamp / 1e3,
        end: endTimestamp / 1e3,
        name: url,
        data: {
            method: method,
            statusCode: statusCode,
            request: request,
            response: response
        }
    };
    return result;
}
function $4242ad5853add3e0$var$buildSkippedNetworkRequestOrResponse(bodySize) {
    return {
        headers: {},
        size: bodySize,
        _meta: {
            warnings: [
                "URL_SKIPPED"
            ]
        }
    };
}
function $4242ad5853add3e0$var$buildNetworkRequestOrResponse(headers, bodySize, body) {
    if (!bodySize && Object.keys(headers).length === 0) return void 0;
    if (!bodySize) return {
        headers: headers
    };
    if (!body) return {
        headers: headers,
        size: bodySize
    };
    const info = {
        headers: headers,
        size: bodySize
    };
    const { body: normalizedBody, warnings: warnings } = $4242ad5853add3e0$var$normalizeNetworkBody(body);
    info.body = normalizedBody;
    if (warnings?.length) info._meta = {
        warnings: warnings
    };
    return info;
}
function $4242ad5853add3e0$var$getAllowedHeaders(headers, allowedHeaders) {
    return Object.entries(headers).reduce((filteredHeaders, [key, value])=>{
        const normalizedKey = key.toLowerCase();
        if (allowedHeaders.includes(normalizedKey) && headers[key]) filteredHeaders[normalizedKey] = value;
        return filteredHeaders;
    }, {});
}
function $4242ad5853add3e0$var$normalizeNetworkBody(body) {
    if (!body || typeof body !== "string") return {
        body: body
    };
    const exceedsSizeLimit = body.length > $4242ad5853add3e0$var$NETWORK_BODY_MAX_SIZE;
    const isProbablyJson = $4242ad5853add3e0$var$_strIsProbablyJson(body);
    if (exceedsSizeLimit) {
        const truncatedBody = body.slice(0, $4242ad5853add3e0$var$NETWORK_BODY_MAX_SIZE);
        if (isProbablyJson) return {
            body: truncatedBody,
            warnings: [
                "MAYBE_JSON_TRUNCATED"
            ]
        };
        return {
            body: `${truncatedBody}\u2026`,
            warnings: [
                "TEXT_TRUNCATED"
            ]
        };
    }
    if (isProbablyJson) try {
        const jsonBody = JSON.parse(body);
        return {
            body: jsonBody
        };
    } catch  {}
    return {
        body: body
    };
}
function $4242ad5853add3e0$var$_strIsProbablyJson(str) {
    const first = str[0];
    const last = str[str.length - 1];
    return first === "[" && last === "]" || first === "{" && last === "}";
}
function $4242ad5853add3e0$var$urlMatches(url, urls) {
    const fullUrl = $4242ad5853add3e0$var$getFullUrl(url);
    return (0, $2088fbfa8bfbfeb6$export$a7a5ec66062ea5d)(fullUrl, urls);
}
function $4242ad5853add3e0$var$getFullUrl(url, baseURI = $4242ad5853add3e0$var$WINDOW.document.baseURI) {
    if (url.startsWith("http://") || url.startsWith("https://") || url.startsWith($4242ad5853add3e0$var$WINDOW.location.origin)) return url;
    const fixedUrl = new URL(url, baseURI);
    if (fixedUrl.origin !== new URL(baseURI).origin) return url;
    const fullUrl = fixedUrl.href;
    if (!url.endsWith("/") && fullUrl.endsWith("/")) return fullUrl.slice(0, -1);
    return fullUrl;
}
async function $4242ad5853add3e0$var$captureFetchBreadcrumbToReplay(breadcrumb, hint, options) {
    try {
        const data = await $4242ad5853add3e0$var$_prepareFetchData(breadcrumb, hint, options);
        const result = $4242ad5853add3e0$var$makeNetworkReplayBreadcrumb("resource.fetch", data);
        $4242ad5853add3e0$var$addNetworkBreadcrumb(options.replay, result);
    } catch (error) {
        $4242ad5853add3e0$var$DEBUG_BUILD && $4242ad5853add3e0$var$debug.exception(error, "Failed to capture fetch breadcrumb");
    }
}
function $4242ad5853add3e0$var$enrichFetchBreadcrumb(breadcrumb, hint) {
    const { input: input, response: response } = hint;
    const body = input ? (0, $d7e25a8beb5484e0$export$ad44edf8012ec314)(input) : void 0;
    const reqSize = $4242ad5853add3e0$var$getBodySize(body);
    const resSize = response ? $4242ad5853add3e0$var$parseContentLengthHeader(response.headers.get("content-length")) : void 0;
    if (reqSize !== void 0) breadcrumb.data.request_body_size = reqSize;
    if (resSize !== void 0) breadcrumb.data.response_body_size = resSize;
}
async function $4242ad5853add3e0$var$_prepareFetchData(breadcrumb, hint, options) {
    const now = Date.now();
    const { startTimestamp: startTimestamp = now, endTimestamp: endTimestamp = now } = hint;
    const { url: url, method: method, status_code: statusCode = 0, request_body_size: requestBodySize, response_body_size: responseBodySize } = breadcrumb.data;
    const captureDetails = $4242ad5853add3e0$var$urlMatches(url, options.networkDetailAllowUrls) && !$4242ad5853add3e0$var$urlMatches(url, options.networkDetailDenyUrls);
    const request = captureDetails ? $4242ad5853add3e0$var$_getRequestInfo(options, hint.input, requestBodySize) : $4242ad5853add3e0$var$buildSkippedNetworkRequestOrResponse(requestBodySize);
    const response = await $4242ad5853add3e0$var$_getResponseInfo(captureDetails, options, hint.response, responseBodySize);
    return {
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp,
        url: url,
        method: method,
        statusCode: statusCode,
        request: request,
        response: response
    };
}
function $4242ad5853add3e0$var$_getRequestInfo({ networkCaptureBodies: networkCaptureBodies, networkRequestHeaders: networkRequestHeaders }, input, requestBodySize) {
    const headers = input ? $4242ad5853add3e0$var$getRequestHeaders(input, networkRequestHeaders) : {};
    if (!networkCaptureBodies) return $4242ad5853add3e0$var$buildNetworkRequestOrResponse(headers, requestBodySize, void 0);
    const requestBody = (0, $d7e25a8beb5484e0$export$ad44edf8012ec314)(input);
    const [bodyStr, warning] = (0, $d7e25a8beb5484e0$export$945a2d5364608d5)(requestBody, $4242ad5853add3e0$var$debug);
    const data = $4242ad5853add3e0$var$buildNetworkRequestOrResponse(headers, requestBodySize, bodyStr);
    if (warning) return $4242ad5853add3e0$var$mergeWarning(data, warning);
    return data;
}
async function $4242ad5853add3e0$var$_getResponseInfo(captureDetails, { networkCaptureBodies: networkCaptureBodies, networkResponseHeaders: networkResponseHeaders }, response, responseBodySize) {
    if (!captureDetails && responseBodySize !== void 0) return $4242ad5853add3e0$var$buildSkippedNetworkRequestOrResponse(responseBodySize);
    const headers = response ? $4242ad5853add3e0$var$getAllHeaders(response.headers, networkResponseHeaders) : {};
    if (!response || !networkCaptureBodies && responseBodySize !== void 0) return $4242ad5853add3e0$var$buildNetworkRequestOrResponse(headers, responseBodySize, void 0);
    const [bodyText, warning] = await $4242ad5853add3e0$var$_parseFetchResponseBody(response);
    const result = $4242ad5853add3e0$var$getResponseData(bodyText, {
        networkCaptureBodies: networkCaptureBodies,
        responseBodySize: responseBodySize,
        captureDetails: captureDetails,
        headers: headers
    });
    if (warning) return $4242ad5853add3e0$var$mergeWarning(result, warning);
    return result;
}
function $4242ad5853add3e0$var$getResponseData(bodyText, { networkCaptureBodies: networkCaptureBodies, responseBodySize: responseBodySize, captureDetails: captureDetails, headers: headers }) {
    try {
        const size = bodyText?.length && responseBodySize === void 0 ? $4242ad5853add3e0$var$getBodySize(bodyText) : responseBodySize;
        if (!captureDetails) return $4242ad5853add3e0$var$buildSkippedNetworkRequestOrResponse(size);
        if (networkCaptureBodies) return $4242ad5853add3e0$var$buildNetworkRequestOrResponse(headers, size, bodyText);
        return $4242ad5853add3e0$var$buildNetworkRequestOrResponse(headers, size, void 0);
    } catch (error) {
        $4242ad5853add3e0$var$DEBUG_BUILD && $4242ad5853add3e0$var$debug.exception(error, "Failed to serialize response body");
        return $4242ad5853add3e0$var$buildNetworkRequestOrResponse(headers, responseBodySize, void 0);
    }
}
async function $4242ad5853add3e0$var$_parseFetchResponseBody(response) {
    const res = $4242ad5853add3e0$var$_tryCloneResponse(response);
    if (!res) return [
        void 0,
        "BODY_PARSE_ERROR"
    ];
    try {
        const text = await $4242ad5853add3e0$var$_tryGetResponseText(res);
        return [
            text
        ];
    } catch (error) {
        if (error instanceof Error && error.message.indexOf("Timeout") > -1) {
            $4242ad5853add3e0$var$DEBUG_BUILD && $4242ad5853add3e0$var$debug.warn("Parsing text body from response timed out");
            return [
                void 0,
                "BODY_PARSE_TIMEOUT"
            ];
        }
        $4242ad5853add3e0$var$DEBUG_BUILD && $4242ad5853add3e0$var$debug.exception(error, "Failed to get text body from response");
        return [
            void 0,
            "BODY_PARSE_ERROR"
        ];
    }
}
function $4242ad5853add3e0$var$getAllHeaders(headers, allowedHeaders) {
    const allHeaders = {};
    allowedHeaders.forEach((header)=>{
        if (headers.get(header)) allHeaders[header] = headers.get(header);
    });
    return allHeaders;
}
function $4242ad5853add3e0$var$getRequestHeaders(fetchArgs, allowedHeaders) {
    if (fetchArgs.length === 1 && typeof fetchArgs[0] !== "string") return $4242ad5853add3e0$var$getHeadersFromOptions(fetchArgs[0], allowedHeaders);
    if (fetchArgs.length === 2) return $4242ad5853add3e0$var$getHeadersFromOptions(fetchArgs[1], allowedHeaders);
    return {};
}
function $4242ad5853add3e0$var$getHeadersFromOptions(input, allowedHeaders) {
    if (!input) return {};
    const headers = input.headers;
    if (!headers) return {};
    if (headers instanceof Headers) return $4242ad5853add3e0$var$getAllHeaders(headers, allowedHeaders);
    if (Array.isArray(headers)) return {};
    return $4242ad5853add3e0$var$getAllowedHeaders(headers, allowedHeaders);
}
function $4242ad5853add3e0$var$_tryCloneResponse(response) {
    try {
        return response.clone();
    } catch (error) {
        $4242ad5853add3e0$var$DEBUG_BUILD && $4242ad5853add3e0$var$debug.exception(error, "Failed to clone response body");
    }
}
function $4242ad5853add3e0$var$_tryGetResponseText(response) {
    return new Promise((resolve, reject)=>{
        const timeout = (0, $546e120bd13c90e4$export$831dc9f2ab0a617b)(()=>reject(new Error("Timeout while trying to read response body")), 500);
        $4242ad5853add3e0$var$_getResponseText(response).then((txt)=>resolve(txt), (reason)=>reject(reason)).finally(()=>clearTimeout(timeout));
    });
}
async function $4242ad5853add3e0$var$_getResponseText(response) {
    return await response.text();
}
async function $4242ad5853add3e0$var$captureXhrBreadcrumbToReplay(breadcrumb, hint, options) {
    try {
        const data = $4242ad5853add3e0$var$_prepareXhrData(breadcrumb, hint, options);
        const result = $4242ad5853add3e0$var$makeNetworkReplayBreadcrumb("resource.xhr", data);
        $4242ad5853add3e0$var$addNetworkBreadcrumb(options.replay, result);
    } catch (error) {
        $4242ad5853add3e0$var$DEBUG_BUILD && $4242ad5853add3e0$var$debug.exception(error, "Failed to capture xhr breadcrumb");
    }
}
function $4242ad5853add3e0$var$enrichXhrBreadcrumb(breadcrumb, hint) {
    const { xhr: xhr, input: input } = hint;
    if (!xhr) return;
    const reqSize = $4242ad5853add3e0$var$getBodySize(input);
    const resSize = xhr.getResponseHeader("content-length") ? $4242ad5853add3e0$var$parseContentLengthHeader(xhr.getResponseHeader("content-length")) : $4242ad5853add3e0$var$_getBodySize(xhr.response, xhr.responseType);
    if (reqSize !== void 0) breadcrumb.data.request_body_size = reqSize;
    if (resSize !== void 0) breadcrumb.data.response_body_size = resSize;
}
function $4242ad5853add3e0$var$_prepareXhrData(breadcrumb, hint, options) {
    const now = Date.now();
    const { startTimestamp: startTimestamp = now, endTimestamp: endTimestamp = now, input: input, xhr: xhr } = hint;
    const { url: url, method: method, status_code: statusCode = 0, request_body_size: requestBodySize, response_body_size: responseBodySize } = breadcrumb.data;
    if (!url) return null;
    if (!xhr || !$4242ad5853add3e0$var$urlMatches(url, options.networkDetailAllowUrls) || $4242ad5853add3e0$var$urlMatches(url, options.networkDetailDenyUrls)) {
        const request2 = $4242ad5853add3e0$var$buildSkippedNetworkRequestOrResponse(requestBodySize);
        const response2 = $4242ad5853add3e0$var$buildSkippedNetworkRequestOrResponse(responseBodySize);
        return {
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp,
            url: url,
            method: method,
            statusCode: statusCode,
            request: request2,
            response: response2
        };
    }
    const xhrInfo = xhr[0, $97eb65b7144e66a9$export$55b6bb1e45c6cf59];
    const networkRequestHeaders = xhrInfo ? $4242ad5853add3e0$var$getAllowedHeaders(xhrInfo.request_headers, options.networkRequestHeaders) : {};
    const networkResponseHeaders = $4242ad5853add3e0$var$getAllowedHeaders((0, $d7e25a8beb5484e0$export$ce71c337afb62ea)(xhr), options.networkResponseHeaders);
    const [requestBody, requestWarning] = options.networkCaptureBodies ? (0, $d7e25a8beb5484e0$export$945a2d5364608d5)(input, $4242ad5853add3e0$var$debug) : [
        void 0
    ];
    const [responseBody, responseWarning] = options.networkCaptureBodies ? $4242ad5853add3e0$var$_getXhrResponseBody(xhr) : [
        void 0
    ];
    const request = $4242ad5853add3e0$var$buildNetworkRequestOrResponse(networkRequestHeaders, requestBodySize, requestBody);
    const response = $4242ad5853add3e0$var$buildNetworkRequestOrResponse(networkResponseHeaders, responseBodySize, responseBody);
    return {
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp,
        url: url,
        method: method,
        statusCode: statusCode,
        request: requestWarning ? $4242ad5853add3e0$var$mergeWarning(request, requestWarning) : request,
        response: responseWarning ? $4242ad5853add3e0$var$mergeWarning(response, responseWarning) : response
    };
}
function $4242ad5853add3e0$var$_getXhrResponseBody(xhr) {
    const errors = [];
    try {
        return [
            xhr.responseText
        ];
    } catch (e) {
        errors.push(e);
    }
    try {
        return $4242ad5853add3e0$var$_parseXhrResponse(xhr.response, xhr.responseType);
    } catch (e) {
        errors.push(e);
    }
    $4242ad5853add3e0$var$DEBUG_BUILD && $4242ad5853add3e0$var$debug.warn("Failed to get xhr response body", ...errors);
    return [
        void 0
    ];
}
function $4242ad5853add3e0$var$_parseXhrResponse(body, responseType) {
    try {
        if (typeof body === "string") return [
            body
        ];
        if (body instanceof Document) return [
            body.body.outerHTML
        ];
        if (responseType === "json" && body && typeof body === "object") return [
            JSON.stringify(body)
        ];
        if (!body) return [
            void 0
        ];
    } catch (error) {
        $4242ad5853add3e0$var$DEBUG_BUILD && $4242ad5853add3e0$var$debug.exception(error, "Failed to serialize body", body);
        return [
            void 0,
            "BODY_PARSE_ERROR"
        ];
    }
    $4242ad5853add3e0$var$DEBUG_BUILD && $4242ad5853add3e0$var$debug.log("Skipping network body because of body type", body);
    return [
        void 0,
        "UNPARSEABLE_BODY_TYPE"
    ];
}
function $4242ad5853add3e0$var$_getBodySize(body, responseType) {
    try {
        const bodyStr = responseType === "json" && body && typeof body === "object" ? JSON.stringify(body) : body;
        return $4242ad5853add3e0$var$getBodySize(bodyStr);
    } catch  {
        return void 0;
    }
}
function $4242ad5853add3e0$var$handleNetworkBreadcrumbs(replay) {
    const client = (0, $feb8814e57364805$export$6bb76d6eba7e258c)();
    try {
        const { networkDetailAllowUrls: networkDetailAllowUrls, networkDetailDenyUrls: networkDetailDenyUrls, networkCaptureBodies: networkCaptureBodies, networkRequestHeaders: networkRequestHeaders, networkResponseHeaders: networkResponseHeaders } = replay.getOptions();
        const options = {
            replay: replay,
            networkDetailAllowUrls: networkDetailAllowUrls,
            networkDetailDenyUrls: networkDetailDenyUrls,
            networkCaptureBodies: networkCaptureBodies,
            networkRequestHeaders: networkRequestHeaders,
            networkResponseHeaders: networkResponseHeaders
        };
        if (client) client.on("beforeAddBreadcrumb", (breadcrumb, hint)=>$4242ad5853add3e0$var$beforeAddNetworkBreadcrumb(options, breadcrumb, hint));
    } catch  {}
}
function $4242ad5853add3e0$var$beforeAddNetworkBreadcrumb(options, breadcrumb, hint) {
    if (!breadcrumb.data) return;
    try {
        if ($4242ad5853add3e0$var$_isXhrBreadcrumb(breadcrumb) && $4242ad5853add3e0$var$_isXhrHint(hint)) {
            $4242ad5853add3e0$var$enrichXhrBreadcrumb(breadcrumb, hint);
            $4242ad5853add3e0$var$captureXhrBreadcrumbToReplay(breadcrumb, hint, options);
        }
        if ($4242ad5853add3e0$var$_isFetchBreadcrumb(breadcrumb) && $4242ad5853add3e0$var$_isFetchHint(hint)) {
            $4242ad5853add3e0$var$enrichFetchBreadcrumb(breadcrumb, hint);
            $4242ad5853add3e0$var$captureFetchBreadcrumbToReplay(breadcrumb, hint, options);
        }
    } catch (e) {
        $4242ad5853add3e0$var$DEBUG_BUILD && $4242ad5853add3e0$var$debug.exception(e, "Error when enriching network breadcrumb");
    }
}
function $4242ad5853add3e0$var$_isXhrBreadcrumb(breadcrumb) {
    return breadcrumb.category === "xhr";
}
function $4242ad5853add3e0$var$_isFetchBreadcrumb(breadcrumb) {
    return breadcrumb.category === "fetch";
}
function $4242ad5853add3e0$var$_isXhrHint(hint) {
    return hint?.xhr;
}
function $4242ad5853add3e0$var$_isFetchHint(hint) {
    return hint?.input !== void 0;
}
function $4242ad5853add3e0$var$addGlobalListeners(replay) {
    const client = (0, $feb8814e57364805$export$6bb76d6eba7e258c)();
    (0, $f50b0324088e687b$export$5aeffd3db2cf9df7)($4242ad5853add3e0$var$handleDomListener(replay));
    (0, $3e85eb28f9001ea3$export$3f18c56c58114e75)($4242ad5853add3e0$var$handleHistorySpanListener(replay));
    $4242ad5853add3e0$var$handleBreadcrumbs(replay);
    $4242ad5853add3e0$var$handleNetworkBreadcrumbs(replay);
    const eventProcessor = $4242ad5853add3e0$var$handleGlobalEventListener(replay);
    (0, $fce196f53ce88243$export$9aac0b9f77928fbf)(eventProcessor);
    if (client) {
        client.on("beforeSendEvent", $4242ad5853add3e0$var$handleBeforeSendEvent(replay));
        client.on("afterSendEvent", $4242ad5853add3e0$var$handleAfterSendEvent(replay));
        client.on("createDsc", (dsc)=>{
            const replayId = replay.getSessionId();
            if (replayId && replay.isEnabled() && replay.recordingMode === "session") {
                const isSessionActive = replay.checkAndHandleExpiredSession();
                if (isSessionActive) dsc.replay_id = replayId;
            }
        });
        client.on("spanStart", (span)=>{
            replay.lastActiveSpan = span;
        });
        client.on("spanEnd", (span)=>{
            replay.lastActiveSpan = span;
        });
        client.on("beforeSendFeedback", async (feedbackEvent, options)=>{
            const replayId = replay.getSessionId();
            if (options?.includeReplay && replay.isEnabled() && replayId && feedbackEvent.contexts?.feedback) {
                if (feedbackEvent.contexts.feedback.source === "api") await replay.sendBufferedReplayOrFlush();
                feedbackEvent.contexts.feedback.replay_id = replayId;
            }
        });
        client.on("openFeedbackWidget", async ()=>{
            await replay.sendBufferedReplayOrFlush();
        });
    }
}
async function $4242ad5853add3e0$var$addMemoryEntry(replay) {
    try {
        return Promise.all($4242ad5853add3e0$var$createPerformanceSpans(replay, [
            // @ts-expect-error memory doesn't exist on type Performance as the API is non-standard (we check that it exists above)
            $4242ad5853add3e0$var$createMemoryEntry($4242ad5853add3e0$var$WINDOW.performance.memory)
        ]));
    } catch  {
        return [];
    }
}
function $4242ad5853add3e0$var$createMemoryEntry(memoryEntry) {
    const { jsHeapSizeLimit: jsHeapSizeLimit, totalJSHeapSize: totalJSHeapSize, usedJSHeapSize: usedJSHeapSize } = memoryEntry;
    const time = Date.now() / 1e3;
    return {
        type: "memory",
        name: "memory",
        start: time,
        end: time,
        data: {
            memory: {
                jsHeapSizeLimit: jsHeapSizeLimit,
                totalJSHeapSize: totalJSHeapSize,
                usedJSHeapSize: usedJSHeapSize
            }
        }
    };
}
function $4242ad5853add3e0$var$debounce(func, wait, options) {
    return (0, $41fbec003ec03801$export$61fc7d43ac8f84b0)(func, wait, {
        ...options,
        // @ts-expect-error - Not quite sure why these types do not match, but this is fine
        setTimeoutImpl: (0, $546e120bd13c90e4$export$831dc9f2ab0a617b)
    });
}
const $4242ad5853add3e0$var$NAVIGATOR = (0, $f217104c897b328f$export$f1a6cdb1459e81d1).navigator;
function $4242ad5853add3e0$var$getRecordingSamplingOptions() {
    if (/iPhone|iPad|iPod/i.test($4242ad5853add3e0$var$NAVIGATOR?.userAgent ?? "") || /Macintosh/i.test($4242ad5853add3e0$var$NAVIGATOR?.userAgent ?? "") && $4242ad5853add3e0$var$NAVIGATOR?.maxTouchPoints && $4242ad5853add3e0$var$NAVIGATOR?.maxTouchPoints > 1) return {
        sampling: {
            mousemove: false
        }
    };
    return {};
}
function $4242ad5853add3e0$var$getHandleRecordingEmit(replay) {
    let hadFirstEvent = false;
    return (event, _isCheckout)=>{
        if (!replay.checkAndHandleExpiredSession()) {
            $4242ad5853add3e0$var$DEBUG_BUILD && $4242ad5853add3e0$var$debug.warn("Received replay event after session expired.");
            return;
        }
        const isCheckout = _isCheckout || !hadFirstEvent;
        hadFirstEvent = true;
        $4242ad5853add3e0$var$syncMirrorAttributesFromMutationEvent(event);
        if (replay.clickDetector) $4242ad5853add3e0$var$updateClickDetectorForRecordingEvent(replay.clickDetector, event);
        replay.addUpdate(()=>{
            if (replay.recordingMode === "buffer" && isCheckout) replay.setInitialState();
            if (!$4242ad5853add3e0$var$addEventSync(replay, event, isCheckout)) return true;
            if (!isCheckout) return false;
            const session = replay.session;
            $4242ad5853add3e0$var$addSettingsEvent(replay, isCheckout);
            if (replay.recordingMode === "buffer" && session && replay.eventBuffer && !session.dirty) {
                const earliestEvent = replay.eventBuffer.getEarliestTimestamp();
                if (earliestEvent) {
                    $4242ad5853add3e0$var$DEBUG_BUILD && $4242ad5853add3e0$var$debug.log(`Updating session start time to earliest event in buffer to ${new Date(earliestEvent)}`);
                    session.started = earliestEvent;
                    if (replay.getOptions().stickySession) $4242ad5853add3e0$var$saveSession(session);
                }
            }
            if (session?.previousSessionId) return true;
            if (replay.recordingMode === "session") replay.flush();
            return true;
        });
    };
}
function $4242ad5853add3e0$var$syncMirrorAttributesFromMutationEvent(event) {
    const data = event.data;
    if (event.type !== $4242ad5853add3e0$var$EventType.IncrementalSnapshot || !data || typeof data !== "object" || !("source" in data) || data.source !== $4242ad5853add3e0$var$IncrementalSource.Mutation || !("attributes" in data) || !Array.isArray(data.attributes)) return;
    for (const mutation of data.attributes){
        const node = $4242ad5853add3e0$var$record.mirror.getNode(mutation.id);
        const meta = node && $4242ad5853add3e0$var$record.mirror.getMeta(node);
        if (meta?.type !== $4242ad5853add3e0$var$NodeType.Element) continue;
        for (const [attributeName, value] of Object.entries(mutation.attributes))if (value === null) delete meta.attributes[attributeName];
        else meta.attributes[attributeName] = value;
    }
}
function $4242ad5853add3e0$var$createOptionsEvent(replay) {
    const options = replay.getOptions();
    return {
        type: $4242ad5853add3e0$var$EventType.Custom,
        timestamp: Date.now(),
        data: {
            tag: "options",
            payload: {
                shouldRecordCanvas: replay.isRecordingCanvas(),
                sessionSampleRate: options.sessionSampleRate,
                errorSampleRate: options.errorSampleRate,
                useCompressionOption: options.useCompression,
                blockAllMedia: options.blockAllMedia,
                maskAllText: options.maskAllText,
                maskAllInputs: options.maskAllInputs,
                useCompression: replay.eventBuffer ? replay.eventBuffer.type === "worker" : false,
                networkDetailHasUrls: options.networkDetailAllowUrls.length > 0,
                networkCaptureBodies: options.networkCaptureBodies,
                networkRequestHasHeaders: options.networkRequestHeaders.length > 0,
                networkResponseHasHeaders: options.networkResponseHeaders.length > 0
            }
        }
    };
}
function $4242ad5853add3e0$var$addSettingsEvent(replay, isCheckout) {
    if (!isCheckout || replay.session?.segmentId !== 0) return;
    $4242ad5853add3e0$var$addEventSync(replay, $4242ad5853add3e0$var$createOptionsEvent(replay), false);
}
function $4242ad5853add3e0$var$closestElementOfNode(node) {
    if (!node) return null;
    try {
        const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
        return el;
    } catch  {
        return null;
    }
}
function $4242ad5853add3e0$var$createReplayEnvelope(replayEvent, recordingData, dsn, tunnel) {
    return (0, $94c50881d8803006$export$f93f7f385160c44e)((0, $94c50881d8803006$export$92b6093782fe661b)(replayEvent, (0, $94c50881d8803006$export$d369f3b2758f6743)(replayEvent), tunnel, dsn), [
        [
            {
                type: "replay_event"
            },
            replayEvent
        ],
        [
            {
                type: "replay_recording",
                // If string then we need to encode to UTF8, otherwise will have
                // wrong size. TextEncoder has similar browser support to
                // MutationObserver, although it does not accept IE11.
                length: typeof recordingData === "string" ? new TextEncoder().encode(recordingData).length : recordingData.length
            },
            recordingData
        ]
    ]);
}
function $4242ad5853add3e0$var$prepareRecordingData({ recordingData: recordingData, headers: headers }) {
    let payloadWithSequence;
    const replayHeaders = `${JSON.stringify(headers)}
`;
    if (typeof recordingData === "string") payloadWithSequence = `${replayHeaders}${recordingData}`;
    else {
        const enc = new TextEncoder();
        const sequence = enc.encode(replayHeaders);
        payloadWithSequence = new Uint8Array(sequence.length + recordingData.length);
        payloadWithSequence.set(sequence);
        payloadWithSequence.set(recordingData, sequence.length);
    }
    return payloadWithSequence;
}
async function $4242ad5853add3e0$var$prepareReplayEvent({ client: client, scope: scope, replayId: event_id, event: event }) {
    const integrations = typeof client["_integrations"] === "object" && client["_integrations"] !== null && !Array.isArray(client["_integrations"]) ? Object.keys(client["_integrations"]) : void 0;
    const eventHint = {
        event_id: event_id,
        integrations: integrations
    };
    client.emit("preprocessEvent", event, eventHint);
    const preparedEvent = await (0, $334fc2197f5d0e69$export$2d67fb380bd11267)(client.getOptions(), event, eventHint, scope, client, (0, $feb8814e57364805$export$68f3af03034c9e90)());
    if (!preparedEvent) return null;
    client.emit("postprocessEvent", preparedEvent, eventHint);
    preparedEvent.platform = preparedEvent.platform || "javascript";
    const metadata = client.getSdkMetadata();
    const { name: name, version: version, settings: settings } = metadata?.sdk || {};
    preparedEvent.sdk = {
        ...preparedEvent.sdk,
        name: name || "sentry.javascript.unknown",
        version: version || "0.0.0",
        settings: settings
    };
    return preparedEvent;
}
async function $4242ad5853add3e0$var$sendReplayRequest({ recordingData: recordingData, replayId: replayId, segmentId: segment_id, eventContext: eventContext, timestamp: timestamp, session: session }) {
    const preparedRecordingData = $4242ad5853add3e0$var$prepareRecordingData({
        recordingData: recordingData,
        headers: {
            segment_id: segment_id
        }
    });
    const { urls: urls, errorIds: errorIds, traceIds: traceIds, initialTimestamp: initialTimestamp } = eventContext;
    const client = (0, $feb8814e57364805$export$6bb76d6eba7e258c)();
    const scope = (0, $feb8814e57364805$export$c7be4b0125a10cba)();
    const transport = client?.getTransport();
    const dsn = client?.getDsn();
    if (!client || !transport || !dsn || !session.sampled) return Promise.resolve({});
    const baseEvent = {
        type: $4242ad5853add3e0$var$REPLAY_EVENT_NAME,
        replay_start_timestamp: initialTimestamp / 1e3,
        timestamp: timestamp / 1e3,
        error_ids: errorIds,
        trace_ids: traceIds,
        urls: urls,
        replay_id: replayId,
        segment_id: segment_id,
        replay_type: session.sampled
    };
    const replayEvent = await $4242ad5853add3e0$var$prepareReplayEvent({
        scope: scope,
        client: client,
        replayId: replayId,
        event: baseEvent
    });
    if (!replayEvent) {
        client.recordDroppedEvent("event_processor", "replay");
        $4242ad5853add3e0$var$DEBUG_BUILD && $4242ad5853add3e0$var$debug.log("An event processor returned `null`, will not send event.");
        return Promise.resolve({});
    }
    delete replayEvent.sdkProcessingMetadata;
    const envelope = $4242ad5853add3e0$var$createReplayEnvelope(replayEvent, preparedRecordingData, dsn, client.getOptions().tunnel);
    let response;
    try {
        response = await transport.send(envelope);
    } catch (err) {
        const error = new Error($4242ad5853add3e0$var$UNABLE_TO_SEND_REPLAY);
        try {
            error.cause = err;
        } catch  {}
        throw error;
    }
    const rateLimits = (0, $4736086234f81e69$export$699aff705e0d49d4)({}, response);
    if ((0, $4736086234f81e69$export$6c91fec22056810a)(rateLimits, "replay")) throw new $4242ad5853add3e0$var$RateLimitError(rateLimits);
    if (typeof response.statusCode === "number" && (response.statusCode < 200 || response.statusCode >= 300)) throw new $4242ad5853add3e0$var$TransportStatusCodeError(response.statusCode);
    return response;
}
class $4242ad5853add3e0$var$TransportStatusCodeError extends Error {
    constructor(statusCode){
        super(`Transport returned status code ${statusCode}`);
    }
}
class $4242ad5853add3e0$var$RateLimitError extends Error {
    constructor(rateLimits){
        super("Rate limit hit");
        this.rateLimits = rateLimits;
    }
}
class $4242ad5853add3e0$var$ReplayDurationLimitError extends Error {
    constructor(){
        super("Session is too long, not sending replay");
    }
}
async function $4242ad5853add3e0$var$sendReplay(replayData, retryConfig = {
    count: 0,
    interval: $4242ad5853add3e0$var$RETRY_BASE_INTERVAL
}) {
    const { recordingData: recordingData, onError: onError } = replayData;
    if (!recordingData.length) return;
    try {
        await $4242ad5853add3e0$var$sendReplayRequest(replayData);
        return true;
    } catch (err) {
        if (err instanceof $4242ad5853add3e0$var$TransportStatusCodeError || err instanceof $4242ad5853add3e0$var$RateLimitError) throw err;
        (0, $fce196f53ce88243$export$2f04de43fe27971a)("Replays", {
            _retryCount: retryConfig.count
        });
        if (onError) onError(err);
        if (retryConfig.count >= $4242ad5853add3e0$var$RETRY_MAX_COUNT) {
            const error = new Error(`${$4242ad5853add3e0$var$UNABLE_TO_SEND_REPLAY} - max retries exceeded`);
            try {
                error.cause = err;
            } catch  {}
            throw error;
        }
        retryConfig.interval *= ++retryConfig.count;
        return new Promise((resolve, reject)=>{
            (0, $546e120bd13c90e4$export$831dc9f2ab0a617b)(async ()=>{
                try {
                    await $4242ad5853add3e0$var$sendReplay(replayData, retryConfig);
                    resolve(true);
                } catch (err2) {
                    reject(err2);
                }
            }, retryConfig.interval);
        });
    }
}
const $4242ad5853add3e0$var$THROTTLED = "__THROTTLED";
const $4242ad5853add3e0$var$SKIPPED = "__SKIPPED";
function $4242ad5853add3e0$var$throttle(fn, maxCount, durationSeconds) {
    const counter = /* @__PURE__ */ new Map();
    const _cleanup = (now)=>{
        const threshold = now - durationSeconds;
        counter.forEach((_value, key)=>{
            if (key < threshold) counter.delete(key);
        });
    };
    const _getTotalCount = ()=>{
        return [
            ...counter.values()
        ].reduce((a, b)=>a + b, 0);
    };
    let isThrottled = false;
    return (...rest)=>{
        const now = Math.floor(Date.now() / 1e3);
        _cleanup(now);
        if (_getTotalCount() >= maxCount) {
            const wasThrottled = isThrottled;
            isThrottled = true;
            return wasThrottled ? $4242ad5853add3e0$var$SKIPPED : $4242ad5853add3e0$var$THROTTLED;
        }
        isThrottled = false;
        const count = counter.get(now) || 0;
        counter.set(now, count + 1);
        return fn(...rest);
    };
}
class $4242ad5853add3e0$var$ReplayContainer {
    constructor({ options: options, recordingOptions: recordingOptions }){
        this.eventBuffer = null;
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        this.recordingMode = "session";
        this.timeouts = {
            sessionIdlePause: $4242ad5853add3e0$var$SESSION_IDLE_PAUSE_DURATION,
            sessionIdleExpire: $4242ad5853add3e0$var$SESSION_IDLE_EXPIRE_DURATION
        };
        this._lastActivity = Date.now();
        this._isEnabled = false;
        this._isPaused = false;
        this._requiresManualStart = false;
        this._hasInitializedCoreListeners = false;
        this._context = {
            errorIds: /* @__PURE__ */ new Set(),
            traceIds: /* @__PURE__ */ new Set(),
            urls: [],
            initialTimestamp: Date.now(),
            initialUrl: ""
        };
        this._recordingOptions = recordingOptions;
        this._options = options;
        this._debouncedFlush = $4242ad5853add3e0$var$debounce(()=>this._flush(), this._options.flushMinDelay, {
            maxWait: this._options.flushMaxDelay
        });
        this._throttledAddEvent = $4242ad5853add3e0$var$throttle((event, isCheckout)=>$4242ad5853add3e0$var$addEvent(this, event, isCheckout), // Max 300 events...
        300, // ... per 5s
        5);
        const { slowClickTimeout: slowClickTimeout, slowClickIgnoreSelectors: slowClickIgnoreSelectors } = this.getOptions();
        const slowClickConfig = slowClickTimeout ? {
            threshold: Math.min($4242ad5853add3e0$var$SLOW_CLICK_THRESHOLD, slowClickTimeout),
            timeout: slowClickTimeout,
            scrollTimeout: $4242ad5853add3e0$var$SLOW_CLICK_SCROLL_TIMEOUT,
            ignoreSelector: slowClickIgnoreSelectors ? slowClickIgnoreSelectors.join(",") : ""
        } : void 0;
        if (slowClickConfig) this.clickDetector = new $4242ad5853add3e0$var$ClickDetector(this, slowClickConfig);
        if ($4242ad5853add3e0$var$DEBUG_BUILD) {
            const experiments = options._experiments;
            $4242ad5853add3e0$var$debug.setConfig({
                captureExceptions: !!experiments.captureExceptions,
                traceInternals: !!experiments.traceInternals
            });
        }
        this._handleVisibilityChange = ()=>{
            if ($4242ad5853add3e0$var$WINDOW.document.visibilityState === "visible") this._doChangeToForegroundTasks();
            else this._doChangeToBackgroundTasks();
        };
        this._handleWindowBlur = ()=>{
            const breadcrumb = $4242ad5853add3e0$var$createBreadcrumb({
                category: "ui.blur"
            });
            this._doChangeToBackgroundTasks(breadcrumb);
        };
        this._handleWindowFocus = ()=>{
            const breadcrumb = $4242ad5853add3e0$var$createBreadcrumb({
                category: "ui.focus"
            });
            this._doChangeToForegroundTasks(breadcrumb);
        };
        this._handleKeyboardEvent = (event)=>{
            $4242ad5853add3e0$var$handleKeyboardEvent(this, event);
        };
    }
    /** Get the event context. */ getContext() {
        return this._context;
    }
    /** If recording is currently enabled. */ isEnabled() {
        return this._isEnabled;
    }
    /** If recording is currently paused. */ isPaused() {
        return this._isPaused;
    }
    /**
   * Determine if canvas recording is enabled
   */ isRecordingCanvas() {
        return Boolean(this._canvas);
    }
    /** Get the replay integration options. */ getOptions() {
        return this._options;
    }
    /** A wrapper to conditionally capture exceptions. */ handleException(error) {
        $4242ad5853add3e0$var$DEBUG_BUILD && $4242ad5853add3e0$var$debug.exception(error);
        if (this._options.onError) this._options.onError(error);
    }
    /**
   * Initializes the plugin based on sampling configuration. Should not be
   * called outside of constructor.
   */ initializeSampling(previousSessionId) {
        const { errorSampleRate: errorSampleRate, sessionSampleRate: sessionSampleRate } = this._options;
        const requiresManualStart = errorSampleRate <= 0 && sessionSampleRate <= 0;
        this._requiresManualStart = requiresManualStart;
        if (requiresManualStart) return;
        this._initializeSessionForSampling(previousSessionId);
        if (!this.session) {
            $4242ad5853add3e0$var$DEBUG_BUILD && $4242ad5853add3e0$var$debug.exception(new Error("Unable to initialize and create session"));
            return;
        }
        if (this.session.sampled === false) return;
        this.recordingMode = this.session.sampled === "buffer" && this.session.segmentId === 0 ? "buffer" : "session";
        $4242ad5853add3e0$var$DEBUG_BUILD && $4242ad5853add3e0$var$debug.infoTick(`Starting replay in ${this.recordingMode} mode`);
        this._initializeRecording();
    }
    /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will log a message if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * _performanceObserver, Recording, Sentry SDK, etc)
   */ start() {
        if (this._isEnabled && this.recordingMode === "session") {
            $4242ad5853add3e0$var$DEBUG_BUILD && $4242ad5853add3e0$var$debug.log("Recording is already in progress");
            return;
        }
        if (this._isEnabled && this.recordingMode === "buffer") {
            $4242ad5853add3e0$var$DEBUG_BUILD && $4242ad5853add3e0$var$debug.log("Buffering is in progress, call `flush()` to save the replay");
            return;
        }
        $4242ad5853add3e0$var$DEBUG_BUILD && $4242ad5853add3e0$var$debug.infoTick("Starting replay in session mode");
        this._updateUserActivity();
        const session = $4242ad5853add3e0$var$loadOrCreateSession({
            maxReplayDuration: this._options.maxReplayDuration,
            sessionIdleExpire: this.timeouts.sessionIdleExpire
        }, {
            stickySession: this._options.stickySession,
            // This is intentional: create a new session-based replay when calling `start()`
            sessionSampleRate: 1,
            allowBuffering: false
        });
        this.session = session;
        this.recordingMode = "session";
        this._initializeRecording();
    }
    /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, an error occurs.
   */ startBuffering() {
        if (this._isEnabled) {
            $4242ad5853add3e0$var$DEBUG_BUILD && $4242ad5853add3e0$var$debug.log("Buffering is in progress, call `flush()` to save the replay");
            return;
        }
        $4242ad5853add3e0$var$DEBUG_BUILD && $4242ad5853add3e0$var$debug.infoTick("Starting replay in buffer mode");
        const session = $4242ad5853add3e0$var$loadOrCreateSession({
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration
        }, {
            stickySession: this._options.stickySession,
            sessionSampleRate: 0,
            allowBuffering: true
        });
        this.session = session;
        this.recordingMode = "buffer";
        this._initializeRecording();
    }
    /**
   * Start recording.
   *
   * Note that this will cause a new DOM checkout
   */ startRecording() {
        try {
            const canvasOptions = this._canvas;
            this._stopRecording = $4242ad5853add3e0$var$record({
                ...this._recordingOptions,
                // When running in error sampling mode, we need to overwrite `checkoutEveryNms`
                // Without this, it would record forever, until an error happens, which we don't want
                // instead, we'll always keep the last 60 seconds of replay before an error happened
                ...this.recordingMode === "buffer" ? {
                    checkoutEveryNms: $4242ad5853add3e0$var$BUFFER_CHECKOUT_TIME
                } : // Otherwise, use experimental option w/ min checkout time of 6 minutes
                // This is to improve playback seeking as there could potentially be
                // less mutations to process in the worse cases.
                //
                // checkout by "N" events is probably ideal, but means we have less
                // control about the number of checkouts we make (which generally
                // increases replay size)
                this._options._experiments.continuousCheckout && {
                    // Minimum checkout time is 6 minutes
                    checkoutEveryNms: Math.max(36e4, this._options._experiments.continuousCheckout)
                },
                emit: $4242ad5853add3e0$var$getHandleRecordingEmit(this),
                ...$4242ad5853add3e0$var$getRecordingSamplingOptions(),
                onMutation: this._onMutationHandler.bind(this),
                ...canvasOptions ? {
                    recordCanvas: canvasOptions.recordCanvas,
                    getCanvasManager: canvasOptions.getCanvasManager,
                    sampling: canvasOptions.sampling,
                    dataURLOptions: canvasOptions.dataURLOptions
                } : {}
            });
        } catch (err) {
            this.handleException(err);
        }
    }
    /**
   * Stops the recording, if it was running.
   *
   * Returns true if it was previously stopped, or is now stopped,
   * otherwise false.
   */ stopRecording() {
        try {
            if (this._stopRecording) {
                this._stopRecording();
                this._stopRecording = void 0;
            }
            return true;
        } catch (err) {
            this.handleException(err);
            return false;
        }
    }
    /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */ async stop({ forceFlush: forceFlush = false, reason: reason } = {}) {
        if (!this._isEnabled) return;
        this._isEnabled = false;
        this.recordingMode = "buffer";
        const stopReason = reason ?? "manual";
        (0, $feb8814e57364805$export$6bb76d6eba7e258c)()?.emit("replayEnd", {
            sessionId: this.session?.id,
            reason: stopReason
        });
        try {
            $4242ad5853add3e0$var$DEBUG_BUILD && $4242ad5853add3e0$var$debug.log(`Stopping Replay triggered by ${stopReason}`);
            $4242ad5853add3e0$var$resetReplayIdOnDynamicSamplingContext();
            this._removeListeners();
            this.stopRecording();
            this._debouncedFlush.cancel();
            if (forceFlush) await this._flush({
                force: true
            });
            this.eventBuffer?.destroy();
            this.eventBuffer = null;
            $4242ad5853add3e0$var$clearSession(this);
        } catch (err) {
            this.handleException(err);
        }
    }
    /**
   * Pause some replay functionality. See comments for `_isPaused`.
   * This differs from stop as this only stops DOM recording, it is
   * not as thorough of a shutdown as `stop()`.
   */ pause() {
        if (this._isPaused) return;
        this._isPaused = true;
        this.stopRecording();
        $4242ad5853add3e0$var$DEBUG_BUILD && $4242ad5853add3e0$var$debug.log("Pausing replay");
    }
    /**
   * Resumes recording, see notes for `pause().
   *
   * Note that calling `startRecording()` here will cause a
   * new DOM checkout.`
   */ resume() {
        if (!this._isPaused || !this._checkSession()) return;
        this._isPaused = false;
        this.startRecording();
        $4242ad5853add3e0$var$DEBUG_BUILD && $4242ad5853add3e0$var$debug.log("Resuming replay");
    }
    /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */ async sendBufferedReplayOrFlush({ continueRecording: continueRecording = true } = {}) {
        if (this.recordingMode === "session") return this.flushImmediate();
        const activityTime = Date.now();
        $4242ad5853add3e0$var$DEBUG_BUILD && $4242ad5853add3e0$var$debug.log("Converting buffer to session");
        await this.flushImmediate();
        const hasStoppedRecording = this.stopRecording();
        if (!continueRecording || !hasStoppedRecording) return;
        if (this.recordingMode === "session") return;
        this.recordingMode = "session";
        if (this.session) {
            this.session.dirty = false;
            this._updateUserActivity(activityTime);
            this._updateSessionActivity(activityTime);
            this._maybeSaveSession();
            $4242ad5853add3e0$var$setReplayIdOnDynamicSamplingContext(this.session.id);
        }
        this.startRecording();
    }
    /**
   * We want to batch uploads of replay events. Save events only if
   * `<flushMinDelay>` milliseconds have elapsed since the last event
   * *OR* if `<flushMaxDelay>` milliseconds have elapsed.
   *
   * Accepts a callback to perform side-effects and returns true to stop batch
   * processing and hand back control to caller.
   */ addUpdate(cb) {
        const cbResult = cb();
        if (this.recordingMode === "buffer" || !this._isEnabled) return;
        if (cbResult === true) return;
        this._debouncedFlush();
    }
    /**
   * Updates the user activity timestamp and resumes recording. This should be
   * called in an event handler for a user action that we consider as the user
   * being "active" (e.g. a mouse click).
   */ triggerUserActivity() {
        this._updateUserActivity();
        if (!this._stopRecording) {
            if (!this._checkSession()) return;
            this.resume();
            return;
        }
        this.checkAndHandleExpiredSession();
        this._updateSessionActivity();
    }
    /**
   * Updates the user activity timestamp *without* resuming
   * recording. Some user events (e.g. keydown) can be create
   * low-value replays that only contain the keypress as a
   * breadcrumb. Instead this would require other events to
   * create a new replay after a session has expired.
   */ updateUserActivity() {
        this._updateUserActivity();
        this._updateSessionActivity();
    }
    /**
   * Only flush if `this.recordingMode === 'session'`
   */ conditionalFlush() {
        if (this.recordingMode === "buffer") return Promise.resolve();
        return this.flushImmediate();
    }
    /**
   * Flush using debounce flush
   */ flush() {
        return this._debouncedFlush();
    }
    /**
   * Always flush via `_debouncedFlush` so that we do not have flushes triggered
   * from calling both `flush` and `_debouncedFlush`. Otherwise, there could be
   * cases of multiple flushes happening closely together.
   */ flushImmediate() {
        this._debouncedFlush();
        return this._debouncedFlush.flush();
    }
    /**
   * Cancels queued up flushes.
   */ cancelFlush() {
        this._debouncedFlush.cancel();
    }
    /** Get the current session (=replay) ID
   *
   * @param onlyIfSampled - If true, will only return the session ID if the session is sampled.
   */ getSessionId(onlyIfSampled) {
        if (onlyIfSampled && this.session?.sampled === false) return void 0;
        return this.session?.id;
    }
    /**
   * Checks if recording should be stopped due to user inactivity. Otherwise
   * check if session is expired and create a new session if so. Triggers a new
   * full snapshot on new session.
   *
   * Returns true if session is not expired, false otherwise.
   * @hidden
   */ checkAndHandleExpiredSession() {
        if (this._lastActivity && $4242ad5853add3e0$var$isExpired(this._lastActivity, this.timeouts.sessionIdlePause) && this.session?.sampled === "session") {
            this.pause();
            return;
        }
        if (!this._checkSession()) return false;
        return true;
    }
    /**
   * Capture some initial state that can change throughout the lifespan of the
   * replay. This is required because otherwise they would be captured at the
   * first flush.
   */ setInitialState() {
        const urlPath = `${$4242ad5853add3e0$var$WINDOW.location.pathname}${$4242ad5853add3e0$var$WINDOW.location.hash}${$4242ad5853add3e0$var$WINDOW.location.search}`;
        const url = `${$4242ad5853add3e0$var$WINDOW.location.origin}${urlPath}`;
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        this._clearContext();
        this._context.initialUrl = url;
        this._context.initialTimestamp = Date.now();
        this._context.urls.push(url);
    }
    /**
   * Add a breadcrumb event, that may be throttled.
   * If it was throttled, we add a custom breadcrumb to indicate that.
   */ throttledAddEvent(event, isCheckout) {
        const res = this._throttledAddEvent(event, isCheckout);
        if (res === $4242ad5853add3e0$var$THROTTLED) {
            const breadcrumb = $4242ad5853add3e0$var$createBreadcrumb({
                category: "replay.throttled"
            });
            this.addUpdate(()=>{
                return !$4242ad5853add3e0$var$addEventSync(this, {
                    type: $4242ad5853add3e0$var$ReplayEventTypeCustom,
                    timestamp: breadcrumb.timestamp || 0,
                    data: {
                        tag: "breadcrumb",
                        payload: breadcrumb,
                        metric: true
                    }
                });
            });
        }
        return res;
    }
    /**
   * This will get the parametrized route name of the current page.
   * This is only available if performance is enabled, and if an instrumented router is used.
   */ getCurrentRoute() {
        const lastActiveSpan = this.lastActiveSpan || (0, $5a613f00f24f7165$export$1be426a8e585c83e)();
        const lastRootSpan = lastActiveSpan && (0, $5a613f00f24f7165$export$c4c6a79b1260ca1b)(lastActiveSpan);
        const attributes = lastRootSpan && (0, $5a613f00f24f7165$export$92d8c23565496537)(lastRootSpan).data || {};
        const source = attributes[0, $fbf607a81dcbd641$export$d7a7d984b0791405];
        if (!lastRootSpan || !source || ![
            "route",
            "custom"
        ].includes(source)) return void 0;
        return (0, $5a613f00f24f7165$export$92d8c23565496537)(lastRootSpan).description;
    }
    /**
   * Initialize and start all listeners to varying events (DOM,
   * Performance Observer, Recording, Sentry SDK, etc)
   */ _initializeRecording() {
        this.setInitialState();
        this._updateSessionActivity();
        this.eventBuffer = $4242ad5853add3e0$var$createEventBuffer({
            useCompression: this._options.useCompression,
            workerUrl: this._options.workerUrl
        });
        this._removeListeners();
        this._addListeners();
        this._isEnabled = true;
        this._isPaused = false;
        if (this.session) (0, $feb8814e57364805$export$6bb76d6eba7e258c)()?.emit("replayStart", {
            sessionId: this.session.id,
            recordingMode: this.recordingMode
        });
        this.startRecording();
        if (this.recordingMode === "session" && this.session) $4242ad5853add3e0$var$setReplayIdOnDynamicSamplingContext(this.session.id);
    }
    /**
   * Loads (or refreshes) the current session.
   */ _initializeSessionForSampling(previousSessionId) {
        const allowBuffering = this._options.errorSampleRate > 0;
        const session = $4242ad5853add3e0$var$loadOrCreateSession({
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration,
            previousSessionId: previousSessionId
        }, {
            stickySession: this._options.stickySession,
            sessionSampleRate: this._options.sessionSampleRate,
            allowBuffering: allowBuffering
        });
        this.session = session;
    }
    /**
   * Checks and potentially refreshes the current session.
   * Returns false if session is not recorded.
   */ _checkSession() {
        if (!this.session) return false;
        const currentSession = this.session;
        if ($4242ad5853add3e0$var$shouldRefreshSession(currentSession, {
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration
        })) {
            this._refreshSession(currentSession);
            return false;
        }
        return true;
    }
    /**
   * Refresh a session with a new one.
   * This stops the current session (without forcing a flush, as that would never work since we are expired),
   * and then does a new sampling based on the refreshed session.
   */ async _refreshSession(session) {
        if (!this._isEnabled) return;
        await this.stop({
            reason: "sessionExpired"
        });
        this.initializeSampling(session.id);
    }
    /**
   * Adds listeners to record events for the replay
   */ _addListeners() {
        try {
            $4242ad5853add3e0$var$WINDOW.document.addEventListener("visibilitychange", this._handleVisibilityChange);
            $4242ad5853add3e0$var$WINDOW.addEventListener("blur", this._handleWindowBlur);
            $4242ad5853add3e0$var$WINDOW.addEventListener("focus", this._handleWindowFocus);
            $4242ad5853add3e0$var$WINDOW.addEventListener("keydown", this._handleKeyboardEvent);
            if (this.clickDetector) this.clickDetector.addListeners();
            if (!this._hasInitializedCoreListeners) {
                $4242ad5853add3e0$var$addGlobalListeners(this);
                this._hasInitializedCoreListeners = true;
            }
        } catch (err) {
            this.handleException(err);
        }
        this._performanceCleanupCallback = $4242ad5853add3e0$var$setupPerformanceObserver(this);
    }
    /**
   * Cleans up listeners that were created in `_addListeners`
   */ _removeListeners() {
        try {
            $4242ad5853add3e0$var$WINDOW.document.removeEventListener("visibilitychange", this._handleVisibilityChange);
            $4242ad5853add3e0$var$WINDOW.removeEventListener("blur", this._handleWindowBlur);
            $4242ad5853add3e0$var$WINDOW.removeEventListener("focus", this._handleWindowFocus);
            $4242ad5853add3e0$var$WINDOW.removeEventListener("keydown", this._handleKeyboardEvent);
            if (this.clickDetector) this.clickDetector.removeListeners();
            if (this._performanceCleanupCallback) this._performanceCleanupCallback();
        } catch (err) {
            this.handleException(err);
        }
    }
    /**
   * Tasks to run when we consider a page to be hidden (via blurring and/or visibility)
   */ _doChangeToBackgroundTasks(breadcrumb) {
        if (!this.session) return;
        const expired = $4242ad5853add3e0$var$shouldRefreshSession(this.session, {
            maxReplayDuration: this._options.maxReplayDuration,
            sessionIdleExpire: this.timeouts.sessionIdleExpire
        });
        if (expired) {
            $4242ad5853add3e0$var$resetReplayIdOnDynamicSamplingContext();
            return;
        }
        if (breadcrumb) this._createCustomBreadcrumb(breadcrumb);
        this.conditionalFlush();
    }
    /**
   * Tasks to run when we consider a page to be visible (via focus and/or visibility)
   */ _doChangeToForegroundTasks(breadcrumb) {
        if (!this.session) return;
        const isSessionActive = this.checkAndHandleExpiredSession();
        if (!isSessionActive) {
            $4242ad5853add3e0$var$DEBUG_BUILD && $4242ad5853add3e0$var$debug.log("Document has become active, but session has expired");
            return;
        }
        if (breadcrumb) this._createCustomBreadcrumb(breadcrumb);
    }
    /**
   * Update user activity (across session lifespans)
   */ _updateUserActivity(_lastActivity = Date.now()) {
        this._lastActivity = _lastActivity;
    }
    /**
   * Updates the session's last activity timestamp
   */ _updateSessionActivity(_lastActivity = Date.now()) {
        if (this.session) {
            this.session.lastActivity = _lastActivity;
            this._maybeSaveSession();
        }
    }
    /**
   * Helper to create (and buffer) a replay breadcrumb from a core SDK breadcrumb
   */ _createCustomBreadcrumb(breadcrumb) {
        this.addUpdate(()=>{
            this.throttledAddEvent({
                type: $4242ad5853add3e0$var$EventType.Custom,
                timestamp: breadcrumb.timestamp || 0,
                data: {
                    tag: "breadcrumb",
                    payload: breadcrumb
                }
            });
        });
    }
    /**
   * Observed performance events are added to `this.performanceEntries`. These
   * are included in the replay event before it is finished and sent to Sentry.
   */ _addPerformanceEntries() {
        let performanceEntries = $4242ad5853add3e0$var$createPerformanceEntries(this.performanceEntries).concat(this.replayPerformanceEntries);
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        if (this._requiresManualStart) {
            const initialTimestampInSeconds = this._context.initialTimestamp / 1e3;
            performanceEntries = performanceEntries.filter((entry)=>entry.start >= initialTimestampInSeconds);
        }
        return Promise.all($4242ad5853add3e0$var$createPerformanceSpans(this, performanceEntries));
    }
    /**
   * Clear _context
   */ _clearContext() {
        this._context.errorIds.clear();
        this._context.traceIds.clear();
        this._context.urls = [];
    }
    /** Update the initial timestamp based on the buffer content. */ _updateInitialTimestampFromEventBuffer() {
        const { session: session, eventBuffer: eventBuffer } = this;
        if (!session || !eventBuffer || this._requiresManualStart) return;
        if (session.segmentId) return;
        const earliestEvent = eventBuffer.getEarliestTimestamp();
        if (earliestEvent && earliestEvent < this._context.initialTimestamp) this._context.initialTimestamp = earliestEvent;
    }
    /**
   * Return and clear _context
   */ _popEventContext() {
        const _context = {
            initialTimestamp: this._context.initialTimestamp,
            initialUrl: this._context.initialUrl,
            errorIds: Array.from(this._context.errorIds),
            traceIds: Array.from(this._context.traceIds),
            urls: this._context.urls
        };
        this._clearContext();
        return _context;
    }
    /**
   * Flushes replay event buffer to Sentry.
   *
   * Performance events are only added right before flushing - this is
   * due to the buffered performance observer events.
   *
   * Should never be called directly, only by `flush`
   */ async _runFlush() {
        const replayId = this.getSessionId();
        if (!this.session || !this.eventBuffer || !replayId) {
            $4242ad5853add3e0$var$DEBUG_BUILD && $4242ad5853add3e0$var$debug.error("No session or eventBuffer found to flush.");
            return;
        }
        await this._addPerformanceEntries();
        if (!this.eventBuffer?.hasEvents) return;
        await $4242ad5853add3e0$var$addMemoryEntry(this);
        if (!this.eventBuffer) return;
        if (replayId !== this.getSessionId()) return;
        try {
            this._updateInitialTimestampFromEventBuffer();
            const timestamp = Date.now();
            if (timestamp - this._context.initialTimestamp > this._options.maxReplayDuration + 3e4) throw new $4242ad5853add3e0$var$ReplayDurationLimitError();
            const eventContext = this._popEventContext();
            const segmentId = this.session.segmentId++;
            this._maybeSaveSession();
            const recordingData = await this.eventBuffer.finish();
            await $4242ad5853add3e0$var$sendReplay({
                replayId: replayId,
                recordingData: recordingData,
                segmentId: segmentId,
                eventContext: eventContext,
                session: this.session,
                timestamp: timestamp,
                onError: (err)=>this.handleException(err)
            });
        } catch (err) {
            this.handleException(err);
            this.stop({
                reason: "sendError"
            });
            const client = (0, $feb8814e57364805$export$6bb76d6eba7e258c)();
            if (client) {
                let dropReason;
                if (err instanceof $4242ad5853add3e0$var$RateLimitError) dropReason = "ratelimit_backoff";
                else if (err instanceof $4242ad5853add3e0$var$ReplayDurationLimitError) dropReason = "invalid";
                else dropReason = "send_error";
                client.recordDroppedEvent(dropReason, "replay");
            }
        }
    }
    /**
   * Flush recording data to Sentry. Creates a lock so that only a single flush
   * can be active at a time. Do not call this directly.
   */ async _flush({ force: force = false } = {}) {
        if (!this._isEnabled && !force) return;
        if (!this.checkAndHandleExpiredSession()) {
            $4242ad5853add3e0$var$DEBUG_BUILD && $4242ad5853add3e0$var$debug.error("Attempting to finish replay event after session expired.");
            return;
        }
        if (!this.session) return;
        const start = this.session.started;
        const now = Date.now();
        const duration = now - start;
        this._debouncedFlush.cancel();
        const tooShort = duration < this._options.minReplayDuration;
        const tooLong = duration > this._options.maxReplayDuration + 5e3;
        if (tooShort || tooLong) {
            $4242ad5853add3e0$var$DEBUG_BUILD && $4242ad5853add3e0$var$debug.log(`Session duration (${Math.floor(duration / 1e3)}s) is too ${tooShort ? "short" : "long"}, not sending replay.`);
            if (tooShort) this._debouncedFlush();
            return;
        }
        const eventBuffer = this.eventBuffer;
        if (eventBuffer && this.session.segmentId === 0 && !eventBuffer.hasCheckout) $4242ad5853add3e0$var$DEBUG_BUILD && $4242ad5853add3e0$var$debug.log("Flushing initial segment without checkout.");
        const _flushInProgress = !!this._flushLock;
        if (!this._flushLock) this._flushLock = this._runFlush();
        try {
            await this._flushLock;
        } catch (err) {
            this.handleException(err);
        } finally{
            this._flushLock = void 0;
            if (_flushInProgress) this._debouncedFlush();
        }
    }
    /** Save the session, if it is sticky */ _maybeSaveSession() {
        if (this.session && this._options.stickySession) $4242ad5853add3e0$var$saveSession(this.session);
    }
    /** Handler for rrweb.record.onMutation */ _onMutationHandler(mutations) {
        const { ignoreMutations: ignoreMutations } = this._options._experiments;
        if (ignoreMutations?.length) {
            if (mutations.some((mutation)=>{
                const el = $4242ad5853add3e0$var$closestElementOfNode(mutation.target);
                const selector = ignoreMutations.join(",");
                return el?.matches(selector);
            })) return false;
        }
        const count = mutations.length;
        const mutationLimit = this._options.mutationLimit;
        const mutationBreadcrumbLimit = this._options.mutationBreadcrumbLimit;
        const overMutationLimit = mutationLimit && count > mutationLimit;
        if (count > mutationBreadcrumbLimit || overMutationLimit) {
            const breadcrumb = $4242ad5853add3e0$var$createBreadcrumb({
                category: "replay.mutations",
                data: {
                    count: count,
                    limit: overMutationLimit
                }
            });
            this._createCustomBreadcrumb(breadcrumb);
        }
        if (overMutationLimit) {
            this.stop({
                reason: "mutationLimit",
                forceFlush: this.recordingMode === "session"
            });
            return false;
        }
        return true;
    }
}
function $4242ad5853add3e0$var$getOption(selectors, defaultSelectors) {
    return [
        ...selectors,
        // sentry defaults
        ...defaultSelectors
    ].join(",");
}
function $4242ad5853add3e0$var$getPrivacyOptions({ mask: mask, unmask: unmask, block: block, unblock: unblock, ignore: ignore }) {
    const defaultBlockedElements = [
        "base",
        "iframe[srcdoc]:not([src])"
    ];
    const maskSelector = $4242ad5853add3e0$var$getOption(mask, [
        ".sentry-mask",
        "[data-sentry-mask]"
    ]);
    const unmaskSelector = $4242ad5853add3e0$var$getOption(unmask, []);
    const options = {
        // We are making the decision to make text and input selectors the same
        maskTextSelector: maskSelector,
        unmaskTextSelector: unmaskSelector,
        blockSelector: $4242ad5853add3e0$var$getOption(block, [
            ".sentry-block",
            "[data-sentry-block]",
            ...defaultBlockedElements
        ]),
        unblockSelector: $4242ad5853add3e0$var$getOption(unblock, []),
        ignoreSelector: $4242ad5853add3e0$var$getOption(ignore, [
            ".sentry-ignore",
            "[data-sentry-ignore]",
            'input[type="file"]'
        ])
    };
    return options;
}
function $4242ad5853add3e0$var$maskAttribute({ el: el, key: key, maskAttributes: maskAttributes, maskAllText: maskAllText, privacyOptions: privacyOptions, value: value }) {
    if (privacyOptions.unmaskTextSelector && el.matches(privacyOptions.unmaskTextSelector)) return value;
    const masksNamedAttribute = maskAttributes.includes(key);
    const masksSubmitButtonValue = maskAllText && key === "value" && el.tagName === "INPUT" && [
        "submit",
        "button"
    ].includes(el.getAttribute("type") || "");
    if (masksNamedAttribute || masksSubmitButtonValue) return value.replace(/[\S]/g, "*");
    return value;
}
const $4242ad5853add3e0$var$MEDIA_SELECTORS = 'img,image,svg,video,object,picture,embed,map,audio,link[rel="icon"],link[rel="apple-touch-icon"]';
const $4242ad5853add3e0$var$DEFAULT_NETWORK_HEADERS = [
    "content-length",
    "content-type",
    "accept"
];
const $4242ad5853add3e0$var$ORIGINAL_BODY = /* @__PURE__ */ Symbol.for("sentry__originalRequestBody");
let $4242ad5853add3e0$var$_initialized = false;
let $4242ad5853add3e0$var$_isRequestInstrumented = false;
function $4242ad5853add3e0$var$_INTERNAL_instrumentRequestInterface() {
    if (typeof Request === "undefined" || $4242ad5853add3e0$var$_isRequestInstrumented) return;
    const OriginalRequest = Request;
    try {
        const SentryRequest = function(input, init) {
            const request = new OriginalRequest(input, init);
            if (init?.body != null) request[$4242ad5853add3e0$var$ORIGINAL_BODY] = init.body;
            return request;
        };
        SentryRequest.prototype = OriginalRequest.prototype;
        (0, $f217104c897b328f$export$f1a6cdb1459e81d1).Request = SentryRequest;
        $4242ad5853add3e0$var$_isRequestInstrumented = true;
    } catch  {}
}
const $4242ad5853add3e0$export$d7706faf7ab354bf = (options)=>{
    return new $4242ad5853add3e0$var$Replay(options);
};
class $4242ad5853add3e0$var$Replay {
    constructor({ flushMinDelay: flushMinDelay = $4242ad5853add3e0$var$DEFAULT_FLUSH_MIN_DELAY, flushMaxDelay: flushMaxDelay = $4242ad5853add3e0$var$DEFAULT_FLUSH_MAX_DELAY, minReplayDuration: minReplayDuration = $4242ad5853add3e0$var$MIN_REPLAY_DURATION, maxReplayDuration: maxReplayDuration = $4242ad5853add3e0$var$MAX_REPLAY_DURATION, stickySession: stickySession = true, useCompression: useCompression = true, workerUrl: workerUrl, _experiments: _experiments = {}, maskAllText: maskAllText = true, maskAllInputs: maskAllInputs = true, blockAllMedia: blockAllMedia = true, mutationBreadcrumbLimit: mutationBreadcrumbLimit = 750, mutationLimit: mutationLimit = 1e4, slowClickTimeout: slowClickTimeout = 7e3, slowClickIgnoreSelectors: slowClickIgnoreSelectors = [], networkDetailAllowUrls: networkDetailAllowUrls = [], networkDetailDenyUrls: networkDetailDenyUrls = [], networkCaptureBodies: networkCaptureBodies = true, networkRequestHeaders: networkRequestHeaders = [], networkResponseHeaders: networkResponseHeaders = [], mask: mask = [], maskAttributes: maskAttributes = [
        "title",
        "placeholder",
        "aria-label"
    ], unmask: unmask = [], block: block = [], unblock: unblock = [], ignore: ignore = [], maskFn: maskFn, beforeAddRecordingEvent: beforeAddRecordingEvent, beforeErrorSampling: beforeErrorSampling, onError: onError, attachRawBodyFromRequest: attachRawBodyFromRequest = false } = {}){
        this.name = "Replay";
        const privacyOptions = $4242ad5853add3e0$var$getPrivacyOptions({
            mask: mask,
            unmask: unmask,
            block: block,
            unblock: unblock,
            ignore: ignore
        });
        this._recordingOptions = {
            maskAllInputs: maskAllInputs,
            maskAllText: maskAllText,
            maskInputOptions: {
                password: true
            },
            maskTextFn: maskFn,
            maskInputFn: maskFn,
            maskAttributeFn: (key, value, el)=>$4242ad5853add3e0$var$maskAttribute({
                    maskAttributes: maskAttributes,
                    maskAllText: maskAllText,
                    privacyOptions: privacyOptions,
                    key: key,
                    value: value,
                    el: el
                }),
            ...privacyOptions,
            // Our defaults
            slimDOMOptions: "all",
            inlineStylesheet: true,
            // Disable inline images as it will increase segment/replay size
            inlineImages: false,
            // collect fonts, but be aware that `sentry.io` needs to be an allowed
            // origin for playback
            collectFonts: true,
            errorHandler: (err)=>{
                try {
                    err.__rrweb__ = true;
                } catch  {}
            },
            // experimental support for recording iframes from different origins
            recordCrossOriginIframes: Boolean(_experiments.recordCrossOriginIframes)
        };
        this._initialOptions = {
            flushMinDelay: flushMinDelay,
            flushMaxDelay: flushMaxDelay,
            minReplayDuration: Math.min(minReplayDuration, $4242ad5853add3e0$var$MIN_REPLAY_DURATION_LIMIT),
            maxReplayDuration: Math.min(maxReplayDuration, $4242ad5853add3e0$var$MAX_REPLAY_DURATION),
            stickySession: stickySession,
            useCompression: useCompression,
            workerUrl: workerUrl,
            blockAllMedia: blockAllMedia,
            maskAllInputs: maskAllInputs,
            maskAllText: maskAllText,
            mutationBreadcrumbLimit: mutationBreadcrumbLimit,
            mutationLimit: mutationLimit,
            slowClickTimeout: slowClickTimeout,
            slowClickIgnoreSelectors: slowClickIgnoreSelectors,
            networkDetailAllowUrls: networkDetailAllowUrls,
            networkDetailDenyUrls: networkDetailDenyUrls,
            networkCaptureBodies: networkCaptureBodies,
            networkRequestHeaders: $4242ad5853add3e0$var$_getMergedNetworkHeaders(networkRequestHeaders),
            networkResponseHeaders: $4242ad5853add3e0$var$_getMergedNetworkHeaders(networkResponseHeaders),
            beforeAddRecordingEvent: beforeAddRecordingEvent,
            beforeErrorSampling: beforeErrorSampling,
            onError: onError,
            attachRawBodyFromRequest: attachRawBodyFromRequest,
            _experiments: _experiments
        };
        if (this._initialOptions.blockAllMedia) {
            this._recordingOptions.blockSelector = !this._recordingOptions.blockSelector ? $4242ad5853add3e0$var$MEDIA_SELECTORS : `${this._recordingOptions.blockSelector},${$4242ad5853add3e0$var$MEDIA_SELECTORS}`;
            this._recordingOptions.ignoreCSSAttributes = /* @__PURE__ */ new Set([
                "background-image"
            ]);
        }
        if (this._isInitialized && (0, $f90c965ae52ef7c3$export$4e09c449d6c407f7)()) throw new Error("Multiple Sentry Session Replay instances are not supported");
        this._isInitialized = true;
    }
    /** If replay has already been initialized */ get _isInitialized() {
        return $4242ad5853add3e0$var$_initialized;
    }
    /** Update _isInitialized */ set _isInitialized(value) {
        $4242ad5853add3e0$var$_initialized = value;
    }
    /**
   * Setup and initialize replay container
   */ afterAllSetup(client) {
        if (!(0, $f90c965ae52ef7c3$export$4e09c449d6c407f7)() || this._replay) return;
        if (this._initialOptions.attachRawBodyFromRequest) $4242ad5853add3e0$var$_INTERNAL_instrumentRequestInterface();
        this._setup(client);
        this._initialize(client);
    }
    /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will log a message if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * PerformanceObserver, Recording, Sentry SDK, etc)
   */ start() {
        if (!this._replay) return;
        this._replay.start();
    }
    /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, until an error occurs.
   */ startBuffering() {
        if (!this._replay) return;
        this._replay.startBuffering();
    }
    /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */ stop() {
        if (!this._replay) return Promise.resolve();
        return this._replay.stop({
            forceFlush: this._replay.recordingMode === "session",
            reason: "manual"
        });
    }
    /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * If replay is not enabled, a new session replay is started.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */ flush(options) {
        if (!this._replay) return Promise.resolve();
        if (!this._replay.isEnabled()) {
            this._replay.start();
            return Promise.resolve();
        }
        return this._replay.sendBufferedReplayOrFlush(options);
    }
    /**
   * Get the current session ID.
   *
   * @param onlyIfSampled - If true, will only return the session ID if the session is sampled.
   *
   */ getReplayId(onlyIfSampled) {
        if (!this._replay?.isEnabled()) return;
        return this._replay.getSessionId(onlyIfSampled);
    }
    /**
   * Get the current recording mode. This can be either `session` or `buffer`.
   *
   * `session`: Recording the whole session, sending it continuously
   * `buffer`: Always keeping the last 60s of recording, requires:
   *   - having replaysOnErrorSampleRate > 0 to capture replay when an error occurs
   *   - or calling `flush()` to send the replay
   */ getRecordingMode() {
        if (!this._replay?.isEnabled()) return;
        return this._replay.recordingMode;
    }
    processSpan(span) {
        const replayId = this.getReplayId(true);
        if (replayId) (0, $5cab9018a79b4113$export$146fcadff0eefcf3)(span, {
            "sentry.replay_id": replayId
        });
    }
    /**
   * Initializes replay.
   */ _initialize(client) {
        if (!this._replay) return;
        this._maybeLoadFromReplayCanvasIntegration(client);
        this._replay.initializeSampling();
    }
    /** Setup the integration. */ _setup(client) {
        const finalOptions = $4242ad5853add3e0$var$loadReplayOptionsFromClient(this._initialOptions, client);
        this._replay = new $4242ad5853add3e0$var$ReplayContainer({
            options: finalOptions,
            recordingOptions: this._recordingOptions
        });
    }
    /** Get canvas options from ReplayCanvas integration, if it is also added. */ _maybeLoadFromReplayCanvasIntegration(client) {
        try {
            const canvasIntegration = client.getIntegrationByName("ReplayCanvas");
            if (!canvasIntegration) return;
            this._replay["_canvas"] = canvasIntegration.getOptions();
        } catch  {}
    }
}
function $4242ad5853add3e0$var$loadReplayOptionsFromClient(initialOptions, client) {
    const opt = client.getOptions();
    const finalOptions = {
        sessionSampleRate: 0,
        errorSampleRate: 0,
        ...initialOptions
    };
    const replaysSessionSampleRate = (0, $4f88660a1945fceb$export$a5bd2d81656d9546)(opt.replaysSessionSampleRate);
    const replaysOnErrorSampleRate = (0, $4f88660a1945fceb$export$a5bd2d81656d9546)(opt.replaysOnErrorSampleRate);
    if (replaysSessionSampleRate == null && replaysOnErrorSampleRate == null) (0, $dd4af310e95b2daa$export$cda52e2a8927a2ca)(()=>{
        console.warn("Replay is disabled because neither `replaysSessionSampleRate` nor `replaysOnErrorSampleRate` are set.");
    });
    if (replaysSessionSampleRate != null) finalOptions.sessionSampleRate = replaysSessionSampleRate;
    if (replaysOnErrorSampleRate != null) finalOptions.errorSampleRate = replaysOnErrorSampleRate;
    return finalOptions;
}
function $4242ad5853add3e0$var$_getMergedNetworkHeaders(headers) {
    return [
        ...$4242ad5853add3e0$var$DEFAULT_NETWORK_HEADERS,
        ...headers.map((header)=>header.toLowerCase())
    ];
}
function $4242ad5853add3e0$export$b28310b2f161456b() {
    const client = (0, $feb8814e57364805$export$6bb76d6eba7e258c)();
    return client?.getIntegrationByName("Replay");
}


if (!window.location.hostname.includes('staging')) {
    $a3ef985a7674cc0b$export$2cd8252107eb640b({
        dsn: "https://66b5f54d37b1474daf0d95059e69c0b2@o929176.ingest.us.sentry.io/5878019",
        tracesSampleRate: 0.1,
        integrations: [
            $4242ad5853add3e0$export$d7706faf7ab354bf()
        ],
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
        environment: window.location.hostname,
        denyUrls: [
            /pagead\/js/i,
            /graph\.facebook\.com/i,
            /connect\.facebook\.net\/en_US\/all\.js/i,
            /eatdifferent\.com\.woopra-ns\.com/i,
            /static\.woopra\.com\/js\/woopra\.js/i,
            /extensions\//i,
            /^chrome:\/\//i,
            /127\.0\.0\.1:4001\/isrunning/i,
            /webappstoolbarba\.texthelp\.com\//i,
            /metrics\.itunes\.apple\.com\.edgesuite\.net\//i
        ]
    });
    $492f0fb96695dd9f$exports.setTag("environment", window.location.hostname);
    const currentScript = document.currentScript;
    const userNumber = currentScript?.getAttribute("user-number") ?? 0;
    $492f0fb96695dd9f$exports.setTag("userNumber", userNumber);
}


document.addEventListener("DOMContentLoaded", ()=>{
    if (!document.querySelector(".mainPage")) return;
    _paq.push([
        'trackEvent',
        'Navigation',
        'main'
    ]);
    $d34e11fe05604374$var$initDemo();
});
// "Zobacz UD w akcji" — auto-cycling demo. Progresuje ~4.5 s na krok, po czym
// przełącza się na następny (z zawijaniem). Klik na krok przeskakuje ręcznie.
function $d34e11fe05604374$var$initDemo() {
    const root = document.querySelector("[data-demo]");
    if (!root) return;
    const steps = [
        ...root.querySelectorAll("[data-demo-step]")
    ];
    const shots = [
        ...root.querySelectorAll("[data-demo-shot]")
    ];
    const bars = steps.map((s)=>s.querySelector(".mpr-demo-progress-bar"));
    const caption = root.querySelector("[data-demo-caption]");
    if (!steps.length || steps.length !== shots.length) return;
    const captions = [
        "Fotografujesz kontekst wykroczenia i pojazd \u2013 aplikacja prowadzi Ci\u0119 krok po kroku.",
        "Numer rejestracyjny, data i adres uzupe\u0142niaj\u0105 si\u0119 automatycznie ze zdj\u0119cia.",
        "Podgl\u0105d tre\u015Bci trafiaj\u0105cej do SM/na policj\u0119, zanim je wy\u015Blesz."
    ];
    const DURATION = 4500; // ms na krok
    let current = 0;
    let progress = 0; // 0..1 w obrębie bieżącego kroku
    let last = null;
    let raf = null;
    function render() {
        steps.forEach((s, i)=>s.classList.toggle("is-active", i === current));
        shots.forEach((s, i)=>s.classList.toggle("is-active", i === current));
        bars.forEach((bar, i)=>{
            if (!bar) return;
            const w = i < current ? 1 : i > current ? 0 : progress;
            bar.style.width = w * 100 + "%";
        });
        if (caption) caption.textContent = captions[current] || "";
    }
    function tick(now) {
        if (last == null) last = now;
        progress += (now - last) / DURATION;
        last = now;
        if (progress >= 1) {
            progress = 0;
            current = (current + 1) % steps.length;
        }
        render();
        raf = requestAnimationFrame(tick);
    }
    function setStep(i) {
        current = i;
        progress = 0;
        last = null;
        render();
    }
    steps.forEach((step, i)=>{
        step.addEventListener("click", ()=>setStep(i));
    });
    // Respektuj preferencję ograniczenia animacji — bez auto-cyklu, tylko klik.
    const reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    render();
    if (!reduce) raf = requestAnimationFrame(tick);
}


function $967c1a03034c09a9$export$2e2bcd8739ae039() {
    // @ts-ignore
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}


function $3ad154a167429c69$var$makeTabs() {
    const $tabs = document.querySelectorAll(".tabs > input");
    // @ts-ignore
    $tabs.addEventListener("click", $3ad154a167429c69$var$switchTab);
}
function $3ad154a167429c69$var$switchTab() {
    // @ts-ignore
    document.querySelectorAll(".tabcontent").display(false);
    // @ts-ignore
    document.querySelectorAll(".tablinks").removeClass("active");
    // @ts-ignore
    document.getElementById(`${this.id}-tab`).style.display = "block";
}
var $3ad154a167429c69$export$2e2bcd8739ae039 = $3ad154a167429c69$var$makeTabs;


document.addEventListener("DOMContentLoaded", ()=>{
    if (!document.getElementsByClassName('aplikacja').length) return;
    (0, $3ad154a167429c69$export$2e2bcd8739ae039)();
    const platform = (0, $967c1a03034c09a9$export$2e2bcd8739ae039)() ? "ios" : "android";
    // @ts-ignore
    document.getElementById(platform).checked = true;
    // @ts-ignore
    document.getElementById(`${platform}-tab`).style.display = "block";
});


document.addEventListener("DOMContentLoaded", ()=>{
    if (!document.querySelector(".confirm-application")) return;
    const appIdElement = document.getElementById("applicationId");
    let appId = null;
    if (appIdElement && 'value' in appIdElement) appId = appIdElement.value;
    _paq.push([
        'trackEvent',
        'Application',
        'set-status',
        appId
    ]);
    setTimeout(function() {
        const confirmButton = document.querySelector("a.confirm-send-button");
        if (confirmButton) confirmButton.classList.remove('disabled');
    }, 1500);
});
function $7acbdb77df2718ad$var$confirmApplication() {
    const form = /** @type {HTMLFormElement} */ document.getElementById('form');
    if (form) form.submit();
    const saveButton = document.querySelector('.confirm-save-button');
    if (saveButton) saveButton.classList.add('disabled');
}
// @ts-ignore
window.confirmApplication = $7acbdb77df2718ad$var$confirmApplication;


document.addEventListener("DOMContentLoaded", ()=>{
    if (!document.getElementsByClassName('faq').length) return;
    let copyLink = document.createElement('a');
    copyLink.classList.add('copyLink');
    copyLink.title = 'Skopiuk link do sekcji';
    copyLink.innerText = ' (skopiuj link)';
    document.querySelectorAll('h4[id]').forEach((node)=>node.appendChild(copyLink.cloneNode(true)));
    document.querySelectorAll('a.copyLink').addEventListener('click', function(e) {
        e.preventDefault();
        var copyText = `${window.location.origin}${window.location.pathname}#` + this.parentElement.id;
        navigator.clipboard.writeText(copyText);
    });
});


async function $96eeca436dcc5c1f$var$tumblr() {
    try {
        const response = await fetch("https://galeria.uprzejmiedonosze.net/api/read/json?num=30");
        const text = await response.text();
        // Remove JSONP callback wrapper
        const jsonText = text.replace(/^[^{]*/, '').replace(/[^}]*$/, '');
        const data = JSON.parse(jsonText);
        data.posts.forEach(function(post) {
            var postHtml = "";
            switch(post.type){
                case "regular":
                    if (post["regular-title"]) postHtml += "<h3>" + post["regular-title"] + "</h3>";
                    postHtml += "<p>" + post["regular-body"] + "</p>";
                    break;
                case "link":
                    postHtml = "<h3><a href='" + post["link-url"] + "'>" + post["link-text"] + "</a></h3>";
                    break;
                case "quote":
                    postHtml = post["quote-text"];
                    break;
                case "photo":
                    postHtml = '<div class="galleryItem"><a href=\'' + post["url-with-slug"] + "'><img src='" + post["photo-url-500"] + "'></a>";
                    if (post["photo-caption"]) postHtml += "<p>" + post["photo-caption"] + "</p>";
                    postHtml += "</li>";
                    break;
            }
            const loader = document.querySelector("div.loader");
            if (loader) loader.style.display = 'none';
            const tumblrPosts = document.querySelector("div.tumblr_posts");
            if (tumblrPosts) tumblrPosts.insertAdjacentHTML('beforeend', postHtml); // nosemgrep: typescript.react.security.audit.react-unsanitized-method.react-unsanitized-method
        });
    } catch (error) {
        console.error('Error loading gallery:', error);
    }
}
if (document.querySelector(".gallery")) document.addEventListener("DOMContentLoaded", function() {
    if (document.querySelector("div.tumblr_posts")) $96eeca436dcc5c1f$var$tumblr();
});



var $c9ee9f81cdf9785c$exports = {};
'use strict';
Object.defineProperty($c9ee9f81cdf9785c$exports, '__esModule', {
    value: true
});
function $c9ee9f81cdf9785c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $c9ee9f81cdf9785c$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $c9ee9f81cdf9785c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c9ee9f81cdf9785c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c9ee9f81cdf9785c$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $c9ee9f81cdf9785c$var$_extends() {
    $c9ee9f81cdf9785c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c9ee9f81cdf9785c$var$_extends.apply(this, arguments);
}
function $c9ee9f81cdf9785c$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $c9ee9f81cdf9785c$var$_setPrototypeOf(subClass, superClass);
}
function $c9ee9f81cdf9785c$var$_getPrototypeOf(o) {
    $c9ee9f81cdf9785c$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $c9ee9f81cdf9785c$var$_getPrototypeOf(o);
}
function $c9ee9f81cdf9785c$var$_setPrototypeOf(o, p) {
    $c9ee9f81cdf9785c$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $c9ee9f81cdf9785c$var$_setPrototypeOf(o, p);
}
function $c9ee9f81cdf9785c$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $c9ee9f81cdf9785c$var$_construct(Parent, args, Class) {
    if ($c9ee9f81cdf9785c$var$_isNativeReflectConstruct()) $c9ee9f81cdf9785c$var$_construct = Reflect.construct.bind();
    else $c9ee9f81cdf9785c$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $c9ee9f81cdf9785c$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $c9ee9f81cdf9785c$var$_construct.apply(null, arguments);
}
function $c9ee9f81cdf9785c$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $c9ee9f81cdf9785c$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $c9ee9f81cdf9785c$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$c9ee9f81cdf9785c$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $c9ee9f81cdf9785c$var$_construct(Class, arguments, $c9ee9f81cdf9785c$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $c9ee9f81cdf9785c$var$_setPrototypeOf(Wrapper, Class);
    };
    return $c9ee9f81cdf9785c$var$_wrapNativeSuper(Class);
}
function $c9ee9f81cdf9785c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $c9ee9f81cdf9785c$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c9ee9f81cdf9785c$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c9ee9f81cdf9785c$var$_arrayLikeToArray(o, minLen);
}
function $c9ee9f81cdf9785c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $c9ee9f81cdf9785c$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $c9ee9f81cdf9785c$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c9ee9f81cdf9785c$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $c9ee9f81cdf9785c$var$_toPropertyKey(arg) {
    var key = $c9ee9f81cdf9785c$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
// these aren't really private, but nor are they really useful to document
/**
 * @private
 */ var $c9ee9f81cdf9785c$var$LuxonError = /*#__PURE__*/ function(_Error) {
    $c9ee9f81cdf9785c$var$_inheritsLoose(LuxonError, _Error);
    function LuxonError() {
        return _Error.apply(this, arguments) || this;
    }
    return LuxonError;
}(/*#__PURE__*/ $c9ee9f81cdf9785c$var$_wrapNativeSuper(Error));
/**
 * @private
 */ var $c9ee9f81cdf9785c$var$InvalidDateTimeError = /*#__PURE__*/ function(_LuxonError) {
    $c9ee9f81cdf9785c$var$_inheritsLoose(InvalidDateTimeError, _LuxonError);
    function InvalidDateTimeError(reason) {
        return _LuxonError.call(this, "Invalid DateTime: " + reason.toMessage()) || this;
    }
    return InvalidDateTimeError;
}($c9ee9f81cdf9785c$var$LuxonError);
/**
 * @private
 */ var $c9ee9f81cdf9785c$var$InvalidIntervalError = /*#__PURE__*/ function(_LuxonError2) {
    $c9ee9f81cdf9785c$var$_inheritsLoose(InvalidIntervalError, _LuxonError2);
    function InvalidIntervalError(reason) {
        return _LuxonError2.call(this, "Invalid Interval: " + reason.toMessage()) || this;
    }
    return InvalidIntervalError;
}($c9ee9f81cdf9785c$var$LuxonError);
/**
 * @private
 */ var $c9ee9f81cdf9785c$var$InvalidDurationError = /*#__PURE__*/ function(_LuxonError3) {
    $c9ee9f81cdf9785c$var$_inheritsLoose(InvalidDurationError, _LuxonError3);
    function InvalidDurationError(reason) {
        return _LuxonError3.call(this, "Invalid Duration: " + reason.toMessage()) || this;
    }
    return InvalidDurationError;
}($c9ee9f81cdf9785c$var$LuxonError);
/**
 * @private
 */ var $c9ee9f81cdf9785c$var$ConflictingSpecificationError = /*#__PURE__*/ function(_LuxonError4) {
    $c9ee9f81cdf9785c$var$_inheritsLoose(ConflictingSpecificationError, _LuxonError4);
    function ConflictingSpecificationError() {
        return _LuxonError4.apply(this, arguments) || this;
    }
    return ConflictingSpecificationError;
}($c9ee9f81cdf9785c$var$LuxonError);
/**
 * @private
 */ var $c9ee9f81cdf9785c$var$InvalidUnitError = /*#__PURE__*/ function(_LuxonError5) {
    $c9ee9f81cdf9785c$var$_inheritsLoose(InvalidUnitError, _LuxonError5);
    function InvalidUnitError(unit) {
        return _LuxonError5.call(this, "Invalid unit " + unit) || this;
    }
    return InvalidUnitError;
}($c9ee9f81cdf9785c$var$LuxonError);
/**
 * @private
 */ var $c9ee9f81cdf9785c$var$InvalidArgumentError = /*#__PURE__*/ function(_LuxonError6) {
    $c9ee9f81cdf9785c$var$_inheritsLoose(InvalidArgumentError, _LuxonError6);
    function InvalidArgumentError() {
        return _LuxonError6.apply(this, arguments) || this;
    }
    return InvalidArgumentError;
}($c9ee9f81cdf9785c$var$LuxonError);
/**
 * @private
 */ var $c9ee9f81cdf9785c$var$ZoneIsAbstractError = /*#__PURE__*/ function(_LuxonError7) {
    $c9ee9f81cdf9785c$var$_inheritsLoose(ZoneIsAbstractError, _LuxonError7);
    function ZoneIsAbstractError() {
        return _LuxonError7.call(this, "Zone is an abstract class") || this;
    }
    return ZoneIsAbstractError;
}($c9ee9f81cdf9785c$var$LuxonError);
/**
 * @private
 */ var $c9ee9f81cdf9785c$var$n = "numeric", $c9ee9f81cdf9785c$var$s = "short", $c9ee9f81cdf9785c$var$l = "long";
var $c9ee9f81cdf9785c$var$DATE_SHORT = {
    year: $c9ee9f81cdf9785c$var$n,
    month: $c9ee9f81cdf9785c$var$n,
    day: $c9ee9f81cdf9785c$var$n
};
var $c9ee9f81cdf9785c$var$DATE_MED = {
    year: $c9ee9f81cdf9785c$var$n,
    month: $c9ee9f81cdf9785c$var$s,
    day: $c9ee9f81cdf9785c$var$n
};
var $c9ee9f81cdf9785c$var$DATE_MED_WITH_WEEKDAY = {
    year: $c9ee9f81cdf9785c$var$n,
    month: $c9ee9f81cdf9785c$var$s,
    day: $c9ee9f81cdf9785c$var$n,
    weekday: $c9ee9f81cdf9785c$var$s
};
var $c9ee9f81cdf9785c$var$DATE_FULL = {
    year: $c9ee9f81cdf9785c$var$n,
    month: $c9ee9f81cdf9785c$var$l,
    day: $c9ee9f81cdf9785c$var$n
};
var $c9ee9f81cdf9785c$var$DATE_HUGE = {
    year: $c9ee9f81cdf9785c$var$n,
    month: $c9ee9f81cdf9785c$var$l,
    day: $c9ee9f81cdf9785c$var$n,
    weekday: $c9ee9f81cdf9785c$var$l
};
var $c9ee9f81cdf9785c$var$TIME_SIMPLE = {
    hour: $c9ee9f81cdf9785c$var$n,
    minute: $c9ee9f81cdf9785c$var$n
};
var $c9ee9f81cdf9785c$var$TIME_WITH_SECONDS = {
    hour: $c9ee9f81cdf9785c$var$n,
    minute: $c9ee9f81cdf9785c$var$n,
    second: $c9ee9f81cdf9785c$var$n
};
var $c9ee9f81cdf9785c$var$TIME_WITH_SHORT_OFFSET = {
    hour: $c9ee9f81cdf9785c$var$n,
    minute: $c9ee9f81cdf9785c$var$n,
    second: $c9ee9f81cdf9785c$var$n,
    timeZoneName: $c9ee9f81cdf9785c$var$s
};
var $c9ee9f81cdf9785c$var$TIME_WITH_LONG_OFFSET = {
    hour: $c9ee9f81cdf9785c$var$n,
    minute: $c9ee9f81cdf9785c$var$n,
    second: $c9ee9f81cdf9785c$var$n,
    timeZoneName: $c9ee9f81cdf9785c$var$l
};
var $c9ee9f81cdf9785c$var$TIME_24_SIMPLE = {
    hour: $c9ee9f81cdf9785c$var$n,
    minute: $c9ee9f81cdf9785c$var$n,
    hourCycle: "h23"
};
var $c9ee9f81cdf9785c$var$TIME_24_WITH_SECONDS = {
    hour: $c9ee9f81cdf9785c$var$n,
    minute: $c9ee9f81cdf9785c$var$n,
    second: $c9ee9f81cdf9785c$var$n,
    hourCycle: "h23"
};
var $c9ee9f81cdf9785c$var$TIME_24_WITH_SHORT_OFFSET = {
    hour: $c9ee9f81cdf9785c$var$n,
    minute: $c9ee9f81cdf9785c$var$n,
    second: $c9ee9f81cdf9785c$var$n,
    hourCycle: "h23",
    timeZoneName: $c9ee9f81cdf9785c$var$s
};
var $c9ee9f81cdf9785c$var$TIME_24_WITH_LONG_OFFSET = {
    hour: $c9ee9f81cdf9785c$var$n,
    minute: $c9ee9f81cdf9785c$var$n,
    second: $c9ee9f81cdf9785c$var$n,
    hourCycle: "h23",
    timeZoneName: $c9ee9f81cdf9785c$var$l
};
var $c9ee9f81cdf9785c$var$DATETIME_SHORT = {
    year: $c9ee9f81cdf9785c$var$n,
    month: $c9ee9f81cdf9785c$var$n,
    day: $c9ee9f81cdf9785c$var$n,
    hour: $c9ee9f81cdf9785c$var$n,
    minute: $c9ee9f81cdf9785c$var$n
};
var $c9ee9f81cdf9785c$var$DATETIME_SHORT_WITH_SECONDS = {
    year: $c9ee9f81cdf9785c$var$n,
    month: $c9ee9f81cdf9785c$var$n,
    day: $c9ee9f81cdf9785c$var$n,
    hour: $c9ee9f81cdf9785c$var$n,
    minute: $c9ee9f81cdf9785c$var$n,
    second: $c9ee9f81cdf9785c$var$n
};
var $c9ee9f81cdf9785c$var$DATETIME_MED = {
    year: $c9ee9f81cdf9785c$var$n,
    month: $c9ee9f81cdf9785c$var$s,
    day: $c9ee9f81cdf9785c$var$n,
    hour: $c9ee9f81cdf9785c$var$n,
    minute: $c9ee9f81cdf9785c$var$n
};
var $c9ee9f81cdf9785c$var$DATETIME_MED_WITH_SECONDS = {
    year: $c9ee9f81cdf9785c$var$n,
    month: $c9ee9f81cdf9785c$var$s,
    day: $c9ee9f81cdf9785c$var$n,
    hour: $c9ee9f81cdf9785c$var$n,
    minute: $c9ee9f81cdf9785c$var$n,
    second: $c9ee9f81cdf9785c$var$n
};
var $c9ee9f81cdf9785c$var$DATETIME_MED_WITH_WEEKDAY = {
    year: $c9ee9f81cdf9785c$var$n,
    month: $c9ee9f81cdf9785c$var$s,
    day: $c9ee9f81cdf9785c$var$n,
    weekday: $c9ee9f81cdf9785c$var$s,
    hour: $c9ee9f81cdf9785c$var$n,
    minute: $c9ee9f81cdf9785c$var$n
};
var $c9ee9f81cdf9785c$var$DATETIME_FULL = {
    year: $c9ee9f81cdf9785c$var$n,
    month: $c9ee9f81cdf9785c$var$l,
    day: $c9ee9f81cdf9785c$var$n,
    hour: $c9ee9f81cdf9785c$var$n,
    minute: $c9ee9f81cdf9785c$var$n,
    timeZoneName: $c9ee9f81cdf9785c$var$s
};
var $c9ee9f81cdf9785c$var$DATETIME_FULL_WITH_SECONDS = {
    year: $c9ee9f81cdf9785c$var$n,
    month: $c9ee9f81cdf9785c$var$l,
    day: $c9ee9f81cdf9785c$var$n,
    hour: $c9ee9f81cdf9785c$var$n,
    minute: $c9ee9f81cdf9785c$var$n,
    second: $c9ee9f81cdf9785c$var$n,
    timeZoneName: $c9ee9f81cdf9785c$var$s
};
var $c9ee9f81cdf9785c$var$DATETIME_HUGE = {
    year: $c9ee9f81cdf9785c$var$n,
    month: $c9ee9f81cdf9785c$var$l,
    day: $c9ee9f81cdf9785c$var$n,
    weekday: $c9ee9f81cdf9785c$var$l,
    hour: $c9ee9f81cdf9785c$var$n,
    minute: $c9ee9f81cdf9785c$var$n,
    timeZoneName: $c9ee9f81cdf9785c$var$l
};
var $c9ee9f81cdf9785c$var$DATETIME_HUGE_WITH_SECONDS = {
    year: $c9ee9f81cdf9785c$var$n,
    month: $c9ee9f81cdf9785c$var$l,
    day: $c9ee9f81cdf9785c$var$n,
    weekday: $c9ee9f81cdf9785c$var$l,
    hour: $c9ee9f81cdf9785c$var$n,
    minute: $c9ee9f81cdf9785c$var$n,
    second: $c9ee9f81cdf9785c$var$n,
    timeZoneName: $c9ee9f81cdf9785c$var$l
};
/**
 * @interface
 */ var $c9ee9f81cdf9785c$var$Zone = /*#__PURE__*/ function() {
    function Zone() {}
    var _proto = Zone.prototype;
    /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */ _proto.offsetName = function offsetName(ts, opts) {
        throw new $c9ee9f81cdf9785c$var$ZoneIsAbstractError();
    };
    _proto.formatOffset = function formatOffset(ts, format) {
        throw new $c9ee9f81cdf9785c$var$ZoneIsAbstractError();
    };
    _proto.offset = function offset(ts) {
        throw new $c9ee9f81cdf9785c$var$ZoneIsAbstractError();
    };
    _proto.equals = function equals(otherZone) {
        throw new $c9ee9f81cdf9785c$var$ZoneIsAbstractError();
    };
    $c9ee9f81cdf9785c$var$_createClass(Zone, [
        {
            key: "type",
            get: /**
     * The type of zone
     * @abstract
     * @type {string}
     */ function get() {
                throw new $c9ee9f81cdf9785c$var$ZoneIsAbstractError();
            }
        },
        {
            key: "name",
            get: function get() {
                throw new $c9ee9f81cdf9785c$var$ZoneIsAbstractError();
            }
        },
        {
            key: "ianaName",
            get: function get() {
                return this.name;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                throw new $c9ee9f81cdf9785c$var$ZoneIsAbstractError();
            }
        },
        {
            key: "isValid",
            get: function get() {
                throw new $c9ee9f81cdf9785c$var$ZoneIsAbstractError();
            }
        }
    ]);
    return Zone;
}();
var $c9ee9f81cdf9785c$var$singleton$1 = null;
/**
 * Represents the local zone for this JavaScript environment.
 * @implements {Zone}
 */ var $c9ee9f81cdf9785c$var$SystemZone = /*#__PURE__*/ function(_Zone) {
    $c9ee9f81cdf9785c$var$_inheritsLoose(SystemZone, _Zone);
    function SystemZone() {
        return _Zone.apply(this, arguments) || this;
    }
    var _proto = SystemZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName(ts, _ref) {
        var format = _ref.format, locale = _ref.locale;
        return $c9ee9f81cdf9785c$var$parseZoneInfo(ts, format, locale);
    };
    _proto.formatOffset = function formatOffset$1(ts, format) {
        return $c9ee9f81cdf9785c$var$formatOffset(this.offset(ts), format);
    };
    _proto.offset = function offset(ts) {
        return -new Date(ts).getTimezoneOffset();
    };
    _proto.equals = function equals(otherZone) {
        return otherZone.type === "system";
    };
    $c9ee9f81cdf9785c$var$_createClass(SystemZone, [
        {
            key: "type",
            get: /** @override **/ function get() {
                return "system";
            }
        },
        {
            key: "name",
            get: function get() {
                return new Intl.DateTimeFormat().resolvedOptions().timeZone;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return false;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return true;
            }
        }
    ], [
        {
            key: "instance",
            get: /**
     * Get a singleton instance of the local zone
     * @return {SystemZone}
     */ function get() {
                if ($c9ee9f81cdf9785c$var$singleton$1 === null) $c9ee9f81cdf9785c$var$singleton$1 = new SystemZone();
                return $c9ee9f81cdf9785c$var$singleton$1;
            }
        }
    ]);
    return SystemZone;
}($c9ee9f81cdf9785c$var$Zone);
var $c9ee9f81cdf9785c$var$dtfCache = new Map();
function $c9ee9f81cdf9785c$var$makeDTF(zoneName) {
    var dtf = $c9ee9f81cdf9785c$var$dtfCache.get(zoneName);
    if (dtf === undefined) {
        dtf = new Intl.DateTimeFormat("en-US", {
            hour12: false,
            timeZone: zoneName,
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            era: "short"
        });
        $c9ee9f81cdf9785c$var$dtfCache.set(zoneName, dtf);
    }
    return dtf;
}
var $c9ee9f81cdf9785c$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    era: 3,
    hour: 4,
    minute: 5,
    second: 6
};
function $c9ee9f81cdf9785c$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, ""), parsed = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(formatted), fMonth = parsed[1], fDay = parsed[2], fYear = parsed[3], fadOrBc = parsed[4], fHour = parsed[5], fMinute = parsed[6], fSecond = parsed[7];
    return [
        fYear,
        fMonth,
        fDay,
        fadOrBc,
        fHour,
        fMinute,
        fSecond
    ];
}
function $c9ee9f81cdf9785c$var$partsOffset(dtf, date) {
    var formatted = dtf.formatToParts(date);
    var filled = [];
    for(var i = 0; i < formatted.length; i++){
        var _formatted$i = formatted[i], type = _formatted$i.type, value = _formatted$i.value;
        var pos = $c9ee9f81cdf9785c$var$typeToPos[type];
        if (type === "era") filled[pos] = value;
        else if (!$c9ee9f81cdf9785c$var$isUndefined(pos)) filled[pos] = parseInt(value, 10);
    }
    return filled;
}
var $c9ee9f81cdf9785c$var$ianaZoneCache = new Map();
/**
 * A zone identified by an IANA identifier, like America/New_York
 * @implements {Zone}
 */ var $c9ee9f81cdf9785c$var$IANAZone = /*#__PURE__*/ function(_Zone) {
    $c9ee9f81cdf9785c$var$_inheritsLoose(IANAZone, _Zone);
    /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */ IANAZone.create = function create(name) {
        var zone = $c9ee9f81cdf9785c$var$ianaZoneCache.get(name);
        if (zone === undefined) $c9ee9f81cdf9785c$var$ianaZoneCache.set(name, zone = new IANAZone(name));
        return zone;
    };
    IANAZone.resetCache = function resetCache() {
        $c9ee9f81cdf9785c$var$ianaZoneCache.clear();
        $c9ee9f81cdf9785c$var$dtfCache.clear();
    };
    IANAZone.isValidSpecifier = function isValidSpecifier(s) {
        return this.isValidZone(s);
    };
    IANAZone.isValidZone = function isValidZone(zone) {
        if (!zone) return false;
        try {
            new Intl.DateTimeFormat("en-US", {
                timeZone: zone
            }).format();
            return true;
        } catch (e) {
            return false;
        }
    };
    function IANAZone(name) {
        var _this;
        _this = _Zone.call(this) || this;
        /** @private **/ _this.zoneName = name;
        /** @private **/ _this.valid = IANAZone.isValidZone(name);
        return _this;
    }
    /**
   * The type of zone. `iana` for all instances of `IANAZone`.
   * @override
   * @type {string}
   */ var _proto = IANAZone.prototype;
    /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */ _proto.offsetName = function offsetName(ts, _ref) {
        var format = _ref.format, locale = _ref.locale;
        return $c9ee9f81cdf9785c$var$parseZoneInfo(ts, format, locale, this.name);
    };
    _proto.formatOffset = function formatOffset$1(ts, format) {
        return $c9ee9f81cdf9785c$var$formatOffset(this.offset(ts), format);
    };
    _proto.offset = function offset(ts) {
        if (!this.valid) return NaN;
        var date = new Date(ts);
        if (isNaN(date)) return NaN;
        var dtf = $c9ee9f81cdf9785c$var$makeDTF(this.name);
        var _ref2 = dtf.formatToParts ? $c9ee9f81cdf9785c$var$partsOffset(dtf, date) : $c9ee9f81cdf9785c$var$hackyOffset(dtf, date), year = _ref2[0], month = _ref2[1], day = _ref2[2], adOrBc = _ref2[3], hour = _ref2[4], minute = _ref2[5], second = _ref2[6];
        if (adOrBc === "BC") year = -Math.abs(year) + 1;
        // because we're using hour12 and https://bugs.chromium.org/p/chromium/issues/detail?id=1025564&can=2&q=%2224%3A00%22%20datetimeformat
        var adjustedHour = hour === 24 ? 0 : hour;
        var asUTC = $c9ee9f81cdf9785c$var$objToLocalTS({
            year: year,
            month: month,
            day: day,
            hour: adjustedHour,
            minute: minute,
            second: second,
            millisecond: 0
        });
        var asTS = +date;
        var over = asTS % 1000;
        asTS -= over >= 0 ? over : 1000 + over;
        return (asUTC - asTS) / 60000;
    };
    _proto.equals = function equals(otherZone) {
        return otherZone.type === "iana" && otherZone.name === this.name;
    };
    $c9ee9f81cdf9785c$var$_createClass(IANAZone, [
        {
            key: "type",
            get: function get() {
                return "iana";
            }
        },
        {
            key: "name",
            get: function get() {
                return this.zoneName;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return false;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return this.valid;
            }
        }
    ]);
    return IANAZone;
}($c9ee9f81cdf9785c$var$Zone);
var $c9ee9f81cdf9785c$var$_excluded = [
    "base"
], $c9ee9f81cdf9785c$var$_excluded2 = [
    "padTo",
    "floor"
];
// todo - remap caching
var $c9ee9f81cdf9785c$var$intlLFCache = {};
function $c9ee9f81cdf9785c$var$getCachedLF(locString, opts) {
    if (opts === void 0) opts = {};
    var key = JSON.stringify([
        locString,
        opts
    ]);
    var dtf = $c9ee9f81cdf9785c$var$intlLFCache[key];
    if (!dtf) {
        dtf = new Intl.ListFormat(locString, opts);
        $c9ee9f81cdf9785c$var$intlLFCache[key] = dtf;
    }
    return dtf;
}
var $c9ee9f81cdf9785c$var$intlDTCache = new Map();
function $c9ee9f81cdf9785c$var$getCachedDTF(locString, opts) {
    if (opts === void 0) opts = {};
    var key = JSON.stringify([
        locString,
        opts
    ]);
    var dtf = $c9ee9f81cdf9785c$var$intlDTCache.get(key);
    if (dtf === undefined) {
        dtf = new Intl.DateTimeFormat(locString, opts);
        $c9ee9f81cdf9785c$var$intlDTCache.set(key, dtf);
    }
    return dtf;
}
var $c9ee9f81cdf9785c$var$intlNumCache = new Map();
function $c9ee9f81cdf9785c$var$getCachedINF(locString, opts) {
    if (opts === void 0) opts = {};
    var key = JSON.stringify([
        locString,
        opts
    ]);
    var inf = $c9ee9f81cdf9785c$var$intlNumCache.get(key);
    if (inf === undefined) {
        inf = new Intl.NumberFormat(locString, opts);
        $c9ee9f81cdf9785c$var$intlNumCache.set(key, inf);
    }
    return inf;
}
var $c9ee9f81cdf9785c$var$intlRelCache = new Map();
function $c9ee9f81cdf9785c$var$getCachedRTF(locString, opts) {
    if (opts === void 0) opts = {};
    var _opts = opts;
    _opts.base;
    var cacheKeyOpts = $c9ee9f81cdf9785c$var$_objectWithoutPropertiesLoose(_opts, $c9ee9f81cdf9785c$var$_excluded); // exclude `base` from the options
    var key = JSON.stringify([
        locString,
        cacheKeyOpts
    ]);
    var inf = $c9ee9f81cdf9785c$var$intlRelCache.get(key);
    if (inf === undefined) {
        inf = new Intl.RelativeTimeFormat(locString, opts);
        $c9ee9f81cdf9785c$var$intlRelCache.set(key, inf);
    }
    return inf;
}
var $c9ee9f81cdf9785c$var$sysLocaleCache = null;
function $c9ee9f81cdf9785c$var$systemLocale() {
    if ($c9ee9f81cdf9785c$var$sysLocaleCache) return $c9ee9f81cdf9785c$var$sysLocaleCache;
    else {
        $c9ee9f81cdf9785c$var$sysLocaleCache = new Intl.DateTimeFormat().resolvedOptions().locale;
        return $c9ee9f81cdf9785c$var$sysLocaleCache;
    }
}
var $c9ee9f81cdf9785c$var$intlResolvedOptionsCache = new Map();
function $c9ee9f81cdf9785c$var$getCachedIntResolvedOptions(locString) {
    var opts = $c9ee9f81cdf9785c$var$intlResolvedOptionsCache.get(locString);
    if (opts === undefined) {
        opts = new Intl.DateTimeFormat(locString).resolvedOptions();
        $c9ee9f81cdf9785c$var$intlResolvedOptionsCache.set(locString, opts);
    }
    return opts;
}
var $c9ee9f81cdf9785c$var$weekInfoCache = new Map();
function $c9ee9f81cdf9785c$var$getCachedWeekInfo(locString) {
    var data = $c9ee9f81cdf9785c$var$weekInfoCache.get(locString);
    if (!data) {
        var locale = new Intl.Locale(locString);
        // browsers currently implement this as a property, but spec says it should be a getter function
        data = "getWeekInfo" in locale ? locale.getWeekInfo() : locale.weekInfo;
        // minimalDays was removed from WeekInfo: https://github.com/tc39/proposal-intl-locale-info/issues/86
        if (!("minimalDays" in data)) data = $c9ee9f81cdf9785c$var$_extends({}, $c9ee9f81cdf9785c$var$fallbackWeekSettings, data);
        $c9ee9f81cdf9785c$var$weekInfoCache.set(locString, data);
    }
    return data;
}
function $c9ee9f81cdf9785c$var$parseLocaleString(localeStr) {
    // I really want to avoid writing a BCP 47 parser
    // see, e.g. https://github.com/wooorm/bcp-47
    // Instead, we'll do this:
    // a) if the string has no -u extensions, just leave it alone
    // b) if it does, use Intl to resolve everything
    // c) if Intl fails, try again without the -u
    // private subtags and unicode subtags have ordering requirements,
    // and we're not properly parsing this, so just strip out the
    // private ones if they exist.
    var xIndex = localeStr.indexOf("-x-");
    if (xIndex !== -1) localeStr = localeStr.substring(0, xIndex);
    var uIndex = localeStr.indexOf("-u-");
    if (uIndex === -1) return [
        localeStr
    ];
    else {
        var options;
        var selectedStr;
        try {
            options = $c9ee9f81cdf9785c$var$getCachedDTF(localeStr).resolvedOptions();
            selectedStr = localeStr;
        } catch (e) {
            var smaller = localeStr.substring(0, uIndex);
            options = $c9ee9f81cdf9785c$var$getCachedDTF(smaller).resolvedOptions();
            selectedStr = smaller;
        }
        var _options = options, numberingSystem = _options.numberingSystem, calendar = _options.calendar;
        return [
            selectedStr,
            numberingSystem,
            calendar
        ];
    }
}
function $c9ee9f81cdf9785c$var$intlConfigString(localeStr, numberingSystem, outputCalendar) {
    if (outputCalendar || numberingSystem) {
        if (!localeStr.includes("-u-")) localeStr += "-u";
        if (outputCalendar) localeStr += "-ca-" + outputCalendar;
        if (numberingSystem) localeStr += "-nu-" + numberingSystem;
        return localeStr;
    } else return localeStr;
}
function $c9ee9f81cdf9785c$var$mapMonths(f) {
    var ms = [];
    for(var i = 1; i <= 12; i++){
        var dt = $c9ee9f81cdf9785c$var$DateTime.utc(2009, i, 1);
        ms.push(f(dt));
    }
    return ms;
}
function $c9ee9f81cdf9785c$var$mapWeekdays(f) {
    var ms = [];
    for(var i = 1; i <= 7; i++){
        var dt = $c9ee9f81cdf9785c$var$DateTime.utc(2016, 11, 13 + i);
        ms.push(f(dt));
    }
    return ms;
}
function $c9ee9f81cdf9785c$var$listStuff(loc, length, englishFn, intlFn) {
    var mode = loc.listingMode();
    if (mode === "error") return null;
    else if (mode === "en") return englishFn(length);
    else return intlFn(length);
}
function $c9ee9f81cdf9785c$var$supportsFastNumbers(loc) {
    if (loc.numberingSystem && loc.numberingSystem !== "latn") return false;
    else return loc.numberingSystem === "latn" || !loc.locale || loc.locale.startsWith("en") || $c9ee9f81cdf9785c$var$getCachedIntResolvedOptions(loc.locale).numberingSystem === "latn";
}
/**
 * @private
 */ var $c9ee9f81cdf9785c$var$PolyNumberFormatter = /*#__PURE__*/ function() {
    function PolyNumberFormatter(intl, forceSimple, opts) {
        this.padTo = opts.padTo || 0;
        this.floor = opts.floor || false;
        opts.padTo;
        opts.floor;
        var otherOpts = $c9ee9f81cdf9785c$var$_objectWithoutPropertiesLoose(opts, $c9ee9f81cdf9785c$var$_excluded2);
        if (!forceSimple || Object.keys(otherOpts).length > 0) {
            var intlOpts = $c9ee9f81cdf9785c$var$_extends({
                useGrouping: false
            }, opts);
            if (opts.padTo > 0) intlOpts.minimumIntegerDigits = opts.padTo;
            this.inf = $c9ee9f81cdf9785c$var$getCachedINF(intl, intlOpts);
        }
    }
    var _proto = PolyNumberFormatter.prototype;
    _proto.format = function format(i) {
        if (this.inf) {
            var fixed = this.floor ? Math.floor(i) : i;
            return this.inf.format(fixed);
        } else {
            // to match the browser's numberformatter defaults
            var _fixed = this.floor ? Math.floor(i) : $c9ee9f81cdf9785c$var$roundTo(i, 3);
            return $c9ee9f81cdf9785c$var$padStart(_fixed, this.padTo);
        }
    };
    return PolyNumberFormatter;
}();
/**
 * @private
 */ var $c9ee9f81cdf9785c$var$PolyDateFormatter = /*#__PURE__*/ function() {
    function PolyDateFormatter(dt, intl, opts) {
        this.opts = opts;
        this.originalZone = undefined;
        var z = undefined;
        if (this.opts.timeZone) // Don't apply any workarounds if a timeZone is explicitly provided in opts
        this.dt = dt;
        else if (dt.zone.type === "fixed") {
            // UTC-8 or Etc/UTC-8 are not part of tzdata, only Etc/GMT+8 and the like.
            // That is why fixed-offset TZ is set to that unless it is:
            // 1. Representing offset 0 when UTC is used to maintain previous behavior and does not become GMT.
            // 2. Unsupported by the browser:
            //    - some do not support Etc/
            //    - < Etc/GMT-14, > Etc/GMT+12, and 30-minute or 45-minute offsets are not part of tzdata
            var gmtOffset = -1 * (dt.offset / 60);
            var offsetZ = gmtOffset >= 0 ? "Etc/GMT+" + gmtOffset : "Etc/GMT" + gmtOffset;
            if (dt.offset !== 0 && $c9ee9f81cdf9785c$var$IANAZone.create(offsetZ).valid) {
                z = offsetZ;
                this.dt = dt;
            } else {
                // Not all fixed-offset zones like Etc/+4:30 are present in tzdata so
                // we manually apply the offset and substitute the zone as needed.
                z = "UTC";
                this.dt = dt.offset === 0 ? dt : dt.setZone("UTC").plus({
                    minutes: dt.offset
                });
                this.originalZone = dt.zone;
            }
        } else if (dt.zone.type === "system") this.dt = dt;
        else if (dt.zone.type === "iana") {
            this.dt = dt;
            z = dt.zone.name;
        } else {
            // Custom zones can have any offset / offsetName so we just manually
            // apply the offset and substitute the zone as needed.
            z = "UTC";
            this.dt = dt.setZone("UTC").plus({
                minutes: dt.offset
            });
            this.originalZone = dt.zone;
        }
        var intlOpts = $c9ee9f81cdf9785c$var$_extends({}, this.opts);
        intlOpts.timeZone = intlOpts.timeZone || z;
        this.dtf = $c9ee9f81cdf9785c$var$getCachedDTF(intl, intlOpts);
    }
    var _proto2 = PolyDateFormatter.prototype;
    _proto2.format = function format() {
        if (this.originalZone) // If we have to substitute in the actual zone name, we have to use
        // formatToParts so that the timezone can be replaced.
        return this.formatToParts().map(function(_ref) {
            var value = _ref.value;
            return value;
        }).join("");
        return this.dtf.format(this.dt.toJSDate());
    };
    _proto2.formatToParts = function formatToParts() {
        var _this = this;
        var parts = this.dtf.formatToParts(this.dt.toJSDate());
        if (this.originalZone) return parts.map(function(part) {
            if (part.type === "timeZoneName") {
                var offsetName = _this.originalZone.offsetName(_this.dt.ts, {
                    locale: _this.dt.locale,
                    format: _this.opts.timeZoneName
                });
                return $c9ee9f81cdf9785c$var$_extends({}, part, {
                    value: offsetName
                });
            } else return part;
        });
        return parts;
    };
    _proto2.resolvedOptions = function resolvedOptions() {
        return this.dtf.resolvedOptions();
    };
    return PolyDateFormatter;
}();
/**
 * @private
 */ var $c9ee9f81cdf9785c$var$PolyRelFormatter = /*#__PURE__*/ function() {
    function PolyRelFormatter(intl, isEnglish, opts) {
        this.opts = $c9ee9f81cdf9785c$var$_extends({
            style: "long"
        }, opts);
        if (!isEnglish && $c9ee9f81cdf9785c$var$hasRelative()) this.rtf = $c9ee9f81cdf9785c$var$getCachedRTF(intl, opts);
    }
    var _proto3 = PolyRelFormatter.prototype;
    _proto3.format = function format(count, unit) {
        if (this.rtf) return this.rtf.format(count, unit);
        else return $c9ee9f81cdf9785c$var$formatRelativeTime(unit, count, this.opts.numeric, this.opts.style !== "long");
    };
    _proto3.formatToParts = function formatToParts(count, unit) {
        if (this.rtf) return this.rtf.formatToParts(count, unit);
        else return [];
    };
    return PolyRelFormatter;
}();
var $c9ee9f81cdf9785c$var$fallbackWeekSettings = {
    firstDay: 1,
    minimalDays: 4,
    weekend: [
        6,
        7
    ]
};
/**
 * @private
 */ var $c9ee9f81cdf9785c$var$Locale = /*#__PURE__*/ function() {
    Locale.fromOpts = function fromOpts(opts) {
        return Locale.create(opts.locale, opts.numberingSystem, opts.outputCalendar, opts.weekSettings, opts.defaultToEN);
    };
    Locale.create = function create(locale, numberingSystem, outputCalendar, weekSettings, defaultToEN) {
        if (defaultToEN === void 0) defaultToEN = false;
        var specifiedLocale = locale || $c9ee9f81cdf9785c$var$Settings.defaultLocale;
        // the system locale is useful for human-readable strings but annoying for parsing/formatting known formats
        var localeR = specifiedLocale || (defaultToEN ? "en-US" : $c9ee9f81cdf9785c$var$systemLocale());
        var numberingSystemR = numberingSystem || $c9ee9f81cdf9785c$var$Settings.defaultNumberingSystem;
        var outputCalendarR = outputCalendar || $c9ee9f81cdf9785c$var$Settings.defaultOutputCalendar;
        var weekSettingsR = $c9ee9f81cdf9785c$var$validateWeekSettings(weekSettings) || $c9ee9f81cdf9785c$var$Settings.defaultWeekSettings;
        return new Locale(localeR, numberingSystemR, outputCalendarR, weekSettingsR, specifiedLocale);
    };
    Locale.resetCache = function resetCache() {
        $c9ee9f81cdf9785c$var$sysLocaleCache = null;
        $c9ee9f81cdf9785c$var$intlDTCache.clear();
        $c9ee9f81cdf9785c$var$intlNumCache.clear();
        $c9ee9f81cdf9785c$var$intlRelCache.clear();
        $c9ee9f81cdf9785c$var$intlResolvedOptionsCache.clear();
        $c9ee9f81cdf9785c$var$weekInfoCache.clear();
    };
    Locale.fromObject = function fromObject(_temp) {
        var _ref2 = _temp === void 0 ? {} : _temp, locale = _ref2.locale, numberingSystem = _ref2.numberingSystem, outputCalendar = _ref2.outputCalendar, weekSettings = _ref2.weekSettings;
        return Locale.create(locale, numberingSystem, outputCalendar, weekSettings);
    };
    function Locale(locale, numbering, outputCalendar, weekSettings, specifiedLocale) {
        var _parseLocaleString = $c9ee9f81cdf9785c$var$parseLocaleString(locale), parsedLocale = _parseLocaleString[0], parsedNumberingSystem = _parseLocaleString[1], parsedOutputCalendar = _parseLocaleString[2];
        this.locale = parsedLocale;
        this.numberingSystem = numbering || parsedNumberingSystem || null;
        this.outputCalendar = outputCalendar || parsedOutputCalendar || null;
        this.weekSettings = weekSettings;
        this.intl = $c9ee9f81cdf9785c$var$intlConfigString(this.locale, this.numberingSystem, this.outputCalendar);
        this.weekdaysCache = {
            format: {},
            standalone: {}
        };
        this.monthsCache = {
            format: {},
            standalone: {}
        };
        this.meridiemCache = null;
        this.eraCache = {};
        this.specifiedLocale = specifiedLocale;
        this.fastNumbersCached = null;
    }
    var _proto4 = Locale.prototype;
    _proto4.listingMode = function listingMode() {
        var isActuallyEn = this.isEnglish();
        var hasNoWeirdness = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
        return isActuallyEn && hasNoWeirdness ? "en" : "intl";
    };
    _proto4.clone = function clone(alts) {
        if (!alts || Object.getOwnPropertyNames(alts).length === 0) return this;
        else return Locale.create(alts.locale || this.specifiedLocale, alts.numberingSystem || this.numberingSystem, alts.outputCalendar || this.outputCalendar, $c9ee9f81cdf9785c$var$validateWeekSettings(alts.weekSettings) || this.weekSettings, alts.defaultToEN || false);
    };
    _proto4.redefaultToEN = function redefaultToEN(alts) {
        if (alts === void 0) alts = {};
        return this.clone($c9ee9f81cdf9785c$var$_extends({}, alts, {
            defaultToEN: true
        }));
    };
    _proto4.redefaultToSystem = function redefaultToSystem(alts) {
        if (alts === void 0) alts = {};
        return this.clone($c9ee9f81cdf9785c$var$_extends({}, alts, {
            defaultToEN: false
        }));
    };
    _proto4.months = function months$1(length, format) {
        var _this2 = this;
        if (format === void 0) format = false;
        return $c9ee9f81cdf9785c$var$listStuff(this, length, $c9ee9f81cdf9785c$var$months, function() {
            // Workaround for "ja" locale: formatToParts does not label all parts of the month
            // as "month" and for this locale there is no difference between "format" and "non-format".
            // As such, just use format() instead of formatToParts() and take the whole string
            var monthSpecialCase = _this2.intl === "ja" || _this2.intl.startsWith("ja-");
            format &= !monthSpecialCase;
            var intl = format ? {
                month: length,
                day: "numeric"
            } : {
                month: length
            }, formatStr = format ? "format" : "standalone";
            if (!_this2.monthsCache[formatStr][length]) {
                var mapper = !monthSpecialCase ? function(dt) {
                    return _this2.extract(dt, intl, "month");
                } : function(dt) {
                    return _this2.dtFormatter(dt, intl).format();
                };
                _this2.monthsCache[formatStr][length] = $c9ee9f81cdf9785c$var$mapMonths(mapper);
            }
            return _this2.monthsCache[formatStr][length];
        });
    };
    _proto4.weekdays = function weekdays$1(length, format) {
        var _this3 = this;
        if (format === void 0) format = false;
        return $c9ee9f81cdf9785c$var$listStuff(this, length, $c9ee9f81cdf9785c$var$weekdays, function() {
            var intl = format ? {
                weekday: length,
                year: "numeric",
                month: "long",
                day: "numeric"
            } : {
                weekday: length
            }, formatStr = format ? "format" : "standalone";
            if (!_this3.weekdaysCache[formatStr][length]) _this3.weekdaysCache[formatStr][length] = $c9ee9f81cdf9785c$var$mapWeekdays(function(dt) {
                return _this3.extract(dt, intl, "weekday");
            });
            return _this3.weekdaysCache[formatStr][length];
        });
    };
    _proto4.meridiems = function meridiems$1() {
        var _this4 = this;
        return $c9ee9f81cdf9785c$var$listStuff(this, undefined, function() {
            return $c9ee9f81cdf9785c$var$meridiems;
        }, function() {
            // In theory there could be aribitrary day periods. We're gonna assume there are exactly two
            // for AM and PM. This is probably wrong, but it's makes parsing way easier.
            if (!_this4.meridiemCache) {
                var intl = {
                    hour: "numeric",
                    hourCycle: "h12"
                };
                _this4.meridiemCache = [
                    $c9ee9f81cdf9785c$var$DateTime.utc(2016, 11, 13, 9),
                    $c9ee9f81cdf9785c$var$DateTime.utc(2016, 11, 13, 19)
                ].map(function(dt) {
                    return _this4.extract(dt, intl, "dayperiod");
                });
            }
            return _this4.meridiemCache;
        });
    };
    _proto4.eras = function eras$1(length) {
        var _this5 = this;
        return $c9ee9f81cdf9785c$var$listStuff(this, length, $c9ee9f81cdf9785c$var$eras, function() {
            var intl = {
                era: length
            };
            // This is problematic. Different calendars are going to define eras totally differently. What I need is the minimum set of dates
            // to definitely enumerate them.
            if (!_this5.eraCache[length]) _this5.eraCache[length] = [
                $c9ee9f81cdf9785c$var$DateTime.utc(-40, 1, 1),
                $c9ee9f81cdf9785c$var$DateTime.utc(2017, 1, 1)
            ].map(function(dt) {
                return _this5.extract(dt, intl, "era");
            });
            return _this5.eraCache[length];
        });
    };
    _proto4.extract = function extract(dt, intlOpts, field) {
        var df = this.dtFormatter(dt, intlOpts), results = df.formatToParts(), matching = results.find(function(m) {
            return m.type.toLowerCase() === field;
        });
        return matching ? matching.value : null;
    };
    _proto4.numberFormatter = function numberFormatter(opts) {
        if (opts === void 0) opts = {};
        // this forcesimple option is never used (the only caller short-circuits on it, but it seems safer to leave)
        // (in contrast, the rest of the condition is used heavily)
        return new $c9ee9f81cdf9785c$var$PolyNumberFormatter(this.intl, opts.forceSimple || this.fastNumbers, opts);
    };
    _proto4.dtFormatter = function dtFormatter(dt, intlOpts) {
        if (intlOpts === void 0) intlOpts = {};
        return new $c9ee9f81cdf9785c$var$PolyDateFormatter(dt, this.intl, intlOpts);
    };
    _proto4.relFormatter = function relFormatter(opts) {
        if (opts === void 0) opts = {};
        return new $c9ee9f81cdf9785c$var$PolyRelFormatter(this.intl, this.isEnglish(), opts);
    };
    _proto4.listFormatter = function listFormatter(opts) {
        if (opts === void 0) opts = {};
        return $c9ee9f81cdf9785c$var$getCachedLF(this.intl, opts);
    };
    _proto4.isEnglish = function isEnglish() {
        return this.locale === "en" || this.locale.toLowerCase() === "en-us" || $c9ee9f81cdf9785c$var$getCachedIntResolvedOptions(this.intl).locale.startsWith("en-us");
    };
    _proto4.getWeekSettings = function getWeekSettings() {
        if (this.weekSettings) return this.weekSettings;
        else if (!$c9ee9f81cdf9785c$var$hasLocaleWeekInfo()) return $c9ee9f81cdf9785c$var$fallbackWeekSettings;
        else return $c9ee9f81cdf9785c$var$getCachedWeekInfo(this.locale);
    };
    _proto4.getStartOfWeek = function getStartOfWeek() {
        return this.getWeekSettings().firstDay;
    };
    _proto4.getMinDaysInFirstWeek = function getMinDaysInFirstWeek() {
        return this.getWeekSettings().minimalDays;
    };
    _proto4.getWeekendDays = function getWeekendDays() {
        return this.getWeekSettings().weekend;
    };
    _proto4.equals = function equals(other) {
        return this.locale === other.locale && this.numberingSystem === other.numberingSystem && this.outputCalendar === other.outputCalendar;
    };
    _proto4.toString = function toString() {
        return "Locale(" + this.locale + ", " + this.numberingSystem + ", " + this.outputCalendar + ")";
    };
    $c9ee9f81cdf9785c$var$_createClass(Locale, [
        {
            key: "fastNumbers",
            get: function get() {
                if (this.fastNumbersCached == null) this.fastNumbersCached = $c9ee9f81cdf9785c$var$supportsFastNumbers(this);
                return this.fastNumbersCached;
            }
        }
    ]);
    return Locale;
}();
var $c9ee9f81cdf9785c$var$singleton = null;
/**
 * A zone with a fixed offset (meaning no DST)
 * @implements {Zone}
 */ var $c9ee9f81cdf9785c$var$FixedOffsetZone = /*#__PURE__*/ function(_Zone) {
    $c9ee9f81cdf9785c$var$_inheritsLoose(FixedOffsetZone, _Zone);
    /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */ FixedOffsetZone.instance = function instance(offset) {
        return offset === 0 ? FixedOffsetZone.utcInstance : new FixedOffsetZone(offset);
    };
    FixedOffsetZone.parseSpecifier = function parseSpecifier(s) {
        if (s) {
            var r = s.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
            if (r) return new FixedOffsetZone($c9ee9f81cdf9785c$var$signedOffset(r[1], r[2]));
        }
        return null;
    };
    function FixedOffsetZone(offset) {
        var _this;
        _this = _Zone.call(this) || this;
        /** @private **/ _this.fixed = offset;
        return _this;
    }
    /**
   * The type of zone. `fixed` for all instances of `FixedOffsetZone`.
   * @override
   * @type {string}
   */ var _proto = FixedOffsetZone.prototype;
    /**
   * Returns the offset's common name at the specified timestamp.
   *
   * For fixed offset zones this equals to the zone name.
   * @override
   */ _proto.offsetName = function offsetName() {
        return this.name;
    };
    _proto.formatOffset = function formatOffset$1(ts, format) {
        return $c9ee9f81cdf9785c$var$formatOffset(this.fixed, format);
    };
    /**
   * Return the offset in minutes for this zone at the specified timestamp.
   *
   * For fixed offset zones, this is constant and does not depend on a timestamp.
   * @override
   * @return {number}
   */ _proto.offset = function offset() {
        return this.fixed;
    };
    _proto.equals = function equals(otherZone) {
        return otherZone.type === "fixed" && otherZone.fixed === this.fixed;
    };
    $c9ee9f81cdf9785c$var$_createClass(FixedOffsetZone, [
        {
            key: "type",
            get: function get() {
                return "fixed";
            }
        },
        {
            key: "name",
            get: function get() {
                return this.fixed === 0 ? "UTC" : "UTC" + $c9ee9f81cdf9785c$var$formatOffset(this.fixed, "narrow");
            }
        },
        {
            key: "ianaName",
            get: function get() {
                if (this.fixed === 0) return "Etc/UTC";
                else return "Etc/GMT" + $c9ee9f81cdf9785c$var$formatOffset(-this.fixed, "narrow");
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return true;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return true;
            }
        }
    ], [
        {
            key: "utcInstance",
            get: /**
     * Get a singleton instance of UTC
     * @return {FixedOffsetZone}
     */ function get() {
                if ($c9ee9f81cdf9785c$var$singleton === null) $c9ee9f81cdf9785c$var$singleton = new FixedOffsetZone(0);
                return $c9ee9f81cdf9785c$var$singleton;
            }
        }
    ]);
    return FixedOffsetZone;
}($c9ee9f81cdf9785c$var$Zone);
/**
 * A zone that failed to parse. You should never need to instantiate this.
 * @implements {Zone}
 */ var $c9ee9f81cdf9785c$var$InvalidZone = /*#__PURE__*/ function(_Zone) {
    $c9ee9f81cdf9785c$var$_inheritsLoose(InvalidZone, _Zone);
    function InvalidZone(zoneName) {
        var _this;
        _this = _Zone.call(this) || this;
        /**  @private */ _this.zoneName = zoneName;
        return _this;
    }
    /** @override **/ var _proto = InvalidZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName() {
        return null;
    };
    _proto.formatOffset = function formatOffset() {
        return "";
    };
    _proto.offset = function offset() {
        return NaN;
    };
    _proto.equals = function equals() {
        return false;
    };
    $c9ee9f81cdf9785c$var$_createClass(InvalidZone, [
        {
            key: "type",
            get: function get() {
                return "invalid";
            }
        },
        {
            key: "name",
            get: function get() {
                return this.zoneName;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return false;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return false;
            }
        }
    ]);
    return InvalidZone;
}($c9ee9f81cdf9785c$var$Zone);
/**
 * @private
 */ function $c9ee9f81cdf9785c$var$normalizeZone(input, defaultZone) {
    if ($c9ee9f81cdf9785c$var$isUndefined(input) || input === null) return defaultZone;
    else if (input instanceof $c9ee9f81cdf9785c$var$Zone) return input;
    else if ($c9ee9f81cdf9785c$var$isString(input)) {
        var lowered = input.toLowerCase();
        if (lowered === "default") return defaultZone;
        else if (lowered === "local" || lowered === "system") return $c9ee9f81cdf9785c$var$SystemZone.instance;
        else if (lowered === "utc" || lowered === "gmt") return $c9ee9f81cdf9785c$var$FixedOffsetZone.utcInstance;
        else return $c9ee9f81cdf9785c$var$FixedOffsetZone.parseSpecifier(lowered) || $c9ee9f81cdf9785c$var$IANAZone.create(input);
    } else if ($c9ee9f81cdf9785c$var$isNumber(input)) return $c9ee9f81cdf9785c$var$FixedOffsetZone.instance(input);
    else if (typeof input === "object" && "offset" in input && typeof input.offset === "function") // This is dumb, but the instanceof check above doesn't seem to really work
    // so we're duck checking it
    return input;
    else return new $c9ee9f81cdf9785c$var$InvalidZone(input);
}
var $c9ee9f81cdf9785c$var$numberingSystems = {
    arab: "[\u0660-\u0669]",
    arabext: "[\u06F0-\u06F9]",
    bali: "[\u1B50-\u1B59]",
    beng: "[\u09E6-\u09EF]",
    deva: "[\u0966-\u096F]",
    fullwide: "[\uFF10-\uFF19]",
    gujr: "[\u0AE6-\u0AEF]",
    hanidec: "[\u3007|\u4E00|\u4E8C|\u4E09|\u56DB|\u4E94|\u516D|\u4E03|\u516B|\u4E5D]",
    khmr: "[\u17E0-\u17E9]",
    knda: "[\u0CE6-\u0CEF]",
    laoo: "[\u0ED0-\u0ED9]",
    limb: "[\u1946-\u194F]",
    mlym: "[\u0D66-\u0D6F]",
    mong: "[\u1810-\u1819]",
    mymr: "[\u1040-\u1049]",
    orya: "[\u0B66-\u0B6F]",
    tamldec: "[\u0BE6-\u0BEF]",
    telu: "[\u0C66-\u0C6F]",
    thai: "[\u0E50-\u0E59]",
    tibt: "[\u0F20-\u0F29]",
    latn: "\\d"
};
var $c9ee9f81cdf9785c$var$numberingSystemsUTF16 = {
    arab: [
        1632,
        1641
    ],
    arabext: [
        1776,
        1785
    ],
    bali: [
        6992,
        7001
    ],
    beng: [
        2534,
        2543
    ],
    deva: [
        2406,
        2415
    ],
    fullwide: [
        65296,
        65303
    ],
    gujr: [
        2790,
        2799
    ],
    khmr: [
        6112,
        6121
    ],
    knda: [
        3302,
        3311
    ],
    laoo: [
        3792,
        3801
    ],
    limb: [
        6470,
        6479
    ],
    mlym: [
        3430,
        3439
    ],
    mong: [
        6160,
        6169
    ],
    mymr: [
        4160,
        4169
    ],
    orya: [
        2918,
        2927
    ],
    tamldec: [
        3046,
        3055
    ],
    telu: [
        3174,
        3183
    ],
    thai: [
        3664,
        3673
    ],
    tibt: [
        3872,
        3881
    ]
};
var $c9ee9f81cdf9785c$var$hanidecChars = $c9ee9f81cdf9785c$var$numberingSystems.hanidec.replace(/[\[|\]]/g, "").split("");
function $c9ee9f81cdf9785c$var$parseDigits(str) {
    var value = parseInt(str, 10);
    if (isNaN(value)) {
        value = "";
        for(var i = 0; i < str.length; i++){
            var code = str.charCodeAt(i);
            if (str[i].search($c9ee9f81cdf9785c$var$numberingSystems.hanidec) !== -1) value += $c9ee9f81cdf9785c$var$hanidecChars.indexOf(str[i]);
            else for(var key in $c9ee9f81cdf9785c$var$numberingSystemsUTF16){
                var _numberingSystemsUTF = $c9ee9f81cdf9785c$var$numberingSystemsUTF16[key], min = _numberingSystemsUTF[0], max = _numberingSystemsUTF[1];
                if (code >= min && code <= max) value += code - min;
            }
        }
        return parseInt(value, 10);
    } else return value;
}
// cache of {numberingSystem: {append: regex}}
var $c9ee9f81cdf9785c$var$digitRegexCache = new Map();
function $c9ee9f81cdf9785c$var$resetDigitRegexCache() {
    $c9ee9f81cdf9785c$var$digitRegexCache.clear();
}
function $c9ee9f81cdf9785c$var$digitRegex(_ref, append) {
    var numberingSystem = _ref.numberingSystem;
    if (append === void 0) append = "";
    var ns = numberingSystem || "latn";
    var appendCache = $c9ee9f81cdf9785c$var$digitRegexCache.get(ns);
    if (appendCache === undefined) {
        appendCache = new Map();
        $c9ee9f81cdf9785c$var$digitRegexCache.set(ns, appendCache);
    }
    var regex = appendCache.get(append);
    if (regex === undefined) {
        regex = new RegExp("" + $c9ee9f81cdf9785c$var$numberingSystems[ns] + append);
        appendCache.set(append, regex);
    }
    return regex;
}
var $c9ee9f81cdf9785c$var$now = function now() {
    return Date.now();
}, $c9ee9f81cdf9785c$var$defaultZone = "system", $c9ee9f81cdf9785c$var$defaultLocale = null, $c9ee9f81cdf9785c$var$defaultNumberingSystem = null, $c9ee9f81cdf9785c$var$defaultOutputCalendar = null, $c9ee9f81cdf9785c$var$twoDigitCutoffYear = 60, $c9ee9f81cdf9785c$var$throwOnInvalid, $c9ee9f81cdf9785c$var$defaultWeekSettings = null;
/**
 * Settings contains static getters and setters that control Luxon's overall behavior. Luxon is a simple library with few options, but the ones it does have live here.
 */ var $c9ee9f81cdf9785c$var$Settings = /*#__PURE__*/ function() {
    function Settings() {}
    /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */ Settings.resetCaches = function resetCaches() {
        $c9ee9f81cdf9785c$var$Locale.resetCache();
        $c9ee9f81cdf9785c$var$IANAZone.resetCache();
        $c9ee9f81cdf9785c$var$DateTime.resetCache();
        $c9ee9f81cdf9785c$var$resetDigitRegexCache();
    };
    $c9ee9f81cdf9785c$var$_createClass(Settings, null, [
        {
            key: "now",
            get: /**
     * Get the callback for returning the current timestamp.
     * @type {function}
     */ function get() {
                return $c9ee9f81cdf9785c$var$now;
            },
            set: function set(n) {
                $c9ee9f81cdf9785c$var$now = n;
            }
        },
        {
            key: "defaultZone",
            get: /**
     * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
     * The default value is the system's time zone (the one set on the machine that runs this code).
     * @type {Zone}
     */ function get() {
                return $c9ee9f81cdf9785c$var$normalizeZone($c9ee9f81cdf9785c$var$defaultZone, $c9ee9f81cdf9785c$var$SystemZone.instance);
            },
            set: function set(zone) {
                $c9ee9f81cdf9785c$var$defaultZone = zone;
            }
        },
        {
            key: "defaultLocale",
            get: function get() {
                return $c9ee9f81cdf9785c$var$defaultLocale;
            },
            set: function set(locale) {
                $c9ee9f81cdf9785c$var$defaultLocale = locale;
            }
        },
        {
            key: "defaultNumberingSystem",
            get: function get() {
                return $c9ee9f81cdf9785c$var$defaultNumberingSystem;
            },
            set: function set(numberingSystem) {
                $c9ee9f81cdf9785c$var$defaultNumberingSystem = numberingSystem;
            }
        },
        {
            key: "defaultOutputCalendar",
            get: function get() {
                return $c9ee9f81cdf9785c$var$defaultOutputCalendar;
            },
            set: function set(outputCalendar) {
                $c9ee9f81cdf9785c$var$defaultOutputCalendar = outputCalendar;
            }
        },
        {
            key: "defaultWeekSettings",
            get: function get() {
                return $c9ee9f81cdf9785c$var$defaultWeekSettings;
            },
            set: function set(weekSettings) {
                $c9ee9f81cdf9785c$var$defaultWeekSettings = $c9ee9f81cdf9785c$var$validateWeekSettings(weekSettings);
            }
        },
        {
            key: "twoDigitCutoffYear",
            get: function get() {
                return $c9ee9f81cdf9785c$var$twoDigitCutoffYear;
            },
            set: function set(cutoffYear) {
                $c9ee9f81cdf9785c$var$twoDigitCutoffYear = cutoffYear % 100;
            }
        },
        {
            key: "throwOnInvalid",
            get: function get() {
                return $c9ee9f81cdf9785c$var$throwOnInvalid;
            },
            set: function set(t) {
                $c9ee9f81cdf9785c$var$throwOnInvalid = t;
            }
        }
    ]);
    return Settings;
}();
var $c9ee9f81cdf9785c$var$Invalid = /*#__PURE__*/ function() {
    function Invalid(reason, explanation) {
        this.reason = reason;
        this.explanation = explanation;
    }
    var _proto = Invalid.prototype;
    _proto.toMessage = function toMessage() {
        if (this.explanation) return this.reason + ": " + this.explanation;
        else return this.reason;
    };
    return Invalid;
}();
var $c9ee9f81cdf9785c$var$nonLeapLadder = [
    0,
    31,
    59,
    90,
    120,
    151,
    181,
    212,
    243,
    273,
    304,
    334
], $c9ee9f81cdf9785c$var$leapLadder = [
    0,
    31,
    60,
    91,
    121,
    152,
    182,
    213,
    244,
    274,
    305,
    335
];
function $c9ee9f81cdf9785c$var$unitOutOfRange(unit, value) {
    return new $c9ee9f81cdf9785c$var$Invalid("unit out of range", "you specified " + value + " (of type " + typeof value + ") as a " + unit + ", which is invalid");
}
function $c9ee9f81cdf9785c$var$dayOfWeek(year, month, day) {
    var d = new Date(Date.UTC(year, month - 1, day));
    if (year < 100 && year >= 0) d.setUTCFullYear(d.getUTCFullYear() - 1900);
    var js = d.getUTCDay();
    return js === 0 ? 7 : js;
}
function $c9ee9f81cdf9785c$var$computeOrdinal(year, month, day) {
    return day + ($c9ee9f81cdf9785c$var$isLeapYear(year) ? $c9ee9f81cdf9785c$var$leapLadder : $c9ee9f81cdf9785c$var$nonLeapLadder)[month - 1];
}
function $c9ee9f81cdf9785c$var$uncomputeOrdinal(year, ordinal) {
    var table = $c9ee9f81cdf9785c$var$isLeapYear(year) ? $c9ee9f81cdf9785c$var$leapLadder : $c9ee9f81cdf9785c$var$nonLeapLadder, month0 = table.findIndex(function(i) {
        return i < ordinal;
    }), day = ordinal - table[month0];
    return {
        month: month0 + 1,
        day: day
    };
}
function $c9ee9f81cdf9785c$var$isoWeekdayToLocal(isoWeekday, startOfWeek) {
    return (isoWeekday - startOfWeek + 7) % 7 + 1;
}
/**
 * @private
 */ function $c9ee9f81cdf9785c$var$gregorianToWeek(gregObj, minDaysInFirstWeek, startOfWeek) {
    if (minDaysInFirstWeek === void 0) minDaysInFirstWeek = 4;
    if (startOfWeek === void 0) startOfWeek = 1;
    var year = gregObj.year, month = gregObj.month, day = gregObj.day, ordinal = $c9ee9f81cdf9785c$var$computeOrdinal(year, month, day), weekday = $c9ee9f81cdf9785c$var$isoWeekdayToLocal($c9ee9f81cdf9785c$var$dayOfWeek(year, month, day), startOfWeek);
    var weekNumber = Math.floor((ordinal - weekday + 14 - minDaysInFirstWeek) / 7), weekYear;
    if (weekNumber < 1) {
        weekYear = year - 1;
        weekNumber = $c9ee9f81cdf9785c$var$weeksInWeekYear(weekYear, minDaysInFirstWeek, startOfWeek);
    } else if (weekNumber > $c9ee9f81cdf9785c$var$weeksInWeekYear(year, minDaysInFirstWeek, startOfWeek)) {
        weekYear = year + 1;
        weekNumber = 1;
    } else weekYear = year;
    return $c9ee9f81cdf9785c$var$_extends({
        weekYear: weekYear,
        weekNumber: weekNumber,
        weekday: weekday
    }, $c9ee9f81cdf9785c$var$timeObject(gregObj));
}
function $c9ee9f81cdf9785c$var$weekToGregorian(weekData, minDaysInFirstWeek, startOfWeek) {
    if (minDaysInFirstWeek === void 0) minDaysInFirstWeek = 4;
    if (startOfWeek === void 0) startOfWeek = 1;
    var weekYear = weekData.weekYear, weekNumber = weekData.weekNumber, weekday = weekData.weekday, weekdayOfJan4 = $c9ee9f81cdf9785c$var$isoWeekdayToLocal($c9ee9f81cdf9785c$var$dayOfWeek(weekYear, 1, minDaysInFirstWeek), startOfWeek), yearInDays = $c9ee9f81cdf9785c$var$daysInYear(weekYear);
    var ordinal = weekNumber * 7 + weekday - weekdayOfJan4 - 7 + minDaysInFirstWeek, year;
    if (ordinal < 1) {
        year = weekYear - 1;
        ordinal += $c9ee9f81cdf9785c$var$daysInYear(year);
    } else if (ordinal > yearInDays) {
        year = weekYear + 1;
        ordinal -= $c9ee9f81cdf9785c$var$daysInYear(weekYear);
    } else year = weekYear;
    var _uncomputeOrdinal = $c9ee9f81cdf9785c$var$uncomputeOrdinal(year, ordinal), month = _uncomputeOrdinal.month, day = _uncomputeOrdinal.day;
    return $c9ee9f81cdf9785c$var$_extends({
        year: year,
        month: month,
        day: day
    }, $c9ee9f81cdf9785c$var$timeObject(weekData));
}
function $c9ee9f81cdf9785c$var$gregorianToOrdinal(gregData) {
    var year = gregData.year, month = gregData.month, day = gregData.day;
    var ordinal = $c9ee9f81cdf9785c$var$computeOrdinal(year, month, day);
    return $c9ee9f81cdf9785c$var$_extends({
        year: year,
        ordinal: ordinal
    }, $c9ee9f81cdf9785c$var$timeObject(gregData));
}
function $c9ee9f81cdf9785c$var$ordinalToGregorian(ordinalData) {
    var year = ordinalData.year, ordinal = ordinalData.ordinal;
    var _uncomputeOrdinal2 = $c9ee9f81cdf9785c$var$uncomputeOrdinal(year, ordinal), month = _uncomputeOrdinal2.month, day = _uncomputeOrdinal2.day;
    return $c9ee9f81cdf9785c$var$_extends({
        year: year,
        month: month,
        day: day
    }, $c9ee9f81cdf9785c$var$timeObject(ordinalData));
}
/**
 * Check if local week units like localWeekday are used in obj.
 * If so, validates that they are not mixed with ISO week units and then copies them to the normal week unit properties.
 * Modifies obj in-place!
 * @param obj the object values
 */ function $c9ee9f81cdf9785c$var$usesLocalWeekValues(obj, loc) {
    var hasLocaleWeekData = !$c9ee9f81cdf9785c$var$isUndefined(obj.localWeekday) || !$c9ee9f81cdf9785c$var$isUndefined(obj.localWeekNumber) || !$c9ee9f81cdf9785c$var$isUndefined(obj.localWeekYear);
    if (hasLocaleWeekData) {
        var hasIsoWeekData = !$c9ee9f81cdf9785c$var$isUndefined(obj.weekday) || !$c9ee9f81cdf9785c$var$isUndefined(obj.weekNumber) || !$c9ee9f81cdf9785c$var$isUndefined(obj.weekYear);
        if (hasIsoWeekData) throw new $c9ee9f81cdf9785c$var$ConflictingSpecificationError("Cannot mix locale-based week fields with ISO-based week fields");
        if (!$c9ee9f81cdf9785c$var$isUndefined(obj.localWeekday)) obj.weekday = obj.localWeekday;
        if (!$c9ee9f81cdf9785c$var$isUndefined(obj.localWeekNumber)) obj.weekNumber = obj.localWeekNumber;
        if (!$c9ee9f81cdf9785c$var$isUndefined(obj.localWeekYear)) obj.weekYear = obj.localWeekYear;
        delete obj.localWeekday;
        delete obj.localWeekNumber;
        delete obj.localWeekYear;
        return {
            minDaysInFirstWeek: loc.getMinDaysInFirstWeek(),
            startOfWeek: loc.getStartOfWeek()
        };
    } else return {
        minDaysInFirstWeek: 4,
        startOfWeek: 1
    };
}
function $c9ee9f81cdf9785c$var$hasInvalidWeekData(obj, minDaysInFirstWeek, startOfWeek) {
    if (minDaysInFirstWeek === void 0) minDaysInFirstWeek = 4;
    if (startOfWeek === void 0) startOfWeek = 1;
    var validYear = $c9ee9f81cdf9785c$var$isInteger(obj.weekYear), validWeek = $c9ee9f81cdf9785c$var$integerBetween(obj.weekNumber, 1, $c9ee9f81cdf9785c$var$weeksInWeekYear(obj.weekYear, minDaysInFirstWeek, startOfWeek)), validWeekday = $c9ee9f81cdf9785c$var$integerBetween(obj.weekday, 1, 7);
    if (!validYear) return $c9ee9f81cdf9785c$var$unitOutOfRange("weekYear", obj.weekYear);
    else if (!validWeek) return $c9ee9f81cdf9785c$var$unitOutOfRange("week", obj.weekNumber);
    else if (!validWeekday) return $c9ee9f81cdf9785c$var$unitOutOfRange("weekday", obj.weekday);
    else return false;
}
function $c9ee9f81cdf9785c$var$hasInvalidOrdinalData(obj) {
    var validYear = $c9ee9f81cdf9785c$var$isInteger(obj.year), validOrdinal = $c9ee9f81cdf9785c$var$integerBetween(obj.ordinal, 1, $c9ee9f81cdf9785c$var$daysInYear(obj.year));
    if (!validYear) return $c9ee9f81cdf9785c$var$unitOutOfRange("year", obj.year);
    else if (!validOrdinal) return $c9ee9f81cdf9785c$var$unitOutOfRange("ordinal", obj.ordinal);
    else return false;
}
function $c9ee9f81cdf9785c$var$hasInvalidGregorianData(obj) {
    var validYear = $c9ee9f81cdf9785c$var$isInteger(obj.year), validMonth = $c9ee9f81cdf9785c$var$integerBetween(obj.month, 1, 12), validDay = $c9ee9f81cdf9785c$var$integerBetween(obj.day, 1, $c9ee9f81cdf9785c$var$daysInMonth(obj.year, obj.month));
    if (!validYear) return $c9ee9f81cdf9785c$var$unitOutOfRange("year", obj.year);
    else if (!validMonth) return $c9ee9f81cdf9785c$var$unitOutOfRange("month", obj.month);
    else if (!validDay) return $c9ee9f81cdf9785c$var$unitOutOfRange("day", obj.day);
    else return false;
}
function $c9ee9f81cdf9785c$var$hasInvalidTimeData(obj) {
    var hour = obj.hour, minute = obj.minute, second = obj.second, millisecond = obj.millisecond;
    var validHour = $c9ee9f81cdf9785c$var$integerBetween(hour, 0, 23) || hour === 24 && minute === 0 && second === 0 && millisecond === 0, validMinute = $c9ee9f81cdf9785c$var$integerBetween(minute, 0, 59), validSecond = $c9ee9f81cdf9785c$var$integerBetween(second, 0, 59), validMillisecond = $c9ee9f81cdf9785c$var$integerBetween(millisecond, 0, 999);
    if (!validHour) return $c9ee9f81cdf9785c$var$unitOutOfRange("hour", hour);
    else if (!validMinute) return $c9ee9f81cdf9785c$var$unitOutOfRange("minute", minute);
    else if (!validSecond) return $c9ee9f81cdf9785c$var$unitOutOfRange("second", second);
    else if (!validMillisecond) return $c9ee9f81cdf9785c$var$unitOutOfRange("millisecond", millisecond);
    else return false;
}
/**
 * @private
 */ // TYPES
function $c9ee9f81cdf9785c$var$isUndefined(o) {
    return typeof o === "undefined";
}
function $c9ee9f81cdf9785c$var$isNumber(o) {
    return typeof o === "number";
}
function $c9ee9f81cdf9785c$var$isInteger(o) {
    return typeof o === "number" && o % 1 === 0;
}
function $c9ee9f81cdf9785c$var$isString(o) {
    return typeof o === "string";
}
function $c9ee9f81cdf9785c$var$isDate(o) {
    return Object.prototype.toString.call(o) === "[object Date]";
}
// CAPABILITIES
function $c9ee9f81cdf9785c$var$hasRelative() {
    try {
        return typeof Intl !== "undefined" && !!Intl.RelativeTimeFormat;
    } catch (e) {
        return false;
    }
}
function $c9ee9f81cdf9785c$var$hasLocaleWeekInfo() {
    try {
        return typeof Intl !== "undefined" && !!Intl.Locale && ("weekInfo" in Intl.Locale.prototype || "getWeekInfo" in Intl.Locale.prototype);
    } catch (e) {
        return false;
    }
}
// OBJECTS AND ARRAYS
function $c9ee9f81cdf9785c$var$maybeArray(thing) {
    return Array.isArray(thing) ? thing : [
        thing
    ];
}
function $c9ee9f81cdf9785c$var$bestBy(arr, by, compare) {
    if (arr.length === 0) return undefined;
    return arr.reduce(function(best, next) {
        var pair = [
            by(next),
            next
        ];
        if (!best) return pair;
        else if (compare(best[0], pair[0]) === best[0]) return best;
        else return pair;
    }, null)[1];
}
function $c9ee9f81cdf9785c$var$pick(obj, keys) {
    return keys.reduce(function(a, k) {
        a[k] = obj[k];
        return a;
    }, {});
}
function $c9ee9f81cdf9785c$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
function $c9ee9f81cdf9785c$var$validateWeekSettings(settings) {
    if (settings == null) return null;
    else if (typeof settings !== "object") throw new $c9ee9f81cdf9785c$var$InvalidArgumentError("Week settings must be an object");
    else {
        if (!$c9ee9f81cdf9785c$var$integerBetween(settings.firstDay, 1, 7) || !$c9ee9f81cdf9785c$var$integerBetween(settings.minimalDays, 1, 7) || !Array.isArray(settings.weekend) || settings.weekend.some(function(v) {
            return !$c9ee9f81cdf9785c$var$integerBetween(v, 1, 7);
        })) throw new $c9ee9f81cdf9785c$var$InvalidArgumentError("Invalid week settings");
        return {
            firstDay: settings.firstDay,
            minimalDays: settings.minimalDays,
            weekend: Array.from(settings.weekend)
        };
    }
}
// NUMBERS AND STRINGS
function $c9ee9f81cdf9785c$var$integerBetween(thing, bottom, top) {
    return $c9ee9f81cdf9785c$var$isInteger(thing) && thing >= bottom && thing <= top;
}
// x % n but takes the sign of n instead of x
function $c9ee9f81cdf9785c$var$floorMod(x, n) {
    return x - n * Math.floor(x / n);
}
function $c9ee9f81cdf9785c$var$padStart(input, n) {
    if (n === void 0) n = 2;
    var isNeg = input < 0;
    var padded;
    if (isNeg) padded = "-" + ("" + -input).padStart(n, "0");
    else padded = ("" + input).padStart(n, "0");
    return padded;
}
function $c9ee9f81cdf9785c$var$parseInteger(string) {
    if ($c9ee9f81cdf9785c$var$isUndefined(string) || string === null || string === "") return undefined;
    else return parseInt(string, 10);
}
function $c9ee9f81cdf9785c$var$parseFloating(string) {
    if ($c9ee9f81cdf9785c$var$isUndefined(string) || string === null || string === "") return undefined;
    else return parseFloat(string);
}
function $c9ee9f81cdf9785c$var$parseMillis(fraction) {
    // Return undefined (instead of 0) in these cases, where fraction is not set
    if ($c9ee9f81cdf9785c$var$isUndefined(fraction) || fraction === null || fraction === "") return undefined;
    else {
        var f = parseFloat("0." + fraction) * 1000;
        return Math.floor(f);
    }
}
function $c9ee9f81cdf9785c$var$roundTo(number, digits, rounding) {
    if (rounding === void 0) rounding = "round";
    var factor = Math.pow(10, digits);
    switch(rounding){
        case "expand":
            return number > 0 ? Math.ceil(number * factor) / factor : Math.floor(number * factor) / factor;
        case "trunc":
            return Math.trunc(number * factor) / factor;
        case "round":
            return Math.round(number * factor) / factor;
        case "floor":
            return Math.floor(number * factor) / factor;
        case "ceil":
            return Math.ceil(number * factor) / factor;
        default:
            throw new RangeError("Value rounding " + rounding + " is out of range");
    }
}
// DATE BASICS
function $c9ee9f81cdf9785c$var$isLeapYear(year) {
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
function $c9ee9f81cdf9785c$var$daysInYear(year) {
    return $c9ee9f81cdf9785c$var$isLeapYear(year) ? 366 : 365;
}
function $c9ee9f81cdf9785c$var$daysInMonth(year, month) {
    var modMonth = $c9ee9f81cdf9785c$var$floorMod(month - 1, 12) + 1, modYear = year + (month - modMonth) / 12;
    if (modMonth === 2) return $c9ee9f81cdf9785c$var$isLeapYear(modYear) ? 29 : 28;
    else return [
        31,
        null,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][modMonth - 1];
}
// convert a calendar object to a local timestamp (epoch, but with the offset baked in)
function $c9ee9f81cdf9785c$var$objToLocalTS(obj) {
    var d = Date.UTC(obj.year, obj.month - 1, obj.day, obj.hour, obj.minute, obj.second, obj.millisecond);
    // for legacy reasons, years between 0 and 99 are interpreted as 19XX; revert that
    if (obj.year < 100 && obj.year >= 0) {
        d = new Date(d);
        // set the month and day again, this is necessary because year 2000 is a leap year, but year 100 is not
        // so if obj.year is in 99, but obj.day makes it roll over into year 100,
        // the calculations done by Date.UTC are using year 2000 - which is incorrect
        d.setUTCFullYear(obj.year, obj.month - 1, obj.day);
    }
    return +d;
}
// adapted from moment.js: https://github.com/moment/moment/blob/000ac1800e620f770f4eb31b5ae908f6167b0ab2/src/lib/units/week-calendar-utils.js
function $c9ee9f81cdf9785c$var$firstWeekOffset(year, minDaysInFirstWeek, startOfWeek) {
    var fwdlw = $c9ee9f81cdf9785c$var$isoWeekdayToLocal($c9ee9f81cdf9785c$var$dayOfWeek(year, 1, minDaysInFirstWeek), startOfWeek);
    return -fwdlw + minDaysInFirstWeek - 1;
}
function $c9ee9f81cdf9785c$var$weeksInWeekYear(weekYear, minDaysInFirstWeek, startOfWeek) {
    if (minDaysInFirstWeek === void 0) minDaysInFirstWeek = 4;
    if (startOfWeek === void 0) startOfWeek = 1;
    var weekOffset = $c9ee9f81cdf9785c$var$firstWeekOffset(weekYear, minDaysInFirstWeek, startOfWeek);
    var weekOffsetNext = $c9ee9f81cdf9785c$var$firstWeekOffset(weekYear + 1, minDaysInFirstWeek, startOfWeek);
    return ($c9ee9f81cdf9785c$var$daysInYear(weekYear) - weekOffset + weekOffsetNext) / 7;
}
function $c9ee9f81cdf9785c$var$untruncateYear(year) {
    if (year > 99) return year;
    else return year > $c9ee9f81cdf9785c$var$Settings.twoDigitCutoffYear ? 1900 + year : 2000 + year;
}
// PARSING
function $c9ee9f81cdf9785c$var$parseZoneInfo(ts, offsetFormat, locale, timeZone) {
    if (timeZone === void 0) timeZone = null;
    var date = new Date(ts), intlOpts = {
        hourCycle: "h23",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit"
    };
    if (timeZone) intlOpts.timeZone = timeZone;
    var modified = $c9ee9f81cdf9785c$var$_extends({
        timeZoneName: offsetFormat
    }, intlOpts);
    var parsed = new Intl.DateTimeFormat(locale, modified).formatToParts(date).find(function(m) {
        return m.type.toLowerCase() === "timezonename";
    });
    return parsed ? parsed.value : null;
}
// signedOffset('-5', '30') -> -330
function $c9ee9f81cdf9785c$var$signedOffset(offHourStr, offMinuteStr) {
    var offHour = parseInt(offHourStr, 10);
    // don't || this because we want to preserve -0
    if (Number.isNaN(offHour)) offHour = 0;
    var offMin = parseInt(offMinuteStr, 10) || 0, offMinSigned = offHour < 0 || Object.is(offHour, -0) ? -offMin : offMin;
    return offHour * 60 + offMinSigned;
}
// COERCION
function $c9ee9f81cdf9785c$var$asNumber(value) {
    var numericValue = Number(value);
    if (typeof value === "boolean" || value === "" || !Number.isFinite(numericValue)) throw new $c9ee9f81cdf9785c$var$InvalidArgumentError("Invalid unit value " + value);
    return numericValue;
}
function $c9ee9f81cdf9785c$var$normalizeObject(obj, normalizer) {
    var normalized = {};
    for(var u in obj)if ($c9ee9f81cdf9785c$var$hasOwnProperty(obj, u)) {
        var v = obj[u];
        if (v === undefined || v === null) continue;
        normalized[normalizer(u)] = $c9ee9f81cdf9785c$var$asNumber(v);
    }
    return normalized;
}
/**
 * Returns the offset's value as a string
 * @param {number} ts - Epoch milliseconds for which to get the offset
 * @param {string} format - What style of offset to return.
 *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
 * @return {string}
 */ function $c9ee9f81cdf9785c$var$formatOffset(offset, format) {
    var hours = Math.trunc(Math.abs(offset / 60)), minutes = Math.trunc(Math.abs(offset % 60)), sign = offset >= 0 ? "+" : "-";
    switch(format){
        case "short":
            return "" + sign + $c9ee9f81cdf9785c$var$padStart(hours, 2) + ":" + $c9ee9f81cdf9785c$var$padStart(minutes, 2);
        case "narrow":
            return "" + sign + hours + (minutes > 0 ? ":" + minutes : "");
        case "techie":
            return "" + sign + $c9ee9f81cdf9785c$var$padStart(hours, 2) + $c9ee9f81cdf9785c$var$padStart(minutes, 2);
        default:
            throw new RangeError("Value format " + format + " is out of range for property format");
    }
}
function $c9ee9f81cdf9785c$var$timeObject(obj) {
    return $c9ee9f81cdf9785c$var$pick(obj, [
        "hour",
        "minute",
        "second",
        "millisecond"
    ]);
}
/**
 * @private
 */ var $c9ee9f81cdf9785c$var$monthsLong = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
var $c9ee9f81cdf9785c$var$monthsShort = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
var $c9ee9f81cdf9785c$var$monthsNarrow = [
    "J",
    "F",
    "M",
    "A",
    "M",
    "J",
    "J",
    "A",
    "S",
    "O",
    "N",
    "D"
];
function $c9ee9f81cdf9785c$var$months(length) {
    switch(length){
        case "narrow":
            return [].concat($c9ee9f81cdf9785c$var$monthsNarrow);
        case "short":
            return [].concat($c9ee9f81cdf9785c$var$monthsShort);
        case "long":
            return [].concat($c9ee9f81cdf9785c$var$monthsLong);
        case "numeric":
            return [
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7",
                "8",
                "9",
                "10",
                "11",
                "12"
            ];
        case "2-digit":
            return [
                "01",
                "02",
                "03",
                "04",
                "05",
                "06",
                "07",
                "08",
                "09",
                "10",
                "11",
                "12"
            ];
        default:
            return null;
    }
}
var $c9ee9f81cdf9785c$var$weekdaysLong = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday"
];
var $c9ee9f81cdf9785c$var$weekdaysShort = [
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat",
    "Sun"
];
var $c9ee9f81cdf9785c$var$weekdaysNarrow = [
    "M",
    "T",
    "W",
    "T",
    "F",
    "S",
    "S"
];
function $c9ee9f81cdf9785c$var$weekdays(length) {
    switch(length){
        case "narrow":
            return [].concat($c9ee9f81cdf9785c$var$weekdaysNarrow);
        case "short":
            return [].concat($c9ee9f81cdf9785c$var$weekdaysShort);
        case "long":
            return [].concat($c9ee9f81cdf9785c$var$weekdaysLong);
        case "numeric":
            return [
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7"
            ];
        default:
            return null;
    }
}
var $c9ee9f81cdf9785c$var$meridiems = [
    "AM",
    "PM"
];
var $c9ee9f81cdf9785c$var$erasLong = [
    "Before Christ",
    "Anno Domini"
];
var $c9ee9f81cdf9785c$var$erasShort = [
    "BC",
    "AD"
];
var $c9ee9f81cdf9785c$var$erasNarrow = [
    "B",
    "A"
];
function $c9ee9f81cdf9785c$var$eras(length) {
    switch(length){
        case "narrow":
            return [].concat($c9ee9f81cdf9785c$var$erasNarrow);
        case "short":
            return [].concat($c9ee9f81cdf9785c$var$erasShort);
        case "long":
            return [].concat($c9ee9f81cdf9785c$var$erasLong);
        default:
            return null;
    }
}
function $c9ee9f81cdf9785c$var$meridiemForDateTime(dt) {
    return $c9ee9f81cdf9785c$var$meridiems[dt.hour < 12 ? 0 : 1];
}
function $c9ee9f81cdf9785c$var$weekdayForDateTime(dt, length) {
    return $c9ee9f81cdf9785c$var$weekdays(length)[dt.weekday - 1];
}
function $c9ee9f81cdf9785c$var$monthForDateTime(dt, length) {
    return $c9ee9f81cdf9785c$var$months(length)[dt.month - 1];
}
function $c9ee9f81cdf9785c$var$eraForDateTime(dt, length) {
    return $c9ee9f81cdf9785c$var$eras(length)[dt.year < 0 ? 0 : 1];
}
function $c9ee9f81cdf9785c$var$formatRelativeTime(unit, count, numeric, narrow) {
    if (numeric === void 0) numeric = "always";
    if (narrow === void 0) narrow = false;
    var units = {
        years: [
            "year",
            "yr."
        ],
        quarters: [
            "quarter",
            "qtr."
        ],
        months: [
            "month",
            "mo."
        ],
        weeks: [
            "week",
            "wk."
        ],
        days: [
            "day",
            "day",
            "days"
        ],
        hours: [
            "hour",
            "hr."
        ],
        minutes: [
            "minute",
            "min."
        ],
        seconds: [
            "second",
            "sec."
        ]
    };
    var lastable = [
        "hours",
        "minutes",
        "seconds"
    ].indexOf(unit) === -1;
    if (numeric === "auto" && lastable) {
        var isDay = unit === "days";
        switch(count){
            case 1:
                return isDay ? "tomorrow" : "next " + units[unit][0];
            case -1:
                return isDay ? "yesterday" : "last " + units[unit][0];
            case 0:
                return isDay ? "today" : "this " + units[unit][0];
        }
    }
    var isInPast = Object.is(count, -0) || count < 0, fmtValue = Math.abs(count), singular = fmtValue === 1, lilUnits = units[unit], fmtUnit = narrow ? singular ? lilUnits[1] : lilUnits[2] || lilUnits[1] : singular ? units[unit][0] : unit;
    return isInPast ? fmtValue + " " + fmtUnit + " ago" : "in " + fmtValue + " " + fmtUnit;
}
function $c9ee9f81cdf9785c$var$stringifyTokens(splits, tokenToString) {
    var s = "";
    for(var _iterator = $c9ee9f81cdf9785c$var$_createForOfIteratorHelperLoose(splits), _step; !(_step = _iterator()).done;){
        var token = _step.value;
        if (token.literal) s += token.val;
        else s += tokenToString(token.val);
    }
    return s;
}
var $c9ee9f81cdf9785c$var$_macroTokenToFormatOpts = {
    D: $c9ee9f81cdf9785c$var$DATE_SHORT,
    DD: $c9ee9f81cdf9785c$var$DATE_MED,
    DDD: $c9ee9f81cdf9785c$var$DATE_FULL,
    DDDD: $c9ee9f81cdf9785c$var$DATE_HUGE,
    t: $c9ee9f81cdf9785c$var$TIME_SIMPLE,
    tt: $c9ee9f81cdf9785c$var$TIME_WITH_SECONDS,
    ttt: $c9ee9f81cdf9785c$var$TIME_WITH_SHORT_OFFSET,
    tttt: $c9ee9f81cdf9785c$var$TIME_WITH_LONG_OFFSET,
    T: $c9ee9f81cdf9785c$var$TIME_24_SIMPLE,
    TT: $c9ee9f81cdf9785c$var$TIME_24_WITH_SECONDS,
    TTT: $c9ee9f81cdf9785c$var$TIME_24_WITH_SHORT_OFFSET,
    TTTT: $c9ee9f81cdf9785c$var$TIME_24_WITH_LONG_OFFSET,
    f: $c9ee9f81cdf9785c$var$DATETIME_SHORT,
    ff: $c9ee9f81cdf9785c$var$DATETIME_MED,
    fff: $c9ee9f81cdf9785c$var$DATETIME_FULL,
    ffff: $c9ee9f81cdf9785c$var$DATETIME_HUGE,
    F: $c9ee9f81cdf9785c$var$DATETIME_SHORT_WITH_SECONDS,
    FF: $c9ee9f81cdf9785c$var$DATETIME_MED_WITH_SECONDS,
    FFF: $c9ee9f81cdf9785c$var$DATETIME_FULL_WITH_SECONDS,
    FFFF: $c9ee9f81cdf9785c$var$DATETIME_HUGE_WITH_SECONDS
};
/**
 * @private
 */ var $c9ee9f81cdf9785c$var$Formatter = /*#__PURE__*/ function() {
    Formatter.create = function create(locale, opts) {
        if (opts === void 0) opts = {};
        return new Formatter(locale, opts);
    };
    Formatter.parseFormat = function parseFormat(fmt) {
        // white-space is always considered a literal in user-provided formats
        // the " " token has a special meaning (see unitForToken)
        var current = null, currentFull = "", bracketed = false;
        var splits = [];
        for(var i = 0; i < fmt.length; i++){
            var c = fmt.charAt(i);
            if (c === "'") {
                // turn '' into a literal signal quote instead of just skipping the empty literal
                if (currentFull.length > 0 || bracketed) splits.push({
                    literal: bracketed || /^\s+$/.test(currentFull),
                    val: currentFull === "" ? "'" : currentFull
                });
                current = null;
                currentFull = "";
                bracketed = !bracketed;
            } else if (bracketed) currentFull += c;
            else if (c === current) currentFull += c;
            else {
                if (currentFull.length > 0) splits.push({
                    literal: /^\s+$/.test(currentFull),
                    val: currentFull
                });
                currentFull = c;
                current = c;
            }
        }
        if (currentFull.length > 0) splits.push({
            literal: bracketed || /^\s+$/.test(currentFull),
            val: currentFull
        });
        return splits;
    };
    Formatter.macroTokenToFormatOpts = function macroTokenToFormatOpts(token) {
        return $c9ee9f81cdf9785c$var$_macroTokenToFormatOpts[token];
    };
    function Formatter(locale, formatOpts) {
        this.opts = formatOpts;
        this.loc = locale;
        this.systemLoc = null;
    }
    var _proto = Formatter.prototype;
    _proto.formatWithSystemDefault = function formatWithSystemDefault(dt, opts) {
        if (this.systemLoc === null) this.systemLoc = this.loc.redefaultToSystem();
        var df = this.systemLoc.dtFormatter(dt, $c9ee9f81cdf9785c$var$_extends({}, this.opts, opts));
        return df.format();
    };
    _proto.dtFormatter = function dtFormatter(dt, opts) {
        if (opts === void 0) opts = {};
        return this.loc.dtFormatter(dt, $c9ee9f81cdf9785c$var$_extends({}, this.opts, opts));
    };
    _proto.formatDateTime = function formatDateTime(dt, opts) {
        return this.dtFormatter(dt, opts).format();
    };
    _proto.formatDateTimeParts = function formatDateTimeParts(dt, opts) {
        return this.dtFormatter(dt, opts).formatToParts();
    };
    _proto.formatInterval = function formatInterval(interval, opts) {
        var df = this.dtFormatter(interval.start, opts);
        return df.dtf.formatRange(interval.start.toJSDate(), interval.end.toJSDate());
    };
    _proto.resolvedOptions = function resolvedOptions(dt, opts) {
        return this.dtFormatter(dt, opts).resolvedOptions();
    };
    _proto.num = function num(n, p, signDisplay) {
        if (p === void 0) p = 0;
        if (signDisplay === void 0) signDisplay = undefined;
        // we get some perf out of doing this here, annoyingly
        if (this.opts.forceSimple) return $c9ee9f81cdf9785c$var$padStart(n, p);
        var opts = $c9ee9f81cdf9785c$var$_extends({}, this.opts);
        if (p > 0) opts.padTo = p;
        if (signDisplay) opts.signDisplay = signDisplay;
        return this.loc.numberFormatter(opts).format(n);
    };
    _proto.formatDateTimeFromString = function formatDateTimeFromString(dt, fmt) {
        var _this = this;
        var knownEnglish = this.loc.listingMode() === "en", useDateTimeFormatter = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory", string = function string(opts, extract) {
            return _this.loc.extract(dt, opts, extract);
        }, formatOffset = function formatOffset(opts) {
            if (dt.isOffsetFixed && dt.offset === 0 && opts.allowZ) return "Z";
            return dt.isValid ? dt.zone.formatOffset(dt.ts, opts.format) : "";
        }, meridiem = function meridiem() {
            return knownEnglish ? $c9ee9f81cdf9785c$var$meridiemForDateTime(dt) : string({
                hour: "numeric",
                hourCycle: "h12"
            }, "dayperiod");
        }, month = function month(length, standalone) {
            return knownEnglish ? $c9ee9f81cdf9785c$var$monthForDateTime(dt, length) : string(standalone ? {
                month: length
            } : {
                month: length,
                day: "numeric"
            }, "month");
        }, weekday = function weekday(length, standalone) {
            return knownEnglish ? $c9ee9f81cdf9785c$var$weekdayForDateTime(dt, length) : string(standalone ? {
                weekday: length
            } : {
                weekday: length,
                month: "long",
                day: "numeric"
            }, "weekday");
        }, maybeMacro = function maybeMacro(token) {
            var formatOpts = Formatter.macroTokenToFormatOpts(token);
            if (formatOpts) return _this.formatWithSystemDefault(dt, formatOpts);
            else return token;
        }, era = function era(length) {
            return knownEnglish ? $c9ee9f81cdf9785c$var$eraForDateTime(dt, length) : string({
                era: length
            }, "era");
        }, tokenToString = function tokenToString(token) {
            // Where possible: https://cldr.unicode.org/translation/date-time/date-time-symbols
            switch(token){
                // ms
                case "S":
                    return _this.num(dt.millisecond);
                case "u":
                // falls through
                case "SSS":
                    return _this.num(dt.millisecond, 3);
                // seconds
                case "s":
                    return _this.num(dt.second);
                case "ss":
                    return _this.num(dt.second, 2);
                // fractional seconds
                case "uu":
                    return _this.num(Math.floor(dt.millisecond / 10), 2);
                case "uuu":
                    return _this.num(Math.floor(dt.millisecond / 100));
                // minutes
                case "m":
                    return _this.num(dt.minute);
                case "mm":
                    return _this.num(dt.minute, 2);
                // hours
                case "h":
                    return _this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12);
                case "hh":
                    return _this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12, 2);
                case "H":
                    return _this.num(dt.hour);
                case "HH":
                    return _this.num(dt.hour, 2);
                // offset
                case "Z":
                    // like +6
                    return formatOffset({
                        format: "narrow",
                        allowZ: _this.opts.allowZ
                    });
                case "ZZ":
                    // like +06:00
                    return formatOffset({
                        format: "short",
                        allowZ: _this.opts.allowZ
                    });
                case "ZZZ":
                    // like +0600
                    return formatOffset({
                        format: "techie",
                        allowZ: _this.opts.allowZ
                    });
                case "ZZZZ":
                    // like EST
                    return dt.zone.offsetName(dt.ts, {
                        format: "short",
                        locale: _this.loc.locale
                    });
                case "ZZZZZ":
                    // like Eastern Standard Time
                    return dt.zone.offsetName(dt.ts, {
                        format: "long",
                        locale: _this.loc.locale
                    });
                // zone
                case "z":
                    // like America/New_York
                    return dt.zoneName;
                // meridiems
                case "a":
                    return meridiem();
                // dates
                case "d":
                    return useDateTimeFormatter ? string({
                        day: "numeric"
                    }, "day") : _this.num(dt.day);
                case "dd":
                    return useDateTimeFormatter ? string({
                        day: "2-digit"
                    }, "day") : _this.num(dt.day, 2);
                // weekdays - standalone
                case "c":
                    // like 1
                    return _this.num(dt.weekday);
                case "ccc":
                    // like 'Tues'
                    return weekday("short", true);
                case "cccc":
                    // like 'Tuesday'
                    return weekday("long", true);
                case "ccccc":
                    // like 'T'
                    return weekday("narrow", true);
                // weekdays - format
                case "E":
                    // like 1
                    return _this.num(dt.weekday);
                case "EEE":
                    // like 'Tues'
                    return weekday("short", false);
                case "EEEE":
                    // like 'Tuesday'
                    return weekday("long", false);
                case "EEEEE":
                    // like 'T'
                    return weekday("narrow", false);
                // months - standalone
                case "L":
                    // like 1
                    return useDateTimeFormatter ? string({
                        month: "numeric",
                        day: "numeric"
                    }, "month") : _this.num(dt.month);
                case "LL":
                    // like 01, doesn't seem to work
                    return useDateTimeFormatter ? string({
                        month: "2-digit",
                        day: "numeric"
                    }, "month") : _this.num(dt.month, 2);
                case "LLL":
                    // like Jan
                    return month("short", true);
                case "LLLL":
                    // like January
                    return month("long", true);
                case "LLLLL":
                    // like J
                    return month("narrow", true);
                // months - format
                case "M":
                    // like 1
                    return useDateTimeFormatter ? string({
                        month: "numeric"
                    }, "month") : _this.num(dt.month);
                case "MM":
                    // like 01
                    return useDateTimeFormatter ? string({
                        month: "2-digit"
                    }, "month") : _this.num(dt.month, 2);
                case "MMM":
                    // like Jan
                    return month("short", false);
                case "MMMM":
                    // like January
                    return month("long", false);
                case "MMMMM":
                    // like J
                    return month("narrow", false);
                // years
                case "y":
                    // like 2014
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : _this.num(dt.year);
                case "yy":
                    // like 14
                    return useDateTimeFormatter ? string({
                        year: "2-digit"
                    }, "year") : _this.num(dt.year.toString().slice(-2), 2);
                case "yyyy":
                    // like 0012
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : _this.num(dt.year, 4);
                case "yyyyyy":
                    // like 000012
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : _this.num(dt.year, 6);
                // eras
                case "G":
                    // like AD
                    return era("short");
                case "GG":
                    // like Anno Domini
                    return era("long");
                case "GGGGG":
                    return era("narrow");
                case "kk":
                    return _this.num(dt.weekYear.toString().slice(-2), 2);
                case "kkkk":
                    return _this.num(dt.weekYear, 4);
                case "W":
                    return _this.num(dt.weekNumber);
                case "WW":
                    return _this.num(dt.weekNumber, 2);
                case "n":
                    return _this.num(dt.localWeekNumber);
                case "nn":
                    return _this.num(dt.localWeekNumber, 2);
                case "ii":
                    return _this.num(dt.localWeekYear.toString().slice(-2), 2);
                case "iiii":
                    return _this.num(dt.localWeekYear, 4);
                case "o":
                    return _this.num(dt.ordinal);
                case "ooo":
                    return _this.num(dt.ordinal, 3);
                case "q":
                    // like 1
                    return _this.num(dt.quarter);
                case "qq":
                    // like 01
                    return _this.num(dt.quarter, 2);
                case "X":
                    return _this.num(Math.floor(dt.ts / 1000));
                case "x":
                    return _this.num(dt.ts);
                default:
                    return maybeMacro(token);
            }
        };
        return $c9ee9f81cdf9785c$var$stringifyTokens(Formatter.parseFormat(fmt), tokenToString);
    };
    _proto.formatDurationFromString = function formatDurationFromString(dur, fmt) {
        var _this2 = this;
        var invertLargest = this.opts.signMode === "negativeLargestOnly" ? -1 : 1;
        var tokenToField = function tokenToField(token) {
            switch(token[0]){
                case "S":
                    return "milliseconds";
                case "s":
                    return "seconds";
                case "m":
                    return "minutes";
                case "h":
                    return "hours";
                case "d":
                    return "days";
                case "w":
                    return "weeks";
                case "M":
                    return "months";
                case "y":
                    return "years";
                default:
                    return null;
            }
        }, tokenToString = function tokenToString(lildur, info) {
            return function(token) {
                var mapped = tokenToField(token);
                if (mapped) {
                    var inversionFactor = info.isNegativeDuration && mapped !== info.largestUnit ? invertLargest : 1;
                    var signDisplay;
                    if (_this2.opts.signMode === "negativeLargestOnly" && mapped !== info.largestUnit) signDisplay = "never";
                    else if (_this2.opts.signMode === "all") signDisplay = "always";
                    else // "auto" and "negative" are the same, but "auto" has better support
                    signDisplay = "auto";
                    return _this2.num(lildur.get(mapped) * inversionFactor, token.length, signDisplay);
                } else return token;
            };
        }, tokens = Formatter.parseFormat(fmt), realTokens = tokens.reduce(function(found, _ref) {
            var literal = _ref.literal, val = _ref.val;
            return literal ? found : found.concat(val);
        }, []), collapsed = dur.shiftTo.apply(dur, realTokens.map(tokenToField).filter(function(t) {
            return t;
        })), durationInfo = {
            isNegativeDuration: collapsed < 0,
            // this relies on "collapsed" being based on "shiftTo", which builds up the object
            // in order
            largestUnit: Object.keys(collapsed.values)[0]
        };
        return $c9ee9f81cdf9785c$var$stringifyTokens(tokens, tokenToString(collapsed, durationInfo));
    };
    return Formatter;
}();
/*
 * This file handles parsing for well-specified formats. Here's how it works:
 * Two things go into parsing: a regex to match with and an extractor to take apart the groups in the match.
 * An extractor is just a function that takes a regex match array and returns a { year: ..., month: ... } object
 * parse() does the work of executing the regex and applying the extractor. It takes multiple regex/extractor pairs to try in sequence.
 * Extractors can take a "cursor" representing the offset in the match to look at. This makes it easy to combine extractors.
 * combineExtractors() does the work of combining them, keeping track of the cursor through multiple extractions.
 * Some extractions are super dumb and simpleParse and fromStrings help DRY them.
 */ var $c9ee9f81cdf9785c$var$ianaRegex = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;
function $c9ee9f81cdf9785c$var$combineRegexes() {
    for(var _len = arguments.length, regexes = new Array(_len), _key = 0; _key < _len; _key++)regexes[_key] = arguments[_key];
    var full = regexes.reduce(function(f, r) {
        return f + r.source;
    }, "");
    return RegExp("^" + full + "$");
}
function $c9ee9f81cdf9785c$var$combineExtractors() {
    for(var _len2 = arguments.length, extractors = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)extractors[_key2] = arguments[_key2];
    return function(m) {
        return extractors.reduce(function(_ref, ex) {
            var mergedVals = _ref[0], mergedZone = _ref[1], cursor = _ref[2];
            var _ex = ex(m, cursor), val = _ex[0], zone = _ex[1], next = _ex[2];
            return [
                $c9ee9f81cdf9785c$var$_extends({}, mergedVals, val),
                zone || mergedZone,
                next
            ];
        }, [
            {},
            null,
            1
        ]).slice(0, 2);
    };
}
function $c9ee9f81cdf9785c$var$parse(s) {
    if (s == null) return [
        null,
        null
    ];
    for(var _len3 = arguments.length, patterns = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)patterns[_key3 - 1] = arguments[_key3];
    for(var _i = 0, _patterns = patterns; _i < _patterns.length; _i++){
        var _patterns$_i = _patterns[_i], regex = _patterns$_i[0], extractor = _patterns$_i[1];
        var m = regex.exec(s);
        if (m) return extractor(m);
    }
    return [
        null,
        null
    ];
}
function $c9ee9f81cdf9785c$var$simpleParse() {
    for(var _len4 = arguments.length, keys = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)keys[_key4] = arguments[_key4];
    return function(match, cursor) {
        var ret = {};
        var i;
        for(i = 0; i < keys.length; i++)ret[keys[i]] = $c9ee9f81cdf9785c$var$parseInteger(match[cursor + i]);
        return [
            ret,
            null,
            cursor + i
        ];
    };
}
// ISO and SQL parsing
var $c9ee9f81cdf9785c$var$offsetRegex = /(?:([Zz])|([+-]\d\d)(?::?(\d\d))?)/;
var $c9ee9f81cdf9785c$var$isoExtendedZone = "(?:" + $c9ee9f81cdf9785c$var$offsetRegex.source + "?(?:\\[(" + $c9ee9f81cdf9785c$var$ianaRegex.source + ")\\])?)?";
var $c9ee9f81cdf9785c$var$isoTimeBaseRegex = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/;
var $c9ee9f81cdf9785c$var$isoTimeRegex = RegExp("" + $c9ee9f81cdf9785c$var$isoTimeBaseRegex.source + $c9ee9f81cdf9785c$var$isoExtendedZone);
var $c9ee9f81cdf9785c$var$isoTimeExtensionRegex = RegExp("(?:[Tt]" + $c9ee9f81cdf9785c$var$isoTimeRegex.source + ")?");
var $c9ee9f81cdf9785c$var$isoYmdRegex = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/;
var $c9ee9f81cdf9785c$var$isoWeekRegex = /(\d{4})-?W(\d\d)(?:-?(\d))?/;
var $c9ee9f81cdf9785c$var$isoOrdinalRegex = /(\d{4})-?(\d{3})/;
var $c9ee9f81cdf9785c$var$extractISOWeekData = $c9ee9f81cdf9785c$var$simpleParse("weekYear", "weekNumber", "weekDay");
var $c9ee9f81cdf9785c$var$extractISOOrdinalData = $c9ee9f81cdf9785c$var$simpleParse("year", "ordinal");
var $c9ee9f81cdf9785c$var$sqlYmdRegex = /(\d{4})-(\d\d)-(\d\d)/; // dumbed-down version of the ISO one
var $c9ee9f81cdf9785c$var$sqlTimeRegex = RegExp($c9ee9f81cdf9785c$var$isoTimeBaseRegex.source + " ?(?:" + $c9ee9f81cdf9785c$var$offsetRegex.source + "|(" + $c9ee9f81cdf9785c$var$ianaRegex.source + "))?");
var $c9ee9f81cdf9785c$var$sqlTimeExtensionRegex = RegExp("(?: " + $c9ee9f81cdf9785c$var$sqlTimeRegex.source + ")?");
function $c9ee9f81cdf9785c$var$int(match, pos, fallback) {
    var m = match[pos];
    return $c9ee9f81cdf9785c$var$isUndefined(m) ? fallback : $c9ee9f81cdf9785c$var$parseInteger(m);
}
function $c9ee9f81cdf9785c$var$extractISOYmd(match, cursor) {
    var item = {
        year: $c9ee9f81cdf9785c$var$int(match, cursor),
        month: $c9ee9f81cdf9785c$var$int(match, cursor + 1, 1),
        day: $c9ee9f81cdf9785c$var$int(match, cursor + 2, 1)
    };
    return [
        item,
        null,
        cursor + 3
    ];
}
function $c9ee9f81cdf9785c$var$extractISOTime(match, cursor) {
    var item = {
        hours: $c9ee9f81cdf9785c$var$int(match, cursor, 0),
        minutes: $c9ee9f81cdf9785c$var$int(match, cursor + 1, 0),
        seconds: $c9ee9f81cdf9785c$var$int(match, cursor + 2, 0),
        milliseconds: $c9ee9f81cdf9785c$var$parseMillis(match[cursor + 3])
    };
    return [
        item,
        null,
        cursor + 4
    ];
}
function $c9ee9f81cdf9785c$var$extractISOOffset(match, cursor) {
    var local = !match[cursor] && !match[cursor + 1], fullOffset = $c9ee9f81cdf9785c$var$signedOffset(match[cursor + 1], match[cursor + 2]), zone = local ? null : $c9ee9f81cdf9785c$var$FixedOffsetZone.instance(fullOffset);
    return [
        {},
        zone,
        cursor + 3
    ];
}
function $c9ee9f81cdf9785c$var$extractIANAZone(match, cursor) {
    var zone = match[cursor] ? $c9ee9f81cdf9785c$var$IANAZone.create(match[cursor]) : null;
    return [
        {},
        zone,
        cursor + 1
    ];
}
// ISO time parsing
var $c9ee9f81cdf9785c$var$isoTimeOnly = RegExp("^T?" + $c9ee9f81cdf9785c$var$isoTimeBaseRegex.source + "$");
// ISO duration parsing
var $c9ee9f81cdf9785c$var$isoDuration = /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;
function $c9ee9f81cdf9785c$var$extractISODuration(match) {
    var s = match[0], yearStr = match[1], monthStr = match[2], weekStr = match[3], dayStr = match[4], hourStr = match[5], minuteStr = match[6], secondStr = match[7], millisecondsStr = match[8];
    var hasNegativePrefix = s[0] === "-";
    var negativeSeconds = secondStr && secondStr[0] === "-";
    var maybeNegate = function maybeNegate(num, force) {
        if (force === void 0) force = false;
        return num !== undefined && (force || num && hasNegativePrefix) ? -num : num;
    };
    return [
        {
            years: maybeNegate($c9ee9f81cdf9785c$var$parseFloating(yearStr)),
            months: maybeNegate($c9ee9f81cdf9785c$var$parseFloating(monthStr)),
            weeks: maybeNegate($c9ee9f81cdf9785c$var$parseFloating(weekStr)),
            days: maybeNegate($c9ee9f81cdf9785c$var$parseFloating(dayStr)),
            hours: maybeNegate($c9ee9f81cdf9785c$var$parseFloating(hourStr)),
            minutes: maybeNegate($c9ee9f81cdf9785c$var$parseFloating(minuteStr)),
            seconds: maybeNegate($c9ee9f81cdf9785c$var$parseFloating(secondStr), secondStr === "-0"),
            milliseconds: maybeNegate($c9ee9f81cdf9785c$var$parseMillis(millisecondsStr), negativeSeconds)
        }
    ];
}
// These are a little braindead. EDT *should* tell us that we're in, say, America/New_York
// and not just that we're in -240 *right now*. But since I don't think these are used that often
// I'm just going to ignore that
var $c9ee9f81cdf9785c$var$obsOffsets = {
    GMT: 0,
    EDT: -240,
    EST: -300,
    CDT: -300,
    CST: -360,
    MDT: -360,
    MST: -420,
    PDT: -420,
    PST: -480
};
function $c9ee9f81cdf9785c$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
    var result = {
        year: yearStr.length === 2 ? $c9ee9f81cdf9785c$var$untruncateYear($c9ee9f81cdf9785c$var$parseInteger(yearStr)) : $c9ee9f81cdf9785c$var$parseInteger(yearStr),
        month: $c9ee9f81cdf9785c$var$monthsShort.indexOf(monthStr) + 1,
        day: $c9ee9f81cdf9785c$var$parseInteger(dayStr),
        hour: $c9ee9f81cdf9785c$var$parseInteger(hourStr),
        minute: $c9ee9f81cdf9785c$var$parseInteger(minuteStr)
    };
    if (secondStr) result.second = $c9ee9f81cdf9785c$var$parseInteger(secondStr);
    if (weekdayStr) result.weekday = weekdayStr.length > 3 ? $c9ee9f81cdf9785c$var$weekdaysLong.indexOf(weekdayStr) + 1 : $c9ee9f81cdf9785c$var$weekdaysShort.indexOf(weekdayStr) + 1;
    return result;
}
// RFC 2822/5322
var $c9ee9f81cdf9785c$var$rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function $c9ee9f81cdf9785c$var$extractRFC2822(match) {
    var weekdayStr = match[1], dayStr = match[2], monthStr = match[3], yearStr = match[4], hourStr = match[5], minuteStr = match[6], secondStr = match[7], obsOffset = match[8], milOffset = match[9], offHourStr = match[10], offMinuteStr = match[11], result = $c9ee9f81cdf9785c$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    var offset;
    if (obsOffset) offset = $c9ee9f81cdf9785c$var$obsOffsets[obsOffset];
    else if (milOffset) offset = 0;
    else offset = $c9ee9f81cdf9785c$var$signedOffset(offHourStr, offMinuteStr);
    return [
        result,
        new $c9ee9f81cdf9785c$var$FixedOffsetZone(offset)
    ];
}
function $c9ee9f81cdf9785c$var$preprocessRFC2822(s) {
    // Remove comments and folding whitespace and replace multiple-spaces with a single space
    return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
}
// http date
var $c9ee9f81cdf9785c$var$rfc1123 = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/, $c9ee9f81cdf9785c$var$rfc850 = /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/, $c9ee9f81cdf9785c$var$ascii = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function $c9ee9f81cdf9785c$var$extractRFC1123Or850(match) {
    var weekdayStr = match[1], dayStr = match[2], monthStr = match[3], yearStr = match[4], hourStr = match[5], minuteStr = match[6], secondStr = match[7], result = $c9ee9f81cdf9785c$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    return [
        result,
        $c9ee9f81cdf9785c$var$FixedOffsetZone.utcInstance
    ];
}
function $c9ee9f81cdf9785c$var$extractASCII(match) {
    var weekdayStr = match[1], monthStr = match[2], dayStr = match[3], hourStr = match[4], minuteStr = match[5], secondStr = match[6], yearStr = match[7], result = $c9ee9f81cdf9785c$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    return [
        result,
        $c9ee9f81cdf9785c$var$FixedOffsetZone.utcInstance
    ];
}
var $c9ee9f81cdf9785c$var$isoYmdWithTimeExtensionRegex = $c9ee9f81cdf9785c$var$combineRegexes($c9ee9f81cdf9785c$var$isoYmdRegex, $c9ee9f81cdf9785c$var$isoTimeExtensionRegex);
var $c9ee9f81cdf9785c$var$isoWeekWithTimeExtensionRegex = $c9ee9f81cdf9785c$var$combineRegexes($c9ee9f81cdf9785c$var$isoWeekRegex, $c9ee9f81cdf9785c$var$isoTimeExtensionRegex);
var $c9ee9f81cdf9785c$var$isoOrdinalWithTimeExtensionRegex = $c9ee9f81cdf9785c$var$combineRegexes($c9ee9f81cdf9785c$var$isoOrdinalRegex, $c9ee9f81cdf9785c$var$isoTimeExtensionRegex);
var $c9ee9f81cdf9785c$var$isoTimeCombinedRegex = $c9ee9f81cdf9785c$var$combineRegexes($c9ee9f81cdf9785c$var$isoTimeRegex);
var $c9ee9f81cdf9785c$var$extractISOYmdTimeAndOffset = $c9ee9f81cdf9785c$var$combineExtractors($c9ee9f81cdf9785c$var$extractISOYmd, $c9ee9f81cdf9785c$var$extractISOTime, $c9ee9f81cdf9785c$var$extractISOOffset, $c9ee9f81cdf9785c$var$extractIANAZone);
var $c9ee9f81cdf9785c$var$extractISOWeekTimeAndOffset = $c9ee9f81cdf9785c$var$combineExtractors($c9ee9f81cdf9785c$var$extractISOWeekData, $c9ee9f81cdf9785c$var$extractISOTime, $c9ee9f81cdf9785c$var$extractISOOffset, $c9ee9f81cdf9785c$var$extractIANAZone);
var $c9ee9f81cdf9785c$var$extractISOOrdinalDateAndTime = $c9ee9f81cdf9785c$var$combineExtractors($c9ee9f81cdf9785c$var$extractISOOrdinalData, $c9ee9f81cdf9785c$var$extractISOTime, $c9ee9f81cdf9785c$var$extractISOOffset, $c9ee9f81cdf9785c$var$extractIANAZone);
var $c9ee9f81cdf9785c$var$extractISOTimeAndOffset = $c9ee9f81cdf9785c$var$combineExtractors($c9ee9f81cdf9785c$var$extractISOTime, $c9ee9f81cdf9785c$var$extractISOOffset, $c9ee9f81cdf9785c$var$extractIANAZone);
/*
 * @private
 */ function $c9ee9f81cdf9785c$var$parseISODate(s) {
    return $c9ee9f81cdf9785c$var$parse(s, [
        $c9ee9f81cdf9785c$var$isoYmdWithTimeExtensionRegex,
        $c9ee9f81cdf9785c$var$extractISOYmdTimeAndOffset
    ], [
        $c9ee9f81cdf9785c$var$isoWeekWithTimeExtensionRegex,
        $c9ee9f81cdf9785c$var$extractISOWeekTimeAndOffset
    ], [
        $c9ee9f81cdf9785c$var$isoOrdinalWithTimeExtensionRegex,
        $c9ee9f81cdf9785c$var$extractISOOrdinalDateAndTime
    ], [
        $c9ee9f81cdf9785c$var$isoTimeCombinedRegex,
        $c9ee9f81cdf9785c$var$extractISOTimeAndOffset
    ]);
}
function $c9ee9f81cdf9785c$var$parseRFC2822Date(s) {
    return $c9ee9f81cdf9785c$var$parse($c9ee9f81cdf9785c$var$preprocessRFC2822(s), [
        $c9ee9f81cdf9785c$var$rfc2822,
        $c9ee9f81cdf9785c$var$extractRFC2822
    ]);
}
function $c9ee9f81cdf9785c$var$parseHTTPDate(s) {
    return $c9ee9f81cdf9785c$var$parse(s, [
        $c9ee9f81cdf9785c$var$rfc1123,
        $c9ee9f81cdf9785c$var$extractRFC1123Or850
    ], [
        $c9ee9f81cdf9785c$var$rfc850,
        $c9ee9f81cdf9785c$var$extractRFC1123Or850
    ], [
        $c9ee9f81cdf9785c$var$ascii,
        $c9ee9f81cdf9785c$var$extractASCII
    ]);
}
function $c9ee9f81cdf9785c$var$parseISODuration(s) {
    return $c9ee9f81cdf9785c$var$parse(s, [
        $c9ee9f81cdf9785c$var$isoDuration,
        $c9ee9f81cdf9785c$var$extractISODuration
    ]);
}
var $c9ee9f81cdf9785c$var$extractISOTimeOnly = $c9ee9f81cdf9785c$var$combineExtractors($c9ee9f81cdf9785c$var$extractISOTime);
function $c9ee9f81cdf9785c$var$parseISOTimeOnly(s) {
    return $c9ee9f81cdf9785c$var$parse(s, [
        $c9ee9f81cdf9785c$var$isoTimeOnly,
        $c9ee9f81cdf9785c$var$extractISOTimeOnly
    ]);
}
var $c9ee9f81cdf9785c$var$sqlYmdWithTimeExtensionRegex = $c9ee9f81cdf9785c$var$combineRegexes($c9ee9f81cdf9785c$var$sqlYmdRegex, $c9ee9f81cdf9785c$var$sqlTimeExtensionRegex);
var $c9ee9f81cdf9785c$var$sqlTimeCombinedRegex = $c9ee9f81cdf9785c$var$combineRegexes($c9ee9f81cdf9785c$var$sqlTimeRegex);
var $c9ee9f81cdf9785c$var$extractISOTimeOffsetAndIANAZone = $c9ee9f81cdf9785c$var$combineExtractors($c9ee9f81cdf9785c$var$extractISOTime, $c9ee9f81cdf9785c$var$extractISOOffset, $c9ee9f81cdf9785c$var$extractIANAZone);
function $c9ee9f81cdf9785c$var$parseSQL(s) {
    return $c9ee9f81cdf9785c$var$parse(s, [
        $c9ee9f81cdf9785c$var$sqlYmdWithTimeExtensionRegex,
        $c9ee9f81cdf9785c$var$extractISOYmdTimeAndOffset
    ], [
        $c9ee9f81cdf9785c$var$sqlTimeCombinedRegex,
        $c9ee9f81cdf9785c$var$extractISOTimeOffsetAndIANAZone
    ]);
}
var $c9ee9f81cdf9785c$var$INVALID$2 = "Invalid Duration";
// unit conversion constants
var $c9ee9f81cdf9785c$var$lowOrderMatrix = {
    weeks: {
        days: 7,
        hours: 168,
        minutes: 10080,
        seconds: 604800,
        milliseconds: 604800000
    },
    days: {
        hours: 24,
        minutes: 1440,
        seconds: 86400,
        milliseconds: 86400000
    },
    hours: {
        minutes: 60,
        seconds: 3600,
        milliseconds: 3600000
    },
    minutes: {
        seconds: 60,
        milliseconds: 60000
    },
    seconds: {
        milliseconds: 1000
    }
}, $c9ee9f81cdf9785c$var$casualMatrix = $c9ee9f81cdf9785c$var$_extends({
    years: {
        quarters: 4,
        months: 12,
        weeks: 52,
        days: 365,
        hours: 8760,
        minutes: 525600,
        seconds: 31536000,
        milliseconds: 31536000000
    },
    quarters: {
        months: 3,
        weeks: 13,
        days: 91,
        hours: 2184,
        minutes: 131040,
        seconds: 7862400,
        milliseconds: 7862400000
    },
    months: {
        weeks: 4,
        days: 30,
        hours: 720,
        minutes: 43200,
        seconds: 2592000,
        milliseconds: 2592000000
    }
}, $c9ee9f81cdf9785c$var$lowOrderMatrix), $c9ee9f81cdf9785c$var$daysInYearAccurate = 365.2425, $c9ee9f81cdf9785c$var$daysInMonthAccurate = 30.436875, $c9ee9f81cdf9785c$var$accurateMatrix = $c9ee9f81cdf9785c$var$_extends({
    years: {
        quarters: 4,
        months: 12,
        weeks: $c9ee9f81cdf9785c$var$daysInYearAccurate / 7,
        days: $c9ee9f81cdf9785c$var$daysInYearAccurate,
        hours: $c9ee9f81cdf9785c$var$daysInYearAccurate * 24,
        minutes: $c9ee9f81cdf9785c$var$daysInYearAccurate * 1440,
        seconds: $c9ee9f81cdf9785c$var$daysInYearAccurate * 86400,
        milliseconds: $c9ee9f81cdf9785c$var$daysInYearAccurate * 86400000
    },
    quarters: {
        months: 3,
        weeks: $c9ee9f81cdf9785c$var$daysInYearAccurate / 28,
        days: $c9ee9f81cdf9785c$var$daysInYearAccurate / 4,
        hours: $c9ee9f81cdf9785c$var$daysInYearAccurate * 24 / 4,
        minutes: $c9ee9f81cdf9785c$var$daysInYearAccurate * 1440 / 4,
        seconds: $c9ee9f81cdf9785c$var$daysInYearAccurate * 86400 / 4,
        milliseconds: $c9ee9f81cdf9785c$var$daysInYearAccurate * 86400000 / 4
    },
    months: {
        weeks: $c9ee9f81cdf9785c$var$daysInMonthAccurate / 7,
        days: $c9ee9f81cdf9785c$var$daysInMonthAccurate,
        hours: $c9ee9f81cdf9785c$var$daysInMonthAccurate * 24,
        minutes: $c9ee9f81cdf9785c$var$daysInMonthAccurate * 1440,
        seconds: $c9ee9f81cdf9785c$var$daysInMonthAccurate * 86400,
        milliseconds: $c9ee9f81cdf9785c$var$daysInMonthAccurate * 86400000
    }
}, $c9ee9f81cdf9785c$var$lowOrderMatrix);
// units ordered by size
var $c9ee9f81cdf9785c$var$orderedUnits$1 = [
    "years",
    "quarters",
    "months",
    "weeks",
    "days",
    "hours",
    "minutes",
    "seconds",
    "milliseconds"
];
var $c9ee9f81cdf9785c$var$reverseUnits = $c9ee9f81cdf9785c$var$orderedUnits$1.slice(0).reverse();
// clone really means "create another instance just like this one, but with these changes"
function $c9ee9f81cdf9785c$var$clone$1(dur, alts, clear) {
    if (clear === void 0) clear = false;
    // deep merge for vals
    var conf = {
        values: clear ? alts.values : $c9ee9f81cdf9785c$var$_extends({}, dur.values, alts.values || {}),
        loc: dur.loc.clone(alts.loc),
        conversionAccuracy: alts.conversionAccuracy || dur.conversionAccuracy,
        matrix: alts.matrix || dur.matrix
    };
    return new $c9ee9f81cdf9785c$var$Duration(conf);
}
function $c9ee9f81cdf9785c$var$durationToMillis(matrix, vals) {
    var _vals$milliseconds;
    var sum = (_vals$milliseconds = vals.milliseconds) != null ? _vals$milliseconds : 0;
    for(var _iterator = $c9ee9f81cdf9785c$var$_createForOfIteratorHelperLoose($c9ee9f81cdf9785c$var$reverseUnits.slice(1)), _step; !(_step = _iterator()).done;){
        var unit = _step.value;
        if (vals[unit]) sum += vals[unit] * matrix[unit]["milliseconds"];
    }
    return sum;
}
// NB: mutates parameters
function $c9ee9f81cdf9785c$var$normalizeValues(matrix, vals) {
    // the logic below assumes the overall value of the duration is positive
    // if this is not the case, factor is used to make it so
    var factor = $c9ee9f81cdf9785c$var$durationToMillis(matrix, vals) < 0 ? -1 : 1;
    $c9ee9f81cdf9785c$var$orderedUnits$1.reduceRight(function(previous, current) {
        if (!$c9ee9f81cdf9785c$var$isUndefined(vals[current])) {
            if (previous) {
                var previousVal = vals[previous] * factor;
                var conv = matrix[current][previous];
                // if (previousVal < 0):
                // lower order unit is negative (e.g. { years: 2, days: -2 })
                // normalize this by reducing the higher order unit by the appropriate amount
                // and increasing the lower order unit
                // this can never make the higher order unit negative, because this function only operates
                // on positive durations, so the amount of time represented by the lower order unit cannot
                // be larger than the higher order unit
                // else:
                // lower order unit is positive (e.g. { years: 2, days: 450 } or { years: -2, days: 450 })
                // in this case we attempt to convert as much as possible from the lower order unit into
                // the higher order one
                //
                // Math.floor takes care of both of these cases, rounding away from 0
                // if previousVal < 0 it makes the absolute value larger
                // if previousVal >= it makes the absolute value smaller
                var rollUp = Math.floor(previousVal / conv);
                vals[current] += rollUp * factor;
                vals[previous] -= rollUp * conv * factor;
            }
            return current;
        } else return previous;
    }, null);
    // try to convert any decimals into smaller units if possible
    // for example for { years: 2.5, days: 0, seconds: 0 } we want to get { years: 2, days: 182, hours: 12 }
    $c9ee9f81cdf9785c$var$orderedUnits$1.reduce(function(previous, current) {
        if (!$c9ee9f81cdf9785c$var$isUndefined(vals[current])) {
            if (previous) {
                var fraction = vals[previous] % 1;
                vals[previous] -= fraction;
                vals[current] += fraction * matrix[previous][current];
            }
            return current;
        } else return previous;
    }, null);
}
// Remove all properties with a value of 0 from an object
function $c9ee9f81cdf9785c$var$removeZeroes(vals) {
    var newVals = {};
    for(var _i = 0, _Object$entries = Object.entries(vals); _i < _Object$entries.length; _i++){
        var _Object$entries$_i = _Object$entries[_i], key = _Object$entries$_i[0], value = _Object$entries$_i[1];
        if (value !== 0) newVals[key] = value;
    }
    return newVals;
}
/**
 * A Duration object represents a period of time, like "2 months" or "1 day, 1 hour". Conceptually, it's just a map of units to their quantities, accompanied by some additional configuration and methods for creating, parsing, interrogating, transforming, and formatting them. They can be used on their own or in conjunction with other Luxon types; for example, you can use {@link DateTime#plus} to add a Duration object to a DateTime, producing another DateTime.
 *
 * Here is a brief overview of commonly used methods and getters in Duration:
 *
 * * **Creation** To create a Duration, use {@link Duration.fromMillis}, {@link Duration.fromObject}, or {@link Duration.fromISO}.
 * * **Unit values** See the {@link Duration#years}, {@link Duration#months}, {@link Duration#weeks}, {@link Duration#days}, {@link Duration#hours}, {@link Duration#minutes}, {@link Duration#seconds}, {@link Duration#milliseconds} accessors.
 * * **Configuration** See  {@link Duration#locale} and {@link Duration#numberingSystem} accessors.
 * * **Transformation** To create new Durations out of old ones use {@link Duration#plus}, {@link Duration#minus}, {@link Duration#normalize}, {@link Duration#set}, {@link Duration#reconfigure}, {@link Duration#shiftTo}, and {@link Duration#negate}.
 * * **Output** To convert the Duration into other representations, see {@link Duration#as}, {@link Duration#toISO}, {@link Duration#toFormat}, and {@link Duration#toJSON}
 *
 * There's are more methods documented below. In addition, for more information on subtler topics like internationalization and validity, see the external documentation.
 */ var $c9ee9f81cdf9785c$var$Duration = /*#__PURE__*/ function(_Symbol$for) {
    /**
   * @private
   */ function Duration(config) {
        var accurate = config.conversionAccuracy === "longterm" || false;
        var matrix = accurate ? $c9ee9f81cdf9785c$var$accurateMatrix : $c9ee9f81cdf9785c$var$casualMatrix;
        if (config.matrix) matrix = config.matrix;
        /**
     * @access private
     */ this.values = config.values;
        /**
     * @access private
     */ this.loc = config.loc || $c9ee9f81cdf9785c$var$Locale.create();
        /**
     * @access private
     */ this.conversionAccuracy = accurate ? "longterm" : "casual";
        /**
     * @access private
     */ this.invalid = config.invalid || null;
        /**
     * @access private
     */ this.matrix = matrix;
        /**
     * @access private
     */ this.isLuxonDuration = true;
    }
    /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */ Duration.fromMillis = function fromMillis(count, opts) {
        return Duration.fromObject({
            milliseconds: count
        }, opts);
    };
    Duration.fromObject = function fromObject(obj, opts) {
        if (opts === void 0) opts = {};
        if (obj == null || typeof obj !== "object") throw new $c9ee9f81cdf9785c$var$InvalidArgumentError("Duration.fromObject: argument expected to be an object, got " + (obj === null ? "null" : typeof obj));
        return new Duration({
            values: $c9ee9f81cdf9785c$var$normalizeObject(obj, Duration.normalizeUnit),
            loc: $c9ee9f81cdf9785c$var$Locale.fromObject(opts),
            conversionAccuracy: opts.conversionAccuracy,
            matrix: opts.matrix
        });
    };
    Duration.fromDurationLike = function fromDurationLike(durationLike) {
        if ($c9ee9f81cdf9785c$var$isNumber(durationLike)) return Duration.fromMillis(durationLike);
        else if (Duration.isDuration(durationLike)) return durationLike;
        else if (typeof durationLike === "object") return Duration.fromObject(durationLike);
        else throw new $c9ee9f81cdf9785c$var$InvalidArgumentError("Unknown duration argument " + durationLike + " of type " + typeof durationLike);
    };
    Duration.fromISO = function fromISO(text, opts) {
        var _parseISODuration = $c9ee9f81cdf9785c$var$parseISODuration(text), parsed = _parseISODuration[0];
        if (parsed) return Duration.fromObject(parsed, opts);
        else return Duration.invalid("unparsable", "the input \"" + text + "\" can't be parsed as ISO 8601");
    };
    Duration.fromISOTime = function fromISOTime(text, opts) {
        var _parseISOTimeOnly = $c9ee9f81cdf9785c$var$parseISOTimeOnly(text), parsed = _parseISOTimeOnly[0];
        if (parsed) return Duration.fromObject(parsed, opts);
        else return Duration.invalid("unparsable", "the input \"" + text + "\" can't be parsed as ISO 8601");
    };
    Duration.invalid = function invalid(reason, explanation) {
        if (explanation === void 0) explanation = null;
        if (!reason) throw new $c9ee9f81cdf9785c$var$InvalidArgumentError("need to specify a reason the Duration is invalid");
        var invalid = reason instanceof $c9ee9f81cdf9785c$var$Invalid ? reason : new $c9ee9f81cdf9785c$var$Invalid(reason, explanation);
        if ($c9ee9f81cdf9785c$var$Settings.throwOnInvalid) throw new $c9ee9f81cdf9785c$var$InvalidDurationError(invalid);
        else return new Duration({
            invalid: invalid
        });
    };
    Duration.normalizeUnit = function normalizeUnit(unit) {
        var normalized = {
            year: "years",
            years: "years",
            quarter: "quarters",
            quarters: "quarters",
            month: "months",
            months: "months",
            week: "weeks",
            weeks: "weeks",
            day: "days",
            days: "days",
            hour: "hours",
            hours: "hours",
            minute: "minutes",
            minutes: "minutes",
            second: "seconds",
            seconds: "seconds",
            millisecond: "milliseconds",
            milliseconds: "milliseconds"
        }[unit ? unit.toLowerCase() : unit];
        if (!normalized) throw new $c9ee9f81cdf9785c$var$InvalidUnitError(unit);
        return normalized;
    };
    Duration.isDuration = function isDuration(o) {
        return o && o.isLuxonDuration || false;
    };
    var _proto = Duration.prototype;
    /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `w` for weeks
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * Tokens can be escaped by wrapping with single quotes.
   * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @param {'negative'|'all'|'negativeLargestOnly'} [opts.signMode=negative] - How to handle signs
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @example Duration.fromObject({ days: 6, seconds: 2 }).toFormat("d s", { signMode: "all" }) //=> "+6 +2"
   * @example Duration.fromObject({ days: -6, seconds: -2 }).toFormat("d s", { signMode: "all" }) //=> "-6 -2"
   * @example Duration.fromObject({ days: -6, seconds: -2 }).toFormat("d s", { signMode: "negativeLargestOnly" }) //=> "-6 2"
   * @return {string}
   */ _proto.toFormat = function toFormat(fmt, opts) {
        if (opts === void 0) opts = {};
        // reverse-compat since 1.2; we always round down now, never up, and we do it by default
        var fmtOpts = $c9ee9f81cdf9785c$var$_extends({}, opts, {
            floor: opts.round !== false && opts.floor !== false
        });
        return this.isValid ? $c9ee9f81cdf9785c$var$Formatter.create(this.loc, fmtOpts).formatDurationFromString(this, fmt) : $c9ee9f81cdf9785c$var$INVALID$2;
    };
    _proto.toHuman = function toHuman(opts) {
        var _this = this;
        if (opts === void 0) opts = {};
        if (!this.isValid) return $c9ee9f81cdf9785c$var$INVALID$2;
        var showZeros = opts.showZeros !== false;
        var l = $c9ee9f81cdf9785c$var$orderedUnits$1.map(function(unit) {
            var val = _this.values[unit];
            if ($c9ee9f81cdf9785c$var$isUndefined(val) || val === 0 && !showZeros) return null;
            return _this.loc.numberFormatter($c9ee9f81cdf9785c$var$_extends({
                style: "unit",
                unitDisplay: "long"
            }, opts, {
                unit: unit.slice(0, -1)
            })).format(val);
        }).filter(function(n) {
            return n;
        });
        return this.loc.listFormatter($c9ee9f81cdf9785c$var$_extends({
            type: "conjunction",
            style: opts.listStyle || "narrow"
        }, opts)).format(l);
    };
    _proto.toObject = function toObject() {
        if (!this.isValid) return {};
        return $c9ee9f81cdf9785c$var$_extends({}, this.values);
    };
    _proto.toISO = function toISO() {
        // we could use the formatter, but this is an easier way to get the minimum string
        if (!this.isValid) return null;
        var s = "P";
        if (this.years !== 0) s += this.years + "Y";
        if (this.months !== 0 || this.quarters !== 0) s += this.months + this.quarters * 3 + "M";
        if (this.weeks !== 0) s += this.weeks + "W";
        if (this.days !== 0) s += this.days + "D";
        if (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) s += "T";
        if (this.hours !== 0) s += this.hours + "H";
        if (this.minutes !== 0) s += this.minutes + "M";
        if (this.seconds !== 0 || this.milliseconds !== 0) // this will handle "floating point madness" by removing extra decimal places
        // https://stackoverflow.com/questions/588004/is-floating-point-math-broken
        s += $c9ee9f81cdf9785c$var$roundTo(this.seconds + this.milliseconds / 1000, 3) + "S";
        if (s === "P") s += "T0S";
        return s;
    };
    _proto.toISOTime = function toISOTime(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return null;
        var millis = this.toMillis();
        if (millis < 0 || millis >= 86400000) return null;
        opts = $c9ee9f81cdf9785c$var$_extends({
            suppressMilliseconds: false,
            suppressSeconds: false,
            includePrefix: false,
            format: "extended"
        }, opts, {
            includeOffset: false
        });
        var dateTime = $c9ee9f81cdf9785c$var$DateTime.fromMillis(millis, {
            zone: "UTC"
        });
        return dateTime.toISOTime(opts);
    };
    _proto.toJSON = function toJSON() {
        return this.toISO();
    };
    _proto.toString = function toString() {
        return this.toISO();
    };
    _proto[_Symbol$for] = function() {
        if (this.isValid) return "Duration { values: " + JSON.stringify(this.values) + " }";
        else return "Duration { Invalid, reason: " + this.invalidReason + " }";
    };
    _proto.toMillis = function toMillis() {
        if (!this.isValid) return NaN;
        return $c9ee9f81cdf9785c$var$durationToMillis(this.matrix, this.values);
    };
    _proto.valueOf = function valueOf() {
        return this.toMillis();
    };
    _proto.plus = function plus(duration) {
        if (!this.isValid) return this;
        var dur = Duration.fromDurationLike(duration), result = {};
        for(var _i2 = 0, _orderedUnits = $c9ee9f81cdf9785c$var$orderedUnits$1; _i2 < _orderedUnits.length; _i2++){
            var k = _orderedUnits[_i2];
            if ($c9ee9f81cdf9785c$var$hasOwnProperty(dur.values, k) || $c9ee9f81cdf9785c$var$hasOwnProperty(this.values, k)) result[k] = dur.get(k) + this.get(k);
        }
        return $c9ee9f81cdf9785c$var$clone$1(this, {
            values: result
        }, true);
    };
    _proto.minus = function minus(duration) {
        if (!this.isValid) return this;
        var dur = Duration.fromDurationLike(duration);
        return this.plus(dur.negate());
    };
    _proto.mapUnits = function mapUnits(fn) {
        if (!this.isValid) return this;
        var result = {};
        for(var _i3 = 0, _Object$keys = Object.keys(this.values); _i3 < _Object$keys.length; _i3++){
            var k = _Object$keys[_i3];
            result[k] = $c9ee9f81cdf9785c$var$asNumber(fn(this.values[k], k));
        }
        return $c9ee9f81cdf9785c$var$clone$1(this, {
            values: result
        }, true);
    };
    _proto.get = function get(unit) {
        return this[Duration.normalizeUnit(unit)];
    };
    _proto.set = function set(values) {
        if (!this.isValid) return this;
        var mixed = $c9ee9f81cdf9785c$var$_extends({}, this.values, $c9ee9f81cdf9785c$var$normalizeObject(values, Duration.normalizeUnit));
        return $c9ee9f81cdf9785c$var$clone$1(this, {
            values: mixed
        });
    };
    _proto.reconfigure = function reconfigure(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, locale = _ref.locale, numberingSystem = _ref.numberingSystem, conversionAccuracy = _ref.conversionAccuracy, matrix = _ref.matrix;
        var loc = this.loc.clone({
            locale: locale,
            numberingSystem: numberingSystem
        });
        var opts = {
            loc: loc,
            matrix: matrix,
            conversionAccuracy: conversionAccuracy
        };
        return $c9ee9f81cdf9785c$var$clone$1(this, opts);
    };
    _proto.as = function as(unit) {
        return this.isValid ? this.shiftTo(unit).get(unit) : NaN;
    };
    _proto.normalize = function normalize() {
        if (!this.isValid) return this;
        var vals = this.toObject();
        $c9ee9f81cdf9785c$var$normalizeValues(this.matrix, vals);
        return $c9ee9f81cdf9785c$var$clone$1(this, {
            values: vals
        }, true);
    };
    _proto.rescale = function rescale() {
        if (!this.isValid) return this;
        var vals = $c9ee9f81cdf9785c$var$removeZeroes(this.normalize().shiftToAll().toObject());
        return $c9ee9f81cdf9785c$var$clone$1(this, {
            values: vals
        }, true);
    };
    _proto.shiftTo = function shiftTo() {
        for(var _len = arguments.length, units = new Array(_len), _key = 0; _key < _len; _key++)units[_key] = arguments[_key];
        if (!this.isValid) return this;
        if (units.length === 0) return this;
        units = units.map(function(u) {
            return Duration.normalizeUnit(u);
        });
        var built = {}, accumulated = {}, vals = this.toObject();
        var lastUnit;
        for(var _i4 = 0, _orderedUnits2 = $c9ee9f81cdf9785c$var$orderedUnits$1; _i4 < _orderedUnits2.length; _i4++){
            var k = _orderedUnits2[_i4];
            if (units.indexOf(k) >= 0) {
                lastUnit = k;
                var own = 0;
                // anything we haven't boiled down yet should get boiled to this unit
                for(var ak in accumulated){
                    own += this.matrix[ak][k] * accumulated[ak];
                    accumulated[ak] = 0;
                }
                // plus anything that's already in this unit
                if ($c9ee9f81cdf9785c$var$isNumber(vals[k])) own += vals[k];
                // only keep the integer part for now in the hopes of putting any decimal part
                // into a smaller unit later
                var i = Math.trunc(own);
                built[k] = i;
                accumulated[k] = (own * 1000 - i * 1000) / 1000;
            // otherwise, keep it in the wings to boil it later
            } else if ($c9ee9f81cdf9785c$var$isNumber(vals[k])) accumulated[k] = vals[k];
        }
        // anything leftover becomes the decimal for the last unit
        // lastUnit must be defined since units is not empty
        for(var key in accumulated)if (accumulated[key] !== 0) built[lastUnit] += key === lastUnit ? accumulated[key] : accumulated[key] / this.matrix[lastUnit][key];
        $c9ee9f81cdf9785c$var$normalizeValues(this.matrix, built);
        return $c9ee9f81cdf9785c$var$clone$1(this, {
            values: built
        }, true);
    };
    _proto.shiftToAll = function shiftToAll() {
        if (!this.isValid) return this;
        return this.shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds");
    };
    _proto.negate = function negate() {
        if (!this.isValid) return this;
        var negated = {};
        for(var _i5 = 0, _Object$keys2 = Object.keys(this.values); _i5 < _Object$keys2.length; _i5++){
            var k = _Object$keys2[_i5];
            negated[k] = this.values[k] === 0 ? 0 : -this.values[k];
        }
        return $c9ee9f81cdf9785c$var$clone$1(this, {
            values: negated
        }, true);
    };
    _proto.removeZeros = function removeZeros() {
        if (!this.isValid) return this;
        var vals = $c9ee9f81cdf9785c$var$removeZeroes(this.values);
        return $c9ee9f81cdf9785c$var$clone$1(this, {
            values: vals
        }, true);
    };
    /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */ _proto.equals = function equals(other) {
        if (!this.isValid || !other.isValid) return false;
        if (!this.loc.equals(other.loc)) return false;
        function eq(v1, v2) {
            // Consider 0 and undefined as equal
            if (v1 === undefined || v1 === 0) return v2 === undefined || v2 === 0;
            return v1 === v2;
        }
        for(var _i6 = 0, _orderedUnits3 = $c9ee9f81cdf9785c$var$orderedUnits$1; _i6 < _orderedUnits3.length; _i6++){
            var u = _orderedUnits3[_i6];
            if (!eq(this.values[u], other.values[u])) return false;
        }
        return true;
    };
    $c9ee9f81cdf9785c$var$_createClass(Duration, [
        {
            key: "locale",
            get: function get() {
                return this.isValid ? this.loc.locale : null;
            }
        },
        {
            key: "numberingSystem",
            get: function get() {
                return this.isValid ? this.loc.numberingSystem : null;
            }
        },
        {
            key: "years",
            get: function get() {
                return this.isValid ? this.values.years || 0 : NaN;
            }
        },
        {
            key: "quarters",
            get: function get() {
                return this.isValid ? this.values.quarters || 0 : NaN;
            }
        },
        {
            key: "months",
            get: function get() {
                return this.isValid ? this.values.months || 0 : NaN;
            }
        },
        {
            key: "weeks",
            get: function get() {
                return this.isValid ? this.values.weeks || 0 : NaN;
            }
        },
        {
            key: "days",
            get: function get() {
                return this.isValid ? this.values.days || 0 : NaN;
            }
        },
        {
            key: "hours",
            get: function get() {
                return this.isValid ? this.values.hours || 0 : NaN;
            }
        },
        {
            key: "minutes",
            get: function get() {
                return this.isValid ? this.values.minutes || 0 : NaN;
            }
        },
        {
            key: "seconds",
            get: function get() {
                return this.isValid ? this.values.seconds || 0 : NaN;
            }
        },
        {
            key: "milliseconds",
            get: function get() {
                return this.isValid ? this.values.milliseconds || 0 : NaN;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return this.invalid === null;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.invalid ? this.invalid.reason : null;
            }
        },
        {
            key: "invalidExplanation",
            get: function get() {
                return this.invalid ? this.invalid.explanation : null;
            }
        }
    ]);
    return Duration;
}(Symbol.for("nodejs.util.inspect.custom"));
var $c9ee9f81cdf9785c$var$INVALID$1 = "Invalid Interval";
// checks if the start is equal to or before the end
function $c9ee9f81cdf9785c$var$validateStartEnd(start, end) {
    if (!start || !start.isValid) return $c9ee9f81cdf9785c$var$Interval.invalid("missing or invalid start");
    else if (!end || !end.isValid) return $c9ee9f81cdf9785c$var$Interval.invalid("missing or invalid end");
    else if (end < start) return $c9ee9f81cdf9785c$var$Interval.invalid("end before start", "The end of an interval must be after its start, but you had start=" + start.toISO() + " and end=" + end.toISO());
    else return null;
}
/**
 * An Interval object represents a half-open interval of time, where each endpoint is a {@link DateTime}. Conceptually, it's a container for those two endpoints, accompanied by methods for creating, parsing, interrogating, comparing, transforming, and formatting them.
 *
 * Here is a brief overview of the most commonly used methods and getters in Interval:
 *
 * * **Creation** To create an Interval, use {@link Interval.fromDateTimes}, {@link Interval.after}, {@link Interval.before}, or {@link Interval.fromISO}.
 * * **Accessors** Use {@link Interval#start} and {@link Interval#end} to get the start and end.
 * * **Interrogation** To analyze the Interval, use {@link Interval#count}, {@link Interval#length}, {@link Interval#hasSame}, {@link Interval#contains}, {@link Interval#isAfter}, or {@link Interval#isBefore}.
 * * **Transformation** To create other Intervals out of this one, use {@link Interval#set}, {@link Interval#splitAt}, {@link Interval#splitBy}, {@link Interval#divideEqually}, {@link Interval.merge}, {@link Interval.xor}, {@link Interval#union}, {@link Interval#intersection}, or {@link Interval#difference}.
 * * **Comparison** To compare this Interval to another one, use {@link Interval#equals}, {@link Interval#overlaps}, {@link Interval#abutsStart}, {@link Interval#abutsEnd}, {@link Interval#engulfs}
 * * **Output** To convert the Interval into other representations, see {@link Interval#toString}, {@link Interval#toLocaleString}, {@link Interval#toISO}, {@link Interval#toISODate}, {@link Interval#toISOTime}, {@link Interval#toFormat}, and {@link Interval#toDuration}.
 */ var $c9ee9f81cdf9785c$var$Interval = /*#__PURE__*/ function(_Symbol$for) {
    /**
   * @private
   */ function Interval(config) {
        /**
     * @access private
     */ this.s = config.start;
        /**
     * @access private
     */ this.e = config.end;
        /**
     * @access private
     */ this.invalid = config.invalid || null;
        /**
     * @access private
     */ this.isLuxonInterval = true;
    }
    /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */ Interval.invalid = function invalid(reason, explanation) {
        if (explanation === void 0) explanation = null;
        if (!reason) throw new $c9ee9f81cdf9785c$var$InvalidArgumentError("need to specify a reason the Interval is invalid");
        var invalid = reason instanceof $c9ee9f81cdf9785c$var$Invalid ? reason : new $c9ee9f81cdf9785c$var$Invalid(reason, explanation);
        if ($c9ee9f81cdf9785c$var$Settings.throwOnInvalid) throw new $c9ee9f81cdf9785c$var$InvalidIntervalError(invalid);
        else return new Interval({
            invalid: invalid
        });
    };
    Interval.fromDateTimes = function fromDateTimes(start, end) {
        var builtStart = $c9ee9f81cdf9785c$var$friendlyDateTime(start), builtEnd = $c9ee9f81cdf9785c$var$friendlyDateTime(end);
        var validateError = $c9ee9f81cdf9785c$var$validateStartEnd(builtStart, builtEnd);
        if (validateError == null) return new Interval({
            start: builtStart,
            end: builtEnd
        });
        else return validateError;
    };
    Interval.after = function after(start, duration) {
        var dur = $c9ee9f81cdf9785c$var$Duration.fromDurationLike(duration), dt = $c9ee9f81cdf9785c$var$friendlyDateTime(start);
        return Interval.fromDateTimes(dt, dt.plus(dur));
    };
    Interval.before = function before(end, duration) {
        var dur = $c9ee9f81cdf9785c$var$Duration.fromDurationLike(duration), dt = $c9ee9f81cdf9785c$var$friendlyDateTime(end);
        return Interval.fromDateTimes(dt.minus(dur), dt);
    };
    Interval.fromISO = function fromISO(text, opts) {
        var _split = (text || "").split("/", 2), s = _split[0], e = _split[1];
        if (s && e) {
            var start, startIsValid;
            try {
                start = $c9ee9f81cdf9785c$var$DateTime.fromISO(s, opts);
                startIsValid = start.isValid;
            } catch (e) {
                startIsValid = false;
            }
            var end, endIsValid;
            try {
                end = $c9ee9f81cdf9785c$var$DateTime.fromISO(e, opts);
                endIsValid = end.isValid;
            } catch (e) {
                endIsValid = false;
            }
            if (startIsValid && endIsValid) return Interval.fromDateTimes(start, end);
            if (startIsValid) {
                var dur = $c9ee9f81cdf9785c$var$Duration.fromISO(e, opts);
                if (dur.isValid) return Interval.after(start, dur);
            } else if (endIsValid) {
                var _dur = $c9ee9f81cdf9785c$var$Duration.fromISO(s, opts);
                if (_dur.isValid) return Interval.before(end, _dur);
            }
        }
        return Interval.invalid("unparsable", "the input \"" + text + "\" can't be parsed as ISO 8601");
    };
    Interval.isInterval = function isInterval(o) {
        return o && o.isLuxonInterval || false;
    };
    var _proto = Interval.prototype;
    /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */ _proto.length = function length(unit) {
        if (unit === void 0) unit = "milliseconds";
        return this.isValid ? this.toDuration.apply(this, [
            unit
        ]).get(unit) : NaN;
    };
    _proto.count = function count(unit, opts) {
        if (unit === void 0) unit = "milliseconds";
        if (!this.isValid) return NaN;
        var start = this.start.startOf(unit, opts);
        var end;
        if (opts != null && opts.useLocaleWeeks) end = this.end.reconfigure({
            locale: start.locale
        });
        else end = this.end;
        end = end.startOf(unit, opts);
        return Math.floor(end.diff(start, unit).get(unit)) + (end.valueOf() !== this.end.valueOf());
    };
    _proto.hasSame = function hasSame(unit) {
        return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, unit) : false;
    };
    _proto.isEmpty = function isEmpty() {
        return this.s.valueOf() === this.e.valueOf();
    };
    _proto.isAfter = function isAfter(dateTime) {
        if (!this.isValid) return false;
        return this.s > dateTime;
    };
    _proto.isBefore = function isBefore(dateTime) {
        if (!this.isValid) return false;
        return this.e <= dateTime;
    };
    _proto.contains = function contains(dateTime) {
        if (!this.isValid) return false;
        return this.s <= dateTime && this.e > dateTime;
    };
    _proto.set = function set(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, start = _ref.start, end = _ref.end;
        if (!this.isValid) return this;
        return Interval.fromDateTimes(start || this.s, end || this.e);
    };
    _proto.splitAt = function splitAt() {
        var _this = this;
        if (!this.isValid) return [];
        for(var _len = arguments.length, dateTimes = new Array(_len), _key = 0; _key < _len; _key++)dateTimes[_key] = arguments[_key];
        var sorted = dateTimes.map($c9ee9f81cdf9785c$var$friendlyDateTime).filter(function(d) {
            return _this.contains(d);
        }).sort(function(a, b) {
            return a.toMillis() - b.toMillis();
        }), results = [];
        var s = this.s, i = 0;
        while(s < this.e){
            var added = sorted[i] || this.e, next = +added > +this.e ? this.e : added;
            results.push(Interval.fromDateTimes(s, next));
            s = next;
            i += 1;
        }
        return results;
    };
    _proto.splitBy = function splitBy(duration) {
        var dur = $c9ee9f81cdf9785c$var$Duration.fromDurationLike(duration);
        if (!this.isValid || !dur.isValid || dur.as("milliseconds") === 0) return [];
        var s = this.s, idx = 1, next;
        var results = [];
        while(s < this.e){
            var added = this.start.plus(dur.mapUnits(function(x) {
                return x * idx;
            }));
            next = +added > +this.e ? this.e : added;
            results.push(Interval.fromDateTimes(s, next));
            s = next;
            idx += 1;
        }
        return results;
    };
    _proto.divideEqually = function divideEqually(numberOfParts) {
        if (!this.isValid) return [];
        return this.splitBy(this.length() / numberOfParts).slice(0, numberOfParts);
    };
    _proto.overlaps = function overlaps(other) {
        return this.e > other.s && this.s < other.e;
    };
    _proto.abutsStart = function abutsStart(other) {
        if (!this.isValid) return false;
        return +this.e === +other.s;
    };
    _proto.abutsEnd = function abutsEnd(other) {
        if (!this.isValid) return false;
        return +other.e === +this.s;
    };
    _proto.engulfs = function engulfs(other) {
        if (!this.isValid) return false;
        return this.s <= other.s && this.e >= other.e;
    };
    _proto.equals = function equals(other) {
        if (!this.isValid || !other.isValid) return false;
        return this.s.equals(other.s) && this.e.equals(other.e);
    };
    _proto.intersection = function intersection(other) {
        if (!this.isValid) return this;
        var s = this.s > other.s ? this.s : other.s, e = this.e < other.e ? this.e : other.e;
        if (s >= e) return null;
        else return Interval.fromDateTimes(s, e);
    };
    _proto.union = function union(other) {
        if (!this.isValid) return this;
        var s = this.s < other.s ? this.s : other.s, e = this.e > other.e ? this.e : other.e;
        return Interval.fromDateTimes(s, e);
    };
    Interval.merge = function merge(intervals) {
        var _intervals$sort$reduc = intervals.sort(function(a, b) {
            return a.s - b.s;
        }).reduce(function(_ref2, item) {
            var sofar = _ref2[0], current = _ref2[1];
            if (!current) return [
                sofar,
                item
            ];
            else if (current.overlaps(item) || current.abutsStart(item)) return [
                sofar,
                current.union(item)
            ];
            else return [
                sofar.concat([
                    current
                ]),
                item
            ];
        }, [
            [],
            null
        ]), found = _intervals$sort$reduc[0], final = _intervals$sort$reduc[1];
        if (final) found.push(final);
        return found;
    };
    Interval.xor = function xor(intervals) {
        var _Array$prototype;
        var start = null, currentCount = 0;
        var results = [], ends = intervals.map(function(i) {
            return [
                {
                    time: i.s,
                    type: "s"
                },
                {
                    time: i.e,
                    type: "e"
                }
            ];
        }), flattened = (_Array$prototype = Array.prototype).concat.apply(_Array$prototype, ends), arr = flattened.sort(function(a, b) {
            return a.time - b.time;
        });
        for(var _iterator = $c9ee9f81cdf9785c$var$_createForOfIteratorHelperLoose(arr), _step; !(_step = _iterator()).done;){
            var i = _step.value;
            currentCount += i.type === "s" ? 1 : -1;
            if (currentCount === 1) start = i.time;
            else {
                if (start && +start !== +i.time) results.push(Interval.fromDateTimes(start, i.time));
                start = null;
            }
        }
        return Interval.merge(results);
    };
    _proto.difference = function difference() {
        var _this2 = this;
        for(var _len2 = arguments.length, intervals = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)intervals[_key2] = arguments[_key2];
        return Interval.xor([
            this
        ].concat(intervals)).map(function(i) {
            return _this2.intersection(i);
        }).filter(function(i) {
            return i && !i.isEmpty();
        });
    };
    _proto.toString = function toString() {
        if (!this.isValid) return $c9ee9f81cdf9785c$var$INVALID$1;
        return "[" + this.s.toISO() + " \u2013 " + this.e.toISO() + ")";
    };
    _proto[_Symbol$for] = function() {
        if (this.isValid) return "Interval { start: " + this.s.toISO() + ", end: " + this.e.toISO() + " }";
        else return "Interval { Invalid, reason: " + this.invalidReason + " }";
    };
    _proto.toLocaleString = function toLocaleString(formatOpts, opts) {
        if (formatOpts === void 0) formatOpts = $c9ee9f81cdf9785c$var$DATE_SHORT;
        if (opts === void 0) opts = {};
        return this.isValid ? $c9ee9f81cdf9785c$var$Formatter.create(this.s.loc.clone(opts), formatOpts).formatInterval(this) : $c9ee9f81cdf9785c$var$INVALID$1;
    };
    _proto.toISO = function toISO(opts) {
        if (!this.isValid) return $c9ee9f81cdf9785c$var$INVALID$1;
        return this.s.toISO(opts) + "/" + this.e.toISO(opts);
    };
    _proto.toISODate = function toISODate() {
        if (!this.isValid) return $c9ee9f81cdf9785c$var$INVALID$1;
        return this.s.toISODate() + "/" + this.e.toISODate();
    };
    _proto.toISOTime = function toISOTime(opts) {
        if (!this.isValid) return $c9ee9f81cdf9785c$var$INVALID$1;
        return this.s.toISOTime(opts) + "/" + this.e.toISOTime(opts);
    };
    _proto.toFormat = function toFormat(dateFormat, _temp2) {
        var _ref3 = _temp2 === void 0 ? {} : _temp2, _ref3$separator = _ref3.separator, separator = _ref3$separator === void 0 ? " \u2013 " : _ref3$separator;
        if (!this.isValid) return $c9ee9f81cdf9785c$var$INVALID$1;
        return "" + this.s.toFormat(dateFormat) + separator + this.e.toFormat(dateFormat);
    };
    _proto.toDuration = function toDuration(unit, opts) {
        if (!this.isValid) return $c9ee9f81cdf9785c$var$Duration.invalid(this.invalidReason);
        return this.e.diff(this.s, unit, opts);
    };
    _proto.mapEndpoints = function mapEndpoints(mapFn) {
        return Interval.fromDateTimes(mapFn(this.s), mapFn(this.e));
    };
    $c9ee9f81cdf9785c$var$_createClass(Interval, [
        {
            key: "start",
            get: function get() {
                return this.isValid ? this.s : null;
            }
        },
        {
            key: "end",
            get: function get() {
                return this.isValid ? this.e : null;
            }
        },
        {
            key: "lastDateTime",
            get: function get() {
                return this.isValid ? this.e ? this.e.minus(1) : null : null;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return this.invalidReason === null;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.invalid ? this.invalid.reason : null;
            }
        },
        {
            key: "invalidExplanation",
            get: function get() {
                return this.invalid ? this.invalid.explanation : null;
            }
        }
    ]);
    return Interval;
}(Symbol.for("nodejs.util.inspect.custom"));
/**
 * The Info class contains static methods for retrieving general time and date related data. For example, it has methods for finding out if a time zone has a DST, for listing the months in any supported locale, and for discovering which of Luxon features are available in the current environment.
 */ var $c9ee9f81cdf9785c$var$Info = /*#__PURE__*/ function() {
    function Info() {}
    /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */ Info.hasDST = function hasDST(zone) {
        if (zone === void 0) zone = $c9ee9f81cdf9785c$var$Settings.defaultZone;
        var proto = $c9ee9f81cdf9785c$var$DateTime.now().setZone(zone).set({
            month: 12
        });
        return !zone.isUniversal && proto.offset !== proto.set({
            month: 6
        }).offset;
    };
    Info.isValidIANAZone = function isValidIANAZone(zone) {
        return $c9ee9f81cdf9785c$var$IANAZone.isValidZone(zone);
    };
    Info.normalizeZone = function normalizeZone$1(input) {
        return $c9ee9f81cdf9785c$var$normalizeZone(input, $c9ee9f81cdf9785c$var$Settings.defaultZone);
    };
    Info.getStartOfWeek = function getStartOfWeek(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, _ref$locale = _ref.locale, locale = _ref$locale === void 0 ? null : _ref$locale, _ref$locObj = _ref.locObj, locObj = _ref$locObj === void 0 ? null : _ref$locObj;
        return (locObj || $c9ee9f81cdf9785c$var$Locale.create(locale)).getStartOfWeek();
    };
    Info.getMinimumDaysInFirstWeek = function getMinimumDaysInFirstWeek(_temp2) {
        var _ref2 = _temp2 === void 0 ? {} : _temp2, _ref2$locale = _ref2.locale, locale = _ref2$locale === void 0 ? null : _ref2$locale, _ref2$locObj = _ref2.locObj, locObj = _ref2$locObj === void 0 ? null : _ref2$locObj;
        return (locObj || $c9ee9f81cdf9785c$var$Locale.create(locale)).getMinDaysInFirstWeek();
    };
    Info.getWeekendWeekdays = function getWeekendWeekdays(_temp3) {
        var _ref3 = _temp3 === void 0 ? {} : _temp3, _ref3$locale = _ref3.locale, locale = _ref3$locale === void 0 ? null : _ref3$locale, _ref3$locObj = _ref3.locObj, locObj = _ref3$locObj === void 0 ? null : _ref3$locObj;
        // copy the array, because we cache it internally
        return (locObj || $c9ee9f81cdf9785c$var$Locale.create(locale)).getWeekendDays().slice();
    };
    Info.months = function months(length, _temp4) {
        if (length === void 0) length = "long";
        var _ref4 = _temp4 === void 0 ? {} : _temp4, _ref4$locale = _ref4.locale, locale = _ref4$locale === void 0 ? null : _ref4$locale, _ref4$numberingSystem = _ref4.numberingSystem, numberingSystem = _ref4$numberingSystem === void 0 ? null : _ref4$numberingSystem, _ref4$locObj = _ref4.locObj, locObj = _ref4$locObj === void 0 ? null : _ref4$locObj, _ref4$outputCalendar = _ref4.outputCalendar, outputCalendar = _ref4$outputCalendar === void 0 ? "gregory" : _ref4$outputCalendar;
        return (locObj || $c9ee9f81cdf9785c$var$Locale.create(locale, numberingSystem, outputCalendar)).months(length);
    };
    Info.monthsFormat = function monthsFormat(length, _temp5) {
        if (length === void 0) length = "long";
        var _ref5 = _temp5 === void 0 ? {} : _temp5, _ref5$locale = _ref5.locale, locale = _ref5$locale === void 0 ? null : _ref5$locale, _ref5$numberingSystem = _ref5.numberingSystem, numberingSystem = _ref5$numberingSystem === void 0 ? null : _ref5$numberingSystem, _ref5$locObj = _ref5.locObj, locObj = _ref5$locObj === void 0 ? null : _ref5$locObj, _ref5$outputCalendar = _ref5.outputCalendar, outputCalendar = _ref5$outputCalendar === void 0 ? "gregory" : _ref5$outputCalendar;
        return (locObj || $c9ee9f81cdf9785c$var$Locale.create(locale, numberingSystem, outputCalendar)).months(length, true);
    };
    Info.weekdays = function weekdays(length, _temp6) {
        if (length === void 0) length = "long";
        var _ref6 = _temp6 === void 0 ? {} : _temp6, _ref6$locale = _ref6.locale, locale = _ref6$locale === void 0 ? null : _ref6$locale, _ref6$numberingSystem = _ref6.numberingSystem, numberingSystem = _ref6$numberingSystem === void 0 ? null : _ref6$numberingSystem, _ref6$locObj = _ref6.locObj, locObj = _ref6$locObj === void 0 ? null : _ref6$locObj;
        return (locObj || $c9ee9f81cdf9785c$var$Locale.create(locale, numberingSystem, null)).weekdays(length);
    };
    Info.weekdaysFormat = function weekdaysFormat(length, _temp7) {
        if (length === void 0) length = "long";
        var _ref7 = _temp7 === void 0 ? {} : _temp7, _ref7$locale = _ref7.locale, locale = _ref7$locale === void 0 ? null : _ref7$locale, _ref7$numberingSystem = _ref7.numberingSystem, numberingSystem = _ref7$numberingSystem === void 0 ? null : _ref7$numberingSystem, _ref7$locObj = _ref7.locObj, locObj = _ref7$locObj === void 0 ? null : _ref7$locObj;
        return (locObj || $c9ee9f81cdf9785c$var$Locale.create(locale, numberingSystem, null)).weekdays(length, true);
    };
    Info.meridiems = function meridiems(_temp8) {
        var _ref8 = _temp8 === void 0 ? {} : _temp8, _ref8$locale = _ref8.locale, locale = _ref8$locale === void 0 ? null : _ref8$locale;
        return $c9ee9f81cdf9785c$var$Locale.create(locale).meridiems();
    };
    Info.eras = function eras(length, _temp9) {
        if (length === void 0) length = "short";
        var _ref9 = _temp9 === void 0 ? {} : _temp9, _ref9$locale = _ref9.locale, locale = _ref9$locale === void 0 ? null : _ref9$locale;
        return $c9ee9f81cdf9785c$var$Locale.create(locale, null, "gregory").eras(length);
    };
    Info.features = function features() {
        return {
            relative: $c9ee9f81cdf9785c$var$hasRelative(),
            localeWeek: $c9ee9f81cdf9785c$var$hasLocaleWeekInfo()
        };
    };
    return Info;
}();
function $c9ee9f81cdf9785c$var$dayDiff(earlier, later) {
    var utcDayStart = function utcDayStart(dt) {
        return dt.toUTC(0, {
            keepLocalTime: true
        }).startOf("day").valueOf();
    }, ms = utcDayStart(later) - utcDayStart(earlier);
    return Math.floor($c9ee9f81cdf9785c$var$Duration.fromMillis(ms).as("days"));
}
function $c9ee9f81cdf9785c$var$highOrderDiffs(cursor, later, units) {
    var differs = [
        [
            "years",
            function(a, b) {
                return b.year - a.year;
            }
        ],
        [
            "quarters",
            function(a, b) {
                return b.quarter - a.quarter + (b.year - a.year) * 4;
            }
        ],
        [
            "months",
            function(a, b) {
                return b.month - a.month + (b.year - a.year) * 12;
            }
        ],
        [
            "weeks",
            function(a, b) {
                var days = $c9ee9f81cdf9785c$var$dayDiff(a, b);
                return (days - days % 7) / 7;
            }
        ],
        [
            "days",
            $c9ee9f81cdf9785c$var$dayDiff
        ]
    ];
    var results = {};
    var earlier = cursor;
    var lowestOrder, highWater;
    /* This loop tries to diff using larger units first.
     If we overshoot, we backtrack and try the next smaller unit.
     "cursor" starts out at the earlier timestamp and moves closer and closer to "later"
     as we use smaller and smaller units.
     highWater keeps track of where we would be if we added one more of the smallest unit,
     this is used later to potentially convert any difference smaller than the smallest higher order unit
     into a fraction of that smallest higher order unit
  */ for(var _i = 0, _differs = differs; _i < _differs.length; _i++){
        var _differs$_i = _differs[_i], unit = _differs$_i[0], differ = _differs$_i[1];
        if (units.indexOf(unit) >= 0) {
            lowestOrder = unit;
            results[unit] = differ(cursor, later);
            highWater = earlier.plus(results);
            if (highWater > later) {
                // we overshot the end point, backtrack cursor by 1
                results[unit]--;
                cursor = earlier.plus(results);
                // if we are still overshooting now, we need to backtrack again
                // this happens in certain situations when diffing times in different zones,
                // because this calculation ignores time zones
                if (cursor > later) {
                    // keep the "overshot by 1" around as highWater
                    highWater = cursor;
                    // backtrack cursor by 1
                    results[unit]--;
                    cursor = earlier.plus(results);
                }
            } else cursor = highWater;
        }
    }
    return [
        cursor,
        results,
        highWater,
        lowestOrder
    ];
}
function $c9ee9f81cdf9785c$var$_diff(earlier, later, units, opts) {
    var _highOrderDiffs = $c9ee9f81cdf9785c$var$highOrderDiffs(earlier, later, units), cursor = _highOrderDiffs[0], results = _highOrderDiffs[1], highWater = _highOrderDiffs[2], lowestOrder = _highOrderDiffs[3];
    var remainingMillis = later - cursor;
    var lowerOrderUnits = units.filter(function(u) {
        return [
            "hours",
            "minutes",
            "seconds",
            "milliseconds"
        ].indexOf(u) >= 0;
    });
    if (lowerOrderUnits.length === 0) {
        if (highWater < later) {
            var _cursor$plus;
            highWater = cursor.plus((_cursor$plus = {}, _cursor$plus[lowestOrder] = 1, _cursor$plus));
        }
        if (highWater !== cursor) results[lowestOrder] = (results[lowestOrder] || 0) + remainingMillis / (highWater - cursor);
    }
    var duration = $c9ee9f81cdf9785c$var$Duration.fromObject(results, opts);
    if (lowerOrderUnits.length > 0) {
        var _Duration$fromMillis;
        return (_Duration$fromMillis = $c9ee9f81cdf9785c$var$Duration.fromMillis(remainingMillis, opts)).shiftTo.apply(_Duration$fromMillis, lowerOrderUnits).plus(duration);
    } else return duration;
}
var $c9ee9f81cdf9785c$var$MISSING_FTP = "missing Intl.DateTimeFormat.formatToParts support";
function $c9ee9f81cdf9785c$var$intUnit(regex, post) {
    if (post === void 0) post = function post(i) {
        return i;
    };
    return {
        regex: regex,
        deser: function deser(_ref) {
            var s = _ref[0];
            return post($c9ee9f81cdf9785c$var$parseDigits(s));
        }
    };
}
var $c9ee9f81cdf9785c$var$NBSP = String.fromCharCode(160);
var $c9ee9f81cdf9785c$var$spaceOrNBSP = "[ " + $c9ee9f81cdf9785c$var$NBSP + "]";
var $c9ee9f81cdf9785c$var$spaceOrNBSPRegExp = new RegExp($c9ee9f81cdf9785c$var$spaceOrNBSP, "g");
function $c9ee9f81cdf9785c$var$fixListRegex(s) {
    // make dots optional and also make them literal
    // make space and non breakable space characters interchangeable
    return s.replace(/\./g, "\\.?").replace($c9ee9f81cdf9785c$var$spaceOrNBSPRegExp, $c9ee9f81cdf9785c$var$spaceOrNBSP);
}
function $c9ee9f81cdf9785c$var$stripInsensitivities(s) {
    return s.replace(/\./g, "") // ignore dots that were made optional
    .replace($c9ee9f81cdf9785c$var$spaceOrNBSPRegExp, " ") // interchange space and nbsp
    .toLowerCase();
}
function $c9ee9f81cdf9785c$var$oneOf(strings, startIndex) {
    if (strings === null) return null;
    else return {
        regex: RegExp(strings.map($c9ee9f81cdf9785c$var$fixListRegex).join("|")),
        deser: function deser(_ref2) {
            var s = _ref2[0];
            return strings.findIndex(function(i) {
                return $c9ee9f81cdf9785c$var$stripInsensitivities(s) === $c9ee9f81cdf9785c$var$stripInsensitivities(i);
            }) + startIndex;
        }
    };
}
function $c9ee9f81cdf9785c$var$offset(regex, groups) {
    return {
        regex: regex,
        deser: function deser(_ref3) {
            var h = _ref3[1], m = _ref3[2];
            return $c9ee9f81cdf9785c$var$signedOffset(h, m);
        },
        groups: groups
    };
}
function $c9ee9f81cdf9785c$var$simple(regex) {
    return {
        regex: regex,
        deser: function deser(_ref4) {
            var s = _ref4[0];
            return s;
        }
    };
}
function $c9ee9f81cdf9785c$var$escapeToken(value) {
    return value.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
/**
 * @param token
 * @param {Locale} loc
 */ function $c9ee9f81cdf9785c$var$unitForToken(token, loc) {
    var one = $c9ee9f81cdf9785c$var$digitRegex(loc), two = $c9ee9f81cdf9785c$var$digitRegex(loc, "{2}"), three = $c9ee9f81cdf9785c$var$digitRegex(loc, "{3}"), four = $c9ee9f81cdf9785c$var$digitRegex(loc, "{4}"), six = $c9ee9f81cdf9785c$var$digitRegex(loc, "{6}"), oneOrTwo = $c9ee9f81cdf9785c$var$digitRegex(loc, "{1,2}"), oneToThree = $c9ee9f81cdf9785c$var$digitRegex(loc, "{1,3}"), oneToSix = $c9ee9f81cdf9785c$var$digitRegex(loc, "{1,6}"), oneToNine = $c9ee9f81cdf9785c$var$digitRegex(loc, "{1,9}"), twoToFour = $c9ee9f81cdf9785c$var$digitRegex(loc, "{2,4}"), fourToSix = $c9ee9f81cdf9785c$var$digitRegex(loc, "{4,6}"), literal = function literal(t) {
        return {
            regex: RegExp($c9ee9f81cdf9785c$var$escapeToken(t.val)),
            deser: function deser(_ref5) {
                var s = _ref5[0];
                return s;
            },
            literal: true
        };
    }, unitate = function unitate(t) {
        if (token.literal) return literal(t);
        switch(t.val){
            // era
            case "G":
                return $c9ee9f81cdf9785c$var$oneOf(loc.eras("short"), 0);
            case "GG":
                return $c9ee9f81cdf9785c$var$oneOf(loc.eras("long"), 0);
            // years
            case "y":
                return $c9ee9f81cdf9785c$var$intUnit(oneToSix);
            case "yy":
                return $c9ee9f81cdf9785c$var$intUnit(twoToFour, $c9ee9f81cdf9785c$var$untruncateYear);
            case "yyyy":
                return $c9ee9f81cdf9785c$var$intUnit(four);
            case "yyyyy":
                return $c9ee9f81cdf9785c$var$intUnit(fourToSix);
            case "yyyyyy":
                return $c9ee9f81cdf9785c$var$intUnit(six);
            // months
            case "M":
                return $c9ee9f81cdf9785c$var$intUnit(oneOrTwo);
            case "MM":
                return $c9ee9f81cdf9785c$var$intUnit(two);
            case "MMM":
                return $c9ee9f81cdf9785c$var$oneOf(loc.months("short", true), 1);
            case "MMMM":
                return $c9ee9f81cdf9785c$var$oneOf(loc.months("long", true), 1);
            case "L":
                return $c9ee9f81cdf9785c$var$intUnit(oneOrTwo);
            case "LL":
                return $c9ee9f81cdf9785c$var$intUnit(two);
            case "LLL":
                return $c9ee9f81cdf9785c$var$oneOf(loc.months("short", false), 1);
            case "LLLL":
                return $c9ee9f81cdf9785c$var$oneOf(loc.months("long", false), 1);
            // dates
            case "d":
                return $c9ee9f81cdf9785c$var$intUnit(oneOrTwo);
            case "dd":
                return $c9ee9f81cdf9785c$var$intUnit(two);
            // ordinals
            case "o":
                return $c9ee9f81cdf9785c$var$intUnit(oneToThree);
            case "ooo":
                return $c9ee9f81cdf9785c$var$intUnit(three);
            // time
            case "HH":
                return $c9ee9f81cdf9785c$var$intUnit(two);
            case "H":
                return $c9ee9f81cdf9785c$var$intUnit(oneOrTwo);
            case "hh":
                return $c9ee9f81cdf9785c$var$intUnit(two);
            case "h":
                return $c9ee9f81cdf9785c$var$intUnit(oneOrTwo);
            case "mm":
                return $c9ee9f81cdf9785c$var$intUnit(two);
            case "m":
                return $c9ee9f81cdf9785c$var$intUnit(oneOrTwo);
            case "q":
                return $c9ee9f81cdf9785c$var$intUnit(oneOrTwo);
            case "qq":
                return $c9ee9f81cdf9785c$var$intUnit(two);
            case "s":
                return $c9ee9f81cdf9785c$var$intUnit(oneOrTwo);
            case "ss":
                return $c9ee9f81cdf9785c$var$intUnit(two);
            case "S":
                return $c9ee9f81cdf9785c$var$intUnit(oneToThree);
            case "SSS":
                return $c9ee9f81cdf9785c$var$intUnit(three);
            case "u":
                return $c9ee9f81cdf9785c$var$simple(oneToNine);
            case "uu":
                return $c9ee9f81cdf9785c$var$simple(oneOrTwo);
            case "uuu":
                return $c9ee9f81cdf9785c$var$intUnit(one);
            // meridiem
            case "a":
                return $c9ee9f81cdf9785c$var$oneOf(loc.meridiems(), 0);
            // weekYear (k)
            case "kkkk":
                return $c9ee9f81cdf9785c$var$intUnit(four);
            case "kk":
                return $c9ee9f81cdf9785c$var$intUnit(twoToFour, $c9ee9f81cdf9785c$var$untruncateYear);
            // weekNumber (W)
            case "W":
                return $c9ee9f81cdf9785c$var$intUnit(oneOrTwo);
            case "WW":
                return $c9ee9f81cdf9785c$var$intUnit(two);
            // weekdays
            case "E":
            case "c":
                return $c9ee9f81cdf9785c$var$intUnit(one);
            case "EEE":
                return $c9ee9f81cdf9785c$var$oneOf(loc.weekdays("short", false), 1);
            case "EEEE":
                return $c9ee9f81cdf9785c$var$oneOf(loc.weekdays("long", false), 1);
            case "ccc":
                return $c9ee9f81cdf9785c$var$oneOf(loc.weekdays("short", true), 1);
            case "cccc":
                return $c9ee9f81cdf9785c$var$oneOf(loc.weekdays("long", true), 1);
            // offset/zone
            case "Z":
            case "ZZ":
                return $c9ee9f81cdf9785c$var$offset(new RegExp("([+-]" + oneOrTwo.source + ")(?::(" + two.source + "))?"), 2);
            case "ZZZ":
                return $c9ee9f81cdf9785c$var$offset(new RegExp("([+-]" + oneOrTwo.source + ")(" + two.source + ")?"), 2);
            // we don't support ZZZZ (PST) or ZZZZZ (Pacific Standard Time) in parsing
            // because we don't have any way to figure out what they are
            case "z":
                return $c9ee9f81cdf9785c$var$simple(/[a-z_+-/]{1,256}?/i);
            // this special-case "token" represents a place where a macro-token expanded into a white-space literal
            // in this case we accept any non-newline white-space
            case " ":
                return $c9ee9f81cdf9785c$var$simple(/[^\S\n\r]/);
            default:
                return literal(t);
        }
    };
    var unit = unitate(token) || {
        invalidReason: $c9ee9f81cdf9785c$var$MISSING_FTP
    };
    unit.token = token;
    return unit;
}
var $c9ee9f81cdf9785c$var$partTypeStyleToTokenVal = {
    year: {
        "2-digit": "yy",
        numeric: "yyyyy"
    },
    month: {
        numeric: "M",
        "2-digit": "MM",
        short: "MMM",
        long: "MMMM"
    },
    day: {
        numeric: "d",
        "2-digit": "dd"
    },
    weekday: {
        short: "EEE",
        long: "EEEE"
    },
    dayperiod: "a",
    dayPeriod: "a",
    hour12: {
        numeric: "h",
        "2-digit": "hh"
    },
    hour24: {
        numeric: "H",
        "2-digit": "HH"
    },
    minute: {
        numeric: "m",
        "2-digit": "mm"
    },
    second: {
        numeric: "s",
        "2-digit": "ss"
    },
    timeZoneName: {
        long: "ZZZZZ",
        short: "ZZZ"
    }
};
function $c9ee9f81cdf9785c$var$tokenForPart(part, formatOpts, resolvedOpts) {
    var type = part.type, value = part.value;
    if (type === "literal") {
        var isSpace = /^\s+$/.test(value);
        return {
            literal: !isSpace,
            val: isSpace ? " " : value
        };
    }
    var style = formatOpts[type];
    // The user might have explicitly specified hour12 or hourCycle
    // if so, respect their decision
    // if not, refer back to the resolvedOpts, which are based on the locale
    var actualType = type;
    if (type === "hour") {
        if (formatOpts.hour12 != null) actualType = formatOpts.hour12 ? "hour12" : "hour24";
        else if (formatOpts.hourCycle != null) {
            if (formatOpts.hourCycle === "h11" || formatOpts.hourCycle === "h12") actualType = "hour12";
            else actualType = "hour24";
        } else // tokens only differentiate between 24 hours or not,
        // so we do not need to check hourCycle here, which is less supported anyways
        actualType = resolvedOpts.hour12 ? "hour12" : "hour24";
    }
    var val = $c9ee9f81cdf9785c$var$partTypeStyleToTokenVal[actualType];
    if (typeof val === "object") val = val[style];
    if (val) return {
        literal: false,
        val: val
    };
    return undefined;
}
function $c9ee9f81cdf9785c$var$buildRegex(units) {
    var re = units.map(function(u) {
        return u.regex;
    }).reduce(function(f, r) {
        return f + "(" + r.source + ")";
    }, "");
    return [
        "^" + re + "$",
        units
    ];
}
function $c9ee9f81cdf9785c$var$match(input, regex, handlers) {
    var matches = input.match(regex);
    if (matches) {
        var all = {};
        var matchIndex = 1;
        for(var i in handlers)if ($c9ee9f81cdf9785c$var$hasOwnProperty(handlers, i)) {
            var h = handlers[i], groups = h.groups ? h.groups + 1 : 1;
            if (!h.literal && h.token) all[h.token.val[0]] = h.deser(matches.slice(matchIndex, matchIndex + groups));
            matchIndex += groups;
        }
        return [
            matches,
            all
        ];
    } else return [
        matches,
        {}
    ];
}
function $c9ee9f81cdf9785c$var$dateTimeFromMatches(matches) {
    var toField = function toField(token) {
        switch(token){
            case "S":
                return "millisecond";
            case "s":
                return "second";
            case "m":
                return "minute";
            case "h":
            case "H":
                return "hour";
            case "d":
                return "day";
            case "o":
                return "ordinal";
            case "L":
            case "M":
                return "month";
            case "y":
                return "year";
            case "E":
            case "c":
                return "weekday";
            case "W":
                return "weekNumber";
            case "k":
                return "weekYear";
            case "q":
                return "quarter";
            default:
                return null;
        }
    };
    var zone = null;
    var specificOffset;
    if (!$c9ee9f81cdf9785c$var$isUndefined(matches.z)) zone = $c9ee9f81cdf9785c$var$IANAZone.create(matches.z);
    if (!$c9ee9f81cdf9785c$var$isUndefined(matches.Z)) {
        if (!zone) zone = new $c9ee9f81cdf9785c$var$FixedOffsetZone(matches.Z);
        specificOffset = matches.Z;
    }
    if (!$c9ee9f81cdf9785c$var$isUndefined(matches.q)) matches.M = (matches.q - 1) * 3 + 1;
    if (!$c9ee9f81cdf9785c$var$isUndefined(matches.h)) {
        if (matches.h < 12 && matches.a === 1) matches.h += 12;
        else if (matches.h === 12 && matches.a === 0) matches.h = 0;
    }
    if (matches.G === 0 && matches.y) matches.y = -matches.y;
    if (!$c9ee9f81cdf9785c$var$isUndefined(matches.u)) matches.S = $c9ee9f81cdf9785c$var$parseMillis(matches.u);
    var vals = Object.keys(matches).reduce(function(r, k) {
        var f = toField(k);
        if (f) r[f] = matches[k];
        return r;
    }, {});
    return [
        vals,
        zone,
        specificOffset
    ];
}
var $c9ee9f81cdf9785c$var$dummyDateTimeCache = null;
function $c9ee9f81cdf9785c$var$getDummyDateTime() {
    if (!$c9ee9f81cdf9785c$var$dummyDateTimeCache) $c9ee9f81cdf9785c$var$dummyDateTimeCache = $c9ee9f81cdf9785c$var$DateTime.fromMillis(1555555555555);
    return $c9ee9f81cdf9785c$var$dummyDateTimeCache;
}
function $c9ee9f81cdf9785c$var$maybeExpandMacroToken(token, locale) {
    if (token.literal) return token;
    var formatOpts = $c9ee9f81cdf9785c$var$Formatter.macroTokenToFormatOpts(token.val);
    var tokens = $c9ee9f81cdf9785c$var$formatOptsToTokens(formatOpts, locale);
    if (tokens == null || tokens.includes(undefined)) return token;
    return tokens;
}
function $c9ee9f81cdf9785c$var$expandMacroTokens(tokens, locale) {
    var _Array$prototype;
    return (_Array$prototype = Array.prototype).concat.apply(_Array$prototype, tokens.map(function(t) {
        return $c9ee9f81cdf9785c$var$maybeExpandMacroToken(t, locale);
    }));
}
/**
 * @private
 */ var $c9ee9f81cdf9785c$var$TokenParser = /*#__PURE__*/ function() {
    function TokenParser(locale, format) {
        this.locale = locale;
        this.format = format;
        this.tokens = $c9ee9f81cdf9785c$var$expandMacroTokens($c9ee9f81cdf9785c$var$Formatter.parseFormat(format), locale);
        this.units = this.tokens.map(function(t) {
            return $c9ee9f81cdf9785c$var$unitForToken(t, locale);
        });
        this.disqualifyingUnit = this.units.find(function(t) {
            return t.invalidReason;
        });
        if (!this.disqualifyingUnit) {
            var _buildRegex = $c9ee9f81cdf9785c$var$buildRegex(this.units), regexString = _buildRegex[0], handlers = _buildRegex[1];
            this.regex = RegExp(regexString, "i");
            this.handlers = handlers;
        }
    }
    var _proto = TokenParser.prototype;
    _proto.explainFromTokens = function explainFromTokens(input) {
        if (!this.isValid) return {
            input: input,
            tokens: this.tokens,
            invalidReason: this.invalidReason
        };
        else {
            var _match = $c9ee9f81cdf9785c$var$match(input, this.regex, this.handlers), rawMatches = _match[0], matches = _match[1], _ref6 = matches ? $c9ee9f81cdf9785c$var$dateTimeFromMatches(matches) : [
                null,
                null,
                undefined
            ], result = _ref6[0], zone = _ref6[1], specificOffset = _ref6[2];
            if ($c9ee9f81cdf9785c$var$hasOwnProperty(matches, "a") && $c9ee9f81cdf9785c$var$hasOwnProperty(matches, "H")) throw new $c9ee9f81cdf9785c$var$ConflictingSpecificationError("Can't include meridiem when specifying 24-hour format");
            return {
                input: input,
                tokens: this.tokens,
                regex: this.regex,
                rawMatches: rawMatches,
                matches: matches,
                result: result,
                zone: zone,
                specificOffset: specificOffset
            };
        }
    };
    $c9ee9f81cdf9785c$var$_createClass(TokenParser, [
        {
            key: "isValid",
            get: function get() {
                return !this.disqualifyingUnit;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.disqualifyingUnit ? this.disqualifyingUnit.invalidReason : null;
            }
        }
    ]);
    return TokenParser;
}();
function $c9ee9f81cdf9785c$var$explainFromTokens(locale, input, format) {
    var parser = new $c9ee9f81cdf9785c$var$TokenParser(locale, format);
    return parser.explainFromTokens(input);
}
function $c9ee9f81cdf9785c$var$parseFromTokens(locale, input, format) {
    var _explainFromTokens = $c9ee9f81cdf9785c$var$explainFromTokens(locale, input, format), result = _explainFromTokens.result, zone = _explainFromTokens.zone, specificOffset = _explainFromTokens.specificOffset, invalidReason = _explainFromTokens.invalidReason;
    return [
        result,
        zone,
        specificOffset,
        invalidReason
    ];
}
function $c9ee9f81cdf9785c$var$formatOptsToTokens(formatOpts, locale) {
    if (!formatOpts) return null;
    var formatter = $c9ee9f81cdf9785c$var$Formatter.create(locale, formatOpts);
    var df = formatter.dtFormatter($c9ee9f81cdf9785c$var$getDummyDateTime());
    var parts = df.formatToParts();
    var resolvedOpts = df.resolvedOptions();
    return parts.map(function(p) {
        return $c9ee9f81cdf9785c$var$tokenForPart(p, formatOpts, resolvedOpts);
    });
}
var $c9ee9f81cdf9785c$var$INVALID = "Invalid DateTime";
var $c9ee9f81cdf9785c$var$MAX_DATE = 8.64e15;
function $c9ee9f81cdf9785c$var$unsupportedZone(zone) {
    return new $c9ee9f81cdf9785c$var$Invalid("unsupported zone", "the zone \"" + zone.name + "\" is not supported");
}
// we cache week data on the DT object and this intermediates the cache
/**
 * @param {DateTime} dt
 */ function $c9ee9f81cdf9785c$var$possiblyCachedWeekData(dt) {
    if (dt.weekData === null) dt.weekData = $c9ee9f81cdf9785c$var$gregorianToWeek(dt.c);
    return dt.weekData;
}
/**
 * @param {DateTime} dt
 */ function $c9ee9f81cdf9785c$var$possiblyCachedLocalWeekData(dt) {
    if (dt.localWeekData === null) dt.localWeekData = $c9ee9f81cdf9785c$var$gregorianToWeek(dt.c, dt.loc.getMinDaysInFirstWeek(), dt.loc.getStartOfWeek());
    return dt.localWeekData;
}
// clone really means, "make a new object with these modifications". all "setters" really use this
// to create a new object while only changing some of the properties
function $c9ee9f81cdf9785c$var$clone(inst, alts) {
    var current = {
        ts: inst.ts,
        zone: inst.zone,
        c: inst.c,
        o: inst.o,
        loc: inst.loc,
        invalid: inst.invalid
    };
    return new $c9ee9f81cdf9785c$var$DateTime($c9ee9f81cdf9785c$var$_extends({}, current, alts, {
        old: current
    }));
}
// find the right offset a given local time. The o input is our guess, which determines which
// offset we'll pick in ambiguous cases (e.g. there are two 3 AMs b/c Fallback DST)
function $c9ee9f81cdf9785c$var$fixOffset(localTS, o, tz) {
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - o * 60000;
    // Test whether the zone matches the offset for this ts
    var o2 = tz.offset(utcGuess);
    // If so, offset didn't change and we're done
    if (o === o2) return [
        utcGuess,
        o
    ];
    // If not, change the ts by the difference in the offset
    utcGuess -= (o2 - o) * 60000;
    // If that gives us the local time we want, we're done
    var o3 = tz.offset(utcGuess);
    if (o2 === o3) return [
        utcGuess,
        o2
    ];
    // If it's different, we're in a hole time. The offset has changed, but the we don't adjust the time
    return [
        localTS - Math.min(o2, o3) * 60000,
        Math.max(o2, o3)
    ];
}
// convert an epoch timestamp into a calendar object with the given offset
function $c9ee9f81cdf9785c$var$tsToObj(ts, offset) {
    ts += offset * 60000;
    var d = new Date(ts);
    return {
        year: d.getUTCFullYear(),
        month: d.getUTCMonth() + 1,
        day: d.getUTCDate(),
        hour: d.getUTCHours(),
        minute: d.getUTCMinutes(),
        second: d.getUTCSeconds(),
        millisecond: d.getUTCMilliseconds()
    };
}
// convert a calendar object to a epoch timestamp
function $c9ee9f81cdf9785c$var$objToTS(obj, offset, zone) {
    return $c9ee9f81cdf9785c$var$fixOffset($c9ee9f81cdf9785c$var$objToLocalTS(obj), offset, zone);
}
// create a new DT instance by adding a duration, adjusting for DSTs
function $c9ee9f81cdf9785c$var$adjustTime(inst, dur) {
    var oPre = inst.o, year = inst.c.year + Math.trunc(dur.years), month = inst.c.month + Math.trunc(dur.months) + Math.trunc(dur.quarters) * 3, c = $c9ee9f81cdf9785c$var$_extends({}, inst.c, {
        year: year,
        month: month,
        day: Math.min(inst.c.day, $c9ee9f81cdf9785c$var$daysInMonth(year, month)) + Math.trunc(dur.days) + Math.trunc(dur.weeks) * 7
    }), millisToAdd = $c9ee9f81cdf9785c$var$Duration.fromObject({
        years: dur.years - Math.trunc(dur.years),
        quarters: dur.quarters - Math.trunc(dur.quarters),
        months: dur.months - Math.trunc(dur.months),
        weeks: dur.weeks - Math.trunc(dur.weeks),
        days: dur.days - Math.trunc(dur.days),
        hours: dur.hours,
        minutes: dur.minutes,
        seconds: dur.seconds,
        milliseconds: dur.milliseconds
    }).as("milliseconds"), localTS = $c9ee9f81cdf9785c$var$objToLocalTS(c);
    var _fixOffset = $c9ee9f81cdf9785c$var$fixOffset(localTS, oPre, inst.zone), ts = _fixOffset[0], o = _fixOffset[1];
    if (millisToAdd !== 0) {
        ts += millisToAdd;
        // that could have changed the offset by going over a DST, but we want to keep the ts the same
        o = inst.zone.offset(ts);
    }
    return {
        ts: ts,
        o: o
    };
}
// helper useful in turning the results of parsing into real dates
// by handling the zone options
function $c9ee9f81cdf9785c$var$parseDataToDateTime(parsed, parsedZone, opts, format, text, specificOffset) {
    var setZone = opts.setZone, zone = opts.zone;
    if (parsed && Object.keys(parsed).length !== 0 || parsedZone) {
        var interpretationZone = parsedZone || zone, inst = $c9ee9f81cdf9785c$var$DateTime.fromObject(parsed, $c9ee9f81cdf9785c$var$_extends({}, opts, {
            zone: interpretationZone,
            specificOffset: specificOffset
        }));
        return setZone ? inst : inst.setZone(zone);
    } else return $c9ee9f81cdf9785c$var$DateTime.invalid(new $c9ee9f81cdf9785c$var$Invalid("unparsable", "the input \"" + text + "\" can't be parsed as " + format));
}
// if you want to output a technical format (e.g. RFC 2822), this helper
// helps handle the details
function $c9ee9f81cdf9785c$var$toTechFormat(dt, format, allowZ) {
    if (allowZ === void 0) allowZ = true;
    return dt.isValid ? $c9ee9f81cdf9785c$var$Formatter.create($c9ee9f81cdf9785c$var$Locale.create("en-US"), {
        allowZ: allowZ,
        forceSimple: true
    }).formatDateTimeFromString(dt, format) : null;
}
function $c9ee9f81cdf9785c$var$_toISODate(o, extended, precision) {
    var longFormat = o.c.year > 9999 || o.c.year < 0;
    var c = "";
    if (longFormat && o.c.year >= 0) c += "+";
    c += $c9ee9f81cdf9785c$var$padStart(o.c.year, longFormat ? 6 : 4);
    if (precision === "year") return c;
    if (extended) {
        c += "-";
        c += $c9ee9f81cdf9785c$var$padStart(o.c.month);
        if (precision === "month") return c;
        c += "-";
    } else {
        c += $c9ee9f81cdf9785c$var$padStart(o.c.month);
        if (precision === "month") return c;
    }
    c += $c9ee9f81cdf9785c$var$padStart(o.c.day);
    return c;
}
function $c9ee9f81cdf9785c$var$_toISOTime(o, extended, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone, precision) {
    var showSeconds = !suppressSeconds || o.c.millisecond !== 0 || o.c.second !== 0, c = "";
    switch(precision){
        case "day":
        case "month":
        case "year":
            break;
        default:
            c += $c9ee9f81cdf9785c$var$padStart(o.c.hour);
            if (precision === "hour") break;
            if (extended) {
                c += ":";
                c += $c9ee9f81cdf9785c$var$padStart(o.c.minute);
                if (precision === "minute") break;
                if (showSeconds) {
                    c += ":";
                    c += $c9ee9f81cdf9785c$var$padStart(o.c.second);
                }
            } else {
                c += $c9ee9f81cdf9785c$var$padStart(o.c.minute);
                if (precision === "minute") break;
                if (showSeconds) c += $c9ee9f81cdf9785c$var$padStart(o.c.second);
            }
            if (precision === "second") break;
            if (showSeconds && (!suppressMilliseconds || o.c.millisecond !== 0)) {
                c += ".";
                c += $c9ee9f81cdf9785c$var$padStart(o.c.millisecond, 3);
            }
    }
    if (includeOffset) {
        if (o.isOffsetFixed && o.offset === 0 && !extendedZone) c += "Z";
        else if (o.o < 0) {
            c += "-";
            c += $c9ee9f81cdf9785c$var$padStart(Math.trunc(-o.o / 60));
            c += ":";
            c += $c9ee9f81cdf9785c$var$padStart(Math.trunc(-o.o % 60));
        } else {
            c += "+";
            c += $c9ee9f81cdf9785c$var$padStart(Math.trunc(o.o / 60));
            c += ":";
            c += $c9ee9f81cdf9785c$var$padStart(Math.trunc(o.o % 60));
        }
    }
    if (extendedZone) c += "[" + o.zone.ianaName + "]";
    return c;
}
// defaults for unspecified units in the supported calendars
var $c9ee9f81cdf9785c$var$defaultUnitValues = {
    month: 1,
    day: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
}, $c9ee9f81cdf9785c$var$defaultWeekUnitValues = {
    weekNumber: 1,
    weekday: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
}, $c9ee9f81cdf9785c$var$defaultOrdinalUnitValues = {
    ordinal: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
};
// Units in the supported calendars, sorted by bigness
var $c9ee9f81cdf9785c$var$orderedUnits = [
    "year",
    "month",
    "day",
    "hour",
    "minute",
    "second",
    "millisecond"
], $c9ee9f81cdf9785c$var$orderedWeekUnits = [
    "weekYear",
    "weekNumber",
    "weekday",
    "hour",
    "minute",
    "second",
    "millisecond"
], $c9ee9f81cdf9785c$var$orderedOrdinalUnits = [
    "year",
    "ordinal",
    "hour",
    "minute",
    "second",
    "millisecond"
];
// standardize case and plurality in units
function $c9ee9f81cdf9785c$var$normalizeUnit(unit) {
    var normalized = {
        year: "year",
        years: "year",
        month: "month",
        months: "month",
        day: "day",
        days: "day",
        hour: "hour",
        hours: "hour",
        minute: "minute",
        minutes: "minute",
        quarter: "quarter",
        quarters: "quarter",
        second: "second",
        seconds: "second",
        millisecond: "millisecond",
        milliseconds: "millisecond",
        weekday: "weekday",
        weekdays: "weekday",
        weeknumber: "weekNumber",
        weeksnumber: "weekNumber",
        weeknumbers: "weekNumber",
        weekyear: "weekYear",
        weekyears: "weekYear",
        ordinal: "ordinal"
    }[unit.toLowerCase()];
    if (!normalized) throw new $c9ee9f81cdf9785c$var$InvalidUnitError(unit);
    return normalized;
}
function $c9ee9f81cdf9785c$var$normalizeUnitWithLocalWeeks(unit) {
    switch(unit.toLowerCase()){
        case "localweekday":
        case "localweekdays":
            return "localWeekday";
        case "localweeknumber":
        case "localweeknumbers":
            return "localWeekNumber";
        case "localweekyear":
        case "localweekyears":
            return "localWeekYear";
        default:
            return $c9ee9f81cdf9785c$var$normalizeUnit(unit);
    }
}
// cache offsets for zones based on the current timestamp when this function is
// first called. When we are handling a datetime from components like (year,
// month, day, hour) in a time zone, we need a guess about what the timezone
// offset is so that we can convert into a UTC timestamp. One way is to find the
// offset of now in the zone. The actual date may have a different offset (for
// example, if we handle a date in June while we're in December in a zone that
// observes DST), but we can check and adjust that.
//
// When handling many dates, calculating the offset for now every time is
// expensive. It's just a guess, so we can cache the offset to use even if we
// are right on a time change boundary (we'll just correct in the other
// direction). Using a timestamp from first read is a slight optimization for
// handling dates close to the current date, since those dates will usually be
// in the same offset (we could set the timestamp statically, instead). We use a
// single timestamp for all zones to make things a bit more predictable.
//
// This is safe for quickDT (used by local() and utc()) because we don't fill in
// higher-order units from tsNow (as we do in fromObject, this requires that
// offset is calculated from tsNow).
/**
 * @param {Zone} zone
 * @return {number}
 */ function $c9ee9f81cdf9785c$var$guessOffsetForZone(zone) {
    if ($c9ee9f81cdf9785c$var$zoneOffsetTs === undefined) $c9ee9f81cdf9785c$var$zoneOffsetTs = $c9ee9f81cdf9785c$var$Settings.now();
    // Do not cache anything but IANA zones, because it is not safe to do so.
    // Guessing an offset which is not present in the zone can cause wrong results from fixOffset
    if (zone.type !== "iana") return zone.offset($c9ee9f81cdf9785c$var$zoneOffsetTs);
    var zoneName = zone.name;
    var offsetGuess = $c9ee9f81cdf9785c$var$zoneOffsetGuessCache.get(zoneName);
    if (offsetGuess === undefined) {
        offsetGuess = zone.offset($c9ee9f81cdf9785c$var$zoneOffsetTs);
        $c9ee9f81cdf9785c$var$zoneOffsetGuessCache.set(zoneName, offsetGuess);
    }
    return offsetGuess;
}
// this is a dumbed down version of fromObject() that runs about 60% faster
// but doesn't do any validation, makes a bunch of assumptions about what units
// are present, and so on.
function $c9ee9f81cdf9785c$var$quickDT(obj, opts) {
    var zone = $c9ee9f81cdf9785c$var$normalizeZone(opts.zone, $c9ee9f81cdf9785c$var$Settings.defaultZone);
    if (!zone.isValid) return $c9ee9f81cdf9785c$var$DateTime.invalid($c9ee9f81cdf9785c$var$unsupportedZone(zone));
    var loc = $c9ee9f81cdf9785c$var$Locale.fromObject(opts);
    var ts, o;
    // assume we have the higher-order units
    if (!$c9ee9f81cdf9785c$var$isUndefined(obj.year)) {
        for(var _i = 0, _orderedUnits = $c9ee9f81cdf9785c$var$orderedUnits; _i < _orderedUnits.length; _i++){
            var u = _orderedUnits[_i];
            if ($c9ee9f81cdf9785c$var$isUndefined(obj[u])) obj[u] = $c9ee9f81cdf9785c$var$defaultUnitValues[u];
        }
        var invalid = $c9ee9f81cdf9785c$var$hasInvalidGregorianData(obj) || $c9ee9f81cdf9785c$var$hasInvalidTimeData(obj);
        if (invalid) return $c9ee9f81cdf9785c$var$DateTime.invalid(invalid);
        var offsetProvis = $c9ee9f81cdf9785c$var$guessOffsetForZone(zone);
        var _objToTS = $c9ee9f81cdf9785c$var$objToTS(obj, offsetProvis, zone);
        ts = _objToTS[0];
        o = _objToTS[1];
    } else ts = $c9ee9f81cdf9785c$var$Settings.now();
    return new $c9ee9f81cdf9785c$var$DateTime({
        ts: ts,
        zone: zone,
        loc: loc,
        o: o
    });
}
function $c9ee9f81cdf9785c$var$diffRelative(start, end, opts) {
    var round = $c9ee9f81cdf9785c$var$isUndefined(opts.round) ? true : opts.round, rounding = $c9ee9f81cdf9785c$var$isUndefined(opts.rounding) ? "trunc" : opts.rounding, format = function format(c, unit) {
        c = $c9ee9f81cdf9785c$var$roundTo(c, round || opts.calendary ? 0 : 2, opts.calendary ? "round" : rounding);
        var formatter = end.loc.clone(opts).relFormatter(opts);
        return formatter.format(c, unit);
    }, differ = function differ(unit) {
        if (opts.calendary) {
            if (!end.hasSame(start, unit)) return end.startOf(unit).diff(start.startOf(unit), unit).get(unit);
            else return 0;
        } else return end.diff(start, unit).get(unit);
    };
    if (opts.unit) return format(differ(opts.unit), opts.unit);
    for(var _iterator = $c9ee9f81cdf9785c$var$_createForOfIteratorHelperLoose(opts.units), _step; !(_step = _iterator()).done;){
        var unit = _step.value;
        var count = differ(unit);
        if (Math.abs(count) >= 1) return format(count, unit);
    }
    return format(start > end ? -0 : 0, opts.units[opts.units.length - 1]);
}
function $c9ee9f81cdf9785c$var$lastOpts(argList) {
    var opts = {}, args;
    if (argList.length > 0 && typeof argList[argList.length - 1] === "object") {
        opts = argList[argList.length - 1];
        args = Array.from(argList).slice(0, argList.length - 1);
    } else args = Array.from(argList);
    return [
        opts,
        args
    ];
}
/**
 * Timestamp to use for cached zone offset guesses (exposed for test)
 */ var $c9ee9f81cdf9785c$var$zoneOffsetTs;
/**
 * Cache for zone offset guesses (exposed for test).
 *
 * This optimizes quickDT via guessOffsetForZone to avoid repeated calls of
 * zone.offset().
 */ var $c9ee9f81cdf9785c$var$zoneOffsetGuessCache = new Map();
/**
 * A DateTime is an immutable data structure representing a specific date and time and accompanying methods. It contains class and instance methods for creating, parsing, interrogating, transforming, and formatting them.
 *
 * A DateTime comprises of:
 * * A timestamp. Each DateTime instance refers to a specific millisecond of the Unix epoch.
 * * A time zone. Each instance is considered in the context of a specific zone (by default the local system's zone).
 * * Configuration properties that effect how output strings are formatted, such as `locale`, `numberingSystem`, and `outputCalendar`.
 *
 * Here is a brief overview of the most commonly used functionality it provides:
 *
 * * **Creation**: To create a DateTime from its components, use one of its factory class methods: {@link DateTime.local}, {@link DateTime.utc}, and (most flexibly) {@link DateTime.fromObject}. To create one from a standard string format, use {@link DateTime.fromISO}, {@link DateTime.fromHTTP}, and {@link DateTime.fromRFC2822}. To create one from a custom string format, use {@link DateTime.fromFormat}. To create one from a native JS date, use {@link DateTime.fromJSDate}.
 * * **Gregorian calendar and time**: To examine the Gregorian properties of a DateTime individually (i.e as opposed to collectively through {@link DateTime#toObject}), use the {@link DateTime#year}, {@link DateTime#month},
 * {@link DateTime#day}, {@link DateTime#hour}, {@link DateTime#minute}, {@link DateTime#second}, {@link DateTime#millisecond} accessors.
 * * **Week calendar**: For ISO week calendar attributes, see the {@link DateTime#weekYear}, {@link DateTime#weekNumber}, and {@link DateTime#weekday} accessors.
 * * **Configuration** See the {@link DateTime#locale} and {@link DateTime#numberingSystem} accessors.
 * * **Transformation**: To transform the DateTime into other DateTimes, use {@link DateTime#set}, {@link DateTime#reconfigure}, {@link DateTime#setZone}, {@link DateTime#setLocale}, {@link DateTime.plus}, {@link DateTime#minus}, {@link DateTime#endOf}, {@link DateTime#startOf}, {@link DateTime#toUTC}, and {@link DateTime#toLocal}.
 * * **Output**: To convert the DateTime to other representations, use the {@link DateTime#toRelative}, {@link DateTime#toRelativeCalendar}, {@link DateTime#toJSON}, {@link DateTime#toISO}, {@link DateTime#toHTTP}, {@link DateTime#toObject}, {@link DateTime#toRFC2822}, {@link DateTime#toString}, {@link DateTime#toLocaleString}, {@link DateTime#toFormat}, {@link DateTime#toMillis} and {@link DateTime#toJSDate}.
 *
 * There's plenty others documented below. In addition, for more information on subtler topics like internationalization, time zones, alternative calendars, validity, and so on, see the external documentation.
 */ var $c9ee9f81cdf9785c$var$DateTime = /*#__PURE__*/ function(_Symbol$for) {
    /**
   * @access private
   */ function DateTime(config) {
        var zone = config.zone || $c9ee9f81cdf9785c$var$Settings.defaultZone;
        var invalid = config.invalid || (Number.isNaN(config.ts) ? new $c9ee9f81cdf9785c$var$Invalid("invalid input") : null) || (!zone.isValid ? $c9ee9f81cdf9785c$var$unsupportedZone(zone) : null);
        /**
     * @access private
     */ this.ts = $c9ee9f81cdf9785c$var$isUndefined(config.ts) ? $c9ee9f81cdf9785c$var$Settings.now() : config.ts;
        var c = null, o = null;
        if (!invalid) {
            var unchanged = config.old && config.old.ts === this.ts && config.old.zone.equals(zone);
            if (unchanged) {
                var _ref = [
                    config.old.c,
                    config.old.o
                ];
                c = _ref[0];
                o = _ref[1];
            } else {
                // If an offset has been passed and we have not been called from
                // clone(), we can trust it and avoid the offset calculation.
                var ot = $c9ee9f81cdf9785c$var$isNumber(config.o) && !config.old ? config.o : zone.offset(this.ts);
                c = $c9ee9f81cdf9785c$var$tsToObj(this.ts, ot);
                invalid = Number.isNaN(c.year) ? new $c9ee9f81cdf9785c$var$Invalid("invalid input") : null;
                c = invalid ? null : c;
                o = invalid ? null : ot;
            }
        }
        /**
     * @access private
     */ this._zone = zone;
        /**
     * @access private
     */ this.loc = config.loc || $c9ee9f81cdf9785c$var$Locale.create();
        /**
     * @access private
     */ this.invalid = invalid;
        /**
     * @access private
     */ this.weekData = null;
        /**
     * @access private
     */ this.localWeekData = null;
        /**
     * @access private
     */ this.c = c;
        /**
     * @access private
     */ this.o = o;
        /**
     * @access private
     */ this.isLuxonDateTime = true;
    }
    // CONSTRUCT
    /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */ DateTime.now = function now() {
        return new DateTime({});
    };
    DateTime.local = function local() {
        var _lastOpts = $c9ee9f81cdf9785c$var$lastOpts(arguments), opts = _lastOpts[0], args = _lastOpts[1], year = args[0], month = args[1], day = args[2], hour = args[3], minute = args[4], second = args[5], millisecond = args[6];
        return $c9ee9f81cdf9785c$var$quickDT({
            year: year,
            month: month,
            day: day,
            hour: hour,
            minute: minute,
            second: second,
            millisecond: millisecond
        }, opts);
    };
    DateTime.utc = function utc() {
        var _lastOpts2 = $c9ee9f81cdf9785c$var$lastOpts(arguments), opts = _lastOpts2[0], args = _lastOpts2[1], year = args[0], month = args[1], day = args[2], hour = args[3], minute = args[4], second = args[5], millisecond = args[6];
        opts.zone = $c9ee9f81cdf9785c$var$FixedOffsetZone.utcInstance;
        return $c9ee9f81cdf9785c$var$quickDT({
            year: year,
            month: month,
            day: day,
            hour: hour,
            minute: minute,
            second: second,
            millisecond: millisecond
        }, opts);
    };
    DateTime.fromJSDate = function fromJSDate(date, options) {
        if (options === void 0) options = {};
        var ts = $c9ee9f81cdf9785c$var$isDate(date) ? date.valueOf() : NaN;
        if (Number.isNaN(ts)) return DateTime.invalid("invalid input");
        var zoneToUse = $c9ee9f81cdf9785c$var$normalizeZone(options.zone, $c9ee9f81cdf9785c$var$Settings.defaultZone);
        if (!zoneToUse.isValid) return DateTime.invalid($c9ee9f81cdf9785c$var$unsupportedZone(zoneToUse));
        return new DateTime({
            ts: ts,
            zone: zoneToUse,
            loc: $c9ee9f81cdf9785c$var$Locale.fromObject(options)
        });
    };
    DateTime.fromMillis = function fromMillis(milliseconds, options) {
        if (options === void 0) options = {};
        if (!$c9ee9f81cdf9785c$var$isNumber(milliseconds)) throw new $c9ee9f81cdf9785c$var$InvalidArgumentError("fromMillis requires a numerical input, but received a " + typeof milliseconds + " with value " + milliseconds);
        else if (milliseconds < -$c9ee9f81cdf9785c$var$MAX_DATE || milliseconds > $c9ee9f81cdf9785c$var$MAX_DATE) // this isn't perfect because we can still end up out of range because of additional shifting, but it's a start
        return DateTime.invalid("Timestamp out of range");
        else return new DateTime({
            ts: milliseconds,
            zone: $c9ee9f81cdf9785c$var$normalizeZone(options.zone, $c9ee9f81cdf9785c$var$Settings.defaultZone),
            loc: $c9ee9f81cdf9785c$var$Locale.fromObject(options)
        });
    };
    DateTime.fromSeconds = function fromSeconds(seconds, options) {
        if (options === void 0) options = {};
        if (!$c9ee9f81cdf9785c$var$isNumber(seconds)) throw new $c9ee9f81cdf9785c$var$InvalidArgumentError("fromSeconds requires a numerical input");
        else return new DateTime({
            ts: seconds * 1000,
            zone: $c9ee9f81cdf9785c$var$normalizeZone(options.zone, $c9ee9f81cdf9785c$var$Settings.defaultZone),
            loc: $c9ee9f81cdf9785c$var$Locale.fromObject(options)
        });
    };
    DateTime.fromObject = function fromObject(obj, opts) {
        if (opts === void 0) opts = {};
        obj = obj || {};
        var zoneToUse = $c9ee9f81cdf9785c$var$normalizeZone(opts.zone, $c9ee9f81cdf9785c$var$Settings.defaultZone);
        if (!zoneToUse.isValid) return DateTime.invalid($c9ee9f81cdf9785c$var$unsupportedZone(zoneToUse));
        var loc = $c9ee9f81cdf9785c$var$Locale.fromObject(opts);
        var normalized = $c9ee9f81cdf9785c$var$normalizeObject(obj, $c9ee9f81cdf9785c$var$normalizeUnitWithLocalWeeks);
        var _usesLocalWeekValues = $c9ee9f81cdf9785c$var$usesLocalWeekValues(normalized, loc), minDaysInFirstWeek = _usesLocalWeekValues.minDaysInFirstWeek, startOfWeek = _usesLocalWeekValues.startOfWeek;
        var tsNow = $c9ee9f81cdf9785c$var$Settings.now(), offsetProvis = !$c9ee9f81cdf9785c$var$isUndefined(opts.specificOffset) ? opts.specificOffset : zoneToUse.offset(tsNow), containsOrdinal = !$c9ee9f81cdf9785c$var$isUndefined(normalized.ordinal), containsGregorYear = !$c9ee9f81cdf9785c$var$isUndefined(normalized.year), containsGregorMD = !$c9ee9f81cdf9785c$var$isUndefined(normalized.month) || !$c9ee9f81cdf9785c$var$isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber;
        // cases:
        // just a weekday -> this week's instance of that weekday, no worries
        // (gregorian data or ordinal) + (weekYear or weekNumber) -> error
        // (gregorian month or day) + ordinal -> error
        // otherwise just use weeks or ordinals or gregorian, depending on what's specified
        if ((containsGregor || containsOrdinal) && definiteWeekDef) throw new $c9ee9f81cdf9785c$var$ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
        if (containsGregorMD && containsOrdinal) throw new $c9ee9f81cdf9785c$var$ConflictingSpecificationError("Can't mix ordinal dates with month/day");
        var useWeekData = definiteWeekDef || normalized.weekday && !containsGregor;
        // configure ourselves to deal with gregorian dates or week stuff
        var units, defaultValues, objNow = $c9ee9f81cdf9785c$var$tsToObj(tsNow, offsetProvis);
        if (useWeekData) {
            units = $c9ee9f81cdf9785c$var$orderedWeekUnits;
            defaultValues = $c9ee9f81cdf9785c$var$defaultWeekUnitValues;
            objNow = $c9ee9f81cdf9785c$var$gregorianToWeek(objNow, minDaysInFirstWeek, startOfWeek);
        } else if (containsOrdinal) {
            units = $c9ee9f81cdf9785c$var$orderedOrdinalUnits;
            defaultValues = $c9ee9f81cdf9785c$var$defaultOrdinalUnitValues;
            objNow = $c9ee9f81cdf9785c$var$gregorianToOrdinal(objNow);
        } else {
            units = $c9ee9f81cdf9785c$var$orderedUnits;
            defaultValues = $c9ee9f81cdf9785c$var$defaultUnitValues;
        }
        // set default values for missing stuff
        var foundFirst = false;
        for(var _iterator2 = $c9ee9f81cdf9785c$var$_createForOfIteratorHelperLoose(units), _step2; !(_step2 = _iterator2()).done;){
            var u = _step2.value;
            var v = normalized[u];
            if (!$c9ee9f81cdf9785c$var$isUndefined(v)) foundFirst = true;
            else if (foundFirst) normalized[u] = defaultValues[u];
            else normalized[u] = objNow[u];
        }
        // make sure the values we have are in range
        var higherOrderInvalid = useWeekData ? $c9ee9f81cdf9785c$var$hasInvalidWeekData(normalized, minDaysInFirstWeek, startOfWeek) : containsOrdinal ? $c9ee9f81cdf9785c$var$hasInvalidOrdinalData(normalized) : $c9ee9f81cdf9785c$var$hasInvalidGregorianData(normalized), invalid = higherOrderInvalid || $c9ee9f81cdf9785c$var$hasInvalidTimeData(normalized);
        if (invalid) return DateTime.invalid(invalid);
        // compute the actual time
        var gregorian = useWeekData ? $c9ee9f81cdf9785c$var$weekToGregorian(normalized, minDaysInFirstWeek, startOfWeek) : containsOrdinal ? $c9ee9f81cdf9785c$var$ordinalToGregorian(normalized) : normalized, _objToTS2 = $c9ee9f81cdf9785c$var$objToTS(gregorian, offsetProvis, zoneToUse), tsFinal = _objToTS2[0], offsetFinal = _objToTS2[1], inst = new DateTime({
            ts: tsFinal,
            zone: zoneToUse,
            o: offsetFinal,
            loc: loc
        });
        // gregorian data + weekday serves only to validate
        if (normalized.weekday && containsGregor && obj.weekday !== inst.weekday) return DateTime.invalid("mismatched weekday", "you can't specify both a weekday of " + normalized.weekday + " and a date of " + inst.toISO());
        if (!inst.isValid) return DateTime.invalid(inst.invalid);
        return inst;
    };
    DateTime.fromISO = function fromISO(text, opts) {
        if (opts === void 0) opts = {};
        var _parseISODate = $c9ee9f81cdf9785c$var$parseISODate(text), vals = _parseISODate[0], parsedZone = _parseISODate[1];
        return $c9ee9f81cdf9785c$var$parseDataToDateTime(vals, parsedZone, opts, "ISO 8601", text);
    };
    DateTime.fromRFC2822 = function fromRFC2822(text, opts) {
        if (opts === void 0) opts = {};
        var _parseRFC2822Date = $c9ee9f81cdf9785c$var$parseRFC2822Date(text), vals = _parseRFC2822Date[0], parsedZone = _parseRFC2822Date[1];
        return $c9ee9f81cdf9785c$var$parseDataToDateTime(vals, parsedZone, opts, "RFC 2822", text);
    };
    DateTime.fromHTTP = function fromHTTP(text, opts) {
        if (opts === void 0) opts = {};
        var _parseHTTPDate = $c9ee9f81cdf9785c$var$parseHTTPDate(text), vals = _parseHTTPDate[0], parsedZone = _parseHTTPDate[1];
        return $c9ee9f81cdf9785c$var$parseDataToDateTime(vals, parsedZone, opts, "HTTP", opts);
    };
    DateTime.fromFormat = function fromFormat(text, fmt, opts) {
        if (opts === void 0) opts = {};
        if ($c9ee9f81cdf9785c$var$isUndefined(text) || $c9ee9f81cdf9785c$var$isUndefined(fmt)) throw new $c9ee9f81cdf9785c$var$InvalidArgumentError("fromFormat requires an input string and a format");
        var _opts = opts, _opts$locale = _opts.locale, locale = _opts$locale === void 0 ? null : _opts$locale, _opts$numberingSystem = _opts.numberingSystem, numberingSystem = _opts$numberingSystem === void 0 ? null : _opts$numberingSystem, localeToUse = $c9ee9f81cdf9785c$var$Locale.fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        }), _parseFromTokens = $c9ee9f81cdf9785c$var$parseFromTokens(localeToUse, text, fmt), vals = _parseFromTokens[0], parsedZone = _parseFromTokens[1], specificOffset = _parseFromTokens[2], invalid = _parseFromTokens[3];
        if (invalid) return DateTime.invalid(invalid);
        else return $c9ee9f81cdf9785c$var$parseDataToDateTime(vals, parsedZone, opts, "format " + fmt, text, specificOffset);
    };
    DateTime.fromString = function fromString(text, fmt, opts) {
        if (opts === void 0) opts = {};
        return DateTime.fromFormat(text, fmt, opts);
    };
    DateTime.fromSQL = function fromSQL(text, opts) {
        if (opts === void 0) opts = {};
        var _parseSQL = $c9ee9f81cdf9785c$var$parseSQL(text), vals = _parseSQL[0], parsedZone = _parseSQL[1];
        return $c9ee9f81cdf9785c$var$parseDataToDateTime(vals, parsedZone, opts, "SQL", text);
    };
    DateTime.invalid = function invalid(reason, explanation) {
        if (explanation === void 0) explanation = null;
        if (!reason) throw new $c9ee9f81cdf9785c$var$InvalidArgumentError("need to specify a reason the DateTime is invalid");
        var invalid = reason instanceof $c9ee9f81cdf9785c$var$Invalid ? reason : new $c9ee9f81cdf9785c$var$Invalid(reason, explanation);
        if ($c9ee9f81cdf9785c$var$Settings.throwOnInvalid) throw new $c9ee9f81cdf9785c$var$InvalidDateTimeError(invalid);
        else return new DateTime({
            invalid: invalid
        });
    };
    DateTime.isDateTime = function isDateTime(o) {
        return o && o.isLuxonDateTime || false;
    };
    DateTime.parseFormatForOpts = function parseFormatForOpts(formatOpts, localeOpts) {
        if (localeOpts === void 0) localeOpts = {};
        var tokenList = $c9ee9f81cdf9785c$var$formatOptsToTokens(formatOpts, $c9ee9f81cdf9785c$var$Locale.fromObject(localeOpts));
        return !tokenList ? null : tokenList.map(function(t) {
            return t ? t.val : null;
        }).join("");
    };
    DateTime.expandFormat = function expandFormat(fmt, localeOpts) {
        if (localeOpts === void 0) localeOpts = {};
        var expanded = $c9ee9f81cdf9785c$var$expandMacroTokens($c9ee9f81cdf9785c$var$Formatter.parseFormat(fmt), $c9ee9f81cdf9785c$var$Locale.fromObject(localeOpts));
        return expanded.map(function(t) {
            return t.val;
        }).join("");
    };
    DateTime.resetCache = function resetCache() {
        $c9ee9f81cdf9785c$var$zoneOffsetTs = undefined;
        $c9ee9f81cdf9785c$var$zoneOffsetGuessCache.clear();
    };
    var _proto = DateTime.prototype;
    _proto.get = function get(unit) {
        return this[unit];
    };
    /**
   * Get those DateTimes which have the same local time as this DateTime, but a different offset from UTC
   * in this DateTime's zone. During DST changes local time can be ambiguous, for example
   * `2023-10-29T02:30:00` in `Europe/Berlin` can have offset `+01:00` or `+02:00`.
   * This method will return both possible DateTimes if this DateTime's local time is ambiguous.
   * @returns {DateTime[]}
   */ _proto.getPossibleOffsets = function getPossibleOffsets() {
        if (!this.isValid || this.isOffsetFixed) return [
            this
        ];
        var dayMs = 86400000;
        var minuteMs = 60000;
        var localTS = $c9ee9f81cdf9785c$var$objToLocalTS(this.c);
        var oEarlier = this.zone.offset(localTS - dayMs);
        var oLater = this.zone.offset(localTS + dayMs);
        var o1 = this.zone.offset(localTS - oEarlier * minuteMs);
        var o2 = this.zone.offset(localTS - oLater * minuteMs);
        if (o1 === o2) return [
            this
        ];
        var ts1 = localTS - o1 * minuteMs;
        var ts2 = localTS - o2 * minuteMs;
        var c1 = $c9ee9f81cdf9785c$var$tsToObj(ts1, o1);
        var c2 = $c9ee9f81cdf9785c$var$tsToObj(ts2, o2);
        if (c1.hour === c2.hour && c1.minute === c2.minute && c1.second === c2.second && c1.millisecond === c2.millisecond) return [
            $c9ee9f81cdf9785c$var$clone(this, {
                ts: ts1
            }),
            $c9ee9f81cdf9785c$var$clone(this, {
                ts: ts2
            })
        ];
        return [
            this
        ];
    };
    /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */ _proto.resolvedLocaleOptions = function resolvedLocaleOptions(opts) {
        if (opts === void 0) opts = {};
        var _Formatter$create$res = $c9ee9f81cdf9785c$var$Formatter.create(this.loc.clone(opts), opts).resolvedOptions(this), locale = _Formatter$create$res.locale, numberingSystem = _Formatter$create$res.numberingSystem, calendar = _Formatter$create$res.calendar;
        return {
            locale: locale,
            numberingSystem: numberingSystem,
            outputCalendar: calendar
        };
    };
    _proto.toUTC = function toUTC(offset, opts) {
        if (offset === void 0) offset = 0;
        if (opts === void 0) opts = {};
        return this.setZone($c9ee9f81cdf9785c$var$FixedOffsetZone.instance(offset), opts);
    };
    _proto.toLocal = function toLocal() {
        return this.setZone($c9ee9f81cdf9785c$var$Settings.defaultZone);
    };
    _proto.setZone = function setZone(zone, _temp) {
        var _ref2 = _temp === void 0 ? {} : _temp, _ref2$keepLocalTime = _ref2.keepLocalTime, keepLocalTime = _ref2$keepLocalTime === void 0 ? false : _ref2$keepLocalTime, _ref2$keepCalendarTim = _ref2.keepCalendarTime, keepCalendarTime = _ref2$keepCalendarTim === void 0 ? false : _ref2$keepCalendarTim;
        zone = $c9ee9f81cdf9785c$var$normalizeZone(zone, $c9ee9f81cdf9785c$var$Settings.defaultZone);
        if (zone.equals(this.zone)) return this;
        else if (!zone.isValid) return DateTime.invalid($c9ee9f81cdf9785c$var$unsupportedZone(zone));
        else {
            var newTS = this.ts;
            if (keepLocalTime || keepCalendarTime) {
                var offsetGuess = zone.offset(this.ts);
                var asObj = this.toObject();
                var _objToTS3 = $c9ee9f81cdf9785c$var$objToTS(asObj, offsetGuess, zone);
                newTS = _objToTS3[0];
            }
            return $c9ee9f81cdf9785c$var$clone(this, {
                ts: newTS,
                zone: zone
            });
        }
    };
    _proto.reconfigure = function reconfigure(_temp2) {
        var _ref3 = _temp2 === void 0 ? {} : _temp2, locale = _ref3.locale, numberingSystem = _ref3.numberingSystem, outputCalendar = _ref3.outputCalendar;
        var loc = this.loc.clone({
            locale: locale,
            numberingSystem: numberingSystem,
            outputCalendar: outputCalendar
        });
        return $c9ee9f81cdf9785c$var$clone(this, {
            loc: loc
        });
    };
    _proto.setLocale = function setLocale(locale) {
        return this.reconfigure({
            locale: locale
        });
    };
    _proto.set = function set(values) {
        if (!this.isValid) return this;
        var normalized = $c9ee9f81cdf9785c$var$normalizeObject(values, $c9ee9f81cdf9785c$var$normalizeUnitWithLocalWeeks);
        var _usesLocalWeekValues2 = $c9ee9f81cdf9785c$var$usesLocalWeekValues(normalized, this.loc), minDaysInFirstWeek = _usesLocalWeekValues2.minDaysInFirstWeek, startOfWeek = _usesLocalWeekValues2.startOfWeek;
        var settingWeekStuff = !$c9ee9f81cdf9785c$var$isUndefined(normalized.weekYear) || !$c9ee9f81cdf9785c$var$isUndefined(normalized.weekNumber) || !$c9ee9f81cdf9785c$var$isUndefined(normalized.weekday), containsOrdinal = !$c9ee9f81cdf9785c$var$isUndefined(normalized.ordinal), containsGregorYear = !$c9ee9f81cdf9785c$var$isUndefined(normalized.year), containsGregorMD = !$c9ee9f81cdf9785c$var$isUndefined(normalized.month) || !$c9ee9f81cdf9785c$var$isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber;
        if ((containsGregor || containsOrdinal) && definiteWeekDef) throw new $c9ee9f81cdf9785c$var$ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
        if (containsGregorMD && containsOrdinal) throw new $c9ee9f81cdf9785c$var$ConflictingSpecificationError("Can't mix ordinal dates with month/day");
        var mixed;
        if (settingWeekStuff) mixed = $c9ee9f81cdf9785c$var$weekToGregorian($c9ee9f81cdf9785c$var$_extends({}, $c9ee9f81cdf9785c$var$gregorianToWeek(this.c, minDaysInFirstWeek, startOfWeek), normalized), minDaysInFirstWeek, startOfWeek);
        else if (!$c9ee9f81cdf9785c$var$isUndefined(normalized.ordinal)) mixed = $c9ee9f81cdf9785c$var$ordinalToGregorian($c9ee9f81cdf9785c$var$_extends({}, $c9ee9f81cdf9785c$var$gregorianToOrdinal(this.c), normalized));
        else {
            mixed = $c9ee9f81cdf9785c$var$_extends({}, this.toObject(), normalized);
            // if we didn't set the day but we ended up on an overflow date,
            // use the last day of the right month
            if ($c9ee9f81cdf9785c$var$isUndefined(normalized.day)) mixed.day = Math.min($c9ee9f81cdf9785c$var$daysInMonth(mixed.year, mixed.month), mixed.day);
        }
        var _objToTS4 = $c9ee9f81cdf9785c$var$objToTS(mixed, this.o, this.zone), ts = _objToTS4[0], o = _objToTS4[1];
        return $c9ee9f81cdf9785c$var$clone(this, {
            ts: ts,
            o: o
        });
    };
    _proto.plus = function plus(duration) {
        if (!this.isValid) return this;
        var dur = $c9ee9f81cdf9785c$var$Duration.fromDurationLike(duration);
        return $c9ee9f81cdf9785c$var$clone(this, $c9ee9f81cdf9785c$var$adjustTime(this, dur));
    };
    _proto.minus = function minus(duration) {
        if (!this.isValid) return this;
        var dur = $c9ee9f81cdf9785c$var$Duration.fromDurationLike(duration).negate();
        return $c9ee9f81cdf9785c$var$clone(this, $c9ee9f81cdf9785c$var$adjustTime(this, dur));
    };
    _proto.startOf = function startOf(unit, _temp3) {
        var _ref4 = _temp3 === void 0 ? {} : _temp3, _ref4$useLocaleWeeks = _ref4.useLocaleWeeks, useLocaleWeeks = _ref4$useLocaleWeeks === void 0 ? false : _ref4$useLocaleWeeks;
        if (!this.isValid) return this;
        var o = {}, normalizedUnit = $c9ee9f81cdf9785c$var$Duration.normalizeUnit(unit);
        switch(normalizedUnit){
            case "years":
                o.month = 1;
            // falls through
            case "quarters":
            case "months":
                o.day = 1;
            // falls through
            case "weeks":
            case "days":
                o.hour = 0;
            // falls through
            case "hours":
                o.minute = 0;
            // falls through
            case "minutes":
                o.second = 0;
            // falls through
            case "seconds":
                o.millisecond = 0;
                break;
        }
        if (normalizedUnit === "weeks") {
            if (useLocaleWeeks) {
                var startOfWeek = this.loc.getStartOfWeek();
                var weekday = this.weekday;
                if (weekday < startOfWeek) o.weekNumber = this.weekNumber - 1;
                o.weekday = startOfWeek;
            } else o.weekday = 1;
        }
        if (normalizedUnit === "quarters") {
            var q = Math.ceil(this.month / 3);
            o.month = (q - 1) * 3 + 1;
        }
        return this.set(o);
    };
    _proto.endOf = function endOf(unit, opts) {
        var _this$plus;
        return this.isValid ? this.plus((_this$plus = {}, _this$plus[unit] = 1, _this$plus)).startOf(unit, opts).minus(1) : this;
    };
    _proto.toFormat = function toFormat(fmt, opts) {
        if (opts === void 0) opts = {};
        return this.isValid ? $c9ee9f81cdf9785c$var$Formatter.create(this.loc.redefaultToEN(opts)).formatDateTimeFromString(this, fmt) : $c9ee9f81cdf9785c$var$INVALID;
    };
    _proto.toLocaleString = function toLocaleString(formatOpts, opts) {
        if (formatOpts === void 0) formatOpts = $c9ee9f81cdf9785c$var$DATE_SHORT;
        if (opts === void 0) opts = {};
        return this.isValid ? $c9ee9f81cdf9785c$var$Formatter.create(this.loc.clone(opts), formatOpts).formatDateTime(this) : $c9ee9f81cdf9785c$var$INVALID;
    };
    _proto.toLocaleParts = function toLocaleParts(opts) {
        if (opts === void 0) opts = {};
        return this.isValid ? $c9ee9f81cdf9785c$var$Formatter.create(this.loc.clone(opts), opts).formatDateTimeParts(this) : [];
    };
    _proto.toISO = function toISO(_temp4) {
        var _ref5 = _temp4 === void 0 ? {} : _temp4, _ref5$format = _ref5.format, format = _ref5$format === void 0 ? "extended" : _ref5$format, _ref5$suppressSeconds = _ref5.suppressSeconds, suppressSeconds = _ref5$suppressSeconds === void 0 ? false : _ref5$suppressSeconds, _ref5$suppressMillise = _ref5.suppressMilliseconds, suppressMilliseconds = _ref5$suppressMillise === void 0 ? false : _ref5$suppressMillise, _ref5$includeOffset = _ref5.includeOffset, includeOffset = _ref5$includeOffset === void 0 ? true : _ref5$includeOffset, _ref5$extendedZone = _ref5.extendedZone, extendedZone = _ref5$extendedZone === void 0 ? false : _ref5$extendedZone, _ref5$precision = _ref5.precision, precision = _ref5$precision === void 0 ? "milliseconds" : _ref5$precision;
        if (!this.isValid) return null;
        precision = $c9ee9f81cdf9785c$var$normalizeUnit(precision);
        var ext = format === "extended";
        var c = $c9ee9f81cdf9785c$var$_toISODate(this, ext, precision);
        if ($c9ee9f81cdf9785c$var$orderedUnits.indexOf(precision) >= 3) c += "T";
        c += $c9ee9f81cdf9785c$var$_toISOTime(this, ext, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone, precision);
        return c;
    };
    _proto.toISODate = function toISODate(_temp5) {
        var _ref6 = _temp5 === void 0 ? {} : _temp5, _ref6$format = _ref6.format, format = _ref6$format === void 0 ? "extended" : _ref6$format, _ref6$precision = _ref6.precision, precision = _ref6$precision === void 0 ? "day" : _ref6$precision;
        if (!this.isValid) return null;
        return $c9ee9f81cdf9785c$var$_toISODate(this, format === "extended", $c9ee9f81cdf9785c$var$normalizeUnit(precision));
    };
    _proto.toISOWeekDate = function toISOWeekDate() {
        return $c9ee9f81cdf9785c$var$toTechFormat(this, "kkkk-'W'WW-c");
    };
    _proto.toISOTime = function toISOTime(_temp6) {
        var _ref7 = _temp6 === void 0 ? {} : _temp6, _ref7$suppressMillise = _ref7.suppressMilliseconds, suppressMilliseconds = _ref7$suppressMillise === void 0 ? false : _ref7$suppressMillise, _ref7$suppressSeconds = _ref7.suppressSeconds, suppressSeconds = _ref7$suppressSeconds === void 0 ? false : _ref7$suppressSeconds, _ref7$includeOffset = _ref7.includeOffset, includeOffset = _ref7$includeOffset === void 0 ? true : _ref7$includeOffset, _ref7$includePrefix = _ref7.includePrefix, includePrefix = _ref7$includePrefix === void 0 ? false : _ref7$includePrefix, _ref7$extendedZone = _ref7.extendedZone, extendedZone = _ref7$extendedZone === void 0 ? false : _ref7$extendedZone, _ref7$format = _ref7.format, format = _ref7$format === void 0 ? "extended" : _ref7$format, _ref7$precision = _ref7.precision, precision = _ref7$precision === void 0 ? "milliseconds" : _ref7$precision;
        if (!this.isValid) return null;
        precision = $c9ee9f81cdf9785c$var$normalizeUnit(precision);
        var c = includePrefix && $c9ee9f81cdf9785c$var$orderedUnits.indexOf(precision) >= 3 ? "T" : "";
        return c + $c9ee9f81cdf9785c$var$_toISOTime(this, format === "extended", suppressSeconds, suppressMilliseconds, includeOffset, extendedZone, precision);
    };
    _proto.toRFC2822 = function toRFC2822() {
        return $c9ee9f81cdf9785c$var$toTechFormat(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", false);
    };
    _proto.toHTTP = function toHTTP() {
        return $c9ee9f81cdf9785c$var$toTechFormat(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
    };
    _proto.toSQLDate = function toSQLDate() {
        if (!this.isValid) return null;
        return $c9ee9f81cdf9785c$var$_toISODate(this, true);
    };
    _proto.toSQLTime = function toSQLTime(_temp7) {
        var _ref8 = _temp7 === void 0 ? {} : _temp7, _ref8$includeOffset = _ref8.includeOffset, includeOffset = _ref8$includeOffset === void 0 ? true : _ref8$includeOffset, _ref8$includeZone = _ref8.includeZone, includeZone = _ref8$includeZone === void 0 ? false : _ref8$includeZone, _ref8$includeOffsetSp = _ref8.includeOffsetSpace, includeOffsetSpace = _ref8$includeOffsetSp === void 0 ? true : _ref8$includeOffsetSp;
        var fmt = "HH:mm:ss.SSS";
        if (includeZone || includeOffset) {
            if (includeOffsetSpace) fmt += " ";
            if (includeZone) fmt += "z";
            else if (includeOffset) fmt += "ZZ";
        }
        return $c9ee9f81cdf9785c$var$toTechFormat(this, fmt, true);
    };
    _proto.toSQL = function toSQL(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return null;
        return this.toSQLDate() + " " + this.toSQLTime(opts);
    };
    _proto.toString = function toString() {
        return this.isValid ? this.toISO() : $c9ee9f81cdf9785c$var$INVALID;
    };
    _proto[_Symbol$for] = function() {
        if (this.isValid) return "DateTime { ts: " + this.toISO() + ", zone: " + this.zone.name + ", locale: " + this.locale + " }";
        else return "DateTime { Invalid, reason: " + this.invalidReason + " }";
    };
    _proto.valueOf = function valueOf() {
        return this.toMillis();
    };
    _proto.toMillis = function toMillis() {
        return this.isValid ? this.ts : NaN;
    };
    _proto.toSeconds = function toSeconds() {
        return this.isValid ? this.ts / 1000 : NaN;
    };
    _proto.toUnixInteger = function toUnixInteger() {
        return this.isValid ? Math.floor(this.ts / 1000) : NaN;
    };
    _proto.toJSON = function toJSON() {
        return this.toISO();
    };
    _proto.toBSON = function toBSON() {
        return this.toJSDate();
    };
    _proto.toObject = function toObject(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return {};
        var base = $c9ee9f81cdf9785c$var$_extends({}, this.c);
        if (opts.includeConfig) {
            base.outputCalendar = this.outputCalendar;
            base.numberingSystem = this.loc.numberingSystem;
            base.locale = this.loc.locale;
        }
        return base;
    };
    _proto.toJSDate = function toJSDate() {
        return new Date(this.isValid ? this.ts : NaN);
    };
    _proto.diff = function diff(otherDateTime, unit, opts) {
        if (unit === void 0) unit = "milliseconds";
        if (opts === void 0) opts = {};
        if (!this.isValid || !otherDateTime.isValid) return $c9ee9f81cdf9785c$var$Duration.invalid("created by diffing an invalid DateTime");
        var durOpts = $c9ee9f81cdf9785c$var$_extends({
            locale: this.locale,
            numberingSystem: this.numberingSystem
        }, opts);
        var units = $c9ee9f81cdf9785c$var$maybeArray(unit).map($c9ee9f81cdf9785c$var$Duration.normalizeUnit), otherIsLater = otherDateTime.valueOf() > this.valueOf(), earlier = otherIsLater ? this : otherDateTime, later = otherIsLater ? otherDateTime : this, diffed = $c9ee9f81cdf9785c$var$_diff(earlier, later, units, durOpts);
        return otherIsLater ? diffed.negate() : diffed;
    };
    _proto.diffNow = function diffNow(unit, opts) {
        if (unit === void 0) unit = "milliseconds";
        if (opts === void 0) opts = {};
        return this.diff(DateTime.now(), unit, opts);
    };
    _proto.until = function until(otherDateTime) {
        return this.isValid ? $c9ee9f81cdf9785c$var$Interval.fromDateTimes(this, otherDateTime) : this;
    };
    _proto.hasSame = function hasSame(otherDateTime, unit, opts) {
        if (!this.isValid) return false;
        var inputMs = otherDateTime.valueOf();
        var adjustedToZone = this.setZone(otherDateTime.zone, {
            keepLocalTime: true
        });
        return adjustedToZone.startOf(unit, opts) <= inputMs && inputMs <= adjustedToZone.endOf(unit, opts);
    };
    _proto.equals = function equals(other) {
        return this.isValid && other.isValid && this.valueOf() === other.valueOf() && this.zone.equals(other.zone) && this.loc.equals(other.loc);
    };
    _proto.toRelative = function toRelative(options) {
        if (options === void 0) options = {};
        if (!this.isValid) return null;
        var base = options.base || DateTime.fromObject({}, {
            zone: this.zone
        }), padding = options.padding ? this < base ? -options.padding : options.padding : 0;
        var units = [
            "years",
            "months",
            "days",
            "hours",
            "minutes",
            "seconds"
        ];
        var unit = options.unit;
        if (Array.isArray(options.unit)) {
            units = options.unit;
            unit = undefined;
        }
        return $c9ee9f81cdf9785c$var$diffRelative(base, this.plus(padding), $c9ee9f81cdf9785c$var$_extends({}, options, {
            numeric: "always",
            units: units,
            unit: unit
        }));
    };
    _proto.toRelativeCalendar = function toRelativeCalendar(options) {
        if (options === void 0) options = {};
        if (!this.isValid) return null;
        return $c9ee9f81cdf9785c$var$diffRelative(options.base || DateTime.fromObject({}, {
            zone: this.zone
        }), this, $c9ee9f81cdf9785c$var$_extends({}, options, {
            numeric: "auto",
            units: [
                "years",
                "months",
                "days"
            ],
            calendary: true
        }));
    };
    DateTime.min = function min() {
        for(var _len = arguments.length, dateTimes = new Array(_len), _key = 0; _key < _len; _key++)dateTimes[_key] = arguments[_key];
        if (!dateTimes.every(DateTime.isDateTime)) throw new $c9ee9f81cdf9785c$var$InvalidArgumentError("min requires all arguments be DateTimes");
        return $c9ee9f81cdf9785c$var$bestBy(dateTimes, function(i) {
            return i.valueOf();
        }, Math.min);
    };
    DateTime.max = function max() {
        for(var _len2 = arguments.length, dateTimes = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)dateTimes[_key2] = arguments[_key2];
        if (!dateTimes.every(DateTime.isDateTime)) throw new $c9ee9f81cdf9785c$var$InvalidArgumentError("max requires all arguments be DateTimes");
        return $c9ee9f81cdf9785c$var$bestBy(dateTimes, function(i) {
            return i.valueOf();
        }, Math.max);
    };
    DateTime.fromFormatExplain = function fromFormatExplain(text, fmt, options) {
        if (options === void 0) options = {};
        var _options = options, _options$locale = _options.locale, locale = _options$locale === void 0 ? null : _options$locale, _options$numberingSys = _options.numberingSystem, numberingSystem = _options$numberingSys === void 0 ? null : _options$numberingSys, localeToUse = $c9ee9f81cdf9785c$var$Locale.fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        });
        return $c9ee9f81cdf9785c$var$explainFromTokens(localeToUse, text, fmt);
    };
    DateTime.fromStringExplain = function fromStringExplain(text, fmt, options) {
        if (options === void 0) options = {};
        return DateTime.fromFormatExplain(text, fmt, options);
    };
    DateTime.buildFormatParser = function buildFormatParser(fmt, options) {
        if (options === void 0) options = {};
        var _options2 = options, _options2$locale = _options2.locale, locale = _options2$locale === void 0 ? null : _options2$locale, _options2$numberingSy = _options2.numberingSystem, numberingSystem = _options2$numberingSy === void 0 ? null : _options2$numberingSy, localeToUse = $c9ee9f81cdf9785c$var$Locale.fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        });
        return new $c9ee9f81cdf9785c$var$TokenParser(localeToUse, fmt);
    };
    DateTime.fromFormatParser = function fromFormatParser(text, formatParser, opts) {
        if (opts === void 0) opts = {};
        if ($c9ee9f81cdf9785c$var$isUndefined(text) || $c9ee9f81cdf9785c$var$isUndefined(formatParser)) throw new $c9ee9f81cdf9785c$var$InvalidArgumentError("fromFormatParser requires an input string and a format parser");
        var _opts2 = opts, _opts2$locale = _opts2.locale, locale = _opts2$locale === void 0 ? null : _opts2$locale, _opts2$numberingSyste = _opts2.numberingSystem, numberingSystem = _opts2$numberingSyste === void 0 ? null : _opts2$numberingSyste, localeToUse = $c9ee9f81cdf9785c$var$Locale.fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        });
        if (!localeToUse.equals(formatParser.locale)) throw new $c9ee9f81cdf9785c$var$InvalidArgumentError("fromFormatParser called with a locale of " + localeToUse + ", " + ("but the format parser was created for " + formatParser.locale));
        var _formatParser$explain = formatParser.explainFromTokens(text), result = _formatParser$explain.result, zone = _formatParser$explain.zone, specificOffset = _formatParser$explain.specificOffset, invalidReason = _formatParser$explain.invalidReason;
        if (invalidReason) return DateTime.invalid(invalidReason);
        else return $c9ee9f81cdf9785c$var$parseDataToDateTime(result, zone, opts, "format " + formatParser.format, text, specificOffset);
    };
    $c9ee9f81cdf9785c$var$_createClass(DateTime, [
        {
            key: "isValid",
            get: function get() {
                return this.invalid === null;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.invalid ? this.invalid.reason : null;
            }
        },
        {
            key: "invalidExplanation",
            get: function get() {
                return this.invalid ? this.invalid.explanation : null;
            }
        },
        {
            key: "locale",
            get: function get() {
                return this.isValid ? this.loc.locale : null;
            }
        },
        {
            key: "numberingSystem",
            get: function get() {
                return this.isValid ? this.loc.numberingSystem : null;
            }
        },
        {
            key: "outputCalendar",
            get: function get() {
                return this.isValid ? this.loc.outputCalendar : null;
            }
        },
        {
            key: "zone",
            get: function get() {
                return this._zone;
            }
        },
        {
            key: "zoneName",
            get: function get() {
                return this.isValid ? this.zone.name : null;
            }
        },
        {
            key: "year",
            get: function get() {
                return this.isValid ? this.c.year : NaN;
            }
        },
        {
            key: "quarter",
            get: function get() {
                return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
            }
        },
        {
            key: "month",
            get: function get() {
                return this.isValid ? this.c.month : NaN;
            }
        },
        {
            key: "day",
            get: function get() {
                return this.isValid ? this.c.day : NaN;
            }
        },
        {
            key: "hour",
            get: function get() {
                return this.isValid ? this.c.hour : NaN;
            }
        },
        {
            key: "minute",
            get: function get() {
                return this.isValid ? this.c.minute : NaN;
            }
        },
        {
            key: "second",
            get: function get() {
                return this.isValid ? this.c.second : NaN;
            }
        },
        {
            key: "millisecond",
            get: function get() {
                return this.isValid ? this.c.millisecond : NaN;
            }
        },
        {
            key: "weekYear",
            get: function get() {
                return this.isValid ? $c9ee9f81cdf9785c$var$possiblyCachedWeekData(this).weekYear : NaN;
            }
        },
        {
            key: "weekNumber",
            get: function get() {
                return this.isValid ? $c9ee9f81cdf9785c$var$possiblyCachedWeekData(this).weekNumber : NaN;
            }
        },
        {
            key: "weekday",
            get: function get() {
                return this.isValid ? $c9ee9f81cdf9785c$var$possiblyCachedWeekData(this).weekday : NaN;
            }
        },
        {
            key: "isWeekend",
            get: function get() {
                return this.isValid && this.loc.getWeekendDays().includes(this.weekday);
            }
        },
        {
            key: "localWeekday",
            get: function get() {
                return this.isValid ? $c9ee9f81cdf9785c$var$possiblyCachedLocalWeekData(this).weekday : NaN;
            }
        },
        {
            key: "localWeekNumber",
            get: function get() {
                return this.isValid ? $c9ee9f81cdf9785c$var$possiblyCachedLocalWeekData(this).weekNumber : NaN;
            }
        },
        {
            key: "localWeekYear",
            get: function get() {
                return this.isValid ? $c9ee9f81cdf9785c$var$possiblyCachedLocalWeekData(this).weekYear : NaN;
            }
        },
        {
            key: "ordinal",
            get: function get() {
                return this.isValid ? $c9ee9f81cdf9785c$var$gregorianToOrdinal(this.c).ordinal : NaN;
            }
        },
        {
            key: "monthShort",
            get: function get() {
                return this.isValid ? $c9ee9f81cdf9785c$var$Info.months("short", {
                    locObj: this.loc
                })[this.month - 1] : null;
            }
        },
        {
            key: "monthLong",
            get: function get() {
                return this.isValid ? $c9ee9f81cdf9785c$var$Info.months("long", {
                    locObj: this.loc
                })[this.month - 1] : null;
            }
        },
        {
            key: "weekdayShort",
            get: function get() {
                return this.isValid ? $c9ee9f81cdf9785c$var$Info.weekdays("short", {
                    locObj: this.loc
                })[this.weekday - 1] : null;
            }
        },
        {
            key: "weekdayLong",
            get: function get() {
                return this.isValid ? $c9ee9f81cdf9785c$var$Info.weekdays("long", {
                    locObj: this.loc
                })[this.weekday - 1] : null;
            }
        },
        {
            key: "offset",
            get: function get() {
                return this.isValid ? +this.o : NaN;
            }
        },
        {
            key: "offsetNameShort",
            get: function get() {
                if (this.isValid) return this.zone.offsetName(this.ts, {
                    format: "short",
                    locale: this.locale
                });
                else return null;
            }
        },
        {
            key: "offsetNameLong",
            get: function get() {
                if (this.isValid) return this.zone.offsetName(this.ts, {
                    format: "long",
                    locale: this.locale
                });
                else return null;
            }
        },
        {
            key: "isOffsetFixed",
            get: function get() {
                return this.isValid ? this.zone.isUniversal : null;
            }
        },
        {
            key: "isInDST",
            get: function get() {
                if (this.isOffsetFixed) return false;
                else return this.offset > this.set({
                    month: 1,
                    day: 1
                }).offset || this.offset > this.set({
                    month: 5
                }).offset;
            }
        },
        {
            key: "isInLeapYear",
            get: function get() {
                return $c9ee9f81cdf9785c$var$isLeapYear(this.year);
            }
        },
        {
            key: "daysInMonth",
            get: function get() {
                return $c9ee9f81cdf9785c$var$daysInMonth(this.year, this.month);
            }
        },
        {
            key: "daysInYear",
            get: function get() {
                return this.isValid ? $c9ee9f81cdf9785c$var$daysInYear(this.year) : NaN;
            }
        },
        {
            key: "weeksInWeekYear",
            get: function get() {
                return this.isValid ? $c9ee9f81cdf9785c$var$weeksInWeekYear(this.weekYear) : NaN;
            }
        },
        {
            key: "weeksInLocalWeekYear",
            get: function get() {
                return this.isValid ? $c9ee9f81cdf9785c$var$weeksInWeekYear(this.localWeekYear, this.loc.getMinDaysInFirstWeek(), this.loc.getStartOfWeek()) : NaN;
            }
        }
    ], [
        {
            key: "DATE_SHORT",
            get: function get() {
                return $c9ee9f81cdf9785c$var$DATE_SHORT;
            }
        },
        {
            key: "DATE_MED",
            get: function get() {
                return $c9ee9f81cdf9785c$var$DATE_MED;
            }
        },
        {
            key: "DATE_MED_WITH_WEEKDAY",
            get: function get() {
                return $c9ee9f81cdf9785c$var$DATE_MED_WITH_WEEKDAY;
            }
        },
        {
            key: "DATE_FULL",
            get: function get() {
                return $c9ee9f81cdf9785c$var$DATE_FULL;
            }
        },
        {
            key: "DATE_HUGE",
            get: function get() {
                return $c9ee9f81cdf9785c$var$DATE_HUGE;
            }
        },
        {
            key: "TIME_SIMPLE",
            get: function get() {
                return $c9ee9f81cdf9785c$var$TIME_SIMPLE;
            }
        },
        {
            key: "TIME_WITH_SECONDS",
            get: function get() {
                return $c9ee9f81cdf9785c$var$TIME_WITH_SECONDS;
            }
        },
        {
            key: "TIME_WITH_SHORT_OFFSET",
            get: function get() {
                return $c9ee9f81cdf9785c$var$TIME_WITH_SHORT_OFFSET;
            }
        },
        {
            key: "TIME_WITH_LONG_OFFSET",
            get: function get() {
                return $c9ee9f81cdf9785c$var$TIME_WITH_LONG_OFFSET;
            }
        },
        {
            key: "TIME_24_SIMPLE",
            get: function get() {
                return $c9ee9f81cdf9785c$var$TIME_24_SIMPLE;
            }
        },
        {
            key: "TIME_24_WITH_SECONDS",
            get: function get() {
                return $c9ee9f81cdf9785c$var$TIME_24_WITH_SECONDS;
            }
        },
        {
            key: "TIME_24_WITH_SHORT_OFFSET",
            get: function get() {
                return $c9ee9f81cdf9785c$var$TIME_24_WITH_SHORT_OFFSET;
            }
        },
        {
            key: "TIME_24_WITH_LONG_OFFSET",
            get: function get() {
                return $c9ee9f81cdf9785c$var$TIME_24_WITH_LONG_OFFSET;
            }
        },
        {
            key: "DATETIME_SHORT",
            get: function get() {
                return $c9ee9f81cdf9785c$var$DATETIME_SHORT;
            }
        },
        {
            key: "DATETIME_SHORT_WITH_SECONDS",
            get: function get() {
                return $c9ee9f81cdf9785c$var$DATETIME_SHORT_WITH_SECONDS;
            }
        },
        {
            key: "DATETIME_MED",
            get: function get() {
                return $c9ee9f81cdf9785c$var$DATETIME_MED;
            }
        },
        {
            key: "DATETIME_MED_WITH_SECONDS",
            get: function get() {
                return $c9ee9f81cdf9785c$var$DATETIME_MED_WITH_SECONDS;
            }
        },
        {
            key: "DATETIME_MED_WITH_WEEKDAY",
            get: function get() {
                return $c9ee9f81cdf9785c$var$DATETIME_MED_WITH_WEEKDAY;
            }
        },
        {
            key: "DATETIME_FULL",
            get: function get() {
                return $c9ee9f81cdf9785c$var$DATETIME_FULL;
            }
        },
        {
            key: "DATETIME_FULL_WITH_SECONDS",
            get: function get() {
                return $c9ee9f81cdf9785c$var$DATETIME_FULL_WITH_SECONDS;
            }
        },
        {
            key: "DATETIME_HUGE",
            get: function get() {
                return $c9ee9f81cdf9785c$var$DATETIME_HUGE;
            }
        },
        {
            key: "DATETIME_HUGE_WITH_SECONDS",
            get: function get() {
                return $c9ee9f81cdf9785c$var$DATETIME_HUGE_WITH_SECONDS;
            }
        }
    ]);
    return DateTime;
}(Symbol.for("nodejs.util.inspect.custom"));
function $c9ee9f81cdf9785c$var$friendlyDateTime(dateTimeish) {
    if ($c9ee9f81cdf9785c$var$DateTime.isDateTime(dateTimeish)) return dateTimeish;
    else if (dateTimeish && dateTimeish.valueOf && $c9ee9f81cdf9785c$var$isNumber(dateTimeish.valueOf())) return $c9ee9f81cdf9785c$var$DateTime.fromJSDate(dateTimeish);
    else if (dateTimeish && typeof dateTimeish === "object") return $c9ee9f81cdf9785c$var$DateTime.fromObject(dateTimeish);
    else throw new $c9ee9f81cdf9785c$var$InvalidArgumentError("Unknown datetime argument: " + dateTimeish + ", of type " + typeof dateTimeish);
}
var $c9ee9f81cdf9785c$var$VERSION = "3.7.2";
$c9ee9f81cdf9785c$exports.DateTime = $c9ee9f81cdf9785c$var$DateTime;
$c9ee9f81cdf9785c$exports.Duration = $c9ee9f81cdf9785c$var$Duration;
$c9ee9f81cdf9785c$exports.FixedOffsetZone = $c9ee9f81cdf9785c$var$FixedOffsetZone;
$c9ee9f81cdf9785c$exports.IANAZone = $c9ee9f81cdf9785c$var$IANAZone;
$c9ee9f81cdf9785c$exports.Info = $c9ee9f81cdf9785c$var$Info;
$c9ee9f81cdf9785c$exports.Interval = $c9ee9f81cdf9785c$var$Interval;
$c9ee9f81cdf9785c$exports.InvalidZone = $c9ee9f81cdf9785c$var$InvalidZone;
$c9ee9f81cdf9785c$exports.Settings = $c9ee9f81cdf9785c$var$Settings;
$c9ee9f81cdf9785c$exports.SystemZone = $c9ee9f81cdf9785c$var$SystemZone;
$c9ee9f81cdf9785c$exports.VERSION = $c9ee9f81cdf9785c$var$VERSION;
$c9ee9f81cdf9785c$exports.Zone = $c9ee9f81cdf9785c$var$Zone;



const $8c9b064db3f235f7$export$6b8b6613328ae8b4 = function() {
    const lokalizacjaInput = /** @type {HTMLInputElement} */ document.getElementById("lokalizacja");
    const addressInput = /** @type {HTMLInputElement} */ document.getElementById("address");
    const textAddress = (lokalizacjaInput?.value || "").trim();
    const jsonAddress = addressInput?.value || "";
    var ret = textAddress.length > 10;
    var address = JSON.parse(jsonAddress);
    ret = address.city?.length > 2 && ret;
    ret = address.lat > 0 && ret;
    ret = address.lng > 0 && ret;
    if (!ret && textAddress.length > 0) {
        const addressHint = document.getElementById("addressHint");
        if (addressHint) {
            addressHint.textContent = "Podaj adres lub wska\u017C go na mapie. Ew. uwagi dotycz\u0105ce lokalizacji napisz w polu komentarz poni\u017Cej";
            addressHint.classList.add("hint");
        }
    }
    if (!ret && lokalizacjaInput) lokalizacjaInput.classList.add("error");
    return ret;
};
const $8c9b064db3f235f7$export$72a04a8c721c2b96 = function(item, minLength) {
    if (!item) return false;
    const len = item.value.trim().length;
    if (len > minLength) return true;
    item.classList.add("error");
    return false;
};
const $8c9b064db3f235f7$export$87c90538599656c5 = function(item, regex) {
    if (!item) return false;
    if (item.value.trim().match(regex)) return true;
    item.classList.add("error");
    return false;
};
const $8c9b064db3f235f7$export$a0f57aadb71fee09 = function() {
    const commentInput = /** @type {HTMLTextAreaElement} */ document.getElementById("comment");
    if (!commentInput) return false;
    const comment = (commentInput.value || "").trim();
    if (comment.length > 10) return true;
    commentInput.classList.add("error");
    commentInput.placeholder = "Wybierz rodzaj wykroczenia z listy poni\u017Cej, albo opisz je w tym polu";
    return false;
};
function $8c9b064db3f235f7$export$fa98529299c8c4f2() {
    const commentInput = /** @type {HTMLTextAreaElement} */ document.getElementById('comment');
    if (commentInput) commentInput.addEventListener('focusout', function() {
        const comment = this.value ?? '';
        const witnessElement = /** @type {HTMLInputElement} */ document.getElementById('witness');
        const witnessChecked = witnessElement?.checked;
        if (witnessChecked) return;
        const driver = comment.search(/(?:^|[^A-Za-z0-9_])kier\w*/i) >= 0;
        let warningMsg = null;
        if (driver) warningMsg = "Wspominasz kierowc\u0119 w komentarzu.";
        const witness = comment.search(/(?:^|[^A-Za-z0-9_])[sś]wiadk\w*/i) >= 0;
        if (witness) warningMsg = "U\u017Cywasz s\u0142owa \u201E\u015Bwiadek\u201D w komentarzu.";
        const mr = comment.search(/(?:^|[^A-Za-z0-9_])pani?/i) >= 0;
        if (mr) warningMsg = "U\u017Cywasz s\u0142owa \u201Epan/i\u201D w komentarzu.";
        if (warningMsg) (0, $d0b61ef20bcb31bc$export$491112666e282270)(`<p>${warningMsg}</p><a href="#statements">Sprawd\u{17A} opcj\u{119} \u{201E}\u{15B}wiadek momentu parkowania\u{201D}</a>`);
    });
}
const $8c9b064db3f235f7$export$71fc35aaad18fe14 = function() {
    const datetimeInput = /** @type {HTMLInputElement} */ document.getElementById('datetime');
    datetimeInput.classList.remove("error");
    const dt = (0, $c9ee9f81cdf9785c$exports.DateTime).fromISO(datetimeInput?.value || "");
    if (dt > (0, $c9ee9f81cdf9785c$exports.DateTime).now()) {
        if (datetimeInput) datetimeInput.classList.add("error");
        (0, $d0b61ef20bcb31bc$export$a3bc9b8ed74fc)("Data nie mo\u017Ce by\u0107 z przysz\u0142o\u015Bci");
        return false;
    }
    const sevenMonthsAgo = (0, $c9ee9f81cdf9785c$exports.DateTime).now().minus({
        months: 7
    });
    if (dt < sevenMonthsAgo) {
        if (datetimeInput) datetimeInput.classList.add("error");
        (0, $d0b61ef20bcb31bc$export$a3bc9b8ed74fc)("Wykroczenie starsze ni\u017C 7 miesi\u0119cy. SM/Policja nie zd\u0105\u017Cy zareagowa\u0107!");
        return false;
    }
    if (!dt.isValid) datetimeInput.classList.add("error");
    return dt.isValid;
};


const $741b4ae437a2c67e$var$nameElement = /** @type {HTMLInputElement} */ document.getElementById("name");
const $741b4ae437a2c67e$var$addressElement = /** @type {HTMLInputElement} */ document.getElementById("address");
const $741b4ae437a2c67e$var$edeliveryElement = /** @type {HTMLInputElement} */ document.getElementById("edelivery");
function $741b4ae437a2c67e$var$validateRegisterForm() {
    let ret = (0, $8c9b064db3f235f7$export$87c90538599656c5)($741b4ae437a2c67e$var$nameElement, /^(\S{2,5}\s)?\S{2,20}\s[\S -]{3,40}$/i);
    const addressCheck = (0, $8c9b064db3f235f7$export$87c90538599656c5)($741b4ae437a2c67e$var$addressElement, /^.{3,50}\d.{3,40}\D$/i);
    ret = addressCheck && ret;
    ret = (0, $8c9b064db3f235f7$export$87c90538599656c5)($741b4ae437a2c67e$var$edeliveryElement, /(^[A-Z]{2}:[A-Z]{2}-(\d{5}-){2}[A-Z]{5}-\d{2})$|^$/i) && ret;
    if (!ret) {
        const errorElement = document.querySelector(".error");
        if (errorElement) errorElement.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
        });
    }
    if (!addressCheck) {
        const addressLabel = document.querySelector('label[for="address"]');
        if (addressLabel) addressLabel.textContent = 'Poprawny format to: "Ulica numer domu/mieszkania, Miasto"';
    }
    return ret;
}
document.addEventListener("DOMContentLoaded", ()=>{
    if (!document.querySelector(".register")) return;
    if ($741b4ae437a2c67e$var$nameElement) $741b4ae437a2c67e$var$nameElement.addEventListener("change", function() {
        $741b4ae437a2c67e$var$nameElement.classList.remove("error");
    });
    if ($741b4ae437a2c67e$var$addressElement) $741b4ae437a2c67e$var$addressElement.addEventListener("change", function() {
        $741b4ae437a2c67e$var$addressElement.classList.remove("error");
    });
    const submitButton = document.getElementById("register-submit");
    if (submitButton) submitButton.addEventListener("click", function() {
        if ($741b4ae437a2c67e$var$validateRegisterForm()) {
            const form = /** @type {HTMLFormElement} */ document.getElementById("register-form");
            if (form) form.submit();
        } else submitButton.classList.remove('disabled');
    });
});





function $2ee8d2c9ccbd6c4e$export$5f747a46dc0eb6ee() {
    return typeof window !== 'undefined' && !!window.PublicKeyCredential;
}
function $2ee8d2c9ccbd6c4e$export$f0be84e48fcc9f86(error) {
    return error?.name === 'NotAllowedError' || error?.name === 'AbortError';
}
async function $2ee8d2c9ccbd6c4e$export$9ef244788981a19d() {
    if (!$2ee8d2c9ccbd6c4e$export$5f747a46dc0eb6ee() || !window.PublicKeyCredential.isConditionalMediationAvailable) return false;
    try {
        return await window.PublicKeyCredential.isConditionalMediationAvailable();
    } catch  {
        return false;
    }
}
function $2ee8d2c9ccbd6c4e$var$b64uToBuf(base64url) {
    const base64 = base64url.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64.padEnd(base64.length + (4 - base64.length % 4) % 4, '=');
    const binary = atob(padded);
    const bytes = new Uint8Array(binary.length);
    for(let i = 0; i < binary.length; i++)bytes[i] = binary.charCodeAt(i);
    return bytes.buffer;
}
function $2ee8d2c9ccbd6c4e$var$bufToB64u(buffer) {
    const bytes = new Uint8Array(buffer);
    let binary = '';
    for(let i = 0; i < bytes.byteLength; i++)binary += String.fromCharCode(bytes[i]);
    return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
async function $2ee8d2c9ccbd6c4e$export$f3196ed212209546() {
    const options = await new (0, $2e0d7d2a9ac04488$export$2e2bcd8739ae039)('/api/passkey/register-options').post({});
    const publicKey = {
        ...options.publicKey,
        challenge: $2ee8d2c9ccbd6c4e$var$b64uToBuf(options.publicKey.challenge),
        user: {
            ...options.publicKey.user,
            id: $2ee8d2c9ccbd6c4e$var$b64uToBuf(options.publicKey.user.id)
        },
        excludeCredentials: (options.publicKey.excludeCredentials || []).map((cred)=>({
                ...cred,
                id: $2ee8d2c9ccbd6c4e$var$b64uToBuf(cred.id)
            }))
    };
    const credential = await navigator.credentials.create({
        publicKey: publicKey
    });
    const body = {
        id: credential.id,
        clientDataJSON: $2ee8d2c9ccbd6c4e$var$bufToB64u(credential.response.clientDataJSON),
        attestationObject: $2ee8d2c9ccbd6c4e$var$bufToB64u(credential.response.attestationObject),
        transports: credential.response.getTransports ? credential.response.getTransports() : []
    };
    const result = await new (0, $2e0d7d2a9ac04488$export$2e2bcd8739ae039)('/api/passkey/register-verify').post(body);
    return result.passkeys;
}
async function $2ee8d2c9ccbd6c4e$export$96fc8808ce824911({ mediation: mediation, signal: signal } = {}) {
    const options = await new (0, $2e0d7d2a9ac04488$export$2e2bcd8739ae039)('/api/passkey/login-options').post({});
    const publicKey = {
        ...options.publicKey,
        challenge: $2ee8d2c9ccbd6c4e$var$b64uToBuf(options.publicKey.challenge),
        allowCredentials: (options.publicKey.allowCredentials || []).map((cred)=>({
                ...cred,
                id: $2ee8d2c9ccbd6c4e$var$b64uToBuf(cred.id)
            }))
    };
    const getOptions = {
        publicKey: publicKey
    };
    if (mediation) getOptions.mediation = mediation;
    if (signal) getOptions.signal = signal;
    const assertion = await navigator.credentials.get(getOptions);
    const body = {
        id: assertion.id,
        clientDataJSON: $2ee8d2c9ccbd6c4e$var$bufToB64u(assertion.response.clientDataJSON),
        authenticatorData: $2ee8d2c9ccbd6c4e$var$bufToB64u(assertion.response.authenticatorData),
        signature: $2ee8d2c9ccbd6c4e$var$bufToB64u(assertion.response.signature),
        userHandle: assertion.response.userHandle ? $2ee8d2c9ccbd6c4e$var$bufToB64u(assertion.response.userHandle) : null
    };
    const result = await new (0, $2e0d7d2a9ac04488$export$2e2bcd8739ae039)('/api/passkey/login-verify').post(body);
    return result.customToken;
}


function $047ae47ae03f1941$var$renderList(section, passkeys) {
    const list = section.querySelector('#passkeys-list');
    if (!list) return;
    if (!passkeys.length) {
        list.innerHTML = '<li class="passkeys-empty muted">Nie masz jeszcze \u017Cadnego passkeya.</li>';
        return;
    }
    // Same .connected-app markup as /mcp's "Połączone aplikacje" list.
    list.innerHTML = passkeys.map((pk)=>`
    <li class="connected-app" data-id="${pk.credential_id}">
      <span class="connected-app-name">${pk.label}</span>
      <span class="connected-app-meta">dodano ${$047ae47ae03f1941$var$formatDate(pk.created_at)}${pk.last_used_at ? `, ostatnio u\u{17C}yto ${$047ae47ae03f1941$var$formatDate(pk.last_used_at)}` : ''}</span>
      <button type="button" class="button small passkey-remove" data-id="${pk.credential_id}">Usu\u{144}</button>
    </li>
  `).join('');
}
function $047ae47ae03f1941$var$formatDate(iso) {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return iso;
    return d.toLocaleDateString('pl-PL');
}
async function $047ae47ae03f1941$var$removePasskey(section, credentialId) {
    if (!window.confirm("Usun\u0105\u0107 ten passkey?")) return;
    await new (0, $2e0d7d2a9ac04488$export$2e2bcd8739ae039)(`/api/passkey/${encodeURIComponent(credentialId)}`).delete();
    const item = section.querySelector(`.connected-app[data-id="${credentialId}"]`);
    item?.remove();
    const list = section.querySelector('#passkeys-list');
    if (list && !list.querySelector('.connected-app[data-id]')) list.innerHTML = '<li class="passkeys-empty muted">Nie masz jeszcze \u017Cadnego passkeya.</li>';
    (0, $d0b61ef20bcb31bc$export$a8ecead220dd38a6)("Passkey usuni\u0119ty.");
}
document.addEventListener('DOMContentLoaded', ()=>{
    const section = document.getElementById('passkeys-section');
    if (!section) return;
    if (!(0, $2ee8d2c9ccbd6c4e$export$5f747a46dc0eb6ee)()) {
        section.hidden = true;
        return;
    }
    const addButton = section.querySelector('#passkey-add');
    if (addButton) addButton.hidden = false;
    addButton?.addEventListener('click', async ()=>{
        try {
            const passkeys = await (0, $2ee8d2c9ccbd6c4e$export$f3196ed212209546)();
            $047ae47ae03f1941$var$renderList(section, passkeys);
            (0, $d0b61ef20bcb31bc$export$a8ecead220dd38a6)('Passkey dodany.');
        } catch (e) {
            // A cancelled/dismissed picker (Esc, timeout) is not an error worth showing.
            if ((0, $2ee8d2c9ccbd6c4e$export$f0be84e48fcc9f86)(e)) return;
            (0, $d0b61ef20bcb31bc$export$a3bc9b8ed74fc)(e?.message ?? "Nie uda\u0142o si\u0119 doda\u0107 passkeya");
        }
    });
    section.addEventListener('click', async (event)=>{
        const button = event.target.closest('.passkey-remove');
        if (!button) return;
        try {
            await $047ae47ae03f1941$var$removePasskey(section, button.dataset.id);
        } catch (e) {
            (0, $d0b61ef20bcb31bc$export$a3bc9b8ed74fc)(e?.message ?? "Nie uda\u0142o si\u0119 usun\u0105\u0107 passkeya");
        }
    });
});


document.addEventListener('DOMContentLoaded', ()=>{
    const input = document.getElementById('delete-account-email');
    const submit = document.getElementById('delete-account-submit');
    if (!input || !submit) return;
    const expected = (input.dataset.expected || '').trim().toLowerCase();
    input.addEventListener('input', ()=>{
        submit.disabled = input.value.trim().toLowerCase() !== expected;
    });
});


document.addEventListener("DOMContentLoaded", ()=>{
    if (!document.querySelector(".przepisy")) return;
    const hash = window.location.hash;
    if (!hash) return;
    const hashElement = document.querySelector(hash);
    if (hashElement) setTimeout(function() {
        hashElement.scrollIntoView({
            behavior: 'smooth'
        });
    }, 100);
});


document.addEventListener("DOMContentLoaded", ()=>{
    if (!document.querySelector(".start-page")) return;
    _paq.push([
        'trackEvent',
        'Navigation',
        'start'
    ]);
});


var $861296feb2339393$exports = {};
!/**
 * Highcharts JS v11.4.8 (2024-08-29)
 *
 * (c) 2009-2024 Torstein Honsi
 *
 * License: www.highcharts.com/license
 */ function(t, e) {
    $861296feb2339393$exports ? (e.default = e, $861296feb2339393$exports = t && t.document ? e(t) : e) : "function" == typeof define && define.amd ? define("highcharts/highcharts", function() {
        return e(t);
    }) : (t.Highcharts && t.Highcharts.error(16, !0), t.Highcharts = e(t));
}("undefined" != typeof window ? window : $861296feb2339393$exports, function(t) {
    "use strict";
    var e = {};
    function i(e, i, s, r) {
        !e.hasOwnProperty(i) && (e[i] = r.apply(null, s), t && "function" == typeof CustomEvent && t.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", {
            detail: {
                path: i,
                module: e[i]
            }
        })));
    }
    return i(e, "Core/Globals.js", [], function() {
        var e, i;
        return (i = e || (e = {})).SVG_NS = "http://www.w3.org/2000/svg", i.product = "Highcharts", i.version = "11.4.8", i.win = void 0 !== t ? t : {}, i.doc = i.win.document, i.svg = i.doc && i.doc.createElementNS && !!i.doc.createElementNS(i.SVG_NS, "svg").createSVGRect, i.userAgent = i.win.navigator && i.win.navigator.userAgent || "", i.isChrome = i.win.chrome, i.isFirefox = -1 !== i.userAgent.indexOf("Firefox"), i.isMS = /(edge|msie|trident)/i.test(i.userAgent) && !i.win.opera, i.isSafari = !i.isChrome && -1 !== i.userAgent.indexOf("Safari"), i.isTouchDevice = /(Mobile|Android|Windows Phone)/.test(i.userAgent), i.isWebKit = -1 !== i.userAgent.indexOf("AppleWebKit"), i.deg2rad = 2 * Math.PI / 360, i.hasBidiBug = i.isFirefox && 4 > parseInt(i.userAgent.split("Firefox/")[1], 10), i.marginNames = [
            "plotTop",
            "marginRight",
            "marginBottom",
            "plotLeft"
        ], i.noop = function() {}, i.supportsPassiveEvents = function() {
            let t = !1;
            if (!i.isMS) {
                let e = Object.defineProperty({}, "passive", {
                    get: function() {
                        t = !0;
                    }
                });
                i.win.addEventListener && i.win.removeEventListener && (i.win.addEventListener("testPassive", i.noop, e), i.win.removeEventListener("testPassive", i.noop, e));
            }
            return t;
        }(), i.charts = [], i.composed = [], i.dateFormats = {}, i.seriesTypes = {}, i.symbolSizes = {}, i.chartCount = 0, e;
    }), i(e, "Core/Utilities.js", [
        e["Core/Globals.js"]
    ], function(t) {
        let e;
        let { charts: i, doc: s, win: r } = t;
        function o(e, i, s, n) {
            let a = i ? "Highcharts error" : "Highcharts warning";
            32 === e && (e = `${a}: Deprecated member`);
            let h = p(e), l = h ? `${a} #${e}: www.highcharts.com/errors/${e}/` : e.toString();
            if (void 0 !== n) {
                let t = "";
                h && (l += "?"), C(n, function(e, i) {
                    t += `
 - ${i}: ${e}`, h && (l += encodeURI(i) + "=" + encodeURI(e));
                }), l += t;
            }
            M(t, "displayError", {
                chart: s,
                code: e,
                message: l,
                params: n
            }, function() {
                if (i) throw Error(l);
                r.console && -1 === o.messages.indexOf(l) && console.warn(l);
            }), o.messages.push(l);
        }
        function n(t, e) {
            return parseInt(t, e || 10);
        }
        function a(t) {
            return "string" == typeof t;
        }
        function h(t) {
            let e = Object.prototype.toString.call(t);
            return "[object Array]" === e || "[object Array Iterator]" === e;
        }
        function l(t, e) {
            return !!t && "object" == typeof t && (!e || !h(t));
        }
        function d(t) {
            return l(t) && "number" == typeof t.nodeType;
        }
        function c(t) {
            let e = t && t.constructor;
            return !!(l(t, !0) && !d(t) && e && e.name && "Object" !== e.name);
        }
        function p(t) {
            return "number" == typeof t && !isNaN(t) && t < 1 / 0 && t > -1 / 0;
        }
        function u(t) {
            return null != t;
        }
        function g(t, e, i) {
            let s;
            let r = a(e) && !u(i), o = (e, i)=>{
                u(e) ? t.setAttribute(i, e) : r ? (s = t.getAttribute(i)) || "class" !== i || (s = t.getAttribute(i + "Name")) : t.removeAttribute(i);
            };
            return a(e) ? o(i, e) : C(e, o), s;
        }
        function f(t) {
            return h(t) ? t : [
                t
            ];
        }
        function m(t, e) {
            let i;
            for(i in t || (t = {}), e)t[i] = e[i];
            return t;
        }
        function x() {
            let t = arguments, e = t.length;
            for(let i = 0; i < e; i++){
                let e = t[i];
                if (null != e) return e;
            }
        }
        function y(t, e) {
            m(t.style, e);
        }
        function b(t) {
            return Math.pow(10, Math.floor(Math.log(t) / Math.LN10));
        }
        function v(t, e) {
            return t > 1e14 ? t : parseFloat(t.toPrecision(e || 14));
        }
        (o || (o = {})).messages = [], Math.easeInOutSine = function(t) {
            return -0.5 * (Math.cos(Math.PI * t) - 1);
        };
        let S = Array.prototype.find ? function(t, e) {
            return t.find(e);
        } : function(t, e) {
            let i;
            let s = t.length;
            for(i = 0; i < s; i++)if (e(t[i], i)) return t[i];
        };
        function C(t, e, i) {
            for(let s in t)Object.hasOwnProperty.call(t, s) && e.call(i || t[s], t[s], s, t);
        }
        function k(t, e, i) {
            function s(e, i) {
                let s = t.removeEventListener;
                s && s.call(t, e, i, !1);
            }
            function r(i) {
                let r, o;
                t.nodeName && (e ? (r = {})[e] = !0 : r = i, C(r, function(t, e) {
                    if (i[e]) for(o = i[e].length; o--;)s(e, i[e][o].fn);
                }));
            }
            let o = "function" == typeof t && t.prototype || t;
            if (Object.hasOwnProperty.call(o, "hcEvents")) {
                let t = o.hcEvents;
                if (e) {
                    let o = t[e] || [];
                    i ? (t[e] = o.filter(function(t) {
                        return i !== t.fn;
                    }), s(e, i)) : (r(t), t[e] = []);
                } else r(t), delete o.hcEvents;
            }
        }
        function M(e, i, r, o) {
            if (r = r || {}, s.createEvent && (e.dispatchEvent || e.fireEvent && e !== t)) {
                let t = s.createEvent("Events");
                t.initEvent(i, !0, !0), r = m(t, r), e.dispatchEvent ? e.dispatchEvent(r) : e.fireEvent(i, r);
            } else if (e.hcEvents) {
                r.target || m(r, {
                    preventDefault: function() {
                        r.defaultPrevented = !0;
                    },
                    target: e,
                    type: i
                });
                let t = [], s = e, o = !1;
                for(; s.hcEvents;)Object.hasOwnProperty.call(s, "hcEvents") && s.hcEvents[i] && (t.length && (o = !0), t.unshift.apply(t, s.hcEvents[i])), s = Object.getPrototypeOf(s);
                o && t.sort((t, e)=>t.order - e.order), t.forEach((t)=>{
                    !1 === t.fn.call(e, r) && r.preventDefault();
                });
            }
            o && !r.defaultPrevented && o.call(e, r);
        }
        C({
            map: "map",
            each: "forEach",
            grep: "filter",
            reduce: "reduce",
            some: "some"
        }, function(e, i) {
            t[i] = function(t) {
                return o(32, !1, void 0, {
                    [`Highcharts.${i}`]: `use Array.${e}`
                }), Array.prototype[e].apply(t, [].slice.call(arguments, 1));
            };
        });
        let w = function() {
            let t = Math.random().toString(36).substring(2, 9) + "-", i = 0;
            return function() {
                return "highcharts-" + (e ? "" : t) + i++;
            };
        }();
        return r.jQuery && (r.jQuery.fn.highcharts = function() {
            let e = [].slice.call(arguments);
            if (this[0]) return e[0] ? (new t[a(e[0]) ? e.shift() : "Chart"](this[0], e[0], e[1]), this) : i[g(this[0], "data-highcharts-chart")];
        }), {
            addEvent: function(e, i, s, r = {}) {
                let o = "function" == typeof e && e.prototype || e;
                Object.hasOwnProperty.call(o, "hcEvents") || (o.hcEvents = {});
                let n = o.hcEvents;
                t.Point && e instanceof t.Point && e.series && e.series.chart && (e.series.chart.runTrackerClick = !0);
                let a = e.addEventListener;
                a && a.call(e, i, s, !!t.supportsPassiveEvents && {
                    passive: void 0 === r.passive ? -1 !== i.indexOf("touch") : r.passive,
                    capture: !1
                }), n[i] || (n[i] = []);
                let h = {
                    fn: s,
                    order: "number" == typeof r.order ? r.order : 1 / 0
                };
                return n[i].push(h), n[i].sort((t, e)=>t.order - e.order), function() {
                    k(e, i, s);
                };
            },
            arrayMax: function(t) {
                let e = t.length, i = t[0];
                for(; e--;)t[e] > i && (i = t[e]);
                return i;
            },
            arrayMin: function(t) {
                let e = t.length, i = t[0];
                for(; e--;)t[e] < i && (i = t[e]);
                return i;
            },
            attr: g,
            clamp: function(t, e, i) {
                return t > e ? t < i ? t : i : e;
            },
            clearTimeout: function(t) {
                u(t) && clearTimeout(t);
            },
            correctFloat: v,
            createElement: function(t, e, i, r, o) {
                let n = s.createElement(t);
                return e && m(n, e), o && y(n, {
                    padding: "0",
                    border: "none",
                    margin: "0"
                }), i && y(n, i), r && r.appendChild(n), n;
            },
            crisp: (t, e = 0, i)=>{
                let s = e % 2 / 2, r = i ? -1 : 1;
                return (Math.round(t * r - s) + s) * r;
            },
            css: y,
            defined: u,
            destroyObjectProperties: function(t, e, i) {
                C(t, function(s, r) {
                    s !== e && s?.destroy && s.destroy(), (s?.destroy || !i) && delete t[r];
                });
            },
            diffObjects: function(t, e, i, s) {
                let r = {};
                return function t(e, r, o, n) {
                    let a = i ? r : e;
                    C(e, function(i, d) {
                        if (!n && s && s.indexOf(d) > -1 && r[d]) {
                            i = f(i), o[d] = [];
                            for(let e = 0; e < Math.max(i.length, r[d].length); e++)r[d][e] && (void 0 === i[e] ? o[d][e] = r[d][e] : (o[d][e] = {}, t(i[e], r[d][e], o[d][e], n + 1)));
                        } else l(i, !0) && !i.nodeType ? (o[d] = h(i) ? [] : {}, t(i, r[d] || {}, o[d], n + 1), 0 !== Object.keys(o[d]).length || "colorAxis" === d && 0 === n || delete o[d]) : (e[d] !== r[d] || d in e && !(d in r)) && "__proto__" !== d && "constructor" !== d && (o[d] = a[d]);
                    });
                }(t, e, r, 0), r;
            },
            discardElement: function(t) {
                t && t.parentElement && t.parentElement.removeChild(t);
            },
            erase: function(t, e) {
                let i = t.length;
                for(; i--;)if (t[i] === e) {
                    t.splice(i, 1);
                    break;
                }
            },
            error: o,
            extend: m,
            extendClass: function(t, e) {
                let i = function() {};
                return i.prototype = new t, m(i.prototype, e), i;
            },
            find: S,
            fireEvent: M,
            getClosestDistance: function(t, e) {
                let i, s, r, o;
                let n = !e;
                return t.forEach((t)=>{
                    if (t.length > 1) for(o = s = t.length - 1; o > 0; o--)(r = t[o] - t[o - 1]) < 0 && !n ? (e?.(), e = void 0) : r && (void 0 === i || r < i) && (i = r);
                }), i;
            },
            getMagnitude: b,
            getNestedProperty: function(t, e) {
                let i = t.split(".");
                for(; i.length && u(e);){
                    let t = i.shift();
                    if (void 0 === t || "__proto__" === t) return;
                    if ("this" === t) {
                        let t;
                        return l(e) && (t = e["@this"]), t ?? e;
                    }
                    let s = e[t];
                    if (!u(s) || "function" == typeof s || "number" == typeof s.nodeType || s === r) return;
                    e = s;
                }
                return e;
            },
            getStyle: function t(e, i, s) {
                let o;
                if ("width" === i) {
                    let i = Math.min(e.offsetWidth, e.scrollWidth), s = e.getBoundingClientRect && e.getBoundingClientRect().width;
                    return s < i && s >= i - 1 && (i = Math.floor(s)), Math.max(0, i - (t(e, "padding-left", !0) || 0) - (t(e, "padding-right", !0) || 0));
                }
                if ("height" === i) return Math.max(0, Math.min(e.offsetHeight, e.scrollHeight) - (t(e, "padding-top", !0) || 0) - (t(e, "padding-bottom", !0) || 0));
                let a = r.getComputedStyle(e, void 0);
                return a && (o = a.getPropertyValue(i), x(s, "opacity" !== i) && (o = n(o))), o;
            },
            inArray: function(t, e, i) {
                return o(32, !1, void 0, {
                    "Highcharts.inArray": "use Array.indexOf"
                }), e.indexOf(t, i);
            },
            insertItem: function(t, e) {
                let i;
                let s = t.options.index, r = e.length;
                for(i = t.options.isInternal ? r : 0; i < r + 1; i++)if (!e[i] || p(s) && s < x(e[i].options.index, e[i]._i) || e[i].options.isInternal) {
                    e.splice(i, 0, t);
                    break;
                }
                return i;
            },
            isArray: h,
            isClass: c,
            isDOMElement: d,
            isFunction: function(t) {
                return "function" == typeof t;
            },
            isNumber: p,
            isObject: l,
            isString: a,
            keys: function(t) {
                return o(32, !1, void 0, {
                    "Highcharts.keys": "use Object.keys"
                }), Object.keys(t);
            },
            merge: function() {
                let t, e = arguments, i = {}, s = function(t, e) {
                    return "object" != typeof t && (t = {}), C(e, function(i, r) {
                        "__proto__" !== r && "constructor" !== r && (!l(i, !0) || c(i) || d(i) ? t[r] = e[r] : t[r] = s(t[r] || {}, i));
                    }), t;
                };
                !0 === e[0] && (i = e[1], e = Array.prototype.slice.call(e, 2));
                let r = e.length;
                for(t = 0; t < r; t++)i = s(i, e[t]);
                return i;
            },
            normalizeTickInterval: function(t, e, i, s, r) {
                let o, n = t;
                i = x(i, b(t));
                let a = t / i;
                for(!e && (e = r ? [
                    1,
                    1.2,
                    1.5,
                    2,
                    2.5,
                    3,
                    4,
                    5,
                    6,
                    8,
                    10
                ] : [
                    1,
                    2,
                    2.5,
                    5,
                    10
                ], !1 === s && (1 === i ? e = e.filter(function(t) {
                    return t % 1 == 0;
                }) : i <= .1 && (e = [
                    1 / i
                ]))), o = 0; o < e.length && (n = e[o], (!r || !(n * i >= t)) && (r || !(a <= (e[o] + (e[o + 1] || e[o])) / 2))); o++);
                return v(n * i, -Math.round(Math.log(.001) / Math.LN10));
            },
            objectEach: C,
            offset: function(t) {
                let e = s.documentElement, i = t.parentElement || t.parentNode ? t.getBoundingClientRect() : {
                    top: 0,
                    left: 0,
                    width: 0,
                    height: 0
                };
                return {
                    top: i.top + (r.pageYOffset || e.scrollTop) - (e.clientTop || 0),
                    left: i.left + (r.pageXOffset || e.scrollLeft) - (e.clientLeft || 0),
                    width: i.width,
                    height: i.height
                };
            },
            pad: function(t, e, i) {
                return Array((e || 2) + 1 - String(t).replace("-", "").length).join(i || "0") + t;
            },
            pick: x,
            pInt: n,
            pushUnique: function(t, e) {
                return 0 > t.indexOf(e) && !!t.push(e);
            },
            relativeLength: function(t, e, i) {
                return /%$/.test(t) ? e * parseFloat(t) / 100 + (i || 0) : parseFloat(t);
            },
            removeEvent: k,
            replaceNested: function(t, ...e) {
                let i, s;
                do for (s of (i = t, e))t = t.replace(s[0], s[1]);
                while (t !== i);
                return t;
            },
            splat: f,
            stableSort: function(t, e) {
                let i, s;
                let r = t.length;
                for(s = 0; s < r; s++)t[s].safeI = s;
                for(t.sort(function(t, s) {
                    return 0 === (i = e(t, s)) ? t.safeI - s.safeI : i;
                }), s = 0; s < r; s++)delete t[s].safeI;
            },
            syncTimeout: function(t, e, i) {
                return e > 0 ? setTimeout(t, e, i) : (t.call(0, i), -1);
            },
            timeUnits: {
                millisecond: 1,
                second: 1e3,
                minute: 6e4,
                hour: 36e5,
                day: 864e5,
                week: 6048e5,
                month: 24192e5,
                year: 314496e5
            },
            uniqueKey: w,
            useSerialIds: function(t) {
                return e = x(t, e);
            },
            wrap: function(t, e, i) {
                let s = t[e];
                t[e] = function() {
                    let t = arguments, e = this;
                    return i.apply(this, [
                        function() {
                            return s.apply(e, arguments.length ? arguments : t);
                        }
                    ].concat([].slice.call(arguments)));
                };
            }
        };
    }), i(e, "Core/Chart/ChartDefaults.js", [], function() {
        return {
            alignThresholds: !1,
            panning: {
                enabled: !1,
                type: "x"
            },
            styledMode: !1,
            borderRadius: 0,
            colorCount: 10,
            allowMutatingData: !0,
            ignoreHiddenSeries: !0,
            spacing: [
                10,
                10,
                15,
                10
            ],
            resetZoomButton: {
                theme: {},
                position: {}
            },
            reflow: !0,
            type: "line",
            zooming: {
                singleTouch: !1,
                resetButton: {
                    theme: {
                        zIndex: 6
                    },
                    position: {
                        align: "right",
                        x: -10,
                        y: 10
                    }
                }
            },
            width: null,
            height: null,
            borderColor: "#334eff",
            backgroundColor: "#ffffff",
            plotBorderColor: "#cccccc"
        };
    }), i(e, "Core/Color/Palettes.js", [], function() {
        return {
            colors: [
                "#2caffe",
                "#544fc5",
                "#00e272",
                "#fe6a35",
                "#6b8abc",
                "#d568fb",
                "#2ee0ca",
                "#fa4b42",
                "#feb56a",
                "#91e8e1"
            ]
        };
    }), i(e, "Core/Time.js", [
        e["Core/Globals.js"],
        e["Core/Utilities.js"]
    ], function(t, e) {
        let { win: i } = t, { defined: s, error: r, extend: o, isNumber: n, isObject: a, merge: h, objectEach: l, pad: d, pick: c, splat: p, timeUnits: u } = e, g = t.isSafari && i.Intl && i.Intl.DateTimeFormat.prototype.formatRange, f = t.isSafari && i.Intl && !i.Intl.DateTimeFormat.prototype.formatRange;
        class m {
            constructor(t){
                this.options = {}, this.useUTC = !1, this.variableTimezone = !1, this.Date = i.Date, this.getTimezoneOffset = this.timezoneOffsetFunction(), this.update(t);
            }
            get(t, e) {
                if (this.variableTimezone || this.timezoneOffset) {
                    let i = e.getTime(), s = i - this.getTimezoneOffset(e);
                    e.setTime(s);
                    let r = e["getUTC" + t]();
                    return e.setTime(i), r;
                }
                return this.useUTC ? e["getUTC" + t]() : e["get" + t]();
            }
            set(t, e, i) {
                if (this.variableTimezone || this.timezoneOffset) {
                    if ("Milliseconds" === t || "Seconds" === t || "Minutes" === t && this.getTimezoneOffset(e) % 36e5 == 0) return e["setUTC" + t](i);
                    let s = this.getTimezoneOffset(e), r = e.getTime() - s;
                    e.setTime(r), e["setUTC" + t](i);
                    let o = this.getTimezoneOffset(e);
                    return r = e.getTime() + o, e.setTime(r);
                }
                return this.useUTC || g && "FullYear" === t ? e["setUTC" + t](i) : e["set" + t](i);
            }
            update(t = {}) {
                let e = c(t.useUTC, !0);
                this.options = t = h(!0, this.options, t), this.Date = t.Date || i.Date || Date, this.useUTC = e, this.timezoneOffset = e && t.timezoneOffset || void 0, this.getTimezoneOffset = this.timezoneOffsetFunction(), this.variableTimezone = e && !!(t.getTimezoneOffset || t.timezone);
            }
            makeTime(t, e, i, s, r, o) {
                let n, a, h;
                return this.useUTC ? (n = this.Date.UTC.apply(0, arguments), a = this.getTimezoneOffset(n), n += a, a !== (h = this.getTimezoneOffset(n)) ? n += h - a : a - 36e5 !== this.getTimezoneOffset(n - 36e5) || f || (n -= 36e5)) : n = new this.Date(t, e, c(i, 1), c(s, 0), c(r, 0), c(o, 0)).getTime(), n;
            }
            timezoneOffsetFunction() {
                let t = this, e = this.options, i = e.getTimezoneOffset;
                return this.useUTC ? e.timezone ? (t)=>{
                    try {
                        let i = `shortOffset,${e.timezone || ""}`, [s, r, o, a, h = 0] = (m.formatCache[i] = m.formatCache[i] || Intl.DateTimeFormat("en", {
                            timeZone: e.timezone,
                            timeZoneName: "shortOffset"
                        })).format(t).split(/(GMT|:)/).map(Number), l = -(36e5 * (o + h / 60));
                        if (n(l)) return l;
                    } catch (t) {
                        r(34);
                    }
                    return 0;
                } : this.useUTC && i ? (t)=>6e4 * i(t.valueOf()) : ()=>6e4 * (t.timezoneOffset || 0) : (t)=>6e4 * new Date(t.toString()).getTimezoneOffset();
            }
            dateFormat(e, i, r) {
                if (!s(i) || isNaN(i)) return t.defaultOptions.lang && t.defaultOptions.lang.invalidDate || "";
                e = c(e, "%Y-%m-%d %H:%M:%S");
                let n = this, a = new this.Date(i), h = this.get("Hours", a), p = this.get("Day", a), u = this.get("Date", a), g = this.get("Month", a), f = this.get("FullYear", a), m = t.defaultOptions.lang, x = m && m.weekdays, y = m && m.shortWeekdays;
                return l(o({
                    a: y ? y[p] : x[p].substr(0, 3),
                    A: x[p],
                    d: d(u),
                    e: d(u, 2, " "),
                    w: p,
                    b: m.shortMonths[g],
                    B: m.months[g],
                    m: d(g + 1),
                    o: g + 1,
                    y: f.toString().substr(2, 2),
                    Y: f,
                    H: d(h),
                    k: h,
                    I: d(h % 12 || 12),
                    l: h % 12 || 12,
                    M: d(this.get("Minutes", a)),
                    p: h < 12 ? "AM" : "PM",
                    P: h < 12 ? "am" : "pm",
                    S: d(this.get("Seconds", a)),
                    L: d(Math.floor(i % 1e3), 3)
                }, t.dateFormats), function(t, s) {
                    for(; -1 !== e.indexOf("%" + s);)e = e.replace("%" + s, "function" == typeof t ? t.call(n, i) : t);
                }), r ? e.substr(0, 1).toUpperCase() + e.substr(1) : e;
            }
            resolveDTLFormat(t) {
                return a(t, !0) ? t : {
                    main: (t = p(t))[0],
                    from: t[1],
                    to: t[2]
                };
            }
            getTimeTicks(t, e, i, r) {
                let n, a, h, l;
                let d = this, p = d.Date, g = [], f = {}, m = new p(e), x = t.unitRange, y = t.count || 1;
                if (r = c(r, 1), s(e)) {
                    d.set("Milliseconds", m, x >= u.second ? 0 : y * Math.floor(d.get("Milliseconds", m) / y)), x >= u.second && d.set("Seconds", m, x >= u.minute ? 0 : y * Math.floor(d.get("Seconds", m) / y)), x >= u.minute && d.set("Minutes", m, x >= u.hour ? 0 : y * Math.floor(d.get("Minutes", m) / y)), x >= u.hour && d.set("Hours", m, x >= u.day ? 0 : y * Math.floor(d.get("Hours", m) / y)), x >= u.day && d.set("Date", m, x >= u.month ? 1 : Math.max(1, y * Math.floor(d.get("Date", m) / y))), x >= u.month && (d.set("Month", m, x >= u.year ? 0 : y * Math.floor(d.get("Month", m) / y)), a = d.get("FullYear", m)), x >= u.year && (a -= a % y, d.set("FullYear", m, a)), x === u.week && (l = d.get("Day", m), d.set("Date", m, d.get("Date", m) - l + r + (l < r ? -7 : 0))), a = d.get("FullYear", m);
                    let t = d.get("Month", m), o = d.get("Date", m), c = d.get("Hours", m);
                    e = m.getTime(), (d.variableTimezone || !d.useUTC) && s(i) && (h = i - e > 4 * u.month || d.getTimezoneOffset(e) !== d.getTimezoneOffset(i));
                    let p = m.getTime();
                    for(n = 1; p < i;)g.push(p), x === u.year ? p = d.makeTime(a + n * y, 0) : x === u.month ? p = d.makeTime(a, t + n * y) : h && (x === u.day || x === u.week) ? p = d.makeTime(a, t, o + n * y * (x === u.day ? 1 : 7)) : h && x === u.hour && y > 1 ? p = d.makeTime(a, t, o, c + n * y) : p += x * y, n++;
                    g.push(p), x <= u.hour && g.length < 1e4 && g.forEach(function(t) {
                        t % 18e5 == 0 && "000000000" === d.dateFormat("%H%M%S%L", t) && (f[t] = "day");
                    });
                }
                return g.info = o(t, {
                    higherRanks: f,
                    totalRange: x * y
                }), g;
            }
            getDateFormat(t, e, i, s) {
                let r = this.dateFormat("%m-%d %H:%M:%S.%L", e), o = "01-01 00:00:00.000", n = {
                    millisecond: 15,
                    second: 12,
                    minute: 9,
                    hour: 6,
                    day: 3
                }, a = "millisecond", h = a;
                for(a in u){
                    if (t === u.week && +this.dateFormat("%w", e) === i && r.substr(6) === o.substr(6)) {
                        a = "week";
                        break;
                    }
                    if (u[a] > t) {
                        a = h;
                        break;
                    }
                    if (n[a] && r.substr(n[a]) !== o.substr(n[a])) break;
                    "week" !== a && (h = a);
                }
                return this.resolveDTLFormat(s[a]).main;
            }
        }
        return m.formatCache = {}, m;
    }), i(e, "Core/Defaults.js", [
        e["Core/Chart/ChartDefaults.js"],
        e["Core/Globals.js"],
        e["Core/Color/Palettes.js"],
        e["Core/Time.js"],
        e["Core/Utilities.js"]
    ], function(t, e, i, s, r) {
        let { isTouchDevice: o } = e, { fireEvent: n, merge: a } = r, h = {
            colors: i.colors,
            symbols: [
                "circle",
                "diamond",
                "square",
                "triangle",
                "triangle-down"
            ],
            lang: {
                loading: "Loading...",
                months: [
                    "January",
                    "February",
                    "March",
                    "April",
                    "May",
                    "June",
                    "July",
                    "August",
                    "September",
                    "October",
                    "November",
                    "December"
                ],
                shortMonths: [
                    "Jan",
                    "Feb",
                    "Mar",
                    "Apr",
                    "May",
                    "Jun",
                    "Jul",
                    "Aug",
                    "Sep",
                    "Oct",
                    "Nov",
                    "Dec"
                ],
                weekdays: [
                    "Sunday",
                    "Monday",
                    "Tuesday",
                    "Wednesday",
                    "Thursday",
                    "Friday",
                    "Saturday"
                ],
                decimalPoint: ".",
                numericSymbols: [
                    "k",
                    "M",
                    "G",
                    "T",
                    "P",
                    "E"
                ],
                resetZoom: "Reset zoom",
                resetZoomTitle: "Reset zoom level 1:1",
                thousandsSep: " "
            },
            global: {
                buttonTheme: {
                    fill: "#f7f7f7",
                    padding: 8,
                    r: 2,
                    stroke: "#cccccc",
                    "stroke-width": 1,
                    style: {
                        color: "#333333",
                        cursor: "pointer",
                        fontSize: "0.8em",
                        fontWeight: "normal"
                    },
                    states: {
                        hover: {
                            fill: "#e6e6e6"
                        },
                        select: {
                            fill: "#e6e9ff",
                            style: {
                                color: "#000000",
                                fontWeight: "bold"
                            }
                        },
                        disabled: {
                            style: {
                                color: "#cccccc"
                            }
                        }
                    }
                }
            },
            time: {
                Date: void 0,
                getTimezoneOffset: void 0,
                timezone: void 0,
                timezoneOffset: 0,
                useUTC: !0
            },
            chart: t,
            title: {
                style: {
                    color: "#333333",
                    fontWeight: "bold"
                },
                text: "Chart title",
                align: "center",
                margin: 15,
                widthAdjust: -44
            },
            subtitle: {
                style: {
                    color: "#666666",
                    fontSize: "0.8em"
                },
                text: "",
                align: "center",
                widthAdjust: -44
            },
            caption: {
                margin: 15,
                style: {
                    color: "#666666",
                    fontSize: "0.8em"
                },
                text: "",
                align: "left",
                verticalAlign: "bottom"
            },
            plotOptions: {},
            legend: {
                enabled: !0,
                align: "center",
                alignColumns: !0,
                className: "highcharts-no-tooltip",
                events: {},
                layout: "horizontal",
                itemMarginBottom: 2,
                itemMarginTop: 2,
                labelFormatter: function() {
                    return this.name;
                },
                borderColor: "#999999",
                borderRadius: 0,
                navigation: {
                    style: {
                        fontSize: "0.8em"
                    },
                    activeColor: "#0022ff",
                    inactiveColor: "#cccccc"
                },
                itemStyle: {
                    color: "#333333",
                    cursor: "pointer",
                    fontSize: "0.8em",
                    textDecoration: "none",
                    textOverflow: "ellipsis"
                },
                itemHoverStyle: {
                    color: "#000000"
                },
                itemHiddenStyle: {
                    color: "#666666",
                    textDecoration: "line-through"
                },
                shadow: !1,
                itemCheckboxStyle: {
                    position: "absolute",
                    width: "13px",
                    height: "13px"
                },
                squareSymbol: !0,
                symbolPadding: 5,
                verticalAlign: "bottom",
                x: 0,
                y: 0,
                title: {
                    style: {
                        fontSize: "0.8em",
                        fontWeight: "bold"
                    }
                }
            },
            loading: {
                labelStyle: {
                    fontWeight: "bold",
                    position: "relative",
                    top: "45%"
                },
                style: {
                    position: "absolute",
                    backgroundColor: "#ffffff",
                    opacity: .5,
                    textAlign: "center"
                }
            },
            tooltip: {
                enabled: !0,
                animation: {
                    duration: 300,
                    easing: (t)=>Math.sqrt(1 - Math.pow(t - 1, 2))
                },
                borderRadius: 3,
                dateTimeLabelFormats: {
                    millisecond: "%A, %e %b, %H:%M:%S.%L",
                    second: "%A, %e %b, %H:%M:%S",
                    minute: "%A, %e %b, %H:%M",
                    hour: "%A, %e %b, %H:%M",
                    day: "%A, %e %b %Y",
                    week: "Week from %A, %e %b %Y",
                    month: "%B %Y",
                    year: "%Y"
                },
                footerFormat: "",
                headerShape: "callout",
                hideDelay: 500,
                padding: 8,
                shape: "callout",
                shared: !1,
                snap: o ? 25 : 10,
                headerFormat: '<span style="font-size: 0.8em">{point.key}</span><br/>',
                pointFormat: '<span style="color:{point.color}">\u25CF</span> {series.name}: <b>{point.y}</b><br/>',
                backgroundColor: "#ffffff",
                borderWidth: void 0,
                shadow: !0,
                stickOnContact: !1,
                style: {
                    color: "#333333",
                    cursor: "default",
                    fontSize: "0.8em"
                },
                useHTML: !1
            },
            credits: {
                enabled: !0,
                href: "https://www.highcharts.com?credits",
                position: {
                    align: "right",
                    x: -10,
                    verticalAlign: "bottom",
                    y: -5
                },
                style: {
                    cursor: "pointer",
                    color: "#999999",
                    fontSize: "0.6em"
                },
                text: "Highcharts.com"
            }
        };
        h.chart.styledMode = !1;
        let l = new s(h.time);
        return {
            defaultOptions: h,
            defaultTime: l,
            getOptions: function() {
                return h;
            },
            setOptions: function(t) {
                return n(e, "setOptions", {
                    options: t
                }), a(!0, h, t), (t.time || t.global) && (e.time ? e.time.update(a(h.global, h.time, t.global, t.time)) : e.time = l), h;
            }
        };
    }), i(e, "Core/Color/Color.js", [
        e["Core/Globals.js"],
        e["Core/Utilities.js"]
    ], function(t, e) {
        let { isNumber: i, merge: s, pInt: r } = e;
        class o {
            static parse(t) {
                return t ? new o(t) : o.None;
            }
            constructor(e){
                let i, s, r, n;
                this.rgba = [
                    NaN,
                    NaN,
                    NaN,
                    NaN
                ], this.input = e;
                let a = t.Color;
                if (a && a !== o) return new a(e);
                if ("object" == typeof e && void 0 !== e.stops) this.stops = e.stops.map((t)=>new o(t[1]));
                else if ("string" == typeof e) {
                    if (this.input = e = o.names[e.toLowerCase()] || e, "#" === e.charAt(0)) {
                        let t = e.length, i = parseInt(e.substr(1), 16);
                        7 === t ? s = [
                            (16711680 & i) >> 16,
                            (65280 & i) >> 8,
                            255 & i,
                            1
                        ] : 4 === t && (s = [
                            (3840 & i) >> 4 | (3840 & i) >> 8,
                            (240 & i) >> 4 | 240 & i,
                            (15 & i) << 4 | 15 & i,
                            1
                        ]);
                    }
                    if (!s) for(r = o.parsers.length; r-- && !s;)(i = (n = o.parsers[r]).regex.exec(e)) && (s = n.parse(i));
                }
                s && (this.rgba = s);
            }
            get(t) {
                let e = this.input, r = this.rgba;
                if ("object" == typeof e && void 0 !== this.stops) {
                    let i = s(e);
                    return i.stops = [].slice.call(i.stops), this.stops.forEach((e, s)=>{
                        i.stops[s] = [
                            i.stops[s][0],
                            e.get(t)
                        ];
                    }), i;
                }
                return r && i(r[0]) ? "rgb" !== t && (t || 1 !== r[3]) ? "a" === t ? `${r[3]}` : "rgba(" + r.join(",") + ")" : "rgb(" + r[0] + "," + r[1] + "," + r[2] + ")" : e;
            }
            brighten(t) {
                let e = this.rgba;
                if (this.stops) this.stops.forEach(function(e) {
                    e.brighten(t);
                });
                else if (i(t) && 0 !== t) for(let i = 0; i < 3; i++)e[i] += r(255 * t), e[i] < 0 && (e[i] = 0), e[i] > 255 && (e[i] = 255);
                return this;
            }
            setOpacity(t) {
                return this.rgba[3] = t, this;
            }
            tweenTo(t, e) {
                let s = this.rgba, r = t.rgba;
                if (!i(s[0]) || !i(r[0])) return t.input || "none";
                let o = 1 !== r[3] || 1 !== s[3];
                return (o ? "rgba(" : "rgb(") + Math.round(r[0] + (s[0] - r[0]) * (1 - e)) + "," + Math.round(r[1] + (s[1] - r[1]) * (1 - e)) + "," + Math.round(r[2] + (s[2] - r[2]) * (1 - e)) + (o ? "," + (r[3] + (s[3] - r[3]) * (1 - e)) : "") + ")";
            }
        }
        return o.names = {
            white: "#ffffff",
            black: "#000000"
        }, o.parsers = [
            {
                regex: /rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d?(?:\.\d+)?)\s*\)/,
                parse: function(t) {
                    return [
                        r(t[1]),
                        r(t[2]),
                        r(t[3]),
                        parseFloat(t[4], 10)
                    ];
                }
            },
            {
                regex: /rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)/,
                parse: function(t) {
                    return [
                        r(t[1]),
                        r(t[2]),
                        r(t[3]),
                        1
                    ];
                }
            }
        ], o.None = new o(""), o;
    }), i(e, "Core/Animation/Fx.js", [
        e["Core/Color/Color.js"],
        e["Core/Globals.js"],
        e["Core/Utilities.js"]
    ], function(t, e, i) {
        let { parse: s } = t, { win: r } = e, { isNumber: o, objectEach: n } = i;
        class a {
            constructor(t, e, i){
                this.pos = NaN, this.options = e, this.elem = t, this.prop = i;
            }
            dSetter() {
                let t = this.paths, e = t && t[0], i = t && t[1], s = this.now || 0, r = [];
                if (1 !== s && e && i) {
                    if (e.length === i.length && s < 1) for(let t = 0; t < i.length; t++){
                        let n = e[t], a = i[t], h = [];
                        for(let t = 0; t < a.length; t++){
                            let e = n[t], i = a[t];
                            o(e) && o(i) && !("A" === a[0] && (4 === t || 5 === t)) ? h[t] = e + s * (i - e) : h[t] = i;
                        }
                        r.push(h);
                    }
                    else r = i;
                } else r = this.toD || [];
                this.elem.attr("d", r, void 0, !0);
            }
            update() {
                let t = this.elem, e = this.prop, i = this.now, s = this.options.step;
                this[e + "Setter"] ? this[e + "Setter"]() : t.attr ? t.element && t.attr(e, i, null, !0) : t.style[e] = i + this.unit, s && s.call(t, i, this);
            }
            run(t, e, i) {
                let s = this, o = s.options, n = function(t) {
                    return !n.stopped && s.step(t);
                }, h = r.requestAnimationFrame || function(t) {
                    setTimeout(t, 13);
                }, l = function() {
                    for(let t = 0; t < a.timers.length; t++)a.timers[t]() || a.timers.splice(t--, 1);
                    a.timers.length && h(l);
                };
                t !== e || this.elem["forceAnimate:" + this.prop] ? (this.startTime = +new Date, this.start = t, this.end = e, this.unit = i, this.now = this.start, this.pos = 0, n.elem = this.elem, n.prop = this.prop, n() && 1 === a.timers.push(n) && h(l)) : (delete o.curAnim[this.prop], o.complete && 0 === Object.keys(o.curAnim).length && o.complete.call(this.elem));
            }
            step(t) {
                let e, i;
                let s = +new Date, r = this.options, o = this.elem, a = r.complete, h = r.duration, l = r.curAnim;
                return o.attr && !o.element ? e = !1 : t || s >= h + this.startTime ? (this.now = this.end, this.pos = 1, this.update(), l[this.prop] = !0, i = !0, n(l, function(t) {
                    !0 !== t && (i = !1);
                }), i && a && a.call(o), e = !1) : (this.pos = r.easing((s - this.startTime) / h), this.now = this.start + (this.end - this.start) * this.pos, this.update(), e = !0), e;
            }
            initPath(t, e, i) {
                let s = t.startX, r = t.endX, n = i.slice(), a = t.isArea, h = a ? 2 : 1, l = e && i.length > e.length && i.hasStackedCliffs, d, c, p, u, g = e && e.slice();
                if (!g || l) return [
                    n,
                    n
                ];
                function f(t, e) {
                    for(; t.length < c;){
                        let i = t[0], s = e[c - t.length];
                        if (s && "M" === i[0] && ("C" === s[0] ? t[0] = [
                            "C",
                            i[1],
                            i[2],
                            i[1],
                            i[2],
                            i[1],
                            i[2]
                        ] : t[0] = [
                            "L",
                            i[1],
                            i[2]
                        ]), t.unshift(i), a) {
                            let e = t.pop();
                            t.push(t[t.length - 1], e);
                        }
                    }
                }
                function m(t) {
                    for(; t.length < c;){
                        let e = t[Math.floor(t.length / h) - 1].slice();
                        if ("C" === e[0] && (e[1] = e[5], e[2] = e[6]), a) {
                            let i = t[Math.floor(t.length / h)].slice();
                            t.splice(t.length / 2, 0, e, i);
                        } else t.push(e);
                    }
                }
                if (s && r && r.length) {
                    for(p = 0; p < s.length; p++){
                        if (s[p] === r[0]) {
                            d = p;
                            break;
                        }
                        if (s[0] === r[r.length - s.length + p]) {
                            d = p, u = !0;
                            break;
                        }
                        if (s[s.length - 1] === r[r.length - s.length + p]) {
                            d = s.length - p;
                            break;
                        }
                    }
                    void 0 === d && (g = []);
                }
                return g.length && o(d) && (c = n.length + d * h, u ? (f(g, n), m(n)) : (f(n, g), m(g))), [
                    g,
                    n
                ];
            }
            fillSetter() {
                a.prototype.strokeSetter.apply(this, arguments);
            }
            strokeSetter() {
                this.elem.attr(this.prop, s(this.start).tweenTo(s(this.end), this.pos), void 0, !0);
            }
        }
        return a.timers = [], a;
    }), i(e, "Core/Animation/AnimationUtilities.js", [
        e["Core/Animation/Fx.js"],
        e["Core/Utilities.js"]
    ], function(t, e) {
        let { defined: i, getStyle: s, isArray: r, isNumber: o, isObject: n, merge: a, objectEach: h, pick: l } = e;
        function d(t) {
            return n(t) ? a({
                duration: 500,
                defer: 0
            }, t) : {
                duration: t ? 500 : 0,
                defer: 0
            };
        }
        function c(e, i) {
            let s = t.timers.length;
            for(; s--;)t.timers[s].elem !== e || i && i !== t.timers[s].prop || (t.timers[s].stopped = !0);
        }
        return {
            animate: function(e, i, l) {
                let d, p = "", u, g, f;
                n(l) || (f = arguments, l = {
                    duration: f[2],
                    easing: f[3],
                    complete: f[4]
                }), o(l.duration) || (l.duration = 400), l.easing = "function" == typeof l.easing ? l.easing : Math[l.easing] || Math.easeInOutSine, l.curAnim = a(i), h(i, function(o, n) {
                    c(e, n), g = new t(e, l, n), u = void 0, "d" === n && r(i.d) ? (g.paths = g.initPath(e, e.pathArray, i.d), g.toD = i.d, d = 0, u = 1) : e.attr ? d = e.attr(n) : (d = parseFloat(s(e, n)) || 0, "opacity" !== n && (p = "px")), u || (u = o), "string" == typeof u && u.match("px") && (u = u.replace(/px/g, "")), g.run(d, u, p);
                });
            },
            animObject: d,
            getDeferredAnimation: function(t, e, s) {
                let r = d(e), o = s ? [
                    s
                ] : t.series, a = 0, h = 0;
                return o.forEach((t)=>{
                    let s = d(t.options.animation);
                    a = n(e) && i(e.defer) ? r.defer : Math.max(a, s.duration + s.defer), h = Math.min(r.duration, s.duration);
                }), t.renderer.forExport && (a = 0), {
                    defer: Math.max(0, a - h),
                    duration: Math.min(a, h)
                };
            },
            setAnimation: function(t, e) {
                e.renderer.globalAnimation = l(t, e.options.chart.animation, !0);
            },
            stop: c
        };
    }), i(e, "Core/Renderer/HTML/AST.js", [
        e["Core/Globals.js"],
        e["Core/Utilities.js"]
    ], function(t, e) {
        let { SVG_NS: i, win: s } = t, { attr: r, createElement: o, css: n, error: a, isFunction: h, isString: l, objectEach: d, splat: c } = e, { trustedTypes: p } = s, u = p && h(p.createPolicy) && p.createPolicy("highcharts", {
            createHTML: (t)=>t
        }), g = u ? u.createHTML("") : "", f = function() {
            try {
                return !!new DOMParser().parseFromString(g, "text/html");
            } catch (t) {
                return !1;
            }
        }();
        class m {
            static filterUserAttributes(t) {
                return d(t, (e, i)=>{
                    let s = !0;
                    -1 === m.allowedAttributes.indexOf(i) && (s = !1), -1 !== [
                        "background",
                        "dynsrc",
                        "href",
                        "lowsrc",
                        "src"
                    ].indexOf(i) && (s = l(e) && m.allowedReferences.some((t)=>0 === e.indexOf(t))), s || (a(33, !1, void 0, {
                        "Invalid attribute in config": `${i}`
                    }), delete t[i]), l(e) && t[i] && (t[i] = e.replace(/</g, "&lt;"));
                }), t;
            }
            static parseStyle(t) {
                return t.split(";").reduce((t, e)=>{
                    let i = e.split(":").map((t)=>t.trim()), s = i.shift();
                    return s && i.length && (t[s.replace(/-([a-z])/g, (t)=>t[1].toUpperCase())] = i.join(":")), t;
                }, {});
            }
            static setElementHTML(t, e) {
                t.innerHTML = m.emptyHTML, e && new m(e).addToDOM(t);
            }
            constructor(t){
                this.nodes = "string" == typeof t ? this.parseMarkup(t) : t;
            }
            addToDOM(e) {
                return function e(s, o) {
                    let h;
                    return c(s).forEach(function(s) {
                        let l;
                        let c = s.tagName, p = s.textContent ? t.doc.createTextNode(s.textContent) : void 0, u = m.bypassHTMLFiltering;
                        if (c) {
                            if ("#text" === c) l = p;
                            else if (-1 !== m.allowedTags.indexOf(c) || u) {
                                let a = "svg" === c ? i : o.namespaceURI || i, h = t.doc.createElementNS(a, c), g = s.attributes || {};
                                d(s, function(t, e) {
                                    "tagName" !== e && "attributes" !== e && "children" !== e && "style" !== e && "textContent" !== e && (g[e] = t);
                                }), r(h, u ? g : m.filterUserAttributes(g)), s.style && n(h, s.style), p && h.appendChild(p), e(s.children || [], h), l = h;
                            } else a(33, !1, void 0, {
                                "Invalid tagName in config": c
                            });
                        }
                        l && o.appendChild(l), h = l;
                    }), h;
                }(this.nodes, e);
            }
            parseMarkup(t) {
                let e;
                let i = [];
                if (t = t.trim().replace(/ style=(["'])/g, " data-style=$1"), f) e = new DOMParser().parseFromString(u ? u.createHTML(t) : t, "text/html");
                else {
                    let i = o("div");
                    i.innerHTML = t, e = {
                        body: i
                    };
                }
                let s = (t, e)=>{
                    let i = t.nodeName.toLowerCase(), r = {
                        tagName: i
                    };
                    "#text" === i && (r.textContent = t.textContent || "");
                    let o = t.attributes;
                    if (o) {
                        let t = {};
                        [].forEach.call(o, (e)=>{
                            "data-style" === e.name ? r.style = m.parseStyle(e.value) : t[e.name] = e.value;
                        }), r.attributes = t;
                    }
                    if (t.childNodes.length) {
                        let e = [];
                        [].forEach.call(t.childNodes, (t)=>{
                            s(t, e);
                        }), e.length && (r.children = e);
                    }
                    e.push(r);
                };
                return [].forEach.call(e.body.childNodes, (t)=>s(t, i)), i;
            }
        }
        return m.allowedAttributes = [
            "alt",
            "aria-controls",
            "aria-describedby",
            "aria-expanded",
            "aria-haspopup",
            "aria-hidden",
            "aria-label",
            "aria-labelledby",
            "aria-live",
            "aria-pressed",
            "aria-readonly",
            "aria-roledescription",
            "aria-selected",
            "class",
            "clip-path",
            "color",
            "colspan",
            "cx",
            "cy",
            "d",
            "dx",
            "dy",
            "disabled",
            "fill",
            "filterUnits",
            "flood-color",
            "flood-opacity",
            "height",
            "href",
            "id",
            "in",
            "in2",
            "markerHeight",
            "markerWidth",
            "offset",
            "opacity",
            "operator",
            "orient",
            "padding",
            "paddingLeft",
            "paddingRight",
            "patternUnits",
            "r",
            "radius",
            "refX",
            "refY",
            "role",
            "scope",
            "slope",
            "src",
            "startOffset",
            "stdDeviation",
            "stroke",
            "stroke-linecap",
            "stroke-width",
            "style",
            "tableValues",
            "result",
            "rowspan",
            "summary",
            "target",
            "tabindex",
            "text-align",
            "text-anchor",
            "textAnchor",
            "textLength",
            "title",
            "type",
            "valign",
            "width",
            "x",
            "x1",
            "x2",
            "xlink:href",
            "y",
            "y1",
            "y2",
            "zIndex"
        ], m.allowedReferences = [
            "https://",
            "http://",
            "mailto:",
            "/",
            "../",
            "./",
            "#"
        ], m.allowedTags = [
            "a",
            "abbr",
            "b",
            "br",
            "button",
            "caption",
            "circle",
            "clipPath",
            "code",
            "dd",
            "defs",
            "div",
            "dl",
            "dt",
            "em",
            "feComponentTransfer",
            "feComposite",
            "feDropShadow",
            "feFlood",
            "feFuncA",
            "feFuncB",
            "feFuncG",
            "feFuncR",
            "feGaussianBlur",
            "feMorphology",
            "feOffset",
            "feMerge",
            "feMergeNode",
            "filter",
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6",
            "hr",
            "i",
            "img",
            "li",
            "linearGradient",
            "marker",
            "ol",
            "p",
            "path",
            "pattern",
            "pre",
            "rect",
            "small",
            "span",
            "stop",
            "strong",
            "style",
            "sub",
            "sup",
            "svg",
            "table",
            "text",
            "textPath",
            "thead",
            "title",
            "tbody",
            "tspan",
            "td",
            "th",
            "tr",
            "u",
            "ul",
            "#text"
        ], m.emptyHTML = g, m.bypassHTMLFiltering = !1, m;
    }), i(e, "Core/Templating.js", [
        e["Core/Defaults.js"],
        e["Core/Utilities.js"]
    ], function(t, e) {
        let { defaultOptions: i, defaultTime: s } = t, { extend: r, getNestedProperty: o, isArray: n, isNumber: a, isObject: h, pick: l, pInt: d } = e, c = {
            add: (t, e)=>t + e,
            divide: (t, e)=>0 !== e ? t / e : "",
            eq: (t, e)=>t == e,
            each: function(t) {
                let e = arguments[arguments.length - 1];
                return !!n(t) && t.map((i, s)=>p(e.body, r(h(i) ? i : {
                        "@this": i
                    }, {
                        "@index": s,
                        "@first": 0 === s,
                        "@last": s === t.length - 1
                    }))).join("");
            },
            ge: (t, e)=>t >= e,
            gt: (t, e)=>t > e,
            if: (t)=>!!t,
            le: (t, e)=>t <= e,
            lt: (t, e)=>t < e,
            multiply: (t, e)=>t * e,
            ne: (t, e)=>t != e,
            subtract: (t, e)=>t - e,
            unless: (t)=>!t
        };
        function p(t = "", e, r) {
            let n = /\{([\w\:\.\,;\-\/<>%@"'’= #\(\)]+)\}/g, a = /\(([\w\:\.\,;\-\/<>%@"'= ]+)\)/g, h = [], d = /f$/, g = /\.(\d)/, f = i.lang, m = r && r.time || s, x = r && r.numberFormatter || u, y = (t = "")=>{
                let i;
                return "true" === t || "false" !== t && ((i = Number(t)).toString() === t ? i : o(t, e));
            }, b, v, S = 0, C;
            for(; null !== (b = n.exec(t));){
                let i = a.exec(b[1]);
                i && (b = i, C = !0), v && v.isBlock || (v = {
                    ctx: e,
                    expression: b[1],
                    find: b[0],
                    isBlock: "#" === b[1].charAt(0),
                    start: b.index,
                    startInner: b.index + b[0].length,
                    length: b[0].length
                });
                let s = b[1].split(" ")[0].replace("#", "");
                c[s] && (v.isBlock && s === v.fn && S++, v.fn || (v.fn = s));
                let r = "else" === b[1];
                if (v.isBlock && v.fn && (b[1] === `/${v.fn}` || r)) {
                    if (S) !r && S--;
                    else {
                        let e = v.startInner, i = t.substr(e, b.index - e);
                        void 0 === v.body ? (v.body = i, v.startInner = b.index + b[0].length) : v.elseBody = i, v.find += i + b[0], r || (h.push(v), v = void 0);
                    }
                } else v.isBlock || h.push(v);
                if (i && !v?.isBlock) break;
            }
            return h.forEach((i)=>{
                let s, o;
                let { body: n, elseBody: a, expression: h, fn: u } = i;
                if (u) {
                    let t = [
                        i
                    ], l = h.split(" ");
                    for(o = c[u].length; o--;)t.unshift(y(l[o + 1]));
                    s = c[u].apply(e, t), i.isBlock && "boolean" == typeof s && (s = p(s ? n : a, e, r));
                } else {
                    let t = h.split(":");
                    if (s = y(t.shift() || ""), t.length && "number" == typeof s) {
                        let e = t.join(":");
                        if (d.test(e)) {
                            let t = parseInt((e.match(g) || [
                                "",
                                "-1"
                            ])[1], 10);
                            null !== s && (s = x(s, t, f.decimalPoint, e.indexOf(",") > -1 ? f.thousandsSep : ""));
                        } else s = m.dateFormat(e, s);
                    }
                }
                t = t.replace(i.find, l(s, ""));
            }), C ? p(t, e, r) : t;
        }
        function u(t, e, s, r) {
            let o, n;
            t = +t || 0, e = +e;
            let h = i.lang, c = (t.toString().split(".")[1] || "").split("e")[0].length, p = t.toString().split("e"), u = e;
            -1 === e ? e = Math.min(c, 20) : a(e) ? e && p[1] && p[1] < 0 && ((n = e + +p[1]) >= 0 ? (p[0] = (+p[0]).toExponential(n).split("e")[0], e = n) : (p[0] = p[0].split(".")[0] || 0, t = e < 20 ? (p[0] * Math.pow(10, p[1])).toFixed(e) : 0, p[1] = 0)) : e = 2;
            let g = (Math.abs(p[1] ? p[0] : t) + Math.pow(10, -Math.max(e, c) - 1)).toFixed(e), f = String(d(g)), m = f.length > 3 ? f.length % 3 : 0;
            return s = l(s, h.decimalPoint), r = l(r, h.thousandsSep), o = (t < 0 ? "-" : "") + (m ? f.substr(0, m) + r : ""), 0 > +p[1] && !u ? o = "0" : o += f.substr(m).replace(/(\d{3})(?=\d)/g, "$1" + r), e ? o += s + g.slice(-e) : 0 == +o && (o = "0"), p[1] && 0 != +o && (o += "e" + p[1]), o;
        }
        return {
            dateFormat: function(t, e, i) {
                return s.dateFormat(t, e, i);
            },
            format: p,
            helpers: c,
            numberFormat: u
        };
    }), i(e, "Core/Renderer/RendererRegistry.js", [
        e["Core/Globals.js"]
    ], function(t) {
        var e, i;
        let s;
        return (i = e || (e = {})).rendererTypes = {}, i.getRendererType = function(t = s) {
            return i.rendererTypes[t] || i.rendererTypes[s];
        }, i.registerRendererType = function(e, r, o) {
            i.rendererTypes[e] = r, (!s || o) && (s = e, t.Renderer = r);
        }, e;
    }), i(e, "Core/Renderer/RendererUtilities.js", [
        e["Core/Utilities.js"]
    ], function(t) {
        var e;
        let { clamp: i, pick: s, pushUnique: r, stableSort: o } = t;
        return (e || (e = {})).distribute = function t(e, n, a) {
            let h = e, l = h.reducedLen || n, d = (t, e)=>t.target - e.target, c = [], p = e.length, u = [], g = c.push, f, m, x, y = !0, b, v, S = 0, C;
            for(f = p; f--;)S += e[f].size;
            if (S > l) {
                for(o(e, (t, e)=>(e.rank || 0) - (t.rank || 0)), x = (C = e[0].rank === e[e.length - 1].rank) ? p / 2 : -1, m = C ? x : p - 1; x && S > l;)b = e[f = Math.floor(m)], r(u, f) && (S -= b.size), m += x, C && m >= e.length && (x /= 2, m = x);
                u.sort((t, e)=>e - t).forEach((t)=>g.apply(c, e.splice(t, 1)));
            }
            for(o(e, d), e = e.map((t)=>({
                    size: t.size,
                    targets: [
                        t.target
                    ],
                    align: s(t.align, .5)
                })); y;){
                for(f = e.length; f--;)b = e[f], v = (Math.min.apply(0, b.targets) + Math.max.apply(0, b.targets)) / 2, b.pos = i(v - b.size * b.align, 0, n - b.size);
                for(f = e.length, y = !1; f--;)f > 0 && e[f - 1].pos + e[f - 1].size > e[f].pos && (e[f - 1].size += e[f].size, e[f - 1].targets = e[f - 1].targets.concat(e[f].targets), e[f - 1].align = .5, e[f - 1].pos + e[f - 1].size > n && (e[f - 1].pos = n - e[f - 1].size), e.splice(f, 1), y = !0);
            }
            return g.apply(h, c), f = 0, e.some((e)=>{
                let i = 0;
                return (e.targets || []).some(()=>(h[f].pos = e.pos + i, void 0 !== a && Math.abs(h[f].pos - h[f].target) > a) ? (h.slice(0, f + 1).forEach((t)=>delete t.pos), h.reducedLen = (h.reducedLen || n) - .1 * n, h.reducedLen > .1 * n && t(h, n, a), !0) : (i += h[f].size, f++, !1));
            }), o(h, d), h;
        }, e;
    }), i(e, "Core/Renderer/SVG/SVGElement.js", [
        e["Core/Animation/AnimationUtilities.js"],
        e["Core/Color/Color.js"],
        e["Core/Globals.js"],
        e["Core/Utilities.js"]
    ], function(t, e, i, s) {
        let { animate: r, animObject: o, stop: n } = t, { deg2rad: a, doc: h, svg: l, SVG_NS: d, win: c } = i, { addEvent: p, attr: u, createElement: g, crisp: f, css: m, defined: x, erase: y, extend: b, fireEvent: v, isArray: S, isFunction: C, isObject: k, isString: M, merge: w, objectEach: T, pick: A, pInt: P, pushUnique: L, replaceNested: O, syncTimeout: D, uniqueKey: E } = s;
        class I {
            _defaultGetter(t) {
                let e = A(this[t + "Value"], this[t], this.element ? this.element.getAttribute(t) : null, 0);
                return /^-?[\d\.]+$/.test(e) && (e = parseFloat(e)), e;
            }
            _defaultSetter(t, e, i) {
                i.setAttribute(e, t);
            }
            add(t) {
                let e;
                let i = this.renderer, s = this.element;
                return t && (this.parentGroup = t), void 0 !== this.textStr && "text" === this.element.nodeName && i.buildText(this), this.added = !0, (!t || t.handleZ || this.zIndex) && (e = this.zIndexSetter()), e || (t ? t.element : i.box).appendChild(s), this.onAdd && this.onAdd(), this;
            }
            addClass(t, e) {
                let i = e ? "" : this.attr("class") || "";
                return (t = (t || "").split(/ /g).reduce(function(t, e) {
                    return -1 === i.indexOf(e) && t.push(e), t;
                }, i ? [
                    i
                ] : []).join(" ")) !== i && this.attr("class", t), this;
            }
            afterSetters() {
                this.doTransform && (this.updateTransform(), this.doTransform = !1);
            }
            align(t, e, i, s = !0) {
                let r, o, n, a;
                let h = {}, l = this.renderer, d = l.alignedObjects, c = !!t;
                t ? (this.alignOptions = t, this.alignByTranslate = e, this.alignTo = i) : (t = this.alignOptions || {}, e = this.alignByTranslate, i = this.alignTo);
                let p = !i || M(i) ? i || "renderer" : void 0;
                p && (c && L(d, this), i = void 0);
                let u = A(i, l[p], l), g = t.align, f = t.verticalAlign;
                return r = (u.x || 0) + (t.x || 0), o = (u.y || 0) + (t.y || 0), "right" === g ? n = 1 : "center" === g && (n = 2), n && (r += ((u.width || 0) - (t.width || 0)) / n), h[e ? "translateX" : "x"] = Math.round(r), "bottom" === f ? a = 1 : "middle" === f && (a = 2), a && (o += ((u.height || 0) - (t.height || 0)) / a), h[e ? "translateY" : "y"] = Math.round(o), s && (this[this.placed ? "animate" : "attr"](h), this.placed = !0), this.alignAttr = h, this;
            }
            alignSetter(t) {
                let e = {
                    left: "start",
                    center: "middle",
                    right: "end"
                };
                e[t] && (this.alignValue = t, this.element.setAttribute("text-anchor", e[t]));
            }
            animate(t, e, i) {
                let s = o(A(e, this.renderer.globalAnimation, !0)), n = s.defer;
                return h.hidden && (s.duration = 0), 0 !== s.duration ? (i && (s.complete = i), D(()=>{
                    this.element && r(this, t, s);
                }, n)) : (this.attr(t, void 0, i || s.complete), T(t, function(t, e) {
                    s.step && s.step.call(this, t, {
                        prop: e,
                        pos: 1,
                        elem: this
                    });
                }, this)), this;
            }
            applyTextOutline(t) {
                let e = this.element;
                -1 !== t.indexOf("contrast") && (t = t.replace(/contrast/g, this.renderer.getContrast(e.style.fill)));
                let s = t.split(" "), r = s[s.length - 1], o = s[0];
                if (o && "none" !== o && i.svg) {
                    this.fakeTS = !0, o = o.replace(/(^[\d\.]+)(.*?)$/g, function(t, e, i) {
                        return 2 * Number(e) + i;
                    }), this.removeTextOutline();
                    let t = h.createElementNS(d, "tspan");
                    u(t, {
                        class: "highcharts-text-outline",
                        fill: r,
                        stroke: r,
                        "stroke-width": o,
                        "stroke-linejoin": "round"
                    });
                    let i = e.querySelector("textPath") || e;
                    [].forEach.call(i.childNodes, (e)=>{
                        let i = e.cloneNode(!0);
                        i.removeAttribute && [
                            "fill",
                            "stroke",
                            "stroke-width",
                            "stroke"
                        ].forEach((t)=>i.removeAttribute(t)), t.appendChild(i);
                    });
                    let s = 0;
                    [].forEach.call(i.querySelectorAll("text tspan"), (t)=>{
                        s += Number(t.getAttribute("dy"));
                    });
                    let n = h.createElementNS(d, "tspan");
                    n.textContent = "\u200B", u(n, {
                        x: Number(e.getAttribute("x")),
                        dy: -s
                    }), t.appendChild(n), i.insertBefore(t, i.firstChild);
                }
            }
            attr(t, e, i, s) {
                let { element: r } = this, o = I.symbolCustomAttribs, a, h, l = this, d;
                return "string" == typeof t && void 0 !== e && (a = t, (t = {})[a] = e), "string" == typeof t ? l = (this[t + "Getter"] || this._defaultGetter).call(this, t, r) : (T(t, function(e, i) {
                    d = !1, s || n(this, i), this.symbolName && -1 !== o.indexOf(i) && (h || (this.symbolAttr(t), h = !0), d = !0), this.rotation && ("x" === i || "y" === i) && (this.doTransform = !0), d || (this[i + "Setter"] || this._defaultSetter).call(this, e, i, r);
                }, this), this.afterSetters()), i && i.call(this), l;
            }
            clip(t) {
                if (t && !t.clipPath) {
                    let e = E() + "-", i = this.renderer.createElement("clipPath").attr({
                        id: e
                    }).add(this.renderer.defs);
                    b(t, {
                        clipPath: i,
                        id: e,
                        count: 0
                    }), t.add(i);
                }
                return this.attr("clip-path", t ? `url(${this.renderer.url}#${t.id})` : "none");
            }
            crisp(t, e) {
                e = Math.round(e || t.strokeWidth || 0);
                let i = t.x || this.x || 0, s = t.y || this.y || 0, r = (t.width || this.width || 0) + i, o = (t.height || this.height || 0) + s, n = f(i, e), a = f(s, e);
                return b(t, {
                    x: n,
                    y: a,
                    width: f(r, e) - n,
                    height: f(o, e) - a
                }), x(t.strokeWidth) && (t.strokeWidth = e), t;
            }
            complexColor(t, i, s) {
                let r = this.renderer, o, n, a, h, l, d, c, p, u, g, f = [], m;
                v(this.renderer, "complexColor", {
                    args: arguments
                }, function() {
                    if (t.radialGradient ? n = "radialGradient" : t.linearGradient && (n = "linearGradient"), n) {
                        if (a = t[n], l = r.gradients, d = t.stops, u = s.radialReference, S(a) && (t[n] = a = {
                            x1: a[0],
                            y1: a[1],
                            x2: a[2],
                            y2: a[3],
                            gradientUnits: "userSpaceOnUse"
                        }), "radialGradient" === n && u && !x(a.gradientUnits) && (h = a, a = w(a, r.getRadialAttr(u, h), {
                            gradientUnits: "userSpaceOnUse"
                        })), T(a, function(t, e) {
                            "id" !== e && f.push(e, t);
                        }), T(d, function(t) {
                            f.push(t);
                        }), l[f = f.join(",")]) g = l[f].attr("id");
                        else {
                            a.id = g = E();
                            let t = l[f] = r.createElement(n).attr(a).add(r.defs);
                            t.radAttr = h, t.stops = [], d.forEach(function(i) {
                                0 === i[1].indexOf("rgba") ? (c = (o = e.parse(i[1])).get("rgb"), p = o.get("a")) : (c = i[1], p = 1);
                                let s = r.createElement("stop").attr({
                                    offset: i[0],
                                    "stop-color": c,
                                    "stop-opacity": p
                                }).add(t);
                                t.stops.push(s);
                            });
                        }
                        m = "url(" + r.url + "#" + g + ")", s.setAttribute(i, m), s.gradient = f, t.toString = function() {
                            return m;
                        };
                    }
                });
            }
            css(t) {
                let e = this.styles, i = {}, s = this.element, r, o = !e;
                if (e && T(t, function(t, s) {
                    e && e[s] !== t && (i[s] = t, o = !0);
                }), o) {
                    e && (t = b(e, i)), null === t.width || "auto" === t.width ? delete this.textWidth : "text" === s.nodeName.toLowerCase() && t.width && (r = this.textWidth = P(t.width)), b(this.styles, t), r && !l && this.renderer.forExport && delete t.width;
                    let o = w(t);
                    s.namespaceURI === this.SVG_NS && ([
                        "textOutline",
                        "textOverflow",
                        "width"
                    ].forEach((t)=>o && delete o[t]), o.color && (o.fill = o.color)), m(s, o);
                }
                return this.added && ("text" === this.element.nodeName && this.renderer.buildText(this), t.textOutline && this.applyTextOutline(t.textOutline)), this;
            }
            dashstyleSetter(t) {
                let e, i = this["stroke-width"];
                if ("inherit" === i && (i = 1), t = t && t.toLowerCase()) {
                    let s = t.replace("shortdashdotdot", "3,1,1,1,1,1,").replace("shortdashdot", "3,1,1,1").replace("shortdot", "1,1,").replace("shortdash", "3,1,").replace("longdash", "8,3,").replace(/dot/g, "1,3,").replace("dash", "4,3,").replace(/,$/, "").split(",");
                    for(e = s.length; e--;)s[e] = "" + P(s[e]) * A(i, NaN);
                    t = s.join(",").replace(/NaN/g, "none"), this.element.setAttribute("stroke-dasharray", t);
                }
            }
            destroy() {
                let t = this, e = t.element || {}, i = t.renderer, s = e.ownerSVGElement, r = "SPAN" === e.nodeName && t.parentGroup || void 0, o, a;
                if (e.onclick = e.onmouseout = e.onmouseover = e.onmousemove = e.point = null, n(t), t.clipPath && s) {
                    let e = t.clipPath;
                    [].forEach.call(s.querySelectorAll("[clip-path],[CLIP-PATH]"), function(t) {
                        t.getAttribute("clip-path").indexOf(e.element.id) > -1 && t.removeAttribute("clip-path");
                    }), t.clipPath = e.destroy();
                }
                if (t.connector = t.connector?.destroy(), t.stops) {
                    for(a = 0; a < t.stops.length; a++)t.stops[a].destroy();
                    t.stops.length = 0, t.stops = void 0;
                }
                for(t.safeRemoveChild(e); r && r.div && 0 === r.div.childNodes.length;)o = r.parentGroup, t.safeRemoveChild(r.div), delete r.div, r = o;
                t.alignOptions && y(i.alignedObjects, t), T(t, function(e, i) {
                    t[i] && t[i].parentGroup === t && t[i].destroy && t[i].destroy(), delete t[i];
                });
            }
            dSetter(t, e, i) {
                S(t) && ("string" == typeof t[0] && (t = this.renderer.pathToSegments(t)), this.pathArray = t, t = t.reduce((t, e, i)=>e && e.join ? (i ? t + " " : "") + e.join(" ") : (e || "").toString(), "")), /(NaN| {2}|^$)/.test(t) && (t = "M 0 0"), this[e] !== t && (i.setAttribute(e, t), this[e] = t);
            }
            fillSetter(t, e, i) {
                "string" == typeof t ? i.setAttribute(e, t) : t && this.complexColor(t, e, i);
            }
            hrefSetter(t, e, i) {
                i.setAttributeNS("http://www.w3.org/1999/xlink", e, t);
            }
            getBBox(t, e) {
                let i, s, r, o;
                let { alignValue: n, element: a, renderer: h, styles: l, textStr: d } = this, { cache: c, cacheKeys: p } = h, u = a.namespaceURI === this.SVG_NS, g = A(e, this.rotation, 0), f = h.styledMode ? a && I.prototype.getStyle.call(a, "font-size") : l.fontSize;
                if (x(d) && (-1 === (o = d.toString()).indexOf("<") && (o = o.replace(/\d/g, "0")), o += [
                    "",
                    h.rootFontSize,
                    f,
                    g,
                    this.textWidth,
                    n,
                    l.textOverflow,
                    l.fontWeight
                ].join(",")), o && !t && (i = c[o]), !i || i.polygon) {
                    if (u || h.forExport) {
                        try {
                            r = this.fakeTS && function(t) {
                                let e = a.querySelector(".highcharts-text-outline");
                                e && m(e, {
                                    display: t
                                });
                            }, C(r) && r("none"), i = a.getBBox ? b({}, a.getBBox()) : {
                                width: a.offsetWidth,
                                height: a.offsetHeight,
                                x: 0,
                                y: 0
                            }, C(r) && r("");
                        } catch (t) {}
                        (!i || i.width < 0) && (i = {
                            x: 0,
                            y: 0,
                            width: 0,
                            height: 0
                        });
                    } else i = this.htmlGetBBox();
                    s = i.height, u && (i.height = s = ({
                        "11px,17": 14,
                        "13px,20": 16
                    })[`${f || ""},${Math.round(s)}`] || s), g && (i = this.getRotatedBox(i, g));
                    let t = {
                        bBox: i
                    };
                    v(this, "afterGetBBox", t), i = t.bBox;
                }
                if (o && ("" === d || i.height > 0)) {
                    for(; p.length > 250;)delete c[p.shift()];
                    c[o] || p.push(o), c[o] = i;
                }
                return i;
            }
            getRotatedBox(t, e) {
                let { x: i, y: s, width: r, height: o } = t, { alignValue: n, translateY: h, rotationOriginX: l = 0, rotationOriginY: d = 0 } = this, c = {
                    right: 1,
                    center: .5
                }[n || 0] || 0, p = Number(this.element.getAttribute("y") || 0) - (h ? 0 : s), u = e * a, g = (e - 90) * a, f = Math.cos(u), m = Math.sin(u), x = r * f, y = r * m, b = Math.cos(g), v = Math.sin(g), [[S, C], [k, M]] = [
                    l,
                    d
                ].map((t)=>[
                        t - t * f,
                        t * m
                    ]), w = i + c * (r - x) + S + M + p * b, T = w + x, A = T - o * b, P = A - x, L = s + p - c * y - C + k + p * v, O = L + y, D = O - o * v, E = D - y, I = Math.min(w, T, A, P), j = Math.min(L, O, D, E), B = Math.max(w, T, A, P) - I, R = Math.max(L, O, D, E) - j;
                return {
                    x: I,
                    y: j,
                    width: B,
                    height: R,
                    polygon: [
                        [
                            w,
                            L
                        ],
                        [
                            T,
                            O
                        ],
                        [
                            A,
                            D
                        ],
                        [
                            P,
                            E
                        ]
                    ]
                };
            }
            getStyle(t) {
                return c.getComputedStyle(this.element || this, "").getPropertyValue(t);
            }
            hasClass(t) {
                return -1 !== ("" + this.attr("class")).split(" ").indexOf(t);
            }
            hide() {
                return this.attr({
                    visibility: "hidden"
                });
            }
            htmlGetBBox() {
                return {
                    height: 0,
                    width: 0,
                    x: 0,
                    y: 0
                };
            }
            constructor(t, e){
                this.onEvents = {}, this.opacity = 1, this.SVG_NS = d, this.element = "span" === e || "body" === e ? g(e) : h.createElementNS(this.SVG_NS, e), this.renderer = t, this.styles = {}, v(this, "afterInit");
            }
            on(t, e) {
                let { onEvents: i } = this;
                return i[t] && i[t](), i[t] = p(this.element, t, e), this;
            }
            opacitySetter(t, e, i) {
                let s = Number(Number(t).toFixed(3));
                this.opacity = s, i.setAttribute(e, s);
            }
            reAlign() {
                this.alignOptions?.width && "left" !== this.alignOptions.align && (this.alignOptions.width = this.getBBox().width, this.placed = !1, this.align());
            }
            removeClass(t) {
                return this.attr("class", ("" + this.attr("class")).replace(M(t) ? RegExp(`(^| )${t}( |$)`) : t, " ").replace(/ +/g, " ").trim());
            }
            removeTextOutline() {
                let t = this.element.querySelector("tspan.highcharts-text-outline");
                t && this.safeRemoveChild(t);
            }
            safeRemoveChild(t) {
                let e = t.parentNode;
                e && e.removeChild(t);
            }
            setRadialReference(t) {
                let e = this.element.gradient && this.renderer.gradients[this.element.gradient];
                return this.element.radialReference = t, e && e.radAttr && e.animate(this.renderer.getRadialAttr(t, e.radAttr)), this;
            }
            shadow(t) {
                let { renderer: e } = this, i = w(this.parentGroup?.rotation === 90 ? {
                    offsetX: -1,
                    offsetY: -1
                } : {}, k(t) ? t : {}), s = e.shadowDefinition(i);
                return this.attr({
                    filter: t ? `url(${e.url}#${s})` : "none"
                });
            }
            show(t = !0) {
                return this.attr({
                    visibility: t ? "inherit" : "visible"
                });
            }
            "stroke-widthSetter"(t, e, i) {
                this[e] = t, i.setAttribute(e, t);
            }
            strokeWidth() {
                if (!this.renderer.styledMode) return this["stroke-width"] || 0;
                let t = this.getStyle("stroke-width"), e = 0, i;
                return /px$/.test(t) ? e = P(t) : "" !== t && (u(i = h.createElementNS(d, "rect"), {
                    width: t,
                    "stroke-width": 0
                }), this.element.parentNode.appendChild(i), e = i.getBBox().width, i.parentNode.removeChild(i)), e;
            }
            symbolAttr(t) {
                let e = this;
                I.symbolCustomAttribs.forEach(function(i) {
                    e[i] = A(t[i], e[i]);
                }), e.attr({
                    d: e.renderer.symbols[e.symbolName](e.x, e.y, e.width, e.height, e)
                });
            }
            textSetter(t) {
                t !== this.textStr && (delete this.textPxLength, this.textStr = t, this.added && this.renderer.buildText(this), this.reAlign());
            }
            titleSetter(t) {
                let e = this.element, i = e.getElementsByTagName("title")[0] || h.createElementNS(this.SVG_NS, "title");
                e.insertBefore ? e.insertBefore(i, e.firstChild) : e.appendChild(i), i.textContent = O(A(t, ""), [
                    /<[^>]*>/g,
                    ""
                ]).replace(/&lt;/g, "<").replace(/&gt;/g, ">");
            }
            toFront() {
                let t = this.element;
                return t.parentNode.appendChild(t), this;
            }
            translate(t, e) {
                return this.attr({
                    translateX: t,
                    translateY: e
                });
            }
            updateTransform(t = "transform") {
                let { element: e, matrix: i, rotation: s = 0, rotationOriginX: r, rotationOriginY: o, scaleX: n, scaleY: a, translateX: h = 0, translateY: l = 0 } = this, d = [
                    "translate(" + h + "," + l + ")"
                ];
                x(i) && d.push("matrix(" + i.join(",") + ")"), s && (d.push("rotate(" + s + " " + A(r, e.getAttribute("x"), 0) + " " + A(o, e.getAttribute("y") || 0) + ")"), this.text?.element.tagName === "SPAN" && this.text.attr({
                    rotation: s,
                    rotationOriginX: (r || 0) - this.padding,
                    rotationOriginY: (o || 0) - this.padding
                })), (x(n) || x(a)) && d.push("scale(" + A(n, 1) + " " + A(a, 1) + ")"), d.length && !(this.text || this).textPath && e.setAttribute(t, d.join(" "));
            }
            visibilitySetter(t, e, i) {
                "inherit" === t ? i.removeAttribute(e) : this[e] !== t && i.setAttribute(e, t), this[e] = t;
            }
            xGetter(t) {
                return "circle" === this.element.nodeName && ("x" === t ? t = "cx" : "y" === t && (t = "cy")), this._defaultGetter(t);
            }
            zIndexSetter(t, e) {
                let i = this.renderer, s = this.parentGroup, r = (s || i).element || i.box, o = this.element, n = r === i.box, a, h, l, d = !1, c, p = this.added, u;
                if (x(t) ? (o.setAttribute("data-z-index", t), t = +t, this[e] === t && (p = !1)) : x(this[e]) && o.removeAttribute("data-z-index"), this[e] = t, p) {
                    for((t = this.zIndex) && s && (s.handleZ = !0), u = (a = r.childNodes).length - 1; u >= 0 && !d; u--)c = !x(l = (h = a[u]).getAttribute("data-z-index")), h !== o && (t < 0 && c && !n && !u ? (r.insertBefore(o, a[u]), d = !0) : (P(l) <= t || c && (!x(t) || t >= 0)) && (r.insertBefore(o, a[u + 1]), d = !0));
                    d || (r.insertBefore(o, a[n ? 3 : 0]), d = !0);
                }
                return d;
            }
        }
        return I.symbolCustomAttribs = [
            "anchorX",
            "anchorY",
            "clockwise",
            "end",
            "height",
            "innerR",
            "r",
            "start",
            "width",
            "x",
            "y"
        ], I.prototype.strokeSetter = I.prototype.fillSetter, I.prototype.yGetter = I.prototype.xGetter, I.prototype.matrixSetter = I.prototype.rotationOriginXSetter = I.prototype.rotationOriginYSetter = I.prototype.rotationSetter = I.prototype.scaleXSetter = I.prototype.scaleYSetter = I.prototype.translateXSetter = I.prototype.translateYSetter = I.prototype.verticalAlignSetter = function(t, e) {
            this[e] = t, this.doTransform = !0;
        }, I;
    }), i(e, "Core/Renderer/SVG/SVGLabel.js", [
        e["Core/Renderer/SVG/SVGElement.js"],
        e["Core/Utilities.js"]
    ], function(t, e) {
        let { defined: i, extend: s, isNumber: r, merge: o, pick: n, removeEvent: a } = e;
        class h extends t {
            constructor(t, e, i, s, r, o, n, a, l, d){
                let c;
                super(t, "g"), this.paddingLeftSetter = this.paddingSetter, this.paddingRightSetter = this.paddingSetter, this.doUpdate = !1, this.textStr = e, this.x = i, this.y = s, this.anchorX = o, this.anchorY = n, this.baseline = l, this.className = d, this.addClass("button" === d ? "highcharts-no-tooltip" : "highcharts-label"), d && this.addClass("highcharts-" + d), this.text = t.text(void 0, 0, 0, a).attr({
                    zIndex: 1
                }), "string" == typeof r && ((c = /^url\((.*?)\)$/.test(r)) || this.renderer.symbols[r]) && (this.symbolKey = r), this.bBox = h.emptyBBox, this.padding = 3, this.baselineOffset = 0, this.needsBox = t.styledMode || c, this.deferredAttr = {}, this.alignFactor = 0;
            }
            alignSetter(t) {
                let e = {
                    left: 0,
                    center: .5,
                    right: 1
                }[t];
                e !== this.alignFactor && (this.alignFactor = e, this.bBox && r(this.xSetting) && this.attr({
                    x: this.xSetting
                }));
            }
            anchorXSetter(t, e) {
                this.anchorX = t, this.boxAttr(e, Math.round(t) - this.getCrispAdjust() - this.xSetting);
            }
            anchorYSetter(t, e) {
                this.anchorY = t, this.boxAttr(e, t - this.ySetting);
            }
            boxAttr(t, e) {
                this.box ? this.box.attr(t, e) : this.deferredAttr[t] = e;
            }
            css(e) {
                if (e) {
                    let t = {};
                    e = o(e), h.textProps.forEach((i)=>{
                        void 0 !== e[i] && (t[i] = e[i], delete e[i]);
                    }), this.text.css(t), "fontSize" in t || "fontWeight" in t ? this.updateTextPadding() : ("width" in t || "textOverflow" in t) && this.updateBoxSize();
                }
                return t.prototype.css.call(this, e);
            }
            destroy() {
                a(this.element, "mouseenter"), a(this.element, "mouseleave"), this.text && this.text.destroy(), this.box && (this.box = this.box.destroy()), t.prototype.destroy.call(this);
            }
            fillSetter(t, e) {
                t && (this.needsBox = !0), this.fill = t, this.boxAttr(e, t);
            }
            getBBox(t, e) {
                this.textStr && 0 === this.bBox.width && 0 === this.bBox.height && this.updateBoxSize();
                let { padding: i, height: s = 0, translateX: r = 0, translateY: o = 0, width: a = 0 } = this, h = n(this.paddingLeft, i), l = e ?? (this.rotation || 0), d = {
                    width: a,
                    height: s,
                    x: r + this.bBox.x - h,
                    y: o + this.bBox.y - i + this.baselineOffset
                };
                return l && (d = this.getRotatedBox(d, l)), d;
            }
            getCrispAdjust() {
                return (this.renderer.styledMode && this.box ? this.box.strokeWidth() : this["stroke-width"] ? parseInt(this["stroke-width"], 10) : 0) % 2 / 2;
            }
            heightSetter(t) {
                this.heightSetting = t, this.doUpdate = !0;
            }
            afterSetters() {
                super.afterSetters(), this.doUpdate && (this.updateBoxSize(), this.doUpdate = !1);
            }
            onAdd() {
                this.text.add(this), this.attr({
                    text: n(this.textStr, ""),
                    x: this.x || 0,
                    y: this.y || 0
                }), this.box && i(this.anchorX) && this.attr({
                    anchorX: this.anchorX,
                    anchorY: this.anchorY
                });
            }
            paddingSetter(t, e) {
                r(t) ? t !== this[e] && (this[e] = t, this.updateTextPadding()) : this[e] = void 0;
            }
            rSetter(t, e) {
                this.boxAttr(e, t);
            }
            strokeSetter(t, e) {
                this.stroke = t, this.boxAttr(e, t);
            }
            "stroke-widthSetter"(t, e) {
                t && (this.needsBox = !0), this["stroke-width"] = t, this.boxAttr(e, t);
            }
            "text-alignSetter"(t) {
                this.textAlign = t;
            }
            textSetter(t) {
                void 0 !== t && this.text.attr({
                    text: t
                }), this.updateTextPadding(), this.reAlign();
            }
            updateBoxSize() {
                let t;
                let e = this.text, o = {}, n = this.padding, a = this.bBox = (!r(this.widthSetting) || !r(this.heightSetting) || this.textAlign) && i(e.textStr) ? e.getBBox(void 0, 0) : h.emptyBBox;
                this.width = this.getPaddedWidth(), this.height = (this.heightSetting || a.height || 0) + 2 * n;
                let l = this.renderer.fontMetrics(e);
                if (this.baselineOffset = n + Math.min((this.text.firstLineMetrics || l).b, a.height || 1 / 0), this.heightSetting && (this.baselineOffset += (this.heightSetting - l.h) / 2), this.needsBox && !e.textPath) {
                    if (!this.box) {
                        let t = this.box = this.symbolKey ? this.renderer.symbol(this.symbolKey) : this.renderer.rect();
                        t.addClass(("button" === this.className ? "" : "highcharts-label-box") + (this.className ? " highcharts-" + this.className + "-box" : "")), t.add(this);
                    }
                    t = this.getCrispAdjust(), o.x = t, o.y = (this.baseline ? -this.baselineOffset : 0) + t, o.width = Math.round(this.width), o.height = Math.round(this.height), this.box.attr(s(o, this.deferredAttr)), this.deferredAttr = {};
                }
            }
            updateTextPadding() {
                let t = this.text;
                if (!t.textPath) {
                    this.updateBoxSize();
                    let e = this.baseline ? 0 : this.baselineOffset, s = n(this.paddingLeft, this.padding);
                    i(this.widthSetting) && this.bBox && ("center" === this.textAlign || "right" === this.textAlign) && (s += ({
                        center: .5,
                        right: 1
                    })[this.textAlign] * (this.widthSetting - this.bBox.width)), (s !== t.x || e !== t.y) && (t.attr("x", s), t.hasBoxWidthChanged && (this.bBox = t.getBBox(!0)), void 0 !== e && t.attr("y", e)), t.x = s, t.y = e;
                }
            }
            widthSetter(t) {
                this.widthSetting = r(t) ? t : void 0, this.doUpdate = !0;
            }
            getPaddedWidth() {
                let t = this.padding, e = n(this.paddingLeft, t), i = n(this.paddingRight, t);
                return (this.widthSetting || this.bBox.width || 0) + e + i;
            }
            xSetter(t) {
                this.x = t, this.alignFactor && (t -= this.alignFactor * this.getPaddedWidth(), this["forceAnimate:x"] = !0), this.xSetting = Math.round(t), this.attr("translateX", this.xSetting);
            }
            ySetter(t) {
                this.ySetting = this.y = Math.round(t), this.attr("translateY", this.ySetting);
            }
        }
        return h.emptyBBox = {
            width: 0,
            height: 0,
            x: 0,
            y: 0
        }, h.textProps = [
            "color",
            "direction",
            "fontFamily",
            "fontSize",
            "fontStyle",
            "fontWeight",
            "lineHeight",
            "textAlign",
            "textDecoration",
            "textOutline",
            "textOverflow",
            "whiteSpace",
            "width"
        ], h;
    }), i(e, "Core/Renderer/SVG/Symbols.js", [
        e["Core/Utilities.js"]
    ], function(t) {
        let { defined: e, isNumber: i, pick: s } = t;
        function r(t, i, r, o, n) {
            let a = [];
            if (n) {
                let h = n.start || 0, l = s(n.r, r), d = s(n.r, o || r), c = 2e-4 / (n.borderRadius ? 1 : Math.max(l, 1)), p = Math.abs((n.end || 0) - h - 2 * Math.PI) < c, u = (n.end || 0) - (p ? c : 0), g = n.innerR, f = s(n.open, p), m = Math.cos(h), x = Math.sin(h), y = Math.cos(u), b = Math.sin(u), v = s(n.longArc, u - h - Math.PI < c ? 0 : 1), S = [
                    "A",
                    l,
                    d,
                    0,
                    v,
                    s(n.clockwise, 1),
                    t + l * y,
                    i + d * b
                ];
                S.params = {
                    start: h,
                    end: u,
                    cx: t,
                    cy: i
                }, a.push([
                    "M",
                    t + l * m,
                    i + d * x
                ], S), e(g) && ((S = [
                    "A",
                    g,
                    g,
                    0,
                    v,
                    e(n.clockwise) ? 1 - n.clockwise : 0,
                    t + g * m,
                    i + g * x
                ]).params = {
                    start: u,
                    end: h,
                    cx: t,
                    cy: i
                }, a.push(f ? [
                    "M",
                    t + g * y,
                    i + g * b
                ] : [
                    "L",
                    t + g * y,
                    i + g * b
                ], S)), f || a.push([
                    "Z"
                ]);
            }
            return a;
        }
        function o(t, e, i, s, r) {
            return r && r.r ? n(t, e, i, s, r) : [
                [
                    "M",
                    t,
                    e
                ],
                [
                    "L",
                    t + i,
                    e
                ],
                [
                    "L",
                    t + i,
                    e + s
                ],
                [
                    "L",
                    t,
                    e + s
                ],
                [
                    "Z"
                ]
            ];
        }
        function n(t, e, i, s, r) {
            let o = r?.r || 0;
            return [
                [
                    "M",
                    t + o,
                    e
                ],
                [
                    "L",
                    t + i - o,
                    e
                ],
                [
                    "A",
                    o,
                    o,
                    0,
                    0,
                    1,
                    t + i,
                    e + o
                ],
                [
                    "L",
                    t + i,
                    e + s - o
                ],
                [
                    "A",
                    o,
                    o,
                    0,
                    0,
                    1,
                    t + i - o,
                    e + s
                ],
                [
                    "L",
                    t + o,
                    e + s
                ],
                [
                    "A",
                    o,
                    o,
                    0,
                    0,
                    1,
                    t,
                    e + s - o
                ],
                [
                    "L",
                    t,
                    e + o
                ],
                [
                    "A",
                    o,
                    o,
                    0,
                    0,
                    1,
                    t + o,
                    e
                ],
                [
                    "Z"
                ]
            ];
        }
        return {
            arc: r,
            callout: function(t, e, s, r, o) {
                let a = Math.min(o && o.r || 0, s, r), h = a + 6, l = o && o.anchorX, d = o && o.anchorY || 0, c = n(t, e, s, r, {
                    r: a
                });
                if (!i(l) || l < s && l > 0 && d < r && d > 0) return c;
                if (t + l > s - h) {
                    if (d > e + h && d < e + r - h) c.splice(3, 1, [
                        "L",
                        t + s,
                        d - 6
                    ], [
                        "L",
                        t + s + 6,
                        d
                    ], [
                        "L",
                        t + s,
                        d + 6
                    ], [
                        "L",
                        t + s,
                        e + r - a
                    ]);
                    else if (l < s) {
                        let i = d < e + h, o = i ? e : e + r;
                        c.splice(i ? 2 : 5, 0, [
                            "L",
                            l,
                            d
                        ], [
                            "L",
                            t + s - a,
                            o
                        ]);
                    } else c.splice(3, 1, [
                        "L",
                        t + s,
                        r / 2
                    ], [
                        "L",
                        l,
                        d
                    ], [
                        "L",
                        t + s,
                        r / 2
                    ], [
                        "L",
                        t + s,
                        e + r - a
                    ]);
                } else if (t + l < h) {
                    if (d > e + h && d < e + r - h) c.splice(7, 1, [
                        "L",
                        t,
                        d + 6
                    ], [
                        "L",
                        t - 6,
                        d
                    ], [
                        "L",
                        t,
                        d - 6
                    ], [
                        "L",
                        t,
                        e + a
                    ]);
                    else if (l > 0) {
                        let i = d < e + h, s = i ? e : e + r;
                        c.splice(i ? 1 : 6, 0, [
                            "L",
                            l,
                            d
                        ], [
                            "L",
                            t + a,
                            s
                        ]);
                    } else c.splice(7, 1, [
                        "L",
                        t,
                        r / 2
                    ], [
                        "L",
                        l,
                        d
                    ], [
                        "L",
                        t,
                        r / 2
                    ], [
                        "L",
                        t,
                        e + a
                    ]);
                } else d > r && l < s - h ? c.splice(5, 1, [
                    "L",
                    l + 6,
                    e + r
                ], [
                    "L",
                    l,
                    e + r + 6
                ], [
                    "L",
                    l - 6,
                    e + r
                ], [
                    "L",
                    t + a,
                    e + r
                ]) : d < 0 && l > h && c.splice(1, 1, [
                    "L",
                    l - 6,
                    e
                ], [
                    "L",
                    l,
                    e - 6
                ], [
                    "L",
                    l + 6,
                    e
                ], [
                    "L",
                    s - a,
                    e
                ]);
                return c;
            },
            circle: function(t, e, i, s) {
                return r(t + i / 2, e + s / 2, i / 2, s / 2, {
                    start: .5 * Math.PI,
                    end: 2.5 * Math.PI,
                    open: !1
                });
            },
            diamond: function(t, e, i, s) {
                return [
                    [
                        "M",
                        t + i / 2,
                        e
                    ],
                    [
                        "L",
                        t + i,
                        e + s / 2
                    ],
                    [
                        "L",
                        t + i / 2,
                        e + s
                    ],
                    [
                        "L",
                        t,
                        e + s / 2
                    ],
                    [
                        "Z"
                    ]
                ];
            },
            rect: o,
            roundedRect: n,
            square: o,
            triangle: function(t, e, i, s) {
                return [
                    [
                        "M",
                        t + i / 2,
                        e
                    ],
                    [
                        "L",
                        t + i,
                        e + s
                    ],
                    [
                        "L",
                        t,
                        e + s
                    ],
                    [
                        "Z"
                    ]
                ];
            },
            "triangle-down": function(t, e, i, s) {
                return [
                    [
                        "M",
                        t,
                        e
                    ],
                    [
                        "L",
                        t + i,
                        e
                    ],
                    [
                        "L",
                        t + i / 2,
                        e + s
                    ],
                    [
                        "Z"
                    ]
                ];
            }
        };
    }), i(e, "Core/Renderer/SVG/TextBuilder.js", [
        e["Core/Renderer/HTML/AST.js"],
        e["Core/Globals.js"],
        e["Core/Utilities.js"]
    ], function(t, e, i) {
        let { doc: s, SVG_NS: r, win: o } = e, { attr: n, extend: a, fireEvent: h, isString: l, objectEach: d, pick: c } = i;
        return class {
            constructor(t){
                let e = t.styles;
                this.renderer = t.renderer, this.svgElement = t, this.width = t.textWidth, this.textLineHeight = e && e.lineHeight, this.textOutline = e && e.textOutline, this.ellipsis = !!(e && "ellipsis" === e.textOverflow), this.noWrap = !!(e && "nowrap" === e.whiteSpace);
            }
            buildSVG() {
                let e = this.svgElement, i = e.element, r = e.renderer, o = c(e.textStr, "").toString(), n = -1 !== o.indexOf("<"), a = i.childNodes, h = !e.added && r.box, d = [
                    o,
                    this.ellipsis,
                    this.noWrap,
                    this.textLineHeight,
                    this.textOutline,
                    e.getStyle("font-size"),
                    this.width
                ].join(",");
                if (d !== e.textCache) {
                    e.textCache = d, delete e.actualWidth;
                    for(let t = a.length; t--;)i.removeChild(a[t]);
                    if (n || this.ellipsis || this.width || e.textPath || -1 !== o.indexOf(" ") && (!this.noWrap || /<br.*?>/g.test(o))) {
                        if ("" !== o) {
                            h && h.appendChild(i);
                            let s = new t(o);
                            this.modifyTree(s.nodes), s.addToDOM(i), this.modifyDOM(), this.ellipsis && -1 !== (i.textContent || "").indexOf("\u2026") && e.attr("title", this.unescapeEntities(e.textStr || "", [
                                "&lt;",
                                "&gt;"
                            ])), h && h.removeChild(i);
                        }
                    } else i.appendChild(s.createTextNode(this.unescapeEntities(o)));
                    l(this.textOutline) && e.applyTextOutline && e.applyTextOutline(this.textOutline);
                }
            }
            modifyDOM() {
                let t;
                let e = this.svgElement, i = n(e.element, "x");
                for(e.firstLineMetrics = void 0; t = e.element.firstChild;)if (/^[\s\u200B]*$/.test(t.textContent || " ")) e.element.removeChild(t);
                else break;
                [].forEach.call(e.element.querySelectorAll("tspan.highcharts-br"), (t, s)=>{
                    t.nextSibling && t.previousSibling && (0 === s && 1 === t.previousSibling.nodeType && (e.firstLineMetrics = e.renderer.fontMetrics(t.previousSibling)), n(t, {
                        dy: this.getLineHeight(t.nextSibling),
                        x: i
                    }));
                });
                let a = this.width || 0;
                if (!a) return;
                let h = (t, o)=>{
                    let h = t.textContent || "", l = h.replace(/([^\^])-/g, "$1- ").split(" "), d = !this.noWrap && (l.length > 1 || e.element.childNodes.length > 1), c = this.getLineHeight(o), p = 0, u = e.actualWidth;
                    if (this.ellipsis) h && this.truncate(t, h, void 0, 0, Math.max(0, a - .8 * c), (t, e)=>t.substring(0, e) + "\u2026");
                    else if (d) {
                        let h = [], d = [];
                        for(; o.firstChild && o.firstChild !== t;)d.push(o.firstChild), o.removeChild(o.firstChild);
                        for(; l.length;)l.length && !this.noWrap && p > 0 && (h.push(t.textContent || ""), t.textContent = l.join(" ").replace(/- /g, "-")), this.truncate(t, void 0, l, 0 === p && u || 0, a, (t, e)=>l.slice(0, e).join(" ").replace(/- /g, "-")), u = e.actualWidth, p++;
                        d.forEach((e)=>{
                            o.insertBefore(e, t);
                        }), h.forEach((e)=>{
                            o.insertBefore(s.createTextNode(e), t);
                            let a = s.createElementNS(r, "tspan");
                            a.textContent = "\u200B", n(a, {
                                dy: c,
                                x: i
                            }), o.insertBefore(a, t);
                        });
                    }
                }, l = (t)=>{
                    [].slice.call(t.childNodes).forEach((i)=>{
                        i.nodeType === o.Node.TEXT_NODE ? h(i, t) : (-1 !== i.className.baseVal.indexOf("highcharts-br") && (e.actualWidth = 0), l(i));
                    });
                };
                l(e.element);
            }
            getLineHeight(t) {
                let e = t.nodeType === o.Node.TEXT_NODE ? t.parentElement : t;
                return this.textLineHeight ? parseInt(this.textLineHeight.toString(), 10) : this.renderer.fontMetrics(e || this.svgElement.element).h;
            }
            modifyTree(t) {
                let e = (i, s)=>{
                    let { attributes: r = {}, children: o, style: n = {}, tagName: h } = i, l = this.renderer.styledMode;
                    if ("b" === h || "strong" === h ? l ? r.class = "highcharts-strong" : n.fontWeight = "bold" : ("i" === h || "em" === h) && (l ? r.class = "highcharts-emphasized" : n.fontStyle = "italic"), n && n.color && (n.fill = n.color), "br" === h) {
                        r.class = "highcharts-br", i.textContent = "\u200B";
                        let e = t[s + 1];
                        e && e.textContent && (e.textContent = e.textContent.replace(/^ +/gm, ""));
                    } else "a" === h && o && o.some((t)=>"#text" === t.tagName) && (i.children = [
                        {
                            children: o,
                            tagName: "tspan"
                        }
                    ]);
                    "#text" !== h && "a" !== h && (i.tagName = "tspan"), a(i, {
                        attributes: r,
                        style: n
                    }), o && o.filter((t)=>"#text" !== t.tagName).forEach(e);
                };
                t.forEach(e), h(this.svgElement, "afterModifyTree", {
                    nodes: t
                });
            }
            truncate(t, e, i, s, r, o) {
                let n, a;
                let h = this.svgElement, { rotation: l } = h, d = [], c = i ? 1 : 0, p = (e || i || "").length, u = p, g = function(e, r) {
                    let o = r || e, n = t.parentNode;
                    if (n && void 0 === d[o] && n.getSubStringLength) try {
                        d[o] = s + n.getSubStringLength(0, i ? o + 1 : o);
                    } catch (t) {}
                    return d[o];
                };
                if (h.rotation = 0, s + (a = g(t.textContent.length)) > r) {
                    for(; c <= p;)u = Math.ceil((c + p) / 2), i && (n = o(i, u)), a = g(u, n && n.length - 1), c === p ? c = p + 1 : a > r ? p = u - 1 : c = u;
                    0 === p ? t.textContent = "" : e && p === e.length - 1 || (t.textContent = n || o(e || i, u));
                }
                i && i.splice(0, u), h.actualWidth = a, h.rotation = l;
            }
            unescapeEntities(t, e) {
                return d(this.renderer.escapes, function(i, s) {
                    e && -1 !== e.indexOf(i) || (t = t.toString().replace(RegExp(i, "g"), s));
                }), t;
            }
        };
    }), i(e, "Core/Renderer/SVG/SVGRenderer.js", [
        e["Core/Renderer/HTML/AST.js"],
        e["Core/Defaults.js"],
        e["Core/Color/Color.js"],
        e["Core/Globals.js"],
        e["Core/Renderer/RendererRegistry.js"],
        e["Core/Renderer/SVG/SVGElement.js"],
        e["Core/Renderer/SVG/SVGLabel.js"],
        e["Core/Renderer/SVG/Symbols.js"],
        e["Core/Renderer/SVG/TextBuilder.js"],
        e["Core/Utilities.js"]
    ], function(t, e, i, s, r, o, n, a, h, l) {
        let d;
        let { defaultOptions: c } = e, { charts: p, deg2rad: u, doc: g, isFirefox: f, isMS: m, isWebKit: x, noop: y, SVG_NS: b, symbolSizes: v, win: S } = s, { addEvent: C, attr: k, createElement: M, crisp: w, css: T, defined: A, destroyObjectProperties: P, extend: L, isArray: O, isNumber: D, isObject: E, isString: I, merge: j, pick: B, pInt: R, replaceNested: z, uniqueKey: N } = l;
        class W {
            constructor(t, e, i, s, r, o, n){
                let a, h;
                let l = this.createElement("svg").attr({
                    version: "1.1",
                    class: "highcharts-root"
                }), d = l.element;
                n || l.css(this.getStyle(s || {})), t.appendChild(d), k(t, "dir", "ltr"), -1 === t.innerHTML.indexOf("xmlns") && k(d, "xmlns", this.SVG_NS), this.box = d, this.boxWrapper = l, this.alignedObjects = [], this.url = this.getReferenceURL(), this.createElement("desc").add().element.appendChild(g.createTextNode("Created with Highcharts 11.4.8")), this.defs = this.createElement("defs").add(), this.allowHTML = o, this.forExport = r, this.styledMode = n, this.gradients = {}, this.cache = {}, this.cacheKeys = [], this.imgCount = 0, this.rootFontSize = l.getStyle("font-size"), this.setSize(e, i, !1), f && t.getBoundingClientRect && ((a = function() {
                    T(t, {
                        left: 0,
                        top: 0
                    }), h = t.getBoundingClientRect(), T(t, {
                        left: Math.ceil(h.left) - h.left + "px",
                        top: Math.ceil(h.top) - h.top + "px"
                    });
                })(), this.unSubPixelFix = C(S, "resize", a));
            }
            definition(e) {
                return new t([
                    e
                ]).addToDOM(this.defs.element);
            }
            getReferenceURL() {
                if ((f || x) && g.getElementsByTagName("base").length) {
                    if (!A(d)) {
                        let e = N(), i = new t([
                            {
                                tagName: "svg",
                                attributes: {
                                    width: 8,
                                    height: 8
                                },
                                children: [
                                    {
                                        tagName: "defs",
                                        children: [
                                            {
                                                tagName: "clipPath",
                                                attributes: {
                                                    id: e
                                                },
                                                children: [
                                                    {
                                                        tagName: "rect",
                                                        attributes: {
                                                            width: 4,
                                                            height: 4
                                                        }
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        tagName: "rect",
                                        attributes: {
                                            id: "hitme",
                                            width: 8,
                                            height: 8,
                                            "clip-path": `url(#${e})`,
                                            fill: "rgba(0,0,0,0.001)"
                                        }
                                    }
                                ]
                            }
                        ]).addToDOM(g.body);
                        T(i, {
                            position: "fixed",
                            top: 0,
                            left: 0,
                            zIndex: 9e5
                        });
                        let s = g.elementFromPoint(6, 6);
                        d = "hitme" === (s && s.id), g.body.removeChild(i);
                    }
                    if (d) return z(S.location.href.split("#")[0], [
                        /<[^>]*>/g,
                        ""
                    ], [
                        /([\('\)])/g,
                        "\\$1"
                    ], [
                        / /g,
                        "%20"
                    ]);
                }
                return "";
            }
            getStyle(t) {
                return this.style = L({
                    fontFamily: "Helvetica, Arial, sans-serif",
                    fontSize: "1rem"
                }, t), this.style;
            }
            setStyle(t) {
                this.boxWrapper.css(this.getStyle(t));
            }
            isHidden() {
                return !this.boxWrapper.getBBox().width;
            }
            destroy() {
                let t = this.defs;
                return this.box = null, this.boxWrapper = this.boxWrapper.destroy(), P(this.gradients || {}), this.gradients = null, this.defs = t.destroy(), this.unSubPixelFix && this.unSubPixelFix(), this.alignedObjects = null, null;
            }
            createElement(t) {
                return new this.Element(this, t);
            }
            getRadialAttr(t, e) {
                return {
                    cx: t[0] - t[2] / 2 + (e.cx || 0) * t[2],
                    cy: t[1] - t[2] / 2 + (e.cy || 0) * t[2],
                    r: (e.r || 0) * t[2]
                };
            }
            shadowDefinition(t) {
                let e = [
                    `highcharts-drop-shadow-${this.chartIndex}`,
                    ...Object.keys(t).map((e)=>`${e}-${t[e]}`)
                ].join("-").toLowerCase().replace(/[^a-z\d\-]/g, ""), i = j({
                    color: "#000000",
                    offsetX: 1,
                    offsetY: 1,
                    opacity: .15,
                    width: 5
                }, t);
                return this.defs.element.querySelector(`#${e}`) || this.definition({
                    tagName: "filter",
                    attributes: {
                        id: e,
                        filterUnits: i.filterUnits
                    },
                    children: this.getShadowFilterContent(i)
                }), e;
            }
            getShadowFilterContent(t) {
                return [
                    {
                        tagName: "feDropShadow",
                        attributes: {
                            dx: t.offsetX,
                            dy: t.offsetY,
                            "flood-color": t.color,
                            "flood-opacity": Math.min(5 * t.opacity, 1),
                            stdDeviation: t.width / 2
                        }
                    }
                ];
            }
            buildText(t) {
                new h(t).buildSVG();
            }
            getContrast(t) {
                let e = i.parse(t).rgba.map((t)=>{
                    let e = t / 255;
                    return e <= .03928 ? e / 12.92 : Math.pow((e + .055) / 1.055, 2.4);
                }), s = .2126 * e[0] + .7152 * e[1] + .0722 * e[2];
                return 1.05 / (s + .05) > (s + .05) / .05 ? "#FFFFFF" : "#000000";
            }
            button(e, i, s, r, o = {}, n, a, h, l, d) {
                let p = this.label(e, i, s, l, void 0, void 0, d, void 0, "button"), u = this.styledMode, g = arguments, f = 0;
                o = j(c.global.buttonTheme, o), u && (delete o.fill, delete o.stroke, delete o["stroke-width"]);
                let x = o.states || {}, y = o.style || {};
                delete o.states, delete o.style;
                let b = [
                    t.filterUserAttributes(o)
                ], v = [
                    y
                ];
                return u || [
                    "hover",
                    "select",
                    "disabled"
                ].forEach((e, i)=>{
                    b.push(j(b[0], t.filterUserAttributes(g[i + 5] || x[e] || {}))), v.push(b[i + 1].style), delete b[i + 1].style;
                }), C(p.element, m ? "mouseover" : "mouseenter", function() {
                    3 !== f && p.setState(1);
                }), C(p.element, m ? "mouseout" : "mouseleave", function() {
                    3 !== f && p.setState(f);
                }), p.setState = (t = 0)=>{
                    if (1 !== t && (p.state = f = t), p.removeClass(/highcharts-button-(normal|hover|pressed|disabled)/).addClass("highcharts-button-" + [
                        "normal",
                        "hover",
                        "pressed",
                        "disabled"
                    ][t]), !u) {
                        p.attr(b[t]);
                        let e = v[t];
                        E(e) && p.css(e);
                    }
                }, p.attr(b[0]), !u && (p.css(L({
                    cursor: "default"
                }, y)), d && p.text.css({
                    pointerEvents: "none"
                })), p.on("touchstart", (t)=>t.stopPropagation()).on("click", function(t) {
                    3 !== f && r.call(p, t);
                });
            }
            crispLine(t, e) {
                let [i, s] = t;
                return A(i[1]) && i[1] === s[1] && (i[1] = s[1] = w(i[1], e)), A(i[2]) && i[2] === s[2] && (i[2] = s[2] = w(i[2], e)), t;
            }
            path(t) {
                let e = this.styledMode ? {} : {
                    fill: "none"
                };
                return O(t) ? e.d = t : E(t) && L(e, t), this.createElement("path").attr(e);
            }
            circle(t, e, i) {
                let s = E(t) ? t : void 0 === t ? {} : {
                    x: t,
                    y: e,
                    r: i
                }, r = this.createElement("circle");
                return r.xSetter = r.ySetter = function(t, e, i) {
                    i.setAttribute("c" + e, t);
                }, r.attr(s);
            }
            arc(t, e, i, s, r, o) {
                let n;
                E(t) ? (e = (n = t).y, i = n.r, s = n.innerR, r = n.start, o = n.end, t = n.x) : n = {
                    innerR: s,
                    start: r,
                    end: o
                };
                let a = this.symbol("arc", t, e, i, i, n);
                return a.r = i, a;
            }
            rect(t, e, i, s, r, o) {
                let n = E(t) ? t : void 0 === t ? {} : {
                    x: t,
                    y: e,
                    r: r,
                    width: Math.max(i || 0, 0),
                    height: Math.max(s || 0, 0)
                }, a = this.createElement("rect");
                return this.styledMode || (void 0 !== o && (n["stroke-width"] = o, L(n, a.crisp(n))), n.fill = "none"), a.rSetter = function(t, e, i) {
                    a.r = t, k(i, {
                        rx: t,
                        ry: t
                    });
                }, a.rGetter = function() {
                    return a.r || 0;
                }, a.attr(n);
            }
            roundedRect(t) {
                return this.symbol("roundedRect").attr(t);
            }
            setSize(t, e, i) {
                this.width = t, this.height = e, this.boxWrapper.animate({
                    width: t,
                    height: e
                }, {
                    step: function() {
                        this.attr({
                            viewBox: "0 0 " + this.attr("width") + " " + this.attr("height")
                        });
                    },
                    duration: B(i, !0) ? void 0 : 0
                }), this.alignElements();
            }
            g(t) {
                let e = this.createElement("g");
                return t ? e.attr({
                    class: "highcharts-" + t
                }) : e;
            }
            image(t, e, i, s, r, o) {
                let n = {
                    preserveAspectRatio: "none"
                };
                D(e) && (n.x = e), D(i) && (n.y = i), D(s) && (n.width = s), D(r) && (n.height = r);
                let a = this.createElement("image").attr(n), h = function(e) {
                    a.attr({
                        href: t
                    }), o.call(a, e);
                };
                if (o) {
                    a.attr({
                        href: "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
                    });
                    let e = new S.Image;
                    C(e, "load", h), e.src = t, e.complete && h({});
                } else a.attr({
                    href: t
                });
                return a;
            }
            symbol(t, e, i, s, r, o) {
                let n, a, h, l;
                let d = this, c = /^url\((.*?)\)$/, u = c.test(t), f = !u && (this.symbols[t] ? t : "circle"), m = f && this.symbols[f];
                if (m) "number" == typeof e && (a = m.call(this.symbols, e || 0, i || 0, s || 0, r || 0, o)), n = this.path(a), d.styledMode || n.attr("fill", "none"), L(n, {
                    symbolName: f || void 0,
                    x: e,
                    y: i,
                    width: s,
                    height: r
                }), o && L(n, o);
                else if (u) {
                    h = t.match(c)[1];
                    let s = n = this.image(h);
                    s.imgwidth = B(o && o.width, v[h] && v[h].width), s.imgheight = B(o && o.height, v[h] && v[h].height), l = (t)=>t.attr({
                            width: t.width,
                            height: t.height
                        }), [
                        "width",
                        "height"
                    ].forEach((t)=>{
                        s[`${t}Setter`] = function(t, e) {
                            this[e] = t;
                            let { alignByTranslate: i, element: s, width: r, height: n, imgwidth: a, imgheight: h } = this, l = "width" === e ? a : h, d = 1;
                            o && "within" === o.backgroundSize && r && n && a && h ? (d = Math.min(r / a, n / h), k(s, {
                                width: Math.round(a * d),
                                height: Math.round(h * d)
                            })) : s && l && s.setAttribute(e, l), !i && a && h && this.translate(((r || 0) - a * d) / 2, ((n || 0) - h * d) / 2);
                        };
                    }), A(e) && s.attr({
                        x: e,
                        y: i
                    }), s.isImg = !0, s.symbolUrl = t, A(s.imgwidth) && A(s.imgheight) ? l(s) : (s.attr({
                        width: 0,
                        height: 0
                    }), M("img", {
                        onload: function() {
                            let t = p[d.chartIndex];
                            0 === this.width && (T(this, {
                                position: "absolute",
                                top: "-999em"
                            }), g.body.appendChild(this)), v[h] = {
                                width: this.width,
                                height: this.height
                            }, s.imgwidth = this.width, s.imgheight = this.height, s.element && l(s), this.parentNode && this.parentNode.removeChild(this), d.imgCount--, d.imgCount || !t || t.hasLoaded || t.onload();
                        },
                        src: h
                    }), this.imgCount++);
                }
                return n;
            }
            clipRect(t, e, i, s) {
                return this.rect(t, e, i, s, 0);
            }
            text(t, e, i, s) {
                let r = {};
                if (s && (this.allowHTML || !this.forExport)) return this.html(t, e, i);
                r.x = Math.round(e || 0), i && (r.y = Math.round(i)), A(t) && (r.text = t);
                let o = this.createElement("text").attr(r);
                return s && (!this.forExport || this.allowHTML) || (o.xSetter = function(t, e, i) {
                    let s = i.getElementsByTagName("tspan"), r = i.getAttribute(e);
                    for(let i = 0, o; i < s.length; i++)(o = s[i]).getAttribute(e) === r && o.setAttribute(e, t);
                    i.setAttribute(e, t);
                }), o;
            }
            fontMetrics(t) {
                let e = R(o.prototype.getStyle.call(t, "font-size") || 0), i = e < 24 ? e + 3 : Math.round(1.2 * e), s = Math.round(.8 * i);
                return {
                    h: i,
                    b: s,
                    f: e
                };
            }
            rotCorr(t, e, i) {
                let s = t;
                return e && i && (s = Math.max(s * Math.cos(e * u), 4)), {
                    x: -t / 3 * Math.sin(e * u),
                    y: s
                };
            }
            pathToSegments(t) {
                let e = [], i = [], s = {
                    A: 8,
                    C: 7,
                    H: 2,
                    L: 3,
                    M: 3,
                    Q: 5,
                    S: 5,
                    T: 3,
                    V: 2
                };
                for(let r = 0; r < t.length; r++)I(i[0]) && D(t[r]) && i.length === s[i[0].toUpperCase()] && t.splice(r, 0, i[0].replace("M", "L").replace("m", "l")), "string" == typeof t[r] && (i.length && e.push(i.slice(0)), i.length = 0), i.push(t[r]);
                return e.push(i.slice(0)), e;
            }
            label(t, e, i, s, r, o, a, h, l) {
                return new n(this, t, e, i, s, r, o, a, h, l);
            }
            alignElements() {
                this.alignedObjects.forEach((t)=>t.align());
            }
        }
        return L(W.prototype, {
            Element: o,
            SVG_NS: b,
            escapes: {
                "&": "&amp;",
                "<": "&lt;",
                ">": "&gt;",
                "'": "&#39;",
                '"': "&quot;"
            },
            symbols: a,
            draw: y
        }), r.registerRendererType("svg", W, !0), W;
    }), i(e, "Core/Renderer/HTML/HTMLElement.js", [
        e["Core/Renderer/HTML/AST.js"],
        e["Core/Globals.js"],
        e["Core/Renderer/SVG/SVGElement.js"],
        e["Core/Utilities.js"]
    ], function(t, e, i, s) {
        let { composed: r } = e, { attr: o, css: n, createElement: a, defined: h, extend: l, pInt: d, pushUnique: c } = s;
        function p(t, e, s) {
            let r = this.div?.style || s.style;
            i.prototype[`${e}Setter`].call(this, t, e, s), r && (r[e] = t);
        }
        let u = (t, e)=>{
            if (!t.div) {
                let s = o(t.element, "class"), r = t.css, n = a("div", s ? {
                    className: s
                } : void 0, {
                    position: "absolute",
                    left: `${t.translateX || 0}px`,
                    top: `${t.translateY || 0}px`,
                    ...t.styles,
                    display: t.display,
                    opacity: t.opacity,
                    visibility: t.visibility
                }, t.parentGroup?.div || e);
                t.classSetter = (t, e, i)=>{
                    i.setAttribute("class", t), n.className = t;
                }, t.translateXSetter = t.translateYSetter = (e, i)=>{
                    t[i] = e, n.style["translateX" === i ? "left" : "top"] = `${e}px`, t.doTransform = !0;
                }, t.opacitySetter = t.visibilitySetter = p, t.css = (e)=>(r.call(t, e), e.cursor && (n.style.cursor = e.cursor), e.pointerEvents && (n.style.pointerEvents = e.pointerEvents), t), t.on = function() {
                    return i.prototype.on.apply({
                        element: n,
                        onEvents: t.onEvents
                    }, arguments), t;
                }, t.div = n;
            }
            return t.div;
        };
        class g extends i {
            static compose(t) {
                c(r, this.compose) && (t.prototype.html = function(t, e, i) {
                    return new g(this, "span").attr({
                        text: t,
                        x: Math.round(e),
                        y: Math.round(i)
                    });
                });
            }
            constructor(t, e){
                super(t, e), this.css({
                    position: "absolute",
                    ...t.styledMode ? {} : {
                        fontFamily: t.style.fontFamily,
                        fontSize: t.style.fontSize
                    }
                }), this.element.style.whiteSpace = "nowrap";
            }
            getSpanCorrection(t, e, i) {
                this.xCorr = -t * i, this.yCorr = -e;
            }
            css(t) {
                let e;
                let { element: i } = this, s = "SPAN" === i.tagName && t && "width" in t, r = s && t.width;
                return s && (delete t.width, this.textWidth = d(r) || void 0, e = !0), t?.textOverflow === "ellipsis" && (t.whiteSpace = "nowrap", t.overflow = "hidden"), l(this.styles, t), n(i, t), e && this.updateTransform(), this;
            }
            htmlGetBBox() {
                let { element: t } = this;
                return {
                    x: t.offsetLeft,
                    y: t.offsetTop,
                    width: t.offsetWidth,
                    height: t.offsetHeight
                };
            }
            updateTransform() {
                if (!this.added) {
                    this.alignOnAdd = !0;
                    return;
                }
                let { element: t, renderer: e, rotation: i, rotationOriginX: s, rotationOriginY: r, styles: o, textAlign: a = "left", textWidth: l, translateX: d = 0, translateY: c = 0, x: p = 0, y: u = 0 } = this, g = {
                    left: 0,
                    center: .5,
                    right: 1
                }[a], f = o.whiteSpace;
                if (n(t, {
                    marginLeft: `${d}px`,
                    marginTop: `${c}px`
                }), "SPAN" === t.tagName) {
                    let o = [
                        i,
                        a,
                        t.innerHTML,
                        l,
                        this.textAlign
                    ].join(","), d = -(this.parentGroup?.padding * 1) || 0, c, m = !1;
                    if (l !== this.oldTextWidth) {
                        let e = this.textPxLength ? this.textPxLength : (n(t, {
                            width: "",
                            whiteSpace: f || "nowrap"
                        }), t.offsetWidth), s = l || 0;
                        (s > this.oldTextWidth || e > s) && (/[ \-]/.test(t.textContent || t.innerText) || "ellipsis" === t.style.textOverflow) && (n(t, {
                            width: e > s || i ? l + "px" : "auto",
                            display: "block",
                            whiteSpace: f || "normal"
                        }), this.oldTextWidth = l, m = !0);
                    }
                    this.hasBoxWidthChanged = m, o !== this.cTT && (c = e.fontMetrics(t).b, h(i) && (i !== (this.oldRotation || 0) || a !== this.oldAlign) && this.setSpanRotation(i, d, d), this.getSpanCorrection(!h(i) && this.textPxLength || t.offsetWidth, c, g));
                    let { xCorr: x = 0, yCorr: y = 0 } = this, b = (s ?? p) - x - p - d, v = (r ?? u) - y - u - d;
                    n(t, {
                        left: `${p + x}px`,
                        top: `${u + y}px`,
                        transformOrigin: `${b}px ${v}px`
                    }), this.cTT = o, this.oldRotation = i, this.oldAlign = a;
                }
            }
            setSpanRotation(t, e, i) {
                n(this.element, {
                    transform: `rotate(${t}deg)`,
                    transformOrigin: `${e}% ${i}px`
                });
            }
            add(t) {
                let e;
                let i = this.renderer.box.parentNode, s = [];
                if (this.parentGroup = t, t && !(e = t.div)) {
                    let r = t;
                    for(; r;)s.push(r), r = r.parentGroup;
                    for (let t of s.reverse())e = u(t, i);
                }
                return (e || i).appendChild(this.element), this.added = !0, this.alignOnAdd && this.updateTransform(), this;
            }
            textSetter(e) {
                e !== this.textStr && (delete this.bBox, delete this.oldTextWidth, t.setElementHTML(this.element, e ?? ""), this.textStr = e, this.doTransform = !0);
            }
            alignSetter(t) {
                this.alignValue = this.textAlign = t, this.doTransform = !0;
            }
            xSetter(t, e) {
                this[e] = t, this.doTransform = !0;
            }
        }
        let f = g.prototype;
        return f.visibilitySetter = f.opacitySetter = p, f.ySetter = f.rotationSetter = f.rotationOriginXSetter = f.rotationOriginYSetter = f.xSetter, g;
    }), i(e, "Core/Axis/AxisDefaults.js", [], function() {
        var t, e;
        return (e = t || (t = {})).xAxis = {
            alignTicks: !0,
            allowDecimals: void 0,
            panningEnabled: !0,
            zIndex: 2,
            zoomEnabled: !0,
            dateTimeLabelFormats: {
                millisecond: {
                    main: "%H:%M:%S.%L",
                    range: !1
                },
                second: {
                    main: "%H:%M:%S",
                    range: !1
                },
                minute: {
                    main: "%H:%M",
                    range: !1
                },
                hour: {
                    main: "%H:%M",
                    range: !1
                },
                day: {
                    main: "%e %b"
                },
                week: {
                    main: "%e %b"
                },
                month: {
                    main: "%b '%y"
                },
                year: {
                    main: "%Y"
                }
            },
            endOnTick: !1,
            gridLineDashStyle: "Solid",
            gridZIndex: 1,
            labels: {
                autoRotationLimit: 80,
                distance: 15,
                enabled: !0,
                indentation: 10,
                overflow: "justify",
                reserveSpace: void 0,
                rotation: void 0,
                staggerLines: 0,
                step: 0,
                useHTML: !1,
                zIndex: 7,
                style: {
                    color: "#333333",
                    cursor: "default",
                    fontSize: "0.8em"
                }
            },
            maxPadding: .01,
            minorGridLineDashStyle: "Solid",
            minorTickLength: 2,
            minorTickPosition: "outside",
            minorTicksPerMajor: 5,
            minPadding: .01,
            offset: void 0,
            reversed: void 0,
            reversedStacks: !1,
            showEmpty: !0,
            showFirstLabel: !0,
            showLastLabel: !0,
            startOfWeek: 1,
            startOnTick: !1,
            tickLength: 10,
            tickPixelInterval: 100,
            tickmarkPlacement: "between",
            tickPosition: "outside",
            title: {
                align: "middle",
                useHTML: !1,
                x: 0,
                y: 0,
                style: {
                    color: "#666666",
                    fontSize: "0.8em"
                }
            },
            visible: !0,
            minorGridLineColor: "#f2f2f2",
            minorGridLineWidth: 1,
            minorTickColor: "#999999",
            lineColor: "#333333",
            lineWidth: 1,
            gridLineColor: "#e6e6e6",
            gridLineWidth: void 0,
            tickColor: "#333333"
        }, e.yAxis = {
            reversedStacks: !0,
            endOnTick: !0,
            maxPadding: .05,
            minPadding: .05,
            tickPixelInterval: 72,
            showLastLabel: !0,
            labels: {
                x: void 0
            },
            startOnTick: !0,
            title: {
                text: "Values"
            },
            stackLabels: {
                animation: {},
                allowOverlap: !1,
                enabled: !1,
                crop: !0,
                overflow: "justify",
                formatter: function() {
                    let { numberFormatter: t } = this.axis.chart;
                    return t(this.total || 0, -1);
                },
                style: {
                    color: "#000000",
                    fontSize: "0.7em",
                    fontWeight: "bold",
                    textOutline: "1px contrast"
                }
            },
            gridLineWidth: 1,
            lineWidth: 0
        }, t;
    }), i(e, "Core/Foundation.js", [
        e["Core/Utilities.js"]
    ], function(t) {
        var e;
        let { addEvent: i, isFunction: s, objectEach: r, removeEvent: o } = t;
        return (e || (e = {})).registerEventOptions = function(t, e) {
            t.eventOptions = t.eventOptions || {}, r(e.events, function(e, r) {
                t.eventOptions[r] !== e && (t.eventOptions[r] && (o(t, r, t.eventOptions[r]), delete t.eventOptions[r]), s(e) && (t.eventOptions[r] = e, i(t, r, e, {
                    order: 0
                })));
            });
        }, e;
    }), i(e, "Core/Axis/Tick.js", [
        e["Core/Templating.js"],
        e["Core/Globals.js"],
        e["Core/Utilities.js"]
    ], function(t, e, i) {
        let { deg2rad: s } = e, { clamp: r, correctFloat: o, defined: n, destroyObjectProperties: a, extend: h, fireEvent: l, isNumber: d, merge: c, objectEach: p, pick: u } = i;
        return class {
            constructor(t, e, i, s, r){
                this.isNew = !0, this.isNewLabel = !0, this.axis = t, this.pos = e, this.type = i || "", this.parameters = r || {}, this.tickmarkOffset = this.parameters.tickmarkOffset, this.options = this.parameters.options, l(this, "init"), i || s || this.addLabel();
            }
            addLabel() {
                let e = this, i = e.axis, s = i.options, r = i.chart, a = i.categories, c = i.logarithmic, p = i.names, g = e.pos, f = u(e.options && e.options.labels, s.labels), m = i.tickPositions, x = g === m[0], y = g === m[m.length - 1], b = (!f.step || 1 === f.step) && 1 === i.tickInterval, v = m.info, S = e.label, C, k, M, w = this.parameters.category || (a ? u(a[g], p[g], g) : g);
                c && d(w) && (w = o(c.lin2log(w))), i.dateTime && (v ? C = (k = r.time.resolveDTLFormat(s.dateTimeLabelFormats[!s.grid && v.higherRanks[g] || v.unitName])).main : d(w) && (C = i.dateTime.getXDateFormat(w, s.dateTimeLabelFormats || {}))), e.isFirst = x, e.isLast = y;
                let T = {
                    axis: i,
                    chart: r,
                    dateTimeLabelFormat: C,
                    isFirst: x,
                    isLast: y,
                    pos: g,
                    tick: e,
                    tickPositionInfo: v,
                    value: w
                };
                l(this, "labelFormat", T);
                let A = (e)=>f.formatter ? f.formatter.call(e, e) : f.format ? (e.text = i.defaultLabelFormatter.call(e), t.format(f.format, e, r)) : i.defaultLabelFormatter.call(e), P = A.call(T, T), L = k && k.list;
                L ? e.shortenLabel = function() {
                    for(M = 0; M < L.length; M++)if (h(T, {
                        dateTimeLabelFormat: L[M]
                    }), S.attr({
                        text: A.call(T, T)
                    }), S.getBBox().width < i.getSlotWidth(e) - 2 * (f.padding || 0)) return;
                    S.attr({
                        text: ""
                    });
                } : e.shortenLabel = void 0, b && i._addedPlotLB && e.moveLabel(P, f), n(S) || e.movedLabel ? S && S.textStr !== P && !b && (!S.textWidth || f.style.width || S.styles.width || S.css({
                    width: null
                }), S.attr({
                    text: P
                }), S.textPxLength = S.getBBox().width) : (e.label = S = e.createLabel(P, f), e.rotation = 0);
            }
            createLabel(t, e, i) {
                let s = this.axis, r = s.chart, o = n(t) && e.enabled ? r.renderer.text(t, i?.x, i?.y, e.useHTML).add(s.labelGroup) : void 0;
                return o && (r.styledMode || o.css(c(e.style)), o.textPxLength = o.getBBox().width), o;
            }
            destroy() {
                a(this, this.axis);
            }
            getPosition(t, e, i, s) {
                let n = this.axis, a = n.chart, h = s && a.oldChartHeight || a.chartHeight, d = {
                    x: t ? o(n.translate(e + i, void 0, void 0, s) + n.transB) : n.left + n.offset + (n.opposite ? (s && a.oldChartWidth || a.chartWidth) - n.right - n.left : 0),
                    y: t ? h - n.bottom + n.offset - (n.opposite ? n.height : 0) : o(h - n.translate(e + i, void 0, void 0, s) - n.transB)
                };
                return d.y = r(d.y, -1000000000, 1e9), l(this, "afterGetPosition", {
                    pos: d
                }), d;
            }
            getLabelPosition(t, e, i, r, o, a, h, d) {
                let c, p;
                let g = this.axis, f = g.transA, m = g.isLinked && g.linkedParent ? g.linkedParent.reversed : g.reversed, x = g.staggerLines, y = g.tickRotCorr || {
                    x: 0,
                    y: 0
                }, b = r || g.reserveSpaceDefault ? 0 : -g.labelOffset * ("center" === g.labelAlign ? .5 : 1), v = o.distance, S = {};
                return c = 0 === g.side ? i.rotation ? -v : -i.getBBox().height : 2 === g.side ? y.y + v : Math.cos(i.rotation * s) * (y.y - i.getBBox(!1, 0).height / 2), n(o.y) && (c = 0 === g.side && g.horiz ? o.y + c : o.y), t = t + u(o.x, [
                    0,
                    1,
                    0,
                    -1
                ][g.side] * v) + b + y.x - (a && r ? a * f * (m ? -1 : 1) : 0), e = e + c - (a && !r ? a * f * (m ? 1 : -1) : 0), x && (p = h / (d || 1) % x, g.opposite && (p = x - p - 1), e += p * (g.labelOffset / x)), S.x = t, S.y = Math.round(e), l(this, "afterGetLabelPosition", {
                    pos: S,
                    tickmarkOffset: a,
                    index: h
                }), S;
            }
            getLabelSize() {
                return this.label ? this.label.getBBox()[this.axis.horiz ? "height" : "width"] : 0;
            }
            getMarkPath(t, e, i, s, r = !1, o) {
                return o.crispLine([
                    [
                        "M",
                        t,
                        e
                    ],
                    [
                        "L",
                        t + (r ? 0 : -i),
                        e + (r ? i : 0)
                    ]
                ], s);
            }
            handleOverflow(t) {
                let e = this.axis, i = e.options.labels, r = t.x, o = e.chart.chartWidth, n = e.chart.spacing, a = u(e.labelLeft, Math.min(e.pos, n[3])), h = u(e.labelRight, Math.max(e.isRadial ? 0 : e.pos + e.len, o - n[1])), l = this.label, d = this.rotation, c = {
                    left: 0,
                    center: .5,
                    right: 1
                }[e.labelAlign || l.attr("align")], p = l.getBBox().width, g = e.getSlotWidth(this), f = {}, m = g, x = 1, y, b, v;
                d || "justify" !== i.overflow ? d < 0 && r - c * p < a ? v = Math.round(r / Math.cos(d * s) - a) : d > 0 && r + c * p > h && (v = Math.round((o - r) / Math.cos(d * s))) : (y = r - c * p, b = r + (1 - c) * p, y < a ? m = t.x + m * (1 - c) - a : b > h && (m = h - t.x + m * c, x = -1), (m = Math.min(g, m)) < g && "center" === e.labelAlign && (t.x += x * (g - m - c * (g - Math.min(p, m)))), (p > m || e.autoRotation && (l.styles || {}).width) && (v = m)), v && (this.shortenLabel ? this.shortenLabel() : (f.width = Math.floor(v) + "px", (i.style || {}).textOverflow || (f.textOverflow = "ellipsis"), l.css(f)));
            }
            moveLabel(t, e) {
                let i = this, s = i.label, r = i.axis, o = !1, n;
                s && s.textStr === t ? (i.movedLabel = s, o = !0, delete i.label) : p(r.ticks, function(e) {
                    o || e.isNew || e === i || !e.label || e.label.textStr !== t || (i.movedLabel = e.label, o = !0, e.labelPos = i.movedLabel.xy, delete e.label);
                }), !o && (i.labelPos || s) && (n = i.labelPos || s.xy, i.movedLabel = i.createLabel(t, e, n), i.movedLabel && i.movedLabel.attr({
                    opacity: 0
                }));
            }
            render(t, e, i) {
                let s = this.axis, r = s.horiz, n = this.pos, a = u(this.tickmarkOffset, s.tickmarkOffset), h = this.getPosition(r, n, a, e), d = h.x, c = h.y, p = s.pos, g = p + s.len, f = r ? d : c;
                !s.chart.polar && this.isNew && (o(f) < p || f > g) && (i = 0);
                let m = u(i, this.label && this.label.newOpacity, 1);
                i = u(i, 1), this.isActive = !0, this.renderGridLine(e, i), this.renderMark(h, i), this.renderLabel(h, e, m, t), this.isNew = !1, l(this, "afterRender");
            }
            renderGridLine(t, e) {
                let i = this.axis, s = i.options, r = {}, o = this.pos, n = this.type, a = u(this.tickmarkOffset, i.tickmarkOffset), h = i.chart.renderer, l = this.gridLine, d, c = s.gridLineWidth, p = s.gridLineColor, g = s.gridLineDashStyle;
                "minor" === this.type && (c = s.minorGridLineWidth, p = s.minorGridLineColor, g = s.minorGridLineDashStyle), l || (i.chart.styledMode || (r.stroke = p, r["stroke-width"] = c || 0, r.dashstyle = g), n || (r.zIndex = 1), t && (e = 0), this.gridLine = l = h.path().attr(r).addClass("highcharts-" + (n ? n + "-" : "") + "grid-line").add(i.gridGroup)), l && (d = i.getPlotLinePath({
                    value: o + a,
                    lineWidth: l.strokeWidth(),
                    force: "pass",
                    old: t,
                    acrossPanes: !1
                })) && l[t || this.isNew ? "attr" : "animate"]({
                    d: d,
                    opacity: e
                });
            }
            renderMark(t, e) {
                let i = this.axis, s = i.options, r = i.chart.renderer, o = this.type, n = i.tickSize(o ? o + "Tick" : "tick"), a = t.x, h = t.y, l = u(s["minor" !== o ? "tickWidth" : "minorTickWidth"], !o && i.isXAxis ? 1 : 0), d = s["minor" !== o ? "tickColor" : "minorTickColor"], c = this.mark, p = !c;
                n && (i.opposite && (n[0] = -n[0]), c || (this.mark = c = r.path().addClass("highcharts-" + (o ? o + "-" : "") + "tick").add(i.axisGroup), i.chart.styledMode || c.attr({
                    stroke: d,
                    "stroke-width": l
                })), c[p ? "attr" : "animate"]({
                    d: this.getMarkPath(a, h, n[0], c.strokeWidth(), i.horiz, r),
                    opacity: e
                }));
            }
            renderLabel(t, e, i, s) {
                let r = this.axis, o = r.horiz, n = r.options, a = this.label, h = n.labels, l = h.step, c = u(this.tickmarkOffset, r.tickmarkOffset), p = t.x, g = t.y, f = !0;
                a && d(p) && (a.xy = t = this.getLabelPosition(p, g, a, o, h, c, s, l), (!this.isFirst || this.isLast || n.showFirstLabel) && (!this.isLast || this.isFirst || n.showLastLabel) ? !o || h.step || h.rotation || e || 0 === i || this.handleOverflow(t) : f = !1, l && s % l && (f = !1), f && d(t.y) ? (t.opacity = i, a[this.isNewLabel ? "attr" : "animate"](t).show(!0), this.isNewLabel = !1) : (a.hide(), this.isNewLabel = !0));
            }
            replaceMovedLabel() {
                let t = this.label, e = this.axis;
                t && !this.isNew && (t.animate({
                    opacity: 0
                }, void 0, t.destroy), delete this.label), e.isDirty = !0, this.label = this.movedLabel, delete this.movedLabel;
            }
        };
    }), i(e, "Core/Axis/Axis.js", [
        e["Core/Animation/AnimationUtilities.js"],
        e["Core/Axis/AxisDefaults.js"],
        e["Core/Color/Color.js"],
        e["Core/Defaults.js"],
        e["Core/Foundation.js"],
        e["Core/Globals.js"],
        e["Core/Axis/Tick.js"],
        e["Core/Utilities.js"]
    ], function(t, e, i, s, r, o, n, a) {
        let { animObject: h } = t, { xAxis: l, yAxis: d } = e, { defaultOptions: c } = s, { registerEventOptions: p } = r, { deg2rad: u } = o, { arrayMax: g, arrayMin: f, clamp: m, correctFloat: x, defined: y, destroyObjectProperties: b, erase: v, error: S, extend: C, fireEvent: k, getClosestDistance: M, insertItem: w, isArray: T, isNumber: A, isString: P, merge: L, normalizeTickInterval: O, objectEach: D, pick: E, relativeLength: I, removeEvent: j, splat: B, syncTimeout: R } = a, z = (t, e)=>O(e, void 0, void 0, E(t.options.allowDecimals, e < .5 || void 0 !== t.tickAmount), !!t.tickAmount);
        C(c, {
            xAxis: l,
            yAxis: L(l, d)
        });
        class N {
            constructor(t, e, i){
                this.init(t, e, i);
            }
            init(t, e, i = this.coll) {
                let s = "xAxis" === i, r = this.isZAxis || (t.inverted ? !s : s);
                this.chart = t, this.horiz = r, this.isXAxis = s, this.coll = i, k(this, "init", {
                    userOptions: e
                }), this.opposite = E(e.opposite, this.opposite), this.side = E(e.side, this.side, r ? this.opposite ? 0 : 2 : this.opposite ? 1 : 3), this.setOptions(e);
                let o = this.options, n = o.labels;
                this.type ?? (this.type = o.type || "linear"), this.uniqueNames ?? (this.uniqueNames = o.uniqueNames ?? !0), k(this, "afterSetType"), this.userOptions = e, this.minPixelPadding = 0, this.reversed = E(o.reversed, this.reversed), this.visible = o.visible, this.zoomEnabled = o.zoomEnabled, this.hasNames = "category" === this.type || !0 === o.categories, this.categories = T(o.categories) && o.categories || (this.hasNames ? [] : void 0), this.names || (this.names = [], this.names.keys = {}), this.plotLinesAndBandsGroups = {}, this.positiveValuesOnly = !!this.logarithmic, this.isLinked = y(o.linkedTo), this.ticks = {}, this.labelEdge = [], this.minorTicks = {}, this.plotLinesAndBands = [], this.alternateBands = {}, this.len ?? (this.len = 0), this.minRange = this.userMinRange = o.minRange || o.maxZoom, this.range = o.range, this.offset = o.offset || 0, this.max = void 0, this.min = void 0;
                let a = E(o.crosshair, B(t.options.tooltip.crosshairs)[s ? 0 : 1]);
                this.crosshair = !0 === a ? {} : a, -1 === t.axes.indexOf(this) && (s ? t.axes.splice(t.xAxis.length, 0, this) : t.axes.push(this), w(this, t[this.coll])), t.orderItems(this.coll), this.series = this.series || [], t.inverted && !this.isZAxis && s && !y(this.reversed) && (this.reversed = !0), this.labelRotation = A(n.rotation) ? n.rotation : void 0, p(this, o), k(this, "afterInit");
            }
            setOptions(t) {
                let e = this.horiz ? {
                    labels: {
                        autoRotation: [
                            -45
                        ],
                        padding: 4
                    },
                    margin: 15
                } : {
                    labels: {
                        padding: 1
                    },
                    title: {
                        rotation: 90 * this.side
                    }
                };
                this.options = L(e, c[this.coll], t), k(this, "afterSetOptions", {
                    userOptions: t
                });
            }
            defaultLabelFormatter() {
                let t = this.axis, { numberFormatter: e } = this.chart, i = A(this.value) ? this.value : NaN, s = t.chart.time, r = t.categories, o = this.dateTimeLabelFormat, n = c.lang, a = n.numericSymbols, h = n.numericSymbolMagnitude || 1e3, l = t.logarithmic ? Math.abs(i) : t.tickInterval, d = a && a.length, p, u;
                if (r) u = `${this.value}`;
                else if (o) u = s.dateFormat(o, i);
                else if (d && a && l >= 1e3) for(; d-- && void 0 === u;)l >= (p = Math.pow(h, d + 1)) && 10 * i % p == 0 && null !== a[d] && 0 !== i && (u = e(i / p, -1) + a[d]);
                return void 0 === u && (u = Math.abs(i) >= 1e4 ? e(i, -1) : e(i, -1, void 0, "")), u;
            }
            getSeriesExtremes() {
                let t;
                let e = this;
                k(this, "getSeriesExtremes", null, function() {
                    e.hasVisibleSeries = !1, e.dataMin = e.dataMax = e.threshold = void 0, e.softThreshold = !e.isXAxis, e.series.forEach((i)=>{
                        if (i.reserveSpace()) {
                            let s = i.options, r, o = s.threshold, n, a;
                            if (e.hasVisibleSeries = !0, e.positiveValuesOnly && 0 >= (o || 0) && (o = void 0), e.isXAxis) (r = i.xData) && r.length && (r = e.logarithmic ? r.filter((t)=>t > 0) : r, n = (t = i.getXExtremes(r)).min, a = t.max, A(n) || n instanceof Date || (r = r.filter(A), n = (t = i.getXExtremes(r)).min, a = t.max), r.length && (e.dataMin = Math.min(E(e.dataMin, n), n), e.dataMax = Math.max(E(e.dataMax, a), a)));
                            else {
                                let t = i.applyExtremes();
                                A(t.dataMin) && (n = t.dataMin, e.dataMin = Math.min(E(e.dataMin, n), n)), A(t.dataMax) && (a = t.dataMax, e.dataMax = Math.max(E(e.dataMax, a), a)), y(o) && (e.threshold = o), (!s.softThreshold || e.positiveValuesOnly) && (e.softThreshold = !1);
                            }
                        }
                    });
                }), k(this, "afterGetSeriesExtremes");
            }
            translate(t, e, i, s, r, o) {
                let n = this.linkedParent || this, a = s && n.old ? n.old.min : n.min;
                if (!A(a)) return NaN;
                let h = n.minPixelPadding, l = (n.isOrdinal || n.brokenAxis?.hasBreaks || n.logarithmic && r) && n.lin2val, d = 1, c = 0, p = s && n.old ? n.old.transA : n.transA, u = 0;
                return p || (p = n.transA), i && (d *= -1, c = n.len), n.reversed && (d *= -1, c -= d * (n.sector || n.len)), e ? (u = (t = t * d + c - h) / p + a, l && (u = n.lin2val(u))) : (l && (t = n.val2lin(t)), u = d * (t - a) * p + c + d * h + (A(o) ? p * o : 0), n.isRadial || (u = x(u))), u;
            }
            toPixels(t, e) {
                return this.translate(t, !1, !this.horiz, void 0, !0) + (e ? 0 : this.pos);
            }
            toValue(t, e) {
                return this.translate(t - (e ? 0 : this.pos), !0, !this.horiz, void 0, !0);
            }
            getPlotLinePath(t) {
                let e = this, i = e.chart, s = e.left, r = e.top, o = t.old, n = t.value, a = t.lineWidth, h = o && i.oldChartHeight || i.chartHeight, l = o && i.oldChartWidth || i.chartWidth, d = e.transB, c = t.translatedValue, p = t.force, u, g, f, x, y;
                function b(t, e, i) {
                    return "pass" !== p && (t < e || t > i) && (p ? t = m(t, e, i) : y = !0), t;
                }
                let v = {
                    value: n,
                    lineWidth: a,
                    old: o,
                    force: p,
                    acrossPanes: t.acrossPanes,
                    translatedValue: c
                };
                return k(this, "getPlotLinePath", v, function(t) {
                    u = f = (c = m(c = E(c, e.translate(n, void 0, void 0, o)), -1000000000, 1e9)) + d, g = x = h - c - d, A(c) ? e.horiz ? (g = r, x = h - e.bottom + (e.options.isInternal ? 0 : i.scrollablePixelsY || 0), u = f = b(u, s, s + e.width)) : (u = s, f = l - e.right + (i.scrollablePixelsX || 0), g = x = b(g, r, r + e.height)) : (y = !0, p = !1), t.path = y && !p ? void 0 : i.renderer.crispLine([
                        [
                            "M",
                            u,
                            g
                        ],
                        [
                            "L",
                            f,
                            x
                        ]
                    ], a || 1);
                }), v.path;
            }
            getLinearTickPositions(t, e, i) {
                let s, r, o;
                let n = x(Math.floor(e / t) * t), a = x(Math.ceil(i / t) * t), h = [];
                if (x(n + t) === n && (o = 20), this.single) return [
                    e
                ];
                for(s = n; s <= a && (h.push(s), (s = x(s + t, o)) !== r);)r = s;
                return h;
            }
            getMinorTickInterval() {
                let { minorTicks: t, minorTickInterval: e } = this.options;
                return !0 === t ? E(e, "auto") : !1 !== t ? e : void 0;
            }
            getMinorTickPositions() {
                let t = this.options, e = this.tickPositions, i = this.minorTickInterval, s = this.pointRangePadding || 0, r = (this.min || 0) - s, o = (this.max || 0) + s, n = o - r, a = [], h;
                if (n && n / i < this.len / 3) {
                    let s = this.logarithmic;
                    if (s) this.paddedTicks.forEach(function(t, e, r) {
                        e && a.push.apply(a, s.getLogTickPositions(i, r[e - 1], r[e], !0));
                    });
                    else if (this.dateTime && "auto" === this.getMinorTickInterval()) a = a.concat(this.getTimeTicks(this.dateTime.normalizeTimeTickInterval(i), r, o, t.startOfWeek));
                    else for(h = r + (e[0] - r) % i; h <= o && h !== a[0]; h += i)a.push(h);
                }
                return 0 !== a.length && this.trimTicks(a), a;
            }
            adjustForMinRange() {
                let t = this.options, e = this.logarithmic, { max: i, min: s, minRange: r } = this, o, n, a, h;
                this.isXAxis && void 0 === r && !e && (r = y(t.min) || y(t.max) || y(t.floor) || y(t.ceiling) ? null : Math.min(5 * (M(this.series.map((t)=>(t.xIncrement ? t.xData?.slice(0, 2) : t.xData) || [])) || 0), this.dataMax - this.dataMin)), A(i) && A(s) && A(r) && i - s < r && (n = this.dataMax - this.dataMin >= r, o = (r - i + s) / 2, a = [
                    s - o,
                    E(t.min, s - o)
                ], n && (a[2] = e ? e.log2lin(this.dataMin) : this.dataMin), h = [
                    (s = g(a)) + r,
                    E(t.max, s + r)
                ], n && (h[2] = e ? e.log2lin(this.dataMax) : this.dataMax), (i = f(h)) - s < r && (a[0] = i - r, a[1] = E(t.min, i - r), s = g(a))), this.minRange = r, this.min = s, this.max = i;
            }
            getClosest() {
                let t, e;
                if (this.categories) e = 1;
                else {
                    let i = [];
                    this.series.forEach(function(t) {
                        let s = t.closestPointRange;
                        t.xData?.length === 1 ? i.push(t.xData[0]) : !t.noSharedTooltip && y(s) && t.reserveSpace() && (e = y(e) ? Math.min(e, s) : s);
                    }), i.length && (i.sort((t, e)=>t - e), t = M([
                        i
                    ]));
                }
                return t && e ? Math.min(t, e) : t || e;
            }
            nameToX(t) {
                let e = T(this.options.categories), i = e ? this.categories : this.names, s = t.options.x, r;
                return t.series.requireSorting = !1, y(s) || (s = this.uniqueNames && i ? e ? i.indexOf(t.name) : E(i.keys[t.name], -1) : t.series.autoIncrement()), -1 === s ? !e && i && (r = i.length) : r = s, void 0 !== r ? (this.names[r] = t.name, this.names.keys[t.name] = r) : t.x && (r = t.x), r;
            }
            updateNames() {
                let t = this, e = this.names;
                e.length > 0 && (Object.keys(e.keys).forEach(function(t) {
                    delete e.keys[t];
                }), e.length = 0, this.minRange = this.userMinRange, (this.series || []).forEach((e)=>{
                    e.xIncrement = null, (!e.points || e.isDirtyData) && (t.max = Math.max(t.max, e.xData.length - 1), e.processData(), e.generatePoints()), e.data.forEach(function(i, s) {
                        let r;
                        i?.options && void 0 !== i.name && void 0 !== (r = t.nameToX(i)) && r !== i.x && (i.x = r, e.xData[s] = r);
                    });
                }));
            }
            setAxisTranslation() {
                let t = this, e = t.max - t.min, i = t.linkedParent, s = !!t.categories, r = t.isXAxis, o = t.axisPointRange || 0, n, a = 0, h = 0, l, d = t.transA;
                (r || s || o) && (n = t.getClosest(), i ? (a = i.minPointOffset, h = i.pointRangePadding) : t.series.forEach(function(e) {
                    let i = s ? 1 : r ? E(e.options.pointRange, n, 0) : t.axisPointRange || 0, l = e.options.pointPlacement;
                    if (o = Math.max(o, i), !t.single || s) {
                        let t = e.is("xrange") ? !r : r;
                        a = Math.max(a, t && P(l) ? 0 : i / 2), h = Math.max(h, t && "on" === l ? 0 : i);
                    }
                }), l = t.ordinal && t.ordinal.slope && n ? t.ordinal.slope / n : 1, t.minPointOffset = a *= l, t.pointRangePadding = h *= l, t.pointRange = Math.min(o, t.single && s ? 1 : e), r && n && (t.closestPointRange = n)), t.translationSlope = t.transA = d = t.staticScale || t.len / (e + h || 1), t.transB = t.horiz ? t.left : t.bottom, t.minPixelPadding = d * a, k(this, "afterSetAxisTranslation");
            }
            minFromRange() {
                let { max: t, min: e } = this;
                return A(t) && A(e) && t - e || void 0;
            }
            setTickInterval(t) {
                let { categories: e, chart: i, dataMax: s, dataMin: r, dateTime: o, isXAxis: n, logarithmic: a, options: h, softThreshold: l } = this, d = A(this.threshold) ? this.threshold : void 0, c = this.minRange || 0, { ceiling: p, floor: u, linkedTo: g, softMax: f, softMin: m } = h, b = A(g) && i[this.coll]?.[g], v = h.tickPixelInterval, C = h.maxPadding, M = h.minPadding, w = 0, T, P = A(h.tickInterval) && h.tickInterval >= 0 ? h.tickInterval : void 0, L, O, D, I;
                if (o || e || b || this.getTickAmount(), D = E(this.userMin, h.min), I = E(this.userMax, h.max), b ? (this.linkedParent = b, T = b.getExtremes(), this.min = E(T.min, T.dataMin), this.max = E(T.max, T.dataMax), this.type !== b.type && S(11, !0, i)) : (l && y(d) && A(s) && A(r) && (r >= d ? (L = d, M = 0) : s <= d && (O = d, C = 0)), this.min = E(D, L, r), this.max = E(I, O, s)), A(this.max) && A(this.min) && (a && (this.positiveValuesOnly && !t && 0 >= Math.min(this.min, E(r, this.min)) && S(10, !0, i), this.min = x(a.log2lin(this.min), 16), this.max = x(a.log2lin(this.max), 16)), this.range && A(r) && (this.userMin = this.min = D = Math.max(r, this.minFromRange() || 0), this.userMax = I = this.max, this.range = void 0)), k(this, "foundExtremes"), this.adjustForMinRange(), A(this.min) && A(this.max)) {
                    if (!A(this.userMin) && A(m) && m < this.min && (this.min = D = m), !A(this.userMax) && A(f) && f > this.max && (this.max = I = f), e || this.axisPointRange || this.stacking?.usePercentage || b || !(w = this.max - this.min) || (!y(D) && M && (this.min -= w * M), y(I) || !C || (this.max += w * C)), !A(this.userMin) && A(u) && (this.min = Math.max(this.min, u)), !A(this.userMax) && A(p) && (this.max = Math.min(this.max, p)), l && A(r) && A(s)) {
                        let t = d || 0;
                        !y(D) && this.min < t && r >= t ? this.min = h.minRange ? Math.min(t, this.max - c) : t : !y(I) && this.max > t && s <= t && (this.max = h.minRange ? Math.max(t, this.min + c) : t);
                    }
                    !i.polar && this.min > this.max && (y(h.min) ? this.max = this.min : y(h.max) && (this.min = this.max)), w = this.max - this.min;
                }
                if (this.min !== this.max && A(this.min) && A(this.max) ? b && !P && v === b.options.tickPixelInterval ? this.tickInterval = P = b.tickInterval : this.tickInterval = E(P, this.tickAmount ? w / Math.max(this.tickAmount - 1, 1) : void 0, e ? 1 : w * v / Math.max(this.len, v)) : this.tickInterval = 1, n && !t) {
                    let t = this.min !== this.old?.min || this.max !== this.old?.max;
                    this.series.forEach(function(e) {
                        e.forceCrop = e.forceCropping?.(), e.processData(t);
                    }), k(this, "postProcessData", {
                        hasExtremesChanged: t
                    });
                }
                this.setAxisTranslation(), k(this, "initialAxisTranslation"), this.pointRange && !P && (this.tickInterval = Math.max(this.pointRange, this.tickInterval));
                let j = E(h.minTickInterval, o && !this.series.some((t)=>t.noSharedTooltip) ? this.closestPointRange : 0);
                !P && this.tickInterval < j && (this.tickInterval = j), o || a || P || (this.tickInterval = z(this, this.tickInterval)), this.tickAmount || (this.tickInterval = this.unsquish()), this.setTickPositions();
            }
            setTickPositions() {
                let t = this.options, e = t.tickPositions, i = t.tickPositioner, s = this.getMinorTickInterval(), r = !this.isPanning, o = r && t.startOnTick, n = r && t.endOnTick, a = [], h;
                if (this.tickmarkOffset = this.categories && "between" === t.tickmarkPlacement && 1 === this.tickInterval ? .5 : 0, this.single = this.min === this.max && y(this.min) && !this.tickAmount && (this.min % 1 == 0 || !1 !== t.allowDecimals), e) a = e.slice();
                else if (A(this.min) && A(this.max)) {
                    if (!this.ordinal?.positions && (this.max - this.min) / this.tickInterval > Math.max(2 * this.len, 200)) a = [
                        this.min,
                        this.max
                    ], S(19, !1, this.chart);
                    else if (this.dateTime) a = this.getTimeTicks(this.dateTime.normalizeTimeTickInterval(this.tickInterval, t.units), this.min, this.max, t.startOfWeek, this.ordinal?.positions, this.closestPointRange, !0);
                    else if (this.logarithmic) a = this.logarithmic.getLogTickPositions(this.tickInterval, this.min, this.max);
                    else {
                        let t = this.tickInterval, e = t;
                        for(; e <= 2 * t;)if (a = this.getLinearTickPositions(this.tickInterval, this.min, this.max), this.tickAmount && a.length > this.tickAmount) this.tickInterval = z(this, e *= 1.1);
                        else break;
                    }
                    a.length > this.len && (a = [
                        a[0],
                        a[a.length - 1]
                    ])[0] === a[1] && (a.length = 1), i && (this.tickPositions = a, (h = i.apply(this, [
                        this.min,
                        this.max
                    ])) && (a = h));
                }
                this.tickPositions = a, this.minorTickInterval = "auto" === s && this.tickInterval ? this.tickInterval / t.minorTicksPerMajor : s, this.paddedTicks = a.slice(0), this.trimTicks(a, o, n), !this.isLinked && A(this.min) && A(this.max) && (this.single && a.length < 2 && !this.categories && !this.series.some((t)=>t.is("heatmap") && "between" === t.options.pointPlacement) && (this.min -= .5, this.max += .5), e || h || this.adjustTickAmount()), k(this, "afterSetTickPositions");
            }
            trimTicks(t, e, i) {
                let s = t[0], r = t[t.length - 1], o = !this.isOrdinal && this.minPointOffset || 0;
                if (k(this, "trimTicks"), !this.isLinked) {
                    if (e && s !== -1 / 0) this.min = s;
                    else for(; this.min - o > t[0];)t.shift();
                    if (i) this.max = r;
                    else for(; this.max + o < t[t.length - 1];)t.pop();
                    0 === t.length && y(s) && !this.options.tickPositions && t.push((r + s) / 2);
                }
            }
            alignToOthers() {
                let t;
                let e = this, i = e.chart, s = [
                    this
                ], r = e.options, o = i.options.chart, n = "yAxis" === this.coll && o.alignThresholds, a = [];
                if (e.thresholdAlignment = void 0, (!1 !== o.alignTicks && r.alignTicks || n) && !1 !== r.startOnTick && !1 !== r.endOnTick && !e.logarithmic) {
                    let r = (t)=>{
                        let { horiz: e, options: i } = t;
                        return [
                            e ? i.left : i.top,
                            i.width,
                            i.height,
                            i.pane
                        ].join(",");
                    }, o = r(this);
                    i[this.coll].forEach(function(i) {
                        let { series: n } = i;
                        n.length && n.some((t)=>t.visible) && i !== e && r(i) === o && (t = !0, s.push(i));
                    });
                }
                if (t && n) {
                    s.forEach((t)=>{
                        let i = t.getThresholdAlignment(e);
                        A(i) && a.push(i);
                    });
                    let t = a.length > 1 ? a.reduce((t, e)=>t += e, 0) / a.length : void 0;
                    s.forEach((e)=>{
                        e.thresholdAlignment = t;
                    });
                }
                return t;
            }
            getThresholdAlignment(t) {
                if ((!A(this.dataMin) || this !== t && this.series.some((t)=>t.isDirty || t.isDirtyData)) && this.getSeriesExtremes(), A(this.threshold)) {
                    let t = m((this.threshold - (this.dataMin || 0)) / ((this.dataMax || 0) - (this.dataMin || 0)), 0, 1);
                    return this.options.reversed && (t = 1 - t), t;
                }
            }
            getTickAmount() {
                let t = this.options, e = t.tickPixelInterval, i = t.tickAmount;
                y(t.tickInterval) || i || !(this.len < e) || this.isRadial || this.logarithmic || !t.startOnTick || !t.endOnTick || (i = 2), !i && this.alignToOthers() && (i = Math.ceil(this.len / e) + 1), i < 4 && (this.finalTickAmt = i, i = 5), this.tickAmount = i;
            }
            adjustTickAmount() {
                let t = this, { finalTickAmt: e, max: i, min: s, options: r, tickPositions: o, tickAmount: n, thresholdAlignment: a } = t, h = o?.length, l = E(t.threshold, t.softThreshold ? 0 : null), d, c, p = t.tickInterval, u, g = ()=>o.push(x(o[o.length - 1] + p)), f = ()=>o.unshift(x(o[0] - p));
                if (A(a) && (u = a < .5 ? Math.ceil(a * (n - 1)) : Math.floor(a * (n - 1)), r.reversed && (u = n - 1 - u)), t.hasData() && A(s) && A(i)) {
                    let a = ()=>{
                        t.transA *= (h - 1) / (n - 1), t.min = r.startOnTick ? o[0] : Math.min(s, o[0]), t.max = r.endOnTick ? o[o.length - 1] : Math.max(i, o[o.length - 1]);
                    };
                    if (A(u) && A(t.threshold)) {
                        for(; o[u] !== l || o.length !== n || o[0] > s || o[o.length - 1] < i;){
                            for(o.length = 0, o.push(t.threshold); o.length < n;)void 0 === o[u] || o[u] > t.threshold ? f() : g();
                            if (p > 8 * t.tickInterval) break;
                            p *= 2;
                        }
                        a();
                    } else if (h < n) {
                        for(; o.length < n;)o.length % 2 || s === l ? g() : f();
                        a();
                    }
                    if (y(e)) {
                        for(c = d = o.length; c--;)(3 === e && c % 2 == 1 || e <= 2 && c > 0 && c < d - 1) && o.splice(c, 1);
                        t.finalTickAmt = void 0;
                    }
                }
            }
            setScale() {
                let { coll: t, stacking: e } = this, i = !1, s = !1;
                this.series.forEach((t)=>{
                    i = i || t.isDirtyData || t.isDirty, s = s || t.xAxis && t.xAxis.isDirty || !1;
                }), this.setAxisSize();
                let r = this.len !== (this.old && this.old.len);
                r || i || s || this.isLinked || this.forceRedraw || this.userMin !== (this.old && this.old.userMin) || this.userMax !== (this.old && this.old.userMax) || this.alignToOthers() ? (e && "yAxis" === t && e.buildStacks(), this.forceRedraw = !1, this.userMinRange || (this.minRange = void 0), this.getSeriesExtremes(), this.setTickInterval(), e && "xAxis" === t && e.buildStacks(), this.isDirty || (this.isDirty = r || this.min !== this.old?.min || this.max !== this.old?.max)) : e && e.cleanStacks(), i && delete this.allExtremes, k(this, "afterSetScale");
            }
            setExtremes(t, e, i = !0, s, r) {
                this.series.forEach((t)=>{
                    delete t.kdTree;
                }), k(this, "setExtremes", r = C(r, {
                    min: t,
                    max: e
                }), (t)=>{
                    this.userMin = t.min, this.userMax = t.max, this.eventArgs = t, i && this.chart.redraw(s);
                });
            }
            setAxisSize() {
                let t = this.chart, e = this.options, i = e.offsets || [
                    0,
                    0,
                    0,
                    0
                ], s = this.horiz, r = this.width = Math.round(I(E(e.width, t.plotWidth - i[3] + i[1]), t.plotWidth)), o = this.height = Math.round(I(E(e.height, t.plotHeight - i[0] + i[2]), t.plotHeight)), n = this.top = Math.round(I(E(e.top, t.plotTop + i[0]), t.plotHeight, t.plotTop)), a = this.left = Math.round(I(E(e.left, t.plotLeft + i[3]), t.plotWidth, t.plotLeft));
                this.bottom = t.chartHeight - o - n, this.right = t.chartWidth - r - a, this.len = Math.max(s ? r : o, 0), this.pos = s ? a : n;
            }
            getExtremes() {
                let t = this.logarithmic;
                return {
                    min: t ? x(t.lin2log(this.min)) : this.min,
                    max: t ? x(t.lin2log(this.max)) : this.max,
                    dataMin: this.dataMin,
                    dataMax: this.dataMax,
                    userMin: this.userMin,
                    userMax: this.userMax
                };
            }
            getThreshold(t) {
                let e = this.logarithmic, i = e ? e.lin2log(this.min) : this.min, s = e ? e.lin2log(this.max) : this.max;
                return null === t || t === -1 / 0 ? t = i : t === 1 / 0 ? t = s : i > t ? t = i : s < t && (t = s), this.translate(t, 0, 1, 0, 1);
            }
            autoLabelAlign(t) {
                let e = (E(t, 0) - 90 * this.side + 720) % 360, i = {
                    align: "center"
                };
                return k(this, "autoLabelAlign", i, function(t) {
                    e > 15 && e < 165 ? t.align = "right" : e > 195 && e < 345 && (t.align = "left");
                }), i.align;
            }
            tickSize(t) {
                let e = this.options, i = E(e["tick" === t ? "tickWidth" : "minorTickWidth"], "tick" === t && this.isXAxis && !this.categories ? 1 : 0), s = e["tick" === t ? "tickLength" : "minorTickLength"], r;
                i && s && ("inside" === e[t + "Position"] && (s = -s), r = [
                    s,
                    i
                ]);
                let o = {
                    tickSize: r
                };
                return k(this, "afterTickSize", o), o.tickSize;
            }
            labelMetrics() {
                let t = this.chart.renderer, e = this.ticks, i = e[Object.keys(e)[0]] || {};
                return this.chart.renderer.fontMetrics(i.label || i.movedLabel || t.box);
            }
            unsquish() {
                let t = this.options.labels, e = t.padding || 0, i = this.horiz, s = this.tickInterval, r = this.len / (((this.categories ? 1 : 0) + this.max - this.min) / s), o = t.rotation, n = x(.8 * this.labelMetrics().h), a = Math.max(this.max - this.min, 0), h = function(t) {
                    let i = (t + 2 * e) / (r || 1);
                    return (i = i > 1 ? Math.ceil(i) : 1) * s > a && t !== 1 / 0 && r !== 1 / 0 && a && (i = Math.ceil(a / s)), x(i * s);
                }, l = s, d, c = Number.MAX_VALUE, p;
                if (i) {
                    if (!t.staggerLines && (A(o) ? p = [
                        o
                    ] : r < t.autoRotationLimit && (p = t.autoRotation)), p) {
                        let t, e;
                        for (let i of p)(i === o || i && i >= -90 && i <= 90) && (e = (t = h(Math.abs(n / Math.sin(u * i)))) + Math.abs(i / 360)) < c && (c = e, d = i, l = t);
                    }
                } else l = h(.75 * n);
                return this.autoRotation = p, this.labelRotation = E(d, A(o) ? o : 0), t.step ? s : l;
            }
            getSlotWidth(t) {
                let e = this.chart, i = this.horiz, s = this.options.labels, r = Math.max(this.tickPositions.length - (this.categories ? 0 : 1), 1), o = e.margin[3];
                if (t && A(t.slotWidth)) return t.slotWidth;
                if (i && s.step < 2) return s.rotation ? 0 : (this.staggerLines || 1) * this.len / r;
                if (!i) {
                    let t = s.style.width;
                    if (void 0 !== t) return parseInt(String(t), 10);
                    if (o) return o - e.spacing[3];
                }
                return .33 * e.chartWidth;
            }
            renderUnsquish() {
                let t = this.chart, e = t.renderer, i = this.tickPositions, s = this.ticks, r = this.options.labels, o = r.style, n = this.horiz, a = this.getSlotWidth(), h = Math.max(1, Math.round(a - (n ? 2 * (r.padding || 0) : r.distance || 0))), l = {}, d = this.labelMetrics(), c = o.textOverflow, p, u, g = 0, f, m;
                if (P(r.rotation) || (l.rotation = r.rotation || 0), i.forEach(function(t) {
                    let e = s[t];
                    e.movedLabel && e.replaceMovedLabel(), e && e.label && e.label.textPxLength > g && (g = e.label.textPxLength);
                }), this.maxLabelLength = g, this.autoRotation) g > h && g > d.h ? l.rotation = this.labelRotation : this.labelRotation = 0;
                else if (a && (p = h, !c)) for(u = "clip", m = i.length; !n && m--;)(f = s[i[m]].label) && ("ellipsis" === f.styles.textOverflow ? f.css({
                    textOverflow: "clip"
                }) : f.textPxLength > a && f.css({
                    width: a + "px"
                }), f.getBBox().height > this.len / i.length - (d.h - d.f) && (f.specificTextOverflow = "ellipsis"));
                l.rotation && (p = g > .5 * t.chartHeight ? .33 * t.chartHeight : g, c || (u = "ellipsis")), this.labelAlign = r.align || this.autoLabelAlign(this.labelRotation), this.labelAlign && (l.align = this.labelAlign), i.forEach(function(t) {
                    let e = s[t], i = e && e.label, r = o.width, n = {};
                    i && (i.attr(l), e.shortenLabel ? e.shortenLabel() : p && !r && "nowrap" !== o.whiteSpace && (p < i.textPxLength || "SPAN" === i.element.tagName) ? (n.width = p + "px", c || (n.textOverflow = i.specificTextOverflow || u), i.css(n)) : !i.styles.width || n.width || r || i.css({
                        width: null
                    }), delete i.specificTextOverflow, e.rotation = l.rotation);
                }, this), this.tickRotCorr = e.rotCorr(d.b, this.labelRotation || 0, 0 !== this.side);
            }
            hasData() {
                return this.series.some(function(t) {
                    return t.hasData();
                }) || this.options.showEmpty && y(this.min) && y(this.max);
            }
            addTitle(t) {
                let e;
                let i = this.chart.renderer, s = this.horiz, r = this.opposite, o = this.options.title, n = this.chart.styledMode;
                this.axisTitle || ((e = o.textAlign) || (e = (s ? {
                    low: "left",
                    middle: "center",
                    high: "right"
                } : {
                    low: r ? "right" : "left",
                    middle: "center",
                    high: r ? "left" : "right"
                })[o.align]), this.axisTitle = i.text(o.text || "", 0, 0, o.useHTML).attr({
                    zIndex: 7,
                    rotation: o.rotation || 0,
                    align: e
                }).addClass("highcharts-axis-title"), n || this.axisTitle.css(L(o.style)), this.axisTitle.add(this.axisGroup), this.axisTitle.isNew = !0), n || o.style.width || this.isRadial || this.axisTitle.css({
                    width: this.len + "px"
                }), this.axisTitle[t ? "show" : "hide"](t);
            }
            generateTick(t) {
                let e = this.ticks;
                e[t] ? e[t].addLabel() : e[t] = new n(this, t);
            }
            createGroups() {
                let { axisParent: t, chart: e, coll: i, options: s } = this, r = e.renderer, o = (e, o, n)=>r.g(e).attr({
                        zIndex: n
                    }).addClass(`highcharts-${i.toLowerCase()}${o} ` + (this.isRadial ? `highcharts-radial-axis${o} ` : "") + (s.className || "")).add(t);
                this.axisGroup || (this.gridGroup = o("grid", "-grid", s.gridZIndex), this.axisGroup = o("axis", "", s.zIndex), this.labelGroup = o("axis-labels", "-labels", s.labels.zIndex));
            }
            getOffset() {
                let t = this, { chart: e, horiz: i, options: s, side: r, ticks: o, tickPositions: n, coll: a } = t, h = e.inverted && !t.isZAxis ? [
                    1,
                    0,
                    3,
                    2
                ][r] : r, l = t.hasData(), d = s.title, c = s.labels, p = A(s.crossing), u = e.axisOffset, g = e.clipOffset, f = [
                    -1,
                    1,
                    1,
                    -1
                ][r], m, x = 0, b, v = 0, S = 0, C, M;
                if (t.showAxis = m = l || s.showEmpty, t.staggerLines = t.horiz && c.staggerLines || void 0, t.createGroups(), l || t.isLinked ? (n.forEach(function(e) {
                    t.generateTick(e);
                }), t.renderUnsquish(), t.reserveSpaceDefault = 0 === r || 2 === r || ({
                    1: "left",
                    3: "right"
                })[r] === t.labelAlign, E(c.reserveSpace, !p && null, "center" === t.labelAlign || null, t.reserveSpaceDefault) && n.forEach(function(t) {
                    S = Math.max(o[t].getLabelSize(), S);
                }), t.staggerLines && (S *= t.staggerLines), t.labelOffset = S * (t.opposite ? -1 : 1)) : D(o, function(t, e) {
                    t.destroy(), delete o[e];
                }), d?.text && !1 !== d.enabled && (t.addTitle(m), m && !p && !1 !== d.reserveSpace && (t.titleOffset = x = t.axisTitle.getBBox()[i ? "height" : "width"], v = y(b = d.offset) ? 0 : E(d.margin, i ? 5 : 10))), t.renderLine(), t.offset = f * E(s.offset, u[r] ? u[r] + (s.margin || 0) : 0), t.tickRotCorr = t.tickRotCorr || {
                    x: 0,
                    y: 0
                }, M = 0 === r ? -t.labelMetrics().h : 2 === r ? t.tickRotCorr.y : 0, C = Math.abs(S) + v, S && (C -= M, C += f * (i ? E(c.y, t.tickRotCorr.y + f * c.distance) : E(c.x, f * c.distance))), t.axisTitleMargin = E(b, C), t.getMaxLabelDimensions && (t.maxLabelDimensions = t.getMaxLabelDimensions(o, n)), "colorAxis" !== a && g) {
                    let e = this.tickSize("tick");
                    u[r] = Math.max(u[r], (t.axisTitleMargin || 0) + x + f * t.offset, C, n && n.length && e ? e[0] + f * t.offset : 0);
                    let i = !t.axisLine || s.offset ? 0 : t.axisLine.strokeWidth() / 2;
                    g[h] = Math.max(g[h], i);
                }
                k(this, "afterGetOffset");
            }
            getLinePath(t) {
                let e = this.chart, i = this.opposite, s = this.offset, r = this.horiz, o = this.left + (i ? this.width : 0) + s, n = e.chartHeight - this.bottom - (i ? this.height : 0) + s;
                return i && (t *= -1), e.renderer.crispLine([
                    [
                        "M",
                        r ? this.left : o,
                        r ? n : this.top
                    ],
                    [
                        "L",
                        r ? e.chartWidth - this.right : o,
                        r ? n : e.chartHeight - this.bottom
                    ]
                ], t);
            }
            renderLine() {
                this.axisLine || (this.axisLine = this.chart.renderer.path().addClass("highcharts-axis-line").add(this.axisGroup), this.chart.styledMode || this.axisLine.attr({
                    stroke: this.options.lineColor,
                    "stroke-width": this.options.lineWidth,
                    zIndex: 7
                }));
            }
            getTitlePosition(t) {
                let e = this.horiz, i = this.left, s = this.top, r = this.len, o = this.options.title, n = e ? i : s, a = this.opposite, h = this.offset, l = o.x, d = o.y, c = this.chart.renderer.fontMetrics(t), p = t ? Math.max(t.getBBox(!1, 0).height - c.h - 1, 0) : 0, u = {
                    low: n + (e ? 0 : r),
                    middle: n + r / 2,
                    high: n + (e ? r : 0)
                }[o.align], g = (e ? s + this.height : i) + (e ? 1 : -1) * (a ? -1 : 1) * (this.axisTitleMargin || 0) + [
                    -p,
                    p,
                    c.f,
                    -p
                ][this.side], f = {
                    x: e ? u + l : g + (a ? this.width : 0) + h + l,
                    y: e ? g + d - (a ? this.height : 0) + h : u + d
                };
                return k(this, "afterGetTitlePosition", {
                    titlePosition: f
                }), f;
            }
            renderMinorTick(t, e) {
                let i = this.minorTicks;
                i[t] || (i[t] = new n(this, t, "minor")), e && i[t].isNew && i[t].render(null, !0), i[t].render(null, !1, 1);
            }
            renderTick(t, e, i) {
                let s = this.isLinked, r = this.ticks;
                (!s || t >= this.min && t <= this.max || this.grid && this.grid.isColumn) && (r[t] || (r[t] = new n(this, t)), i && r[t].isNew && r[t].render(e, !0, -1), r[t].render(e));
            }
            render() {
                let t, e;
                let i = this, s = i.chart, r = i.logarithmic, a = s.renderer, l = i.options, d = i.isLinked, c = i.tickPositions, p = i.axisTitle, u = i.ticks, g = i.minorTicks, f = i.alternateBands, m = l.stackLabels, x = l.alternateGridColor, y = l.crossing, b = i.tickmarkOffset, v = i.axisLine, S = i.showAxis, C = h(a.globalAnimation);
                if (i.labelEdge.length = 0, i.overlap = !1, [
                    u,
                    g,
                    f
                ].forEach(function(t) {
                    D(t, function(t) {
                        t.isActive = !1;
                    });
                }), A(y)) {
                    let t = this.isXAxis ? s.yAxis[0] : s.xAxis[0], e = [
                        1,
                        -1,
                        -1,
                        1
                    ][this.side];
                    if (t) {
                        let s = t.toPixels(y, !0);
                        i.horiz && (s = t.len - s), i.offset = e * s;
                    }
                }
                if (i.hasData() || d) {
                    let a = i.chart.hasRendered && i.old && A(i.old.min);
                    i.minorTickInterval && !i.categories && i.getMinorTickPositions().forEach(function(t) {
                        i.renderMinorTick(t, a);
                    }), c.length && (c.forEach(function(t, e) {
                        i.renderTick(t, e, a);
                    }), b && (0 === i.min || i.single) && (u[-1] || (u[-1] = new n(i, -1, null, !0)), u[-1].render(-1))), x && c.forEach(function(n, a) {
                        e = void 0 !== c[a + 1] ? c[a + 1] + b : i.max - b, a % 2 == 0 && n < i.max && e <= i.max + (s.polar ? -b : b) && (f[n] || (f[n] = new o.PlotLineOrBand(i, {})), t = n + b, f[n].options = {
                            from: r ? r.lin2log(t) : t,
                            to: r ? r.lin2log(e) : e,
                            color: x,
                            className: "highcharts-alternate-grid"
                        }, f[n].render(), f[n].isActive = !0);
                    }), i._addedPlotLB || (i._addedPlotLB = !0, (l.plotLines || []).concat(l.plotBands || []).forEach(function(t) {
                        i.addPlotBandOrLine(t);
                    }));
                }
                [
                    u,
                    g,
                    f
                ].forEach(function(t) {
                    let e = [], i = C.duration;
                    D(t, function(t, i) {
                        t.isActive || (t.render(i, !1, 0), t.isActive = !1, e.push(i));
                    }), R(function() {
                        let i = e.length;
                        for(; i--;)t[e[i]] && !t[e[i]].isActive && (t[e[i]].destroy(), delete t[e[i]]);
                    }, t !== f && s.hasRendered && i ? i : 0);
                }), v && (v[v.isPlaced ? "animate" : "attr"]({
                    d: this.getLinePath(v.strokeWidth())
                }), v.isPlaced = !0, v[S ? "show" : "hide"](S)), p && S && (p[p.isNew ? "attr" : "animate"](i.getTitlePosition(p)), p.isNew = !1), m && m.enabled && i.stacking && i.stacking.renderStackTotals(), i.old = {
                    len: i.len,
                    max: i.max,
                    min: i.min,
                    transA: i.transA,
                    userMax: i.userMax,
                    userMin: i.userMin
                }, i.isDirty = !1, k(this, "afterRender");
            }
            redraw() {
                this.visible && (this.render(), this.plotLinesAndBands.forEach(function(t) {
                    t.render();
                })), this.series.forEach(function(t) {
                    t.isDirty = !0;
                });
            }
            getKeepProps() {
                return this.keepProps || N.keepProps;
            }
            destroy(t) {
                let e = this, i = e.plotLinesAndBands, s = this.eventOptions;
                if (k(this, "destroy", {
                    keepEvents: t
                }), t || j(e), [
                    e.ticks,
                    e.minorTicks,
                    e.alternateBands
                ].forEach(function(t) {
                    b(t);
                }), i) {
                    let t = i.length;
                    for(; t--;)i[t].destroy();
                }
                for(let t in [
                    "axisLine",
                    "axisTitle",
                    "axisGroup",
                    "gridGroup",
                    "labelGroup",
                    "cross",
                    "scrollbar"
                ].forEach(function(t) {
                    e[t] && (e[t] = e[t].destroy());
                }), e.plotLinesAndBandsGroups)e.plotLinesAndBandsGroups[t] = e.plotLinesAndBandsGroups[t].destroy();
                D(e, function(t, i) {
                    -1 === e.getKeepProps().indexOf(i) && delete e[i];
                }), this.eventOptions = s;
            }
            drawCrosshair(t, e) {
                let s = this.crosshair, r = E(s && s.snap, !0), o = this.chart, n, a, h, l = this.cross, d;
                if (k(this, "drawCrosshair", {
                    e: t,
                    point: e
                }), t || (t = this.cross && this.cross.e), s && !1 !== (y(e) || !r)) {
                    if (r ? y(e) && (a = E("colorAxis" !== this.coll ? e.crosshairPos : null, this.isXAxis ? e.plotX : this.len - e.plotY)) : a = t && (this.horiz ? t.chartX - this.pos : this.len - t.chartY + this.pos), y(a) && (d = {
                        value: e && (this.isXAxis ? e.x : E(e.stackY, e.y)),
                        translatedValue: a
                    }, o.polar && C(d, {
                        isCrosshair: !0,
                        chartX: t && t.chartX,
                        chartY: t && t.chartY,
                        point: e
                    }), n = this.getPlotLinePath(d) || null), !y(n)) {
                        this.hideCrosshair();
                        return;
                    }
                    h = this.categories && !this.isRadial, l || (this.cross = l = o.renderer.path().addClass("highcharts-crosshair highcharts-crosshair-" + (h ? "category " : "thin ") + (s.className || "")).attr({
                        zIndex: E(s.zIndex, 2)
                    }).add(), !o.styledMode && (l.attr({
                        stroke: s.color || (h ? i.parse("#ccd3ff").setOpacity(.25).get() : "#cccccc"),
                        "stroke-width": E(s.width, 1)
                    }).css({
                        "pointer-events": "none"
                    }), s.dashStyle && l.attr({
                        dashstyle: s.dashStyle
                    }))), l.show().attr({
                        d: n
                    }), h && !s.width && l.attr({
                        "stroke-width": this.transA
                    }), this.cross.e = t;
                } else this.hideCrosshair();
                k(this, "afterDrawCrosshair", {
                    e: t,
                    point: e
                });
            }
            hideCrosshair() {
                this.cross && this.cross.hide(), k(this, "afterHideCrosshair");
            }
            update(t, e) {
                let i = this.chart;
                t = L(this.userOptions, t), this.destroy(!0), this.init(i, t), i.isDirtyBox = !0, E(e, !0) && i.redraw();
            }
            remove(t) {
                let e = this.chart, i = this.coll, s = this.series, r = s.length;
                for(; r--;)s[r] && s[r].remove(!1);
                v(e.axes, this), v(e[i] || [], this), e.orderItems(i), this.destroy(), e.isDirtyBox = !0, E(t, !0) && e.redraw();
            }
            setTitle(t, e) {
                this.update({
                    title: t
                }, e);
            }
            setCategories(t, e) {
                this.update({
                    categories: t
                }, e);
            }
        }
        return N.keepProps = [
            "coll",
            "extKey",
            "hcEvents",
            "len",
            "names",
            "series",
            "userMax",
            "userMin"
        ], N;
    }), i(e, "Core/Axis/DateTimeAxis.js", [
        e["Core/Utilities.js"]
    ], function(t) {
        var e;
        let { addEvent: i, getMagnitude: s, normalizeTickInterval: r, timeUnits: o } = t;
        return function(t) {
            function e() {
                return this.chart.time.getTimeTicks.apply(this.chart.time, arguments);
            }
            function n() {
                if ("datetime" !== this.type) {
                    this.dateTime = void 0;
                    return;
                }
                this.dateTime || (this.dateTime = new a(this));
            }
            t.compose = function(t) {
                return t.keepProps.includes("dateTime") || (t.keepProps.push("dateTime"), t.prototype.getTimeTicks = e, i(t, "afterSetType", n)), t;
            };
            class a {
                constructor(t){
                    this.axis = t;
                }
                normalizeTimeTickInterval(t, e) {
                    let i = e || [
                        [
                            "millisecond",
                            [
                                1,
                                2,
                                5,
                                10,
                                20,
                                25,
                                50,
                                100,
                                200,
                                500
                            ]
                        ],
                        [
                            "second",
                            [
                                1,
                                2,
                                5,
                                10,
                                15,
                                30
                            ]
                        ],
                        [
                            "minute",
                            [
                                1,
                                2,
                                5,
                                10,
                                15,
                                30
                            ]
                        ],
                        [
                            "hour",
                            [
                                1,
                                2,
                                3,
                                4,
                                6,
                                8,
                                12
                            ]
                        ],
                        [
                            "day",
                            [
                                1,
                                2
                            ]
                        ],
                        [
                            "week",
                            [
                                1,
                                2
                            ]
                        ],
                        [
                            "month",
                            [
                                1,
                                2,
                                3,
                                4,
                                6
                            ]
                        ],
                        [
                            "year",
                            null
                        ]
                    ], n = i[i.length - 1], a = o[n[0]], h = n[1], l;
                    for(l = 0; l < i.length && (a = o[(n = i[l])[0]], h = n[1], !i[l + 1] || !(t <= (a * h[h.length - 1] + o[i[l + 1][0]]) / 2)); l++);
                    a === o.year && t < 5 * a && (h = [
                        1,
                        2,
                        5
                    ]);
                    let d = r(t / a, h, "year" === n[0] ? Math.max(s(t / a), 1) : 1);
                    return {
                        unitRange: a,
                        count: d,
                        unitName: n[0]
                    };
                }
                getXDateFormat(t, e) {
                    let { axis: i } = this, s = i.chart.time;
                    return i.closestPointRange ? s.getDateFormat(i.closestPointRange, t, i.options.startOfWeek, e) || s.resolveDTLFormat(e.year).main : s.resolveDTLFormat(e.day).main;
                }
            }
            t.Additions = a;
        }(e || (e = {})), e;
    }), i(e, "Core/Axis/LogarithmicAxis.js", [
        e["Core/Utilities.js"]
    ], function(t) {
        var e;
        let { addEvent: i, normalizeTickInterval: s, pick: r } = t;
        return function(t) {
            function e() {
                "logarithmic" !== this.type ? this.logarithmic = void 0 : this.logarithmic ?? (this.logarithmic = new n(this));
            }
            function o() {
                let t = this.logarithmic;
                t && (this.lin2val = function(e) {
                    return t.lin2log(e);
                }, this.val2lin = function(e) {
                    return t.log2lin(e);
                });
            }
            t.compose = function(t) {
                return t.keepProps.includes("logarithmic") || (t.keepProps.push("logarithmic"), i(t, "afterSetType", e), i(t, "afterInit", o)), t;
            };
            class n {
                constructor(t){
                    this.axis = t;
                }
                getLogTickPositions(t, e, i, o) {
                    let n = this.axis, a = n.len, h = n.options, l = [];
                    if (o || (this.minorAutoInterval = void 0), t >= .5) t = Math.round(t), l = n.getLinearTickPositions(t, e, i);
                    else if (t >= .08) {
                        let s, r, n, a, h, d, c;
                        let p = Math.floor(e);
                        for(s = t > .3 ? [
                            1,
                            2,
                            4
                        ] : t > .15 ? [
                            1,
                            2,
                            4,
                            6,
                            8
                        ] : [
                            1,
                            2,
                            3,
                            4,
                            5,
                            6,
                            7,
                            8,
                            9
                        ], r = p; r < i + 1 && !c; r++)for(n = 0, a = s.length; n < a && !c; n++)(h = this.log2lin(this.lin2log(r) * s[n])) > e && (!o || d <= i) && void 0 !== d && l.push(d), d > i && (c = !0), d = h;
                    } else {
                        let d = this.lin2log(e), c = this.lin2log(i), p = o ? n.getMinorTickInterval() : h.tickInterval, u = h.tickPixelInterval / (o ? 5 : 1), g = o ? a / n.tickPositions.length : a;
                        t = s(t = r("auto" === p ? null : p, this.minorAutoInterval, (c - d) * u / (g || 1))), l = n.getLinearTickPositions(t, d, c).map(this.log2lin), o || (this.minorAutoInterval = t / 5);
                    }
                    return o || (n.tickInterval = t), l;
                }
                lin2log(t) {
                    return Math.pow(10, t);
                }
                log2lin(t) {
                    return Math.log(t) / Math.LN10;
                }
            }
            t.Additions = n;
        }(e || (e = {})), e;
    }), i(e, "Core/Axis/PlotLineOrBand/PlotLineOrBandAxis.js", [
        e["Core/Utilities.js"]
    ], function(t) {
        var e;
        let { erase: i, extend: s, isNumber: r } = t;
        return function(t) {
            let e;
            function o(t) {
                return this.addPlotBandOrLine(t, "plotBands");
            }
            function n(t, i) {
                let s = this.userOptions, r = new e(this, t);
                if (this.visible && (r = r.render()), r) {
                    if (this._addedPlotLB || (this._addedPlotLB = !0, (s.plotLines || []).concat(s.plotBands || []).forEach((t)=>{
                        this.addPlotBandOrLine(t);
                    })), i) {
                        let e = s[i] || [];
                        e.push(t), s[i] = e;
                    }
                    this.plotLinesAndBands.push(r);
                }
                return r;
            }
            function a(t) {
                return this.addPlotBandOrLine(t, "plotLines");
            }
            function h(t, e, i) {
                i = i || this.options;
                let s = this.getPlotLinePath({
                    value: e,
                    force: !0,
                    acrossPanes: i.acrossPanes
                }), o = [], n = this.horiz, a = !r(this.min) || !r(this.max) || t < this.min && e < this.min || t > this.max && e > this.max, h = this.getPlotLinePath({
                    value: t,
                    force: !0,
                    acrossPanes: i.acrossPanes
                }), l, d = 1, c;
                if (h && s) for(a && (c = h.toString() === s.toString(), d = 0), l = 0; l < h.length; l += 2){
                    let t = h[l], e = h[l + 1], i = s[l], r = s[l + 1];
                    ("M" === t[0] || "L" === t[0]) && ("M" === e[0] || "L" === e[0]) && ("M" === i[0] || "L" === i[0]) && ("M" === r[0] || "L" === r[0]) && (n && i[1] === t[1] ? (i[1] += d, r[1] += d) : n || i[2] !== t[2] || (i[2] += d, r[2] += d), o.push([
                        "M",
                        t[1],
                        t[2]
                    ], [
                        "L",
                        e[1],
                        e[2]
                    ], [
                        "L",
                        r[1],
                        r[2]
                    ], [
                        "L",
                        i[1],
                        i[2]
                    ], [
                        "Z"
                    ])), o.isFlat = c;
                }
                return o;
            }
            function l(t) {
                this.removePlotBandOrLine(t);
            }
            function d(t) {
                let e = this.plotLinesAndBands, s = this.options, r = this.userOptions;
                if (e) {
                    let o = e.length;
                    for(; o--;)e[o].id === t && e[o].destroy();
                    [
                        s.plotLines || [],
                        r.plotLines || [],
                        s.plotBands || [],
                        r.plotBands || []
                    ].forEach(function(e) {
                        for(o = e.length; o--;)(e[o] || {}).id === t && i(e, e[o]);
                    });
                }
            }
            function c(t) {
                this.removePlotBandOrLine(t);
            }
            t.compose = function(t, i) {
                let r = i.prototype;
                return r.addPlotBand || (e = t, s(r, {
                    addPlotBand: o,
                    addPlotLine: a,
                    addPlotBandOrLine: n,
                    getPlotBandPath: h,
                    removePlotBand: l,
                    removePlotLine: c,
                    removePlotBandOrLine: d
                })), i;
            };
        }(e || (e = {})), e;
    }), i(e, "Core/Axis/PlotLineOrBand/PlotLineOrBand.js", [
        e["Core/Axis/PlotLineOrBand/PlotLineOrBandAxis.js"],
        e["Core/Utilities.js"]
    ], function(t, e) {
        let { addEvent: i, arrayMax: s, arrayMin: r, defined: o, destroyObjectProperties: n, erase: a, fireEvent: h, merge: l, objectEach: d, pick: c } = e;
        class p {
            static compose(e, s) {
                return i(e, "afterInit", function() {
                    this.labelCollectors.push(()=>{
                        let t = [];
                        for (let e of this.axes)for (let { label: i, options: s } of e.plotLinesAndBands)i && !s?.label?.allowOverlap && t.push(i);
                        return t;
                    });
                }), t.compose(p, s);
            }
            constructor(t, e){
                this.axis = t, this.options = e, this.id = e.id;
            }
            render() {
                h(this, "render");
                let { axis: t, options: e } = this, { horiz: i, logarithmic: s } = t, { color: r, events: n, zIndex: a = 0 } = e, p = {}, u = t.chart.renderer, g = e.to, f = e.from, m = e.value, x = e.borderWidth, y = e.label, { label: b, svgElem: v } = this, S = [], C, k = o(f) && o(g), M = o(m), w = !v, T = {
                    class: "highcharts-plot-" + (k ? "band " : "line ") + (e.className || "")
                }, A = k ? "bands" : "lines";
                if (!t.chart.styledMode && (M ? (T.stroke = r || "#999999", T["stroke-width"] = c(e.width, 1), e.dashStyle && (T.dashstyle = e.dashStyle)) : k && (T.fill = r || "#e6e9ff", x && (T.stroke = e.borderColor, T["stroke-width"] = x))), p.zIndex = a, A += "-" + a, (C = t.plotLinesAndBandsGroups[A]) || (t.plotLinesAndBandsGroups[A] = C = u.g("plot-" + A).attr(p).add()), v || (this.svgElem = v = u.path().attr(T).add(C)), o(m)) S = t.getPlotLinePath({
                    value: s?.log2lin(m) ?? m,
                    lineWidth: v.strokeWidth(),
                    acrossPanes: e.acrossPanes
                });
                else {
                    if (!(o(f) && o(g))) return;
                    S = t.getPlotBandPath(s?.log2lin(f) ?? f, s?.log2lin(g) ?? g, e);
                }
                return !this.eventsAdded && n && (d(n, (t, e)=>{
                    v?.on(e, (t)=>{
                        n[e].apply(this, [
                            t
                        ]);
                    });
                }), this.eventsAdded = !0), (w || !v.d) && S?.length ? v.attr({
                    d: S
                }) : v && (S ? (v.show(), v.animate({
                    d: S
                })) : v.d && (v.hide(), b && (this.label = b = b.destroy()))), y && (o(y.text) || o(y.formatter)) && S?.length && t.width > 0 && t.height > 0 && !S.isFlat ? (y = l({
                    align: i && k ? "center" : void 0,
                    x: i ? !k && 4 : 10,
                    verticalAlign: !i && k ? "middle" : void 0,
                    y: i ? k ? 16 : 10 : k ? 6 : -4,
                    rotation: i && !k ? 90 : 0,
                    ...k ? {
                        inside: !0
                    } : {}
                }, y), this.renderLabel(y, S, k, a)) : b && b.hide(), this;
            }
            renderLabel(t, e, i, n) {
                let a = this.axis, h = a.chart.renderer, d = t.inside, c = this.label;
                c || (this.label = c = h.text(this.getLabelText(t), 0, 0, t.useHTML).attr({
                    align: t.textAlign || t.align,
                    rotation: t.rotation,
                    class: "highcharts-plot-" + (i ? "band" : "line") + "-label " + (t.className || ""),
                    zIndex: n
                }), a.chart.styledMode || c.css(l({
                    fontSize: "0.8em",
                    textOverflow: i && !d ? "" : "ellipsis"
                }, t.style)), c.add());
                let p = e.xBounds || [
                    e[0][1],
                    e[1][1],
                    i ? e[2][1] : e[0][1]
                ], u = e.yBounds || [
                    e[0][2],
                    e[1][2],
                    i ? e[2][2] : e[0][2]
                ], g = r(p), f = r(u), m = s(p) - g;
                c.align(t, !1, {
                    x: g,
                    y: f,
                    width: m,
                    height: s(u) - f
                }), (!c.alignValue || "left" === c.alignValue || o(d)) && c.css({
                    width: (t.style?.width || (i && d ? m : 90 === c.rotation ? a.height - (c.alignAttr.y - a.top) : (t.clip ? a.width : a.chart.chartWidth) - (c.alignAttr.x - a.left))) + "px"
                }), c.show(!0);
            }
            getLabelText(t) {
                return o(t.formatter) ? t.formatter.call(this) : t.text;
            }
            destroy() {
                a(this.axis.plotLinesAndBands, this), delete this.axis, n(this);
            }
        }
        return p;
    }), i(e, "Core/Tooltip.js", [
        e["Core/Animation/AnimationUtilities.js"],
        e["Core/Templating.js"],
        e["Core/Globals.js"],
        e["Core/Renderer/RendererUtilities.js"],
        e["Core/Renderer/RendererRegistry.js"],
        e["Core/Utilities.js"]
    ], function(t, e, i, s, r, o) {
        var n;
        let { animObject: a } = t, { format: h } = e, { composed: l, doc: d, isSafari: c } = i, { distribute: p } = s, { addEvent: u, clamp: g, css: f, discardElement: m, extend: x, fireEvent: y, isArray: b, isNumber: v, isString: S, merge: C, pick: k, pushUnique: M, splat: w, syncTimeout: T } = o;
        class A {
            constructor(t, e, i){
                this.allowShared = !0, this.crosshairs = [], this.distance = 0, this.isHidden = !0, this.isSticky = !1, this.options = {}, this.outside = !1, this.chart = t, this.init(t, e), this.pointer = i;
            }
            bodyFormatter(t) {
                return t.map(function(t) {
                    let e = t.series.tooltipOptions;
                    return (e[(t.point.formatPrefix || "point") + "Formatter"] || t.point.tooltipFormatter).call(t.point, e[(t.point.formatPrefix || "point") + "Format"] || "");
                });
            }
            cleanSplit(t) {
                this.chart.series.forEach(function(e) {
                    let i = e && e.tt;
                    i && (!i.isActive || t ? e.tt = i.destroy() : i.isActive = !1);
                });
            }
            defaultFormatter(t) {
                let e;
                let i = this.points || w(this);
                return (e = (e = [
                    t.tooltipFooterHeaderFormatter(i[0])
                ]).concat(t.bodyFormatter(i))).push(t.tooltipFooterHeaderFormatter(i[0], !0)), e;
            }
            destroy() {
                this.label && (this.label = this.label.destroy()), this.split && (this.cleanSplit(!0), this.tt && (this.tt = this.tt.destroy())), this.renderer && (this.renderer = this.renderer.destroy(), m(this.container)), o.clearTimeout(this.hideTimer);
            }
            getAnchor(t, e) {
                let i;
                let { chart: s, pointer: r } = this, o = s.inverted, n = s.plotTop, a = s.plotLeft;
                if ((t = w(t))[0].series && t[0].series.yAxis && !t[0].series.yAxis.options.reversedStacks && (t = t.slice().reverse()), this.followPointer && e) void 0 === e.chartX && (e = r.normalize(e)), i = [
                    e.chartX - a,
                    e.chartY - n
                ];
                else if (t[0].tooltipPos) i = t[0].tooltipPos;
                else {
                    let s = 0, r = 0;
                    t.forEach(function(t) {
                        let e = t.pos(!0);
                        e && (s += e[0], r += e[1]);
                    }), s /= t.length, r /= t.length, this.shared && t.length > 1 && e && (o ? s = e.chartX : r = e.chartY), i = [
                        s - a,
                        r - n
                    ];
                }
                return i.map(Math.round);
            }
            getClassName(t, e, i) {
                let s = this.options, r = t.series, o = r.options;
                return [
                    s.className,
                    "highcharts-label",
                    i && "highcharts-tooltip-header",
                    e ? "highcharts-tooltip-box" : "highcharts-tooltip",
                    !i && "highcharts-color-" + k(t.colorIndex, r.colorIndex),
                    o && o.className
                ].filter(S).join(" ");
            }
            getLabel({ anchorX: t, anchorY: e } = {
                anchorX: 0,
                anchorY: 0
            }) {
                let s = this, o = this.chart.styledMode, n = this.options, a = this.split && this.allowShared, h = this.container, l = this.chart.renderer;
                if (this.label) {
                    let t = !this.label.hasClass("highcharts-label");
                    (!a && t || a && !t) && this.destroy();
                }
                if (!this.label) {
                    if (this.outside) {
                        let t = this.chart.options.chart.style, e = r.getRendererType();
                        this.container = h = i.doc.createElement("div"), h.className = "highcharts-tooltip-container", f(h, {
                            position: "absolute",
                            top: "1px",
                            pointerEvents: "none",
                            zIndex: Math.max(this.options.style.zIndex || 0, (t && t.zIndex || 0) + 3)
                        }), this.renderer = l = new e(h, 0, 0, t, void 0, void 0, l.styledMode);
                    }
                    if (a ? this.label = l.g("tooltip") : (this.label = l.label("", t, e, n.shape, void 0, void 0, n.useHTML, void 0, "tooltip").attr({
                        padding: n.padding,
                        r: n.borderRadius
                    }), o || this.label.attr({
                        fill: n.backgroundColor,
                        "stroke-width": n.borderWidth || 0
                    }).css(n.style).css({
                        pointerEvents: n.style.pointerEvents || (this.shouldStickOnContact() ? "auto" : "none")
                    })), s.outside) {
                        let t = this.label;
                        [
                            t.xSetter,
                            t.ySetter
                        ].forEach((e, i)=>{
                            t[i ? "ySetter" : "xSetter"] = (r)=>{
                                e.call(t, s.distance), t[i ? "y" : "x"] = r, h && (h.style[i ? "top" : "left"] = `${r}px`);
                            };
                        });
                    }
                    this.label.attr({
                        zIndex: 8
                    }).shadow(n.shadow).add();
                }
                return h && !h.parentElement && i.doc.body.appendChild(h), this.label;
            }
            getPlayingField() {
                let { body: t, documentElement: e } = d, { chart: i, distance: s, outside: r } = this;
                return {
                    width: r ? Math.max(t.scrollWidth, e.scrollWidth, t.offsetWidth, e.offsetWidth, e.clientWidth) - 2 * s : i.chartWidth,
                    height: r ? Math.max(t.scrollHeight, e.scrollHeight, t.offsetHeight, e.offsetHeight, e.clientHeight) : i.chartHeight
                };
            }
            getPosition(t, e, i) {
                let { distance: s, chart: r, outside: o, pointer: n } = this, { inverted: a, plotLeft: h, plotTop: l, polar: d } = r, { plotX: c = 0, plotY: p = 0 } = i, u = {}, g = a && i.h || 0, { height: f, width: m } = this.getPlayingField(), x = n.getChartPosition(), y = (t)=>t * x.scaleX, b = (t)=>t * x.scaleY, v = (i)=>{
                    let n = "x" === i;
                    return [
                        i,
                        n ? m : f,
                        n ? t : e
                    ].concat(o ? [
                        n ? y(t) : b(e),
                        n ? x.left - s + y(c + h) : x.top - s + b(p + l),
                        0,
                        n ? m : f
                    ] : [
                        n ? t : e,
                        n ? c + h : p + l,
                        n ? h : l,
                        n ? h + r.plotWidth : l + r.plotHeight
                    ]);
                }, S = v("y"), C = v("x"), M, w = !!i.negative;
                !d && r.hoverSeries?.yAxis?.reversed && (w = !w);
                let T = !this.followPointer && k(i.ttBelow, !d && !a === w), A = function(t, e, i, r, n, a, h) {
                    let l = o ? "y" === t ? b(s) : y(s) : s, d = (i - r) / 2, c = r < n - s, p = n + s + r < e, f = n - l - i + d, m = n + l - d;
                    if (T && p) u[t] = m;
                    else if (!T && c) u[t] = f;
                    else if (c) u[t] = Math.min(h - r, f - g < 0 ? f : f - g);
                    else {
                        if (!p) return !1;
                        u[t] = Math.max(a, m + g + i > e ? m : m + g);
                    }
                }, P = function(t, e, i, r, o) {
                    if (o < s || o > e - s) return !1;
                    o < i / 2 ? u[t] = 1 : o > e - r / 2 ? u[t] = e - r - 2 : u[t] = o - i / 2;
                }, L = function(t) {
                    [S, C] = [
                        C,
                        S
                    ], M = t;
                }, O = ()=>{
                    !1 !== A.apply(0, S) ? !1 !== P.apply(0, C) || M || (L(!0), O()) : M ? u.x = u.y = 0 : (L(!0), O());
                };
                return (a && !d || this.len > 1) && L(), O(), u;
            }
            hide(t) {
                let e = this;
                o.clearTimeout(this.hideTimer), t = k(t, this.options.hideDelay), this.isHidden || (this.hideTimer = T(function() {
                    let i = e.getLabel();
                    e.getLabel().animate({
                        opacity: 0
                    }, {
                        duration: t ? 150 : t,
                        complete: ()=>{
                            i.hide(), e.container && e.container.remove();
                        }
                    }), e.isHidden = !0;
                }, t));
            }
            init(t, e) {
                this.chart = t, this.options = e, this.crosshairs = [], this.isHidden = !0, this.split = e.split && !t.inverted && !t.polar, this.shared = e.shared || this.split, this.outside = k(e.outside, !!(t.scrollablePixelsX || t.scrollablePixelsY));
            }
            shouldStickOnContact(t) {
                return !!(!this.followPointer && this.options.stickOnContact && (!t || this.pointer.inClass(t.target, "highcharts-tooltip")));
            }
            move(t, e, i, s) {
                let r = this, o = a(!r.isHidden && r.options.animation), n = r.followPointer || (r.len || 0) > 1, h = {
                    x: t,
                    y: e
                };
                n || (h.anchorX = i, h.anchorY = s), o.step = ()=>r.drawTracker(), r.getLabel().animate(h, o);
            }
            refresh(t, e) {
                let { chart: i, options: s, pointer: r, shared: n } = this, a = w(t), l = a[0], d = [], c = s.format, p = s.formatter || this.defaultFormatter, u = i.styledMode, f = {}, m = this.allowShared;
                if (!s.enabled || !l.series) return;
                o.clearTimeout(this.hideTimer), this.allowShared = !(!b(t) && t.series && t.series.noSharedTooltip), m = m && !this.allowShared, this.followPointer = !this.split && l.series.tooltipOptions.followPointer;
                let x = this.getAnchor(t, e), v = x[0], C = x[1];
                n && this.allowShared ? (r.applyInactiveState(a), a.forEach(function(t) {
                    t.setState("hover"), d.push(t.getLabelConfig());
                }), (f = l.getLabelConfig()).points = d) : f = l.getLabelConfig(), this.len = d.length;
                let M = S(c) ? h(c, f, i) : p.call(f, this), T = l.series;
                if (this.distance = k(T.tooltipOptions.distance, 16), !1 === M) this.hide();
                else {
                    if (this.split && this.allowShared) this.renderSplit(M, a);
                    else {
                        let t = v, o = C;
                        if (e && r.isDirectTouch && (t = e.chartX - i.plotLeft, o = e.chartY - i.plotTop), i.polar || !1 === T.options.clip || a.some((e)=>r.isDirectTouch || e.series.shouldShowTooltip(t, o))) {
                            let t = this.getLabel(m && this.tt || {});
                            (!s.style.width || u) && t.css({
                                width: (this.outside ? this.getPlayingField() : i.spacingBox).width + "px"
                            }), t.attr({
                                class: this.getClassName(l),
                                text: M && M.join ? M.join("") : M
                            }), this.outside && t.attr({
                                x: g(t.x || 0, 0, this.getPlayingField().width - (t.width || 0))
                            }), u || t.attr({
                                stroke: s.borderColor || l.color || T.color || "#666666"
                            }), this.updatePosition({
                                plotX: v,
                                plotY: C,
                                negative: l.negative,
                                ttBelow: l.ttBelow,
                                h: x[2] || 0
                            });
                        } else {
                            this.hide();
                            return;
                        }
                    }
                    this.isHidden && this.label && this.label.attr({
                        opacity: 1
                    }).show(), this.isHidden = !1;
                }
                y(this, "refresh");
            }
            renderSplit(t, e) {
                let i = this, { chart: s, chart: { chartWidth: r, chartHeight: o, plotHeight: n, plotLeft: a, plotTop: h, scrollablePixelsY: l = 0, scrollablePixelsX: u, styledMode: f }, distance: m, options: y, options: { positioner: b }, pointer: v } = i, { scrollLeft: C = 0, scrollTop: M = 0 } = s.scrollablePlotArea?.scrollingContainer || {}, w = i.outside && "number" != typeof u ? d.documentElement.getBoundingClientRect() : {
                    left: C,
                    right: C + r,
                    top: M,
                    bottom: M + o
                }, T = i.getLabel(), A = this.renderer || s.renderer, P = !!(s.xAxis[0] && s.xAxis[0].opposite), { left: L, top: O } = v.getChartPosition(), D = h + M, E = 0, I = n - l;
                function j(t, e, s, r, o = !0) {
                    let n, a;
                    return s ? (n = P ? 0 : I, a = g(t - r / 2, w.left, w.right - r - (i.outside ? L : 0))) : (n = e - D, a = g(a = o ? t - r - m : t + m, o ? a : w.left, w.right)), {
                        x: a,
                        y: n
                    };
                }
                S(t) && (t = [
                    !1,
                    t
                ]);
                let B = t.slice(0, e.length + 1).reduce(function(t, s, r) {
                    if (!1 !== s && "" !== s) {
                        let o = e[r - 1] || {
                            isHeader: !0,
                            plotX: e[0].plotX,
                            plotY: n,
                            series: {}
                        }, l = o.isHeader, d = l ? i : o.series, c = d.tt = function(t, e, s) {
                            let r = t, { isHeader: o, series: n } = e;
                            if (!r) {
                                let t = {
                                    padding: y.padding,
                                    r: y.borderRadius
                                };
                                f || (t.fill = y.backgroundColor, t["stroke-width"] = y.borderWidth ?? 1), r = A.label("", 0, 0, y[o ? "headerShape" : "shape"], void 0, void 0, y.useHTML).addClass(i.getClassName(e, !0, o)).attr(t).add(T);
                            }
                            return r.isActive = !0, r.attr({
                                text: s
                            }), f || r.css(y.style).attr({
                                stroke: y.borderColor || e.color || n.color || "#333333"
                            }), r;
                        }(d.tt, o, s.toString()), p = c.getBBox(), u = p.width + c.strokeWidth();
                        l && (E = p.height, I += E, P && (D -= E));
                        let { anchorX: x, anchorY: v } = function(t) {
                            let e, i;
                            let { isHeader: s, plotX: r = 0, plotY: o = 0, series: l } = t;
                            if (s) e = Math.max(a + r, a), i = h + n / 2;
                            else {
                                let { xAxis: t, yAxis: s } = l;
                                e = t.pos + g(r, -m, t.len + m), l.shouldShowTooltip(0, s.pos - h + o, {
                                    ignoreX: !0
                                }) && (i = s.pos + o);
                            }
                            return {
                                anchorX: e = g(e, w.left - m, w.right + m),
                                anchorY: i
                            };
                        }(o);
                        if ("number" == typeof v) {
                            let e = p.height + 1, s = b ? b.call(i, u, e, o) : j(x, v, l, u);
                            t.push({
                                align: b ? 0 : void 0,
                                anchorX: x,
                                anchorY: v,
                                boxWidth: u,
                                point: o,
                                rank: k(s.rank, l ? 1 : 0),
                                size: e,
                                target: s.y,
                                tt: c,
                                x: s.x
                            });
                        } else c.isActive = !1;
                    }
                    return t;
                }, []);
                !b && B.some((t)=>{
                    let { outside: e } = i, s = (e ? L : 0) + t.anchorX;
                    return s < w.left && s + t.boxWidth < w.right || s < L - w.left + t.boxWidth && w.right - s > s;
                }) && (B = B.map((t)=>{
                    let { x: e, y: i } = j(t.anchorX, t.anchorY, t.point.isHeader, t.boxWidth, !1);
                    return x(t, {
                        target: i,
                        x: e
                    });
                })), i.cleanSplit(), p(B, I);
                let R = {
                    left: L,
                    right: L
                };
                B.forEach(function(t) {
                    let { x: e, boxWidth: s, isHeader: r } = t;
                    !r && (i.outside && L + e < R.left && (R.left = L + e), !r && i.outside && R.left + s > R.right && (R.right = L + e));
                }), B.forEach(function(t) {
                    let { x: e, anchorX: s, anchorY: r, pos: o, point: { isHeader: n } } = t, a = {
                        visibility: void 0 === o ? "hidden" : "inherit",
                        x: e,
                        y: (o || 0) + D,
                        anchorX: s,
                        anchorY: r
                    };
                    if (i.outside && e < s) {
                        let t = L - R.left;
                        t > 0 && (n || (a.x = e + t, a.anchorX = s + t), n && (a.x = (R.right - R.left) / 2, a.anchorX = s + t));
                    }
                    t.tt.attr(a);
                });
                let { container: z, outside: N, renderer: W } = i;
                if (N && z && W) {
                    let { width: t, height: e, x: i, y: s } = T.getBBox();
                    W.setSize(t + i, e + s, !1), z.style.left = R.left + "px", z.style.top = O + "px";
                }
                c && T.attr({
                    opacity: 1 === T.opacity ? .999 : 1
                });
            }
            drawTracker() {
                if (!this.shouldStickOnContact()) {
                    this.tracker && (this.tracker = this.tracker.destroy());
                    return;
                }
                let t = this.chart, e = this.label, i = this.shared ? t.hoverPoints : t.hoverPoint;
                if (!e || !i) return;
                let s = {
                    x: 0,
                    y: 0,
                    width: 0,
                    height: 0
                }, r = this.getAnchor(i), o = e.getBBox();
                r[0] += t.plotLeft - (e.translateX || 0), r[1] += t.plotTop - (e.translateY || 0), s.x = Math.min(0, r[0]), s.y = Math.min(0, r[1]), s.width = r[0] < 0 ? Math.max(Math.abs(r[0]), o.width - r[0]) : Math.max(Math.abs(r[0]), o.width), s.height = r[1] < 0 ? Math.max(Math.abs(r[1]), o.height - Math.abs(r[1])) : Math.max(Math.abs(r[1]), o.height), this.tracker ? this.tracker.attr(s) : (this.tracker = e.renderer.rect(s).addClass("highcharts-tracker").add(e), t.styledMode || this.tracker.attr({
                    fill: "rgba(0,0,0,0)"
                }));
            }
            styledModeFormat(t) {
                return t.replace('style="font-size: 0.8em"', 'class="highcharts-header"').replace(/style="color:{(point|series)\.color}"/g, 'class="highcharts-color-{$1.colorIndex} {series.options.className} {point.options.className}"');
            }
            tooltipFooterHeaderFormatter(t, e) {
                let i = t.series, s = i.tooltipOptions, r = i.xAxis, o = r && r.dateTime, n = {
                    isFooter: e,
                    labelConfig: t
                }, a = s.xDateFormat, l = s[e ? "footerFormat" : "headerFormat"];
                return y(this, "headerFormatter", n, function(e) {
                    o && !a && v(t.key) && (a = o.getXDateFormat(t.key, s.dateTimeLabelFormats)), o && a && (t.point && t.point.tooltipDateKeys || [
                        "key"
                    ]).forEach(function(t) {
                        l = l.replace("{point." + t + "}", "{point." + t + ":" + a + "}");
                    }), i.chart.styledMode && (l = this.styledModeFormat(l)), e.text = h(l, {
                        point: t,
                        series: i
                    }, this.chart);
                }), n.text;
            }
            update(t) {
                this.destroy(), this.init(this.chart, C(!0, this.options, t));
            }
            updatePosition(t) {
                let { chart: e, container: i, distance: s, options: r, pointer: o, renderer: n } = this, { height: a = 0, width: h = 0 } = this.getLabel(), { left: l, top: d, scaleX: c, scaleY: p } = o.getChartPosition(), u = (r.positioner || this.getPosition).call(this, h, a, t), g = (t.plotX || 0) + e.plotLeft, m = (t.plotY || 0) + e.plotTop, x;
                n && i && (r.positioner && (u.x += l - s, u.y += d - s), x = (r.borderWidth || 0) + 2 * s + 2, n.setSize(h + x, a + x, !1), (1 !== c || 1 !== p) && (f(i, {
                    transform: `scale(${c}, ${p})`
                }), g *= c, m *= p), g += l - u.x, m += d - u.y), this.move(Math.round(u.x), Math.round(u.y || 0), g, m);
            }
        }
        return (n = A || (A = {})).compose = function(t) {
            M(l, "Core.Tooltip") && u(t, "afterInit", function() {
                let t = this.chart;
                t.options.tooltip && (t.tooltip = new n(t, t.options.tooltip, this));
            });
        }, A;
    }), i(e, "Core/Series/Point.js", [
        e["Core/Renderer/HTML/AST.js"],
        e["Core/Animation/AnimationUtilities.js"],
        e["Core/Defaults.js"],
        e["Core/Templating.js"],
        e["Core/Utilities.js"]
    ], function(t, e, i, s, r) {
        let { animObject: o } = e, { defaultOptions: n } = i, { format: a } = s, { addEvent: h, crisp: l, erase: d, extend: c, fireEvent: p, getNestedProperty: u, isArray: g, isFunction: f, isNumber: m, isObject: x, merge: y, pick: b, syncTimeout: v, removeEvent: S, uniqueKey: C } = r;
        class k {
            animateBeforeDestroy() {
                let t = this, e = {
                    x: t.startXPos,
                    opacity: 0
                }, i = t.getGraphicalProps();
                i.singular.forEach(function(i) {
                    t[i] = t[i].animate("dataLabel" === i ? {
                        x: t[i].startXPos,
                        y: t[i].startYPos,
                        opacity: 0
                    } : e);
                }), i.plural.forEach(function(e) {
                    t[e].forEach(function(e) {
                        e.element && e.animate(c({
                            x: t.startXPos
                        }, e.startYPos ? {
                            x: e.startXPos,
                            y: e.startYPos
                        } : {}));
                    });
                });
            }
            applyOptions(t, e) {
                let i = this.series, s = i.options.pointValKey || i.pointValKey;
                return c(this, t = k.prototype.optionsToObject.call(this, t)), this.options = this.options ? c(this.options, t) : t, t.group && delete this.group, t.dataLabels && delete this.dataLabels, s && (this.y = k.prototype.getNestedProperty.call(this, s)), this.selected && (this.state = "select"), "name" in this && void 0 === e && i.xAxis && i.xAxis.hasNames && (this.x = i.xAxis.nameToX(this)), void 0 === this.x && i ? this.x = e ?? i.autoIncrement() : m(t.x) && i.options.relativeXValue && (this.x = i.autoIncrement(t.x)), this.isNull = this.isValid && !this.isValid(), this.formatPrefix = this.isNull ? "null" : "point", this;
            }
            destroy() {
                if (!this.destroyed) {
                    let t = this, e = t.series, i = e.chart, s = e.options.dataSorting, r = i.hoverPoints, n = o(t.series.chart.renderer.globalAnimation), a = ()=>{
                        for(let e in (t.graphic || t.graphics || t.dataLabel || t.dataLabels) && (S(t), t.destroyElements()), t)delete t[e];
                    };
                    t.legendItem && i.legend.destroyItem(t), r && (t.setState(), d(r, t), r.length || (i.hoverPoints = null)), t === i.hoverPoint && t.onMouseOut(), s && s.enabled ? (this.animateBeforeDestroy(), v(a, n.duration)) : a(), i.pointCount--;
                }
                this.destroyed = !0;
            }
            destroyElements(t) {
                let e = this, i = e.getGraphicalProps(t);
                i.singular.forEach(function(t) {
                    e[t] = e[t].destroy();
                }), i.plural.forEach(function(t) {
                    e[t].forEach(function(t) {
                        t && t.element && t.destroy();
                    }), delete e[t];
                });
            }
            firePointEvent(t, e, i) {
                let s = this, r = this.series.options;
                s.manageEvent(t), "click" === t && r.allowPointSelect && (i = function(t) {
                    !s.destroyed && s.select && s.select(null, t.ctrlKey || t.metaKey || t.shiftKey);
                }), p(s, t, e, i);
            }
            getClassName() {
                return "highcharts-point" + (this.selected ? " highcharts-point-select" : "") + (this.negative ? " highcharts-negative" : "") + (this.isNull ? " highcharts-null-point" : "") + (void 0 !== this.colorIndex ? " highcharts-color-" + this.colorIndex : "") + (this.options.className ? " " + this.options.className : "") + (this.zone && this.zone.className ? " " + this.zone.className.replace("highcharts-negative", "") : "");
            }
            getGraphicalProps(t) {
                let e, i;
                let s = this, r = [], o = {
                    singular: [],
                    plural: []
                };
                for((t = t || {
                    graphic: 1,
                    dataLabel: 1
                }).graphic && r.push("graphic", "connector"), t.dataLabel && r.push("dataLabel", "dataLabelPath", "dataLabelUpper"), i = r.length; i--;)s[e = r[i]] && o.singular.push(e);
                return [
                    "graphic",
                    "dataLabel"
                ].forEach(function(e) {
                    let i = e + "s";
                    t[e] && s[i] && o.plural.push(i);
                }), o;
            }
            getLabelConfig() {
                return {
                    x: this.category,
                    y: this.y,
                    color: this.color,
                    colorIndex: this.colorIndex,
                    key: this.name || this.category,
                    series: this.series,
                    point: this,
                    percentage: this.percentage,
                    total: this.total || this.stackTotal
                };
            }
            getNestedProperty(t) {
                return t ? 0 === t.indexOf("custom.") ? u(t, this.options) : this[t] : void 0;
            }
            getZone() {
                let t = this.series, e = t.zones, i = t.zoneAxis || "y", s, r = 0;
                for(s = e[0]; this[i] >= s.value;)s = e[++r];
                return this.nonZonedColor || (this.nonZonedColor = this.color), s && s.color && !this.options.color ? this.color = s.color : this.color = this.nonZonedColor, s;
            }
            hasNewShapeType() {
                return (this.graphic && (this.graphic.symbolName || this.graphic.element.nodeName)) !== this.shapeType;
            }
            constructor(t, e, i){
                this.formatPrefix = "point", this.visible = !0, this.series = t, this.applyOptions(e, i), this.id ?? (this.id = C()), this.resolveColor(), t.chart.pointCount++, p(this, "afterInit");
            }
            isValid() {
                return (m(this.x) || this.x instanceof Date) && m(this.y);
            }
            optionsToObject(t) {
                let e = this.series, i = e.options.keys, s = i || e.pointArrayMap || [
                    "y"
                ], r = s.length, o = {}, n, a = 0, h = 0;
                if (m(t) || null === t) o[s[0]] = t;
                else if (g(t)) for(!i && t.length > r && ("string" == (n = typeof t[0]) ? o.name = t[0] : "number" === n && (o.x = t[0]), a++); h < r;)i && void 0 === t[a] || (s[h].indexOf(".") > 0 ? k.prototype.setNestedProperty(o, t[a], s[h]) : o[s[h]] = t[a]), a++, h++;
                else "object" == typeof t && (o = t, t.dataLabels && (e.hasDataLabels = ()=>!0), t.marker && (e._hasPointMarkers = !0));
                return o;
            }
            pos(t, e = this.plotY) {
                if (!this.destroyed) {
                    let { plotX: i, series: s } = this, { chart: r, xAxis: o, yAxis: n } = s, a = 0, h = 0;
                    if (m(i) && m(e)) return t && (a = o ? o.pos : r.plotLeft, h = n ? n.pos : r.plotTop), r.inverted && o && n ? [
                        n.len - e + h,
                        o.len - i + a
                    ] : [
                        i + a,
                        e + h
                    ];
                }
            }
            resolveColor() {
                let t = this.series, e = t.chart.options.chart, i = t.chart.styledMode, s, r, o = e.colorCount, n;
                delete this.nonZonedColor, t.options.colorByPoint ? (i || (s = (r = t.options.colors || t.chart.options.colors)[t.colorCounter], o = r.length), n = t.colorCounter, t.colorCounter++, t.colorCounter === o && (t.colorCounter = 0)) : (i || (s = t.color), n = t.colorIndex), this.colorIndex = b(this.options.colorIndex, n), this.color = b(this.options.color, s);
            }
            setNestedProperty(t, e, i) {
                return i.split(".").reduce(function(t, i, s, r) {
                    let o = r.length - 1 === s;
                    return t[i] = o ? e : x(t[i], !0) ? t[i] : {}, t[i];
                }, t), t;
            }
            shouldDraw() {
                return !this.isNull;
            }
            tooltipFormatter(t) {
                let e = this.series, i = e.tooltipOptions, s = b(i.valueDecimals, ""), r = i.valuePrefix || "", o = i.valueSuffix || "";
                return e.chart.styledMode && (t = e.chart.tooltip.styledModeFormat(t)), (e.pointArrayMap || [
                    "y"
                ]).forEach(function(e) {
                    e = "{point." + e, (r || o) && (t = t.replace(RegExp(e + "}", "g"), r + e + "}" + o)), t = t.replace(RegExp(e + "}", "g"), e + ":,." + s + "f}");
                }), a(t, {
                    point: this,
                    series: this.series
                }, e.chart);
            }
            update(t, e, i, s) {
                let r;
                let o = this, n = o.series, a = o.graphic, h = n.chart, l = n.options;
                function d() {
                    o.applyOptions(t);
                    let s = a && o.hasMockGraphic, d = null === o.y ? !s : s;
                    a && d && (o.graphic = a.destroy(), delete o.hasMockGraphic), x(t, !0) && (a && a.element && t && t.marker && void 0 !== t.marker.symbol && (o.graphic = a.destroy()), t?.dataLabels && o.dataLabel && (o.dataLabel = o.dataLabel.destroy())), r = o.index, n.updateParallelArrays(o, r), l.data[r] = x(l.data[r], !0) || x(t, !0) ? o.options : b(t, l.data[r]), n.isDirty = n.isDirtyData = !0, !n.fixedBox && n.hasCartesianSeries && (h.isDirtyBox = !0), "point" === l.legendType && (h.isDirtyLegend = !0), e && h.redraw(i);
                }
                e = b(e, !0), !1 === s ? d() : o.firePointEvent("update", {
                    options: t
                }, d);
            }
            remove(t, e) {
                this.series.removePoint(this.series.data.indexOf(this), t, e);
            }
            select(t, e) {
                let i = this, s = i.series, r = s.chart;
                t = b(t, !i.selected), this.selectedStaging = t, i.firePointEvent(t ? "select" : "unselect", {
                    accumulate: e
                }, function() {
                    i.selected = i.options.selected = t, s.options.data[s.data.indexOf(i)] = i.options, i.setState(t && "select"), e || r.getSelectedPoints().forEach(function(t) {
                        let e = t.series;
                        t.selected && t !== i && (t.selected = t.options.selected = !1, e.options.data[e.data.indexOf(t)] = t.options, t.setState(r.hoverPoints && e.options.inactiveOtherPoints ? "inactive" : ""), t.firePointEvent("unselect"));
                    });
                }), delete this.selectedStaging;
            }
            onMouseOver(t) {
                let { inverted: e, pointer: i } = this.series.chart;
                i && (t = t ? i.normalize(t) : i.getChartCoordinatesFromPoint(this, e), i.runPointActions(t, this));
            }
            onMouseOut() {
                let t = this.series.chart;
                this.firePointEvent("mouseOut"), this.series.options.inactiveOtherPoints || (t.hoverPoints || []).forEach(function(t) {
                    t.setState();
                }), t.hoverPoints = t.hoverPoint = null;
            }
            manageEvent(t) {
                let e = y(this.series.options.point, this.options), i = e.events?.[t];
                f(i) && (!this.hcEvents?.[t] || this.hcEvents?.[t]?.map((t)=>t.fn).indexOf(i) === -1) ? (this.importedUserEvent?.(), this.importedUserEvent = h(this, t, i)) : this.importedUserEvent && !i && this.hcEvents?.[t] && (S(this, t), delete this.hcEvents[t], Object.keys(this.hcEvents) || delete this.importedUserEvent);
            }
            setState(e, i) {
                let s = this.series, r = this.state, o = s.options.states[e || "normal"] || {}, a = n.plotOptions[s.type].marker && s.options.marker, h = a && !1 === a.enabled, l = a && a.states && a.states[e || "normal"] || {}, d = !1 === l.enabled, u = this.marker || {}, g = s.chart, f = a && s.markerAttribs, x = s.halo, y, v, S, C = s.stateMarkerGraphic, k;
                if ((e = e || "") === this.state && !i || this.selected && "select" !== e || !1 === o.enabled || e && (d || h && !1 === l.enabled) || e && u.states && u.states[e] && !1 === u.states[e].enabled) return;
                if (this.state = e, f && (y = s.markerAttribs(this, e)), this.graphic && !this.hasMockGraphic) {
                    if (r && this.graphic.removeClass("highcharts-point-" + r), e && this.graphic.addClass("highcharts-point-" + e), !g.styledMode) {
                        v = s.pointAttribs(this, e), S = b(g.options.chart.animation, o.animation);
                        let t = v.opacity;
                        s.options.inactiveOtherPoints && m(t) && (this.dataLabels || []).forEach(function(e) {
                            e && !e.hasClass("highcharts-data-label-hidden") && (e.animate({
                                opacity: t
                            }, S), e.connector && e.connector.animate({
                                opacity: t
                            }, S));
                        }), this.graphic.animate(v, S);
                    }
                    y && this.graphic.animate(y, b(g.options.chart.animation, l.animation, a.animation)), C && C.hide();
                } else e && l && (k = u.symbol || s.symbol, C && C.currentSymbol !== k && (C = C.destroy()), y && (C ? C[i ? "animate" : "attr"]({
                    x: y.x,
                    y: y.y
                }) : k && (s.stateMarkerGraphic = C = g.renderer.symbol(k, y.x, y.y, y.width, y.height).add(s.markerGroup), C.currentSymbol = k)), !g.styledMode && C && "inactive" !== this.state && C.attr(s.pointAttribs(this, e))), C && (C[e && this.isInside ? "show" : "hide"](), C.element.point = this, C.addClass(this.getClassName(), !0));
                let M = o.halo, w = this.graphic || C, T = w && w.visibility || "inherit";
                M && M.size && w && "hidden" !== T && !this.isCluster ? (x || (s.halo = x = g.renderer.path().add(w.parentGroup)), x.show()[i ? "animate" : "attr"]({
                    d: this.haloPath(M.size)
                }), x.attr({
                    class: "highcharts-halo highcharts-color-" + b(this.colorIndex, s.colorIndex) + (this.className ? " " + this.className : ""),
                    visibility: T,
                    zIndex: -1
                }), x.point = this, g.styledMode || x.attr(c({
                    fill: this.color || s.color,
                    "fill-opacity": M.opacity
                }, t.filterUserAttributes(M.attributes || {})))) : x?.point?.haloPath && !x.point.destroyed && x.animate({
                    d: x.point.haloPath(0)
                }, null, x.hide), p(this, "afterSetState", {
                    state: e
                });
            }
            haloPath(t) {
                let e = this.pos();
                return e ? this.series.chart.renderer.symbols.circle(l(e[0], 1) - t, e[1] - t, 2 * t, 2 * t) : [];
            }
        }
        return k;
    }), i(e, "Core/Pointer.js", [
        e["Core/Color/Color.js"],
        e["Core/Globals.js"],
        e["Core/Utilities.js"]
    ], function(t, e, i) {
        var s;
        let { parse: r } = t, { charts: o, composed: n, isTouchDevice: a } = e, { addEvent: h, attr: l, css: d, extend: c, find: p, fireEvent: u, isNumber: g, isObject: f, objectEach: m, offset: x, pick: y, pushUnique: b, splat: v } = i;
        class S {
            applyInactiveState(t) {
                let e = [], i;
                (t || []).forEach(function(t) {
                    i = t.series, e.push(i), i.linkedParent && e.push(i.linkedParent), i.linkedSeries && (e = e.concat(i.linkedSeries)), i.navigatorSeries && e.push(i.navigatorSeries);
                }), this.chart.series.forEach(function(t) {
                    -1 === e.indexOf(t) ? t.setState("inactive", !0) : t.options.inactiveOtherPoints && t.setAllPointsToState("inactive");
                });
            }
            destroy() {
                let t = this;
                this.eventsToUnbind.forEach((t)=>t()), this.eventsToUnbind = [], !e.chartCount && (S.unbindDocumentMouseUp && S.unbindDocumentMouseUp.forEach((t)=>t()), S.unbindDocumentTouchEnd && (S.unbindDocumentTouchEnd = S.unbindDocumentTouchEnd())), clearInterval(t.tooltipTimeout), m(t, function(e, i) {
                    t[i] = void 0;
                });
            }
            getSelectionMarkerAttrs(t, e) {
                let i = {
                    args: {
                        chartX: t,
                        chartY: e
                    },
                    attrs: {},
                    shapeType: "rect"
                };
                return u(this, "getSelectionMarkerAttrs", i, (i)=>{
                    let s;
                    let { chart: r, zoomHor: o, zoomVert: n } = this, { mouseDownX: a = 0, mouseDownY: h = 0 } = r, l = i.attrs;
                    l.x = r.plotLeft, l.y = r.plotTop, l.width = o ? 1 : r.plotWidth, l.height = n ? 1 : r.plotHeight, o && (s = t - a, l.width = Math.max(1, Math.abs(s)), l.x = (s > 0 ? 0 : s) + a), n && (s = e - h, l.height = Math.max(1, Math.abs(s)), l.y = (s > 0 ? 0 : s) + h);
                }), i;
            }
            drag(t) {
                let { chart: e } = this, { mouseDownX: i = 0, mouseDownY: s = 0 } = e, { panning: o, panKey: n, selectionMarkerFill: a } = e.options.chart, h = e.plotLeft, l = e.plotTop, d = e.plotWidth, c = e.plotHeight, p = f(o) ? o.enabled : o, u = n && t[`${n}Key`], g = t.chartX, m = t.chartY, x, y = this.selectionMarker;
                if ((!y || !y.touch) && (g < h ? g = h : g > h + d && (g = h + d), m < l ? m = l : m > l + c && (m = l + c), this.hasDragged = Math.sqrt(Math.pow(i - g, 2) + Math.pow(s - m, 2)), this.hasDragged > 10)) {
                    x = e.isInsidePlot(i - h, s - l, {
                        visiblePlotOnly: !0
                    });
                    let { shapeType: n, attrs: d } = this.getSelectionMarkerAttrs(g, m);
                    (e.hasCartesianSeries || e.mapView) && this.hasZoom && x && !u && !y && (this.selectionMarker = y = e.renderer[n](), y.attr({
                        class: "highcharts-selection-marker",
                        zIndex: 7
                    }).add(), e.styledMode || y.attr({
                        fill: a || r("#334eff").setOpacity(.25).get()
                    })), y && y.attr(d), x && !y && p && e.pan(t, o);
                }
            }
            dragStart(t) {
                let e = this.chart;
                e.mouseIsDown = t.type, e.cancelClick = !1, e.mouseDownX = t.chartX, e.mouseDownY = t.chartY;
            }
            getSelectionBox(t) {
                let e = {
                    args: {
                        marker: t
                    },
                    result: t.getBBox()
                };
                return u(this, "getSelectionBox", e), e.result;
            }
            drop(t) {
                let e;
                let { chart: i, selectionMarker: s } = this;
                for (let t of i.axes)t.isPanning && (t.isPanning = !1, (t.options.startOnTick || t.options.endOnTick || t.series.some((t)=>t.boosted)) && (t.forceRedraw = !0, t.setExtremes(t.userMin, t.userMax, !1), e = !0));
                if (e && i.redraw(), s && t) {
                    if (this.hasDragged) {
                        let e = this.getSelectionBox(s);
                        i.transform({
                            axes: i.axes.filter((t)=>t.zoomEnabled && ("xAxis" === t.coll && this.zoomX || "yAxis" === t.coll && this.zoomY)),
                            selection: {
                                originalEvent: t,
                                xAxis: [],
                                yAxis: [],
                                ...e
                            },
                            from: e
                        });
                    }
                    g(i.index) && (this.selectionMarker = s.destroy());
                }
                i && g(i.index) && (d(i.container, {
                    cursor: i._cursor
                }), i.cancelClick = this.hasDragged > 10, i.mouseIsDown = !1, this.hasDragged = 0, this.pinchDown = []);
            }
            findNearestKDPoint(t, e, i) {
                let s;
                return t.forEach(function(t) {
                    let r = !(t.noSharedTooltip && e) && 0 > t.options.findNearestPointBy.indexOf("y"), o = t.searchPoint(i, r);
                    f(o, !0) && o.series && (!f(s, !0) || function(t, i) {
                        let s = t.distX - i.distX, r = t.dist - i.dist, o = i.series.group?.zIndex - t.series.group?.zIndex;
                        return 0 !== s && e ? s : 0 !== r ? r : 0 !== o ? o : t.series.index > i.series.index ? -1 : 1;
                    }(s, o) > 0) && (s = o);
                }), s;
            }
            getChartCoordinatesFromPoint(t, e) {
                let { xAxis: i, yAxis: s } = t.series, r = t.shapeArgs;
                if (i && s) {
                    let o = t.clientX ?? t.plotX ?? 0, n = t.plotY || 0;
                    return t.isNode && r && g(r.x) && g(r.y) && (o = r.x, n = r.y), e ? {
                        chartX: s.len + s.pos - n,
                        chartY: i.len + i.pos - o
                    } : {
                        chartX: o + i.pos,
                        chartY: n + s.pos
                    };
                }
                if (r && r.x && r.y) return {
                    chartX: r.x,
                    chartY: r.y
                };
            }
            getChartPosition() {
                if (this.chartPosition) return this.chartPosition;
                let { container: t } = this.chart, e = x(t);
                this.chartPosition = {
                    left: e.left,
                    top: e.top,
                    scaleX: 1,
                    scaleY: 1
                };
                let { offsetHeight: i, offsetWidth: s } = t;
                return s > 2 && i > 2 && (this.chartPosition.scaleX = e.width / s, this.chartPosition.scaleY = e.height / i), this.chartPosition;
            }
            getCoordinates(t) {
                let e = {
                    xAxis: [],
                    yAxis: []
                };
                for (let i of this.chart.axes)e[i.isXAxis ? "xAxis" : "yAxis"].push({
                    axis: i,
                    value: i.toValue(t[i.horiz ? "chartX" : "chartY"])
                });
                return e;
            }
            getHoverData(t, e, i, s, r, o) {
                let n = [], a = function(t) {
                    return t.visible && !(!r && t.directTouch) && y(t.options.enableMouseTracking, !0);
                }, h = e, l, d = {
                    chartX: o ? o.chartX : void 0,
                    chartY: o ? o.chartY : void 0,
                    shared: r
                };
                u(this, "beforeGetHoverData", d), l = h && !h.stickyTracking ? [
                    h
                ] : i.filter((t)=>t.stickyTracking && (d.filter || a)(t));
                let c = s && t || !o ? t : this.findNearestKDPoint(l, r, o);
                return h = c && c.series, c && (r && !h.noSharedTooltip ? (l = i.filter(function(t) {
                    return d.filter ? d.filter(t) : a(t) && !t.noSharedTooltip;
                })).forEach(function(t) {
                    let e = p(t.points, function(t) {
                        return t.x === c.x && !t.isNull;
                    });
                    f(e) && (t.boosted && t.boost && (e = t.boost.getPoint(e)), n.push(e));
                }) : n.push(c)), u(this, "afterGetHoverData", d = {
                    hoverPoint: c
                }), {
                    hoverPoint: d.hoverPoint,
                    hoverSeries: h,
                    hoverPoints: n
                };
            }
            getPointFromEvent(t) {
                let e = t.target, i;
                for(; e && !i;)i = e.point, e = e.parentNode;
                return i;
            }
            onTrackerMouseOut(t) {
                let e = this.chart, i = t.relatedTarget, s = e.hoverSeries;
                this.isDirectTouch = !1, !s || !i || s.stickyTracking || this.inClass(i, "highcharts-tooltip") || this.inClass(i, "highcharts-series-" + s.index) && this.inClass(i, "highcharts-tracker") || s.onMouseOut();
            }
            inClass(t, e) {
                let i = t, s;
                for(; i;){
                    if (s = l(i, "class")) {
                        if (-1 !== s.indexOf(e)) return !0;
                        if (-1 !== s.indexOf("highcharts-container")) return !1;
                    }
                    i = i.parentElement;
                }
            }
            constructor(t, e){
                this.hasDragged = 0, this.pointerCaptureEventsToUnbind = [], this.eventsToUnbind = [], this.options = e, this.chart = t, this.runChartClick = !!e.chart.events?.click, this.pinchDown = [], this.setDOMEvents(), u(this, "afterInit");
            }
            normalize(t, e) {
                let i = t.touches, s = i ? i.length ? i.item(0) : y(i.changedTouches, t.changedTouches)[0] : t;
                e || (e = this.getChartPosition());
                let r = s.pageX - e.left, o = s.pageY - e.top;
                return c(t, {
                    chartX: Math.round(r /= e.scaleX),
                    chartY: Math.round(o /= e.scaleY)
                });
            }
            onContainerClick(t) {
                let e = this.chart, i = e.hoverPoint, s = this.normalize(t), r = e.plotLeft, o = e.plotTop;
                !e.cancelClick && (i && this.inClass(s.target, "highcharts-tracker") ? (u(i.series, "click", c(s, {
                    point: i
                })), e.hoverPoint && i.firePointEvent("click", s)) : (c(s, this.getCoordinates(s)), e.isInsidePlot(s.chartX - r, s.chartY - o, {
                    visiblePlotOnly: !0
                }) && u(e, "click", s)));
            }
            onContainerMouseDown(t) {
                let i = (1 & (t.buttons || t.button)) == 1;
                t = this.normalize(t), e.isFirefox && 0 !== t.button && this.onContainerMouseMove(t), (void 0 === t.button || i) && (this.zoomOption(t), i && t.preventDefault?.(), this.dragStart(t));
            }
            onContainerMouseLeave(t) {
                let { pointer: e } = o[y(S.hoverChartIndex, -1)] || {};
                t = this.normalize(t), this.onContainerMouseMove(t), e && !this.inClass(t.relatedTarget, "highcharts-tooltip") && (e.reset(), e.chartPosition = void 0);
            }
            onContainerMouseEnter() {
                delete this.chartPosition;
            }
            onContainerMouseMove(t) {
                let e = this.chart, i = e.tooltip, s = this.normalize(t);
                this.setHoverChartIndex(t), ("mousedown" === e.mouseIsDown || this.touchSelect(s)) && this.drag(s), !e.openMenu && (this.inClass(s.target, "highcharts-tracker") || e.isInsidePlot(s.chartX - e.plotLeft, s.chartY - e.plotTop, {
                    visiblePlotOnly: !0
                })) && !(i && i.shouldStickOnContact(s)) && (this.inClass(s.target, "highcharts-no-tooltip") ? this.reset(!1, 0) : this.runPointActions(s));
            }
            onDocumentTouchEnd(t) {
                this.onDocumentMouseUp(t);
            }
            onContainerTouchMove(t) {
                this.touchSelect(t) ? this.onContainerMouseMove(t) : this.touch(t);
            }
            onContainerTouchStart(t) {
                this.touchSelect(t) ? this.onContainerMouseDown(t) : (this.zoomOption(t), this.touch(t, !0));
            }
            onDocumentMouseMove(t) {
                let e = this.chart, i = e.tooltip, s = this.chartPosition, r = this.normalize(t, s);
                !s || e.isInsidePlot(r.chartX - e.plotLeft, r.chartY - e.plotTop, {
                    visiblePlotOnly: !0
                }) || i && i.shouldStickOnContact(r) || r.target !== e.container.ownerDocument && this.inClass(r.target, "highcharts-tracker") || this.reset();
            }
            onDocumentMouseUp(t) {
                o[y(S.hoverChartIndex, -1)]?.pointer?.drop(t);
            }
            pinch(t) {
                let e = this, { chart: i, hasZoom: s, lastTouches: r } = e, o = [].map.call(t.touches || [], (t)=>e.normalize(t)), n = o.length, a = 1 === n && (e.inClass(t.target, "highcharts-tracker") && i.runTrackerClick || e.runChartClick), h = i.tooltip, l = 1 === n && y(h?.options.followTouchMove, !0);
                n > 1 ? e.initiated = !0 : l && (e.initiated = !1), s && e.initiated && !a && !1 !== t.cancelable && t.preventDefault(), "touchstart" === t.type ? (e.pinchDown = o, e.res = !0, i.mouseDownX = t.chartX) : l ? this.runPointActions(e.normalize(t)) : r && (u(i, "touchpan", {
                    originalEvent: t,
                    touches: o
                }, ()=>{
                    let e = (t)=>{
                        let e = t[0], i = t[1] || e;
                        return {
                            x: e.chartX,
                            y: e.chartY,
                            width: i.chartX - e.chartX,
                            height: i.chartY - e.chartY
                        };
                    };
                    i.transform({
                        axes: i.axes.filter((t)=>t.zoomEnabled && (this.zoomHor && t.horiz || this.zoomVert && !t.horiz)),
                        to: e(o),
                        from: e(r),
                        trigger: t.type
                    });
                }), e.res && (e.res = !1, this.reset(!1, 0))), e.lastTouches = o;
            }
            reset(t, e) {
                let i = this.chart, s = i.hoverSeries, r = i.hoverPoint, o = i.hoverPoints, n = i.tooltip, a = n && n.shared ? o : r;
                t && a && v(a).forEach(function(e) {
                    e.series.isCartesian && void 0 === e.plotX && (t = !1);
                }), t ? n && a && v(a).length && (n.refresh(a), n.shared && o ? o.forEach(function(t) {
                    t.setState(t.state, !0), t.series.isCartesian && (t.series.xAxis.crosshair && t.series.xAxis.drawCrosshair(null, t), t.series.yAxis.crosshair && t.series.yAxis.drawCrosshair(null, t));
                }) : r && (r.setState(r.state, !0), i.axes.forEach(function(t) {
                    t.crosshair && r.series[t.coll] === t && t.drawCrosshair(null, r);
                }))) : (r && r.onMouseOut(), o && o.forEach(function(t) {
                    t.setState();
                }), s && s.onMouseOut(), n && n.hide(e), this.unDocMouseMove && (this.unDocMouseMove = this.unDocMouseMove()), i.axes.forEach(function(t) {
                    t.hideCrosshair();
                }), i.hoverPoints = i.hoverPoint = void 0);
            }
            runPointActions(t, e, i) {
                let s = this.chart, r = s.series, n = s.tooltip && s.tooltip.options.enabled ? s.tooltip : void 0, a = !!n && n.shared, l = e || s.hoverPoint, d = l && l.series || s.hoverSeries, c = (!t || "touchmove" !== t.type) && (!!e || d && d.directTouch && this.isDirectTouch), u = this.getHoverData(l, d, r, c, a, t);
                l = u.hoverPoint, d = u.hoverSeries;
                let g = u.hoverPoints, f = d && d.tooltipOptions.followPointer && !d.tooltipOptions.split, m = a && d && !d.noSharedTooltip;
                if (l && (i || l !== s.hoverPoint || n && n.isHidden)) {
                    if ((s.hoverPoints || []).forEach(function(t) {
                        -1 === g.indexOf(t) && t.setState();
                    }), s.hoverSeries !== d && d.onMouseOver(), this.applyInactiveState(g), (g || []).forEach(function(t) {
                        t.setState("hover");
                    }), s.hoverPoint && s.hoverPoint.firePointEvent("mouseOut"), !l.series) return;
                    s.hoverPoints = g, s.hoverPoint = l, l.firePointEvent("mouseOver", void 0, ()=>{
                        n && l && n.refresh(m ? g : l, t);
                    });
                } else if (f && n && !n.isHidden) {
                    let e = n.getAnchor([
                        {}
                    ], t);
                    s.isInsidePlot(e[0], e[1], {
                        visiblePlotOnly: !0
                    }) && n.updatePosition({
                        plotX: e[0],
                        plotY: e[1]
                    });
                }
                this.unDocMouseMove || (this.unDocMouseMove = h(s.container.ownerDocument, "mousemove", (t)=>o[S.hoverChartIndex ?? -1]?.pointer?.onDocumentMouseMove(t)), this.eventsToUnbind.push(this.unDocMouseMove)), s.axes.forEach(function(e) {
                    let i;
                    let r = y((e.crosshair || {}).snap, !0);
                    !r || (i = s.hoverPoint) && i.series[e.coll] === e || (i = p(g, (t)=>t.series && t.series[e.coll] === e)), i || !r ? e.drawCrosshair(t, i) : e.hideCrosshair();
                });
            }
            setDOMEvents() {
                let t = this.chart.container, e = t.ownerDocument;
                t.onmousedown = this.onContainerMouseDown.bind(this), t.onmousemove = this.onContainerMouseMove.bind(this), t.onclick = this.onContainerClick.bind(this), this.eventsToUnbind.push(h(t, "mouseenter", this.onContainerMouseEnter.bind(this)), h(t, "mouseleave", this.onContainerMouseLeave.bind(this))), S.unbindDocumentMouseUp || (S.unbindDocumentMouseUp = []), S.unbindDocumentMouseUp.push(h(e, "mouseup", this.onDocumentMouseUp.bind(this)));
                let i = this.chart.renderTo.parentElement;
                for(; i && "BODY" !== i.tagName;)this.eventsToUnbind.push(h(i, "scroll", ()=>{
                    delete this.chartPosition;
                })), i = i.parentElement;
                this.eventsToUnbind.push(h(t, "touchstart", this.onContainerTouchStart.bind(this), {
                    passive: !1
                }), h(t, "touchmove", this.onContainerTouchMove.bind(this), {
                    passive: !1
                })), S.unbindDocumentTouchEnd || (S.unbindDocumentTouchEnd = h(e, "touchend", this.onDocumentTouchEnd.bind(this), {
                    passive: !1
                })), this.setPointerCapture(), h(this.chart, "redraw", this.setPointerCapture.bind(this));
            }
            setPointerCapture() {
                if (!a) return;
                let t = this.pointerCaptureEventsToUnbind, e = this.chart, i = e.container, s = y(e.options.tooltip?.followTouchMove, !0) && e.series.some((t)=>t.options.findNearestPointBy.indexOf("y") > -1);
                !this.hasPointerCapture && s ? (t.push(h(i, "pointerdown", (t)=>{
                    t.target?.hasPointerCapture(t.pointerId) && t.target?.releasePointerCapture(t.pointerId);
                }), h(i, "pointermove", (t)=>{
                    e.pointer?.getPointFromEvent(t)?.onMouseOver(t);
                })), e.styledMode || d(i, {
                    "touch-action": "none"
                }), i.className += " highcharts-no-touch-action", this.hasPointerCapture = !0) : this.hasPointerCapture && !s && (t.forEach((t)=>t()), t.length = 0, e.styledMode || d(i, {
                    "touch-action": y(e.options.chart.style?.["touch-action"], "manipulation")
                }), i.className = i.className.replace(" highcharts-no-touch-action", ""), this.hasPointerCapture = !1);
            }
            setHoverChartIndex(t) {
                let i = this.chart, s = e.charts[y(S.hoverChartIndex, -1)];
                if (s && s !== i) {
                    let e = {
                        relatedTarget: i.container
                    };
                    t && !t?.relatedTarget && (t = {
                        ...e,
                        ...t
                    }), s.pointer?.onContainerMouseLeave(t || e);
                }
                s && s.mouseIsDown || (S.hoverChartIndex = i.index);
            }
            touch(t, e) {
                let i;
                let { chart: s, pinchDown: r = [] } = this;
                this.setHoverChartIndex(), 1 === (t = this.normalize(t)).touches.length ? s.isInsidePlot(t.chartX - s.plotLeft, t.chartY - s.plotTop, {
                    visiblePlotOnly: !0
                }) && !s.openMenu ? (e && this.runPointActions(t), "touchmove" === t.type && (i = !!r[0] && Math.pow(r[0].chartX - t.chartX, 2) + Math.pow(r[0].chartY - t.chartY, 2) >= 16), y(i, !0) && this.pinch(t)) : e && this.reset() : 2 === t.touches.length && this.pinch(t);
            }
            touchSelect(t) {
                return !!(this.chart.zooming.singleTouch && t.touches && 1 === t.touches.length);
            }
            zoomOption(t) {
                let e = this.chart, i = e.inverted, s = e.zooming.type || "", r, o;
                /touch/.test(t.type) && (s = y(e.zooming.pinchType, s)), this.zoomX = r = /x/.test(s), this.zoomY = o = /y/.test(s), this.zoomHor = r && !i || o && i, this.zoomVert = o && !i || r && i, this.hasZoom = r || o;
            }
        }
        return (s = S || (S = {})).compose = function(t) {
            b(n, "Core.Pointer") && h(t, "beforeRender", function() {
                this.pointer = new s(this, this.options);
            });
        }, S;
    }), i(e, "Core/Legend/LegendSymbol.js", [
        e["Core/Utilities.js"]
    ], function(t) {
        var e;
        let { extend: i, merge: s, pick: r } = t;
        return function(t) {
            function e(t, e, o) {
                let n = this.legendItem = this.legendItem || {}, { chart: a, options: h } = this, { baseline: l = 0, symbolWidth: d, symbolHeight: c } = t, p = this.symbol || "circle", u = c / 2, g = a.renderer, f = n.group, m = l - Math.round((t.fontMetrics?.b || c) * (o ? .4 : .3)), x = {}, y, b = h.marker, v = 0;
                if (a.styledMode || (x["stroke-width"] = Math.min(h.lineWidth || 0, 24), h.dashStyle ? x.dashstyle = h.dashStyle : "square" === h.linecap || (x["stroke-linecap"] = "round")), n.line = g.path().addClass("highcharts-graph").attr(x).add(f), o && (n.area = g.path().addClass("highcharts-area").add(f)), x["stroke-linecap"] && (v = Math.min(n.line.strokeWidth(), d) / 2), d) {
                    let t = [
                        [
                            "M",
                            v,
                            m
                        ],
                        [
                            "L",
                            d - v,
                            m
                        ]
                    ];
                    n.line.attr({
                        d: t
                    }), n.area?.attr({
                        d: [
                            ...t,
                            [
                                "L",
                                d - v,
                                l
                            ],
                            [
                                "L",
                                v,
                                l
                            ]
                        ]
                    });
                }
                if (b && !1 !== b.enabled && d) {
                    let t = Math.min(r(b.radius, u), u);
                    0 === p.indexOf("url") && (b = s(b, {
                        width: c,
                        height: c
                    }), t = 0), n.symbol = y = g.symbol(p, d / 2 - t, m - t, 2 * t, 2 * t, i({
                        context: "legend"
                    }, b)).addClass("highcharts-point").add(f), y.isMarker = !0;
                }
            }
            t.areaMarker = function(t, i) {
                e.call(this, t, i, !0);
            }, t.lineMarker = e, t.rectangle = function(t, e) {
                let i = e.legendItem || {}, s = t.options, o = t.symbolHeight, n = s.squareSymbol, a = n ? o : t.symbolWidth;
                i.symbol = this.chart.renderer.rect(n ? (t.symbolWidth - o) / 2 : 0, t.baseline - o + 1, a, o, r(t.options.symbolRadius, o / 2)).addClass("highcharts-point").attr({
                    zIndex: 3
                }).add(i.group);
            };
        }(e || (e = {})), e;
    }), i(e, "Core/Series/SeriesDefaults.js", [], function() {
        return {
            lineWidth: 2,
            allowPointSelect: !1,
            crisp: !0,
            showCheckbox: !1,
            animation: {
                duration: 1e3
            },
            enableMouseTracking: !0,
            events: {},
            marker: {
                enabledThreshold: 2,
                lineColor: "#ffffff",
                lineWidth: 0,
                radius: 4,
                states: {
                    normal: {
                        animation: !0
                    },
                    hover: {
                        animation: {
                            duration: 150
                        },
                        enabled: !0,
                        radiusPlus: 2,
                        lineWidthPlus: 1
                    },
                    select: {
                        fillColor: "#cccccc",
                        lineColor: "#000000",
                        lineWidth: 2
                    }
                }
            },
            point: {
                events: {}
            },
            dataLabels: {
                animation: {},
                align: "center",
                borderWidth: 0,
                defer: !0,
                formatter: function() {
                    let { numberFormatter: t } = this.series.chart;
                    return "number" != typeof this.y ? "" : t(this.y, -1);
                },
                padding: 5,
                style: {
                    fontSize: "0.7em",
                    fontWeight: "bold",
                    color: "contrast",
                    textOutline: "1px contrast"
                },
                verticalAlign: "bottom",
                x: 0,
                y: 0
            },
            cropThreshold: 300,
            opacity: 1,
            pointRange: 0,
            softThreshold: !0,
            states: {
                normal: {
                    animation: !0
                },
                hover: {
                    animation: {
                        duration: 150
                    },
                    lineWidthPlus: 1,
                    marker: {},
                    halo: {
                        size: 10,
                        opacity: .25
                    }
                },
                select: {
                    animation: {
                        duration: 0
                    }
                },
                inactive: {
                    animation: {
                        duration: 150
                    },
                    opacity: .2
                }
            },
            stickyTracking: !0,
            turboThreshold: 1e3,
            findNearestPointBy: "x"
        };
    }), i(e, "Core/Series/SeriesRegistry.js", [
        e["Core/Globals.js"],
        e["Core/Defaults.js"],
        e["Core/Series/Point.js"],
        e["Core/Utilities.js"]
    ], function(t, e, i, s) {
        var r;
        let { defaultOptions: o } = e, { extend: n, extendClass: a, merge: h } = s;
        return function(e) {
            function s(t, s) {
                let r = o.plotOptions || {}, n = s.defaultOptions, a = s.prototype;
                return a.type = t, a.pointClass || (a.pointClass = i), !e.seriesTypes[t] && (n && (r[t] = n), e.seriesTypes[t] = s, !0);
            }
            e.seriesTypes = t.seriesTypes, e.registerSeriesType = s, e.seriesType = function(t, r, l, d, c) {
                let p = o.plotOptions || {};
                if (r = r || "", p[t] = h(p[r], l), delete e.seriesTypes[t], s(t, a(e.seriesTypes[r] || function() {}, d)), e.seriesTypes[t].prototype.type = t, c) {
                    class s extends i {
                    }
                    n(s.prototype, c), e.seriesTypes[t].prototype.pointClass = s;
                }
                return e.seriesTypes[t];
            };
        }(r || (r = {})), r;
    }), i(e, "Core/Series/Series.js", [
        e["Core/Animation/AnimationUtilities.js"],
        e["Core/Defaults.js"],
        e["Core/Foundation.js"],
        e["Core/Globals.js"],
        e["Core/Legend/LegendSymbol.js"],
        e["Core/Series/Point.js"],
        e["Core/Series/SeriesDefaults.js"],
        e["Core/Series/SeriesRegistry.js"],
        e["Core/Renderer/SVG/SVGElement.js"],
        e["Core/Utilities.js"]
    ], function(t, e, i, s, r, o, n, a, h, l) {
        let { animObject: d, setAnimation: c } = t, { defaultOptions: p } = e, { registerEventOptions: u } = i, { svg: g, win: f } = s, { seriesTypes: m } = a, { arrayMax: x, arrayMin: y, clamp: b, correctFloat: v, crisp: S, defined: C, destroyObjectProperties: k, diffObjects: M, erase: w, error: T, extend: A, find: P, fireEvent: L, getClosestDistance: O, getNestedProperty: D, insertItem: E, isArray: I, isNumber: j, isString: B, merge: R, objectEach: z, pick: N, removeEvent: W, splat: G, syncTimeout: H } = l;
        class X {
            constructor(){
                this.zoneAxis = "y";
            }
            init(t, e) {
                let i;
                L(this, "init", {
                    options: e
                });
                let s = this, r = t.series;
                this.eventsToUnbind = [], s.chart = t, s.options = s.setOptions(e);
                let o = s.options, n = !1 !== o.visible;
                s.linkedSeries = [], s.bindAxes(), A(s, {
                    name: o.name,
                    state: "",
                    visible: n,
                    selected: !0 === o.selected
                }), u(this, o);
                let a = o.events;
                (a && a.click || o.point && o.point.events && o.point.events.click || o.allowPointSelect) && (t.runTrackerClick = !0), s.getColor(), s.getSymbol(), s.parallelArrays.forEach(function(t) {
                    s[t + "Data"] || (s[t + "Data"] = []);
                }), s.isCartesian && (t.hasCartesianSeries = !0), r.length && (i = r[r.length - 1]), s._i = N(i && i._i, -1) + 1, s.opacity = s.options.opacity, t.orderItems("series", E(this, r)), o.dataSorting && o.dataSorting.enabled ? s.setDataSortingOptions() : s.points || s.data || s.setData(o.data, !1), L(this, "afterInit");
            }
            is(t) {
                return m[t] && this instanceof m[t];
            }
            bindAxes() {
                let t;
                let e = this, i = e.options, s = e.chart;
                L(this, "bindAxes", null, function() {
                    (e.axisTypes || []).forEach(function(r) {
                        (s[r] || []).forEach(function(s) {
                            t = s.options, (N(i[r], 0) === s.index || void 0 !== i[r] && i[r] === t.id) && (E(e, s.series), e[r] = s, s.isDirty = !0);
                        }), e[r] || e.optionalAxis === r || T(18, !0, s);
                    });
                }), L(this, "afterBindAxes");
            }
            updateParallelArrays(t, e, i) {
                let s = t.series, r = j(e) ? function(i) {
                    let r = "y" === i && s.toYData ? s.toYData(t) : t[i];
                    s[i + "Data"][e] = r;
                } : function(t) {
                    Array.prototype[e].apply(s[t + "Data"], i);
                };
                s.parallelArrays.forEach(r);
            }
            hasData() {
                return this.visible && void 0 !== this.dataMax && void 0 !== this.dataMin || this.visible && this.yData && this.yData.length > 0;
            }
            hasMarkerChanged(t, e) {
                let i = t.marker, s = e.marker || {};
                return i && (s.enabled && !i.enabled || s.symbol !== i.symbol || s.height !== i.height || s.width !== i.width);
            }
            autoIncrement(t) {
                let e = this.options, i = e.pointIntervalUnit, s = e.relativeXValue, r = this.chart.time, o = this.xIncrement, n, a;
                return (o = N(o, e.pointStart, 0), this.pointInterval = a = N(this.pointInterval, e.pointInterval, 1), s && j(t) && (a *= t), i && (n = new r.Date(o), "day" === i ? r.set("Date", n, r.get("Date", n) + a) : "month" === i ? r.set("Month", n, r.get("Month", n) + a) : "year" === i && r.set("FullYear", n, r.get("FullYear", n) + a), a = n.getTime() - o), s && j(t)) ? o + a : (this.xIncrement = o + a, o);
            }
            setDataSortingOptions() {
                let t = this.options;
                A(this, {
                    requireSorting: !1,
                    sorted: !1,
                    enabledDataSorting: !0,
                    allowDG: !1
                }), C(t.pointRange) || (t.pointRange = 1);
            }
            setOptions(t) {
                let e;
                let i = this.chart, s = i.options.plotOptions, r = i.userOptions || {}, o = R(t), n = i.styledMode, a = {
                    plotOptions: s,
                    userOptions: o
                };
                L(this, "setOptions", a);
                let h = a.plotOptions[this.type], l = r.plotOptions || {}, d = l.series || {}, c = p.plotOptions[this.type] || {}, u = l[this.type] || {};
                this.userOptions = a.userOptions;
                let g = R(h, s.series, u, o);
                this.tooltipOptions = R(p.tooltip, p.plotOptions.series?.tooltip, c?.tooltip, i.userOptions.tooltip, l.series?.tooltip, u.tooltip, o.tooltip), this.stickyTracking = N(o.stickyTracking, u.stickyTracking, d.stickyTracking, !!this.tooltipOptions.shared && !this.noSharedTooltip || g.stickyTracking), null === h.marker && delete g.marker, this.zoneAxis = g.zoneAxis || "y";
                let f = this.zones = (g.zones || []).map((t)=>({
                        ...t
                    }));
                return (g.negativeColor || g.negativeFillColor) && !g.zones && (e = {
                    value: g[this.zoneAxis + "Threshold"] || g.threshold || 0,
                    className: "highcharts-negative"
                }, n || (e.color = g.negativeColor, e.fillColor = g.negativeFillColor), f.push(e)), f.length && C(f[f.length - 1].value) && f.push(n ? {} : {
                    color: this.color,
                    fillColor: this.fillColor
                }), L(this, "afterSetOptions", {
                    options: g
                }), g;
            }
            getName() {
                return N(this.options.name, "Series " + (this.index + 1));
            }
            getCyclic(t, e, i) {
                let s, r;
                let o = this.chart, n = `${t}Index`, a = `${t}Counter`, h = i?.length || o.options.chart.colorCount;
                !e && (C(r = N("color" === t ? this.options.colorIndex : void 0, this[n])) ? s = r : (o.series.length || (o[a] = 0), s = o[a] % h, o[a] += 1), i && (e = i[s])), void 0 !== s && (this[n] = s), this[t] = e;
            }
            getColor() {
                this.chart.styledMode ? this.getCyclic("color") : this.options.colorByPoint ? this.color = "#cccccc" : this.getCyclic("color", this.options.color || p.plotOptions[this.type].color, this.chart.options.colors);
            }
            getPointsCollection() {
                return (this.hasGroupedData ? this.points : this.data) || [];
            }
            getSymbol() {
                let t = this.options.marker;
                this.getCyclic("symbol", t.symbol, this.chart.options.symbols);
            }
            findPointIndex(t, e) {
                let i, s, r;
                let n = t.id, a = t.x, h = this.points, l = this.options.dataSorting;
                if (n) {
                    let t = this.chart.get(n);
                    t instanceof o && (i = t);
                } else if (this.linkedParent || this.enabledDataSorting || this.options.relativeXValue) {
                    let e = (e)=>!e.touched && e.index === t.index;
                    if (l && l.matchByName ? e = (e)=>!e.touched && e.name === t.name : this.options.relativeXValue && (e = (e)=>!e.touched && e.options.x === t.x), !(i = P(h, e))) return;
                }
                return i && void 0 !== (r = i && i.index) && (s = !0), void 0 === r && j(a) && (r = this.xData.indexOf(a, e)), -1 !== r && void 0 !== r && this.cropped && (r = r >= this.cropStart ? r - this.cropStart : r), !s && j(r) && h[r] && h[r].touched && (r = void 0), r;
            }
            updateData(t, e) {
                let i = this.options, s = i.dataSorting, r = this.points, o = [], n = this.requireSorting, a = t.length === r.length, h, l, d, c, p = !0;
                if (this.xIncrement = null, t.forEach(function(t, e) {
                    let l;
                    let d = C(t) && this.pointClass.prototype.optionsToObject.call({
                        series: this
                    }, t) || {}, p = d.x;
                    d.id || j(p) ? (-1 === (l = this.findPointIndex(d, c)) || void 0 === l ? o.push(t) : r[l] && t !== i.data[l] ? (r[l].update(t, !1, null, !1), r[l].touched = !0, n && (c = l + 1)) : r[l] && (r[l].touched = !0), (!a || e !== l || s && s.enabled || this.hasDerivedData) && (h = !0)) : o.push(t);
                }, this), h) for(l = r.length; l--;)(d = r[l]) && !d.touched && d.remove && d.remove(!1, e);
                else !a || s && s.enabled ? p = !1 : (t.forEach(function(t, e) {
                    t === r[e].y || r[e].destroyed || r[e].update(t, !1, null, !1);
                }), o.length = 0);
                return r.forEach(function(t) {
                    t && (t.touched = !1);
                }), !!p && (o.forEach(function(t) {
                    this.addPoint(t, !1, null, null, !1);
                }, this), null === this.xIncrement && this.xData && this.xData.length && (this.xIncrement = x(this.xData), this.autoIncrement()), !0);
            }
            setData(t, e = !0, i, s) {
                let r = this, o = r.points, n = o && o.length || 0, a = r.options, h = r.chart, l = a.dataSorting, d = r.xAxis, c = a.turboThreshold, p = this.xData, u = this.yData, g = r.pointArrayMap, f = g && g.length, m = a.keys, x, y, b, v = 0, S = 1, C;
                h.options.chart.allowMutatingData || (a.data && delete r.options.data, r.userOptions.data && delete r.userOptions.data, C = R(!0, t));
                let k = (t = C || t || []).length;
                if (l && l.enabled && (t = this.sortData(t)), h.options.chart.allowMutatingData && !1 !== s && k && n && !r.cropped && !r.hasGroupedData && r.visible && !r.boosted && (b = this.updateData(t, i)), !b) {
                    r.xIncrement = null, r.colorCounter = 0, this.parallelArrays.forEach(function(t) {
                        r[t + "Data"].length = 0;
                    });
                    let e = c && k > c;
                    if (e) {
                        let i = r.getFirstValidPoint(t), s = r.getFirstValidPoint(t, k - 1, -1), o = (t)=>!!(I(t) && (m || j(t[0])));
                        if (j(i) && j(s)) for(x = 0; x < k; x++)p[x] = this.autoIncrement(), u[x] = t[x];
                        else if (o(i) && o(s)) {
                            if (f) {
                                if (i.length === f) for(x = 0; x < k; x++)p[x] = this.autoIncrement(), u[x] = t[x];
                                else for(x = 0; x < k; x++)y = t[x], p[x] = y[0], u[x] = y.slice(1, f + 1);
                            } else if (m && (v = m.indexOf("x"), S = m.indexOf("y"), v = v >= 0 ? v : 0, S = S >= 0 ? S : 1), 1 === i.length && (S = 0), v === S) for(x = 0; x < k; x++)p[x] = this.autoIncrement(), u[x] = t[x][S];
                            else for(x = 0; x < k; x++)y = t[x], p[x] = y[v], u[x] = y[S];
                        } else e = !1;
                    }
                    if (!e) for(x = 0; x < k; x++)y = {
                        series: r
                    }, r.pointClass.prototype.applyOptions.apply(y, [
                        t[x]
                    ]), r.updateParallelArrays(y, x);
                    for(u && B(u[0]) && T(14, !0, h), r.data = [], r.options.data = r.userOptions.data = t, x = n; x--;)o[x]?.destroy();
                    d && (d.minRange = d.userMinRange), r.isDirty = h.isDirtyBox = !0, r.isDirtyData = !!o, i = !1;
                }
                "point" === a.legendType && (this.processData(), this.generatePoints()), e && h.redraw(i);
            }
            sortData(t) {
                let e = this, i = e.options.dataSorting.sortKey || "y", s = function(t, e) {
                    return C(e) && t.pointClass.prototype.optionsToObject.call({
                        series: t
                    }, e) || {};
                };
                return t.forEach(function(i, r) {
                    t[r] = s(e, i), t[r].index = r;
                }, this), t.concat().sort((t, e)=>{
                    let s = D(i, t), r = D(i, e);
                    return r < s ? -1 : r > s ? 1 : 0;
                }).forEach(function(t, e) {
                    t.x = e;
                }, this), e.linkedSeries && e.linkedSeries.forEach(function(e) {
                    let i = e.options, r = i.data;
                    i.dataSorting && i.dataSorting.enabled || !r || (r.forEach(function(i, o) {
                        r[o] = s(e, i), t[o] && (r[o].x = t[o].x, r[o].index = o);
                    }), e.setData(r, !1));
                }), t;
            }
            getProcessedData(t) {
                let e = this, i = e.xAxis, s = e.options.cropThreshold, r = i?.logarithmic, o = e.isCartesian, n, a, h = 0, l, d, c, p = e.xData, u = e.yData, g = !1, f = p.length;
                i && (d = (l = i.getExtremes()).min, c = l.max, g = !!(i.categories && !i.names.length)), o && e.sorted && !t && (!s || f > s || e.forceCrop) && (p[f - 1] < d || p[0] > c ? (p = [], u = []) : e.yData && (p[0] < d || p[f - 1] > c) && (p = (n = this.cropData(e.xData, e.yData, d, c)).xData, u = n.yData, h = n.start, a = !0));
                let m = O([
                    r ? p.map(r.log2lin) : p
                ], ()=>e.requireSorting && !g && T(15, !1, e.chart));
                return {
                    xData: p,
                    yData: u,
                    cropped: a,
                    cropStart: h,
                    closestPointRange: m
                };
            }
            processData(t) {
                let e = this.xAxis;
                if (this.isCartesian && !this.isDirty && !e.isDirty && !this.yAxis.isDirty && !t) return !1;
                let i = this.getProcessedData();
                this.cropped = i.cropped, this.cropStart = i.cropStart, this.processedXData = i.xData, this.processedYData = i.yData, this.closestPointRange = this.basePointRange = i.closestPointRange, L(this, "afterProcessData");
            }
            cropData(t, e, i, s) {
                let r = t.length, o, n, a = 0, h = r;
                for(o = 0; o < r; o++)if (t[o] >= i) {
                    a = Math.max(0, o - 1);
                    break;
                }
                for(n = o; n < r; n++)if (t[n] > s) {
                    h = n + 1;
                    break;
                }
                return {
                    xData: t.slice(a, h),
                    yData: e.slice(a, h),
                    start: a,
                    end: h
                };
            }
            generatePoints() {
                let t = this.options, e = this.processedData || t.data, i = this.processedXData, s = this.processedYData, r = this.pointClass, o = i.length, n = this.cropStart || 0, a = this.hasGroupedData, h = t.keys, l = [], d = t.dataGrouping && t.dataGrouping.groupAll ? n : 0, c, p, u, g, f = this.data;
                if (!f && !a) {
                    let t = [];
                    t.length = e.length, f = this.data = t;
                }
                for(h && a && (this.options.keys = !1), g = 0; g < o; g++)p = n + g, a ? ((u = new r(this, [
                    i[g]
                ].concat(G(s[g])))).dataGroup = this.groupMap[d + g], u.dataGroup.options && (u.options = u.dataGroup.options, A(u, u.dataGroup.options), delete u.dataLabels)) : (u = f[p]) || void 0 === e[p] || (f[p] = u = new r(this, e[p], i[g])), u && (u.index = a ? d + g : p, l[g] = u);
                if (this.options.keys = h, f && (o !== (c = f.length) || a)) for(g = 0; g < c; g++)g !== n || a || (g += o), f[g] && (f[g].destroyElements(), f[g].plotX = void 0);
                this.data = f, this.points = l, L(this, "afterGeneratePoints");
            }
            getXExtremes(t) {
                return {
                    min: y(t),
                    max: x(t)
                };
            }
            getExtremes(t, e) {
                let i = this.xAxis, s = this.yAxis, r = [], o = this.requireSorting && !this.is("column") ? 1 : 0, n = !!s && s.positiveValuesOnly, a = e || this.getExtremesFromAll || this.options.getExtremesFromAll, { processedXData: h, processedYData: l } = this, d, c, p, u, g, f, m, b = 0, v = 0, S = 0;
                if (this.cropped && a) {
                    let t = this.getProcessedData(!0);
                    h = t.xData, l = t.yData;
                }
                let C = (t = t || this.stackedYData || l || []).length, k = h || this.xData;
                for(i && (b = (d = i.getExtremes()).min, v = d.max), f = 0; f < C; f++)if (u = k[f], c = (j(g = t[f]) || I(g)) && ((j(g) ? g > 0 : g.length) || !n), p = e || this.getExtremesFromAll || this.options.getExtremesFromAll || this.cropped || !i || (k[f + o] || u) >= b && (k[f - o] || u) <= v, c && p) {
                    if (m = g.length) for(; m--;)j(g[m]) && (r[S++] = g[m]);
                    else r[S++] = g;
                }
                let M = {
                    activeYData: r,
                    dataMin: y(r),
                    dataMax: x(r)
                };
                return L(this, "afterGetExtremes", {
                    dataExtremes: M
                }), M;
            }
            applyExtremes() {
                let t = this.getExtremes();
                return this.dataMin = t.dataMin, this.dataMax = t.dataMax, t;
            }
            getFirstValidPoint(t, e = 0, i = 1) {
                let s = t.length, r = e;
                for(; r >= 0 && r < s;){
                    if (C(t[r])) return t[r];
                    r += i;
                }
            }
            translate() {
                this.processedXData || this.processData(), this.generatePoints();
                let t = this.options, e = t.stacking, i = this.xAxis, s = i.categories, r = this.enabledDataSorting, o = this.yAxis, n = this.points, a = n.length, h = this.pointPlacementToXValue(), l = !!h, d = t.threshold, c = t.startFromThreshold ? d : 0, p, u, g, f, m = Number.MAX_VALUE;
                function x(t) {
                    return b(t, -1000000000, 1e9);
                }
                for(p = 0; p < a; p++){
                    let t;
                    let a = n[p], y = a.x, b, S, k = a.y, M = a.low, w = e && o.stacking?.stacks[(this.negStacks && k < (c ? 0 : d) ? "-" : "") + this.stackKey];
                    u = i.translate(y, !1, !1, !1, !0, h), a.plotX = j(u) ? v(x(u)) : void 0, e && this.visible && w && w[y] && (f = this.getStackIndicator(f, y, this.index), !a.isNull && f.key && (S = (b = w[y]).points[f.key]), b && I(S) && (M = S[0], k = S[1], M === c && f.key === w[y].base && (M = N(j(d) ? d : o.min)), o.positiveValuesOnly && C(M) && M <= 0 && (M = void 0), a.total = a.stackTotal = N(b.total), a.percentage = C(a.y) && b.total ? a.y / b.total * 100 : void 0, a.stackY = k, this.irregularWidths || b.setOffset(this.pointXOffset || 0, this.barW || 0, void 0, void 0, void 0, this.xAxis))), a.yBottom = C(M) ? x(o.translate(M, !1, !0, !1, !0)) : void 0, this.dataModify && (k = this.dataModify.modifyValue(k, p)), j(k) && void 0 !== a.plotX && (t = j(t = o.translate(k, !1, !0, !1, !0)) ? x(t) : void 0), a.plotY = t, a.isInside = this.isPointInside(a), a.clientX = l ? v(i.translate(y, !1, !1, !1, !0, h)) : u, a.negative = (a.y || 0) < (d || 0), a.category = N(s && s[a.x], a.x), a.isNull || !1 === a.visible || (void 0 !== g && (m = Math.min(m, Math.abs(u - g))), g = u), a.zone = this.zones.length ? a.getZone() : void 0, !a.graphic && this.group && r && (a.isNew = !0);
                }
                this.closestPointRangePx = m, L(this, "afterTranslate");
            }
            getValidPoints(t, e, i) {
                let s = this.chart;
                return (t || this.points || []).filter(function(t) {
                    let { plotX: r, plotY: o } = t;
                    return !!((i || !t.isNull && j(o)) && (!e || s.isInsidePlot(r, o, {
                        inverted: s.inverted
                    }))) && !1 !== t.visible;
                });
            }
            getClipBox() {
                let { chart: t, xAxis: e, yAxis: i } = this, { x: s, y: r, width: o, height: n } = R(t.clipBox);
                return e && e.len !== t.plotSizeX && (o = e.len), i && i.len !== t.plotSizeY && (n = i.len), t.inverted && !this.invertible && ([o, n] = [
                    n,
                    o
                ]), {
                    x: s,
                    y: r,
                    width: o,
                    height: n
                };
            }
            getSharedClipKey() {
                return this.sharedClipKey = (this.options.xAxis || 0) + "," + (this.options.yAxis || 0), this.sharedClipKey;
            }
            setClip() {
                let { chart: t, group: e, markerGroup: i } = this, s = t.sharedClips, r = t.renderer, o = this.getClipBox(), n = this.getSharedClipKey(), a = s[n];
                a ? a.animate(o) : s[n] = a = r.clipRect(o), e && e.clip(!1 === this.options.clip ? void 0 : a), i && i.clip();
            }
            animate(t) {
                let { chart: e, group: i, markerGroup: s } = this, r = e.inverted, o = d(this.options.animation), n = [
                    this.getSharedClipKey(),
                    o.duration,
                    o.easing,
                    o.defer
                ].join(","), a = e.sharedClips[n], h = e.sharedClips[n + "m"];
                if (t && i) {
                    let t = this.getClipBox();
                    if (a) a.attr("height", t.height);
                    else {
                        t.width = 0, r && (t.x = e.plotHeight), a = e.renderer.clipRect(t), e.sharedClips[n] = a;
                        let i = {
                            x: -99,
                            y: -99,
                            width: r ? e.plotWidth + 199 : 99,
                            height: r ? 99 : e.plotHeight + 199
                        };
                        h = e.renderer.clipRect(i), e.sharedClips[n + "m"] = h;
                    }
                    i.clip(a), s?.clip(h);
                } else if (a && !a.hasClass("highcharts-animating")) {
                    let t = this.getClipBox(), i = o.step;
                    (s?.element.childNodes.length || e.series.length > 1) && (o.step = function(t, e) {
                        i && i.apply(e, arguments), "width" === e.prop && h?.element && h.attr(r ? "height" : "width", t + 99);
                    }), a.addClass("highcharts-animating").animate(t, o);
                }
            }
            afterAnimate() {
                this.setClip(), z(this.chart.sharedClips, (t, e, i)=>{
                    t && !this.chart.container.querySelector(`[clip-path="url(#${t.id})"]`) && (t.destroy(), delete i[e]);
                }), this.finishedAnimating = !0, L(this, "afterAnimate");
            }
            drawPoints(t = this.points) {
                let e, i, s, r, o, n, a;
                let h = this.chart, l = h.styledMode, { colorAxis: d, options: c } = this, p = c.marker, u = this[this.specialGroup || "markerGroup"], g = this.xAxis, f = N(p.enabled, !g || !!g.isRadial || null, this.closestPointRangePx >= p.enabledThreshold * p.radius);
                if (!1 !== p.enabled || this._hasPointMarkers) for(e = 0; e < t.length; e++)if (r = (s = (i = t[e]).graphic) ? "animate" : "attr", o = i.marker || {}, n = !!i.marker, (f && void 0 === o.enabled || o.enabled) && !i.isNull && !1 !== i.visible) {
                    let t = N(o.symbol, this.symbol, "rect");
                    a = this.markerAttribs(i, i.selected && "select"), this.enabledDataSorting && (i.startXPos = g.reversed ? -(a.width || 0) : g.width);
                    let e = !1 !== i.isInside;
                    if (!s && e && ((a.width || 0) > 0 || i.hasImage) && (i.graphic = s = h.renderer.symbol(t, a.x, a.y, a.width, a.height, n ? o : p).add(u), this.enabledDataSorting && h.hasRendered && (s.attr({
                        x: i.startXPos
                    }), r = "animate")), s && "animate" === r && s[e ? "show" : "hide"](e).animate(a), s) {
                        let t = this.pointAttribs(i, l || !i.selected ? void 0 : "select");
                        l ? d && s.css({
                            fill: t.fill
                        }) : s[r](t);
                    }
                    s && s.addClass(i.getClassName(), !0);
                } else s && (i.graphic = s.destroy());
            }
            markerAttribs(t, e) {
                let i = this.options, s = i.marker, r = t.marker || {}, o = r.symbol || s.symbol, n = {}, a, h, l = N(r.radius, s && s.radius);
                e && (a = s.states[e], l = N((h = r.states && r.states[e]) && h.radius, a && a.radius, l && l + (a && a.radiusPlus || 0))), t.hasImage = o && 0 === o.indexOf("url"), t.hasImage && (l = 0);
                let d = t.pos();
                return j(l) && d && (i.crisp && (d[0] = S(d[0], t.hasImage ? 0 : "rect" === o ? s?.lineWidth || 0 : 1)), n.x = d[0] - l, n.y = d[1] - l), l && (n.width = n.height = 2 * l), n;
            }
            pointAttribs(t, e) {
                let i = this.options.marker, s = t && t.options, r = s && s.marker || {}, o = s && s.color, n = t && t.color, a = t && t.zone && t.zone.color, h, l, d = this.color, c, p, u = N(r.lineWidth, i.lineWidth), g = 1;
                return d = o || a || n || d, c = r.fillColor || i.fillColor || d, p = r.lineColor || i.lineColor || d, e = e || "normal", h = i.states[e] || {}, u = N((l = r.states && r.states[e] || {}).lineWidth, h.lineWidth, u + N(l.lineWidthPlus, h.lineWidthPlus, 0)), c = l.fillColor || h.fillColor || c, {
                    stroke: p = l.lineColor || h.lineColor || p,
                    "stroke-width": u,
                    fill: c,
                    opacity: g = N(l.opacity, h.opacity, g)
                };
            }
            destroy(t) {
                let e, i, s;
                let r = this, o = r.chart, n = /AppleWebKit\/533/.test(f.navigator.userAgent), a = r.data || [];
                for(L(r, "destroy", {
                    keepEventsForUpdate: t
                }), this.removeEvents(t), (r.axisTypes || []).forEach(function(t) {
                    (s = r[t]) && s.series && (w(s.series, r), s.isDirty = s.forceRedraw = !0);
                }), r.legendItem && r.chart.legend.destroyItem(r), e = a.length; e--;)(i = a[e]) && i.destroy && i.destroy();
                for (let t of r.zones)k(t, void 0, !0);
                l.clearTimeout(r.animationTimeout), z(r, function(t, e) {
                    t instanceof h && !t.survive && t[n && "group" === e ? "hide" : "destroy"]();
                }), o.hoverSeries === r && (o.hoverSeries = void 0), w(o.series, r), o.orderItems("series"), z(r, function(e, i) {
                    t && "hcEvents" === i || delete r[i];
                });
            }
            applyZones() {
                let { area: t, chart: e, graph: i, zones: s, points: r, xAxis: o, yAxis: n, zoneAxis: a } = this, { inverted: h, renderer: l } = e, d = this[`${a}Axis`], { isXAxis: c, len: p = 0 } = d || {}, u = (i?.strokeWidth() || 0) / 2 + 1, g = (t, e = 0, i = 0)=>{
                    h && (i = p - i);
                    let { translated: s = 0, lineClip: r } = t, o = i - s;
                    r?.push([
                        "L",
                        e,
                        Math.abs(o) < u ? i - u * (o <= 0 ? -1 : 1) : s
                    ]);
                };
                if (s.length && (i || t) && d && j(d.min)) {
                    let e = d.getExtremes().max, u = (t)=>{
                        t.forEach((e, i)=>{
                            ("M" === e[0] || "L" === e[0]) && (t[i] = [
                                e[0],
                                c ? p - e[1] : e[1],
                                c ? e[2] : p - e[2]
                            ]);
                        });
                    };
                    if (s.forEach((t)=>{
                        t.lineClip = [], t.translated = b(d.toPixels(N(t.value, e), !0) || 0, 0, p);
                    }), i && !this.showLine && i.hide(), t && t.hide(), "y" === a && r.length < o.len) for (let t of r){
                        let { plotX: e, plotY: i, zone: r } = t, o = r && s[s.indexOf(r) - 1];
                        r && g(r, e, i), o && g(o, e, i);
                    }
                    let f = [], m = d.toPixels(d.getExtremes().min, !0);
                    s.forEach((e)=>{
                        let s = e.lineClip || [], r = Math.round(e.translated || 0);
                        o.reversed && s.reverse();
                        let { clip: a, simpleClip: d } = e, p = 0, g = 0, x = o.len, y = n.len;
                        c ? (p = r, x = m) : (g = r, y = m);
                        let b = [
                            [
                                "M",
                                p,
                                g
                            ],
                            [
                                "L",
                                x,
                                g
                            ],
                            [
                                "L",
                                x,
                                y
                            ],
                            [
                                "L",
                                p,
                                y
                            ],
                            [
                                "Z"
                            ]
                        ], v = [
                            b[0],
                            ...s,
                            b[1],
                            b[2],
                            ...f,
                            b[3],
                            b[4]
                        ];
                        f = s.reverse(), m = r, h && (u(v), t && u(b)), a ? (a.animate({
                            d: v
                        }), d?.animate({
                            d: b
                        })) : (a = e.clip = l.path(v), t && (d = e.simpleClip = l.path(b))), i && e.graph?.clip(a), t && e.area?.clip(d);
                    });
                } else this.visible && (i && i.show(), t && t.show());
            }
            plotGroup(t, e, i, s, r) {
                let o = this[t], n = !o, a = {
                    visibility: i,
                    zIndex: s || .1
                };
                return C(this.opacity) && !this.chart.styledMode && "inactive" !== this.state && (a.opacity = this.opacity), o || (this[t] = o = this.chart.renderer.g().add(r)), o.addClass("highcharts-" + e + " highcharts-series-" + this.index + " highcharts-" + this.type + "-series " + (C(this.colorIndex) ? "highcharts-color-" + this.colorIndex + " " : "") + (this.options.className || "") + (o.hasClass("highcharts-tracker") ? " highcharts-tracker" : ""), !0), o.attr(a)[n ? "attr" : "animate"](this.getPlotBox(e)), o;
            }
            getPlotBox(t) {
                let e = this.xAxis, i = this.yAxis, s = this.chart, r = s.inverted && !s.polar && e && this.invertible && "series" === t;
                return s.inverted && (e = i, i = this.xAxis), {
                    translateX: e ? e.left : s.plotLeft,
                    translateY: i ? i.top : s.plotTop,
                    rotation: r ? 90 : 0,
                    rotationOriginX: r ? (e.len - i.len) / 2 : 0,
                    rotationOriginY: r ? (e.len + i.len) / 2 : 0,
                    scaleX: r ? -1 : 1,
                    scaleY: 1
                };
            }
            removeEvents(t) {
                let { eventsToUnbind: e } = this;
                t || W(this), e.length && (e.forEach((t)=>{
                    t();
                }), e.length = 0);
            }
            render() {
                let t = this, { chart: e, options: i, hasRendered: s } = t, r = d(i.animation), o = t.visible ? "inherit" : "hidden", n = i.zIndex, a = e.seriesGroup, h = t.finishedAnimating ? 0 : r.duration;
                L(this, "render"), t.plotGroup("group", "series", o, n, a), t.markerGroup = t.plotGroup("markerGroup", "markers", o, n, a), !1 !== i.clip && t.setClip(), h && t.animate?.(!0), t.drawGraph && (t.drawGraph(), t.applyZones()), t.visible && t.drawPoints(), t.drawDataLabels?.(), t.redrawPoints?.(), i.enableMouseTracking && t.drawTracker?.(), h && t.animate?.(), s || (h && r.defer && (h += r.defer), t.animationTimeout = H(()=>{
                    t.afterAnimate();
                }, h || 0)), t.isDirty = !1, t.hasRendered = !0, L(t, "afterRender");
            }
            redraw() {
                let t = this.isDirty || this.isDirtyData;
                this.translate(), this.render(), t && delete this.kdTree;
            }
            reserveSpace() {
                return this.visible || !this.chart.options.chart.ignoreHiddenSeries;
            }
            searchPoint(t, e) {
                let { xAxis: i, yAxis: s } = this, r = this.chart.inverted;
                return this.searchKDTree({
                    clientX: r ? i.len - t.chartY + i.pos : t.chartX - i.pos,
                    plotY: r ? s.len - t.chartX + s.pos : t.chartY - s.pos
                }, e, t);
            }
            buildKDTree(t) {
                this.buildingKdTree = !0;
                let e = this, i = e.options.findNearestPointBy.indexOf("y") > -1 ? 2 : 1;
                delete e.kdTree, H(function() {
                    e.kdTree = function t(i, s, r) {
                        let o, n;
                        let a = i?.length;
                        if (a) return o = e.kdAxisArray[s % r], i.sort((t, e)=>(t[o] || 0) - (e[o] || 0)), {
                            point: i[n = Math.floor(a / 2)],
                            left: t(i.slice(0, n), s + 1, r),
                            right: t(i.slice(n + 1), s + 1, r)
                        };
                    }(e.getValidPoints(void 0, !e.directTouch), i, i), e.buildingKdTree = !1;
                }, e.options.kdNow || t?.type === "touchstart" ? 0 : 1);
            }
            searchKDTree(t, e, i) {
                let s = this, [r, o] = this.kdAxisArray, n = e ? "distX" : "dist", a = (s.options.findNearestPointBy || "").indexOf("y") > -1 ? 2 : 1, h = !!s.isBubble;
                if (this.kdTree || this.buildingKdTree || this.buildKDTree(i), this.kdTree) return function t(e, i, a, l) {
                    let d = i.point, c = s.kdAxisArray[a % l], p, u, g = d;
                    !function(t, e) {
                        let i = t[r], s = e[r], n = C(i) && C(s) ? i - s : null, a = t[o], l = e[o], d = C(a) && C(l) ? a - l : 0, c = h && e.marker?.radius || 0;
                        e.dist = Math.sqrt((n && n * n || 0) + d * d) - c, e.distX = C(n) ? Math.abs(n) - c : Number.MAX_VALUE;
                    }(e, d);
                    let f = (e[c] || 0) - (d[c] || 0) + (h && d.marker?.radius || 0), m = f < 0 ? "left" : "right", x = f < 0 ? "right" : "left";
                    return i[m] && (g = (p = t(e, i[m], a + 1, l))[n] < g[n] ? p : d), i[x] && Math.sqrt(f * f) < g[n] && (g = (u = t(e, i[x], a + 1, l))[n] < g[n] ? u : g), g;
                }(t, this.kdTree, a, a);
            }
            pointPlacementToXValue() {
                let { options: t, xAxis: e } = this, i = t.pointPlacement;
                return "between" === i && (i = e.reversed ? -0.5 : .5), j(i) ? i * (t.pointRange || e.pointRange) : 0;
            }
            isPointInside(t) {
                let { chart: e, xAxis: i, yAxis: s } = this, { plotX: r = -1, plotY: o = -1 } = t;
                return o >= 0 && o <= (s ? s.len : e.plotHeight) && r >= 0 && r <= (i ? i.len : e.plotWidth);
            }
            drawTracker() {
                let t = this, e = t.options, i = e.trackByArea, s = [].concat((i ? t.areaPath : t.graphPath) || []), r = t.chart, o = r.pointer, n = r.renderer, a = r.options.tooltip?.snap || 0, h = ()=>{
                    e.enableMouseTracking && r.hoverSeries !== t && t.onMouseOver();
                }, l = "rgba(192,192,192," + (g ? 1e-4 : .002) + ")", d = t.tracker;
                d ? d.attr({
                    d: s
                }) : t.graph && (t.tracker = d = n.path(s).attr({
                    visibility: t.visible ? "inherit" : "hidden",
                    zIndex: 2
                }).addClass(i ? "highcharts-tracker-area" : "highcharts-tracker-line").add(t.group), r.styledMode || d.attr({
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    stroke: l,
                    fill: i ? l : "none",
                    "stroke-width": t.graph.strokeWidth() + (i ? 0 : 2 * a)
                }), [
                    t.tracker,
                    t.markerGroup,
                    t.dataLabelsGroup
                ].forEach((t)=>{
                    t && (t.addClass("highcharts-tracker").on("mouseover", h).on("mouseout", (t)=>{
                        o?.onTrackerMouseOut(t);
                    }), e.cursor && !r.styledMode && t.css({
                        cursor: e.cursor
                    }), t.on("touchstart", h));
                })), L(this, "afterDrawTracker");
            }
            addPoint(t, e, i, s, r) {
                let o, n;
                let a = this.options, h = this.data, l = this.chart, d = this.xAxis, c = d && d.hasNames && d.names, p = a.data, u = this.xData;
                e = N(e, !0);
                let g = {
                    series: this
                };
                this.pointClass.prototype.applyOptions.apply(g, [
                    t
                ]);
                let f = g.x;
                if (n = u.length, this.requireSorting && f < u[n - 1]) for(o = !0; n && u[n - 1] > f;)n--;
                this.updateParallelArrays(g, "splice", [
                    n,
                    0,
                    0
                ]), this.updateParallelArrays(g, n), c && g.name && (c[f] = g.name), p.splice(n, 0, t), (o || this.processedData) && (this.data.splice(n, 0, null), this.processData()), "point" === a.legendType && this.generatePoints(), i && (h[0] && h[0].remove ? h[0].remove(!1) : (h.shift(), this.updateParallelArrays(g, "shift"), p.shift())), !1 !== r && L(this, "addPoint", {
                    point: g
                }), this.isDirty = !0, this.isDirtyData = !0, e && l.redraw(s);
            }
            removePoint(t, e, i) {
                let s = this, r = s.data, o = r[t], n = s.points, a = s.chart, h = function() {
                    n && n.length === r.length && n.splice(t, 1), r.splice(t, 1), s.options.data.splice(t, 1), s.updateParallelArrays(o || {
                        series: s
                    }, "splice", [
                        t,
                        1
                    ]), o && o.destroy(), s.isDirty = !0, s.isDirtyData = !0, e && a.redraw();
                };
                c(i, a), e = N(e, !0), o ? o.firePointEvent("remove", null, h) : h();
            }
            remove(t, e, i, s) {
                let r = this, o = r.chart;
                function n() {
                    r.destroy(s), o.isDirtyLegend = o.isDirtyBox = !0, o.linkSeries(s), N(t, !0) && o.redraw(e);
                }
                !1 !== i ? L(r, "remove", null, n) : n();
            }
            update(t, e) {
                L(this, "update", {
                    options: t = M(t, this.userOptions)
                });
                let i = this, s = i.chart, r = i.userOptions, o = i.initialType || i.type, n = s.options.plotOptions, a = m[o].prototype, h = i.finishedAnimating && {
                    animation: !1
                }, l = {}, d, c, p = [
                    "colorIndex",
                    "eventOptions",
                    "navigatorSeries",
                    "symbolIndex",
                    "baseSeries"
                ], u = t.type || r.type || s.options.chart.type, g = !(this.hasDerivedData || u && u !== this.type || void 0 !== t.pointStart || void 0 !== t.pointInterval || void 0 !== t.relativeXValue || t.joinBy || t.mapData || [
                    "dataGrouping",
                    "pointStart",
                    "pointInterval",
                    "pointIntervalUnit",
                    "keys"
                ].some((t)=>i.hasOptionChanged(t)));
                u = u || o, g && (p.push("data", "isDirtyData", "isDirtyCanvas", "points", "processedData", "processedXData", "processedYData", "xIncrement", "cropped", "_hasPointMarkers", "hasDataLabels", "nodes", "layout", "level", "mapMap", "mapData", "minY", "maxY", "minX", "maxX", "transformGroups"), !1 !== t.visible && p.push("area", "graph"), i.parallelArrays.forEach(function(t) {
                    p.push(t + "Data");
                }), t.data && (t.dataSorting && A(i.options.dataSorting, t.dataSorting), this.setData(t.data, !1))), t = R(r, {
                    index: void 0 === r.index ? i.index : r.index,
                    pointStart: n?.series?.pointStart ?? r.pointStart ?? i.xData?.[0]
                }, !g && {
                    data: i.options.data
                }, t, h), g && t.data && (t.data = i.options.data), (p = [
                    "group",
                    "markerGroup",
                    "dataLabelsGroup",
                    "transformGroup"
                ].concat(p)).forEach(function(t) {
                    p[t] = i[t], delete i[t];
                });
                let f = !1;
                if (m[u]) {
                    if (f = u !== i.type, i.remove(!1, !1, !1, !0), f) {
                        if (s.propFromSeries(), Object.setPrototypeOf) Object.setPrototypeOf(i, m[u].prototype);
                        else {
                            let t = Object.hasOwnProperty.call(i, "hcEvents") && i.hcEvents;
                            for(c in a)i[c] = void 0;
                            A(i, m[u].prototype), t ? i.hcEvents = t : delete i.hcEvents;
                        }
                    }
                } else T(17, !0, s, {
                    missingModuleFor: u
                });
                if (p.forEach(function(t) {
                    i[t] = p[t];
                }), i.init(s, t), g && this.points) for (let t of (!1 === (d = i.options).visible ? (l.graphic = 1, l.dataLabel = 1) : (this.hasMarkerChanged(d, r) && (l.graphic = 1), i.hasDataLabels?.() || (l.dataLabel = 1)), this.points))t && t.series && (t.resolveColor(), Object.keys(l).length && t.destroyElements(l), !1 === d.showInLegend && t.legendItem && s.legend.destroyItem(t));
                i.initialType = o, s.linkSeries(), s.setSortedData(), f && i.linkedSeries.length && (i.isDirtyData = !0), L(this, "afterUpdate"), N(e, !0) && s.redraw(!!g && void 0);
            }
            setName(t) {
                this.name = this.options.name = this.userOptions.name = t, this.chart.isDirtyLegend = !0;
            }
            hasOptionChanged(t) {
                let e = this.chart, i = this.options[t], s = e.options.plotOptions, r = this.userOptions[t], o = N(s?.[this.type]?.[t], s?.series?.[t]);
                return r && !C(o) ? i !== r : i !== N(o, i);
            }
            onMouseOver() {
                let t = this.chart, e = t.hoverSeries, i = t.pointer;
                i?.setHoverChartIndex(), e && e !== this && e.onMouseOut(), this.options.events.mouseOver && L(this, "mouseOver"), this.setState("hover"), t.hoverSeries = this;
            }
            onMouseOut() {
                let t = this.options, e = this.chart, i = e.tooltip, s = e.hoverPoint;
                e.hoverSeries = null, s && s.onMouseOut(), this && t.events.mouseOut && L(this, "mouseOut"), i && !this.stickyTracking && (!i.shared || this.noSharedTooltip) && i.hide(), e.series.forEach(function(t) {
                    t.setState("", !0);
                });
            }
            setState(t, e) {
                let i = this, s = i.options, r = i.graph, o = s.inactiveOtherPoints, n = s.states, a = N(n[t || "normal"] && n[t || "normal"].animation, i.chart.options.chart.animation), h = s.lineWidth, l = s.opacity;
                if (t = t || "", i.state !== t && ([
                    i.group,
                    i.markerGroup,
                    i.dataLabelsGroup
                ].forEach(function(e) {
                    e && (i.state && e.removeClass("highcharts-series-" + i.state), t && e.addClass("highcharts-series-" + t));
                }), i.state = t, !i.chart.styledMode)) {
                    if (n[t] && !1 === n[t].enabled) return;
                    if (t && (h = n[t].lineWidth || h + (n[t].lineWidthPlus || 0), l = N(n[t].opacity, l)), r && !r.dashstyle && j(h)) for (let t of [
                        r,
                        ...this.zones.map((t)=>t.graph)
                    ])t?.animate({
                        "stroke-width": h
                    }, a);
                    o || [
                        i.group,
                        i.markerGroup,
                        i.dataLabelsGroup,
                        i.labelBySeries
                    ].forEach(function(t) {
                        t && t.animate({
                            opacity: l
                        }, a);
                    });
                }
                e && o && i.points && i.setAllPointsToState(t || void 0);
            }
            setAllPointsToState(t) {
                this.points.forEach(function(e) {
                    e.setState && e.setState(t);
                });
            }
            setVisible(t, e) {
                let i = this, s = i.chart, r = s.options.chart.ignoreHiddenSeries, o = i.visible;
                i.visible = t = i.options.visible = i.userOptions.visible = void 0 === t ? !o : t;
                let n = t ? "show" : "hide";
                [
                    "group",
                    "dataLabelsGroup",
                    "markerGroup",
                    "tracker",
                    "tt"
                ].forEach((t)=>{
                    i[t]?.[n]();
                }), (s.hoverSeries === i || s.hoverPoint?.series === i) && i.onMouseOut(), i.legendItem && s.legend.colorizeItem(i, t), i.isDirty = !0, i.options.stacking && s.series.forEach((t)=>{
                    t.options.stacking && t.visible && (t.isDirty = !0);
                }), i.linkedSeries.forEach((e)=>{
                    e.setVisible(t, !1);
                }), r && (s.isDirtyBox = !0), L(i, n), !1 !== e && s.redraw();
            }
            show() {
                this.setVisible(!0);
            }
            hide() {
                this.setVisible(!1);
            }
            select(t) {
                this.selected = t = this.options.selected = void 0 === t ? !this.selected : t, this.checkbox && (this.checkbox.checked = t), L(this, t ? "select" : "unselect");
            }
            shouldShowTooltip(t, e, i = {}) {
                return i.series = this, i.visiblePlotOnly = !0, this.chart.isInsidePlot(t, e, i);
            }
            drawLegendSymbol(t, e) {
                r[this.options.legendSymbol || "rectangle"]?.call(this, t, e);
            }
        }
        return X.defaultOptions = n, X.types = a.seriesTypes, X.registerType = a.registerSeriesType, A(X.prototype, {
            axisTypes: [
                "xAxis",
                "yAxis"
            ],
            coll: "series",
            colorCounter: 0,
            directTouch: !1,
            invertible: !0,
            isCartesian: !0,
            kdAxisArray: [
                "clientX",
                "plotY"
            ],
            parallelArrays: [
                "x",
                "y"
            ],
            pointClass: o,
            requireSorting: !0,
            sorted: !0
        }), a.series = X, X;
    }), i(e, "Core/Legend/Legend.js", [
        e["Core/Animation/AnimationUtilities.js"],
        e["Core/Foundation.js"],
        e["Core/Globals.js"],
        e["Core/Series/Series.js"],
        e["Core/Series/Point.js"],
        e["Core/Renderer/RendererUtilities.js"],
        e["Core/Templating.js"],
        e["Core/Utilities.js"]
    ], function(t, e, i, s, r, o, n, a) {
        var h;
        let { animObject: l, setAnimation: d } = t, { registerEventOptions: c } = e, { composed: p, marginNames: u } = i, { distribute: g } = o, { format: f } = n, { addEvent: m, createElement: x, css: y, defined: b, discardElement: v, find: S, fireEvent: C, isNumber: k, merge: M, pick: w, pushUnique: T, relativeLength: A, stableSort: P, syncTimeout: L } = a;
        class O {
            constructor(t, e){
                this.allItems = [], this.initialItemY = 0, this.itemHeight = 0, this.itemMarginBottom = 0, this.itemMarginTop = 0, this.itemX = 0, this.itemY = 0, this.lastItemY = 0, this.lastLineHeight = 0, this.legendHeight = 0, this.legendWidth = 0, this.maxItemWidth = 0, this.maxLegendWidth = 0, this.offsetWidth = 0, this.padding = 0, this.pages = [], this.symbolHeight = 0, this.symbolWidth = 0, this.titleHeight = 0, this.totalItemWidth = 0, this.widthOption = 0, this.chart = t, this.setOptions(e), e.enabled && (this.render(), c(this, e), m(this.chart, "endResize", function() {
                    this.legend.positionCheckboxes();
                })), m(this.chart, "render", ()=>{
                    this.options.enabled && this.proximate && (this.proximatePositions(), this.positionItems());
                });
            }
            setOptions(t) {
                let e = w(t.padding, 8);
                this.options = t, this.chart.styledMode || (this.itemStyle = t.itemStyle, this.itemHiddenStyle = M(this.itemStyle, t.itemHiddenStyle)), this.itemMarginTop = t.itemMarginTop, this.itemMarginBottom = t.itemMarginBottom, this.padding = e, this.initialItemY = e - 5, this.symbolWidth = w(t.symbolWidth, 16), this.pages = [], this.proximate = "proximate" === t.layout && !this.chart.inverted, this.baseline = void 0;
            }
            update(t, e) {
                let i = this.chart;
                this.setOptions(M(!0, this.options, t)), "events" in this.options && c(this, this.options), this.destroy(), i.isDirtyLegend = i.isDirtyBox = !0, w(e, !0) && i.redraw(), C(this, "afterUpdate", {
                    redraw: e
                });
            }
            colorizeItem(t, e) {
                let { area: i, group: s, label: r, line: o, symbol: n } = t.legendItem || {};
                if (s?.[e ? "removeClass" : "addClass"]("highcharts-legend-item-hidden"), !this.chart.styledMode) {
                    let { itemHiddenStyle: s = {} } = this, a = s.color, { fillColor: h, fillOpacity: l, lineColor: d, marker: c } = t.options, p = (t)=>(!e && (t.fill && (t.fill = a), t.stroke && (t.stroke = a)), t);
                    r?.css(M(e ? this.itemStyle : s)), o?.attr(p({
                        stroke: d || t.color
                    })), n && n.attr(p(c && n.isMarker ? t.pointAttribs() : {
                        fill: t.color
                    })), i?.attr(p({
                        fill: h || t.color,
                        "fill-opacity": h ? 1 : l ?? .75
                    }));
                }
                C(this, "afterColorizeItem", {
                    item: t,
                    visible: e
                });
            }
            positionItems() {
                this.allItems.forEach(this.positionItem, this), this.chart.isResizing || this.positionCheckboxes();
            }
            positionItem(t) {
                let { group: e, x: i = 0, y: s = 0 } = t.legendItem || {}, r = this.options, o = r.symbolPadding, n = !r.rtl, a = t.checkbox;
                if (e && e.element) {
                    let r = {
                        translateX: n ? i : this.legendWidth - i - 2 * o - 4,
                        translateY: s
                    };
                    e[b(e.translateY) ? "animate" : "attr"](r, void 0, ()=>{
                        C(this, "afterPositionItem", {
                            item: t
                        });
                    });
                }
                a && (a.x = i, a.y = s);
            }
            destroyItem(t) {
                let e = t.checkbox, i = t.legendItem || {};
                for (let t of [
                    "group",
                    "label",
                    "line",
                    "symbol"
                ])i[t] && (i[t] = i[t].destroy());
                e && v(e), t.legendItem = void 0;
            }
            destroy() {
                for (let t of this.getAllItems())this.destroyItem(t);
                for (let t of [
                    "clipRect",
                    "up",
                    "down",
                    "pager",
                    "nav",
                    "box",
                    "title",
                    "group"
                ])this[t] && (this[t] = this[t].destroy());
                this.display = null;
            }
            positionCheckboxes() {
                let t;
                let e = this.group && this.group.alignAttr, i = this.clipHeight || this.legendHeight, s = this.titleHeight;
                e && (t = e.translateY, this.allItems.forEach(function(r) {
                    let o;
                    let n = r.checkbox;
                    n && (o = t + s + n.y + (this.scrollOffset || 0) + 3, y(n, {
                        left: e.translateX + r.checkboxOffset + n.x - 20 + "px",
                        top: o + "px",
                        display: this.proximate || o > t - 6 && o < t + i - 6 ? "" : "none"
                    }));
                }, this));
            }
            renderTitle() {
                let t = this.options, e = this.padding, i = t.title, s, r = 0;
                i.text && (this.title || (this.title = this.chart.renderer.label(i.text, e - 3, e - 4, void 0, void 0, void 0, t.useHTML, void 0, "legend-title").attr({
                    zIndex: 1
                }), this.chart.styledMode || this.title.css(i.style), this.title.add(this.group)), i.width || this.title.css({
                    width: this.maxLegendWidth + "px"
                }), r = (s = this.title.getBBox()).height, this.offsetWidth = s.width, this.contentGroup.attr({
                    translateY: r
                })), this.titleHeight = r;
            }
            setText(t) {
                let e = this.options;
                t.legendItem.label.attr({
                    text: e.labelFormat ? f(e.labelFormat, t, this.chart) : e.labelFormatter.call(t)
                });
            }
            renderItem(t) {
                let e = t.legendItem = t.legendItem || {}, i = this.chart, s = i.renderer, r = this.options, o = "horizontal" === r.layout, n = this.symbolWidth, a = r.symbolPadding || 0, h = this.itemStyle, l = this.itemHiddenStyle, d = o ? w(r.itemDistance, 20) : 0, c = !r.rtl, p = !t.series, u = !p && t.series.drawLegendSymbol ? t.series : t, g = u.options, f = !!this.createCheckboxForItem && g && g.showCheckbox, m = r.useHTML, x = t.options.className, y = e.label, b = n + a + d + (f ? 20 : 0);
                !y && (e.group = s.g("legend-item").addClass("highcharts-" + u.type + "-series highcharts-color-" + t.colorIndex + (x ? " " + x : "") + (p ? " highcharts-series-" + t.index : "")).attr({
                    zIndex: 1
                }).add(this.scrollGroup), e.label = y = s.text("", c ? n + a : -a, this.baseline || 0, m), i.styledMode || y.css(M(t.visible ? h : l)), y.attr({
                    align: c ? "left" : "right",
                    zIndex: 2
                }).add(e.group), !this.baseline && (this.fontMetrics = s.fontMetrics(y), this.baseline = this.fontMetrics.f + 3 + this.itemMarginTop, y.attr("y", this.baseline), this.symbolHeight = w(r.symbolHeight, this.fontMetrics.f), r.squareSymbol && (this.symbolWidth = w(r.symbolWidth, Math.max(this.symbolHeight, 16)), b = this.symbolWidth + a + d + (f ? 20 : 0), c && y.attr("x", this.symbolWidth + a))), u.drawLegendSymbol(this, t), this.setItemEvents && this.setItemEvents(t, y, m)), f && !t.checkbox && this.createCheckboxForItem && this.createCheckboxForItem(t), this.colorizeItem(t, t.visible), (i.styledMode || !h.width) && y.css({
                    width: (r.itemWidth || this.widthOption || i.spacingBox.width) - b + "px"
                }), this.setText(t);
                let v = y.getBBox(), S = this.fontMetrics && this.fontMetrics.h || 0;
                t.itemWidth = t.checkboxOffset = r.itemWidth || e.labelWidth || v.width + b, this.maxItemWidth = Math.max(this.maxItemWidth, t.itemWidth), this.totalItemWidth += t.itemWidth, this.itemHeight = t.itemHeight = Math.round(e.labelHeight || (v.height > 1.5 * S ? v.height : S));
            }
            layoutItem(t) {
                let e = this.options, i = this.padding, s = "horizontal" === e.layout, r = t.itemHeight, o = this.itemMarginBottom, n = this.itemMarginTop, a = s ? w(e.itemDistance, 20) : 0, h = this.maxLegendWidth, l = e.alignColumns && this.totalItemWidth > h ? this.maxItemWidth : t.itemWidth, d = t.legendItem || {};
                s && this.itemX - i + l > h && (this.itemX = i, this.lastLineHeight && (this.itemY += n + this.lastLineHeight + o), this.lastLineHeight = 0), this.lastItemY = n + this.itemY + o, this.lastLineHeight = Math.max(r, this.lastLineHeight), d.x = this.itemX, d.y = this.itemY, s ? this.itemX += l : (this.itemY += n + r + o, this.lastLineHeight = r), this.offsetWidth = this.widthOption || Math.max((s ? this.itemX - i - (t.checkbox ? 0 : a) : l) + i, this.offsetWidth);
            }
            getAllItems() {
                let t = [];
                return this.chart.series.forEach(function(e) {
                    let i = e && e.options;
                    e && w(i.showInLegend, !b(i.linkedTo) && void 0, !0) && (t = t.concat((e.legendItem || {}).labels || ("point" === i.legendType ? e.data : e)));
                }), C(this, "afterGetAllItems", {
                    allItems: t
                }), t;
            }
            getAlignment() {
                let t = this.options;
                return this.proximate ? t.align.charAt(0) + "tv" : t.floating ? "" : t.align.charAt(0) + t.verticalAlign.charAt(0) + t.layout.charAt(0);
            }
            adjustMargins(t, e) {
                let i = this.chart, s = this.options, r = this.getAlignment();
                r && [
                    /(lth|ct|rth)/,
                    /(rtv|rm|rbv)/,
                    /(rbh|cb|lbh)/,
                    /(lbv|lm|ltv)/
                ].forEach(function(o, n) {
                    o.test(r) && !b(t[n]) && (i[u[n]] = Math.max(i[u[n]], i.legend[(n + 1) % 2 ? "legendHeight" : "legendWidth"] + [
                        1,
                        -1,
                        -1,
                        1
                    ][n] * s[n % 2 ? "x" : "y"] + w(s.margin, 12) + e[n] + (i.titleOffset[n] || 0)));
                });
            }
            proximatePositions() {
                let t;
                let e = this.chart, i = [], s = "left" === this.options.align;
                for (let r of (this.allItems.forEach(function(t) {
                    let r, o, n = s, a, h;
                    t.yAxis && (t.xAxis.options.reversed && (n = !n), t.points && (r = S(n ? t.points : t.points.slice(0).reverse(), function(t) {
                        return k(t.plotY);
                    })), o = this.itemMarginTop + t.legendItem.label.getBBox().height + this.itemMarginBottom, h = t.yAxis.top - e.plotTop, a = t.visible ? (r ? r.plotY : t.yAxis.height) + (h - .3 * o) : h + t.yAxis.height, i.push({
                        target: a,
                        size: o,
                        item: t
                    }));
                }, this), g(i, e.plotHeight)))t = r.item.legendItem || {}, k(r.pos) && (t.y = e.plotTop - e.spacing[0] + r.pos);
            }
            render() {
                let t = this.chart, e = t.renderer, i = this.options, s = this.padding, r = this.getAllItems(), o, n, a, h = this.group, l, d = this.box;
                this.itemX = s, this.itemY = this.initialItemY, this.offsetWidth = 0, this.lastItemY = 0, this.widthOption = A(i.width, t.spacingBox.width - s), l = t.spacingBox.width - 2 * s - i.x, [
                    "rm",
                    "lm"
                ].indexOf(this.getAlignment().substring(0, 2)) > -1 && (l /= 2), this.maxLegendWidth = this.widthOption || l, h || (this.group = h = e.g("legend").addClass(i.className || "").attr({
                    zIndex: 7
                }).add(), this.contentGroup = e.g().attr({
                    zIndex: 1
                }).add(h), this.scrollGroup = e.g().add(this.contentGroup)), this.renderTitle(), P(r, (t, e)=>(t.options && t.options.legendIndex || 0) - (e.options && e.options.legendIndex || 0)), i.reversed && r.reverse(), this.allItems = r, this.display = o = !!r.length, this.lastLineHeight = 0, this.maxItemWidth = 0, this.totalItemWidth = 0, this.itemHeight = 0, r.forEach(this.renderItem, this), r.forEach(this.layoutItem, this), n = (this.widthOption || this.offsetWidth) + s, a = this.lastItemY + this.lastLineHeight + this.titleHeight, a = this.handleOverflow(a) + s, d || (this.box = d = e.rect().addClass("highcharts-legend-box").attr({
                    r: i.borderRadius
                }).add(h)), t.styledMode || d.attr({
                    stroke: i.borderColor,
                    "stroke-width": i.borderWidth || 0,
                    fill: i.backgroundColor || "none"
                }).shadow(i.shadow), n > 0 && a > 0 && d[d.placed ? "animate" : "attr"](d.crisp.call({}, {
                    x: 0,
                    y: 0,
                    width: n,
                    height: a
                }, d.strokeWidth())), h[o ? "show" : "hide"](), t.styledMode && "none" === h.getStyle("display") && (n = a = 0), this.legendWidth = n, this.legendHeight = a, o && this.align(), this.proximate || this.positionItems(), C(this, "afterRender");
            }
            align(t = this.chart.spacingBox) {
                let e = this.chart, i = this.options, s = t.y;
                /(lth|ct|rth)/.test(this.getAlignment()) && e.titleOffset[0] > 0 ? s += e.titleOffset[0] : /(lbh|cb|rbh)/.test(this.getAlignment()) && e.titleOffset[2] > 0 && (s -= e.titleOffset[2]), s !== t.y && (t = M(t, {
                    y: s
                })), e.hasRendered || (this.group.placed = !1), this.group.align(M(i, {
                    width: this.legendWidth,
                    height: this.legendHeight,
                    verticalAlign: this.proximate ? "top" : i.verticalAlign
                }), !0, t);
            }
            handleOverflow(t) {
                let e = this, i = this.chart, s = i.renderer, r = this.options, o = r.y, n = "top" === r.verticalAlign, a = this.padding, h = r.maxHeight, l = r.navigation, d = w(l.animation, !0), c = l.arrowSize || 12, p = this.pages, u = this.allItems, g = function(t) {
                    "number" == typeof t ? S.attr({
                        height: t
                    }) : S && (e.clipRect = S.destroy(), e.contentGroup.clip()), e.contentGroup.div && (e.contentGroup.div.style.clip = t ? "rect(" + a + "px,9999px," + (a + t) + "px,0)" : "auto");
                }, f = function(t) {
                    return e[t] = s.circle(0, 0, 1.3 * c).translate(c / 2, c / 2).add(v), i.styledMode || e[t].attr("fill", "rgba(0,0,0,0.0001)"), e[t];
                }, m, x, y, b = i.spacingBox.height + (n ? -o : o) - a, v = this.nav, S = this.clipRect;
                return "horizontal" !== r.layout || "middle" === r.verticalAlign || r.floating || (b /= 2), h && (b = Math.min(b, h)), p.length = 0, t && b > 0 && t > b && !1 !== l.enabled ? (this.clipHeight = m = Math.max(b - 20 - this.titleHeight - a, 0), this.currentPage = w(this.currentPage, 1), this.fullHeight = t, u.forEach((t, e)=>{
                    let i = (y = t.legendItem || {}).y || 0, s = Math.round(y.label.getBBox().height), r = p.length;
                    (!r || i - p[r - 1] > m && (x || i) !== p[r - 1]) && (p.push(x || i), r++), y.pageIx = r - 1, x && ((u[e - 1].legendItem || {}).pageIx = r - 1), e === u.length - 1 && i + s - p[r - 1] > m && i > p[r - 1] && (p.push(i), y.pageIx = r), i !== x && (x = i);
                }), S || (S = e.clipRect = s.clipRect(0, a - 2, 9999, 0), e.contentGroup.clip(S)), g(m), v || (this.nav = v = s.g().attr({
                    zIndex: 1
                }).add(this.group), this.up = s.symbol("triangle", 0, 0, c, c).add(v), f("upTracker").on("click", function() {
                    e.scroll(-1, d);
                }), this.pager = s.text("", 15, 10).addClass("highcharts-legend-navigation"), !i.styledMode && l.style && this.pager.css(l.style), this.pager.add(v), this.down = s.symbol("triangle-down", 0, 0, c, c).add(v), f("downTracker").on("click", function() {
                    e.scroll(1, d);
                })), e.scroll(0), t = b) : v && (g(), this.nav = v.destroy(), this.scrollGroup.attr({
                    translateY: 1
                }), this.clipHeight = 0), t;
            }
            scroll(t, e) {
                let i = this.chart, s = this.pages, r = s.length, o = this.clipHeight, n = this.options.navigation, a = this.pager, h = this.padding, c = this.currentPage + t;
                c > r && (c = r), c > 0 && (void 0 !== e && d(e, i), this.nav.attr({
                    translateX: h,
                    translateY: o + this.padding + 7 + this.titleHeight,
                    visibility: "inherit"
                }), [
                    this.up,
                    this.upTracker
                ].forEach(function(t) {
                    t.attr({
                        class: 1 === c ? "highcharts-legend-nav-inactive" : "highcharts-legend-nav-active"
                    });
                }), a.attr({
                    text: c + "/" + r
                }), [
                    this.down,
                    this.downTracker
                ].forEach(function(t) {
                    t.attr({
                        x: 18 + this.pager.getBBox().width,
                        class: c === r ? "highcharts-legend-nav-inactive" : "highcharts-legend-nav-active"
                    });
                }, this), i.styledMode || (this.up.attr({
                    fill: 1 === c ? n.inactiveColor : n.activeColor
                }), this.upTracker.css({
                    cursor: 1 === c ? "default" : "pointer"
                }), this.down.attr({
                    fill: c === r ? n.inactiveColor : n.activeColor
                }), this.downTracker.css({
                    cursor: c === r ? "default" : "pointer"
                })), this.scrollOffset = -s[c - 1] + this.initialItemY, this.scrollGroup.animate({
                    translateY: this.scrollOffset
                }), this.currentPage = c, this.positionCheckboxes(), L(()=>{
                    C(this, "afterScroll", {
                        currentPage: c
                    });
                }, l(w(e, i.renderer.globalAnimation, !0)).duration));
            }
            setItemEvents(t, e, i) {
                let o = this, n = t.legendItem || {}, a = o.chart.renderer.boxWrapper, h = t instanceof r, l = t instanceof s, d = "highcharts-legend-" + (h ? "point" : "series") + "-active", c = o.chart.styledMode, p = i ? [
                    e,
                    n.symbol
                ] : [
                    n.group
                ], u = (e)=>{
                    o.allItems.forEach((i)=>{
                        t !== i && [
                            i
                        ].concat(i.linkedSeries || []).forEach((t)=>{
                            t.setState(e, !h);
                        });
                    });
                };
                for (let i of p)i && i.on("mouseover", function() {
                    t.visible && u("inactive"), t.setState("hover"), t.visible && a.addClass(d), c || e.css(o.options.itemHoverStyle);
                }).on("mouseout", function() {
                    o.chart.styledMode || e.css(M(t.visible ? o.itemStyle : o.itemHiddenStyle)), u(""), a.removeClass(d), t.setState();
                }).on("click", function(e) {
                    let i = function() {
                        t.setVisible && t.setVisible(), u(t.visible ? "inactive" : "");
                    };
                    a.removeClass(d), C(o, "itemClick", {
                        browserEvent: e,
                        legendItem: t
                    }, i), h ? t.firePointEvent("legendItemClick", {
                        browserEvent: e
                    }) : l && C(t, "legendItemClick", {
                        browserEvent: e
                    });
                });
            }
            createCheckboxForItem(t) {
                t.checkbox = x("input", {
                    type: "checkbox",
                    className: "highcharts-legend-checkbox",
                    checked: t.selected,
                    defaultChecked: t.selected
                }, this.options.itemCheckboxStyle, this.chart.container), m(t.checkbox, "click", function(e) {
                    let i = e.target;
                    C(t.series || t, "checkboxClick", {
                        checked: i.checked,
                        item: t
                    }, function() {
                        t.select();
                    });
                });
            }
        }
        return (h = O || (O = {})).compose = function(t) {
            T(p, "Core.Legend") && m(t, "beforeMargins", function() {
                this.legend = new h(this, this.options.legend);
            });
        }, O;
    }), i(e, "Core/Chart/Chart.js", [
        e["Core/Animation/AnimationUtilities.js"],
        e["Core/Axis/Axis.js"],
        e["Core/Defaults.js"],
        e["Core/Templating.js"],
        e["Core/Foundation.js"],
        e["Core/Globals.js"],
        e["Core/Renderer/RendererRegistry.js"],
        e["Core/Series/Series.js"],
        e["Core/Series/SeriesRegistry.js"],
        e["Core/Renderer/SVG/SVGRenderer.js"],
        e["Core/Time.js"],
        e["Core/Utilities.js"],
        e["Core/Renderer/HTML/AST.js"],
        e["Core/Axis/Tick.js"]
    ], function(t, e, i, s, r, o, n, a, h, l, d, c, p, u) {
        let { animate: g, animObject: f, setAnimation: m } = t, { defaultOptions: x, defaultTime: y } = i, { numberFormat: b } = s, { registerEventOptions: v } = r, { charts: S, doc: C, marginNames: k, svg: M, win: w } = o, { seriesTypes: T } = h, { addEvent: A, attr: P, createElement: L, css: O, defined: D, diffObjects: E, discardElement: I, erase: j, error: B, extend: R, find: z, fireEvent: N, getStyle: W, isArray: G, isNumber: H, isObject: X, isString: F, merge: Y, objectEach: U, pick: V, pInt: $, relativeLength: Z, removeEvent: _, splat: q, syncTimeout: K, uniqueKey: J } = c;
        class Q {
            static chart(t, e, i) {
                return new Q(t, e, i);
            }
            constructor(t, e, i){
                this.sharedClips = {};
                let s = [
                    ...arguments
                ];
                (F(t) || t.nodeName) && (this.renderTo = s.shift()), this.init(s[0], s[1]);
            }
            setZoomOptions() {
                let t = this.options.chart, e = t.zooming;
                this.zooming = {
                    ...e,
                    type: V(t.zoomType, e.type),
                    key: V(t.zoomKey, e.key),
                    pinchType: V(t.pinchType, e.pinchType),
                    singleTouch: V(t.zoomBySingleTouch, e.singleTouch, !1),
                    resetButton: Y(e.resetButton, t.resetZoomButton)
                };
            }
            init(t, e) {
                N(this, "init", {
                    args: arguments
                }, function() {
                    let i = Y(x, t), s = i.chart;
                    this.userOptions = R({}, t), this.margin = [], this.spacing = [], this.labelCollectors = [], this.callback = e, this.isResizing = 0, this.options = i, this.axes = [], this.series = [], this.time = t.time && Object.keys(t.time).length ? new d(t.time) : o.time, this.numberFormatter = s.numberFormatter || b, this.styledMode = s.styledMode, this.hasCartesianSeries = s.showAxes, this.index = S.length, S.push(this), o.chartCount++, v(this, s), this.xAxis = [], this.yAxis = [], this.pointCount = this.colorCounter = this.symbolCounter = 0, this.setZoomOptions(), N(this, "afterInit"), this.firstRender();
                });
            }
            initSeries(t) {
                let e = this.options.chart, i = t.type || e.type, s = T[i];
                s || B(17, !0, this, {
                    missingModuleFor: i
                });
                let r = new s;
                return "function" == typeof r.init && r.init(this, t), r;
            }
            setSortedData() {
                this.getSeriesOrderByLinks().forEach(function(t) {
                    t.points || t.data || !t.enabledDataSorting || t.setData(t.options.data, !1);
                });
            }
            getSeriesOrderByLinks() {
                return this.series.concat().sort(function(t, e) {
                    return t.linkedSeries.length || e.linkedSeries.length ? e.linkedSeries.length - t.linkedSeries.length : 0;
                });
            }
            orderItems(t, e = 0) {
                let i = this[t], s = this.options[t] = q(this.options[t]).slice(), r = this.userOptions[t] = this.userOptions[t] ? q(this.userOptions[t]).slice() : [];
                if (this.hasRendered && (s.splice(e), r.splice(e)), i) for(let t = e, o = i.length; t < o; ++t){
                    let e = i[t];
                    e && (e.index = t, e instanceof a && (e.name = e.getName()), e.options.isInternal || (s[t] = e.options, r[t] = e.userOptions));
                }
            }
            isInsidePlot(t, e, i = {}) {
                let { inverted: s, plotBox: r, plotLeft: o, plotTop: n, scrollablePlotBox: a } = this, { scrollLeft: h = 0, scrollTop: l = 0 } = i.visiblePlotOnly && this.scrollablePlotArea?.scrollingContainer || {}, d = i.series, c = i.visiblePlotOnly && a || r, p = i.inverted ? e : t, u = i.inverted ? t : e, g = {
                    x: p,
                    y: u,
                    isInsidePlot: !0,
                    options: i
                };
                if (!i.ignoreX) {
                    let t = d && (s && !this.polar ? d.yAxis : d.xAxis) || {
                        pos: o,
                        len: 1 / 0
                    }, e = i.paneCoordinates ? t.pos + p : o + p;
                    e >= Math.max(h + o, t.pos) && e <= Math.min(h + o + c.width, t.pos + t.len) || (g.isInsidePlot = !1);
                }
                if (!i.ignoreY && g.isInsidePlot) {
                    let t = !s && i.axis && !i.axis.isXAxis && i.axis || d && (s ? d.xAxis : d.yAxis) || {
                        pos: n,
                        len: 1 / 0
                    }, e = i.paneCoordinates ? t.pos + u : n + u;
                    e >= Math.max(l + n, t.pos) && e <= Math.min(l + n + c.height, t.pos + t.len) || (g.isInsidePlot = !1);
                }
                return N(this, "afterIsInsidePlot", g), g.isInsidePlot;
            }
            redraw(t) {
                N(this, "beforeRedraw");
                let e = this.hasCartesianSeries ? this.axes : this.colorAxis || [], i = this.series, s = this.pointer, r = this.legend, o = this.userOptions.legend, n = this.renderer, a = n.isHidden(), h = [], l, d, c, p = this.isDirtyBox, u = this.isDirtyLegend, g;
                for(n.rootFontSize = n.boxWrapper.getStyle("font-size"), this.setResponsive && this.setResponsive(!1), m(!!this.hasRendered && t, this), a && this.temporaryDisplay(), this.layOutTitles(!1), c = i.length; c--;)if (((g = i[c]).options.stacking || g.options.centerInCategory) && (d = !0, g.isDirty)) {
                    l = !0;
                    break;
                }
                if (l) for(c = i.length; c--;)(g = i[c]).options.stacking && (g.isDirty = !0);
                i.forEach(function(t) {
                    t.isDirty && ("point" === t.options.legendType ? ("function" == typeof t.updateTotals && t.updateTotals(), u = !0) : o && (o.labelFormatter || o.labelFormat) && (u = !0)), t.isDirtyData && N(t, "updatedData");
                }), u && r && r.options.enabled && (r.render(), this.isDirtyLegend = !1), d && this.getStacks(), e.forEach(function(t) {
                    t.updateNames(), t.setScale();
                }), this.getMargins(), e.forEach(function(t) {
                    t.isDirty && (p = !0);
                }), e.forEach(function(t) {
                    let e = t.min + "," + t.max;
                    t.extKey !== e && (t.extKey = e, h.push(function() {
                        N(t, "afterSetExtremes", R(t.eventArgs, t.getExtremes())), delete t.eventArgs;
                    })), (p || d) && t.redraw();
                }), p && this.drawChartBox(), N(this, "predraw"), i.forEach(function(t) {
                    (p || t.isDirty) && t.visible && t.redraw(), t.isDirtyData = !1;
                }), s && s.reset(!0), n.draw(), N(this, "redraw"), N(this, "render"), a && this.temporaryDisplay(!0), h.forEach(function(t) {
                    t.call();
                });
            }
            get(t) {
                let e = this.series;
                function i(e) {
                    return e.id === t || e.options && e.options.id === t;
                }
                let s = z(this.axes, i) || z(this.series, i);
                for(let t = 0; !s && t < e.length; t++)s = z(e[t].points || [], i);
                return s;
            }
            getAxes() {
                let t = this.userOptions;
                for (let i of (N(this, "getAxes"), [
                    "xAxis",
                    "yAxis"
                ]))for (let s of t[i] = q(t[i] || {}))new e(this, s, i);
                N(this, "afterGetAxes");
            }
            getSelectedPoints() {
                return this.series.reduce((t, e)=>(e.getPointsCollection().forEach((e)=>{
                        V(e.selectedStaging, e.selected) && t.push(e);
                    }), t), []);
            }
            getSelectedSeries() {
                return this.series.filter(function(t) {
                    return t.selected;
                });
            }
            setTitle(t, e, i) {
                this.applyDescription("title", t), this.applyDescription("subtitle", e), this.applyDescription("caption", void 0), this.layOutTitles(i);
            }
            applyDescription(t, e) {
                let i = this, s = this.options[t] = Y(this.options[t], e), r = this[t];
                r && e && (this[t] = r = r.destroy()), s && !r && ((r = this.renderer.text(s.text, 0, 0, s.useHTML).attr({
                    align: s.align,
                    class: "highcharts-" + t,
                    zIndex: s.zIndex || 4
                }).add()).update = function(e, s) {
                    i.applyDescription(t, e), i.layOutTitles(s);
                }, this.styledMode || r.css(R("title" === t ? {
                    fontSize: this.options.isStock ? "1em" : "1.2em"
                } : {}, s.style)), this[t] = r);
            }
            layOutTitles(t = !0) {
                let e = [
                    0,
                    0,
                    0
                ], i = this.renderer, s = this.spacingBox;
                [
                    "title",
                    "subtitle",
                    "caption"
                ].forEach(function(t) {
                    let r = this[t], o = this.options[t], n = o.verticalAlign || "top", a = "title" === t ? "top" === n ? -3 : 0 : "top" === n ? e[0] + 2 : 0;
                    if (r) {
                        r.css({
                            width: (o.width || s.width + (o.widthAdjust || 0)) + "px"
                        });
                        let t = i.fontMetrics(r).b, h = Math.round(r.getBBox(o.useHTML).height);
                        r.align(R({
                            y: "bottom" === n ? t : a + t,
                            height: h
                        }, o), !1, "spacingBox"), o.floating || ("top" === n ? e[0] = Math.ceil(e[0] + h) : "bottom" === n && (e[2] = Math.ceil(e[2] + h)));
                    }
                }, this), e[0] && "top" === (this.options.title.verticalAlign || "top") && (e[0] += this.options.title.margin), e[2] && "bottom" === this.options.caption.verticalAlign && (e[2] += this.options.caption.margin);
                let r = !this.titleOffset || this.titleOffset.join(",") !== e.join(",");
                this.titleOffset = e, N(this, "afterLayOutTitles"), !this.isDirtyBox && r && (this.isDirtyBox = this.isDirtyLegend = r, this.hasRendered && t && this.isDirtyBox && this.redraw());
            }
            getContainerBox() {
                let t = [].map.call(this.renderTo.children, (t)=>{
                    if (t !== this.container) {
                        let e = t.style.display;
                        return t.style.display = "none", [
                            t,
                            e
                        ];
                    }
                }), e = {
                    width: W(this.renderTo, "width", !0) || 0,
                    height: W(this.renderTo, "height", !0) || 0
                };
                return t.filter(Boolean).forEach(([t, e])=>{
                    t.style.display = e;
                }), e;
            }
            getChartSize() {
                let t = this.options.chart, e = t.width, i = t.height, s = this.getContainerBox(), r = s.height > 1 && !(!this.renderTo.parentElement?.style.height && "100%" === this.renderTo.style.height);
                this.chartWidth = Math.max(0, e || s.width || 600), this.chartHeight = Math.max(0, Z(i, this.chartWidth) || (r ? s.height : 400)), this.containerBox = s;
            }
            temporaryDisplay(t) {
                let e = this.renderTo, i;
                if (t) for(; e && e.style;)e.hcOrigStyle && (O(e, e.hcOrigStyle), delete e.hcOrigStyle), e.hcOrigDetached && (C.body.removeChild(e), e.hcOrigDetached = !1), e = e.parentNode;
                else for(; e && e.style && (C.body.contains(e) || e.parentNode || (e.hcOrigDetached = !0, C.body.appendChild(e)), ("none" === W(e, "display", !1) || e.hcOricDetached) && (e.hcOrigStyle = {
                    display: e.style.display,
                    height: e.style.height,
                    overflow: e.style.overflow
                }, i = {
                    display: "block",
                    overflow: "hidden"
                }, e !== this.renderTo && (i.height = 0), O(e, i), e.offsetWidth || e.style.setProperty("display", "block", "important")), (e = e.parentNode) !== C.body););
            }
            setClassName(t) {
                this.container.className = "highcharts-container " + (t || "");
            }
            getContainer() {
                let t = this.options, e = t.chart, i = "data-highcharts-chart", s = J(), r, o = this.renderTo;
                o || (this.renderTo = o = e.renderTo), F(o) && (this.renderTo = o = C.getElementById(o)), o || B(13, !0, this);
                let a = $(P(o, i));
                H(a) && S[a] && S[a].hasRendered && S[a].destroy(), P(o, i, this.index), o.innerHTML = p.emptyHTML, e.skipClone || o.offsetWidth || this.temporaryDisplay(), this.getChartSize();
                let h = this.chartHeight, d = this.chartWidth;
                O(o, {
                    overflow: "hidden"
                }), this.styledMode || (r = R({
                    position: "relative",
                    overflow: "hidden",
                    width: d + "px",
                    height: h + "px",
                    textAlign: "left",
                    lineHeight: "normal",
                    zIndex: 0,
                    "-webkit-tap-highlight-color": "rgba(0,0,0,0)",
                    userSelect: "none",
                    "touch-action": "manipulation",
                    outline: "none",
                    padding: "0px"
                }, e.style || {}));
                let c = L("div", {
                    id: s
                }, r, o);
                this.container = c, this.getChartSize(), d === this.chartWidth || (d = this.chartWidth, this.styledMode || O(c, {
                    width: V(e.style?.width, d + "px")
                })), this.containerBox = this.getContainerBox(), this._cursor = c.style.cursor;
                let u = e.renderer || !M ? n.getRendererType(e.renderer) : l;
                if (this.renderer = new u(c, d, h, void 0, e.forExport, t.exporting && t.exporting.allowHTML, this.styledMode), m(void 0, this), this.setClassName(e.className), this.styledMode) for(let e in t.defs)this.renderer.definition(t.defs[e]);
                else this.renderer.setStyle(e.style);
                this.renderer.chartIndex = this.index, N(this, "afterGetContainer");
            }
            getMargins(t) {
                let { spacing: e, margin: i, titleOffset: s } = this;
                this.resetMargins(), s[0] && !D(i[0]) && (this.plotTop = Math.max(this.plotTop, s[0] + e[0])), s[2] && !D(i[2]) && (this.marginBottom = Math.max(this.marginBottom, s[2] + e[2])), this.legend && this.legend.display && this.legend.adjustMargins(i, e), N(this, "getMargins"), t || this.getAxisMargins();
            }
            getAxisMargins() {
                let t = this, e = t.axisOffset = [
                    0,
                    0,
                    0,
                    0
                ], i = t.colorAxis, s = t.margin, r = function(t) {
                    t.forEach(function(t) {
                        t.visible && t.getOffset();
                    });
                };
                t.hasCartesianSeries ? r(t.axes) : i && i.length && r(i), k.forEach(function(i, r) {
                    D(s[r]) || (t[i] += e[r]);
                }), t.setChartSize();
            }
            getOptions() {
                return E(this.userOptions, x);
            }
            reflow(t) {
                let e = this, i = e.containerBox, s = e.getContainerBox();
                delete e.pointer?.chartPosition, !e.isPrinting && !e.isResizing && i && s.width && ((s.width !== i.width || s.height !== i.height) && (c.clearTimeout(e.reflowTimeout), e.reflowTimeout = K(function() {
                    e.container && e.setSize(void 0, void 0, !1);
                }, t ? 100 : 0)), e.containerBox = s);
            }
            setReflow() {
                let t = this, e = (e)=>{
                    t.options?.chart.reflow && t.hasLoaded && t.reflow(e);
                };
                if ("function" == typeof ResizeObserver) new ResizeObserver(e).observe(t.renderTo);
                else {
                    let t = A(w, "resize", e);
                    A(this, "destroy", t);
                }
            }
            setSize(t, e, i) {
                let s = this, r = s.renderer;
                s.isResizing += 1, m(i, s);
                let o = r.globalAnimation;
                s.oldChartHeight = s.chartHeight, s.oldChartWidth = s.chartWidth, void 0 !== t && (s.options.chart.width = t), void 0 !== e && (s.options.chart.height = e), s.getChartSize();
                let { chartWidth: n, chartHeight: a, scrollablePixelsX: h = 0, scrollablePixelsY: l = 0 } = s;
                (s.isDirtyBox || n !== s.oldChartWidth || a !== s.oldChartHeight) && (s.styledMode || (o ? g : O)(s.container, {
                    width: `${n + h}px`,
                    height: `${a + l}px`
                }, o), s.setChartSize(!0), r.setSize(n, a, o), s.axes.forEach(function(t) {
                    t.isDirty = !0, t.setScale();
                }), s.isDirtyLegend = !0, s.isDirtyBox = !0, s.layOutTitles(), s.getMargins(), s.redraw(o), s.oldChartHeight = void 0, N(s, "resize"), setTimeout(()=>{
                    s && N(s, "endResize");
                }, f(o).duration)), s.isResizing -= 1;
            }
            setChartSize(t) {
                let e, i, s, r;
                let { chartHeight: o, chartWidth: n, inverted: a, spacing: h, renderer: l } = this, d = this.clipOffset, c = Math[a ? "floor" : "round"];
                this.plotLeft = e = Math.round(this.plotLeft), this.plotTop = i = Math.round(this.plotTop), this.plotWidth = s = Math.max(0, Math.round(n - e - this.marginRight)), this.plotHeight = r = Math.max(0, Math.round(o - i - this.marginBottom)), this.plotSizeX = a ? r : s, this.plotSizeY = a ? s : r, this.spacingBox = l.spacingBox = {
                    x: h[3],
                    y: h[0],
                    width: n - h[3] - h[1],
                    height: o - h[0] - h[2]
                }, this.plotBox = l.plotBox = {
                    x: e,
                    y: i,
                    width: s,
                    height: r
                }, d && (this.clipBox = {
                    x: c(d[3]),
                    y: c(d[0]),
                    width: c(this.plotSizeX - d[1] - d[3]),
                    height: c(this.plotSizeY - d[0] - d[2])
                }), t || (this.axes.forEach(function(t) {
                    t.setAxisSize(), t.setAxisTranslation();
                }), l.alignElements()), N(this, "afterSetChartSize", {
                    skipAxes: t
                });
            }
            resetMargins() {
                N(this, "resetMargins");
                let t = this, e = t.options.chart, i = e.plotBorderWidth || 0, s = i / 2;
                [
                    "margin",
                    "spacing"
                ].forEach(function(i) {
                    let s = e[i], r = X(s) ? s : [
                        s,
                        s,
                        s,
                        s
                    ];
                    [
                        "Top",
                        "Right",
                        "Bottom",
                        "Left"
                    ].forEach(function(s, o) {
                        t[i][o] = V(e[i + s], r[o]);
                    });
                }), k.forEach(function(e, i) {
                    t[e] = V(t.margin[i], t.spacing[i]);
                }), t.axisOffset = [
                    0,
                    0,
                    0,
                    0
                ], t.clipOffset = [
                    s,
                    s,
                    s,
                    s
                ], t.plotBorderWidth = i;
            }
            drawChartBox() {
                let t = this.options.chart, e = this.renderer, i = this.chartWidth, s = this.chartHeight, r = this.styledMode, o = this.plotBGImage, n = t.backgroundColor, a = t.plotBackgroundColor, h = t.plotBackgroundImage, l = this.plotLeft, d = this.plotTop, c = this.plotWidth, p = this.plotHeight, u = this.plotBox, g = this.clipRect, f = this.clipBox, m = this.chartBackground, x = this.plotBackground, y = this.plotBorder, b, v, S, C = "animate";
                m || (this.chartBackground = m = e.rect().addClass("highcharts-background").add(), C = "attr"), r ? b = v = m.strokeWidth() : (v = (b = t.borderWidth || 0) + (t.shadow ? 8 : 0), S = {
                    fill: n || "none"
                }, (b || m["stroke-width"]) && (S.stroke = t.borderColor, S["stroke-width"] = b), m.attr(S).shadow(t.shadow)), m[C]({
                    x: v / 2,
                    y: v / 2,
                    width: i - v - b % 2,
                    height: s - v - b % 2,
                    r: t.borderRadius
                }), C = "animate", x || (C = "attr", this.plotBackground = x = e.rect().addClass("highcharts-plot-background").add()), x[C](u), !r && (x.attr({
                    fill: a || "none"
                }).shadow(t.plotShadow), h && (o ? (h !== o.attr("href") && o.attr("href", h), o.animate(u)) : this.plotBGImage = e.image(h, l, d, c, p).add())), g ? g.animate({
                    width: f.width,
                    height: f.height
                }) : this.clipRect = e.clipRect(f), C = "animate", y || (C = "attr", this.plotBorder = y = e.rect().addClass("highcharts-plot-border").attr({
                    zIndex: 1
                }).add()), r || y.attr({
                    stroke: t.plotBorderColor,
                    "stroke-width": t.plotBorderWidth || 0,
                    fill: "none"
                }), y[C](y.crisp({
                    x: l,
                    y: d,
                    width: c,
                    height: p
                }, -y.strokeWidth())), this.isDirtyBox = !1, N(this, "afterDrawChartBox");
            }
            propFromSeries() {
                let t, e, i;
                let s = this, r = s.options.chart, o = s.options.series;
                [
                    "inverted",
                    "angular",
                    "polar"
                ].forEach(function(n) {
                    for(e = T[r.type], i = r[n] || e && e.prototype[n], t = o && o.length; !i && t--;)(e = T[o[t].type]) && e.prototype[n] && (i = !0);
                    s[n] = i;
                });
            }
            linkSeries(t) {
                let e = this, i = e.series;
                i.forEach(function(t) {
                    t.linkedSeries.length = 0;
                }), i.forEach(function(t) {
                    let { linkedTo: i } = t.options;
                    if (F(i)) {
                        let s;
                        (s = ":previous" === i ? e.series[t.index - 1] : e.get(i)) && s.linkedParent !== t && (s.linkedSeries.push(t), t.linkedParent = s, s.enabledDataSorting && t.setDataSortingOptions(), t.visible = V(t.options.visible, s.options.visible, t.visible));
                    }
                }), N(this, "afterLinkSeries", {
                    isUpdating: t
                });
            }
            renderSeries() {
                this.series.forEach(function(t) {
                    t.translate(), t.render();
                });
            }
            render() {
                let t = this.axes, e = this.colorAxis, i = this.renderer, s = this.options.chart.axisLayoutRuns || 2, r = (t)=>{
                    t.forEach((t)=>{
                        t.visible && t.render();
                    });
                }, o = 0, n = !0, a, h = 0;
                for (let e of (this.setTitle(), N(this, "beforeMargins"), this.getStacks?.(), this.getMargins(!0), this.setChartSize(), t)){
                    let { options: t } = e, { labels: i } = t;
                    if (this.hasCartesianSeries && e.horiz && e.visible && i.enabled && e.series.length && "colorAxis" !== e.coll && !this.polar) {
                        o = t.tickLength, e.createGroups();
                        let s = new u(e, 0, "", !0), r = s.createLabel("x", i);
                        if (s.destroy(), r && V(i.reserveSpace, !H(t.crossing)) && (o = r.getBBox().height + i.distance + Math.max(t.offset || 0, 0)), o) {
                            r?.destroy();
                            break;
                        }
                    }
                }
                for(this.plotHeight = Math.max(this.plotHeight - o, 0); (n || a || s > 1) && h < s;){
                    let e = this.plotWidth, i = this.plotHeight;
                    for (let e of t)0 === h ? e.setScale() : (e.horiz && n || !e.horiz && a) && e.setTickInterval(!0);
                    0 === h ? this.getAxisMargins() : this.getMargins(), n = e / this.plotWidth > (h ? 1 : 1.1), a = i / this.plotHeight > (h ? 1 : 1.05), h++;
                }
                this.drawChartBox(), this.hasCartesianSeries ? r(t) : e && e.length && r(e), this.seriesGroup || (this.seriesGroup = i.g("series-group").attr({
                    zIndex: 3
                }).shadow(this.options.chart.seriesGroupShadow).add()), this.renderSeries(), this.addCredits(), this.setResponsive && this.setResponsive(), this.hasRendered = !0;
            }
            addCredits(t) {
                let e = this, i = Y(!0, this.options.credits, t);
                i.enabled && !this.credits && (this.credits = this.renderer.text(i.text + (this.mapCredits || ""), 0, 0).addClass("highcharts-credits").on("click", function() {
                    i.href && (w.location.href = i.href);
                }).attr({
                    align: i.position.align,
                    zIndex: 8
                }), e.styledMode || this.credits.css(i.style), this.credits.add().align(i.position), this.credits.update = function(t) {
                    e.credits = e.credits.destroy(), e.addCredits(t);
                });
            }
            destroy() {
                let t;
                let e = this, i = e.axes, s = e.series, r = e.container, n = r && r.parentNode;
                for(N(e, "destroy"), e.renderer.forExport ? j(S, e) : S[e.index] = void 0, o.chartCount--, e.renderTo.removeAttribute("data-highcharts-chart"), _(e), t = i.length; t--;)i[t] = i[t].destroy();
                for(this.scroller && this.scroller.destroy && this.scroller.destroy(), t = s.length; t--;)s[t] = s[t].destroy();
                [
                    "title",
                    "subtitle",
                    "chartBackground",
                    "plotBackground",
                    "plotBGImage",
                    "plotBorder",
                    "seriesGroup",
                    "clipRect",
                    "credits",
                    "pointer",
                    "rangeSelector",
                    "legend",
                    "resetZoomButton",
                    "tooltip",
                    "renderer"
                ].forEach(function(t) {
                    let i = e[t];
                    i && i.destroy && (e[t] = i.destroy());
                }), r && (r.innerHTML = p.emptyHTML, _(r), n && I(r)), U(e, function(t, i) {
                    delete e[i];
                });
            }
            firstRender() {
                let t = this, e = t.options;
                t.getContainer(), t.resetMargins(), t.setChartSize(), t.propFromSeries(), t.getAxes();
                let i = G(e.series) ? e.series : [];
                e.series = [], i.forEach(function(e) {
                    t.initSeries(e);
                }), t.linkSeries(), t.setSortedData(), N(t, "beforeRender"), t.render(), t.pointer?.getChartPosition(), t.renderer.imgCount || t.hasLoaded || t.onload(), t.temporaryDisplay(!0);
            }
            onload() {
                this.callbacks.concat([
                    this.callback
                ]).forEach(function(t) {
                    t && void 0 !== this.index && t.apply(this, [
                        this
                    ]);
                }, this), N(this, "load"), N(this, "render"), D(this.index) && this.setReflow(), this.warnIfA11yModuleNotLoaded(), this.hasLoaded = !0;
            }
            warnIfA11yModuleNotLoaded() {
                let { options: t, title: e } = this;
                !t || this.accessibility || (this.renderer.boxWrapper.attr({
                    role: "img",
                    "aria-label": (e && e.element.textContent || "").replace(/</g, "&lt;")
                }), t.accessibility && !1 === t.accessibility.enabled || B('Highcharts warning: Consider including the "accessibility.js" module to make your chart more usable for people with disabilities. Set the "accessibility.enabled" option to false to remove this warning. See https://www.highcharts.com/docs/accessibility/accessibility-module.', !1, this));
            }
            addSeries(t, e, i) {
                let s;
                let r = this;
                return t && (e = V(e, !0), N(r, "addSeries", {
                    options: t
                }, function() {
                    s = r.initSeries(t), r.isDirtyLegend = !0, r.linkSeries(), s.enabledDataSorting && s.setData(t.data, !1), N(r, "afterAddSeries", {
                        series: s
                    }), e && r.redraw(i);
                })), s;
            }
            addAxis(t, e, i, s) {
                return this.createAxis(e ? "xAxis" : "yAxis", {
                    axis: t,
                    redraw: i,
                    animation: s
                });
            }
            addColorAxis(t, e, i) {
                return this.createAxis("colorAxis", {
                    axis: t,
                    redraw: e,
                    animation: i
                });
            }
            createAxis(t, i) {
                let s = new e(this, i.axis, t);
                return V(i.redraw, !0) && this.redraw(i.animation), s;
            }
            showLoading(t) {
                let e = this, i = e.options, s = i.loading, r = function() {
                    o && O(o, {
                        left: e.plotLeft + "px",
                        top: e.plotTop + "px",
                        width: e.plotWidth + "px",
                        height: e.plotHeight + "px"
                    });
                }, o = e.loadingDiv, n = e.loadingSpan;
                o || (e.loadingDiv = o = L("div", {
                    className: "highcharts-loading highcharts-loading-hidden"
                }, null, e.container)), n || (e.loadingSpan = n = L("span", {
                    className: "highcharts-loading-inner"
                }, null, o), A(e, "redraw", r)), o.className = "highcharts-loading", p.setElementHTML(n, V(t, i.lang.loading, "")), e.styledMode || (O(o, R(s.style, {
                    zIndex: 10
                })), O(n, s.labelStyle), e.loadingShown || (O(o, {
                    opacity: 0,
                    display: ""
                }), g(o, {
                    opacity: s.style.opacity || .5
                }, {
                    duration: s.showDuration || 0
                }))), e.loadingShown = !0, r();
            }
            hideLoading() {
                let t = this.options, e = this.loadingDiv;
                e && (e.className = "highcharts-loading highcharts-loading-hidden", this.styledMode || g(e, {
                    opacity: 0
                }, {
                    duration: t.loading.hideDuration || 100,
                    complete: function() {
                        O(e, {
                            display: "none"
                        });
                    }
                })), this.loadingShown = !1;
            }
            update(t, e, i, s) {
                let r, o, n;
                let a = this, h = {
                    credits: "addCredits",
                    title: "setTitle",
                    subtitle: "setSubtitle",
                    caption: "setCaption"
                }, l = t.isResponsiveOptions, c = [];
                N(a, "update", {
                    options: t
                }), l || a.setResponsive(!1, !0), t = E(t, a.options), a.userOptions = Y(a.userOptions, t);
                let p = t.chart;
                p && (Y(!0, a.options.chart, p), this.setZoomOptions(), "className" in p && a.setClassName(p.className), ("inverted" in p || "polar" in p || "type" in p) && (a.propFromSeries(), r = !0), "alignTicks" in p && (r = !0), "events" in p && v(this, p), U(p, function(t, e) {
                    -1 !== a.propsRequireUpdateSeries.indexOf("chart." + e) && (o = !0), -1 !== a.propsRequireDirtyBox.indexOf(e) && (a.isDirtyBox = !0), -1 === a.propsRequireReflow.indexOf(e) || (a.isDirtyBox = !0, l || (n = !0));
                }), !a.styledMode && p.style && a.renderer.setStyle(a.options.chart.style || {})), !a.styledMode && t.colors && (this.options.colors = t.colors), t.time && (this.time === y && (this.time = new d(t.time)), Y(!0, a.options.time, t.time)), U(t, function(e, i) {
                    a[i] && "function" == typeof a[i].update ? a[i].update(e, !1) : "function" == typeof a[h[i]] ? a[h[i]](e) : "colors" !== i && -1 === a.collectionsWithUpdate.indexOf(i) && Y(!0, a.options[i], t[i]), "chart" !== i && -1 !== a.propsRequireUpdateSeries.indexOf(i) && (o = !0);
                }), this.collectionsWithUpdate.forEach(function(e) {
                    t[e] && (q(t[e]).forEach(function(t, s) {
                        let r;
                        let o = D(t.id);
                        o && (r = a.get(t.id)), !r && a[e] && (r = a[e][V(t.index, s)]) && (o && D(r.options.id) || r.options.isInternal) && (r = void 0), r && r.coll === e && (r.update(t, !1), i && (r.touched = !0)), !r && i && a.collectionsWithInit[e] && (a.collectionsWithInit[e][0].apply(a, [
                            t
                        ].concat(a.collectionsWithInit[e][1] || []).concat([
                            !1
                        ])).touched = !0);
                    }), i && a[e].forEach(function(t) {
                        t.touched || t.options.isInternal ? delete t.touched : c.push(t);
                    }));
                }), c.forEach(function(t) {
                    t.chart && t.remove && t.remove(!1);
                }), r && a.axes.forEach(function(t) {
                    t.update({}, !1);
                }), o && a.getSeriesOrderByLinks().forEach(function(t) {
                    t.chart && t.update({}, !1);
                }, this);
                let u = p && p.width, g = p && (F(p.height) ? Z(p.height, u || a.chartWidth) : p.height);
                n || H(u) && u !== a.chartWidth || H(g) && g !== a.chartHeight ? a.setSize(u, g, s) : V(e, !0) && a.redraw(s), N(a, "afterUpdate", {
                    options: t,
                    redraw: e,
                    animation: s
                });
            }
            setSubtitle(t, e) {
                this.applyDescription("subtitle", t), this.layOutTitles(e);
            }
            setCaption(t, e) {
                this.applyDescription("caption", t), this.layOutTitles(e);
            }
            showResetZoom() {
                let t = this, e = x.lang, i = t.zooming.resetButton, s = i.theme, r = "chart" === i.relativeTo || "spacingBox" === i.relativeTo ? null : "plotBox";
                function o() {
                    t.zoomOut();
                }
                N(this, "beforeShowResetZoom", null, function() {
                    t.resetZoomButton = t.renderer.button(e.resetZoom, null, null, o, s).attr({
                        align: i.position.align,
                        title: e.resetZoomTitle
                    }).addClass("highcharts-reset-zoom").add().align(i.position, !1, r);
                }), N(this, "afterShowResetZoom");
            }
            zoomOut() {
                N(this, "selection", {
                    resetSelection: !0
                }, ()=>this.transform({
                        reset: !0,
                        trigger: "zoom"
                    }));
            }
            pan(t, e) {
                let i = this, s = "object" == typeof e ? e : {
                    enabled: e,
                    type: "x"
                }, r = s.type, o = r && i[({
                    x: "xAxis",
                    xy: "axes",
                    y: "yAxis"
                })[r]].filter((t)=>t.options.panningEnabled && !t.options.isInternal), n = i.options.chart;
                n?.panning && (n.panning = s), N(this, "pan", {
                    originalEvent: t
                }, ()=>{
                    i.transform({
                        axes: o,
                        event: t,
                        to: {
                            x: t.chartX - (i.mouseDownX || 0),
                            y: t.chartY - (i.mouseDownY || 0)
                        },
                        trigger: "pan"
                    }), O(i.container, {
                        cursor: "move"
                    });
                });
            }
            transform(t) {
                let { axes: e = this.axes, event: i, from: s = {}, reset: r, selection: o, to: n = {}, trigger: a } = t, { inverted: h } = this, l = !1, d, c;
                for (let t of (this.hoverPoints?.forEach((t)=>t.setState()), e)){
                    let { horiz: e, len: p, minPointOffset: u = 0, options: g, reversed: f } = t, m = e ? "width" : "height", x = e ? "x" : "y", y = V(n[m], t.len), b = V(s[m], t.len), v = 10 > Math.abs(y) ? 1 : y / b, S = (s[x] || 0) + b / 2 - t.pos, C = S - ((n[x] ?? t.pos) + y / 2 - t.pos) / v, k = f && !h || !f && h ? -1 : 1;
                    if (!r && (S < 0 || S > t.len)) continue;
                    let M = t.toValue(C, !0) + (o || t.isOrdinal ? 0 : u * k), w = t.toValue(C + p / v, !0) - (o || t.isOrdinal ? 0 : u * k || 0), T = t.allExtremes;
                    if (M > w && ([M, w] = [
                        w,
                        M
                    ]), 1 === v && !r && "yAxis" === t.coll && !T) {
                        for (let e of t.series){
                            let t = e.getExtremes(e.getProcessedData(!0).yData, !0);
                            T ?? (T = {
                                dataMin: Number.MAX_VALUE,
                                dataMax: -Number.MAX_VALUE
                            }), H(t.dataMin) && H(t.dataMax) && (T.dataMin = Math.min(t.dataMin, T.dataMin), T.dataMax = Math.max(t.dataMax, T.dataMax));
                        }
                        t.allExtremes = T;
                    }
                    let { dataMin: A, dataMax: P, min: L, max: O } = R(t.getExtremes(), T || {}), E = A ?? g.min, I = P ?? g.max, j = w - M, B = t.categories ? 0 : Math.min(j, I - E), z = E - B * (D(g.min) ? 0 : g.minPadding), N = I + B * (D(g.max) ? 0 : g.maxPadding), W = t.allowZoomOutside || 1 === v || "zoom" !== a && v > 1, G = Math.min(g.min ?? z, z, W ? L : z), X = Math.max(g.max ?? N, N, W ? O : N);
                    (!t.isOrdinal || t.options.overscroll || 1 !== v || r) && (M < G && (M = G, v >= 1 && (w = M + j)), w > X && (w = X, v >= 1 && (M = w - j)), (r || t.series.length && (M !== L || w !== O) && M >= G && w <= X) && (o ? o[t.coll].push({
                        axis: t,
                        min: M,
                        max: w
                    }) : (t.isPanning = "zoom" !== a, t.isPanning && (c = !0), t.setExtremes(r ? void 0 : M, r ? void 0 : w, !1, !1, {
                        move: C,
                        trigger: a,
                        scale: v
                    }), !r && (M > G || w < X) && "mousewheel" !== a && (d = !0)), l = !0), i && (this[e ? "mouseDownX" : "mouseDownY"] = i[e ? "chartX" : "chartY"]));
                }
                return l && (o ? N(this, "selection", o, ()=>{
                    delete t.selection, t.trigger = "zoom", this.transform(t);
                }) : (!d || c || this.resetZoomButton ? !d && this.resetZoomButton && (this.resetZoomButton = this.resetZoomButton.destroy()) : this.showResetZoom(), this.redraw("zoom" === a && (this.options.chart.animation ?? this.pointCount < 100)))), l;
            }
        }
        return R(Q.prototype, {
            callbacks: [],
            collectionsWithInit: {
                xAxis: [
                    Q.prototype.addAxis,
                    [
                        !0
                    ]
                ],
                yAxis: [
                    Q.prototype.addAxis,
                    [
                        !1
                    ]
                ],
                series: [
                    Q.prototype.addSeries
                ]
            },
            collectionsWithUpdate: [
                "xAxis",
                "yAxis",
                "series"
            ],
            propsRequireDirtyBox: [
                "backgroundColor",
                "borderColor",
                "borderWidth",
                "borderRadius",
                "plotBackgroundColor",
                "plotBackgroundImage",
                "plotBorderColor",
                "plotBorderWidth",
                "plotShadow",
                "shadow"
            ],
            propsRequireReflow: [
                "margin",
                "marginTop",
                "marginRight",
                "marginBottom",
                "marginLeft",
                "spacing",
                "spacingTop",
                "spacingRight",
                "spacingBottom",
                "spacingLeft"
            ],
            propsRequireUpdateSeries: [
                "chart.inverted",
                "chart.polar",
                "chart.ignoreHiddenSeries",
                "chart.type",
                "colors",
                "plotOptions",
                "time",
                "tooltip"
            ]
        }), Q;
    }), i(e, "Extensions/ScrollablePlotArea.js", [
        e["Core/Animation/AnimationUtilities.js"],
        e["Core/Globals.js"],
        e["Core/Renderer/RendererRegistry.js"],
        e["Core/Utilities.js"]
    ], function(t, e, i, s) {
        let { stop: r } = t, { composed: o } = e, { addEvent: n, createElement: a, css: h, defined: l, merge: d, pushUnique: c } = s;
        function p() {
            let t = this.scrollablePlotArea;
            (this.scrollablePixelsX || this.scrollablePixelsY) && !t && (this.scrollablePlotArea = t = new g(this)), t?.applyFixed();
        }
        function u() {
            this.chart.scrollablePlotArea && (this.chart.scrollablePlotArea.isDirty = !0);
        }
        class g {
            static compose(t, e, i) {
                c(o, this.compose) && (n(t, "afterInit", u), n(e, "afterSetChartSize", (t)=>this.afterSetSize(t.target, t)), n(e, "render", p), n(i, "show", u));
            }
            static afterSetSize(t, e) {
                let i, s, r;
                let { minWidth: o, minHeight: n } = t.options.chart.scrollablePlotArea || {}, { clipBox: a, plotBox: h, inverted: c, renderer: p } = t;
                if (!p.forExport && (o ? (t.scrollablePixelsX = i = Math.max(0, o - t.chartWidth), i && (t.scrollablePlotBox = d(t.plotBox), h.width = t.plotWidth += i, a[c ? "height" : "width"] += i, r = !0)) : n && (t.scrollablePixelsY = s = Math.max(0, n - t.chartHeight), l(s) && (t.scrollablePlotBox = d(t.plotBox), h.height = t.plotHeight += s, a[c ? "width" : "height"] += s, r = !1)), l(r) && !e.skipAxes)) for (let e of t.axes)e.horiz === r && (e.setAxisSize(), e.setAxisTranslation());
            }
            constructor(t){
                let e;
                let s = t.options.chart, r = i.getRendererType(), o = s.scrollablePlotArea || {}, l = this.moveFixedElements.bind(this), d = {
                    WebkitOverflowScrolling: "touch",
                    overflowX: "hidden",
                    overflowY: "hidden"
                };
                t.scrollablePixelsX && (d.overflowX = "auto"), t.scrollablePixelsY && (d.overflowY = "auto"), this.chart = t;
                let c = this.parentDiv = a("div", {
                    className: "highcharts-scrolling-parent"
                }, {
                    position: "relative"
                }, t.renderTo), p = this.scrollingContainer = a("div", {
                    className: "highcharts-scrolling"
                }, d, c), u = this.innerContainer = a("div", {
                    className: "highcharts-inner-container"
                }, void 0, p), g = this.fixedDiv = a("div", {
                    className: "highcharts-fixed"
                }, {
                    position: "absolute",
                    overflow: "hidden",
                    pointerEvents: "none",
                    zIndex: (s.style?.zIndex || 0) + 2,
                    top: 0
                }, void 0, !0), f = this.fixedRenderer = new r(g, t.chartWidth, t.chartHeight, s.style);
                this.mask = f.path().attr({
                    fill: s.backgroundColor || "#fff",
                    "fill-opacity": o.opacity ?? .85,
                    zIndex: -1
                }).addClass("highcharts-scrollable-mask").add(), p.parentNode.insertBefore(g, p), h(t.renderTo, {
                    overflow: "visible"
                }), n(t, "afterShowResetZoom", l), n(t, "afterApplyDrilldown", l), n(t, "afterLayOutTitles", l), n(p, "scroll", ()=>{
                    let { pointer: i, hoverPoint: s } = t;
                    i && (delete i.chartPosition, s && (e = s), i.runPointActions(void 0, e, !0));
                }), u.appendChild(t.container);
            }
            applyFixed() {
                let { chart: t, fixedRenderer: e, isDirty: i, scrollingContainer: s } = this, { axisOffset: o, chartWidth: n, chartHeight: a, container: d, plotHeight: c, plotLeft: p, plotTop: u, plotWidth: g, scrollablePixelsX: f = 0, scrollablePixelsY: m = 0 } = t, { scrollPositionX: x = 0, scrollPositionY: y = 0 } = t.options.chart.scrollablePlotArea || {}, b = n + f, v = a + m;
                e.setSize(n, a), (i ?? !0) && (this.isDirty = !1, this.moveFixedElements()), r(t.container), h(d, {
                    width: `${b}px`,
                    height: `${v}px`
                }), t.renderer.boxWrapper.attr({
                    width: b,
                    height: v,
                    viewBox: [
                        0,
                        0,
                        b,
                        v
                    ].join(" ")
                }), t.chartBackground?.attr({
                    width: b,
                    height: v
                }), h(s, {
                    width: `${n}px`,
                    height: `${a}px`
                }), l(i) || (s.scrollLeft = f * x, s.scrollTop = m * y);
                let S = u - o[0] - 1, C = p - o[3] - 1, k = u + c + o[2] + 1, M = p + g + o[1] + 1, w = p + g - f, T = u + c - m, A = [
                    [
                        "M",
                        0,
                        0
                    ]
                ];
                f ? A = [
                    [
                        "M",
                        0,
                        S
                    ],
                    [
                        "L",
                        p - 1,
                        S
                    ],
                    [
                        "L",
                        p - 1,
                        k
                    ],
                    [
                        "L",
                        0,
                        k
                    ],
                    [
                        "Z"
                    ],
                    [
                        "M",
                        w,
                        S
                    ],
                    [
                        "L",
                        n,
                        S
                    ],
                    [
                        "L",
                        n,
                        k
                    ],
                    [
                        "L",
                        w,
                        k
                    ],
                    [
                        "Z"
                    ]
                ] : m && (A = [
                    [
                        "M",
                        C,
                        0
                    ],
                    [
                        "L",
                        C,
                        u - 1
                    ],
                    [
                        "L",
                        M,
                        u - 1
                    ],
                    [
                        "L",
                        M,
                        0
                    ],
                    [
                        "Z"
                    ],
                    [
                        "M",
                        C,
                        T
                    ],
                    [
                        "L",
                        C,
                        a
                    ],
                    [
                        "L",
                        M,
                        a
                    ],
                    [
                        "L",
                        M,
                        T
                    ],
                    [
                        "Z"
                    ]
                ]), "adjustHeight" !== t.redrawTrigger && this.mask.attr({
                    d: A
                });
            }
            moveFixedElements() {
                let t;
                let { container: e, inverted: i, scrollablePixelsX: s, scrollablePixelsY: r } = this.chart, o = this.fixedRenderer, n = g.fixedSelectors;
                for (let a of (s && !i ? t = ".highcharts-yaxis" : s && i ? t = ".highcharts-xaxis" : r && !i ? t = ".highcharts-xaxis" : r && i && (t = ".highcharts-yaxis"), t && n.push(`${t}:not(.highcharts-radial-axis)`, `${t}-labels:not(.highcharts-radial-axis-labels)`), n))[].forEach.call(e.querySelectorAll(a), (t)=>{
                    (t.namespaceURI === o.SVG_NS ? o.box : o.box.parentNode).appendChild(t), t.style.pointerEvents = "auto";
                });
            }
        }
        return g.fixedSelectors = [
            ".highcharts-breadcrumbs-group",
            ".highcharts-contextbutton",
            ".highcharts-caption",
            ".highcharts-credits",
            ".highcharts-drillup-button",
            ".highcharts-legend",
            ".highcharts-legend-checkbox",
            ".highcharts-navigator-series",
            ".highcharts-navigator-xaxis",
            ".highcharts-navigator-yaxis",
            ".highcharts-navigator",
            ".highcharts-range-selector-group",
            ".highcharts-reset-zoom",
            ".highcharts-scrollbar",
            ".highcharts-subtitle",
            ".highcharts-title"
        ], g;
    }), i(e, "Core/Axis/Stacking/StackItem.js", [
        e["Core/Templating.js"],
        e["Core/Series/SeriesRegistry.js"],
        e["Core/Utilities.js"]
    ], function(t, e, i) {
        let { format: s } = t, { series: r } = e, { destroyObjectProperties: o, fireEvent: n, isNumber: a, pick: h } = i;
        return class {
            constructor(t, e, i, s, r){
                let o = t.chart.inverted, n = t.reversed;
                this.axis = t;
                let a = this.isNegative = !!i != !!n;
                this.options = e = e || {}, this.x = s, this.total = null, this.cumulative = null, this.points = {}, this.hasValidPoints = !1, this.stack = r, this.leftCliff = 0, this.rightCliff = 0, this.alignOptions = {
                    align: e.align || (o ? a ? "left" : "right" : "center"),
                    verticalAlign: e.verticalAlign || (o ? "middle" : a ? "bottom" : "top"),
                    y: e.y,
                    x: e.x
                }, this.textAlign = e.textAlign || (o ? a ? "right" : "left" : "center");
            }
            destroy() {
                o(this, this.axis);
            }
            render(t) {
                let e = this.axis.chart, i = this.options, r = i.format, o = r ? s(r, this, e) : i.formatter.call(this);
                if (this.label) this.label.attr({
                    text: o,
                    visibility: "hidden"
                });
                else {
                    this.label = e.renderer.label(o, null, void 0, i.shape, void 0, void 0, i.useHTML, !1, "stack-labels");
                    let s = {
                        r: i.borderRadius || 0,
                        text: o,
                        padding: h(i.padding, 5),
                        visibility: "hidden"
                    };
                    e.styledMode || (s.fill = i.backgroundColor, s.stroke = i.borderColor, s["stroke-width"] = i.borderWidth, this.label.css(i.style || {})), this.label.attr(s), this.label.added || this.label.add(t);
                }
                this.label.labelrank = e.plotSizeY, n(this, "afterRender");
            }
            setOffset(t, e, i, s, o, l) {
                let { alignOptions: d, axis: c, label: p, options: u, textAlign: g } = this, f = c.chart, m = this.getStackBox({
                    xOffset: t,
                    width: e,
                    boxBottom: i,
                    boxTop: s,
                    defaultX: o,
                    xAxis: l
                }), { verticalAlign: x } = d;
                if (p && m) {
                    let t = p.getBBox(void 0, 0), e = p.padding, i = "justify" === h(u.overflow, "justify"), s;
                    d.x = u.x || 0, d.y = u.y || 0;
                    let { x: o, y: n } = this.adjustStackPosition({
                        labelBox: t,
                        verticalAlign: x,
                        textAlign: g
                    });
                    m.x -= o, m.y -= n, p.align(d, !1, m), (s = f.isInsidePlot(p.alignAttr.x + d.x + o, p.alignAttr.y + d.y + n)) || (i = !1), i && r.prototype.justifyDataLabel.call(c, p, d, p.alignAttr, t, m), p.attr({
                        x: p.alignAttr.x,
                        y: p.alignAttr.y,
                        rotation: u.rotation,
                        rotationOriginX: t.width * ({
                            left: 0,
                            center: .5,
                            right: 1
                        })[u.textAlign || "center"],
                        rotationOriginY: t.height / 2
                    }), h(!i && u.crop, !0) && (s = a(p.x) && a(p.y) && f.isInsidePlot(p.x - e + (p.width || 0), p.y) && f.isInsidePlot(p.x + e, p.y)), p[s ? "show" : "hide"]();
                }
                n(this, "afterSetOffset", {
                    xOffset: t,
                    width: e
                });
            }
            adjustStackPosition({ labelBox: t, verticalAlign: e, textAlign: i }) {
                let s = {
                    bottom: 0,
                    middle: 1,
                    top: 2,
                    right: 1,
                    center: 0,
                    left: -1
                }, r = s[e], o = s[i];
                return {
                    x: t.width / 2 + t.width / 2 * o,
                    y: t.height / 2 * r
                };
            }
            getStackBox(t) {
                let e = this.axis, i = e.chart, { boxTop: s, defaultX: r, xOffset: o, width: n, boxBottom: l } = t, d = e.stacking.usePercentage ? 100 : h(s, this.total, 0), c = e.toPixels(d), p = t.xAxis || i.xAxis[0], u = h(r, p.translate(this.x)) + o, g = Math.abs(c - e.toPixels(l || a(e.min) && e.logarithmic && e.logarithmic.lin2log(e.min) || 0)), f = i.inverted, m = this.isNegative;
                return f ? {
                    x: (m ? c : c - g) - i.plotLeft,
                    y: p.height - u - n + p.top - i.plotTop,
                    width: g,
                    height: n
                } : {
                    x: u + p.transB - i.plotLeft,
                    y: (m ? c - g : c) - i.plotTop,
                    width: n,
                    height: g
                };
            }
        };
    }), i(e, "Core/Axis/Stacking/StackingAxis.js", [
        e["Core/Animation/AnimationUtilities.js"],
        e["Core/Axis/Axis.js"],
        e["Core/Series/SeriesRegistry.js"],
        e["Core/Axis/Stacking/StackItem.js"],
        e["Core/Utilities.js"]
    ], function(t, e, i, s, r) {
        var o;
        let { getDeferredAnimation: n } = t, { series: { prototype: a } } = i, { addEvent: h, correctFloat: l, defined: d, destroyObjectProperties: c, fireEvent: p, isArray: u, isNumber: g, objectEach: f, pick: m } = r;
        function x() {
            let t = this.inverted;
            this.axes.forEach((t)=>{
                t.stacking && t.stacking.stacks && t.hasVisibleSeries && (t.stacking.oldStacks = t.stacking.stacks);
            }), this.series.forEach((e)=>{
                let i = e.xAxis && e.xAxis.options || {};
                e.options.stacking && e.reserveSpace() && (e.stackKey = [
                    e.type,
                    m(e.options.stack, ""),
                    t ? i.top : i.left,
                    t ? i.height : i.width
                ].join(","));
            });
        }
        function y() {
            let t = this.stacking;
            if (t) {
                let e = t.stacks;
                f(e, (t, i)=>{
                    c(t), delete e[i];
                }), t.stackTotalGroup?.destroy();
            }
        }
        function b() {
            this.stacking || (this.stacking = new w(this));
        }
        function v(t, e, i, s) {
            return !d(t) || t.x !== e || s && t.stackKey !== s ? t = {
                x: e,
                index: 0,
                key: s,
                stackKey: s
            } : t.index++, t.key = [
                i,
                e,
                t.index
            ].join(","), t;
        }
        function S() {
            let t;
            let e = this, i = e.yAxis, s = e.stackKey || "", r = i.stacking.stacks, o = e.processedXData, n = e.options.stacking, a = e[n + "Stacker"];
            a && [
                s,
                "-" + s
            ].forEach((i)=>{
                let s = o.length, n, h, l;
                for(; s--;)n = o[s], t = e.getStackIndicator(t, n, e.index, i), h = r[i]?.[n], (l = h?.points[t.key || ""]) && a.call(e, l, h, s);
            });
        }
        function C(t, e, i) {
            let s = e.total ? 100 / e.total : 0;
            t[0] = l(t[0] * s), t[1] = l(t[1] * s), this.stackedYData[i] = t[1];
        }
        function k(t) {
            (this.is("column") || this.is("columnrange")) && (this.options.centerInCategory && !this.options.stacking && this.chart.series.length > 1 ? a.setStackedPoints.call(this, t, "group") : t.stacking.resetStacks());
        }
        function M(t, e) {
            let i, r, o, n, a, h, c, p, g;
            let f = e || this.options.stacking;
            if (!f || !this.reserveSpace() || (({
                group: "xAxis"
            })[f] || "yAxis") !== t.coll) return;
            let x = this.processedXData, y = this.processedYData, b = [], v = y.length, S = this.options, C = S.threshold || 0, k = S.startFromThreshold ? C : 0, M = S.stack, w = e ? `${this.type},${f}` : this.stackKey || "", T = "-" + w, A = this.negStacks, P = t.stacking, L = P.stacks, O = P.oldStacks;
            for(P.stacksTouched += 1, c = 0; c < v; c++){
                p = x[c], g = y[c], h = (i = this.getStackIndicator(i, p, this.index)).key || "", L[a = (r = A && g < (k ? 0 : C)) ? T : w] || (L[a] = {}), L[a][p] || (O[a]?.[p] ? (L[a][p] = O[a][p], L[a][p].total = null) : L[a][p] = new s(t, t.options.stackLabels, !!r, p, M)), o = L[a][p], null !== g ? (o.points[h] = o.points[this.index] = [
                    m(o.cumulative, k)
                ], d(o.cumulative) || (o.base = h), o.touched = P.stacksTouched, i.index > 0 && !1 === this.singleStacks && (o.points[h][0] = o.points[this.index + "," + p + ",0"][0])) : (delete o.points[h], delete o.points[this.index]);
                let e = o.total || 0;
                "percent" === f ? (n = r ? w : T, e = A && L[n]?.[p] ? (n = L[n][p]).total = Math.max(n.total || 0, e) + Math.abs(g) || 0 : l(e + (Math.abs(g) || 0))) : "group" === f ? (u(g) && (g = g[0]), null !== g && e++) : e = l(e + (g || 0)), "group" === f ? o.cumulative = (e || 1) - 1 : o.cumulative = l(m(o.cumulative, k) + (g || 0)), o.total = e, null !== g && (o.points[h].push(o.cumulative), b[c] = o.cumulative, o.hasValidPoints = !0);
            }
            "percent" === f && (P.usePercentage = !0), "group" !== f && (this.stackedYData = b), P.oldStacks = {};
        }
        class w {
            constructor(t){
                this.oldStacks = {}, this.stacks = {}, this.stacksTouched = 0, this.axis = t;
            }
            buildStacks() {
                let t, e;
                let i = this.axis, s = i.series, r = "xAxis" === i.coll, o = i.options.reversedStacks, n = s.length;
                for(this.resetStacks(), this.usePercentage = !1, e = n; e--;)t = s[o ? e : n - e - 1], r && t.setGroupedPoints(i), t.setStackedPoints(i);
                if (!r) for(e = 0; e < n; e++)s[e].modifyStacks();
                p(i, "afterBuildStacks");
            }
            cleanStacks() {
                this.oldStacks && (this.stacks = this.oldStacks, f(this.stacks, (t)=>{
                    f(t, (t)=>{
                        t.cumulative = t.total;
                    });
                }));
            }
            resetStacks() {
                f(this.stacks, (t)=>{
                    f(t, (e, i)=>{
                        g(e.touched) && e.touched < this.stacksTouched ? (e.destroy(), delete t[i]) : (e.total = null, e.cumulative = null);
                    });
                });
            }
            renderStackTotals() {
                let t = this.axis, e = t.chart, i = e.renderer, s = this.stacks, r = n(e, t.options.stackLabels?.animation || !1), o = this.stackTotalGroup = this.stackTotalGroup || i.g("stack-labels").attr({
                    zIndex: 6,
                    opacity: 0
                }).add();
                o.translate(e.plotLeft, e.plotTop), f(s, (t)=>{
                    f(t, (t)=>{
                        t.render(o);
                    });
                }), o.animate({
                    opacity: 1
                }, r);
            }
        }
        return (o || (o = {})).compose = function(t, e, i) {
            let s = e.prototype, r = i.prototype;
            s.getStacks || (h(t, "init", b), h(t, "destroy", y), s.getStacks = x, r.getStackIndicator = v, r.modifyStacks = S, r.percentStacker = C, r.setGroupedPoints = k, r.setStackedPoints = M);
        }, o;
    }), i(e, "Series/Line/LineSeries.js", [
        e["Core/Series/Series.js"],
        e["Core/Series/SeriesRegistry.js"],
        e["Core/Utilities.js"]
    ], function(t, e, i) {
        let { defined: s, merge: r, isObject: o } = i;
        class n extends t {
            drawGraph() {
                let t = this.options, e = (this.gappedPath || this.getGraphPath).call(this), i = this.chart.styledMode;
                [
                    this,
                    ...this.zones
                ].forEach((s, n)=>{
                    let a, h = s.graph, l = h ? "animate" : "attr", d = s.dashStyle || t.dashStyle;
                    h ? (h.endX = this.preventGraphAnimation ? null : e.xMap, h.animate({
                        d: e
                    })) : e.length && (s.graph = h = this.chart.renderer.path(e).addClass("highcharts-graph" + (n ? ` highcharts-zone-graph-${n - 1} ` : " ") + (n && s.className || "")).attr({
                        zIndex: 1
                    }).add(this.group)), h && !i && (a = {
                        stroke: !n && t.lineColor || s.color || this.color || "#cccccc",
                        "stroke-width": t.lineWidth || 0,
                        fill: this.fillGraph && this.color || "none"
                    }, d ? a.dashstyle = d : "square" !== t.linecap && (a["stroke-linecap"] = a["stroke-linejoin"] = "round"), h[l](a).shadow(n < 2 && t.shadow && r({
                        filterUnits: "userSpaceOnUse"
                    }, o(t.shadow) ? t.shadow : {}))), h && (h.startX = e.xMap, h.isArea = e.isArea);
                });
            }
            getGraphPath(t, e, i) {
                let r = this, o = r.options, n = [], a = [], h, l = o.step, d = (t = t || r.points).reversed;
                return d && t.reverse(), (l = ({
                    right: 1,
                    center: 2
                })[l] || l && 3) && d && (l = 4 - l), (t = this.getValidPoints(t, !1, !(o.connectNulls && !e && !i))).forEach(function(d, c) {
                    let p;
                    let u = d.plotX, g = d.plotY, f = t[c - 1], m = d.isNull || "number" != typeof g;
                    (d.leftCliff || f && f.rightCliff) && !i && (h = !0), m && !s(e) && c > 0 ? h = !o.connectNulls : m && !e ? h = !0 : (0 === c || h ? p = [
                        [
                            "M",
                            d.plotX,
                            d.plotY
                        ]
                    ] : r.getPointSpline ? p = [
                        r.getPointSpline(t, d, c)
                    ] : l ? (p = 1 === l ? [
                        [
                            "L",
                            f.plotX,
                            g
                        ]
                    ] : 2 === l ? [
                        [
                            "L",
                            (f.plotX + u) / 2,
                            f.plotY
                        ],
                        [
                            "L",
                            (f.plotX + u) / 2,
                            g
                        ]
                    ] : [
                        [
                            "L",
                            u,
                            f.plotY
                        ]
                    ]).push([
                        "L",
                        u,
                        g
                    ]) : p = [
                        [
                            "L",
                            u,
                            g
                        ]
                    ], a.push(d.x), l && (a.push(d.x), 2 === l && a.push(d.x)), n.push.apply(n, p), h = !1);
                }), n.xMap = a, r.graphPath = n, n;
            }
        }
        return n.defaultOptions = r(t.defaultOptions, {
            legendSymbol: "lineMarker"
        }), e.registerSeriesType("line", n), n;
    }), i(e, "Series/Area/AreaSeriesDefaults.js", [], function() {
        return {
            threshold: 0,
            legendSymbol: "areaMarker"
        };
    }), i(e, "Series/Area/AreaSeries.js", [
        e["Series/Area/AreaSeriesDefaults.js"],
        e["Core/Series/SeriesRegistry.js"],
        e["Core/Utilities.js"]
    ], function(t, e, i) {
        let { seriesTypes: { line: s } } = e, { extend: r, merge: o, objectEach: n, pick: a } = i;
        class h extends s {
            drawGraph() {
                this.areaPath = [], super.drawGraph.apply(this);
                let { areaPath: t, options: e } = this;
                [
                    this,
                    ...this.zones
                ].forEach((i, s)=>{
                    let r = {}, o = i.fillColor || e.fillColor, n = i.area, a = n ? "animate" : "attr";
                    n ? (n.endX = this.preventGraphAnimation ? null : t.xMap, n.animate({
                        d: t
                    })) : (r.zIndex = 0, (n = i.area = this.chart.renderer.path(t).addClass("highcharts-area" + (s ? ` highcharts-zone-area-${s - 1} ` : " ") + (s && i.className || "")).add(this.group)).isArea = !0), this.chart.styledMode || (r.fill = o || i.color || this.color, r["fill-opacity"] = o ? 1 : e.fillOpacity ?? .75, n.css({
                        pointerEvents: this.stickyTracking ? "none" : "auto"
                    })), n[a](r), n.startX = t.xMap, n.shiftUnit = e.step ? 2 : 1;
                });
            }
            getGraphPath(t) {
                let e, i, r;
                let o = s.prototype.getGraphPath, n = this.options, h = n.stacking, l = this.yAxis, d = [], c = [], p = this.index, u = l.stacking.stacks[this.stackKey], g = n.threshold, f = Math.round(l.getThreshold(n.threshold)), m = a(n.connectNulls, "percent" === h), x = function(i, s, r) {
                    let o = t[i], n = h && u[o.x].points[p], a = o[r + "Null"] || 0, m = o[r + "Cliff"] || 0, x, y, b = !0;
                    m || a ? (x = (a ? n[0] : n[1]) + m, y = n[0] + m, b = !!a) : !h && t[s] && t[s].isNull && (x = y = g), void 0 !== x && (c.push({
                        plotX: e,
                        plotY: null === x ? f : l.getThreshold(x),
                        isNull: b,
                        isCliff: !0
                    }), d.push({
                        plotX: e,
                        plotY: null === y ? f : l.getThreshold(y),
                        doCurve: !1
                    }));
                };
                t = t || this.points, h && (t = this.getStackPoints(t));
                for(let s = 0, o = t.length; s < o; ++s)h || (t[s].leftCliff = t[s].rightCliff = t[s].leftNull = t[s].rightNull = void 0), i = t[s].isNull, e = a(t[s].rectPlotX, t[s].plotX), r = h ? a(t[s].yBottom, f) : f, i && !m || (m || x(s, s - 1, "left"), i && !h && m || (c.push(t[s]), d.push({
                    x: s,
                    plotX: e,
                    plotY: r
                })), m || x(s, s + 1, "right"));
                let y = o.call(this, c, !0, !0);
                d.reversed = !0;
                let b = o.call(this, d, !0, !0), v = b[0];
                v && "M" === v[0] && (b[0] = [
                    "L",
                    v[1],
                    v[2]
                ]);
                let S = y.concat(b);
                S.length && S.push([
                    "Z"
                ]);
                let C = o.call(this, c, !1, m);
                return this.chart.series.length > 1 && h && c.some((t)=>t.isCliff) && (S.hasStackedCliffs = C.hasStackedCliffs = !0), S.xMap = y.xMap, this.areaPath = S, C;
            }
            getStackPoints(t) {
                let e = this, i = [], s = [], r = this.xAxis, o = this.yAxis, h = o.stacking.stacks[this.stackKey], l = {}, d = o.series, c = d.length, p = o.options.reversedStacks ? 1 : -1, u = d.indexOf(e);
                if (t = t || this.points, this.options.stacking) {
                    for(let e = 0; e < t.length; e++)t[e].leftNull = t[e].rightNull = void 0, l[t[e].x] = t[e];
                    n(h, function(t, e) {
                        null !== t.total && s.push(e);
                    }), s.sort(function(t, e) {
                        return t - e;
                    });
                    let g = d.map((t)=>t.visible);
                    s.forEach(function(t, n) {
                        let f = 0, m, x;
                        if (l[t] && !l[t].isNull) i.push(l[t]), [
                            -1,
                            1
                        ].forEach(function(i) {
                            let r = 1 === i ? "rightNull" : "leftNull", o = h[s[n + i]], a = 0;
                            if (o) {
                                let i = u;
                                for(; i >= 0 && i < c;){
                                    let s = d[i].index;
                                    !(m = o.points[s]) && (s === e.index ? l[t][r] = !0 : g[i] && (x = h[t].points[s]) && (a -= x[1] - x[0])), i += p;
                                }
                            }
                            l[t][1 === i ? "rightCliff" : "leftCliff"] = a;
                        });
                        else {
                            let e = u;
                            for(; e >= 0 && e < c;){
                                let i = d[e].index;
                                if (m = h[t].points[i]) {
                                    f = m[1];
                                    break;
                                }
                                e += p;
                            }
                            f = a(f, 0), f = o.translate(f, 0, 1, 0, 1), i.push({
                                isNull: !0,
                                plotX: r.translate(t, 0, 0, 0, 1),
                                x: t,
                                plotY: f,
                                yBottom: f
                            });
                        }
                    });
                }
                return i;
            }
        }
        return h.defaultOptions = o(s.defaultOptions, t), r(h.prototype, {
            singleStacks: !1
        }), e.registerSeriesType("area", h), h;
    }), i(e, "Series/Spline/SplineSeries.js", [
        e["Core/Series/SeriesRegistry.js"],
        e["Core/Utilities.js"]
    ], function(t, e) {
        let { line: i } = t.seriesTypes, { merge: s, pick: r } = e;
        class o extends i {
            getPointSpline(t, e, i) {
                let s, o, n, a;
                let h = e.plotX || 0, l = e.plotY || 0, d = t[i - 1], c = t[i + 1];
                function p(t) {
                    return t && !t.isNull && !1 !== t.doCurve && !e.isCliff;
                }
                if (p(d) && p(c)) {
                    let t = d.plotX || 0, i = d.plotY || 0, r = c.plotX || 0, p = c.plotY || 0, u = 0;
                    s = (1.5 * h + t) / 2.5, o = (1.5 * l + i) / 2.5, n = (1.5 * h + r) / 2.5, a = (1.5 * l + p) / 2.5, n !== s && (u = (a - o) * (n - h) / (n - s) + l - a), o += u, a += u, o > i && o > l ? (o = Math.max(i, l), a = 2 * l - o) : o < i && o < l && (o = Math.min(i, l), a = 2 * l - o), a > p && a > l ? (a = Math.max(p, l), o = 2 * l - a) : a < p && a < l && (a = Math.min(p, l), o = 2 * l - a), e.rightContX = n, e.rightContY = a, e.controlPoints = {
                        low: [
                            s,
                            o
                        ],
                        high: [
                            n,
                            a
                        ]
                    };
                }
                let u = [
                    "C",
                    r(d.rightContX, d.plotX, 0),
                    r(d.rightContY, d.plotY, 0),
                    r(s, h, 0),
                    r(o, l, 0),
                    h,
                    l
                ];
                return d.rightContX = d.rightContY = void 0, u;
            }
        }
        return o.defaultOptions = s(i.defaultOptions), t.registerSeriesType("spline", o), o;
    }), i(e, "Series/AreaSpline/AreaSplineSeries.js", [
        e["Series/Spline/SplineSeries.js"],
        e["Core/Series/SeriesRegistry.js"],
        e["Core/Utilities.js"]
    ], function(t, e, i) {
        let { area: s, area: { prototype: r } } = e.seriesTypes, { extend: o, merge: n } = i;
        class a extends t {
        }
        return a.defaultOptions = n(t.defaultOptions, s.defaultOptions), o(a.prototype, {
            getGraphPath: r.getGraphPath,
            getStackPoints: r.getStackPoints,
            drawGraph: r.drawGraph
        }), e.registerSeriesType("areaspline", a), a;
    }), i(e, "Series/Column/ColumnSeriesDefaults.js", [], function() {
        return {
            borderRadius: 3,
            centerInCategory: !1,
            groupPadding: .2,
            marker: null,
            pointPadding: .1,
            minPointLength: 0,
            cropThreshold: 50,
            pointRange: null,
            states: {
                hover: {
                    halo: !1,
                    brightness: .1
                },
                select: {
                    color: "#cccccc",
                    borderColor: "#000000"
                }
            },
            dataLabels: {
                align: void 0,
                verticalAlign: void 0,
                y: void 0
            },
            startFromThreshold: !0,
            stickyTracking: !1,
            tooltip: {
                distance: 6
            },
            threshold: 0,
            borderColor: "#ffffff"
        };
    }), i(e, "Series/Column/ColumnSeries.js", [
        e["Core/Animation/AnimationUtilities.js"],
        e["Core/Color/Color.js"],
        e["Series/Column/ColumnSeriesDefaults.js"],
        e["Core/Globals.js"],
        e["Core/Series/Series.js"],
        e["Core/Series/SeriesRegistry.js"],
        e["Core/Utilities.js"]
    ], function(t, e, i, s, r, o, n) {
        let { animObject: a } = t, { parse: h } = e, { noop: l } = s, { clamp: d, crisp: c, defined: p, extend: u, fireEvent: g, isArray: f, isNumber: m, merge: x, pick: y, objectEach: b } = n;
        class v extends r {
            animate(t) {
                let e, i;
                let s = this, r = this.yAxis, o = r.pos, n = r.reversed, h = s.options, { clipOffset: l, inverted: c } = this.chart, p = {}, g = c ? "translateX" : "translateY";
                t && l ? (p.scaleY = .001, i = d(r.toPixels(h.threshold), o, o + r.len), c ? (i += n ? -Math.floor(l[0]) : Math.ceil(l[2]), p.translateX = i - r.len) : (i += n ? Math.ceil(l[0]) : -Math.floor(l[2]), p.translateY = i), s.clipBox && s.setClip(), s.group.attr(p)) : (e = Number(s.group.attr(g)), s.group.animate({
                    scaleY: 1
                }, u(a(s.options.animation), {
                    step: function(t, i) {
                        s.group && (p[g] = e + i.pos * (o - e), s.group.attr(p));
                    }
                })));
            }
            init(t, e) {
                super.init.apply(this, arguments);
                let i = this;
                (t = i.chart).hasRendered && t.series.forEach(function(t) {
                    t.type === i.type && (t.isDirty = !0);
                });
            }
            getColumnMetrics() {
                let t = this, e = t.options, i = t.xAxis, s = t.yAxis, r = i.options.reversedStacks, o = i.reversed && !r || !i.reversed && r, n = {}, a, h = 0;
                !1 === e.grouping ? h = 1 : t.chart.series.forEach(function(e) {
                    let i;
                    let r = e.yAxis, o = e.options;
                    e.type === t.type && e.reserveSpace() && s.len === r.len && s.pos === r.pos && (o.stacking && "group" !== o.stacking ? (void 0 === n[a = e.stackKey] && (n[a] = h++), i = n[a]) : !1 !== o.grouping && (i = h++), e.columnIndex = i);
                });
                let l = Math.min(Math.abs(i.transA) * (!i.brokenAxis?.hasBreaks && i.ordinal?.slope || e.pointRange || i.closestPointRange || i.tickInterval || 1), i.len), d = l * e.groupPadding, c = (l - 2 * d) / (h || 1), p = Math.min(e.maxPointWidth || i.len, y(e.pointWidth, c * (1 - 2 * e.pointPadding))), u = (t.columnIndex || 0) + (o ? 1 : 0);
                return t.columnMetrics = {
                    width: p,
                    offset: (c - p) / 2 + (d + u * c - l / 2) * (o ? -1 : 1),
                    paddedWidth: c,
                    columnCount: h
                }, t.columnMetrics;
            }
            crispCol(t, e, i, s) {
                let r = this.borderWidth, o = this.chart.inverted;
                return s = c(e + s, r, o) - (e = c(e, r, o)), this.options.crisp && (i = c(t + i, r) - (t = c(t, r))), {
                    x: t,
                    y: e,
                    width: i,
                    height: s
                };
            }
            adjustForMissingColumns(t, e, i, s) {
                if (!i.isNull && s.columnCount > 1) {
                    let r = this.xAxis.series.filter((t)=>t.visible).map((t)=>t.index), o = 0, n = 0;
                    b(this.xAxis.stacking?.stacks, (t)=>{
                        if ("number" == typeof i.x) {
                            let e = t[i.x.toString()];
                            if (e && f(e.points[this.index])) {
                                let t = Object.keys(e.points).filter((t)=>!t.match(",") && e.points[t] && e.points[t].length > 1).map(parseFloat).filter((t)=>-1 !== r.indexOf(t)).sort((t, e)=>e - t);
                                o = t.indexOf(this.index), n = t.length;
                            }
                        }
                    }), o = this.xAxis.reversed ? n - 1 - o : o;
                    let a = (n - 1) * s.paddedWidth + e;
                    t = (i.plotX || 0) + a / 2 - e - o * s.paddedWidth;
                }
                return t;
            }
            translate() {
                let t = this, e = t.chart, i = t.options, s = t.dense = t.closestPointRange * t.xAxis.transA < 2, o = t.borderWidth = y(i.borderWidth, s ? 0 : 1), n = t.xAxis, a = t.yAxis, h = i.threshold, l = y(i.minPointLength, 5), c = t.getColumnMetrics(), u = c.width, f = t.pointXOffset = c.offset, x = t.dataMin, b = t.dataMax, v = t.translatedThreshold = a.getThreshold(h), S = t.barW = Math.max(u, 1 + 2 * o);
                i.pointPadding && (S = Math.ceil(S)), r.prototype.translate.apply(t), t.points.forEach(function(s) {
                    let r = y(s.yBottom, v), o = 999 + Math.abs(r), g = s.plotX || 0, C = d(s.plotY, -o, a.len + o), k, M = Math.min(C, r), w = Math.max(C, r) - M, T = u, A = g + f, P = S;
                    l && Math.abs(w) < l && (w = l, k = !a.reversed && !s.negative || a.reversed && s.negative, m(h) && m(b) && s.y === h && b <= h && (a.min || 0) < h && (x !== b || (a.max || 0) <= h) && (k = !k, s.negative = !s.negative), M = Math.abs(M - v) > l ? r - l : v - (k ? l : 0)), p(s.options.pointWidth) && (A -= Math.round(((T = P = Math.ceil(s.options.pointWidth)) - u) / 2)), i.centerInCategory && !i.stacking && (A = t.adjustForMissingColumns(A, T, s, c)), s.barX = A, s.pointWidth = T, s.tooltipPos = e.inverted ? [
                        d(a.len + a.pos - e.plotLeft - C, a.pos - e.plotLeft, a.len + a.pos - e.plotLeft),
                        n.len + n.pos - e.plotTop - A - P / 2,
                        w
                    ] : [
                        n.left - e.plotLeft + A + P / 2,
                        d(C + a.pos - e.plotTop, a.pos - e.plotTop, a.len + a.pos - e.plotTop),
                        w
                    ], s.shapeType = t.pointClass.prototype.shapeType || "roundedRect", s.shapeArgs = t.crispCol(A, s.isNull ? v : M, P, s.isNull ? 0 : w);
                }), g(this, "afterColumnTranslate");
            }
            drawGraph() {
                this.group[this.dense ? "addClass" : "removeClass"]("highcharts-dense-data");
            }
            pointAttribs(t, e) {
                let i = this.options, s = this.pointAttrToOptions || {}, r = s.stroke || "borderColor", o = s["stroke-width"] || "borderWidth", n, a, l, d = t && t.color || this.color, c = t && t[r] || i[r] || d, p = t && t.options.dashStyle || i.dashStyle, u = t && t[o] || i[o] || this[o] || 0, g = y(t && t.opacity, i.opacity, 1);
                t && this.zones.length && (a = t.getZone(), d = t.options.color || a && (a.color || t.nonZonedColor) || this.color, a && (c = a.borderColor || c, p = a.dashStyle || p, u = a.borderWidth || u)), e && t && (l = (n = x(i.states[e], t.options.states && t.options.states[e] || {})).brightness, d = n.color || void 0 !== l && h(d).brighten(n.brightness).get() || d, c = n[r] || c, u = n[o] || u, p = n.dashStyle || p, g = y(n.opacity, g));
                let f = {
                    fill: d,
                    stroke: c,
                    "stroke-width": u,
                    opacity: g
                };
                return p && (f.dashstyle = p), f;
            }
            drawPoints(t = this.points) {
                let e;
                let i = this, s = this.chart, r = i.options, o = s.renderer, n = r.animationLimit || 250;
                t.forEach(function(t) {
                    let a = t.plotY, h = t.graphic, l = !!h, d = h && s.pointCount < n ? "animate" : "attr";
                    m(a) && null !== t.y ? (e = t.shapeArgs, h && t.hasNewShapeType() && (h = h.destroy()), i.enabledDataSorting && (t.startXPos = i.xAxis.reversed ? -(e && e.width || 0) : i.xAxis.width), !h && (t.graphic = h = o[t.shapeType](e).add(t.group || i.group), h && i.enabledDataSorting && s.hasRendered && s.pointCount < n && (h.attr({
                        x: t.startXPos
                    }), l = !0, d = "animate")), h && l && h[d](x(e)), s.styledMode || h[d](i.pointAttribs(t, t.selected && "select")).shadow(!1 !== t.allowShadow && r.shadow), h && (h.addClass(t.getClassName(), !0), h.attr({
                        visibility: t.visible ? "inherit" : "hidden"
                    }))) : h && (t.graphic = h.destroy());
                });
            }
            drawTracker(t = this.points) {
                let e;
                let i = this, s = i.chart, r = s.pointer, o = function(t) {
                    let e = r?.getPointFromEvent(t);
                    r && e && i.options.enableMouseTracking && (r.isDirectTouch = !0, e.onMouseOver(t));
                };
                t.forEach(function(t) {
                    e = f(t.dataLabels) ? t.dataLabels : t.dataLabel ? [
                        t.dataLabel
                    ] : [], t.graphic && (t.graphic.element.point = t), e.forEach(function(e) {
                        (e.div || e.element).point = t;
                    });
                }), i._hasTracking || (i.trackerGroups.forEach(function(t) {
                    i[t] && (i[t].addClass("highcharts-tracker").on("mouseover", o).on("mouseout", function(t) {
                        r?.onTrackerMouseOut(t);
                    }).on("touchstart", o), !s.styledMode && i.options.cursor && i[t].css({
                        cursor: i.options.cursor
                    }));
                }), i._hasTracking = !0), g(this, "afterDrawTracker");
            }
            remove() {
                let t = this, e = t.chart;
                e.hasRendered && e.series.forEach(function(e) {
                    e.type === t.type && (e.isDirty = !0);
                }), r.prototype.remove.apply(t, arguments);
            }
        }
        return v.defaultOptions = x(r.defaultOptions, i), u(v.prototype, {
            directTouch: !0,
            getSymbol: l,
            negStacks: !0,
            trackerGroups: [
                "group",
                "dataLabelsGroup"
            ]
        }), o.registerSeriesType("column", v), v;
    }), i(e, "Core/Series/DataLabel.js", [
        e["Core/Animation/AnimationUtilities.js"],
        e["Core/Templating.js"],
        e["Core/Utilities.js"]
    ], function(t, e, i) {
        var s;
        let { getDeferredAnimation: r } = t, { format: o } = e, { defined: n, extend: a, fireEvent: h, isArray: l, isString: d, merge: c, objectEach: p, pick: u, pInt: g, splat: f } = i;
        return function(t) {
            function e() {
                return v(this).some((t)=>t?.enabled);
            }
            function i(t, e, i, s, r) {
                let { chart: o, enabledDataSorting: h } = this, l = this.isCartesian && o.inverted, d = t.plotX, p = t.plotY, g = i.rotation || 0, f = n(d) && n(p) && o.isInsidePlot(d, Math.round(p), {
                    inverted: l,
                    paneCoordinates: !0,
                    series: this
                }), m = 0 === g && "justify" === u(i.overflow, h ? "none" : "justify"), x = this.visible && !1 !== t.visible && n(d) && (t.series.forceDL || h && !m || f || u(i.inside, !!this.options.stacking) && s && o.isInsidePlot(d, l ? s.x + 1 : s.y + s.height - 1, {
                    inverted: l,
                    paneCoordinates: !0,
                    series: this
                })), y = t.pos();
                if (x && y) {
                    var b;
                    let n = e.getBBox(), d = e.getBBox(void 0, 0), p = {
                        right: 1,
                        center: .5
                    }[i.align || 0] || 0, v = {
                        bottom: 1,
                        middle: .5
                    }[i.verticalAlign || 0] || 0;
                    if (s = a({
                        x: y[0],
                        y: Math.round(y[1]),
                        width: 0,
                        height: 0
                    }, s || {}), "plotEdges" === i.alignTo && this.isCartesian && (s[l ? "x" : "y"] = 0, s[l ? "width" : "height"] = this.yAxis?.len || 0), a(i, {
                        width: n.width,
                        height: n.height
                    }), b = s, h && this.xAxis && !m && this.setDataLabelStartPos(t, e, r, f, b), e.align(c(i, {
                        width: d.width,
                        height: d.height
                    }), !1, s, !1), e.alignAttr.x += p * (d.width - n.width), e.alignAttr.y += v * (d.height - n.height), e[e.placed ? "animate" : "attr"]({
                        x: e.alignAttr.x + (n.width - d.width) / 2,
                        y: e.alignAttr.y + (n.height - d.height) / 2,
                        rotationOriginX: (e.width || 0) / 2,
                        rotationOriginY: (e.height || 0) / 2
                    }), m && s.height >= 0) this.justifyDataLabel(e, i, e.alignAttr, n, s, r);
                    else if (u(i.crop, !0)) {
                        let { x: t, y: i } = e.alignAttr;
                        x = o.isInsidePlot(t, i, {
                            paneCoordinates: !0,
                            series: this
                        }) && o.isInsidePlot(t + n.width - 1, i + n.height - 1, {
                            paneCoordinates: !0,
                            series: this
                        });
                    }
                    i.shape && !g && e[r ? "attr" : "animate"]({
                        anchorX: y[0],
                        anchorY: y[1]
                    });
                }
                r && h && (e.placed = !1), x || h && !m ? (e.show(), e.placed = !0) : (e.hide(), e.placed = !1);
            }
            function s() {
                return this.plotGroup("dataLabelsGroup", "data-labels", this.hasRendered ? "inherit" : "hidden", this.options.dataLabels.zIndex || 6);
            }
            function m(t) {
                let e = this.hasRendered || 0, i = this.initDataLabelsGroup().attr({
                    opacity: +e
                });
                return !e && i && (this.visible && i.show(), this.options.animation ? i.animate({
                    opacity: 1
                }, t) : i.attr({
                    opacity: 1
                })), i;
            }
            function x(t) {
                let e;
                t = t || this.points;
                let i = this, s = i.chart, a = i.options, l = s.renderer, { backgroundColor: c, plotBackgroundColor: m } = s.options.chart, x = l.getContrast(d(m) && m || d(c) && c || "#000000"), y = v(i), { animation: S, defer: C } = y[0], k = C ? r(s, S, i) : {
                    defer: 0,
                    duration: 0
                };
                h(this, "drawDataLabels"), i.hasDataLabels?.() && (e = this.initDataLabels(k), t.forEach((t)=>{
                    let r = t.dataLabels || [];
                    f(b(y, t.dlOptions || t.options?.dataLabels)).forEach((c, f)=>{
                        let m = c.enabled && (t.visible || t.dataLabelOnHidden) && (!t.isNull || t.dataLabelOnNull) && function(t, e) {
                            let i = e.filter;
                            if (i) {
                                let e = i.operator, s = t[i.property], r = i.value;
                                return ">" === e && s > r || "<" === e && s < r || ">=" === e && s >= r || "<=" === e && s <= r || "==" === e && s == r || "===" === e && s === r || "!=" === e && s != r || "!==" === e && s !== r;
                            }
                            return !0;
                        }(t, c), { backgroundColor: y, borderColor: b, distance: v, style: S = {} } = c, C, k, M, w, T = {}, A = r[f], P = !A, L;
                        m && (k = u(c[t.formatPrefix + "Format"], c.format), C = t.getLabelConfig(), M = n(k) ? o(k, C, s) : (c[t.formatPrefix + "Formatter"] || c.formatter).call(C, c), w = c.rotation, !s.styledMode && (S.color = u(c.color, S.color, d(i.color) ? i.color : void 0, "#000000"), "contrast" === S.color ? ("none" !== y && (L = y), t.contrastColor = l.getContrast("auto" !== L && L || t.color || i.color), S.color = L || !n(v) && c.inside || 0 > g(v || 0) || a.stacking ? t.contrastColor : x) : delete t.contrastColor, a.cursor && (S.cursor = a.cursor)), T = {
                            r: c.borderRadius || 0,
                            rotation: w,
                            padding: c.padding,
                            zIndex: 1
                        }, s.styledMode || (T.fill = "auto" === y ? t.color : y, T.stroke = "auto" === b ? t.color : b, T["stroke-width"] = c.borderWidth), p(T, (t, e)=>{
                            void 0 === t && delete T[e];
                        })), !A || m && n(M) && !!A.div == !!c.useHTML && (A.rotation && c.rotation || A.rotation === c.rotation) || (A = void 0, P = !0), m && n(M) && (A ? T.text = M : (A = l.label(M, 0, 0, c.shape, void 0, void 0, c.useHTML, void 0, "data-label")).addClass(" highcharts-data-label-color-" + t.colorIndex + " " + (c.className || "") + (c.useHTML ? " highcharts-tracker" : "")), A && (A.options = c, A.attr(T), s.styledMode ? S.width && A.css({
                            width: S.width,
                            textOverflow: S.textOverflow
                        }) : A.css(S).shadow(c.shadow), h(A, "beforeAddingDataLabel", {
                            labelOptions: c,
                            point: t
                        }), A.added || A.add(e), i.alignDataLabel(t, A, c, void 0, P), A.isActive = !0, r[f] && r[f] !== A && r[f].destroy(), r[f] = A));
                    });
                    let c = r.length;
                    for(; c--;)r[c] && r[c].isActive ? r[c].isActive = !1 : (r[c]?.destroy(), r.splice(c, 1));
                    t.dataLabel = r[0], t.dataLabels = r;
                })), h(this, "afterDrawDataLabels");
            }
            function y(t, e, i, s, r, o) {
                let n = this.chart, a = e.align, h = e.verticalAlign, l = t.box ? 0 : t.padding || 0, d = n.inverted ? this.yAxis : this.xAxis, c = d ? d.left - n.plotLeft : 0, p = n.inverted ? this.xAxis : this.yAxis, u = p ? p.top - n.plotTop : 0, { x: g = 0, y: f = 0 } = e, m, x;
                return (m = (i.x || 0) + l + c) < 0 && ("right" === a && g >= 0 ? (e.align = "left", e.inside = !0) : g -= m, x = !0), (m = (i.x || 0) + s.width - l + c) > n.plotWidth && ("left" === a && g <= 0 ? (e.align = "right", e.inside = !0) : g += n.plotWidth - m, x = !0), (m = i.y + l + u) < 0 && ("bottom" === h && f >= 0 ? (e.verticalAlign = "top", e.inside = !0) : f -= m, x = !0), (m = (i.y || 0) + s.height - l + u) > n.plotHeight && ("top" === h && f <= 0 ? (e.verticalAlign = "bottom", e.inside = !0) : f += n.plotHeight - m, x = !0), x && (e.x = g, e.y = f, t.placed = !o, t.align(e, void 0, r)), x;
            }
            function b(t, e) {
                let i = [], s;
                if (l(t) && !l(e)) i = t.map(function(t) {
                    return c(t, e);
                });
                else if (l(e) && !l(t)) i = e.map(function(e) {
                    return c(t, e);
                });
                else if (l(t) || l(e)) {
                    if (l(t) && l(e)) for(s = Math.max(t.length, e.length); s--;)i[s] = c(t[s], e[s]);
                } else i = c(t, e);
                return i;
            }
            function v(t) {
                let e = t.chart.options.plotOptions;
                return f(b(b(e?.series?.dataLabels, e?.[t.type]?.dataLabels), t.options.dataLabels));
            }
            function S(t, e, i, s, r) {
                let o = this.chart, n = o.inverted, a = this.xAxis, h = a.reversed, l = ((n ? e.height : e.width) || 0) / 2, d = t.pointWidth, c = d ? d / 2 : 0;
                e.startXPos = n ? r.x : h ? -l - c : a.width - l + c, e.startYPos = n ? h ? this.yAxis.height - l + c : -l - c : r.y, s ? "hidden" === e.visibility && (e.show(), e.attr({
                    opacity: 0
                }).animate({
                    opacity: 1
                })) : e.attr({
                    opacity: 1
                }).animate({
                    opacity: 0
                }, void 0, e.hide), o.hasRendered && (i && e.attr({
                    x: e.startXPos,
                    y: e.startYPos
                }), e.placed = !0);
            }
            t.compose = function(t) {
                let r = t.prototype;
                r.initDataLabels || (r.initDataLabels = m, r.initDataLabelsGroup = s, r.alignDataLabel = i, r.drawDataLabels = x, r.justifyDataLabel = y, r.setDataLabelStartPos = S, r.hasDataLabels = e);
            };
        }(s || (s = {})), s;
    }), i(e, "Series/Column/ColumnDataLabel.js", [
        e["Core/Series/DataLabel.js"],
        e["Core/Globals.js"],
        e["Core/Series/SeriesRegistry.js"],
        e["Core/Utilities.js"]
    ], function(t, e, i, s) {
        var r;
        let { composed: o } = e, { series: n } = i, { merge: a, pick: h, pushUnique: l } = s;
        return function(e) {
            function i(t, e, i, s, r) {
                let o = this.chart.inverted, l = t.series, d = (l.xAxis ? l.xAxis.len : this.chart.plotSizeX) || 0, c = (l.yAxis ? l.yAxis.len : this.chart.plotSizeY) || 0, p = t.dlBox || t.shapeArgs, u = h(t.below, t.plotY > h(this.translatedThreshold, c)), g = h(i.inside, !!this.options.stacking);
                if (p) {
                    if (s = a(p), !("allow" === i.overflow && !1 === i.crop)) {
                        s.y < 0 && (s.height += s.y, s.y = 0);
                        let t = s.y + s.height - c;
                        t > 0 && t < s.height - 1 && (s.height -= t);
                    }
                    o && (s = {
                        x: c - s.y - s.height,
                        y: d - s.x - s.width,
                        width: s.height,
                        height: s.width
                    }), g || (o ? (s.x += u ? 0 : s.width, s.width = 0) : (s.y += u ? s.height : 0, s.height = 0));
                }
                i.align = h(i.align, !o || g ? "center" : u ? "right" : "left"), i.verticalAlign = h(i.verticalAlign, o || g ? "middle" : u ? "top" : "bottom"), n.prototype.alignDataLabel.call(this, t, e, i, s, r), i.inside && t.contrastColor && e.css({
                    color: t.contrastColor
                });
            }
            e.compose = function(e) {
                t.compose(n), l(o, "ColumnDataLabel") && (e.prototype.alignDataLabel = i);
            };
        }(r || (r = {})), r;
    }), i(e, "Series/Bar/BarSeries.js", [
        e["Series/Column/ColumnSeries.js"],
        e["Core/Series/SeriesRegistry.js"],
        e["Core/Utilities.js"]
    ], function(t, e, i) {
        let { extend: s, merge: r } = i;
        class o extends t {
        }
        return o.defaultOptions = r(t.defaultOptions, {}), s(o.prototype, {
            inverted: !0
        }), e.registerSeriesType("bar", o), o;
    }), i(e, "Series/Scatter/ScatterSeriesDefaults.js", [], function() {
        return {
            lineWidth: 0,
            findNearestPointBy: "xy",
            jitter: {
                x: 0,
                y: 0
            },
            marker: {
                enabled: !0
            },
            tooltip: {
                headerFormat: '<span style="color:{point.color}">\u25CF</span> <span style="font-size: 0.8em"> {series.name}</span><br/>',
                pointFormat: "x: <b>{point.x}</b><br/>y: <b>{point.y}</b><br/>"
            }
        };
    }), i(e, "Series/Scatter/ScatterSeries.js", [
        e["Series/Scatter/ScatterSeriesDefaults.js"],
        e["Core/Series/SeriesRegistry.js"],
        e["Core/Utilities.js"]
    ], function(t, e, i) {
        let { column: s, line: r } = e.seriesTypes, { addEvent: o, extend: n, merge: a } = i;
        class h extends r {
            applyJitter() {
                let t = this, e = this.options.jitter, i = this.points.length;
                e && this.points.forEach(function(s, r) {
                    [
                        "x",
                        "y"
                    ].forEach(function(o, n) {
                        if (e[o] && !s.isNull) {
                            let a = `plot${o.toUpperCase()}`, h = t[`${o}Axis`], l = e[o] * h.transA;
                            if (h && !h.logarithmic) {
                                let t = Math.max(0, (s[a] || 0) - l), e = Math.min(h.len, (s[a] || 0) + l);
                                s[a] = t + (e - t) * function(t) {
                                    let e = 1e4 * Math.sin(t);
                                    return e - Math.floor(e);
                                }(r + n * i), "x" === o && (s.clientX = s.plotX);
                            }
                        }
                    });
                });
            }
            drawGraph() {
                this.options.lineWidth ? super.drawGraph() : this.graph && (this.graph = this.graph.destroy());
            }
        }
        return h.defaultOptions = a(r.defaultOptions, t), n(h.prototype, {
            drawTracker: s.prototype.drawTracker,
            sorted: !1,
            requireSorting: !1,
            noSharedTooltip: !0,
            trackerGroups: [
                "group",
                "markerGroup",
                "dataLabelsGroup"
            ]
        }), o(h, "afterTranslate", function() {
            this.applyJitter();
        }), e.registerSeriesType("scatter", h), h;
    }), i(e, "Series/CenteredUtilities.js", [
        e["Core/Globals.js"],
        e["Core/Series/Series.js"],
        e["Core/Utilities.js"]
    ], function(t, e, i) {
        var s, r;
        let { deg2rad: o } = t, { fireEvent: n, isNumber: a, pick: h, relativeLength: l } = i;
        return (r = s || (s = {})).getCenter = function() {
            let t = this.options, i = this.chart, s = 2 * (t.slicedOffset || 0), r = i.plotWidth - 2 * s, o = i.plotHeight - 2 * s, d = t.center, c = Math.min(r, o), p = t.thickness, u, g = t.size, f = t.innerSize || 0, m, x;
            "string" == typeof g && (g = parseFloat(g)), "string" == typeof f && (f = parseFloat(f));
            let y = [
                h(d[0], "50%"),
                h(d[1], "50%"),
                h(g && g < 0 ? void 0 : t.size, "100%"),
                h(f && f < 0 ? void 0 : t.innerSize || 0, "0%")
            ];
            for(!i.angular || this instanceof e || (y[3] = 0), m = 0; m < 4; ++m)x = y[m], u = m < 2 || 2 === m && /%$/.test(x), y[m] = l(x, [
                r,
                o,
                c,
                y[2]
            ][m]) + (u ? s : 0);
            return y[3] > y[2] && (y[3] = y[2]), a(p) && 2 * p < y[2] && p > 0 && (y[3] = y[2] - 2 * p), n(this, "afterGetCenter", {
                positions: y
            }), y;
        }, r.getStartAndEndRadians = function(t, e) {
            let i = a(t) ? t : 0, s = a(e) && e > i && e - i < 360 ? e : i + 360;
            return {
                start: o * (i + -90),
                end: o * (s + -90)
            };
        }, s;
    }), i(e, "Series/Pie/PiePoint.js", [
        e["Core/Animation/AnimationUtilities.js"],
        e["Core/Series/Point.js"],
        e["Core/Utilities.js"]
    ], function(t, e, i) {
        let { setAnimation: s } = t, { addEvent: r, defined: o, extend: n, isNumber: a, pick: h, relativeLength: l } = i;
        class d extends e {
            getConnectorPath(t) {
                let e = t.dataLabelPosition, i = t.options || {}, s = i.connectorShape, r = this.connectorShapes[s] || s;
                return e && r.call(this, {
                    ...e.computed,
                    alignment: e.alignment
                }, e.connectorPosition, i) || [];
            }
            getTranslate() {
                return this.sliced && this.slicedTranslation || {
                    translateX: 0,
                    translateY: 0
                };
            }
            haloPath(t) {
                let e = this.shapeArgs;
                return this.sliced || !this.visible ? [] : this.series.chart.renderer.symbols.arc(e.x, e.y, e.r + t, e.r + t, {
                    innerR: e.r - 1,
                    start: e.start,
                    end: e.end,
                    borderRadius: e.borderRadius
                });
            }
            constructor(t, e, i){
                super(t, e, i), this.half = 0, this.name ?? (this.name = "Slice");
                let s = (t)=>{
                    this.slice("select" === t.type);
                };
                r(this, "select", s), r(this, "unselect", s);
            }
            isValid() {
                return a(this.y) && this.y >= 0;
            }
            setVisible(t, e = !0) {
                t !== this.visible && this.update({
                    visible: t ?? !this.visible
                }, e, void 0, !1);
            }
            slice(t, e, i) {
                let r = this.series;
                s(i, r.chart), e = h(e, !0), this.sliced = this.options.sliced = t = o(t) ? t : !this.sliced, r.options.data[r.data.indexOf(this)] = this.options, this.graphic && this.graphic.animate(this.getTranslate());
            }
        }
        return n(d.prototype, {
            connectorShapes: {
                fixedOffset: function(t, e, i) {
                    let s = e.breakAt, r = e.touchingSliceAt, o = i.softConnector ? [
                        "C",
                        t.x + ("left" === t.alignment ? -5 : 5),
                        t.y,
                        2 * s.x - r.x,
                        2 * s.y - r.y,
                        s.x,
                        s.y
                    ] : [
                        "L",
                        s.x,
                        s.y
                    ];
                    return [
                        [
                            "M",
                            t.x,
                            t.y
                        ],
                        o,
                        [
                            "L",
                            r.x,
                            r.y
                        ]
                    ];
                },
                straight: function(t, e) {
                    let i = e.touchingSliceAt;
                    return [
                        [
                            "M",
                            t.x,
                            t.y
                        ],
                        [
                            "L",
                            i.x,
                            i.y
                        ]
                    ];
                },
                crookedLine: function(t, e, i) {
                    let { breakAt: s, touchingSliceAt: r } = e, { series: o } = this, [n, a, h] = o.center, d = h / 2, { plotLeft: c, plotWidth: p } = o.chart, u = "left" === t.alignment, { x: g, y: f } = t, m = s.x;
                    if (i.crookDistance) {
                        let t = l(i.crookDistance, 1);
                        m = u ? n + d + (p + c - n - d) * (1 - t) : c + (n - d) * t;
                    } else m = n + (a - f) * Math.tan((this.angle || 0) - Math.PI / 2);
                    let x = [
                        [
                            "M",
                            g,
                            f
                        ]
                    ];
                    return (u ? m <= g && m >= s.x : m >= g && m <= s.x) && x.push([
                        "L",
                        m,
                        f
                    ]), x.push([
                        "L",
                        s.x,
                        s.y
                    ], [
                        "L",
                        r.x,
                        r.y
                    ]), x;
                }
            }
        }), d;
    }), i(e, "Series/Pie/PieSeriesDefaults.js", [], function() {
        return {
            borderRadius: 3,
            center: [
                null,
                null
            ],
            clip: !1,
            colorByPoint: !0,
            dataLabels: {
                connectorPadding: 5,
                connectorShape: "crookedLine",
                crookDistance: void 0,
                distance: 30,
                enabled: !0,
                formatter: function() {
                    return this.point.isNull ? void 0 : this.point.name;
                },
                softConnector: !0,
                x: 0
            },
            fillColor: void 0,
            ignoreHiddenPoint: !0,
            inactiveOtherPoints: !0,
            legendType: "point",
            marker: null,
            size: null,
            showInLegend: !1,
            slicedOffset: 10,
            stickyTracking: !1,
            tooltip: {
                followPointer: !0
            },
            borderColor: "#ffffff",
            borderWidth: 1,
            lineWidth: void 0,
            states: {
                hover: {
                    brightness: .1
                }
            }
        };
    }), i(e, "Series/Pie/PieSeries.js", [
        e["Series/CenteredUtilities.js"],
        e["Series/Column/ColumnSeries.js"],
        e["Core/Globals.js"],
        e["Series/Pie/PiePoint.js"],
        e["Series/Pie/PieSeriesDefaults.js"],
        e["Core/Series/Series.js"],
        e["Core/Series/SeriesRegistry.js"],
        e["Core/Renderer/SVG/Symbols.js"],
        e["Core/Utilities.js"]
    ], function(t, e, i, s, r, o, n, a, h) {
        let { getStartAndEndRadians: l } = t, { noop: d } = i, { clamp: c, extend: p, fireEvent: u, merge: g, pick: f } = h;
        class m extends o {
            animate(t) {
                let e = this, i = e.points, s = e.startAngleRad;
                t || i.forEach(function(t) {
                    let i = t.graphic, r = t.shapeArgs;
                    i && r && (i.attr({
                        r: f(t.startR, e.center && e.center[3] / 2),
                        start: s,
                        end: s
                    }), i.animate({
                        r: r.r,
                        start: r.start,
                        end: r.end
                    }, e.options.animation));
                });
            }
            drawEmpty() {
                let t, e;
                let i = this.startAngleRad, s = this.endAngleRad, r = this.options;
                0 === this.total && this.center ? (t = this.center[0], e = this.center[1], this.graph || (this.graph = this.chart.renderer.arc(t, e, this.center[1] / 2, 0, i, s).addClass("highcharts-empty-series").add(this.group)), this.graph.attr({
                    d: a.arc(t, e, this.center[2] / 2, 0, {
                        start: i,
                        end: s,
                        innerR: this.center[3] / 2
                    })
                }), this.chart.styledMode || this.graph.attr({
                    "stroke-width": r.borderWidth,
                    fill: r.fillColor || "none",
                    stroke: r.color || "#cccccc"
                })) : this.graph && (this.graph = this.graph.destroy());
            }
            drawPoints() {
                let t = this.chart.renderer;
                this.points.forEach(function(e) {
                    e.graphic && e.hasNewShapeType() && (e.graphic = e.graphic.destroy()), e.graphic || (e.graphic = t[e.shapeType](e.shapeArgs).add(e.series.group), e.delayedRendering = !0);
                });
            }
            generatePoints() {
                super.generatePoints(), this.updateTotals();
            }
            getX(t, e, i, s) {
                let r = this.center, o = this.radii ? this.radii[i.index] || 0 : r[2] / 2, n = s.dataLabelPosition, a = n?.distance || 0, h = Math.asin(c((t - r[1]) / (o + a), -1, 1));
                return r[0] + Math.cos(h) * (o + a) * (e ? -1 : 1) + (a > 0 ? (e ? -1 : 1) * (s.padding || 0) : 0);
            }
            hasData() {
                return !!this.processedXData.length;
            }
            redrawPoints() {
                let t, e, i, s;
                let r = this, o = r.chart;
                this.drawEmpty(), r.group && !o.styledMode && r.group.shadow(r.options.shadow), r.points.forEach(function(n) {
                    let a = {};
                    e = n.graphic, !n.isNull && e ? (s = n.shapeArgs, t = n.getTranslate(), o.styledMode || (i = r.pointAttribs(n, n.selected && "select")), n.delayedRendering ? (e.setRadialReference(r.center).attr(s).attr(t), o.styledMode || e.attr(i).attr({
                        "stroke-linejoin": "round"
                    }), n.delayedRendering = !1) : (e.setRadialReference(r.center), o.styledMode || g(!0, a, i), g(!0, a, s, t), e.animate(a)), e.attr({
                        visibility: n.visible ? "inherit" : "hidden"
                    }), e.addClass(n.getClassName(), !0)) : e && (n.graphic = e.destroy());
                });
            }
            sortByAngle(t, e) {
                t.sort(function(t, i) {
                    return void 0 !== t.angle && (i.angle - t.angle) * e;
                });
            }
            translate(t) {
                u(this, "translate"), this.generatePoints();
                let e = this.options, i = e.slicedOffset, s = l(e.startAngle, e.endAngle), r = this.startAngleRad = s.start, o = (this.endAngleRad = s.end) - r, n = this.points, a = e.ignoreHiddenPoint, h = n.length, d, c, p, g, f, m, x, y = 0;
                for(t || (this.center = t = this.getCenter()), m = 0; m < h; m++){
                    x = n[m], d = r + y * o, x.isValid() && (!a || x.visible) && (y += x.percentage / 100), c = r + y * o;
                    let e = {
                        x: t[0],
                        y: t[1],
                        r: t[2] / 2,
                        innerR: t[3] / 2,
                        start: Math.round(1e3 * d) / 1e3,
                        end: Math.round(1e3 * c) / 1e3
                    };
                    x.shapeType = "arc", x.shapeArgs = e, (p = (c + d) / 2) > 1.5 * Math.PI ? p -= 2 * Math.PI : p < -Math.PI / 2 && (p += 2 * Math.PI), x.slicedTranslation = {
                        translateX: Math.round(Math.cos(p) * i),
                        translateY: Math.round(Math.sin(p) * i)
                    }, g = Math.cos(p) * t[2] / 2, f = Math.sin(p) * t[2] / 2, x.tooltipPos = [
                        t[0] + .7 * g,
                        t[1] + .7 * f
                    ], x.half = p < -Math.PI / 2 || p > Math.PI / 2 ? 1 : 0, x.angle = p;
                }
                u(this, "afterTranslate");
            }
            updateTotals() {
                let t = this.points, e = t.length, i = this.options.ignoreHiddenPoint, s, r, o = 0;
                for(s = 0; s < e; s++)(r = t[s]).isValid() && (!i || r.visible) && (o += r.y);
                for(s = 0, this.total = o; s < e; s++)(r = t[s]).percentage = o > 0 && (r.visible || !i) ? r.y / o * 100 : 0, r.total = o;
            }
        }
        return m.defaultOptions = g(o.defaultOptions, r), p(m.prototype, {
            axisTypes: [],
            directTouch: !0,
            drawGraph: void 0,
            drawTracker: e.prototype.drawTracker,
            getCenter: t.getCenter,
            getSymbol: d,
            invertible: !1,
            isCartesian: !1,
            noSharedTooltip: !0,
            pointAttribs: e.prototype.pointAttribs,
            pointClass: s,
            requireSorting: !1,
            searchPoint: d,
            trackerGroups: [
                "group",
                "dataLabelsGroup"
            ]
        }), n.registerSeriesType("pie", m), m;
    }), i(e, "Series/Pie/PieDataLabel.js", [
        e["Core/Series/DataLabel.js"],
        e["Core/Globals.js"],
        e["Core/Renderer/RendererUtilities.js"],
        e["Core/Series/SeriesRegistry.js"],
        e["Core/Utilities.js"]
    ], function(t, e, i, s, r) {
        var o;
        let { composed: n, noop: a } = e, { distribute: h } = i, { series: l } = s, { arrayMax: d, clamp: c, defined: p, pick: u, pushUnique: g, relativeLength: f } = r;
        return function(e) {
            let i = {
                radialDistributionY: function(t, e) {
                    return (e.dataLabelPosition?.top || 0) + t.distributeBox.pos;
                },
                radialDistributionX: function(t, e, i, s, r) {
                    let o = r.dataLabelPosition;
                    return t.getX(i < (o?.top || 0) + 2 || i > (o?.bottom || 0) - 2 ? s : i, e.half, e, r);
                },
                justify: function(t, e, i, s) {
                    return s[0] + (t.half ? -1 : 1) * (i + (e.dataLabelPosition?.distance || 0));
                },
                alignToPlotEdges: function(t, e, i, s) {
                    let r = t.getBBox().width;
                    return e ? r + s : i - r - s;
                },
                alignToConnectors: function(t, e, i, s) {
                    let r = 0, o;
                    return t.forEach(function(t) {
                        (o = t.dataLabel.getBBox().width) > r && (r = o);
                    }), e ? r + s : i - r - s;
                }
            };
            function s(t, e) {
                let { center: i, options: s } = this, r = i[2] / 2, o = t.angle || 0, n = Math.cos(o), a = Math.sin(o), h = i[0] + n * r, l = i[1] + a * r, d = Math.min((s.slicedOffset || 0) + (s.borderWidth || 0), e / 5);
                return {
                    natural: {
                        x: h + n * e,
                        y: l + a * e
                    },
                    computed: {},
                    alignment: e < 0 ? "center" : t.half ? "right" : "left",
                    connectorPosition: {
                        breakAt: {
                            x: h + n * d,
                            y: l + a * d
                        },
                        touchingSliceAt: {
                            x: h,
                            y: l
                        }
                    },
                    distance: e
                };
            }
            function r() {
                let t = this, e = t.points, i = t.chart, s = i.plotWidth, r = i.plotHeight, o = i.plotLeft, n = Math.round(i.chartWidth / 3), a = t.center, c = a[2] / 2, g = a[1], m = [
                    [],
                    []
                ], x = [
                    0,
                    0,
                    0,
                    0
                ], y = t.dataLabelPositioners, b, v, S, C = 0;
                t.visible && t.hasDataLabels?.() && (e.forEach((t)=>{
                    (t.dataLabels || []).forEach((t)=>{
                        t.shortened && (t.attr({
                            width: "auto"
                        }).css({
                            width: "auto",
                            textOverflow: "clip"
                        }), t.shortened = !1);
                    });
                }), l.prototype.drawDataLabels.apply(t), e.forEach((t)=>{
                    (t.dataLabels || []).forEach((e, i)=>{
                        let s = a[2] / 2, r = e.options, o = f(r?.distance || 0, s);
                        0 === i && m[t.half].push(t), !p(r?.style?.width) && e.getBBox().width > n && (e.css({
                            width: Math.round(.7 * n) + "px"
                        }), e.shortened = !0), e.dataLabelPosition = this.getDataLabelPosition(t, o), C = Math.max(C, o);
                    });
                }), m.forEach((e, n)=>{
                    let l = e.length, d = [], f, m, b = 0, k;
                    l && (t.sortByAngle(e, n - .5), C > 0 && (f = Math.max(0, g - c - C), m = Math.min(g + c + C, i.plotHeight), e.forEach((t)=>{
                        (t.dataLabels || []).forEach((e)=>{
                            let s = e.dataLabelPosition;
                            s && s.distance > 0 && (s.top = Math.max(0, g - c - s.distance), s.bottom = Math.min(g + c + s.distance, i.plotHeight), b = e.getBBox().height || 21, e.lineHeight = i.renderer.fontMetrics(e.text || e).h + 2 * e.padding, t.distributeBox = {
                                target: (e.dataLabelPosition?.natural.y || 0) - s.top + e.lineHeight / 2,
                                size: b,
                                rank: t.y
                            }, d.push(t.distributeBox));
                        });
                    }), h(d, k = m + b - f, k / 5)), e.forEach((i)=>{
                        (i.dataLabels || []).forEach((h)=>{
                            let l = h.options || {}, g = i.distributeBox, f = h.dataLabelPosition, m = f?.natural.y || 0, b = l.connectorPadding || 0, C = h.lineHeight || 21, k = (C - h.getBBox().height) / 2, M = 0, w = m, T = "inherit";
                            if (f) {
                                if (d && p(g) && f.distance > 0 && (void 0 === g.pos ? T = "hidden" : (S = g.size, w = y.radialDistributionY(i, h))), l.justify) M = y.justify(i, h, c, a);
                                else switch(l.alignTo){
                                    case "connectors":
                                        M = y.alignToConnectors(e, n, s, o);
                                        break;
                                    case "plotEdges":
                                        M = y.alignToPlotEdges(h, n, s, o);
                                        break;
                                    default:
                                        M = y.radialDistributionX(t, i, w - k, m, h);
                                }
                                if (f.attribs = {
                                    visibility: T,
                                    align: f.alignment
                                }, f.posAttribs = {
                                    x: M + (l.x || 0) + (({
                                        left: b,
                                        right: -b
                                    })[f.alignment] || 0),
                                    y: w + (l.y || 0) - C / 2
                                }, f.computed.x = M, f.computed.y = w - k, u(l.crop, !0)) {
                                    let t;
                                    M - (v = h.getBBox().width) < b && 1 === n ? (t = Math.round(v - M + b), x[3] = Math.max(t, x[3])) : M + v > s - b && 0 === n && (t = Math.round(M + v - s + b), x[1] = Math.max(t, x[1])), w - S / 2 < 0 ? x[0] = Math.max(Math.round(-w + S / 2), x[0]) : w + S / 2 > r && (x[2] = Math.max(Math.round(w + S / 2 - r), x[2])), f.sideOverflow = t;
                                }
                            }
                        });
                    }));
                }), (0 === d(x) || this.verifyDataLabelOverflow(x)) && (this.placeDataLabels(), this.points.forEach((e)=>{
                    (e.dataLabels || []).forEach((s)=>{
                        let { connectorColor: r, connectorWidth: o = 1 } = s.options || {}, n = s.dataLabelPosition;
                        if (o) {
                            let a;
                            b = s.connector, n && n.distance > 0 ? (a = !b, b || (s.connector = b = i.renderer.path().addClass("highcharts-data-label-connector  highcharts-color-" + e.colorIndex + (e.className ? " " + e.className : "")).add(t.dataLabelsGroup)), i.styledMode || b.attr({
                                "stroke-width": o,
                                stroke: r || e.color || "#666666"
                            }), b[a ? "attr" : "animate"]({
                                d: e.getConnectorPath(s)
                            }), b.attr({
                                visibility: n.attribs?.visibility
                            })) : b && (s.connector = b.destroy());
                        }
                    });
                })));
            }
            function o() {
                this.points.forEach((t)=>{
                    (t.dataLabels || []).forEach((t)=>{
                        let e = t.dataLabelPosition;
                        e ? (e.sideOverflow && (t.css({
                            width: Math.max(t.getBBox().width - e.sideOverflow, 0) + "px",
                            textOverflow: (t.options?.style || {}).textOverflow || "ellipsis"
                        }), t.shortened = !0), t.attr(e.attribs), t[t.moved ? "animate" : "attr"](e.posAttribs), t.moved = !0) : t && t.attr({
                            y: -9999
                        });
                    }), delete t.distributeBox;
                }, this);
            }
            function m(t) {
                let e = this.center, i = this.options, s = i.center, r = i.minSize || 80, o = r, n = null !== i.size;
                return !n && (null !== s[0] ? o = Math.max(e[2] - Math.max(t[1], t[3]), r) : (o = Math.max(e[2] - t[1] - t[3], r), e[0] += (t[3] - t[1]) / 2), null !== s[1] ? o = c(o, r, e[2] - Math.max(t[0], t[2])) : (o = c(o, r, e[2] - t[0] - t[2]), e[1] += (t[0] - t[2]) / 2), o < e[2] ? (e[2] = o, e[3] = Math.min(i.thickness ? Math.max(0, o - 2 * i.thickness) : Math.max(0, f(i.innerSize || 0, o)), o), this.translate(e), this.drawDataLabels && this.drawDataLabels()) : n = !0), n;
            }
            e.compose = function(e) {
                if (t.compose(l), g(n, "PieDataLabel")) {
                    let t = e.prototype;
                    t.dataLabelPositioners = i, t.alignDataLabel = a, t.drawDataLabels = r, t.getDataLabelPosition = s, t.placeDataLabels = o, t.verifyDataLabelOverflow = m;
                }
            };
        }(o || (o = {})), o;
    }), i(e, "Core/Geometry/GeometryUtilities.js", [], function() {
        var t, e;
        return (e = t || (t = {})).getCenterOfPoints = function(t) {
            let e = t.reduce((t, e)=>(t.x += e.x, t.y += e.y, t), {
                x: 0,
                y: 0
            });
            return {
                x: e.x / t.length,
                y: e.y / t.length
            };
        }, e.getDistanceBetweenPoints = function(t, e) {
            return Math.sqrt(Math.pow(e.x - t.x, 2) + Math.pow(e.y - t.y, 2));
        }, e.getAngleBetweenPoints = function(t, e) {
            return Math.atan2(e.x - t.x, e.y - t.y);
        }, e.pointInPolygon = function({ x: t, y: e }, i) {
            let s = i.length, r, o, n = !1;
            for(r = 0, o = s - 1; r < s; o = r++){
                let [s, a] = i[r], [h, l] = i[o];
                a > e != l > e && t < (h - s) * (e - a) / (l - a) + s && (n = !n);
            }
            return n;
        }, t;
    }), i(e, "Extensions/OverlappingDataLabels.js", [
        e["Core/Geometry/GeometryUtilities.js"],
        e["Core/Utilities.js"]
    ], function(t, e) {
        let { pointInPolygon: i } = t, { addEvent: s, fireEvent: r, objectEach: o, pick: n } = e;
        function a(t) {
            let e = t.length, s = (t, e)=>!(e.x >= t.x + t.width || e.x + e.width <= t.x || e.y >= t.y + t.height || e.y + e.height <= t.y), o = (t, e)=>{
                for (let s of t)if (i({
                    x: s[0],
                    y: s[1]
                }, e)) return !0;
                return !1;
            }, n, a, l, d, c, p = !1;
            for(let i = 0; i < e; i++)(n = t[i]) && (n.oldOpacity = n.opacity, n.newOpacity = 1, n.absoluteBox = function(t) {
                if (t && (!t.alignAttr || t.placed)) {
                    let e = t.box ? 0 : t.padding || 0, i = t.alignAttr || {
                        x: t.attr("x"),
                        y: t.attr("y")
                    }, s = t.getBBox();
                    return t.width = s.width, t.height = s.height, {
                        x: i.x + (t.parentGroup?.translateX || 0) + e,
                        y: i.y + (t.parentGroup?.translateY || 0) + e,
                        width: (t.width || 0) - 2 * e,
                        height: (t.height || 0) - 2 * e,
                        polygon: s?.polygon
                    };
                }
            }(n));
            t.sort((t, e)=>(e.labelrank || 0) - (t.labelrank || 0));
            for(let i = 0; i < e; ++i){
                d = (a = t[i]) && a.absoluteBox;
                let r = d?.polygon;
                for(let n = i + 1; n < e; ++n){
                    c = (l = t[n]) && l.absoluteBox;
                    let e = !1;
                    if (d && c && a !== l && 0 !== a.newOpacity && 0 !== l.newOpacity && "hidden" !== a.visibility && "hidden" !== l.visibility) {
                        let t = c.polygon;
                        if (r && t && r !== t ? o(r, t) && (e = !0) : s(d, c) && (e = !0), e) {
                            let t = a.labelrank < l.labelrank ? a : l, e = t.text;
                            t.newOpacity = 0, e?.element.querySelector("textPath") && e.hide();
                        }
                    }
                }
            }
            for (let e of t)h(e, this) && (p = !0);
            p && r(this, "afterHideAllOverlappingLabels");
        }
        function h(t, e) {
            let i, s, o = !1;
            return t && (s = t.newOpacity, t.oldOpacity !== s && (t.hasClass("highcharts-data-label") ? (t[s ? "removeClass" : "addClass"]("highcharts-data-label-hidden"), i = function() {
                e.styledMode || t.css({
                    pointerEvents: s ? "auto" : "none"
                });
            }, o = !0, t[t.isOld ? "animate" : "attr"]({
                opacity: s
            }, void 0, i), r(e, "afterHideOverlappingLabel")) : t.attr({
                opacity: s
            })), t.isOld = !0), o;
        }
        function l() {
            let t = this, e = [];
            for (let i of t.labelCollectors || [])e = e.concat(i());
            for (let i of t.yAxis || [])i.stacking && i.options.stackLabels && !i.options.stackLabels.allowOverlap && o(i.stacking.stacks, (t)=>{
                o(t, (t)=>{
                    t.label && e.push(t.label);
                });
            });
            for (let i of t.series || [])if (i.visible && i.hasDataLabels?.()) {
                let s = (i)=>{
                    for (let s of i)s.visible && (s.dataLabels || []).forEach((i)=>{
                        let r = i.options || {};
                        i.labelrank = n(r.labelrank, s.labelrank, s.shapeArgs?.height), r.allowOverlap ?? Number(r.distance) > 0 ? (i.oldOpacity = i.opacity, i.newOpacity = 1, h(i, t)) : e.push(i);
                    });
                };
                s(i.nodes || []), s(i.points);
            }
            this.hideOverlappingLabels(e);
        }
        return {
            compose: function(t) {
                let e = t.prototype;
                e.hideOverlappingLabels || (e.hideOverlappingLabels = a, s(t, "render", l));
            }
        };
    }), i(e, "Extensions/BorderRadius.js", [
        e["Core/Defaults.js"],
        e["Core/Globals.js"],
        e["Core/Utilities.js"]
    ], function(t, e, i) {
        let { defaultOptions: s } = t, { noop: r } = e, { addEvent: o, extend: n, isObject: a, merge: h, relativeLength: l } = i, d = {
            radius: 0,
            scope: "stack",
            where: void 0
        }, c = r, p = r;
        function u(t, e, i, s, r = {}) {
            let o = c(t, e, i, s, r), { innerR: n = 0, r: a = i, start: h = 0, end: d = 0 } = r;
            if (r.open || !r.borderRadius) return o;
            let p = d - h, g = Math.sin(p / 2), f = Math.max(Math.min(l(r.borderRadius || 0, a - n), (a - n) / 2, a * g / (1 + g)), 0), m = Math.min(f, p / Math.PI * 2 * n), x = o.length - 1;
            for(; x--;)!function(t, e, i) {
                let s, r, o;
                let n = t[e], a = t[e + 1];
                if ("Z" === a[0] && (a = t[0]), ("M" === n[0] || "L" === n[0]) && "A" === a[0] ? (s = n, r = a, o = !0) : "A" === n[0] && ("M" === a[0] || "L" === a[0]) && (s = a, r = n), s && r && r.params) {
                    let n = r[1], a = r[5], h = r.params, { start: l, end: d, cx: c, cy: p } = h, u = a ? n - i : n + i, g = u ? Math.asin(i / u) : 0, f = a ? g : -g, m = Math.cos(g) * u;
                    o ? (h.start = l + f, s[1] = c + m * Math.cos(l), s[2] = p + m * Math.sin(l), t.splice(e + 1, 0, [
                        "A",
                        i,
                        i,
                        0,
                        0,
                        1,
                        c + n * Math.cos(h.start),
                        p + n * Math.sin(h.start)
                    ])) : (h.end = d - f, r[6] = c + n * Math.cos(h.end), r[7] = p + n * Math.sin(h.end), t.splice(e + 1, 0, [
                        "A",
                        i,
                        i,
                        0,
                        0,
                        1,
                        c + m * Math.cos(d),
                        p + m * Math.sin(d)
                    ])), r[4] = Math.abs(h.end - h.start) < Math.PI ? 0 : 1;
                }
            }(o, x, x > 1 ? m : f);
            return o;
        }
        function g() {
            if (this.options.borderRadius && !(this.chart.is3d && this.chart.is3d())) {
                let { options: t, yAxis: e } = this, i = "percent" === t.stacking, r = s.plotOptions?.[this.type]?.borderRadius, o = f(t.borderRadius, a(r) ? r : {}), h = e.options.reversed;
                for (let s of this.points){
                    let { shapeArgs: r } = s;
                    if ("roundedRect" === s.shapeType && r) {
                        let { width: a = 0, height: d = 0, y: c = 0 } = r, p = c, u = d;
                        if ("stack" === o.scope && s.stackTotal) {
                            let r = e.translate(i ? 100 : s.stackTotal, !1, !0, !1, !0), o = e.translate(t.threshold || 0, !1, !0, !1, !0), n = this.crispCol(0, Math.min(r, o), 0, Math.abs(r - o));
                            p = n.y, u = n.height;
                        }
                        let g = (s.negative ? -1 : 1) * (h ? -1 : 1) == -1, f = o.where;
                        !f && this.is("waterfall") && Math.abs((s.yBottom || 0) - (this.translatedThreshold || 0)) > this.borderWidth && (f = "all"), f || (f = "end");
                        let m = Math.min(l(o.radius, a), a / 2, "all" === f ? d / 2 : 1 / 0) || 0;
                        "end" === f && (g && (p -= m), u += m), n(r, {
                            brBoxHeight: u,
                            brBoxY: p,
                            r: m
                        });
                    }
                }
            }
        }
        function f(t, e) {
            return a(t) || (t = {
                radius: t || 0
            }), h(d, e, t);
        }
        function m() {
            let t = f(this.options.borderRadius);
            for (let e of this.points){
                let i = e.shapeArgs;
                i && (i.borderRadius = l(t.radius, (i.r || 0) - (i.innerR || 0)));
            }
        }
        function x(t, e, i, s, r = {}) {
            let o = p(t, e, i, s, r), { r: n = 0, brBoxHeight: a = s, brBoxY: h = e } = r, l = e - h, d = h + a - (e + s), c = l - n > -0.1 ? 0 : n, u = d - n > -0.1 ? 0 : n, g = Math.max(c && l, 0), f = Math.max(u && d, 0), m = [
                t + c,
                e
            ], y = [
                t + i - c,
                e
            ], b = [
                t + i,
                e + c
            ], v = [
                t + i,
                e + s - u
            ], S = [
                t + i - u,
                e + s
            ], C = [
                t + u,
                e + s
            ], k = [
                t,
                e + s - u
            ], M = [
                t,
                e + c
            ], w = (t, e)=>Math.sqrt(Math.pow(t, 2) - Math.pow(e, 2));
            if (g) {
                let t = w(c, c - g);
                m[0] -= t, y[0] += t, b[1] = M[1] = e + c - g;
            }
            if (s < c - g) {
                let r = w(c, c - g - s);
                b[0] = v[0] = t + i - c + r, S[0] = Math.min(b[0], S[0]), C[0] = Math.max(v[0], C[0]), k[0] = M[0] = t + c - r, b[1] = M[1] = e + s;
            }
            if (f) {
                let t = w(u, u - f);
                S[0] += t, C[0] -= t, v[1] = k[1] = e + s - u + f;
            }
            if (s < u - f) {
                let r = w(u, u - f - s);
                b[0] = v[0] = t + i - u + r, y[0] = Math.min(b[0], y[0]), m[0] = Math.max(v[0], m[0]), k[0] = M[0] = t + u - r, v[1] = k[1] = e;
            }
            return o.length = 0, o.push([
                "M",
                ...m
            ], [
                "L",
                ...y
            ], [
                "A",
                c,
                c,
                0,
                0,
                1,
                ...b
            ], [
                "L",
                ...v
            ], [
                "A",
                u,
                u,
                0,
                0,
                1,
                ...S
            ], [
                "L",
                ...C
            ], [
                "A",
                u,
                u,
                0,
                0,
                1,
                ...k
            ], [
                "L",
                ...M
            ], [
                "A",
                c,
                c,
                0,
                0,
                1,
                ...m
            ], [
                "Z"
            ]), o;
        }
        return {
            compose: function(t, e, i) {
                let s = t.types.pie;
                if (!e.symbolCustomAttribs.includes("borderRadius")) {
                    let r = i.prototype.symbols;
                    o(t, "afterColumnTranslate", g, {
                        order: 9
                    }), o(s, "afterTranslate", m), e.symbolCustomAttribs.push("borderRadius", "brBoxHeight", "brBoxY"), c = r.arc, p = r.roundedRect, r.arc = u, r.roundedRect = x;
                }
            },
            optionsToObject: f
        };
    }), i(e, "Core/Responsive.js", [
        e["Core/Utilities.js"]
    ], function(t) {
        var e;
        let { diffObjects: i, extend: s, find: r, merge: o, pick: n, uniqueKey: a } = t;
        return function(t) {
            function e(t, e) {
                let i = t.condition;
                (i.callback || function() {
                    return this.chartWidth <= n(i.maxWidth, Number.MAX_VALUE) && this.chartHeight <= n(i.maxHeight, Number.MAX_VALUE) && this.chartWidth >= n(i.minWidth, 0) && this.chartHeight >= n(i.minHeight, 0);
                }).call(this) && e.push(t._id);
            }
            function h(t, e) {
                let s = this.options.responsive, n = this.currentResponsive, h = [], l;
                !e && s && s.rules && s.rules.forEach((t)=>{
                    void 0 === t._id && (t._id = a()), this.matchResponsiveRule(t, h);
                }, this);
                let d = o(...h.map((t)=>r((s || {}).rules || [], (e)=>e._id === t)).map((t)=>t && t.chartOptions));
                d.isResponsiveOptions = !0, h = h.toString() || void 0;
                let c = n && n.ruleIds;
                h === c || (n && (this.currentResponsive = void 0, this.updatingResponsive = !0, this.update(n.undoOptions, t, !0), this.updatingResponsive = !1), h ? ((l = i(d, this.options, !0, this.collectionsWithUpdate)).isResponsiveOptions = !0, this.currentResponsive = {
                    ruleIds: h,
                    mergedOptions: d,
                    undoOptions: l
                }, this.updatingResponsive || this.update(d, t, !0)) : this.currentResponsive = void 0);
            }
            t.compose = function(t) {
                let i = t.prototype;
                return i.matchResponsiveRule || s(i, {
                    matchResponsiveRule: e,
                    setResponsive: h
                }), t;
            };
        }(e || (e = {})), e;
    }), i(e, "masters/highcharts.src.js", [
        e["Core/Globals.js"],
        e["Core/Utilities.js"],
        e["Core/Defaults.js"],
        e["Core/Animation/Fx.js"],
        e["Core/Animation/AnimationUtilities.js"],
        e["Core/Renderer/HTML/AST.js"],
        e["Core/Templating.js"],
        e["Core/Renderer/RendererRegistry.js"],
        e["Core/Renderer/RendererUtilities.js"],
        e["Core/Renderer/SVG/SVGElement.js"],
        e["Core/Renderer/SVG/SVGRenderer.js"],
        e["Core/Renderer/HTML/HTMLElement.js"],
        e["Core/Axis/Axis.js"],
        e["Core/Axis/DateTimeAxis.js"],
        e["Core/Axis/LogarithmicAxis.js"],
        e["Core/Axis/PlotLineOrBand/PlotLineOrBand.js"],
        e["Core/Axis/Tick.js"],
        e["Core/Tooltip.js"],
        e["Core/Series/Point.js"],
        e["Core/Pointer.js"],
        e["Core/Legend/Legend.js"],
        e["Core/Legend/LegendSymbol.js"],
        e["Core/Chart/Chart.js"],
        e["Extensions/ScrollablePlotArea.js"],
        e["Core/Axis/Stacking/StackingAxis.js"],
        e["Core/Axis/Stacking/StackItem.js"],
        e["Core/Series/Series.js"],
        e["Core/Series/SeriesRegistry.js"],
        e["Series/Column/ColumnDataLabel.js"],
        e["Series/Pie/PieDataLabel.js"],
        e["Core/Series/DataLabel.js"],
        e["Extensions/OverlappingDataLabels.js"],
        e["Extensions/BorderRadius.js"],
        e["Core/Responsive.js"],
        e["Core/Color/Color.js"],
        e["Core/Time.js"]
    ], function(t, e, i, s, r, o, n, a, h, l, d, c, p, u, g, f, m, x, y, b, v, S, C, k, M, w, T, A, P, L, O, D, E, I, j, B) {
        return t.AST = o, t.Axis = p, t.Chart = C, t.Color = j, t.DataLabel = O, t.Fx = s, t.HTMLElement = c, t.Legend = v, t.LegendSymbol = S, t.OverlappingDataLabels = t.OverlappingDataLabels || D, t.PlotLineOrBand = f, t.Point = y, t.Pointer = b, t.RendererRegistry = a, t.Series = T, t.SeriesRegistry = A, t.StackItem = w, t.SVGElement = l, t.SVGRenderer = d, t.Templating = n, t.Tick = m, t.Time = B, t.Tooltip = x, t.animate = r.animate, t.animObject = r.animObject, t.chart = C.chart, t.color = j.parse, t.dateFormat = n.dateFormat, t.defaultOptions = i.defaultOptions, t.distribute = h.distribute, t.format = n.format, t.getDeferredAnimation = r.getDeferredAnimation, t.getOptions = i.getOptions, t.numberFormat = n.numberFormat, t.seriesType = A.seriesType, t.setAnimation = r.setAnimation, t.setOptions = i.setOptions, t.stop = r.stop, t.time = i.defaultTime, t.timers = s.timers, E.compose(t.Series, t.SVGElement, t.SVGRenderer), P.compose(t.Series.types.column), O.compose(t.Series), u.compose(t.Axis), c.compose(t.SVGRenderer), v.compose(t.Chart), g.compose(t.Axis), D.compose(t.Chart), L.compose(t.Series.types.pie), f.compose(t.Chart, t.Axis), b.compose(t.Chart), I.compose(t.Chart), k.compose(t.Axis, t.Chart, t.Series), M.compose(t.Axis, t.Chart, t.Series), x.compose(t.Pointer), e.extend(t, e), t;
    }), e["masters/highcharts.src.js"]._modules = e, e["masters/highcharts.src.js"];
});


var $6593432242bbf5e0$exports = {};
!/**
 * Highcharts JS v11.4.8 (2024-08-29)
 *
 * Data module
 *
 * (c) 2012-2024 Torstein Honsi
 *
 * License: www.highcharts.com/license
 */ function(e) {
    $6593432242bbf5e0$exports ? (e.default = e, $6593432242bbf5e0$exports = e) : "function" == typeof define && define.amd ? define("highcharts/modules/data", [
        "highcharts"
    ], function(t) {
        return e(t), e.Highcharts = t, e;
    }) : e("undefined" != typeof Highcharts ? Highcharts : void 0);
}(function(e) {
    "use strict";
    var t = e ? e._modules : {};
    function s(t, s, i, a) {
        t.hasOwnProperty(s) || (t[s] = a.apply(null, i), "function" == typeof CustomEvent && e.win.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", {
            detail: {
                path: s,
                module: t[s]
            }
        })));
    }
    s(t, "Core/HttpUtilities.js", [
        t["Core/Globals.js"],
        t["Core/Utilities.js"]
    ], function(e, t) {
        let { win: s } = e, { discardElement: i, objectEach: a } = t, n = {
            ajax: function(e) {
                let t = {
                    json: "application/json",
                    xml: "application/xml",
                    text: "text/plain",
                    octet: "application/octet-stream"
                }, s = new XMLHttpRequest;
                function i(t, s) {
                    e.error && e.error(t, s);
                }
                if (!e.url) return !1;
                s.open((e.type || "get").toUpperCase(), e.url, !0), e.headers && e.headers["Content-Type"] || s.setRequestHeader("Content-Type", t[e.dataType || "json"] || t.text), a(e.headers, function(e, t) {
                    s.setRequestHeader(t, e);
                }), e.responseType && (s.responseType = e.responseType), s.onreadystatechange = function() {
                    let t;
                    if (4 === s.readyState) {
                        if (200 === s.status) {
                            if ("blob" !== e.responseType && (t = s.responseText, "json" === e.dataType)) try {
                                t = JSON.parse(t);
                            } catch (e) {
                                if (e instanceof Error) return i(s, e);
                            }
                            return e.success && e.success(t, s);
                        }
                        i(s, s.responseText);
                    }
                }, e.data && "string" != typeof e.data && (e.data = JSON.stringify(e.data)), s.send(e.data);
            },
            getJSON: function(e, t) {
                n.ajax({
                    url: e,
                    success: t,
                    dataType: "json",
                    headers: {
                        "Content-Type": "text/plain"
                    }
                });
            },
            post: function(e, t, n) {
                let r = new s.FormData;
                a(t, function(e, t) {
                    r.append(t, e);
                }), r.append("b64", "true");
                let { filename: o, type: l } = t;
                return s.fetch(e, {
                    method: "POST",
                    body: r,
                    ...n
                }).then((e)=>{
                    e.ok && e.text().then((e)=>{
                        let t = document.createElement("a");
                        t.href = `data:${l};base64,${e}`, t.download = o, t.click(), i(t);
                    });
                });
            }
        };
        return n;
    }), s(t, "Extensions/Data.js", [
        t["Core/Axis/Axis.js"],
        t["Core/Chart/Chart.js"],
        t["Core/Defaults.js"],
        t["Core/Globals.js"],
        t["Core/HttpUtilities.js"],
        t["Core/Series/Point.js"],
        t["Core/Series/SeriesRegistry.js"],
        t["Core/Utilities.js"]
    ], function(e, t, s, i, a, n, r, o) {
        let { getOptions: l } = s, { doc: u } = i, { ajax: h } = a, { seriesTypes: d } = r, { addEvent: p, defined: m, extend: c, fireEvent: f, isNumber: g, merge: x, objectEach: C, pick: y, splat: v } = o;
        function T(e) {
            return !!(e && (e.rowsURL || e.csvURL || e.columnsURL));
        }
        class N {
            static data(e, t = {}, s) {
                return new N(e, t, s);
            }
            static rowsToColumns(e) {
                let t, s, i, a, n;
                if (e) for(t = 0, n = [], s = e.length; t < s; t++)for(i = 0, a = e[t].length; i < a; i++)n[i] || (n[i] = []), n[i][t] = e[t][i];
                return n;
            }
            constructor(e, t = {}, s){
                this.rowsToColumns = N.rowsToColumns, this.dateFormats = {
                    "YYYY/mm/dd": {
                        regex: /^(\d{4})[\-\/\.](\d{1,2})[\-\/\.](\d{1,2})$/,
                        parser: function(e) {
                            return e ? Date.UTC(+e[1], +e[2] - 1, +e[3]) : NaN;
                        }
                    },
                    "dd/mm/YYYY": {
                        regex: /^(\d{1,2})[\-\/\.](\d{1,2})[\-\/\.](\d{4})$/,
                        parser: function(e) {
                            return e ? Date.UTC(+e[3], +e[2] - 1, +e[1]) : NaN;
                        },
                        alternative: "mm/dd/YYYY"
                    },
                    "mm/dd/YYYY": {
                        regex: /^(\d{1,2})[\-\/\.](\d{1,2})[\-\/\.](\d{4})$/,
                        parser: function(e) {
                            return e ? Date.UTC(+e[3], +e[1] - 1, +e[2]) : NaN;
                        }
                    },
                    "dd/mm/YY": {
                        regex: /^(\d{1,2})[\-\/\.](\d{1,2})[\-\/\.](\d{2})$/,
                        parser: function(e) {
                            if (!e) return NaN;
                            let t = new Date, s = +e[3];
                            return s > t.getFullYear() - 2e3 ? s += 1900 : s += 2e3, Date.UTC(s, +e[2] - 1, +e[1]);
                        },
                        alternative: "mm/dd/YY"
                    },
                    "mm/dd/YY": {
                        regex: /^(\d{1,2})[\-\/\.](\d{1,2})[\-\/\.](\d{2})$/,
                        parser: function(e) {
                            return e ? Date.UTC(+e[3] + 2e3, +e[1] - 1, +e[2]) : NaN;
                        }
                    }
                }, this.chart = s, this.chartOptions = t, this.options = e, this.rawColumns = [], this.init(e, t, s);
            }
            init(e, t, s) {
                let i = e.decimalPoint, a;
                t && (this.chartOptions = t), s && (this.chart = s), "." !== i && "," !== i && (i = void 0), this.options = e, this.columns = e.columns || this.rowsToColumns(e.rows) || [], this.firstRowAsNames = y(e.firstRowAsNames, this.firstRowAsNames, !0), this.decimalRegex = i && RegExp("^(-?[0-9]+)" + i + "([0-9]+)$"), void 0 !== this.liveDataTimeout && clearTimeout(this.liveDataTimeout), this.rawColumns = [], this.columns.length && (this.dataFound(), a = !T(e)), a || (a = this.fetchLiveData()), a || (a = !!this.parseCSV().length), a || (a = !!this.parseTable().length), a || (a = this.parseGoogleSpreadsheet()), !a && e.afterComplete && e.afterComplete(this);
            }
            getColumnDistribution() {
                let e = this.chartOptions, t = this.options, s = [], i = function(e = "line") {
                    return (d[e].prototype.pointArrayMap || [
                        0
                    ]).length;
                }, a = function(e = "line") {
                    return d[e].prototype.pointArrayMap;
                }, n = e?.chart?.type, r = [], o = [], l = t?.seriesMapping || e?.series?.map(function() {
                    return {
                        x: 0
                    };
                }) || [], u = 0;
                (e?.series || []).forEach((e)=>{
                    r.push(i(e.type || n));
                }), l.forEach((e)=>{
                    s.push(e.x || 0);
                }), 0 === s.length && s.push(0), l.forEach((t)=>{
                    let s = new R, l = r[u] || i(n), h = (e?.series ?? [])[u] ?? {}, d = a(h.type || n), p = d ?? [
                        "y"
                    ];
                    (m(t.x) || h.isCartesian || !d) && s.addColumnReader(t.x, "x"), C(t, function(e, t) {
                        "x" !== t && s.addColumnReader(e, t);
                    });
                    for(let e = 0; e < l; e++)s.hasReader(p[e]) || s.addColumnReader(void 0, p[e]);
                    o.push(s), u++;
                });
                let h = a(n);
                void 0 === h && (h = [
                    "y"
                ]), this.valueCount = {
                    global: i(n),
                    xColumns: s,
                    individual: r,
                    seriesBuilders: o,
                    globalPointArrayMap: h
                };
            }
            dataFound() {
                this.options.switchRowsAndColumns && (this.columns = this.rowsToColumns(this.columns)), this.getColumnDistribution(), this.parseTypes(), !1 !== this.parsed() && this.complete();
            }
            parseCSV(e) {
                let t = this, s = this.columns = [], i = e || this.options, a = i.startColumn || 0, n = i.endColumn || Number.MAX_VALUE, r = [], o = {
                    ",": 0,
                    ";": 0,
                    "	": 0
                }, l = i.csv, u = i.startRow || 0, h = i.endRow || Number.MAX_VALUE, d, p, m = 0;
                if (l && i.beforeParse && (l = i.beforeParse.call(this, l)), l) {
                    if (p = l.replace(/\r\n/g, "\n").replace(/\r/g, "\n").split(i.lineDelimiter || "\n"), (!u || u < 0) && (u = 0), (!h || h >= p.length) && (h = p.length - 1), i.itemDelimiter) d = i.itemDelimiter;
                    else {
                        let e, s, a;
                        e = 0, s = 0, a = !1, p.some(function(t, i) {
                            let a = !1, n, r, l, u = "";
                            if (i > 13) return !0;
                            for(let i = 0; i < t.length; i++){
                                if (n = t[i], r = t[i + 1], l = t[i - 1], "#" === n) return;
                                if ('"' === n) {
                                    if (a) {
                                        if ('"' !== l && '"' !== r) {
                                            for(; " " === r && i < t.length;)r = t[++i];
                                            void 0 !== o[r] && o[r]++, a = !1;
                                        }
                                    } else a = !0;
                                } else void 0 !== o[n] ? (isNaN(Date.parse(u = u.trim())) ? (isNaN(u) || !isFinite(u)) && o[n]++ : o[n]++, u = "") : u += n;
                                "," === n && s++, "." === n && e++;
                            }
                        }), o[";"] > o[","] ? a = ";" : (o[","], o[";"], a = ","), i.decimalPoint || (e > s ? i.decimalPoint = "." : i.decimalPoint = ",", t.decimalRegex = RegExp("^(-?[0-9]+)" + i.decimalPoint + "([0-9]+)$")), d = a;
                    }
                    let e = 0;
                    for(m = u; m <= h; m++)"#" === p[m][0] ? e++ : function(e, t, o, l) {
                        let u = 0, h = "", p = "", m = "", c = "", f = 0, g = 0;
                        function x(t) {
                            h = e[t], p = e[t - 1], m = e[t + 1];
                        }
                        function C(e) {
                            r.length < g + 1 && r.push([
                                e
                            ]), r[g][r[g].length - 1] !== e && r[g].push(e);
                        }
                        function y() {
                            if (a > f || f > n) {
                                ++f, c = "";
                                return;
                            }
                            i.columnTypes || (!isNaN(parseFloat(c)) && isFinite(c) ? (c = parseFloat(c), C("number")) : isNaN(Date.parse(c)) ? C("string") : (c = c.replace(/\//g, "-"), C("date"))), s.length < g + 1 && s.push([]), s[g][t] = c, c = "", ++g, ++f;
                        }
                        if (e.trim().length && "#" !== e.trim()[0]) {
                            for(; u < e.length; u++)if (x(u), '"' === h) for(x(++u); u < e.length && ('"' !== h || '"' === p || '"' === m);)('"' !== h || '"' === h && '"' !== p) && (c += h), x(++u);
                            else h === d ? y() : c += h;
                            y();
                        }
                    }(p[m], m - u - e);
                    (!i.columnTypes || 0 === i.columnTypes.length) && r.length && r[0].length && "date" === r[0][1] && !i.dateFormat && (i.dateFormat = function(e, s) {
                        let a = "YYYY/mm/dd", n = [], r = [], o, l = [], u, h = 0, d = !1, p;
                        for((!s || s > e.length) && (s = e.length); h < s; h++)if (void 0 !== e[h] && e[h]?.length) for(p = 0, o = e[h].trim().replace(/\//g, " ").replace(/\-/g, " ").replace(/\./g, " ").split(" "), l = [
                            "",
                            "",
                            ""
                        ]; p < o.length; p++)p < l.length && (o[p] = parseInt(o[p], 10), o[p] && (r[p] = !r[p] || r[p] < o[p] ? o[p] : r[p], void 0 !== n[p] ? n[p] !== o[p] && (n[p] = !1) : n[p] = o[p], o[p] > 31 ? o[p] < 100 ? l[p] = "YY" : l[p] = "YYYY" : o[p] > 12 && o[p] <= 31 ? (l[p] = "dd", d = !0) : l[p].length || (l[p] = "mm")));
                        if (d) {
                            for(p = 0; p < n.length; p++)!1 !== n[p] ? r[p] > 12 && "YY" !== l[p] && "YYYY" !== l[p] && (l[p] = "YY") : r[p] > 12 && "mm" === l[p] && (l[p] = "dd");
                            return (3 === l.length && "dd" === l[1] && "dd" === l[2] && (l[2] = "YY"), u = l.join("/"), (i.dateFormats || t.dateFormats)[u]) ? u : (f(t, "deduceDateFailed"), a);
                        }
                        return a;
                    }(s[0])), this.dataFound();
                }
                return s;
            }
            parseTable() {
                let e = this.options, t = this.columns || [], s = e.startRow || 0, i = e.endRow || Number.MAX_VALUE, a = e.startColumn || 0, n = e.endColumn || Number.MAX_VALUE;
                if (e.table) {
                    let r = e.table;
                    "string" == typeof r && (r = u.getElementById(r)), [].forEach.call(r.getElementsByTagName("tr"), (e, r)=>{
                        r >= s && r <= i && [].forEach.call(e.children, (e, i)=>{
                            let o = t[i - a], l = 1;
                            if (("TD" === e.tagName || "TH" === e.tagName) && i >= a && i <= n) for(t[i - a] || (t[i - a] = []), t[i - a][r - s] = e.innerHTML; r - s >= l && void 0 === o[r - s - l];)o[r - s - l] = null, l++;
                        });
                    }), this.dataFound();
                }
                return t;
            }
            fetchLiveData() {
                let e = this, t = this.chart, s = this.options, i = s.enablePolling, a = x(s), n = 0, r = 1e3 * (s.dataRefreshRate || 2);
                return !!T(s) && (r < 1e3 && (r = 1e3), delete s.csvURL, delete s.rowsURL, delete s.columnsURL, function o(l) {
                    function u(a, u, d) {
                        if (!a || !/^(http|\/|\.\/|\.\.\/)/.test(a)) return a && s.error && s.error("Invalid URL"), !1;
                        function p() {
                            i && t.liveDataURL === a && (e.liveDataTimeout = setTimeout(o, r));
                        }
                        return l && (clearTimeout(e.liveDataTimeout), t.liveDataURL = a), h({
                            url: a,
                            dataType: d || "json",
                            success: function(e) {
                                t?.series && u(e), p();
                            },
                            error: function(e, t) {
                                return ++n < 3 && p(), s.error?.(t, e);
                            }
                        }), !0;
                    }
                    u(a.csvURL, function(e) {
                        t.update({
                            data: {
                                csv: e
                            }
                        });
                    }, "text") || u(a.rowsURL, function(e) {
                        t.update({
                            data: {
                                rows: e
                            }
                        });
                    }) || u(a.columnsURL, function(e) {
                        t.update({
                            data: {
                                columns: e
                            }
                        });
                    });
                }(!0), T(s));
            }
            parseGoogleSpreadsheet() {
                let e = this, t = this.options, s = t.googleSpreadsheetKey, i = this.chart, a = Math.max(1e3 * (t.dataRefreshRate || 2), 4e3), n = ()=>{
                    if (t.googleSpreadsheetRange) return t.googleSpreadsheetRange;
                    let e = "ABCDEFGHIJKLMNOPQRSTUVWXYZ", s = (e.charAt(t.startColumn || 0) || "A") + ((t.startRow || 0) + 1), i = e.charAt(y(t.endColumn, -1)) || "ZZ";
                    return m(t.endRow) && (i += t.endRow + 1), `${s}:${i}`;
                };
                return s && (delete t.googleSpreadsheetKey, function i(r) {
                    h({
                        url: [
                            "https://sheets.googleapis.com/v4/spreadsheets",
                            s,
                            "values",
                            n(),
                            "?alt=json&majorDimension=COLUMNS&valueRenderOption=UNFORMATTED_VALUE&dateTimeRenderOption=FORMATTED_STRING&key=" + t.googleAPIKey
                        ].join("/"),
                        dataType: "json",
                        success: function(s) {
                            r(s), t.enablePolling && (e.liveDataTimeout = setTimeout(function() {
                                i(r);
                            }, a));
                        },
                        error: function(e, s) {
                            return t.error?.(s, e);
                        }
                    });
                }(function(t) {
                    let s = t.values;
                    if (!s || 0 === s.length) return !1;
                    let a = s.reduce((e, t)=>Math.max(e, t.length), 0);
                    s.forEach((e)=>{
                        for(let t = 0; t < a; t++)void 0 === e[t] && (e[t] = null);
                    }), i?.series ? i.update({
                        data: {
                            columns: s
                        }
                    }) : (e.columns = s, e.dataFound());
                })), !1;
            }
            trim(e, t) {
                return "string" == typeof e && (e = e.replace(/^\s+|\s+$/g, ""), t && /[\d\s]+/.test(e) && (e = e.replace(/\s/g, "")), this.decimalRegex && (e = e.replace(this.decimalRegex, "$1.$2"))), e;
            }
            parseTypes() {
                let e = this.columns || [], t = e.length;
                for(; t--;)this.parseColumn(e[t], t);
            }
            parseColumn(e, t) {
                let s = this.rawColumns, i = this.columns = this.columns || [], a = this.firstRowAsNames, n = this.valueCount?.xColumns.indexOf(t) !== -1, r = [], o = this.chartOptions, l = (this.options.columnTypes || [])[t], u = n && o?.xAxis && "category" === v(o.xAxis)[0].type || "string" === l, h = m(e.name), d = e.length, p, c, f, x, C, y, T;
                for(s[t] || (s[t] = []); d--;)p = r[d] || e[d], f = this.trim(p), c = parseFloat(x = this.trim(p, !0)), void 0 === s[t][d] && (s[t][d] = f), u || 0 === d && a && !h ? e[d] = "" + f : +x === c ? (e[d] = c, c > 31536e6 && "float" !== l ? e.isDatetime = !0 : e.isNumeric = !0, void 0 !== e[d + 1] && (T = c > e[d + 1])) : (f?.length && (C = this.parseDate(p)), n && g(C) && "float" !== l ? (r[d] = p, e[d] = C, e.isDatetime = !0, void 0 !== e[d + 1] && ((y = C > e[d + 1]) !== T && void 0 !== T && (this.alternativeFormat ? (this.dateFormat = this.alternativeFormat, d = e.length, this.alternativeFormat = this.dateFormats[this.dateFormat].alternative) : e.unsorted = !0), T = y)) : (e[d] = "" === f ? null : f, 0 !== d && (e.isDatetime || e.isNumeric) && (e.mixed = !0)));
                if (n && e.mixed && (i[t] = s[t]), n && T && this.options.sort) {
                    for(t = 0; t < i.length; t++)if (i[t].reverse(), a) {
                        let e = i[t].pop();
                        e && i[t].unshift(e);
                    }
                }
            }
            parseDate(e) {
                let t = this.options.parseDate, s, i, a, n = this.options.dateFormat || this.dateFormat, r;
                if (t) s = t(e);
                else if ("string" == typeof e) {
                    if (n) (a = this.dateFormats[n]) || (a = this.dateFormats["YYYY/mm/dd"]), (r = e.match(a.regex)) && (s = a.parser(r));
                    else for(i in this.dateFormats)if (a = this.dateFormats[i], r = e.match(a.regex)) {
                        this.dateFormat = n = i, this.alternativeFormat = a.alternative, s = a.parser(r);
                        break;
                    }
                    !r && (e.match(/:.+(GMT|UTC|[Z+\-])/) && (e = e.replace(/\s*(?:GMT|UTC)?([+\-])(\d\d)(\d\d)$/, "$1$2:$3").replace(/(?:\s+|GMT|UTC)([+\-])/, "$1").replace(/(\d)\s*(?:GMT|UTC|Z)$/, "$1+00:00")), "object" == typeof (r = Date.parse(e)) && null !== r && r.getTime ? s = r.getTime() - 6e4 * r.getTimezoneOffset() : g(r) && (s = r - 6e4 * new Date(r).getTimezoneOffset()));
                }
                return s;
            }
            getData() {
                if (this.columns) return this.rowsToColumns(this.columns)?.slice(1);
            }
            parsed() {
                if (this.options.parsed) return this.options.parsed.call(this, this.columns);
            }
            complete() {
                let e = this.columns = this.columns || [], t = this.options, s = [], i = "linear", a, n, r, o, l, u, h, d, p, c, f;
                if ([].length = e.length, t.complete || t.afterComplete) {
                    if (this.firstRowAsNames) for(r = 0; r < e.length; r++){
                        let t = e[r];
                        m(t.name) || (t.name = y(t.shift(), "").toString());
                    }
                    for(u = 0, a = [], p = function(e, t) {
                        let s, i, a;
                        let n = [], r = [];
                        for(i = 0; i < e; i += 1)n.push(!0);
                        for(s = 0; s < t.length; s += 1)for(i = 0, a = t[s].getReferencedColumnIndexes(); i < a.length; i += 1)n[a[i]] = !1;
                        for(i = 0; i < n.length; i += 1)n[i] && r.push(i);
                        return r;
                    }(e?.length || 0, this.valueCount.seriesBuilders); u < this.valueCount.seriesBuilders.length; u++)(d = this.valueCount.seriesBuilders[u]).populateColumns(p) && s.push(d);
                    for(; p.length > 0;){
                        for((d = new R).addColumnReader(0, "x"), -1 !== (f = p.indexOf(0)) && p.splice(f, 1), r = 0; r < this.valueCount.global; r++)d.addColumnReader(void 0, this.valueCount.globalPointArrayMap[r]);
                        d.populateColumns(p) && s.push(d);
                    }
                    if (s.length > 0 && s[0].readers.length > 0 && void 0 !== (c = e?.[s[0].readers[0].columnIndex ?? -1]) && (c.isDatetime ? i = "datetime" : c.isNumeric || (i = "category")), "category" === i) for(u = 0; u < s.length; u++)for(l = 0, d = s[u]; l < d.readers.length; l++)"x" === d.readers[l].configName && (d.readers[l].configName = "name");
                    for(u = 0; u < s.length; u++){
                        for(o = 0, d = s[u], n = []; o < e[0].length; o++)n[o] = d.read(e, o);
                        a[u] = {
                            data: n,
                            pointStart: n[0] && (d.pointIsArray ? n[0]?.[0] : n[0]?.x) || void 0
                        }, d.name && (a[u].name = d.name), "category" === i && (a[u].turboThreshold = 0, a[u].pointStart = 0);
                    }
                    h = {
                        series: a
                    }, "linear" !== i || this.xAxisOptions && this.xAxisOptions.type !== i ? (this.xAxisOptions = {
                        type: i
                    }, "category" === i && (this.xAxisOptions.uniqueNames = !1)) : i = this.xAxisOptions = void 0, this.chart || x(!0, h, {
                        xAxis: this.xAxisOptions || {}
                    }), t.complete?.(h), t.afterComplete?.(this, h);
                }
            }
            xAxisUpdateHandler(e) {
                let t = this.xAxisOptions;
                t && (!e.options.type && t.type && (e.type = t.type), e.options.uniqueNames || !1 !== t.uniqueNames || (e.uniqueNames = t.uniqueNames));
            }
            update(e, t) {
                let s = this.chart, i = s.options;
                e && (e.afterComplete = function(e, i) {
                    if (!i) return;
                    let a = s.xAxis[0], n = e.xAxisOptions;
                    n && a && (a.type !== n.type && !a.options.type || a.uniqueNames && !1 === n.uniqueNames && void 0 === a.options.uniqueNames) ? a.update({}, !1) : (i?.series || []).forEach(function(e) {
                        delete e.pointStart;
                    }), s.update(i, t, !0);
                }, x(!0, i.data, e), i.data?.googleSpreadsheetKey && !e.columns && delete i.data.columns, this.init(i.data || {}, i));
            }
        }
        p(e, "afterSetOptions", function() {
            this.isXAxis && (!this.chart.xAxis.length || this.chart.xAxis[0] === this) && this.chart.data?.xAxisUpdateHandler(this);
        }), p(t, "init", function(e) {
            let t = this, s = e.args[1], i = l().data, a = e.args[0] || {};
            if ((i || a && a.data) && !t.hasDataDef) {
                t.hasDataDef = !0;
                let n = x(i, a.data);
                t.data = new N(c(n, {
                    afterComplete: function(e, i) {
                        let n, r;
                        if (Object.hasOwnProperty.call(a, "series")) {
                            if ("object" == typeof a.series) for(n = Math.max(a.series.length, i?.series?.length ?? 0); n--;)r = a.series[n] || {}, a.series[n] = x(r, i?.series?.[n] ?? {});
                            else delete a.series;
                        }
                        a = x(i, a), t.data = e, t.init(a, s);
                    }
                }), a, t), e.preventDefault();
            }
        });
        class R {
            constructor(){
                this.readers = [], this.pointIsArray = !0;
            }
            populateColumns(e) {
                let t = !0;
                return this.readers.forEach((t)=>{
                    void 0 === t.columnIndex && (t.columnIndex = e.shift());
                }), this.readers.forEach((e)=>{
                    void 0 === e.columnIndex && (t = !1);
                }), t;
            }
            read(e, t) {
                let s = this.pointIsArray, i = s ? [] : {};
                if (this.readers.forEach((a)=>{
                    let r = e[a.columnIndex][t];
                    s ? i.push(r) : a.configName.indexOf(".") > 0 ? n.prototype.setNestedProperty(i, r, a.configName) : i[a.configName] = r;
                }), void 0 === this.name && this.readers.length >= 2) {
                    let t = [];
                    this.readers.forEach(function(e) {
                        ("x" === e.configName || "name" === e.configName || "y" === e.configName) && void 0 !== e.columnIndex && t.push(e.columnIndex);
                    }), t.length >= 2 && (t.shift(), t.sort(function(e, t) {
                        return e - t;
                    })), this.name = e[y(t.shift(), 0)].name;
                }
                return i;
            }
            addColumnReader(e, t) {
                this.readers.push({
                    columnIndex: e,
                    configName: t
                }), "x" === t || "y" === t || void 0 === t || (this.pointIsArray = !1);
            }
            getReferencedColumnIndexes() {
                let e, t;
                let s = [];
                for(e = 0; e < this.readers.length; e += 1)void 0 !== (t = this.readers[e]).columnIndex && s.push(t.columnIndex);
                return s;
            }
            hasReader(e) {
                let t;
                for(t = 0; t < this.readers.length; t += 1)if (this.readers[t].configName === e) return !0;
            }
        }
        return N;
    }), s(t, "masters/modules/data.src.js", [
        t["Core/Globals.js"],
        t["Core/HttpUtilities.js"],
        t["Extensions/Data.js"]
    ], function(e, t, s) {
        return e.Data = e.Data || s, e.HttpUtilities = e.HttpUtilities || t, e.ajax = e.HttpUtilities.ajax, e.data = e.Data.data, e.getJSON = e.HttpUtilities.getJSON, e.post = e.HttpUtilities.post, e;
    });
});


(0, (/*@__PURE__*/$parcel$interopDefault($6593432242bbf5e0$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($861296feb2339393$exports))));
document.addEventListener("DOMContentLoaded", function() {
    if (!document.querySelector(".statystyki")) return;
    (0, (/*@__PURE__*/$parcel$interopDefault($861296feb2339393$exports))).setOptions({
        lang: {
            months: [
                "Stycze\u0144",
                "Luty",
                "Marzec",
                "Kwiecie\u0144",
                "Maj",
                "Czerwiec",
                "Lipiec",
                "Sierpie\u0144",
                "Wrzesie\u0144",
                "Pa\u017Adziernik",
                "Listopad",
                "Grudzie\u0144"
            ],
            weekdays: [
                "Niedziela",
                "Poniedzia\u0142ek",
                "Wtorek",
                "\u015Aroda",
                "Czwartek",
                "Pi\u0105tek",
                "Sobota"
            ],
            shortMonths: [
                "Sty",
                "Lut",
                "Mar",
                "Kwi",
                "Maj",
                "Cze",
                "Lip",
                "Sie",
                "Wrz",
                "Pa\u017A",
                "Lis",
                "Gru"
            ]
        },
        title: {
            text: null
        },
        legend: {
            enabled: false
        },
        credits: {
            enabled: false
        },
        colors: [
            "#0d7a55",
            "#e9c200",
            "#ED561B",
            "#DDDF00",
            "#24CBE5",
            "#64E572",
            "#FF9655",
            "#FFF263",
            "#6AF9C4"
        ]
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($861296feb2339393$exports))).chart("statsByDay", {
        data: {
            csvURL: window.location.origin + "/stats/statsByDay.csv?sessionless",
            firstRowAsNames: false
        },
        chart: {
            type: "areaspline",
            backgroundColor: "transparent",
            reflow: true,
            events: {
                load () {
                    const chart = this;
                    chart.showLoading('Pobieram dane...');
                },
                redraw () {
                    const chart = this;
                    chart.hideLoading();
                }
            }
        },
        plotOptions: {
            areaspline: {
                fillColor: {
                    linearGradient: {
                        x1: 0,
                        y1: 0,
                        x2: 0,
                        y2: 1
                    },
                    stops: [
                        [
                            0,
                            "#0d7a55"
                        ],
                        [
                            1,
                            "#FFFFFF"
                        ]
                    ]
                }
            }
        },
        xAxis: {
            tickInterval: 604800000,
            tickWidth: 0,
            gridLineWidth: 1
        },
        series: [
            {
                name: "Nowe zg\u0142oszenia",
                lineWidth: 5,
                color: "#0d7a55"
            },
            {
                name: "Nowi u\u017Cytkownicy",
                lineWidth: 3,
                type: "spline",
                color: "#e9c200"
            }
        ],
        tooltip: {
            shared: true,
            crosshairs: true
        },
        responsive: {
            rules: [
                {
                    condition: {
                        maxWidth: 560
                    },
                    chartOptions: {
                        chart: {
                            height: 250
                        }
                    }
                }
            ]
        }
    });
    const statsByYearElement = document.getElementById("statsByYear");
    const barWidth = statsByYearElement ? statsByYearElement.offsetWidth / 26 : 20;
    (0, (/*@__PURE__*/$parcel$interopDefault($861296feb2339393$exports))).chart("statsByYear", {
        data: {
            csvURL: window.location.origin + "/stats/byYear.csv?sessionless",
            firstRowAsNames: false
        },
        chart: {
            type: "column",
            plotBackgroundColor: null,
            backgroundColor: "transparent",
            reflow: true,
            events: {
                load () {
                    const chart = this;
                    chart.showLoading('Pobieram dane...');
                },
                redraw () {
                    const chart = this;
                    chart.hideLoading();
                }
            }
        },
        plotOptions: {
            column: {
                // grouping:false keeps every stack drawn at the same x, so the users
                // bar stays overlaid on the reports bar instead of sitting beside it.
                grouping: false,
                stacking: "normal",
                shadow: false,
                borderWidth: 0
            },
            series: {
                pointWidth: barWidth
            }
        },
        // Two report series share a bar, so colour alone no longer identifies them.
        legend: {
            enabled: true
        },
        xAxis: {
            tickWidth: 0,
            gridLineWidth: 1
        },
        series: [
            {
                name: "Zg\u0142oszenia \u2013 SM",
                color: "#0d7a55",
                stack: "apps"
            },
            {
                name: "Zg\u0142oszenia \u2013 policja",
                color: "#1F63B8",
                stack: "apps"
            },
            {
                name: "Nowi u\u017Cytkownicy",
                color: "#e9c200",
                // own stack, so it stays a separate overlaid bar rather than piling
                // on top of the reports total
                stack: "users",
                pointPadding: 0.4,
                pointPlacement: 0.2,
                pointWidth: barWidth * 0.7
            }
        ],
        tooltip: {
            shared: true,
            crosshairs: true
        },
        responsive: {
            rules: [
                {
                    condition: {
                        maxWidth: 560
                    },
                    chartOptions: {
                        chart: {
                            height: 250
                        }
                    }
                }
            ]
        }
    });
    // Make monochrome colors
    var pieColors = function() {
        var colors = [], base = (0, (/*@__PURE__*/$parcel$interopDefault($861296feb2339393$exports))).getOptions().colors[0], i;
        for(i = 0; i < 10; i += 1)// Start out with a darkened base color (negative brighten), and end
        // up with a much brighter color
        colors.push((0, (/*@__PURE__*/$parcel$interopDefault($861296feb2339393$exports))).color(base).brighten((i - 2) / 15).get());
        return colors;
    }();
    (0, (/*@__PURE__*/$parcel$interopDefault($861296feb2339393$exports))).chart("statsByCarBrand", {
        data: {
            csvURL: window.location.origin + "/stats/byCarBrand.csv?sessionless",
            firstRowAsNames: false
        },
        chart: {
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false,
            type: "pie",
            backgroundColor: "transparent",
            reflow: true,
            events: {
                load () {
                    const chart = this;
                    chart.showLoading('Pobieram dane...');
                },
                redraw () {
                    const chart = this;
                    chart.hideLoading();
                }
            }
        },
        series: [
            {
                name: "Liczba zg\u0142osze\u0144",
                color: "#0d7a55"
            }
        ],
        tooltip: {
            pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>"
        },
        plotOptions: {
            pie: {
                allowPointSelect: true,
                cursor: "pointer",
                colors: pieColors,
                dataLabels: {
                    enabled: true,
                    format: "<b>{point.name}</b><br>{point.percentage:.1f} %"
                },
                startAngle: -90,
                endAngle: 90,
                center: [
                    "50%",
                    "75%"
                ],
                size: "110%"
            }
        },
        responsive: {
            rules: [
                {
                    condition: {
                        maxWidth: 560
                    },
                    chartOptions: {
                        chart: {
                            height: 250
                        },
                        plotOptions: {
                            pie: {
                                size: "100%"
                            }
                        }
                    }
                }
            ]
        }
    });
});




document.addEventListener("DOMContentLoaded", ()=>{
    if (!document.getElementsByClassName('dziekujemy').length) return;
    const appIdElement = /** @type {HTMLInputElement} */ document.getElementById('applicationId');
    const automatedSMElement = /** @type {HTMLInputElement} */ document.getElementById('automatedSM');
    const appId = appIdElement?.value;
    const automatedSM = automatedSMElement?.value;
    if (appId && automatedSM) // Immediate send instead of setTimeout to avoid race conditions
    // where user closes tab or browser suspends execution
    (0, $78108ba22a655e06$export$2e2bcd8739ae039)(appId).catch((err)=>{
        (0, $d0b61ef20bcb31bc$export$a3bc9b8ed74fc)(err);
    });
    else (0, $78108ba22a655e06$export$2e765e68db96fa95)();
    _paq.push([
        'trackEvent',
        'Application',
        'thank-you',
        appId
    ]);
});


function $132da85e4bfd19bb$var$copyToClipboard(selector) {
    selector = selector || 'dd#copy';
    const element = document.querySelector(selector);
    const txt = element ? element.textContent.trim() : '';
    navigator.clipboard.writeText(txt);
    const copyBtn = document.querySelector('a#copyBtn');
    if (copyBtn) copyBtn.textContent = 'Tekst skopiowany';
}
window.copyToClipboard = $132da85e4bfd19bb$var$copyToClipboard;



function $659383c595d82a11$export$94d3270fa33ee113(inputId, listId) {
    const input = document.getElementById(inputId);
    if (!input) return;
    input.addEventListener("input", (0, $9c7ecb60e349f774$export$2e2bcd8739ae039)($659383c595d82a11$var$filter(inputId, listId), 300), false);
    $659383c595d82a11$export$a629e2d70076dad9(inputId);
}
function $659383c595d82a11$export$a629e2d70076dad9(inputId) {
    const input = document.getElementById(inputId);
    if (!input) return;
    if (input.value.trim()) input.dispatchEvent(new Event('input', {
        bubbles: true
    }));
}
function $659383c595d82a11$var$filter(inputId, listId) {
    return function() {
        // @ts-ignore
        const filter = this.value.toUpperCase().trim();
        const ul = document.getElementById(listId ?? inputId + '-list');
        const lis = ul?.children || [];
        for (let li of lis){
            const filtertext = li.dataset.filtertext?.toUpperCase();
            li.style.display = (filtertext?.indexOf(filter) || 0) > -1 ? "" : "none";
        }
    };
}


document.addEventListener("DOMContentLoaded", ()=>{
    $4ed83ffb52cb8850$var$scrollTo(window.location.hash);
});
function $4ed83ffb52cb8850$var$scrollTo(hash) {
    if (!hash) return;
    const hashElement = document.querySelector(hash);
    if (!hashElement) return;
    window.location.hash = hash;
    const elementTop = hashElement.getBoundingClientRect().top + window.pageYOffset - 60;
    if (elementTop > 0) window.scrollTo({
        top: elementTop,
        behavior: 'smooth'
    });
    document.querySelectorAll('.howto').forEach((el)=>el.classList.remove('highlight'));
    hashElement.classList.add('highlight');
}
// @ts-ignore
window._scrollToHowTo = $4ed83ffb52cb8850$var$scrollTo;
(0, $659383c595d82a11$export$94d3270fa33ee113)('filterable', 'filterable-list');


document.addEventListener("DOMContentLoaded", ()=>{
    if (!document.querySelector(".ask-for-status")) return;
    document.querySelectorAll('h3 > a').forEach((link)=>{
        link.addEventListener('click', (e)=>{
            e.preventDefault();
            const target = /** @type {HTMLElement} */ e.currentTarget;
            if (!target || !target.parentElement) return;
            try {
                const apps = /** @type {HTMLElement} */ target.parentElement.nextElementSibling;
                if (!apps) return;
                const htmlBlob = new Blob([
                    apps.innerHTML
                ], {
                    type: "text/html"
                });
                const textBlob = new Blob([
                    apps.innerText
                ], {
                    type: "text/plain"
                });
                const data = [
                    new ClipboardItem({
                        "text/html": htmlBlob,
                        "text/plain": textBlob
                    })
                ];
                navigator.clipboard.write(data).then(()=>{
                    apps.style.opacity = '0.4';
                    target.classList.add('visited');
                    setTimeout(()=>apps.style.opacity = '1', 80);
                });
            } catch (_e) {
                target.classList.add('error');
            }
        });
    });
});


function $a7bda605a78cafb6$var$closeMenu() {
    // @ts-ignore
    document.getElementById("toggle").checked = false;
}
window.addEventListener("keydown", (e)=>e.key === 'Escape' && $a7bda605a78cafb6$var$closeMenu());
document.getElementById("courtain")?.addEventListener("click", $a7bda605a78cafb6$var$closeMenu);


document.addEventListener("DOMContentLoaded", ()=>{
    const cardsContainers = document.querySelectorAll('.czesto-popelniane-bledy .cards');
    if (cardsContainers.length === 0) return;
    function scrollTo(figure) {
        figure.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'start'
        });
    }
    function setClasses(ev) {
        const arrowLeft = ev.target.querySelector(".left");
        const arrowRight = ev.target.querySelector(".right");
        if (ev.target.scrollLeft > ev.target.scrollWidth * 0.3) {
            arrowLeft.classList.remove('hidden');
            arrowRight.classList.add('hidden');
        } else {
            arrowLeft.classList.add('hidden');
            arrowRight.classList.remove('hidden');
        }
    }
    cardsContainers.forEach((container)=>{
        setClasses({
            target: container
        });
        container.addEventListener("scroll", setClasses);
        container.querySelector(".right").addEventListener("click", (ev)=>{
            scrollTo(container.querySelectorAll("figure")[1]);
        });
        container.querySelector(".left").addEventListener("click", (ev)=>{
            scrollTo(container.querySelectorAll("figure")[0]);
        });
    });
});




// Wiki: przycisk „Kopiuj” we wzorach pism (:::wzor, wiki/_directive-wzor.html.twig). Delegacja, bo wzór pojawia się
// też w podglądzie edytora i w poradniku redaktora.
document.addEventListener('click', (event)=>{
    // @ts-ignore
    const button = event.target?.closest?.('[data-wiki-copy]');
    if (!button) return;
    const body = button.closest('.wiki-wzor')?.querySelector('.wiki-wzor__body');
    if (!body) return;
    navigator.clipboard.writeText(body.innerText.trim()).then(()=>(0, $d0b61ef20bcb31bc$export$a8ecead220dd38a6)("Skopiowano wz\xf3r do schowka")).catch(()=>(0, $d0b61ef20bcb31bc$export$a3bc9b8ed74fc)("Nie uda\u0142o si\u0119 skopiowa\u0107 \u2014 zaznacz tekst i skopiuj r\u0119cznie"));
});
// Lista jednostek /wiki/sluzby (wiki-units.html.twig)
(0, $659383c595d82a11$export$94d3270fa33ee113)('wiki-units-filter', 'wiki-units-filter-list');
// Diagramy ```mermaid (renderer wiki: <pre class="mermaid">). Biblioteka z CDN tylko tam, gdzie jest diagram;
// securityLevel 'strict', bo etykiety to treść redaktorów. Ta sama wersja co wcześniej na faq.html.
let $f5d05a8c5dfa6a52$var$mermaidPromise = null;
function $f5d05a8c5dfa6a52$export$b70b2f9264b87a45(root = document) {
    const pending = root.querySelectorAll('pre.mermaid:not([data-processed])');
    if (!pending.length) return;
    $f5d05a8c5dfa6a52$var$mermaidPromise ??= new Promise((resolve)=>{
        // @ts-ignore
        window.__udMermaidReady = resolve;
        const script = document.createElement('script');
        script.type = 'module';
        script.textContent = "import mermaid from 'https://cdn.jsdelivr.net/npm/mermaid@11.4.1/dist/mermaid.esm.min.mjs';mermaid.initialize({ startOnLoad: false, securityLevel: 'strict' }); window.__udMermaidReady(mermaid)";
        document.head.appendChild(script);
    });
    // @ts-ignore
    $f5d05a8c5dfa6a52$var$mermaidPromise.then((mermaid)=>mermaid.run({
            nodes: pending
        }));
}
document.addEventListener('DOMContentLoaded', ()=>$f5d05a8c5dfa6a52$export$b70b2f9264b87a45());
// Stare kotwice DokuWiki (#pojazd_stal_za_zakazem…, linki z Google i zewnętrznych stron) → identyfikatory nagłówków
// nowej wiki (#pojazd-stal-za-zakazem…). Fragment nie trafia do serwera, więc WikiHandler::legacyRedirect go nie poprawi.
function $f5d05a8c5dfa6a52$var$fixLegacyAnchor() {
    let id;
    try {
        id = decodeURIComponent(location.hash.slice(1));
    } catch  {
        return;
    }
    if (!id.includes('_') || document.getElementById(id)) return;
    const target = document.getElementById(id.replaceAll('_', '-'));
    if (!target) return;
    history.replaceState(null, '', '#' + target.id);
    target.scrollIntoView();
}
document.addEventListener('DOMContentLoaded', $f5d05a8c5dfa6a52$var$fixLegacyAnchor);
window.addEventListener('hashchange', $f5d05a8c5dfa6a52$var$fixLegacyAnchor);




// Edytor wiki (wiki-edit.html.twig): podgląd na żywo przez POST /wiki/_preview (ten sam renderer co zapis),
// „Wstaw” z poradnika redaktora (wiki/_editor-guide.html.twig), ostrzeżenie przed utratą niezapisanych zmian.
document.addEventListener("DOMContentLoaded", ()=>{
    if (!document.getElementsByClassName('wiki-edit').length) return;
    /** @type {HTMLTextAreaElement|null} */ const body = document.querySelector('.js-wiki-body');
    /** @type {HTMLFormElement|null} */ const form = document.querySelector('.js-wiki-editor');
    const preview = document.querySelector('.js-wiki-preview');
    /** @type {HTMLElement|null} */ const errors = document.querySelector('.js-wiki-errors');
    if (!body || !form || !preview || !errors) return;
    let timer = undefined;
    let sequence = 0;
    const refresh = async ()=>{
        const current = ++sequence;
        try {
            const result = await new (0, $2e0d7d2a9ac04488$export$2e2bcd8739ae039)('/wiki/_preview').post({
                body: body.value
            });
            if (current !== sequence) return; // nowszy podgląd już w drodze
            preview.innerHTML = result.html // HTML z renderera wiki (surowy HTML z treści jest wycinany po stronie serwera)
            ;
            (0, $f5d05a8c5dfa6a52$export$b70b2f9264b87a45)(preview);
            errors.replaceChildren(...result.errors.map((msg)=>{
                const item = document.createElement('li');
                item.textContent = msg;
                return item;
            }));
            errors.hidden = !result.errors.length;
        } catch  {
        // Api pokazuje toast z błędem
        }
    };
    body.addEventListener('input', ()=>{
        clearTimeout(timer);
        timer = setTimeout(refresh, 400);
    });
    refresh();
    document.querySelectorAll('.js-wiki-insert').forEach((button)=>button.addEventListener('click', ()=>{
            // @ts-ignore
            $64c97dfe2460d4d0$var$insertBlock(body, button.dataset.snippet);
            // @ts-ignore
            document.getElementById('wiki-guide')?.close();
            body.focus();
            refresh();
        }));
    const initial = body.value;
    let submitting = false;
    form.addEventListener('submit', ()=>{
        submitting = true;
    });
    window.addEventListener('beforeunload', (event)=>{
        if (submitting || body.value === initial) return;
        event.preventDefault();
        event.returnValue = '';
    });
});
/**
 * Wstawia blok w miejscu kursora, oddzielony pustą linią od poprzedzającego tekstu.
 * @param {HTMLTextAreaElement} textarea
 * @param {string} snippet
 */ function $64c97dfe2460d4d0$var$insertBlock(textarea, snippet) {
    const { selectionStart: start, selectionEnd: end, value: value } = textarea;
    const before = value.slice(0, start);
    const separator = !before || before.endsWith('\n\n') ? '' : before.endsWith('\n') ? '\n' : '\n\n';
    textarea.setRangeText(separator + snippet + '\n', start, end, 'end');
}


// Sidebar nawigacyjny (_sidebar.html.twig): akordeon — naraz otwarta jedna sekcja.
// Rozwinięcie <details> zwija pozostałe w tym samym sidebarze. Sekcja bieżącej
// strony jest otwarta już z serwera (atrybut `open` w Twigu), więc na starcie nic
// nie ruszamy. Guard przez querySelectorAll => no-op na stronach bez sidebara.
document.querySelectorAll(".mpr-sidebar--nav").forEach((nav)=>{
    const sections = nav.querySelectorAll("details.mpr-sidebar-section");
    sections.forEach((details)=>{
        details.addEventListener("toggle", ()=>{
            if (!details.open) return;
            sections.forEach((other)=>{
                if (other !== details) other.open = false;
            });
        });
    });
});


// nazwę cookie czyta też HtmlMiddleware (general.showAppBanner)
const $4ebac2e5d0251bad$var$COOKIE = "appBannerClicked=1; path=/; max-age=31536000; SameSite=Lax";
document.addEventListener("DOMContentLoaded", ()=>{
    document.querySelectorAll(".js-app-banner").forEach((banner)=>{
        banner.querySelectorAll(".js-app-banner-action").forEach((action)=>{
            action.addEventListener("click", ()=>{
                document.cookie = $4ebac2e5d0251bad$var$COOKIE;
                // @ts-ignore
                banner.style.display = "none";
            });
        });
    });
});



document.querySelectorAll('.menu-button.right').forEach((button)=>{
    button.addEventListener('click', function() {
        this.classList.add('disabled');
    });
});
document.querySelectorAll('.button.cta').forEach((button)=>{
    button.addEventListener('click', function() {
        this.classList.add('disabled');
    });
});
document.querySelectorAll("textarea").forEach((textarea)=>{
    textarea.style.height = textarea.scrollHeight + "px";
    textarea.style.overflowY = "hidden";
    textarea.addEventListener("input", function() {
        this.style.height = "auto";
        this.style.height = this.scrollHeight + "px";
    });
});
document.addEventListener("DOMContentLoaded", ()=>{
    (0, $7625c8a76fddb1fb$export$2e2bcd8739ae039)();
});

})();
//# sourceMappingURL=index3.js.map
